true&&(function polyfill() {
  const relList = document.createElement("link").relList;
  if (relList && relList.supports && relList.supports("modulepreload")) {
    return;
  }
  for (const link of document.querySelectorAll('link[rel="modulepreload"]')) {
    processPreload(link);
  }
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type !== "childList") {
        continue;
      }
      for (const node of mutation.addedNodes) {
        if (node.tagName === "LINK" && node.rel === "modulepreload")
          processPreload(node);
      }
    }
  }).observe(document, { childList: true, subtree: true });
  function getFetchOpts(link) {
    const fetchOpts = {};
    if (link.integrity) fetchOpts.integrity = link.integrity;
    if (link.referrerPolicy) fetchOpts.referrerPolicy = link.referrerPolicy;
    if (link.crossOrigin === "use-credentials")
      fetchOpts.credentials = "include";
    else if (link.crossOrigin === "anonymous") fetchOpts.credentials = "omit";
    else fetchOpts.credentials = "same-origin";
    return fetchOpts;
  }
  function processPreload(link) {
    if (link.ep)
      return;
    link.ep = true;
    const fetchOpts = getFetchOpts(link);
    fetch(link.href, fetchOpts);
  }
}());

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
	if (typeof f == "function") {
		var a = function a () {
			if (this instanceof a) {
        return Reflect.construct(f, arguments, this.constructor);
			}
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var jsxRuntime = {exports: {}};

var reactJsxRuntime_production = {};

/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var REACT_ELEMENT_TYPE$2 = Symbol.for("react.transitional.element"),
  REACT_FRAGMENT_TYPE$2 = Symbol.for("react.fragment");
function jsxProd(type, config, maybeKey) {
  var key = null;
  void 0 !== maybeKey && (key = "" + maybeKey);
  void 0 !== config.key && (key = "" + config.key);
  if ("key" in config) {
    maybeKey = {};
    for (var propName in config)
      "key" !== propName && (maybeKey[propName] = config[propName]);
  } else maybeKey = config;
  config = maybeKey.ref;
  return {
    $$typeof: REACT_ELEMENT_TYPE$2,
    type: type,
    key: key,
    ref: void 0 !== config ? config : null,
    props: maybeKey
  };
}
reactJsxRuntime_production.Fragment = REACT_FRAGMENT_TYPE$2;
reactJsxRuntime_production.jsx = jsxProd;
reactJsxRuntime_production.jsxs = jsxProd;

{
  jsxRuntime.exports = reactJsxRuntime_production;
}

var jsxRuntimeExports = jsxRuntime.exports;

var client = {exports: {}};

var reactDomClient_production = {};

var scheduler = {exports: {}};

var scheduler_production = {};

/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function (exports) {
	function push(heap, node) {
	  var index = heap.length;
	  heap.push(node);
	  a: for (; 0 < index; ) {
	    var parentIndex = (index - 1) >>> 1,
	      parent = heap[parentIndex];
	    if (0 < compare(parent, node))
	      (heap[parentIndex] = node), (heap[index] = parent), (index = parentIndex);
	    else break a;
	  }
	}
	function peek(heap) {
	  return 0 === heap.length ? null : heap[0];
	}
	function pop(heap) {
	  if (0 === heap.length) return null;
	  var first = heap[0],
	    last = heap.pop();
	  if (last !== first) {
	    heap[0] = last;
	    a: for (
	      var index = 0, length = heap.length, halfLength = length >>> 1;
	      index < halfLength;

	    ) {
	      var leftIndex = 2 * (index + 1) - 1,
	        left = heap[leftIndex],
	        rightIndex = leftIndex + 1,
	        right = heap[rightIndex];
	      if (0 > compare(left, last))
	        rightIndex < length && 0 > compare(right, left)
	          ? ((heap[index] = right),
	            (heap[rightIndex] = last),
	            (index = rightIndex))
	          : ((heap[index] = left),
	            (heap[leftIndex] = last),
	            (index = leftIndex));
	      else if (rightIndex < length && 0 > compare(right, last))
	        (heap[index] = right), (heap[rightIndex] = last), (index = rightIndex);
	      else break a;
	    }
	  }
	  return first;
	}
	function compare(a, b) {
	  var diff = a.sortIndex - b.sortIndex;
	  return 0 !== diff ? diff : a.id - b.id;
	}
	exports.unstable_now = void 0;
	if ("object" === typeof performance && "function" === typeof performance.now) {
	  var localPerformance = performance;
	  exports.unstable_now = function () {
	    return localPerformance.now();
	  };
	} else {
	  var localDate = Date,
	    initialTime = localDate.now();
	  exports.unstable_now = function () {
	    return localDate.now() - initialTime;
	  };
	}
	var taskQueue = [],
	  timerQueue = [],
	  taskIdCounter = 1,
	  currentTask = null,
	  currentPriorityLevel = 3,
	  isPerformingWork = false,
	  isHostCallbackScheduled = false,
	  isHostTimeoutScheduled = false,
	  needsPaint = false,
	  localSetTimeout = "function" === typeof setTimeout ? setTimeout : null,
	  localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null,
	  localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
	function advanceTimers(currentTime) {
	  for (var timer = peek(timerQueue); null !== timer; ) {
	    if (null === timer.callback) pop(timerQueue);
	    else if (timer.startTime <= currentTime)
	      pop(timerQueue),
	        (timer.sortIndex = timer.expirationTime),
	        push(taskQueue, timer);
	    else break;
	    timer = peek(timerQueue);
	  }
	}
	function handleTimeout(currentTime) {
	  isHostTimeoutScheduled = false;
	  advanceTimers(currentTime);
	  if (!isHostCallbackScheduled)
	    if (null !== peek(taskQueue))
	      (isHostCallbackScheduled = true),
	        isMessageLoopRunning ||
	          ((isMessageLoopRunning = true), schedulePerformWorkUntilDeadline());
	    else {
	      var firstTimer = peek(timerQueue);
	      null !== firstTimer &&
	        requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
	    }
	}
	var isMessageLoopRunning = false,
	  taskTimeoutID = -1,
	  frameInterval = 5,
	  startTime = -1;
	function shouldYieldToHost() {
	  return needsPaint
	    ? true
	    : exports.unstable_now() - startTime < frameInterval
	      ? false
	      : true;
	}
	function performWorkUntilDeadline() {
	  needsPaint = false;
	  if (isMessageLoopRunning) {
	    var currentTime = exports.unstable_now();
	    startTime = currentTime;
	    var hasMoreWork = true;
	    try {
	      a: {
	        isHostCallbackScheduled = !1;
	        isHostTimeoutScheduled &&
	          ((isHostTimeoutScheduled = !1),
	          localClearTimeout(taskTimeoutID),
	          (taskTimeoutID = -1));
	        isPerformingWork = !0;
	        var previousPriorityLevel = currentPriorityLevel;
	        try {
	          b: {
	            advanceTimers(currentTime);
	            for (
	              currentTask = peek(taskQueue);
	              null !== currentTask &&
	              !(
	                currentTask.expirationTime > currentTime && shouldYieldToHost()
	              );

	            ) {
	              var callback = currentTask.callback;
	              if ("function" === typeof callback) {
	                currentTask.callback = null;
	                currentPriorityLevel = currentTask.priorityLevel;
	                var continuationCallback = callback(
	                  currentTask.expirationTime <= currentTime
	                );
	                currentTime = exports.unstable_now();
	                if ("function" === typeof continuationCallback) {
	                  currentTask.callback = continuationCallback;
	                  advanceTimers(currentTime);
	                  hasMoreWork = !0;
	                  break b;
	                }
	                currentTask === peek(taskQueue) && pop(taskQueue);
	                advanceTimers(currentTime);
	              } else pop(taskQueue);
	              currentTask = peek(taskQueue);
	            }
	            if (null !== currentTask) hasMoreWork = !0;
	            else {
	              var firstTimer = peek(timerQueue);
	              null !== firstTimer &&
	                requestHostTimeout(
	                  handleTimeout,
	                  firstTimer.startTime - currentTime
	                );
	              hasMoreWork = !1;
	            }
	          }
	          break a;
	        } finally {
	          (currentTask = null),
	            (currentPriorityLevel = previousPriorityLevel),
	            (isPerformingWork = !1);
	        }
	        hasMoreWork = void 0;
	      }
	    } finally {
	      hasMoreWork
	        ? schedulePerformWorkUntilDeadline()
	        : (isMessageLoopRunning = false);
	    }
	  }
	}
	var schedulePerformWorkUntilDeadline;
	if ("function" === typeof localSetImmediate)
	  schedulePerformWorkUntilDeadline = function () {
	    localSetImmediate(performWorkUntilDeadline);
	  };
	else if ("undefined" !== typeof MessageChannel) {
	  var channel = new MessageChannel(),
	    port = channel.port2;
	  channel.port1.onmessage = performWorkUntilDeadline;
	  schedulePerformWorkUntilDeadline = function () {
	    port.postMessage(null);
	  };
	} else
	  schedulePerformWorkUntilDeadline = function () {
	    localSetTimeout(performWorkUntilDeadline, 0);
	  };
	function requestHostTimeout(callback, ms) {
	  taskTimeoutID = localSetTimeout(function () {
	    callback(exports.unstable_now());
	  }, ms);
	}
	exports.unstable_IdlePriority = 5;
	exports.unstable_ImmediatePriority = 1;
	exports.unstable_LowPriority = 4;
	exports.unstable_NormalPriority = 3;
	exports.unstable_Profiling = null;
	exports.unstable_UserBlockingPriority = 2;
	exports.unstable_cancelCallback = function (task) {
	  task.callback = null;
	};
	exports.unstable_forceFrameRate = function (fps) {
	  0 > fps || 125 < fps
	    ? console.error(
	        "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
	      )
	    : (frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5);
	};
	exports.unstable_getCurrentPriorityLevel = function () {
	  return currentPriorityLevel;
	};
	exports.unstable_next = function (eventHandler) {
	  switch (currentPriorityLevel) {
	    case 1:
	    case 2:
	    case 3:
	      var priorityLevel = 3;
	      break;
	    default:
	      priorityLevel = currentPriorityLevel;
	  }
	  var previousPriorityLevel = currentPriorityLevel;
	  currentPriorityLevel = priorityLevel;
	  try {
	    return eventHandler();
	  } finally {
	    currentPriorityLevel = previousPriorityLevel;
	  }
	};
	exports.unstable_requestPaint = function () {
	  needsPaint = true;
	};
	exports.unstable_runWithPriority = function (priorityLevel, eventHandler) {
	  switch (priorityLevel) {
	    case 1:
	    case 2:
	    case 3:
	    case 4:
	    case 5:
	      break;
	    default:
	      priorityLevel = 3;
	  }
	  var previousPriorityLevel = currentPriorityLevel;
	  currentPriorityLevel = priorityLevel;
	  try {
	    return eventHandler();
	  } finally {
	    currentPriorityLevel = previousPriorityLevel;
	  }
	};
	exports.unstable_scheduleCallback = function (
	  priorityLevel,
	  callback,
	  options
	) {
	  var currentTime = exports.unstable_now();
	  "object" === typeof options && null !== options
	    ? ((options = options.delay),
	      (options =
	        "number" === typeof options && 0 < options
	          ? currentTime + options
	          : currentTime))
	    : (options = currentTime);
	  switch (priorityLevel) {
	    case 1:
	      var timeout = -1;
	      break;
	    case 2:
	      timeout = 250;
	      break;
	    case 5:
	      timeout = 1073741823;
	      break;
	    case 4:
	      timeout = 1e4;
	      break;
	    default:
	      timeout = 5e3;
	  }
	  timeout = options + timeout;
	  priorityLevel = {
	    id: taskIdCounter++,
	    callback: callback,
	    priorityLevel: priorityLevel,
	    startTime: options,
	    expirationTime: timeout,
	    sortIndex: -1
	  };
	  options > currentTime
	    ? ((priorityLevel.sortIndex = options),
	      push(timerQueue, priorityLevel),
	      null === peek(taskQueue) &&
	        priorityLevel === peek(timerQueue) &&
	        (isHostTimeoutScheduled
	          ? (localClearTimeout(taskTimeoutID), (taskTimeoutID = -1))
	          : (isHostTimeoutScheduled = true),
	        requestHostTimeout(handleTimeout, options - currentTime)))
	    : ((priorityLevel.sortIndex = timeout),
	      push(taskQueue, priorityLevel),
	      isHostCallbackScheduled ||
	        isPerformingWork ||
	        ((isHostCallbackScheduled = true),
	        isMessageLoopRunning ||
	          ((isMessageLoopRunning = true), schedulePerformWorkUntilDeadline())));
	  return priorityLevel;
	};
	exports.unstable_shouldYield = shouldYieldToHost;
	exports.unstable_wrapCallback = function (callback) {
	  var parentPriorityLevel = currentPriorityLevel;
	  return function () {
	    var previousPriorityLevel = currentPriorityLevel;
	    currentPriorityLevel = parentPriorityLevel;
	    try {
	      return callback.apply(this, arguments);
	    } finally {
	      currentPriorityLevel = previousPriorityLevel;
	    }
	  };
	}; 
} (scheduler_production));

{
  scheduler.exports = scheduler_production;
}

var schedulerExports = scheduler.exports;

var react = {exports: {}};

var react_production = {};

/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var REACT_ELEMENT_TYPE$1 = Symbol.for("react.transitional.element"),
  REACT_PORTAL_TYPE$2 = Symbol.for("react.portal"),
  REACT_FRAGMENT_TYPE$1 = Symbol.for("react.fragment"),
  REACT_STRICT_MODE_TYPE$1 = Symbol.for("react.strict_mode"),
  REACT_PROFILER_TYPE$1 = Symbol.for("react.profiler"),
  REACT_CONSUMER_TYPE$1 = Symbol.for("react.consumer"),
  REACT_CONTEXT_TYPE$1 = Symbol.for("react.context"),
  REACT_FORWARD_REF_TYPE$1 = Symbol.for("react.forward_ref"),
  REACT_SUSPENSE_TYPE$1 = Symbol.for("react.suspense"),
  REACT_MEMO_TYPE$1 = Symbol.for("react.memo"),
  REACT_LAZY_TYPE$1 = Symbol.for("react.lazy"),
  MAYBE_ITERATOR_SYMBOL$1 = Symbol.iterator;
function getIteratorFn$1(maybeIterable) {
  if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
  maybeIterable =
    (MAYBE_ITERATOR_SYMBOL$1 && maybeIterable[MAYBE_ITERATOR_SYMBOL$1]) ||
    maybeIterable["@@iterator"];
  return "function" === typeof maybeIterable ? maybeIterable : null;
}
var ReactNoopUpdateQueue = {
    isMounted: function () {
      return false;
    },
    enqueueForceUpdate: function () {},
    enqueueReplaceState: function () {},
    enqueueSetState: function () {}
  },
  assign$1 = Object.assign,
  emptyObject = {};
function Component(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  this.updater = updater || ReactNoopUpdateQueue;
}
Component.prototype.isReactComponent = {};
Component.prototype.setState = function (partialState, callback) {
  if (
    "object" !== typeof partialState &&
    "function" !== typeof partialState &&
    null != partialState
  )
    throw Error(
      "takes an object of state variables to update or a function which returns an object of state variables."
    );
  this.updater.enqueueSetState(this, partialState, callback, "setState");
};
Component.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function ComponentDummy() {}
ComponentDummy.prototype = Component.prototype;
function PureComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  this.updater = updater || ReactNoopUpdateQueue;
}
var pureComponentPrototype = (PureComponent.prototype = new ComponentDummy());
pureComponentPrototype.constructor = PureComponent;
assign$1(pureComponentPrototype, Component.prototype);
pureComponentPrototype.isPureReactComponent = true;
var isArrayImpl$1 = Array.isArray,
  ReactSharedInternals$2 = { H: null, A: null, T: null, S: null, V: null },
  hasOwnProperty$1 = Object.prototype.hasOwnProperty;
function ReactElement(type, key, self, source, owner, props) {
  self = props.ref;
  return {
    $$typeof: REACT_ELEMENT_TYPE$1,
    type: type,
    key: key,
    ref: void 0 !== self ? self : null,
    props: props
  };
}
function cloneAndReplaceKey(oldElement, newKey) {
  return ReactElement(
    oldElement.type,
    newKey,
    void 0,
    void 0,
    void 0,
    oldElement.props
  );
}
function isValidElement(object) {
  return (
    "object" === typeof object &&
    null !== object &&
    object.$$typeof === REACT_ELEMENT_TYPE$1
  );
}
function escape(key) {
  var escaperLookup = { "=": "=0", ":": "=2" };
  return (
    "$" +
    key.replace(/[=:]/g, function (match) {
      return escaperLookup[match];
    })
  );
}
var userProvidedKeyEscapeRegex = /\/+/g;
function getElementKey(element, index) {
  return "object" === typeof element && null !== element && null != element.key
    ? escape("" + element.key)
    : index.toString(36);
}
function noop$1$1() {}
function resolveThenable(thenable) {
  switch (thenable.status) {
    case "fulfilled":
      return thenable.value;
    case "rejected":
      throw thenable.reason;
    default:
      switch (
        ("string" === typeof thenable.status
          ? thenable.then(noop$1$1, noop$1$1)
          : ((thenable.status = "pending"),
            thenable.then(
              function (fulfilledValue) {
                "pending" === thenable.status &&
                  ((thenable.status = "fulfilled"),
                  (thenable.value = fulfilledValue));
              },
              function (error) {
                "pending" === thenable.status &&
                  ((thenable.status = "rejected"), (thenable.reason = error));
              }
            )),
        thenable.status)
      ) {
        case "fulfilled":
          return thenable.value;
        case "rejected":
          throw thenable.reason;
      }
  }
  throw thenable;
}
function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
  var type = typeof children;
  if ("undefined" === type || "boolean" === type) children = null;
  var invokeCallback = false;
  if (null === children) invokeCallback = true;
  else
    switch (type) {
      case "bigint":
      case "string":
      case "number":
        invokeCallback = true;
        break;
      case "object":
        switch (children.$$typeof) {
          case REACT_ELEMENT_TYPE$1:
          case REACT_PORTAL_TYPE$2:
            invokeCallback = true;
            break;
          case REACT_LAZY_TYPE$1:
            return (
              (invokeCallback = children._init),
              mapIntoArray(
                invokeCallback(children._payload),
                array,
                escapedPrefix,
                nameSoFar,
                callback
              )
            );
        }
    }
  if (invokeCallback)
    return (
      (callback = callback(children)),
      (invokeCallback =
        "" === nameSoFar ? "." + getElementKey(children, 0) : nameSoFar),
      isArrayImpl$1(callback)
        ? ((escapedPrefix = ""),
          null != invokeCallback &&
            (escapedPrefix =
              invokeCallback.replace(userProvidedKeyEscapeRegex, "$&/") + "/"),
          mapIntoArray(callback, array, escapedPrefix, "", function (c) {
            return c;
          }))
        : null != callback &&
          (isValidElement(callback) &&
            (callback = cloneAndReplaceKey(
              callback,
              escapedPrefix +
                (null == callback.key ||
                (children && children.key === callback.key)
                  ? ""
                  : ("" + callback.key).replace(
                      userProvidedKeyEscapeRegex,
                      "$&/"
                    ) + "/") +
                invokeCallback
            )),
          array.push(callback)),
      1
    );
  invokeCallback = 0;
  var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
  if (isArrayImpl$1(children))
    for (var i = 0; i < children.length; i++)
      (nameSoFar = children[i]),
        (type = nextNamePrefix + getElementKey(nameSoFar, i)),
        (invokeCallback += mapIntoArray(
          nameSoFar,
          array,
          escapedPrefix,
          type,
          callback
        ));
  else if (((i = getIteratorFn$1(children)), "function" === typeof i))
    for (
      children = i.call(children), i = 0;
      !(nameSoFar = children.next()).done;

    )
      (nameSoFar = nameSoFar.value),
        (type = nextNamePrefix + getElementKey(nameSoFar, i++)),
        (invokeCallback += mapIntoArray(
          nameSoFar,
          array,
          escapedPrefix,
          type,
          callback
        ));
  else if ("object" === type) {
    if ("function" === typeof children.then)
      return mapIntoArray(
        resolveThenable(children),
        array,
        escapedPrefix,
        nameSoFar,
        callback
      );
    array = String(children);
    throw Error(
      "Objects are not valid as a React child (found: " +
        ("[object Object]" === array
          ? "object with keys {" + Object.keys(children).join(", ") + "}"
          : array) +
        "). If you meant to render a collection of children, use an array instead."
    );
  }
  return invokeCallback;
}
function mapChildren(children, func, context) {
  if (null == children) return children;
  var result = [],
    count = 0;
  mapIntoArray(children, result, "", "", function (child) {
    return func.call(context, child, count++);
  });
  return result;
}
function lazyInitializer(payload) {
  if (-1 === payload._status) {
    var ctor = payload._result;
    ctor = ctor();
    ctor.then(
      function (moduleObject) {
        if (0 === payload._status || -1 === payload._status)
          (payload._status = 1), (payload._result = moduleObject);
      },
      function (error) {
        if (0 === payload._status || -1 === payload._status)
          (payload._status = 2), (payload._result = error);
      }
    );
    -1 === payload._status && ((payload._status = 0), (payload._result = ctor));
  }
  if (1 === payload._status) return payload._result.default;
  throw payload._result;
}
var reportGlobalError$1 =
  "function" === typeof reportError
    ? reportError
    : function (error) {
        if (
          "object" === typeof window &&
          "function" === typeof window.ErrorEvent
        ) {
          var event = new window.ErrorEvent("error", {
            bubbles: true,
            cancelable: true,
            message:
              "object" === typeof error &&
              null !== error &&
              "string" === typeof error.message
                ? String(error.message)
                : String(error),
            error: error
          });
          if (!window.dispatchEvent(event)) return;
        } else if (
          "object" === typeof process &&
          "function" === typeof process.emit
        ) {
          process.emit("uncaughtException", error);
          return;
        }
        console.error(error);
      };
function noop$5() {}
react_production.Children = {
  map: mapChildren,
  forEach: function (children, forEachFunc, forEachContext) {
    mapChildren(
      children,
      function () {
        forEachFunc.apply(this, arguments);
      },
      forEachContext
    );
  },
  count: function (children) {
    var n = 0;
    mapChildren(children, function () {
      n++;
    });
    return n;
  },
  toArray: function (children) {
    return (
      mapChildren(children, function (child) {
        return child;
      }) || []
    );
  },
  only: function (children) {
    if (!isValidElement(children))
      throw Error(
        "React.Children.only expected to receive a single React element child."
      );
    return children;
  }
};
react_production.Component = Component;
react_production.Fragment = REACT_FRAGMENT_TYPE$1;
react_production.Profiler = REACT_PROFILER_TYPE$1;
react_production.PureComponent = PureComponent;
react_production.StrictMode = REACT_STRICT_MODE_TYPE$1;
react_production.Suspense = REACT_SUSPENSE_TYPE$1;
react_production.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE =
  ReactSharedInternals$2;
react_production.__COMPILER_RUNTIME = {
  __proto__: null,
  c: function (size) {
    return ReactSharedInternals$2.H.useMemoCache(size);
  }
};
react_production.cache = function (fn) {
  return function () {
    return fn.apply(null, arguments);
  };
};
react_production.cloneElement = function (element, config, children) {
  if (null === element || void 0 === element)
    throw Error(
      "The argument must be a React element, but you passed " + element + "."
    );
  var props = assign$1({}, element.props),
    key = element.key,
    owner = void 0;
  if (null != config)
    for (propName in (void 0 !== config.ref && (owner = void 0),
    void 0 !== config.key && (key = "" + config.key),
    config))
      !hasOwnProperty$1.call(config, propName) ||
        "key" === propName ||
        "__self" === propName ||
        "__source" === propName ||
        ("ref" === propName && void 0 === config.ref) ||
        (props[propName] = config[propName]);
  var propName = arguments.length - 2;
  if (1 === propName) props.children = children;
  else if (1 < propName) {
    for (var childArray = Array(propName), i = 0; i < propName; i++)
      childArray[i] = arguments[i + 2];
    props.children = childArray;
  }
  return ReactElement(element.type, key, void 0, void 0, owner, props);
};
react_production.createContext = function (defaultValue) {
  defaultValue = {
    $$typeof: REACT_CONTEXT_TYPE$1,
    _currentValue: defaultValue,
    _currentValue2: defaultValue,
    _threadCount: 0,
    Provider: null,
    Consumer: null
  };
  defaultValue.Provider = defaultValue;
  defaultValue.Consumer = {
    $$typeof: REACT_CONSUMER_TYPE$1,
    _context: defaultValue
  };
  return defaultValue;
};
react_production.createElement = function (type, config, children) {
  var propName,
    props = {},
    key = null;
  if (null != config)
    for (propName in (void 0 !== config.key && (key = "" + config.key), config))
      hasOwnProperty$1.call(config, propName) &&
        "key" !== propName &&
        "__self" !== propName &&
        "__source" !== propName &&
        (props[propName] = config[propName]);
  var childrenLength = arguments.length - 2;
  if (1 === childrenLength) props.children = children;
  else if (1 < childrenLength) {
    for (var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)
      childArray[i] = arguments[i + 2];
    props.children = childArray;
  }
  if (type && type.defaultProps)
    for (propName in ((childrenLength = type.defaultProps), childrenLength))
      void 0 === props[propName] &&
        (props[propName] = childrenLength[propName]);
  return ReactElement(type, key, void 0, void 0, null, props);
};
react_production.createRef = function () {
  return { current: null };
};
react_production.forwardRef = function (render) {
  return { $$typeof: REACT_FORWARD_REF_TYPE$1, render: render };
};
react_production.isValidElement = isValidElement;
react_production.lazy = function (ctor) {
  return {
    $$typeof: REACT_LAZY_TYPE$1,
    _payload: { _status: -1, _result: ctor },
    _init: lazyInitializer
  };
};
react_production.memo = function (type, compare) {
  return {
    $$typeof: REACT_MEMO_TYPE$1,
    type: type,
    compare: void 0 === compare ? null : compare
  };
};
react_production.startTransition = function (scope) {
  var prevTransition = ReactSharedInternals$2.T,
    currentTransition = {};
  ReactSharedInternals$2.T = currentTransition;
  try {
    var returnValue = scope(),
      onStartTransitionFinish = ReactSharedInternals$2.S;
    null !== onStartTransitionFinish &&
      onStartTransitionFinish(currentTransition, returnValue);
    "object" === typeof returnValue &&
      null !== returnValue &&
      "function" === typeof returnValue.then &&
      returnValue.then(noop$5, reportGlobalError$1);
  } catch (error) {
    reportGlobalError$1(error);
  } finally {
    ReactSharedInternals$2.T = prevTransition;
  }
};
react_production.unstable_useCacheRefresh = function () {
  return ReactSharedInternals$2.H.useCacheRefresh();
};
react_production.use = function (usable) {
  return ReactSharedInternals$2.H.use(usable);
};
react_production.useActionState = function (action, initialState, permalink) {
  return ReactSharedInternals$2.H.useActionState(action, initialState, permalink);
};
react_production.useCallback = function (callback, deps) {
  return ReactSharedInternals$2.H.useCallback(callback, deps);
};
react_production.useContext = function (Context) {
  return ReactSharedInternals$2.H.useContext(Context);
};
react_production.useDebugValue = function () {};
react_production.useDeferredValue = function (value, initialValue) {
  return ReactSharedInternals$2.H.useDeferredValue(value, initialValue);
};
react_production.useEffect = function (create, createDeps, update) {
  var dispatcher = ReactSharedInternals$2.H;
  if ("function" === typeof update)
    throw Error(
      "useEffect CRUD overload is not enabled in this build of React."
    );
  return dispatcher.useEffect(create, createDeps);
};
react_production.useId = function () {
  return ReactSharedInternals$2.H.useId();
};
react_production.useImperativeHandle = function (ref, create, deps) {
  return ReactSharedInternals$2.H.useImperativeHandle(ref, create, deps);
};
react_production.useInsertionEffect = function (create, deps) {
  return ReactSharedInternals$2.H.useInsertionEffect(create, deps);
};
react_production.useLayoutEffect = function (create, deps) {
  return ReactSharedInternals$2.H.useLayoutEffect(create, deps);
};
react_production.useMemo = function (create, deps) {
  return ReactSharedInternals$2.H.useMemo(create, deps);
};
react_production.useOptimistic = function (passthrough, reducer) {
  return ReactSharedInternals$2.H.useOptimistic(passthrough, reducer);
};
react_production.useReducer = function (reducer, initialArg, init) {
  return ReactSharedInternals$2.H.useReducer(reducer, initialArg, init);
};
react_production.useRef = function (initialValue) {
  return ReactSharedInternals$2.H.useRef(initialValue);
};
react_production.useState = function (initialState) {
  return ReactSharedInternals$2.H.useState(initialState);
};
react_production.useSyncExternalStore = function (
  subscribe,
  getSnapshot,
  getServerSnapshot
) {
  return ReactSharedInternals$2.H.useSyncExternalStore(
    subscribe,
    getSnapshot,
    getServerSnapshot
  );
};
react_production.useTransition = function () {
  return ReactSharedInternals$2.H.useTransition();
};
react_production.version = "19.1.1";

{
  react.exports = react_production;
}

var reactExports = react.exports;

var reactDom = {exports: {}};

var reactDom_production = {};

/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var React$1 = reactExports;
function formatProdErrorMessage$1(code) {
  var url = "https://react.dev/errors/" + code;
  if (1 < arguments.length) {
    url += "?args[]=" + encodeURIComponent(arguments[1]);
    for (var i = 2; i < arguments.length; i++)
      url += "&args[]=" + encodeURIComponent(arguments[i]);
  }
  return (
    "Minified React error #" +
    code +
    "; visit " +
    url +
    " for the full message or use the non-minified dev environment for full errors and additional helpful warnings."
  );
}
function noop$4() {}
var Internals = {
    d: {
      f: noop$4,
      r: function () {
        throw Error(formatProdErrorMessage$1(522));
      },
      D: noop$4,
      C: noop$4,
      L: noop$4,
      m: noop$4,
      X: noop$4,
      S: noop$4,
      M: noop$4
    },
    p: 0,
    findDOMNode: null
  },
  REACT_PORTAL_TYPE$1 = Symbol.for("react.portal");
function createPortal$1(children, containerInfo, implementation) {
  var key =
    3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
  return {
    $$typeof: REACT_PORTAL_TYPE$1,
    key: null == key ? null : "" + key,
    children: children,
    containerInfo: containerInfo,
    implementation: implementation
  };
}
var ReactSharedInternals$1 =
  React$1.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function getCrossOriginStringAs(as, input) {
  if ("font" === as) return "";
  if ("string" === typeof input)
    return "use-credentials" === input ? input : "";
}
reactDom_production.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE =
  Internals;
reactDom_production.createPortal = function (children, container) {
  var key =
    2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
  if (
    !container ||
    (1 !== container.nodeType &&
      9 !== container.nodeType &&
      11 !== container.nodeType)
  )
    throw Error(formatProdErrorMessage$1(299));
  return createPortal$1(children, container, null, key);
};
reactDom_production.flushSync = function (fn) {
  var previousTransition = ReactSharedInternals$1.T,
    previousUpdatePriority = Internals.p;
  try {
    if (((ReactSharedInternals$1.T = null), (Internals.p = 2), fn)) return fn();
  } finally {
    (ReactSharedInternals$1.T = previousTransition),
      (Internals.p = previousUpdatePriority),
      Internals.d.f();
  }
};
reactDom_production.preconnect = function (href, options) {
  "string" === typeof href &&
    (options
      ? ((options = options.crossOrigin),
        (options =
          "string" === typeof options
            ? "use-credentials" === options
              ? options
              : ""
            : void 0))
      : (options = null),
    Internals.d.C(href, options));
};
reactDom_production.prefetchDNS = function (href) {
  "string" === typeof href && Internals.d.D(href);
};
reactDom_production.preinit = function (href, options) {
  if ("string" === typeof href && options && "string" === typeof options.as) {
    var as = options.as,
      crossOrigin = getCrossOriginStringAs(as, options.crossOrigin),
      integrity =
        "string" === typeof options.integrity ? options.integrity : void 0,
      fetchPriority =
        "string" === typeof options.fetchPriority
          ? options.fetchPriority
          : void 0;
    "style" === as
      ? Internals.d.S(
          href,
          "string" === typeof options.precedence ? options.precedence : void 0,
          {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
          }
        )
      : "script" === as &&
        Internals.d.X(href, {
          crossOrigin: crossOrigin,
          integrity: integrity,
          fetchPriority: fetchPriority,
          nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
  }
};
reactDom_production.preinitModule = function (href, options) {
  if ("string" === typeof href)
    if ("object" === typeof options && null !== options) {
      if (null == options.as || "script" === options.as) {
        var crossOrigin = getCrossOriginStringAs(
          options.as,
          options.crossOrigin
        );
        Internals.d.M(href, {
          crossOrigin: crossOrigin,
          integrity:
            "string" === typeof options.integrity ? options.integrity : void 0,
          nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
      }
    } else null == options && Internals.d.M(href);
};
reactDom_production.preload = function (href, options) {
  if (
    "string" === typeof href &&
    "object" === typeof options &&
    null !== options &&
    "string" === typeof options.as
  ) {
    var as = options.as,
      crossOrigin = getCrossOriginStringAs(as, options.crossOrigin);
    Internals.d.L(href, as, {
      crossOrigin: crossOrigin,
      integrity:
        "string" === typeof options.integrity ? options.integrity : void 0,
      nonce: "string" === typeof options.nonce ? options.nonce : void 0,
      type: "string" === typeof options.type ? options.type : void 0,
      fetchPriority:
        "string" === typeof options.fetchPriority
          ? options.fetchPriority
          : void 0,
      referrerPolicy:
        "string" === typeof options.referrerPolicy
          ? options.referrerPolicy
          : void 0,
      imageSrcSet:
        "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
      imageSizes:
        "string" === typeof options.imageSizes ? options.imageSizes : void 0,
      media: "string" === typeof options.media ? options.media : void 0
    });
  }
};
reactDom_production.preloadModule = function (href, options) {
  if ("string" === typeof href)
    if (options) {
      var crossOrigin = getCrossOriginStringAs(options.as, options.crossOrigin);
      Internals.d.m(href, {
        as:
          "string" === typeof options.as && "script" !== options.as
            ? options.as
            : void 0,
        crossOrigin: crossOrigin,
        integrity:
          "string" === typeof options.integrity ? options.integrity : void 0
      });
    } else Internals.d.m(href);
};
reactDom_production.requestFormReset = function (form) {
  Internals.d.r(form);
};
reactDom_production.unstable_batchedUpdates = function (fn, a) {
  return fn(a);
};
reactDom_production.useFormState = function (action, initialState, permalink) {
  return ReactSharedInternals$1.H.useFormState(action, initialState, permalink);
};
reactDom_production.useFormStatus = function () {
  return ReactSharedInternals$1.H.useHostTransitionStatus();
};
reactDom_production.version = "19.1.1";

function checkDCE$1() {
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") {
    return;
  }
  try {
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE$1);
  } catch (err) {
    console.error(err);
  }
}
{
  checkDCE$1();
  reactDom.exports = reactDom_production;
}

var reactDomExports = reactDom.exports;

/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Scheduler = schedulerExports,
  React = reactExports,
  ReactDOM = reactDomExports;
function formatProdErrorMessage(code) {
  var url = "https://react.dev/errors/" + code;
  if (1 < arguments.length) {
    url += "?args[]=" + encodeURIComponent(arguments[1]);
    for (var i = 2; i < arguments.length; i++)
      url += "&args[]=" + encodeURIComponent(arguments[i]);
  }
  return (
    "Minified React error #" +
    code +
    "; visit " +
    url +
    " for the full message or use the non-minified dev environment for full errors and additional helpful warnings."
  );
}
function isValidContainer(node) {
  return !(
    !node ||
    (1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType)
  );
}
function getNearestMountedFiber(fiber) {
  var node = fiber,
    nearestMounted = fiber;
  if (fiber.alternate) for (; node.return; ) node = node.return;
  else {
    fiber = node;
    do
      (node = fiber),
        0 !== (node.flags & 4098) && (nearestMounted = node.return),
        (fiber = node.return);
    while (fiber);
  }
  return 3 === node.tag ? nearestMounted : null;
}
function getSuspenseInstanceFromFiber(fiber) {
  if (13 === fiber.tag) {
    var suspenseState = fiber.memoizedState;
    null === suspenseState &&
      ((fiber = fiber.alternate),
      null !== fiber && (suspenseState = fiber.memoizedState));
    if (null !== suspenseState) return suspenseState.dehydrated;
  }
  return null;
}
function assertIsMounted(fiber) {
  if (getNearestMountedFiber(fiber) !== fiber)
    throw Error(formatProdErrorMessage(188));
}
function findCurrentFiberUsingSlowPath(fiber) {
  var alternate = fiber.alternate;
  if (!alternate) {
    alternate = getNearestMountedFiber(fiber);
    if (null === alternate) throw Error(formatProdErrorMessage(188));
    return alternate !== fiber ? null : fiber;
  }
  for (var a = fiber, b = alternate; ; ) {
    var parentA = a.return;
    if (null === parentA) break;
    var parentB = parentA.alternate;
    if (null === parentB) {
      b = parentA.return;
      if (null !== b) {
        a = b;
        continue;
      }
      break;
    }
    if (parentA.child === parentB.child) {
      for (parentB = parentA.child; parentB; ) {
        if (parentB === a) return assertIsMounted(parentA), fiber;
        if (parentB === b) return assertIsMounted(parentA), alternate;
        parentB = parentB.sibling;
      }
      throw Error(formatProdErrorMessage(188));
    }
    if (a.return !== b.return) (a = parentA), (b = parentB);
    else {
      for (var didFindChild = false, child$0 = parentA.child; child$0; ) {
        if (child$0 === a) {
          didFindChild = true;
          a = parentA;
          b = parentB;
          break;
        }
        if (child$0 === b) {
          didFindChild = true;
          b = parentA;
          a = parentB;
          break;
        }
        child$0 = child$0.sibling;
      }
      if (!didFindChild) {
        for (child$0 = parentB.child; child$0; ) {
          if (child$0 === a) {
            didFindChild = true;
            a = parentB;
            b = parentA;
            break;
          }
          if (child$0 === b) {
            didFindChild = true;
            b = parentB;
            a = parentA;
            break;
          }
          child$0 = child$0.sibling;
        }
        if (!didFindChild) throw Error(formatProdErrorMessage(189));
      }
    }
    if (a.alternate !== b) throw Error(formatProdErrorMessage(190));
  }
  if (3 !== a.tag) throw Error(formatProdErrorMessage(188));
  return a.stateNode.current === a ? fiber : alternate;
}
function findCurrentHostFiberImpl(node) {
  var tag = node.tag;
  if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
  for (node = node.child; null !== node; ) {
    tag = findCurrentHostFiberImpl(node);
    if (null !== tag) return tag;
    node = node.sibling;
  }
  return null;
}
var assign = Object.assign,
  REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"),
  REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"),
  REACT_PORTAL_TYPE = Symbol.for("react.portal"),
  REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"),
  REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"),
  REACT_PROFILER_TYPE = Symbol.for("react.profiler"),
  REACT_PROVIDER_TYPE = Symbol.for("react.provider"),
  REACT_CONSUMER_TYPE = Symbol.for("react.consumer"),
  REACT_CONTEXT_TYPE = Symbol.for("react.context"),
  REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"),
  REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"),
  REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"),
  REACT_MEMO_TYPE = Symbol.for("react.memo"),
  REACT_LAZY_TYPE = Symbol.for("react.lazy");
var REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
var REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
  if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
  maybeIterable =
    (MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL]) ||
    maybeIterable["@@iterator"];
  return "function" === typeof maybeIterable ? maybeIterable : null;
}
var REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function getComponentNameFromType(type) {
  if (null == type) return null;
  if ("function" === typeof type)
    return type.$$typeof === REACT_CLIENT_REFERENCE
      ? null
      : type.displayName || type.name || null;
  if ("string" === typeof type) return type;
  switch (type) {
    case REACT_FRAGMENT_TYPE:
      return "Fragment";
    case REACT_PROFILER_TYPE:
      return "Profiler";
    case REACT_STRICT_MODE_TYPE:
      return "StrictMode";
    case REACT_SUSPENSE_TYPE:
      return "Suspense";
    case REACT_SUSPENSE_LIST_TYPE:
      return "SuspenseList";
    case REACT_ACTIVITY_TYPE:
      return "Activity";
  }
  if ("object" === typeof type)
    switch (type.$$typeof) {
      case REACT_PORTAL_TYPE:
        return "Portal";
      case REACT_CONTEXT_TYPE:
        return (type.displayName || "Context") + ".Provider";
      case REACT_CONSUMER_TYPE:
        return (type._context.displayName || "Context") + ".Consumer";
      case REACT_FORWARD_REF_TYPE:
        var innerType = type.render;
        type = type.displayName;
        type ||
          ((type = innerType.displayName || innerType.name || ""),
          (type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef"));
        return type;
      case REACT_MEMO_TYPE:
        return (
          (innerType = type.displayName || null),
          null !== innerType
            ? innerType
            : getComponentNameFromType(type.type) || "Memo"
        );
      case REACT_LAZY_TYPE:
        innerType = type._payload;
        type = type._init;
        try {
          return getComponentNameFromType(type(innerType));
        } catch (x) {}
    }
  return null;
}
var isArrayImpl = Array.isArray,
  ReactSharedInternals =
    React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
  ReactDOMSharedInternals =
    ReactDOM.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
  sharedNotPendingObject = {
    pending: false,
    data: null,
    method: null,
    action: null
  },
  valueStack = [],
  index$1 = -1;
function createCursor(defaultValue) {
  return { current: defaultValue };
}
function pop(cursor) {
  0 > index$1 ||
    ((cursor.current = valueStack[index$1]), (valueStack[index$1] = null), index$1--);
}
function push(cursor, value) {
  index$1++;
  valueStack[index$1] = cursor.current;
  cursor.current = value;
}
var contextStackCursor = createCursor(null),
  contextFiberStackCursor = createCursor(null),
  rootInstanceStackCursor = createCursor(null),
  hostTransitionProviderCursor = createCursor(null);
function pushHostContainer(fiber, nextRootInstance) {
  push(rootInstanceStackCursor, nextRootInstance);
  push(contextFiberStackCursor, fiber);
  push(contextStackCursor, null);
  switch (nextRootInstance.nodeType) {
    case 9:
    case 11:
      fiber = (fiber = nextRootInstance.documentElement)
        ? (fiber = fiber.namespaceURI)
          ? getOwnHostContext(fiber)
          : 0
        : 0;
      break;
    default:
      if (
        ((fiber = nextRootInstance.tagName),
        (nextRootInstance = nextRootInstance.namespaceURI))
      )
        (nextRootInstance = getOwnHostContext(nextRootInstance)),
          (fiber = getChildHostContextProd(nextRootInstance, fiber));
      else
        switch (fiber) {
          case "svg":
            fiber = 1;
            break;
          case "math":
            fiber = 2;
            break;
          default:
            fiber = 0;
        }
  }
  pop(contextStackCursor);
  push(contextStackCursor, fiber);
}
function popHostContainer() {
  pop(contextStackCursor);
  pop(contextFiberStackCursor);
  pop(rootInstanceStackCursor);
}
function pushHostContext(fiber) {
  null !== fiber.memoizedState && push(hostTransitionProviderCursor, fiber);
  var context = contextStackCursor.current;
  var JSCompiler_inline_result = getChildHostContextProd(context, fiber.type);
  context !== JSCompiler_inline_result &&
    (push(contextFiberStackCursor, fiber),
    push(contextStackCursor, JSCompiler_inline_result));
}
function popHostContext(fiber) {
  contextFiberStackCursor.current === fiber &&
    (pop(contextStackCursor), pop(contextFiberStackCursor));
  hostTransitionProviderCursor.current === fiber &&
    (pop(hostTransitionProviderCursor),
    (HostTransitionContext._currentValue = sharedNotPendingObject));
}
var hasOwnProperty = Object.prototype.hasOwnProperty,
  scheduleCallback$3 = Scheduler.unstable_scheduleCallback,
  cancelCallback$1 = Scheduler.unstable_cancelCallback,
  shouldYield = Scheduler.unstable_shouldYield,
  requestPaint = Scheduler.unstable_requestPaint,
  now$1 = Scheduler.unstable_now,
  getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel,
  ImmediatePriority = Scheduler.unstable_ImmediatePriority,
  UserBlockingPriority = Scheduler.unstable_UserBlockingPriority,
  NormalPriority$1 = Scheduler.unstable_NormalPriority,
  LowPriority = Scheduler.unstable_LowPriority,
  IdlePriority = Scheduler.unstable_IdlePriority,
  log$1 = Scheduler.log,
  unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue,
  rendererID = null,
  injectedHook = null;
function setIsStrictModeForDevtools(newIsStrictMode) {
  "function" === typeof log$1 && unstable_setDisableYieldValue(newIsStrictMode);
  if (injectedHook && "function" === typeof injectedHook.setStrictMode)
    try {
      injectedHook.setStrictMode(rendererID, newIsStrictMode);
    } catch (err) {}
}
var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback,
  log = Math.log,
  LN2 = Math.LN2;
function clz32Fallback(x) {
  x >>>= 0;
  return 0 === x ? 32 : (31 - ((log(x) / LN2) | 0)) | 0;
}
var nextTransitionLane = 256,
  nextRetryLane = 4194304;
function getHighestPriorityLanes(lanes) {
  var pendingSyncLanes = lanes & 42;
  if (0 !== pendingSyncLanes) return pendingSyncLanes;
  switch (lanes & -lanes) {
    case 1:
      return 1;
    case 2:
      return 2;
    case 4:
      return 4;
    case 8:
      return 8;
    case 16:
      return 16;
    case 32:
      return 32;
    case 64:
      return 64;
    case 128:
      return 128;
    case 256:
    case 512:
    case 1024:
    case 2048:
    case 4096:
    case 8192:
    case 16384:
    case 32768:
    case 65536:
    case 131072:
    case 262144:
    case 524288:
    case 1048576:
    case 2097152:
      return lanes & 4194048;
    case 4194304:
    case 8388608:
    case 16777216:
    case 33554432:
      return lanes & 62914560;
    case 67108864:
      return 67108864;
    case 134217728:
      return 134217728;
    case 268435456:
      return 268435456;
    case 536870912:
      return 536870912;
    case 1073741824:
      return 0;
    default:
      return lanes;
  }
}
function getNextLanes(root, wipLanes, rootHasPendingCommit) {
  var pendingLanes = root.pendingLanes;
  if (0 === pendingLanes) return 0;
  var nextLanes = 0,
    suspendedLanes = root.suspendedLanes,
    pingedLanes = root.pingedLanes;
  root = root.warmLanes;
  var nonIdlePendingLanes = pendingLanes & 134217727;
  0 !== nonIdlePendingLanes
    ? ((pendingLanes = nonIdlePendingLanes & ~suspendedLanes),
      0 !== pendingLanes
        ? (nextLanes = getHighestPriorityLanes(pendingLanes))
        : ((pingedLanes &= nonIdlePendingLanes),
          0 !== pingedLanes
            ? (nextLanes = getHighestPriorityLanes(pingedLanes))
            : rootHasPendingCommit ||
              ((rootHasPendingCommit = nonIdlePendingLanes & ~root),
              0 !== rootHasPendingCommit &&
                (nextLanes = getHighestPriorityLanes(rootHasPendingCommit)))))
    : ((nonIdlePendingLanes = pendingLanes & ~suspendedLanes),
      0 !== nonIdlePendingLanes
        ? (nextLanes = getHighestPriorityLanes(nonIdlePendingLanes))
        : 0 !== pingedLanes
          ? (nextLanes = getHighestPriorityLanes(pingedLanes))
          : rootHasPendingCommit ||
            ((rootHasPendingCommit = pendingLanes & ~root),
            0 !== rootHasPendingCommit &&
              (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))));
  return 0 === nextLanes
    ? 0
    : 0 !== wipLanes &&
        wipLanes !== nextLanes &&
        0 === (wipLanes & suspendedLanes) &&
        ((suspendedLanes = nextLanes & -nextLanes),
        (rootHasPendingCommit = wipLanes & -wipLanes),
        suspendedLanes >= rootHasPendingCommit ||
          (32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)))
      ? wipLanes
      : nextLanes;
}
function checkIfRootIsPrerendering(root, renderLanes) {
  return (
    0 ===
    (root.pendingLanes &
      ~(root.suspendedLanes & ~root.pingedLanes) &
      renderLanes)
  );
}
function computeExpirationTime(lane, currentTime) {
  switch (lane) {
    case 1:
    case 2:
    case 4:
    case 8:
    case 64:
      return currentTime + 250;
    case 16:
    case 32:
    case 128:
    case 256:
    case 512:
    case 1024:
    case 2048:
    case 4096:
    case 8192:
    case 16384:
    case 32768:
    case 65536:
    case 131072:
    case 262144:
    case 524288:
    case 1048576:
    case 2097152:
      return currentTime + 5e3;
    case 4194304:
    case 8388608:
    case 16777216:
    case 33554432:
      return -1;
    case 67108864:
    case 134217728:
    case 268435456:
    case 536870912:
    case 1073741824:
      return -1;
    default:
      return -1;
  }
}
function claimNextTransitionLane() {
  var lane = nextTransitionLane;
  nextTransitionLane <<= 1;
  0 === (nextTransitionLane & 4194048) && (nextTransitionLane = 256);
  return lane;
}
function claimNextRetryLane() {
  var lane = nextRetryLane;
  nextRetryLane <<= 1;
  0 === (nextRetryLane & 62914560) && (nextRetryLane = 4194304);
  return lane;
}
function createLaneMap(initial) {
  for (var laneMap = [], i = 0; 31 > i; i++) laneMap.push(initial);
  return laneMap;
}
function markRootUpdated$1(root, updateLane) {
  root.pendingLanes |= updateLane;
  268435456 !== updateLane &&
    ((root.suspendedLanes = 0), (root.pingedLanes = 0), (root.warmLanes = 0));
}
function markRootFinished(
  root,
  finishedLanes,
  remainingLanes,
  spawnedLane,
  updatedLanes,
  suspendedRetryLanes
) {
  var previouslyPendingLanes = root.pendingLanes;
  root.pendingLanes = remainingLanes;
  root.suspendedLanes = 0;
  root.pingedLanes = 0;
  root.warmLanes = 0;
  root.expiredLanes &= remainingLanes;
  root.entangledLanes &= remainingLanes;
  root.errorRecoveryDisabledLanes &= remainingLanes;
  root.shellSuspendCounter = 0;
  var entanglements = root.entanglements,
    expirationTimes = root.expirationTimes,
    hiddenUpdates = root.hiddenUpdates;
  for (
    remainingLanes = previouslyPendingLanes & ~remainingLanes;
    0 < remainingLanes;

  ) {
    var index$5 = 31 - clz32(remainingLanes),
      lane = 1 << index$5;
    entanglements[index$5] = 0;
    expirationTimes[index$5] = -1;
    var hiddenUpdatesForLane = hiddenUpdates[index$5];
    if (null !== hiddenUpdatesForLane)
      for (
        hiddenUpdates[index$5] = null, index$5 = 0;
        index$5 < hiddenUpdatesForLane.length;
        index$5++
      ) {
        var update = hiddenUpdatesForLane[index$5];
        null !== update && (update.lane &= -536870913);
      }
    remainingLanes &= ~lane;
  }
  0 !== spawnedLane && markSpawnedDeferredLane(root, spawnedLane, 0);
  0 !== suspendedRetryLanes &&
    0 === updatedLanes &&
    0 !== root.tag &&
    (root.suspendedLanes |=
      suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
  root.pendingLanes |= spawnedLane;
  root.suspendedLanes &= ~spawnedLane;
  var spawnedLaneIndex = 31 - clz32(spawnedLane);
  root.entangledLanes |= spawnedLane;
  root.entanglements[spawnedLaneIndex] =
    root.entanglements[spawnedLaneIndex] |
    1073741824 |
    (entangledLanes & 4194090);
}
function markRootEntangled(root, entangledLanes) {
  var rootEntangledLanes = (root.entangledLanes |= entangledLanes);
  for (root = root.entanglements; rootEntangledLanes; ) {
    var index$6 = 31 - clz32(rootEntangledLanes),
      lane = 1 << index$6;
    (lane & entangledLanes) | (root[index$6] & entangledLanes) &&
      (root[index$6] |= entangledLanes);
    rootEntangledLanes &= ~lane;
  }
}
function getBumpedLaneForHydrationByLane(lane) {
  switch (lane) {
    case 2:
      lane = 1;
      break;
    case 8:
      lane = 4;
      break;
    case 32:
      lane = 16;
      break;
    case 256:
    case 512:
    case 1024:
    case 2048:
    case 4096:
    case 8192:
    case 16384:
    case 32768:
    case 65536:
    case 131072:
    case 262144:
    case 524288:
    case 1048576:
    case 2097152:
    case 4194304:
    case 8388608:
    case 16777216:
    case 33554432:
      lane = 128;
      break;
    case 268435456:
      lane = 134217728;
      break;
    default:
      lane = 0;
  }
  return lane;
}
function lanesToEventPriority(lanes) {
  lanes &= -lanes;
  return 2 < lanes
    ? 8 < lanes
      ? 0 !== (lanes & 134217727)
        ? 32
        : 268435456
      : 8
    : 2;
}
function resolveUpdatePriority() {
  var updatePriority = ReactDOMSharedInternals.p;
  if (0 !== updatePriority) return updatePriority;
  updatePriority = window.event;
  return void 0 === updatePriority ? 32 : getEventPriority(updatePriority.type);
}
function runWithPriority(priority, fn) {
  var previousPriority = ReactDOMSharedInternals.p;
  try {
    return (ReactDOMSharedInternals.p = priority), fn();
  } finally {
    ReactDOMSharedInternals.p = previousPriority;
  }
}
var randomKey = Math.random().toString(36).slice(2),
  internalInstanceKey = "__reactFiber$" + randomKey,
  internalPropsKey = "__reactProps$" + randomKey,
  internalContainerInstanceKey = "__reactContainer$" + randomKey,
  internalEventHandlersKey = "__reactEvents$" + randomKey,
  internalEventHandlerListenersKey = "__reactListeners$" + randomKey,
  internalEventHandlesSetKey = "__reactHandles$" + randomKey,
  internalRootNodeResourcesKey = "__reactResources$" + randomKey,
  internalHoistableMarker = "__reactMarker$" + randomKey;
function detachDeletedInstance(node) {
  delete node[internalInstanceKey];
  delete node[internalPropsKey];
  delete node[internalEventHandlersKey];
  delete node[internalEventHandlerListenersKey];
  delete node[internalEventHandlesSetKey];
}
function getClosestInstanceFromNode(targetNode) {
  var targetInst = targetNode[internalInstanceKey];
  if (targetInst) return targetInst;
  for (var parentNode = targetNode.parentNode; parentNode; ) {
    if (
      (targetInst =
        parentNode[internalContainerInstanceKey] ||
        parentNode[internalInstanceKey])
    ) {
      parentNode = targetInst.alternate;
      if (
        null !== targetInst.child ||
        (null !== parentNode && null !== parentNode.child)
      )
        for (
          targetNode = getParentSuspenseInstance(targetNode);
          null !== targetNode;

        ) {
          if ((parentNode = targetNode[internalInstanceKey])) return parentNode;
          targetNode = getParentSuspenseInstance(targetNode);
        }
      return targetInst;
    }
    targetNode = parentNode;
    parentNode = targetNode.parentNode;
  }
  return null;
}
function getInstanceFromNode(node) {
  if (
    (node = node[internalInstanceKey] || node[internalContainerInstanceKey])
  ) {
    var tag = node.tag;
    if (
      5 === tag ||
      6 === tag ||
      13 === tag ||
      26 === tag ||
      27 === tag ||
      3 === tag
    )
      return node;
  }
  return null;
}
function getNodeFromInstance(inst) {
  var tag = inst.tag;
  if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
  throw Error(formatProdErrorMessage(33));
}
function getResourcesFromRoot(root) {
  var resources = root[internalRootNodeResourcesKey];
  resources ||
    (resources = root[internalRootNodeResourcesKey] =
      { hoistableStyles: new Map(), hoistableScripts: new Map() });
  return resources;
}
function markNodeAsHoistable(node) {
  node[internalHoistableMarker] = true;
}
var allNativeEvents = new Set(),
  registrationNameDependencies = {};
function registerTwoPhaseEvent(registrationName, dependencies) {
  registerDirectEvent(registrationName, dependencies);
  registerDirectEvent(registrationName + "Capture", dependencies);
}
function registerDirectEvent(registrationName, dependencies) {
  registrationNameDependencies[registrationName] = dependencies;
  for (
    registrationName = 0;
    registrationName < dependencies.length;
    registrationName++
  )
    allNativeEvents.add(dependencies[registrationName]);
}
var VALID_ATTRIBUTE_NAME_REGEX = RegExp(
    "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
  ),
  illegalAttributeNameCache = {},
  validatedAttributeNameCache = {};
function isAttributeNameSafe(attributeName) {
  if (hasOwnProperty.call(validatedAttributeNameCache, attributeName))
    return true;
  if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return false;
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName))
    return (validatedAttributeNameCache[attributeName] = true);
  illegalAttributeNameCache[attributeName] = true;
  return false;
}
function setValueForAttribute(node, name, value) {
  if (isAttributeNameSafe(name))
    if (null === value) node.removeAttribute(name);
    else {
      switch (typeof value) {
        case "undefined":
        case "function":
        case "symbol":
          node.removeAttribute(name);
          return;
        case "boolean":
          var prefix$8 = name.toLowerCase().slice(0, 5);
          if ("data-" !== prefix$8 && "aria-" !== prefix$8) {
            node.removeAttribute(name);
            return;
          }
      }
      node.setAttribute(name, "" + value);
    }
}
function setValueForKnownAttribute(node, name, value) {
  if (null === value) node.removeAttribute(name);
  else {
    switch (typeof value) {
      case "undefined":
      case "function":
      case "symbol":
      case "boolean":
        node.removeAttribute(name);
        return;
    }
    node.setAttribute(name, "" + value);
  }
}
function setValueForNamespacedAttribute(node, namespace, name, value) {
  if (null === value) node.removeAttribute(name);
  else {
    switch (typeof value) {
      case "undefined":
      case "function":
      case "symbol":
      case "boolean":
        node.removeAttribute(name);
        return;
    }
    node.setAttributeNS(namespace, name, "" + value);
  }
}
var prefix, suffix;
function describeBuiltInComponentFrame(name) {
  if (void 0 === prefix)
    try {
      throw Error();
    } catch (x) {
      var match = x.stack.trim().match(/\n( *(at )?)/);
      prefix = (match && match[1]) || "";
      suffix =
        -1 < x.stack.indexOf("\n    at")
          ? " (<anonymous>)"
          : -1 < x.stack.indexOf("@")
            ? "@unknown:0:0"
            : "";
    }
  return "\n" + prefix + name + suffix;
}
var reentry = false;
function describeNativeComponentFrame(fn, construct) {
  if (!fn || reentry) return "";
  reentry = true;
  var previousPrepareStackTrace = Error.prepareStackTrace;
  Error.prepareStackTrace = void 0;
  try {
    var RunInRootFrame = {
      DetermineComponentFrameRoot: function () {
        try {
          if (construct) {
            var Fake = function () {
              throw Error();
            };
            Object.defineProperty(Fake.prototype, "props", {
              set: function () {
                throw Error();
              }
            });
            if ("object" === typeof Reflect && Reflect.construct) {
              try {
                Reflect.construct(Fake, []);
              } catch (x) {
                var control = x;
              }
              Reflect.construct(fn, [], Fake);
            } else {
              try {
                Fake.call();
              } catch (x$9) {
                control = x$9;
              }
              fn.call(Fake.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (x$10) {
              control = x$10;
            }
            (Fake = fn()) &&
              "function" === typeof Fake.catch &&
              Fake.catch(function () {});
          }
        } catch (sample) {
          if (sample && control && "string" === typeof sample.stack)
            return [sample.stack, control.stack];
        }
        return [null, null];
      }
    };
    RunInRootFrame.DetermineComponentFrameRoot.displayName =
      "DetermineComponentFrameRoot";
    var namePropDescriptor = Object.getOwnPropertyDescriptor(
      RunInRootFrame.DetermineComponentFrameRoot,
      "name"
    );
    namePropDescriptor &&
      namePropDescriptor.configurable &&
      Object.defineProperty(
        RunInRootFrame.DetermineComponentFrameRoot,
        "name",
        { value: "DetermineComponentFrameRoot" }
      );
    var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(),
      sampleStack = _RunInRootFrame$Deter[0],
      controlStack = _RunInRootFrame$Deter[1];
    if (sampleStack && controlStack) {
      var sampleLines = sampleStack.split("\n"),
        controlLines = controlStack.split("\n");
      for (
        namePropDescriptor = RunInRootFrame = 0;
        RunInRootFrame < sampleLines.length &&
        !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");

      )
        RunInRootFrame++;
      for (
        ;
        namePropDescriptor < controlLines.length &&
        !controlLines[namePropDescriptor].includes(
          "DetermineComponentFrameRoot"
        );

      )
        namePropDescriptor++;
      if (
        RunInRootFrame === sampleLines.length ||
        namePropDescriptor === controlLines.length
      )
        for (
          RunInRootFrame = sampleLines.length - 1,
            namePropDescriptor = controlLines.length - 1;
          1 <= RunInRootFrame &&
          0 <= namePropDescriptor &&
          sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];

        )
          namePropDescriptor--;
      for (
        ;
        1 <= RunInRootFrame && 0 <= namePropDescriptor;
        RunInRootFrame--, namePropDescriptor--
      )
        if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
          if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
            do
              if (
                (RunInRootFrame--,
                namePropDescriptor--,
                0 > namePropDescriptor ||
                  sampleLines[RunInRootFrame] !==
                    controlLines[namePropDescriptor])
              ) {
                var frame =
                  "\n" +
                  sampleLines[RunInRootFrame].replace(" at new ", " at ");
                fn.displayName &&
                  frame.includes("<anonymous>") &&
                  (frame = frame.replace("<anonymous>", fn.displayName));
                return frame;
              }
            while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
          }
          break;
        }
    }
  } finally {
    (reentry = false), (Error.prepareStackTrace = previousPrepareStackTrace);
  }
  return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "")
    ? describeBuiltInComponentFrame(previousPrepareStackTrace)
    : "";
}
function describeFiber(fiber) {
  switch (fiber.tag) {
    case 26:
    case 27:
    case 5:
      return describeBuiltInComponentFrame(fiber.type);
    case 16:
      return describeBuiltInComponentFrame("Lazy");
    case 13:
      return describeBuiltInComponentFrame("Suspense");
    case 19:
      return describeBuiltInComponentFrame("SuspenseList");
    case 0:
    case 15:
      return describeNativeComponentFrame(fiber.type, false);
    case 11:
      return describeNativeComponentFrame(fiber.type.render, false);
    case 1:
      return describeNativeComponentFrame(fiber.type, true);
    case 31:
      return describeBuiltInComponentFrame("Activity");
    default:
      return "";
  }
}
function getStackByFiberInDevAndProd(workInProgress) {
  try {
    var info = "";
    do
      (info += describeFiber(workInProgress)),
        (workInProgress = workInProgress.return);
    while (workInProgress);
    return info;
  } catch (x) {
    return "\nError generating stack: " + x.message + "\n" + x.stack;
  }
}
function getToStringValue(value) {
  switch (typeof value) {
    case "bigint":
    case "boolean":
    case "number":
    case "string":
    case "undefined":
      return value;
    case "object":
      return value;
    default:
      return "";
  }
}
function isCheckable(elem) {
  var type = elem.type;
  return (
    (elem = elem.nodeName) &&
    "input" === elem.toLowerCase() &&
    ("checkbox" === type || "radio" === type)
  );
}
function trackValueOnNode(node) {
  var valueField = isCheckable(node) ? "checked" : "value",
    descriptor = Object.getOwnPropertyDescriptor(
      node.constructor.prototype,
      valueField
    ),
    currentValue = "" + node[valueField];
  if (
    !node.hasOwnProperty(valueField) &&
    "undefined" !== typeof descriptor &&
    "function" === typeof descriptor.get &&
    "function" === typeof descriptor.set
  ) {
    var get = descriptor.get,
      set = descriptor.set;
    Object.defineProperty(node, valueField, {
      configurable: true,
      get: function () {
        return get.call(this);
      },
      set: function (value) {
        currentValue = "" + value;
        set.call(this, value);
      }
    });
    Object.defineProperty(node, valueField, {
      enumerable: descriptor.enumerable
    });
    return {
      getValue: function () {
        return currentValue;
      },
      setValue: function (value) {
        currentValue = "" + value;
      },
      stopTracking: function () {
        node._valueTracker = null;
        delete node[valueField];
      }
    };
  }
}
function track$1(node) {
  node._valueTracker || (node._valueTracker = trackValueOnNode(node));
}
function updateValueIfChanged(node) {
  if (!node) return false;
  var tracker = node._valueTracker;
  if (!tracker) return true;
  var lastValue = tracker.getValue();
  var value = "";
  node &&
    (value = isCheckable(node)
      ? node.checked
        ? "true"
        : "false"
      : node.value);
  node = value;
  return node !== lastValue ? (tracker.setValue(node), true) : false;
}
function getActiveElement(doc) {
  doc = doc || ("undefined" !== typeof document ? document : void 0);
  if ("undefined" === typeof doc) return null;
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}
var escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function escapeSelectorAttributeValueInsideDoubleQuotes(value) {
  return value.replace(
    escapeSelectorAttributeValueInsideDoubleQuotesRegex,
    function (ch) {
      return "\\" + ch.charCodeAt(0).toString(16) + " ";
    }
  );
}
function updateInput(
  element,
  value,
  defaultValue,
  lastDefaultValue,
  checked,
  defaultChecked,
  type,
  name
) {
  element.name = "";
  null != type &&
  "function" !== typeof type &&
  "symbol" !== typeof type &&
  "boolean" !== typeof type
    ? (element.type = type)
    : element.removeAttribute("type");
  if (null != value)
    if ("number" === type) {
      if ((0 === value && "" === element.value) || element.value != value)
        element.value = "" + getToStringValue(value);
    } else
      element.value !== "" + getToStringValue(value) &&
        (element.value = "" + getToStringValue(value));
  else
    ("submit" !== type && "reset" !== type) || element.removeAttribute("value");
  null != value
    ? setDefaultValue(element, type, getToStringValue(value))
    : null != defaultValue
      ? setDefaultValue(element, type, getToStringValue(defaultValue))
      : null != lastDefaultValue && element.removeAttribute("value");
  null == checked &&
    null != defaultChecked &&
    (element.defaultChecked = !!defaultChecked);
  null != checked &&
    (element.checked =
      checked && "function" !== typeof checked && "symbol" !== typeof checked);
  null != name &&
  "function" !== typeof name &&
  "symbol" !== typeof name &&
  "boolean" !== typeof name
    ? (element.name = "" + getToStringValue(name))
    : element.removeAttribute("name");
}
function initInput(
  element,
  value,
  defaultValue,
  checked,
  defaultChecked,
  type,
  name,
  isHydrating
) {
  null != type &&
    "function" !== typeof type &&
    "symbol" !== typeof type &&
    "boolean" !== typeof type &&
    (element.type = type);
  if (null != value || null != defaultValue) {
    if (
      !(
        ("submit" !== type && "reset" !== type) ||
        (void 0 !== value && null !== value)
      )
    )
      return;
    defaultValue =
      null != defaultValue ? "" + getToStringValue(defaultValue) : "";
    value = null != value ? "" + getToStringValue(value) : defaultValue;
    isHydrating || value === element.value || (element.value = value);
    element.defaultValue = value;
  }
  checked = null != checked ? checked : defaultChecked;
  checked =
    "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
  element.checked = isHydrating ? element.checked : !!checked;
  element.defaultChecked = !!checked;
  null != name &&
    "function" !== typeof name &&
    "symbol" !== typeof name &&
    "boolean" !== typeof name &&
    (element.name = name);
}
function setDefaultValue(node, type, value) {
  ("number" === type && getActiveElement(node.ownerDocument) === node) ||
    node.defaultValue === "" + value ||
    (node.defaultValue = "" + value);
}
function updateOptions(node, multiple, propValue, setDefaultSelected) {
  node = node.options;
  if (multiple) {
    multiple = {};
    for (var i = 0; i < propValue.length; i++)
      multiple["$" + propValue[i]] = true;
    for (propValue = 0; propValue < node.length; propValue++)
      (i = multiple.hasOwnProperty("$" + node[propValue].value)),
        node[propValue].selected !== i && (node[propValue].selected = i),
        i && setDefaultSelected && (node[propValue].defaultSelected = true);
  } else {
    propValue = "" + getToStringValue(propValue);
    multiple = null;
    for (i = 0; i < node.length; i++) {
      if (node[i].value === propValue) {
        node[i].selected = true;
        setDefaultSelected && (node[i].defaultSelected = true);
        return;
      }
      null !== multiple || node[i].disabled || (multiple = node[i]);
    }
    null !== multiple && (multiple.selected = true);
  }
}
function updateTextarea(element, value, defaultValue) {
  if (
    null != value &&
    ((value = "" + getToStringValue(value)),
    value !== element.value && (element.value = value),
    null == defaultValue)
  ) {
    element.defaultValue !== value && (element.defaultValue = value);
    return;
  }
  element.defaultValue =
    null != defaultValue ? "" + getToStringValue(defaultValue) : "";
}
function initTextarea(element, value, defaultValue, children) {
  if (null == value) {
    if (null != children) {
      if (null != defaultValue) throw Error(formatProdErrorMessage(92));
      if (isArrayImpl(children)) {
        if (1 < children.length) throw Error(formatProdErrorMessage(93));
        children = children[0];
      }
      defaultValue = children;
    }
    null == defaultValue && (defaultValue = "");
    value = defaultValue;
  }
  defaultValue = getToStringValue(value);
  element.defaultValue = defaultValue;
  children = element.textContent;
  children === defaultValue &&
    "" !== children &&
    null !== children &&
    (element.value = children);
}
function setTextContent(node, text) {
  if (text) {
    var firstChild = node.firstChild;
    if (
      firstChild &&
      firstChild === node.lastChild &&
      3 === firstChild.nodeType
    ) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
}
var unitlessNumbers = new Set(
  "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
    " "
  )
);
function setValueForStyle(style, styleName, value) {
  var isCustomProperty = 0 === styleName.indexOf("--");
  null == value || "boolean" === typeof value || "" === value
    ? isCustomProperty
      ? style.setProperty(styleName, "")
      : "float" === styleName
        ? (style.cssFloat = "")
        : (style[styleName] = "")
    : isCustomProperty
      ? style.setProperty(styleName, value)
      : "number" !== typeof value ||
          0 === value ||
          unitlessNumbers.has(styleName)
        ? "float" === styleName
          ? (style.cssFloat = value)
          : (style[styleName] = ("" + value).trim())
        : (style[styleName] = value + "px");
}
function setValueForStyles(node, styles, prevStyles) {
  if (null != styles && "object" !== typeof styles)
    throw Error(formatProdErrorMessage(62));
  node = node.style;
  if (null != prevStyles) {
    for (var styleName in prevStyles)
      !prevStyles.hasOwnProperty(styleName) ||
        (null != styles && styles.hasOwnProperty(styleName)) ||
        (0 === styleName.indexOf("--")
          ? node.setProperty(styleName, "")
          : "float" === styleName
            ? (node.cssFloat = "")
            : (node[styleName] = ""));
    for (var styleName$16 in styles)
      (styleName = styles[styleName$16]),
        styles.hasOwnProperty(styleName$16) &&
          prevStyles[styleName$16] !== styleName &&
          setValueForStyle(node, styleName$16, styleName);
  } else
    for (var styleName$17 in styles)
      styles.hasOwnProperty(styleName$17) &&
        setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function isCustomElement(tagName) {
  if (-1 === tagName.indexOf("-")) return false;
  switch (tagName) {
    case "annotation-xml":
    case "color-profile":
    case "font-face":
    case "font-face-src":
    case "font-face-uri":
    case "font-face-format":
    case "font-face-name":
    case "missing-glyph":
      return false;
    default:
      return true;
  }
}
var aliases = new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]),
  isJavaScriptProtocol =
    /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function sanitizeURL(url) {
  return isJavaScriptProtocol.test("" + url)
    ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')"
    : url;
}
var currentReplayingEvent = null;
function getEventTarget(nativeEvent) {
  nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
  nativeEvent.correspondingUseElement &&
    (nativeEvent = nativeEvent.correspondingUseElement);
  return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var restoreTarget = null,
  restoreQueue = null;
function restoreStateOfTarget(target) {
  var internalInstance = getInstanceFromNode(target);
  if (internalInstance && (target = internalInstance.stateNode)) {
    var props = target[internalPropsKey] || null;
    a: switch (((target = internalInstance.stateNode), internalInstance.type)) {
      case "input":
        updateInput(
          target,
          props.value,
          props.defaultValue,
          props.defaultValue,
          props.checked,
          props.defaultChecked,
          props.type,
          props.name
        );
        internalInstance = props.name;
        if ("radio" === props.type && null != internalInstance) {
          for (props = target; props.parentNode; ) props = props.parentNode;
          props = props.querySelectorAll(
            'input[name="' +
              escapeSelectorAttributeValueInsideDoubleQuotes(
                "" + internalInstance
              ) +
              '"][type="radio"]'
          );
          for (
            internalInstance = 0;
            internalInstance < props.length;
            internalInstance++
          ) {
            var otherNode = props[internalInstance];
            if (otherNode !== target && otherNode.form === target.form) {
              var otherProps = otherNode[internalPropsKey] || null;
              if (!otherProps) throw Error(formatProdErrorMessage(90));
              updateInput(
                otherNode,
                otherProps.value,
                otherProps.defaultValue,
                otherProps.defaultValue,
                otherProps.checked,
                otherProps.defaultChecked,
                otherProps.type,
                otherProps.name
              );
            }
          }
          for (
            internalInstance = 0;
            internalInstance < props.length;
            internalInstance++
          )
            (otherNode = props[internalInstance]),
              otherNode.form === target.form && updateValueIfChanged(otherNode);
        }
        break a;
      case "textarea":
        updateTextarea(target, props.value, props.defaultValue);
        break a;
      case "select":
        (internalInstance = props.value),
          null != internalInstance &&
            updateOptions(target, !!props.multiple, internalInstance, false);
    }
  }
}
var isInsideEventHandler = false;
function batchedUpdates$1(fn, a, b) {
  if (isInsideEventHandler) return fn(a, b);
  isInsideEventHandler = true;
  try {
    var JSCompiler_inline_result = fn(a);
    return JSCompiler_inline_result;
  } finally {
    if (
      ((isInsideEventHandler = false),
      null !== restoreTarget || null !== restoreQueue)
    )
      if (
        (flushSyncWork$1(),
        restoreTarget &&
          ((a = restoreTarget),
          (fn = restoreQueue),
          (restoreQueue = restoreTarget = null),
          restoreStateOfTarget(a),
          fn))
      )
        for (a = 0; a < fn.length; a++) restoreStateOfTarget(fn[a]);
  }
}
function getListener(inst, registrationName) {
  var stateNode = inst.stateNode;
  if (null === stateNode) return null;
  var props = stateNode[internalPropsKey] || null;
  if (null === props) return null;
  stateNode = props[registrationName];
  a: switch (registrationName) {
    case "onClick":
    case "onClickCapture":
    case "onDoubleClick":
    case "onDoubleClickCapture":
    case "onMouseDown":
    case "onMouseDownCapture":
    case "onMouseMove":
    case "onMouseMoveCapture":
    case "onMouseUp":
    case "onMouseUpCapture":
    case "onMouseEnter":
      (props = !props.disabled) ||
        ((inst = inst.type),
        (props = !(
          "button" === inst ||
          "input" === inst ||
          "select" === inst ||
          "textarea" === inst
        )));
      inst = !props;
      break a;
    default:
      inst = false;
  }
  if (inst) return null;
  if (stateNode && "function" !== typeof stateNode)
    throw Error(
      formatProdErrorMessage(231, registrationName, typeof stateNode)
    );
  return stateNode;
}
var canUseDOM = !(
    "undefined" === typeof window ||
    "undefined" === typeof window.document ||
    "undefined" === typeof window.document.createElement
  ),
  passiveBrowserEventsSupported = false;
if (canUseDOM)
  try {
    var options = {};
    Object.defineProperty(options, "passive", {
      get: function () {
        passiveBrowserEventsSupported = !0;
      }
    });
    window.addEventListener("test", options, options);
    window.removeEventListener("test", options, options);
  } catch (e) {
    passiveBrowserEventsSupported = false;
  }
var root$1 = null,
  startText = null,
  fallbackText = null;
function getData() {
  if (fallbackText) return fallbackText;
  var start,
    startValue = startText,
    startLength = startValue.length,
    end,
    endValue = "value" in root$1 ? root$1.value : root$1.textContent,
    endLength = endValue.length;
  for (
    start = 0;
    start < startLength && startValue[start] === endValue[start];
    start++
  );
  var minEnd = startLength - start;
  for (
    end = 1;
    end <= minEnd &&
    startValue[startLength - end] === endValue[endLength - end];
    end++
  );
  return (fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0));
}
function getEventCharCode(nativeEvent) {
  var keyCode = nativeEvent.keyCode;
  "charCode" in nativeEvent
    ? ((nativeEvent = nativeEvent.charCode),
      0 === nativeEvent && 13 === keyCode && (nativeEvent = 13))
    : (nativeEvent = keyCode);
  10 === nativeEvent && (nativeEvent = 13);
  return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function functionThatReturnsTrue() {
  return true;
}
function functionThatReturnsFalse() {
  return false;
}
function createSyntheticEvent(Interface) {
  function SyntheticBaseEvent(
    reactName,
    reactEventType,
    targetInst,
    nativeEvent,
    nativeEventTarget
  ) {
    this._reactName = reactName;
    this._targetInst = targetInst;
    this.type = reactEventType;
    this.nativeEvent = nativeEvent;
    this.target = nativeEventTarget;
    this.currentTarget = null;
    for (var propName in Interface)
      Interface.hasOwnProperty(propName) &&
        ((reactName = Interface[propName]),
        (this[propName] = reactName
          ? reactName(nativeEvent)
          : nativeEvent[propName]));
    this.isDefaultPrevented = (
      null != nativeEvent.defaultPrevented
        ? nativeEvent.defaultPrevented
        : false === nativeEvent.returnValue
    )
      ? functionThatReturnsTrue
      : functionThatReturnsFalse;
    this.isPropagationStopped = functionThatReturnsFalse;
    return this;
  }
  assign(SyntheticBaseEvent.prototype, {
    preventDefault: function () {
      this.defaultPrevented = true;
      var event = this.nativeEvent;
      event &&
        (event.preventDefault
          ? event.preventDefault()
          : "unknown" !== typeof event.returnValue && (event.returnValue = false),
        (this.isDefaultPrevented = functionThatReturnsTrue));
    },
    stopPropagation: function () {
      var event = this.nativeEvent;
      event &&
        (event.stopPropagation
          ? event.stopPropagation()
          : "unknown" !== typeof event.cancelBubble &&
            (event.cancelBubble = true),
        (this.isPropagationStopped = functionThatReturnsTrue));
    },
    persist: function () {},
    isPersistent: functionThatReturnsTrue
  });
  return SyntheticBaseEvent;
}
var EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function (event) {
      return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
  },
  SyntheticEvent = createSyntheticEvent(EventInterface),
  UIEventInterface = assign({}, EventInterface, { view: 0, detail: 0 }),
  SyntheticUIEvent = createSyntheticEvent(UIEventInterface),
  lastMovementX,
  lastMovementY,
  lastMouseEvent,
  MouseEventInterface = assign({}, UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function (event) {
      return void 0 === event.relatedTarget
        ? event.fromElement === event.srcElement
          ? event.toElement
          : event.fromElement
        : event.relatedTarget;
    },
    movementX: function (event) {
      if ("movementX" in event) return event.movementX;
      event !== lastMouseEvent &&
        (lastMouseEvent && "mousemove" === event.type
          ? ((lastMovementX = event.screenX - lastMouseEvent.screenX),
            (lastMovementY = event.screenY - lastMouseEvent.screenY))
          : (lastMovementY = lastMovementX = 0),
        (lastMouseEvent = event));
      return lastMovementX;
    },
    movementY: function (event) {
      return "movementY" in event ? event.movementY : lastMovementY;
    }
  }),
  SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface),
  DragEventInterface = assign({}, MouseEventInterface, { dataTransfer: 0 }),
  SyntheticDragEvent = createSyntheticEvent(DragEventInterface),
  FocusEventInterface = assign({}, UIEventInterface, { relatedTarget: 0 }),
  SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface),
  AnimationEventInterface = assign({}, EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }),
  SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface),
  ClipboardEventInterface = assign({}, EventInterface, {
    clipboardData: function (event) {
      return "clipboardData" in event
        ? event.clipboardData
        : window.clipboardData;
    }
  }),
  SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface),
  CompositionEventInterface = assign({}, EventInterface, { data: 0 }),
  SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface),
  normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  },
  translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  },
  modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
  };
function modifierStateGetter(keyArg) {
  var nativeEvent = this.nativeEvent;
  return nativeEvent.getModifierState
    ? nativeEvent.getModifierState(keyArg)
    : (keyArg = modifierKeyToProp[keyArg])
      ? !!nativeEvent[keyArg]
      : false;
}
function getEventModifierState() {
  return modifierStateGetter;
}
var KeyboardEventInterface = assign({}, UIEventInterface, {
    key: function (nativeEvent) {
      if (nativeEvent.key) {
        var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
        if ("Unidentified" !== key) return key;
      }
      return "keypress" === nativeEvent.type
        ? ((nativeEvent = getEventCharCode(nativeEvent)),
          13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent))
        : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type
          ? translateToKey[nativeEvent.keyCode] || "Unidentified"
          : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: getEventModifierState,
    charCode: function (event) {
      return "keypress" === event.type ? getEventCharCode(event) : 0;
    },
    keyCode: function (event) {
      return "keydown" === event.type || "keyup" === event.type
        ? event.keyCode
        : 0;
    },
    which: function (event) {
      return "keypress" === event.type
        ? getEventCharCode(event)
        : "keydown" === event.type || "keyup" === event.type
          ? event.keyCode
          : 0;
    }
  }),
  SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface),
  PointerEventInterface = assign({}, MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
  }),
  SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface),
  TouchEventInterface = assign({}, UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: getEventModifierState
  }),
  SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface),
  TransitionEventInterface = assign({}, EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }),
  SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface),
  WheelEventInterface = assign({}, MouseEventInterface, {
    deltaX: function (event) {
      return "deltaX" in event
        ? event.deltaX
        : "wheelDeltaX" in event
          ? -event.wheelDeltaX
          : 0;
    },
    deltaY: function (event) {
      return "deltaY" in event
        ? event.deltaY
        : "wheelDeltaY" in event
          ? -event.wheelDeltaY
          : "wheelDelta" in event
            ? -event.wheelDelta
            : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }),
  SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface),
  ToggleEventInterface = assign({}, EventInterface, {
    newState: 0,
    oldState: 0
  }),
  SyntheticToggleEvent = createSyntheticEvent(ToggleEventInterface),
  END_KEYCODES = [9, 13, 27, 32],
  canUseCompositionEvent = canUseDOM && "CompositionEvent" in window,
  documentMode = null;
canUseDOM &&
  "documentMode" in document &&
  (documentMode = document.documentMode);
var canUseTextInputEvent = canUseDOM && "TextEvent" in window && !documentMode,
  useFallbackCompositionData =
    canUseDOM &&
    (!canUseCompositionEvent ||
      (documentMode && 8 < documentMode && 11 >= documentMode)),
  SPACEBAR_CHAR = String.fromCharCode(32),
  hasSpaceKeypress = false;
function isFallbackCompositionEnd(domEventName, nativeEvent) {
  switch (domEventName) {
    case "keyup":
      return -1 !== END_KEYCODES.indexOf(nativeEvent.keyCode);
    case "keydown":
      return 229 !== nativeEvent.keyCode;
    case "keypress":
    case "mousedown":
    case "focusout":
      return true;
    default:
      return false;
  }
}
function getDataFromCustomEvent(nativeEvent) {
  nativeEvent = nativeEvent.detail;
  return "object" === typeof nativeEvent && "data" in nativeEvent
    ? nativeEvent.data
    : null;
}
var isComposing = false;
function getNativeBeforeInputChars(domEventName, nativeEvent) {
  switch (domEventName) {
    case "compositionend":
      return getDataFromCustomEvent(nativeEvent);
    case "keypress":
      if (32 !== nativeEvent.which) return null;
      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;
    case "textInput":
      return (
        (domEventName = nativeEvent.data),
        domEventName === SPACEBAR_CHAR && hasSpaceKeypress ? null : domEventName
      );
    default:
      return null;
  }
}
function getFallbackBeforeInputChars(domEventName, nativeEvent) {
  if (isComposing)
    return "compositionend" === domEventName ||
      (!canUseCompositionEvent &&
        isFallbackCompositionEnd(domEventName, nativeEvent))
      ? ((domEventName = getData()),
        (fallbackText = startText = root$1 = null),
        (isComposing = false),
        domEventName)
      : null;
  switch (domEventName) {
    case "paste":
      return null;
    case "keypress":
      if (
        !(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) ||
        (nativeEvent.ctrlKey && nativeEvent.altKey)
      ) {
        if (nativeEvent.char && 1 < nativeEvent.char.length)
          return nativeEvent.char;
        if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case "compositionend":
      return useFallbackCompositionData && "ko" !== nativeEvent.locale
        ? null
        : nativeEvent.data;
    default:
      return null;
  }
}
var supportedInputTypes = {
  color: true,
  date: true,
  datetime: true,
  "datetime-local": true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  time: true,
  url: true,
  week: true
};
function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
  return "input" === nodeName
    ? !!supportedInputTypes[elem.type]
    : "textarea" === nodeName
      ? true
      : false;
}
function createAndAccumulateChangeEvent(
  dispatchQueue,
  inst,
  nativeEvent,
  target
) {
  restoreTarget
    ? restoreQueue
      ? restoreQueue.push(target)
      : (restoreQueue = [target])
    : (restoreTarget = target);
  inst = accumulateTwoPhaseListeners(inst, "onChange");
  0 < inst.length &&
    ((nativeEvent = new SyntheticEvent(
      "onChange",
      "change",
      null,
      nativeEvent,
      target
    )),
    dispatchQueue.push({ event: nativeEvent, listeners: inst }));
}
var activeElement$1 = null,
  activeElementInst$1 = null;
function runEventInBatch(dispatchQueue) {
  processDispatchQueue(dispatchQueue, 0);
}
function getInstIfValueChanged(targetInst) {
  var targetNode = getNodeFromInstance(targetInst);
  if (updateValueIfChanged(targetNode)) return targetInst;
}
function getTargetInstForChangeEvent(domEventName, targetInst) {
  if ("change" === domEventName) return targetInst;
}
var isInputEventSupported = false;
if (canUseDOM) {
  var JSCompiler_inline_result$jscomp$282;
  if (canUseDOM) {
    var isSupported$jscomp$inline_417 = "oninput" in document;
    if (!isSupported$jscomp$inline_417) {
      var element$jscomp$inline_418 = document.createElement("div");
      element$jscomp$inline_418.setAttribute("oninput", "return;");
      isSupported$jscomp$inline_417 =
        "function" === typeof element$jscomp$inline_418.oninput;
    }
    JSCompiler_inline_result$jscomp$282 = isSupported$jscomp$inline_417;
  } else JSCompiler_inline_result$jscomp$282 = false;
  isInputEventSupported =
    JSCompiler_inline_result$jscomp$282 &&
    (!document.documentMode || 9 < document.documentMode);
}
function stopWatchingForValueChange() {
  activeElement$1 &&
    (activeElement$1.detachEvent("onpropertychange", handlePropertyChange),
    (activeElementInst$1 = activeElement$1 = null));
}
function handlePropertyChange(nativeEvent) {
  if (
    "value" === nativeEvent.propertyName &&
    getInstIfValueChanged(activeElementInst$1)
  ) {
    var dispatchQueue = [];
    createAndAccumulateChangeEvent(
      dispatchQueue,
      activeElementInst$1,
      nativeEvent,
      getEventTarget(nativeEvent)
    );
    batchedUpdates$1(runEventInBatch, dispatchQueue);
  }
}
function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
  "focusin" === domEventName
    ? (stopWatchingForValueChange(),
      (activeElement$1 = target),
      (activeElementInst$1 = targetInst),
      activeElement$1.attachEvent("onpropertychange", handlePropertyChange))
    : "focusout" === domEventName && stopWatchingForValueChange();
}
function getTargetInstForInputEventPolyfill(domEventName) {
  if (
    "selectionchange" === domEventName ||
    "keyup" === domEventName ||
    "keydown" === domEventName
  )
    return getInstIfValueChanged(activeElementInst$1);
}
function getTargetInstForClickEvent(domEventName, targetInst) {
  if ("click" === domEventName) return getInstIfValueChanged(targetInst);
}
function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
  if ("input" === domEventName || "change" === domEventName)
    return getInstIfValueChanged(targetInst);
}
function is(x, y) {
  return (x === y && (0 !== x || 1 / x === 1 / y)) || (x !== x && y !== y);
}
var objectIs = "function" === typeof Object.is ? Object.is : is;
function shallowEqual(objA, objB) {
  if (objectIs(objA, objB)) return true;
  if (
    "object" !== typeof objA ||
    null === objA ||
    "object" !== typeof objB ||
    null === objB
  )
    return false;
  var keysA = Object.keys(objA),
    keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;
  for (keysB = 0; keysB < keysA.length; keysB++) {
    var currentKey = keysA[keysB];
    if (
      !hasOwnProperty.call(objB, currentKey) ||
      !objectIs(objA[currentKey], objB[currentKey])
    )
      return false;
  }
  return true;
}
function getLeafNode(node) {
  for (; node && node.firstChild; ) node = node.firstChild;
  return node;
}
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  root = 0;
  for (var nodeEnd; node; ) {
    if (3 === node.nodeType) {
      nodeEnd = root + node.textContent.length;
      if (root <= offset && nodeEnd >= offset)
        return { node: node, offset: offset - root };
      root = nodeEnd;
    }
    a: {
      for (; node; ) {
        if (node.nextSibling) {
          node = node.nextSibling;
          break a;
        }
        node = node.parentNode;
      }
      node = void 0;
    }
    node = getLeafNode(node);
  }
}
function containsNode(outerNode, innerNode) {
  return outerNode && innerNode
    ? outerNode === innerNode
      ? true
      : outerNode && 3 === outerNode.nodeType
        ? false
        : innerNode && 3 === innerNode.nodeType
          ? containsNode(outerNode, innerNode.parentNode)
          : "contains" in outerNode
            ? outerNode.contains(innerNode)
            : outerNode.compareDocumentPosition
              ? !!(outerNode.compareDocumentPosition(innerNode) & 16)
              : false
    : false;
}
function getActiveElementDeep(containerInfo) {
  containerInfo =
    null != containerInfo &&
    null != containerInfo.ownerDocument &&
    null != containerInfo.ownerDocument.defaultView
      ? containerInfo.ownerDocument.defaultView
      : window;
  for (
    var element = getActiveElement(containerInfo.document);
    element instanceof containerInfo.HTMLIFrameElement;

  ) {
    try {
      var JSCompiler_inline_result =
        "string" === typeof element.contentWindow.location.href;
    } catch (err) {
      JSCompiler_inline_result = false;
    }
    if (JSCompiler_inline_result) containerInfo = element.contentWindow;
    else break;
    element = getActiveElement(containerInfo.document);
  }
  return element;
}
function hasSelectionCapabilities(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
  return (
    nodeName &&
    (("input" === nodeName &&
      ("text" === elem.type ||
        "search" === elem.type ||
        "tel" === elem.type ||
        "url" === elem.type ||
        "password" === elem.type)) ||
      "textarea" === nodeName ||
      "true" === elem.contentEditable)
  );
}
var skipSelectionChangeEvent =
    canUseDOM && "documentMode" in document && 11 >= document.documentMode,
  activeElement = null,
  activeElementInst = null,
  lastSelection = null,
  mouseDown = false;
function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
  var doc =
    nativeEventTarget.window === nativeEventTarget
      ? nativeEventTarget.document
      : 9 === nativeEventTarget.nodeType
        ? nativeEventTarget
        : nativeEventTarget.ownerDocument;
  mouseDown ||
    null == activeElement ||
    activeElement !== getActiveElement(doc) ||
    ((doc = activeElement),
    "selectionStart" in doc && hasSelectionCapabilities(doc)
      ? (doc = { start: doc.selectionStart, end: doc.selectionEnd })
      : ((doc = (
          (doc.ownerDocument && doc.ownerDocument.defaultView) ||
          window
        ).getSelection()),
        (doc = {
          anchorNode: doc.anchorNode,
          anchorOffset: doc.anchorOffset,
          focusNode: doc.focusNode,
          focusOffset: doc.focusOffset
        })),
    (lastSelection && shallowEqual(lastSelection, doc)) ||
      ((lastSelection = doc),
      (doc = accumulateTwoPhaseListeners(activeElementInst, "onSelect")),
      0 < doc.length &&
        ((nativeEvent = new SyntheticEvent(
          "onSelect",
          "select",
          null,
          nativeEvent,
          nativeEventTarget
        )),
        dispatchQueue.push({ event: nativeEvent, listeners: doc }),
        (nativeEvent.target = activeElement))));
}
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};
  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes["Webkit" + styleProp] = "webkit" + eventName;
  prefixes["Moz" + styleProp] = "moz" + eventName;
  return prefixes;
}
var vendorPrefixes = {
    animationend: makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: makePrefixMap("Animation", "AnimationIteration"),
    animationstart: makePrefixMap("Animation", "AnimationStart"),
    transitionrun: makePrefixMap("Transition", "TransitionRun"),
    transitionstart: makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: makePrefixMap("Transition", "TransitionCancel"),
    transitionend: makePrefixMap("Transition", "TransitionEnd")
  },
  prefixedEventNames = {},
  style = {};
canUseDOM &&
  ((style = document.createElement("div").style),
  "AnimationEvent" in window ||
    (delete vendorPrefixes.animationend.animation,
    delete vendorPrefixes.animationiteration.animation,
    delete vendorPrefixes.animationstart.animation),
  "TransitionEvent" in window ||
    delete vendorPrefixes.transitionend.transition);
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
  if (!vendorPrefixes[eventName]) return eventName;
  var prefixMap = vendorPrefixes[eventName],
    styleProp;
  for (styleProp in prefixMap)
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style)
      return (prefixedEventNames[eventName] = prefixMap[styleProp]);
  return eventName;
}
var ANIMATION_END = getVendorPrefixedEventName("animationend"),
  ANIMATION_ITERATION = getVendorPrefixedEventName("animationiteration"),
  ANIMATION_START = getVendorPrefixedEventName("animationstart"),
  TRANSITION_RUN = getVendorPrefixedEventName("transitionrun"),
  TRANSITION_START = getVendorPrefixedEventName("transitionstart"),
  TRANSITION_CANCEL = getVendorPrefixedEventName("transitioncancel"),
  TRANSITION_END = getVendorPrefixedEventName("transitionend"),
  topLevelEventsToReactNames = new Map(),
  simpleEventPluginEvents =
    "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
      " "
    );
simpleEventPluginEvents.push("scrollEnd");
function registerSimpleEvent(domEventName, reactName) {
  topLevelEventsToReactNames.set(domEventName, reactName);
  registerTwoPhaseEvent(reactName, [domEventName]);
}
var CapturedStacks = new WeakMap();
function createCapturedValueAtFiber(value, source) {
  if ("object" === typeof value && null !== value) {
    var existing = CapturedStacks.get(value);
    if (void 0 !== existing) return existing;
    source = {
      value: value,
      source: source,
      stack: getStackByFiberInDevAndProd(source)
    };
    CapturedStacks.set(value, source);
    return source;
  }
  return {
    value: value,
    source: source,
    stack: getStackByFiberInDevAndProd(source)
  };
}
var concurrentQueues = [],
  concurrentQueuesIndex = 0,
  concurrentlyUpdatedLanes = 0;
function finishQueueingConcurrentUpdates() {
  for (
    var endIndex = concurrentQueuesIndex,
      i = (concurrentlyUpdatedLanes = concurrentQueuesIndex = 0);
    i < endIndex;

  ) {
    var fiber = concurrentQueues[i];
    concurrentQueues[i++] = null;
    var queue = concurrentQueues[i];
    concurrentQueues[i++] = null;
    var update = concurrentQueues[i];
    concurrentQueues[i++] = null;
    var lane = concurrentQueues[i];
    concurrentQueues[i++] = null;
    if (null !== queue && null !== update) {
      var pending = queue.pending;
      null === pending
        ? (update.next = update)
        : ((update.next = pending.next), (pending.next = update));
      queue.pending = update;
    }
    0 !== lane && markUpdateLaneFromFiberToRoot(fiber, update, lane);
  }
}
function enqueueUpdate$1(fiber, queue, update, lane) {
  concurrentQueues[concurrentQueuesIndex++] = fiber;
  concurrentQueues[concurrentQueuesIndex++] = queue;
  concurrentQueues[concurrentQueuesIndex++] = update;
  concurrentQueues[concurrentQueuesIndex++] = lane;
  concurrentlyUpdatedLanes |= lane;
  fiber.lanes |= lane;
  fiber = fiber.alternate;
  null !== fiber && (fiber.lanes |= lane);
}
function enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
  enqueueUpdate$1(fiber, queue, update, lane);
  return getRootForUpdatedFiber(fiber);
}
function enqueueConcurrentRenderForLane(fiber, lane) {
  enqueueUpdate$1(fiber, null, null, lane);
  return getRootForUpdatedFiber(fiber);
}
function markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
  sourceFiber.lanes |= lane;
  var alternate = sourceFiber.alternate;
  null !== alternate && (alternate.lanes |= lane);
  for (var isHidden = false, parent = sourceFiber.return; null !== parent; )
    (parent.childLanes |= lane),
      (alternate = parent.alternate),
      null !== alternate && (alternate.childLanes |= lane),
      22 === parent.tag &&
        ((sourceFiber = parent.stateNode),
        null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = true)),
      (sourceFiber = parent),
      (parent = parent.return);
  return 3 === sourceFiber.tag
    ? ((parent = sourceFiber.stateNode),
      isHidden &&
        null !== update &&
        ((isHidden = 31 - clz32(lane)),
        (sourceFiber = parent.hiddenUpdates),
        (alternate = sourceFiber[isHidden]),
        null === alternate
          ? (sourceFiber[isHidden] = [update])
          : alternate.push(update),
        (update.lane = lane | 536870912)),
      parent)
    : null;
}
function getRootForUpdatedFiber(sourceFiber) {
  if (50 < nestedUpdateCount)
    throw (
      ((nestedUpdateCount = 0),
      (rootWithNestedUpdates = null),
      Error(formatProdErrorMessage(185)))
    );
  for (var parent = sourceFiber.return; null !== parent; )
    (sourceFiber = parent), (parent = sourceFiber.return);
  return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var emptyContextObject = {};
function FiberNode(tag, pendingProps, key, mode) {
  this.tag = tag;
  this.key = key;
  this.sibling =
    this.child =
    this.return =
    this.stateNode =
    this.type =
    this.elementType =
      null;
  this.index = 0;
  this.refCleanup = this.ref = null;
  this.pendingProps = pendingProps;
  this.dependencies =
    this.memoizedState =
    this.updateQueue =
    this.memoizedProps =
      null;
  this.mode = mode;
  this.subtreeFlags = this.flags = 0;
  this.deletions = null;
  this.childLanes = this.lanes = 0;
  this.alternate = null;
}
function createFiberImplClass(tag, pendingProps, key, mode) {
  return new FiberNode(tag, pendingProps, key, mode);
}
function shouldConstruct(Component) {
  Component = Component.prototype;
  return !(!Component || !Component.isReactComponent);
}
function createWorkInProgress(current, pendingProps) {
  var workInProgress = current.alternate;
  null === workInProgress
    ? ((workInProgress = createFiberImplClass(
        current.tag,
        pendingProps,
        current.key,
        current.mode
      )),
      (workInProgress.elementType = current.elementType),
      (workInProgress.type = current.type),
      (workInProgress.stateNode = current.stateNode),
      (workInProgress.alternate = current),
      (current.alternate = workInProgress))
    : ((workInProgress.pendingProps = pendingProps),
      (workInProgress.type = current.type),
      (workInProgress.flags = 0),
      (workInProgress.subtreeFlags = 0),
      (workInProgress.deletions = null));
  workInProgress.flags = current.flags & 65011712;
  workInProgress.childLanes = current.childLanes;
  workInProgress.lanes = current.lanes;
  workInProgress.child = current.child;
  workInProgress.memoizedProps = current.memoizedProps;
  workInProgress.memoizedState = current.memoizedState;
  workInProgress.updateQueue = current.updateQueue;
  pendingProps = current.dependencies;
  workInProgress.dependencies =
    null === pendingProps
      ? null
      : { lanes: pendingProps.lanes, firstContext: pendingProps.firstContext };
  workInProgress.sibling = current.sibling;
  workInProgress.index = current.index;
  workInProgress.ref = current.ref;
  workInProgress.refCleanup = current.refCleanup;
  return workInProgress;
}
function resetWorkInProgress(workInProgress, renderLanes) {
  workInProgress.flags &= 65011714;
  var current = workInProgress.alternate;
  null === current
    ? ((workInProgress.childLanes = 0),
      (workInProgress.lanes = renderLanes),
      (workInProgress.child = null),
      (workInProgress.subtreeFlags = 0),
      (workInProgress.memoizedProps = null),
      (workInProgress.memoizedState = null),
      (workInProgress.updateQueue = null),
      (workInProgress.dependencies = null),
      (workInProgress.stateNode = null))
    : ((workInProgress.childLanes = current.childLanes),
      (workInProgress.lanes = current.lanes),
      (workInProgress.child = current.child),
      (workInProgress.subtreeFlags = 0),
      (workInProgress.deletions = null),
      (workInProgress.memoizedProps = current.memoizedProps),
      (workInProgress.memoizedState = current.memoizedState),
      (workInProgress.updateQueue = current.updateQueue),
      (workInProgress.type = current.type),
      (renderLanes = current.dependencies),
      (workInProgress.dependencies =
        null === renderLanes
          ? null
          : {
              lanes: renderLanes.lanes,
              firstContext: renderLanes.firstContext
            }));
  return workInProgress;
}
function createFiberFromTypeAndProps(
  type,
  key,
  pendingProps,
  owner,
  mode,
  lanes
) {
  var fiberTag = 0;
  owner = type;
  if ("function" === typeof type) shouldConstruct(type) && (fiberTag = 1);
  else if ("string" === typeof type)
    fiberTag = isHostHoistableType(
      type,
      pendingProps,
      contextStackCursor.current
    )
      ? 26
      : "html" === type || "head" === type || "body" === type
        ? 27
        : 5;
  else
    a: switch (type) {
      case REACT_ACTIVITY_TYPE:
        return (
          (type = createFiberImplClass(31, pendingProps, key, mode)),
          (type.elementType = REACT_ACTIVITY_TYPE),
          (type.lanes = lanes),
          type
        );
      case REACT_FRAGMENT_TYPE:
        return createFiberFromFragment(pendingProps.children, mode, lanes, key);
      case REACT_STRICT_MODE_TYPE:
        fiberTag = 8;
        mode |= 24;
        break;
      case REACT_PROFILER_TYPE:
        return (
          (type = createFiberImplClass(12, pendingProps, key, mode | 2)),
          (type.elementType = REACT_PROFILER_TYPE),
          (type.lanes = lanes),
          type
        );
      case REACT_SUSPENSE_TYPE:
        return (
          (type = createFiberImplClass(13, pendingProps, key, mode)),
          (type.elementType = REACT_SUSPENSE_TYPE),
          (type.lanes = lanes),
          type
        );
      case REACT_SUSPENSE_LIST_TYPE:
        return (
          (type = createFiberImplClass(19, pendingProps, key, mode)),
          (type.elementType = REACT_SUSPENSE_LIST_TYPE),
          (type.lanes = lanes),
          type
        );
      default:
        if ("object" === typeof type && null !== type)
          switch (type.$$typeof) {
            case REACT_PROVIDER_TYPE:
            case REACT_CONTEXT_TYPE:
              fiberTag = 10;
              break a;
            case REACT_CONSUMER_TYPE:
              fiberTag = 9;
              break a;
            case REACT_FORWARD_REF_TYPE:
              fiberTag = 11;
              break a;
            case REACT_MEMO_TYPE:
              fiberTag = 14;
              break a;
            case REACT_LAZY_TYPE:
              fiberTag = 16;
              owner = null;
              break a;
          }
        fiberTag = 29;
        pendingProps = Error(
          formatProdErrorMessage(130, null === type ? "null" : typeof type, "")
        );
        owner = null;
    }
  key = createFiberImplClass(fiberTag, pendingProps, key, mode);
  key.elementType = type;
  key.type = owner;
  key.lanes = lanes;
  return key;
}
function createFiberFromFragment(elements, mode, lanes, key) {
  elements = createFiberImplClass(7, elements, key, mode);
  elements.lanes = lanes;
  return elements;
}
function createFiberFromText(content, mode, lanes) {
  content = createFiberImplClass(6, content, null, mode);
  content.lanes = lanes;
  return content;
}
function createFiberFromPortal(portal, mode, lanes) {
  mode = createFiberImplClass(
    4,
    null !== portal.children ? portal.children : [],
    portal.key,
    mode
  );
  mode.lanes = lanes;
  mode.stateNode = {
    containerInfo: portal.containerInfo,
    pendingChildren: null,
    implementation: portal.implementation
  };
  return mode;
}
var forkStack = [],
  forkStackIndex = 0,
  treeForkProvider = null,
  treeForkCount = 0,
  idStack = [],
  idStackIndex = 0,
  treeContextProvider = null,
  treeContextId = 1,
  treeContextOverflow = "";
function pushTreeFork(workInProgress, totalChildren) {
  forkStack[forkStackIndex++] = treeForkCount;
  forkStack[forkStackIndex++] = treeForkProvider;
  treeForkProvider = workInProgress;
  treeForkCount = totalChildren;
}
function pushTreeId(workInProgress, totalChildren, index) {
  idStack[idStackIndex++] = treeContextId;
  idStack[idStackIndex++] = treeContextOverflow;
  idStack[idStackIndex++] = treeContextProvider;
  treeContextProvider = workInProgress;
  var baseIdWithLeadingBit = treeContextId;
  workInProgress = treeContextOverflow;
  var baseLength = 32 - clz32(baseIdWithLeadingBit) - 1;
  baseIdWithLeadingBit &= ~(1 << baseLength);
  index += 1;
  var length = 32 - clz32(totalChildren) + baseLength;
  if (30 < length) {
    var numberOfOverflowBits = baseLength - (baseLength % 5);
    length = (
      baseIdWithLeadingBit &
      ((1 << numberOfOverflowBits) - 1)
    ).toString(32);
    baseIdWithLeadingBit >>= numberOfOverflowBits;
    baseLength -= numberOfOverflowBits;
    treeContextId =
      (1 << (32 - clz32(totalChildren) + baseLength)) |
      (index << baseLength) |
      baseIdWithLeadingBit;
    treeContextOverflow = length + workInProgress;
  } else
    (treeContextId =
      (1 << length) | (index << baseLength) | baseIdWithLeadingBit),
      (treeContextOverflow = workInProgress);
}
function pushMaterializedTreeId(workInProgress) {
  null !== workInProgress.return &&
    (pushTreeFork(workInProgress, 1), pushTreeId(workInProgress, 1, 0));
}
function popTreeContext(workInProgress) {
  for (; workInProgress === treeForkProvider; )
    (treeForkProvider = forkStack[--forkStackIndex]),
      (forkStack[forkStackIndex] = null),
      (treeForkCount = forkStack[--forkStackIndex]),
      (forkStack[forkStackIndex] = null);
  for (; workInProgress === treeContextProvider; )
    (treeContextProvider = idStack[--idStackIndex]),
      (idStack[idStackIndex] = null),
      (treeContextOverflow = idStack[--idStackIndex]),
      (idStack[idStackIndex] = null),
      (treeContextId = idStack[--idStackIndex]),
      (idStack[idStackIndex] = null);
}
var hydrationParentFiber = null,
  nextHydratableInstance = null,
  isHydrating = false,
  hydrationErrors = null,
  rootOrSingletonContext = false,
  HydrationMismatchException = Error(formatProdErrorMessage(519));
function throwOnHydrationMismatch(fiber) {
  var error = Error(formatProdErrorMessage(418, ""));
  queueHydrationError(createCapturedValueAtFiber(error, fiber));
  throw HydrationMismatchException;
}
function prepareToHydrateHostInstance(fiber) {
  var instance = fiber.stateNode,
    type = fiber.type,
    props = fiber.memoizedProps;
  instance[internalInstanceKey] = fiber;
  instance[internalPropsKey] = props;
  switch (type) {
    case "dialog":
      listenToNonDelegatedEvent("cancel", instance);
      listenToNonDelegatedEvent("close", instance);
      break;
    case "iframe":
    case "object":
    case "embed":
      listenToNonDelegatedEvent("load", instance);
      break;
    case "video":
    case "audio":
      for (type = 0; type < mediaEventTypes.length; type++)
        listenToNonDelegatedEvent(mediaEventTypes[type], instance);
      break;
    case "source":
      listenToNonDelegatedEvent("error", instance);
      break;
    case "img":
    case "image":
    case "link":
      listenToNonDelegatedEvent("error", instance);
      listenToNonDelegatedEvent("load", instance);
      break;
    case "details":
      listenToNonDelegatedEvent("toggle", instance);
      break;
    case "input":
      listenToNonDelegatedEvent("invalid", instance);
      initInput(
        instance,
        props.value,
        props.defaultValue,
        props.checked,
        props.defaultChecked,
        props.type,
        props.name,
        true
      );
      track$1(instance);
      break;
    case "select":
      listenToNonDelegatedEvent("invalid", instance);
      break;
    case "textarea":
      listenToNonDelegatedEvent("invalid", instance),
        initTextarea(instance, props.value, props.defaultValue, props.children),
        track$1(instance);
  }
  type = props.children;
  ("string" !== typeof type &&
    "number" !== typeof type &&
    "bigint" !== typeof type) ||
  instance.textContent === "" + type ||
  true === props.suppressHydrationWarning ||
  checkForUnmatchedText(instance.textContent, type)
    ? (null != props.popover &&
        (listenToNonDelegatedEvent("beforetoggle", instance),
        listenToNonDelegatedEvent("toggle", instance)),
      null != props.onScroll && listenToNonDelegatedEvent("scroll", instance),
      null != props.onScrollEnd &&
        listenToNonDelegatedEvent("scrollend", instance),
      null != props.onClick && (instance.onclick = noop$1),
      (instance = true))
    : (instance = false);
  instance || throwOnHydrationMismatch(fiber);
}
function popToNextHostParent(fiber) {
  for (hydrationParentFiber = fiber.return; hydrationParentFiber; )
    switch (hydrationParentFiber.tag) {
      case 5:
      case 13:
        rootOrSingletonContext = false;
        return;
      case 27:
      case 3:
        rootOrSingletonContext = true;
        return;
      default:
        hydrationParentFiber = hydrationParentFiber.return;
    }
}
function popHydrationState(fiber) {
  if (fiber !== hydrationParentFiber) return false;
  if (!isHydrating) return popToNextHostParent(fiber), (isHydrating = true), false;
  var tag = fiber.tag,
    JSCompiler_temp;
  if ((JSCompiler_temp = 3 !== tag && 27 !== tag)) {
    if ((JSCompiler_temp = 5 === tag))
      (JSCompiler_temp = fiber.type),
        (JSCompiler_temp =
          !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) ||
          shouldSetTextContent(fiber.type, fiber.memoizedProps));
    JSCompiler_temp = !JSCompiler_temp;
  }
  JSCompiler_temp && nextHydratableInstance && throwOnHydrationMismatch(fiber);
  popToNextHostParent(fiber);
  if (13 === tag) {
    fiber = fiber.memoizedState;
    fiber = null !== fiber ? fiber.dehydrated : null;
    if (!fiber) throw Error(formatProdErrorMessage(317));
    a: {
      fiber = fiber.nextSibling;
      for (tag = 0; fiber; ) {
        if (8 === fiber.nodeType)
          if (((JSCompiler_temp = fiber.data), "/$" === JSCompiler_temp)) {
            if (0 === tag) {
              nextHydratableInstance = getNextHydratable(fiber.nextSibling);
              break a;
            }
            tag--;
          } else
            ("$" !== JSCompiler_temp &&
              "$!" !== JSCompiler_temp &&
              "$?" !== JSCompiler_temp) ||
              tag++;
        fiber = fiber.nextSibling;
      }
      nextHydratableInstance = null;
    }
  } else
    27 === tag
      ? ((tag = nextHydratableInstance),
        isSingletonScope(fiber.type)
          ? ((fiber = previousHydratableOnEnteringScopedSingleton),
            (previousHydratableOnEnteringScopedSingleton = null),
            (nextHydratableInstance = fiber))
          : (nextHydratableInstance = tag))
      : (nextHydratableInstance = hydrationParentFiber
          ? getNextHydratable(fiber.stateNode.nextSibling)
          : null);
  return true;
}
function resetHydrationState() {
  nextHydratableInstance = hydrationParentFiber = null;
  isHydrating = false;
}
function upgradeHydrationErrorsToRecoverable() {
  var queuedErrors = hydrationErrors;
  null !== queuedErrors &&
    (null === workInProgressRootRecoverableErrors
      ? (workInProgressRootRecoverableErrors = queuedErrors)
      : workInProgressRootRecoverableErrors.push.apply(
          workInProgressRootRecoverableErrors,
          queuedErrors
        ),
    (hydrationErrors = null));
  return queuedErrors;
}
function queueHydrationError(error) {
  null === hydrationErrors
    ? (hydrationErrors = [error])
    : hydrationErrors.push(error);
}
var valueCursor = createCursor(null),
  currentlyRenderingFiber$1 = null,
  lastContextDependency = null;
function pushProvider(providerFiber, context, nextValue) {
  push(valueCursor, context._currentValue);
  context._currentValue = nextValue;
}
function popProvider(context) {
  context._currentValue = valueCursor.current;
  pop(valueCursor);
}
function scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
  for (; null !== parent; ) {
    var alternate = parent.alternate;
    (parent.childLanes & renderLanes) !== renderLanes
      ? ((parent.childLanes |= renderLanes),
        null !== alternate && (alternate.childLanes |= renderLanes))
      : null !== alternate &&
        (alternate.childLanes & renderLanes) !== renderLanes &&
        (alternate.childLanes |= renderLanes);
    if (parent === propagationRoot) break;
    parent = parent.return;
  }
}
function propagateContextChanges(
  workInProgress,
  contexts,
  renderLanes,
  forcePropagateEntireTree
) {
  var fiber = workInProgress.child;
  null !== fiber && (fiber.return = workInProgress);
  for (; null !== fiber; ) {
    var list = fiber.dependencies;
    if (null !== list) {
      var nextFiber = fiber.child;
      list = list.firstContext;
      a: for (; null !== list; ) {
        var dependency = list;
        list = fiber;
        for (var i = 0; i < contexts.length; i++)
          if (dependency.context === contexts[i]) {
            list.lanes |= renderLanes;
            dependency = list.alternate;
            null !== dependency && (dependency.lanes |= renderLanes);
            scheduleContextWorkOnParentPath(
              list.return,
              renderLanes,
              workInProgress
            );
            forcePropagateEntireTree || (nextFiber = null);
            break a;
          }
        list = dependency.next;
      }
    } else if (18 === fiber.tag) {
      nextFiber = fiber.return;
      if (null === nextFiber) throw Error(formatProdErrorMessage(341));
      nextFiber.lanes |= renderLanes;
      list = nextFiber.alternate;
      null !== list && (list.lanes |= renderLanes);
      scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
      nextFiber = null;
    } else nextFiber = fiber.child;
    if (null !== nextFiber) nextFiber.return = fiber;
    else
      for (nextFiber = fiber; null !== nextFiber; ) {
        if (nextFiber === workInProgress) {
          nextFiber = null;
          break;
        }
        fiber = nextFiber.sibling;
        if (null !== fiber) {
          fiber.return = nextFiber.return;
          nextFiber = fiber;
          break;
        }
        nextFiber = nextFiber.return;
      }
    fiber = nextFiber;
  }
}
function propagateParentContextChanges(
  current,
  workInProgress,
  renderLanes,
  forcePropagateEntireTree
) {
  current = null;
  for (
    var parent = workInProgress, isInsidePropagationBailout = false;
    null !== parent;

  ) {
    if (!isInsidePropagationBailout)
      if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = true;
      else if (0 !== (parent.flags & 262144)) break;
    if (10 === parent.tag) {
      var currentParent = parent.alternate;
      if (null === currentParent) throw Error(formatProdErrorMessage(387));
      currentParent = currentParent.memoizedProps;
      if (null !== currentParent) {
        var context = parent.type;
        objectIs(parent.pendingProps.value, currentParent.value) ||
          (null !== current ? current.push(context) : (current = [context]));
      }
    } else if (parent === hostTransitionProviderCursor.current) {
      currentParent = parent.alternate;
      if (null === currentParent) throw Error(formatProdErrorMessage(387));
      currentParent.memoizedState.memoizedState !==
        parent.memoizedState.memoizedState &&
        (null !== current
          ? current.push(HostTransitionContext)
          : (current = [HostTransitionContext]));
    }
    parent = parent.return;
  }
  null !== current &&
    propagateContextChanges(
      workInProgress,
      current,
      renderLanes,
      forcePropagateEntireTree
    );
  workInProgress.flags |= 262144;
}
function checkIfContextChanged(currentDependencies) {
  for (
    currentDependencies = currentDependencies.firstContext;
    null !== currentDependencies;

  ) {
    if (
      !objectIs(
        currentDependencies.context._currentValue,
        currentDependencies.memoizedValue
      )
    )
      return true;
    currentDependencies = currentDependencies.next;
  }
  return false;
}
function prepareToReadContext(workInProgress) {
  currentlyRenderingFiber$1 = workInProgress;
  lastContextDependency = null;
  workInProgress = workInProgress.dependencies;
  null !== workInProgress && (workInProgress.firstContext = null);
}
function readContext(context) {
  return readContextForConsumer(currentlyRenderingFiber$1, context);
}
function readContextDuringReconciliation(consumer, context) {
  null === currentlyRenderingFiber$1 && prepareToReadContext(consumer);
  return readContextForConsumer(consumer, context);
}
function readContextForConsumer(consumer, context) {
  var value = context._currentValue;
  context = { context: context, memoizedValue: value, next: null };
  if (null === lastContextDependency) {
    if (null === consumer) throw Error(formatProdErrorMessage(308));
    lastContextDependency = context;
    consumer.dependencies = { lanes: 0, firstContext: context };
    consumer.flags |= 524288;
  } else lastContextDependency = lastContextDependency.next = context;
  return value;
}
var AbortControllerLocal =
    "undefined" !== typeof AbortController
      ? AbortController
      : function () {
          var listeners = [],
            signal = (this.signal = {
              aborted: false,
              addEventListener: function (type, listener) {
                listeners.push(listener);
              }
            });
          this.abort = function () {
            signal.aborted = true;
            listeners.forEach(function (listener) {
              return listener();
            });
          };
        },
  scheduleCallback$2 = Scheduler.unstable_scheduleCallback,
  NormalPriority = Scheduler.unstable_NormalPriority,
  CacheContext = {
    $$typeof: REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
  };
function createCache() {
  return {
    controller: new AbortControllerLocal(),
    data: new Map(),
    refCount: 0
  };
}
function releaseCache(cache) {
  cache.refCount--;
  0 === cache.refCount &&
    scheduleCallback$2(NormalPriority, function () {
      cache.controller.abort();
    });
}
var currentEntangledListeners = null,
  currentEntangledPendingCount = 0,
  currentEntangledLane = 0,
  currentEntangledActionThenable = null;
function entangleAsyncAction(transition, thenable) {
  if (null === currentEntangledListeners) {
    var entangledListeners = (currentEntangledListeners = []);
    currentEntangledPendingCount = 0;
    currentEntangledLane = requestTransitionLane();
    currentEntangledActionThenable = {
      status: "pending",
      value: void 0,
      then: function (resolve) {
        entangledListeners.push(resolve);
      }
    };
  }
  currentEntangledPendingCount++;
  thenable.then(pingEngtangledActionScope, pingEngtangledActionScope);
  return thenable;
}
function pingEngtangledActionScope() {
  if (
    0 === --currentEntangledPendingCount &&
    null !== currentEntangledListeners
  ) {
    null !== currentEntangledActionThenable &&
      (currentEntangledActionThenable.status = "fulfilled");
    var listeners = currentEntangledListeners;
    currentEntangledListeners = null;
    currentEntangledLane = 0;
    currentEntangledActionThenable = null;
    for (var i = 0; i < listeners.length; i++) (0, listeners[i])();
  }
}
function chainThenableValue(thenable, result) {
  var listeners = [],
    thenableWithOverride = {
      status: "pending",
      value: null,
      reason: null,
      then: function (resolve) {
        listeners.push(resolve);
      }
    };
  thenable.then(
    function () {
      thenableWithOverride.status = "fulfilled";
      thenableWithOverride.value = result;
      for (var i = 0; i < listeners.length; i++) (0, listeners[i])(result);
    },
    function (error) {
      thenableWithOverride.status = "rejected";
      thenableWithOverride.reason = error;
      for (error = 0; error < listeners.length; error++)
        (0, listeners[error])(void 0);
    }
  );
  return thenableWithOverride;
}
var prevOnStartTransitionFinish = ReactSharedInternals.S;
ReactSharedInternals.S = function (transition, returnValue) {
  "object" === typeof returnValue &&
    null !== returnValue &&
    "function" === typeof returnValue.then &&
    entangleAsyncAction(transition, returnValue);
  null !== prevOnStartTransitionFinish &&
    prevOnStartTransitionFinish(transition, returnValue);
};
var resumedCache = createCursor(null);
function peekCacheFromPool() {
  var cacheResumedFromPreviousRender = resumedCache.current;
  return null !== cacheResumedFromPreviousRender
    ? cacheResumedFromPreviousRender
    : workInProgressRoot.pooledCache;
}
function pushTransition(offscreenWorkInProgress, prevCachePool) {
  null === prevCachePool
    ? push(resumedCache, resumedCache.current)
    : push(resumedCache, prevCachePool.pool);
}
function getSuspendedCache() {
  var cacheFromPool = peekCacheFromPool();
  return null === cacheFromPool
    ? null
    : { parent: CacheContext._currentValue, pool: cacheFromPool };
}
var SuspenseException = Error(formatProdErrorMessage(460)),
  SuspenseyCommitException = Error(formatProdErrorMessage(474)),
  SuspenseActionException = Error(formatProdErrorMessage(542)),
  noopSuspenseyCommitThenable = { then: function () {} };
function isThenableResolved(thenable) {
  thenable = thenable.status;
  return "fulfilled" === thenable || "rejected" === thenable;
}
function noop$3() {}
function trackUsedThenable(thenableState, thenable, index) {
  index = thenableState[index];
  void 0 === index
    ? thenableState.push(thenable)
    : index !== thenable && (thenable.then(noop$3, noop$3), (thenable = index));
  switch (thenable.status) {
    case "fulfilled":
      return thenable.value;
    case "rejected":
      throw (
        ((thenableState = thenable.reason),
        checkIfUseWrappedInAsyncCatch(thenableState),
        thenableState)
      );
    default:
      if ("string" === typeof thenable.status) thenable.then(noop$3, noop$3);
      else {
        thenableState = workInProgressRoot;
        if (null !== thenableState && 100 < thenableState.shellSuspendCounter)
          throw Error(formatProdErrorMessage(482));
        thenableState = thenable;
        thenableState.status = "pending";
        thenableState.then(
          function (fulfilledValue) {
            if ("pending" === thenable.status) {
              var fulfilledThenable = thenable;
              fulfilledThenable.status = "fulfilled";
              fulfilledThenable.value = fulfilledValue;
            }
          },
          function (error) {
            if ("pending" === thenable.status) {
              var rejectedThenable = thenable;
              rejectedThenable.status = "rejected";
              rejectedThenable.reason = error;
            }
          }
        );
      }
      switch (thenable.status) {
        case "fulfilled":
          return thenable.value;
        case "rejected":
          throw (
            ((thenableState = thenable.reason),
            checkIfUseWrappedInAsyncCatch(thenableState),
            thenableState)
          );
      }
      suspendedThenable = thenable;
      throw SuspenseException;
  }
}
var suspendedThenable = null;
function getSuspendedThenable() {
  if (null === suspendedThenable) throw Error(formatProdErrorMessage(459));
  var thenable = suspendedThenable;
  suspendedThenable = null;
  return thenable;
}
function checkIfUseWrappedInAsyncCatch(rejectedReason) {
  if (
    rejectedReason === SuspenseException ||
    rejectedReason === SuspenseActionException
  )
    throw Error(formatProdErrorMessage(483));
}
var hasForceUpdate = false;
function initializeUpdateQueue(fiber) {
  fiber.updateQueue = {
    baseState: fiber.memoizedState,
    firstBaseUpdate: null,
    lastBaseUpdate: null,
    shared: { pending: null, lanes: 0, hiddenCallbacks: null },
    callbacks: null
  };
}
function cloneUpdateQueue(current, workInProgress) {
  current = current.updateQueue;
  workInProgress.updateQueue === current &&
    (workInProgress.updateQueue = {
      baseState: current.baseState,
      firstBaseUpdate: current.firstBaseUpdate,
      lastBaseUpdate: current.lastBaseUpdate,
      shared: current.shared,
      callbacks: null
    });
}
function createUpdate(lane) {
  return { lane: lane, tag: 0, payload: null, callback: null, next: null };
}
function enqueueUpdate(fiber, update, lane) {
  var updateQueue = fiber.updateQueue;
  if (null === updateQueue) return null;
  updateQueue = updateQueue.shared;
  if (0 !== (executionContext & 2)) {
    var pending = updateQueue.pending;
    null === pending
      ? (update.next = update)
      : ((update.next = pending.next), (pending.next = update));
    updateQueue.pending = update;
    update = getRootForUpdatedFiber(fiber);
    markUpdateLaneFromFiberToRoot(fiber, null, lane);
    return update;
  }
  enqueueUpdate$1(fiber, updateQueue, update, lane);
  return getRootForUpdatedFiber(fiber);
}
function entangleTransitions(root, fiber, lane) {
  fiber = fiber.updateQueue;
  if (null !== fiber && ((fiber = fiber.shared), 0 !== (lane & 4194048))) {
    var queueLanes = fiber.lanes;
    queueLanes &= root.pendingLanes;
    lane |= queueLanes;
    fiber.lanes = lane;
    markRootEntangled(root, lane);
  }
}
function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
  var queue = workInProgress.updateQueue,
    current = workInProgress.alternate;
  if (
    null !== current &&
    ((current = current.updateQueue), queue === current)
  ) {
    var newFirst = null,
      newLast = null;
    queue = queue.firstBaseUpdate;
    if (null !== queue) {
      do {
        var clone = {
          lane: queue.lane,
          tag: queue.tag,
          payload: queue.payload,
          callback: null,
          next: null
        };
        null === newLast
          ? (newFirst = newLast = clone)
          : (newLast = newLast.next = clone);
        queue = queue.next;
      } while (null !== queue);
      null === newLast
        ? (newFirst = newLast = capturedUpdate)
        : (newLast = newLast.next = capturedUpdate);
    } else newFirst = newLast = capturedUpdate;
    queue = {
      baseState: current.baseState,
      firstBaseUpdate: newFirst,
      lastBaseUpdate: newLast,
      shared: current.shared,
      callbacks: current.callbacks
    };
    workInProgress.updateQueue = queue;
    return;
  }
  workInProgress = queue.lastBaseUpdate;
  null === workInProgress
    ? (queue.firstBaseUpdate = capturedUpdate)
    : (workInProgress.next = capturedUpdate);
  queue.lastBaseUpdate = capturedUpdate;
}
var didReadFromEntangledAsyncAction = false;
function suspendIfUpdateReadFromEntangledAsyncAction() {
  if (didReadFromEntangledAsyncAction) {
    var entangledActionThenable = currentEntangledActionThenable;
    if (null !== entangledActionThenable) throw entangledActionThenable;
  }
}
function processUpdateQueue(
  workInProgress$jscomp$0,
  props,
  instance$jscomp$0,
  renderLanes
) {
  didReadFromEntangledAsyncAction = false;
  var queue = workInProgress$jscomp$0.updateQueue;
  hasForceUpdate = false;
  var firstBaseUpdate = queue.firstBaseUpdate,
    lastBaseUpdate = queue.lastBaseUpdate,
    pendingQueue = queue.shared.pending;
  if (null !== pendingQueue) {
    queue.shared.pending = null;
    var lastPendingUpdate = pendingQueue,
      firstPendingUpdate = lastPendingUpdate.next;
    lastPendingUpdate.next = null;
    null === lastBaseUpdate
      ? (firstBaseUpdate = firstPendingUpdate)
      : (lastBaseUpdate.next = firstPendingUpdate);
    lastBaseUpdate = lastPendingUpdate;
    var current = workInProgress$jscomp$0.alternate;
    null !== current &&
      ((current = current.updateQueue),
      (pendingQueue = current.lastBaseUpdate),
      pendingQueue !== lastBaseUpdate &&
        (null === pendingQueue
          ? (current.firstBaseUpdate = firstPendingUpdate)
          : (pendingQueue.next = firstPendingUpdate),
        (current.lastBaseUpdate = lastPendingUpdate)));
  }
  if (null !== firstBaseUpdate) {
    var newState = queue.baseState;
    lastBaseUpdate = 0;
    current = firstPendingUpdate = lastPendingUpdate = null;
    pendingQueue = firstBaseUpdate;
    do {
      var updateLane = pendingQueue.lane & -536870913,
        isHiddenUpdate = updateLane !== pendingQueue.lane;
      if (
        isHiddenUpdate
          ? (workInProgressRootRenderLanes & updateLane) === updateLane
          : (renderLanes & updateLane) === updateLane
      ) {
        0 !== updateLane &&
          updateLane === currentEntangledLane &&
          (didReadFromEntangledAsyncAction = true);
        null !== current &&
          (current = current.next =
            {
              lane: 0,
              tag: pendingQueue.tag,
              payload: pendingQueue.payload,
              callback: null,
              next: null
            });
        a: {
          var workInProgress = workInProgress$jscomp$0,
            update = pendingQueue;
          updateLane = props;
          var instance = instance$jscomp$0;
          switch (update.tag) {
            case 1:
              workInProgress = update.payload;
              if ("function" === typeof workInProgress) {
                newState = workInProgress.call(instance, newState, updateLane);
                break a;
              }
              newState = workInProgress;
              break a;
            case 3:
              workInProgress.flags = (workInProgress.flags & -65537) | 128;
            case 0:
              workInProgress = update.payload;
              updateLane =
                "function" === typeof workInProgress
                  ? workInProgress.call(instance, newState, updateLane)
                  : workInProgress;
              if (null === updateLane || void 0 === updateLane) break a;
              newState = assign({}, newState, updateLane);
              break a;
            case 2:
              hasForceUpdate = true;
          }
        }
        updateLane = pendingQueue.callback;
        null !== updateLane &&
          ((workInProgress$jscomp$0.flags |= 64),
          isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192),
          (isHiddenUpdate = queue.callbacks),
          null === isHiddenUpdate
            ? (queue.callbacks = [updateLane])
            : isHiddenUpdate.push(updateLane));
      } else
        (isHiddenUpdate = {
          lane: updateLane,
          tag: pendingQueue.tag,
          payload: pendingQueue.payload,
          callback: pendingQueue.callback,
          next: null
        }),
          null === current
            ? ((firstPendingUpdate = current = isHiddenUpdate),
              (lastPendingUpdate = newState))
            : (current = current.next = isHiddenUpdate),
          (lastBaseUpdate |= updateLane);
      pendingQueue = pendingQueue.next;
      if (null === pendingQueue)
        if (((pendingQueue = queue.shared.pending), null === pendingQueue))
          break;
        else
          (isHiddenUpdate = pendingQueue),
            (pendingQueue = isHiddenUpdate.next),
            (isHiddenUpdate.next = null),
            (queue.lastBaseUpdate = isHiddenUpdate),
            (queue.shared.pending = null);
    } while (1);
    null === current && (lastPendingUpdate = newState);
    queue.baseState = lastPendingUpdate;
    queue.firstBaseUpdate = firstPendingUpdate;
    queue.lastBaseUpdate = current;
    null === firstBaseUpdate && (queue.shared.lanes = 0);
    workInProgressRootSkippedLanes |= lastBaseUpdate;
    workInProgress$jscomp$0.lanes = lastBaseUpdate;
    workInProgress$jscomp$0.memoizedState = newState;
  }
}
function callCallback(callback, context) {
  if ("function" !== typeof callback)
    throw Error(formatProdErrorMessage(191, callback));
  callback.call(context);
}
function commitCallbacks(updateQueue, context) {
  var callbacks = updateQueue.callbacks;
  if (null !== callbacks)
    for (
      updateQueue.callbacks = null, updateQueue = 0;
      updateQueue < callbacks.length;
      updateQueue++
    )
      callCallback(callbacks[updateQueue], context);
}
var currentTreeHiddenStackCursor = createCursor(null),
  prevEntangledRenderLanesCursor = createCursor(0);
function pushHiddenContext(fiber, context) {
  fiber = entangledRenderLanes;
  push(prevEntangledRenderLanesCursor, fiber);
  push(currentTreeHiddenStackCursor, context);
  entangledRenderLanes = fiber | context.baseLanes;
}
function reuseHiddenContextOnStack() {
  push(prevEntangledRenderLanesCursor, entangledRenderLanes);
  push(currentTreeHiddenStackCursor, currentTreeHiddenStackCursor.current);
}
function popHiddenContext() {
  entangledRenderLanes = prevEntangledRenderLanesCursor.current;
  pop(currentTreeHiddenStackCursor);
  pop(prevEntangledRenderLanesCursor);
}
var renderLanes = 0,
  currentlyRenderingFiber = null,
  currentHook = null,
  workInProgressHook = null,
  didScheduleRenderPhaseUpdate = false,
  didScheduleRenderPhaseUpdateDuringThisPass = false,
  shouldDoubleInvokeUserFnsInHooksDEV = false,
  localIdCounter = 0,
  thenableIndexCounter$1 = 0,
  thenableState$1 = null,
  globalClientIdCounter = 0;
function throwInvalidHookError() {
  throw Error(formatProdErrorMessage(321));
}
function areHookInputsEqual(nextDeps, prevDeps) {
  if (null === prevDeps) return false;
  for (var i = 0; i < prevDeps.length && i < nextDeps.length; i++)
    if (!objectIs(nextDeps[i], prevDeps[i])) return false;
  return true;
}
function renderWithHooks(
  current,
  workInProgress,
  Component,
  props,
  secondArg,
  nextRenderLanes
) {
  renderLanes = nextRenderLanes;
  currentlyRenderingFiber = workInProgress;
  workInProgress.memoizedState = null;
  workInProgress.updateQueue = null;
  workInProgress.lanes = 0;
  ReactSharedInternals.H =
    null === current || null === current.memoizedState
      ? HooksDispatcherOnMount
      : HooksDispatcherOnUpdate;
  shouldDoubleInvokeUserFnsInHooksDEV = false;
  nextRenderLanes = Component(props, secondArg);
  shouldDoubleInvokeUserFnsInHooksDEV = false;
  didScheduleRenderPhaseUpdateDuringThisPass &&
    (nextRenderLanes = renderWithHooksAgain(
      workInProgress,
      Component,
      props,
      secondArg
    ));
  finishRenderingHooks(current);
  return nextRenderLanes;
}
function finishRenderingHooks(current) {
  ReactSharedInternals.H = ContextOnlyDispatcher;
  var didRenderTooFewHooks = null !== currentHook && null !== currentHook.next;
  renderLanes = 0;
  workInProgressHook = currentHook = currentlyRenderingFiber = null;
  didScheduleRenderPhaseUpdate = false;
  thenableIndexCounter$1 = 0;
  thenableState$1 = null;
  if (didRenderTooFewHooks) throw Error(formatProdErrorMessage(300));
  null === current ||
    didReceiveUpdate ||
    ((current = current.dependencies),
    null !== current &&
      checkIfContextChanged(current) &&
      (didReceiveUpdate = true));
}
function renderWithHooksAgain(workInProgress, Component, props, secondArg) {
  currentlyRenderingFiber = workInProgress;
  var numberOfReRenders = 0;
  do {
    didScheduleRenderPhaseUpdateDuringThisPass && (thenableState$1 = null);
    thenableIndexCounter$1 = 0;
    didScheduleRenderPhaseUpdateDuringThisPass = false;
    if (25 <= numberOfReRenders) throw Error(formatProdErrorMessage(301));
    numberOfReRenders += 1;
    workInProgressHook = currentHook = null;
    if (null != workInProgress.updateQueue) {
      var children = workInProgress.updateQueue;
      children.lastEffect = null;
      children.events = null;
      children.stores = null;
      null != children.memoCache && (children.memoCache.index = 0);
    }
    ReactSharedInternals.H = HooksDispatcherOnRerender;
    children = Component(props, secondArg);
  } while (didScheduleRenderPhaseUpdateDuringThisPass);
  return children;
}
function TransitionAwareHostComponent() {
  var dispatcher = ReactSharedInternals.H,
    maybeThenable = dispatcher.useState()[0];
  maybeThenable =
    "function" === typeof maybeThenable.then
      ? useThenable(maybeThenable)
      : maybeThenable;
  dispatcher = dispatcher.useState()[0];
  (null !== currentHook ? currentHook.memoizedState : null) !== dispatcher &&
    (currentlyRenderingFiber.flags |= 1024);
  return maybeThenable;
}
function checkDidRenderIdHook() {
  var didRenderIdHook = 0 !== localIdCounter;
  localIdCounter = 0;
  return didRenderIdHook;
}
function bailoutHooks(current, workInProgress, lanes) {
  workInProgress.updateQueue = current.updateQueue;
  workInProgress.flags &= -2053;
  current.lanes &= ~lanes;
}
function resetHooksOnUnwind(workInProgress) {
  if (didScheduleRenderPhaseUpdate) {
    for (
      workInProgress = workInProgress.memoizedState;
      null !== workInProgress;

    ) {
      var queue = workInProgress.queue;
      null !== queue && (queue.pending = null);
      workInProgress = workInProgress.next;
    }
    didScheduleRenderPhaseUpdate = false;
  }
  renderLanes = 0;
  workInProgressHook = currentHook = currentlyRenderingFiber = null;
  didScheduleRenderPhaseUpdateDuringThisPass = false;
  thenableIndexCounter$1 = localIdCounter = 0;
  thenableState$1 = null;
}
function mountWorkInProgressHook() {
  var hook = {
    memoizedState: null,
    baseState: null,
    baseQueue: null,
    queue: null,
    next: null
  };
  null === workInProgressHook
    ? (currentlyRenderingFiber.memoizedState = workInProgressHook = hook)
    : (workInProgressHook = workInProgressHook.next = hook);
  return workInProgressHook;
}
function updateWorkInProgressHook() {
  if (null === currentHook) {
    var nextCurrentHook = currentlyRenderingFiber.alternate;
    nextCurrentHook =
      null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
  } else nextCurrentHook = currentHook.next;
  var nextWorkInProgressHook =
    null === workInProgressHook
      ? currentlyRenderingFiber.memoizedState
      : workInProgressHook.next;
  if (null !== nextWorkInProgressHook)
    (workInProgressHook = nextWorkInProgressHook),
      (currentHook = nextCurrentHook);
  else {
    if (null === nextCurrentHook) {
      if (null === currentlyRenderingFiber.alternate)
        throw Error(formatProdErrorMessage(467));
      throw Error(formatProdErrorMessage(310));
    }
    currentHook = nextCurrentHook;
    nextCurrentHook = {
      memoizedState: currentHook.memoizedState,
      baseState: currentHook.baseState,
      baseQueue: currentHook.baseQueue,
      queue: currentHook.queue,
      next: null
    };
    null === workInProgressHook
      ? (currentlyRenderingFiber.memoizedState = workInProgressHook =
          nextCurrentHook)
      : (workInProgressHook = workInProgressHook.next = nextCurrentHook);
  }
  return workInProgressHook;
}
function createFunctionComponentUpdateQueue() {
  return { lastEffect: null, events: null, stores: null, memoCache: null };
}
function useThenable(thenable) {
  var index = thenableIndexCounter$1;
  thenableIndexCounter$1 += 1;
  null === thenableState$1 && (thenableState$1 = []);
  thenable = trackUsedThenable(thenableState$1, thenable, index);
  index = currentlyRenderingFiber;
  null ===
    (null === workInProgressHook
      ? index.memoizedState
      : workInProgressHook.next) &&
    ((index = index.alternate),
    (ReactSharedInternals.H =
      null === index || null === index.memoizedState
        ? HooksDispatcherOnMount
        : HooksDispatcherOnUpdate));
  return thenable;
}
function use(usable) {
  if (null !== usable && "object" === typeof usable) {
    if ("function" === typeof usable.then) return useThenable(usable);
    if (usable.$$typeof === REACT_CONTEXT_TYPE) return readContext(usable);
  }
  throw Error(formatProdErrorMessage(438, String(usable)));
}
function useMemoCache(size) {
  var memoCache = null,
    updateQueue = currentlyRenderingFiber.updateQueue;
  null !== updateQueue && (memoCache = updateQueue.memoCache);
  if (null == memoCache) {
    var current = currentlyRenderingFiber.alternate;
    null !== current &&
      ((current = current.updateQueue),
      null !== current &&
        ((current = current.memoCache),
        null != current &&
          (memoCache = {
            data: current.data.map(function (array) {
              return array.slice();
            }),
            index: 0
          })));
  }
  null == memoCache && (memoCache = { data: [], index: 0 });
  null === updateQueue &&
    ((updateQueue = createFunctionComponentUpdateQueue()),
    (currentlyRenderingFiber.updateQueue = updateQueue));
  updateQueue.memoCache = memoCache;
  updateQueue = memoCache.data[memoCache.index];
  if (void 0 === updateQueue)
    for (
      updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0;
      current < size;
      current++
    )
      updateQueue[current] = REACT_MEMO_CACHE_SENTINEL;
  memoCache.index++;
  return updateQueue;
}
function basicStateReducer(state, action) {
  return "function" === typeof action ? action(state) : action;
}
function updateReducer(reducer) {
  var hook = updateWorkInProgressHook();
  return updateReducerImpl(hook, currentHook, reducer);
}
function updateReducerImpl(hook, current, reducer) {
  var queue = hook.queue;
  if (null === queue) throw Error(formatProdErrorMessage(311));
  queue.lastRenderedReducer = reducer;
  var baseQueue = hook.baseQueue,
    pendingQueue = queue.pending;
  if (null !== pendingQueue) {
    if (null !== baseQueue) {
      var baseFirst = baseQueue.next;
      baseQueue.next = pendingQueue.next;
      pendingQueue.next = baseFirst;
    }
    current.baseQueue = baseQueue = pendingQueue;
    queue.pending = null;
  }
  pendingQueue = hook.baseState;
  if (null === baseQueue) hook.memoizedState = pendingQueue;
  else {
    current = baseQueue.next;
    var newBaseQueueFirst = (baseFirst = null),
      newBaseQueueLast = null,
      update = current,
      didReadFromEntangledAsyncAction$32 = false;
    do {
      var updateLane = update.lane & -536870913;
      if (
        updateLane !== update.lane
          ? (workInProgressRootRenderLanes & updateLane) === updateLane
          : (renderLanes & updateLane) === updateLane
      ) {
        var revertLane = update.revertLane;
        if (0 === revertLane)
          null !== newBaseQueueLast &&
            (newBaseQueueLast = newBaseQueueLast.next =
              {
                lane: 0,
                revertLane: 0,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
              }),
            updateLane === currentEntangledLane &&
              (didReadFromEntangledAsyncAction$32 = true);
        else if ((renderLanes & revertLane) === revertLane) {
          update = update.next;
          revertLane === currentEntangledLane &&
            (didReadFromEntangledAsyncAction$32 = true);
          continue;
        } else
          (updateLane = {
            lane: 0,
            revertLane: update.revertLane,
            action: update.action,
            hasEagerState: update.hasEagerState,
            eagerState: update.eagerState,
            next: null
          }),
            null === newBaseQueueLast
              ? ((newBaseQueueFirst = newBaseQueueLast = updateLane),
                (baseFirst = pendingQueue))
              : (newBaseQueueLast = newBaseQueueLast.next = updateLane),
            (currentlyRenderingFiber.lanes |= revertLane),
            (workInProgressRootSkippedLanes |= revertLane);
        updateLane = update.action;
        shouldDoubleInvokeUserFnsInHooksDEV &&
          reducer(pendingQueue, updateLane);
        pendingQueue = update.hasEagerState
          ? update.eagerState
          : reducer(pendingQueue, updateLane);
      } else
        (revertLane = {
          lane: updateLane,
          revertLane: update.revertLane,
          action: update.action,
          hasEagerState: update.hasEagerState,
          eagerState: update.eagerState,
          next: null
        }),
          null === newBaseQueueLast
            ? ((newBaseQueueFirst = newBaseQueueLast = revertLane),
              (baseFirst = pendingQueue))
            : (newBaseQueueLast = newBaseQueueLast.next = revertLane),
          (currentlyRenderingFiber.lanes |= updateLane),
          (workInProgressRootSkippedLanes |= updateLane);
      update = update.next;
    } while (null !== update && update !== current);
    null === newBaseQueueLast
      ? (baseFirst = pendingQueue)
      : (newBaseQueueLast.next = newBaseQueueFirst);
    if (
      !objectIs(pendingQueue, hook.memoizedState) &&
      ((didReceiveUpdate = true),
      didReadFromEntangledAsyncAction$32 &&
        ((reducer = currentEntangledActionThenable), null !== reducer))
    )
      throw reducer;
    hook.memoizedState = pendingQueue;
    hook.baseState = baseFirst;
    hook.baseQueue = newBaseQueueLast;
    queue.lastRenderedState = pendingQueue;
  }
  null === baseQueue && (queue.lanes = 0);
  return [hook.memoizedState, queue.dispatch];
}
function rerenderReducer(reducer) {
  var hook = updateWorkInProgressHook(),
    queue = hook.queue;
  if (null === queue) throw Error(formatProdErrorMessage(311));
  queue.lastRenderedReducer = reducer;
  var dispatch = queue.dispatch,
    lastRenderPhaseUpdate = queue.pending,
    newState = hook.memoizedState;
  if (null !== lastRenderPhaseUpdate) {
    queue.pending = null;
    var update = (lastRenderPhaseUpdate = lastRenderPhaseUpdate.next);
    do (newState = reducer(newState, update.action)), (update = update.next);
    while (update !== lastRenderPhaseUpdate);
    objectIs(newState, hook.memoizedState) || (didReceiveUpdate = true);
    hook.memoizedState = newState;
    null === hook.baseQueue && (hook.baseState = newState);
    queue.lastRenderedState = newState;
  }
  return [newState, dispatch];
}
function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
  var fiber = currentlyRenderingFiber,
    hook = updateWorkInProgressHook(),
    isHydrating$jscomp$0 = isHydrating;
  if (isHydrating$jscomp$0) {
    if (void 0 === getServerSnapshot) throw Error(formatProdErrorMessage(407));
    getServerSnapshot = getServerSnapshot();
  } else getServerSnapshot = getSnapshot();
  var snapshotChanged = !objectIs(
    (currentHook || hook).memoizedState,
    getServerSnapshot
  );
  snapshotChanged &&
    ((hook.memoizedState = getServerSnapshot), (didReceiveUpdate = true));
  hook = hook.queue;
  var create = subscribeToStore.bind(null, fiber, hook, subscribe);
  updateEffectImpl(2048, 8, create, [subscribe]);
  if (
    hook.getSnapshot !== getSnapshot ||
    snapshotChanged ||
    (null !== workInProgressHook && workInProgressHook.memoizedState.tag & 1)
  ) {
    fiber.flags |= 2048;
    pushSimpleEffect(
      9,
      createEffectInstance(),
      updateStoreInstance.bind(
        null,
        fiber,
        hook,
        getServerSnapshot,
        getSnapshot
      ),
      null
    );
    if (null === workInProgressRoot) throw Error(formatProdErrorMessage(349));
    isHydrating$jscomp$0 ||
      0 !== (renderLanes & 124) ||
      pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
  }
  return getServerSnapshot;
}
function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
  fiber.flags |= 16384;
  fiber = { getSnapshot: getSnapshot, value: renderedSnapshot };
  getSnapshot = currentlyRenderingFiber.updateQueue;
  null === getSnapshot
    ? ((getSnapshot = createFunctionComponentUpdateQueue()),
      (currentlyRenderingFiber.updateQueue = getSnapshot),
      (getSnapshot.stores = [fiber]))
    : ((renderedSnapshot = getSnapshot.stores),
      null === renderedSnapshot
        ? (getSnapshot.stores = [fiber])
        : renderedSnapshot.push(fiber));
}
function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
  inst.value = nextSnapshot;
  inst.getSnapshot = getSnapshot;
  checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
}
function subscribeToStore(fiber, inst, subscribe) {
  return subscribe(function () {
    checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
  });
}
function checkIfSnapshotChanged(inst) {
  var latestGetSnapshot = inst.getSnapshot;
  inst = inst.value;
  try {
    var nextValue = latestGetSnapshot();
    return !objectIs(inst, nextValue);
  } catch (error) {
    return true;
  }
}
function forceStoreRerender(fiber) {
  var root = enqueueConcurrentRenderForLane(fiber, 2);
  null !== root && scheduleUpdateOnFiber(root, fiber, 2);
}
function mountStateImpl(initialState) {
  var hook = mountWorkInProgressHook();
  if ("function" === typeof initialState) {
    var initialStateInitializer = initialState;
    initialState = initialStateInitializer();
    if (shouldDoubleInvokeUserFnsInHooksDEV) {
      setIsStrictModeForDevtools(true);
      try {
        initialStateInitializer();
      } finally {
        setIsStrictModeForDevtools(false);
      }
    }
  }
  hook.memoizedState = hook.baseState = initialState;
  hook.queue = {
    pending: null,
    lanes: 0,
    dispatch: null,
    lastRenderedReducer: basicStateReducer,
    lastRenderedState: initialState
  };
  return hook;
}
function updateOptimisticImpl(hook, current, passthrough, reducer) {
  hook.baseState = passthrough;
  return updateReducerImpl(
    hook,
    currentHook,
    "function" === typeof reducer ? reducer : basicStateReducer
  );
}
function dispatchActionState(
  fiber,
  actionQueue,
  setPendingState,
  setState,
  payload
) {
  if (isRenderPhaseUpdate(fiber)) throw Error(formatProdErrorMessage(485));
  fiber = actionQueue.action;
  if (null !== fiber) {
    var actionNode = {
      payload: payload,
      action: fiber,
      next: null,
      isTransition: true,
      status: "pending",
      value: null,
      reason: null,
      listeners: [],
      then: function (listener) {
        actionNode.listeners.push(listener);
      }
    };
    null !== ReactSharedInternals.T
      ? setPendingState(true)
      : (actionNode.isTransition = false);
    setState(actionNode);
    setPendingState = actionQueue.pending;
    null === setPendingState
      ? ((actionNode.next = actionQueue.pending = actionNode),
        runActionStateAction(actionQueue, actionNode))
      : ((actionNode.next = setPendingState.next),
        (actionQueue.pending = setPendingState.next = actionNode));
  }
}
function runActionStateAction(actionQueue, node) {
  var action = node.action,
    payload = node.payload,
    prevState = actionQueue.state;
  if (node.isTransition) {
    var prevTransition = ReactSharedInternals.T,
      currentTransition = {};
    ReactSharedInternals.T = currentTransition;
    try {
      var returnValue = action(prevState, payload),
        onStartTransitionFinish = ReactSharedInternals.S;
      null !== onStartTransitionFinish &&
        onStartTransitionFinish(currentTransition, returnValue);
      handleActionReturnValue(actionQueue, node, returnValue);
    } catch (error) {
      onActionError(actionQueue, node, error);
    } finally {
      ReactSharedInternals.T = prevTransition;
    }
  } else
    try {
      (prevTransition = action(prevState, payload)),
        handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$38) {
      onActionError(actionQueue, node, error$38);
    }
}
function handleActionReturnValue(actionQueue, node, returnValue) {
  null !== returnValue &&
  "object" === typeof returnValue &&
  "function" === typeof returnValue.then
    ? returnValue.then(
        function (nextState) {
          onActionSuccess(actionQueue, node, nextState);
        },
        function (error) {
          return onActionError(actionQueue, node, error);
        }
      )
    : onActionSuccess(actionQueue, node, returnValue);
}
function onActionSuccess(actionQueue, actionNode, nextState) {
  actionNode.status = "fulfilled";
  actionNode.value = nextState;
  notifyActionListeners(actionNode);
  actionQueue.state = nextState;
  actionNode = actionQueue.pending;
  null !== actionNode &&
    ((nextState = actionNode.next),
    nextState === actionNode
      ? (actionQueue.pending = null)
      : ((nextState = nextState.next),
        (actionNode.next = nextState),
        runActionStateAction(actionQueue, nextState)));
}
function onActionError(actionQueue, actionNode, error) {
  var last = actionQueue.pending;
  actionQueue.pending = null;
  if (null !== last) {
    last = last.next;
    do
      (actionNode.status = "rejected"),
        (actionNode.reason = error),
        notifyActionListeners(actionNode),
        (actionNode = actionNode.next);
    while (actionNode !== last);
  }
  actionQueue.action = null;
}
function notifyActionListeners(actionNode) {
  actionNode = actionNode.listeners;
  for (var i = 0; i < actionNode.length; i++) (0, actionNode[i])();
}
function actionStateReducer(oldState, newState) {
  return newState;
}
function mountActionState(action, initialStateProp) {
  if (isHydrating) {
    var ssrFormState = workInProgressRoot.formState;
    if (null !== ssrFormState) {
      a: {
        var JSCompiler_inline_result = currentlyRenderingFiber;
        if (isHydrating) {
          if (nextHydratableInstance) {
            b: {
              var JSCompiler_inline_result$jscomp$0 = nextHydratableInstance;
              for (
                var inRootOrSingleton = rootOrSingletonContext;
                8 !== JSCompiler_inline_result$jscomp$0.nodeType;

              ) {
                if (!inRootOrSingleton) {
                  JSCompiler_inline_result$jscomp$0 = null;
                  break b;
                }
                JSCompiler_inline_result$jscomp$0 = getNextHydratable(
                  JSCompiler_inline_result$jscomp$0.nextSibling
                );
                if (null === JSCompiler_inline_result$jscomp$0) {
                  JSCompiler_inline_result$jscomp$0 = null;
                  break b;
                }
              }
              inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
              JSCompiler_inline_result$jscomp$0 =
                "F!" === inRootOrSingleton || "F" === inRootOrSingleton
                  ? JSCompiler_inline_result$jscomp$0
                  : null;
            }
            if (JSCompiler_inline_result$jscomp$0) {
              nextHydratableInstance = getNextHydratable(
                JSCompiler_inline_result$jscomp$0.nextSibling
              );
              JSCompiler_inline_result =
                "F!" === JSCompiler_inline_result$jscomp$0.data;
              break a;
            }
          }
          throwOnHydrationMismatch(JSCompiler_inline_result);
        }
        JSCompiler_inline_result = false;
      }
      JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
    }
  }
  ssrFormState = mountWorkInProgressHook();
  ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
  JSCompiler_inline_result = {
    pending: null,
    lanes: 0,
    dispatch: null,
    lastRenderedReducer: actionStateReducer,
    lastRenderedState: initialStateProp
  };
  ssrFormState.queue = JSCompiler_inline_result;
  ssrFormState = dispatchSetState.bind(
    null,
    currentlyRenderingFiber,
    JSCompiler_inline_result
  );
  JSCompiler_inline_result.dispatch = ssrFormState;
  JSCompiler_inline_result = mountStateImpl(false);
  inRootOrSingleton = dispatchOptimisticSetState.bind(
    null,
    currentlyRenderingFiber,
    false,
    JSCompiler_inline_result.queue
  );
  JSCompiler_inline_result = mountWorkInProgressHook();
  JSCompiler_inline_result$jscomp$0 = {
    state: initialStateProp,
    dispatch: null,
    action: action,
    pending: null
  };
  JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
  ssrFormState = dispatchActionState.bind(
    null,
    currentlyRenderingFiber,
    JSCompiler_inline_result$jscomp$0,
    inRootOrSingleton,
    ssrFormState
  );
  JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
  JSCompiler_inline_result.memoizedState = action;
  return [initialStateProp, ssrFormState, false];
}
function updateActionState(action) {
  var stateHook = updateWorkInProgressHook();
  return updateActionStateImpl(stateHook, currentHook, action);
}
function updateActionStateImpl(stateHook, currentStateHook, action) {
  currentStateHook = updateReducerImpl(
    stateHook,
    currentStateHook,
    actionStateReducer
  )[0];
  stateHook = updateReducer(basicStateReducer)[0];
  if (
    "object" === typeof currentStateHook &&
    null !== currentStateHook &&
    "function" === typeof currentStateHook.then
  )
    try {
      var state = useThenable(currentStateHook);
    } catch (x) {
      if (x === SuspenseException) throw SuspenseActionException;
      throw x;
    }
  else state = currentStateHook;
  currentStateHook = updateWorkInProgressHook();
  var actionQueue = currentStateHook.queue,
    dispatch = actionQueue.dispatch;
  action !== currentStateHook.memoizedState &&
    ((currentlyRenderingFiber.flags |= 2048),
    pushSimpleEffect(
      9,
      createEffectInstance(),
      actionStateActionEffect.bind(null, actionQueue, action),
      null
    ));
  return [state, dispatch, stateHook];
}
function actionStateActionEffect(actionQueue, action) {
  actionQueue.action = action;
}
function rerenderActionState(action) {
  var stateHook = updateWorkInProgressHook(),
    currentStateHook = currentHook;
  if (null !== currentStateHook)
    return updateActionStateImpl(stateHook, currentStateHook, action);
  updateWorkInProgressHook();
  stateHook = stateHook.memoizedState;
  currentStateHook = updateWorkInProgressHook();
  var dispatch = currentStateHook.queue.dispatch;
  currentStateHook.memoizedState = action;
  return [stateHook, dispatch, false];
}
function pushSimpleEffect(tag, inst, create, createDeps) {
  tag = { tag: tag, create: create, deps: createDeps, inst: inst, next: null };
  inst = currentlyRenderingFiber.updateQueue;
  null === inst &&
    ((inst = createFunctionComponentUpdateQueue()),
    (currentlyRenderingFiber.updateQueue = inst));
  create = inst.lastEffect;
  null === create
    ? (inst.lastEffect = tag.next = tag)
    : ((createDeps = create.next),
      (create.next = tag),
      (tag.next = createDeps),
      (inst.lastEffect = tag));
  return tag;
}
function createEffectInstance() {
  return { destroy: void 0, resource: void 0 };
}
function updateRef() {
  return updateWorkInProgressHook().memoizedState;
}
function mountEffectImpl(fiberFlags, hookFlags, create, createDeps) {
  var hook = mountWorkInProgressHook();
  createDeps = void 0 === createDeps ? null : createDeps;
  currentlyRenderingFiber.flags |= fiberFlags;
  hook.memoizedState = pushSimpleEffect(
    1 | hookFlags,
    createEffectInstance(),
    create,
    createDeps
  );
}
function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
  var hook = updateWorkInProgressHook();
  deps = void 0 === deps ? null : deps;
  var inst = hook.memoizedState.inst;
  null !== currentHook &&
  null !== deps &&
  areHookInputsEqual(deps, currentHook.memoizedState.deps)
    ? (hook.memoizedState = pushSimpleEffect(hookFlags, inst, create, deps))
    : ((currentlyRenderingFiber.flags |= fiberFlags),
      (hook.memoizedState = pushSimpleEffect(
        1 | hookFlags,
        inst,
        create,
        deps
      )));
}
function mountEffect(create, createDeps) {
  mountEffectImpl(8390656, 8, create, createDeps);
}
function updateEffect(create, createDeps) {
  updateEffectImpl(2048, 8, create, createDeps);
}
function updateInsertionEffect(create, deps) {
  return updateEffectImpl(4, 2, create, deps);
}
function updateLayoutEffect(create, deps) {
  return updateEffectImpl(4, 4, create, deps);
}
function imperativeHandleEffect(create, ref) {
  if ("function" === typeof ref) {
    create = create();
    var refCleanup = ref(create);
    return function () {
      "function" === typeof refCleanup ? refCleanup() : ref(null);
    };
  }
  if (null !== ref && void 0 !== ref)
    return (
      (create = create()),
      (ref.current = create),
      function () {
        ref.current = null;
      }
    );
}
function updateImperativeHandle(ref, create, deps) {
  deps = null !== deps && void 0 !== deps ? deps.concat([ref]) : null;
  updateEffectImpl(4, 4, imperativeHandleEffect.bind(null, create, ref), deps);
}
function mountDebugValue() {}
function updateCallback(callback, deps) {
  var hook = updateWorkInProgressHook();
  deps = void 0 === deps ? null : deps;
  var prevState = hook.memoizedState;
  if (null !== deps && areHookInputsEqual(deps, prevState[1]))
    return prevState[0];
  hook.memoizedState = [callback, deps];
  return callback;
}
function updateMemo(nextCreate, deps) {
  var hook = updateWorkInProgressHook();
  deps = void 0 === deps ? null : deps;
  var prevState = hook.memoizedState;
  if (null !== deps && areHookInputsEqual(deps, prevState[1]))
    return prevState[0];
  prevState = nextCreate();
  if (shouldDoubleInvokeUserFnsInHooksDEV) {
    setIsStrictModeForDevtools(true);
    try {
      nextCreate();
    } finally {
      setIsStrictModeForDevtools(false);
    }
  }
  hook.memoizedState = [prevState, deps];
  return prevState;
}
function mountDeferredValueImpl(hook, value, initialValue) {
  if (void 0 === initialValue || 0 !== (renderLanes & 1073741824))
    return (hook.memoizedState = value);
  hook.memoizedState = initialValue;
  hook = requestDeferredLane();
  currentlyRenderingFiber.lanes |= hook;
  workInProgressRootSkippedLanes |= hook;
  return initialValue;
}
function updateDeferredValueImpl(hook, prevValue, value, initialValue) {
  if (objectIs(value, prevValue)) return value;
  if (null !== currentTreeHiddenStackCursor.current)
    return (
      (hook = mountDeferredValueImpl(hook, value, initialValue)),
      objectIs(hook, prevValue) || (didReceiveUpdate = true),
      hook
    );
  if (0 === (renderLanes & 42))
    return (didReceiveUpdate = true), (hook.memoizedState = value);
  hook = requestDeferredLane();
  currentlyRenderingFiber.lanes |= hook;
  workInProgressRootSkippedLanes |= hook;
  return prevValue;
}
function startTransition(fiber, queue, pendingState, finishedState, callback) {
  var previousPriority = ReactDOMSharedInternals.p;
  ReactDOMSharedInternals.p =
    0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
  var prevTransition = ReactSharedInternals.T,
    currentTransition = {};
  ReactSharedInternals.T = currentTransition;
  dispatchOptimisticSetState(fiber, false, queue, pendingState);
  try {
    var returnValue = callback(),
      onStartTransitionFinish = ReactSharedInternals.S;
    null !== onStartTransitionFinish &&
      onStartTransitionFinish(currentTransition, returnValue);
    if (
      null !== returnValue &&
      "object" === typeof returnValue &&
      "function" === typeof returnValue.then
    ) {
      var thenableForFinishedState = chainThenableValue(
        returnValue,
        finishedState
      );
      dispatchSetStateInternal(
        fiber,
        queue,
        thenableForFinishedState,
        requestUpdateLane(fiber)
      );
    } else
      dispatchSetStateInternal(
        fiber,
        queue,
        finishedState,
        requestUpdateLane(fiber)
      );
  } catch (error) {
    dispatchSetStateInternal(
      fiber,
      queue,
      { then: function () {}, status: "rejected", reason: error },
      requestUpdateLane()
    );
  } finally {
    (ReactDOMSharedInternals.p = previousPriority),
      (ReactSharedInternals.T = prevTransition);
  }
}
function noop$2() {}
function startHostTransition(formFiber, pendingState, action, formData) {
  if (5 !== formFiber.tag) throw Error(formatProdErrorMessage(476));
  var queue = ensureFormComponentIsStateful(formFiber).queue;
  startTransition(
    formFiber,
    queue,
    pendingState,
    sharedNotPendingObject,
    null === action
      ? noop$2
      : function () {
          requestFormReset$1(formFiber);
          return action(formData);
        }
  );
}
function ensureFormComponentIsStateful(formFiber) {
  var existingStateHook = formFiber.memoizedState;
  if (null !== existingStateHook) return existingStateHook;
  existingStateHook = {
    memoizedState: sharedNotPendingObject,
    baseState: sharedNotPendingObject,
    baseQueue: null,
    queue: {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: basicStateReducer,
      lastRenderedState: sharedNotPendingObject
    },
    next: null
  };
  var initialResetState = {};
  existingStateHook.next = {
    memoizedState: initialResetState,
    baseState: initialResetState,
    baseQueue: null,
    queue: {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: basicStateReducer,
      lastRenderedState: initialResetState
    },
    next: null
  };
  formFiber.memoizedState = existingStateHook;
  formFiber = formFiber.alternate;
  null !== formFiber && (formFiber.memoizedState = existingStateHook);
  return existingStateHook;
}
function requestFormReset$1(formFiber) {
  var resetStateQueue = ensureFormComponentIsStateful(formFiber).next.queue;
  dispatchSetStateInternal(formFiber, resetStateQueue, {}, requestUpdateLane());
}
function useHostTransitionStatus() {
  return readContext(HostTransitionContext);
}
function updateId() {
  return updateWorkInProgressHook().memoizedState;
}
function updateRefresh() {
  return updateWorkInProgressHook().memoizedState;
}
function refreshCache(fiber) {
  for (var provider = fiber.return; null !== provider; ) {
    switch (provider.tag) {
      case 24:
      case 3:
        var lane = requestUpdateLane();
        fiber = createUpdate(lane);
        var root$41 = enqueueUpdate(provider, fiber, lane);
        null !== root$41 &&
          (scheduleUpdateOnFiber(root$41, provider, lane),
          entangleTransitions(root$41, provider, lane));
        provider = { cache: createCache() };
        fiber.payload = provider;
        return;
    }
    provider = provider.return;
  }
}
function dispatchReducerAction(fiber, queue, action) {
  var lane = requestUpdateLane();
  action = {
    lane: lane,
    revertLane: 0,
    action: action,
    hasEagerState: false,
    eagerState: null,
    next: null
  };
  isRenderPhaseUpdate(fiber)
    ? enqueueRenderPhaseUpdate(queue, action)
    : ((action = enqueueConcurrentHookUpdate(fiber, queue, action, lane)),
      null !== action &&
        (scheduleUpdateOnFiber(action, fiber, lane),
        entangleTransitionUpdate(action, queue, lane)));
}
function dispatchSetState(fiber, queue, action) {
  var lane = requestUpdateLane();
  dispatchSetStateInternal(fiber, queue, action, lane);
}
function dispatchSetStateInternal(fiber, queue, action, lane) {
  var update = {
    lane: lane,
    revertLane: 0,
    action: action,
    hasEagerState: false,
    eagerState: null,
    next: null
  };
  if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
  else {
    var alternate = fiber.alternate;
    if (
      0 === fiber.lanes &&
      (null === alternate || 0 === alternate.lanes) &&
      ((alternate = queue.lastRenderedReducer), null !== alternate)
    )
      try {
        var currentState = queue.lastRenderedState,
          eagerState = alternate(currentState, action);
        update.hasEagerState = !0;
        update.eagerState = eagerState;
        if (objectIs(eagerState, currentState))
          return (
            enqueueUpdate$1(fiber, queue, update, 0),
            null === workInProgressRoot && finishQueueingConcurrentUpdates(),
            !1
          );
      } catch (error) {
      } finally {
      }
    action = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
    if (null !== action)
      return (
        scheduleUpdateOnFiber(action, fiber, lane),
        entangleTransitionUpdate(action, queue, lane),
        true
      );
  }
  return false;
}
function dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
  action = {
    lane: 2,
    revertLane: requestTransitionLane(),
    action: action,
    hasEagerState: false,
    eagerState: null,
    next: null
  };
  if (isRenderPhaseUpdate(fiber)) {
    if (throwIfDuringRender) throw Error(formatProdErrorMessage(479));
  } else
    (throwIfDuringRender = enqueueConcurrentHookUpdate(
      fiber,
      queue,
      action,
      2
    )),
      null !== throwIfDuringRender &&
        scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function isRenderPhaseUpdate(fiber) {
  var alternate = fiber.alternate;
  return (
    fiber === currentlyRenderingFiber ||
    (null !== alternate && alternate === currentlyRenderingFiber)
  );
}
function enqueueRenderPhaseUpdate(queue, update) {
  didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate =
    true;
  var pending = queue.pending;
  null === pending
    ? (update.next = update)
    : ((update.next = pending.next), (pending.next = update));
  queue.pending = update;
}
function entangleTransitionUpdate(root, queue, lane) {
  if (0 !== (lane & 4194048)) {
    var queueLanes = queue.lanes;
    queueLanes &= root.pendingLanes;
    lane |= queueLanes;
    queue.lanes = lane;
    markRootEntangled(root, lane);
  }
}
var ContextOnlyDispatcher = {
    readContext: readContext,
    use: use,
    useCallback: throwInvalidHookError,
    useContext: throwInvalidHookError,
    useEffect: throwInvalidHookError,
    useImperativeHandle: throwInvalidHookError,
    useLayoutEffect: throwInvalidHookError,
    useInsertionEffect: throwInvalidHookError,
    useMemo: throwInvalidHookError,
    useReducer: throwInvalidHookError,
    useRef: throwInvalidHookError,
    useState: throwInvalidHookError,
    useDebugValue: throwInvalidHookError,
    useDeferredValue: throwInvalidHookError,
    useTransition: throwInvalidHookError,
    useSyncExternalStore: throwInvalidHookError,
    useId: throwInvalidHookError,
    useHostTransitionStatus: throwInvalidHookError,
    useFormState: throwInvalidHookError,
    useActionState: throwInvalidHookError,
    useOptimistic: throwInvalidHookError,
    useMemoCache: throwInvalidHookError,
    useCacheRefresh: throwInvalidHookError
  },
  HooksDispatcherOnMount = {
    readContext: readContext,
    use: use,
    useCallback: function (callback, deps) {
      mountWorkInProgressHook().memoizedState = [
        callback,
        void 0 === deps ? null : deps
      ];
      return callback;
    },
    useContext: readContext,
    useEffect: mountEffect,
    useImperativeHandle: function (ref, create, deps) {
      deps = null !== deps && void 0 !== deps ? deps.concat([ref]) : null;
      mountEffectImpl(
        4194308,
        4,
        imperativeHandleEffect.bind(null, create, ref),
        deps
      );
    },
    useLayoutEffect: function (create, deps) {
      return mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function (create, deps) {
      mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function (nextCreate, deps) {
      var hook = mountWorkInProgressHook();
      deps = void 0 === deps ? null : deps;
      var nextValue = nextCreate();
      if (shouldDoubleInvokeUserFnsInHooksDEV) {
        setIsStrictModeForDevtools(true);
        try {
          nextCreate();
        } finally {
          setIsStrictModeForDevtools(false);
        }
      }
      hook.memoizedState = [nextValue, deps];
      return nextValue;
    },
    useReducer: function (reducer, initialArg, init) {
      var hook = mountWorkInProgressHook();
      if (void 0 !== init) {
        var initialState = init(initialArg);
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
          setIsStrictModeForDevtools(true);
          try {
            init(initialArg);
          } finally {
            setIsStrictModeForDevtools(false);
          }
        }
      } else initialState = initialArg;
      hook.memoizedState = hook.baseState = initialState;
      reducer = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: reducer,
        lastRenderedState: initialState
      };
      hook.queue = reducer;
      reducer = reducer.dispatch = dispatchReducerAction.bind(
        null,
        currentlyRenderingFiber,
        reducer
      );
      return [hook.memoizedState, reducer];
    },
    useRef: function (initialValue) {
      var hook = mountWorkInProgressHook();
      initialValue = { current: initialValue };
      return (hook.memoizedState = initialValue);
    },
    useState: function (initialState) {
      initialState = mountStateImpl(initialState);
      var queue = initialState.queue,
        dispatch = dispatchSetState.bind(null, currentlyRenderingFiber, queue);
      queue.dispatch = dispatch;
      return [initialState.memoizedState, dispatch];
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function (value, initialValue) {
      var hook = mountWorkInProgressHook();
      return mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function () {
      var stateHook = mountStateImpl(false);
      stateHook = startTransition.bind(
        null,
        currentlyRenderingFiber,
        stateHook.queue,
        true,
        false
      );
      mountWorkInProgressHook().memoizedState = stateHook;
      return [false, stateHook];
    },
    useSyncExternalStore: function (subscribe, getSnapshot, getServerSnapshot) {
      var fiber = currentlyRenderingFiber,
        hook = mountWorkInProgressHook();
      if (isHydrating) {
        if (void 0 === getServerSnapshot)
          throw Error(formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
      } else {
        getServerSnapshot = getSnapshot();
        if (null === workInProgressRoot)
          throw Error(formatProdErrorMessage(349));
        0 !== (workInProgressRootRenderLanes & 124) ||
          pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
      }
      hook.memoizedState = getServerSnapshot;
      var inst = { value: getServerSnapshot, getSnapshot: getSnapshot };
      hook.queue = inst;
      mountEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
        subscribe
      ]);
      fiber.flags |= 2048;
      pushSimpleEffect(
        9,
        createEffectInstance(),
        updateStoreInstance.bind(
          null,
          fiber,
          inst,
          getServerSnapshot,
          getSnapshot
        ),
        null
      );
      return getServerSnapshot;
    },
    useId: function () {
      var hook = mountWorkInProgressHook(),
        identifierPrefix = workInProgressRoot.identifierPrefix;
      if (isHydrating) {
        var JSCompiler_inline_result = treeContextOverflow;
        var idWithLeadingBit = treeContextId;
        JSCompiler_inline_result =
          (
            idWithLeadingBit & ~(1 << (32 - clz32(idWithLeadingBit) - 1))
          ).toString(32) + JSCompiler_inline_result;
        identifierPrefix =
          "\u00ab" + identifierPrefix + "R" + JSCompiler_inline_result;
        JSCompiler_inline_result = localIdCounter++;
        0 < JSCompiler_inline_result &&
          (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
        identifierPrefix += "\u00bb";
      } else
        (JSCompiler_inline_result = globalClientIdCounter++),
          (identifierPrefix =
            "\u00ab" +
            identifierPrefix +
            "r" +
            JSCompiler_inline_result.toString(32) +
            "\u00bb");
      return (hook.memoizedState = identifierPrefix);
    },
    useHostTransitionStatus: useHostTransitionStatus,
    useFormState: mountActionState,
    useActionState: mountActionState,
    useOptimistic: function (passthrough) {
      var hook = mountWorkInProgressHook();
      hook.memoizedState = hook.baseState = passthrough;
      var queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      hook.queue = queue;
      hook = dispatchOptimisticSetState.bind(
        null,
        currentlyRenderingFiber,
        true,
        queue
      );
      queue.dispatch = hook;
      return [passthrough, hook];
    },
    useMemoCache: useMemoCache,
    useCacheRefresh: function () {
      return (mountWorkInProgressHook().memoizedState = refreshCache.bind(
        null,
        currentlyRenderingFiber
      ));
    }
  },
  HooksDispatcherOnUpdate = {
    readContext: readContext,
    use: use,
    useCallback: updateCallback,
    useContext: readContext,
    useEffect: updateEffect,
    useImperativeHandle: updateImperativeHandle,
    useInsertionEffect: updateInsertionEffect,
    useLayoutEffect: updateLayoutEffect,
    useMemo: updateMemo,
    useReducer: updateReducer,
    useRef: updateRef,
    useState: function () {
      return updateReducer(basicStateReducer);
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function (value, initialValue) {
      var hook = updateWorkInProgressHook();
      return updateDeferredValueImpl(
        hook,
        currentHook.memoizedState,
        value,
        initialValue
      );
    },
    useTransition: function () {
      var booleanOrThenable = updateReducer(basicStateReducer)[0],
        start = updateWorkInProgressHook().memoizedState;
      return [
        "boolean" === typeof booleanOrThenable
          ? booleanOrThenable
          : useThenable(booleanOrThenable),
        start
      ];
    },
    useSyncExternalStore: updateSyncExternalStore,
    useId: updateId,
    useHostTransitionStatus: useHostTransitionStatus,
    useFormState: updateActionState,
    useActionState: updateActionState,
    useOptimistic: function (passthrough, reducer) {
      var hook = updateWorkInProgressHook();
      return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
    },
    useMemoCache: useMemoCache,
    useCacheRefresh: updateRefresh
  },
  HooksDispatcherOnRerender = {
    readContext: readContext,
    use: use,
    useCallback: updateCallback,
    useContext: readContext,
    useEffect: updateEffect,
    useImperativeHandle: updateImperativeHandle,
    useInsertionEffect: updateInsertionEffect,
    useLayoutEffect: updateLayoutEffect,
    useMemo: updateMemo,
    useReducer: rerenderReducer,
    useRef: updateRef,
    useState: function () {
      return rerenderReducer(basicStateReducer);
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function (value, initialValue) {
      var hook = updateWorkInProgressHook();
      return null === currentHook
        ? mountDeferredValueImpl(hook, value, initialValue)
        : updateDeferredValueImpl(
            hook,
            currentHook.memoizedState,
            value,
            initialValue
          );
    },
    useTransition: function () {
      var booleanOrThenable = rerenderReducer(basicStateReducer)[0],
        start = updateWorkInProgressHook().memoizedState;
      return [
        "boolean" === typeof booleanOrThenable
          ? booleanOrThenable
          : useThenable(booleanOrThenable),
        start
      ];
    },
    useSyncExternalStore: updateSyncExternalStore,
    useId: updateId,
    useHostTransitionStatus: useHostTransitionStatus,
    useFormState: rerenderActionState,
    useActionState: rerenderActionState,
    useOptimistic: function (passthrough, reducer) {
      var hook = updateWorkInProgressHook();
      if (null !== currentHook)
        return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
      hook.baseState = passthrough;
      return [passthrough, hook.queue.dispatch];
    },
    useMemoCache: useMemoCache,
    useCacheRefresh: updateRefresh
  },
  thenableState = null,
  thenableIndexCounter = 0;
function unwrapThenable(thenable) {
  var index = thenableIndexCounter;
  thenableIndexCounter += 1;
  null === thenableState && (thenableState = []);
  return trackUsedThenable(thenableState, thenable, index);
}
function coerceRef(workInProgress, element) {
  element = element.props.ref;
  workInProgress.ref = void 0 !== element ? element : null;
}
function throwOnInvalidObjectType(returnFiber, newChild) {
  if (newChild.$$typeof === REACT_LEGACY_ELEMENT_TYPE)
    throw Error(formatProdErrorMessage(525));
  returnFiber = Object.prototype.toString.call(newChild);
  throw Error(
    formatProdErrorMessage(
      31,
      "[object Object]" === returnFiber
        ? "object with keys {" + Object.keys(newChild).join(", ") + "}"
        : returnFiber
    )
  );
}
function resolveLazy(lazyType) {
  var init = lazyType._init;
  return init(lazyType._payload);
}
function createChildReconciler(shouldTrackSideEffects) {
  function deleteChild(returnFiber, childToDelete) {
    if (shouldTrackSideEffects) {
      var deletions = returnFiber.deletions;
      null === deletions
        ? ((returnFiber.deletions = [childToDelete]), (returnFiber.flags |= 16))
        : deletions.push(childToDelete);
    }
  }
  function deleteRemainingChildren(returnFiber, currentFirstChild) {
    if (!shouldTrackSideEffects) return null;
    for (; null !== currentFirstChild; )
      deleteChild(returnFiber, currentFirstChild),
        (currentFirstChild = currentFirstChild.sibling);
    return null;
  }
  function mapRemainingChildren(currentFirstChild) {
    for (var existingChildren = new Map(); null !== currentFirstChild; )
      null !== currentFirstChild.key
        ? existingChildren.set(currentFirstChild.key, currentFirstChild)
        : existingChildren.set(currentFirstChild.index, currentFirstChild),
        (currentFirstChild = currentFirstChild.sibling);
    return existingChildren;
  }
  function useFiber(fiber, pendingProps) {
    fiber = createWorkInProgress(fiber, pendingProps);
    fiber.index = 0;
    fiber.sibling = null;
    return fiber;
  }
  function placeChild(newFiber, lastPlacedIndex, newIndex) {
    newFiber.index = newIndex;
    if (!shouldTrackSideEffects)
      return (newFiber.flags |= 1048576), lastPlacedIndex;
    newIndex = newFiber.alternate;
    if (null !== newIndex)
      return (
        (newIndex = newIndex.index),
        newIndex < lastPlacedIndex
          ? ((newFiber.flags |= 67108866), lastPlacedIndex)
          : newIndex
      );
    newFiber.flags |= 67108866;
    return lastPlacedIndex;
  }
  function placeSingleChild(newFiber) {
    shouldTrackSideEffects &&
      null === newFiber.alternate &&
      (newFiber.flags |= 67108866);
    return newFiber;
  }
  function updateTextNode(returnFiber, current, textContent, lanes) {
    if (null === current || 6 !== current.tag)
      return (
        (current = createFiberFromText(textContent, returnFiber.mode, lanes)),
        (current.return = returnFiber),
        current
      );
    current = useFiber(current, textContent);
    current.return = returnFiber;
    return current;
  }
  function updateElement(returnFiber, current, element, lanes) {
    var elementType = element.type;
    if (elementType === REACT_FRAGMENT_TYPE)
      return updateFragment(
        returnFiber,
        current,
        element.props.children,
        lanes,
        element.key
      );
    if (
      null !== current &&
      (current.elementType === elementType ||
        ("object" === typeof elementType &&
          null !== elementType &&
          elementType.$$typeof === REACT_LAZY_TYPE &&
          resolveLazy(elementType) === current.type))
    )
      return (
        (current = useFiber(current, element.props)),
        coerceRef(current, element),
        (current.return = returnFiber),
        current
      );
    current = createFiberFromTypeAndProps(
      element.type,
      element.key,
      element.props,
      null,
      returnFiber.mode,
      lanes
    );
    coerceRef(current, element);
    current.return = returnFiber;
    return current;
  }
  function updatePortal(returnFiber, current, portal, lanes) {
    if (
      null === current ||
      4 !== current.tag ||
      current.stateNode.containerInfo !== portal.containerInfo ||
      current.stateNode.implementation !== portal.implementation
    )
      return (
        (current = createFiberFromPortal(portal, returnFiber.mode, lanes)),
        (current.return = returnFiber),
        current
      );
    current = useFiber(current, portal.children || []);
    current.return = returnFiber;
    return current;
  }
  function updateFragment(returnFiber, current, fragment, lanes, key) {
    if (null === current || 7 !== current.tag)
      return (
        (current = createFiberFromFragment(
          fragment,
          returnFiber.mode,
          lanes,
          key
        )),
        (current.return = returnFiber),
        current
      );
    current = useFiber(current, fragment);
    current.return = returnFiber;
    return current;
  }
  function createChild(returnFiber, newChild, lanes) {
    if (
      ("string" === typeof newChild && "" !== newChild) ||
      "number" === typeof newChild ||
      "bigint" === typeof newChild
    )
      return (
        (newChild = createFiberFromText(
          "" + newChild,
          returnFiber.mode,
          lanes
        )),
        (newChild.return = returnFiber),
        newChild
      );
    if ("object" === typeof newChild && null !== newChild) {
      switch (newChild.$$typeof) {
        case REACT_ELEMENT_TYPE:
          return (
            (lanes = createFiberFromTypeAndProps(
              newChild.type,
              newChild.key,
              newChild.props,
              null,
              returnFiber.mode,
              lanes
            )),
            coerceRef(lanes, newChild),
            (lanes.return = returnFiber),
            lanes
          );
        case REACT_PORTAL_TYPE:
          return (
            (newChild = createFiberFromPortal(
              newChild,
              returnFiber.mode,
              lanes
            )),
            (newChild.return = returnFiber),
            newChild
          );
        case REACT_LAZY_TYPE:
          var init = newChild._init;
          newChild = init(newChild._payload);
          return createChild(returnFiber, newChild, lanes);
      }
      if (isArrayImpl(newChild) || getIteratorFn(newChild))
        return (
          (newChild = createFiberFromFragment(
            newChild,
            returnFiber.mode,
            lanes,
            null
          )),
          (newChild.return = returnFiber),
          newChild
        );
      if ("function" === typeof newChild.then)
        return createChild(returnFiber, unwrapThenable(newChild), lanes);
      if (newChild.$$typeof === REACT_CONTEXT_TYPE)
        return createChild(
          returnFiber,
          readContextDuringReconciliation(returnFiber, newChild),
          lanes
        );
      throwOnInvalidObjectType(returnFiber, newChild);
    }
    return null;
  }
  function updateSlot(returnFiber, oldFiber, newChild, lanes) {
    var key = null !== oldFiber ? oldFiber.key : null;
    if (
      ("string" === typeof newChild && "" !== newChild) ||
      "number" === typeof newChild ||
      "bigint" === typeof newChild
    )
      return null !== key
        ? null
        : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
    if ("object" === typeof newChild && null !== newChild) {
      switch (newChild.$$typeof) {
        case REACT_ELEMENT_TYPE:
          return newChild.key === key
            ? updateElement(returnFiber, oldFiber, newChild, lanes)
            : null;
        case REACT_PORTAL_TYPE:
          return newChild.key === key
            ? updatePortal(returnFiber, oldFiber, newChild, lanes)
            : null;
        case REACT_LAZY_TYPE:
          return (
            (key = newChild._init),
            (newChild = key(newChild._payload)),
            updateSlot(returnFiber, oldFiber, newChild, lanes)
          );
      }
      if (isArrayImpl(newChild) || getIteratorFn(newChild))
        return null !== key
          ? null
          : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
      if ("function" === typeof newChild.then)
        return updateSlot(
          returnFiber,
          oldFiber,
          unwrapThenable(newChild),
          lanes
        );
      if (newChild.$$typeof === REACT_CONTEXT_TYPE)
        return updateSlot(
          returnFiber,
          oldFiber,
          readContextDuringReconciliation(returnFiber, newChild),
          lanes
        );
      throwOnInvalidObjectType(returnFiber, newChild);
    }
    return null;
  }
  function updateFromMap(
    existingChildren,
    returnFiber,
    newIdx,
    newChild,
    lanes
  ) {
    if (
      ("string" === typeof newChild && "" !== newChild) ||
      "number" === typeof newChild ||
      "bigint" === typeof newChild
    )
      return (
        (existingChildren = existingChildren.get(newIdx) || null),
        updateTextNode(returnFiber, existingChildren, "" + newChild, lanes)
      );
    if ("object" === typeof newChild && null !== newChild) {
      switch (newChild.$$typeof) {
        case REACT_ELEMENT_TYPE:
          return (
            (existingChildren =
              existingChildren.get(
                null === newChild.key ? newIdx : newChild.key
              ) || null),
            updateElement(returnFiber, existingChildren, newChild, lanes)
          );
        case REACT_PORTAL_TYPE:
          return (
            (existingChildren =
              existingChildren.get(
                null === newChild.key ? newIdx : newChild.key
              ) || null),
            updatePortal(returnFiber, existingChildren, newChild, lanes)
          );
        case REACT_LAZY_TYPE:
          var init = newChild._init;
          newChild = init(newChild._payload);
          return updateFromMap(
            existingChildren,
            returnFiber,
            newIdx,
            newChild,
            lanes
          );
      }
      if (isArrayImpl(newChild) || getIteratorFn(newChild))
        return (
          (existingChildren = existingChildren.get(newIdx) || null),
          updateFragment(returnFiber, existingChildren, newChild, lanes, null)
        );
      if ("function" === typeof newChild.then)
        return updateFromMap(
          existingChildren,
          returnFiber,
          newIdx,
          unwrapThenable(newChild),
          lanes
        );
      if (newChild.$$typeof === REACT_CONTEXT_TYPE)
        return updateFromMap(
          existingChildren,
          returnFiber,
          newIdx,
          readContextDuringReconciliation(returnFiber, newChild),
          lanes
        );
      throwOnInvalidObjectType(returnFiber, newChild);
    }
    return null;
  }
  function reconcileChildrenArray(
    returnFiber,
    currentFirstChild,
    newChildren,
    lanes
  ) {
    for (
      var resultingFirstChild = null,
        previousNewFiber = null,
        oldFiber = currentFirstChild,
        newIdx = (currentFirstChild = 0),
        nextOldFiber = null;
      null !== oldFiber && newIdx < newChildren.length;
      newIdx++
    ) {
      oldFiber.index > newIdx
        ? ((nextOldFiber = oldFiber), (oldFiber = null))
        : (nextOldFiber = oldFiber.sibling);
      var newFiber = updateSlot(
        returnFiber,
        oldFiber,
        newChildren[newIdx],
        lanes
      );
      if (null === newFiber) {
        null === oldFiber && (oldFiber = nextOldFiber);
        break;
      }
      shouldTrackSideEffects &&
        oldFiber &&
        null === newFiber.alternate &&
        deleteChild(returnFiber, oldFiber);
      currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
      null === previousNewFiber
        ? (resultingFirstChild = newFiber)
        : (previousNewFiber.sibling = newFiber);
      previousNewFiber = newFiber;
      oldFiber = nextOldFiber;
    }
    if (newIdx === newChildren.length)
      return (
        deleteRemainingChildren(returnFiber, oldFiber),
        isHydrating && pushTreeFork(returnFiber, newIdx),
        resultingFirstChild
      );
    if (null === oldFiber) {
      for (; newIdx < newChildren.length; newIdx++)
        (oldFiber = createChild(returnFiber, newChildren[newIdx], lanes)),
          null !== oldFiber &&
            ((currentFirstChild = placeChild(
              oldFiber,
              currentFirstChild,
              newIdx
            )),
            null === previousNewFiber
              ? (resultingFirstChild = oldFiber)
              : (previousNewFiber.sibling = oldFiber),
            (previousNewFiber = oldFiber));
      isHydrating && pushTreeFork(returnFiber, newIdx);
      return resultingFirstChild;
    }
    for (
      oldFiber = mapRemainingChildren(oldFiber);
      newIdx < newChildren.length;
      newIdx++
    )
      (nextOldFiber = updateFromMap(
        oldFiber,
        returnFiber,
        newIdx,
        newChildren[newIdx],
        lanes
      )),
        null !== nextOldFiber &&
          (shouldTrackSideEffects &&
            null !== nextOldFiber.alternate &&
            oldFiber.delete(
              null === nextOldFiber.key ? newIdx : nextOldFiber.key
            ),
          (currentFirstChild = placeChild(
            nextOldFiber,
            currentFirstChild,
            newIdx
          )),
          null === previousNewFiber
            ? (resultingFirstChild = nextOldFiber)
            : (previousNewFiber.sibling = nextOldFiber),
          (previousNewFiber = nextOldFiber));
    shouldTrackSideEffects &&
      oldFiber.forEach(function (child) {
        return deleteChild(returnFiber, child);
      });
    isHydrating && pushTreeFork(returnFiber, newIdx);
    return resultingFirstChild;
  }
  function reconcileChildrenIterator(
    returnFiber,
    currentFirstChild,
    newChildren,
    lanes
  ) {
    if (null == newChildren) throw Error(formatProdErrorMessage(151));
    for (
      var resultingFirstChild = null,
        previousNewFiber = null,
        oldFiber = currentFirstChild,
        newIdx = (currentFirstChild = 0),
        nextOldFiber = null,
        step = newChildren.next();
      null !== oldFiber && !step.done;
      newIdx++, step = newChildren.next()
    ) {
      oldFiber.index > newIdx
        ? ((nextOldFiber = oldFiber), (oldFiber = null))
        : (nextOldFiber = oldFiber.sibling);
      var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
      if (null === newFiber) {
        null === oldFiber && (oldFiber = nextOldFiber);
        break;
      }
      shouldTrackSideEffects &&
        oldFiber &&
        null === newFiber.alternate &&
        deleteChild(returnFiber, oldFiber);
      currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
      null === previousNewFiber
        ? (resultingFirstChild = newFiber)
        : (previousNewFiber.sibling = newFiber);
      previousNewFiber = newFiber;
      oldFiber = nextOldFiber;
    }
    if (step.done)
      return (
        deleteRemainingChildren(returnFiber, oldFiber),
        isHydrating && pushTreeFork(returnFiber, newIdx),
        resultingFirstChild
      );
    if (null === oldFiber) {
      for (; !step.done; newIdx++, step = newChildren.next())
        (step = createChild(returnFiber, step.value, lanes)),
          null !== step &&
            ((currentFirstChild = placeChild(step, currentFirstChild, newIdx)),
            null === previousNewFiber
              ? (resultingFirstChild = step)
              : (previousNewFiber.sibling = step),
            (previousNewFiber = step));
      isHydrating && pushTreeFork(returnFiber, newIdx);
      return resultingFirstChild;
    }
    for (
      oldFiber = mapRemainingChildren(oldFiber);
      !step.done;
      newIdx++, step = newChildren.next()
    )
      (step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes)),
        null !== step &&
          (shouldTrackSideEffects &&
            null !== step.alternate &&
            oldFiber.delete(null === step.key ? newIdx : step.key),
          (currentFirstChild = placeChild(step, currentFirstChild, newIdx)),
          null === previousNewFiber
            ? (resultingFirstChild = step)
            : (previousNewFiber.sibling = step),
          (previousNewFiber = step));
    shouldTrackSideEffects &&
      oldFiber.forEach(function (child) {
        return deleteChild(returnFiber, child);
      });
    isHydrating && pushTreeFork(returnFiber, newIdx);
    return resultingFirstChild;
  }
  function reconcileChildFibersImpl(
    returnFiber,
    currentFirstChild,
    newChild,
    lanes
  ) {
    "object" === typeof newChild &&
      null !== newChild &&
      newChild.type === REACT_FRAGMENT_TYPE &&
      null === newChild.key &&
      (newChild = newChild.props.children);
    if ("object" === typeof newChild && null !== newChild) {
      switch (newChild.$$typeof) {
        case REACT_ELEMENT_TYPE:
          a: {
            for (var key = newChild.key; null !== currentFirstChild; ) {
              if (currentFirstChild.key === key) {
                key = newChild.type;
                if (key === REACT_FRAGMENT_TYPE) {
                  if (7 === currentFirstChild.tag) {
                    deleteRemainingChildren(
                      returnFiber,
                      currentFirstChild.sibling
                    );
                    lanes = useFiber(
                      currentFirstChild,
                      newChild.props.children
                    );
                    lanes.return = returnFiber;
                    returnFiber = lanes;
                    break a;
                  }
                } else if (
                  currentFirstChild.elementType === key ||
                  ("object" === typeof key &&
                    null !== key &&
                    key.$$typeof === REACT_LAZY_TYPE &&
                    resolveLazy(key) === currentFirstChild.type)
                ) {
                  deleteRemainingChildren(
                    returnFiber,
                    currentFirstChild.sibling
                  );
                  lanes = useFiber(currentFirstChild, newChild.props);
                  coerceRef(lanes, newChild);
                  lanes.return = returnFiber;
                  returnFiber = lanes;
                  break a;
                }
                deleteRemainingChildren(returnFiber, currentFirstChild);
                break;
              } else deleteChild(returnFiber, currentFirstChild);
              currentFirstChild = currentFirstChild.sibling;
            }
            newChild.type === REACT_FRAGMENT_TYPE
              ? ((lanes = createFiberFromFragment(
                  newChild.props.children,
                  returnFiber.mode,
                  lanes,
                  newChild.key
                )),
                (lanes.return = returnFiber),
                (returnFiber = lanes))
              : ((lanes = createFiberFromTypeAndProps(
                  newChild.type,
                  newChild.key,
                  newChild.props,
                  null,
                  returnFiber.mode,
                  lanes
                )),
                coerceRef(lanes, newChild),
                (lanes.return = returnFiber),
                (returnFiber = lanes));
          }
          return placeSingleChild(returnFiber);
        case REACT_PORTAL_TYPE:
          a: {
            for (key = newChild.key; null !== currentFirstChild; ) {
              if (currentFirstChild.key === key)
                if (
                  4 === currentFirstChild.tag &&
                  currentFirstChild.stateNode.containerInfo ===
                    newChild.containerInfo &&
                  currentFirstChild.stateNode.implementation ===
                    newChild.implementation
                ) {
                  deleteRemainingChildren(
                    returnFiber,
                    currentFirstChild.sibling
                  );
                  lanes = useFiber(currentFirstChild, newChild.children || []);
                  lanes.return = returnFiber;
                  returnFiber = lanes;
                  break a;
                } else {
                  deleteRemainingChildren(returnFiber, currentFirstChild);
                  break;
                }
              else deleteChild(returnFiber, currentFirstChild);
              currentFirstChild = currentFirstChild.sibling;
            }
            lanes = createFiberFromPortal(newChild, returnFiber.mode, lanes);
            lanes.return = returnFiber;
            returnFiber = lanes;
          }
          return placeSingleChild(returnFiber);
        case REACT_LAZY_TYPE:
          return (
            (key = newChild._init),
            (newChild = key(newChild._payload)),
            reconcileChildFibersImpl(
              returnFiber,
              currentFirstChild,
              newChild,
              lanes
            )
          );
      }
      if (isArrayImpl(newChild))
        return reconcileChildrenArray(
          returnFiber,
          currentFirstChild,
          newChild,
          lanes
        );
      if (getIteratorFn(newChild)) {
        key = getIteratorFn(newChild);
        if ("function" !== typeof key) throw Error(formatProdErrorMessage(150));
        newChild = key.call(newChild);
        return reconcileChildrenIterator(
          returnFiber,
          currentFirstChild,
          newChild,
          lanes
        );
      }
      if ("function" === typeof newChild.then)
        return reconcileChildFibersImpl(
          returnFiber,
          currentFirstChild,
          unwrapThenable(newChild),
          lanes
        );
      if (newChild.$$typeof === REACT_CONTEXT_TYPE)
        return reconcileChildFibersImpl(
          returnFiber,
          currentFirstChild,
          readContextDuringReconciliation(returnFiber, newChild),
          lanes
        );
      throwOnInvalidObjectType(returnFiber, newChild);
    }
    return ("string" === typeof newChild && "" !== newChild) ||
      "number" === typeof newChild ||
      "bigint" === typeof newChild
      ? ((newChild = "" + newChild),
        null !== currentFirstChild && 6 === currentFirstChild.tag
          ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling),
            (lanes = useFiber(currentFirstChild, newChild)),
            (lanes.return = returnFiber),
            (returnFiber = lanes))
          : (deleteRemainingChildren(returnFiber, currentFirstChild),
            (lanes = createFiberFromText(newChild, returnFiber.mode, lanes)),
            (lanes.return = returnFiber),
            (returnFiber = lanes)),
        placeSingleChild(returnFiber))
      : deleteRemainingChildren(returnFiber, currentFirstChild);
  }
  return function (returnFiber, currentFirstChild, newChild, lanes) {
    try {
      thenableIndexCounter = 0;
      var firstChildFiber = reconcileChildFibersImpl(
        returnFiber,
        currentFirstChild,
        newChild,
        lanes
      );
      thenableState = null;
      return firstChildFiber;
    } catch (x) {
      if (x === SuspenseException || x === SuspenseActionException) throw x;
      var fiber = createFiberImplClass(29, x, null, returnFiber.mode);
      fiber.lanes = lanes;
      fiber.return = returnFiber;
      return fiber;
    } finally {
    }
  };
}
var reconcileChildFibers = createChildReconciler(true),
  mountChildFibers = createChildReconciler(false),
  suspenseHandlerStackCursor = createCursor(null),
  shellBoundary = null;
function pushPrimaryTreeSuspenseHandler(handler) {
  var current = handler.alternate;
  push(suspenseStackCursor, suspenseStackCursor.current & 1);
  push(suspenseHandlerStackCursor, handler);
  null === shellBoundary &&
    (null === current || null !== currentTreeHiddenStackCursor.current
      ? (shellBoundary = handler)
      : null !== current.memoizedState && (shellBoundary = handler));
}
function pushOffscreenSuspenseHandler(fiber) {
  if (22 === fiber.tag) {
    if (
      (push(suspenseStackCursor, suspenseStackCursor.current),
      push(suspenseHandlerStackCursor, fiber),
      null === shellBoundary)
    ) {
      var current = fiber.alternate;
      null !== current &&
        null !== current.memoizedState &&
        (shellBoundary = fiber);
    }
  } else reuseSuspenseHandlerOnStack();
}
function reuseSuspenseHandlerOnStack() {
  push(suspenseStackCursor, suspenseStackCursor.current);
  push(suspenseHandlerStackCursor, suspenseHandlerStackCursor.current);
}
function popSuspenseHandler(fiber) {
  pop(suspenseHandlerStackCursor);
  shellBoundary === fiber && (shellBoundary = null);
  pop(suspenseStackCursor);
}
var suspenseStackCursor = createCursor(0);
function findFirstSuspended(row) {
  for (var node = row; null !== node; ) {
    if (13 === node.tag) {
      var state = node.memoizedState;
      if (
        null !== state &&
        ((state = state.dehydrated),
        null === state ||
          "$?" === state.data ||
          isSuspenseInstanceFallback(state))
      )
        return node;
    } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
      if (0 !== (node.flags & 128)) return node;
    } else if (null !== node.child) {
      node.child.return = node;
      node = node.child;
      continue;
    }
    if (node === row) break;
    for (; null === node.sibling; ) {
      if (null === node.return || node.return === row) return null;
      node = node.return;
    }
    node.sibling.return = node.return;
    node = node.sibling;
  }
  return null;
}
function applyDerivedStateFromProps(
  workInProgress,
  ctor,
  getDerivedStateFromProps,
  nextProps
) {
  ctor = workInProgress.memoizedState;
  getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
  getDerivedStateFromProps =
    null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps
      ? ctor
      : assign({}, ctor, getDerivedStateFromProps);
  workInProgress.memoizedState = getDerivedStateFromProps;
  0 === workInProgress.lanes &&
    (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var classComponentUpdater = {
  enqueueSetState: function (inst, payload, callback) {
    inst = inst._reactInternals;
    var lane = requestUpdateLane(),
      update = createUpdate(lane);
    update.payload = payload;
    void 0 !== callback && null !== callback && (update.callback = callback);
    payload = enqueueUpdate(inst, update, lane);
    null !== payload &&
      (scheduleUpdateOnFiber(payload, inst, lane),
      entangleTransitions(payload, inst, lane));
  },
  enqueueReplaceState: function (inst, payload, callback) {
    inst = inst._reactInternals;
    var lane = requestUpdateLane(),
      update = createUpdate(lane);
    update.tag = 1;
    update.payload = payload;
    void 0 !== callback && null !== callback && (update.callback = callback);
    payload = enqueueUpdate(inst, update, lane);
    null !== payload &&
      (scheduleUpdateOnFiber(payload, inst, lane),
      entangleTransitions(payload, inst, lane));
  },
  enqueueForceUpdate: function (inst, callback) {
    inst = inst._reactInternals;
    var lane = requestUpdateLane(),
      update = createUpdate(lane);
    update.tag = 2;
    void 0 !== callback && null !== callback && (update.callback = callback);
    callback = enqueueUpdate(inst, update, lane);
    null !== callback &&
      (scheduleUpdateOnFiber(callback, inst, lane),
      entangleTransitions(callback, inst, lane));
  }
};
function checkShouldComponentUpdate(
  workInProgress,
  ctor,
  oldProps,
  newProps,
  oldState,
  newState,
  nextContext
) {
  workInProgress = workInProgress.stateNode;
  return "function" === typeof workInProgress.shouldComponentUpdate
    ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext)
    : ctor.prototype && ctor.prototype.isPureReactComponent
      ? !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState)
      : true;
}
function callComponentWillReceiveProps(
  workInProgress,
  instance,
  newProps,
  nextContext
) {
  workInProgress = instance.state;
  "function" === typeof instance.componentWillReceiveProps &&
    instance.componentWillReceiveProps(newProps, nextContext);
  "function" === typeof instance.UNSAFE_componentWillReceiveProps &&
    instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
  instance.state !== workInProgress &&
    classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function resolveClassComponentProps(Component, baseProps) {
  var newProps = baseProps;
  if ("ref" in baseProps) {
    newProps = {};
    for (var propName in baseProps)
      "ref" !== propName && (newProps[propName] = baseProps[propName]);
  }
  if ((Component = Component.defaultProps)) {
    newProps === baseProps && (newProps = assign({}, newProps));
    for (var propName$73 in Component)
      void 0 === newProps[propName$73] &&
        (newProps[propName$73] = Component[propName$73]);
  }
  return newProps;
}
var reportGlobalError =
  "function" === typeof reportError
    ? reportError
    : function (error) {
        if (
          "object" === typeof window &&
          "function" === typeof window.ErrorEvent
        ) {
          var event = new window.ErrorEvent("error", {
            bubbles: true,
            cancelable: true,
            message:
              "object" === typeof error &&
              null !== error &&
              "string" === typeof error.message
                ? String(error.message)
                : String(error),
            error: error
          });
          if (!window.dispatchEvent(event)) return;
        } else if (
          "object" === typeof process &&
          "function" === typeof process.emit
        ) {
          process.emit("uncaughtException", error);
          return;
        }
        console.error(error);
      };
function defaultOnUncaughtError(error) {
  reportGlobalError(error);
}
function defaultOnCaughtError(error) {
  console.error(error);
}
function defaultOnRecoverableError(error) {
  reportGlobalError(error);
}
function logUncaughtError(root, errorInfo) {
  try {
    var onUncaughtError = root.onUncaughtError;
    onUncaughtError(errorInfo.value, { componentStack: errorInfo.stack });
  } catch (e$74) {
    setTimeout(function () {
      throw e$74;
    });
  }
}
function logCaughtError(root, boundary, errorInfo) {
  try {
    var onCaughtError = root.onCaughtError;
    onCaughtError(errorInfo.value, {
      componentStack: errorInfo.stack,
      errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
    });
  } catch (e$75) {
    setTimeout(function () {
      throw e$75;
    });
  }
}
function createRootErrorUpdate(root, errorInfo, lane) {
  lane = createUpdate(lane);
  lane.tag = 3;
  lane.payload = { element: null };
  lane.callback = function () {
    logUncaughtError(root, errorInfo);
  };
  return lane;
}
function createClassErrorUpdate(lane) {
  lane = createUpdate(lane);
  lane.tag = 3;
  return lane;
}
function initializeClassErrorUpdate(update, root, fiber, errorInfo) {
  var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
  if ("function" === typeof getDerivedStateFromError) {
    var error = errorInfo.value;
    update.payload = function () {
      return getDerivedStateFromError(error);
    };
    update.callback = function () {
      logCaughtError(root, fiber, errorInfo);
    };
  }
  var inst = fiber.stateNode;
  null !== inst &&
    "function" === typeof inst.componentDidCatch &&
    (update.callback = function () {
      logCaughtError(root, fiber, errorInfo);
      "function" !== typeof getDerivedStateFromError &&
        (null === legacyErrorBoundariesThatAlreadyFailed
          ? (legacyErrorBoundariesThatAlreadyFailed = new Set([this]))
          : legacyErrorBoundariesThatAlreadyFailed.add(this));
      var stack = errorInfo.stack;
      this.componentDidCatch(errorInfo.value, {
        componentStack: null !== stack ? stack : ""
      });
    });
}
function throwException(
  root,
  returnFiber,
  sourceFiber,
  value,
  rootRenderLanes
) {
  sourceFiber.flags |= 32768;
  if (
    null !== value &&
    "object" === typeof value &&
    "function" === typeof value.then
  ) {
    returnFiber = sourceFiber.alternate;
    null !== returnFiber &&
      propagateParentContextChanges(
        returnFiber,
        sourceFiber,
        rootRenderLanes,
        true
      );
    sourceFiber = suspenseHandlerStackCursor.current;
    if (null !== sourceFiber) {
      switch (sourceFiber.tag) {
        case 13:
          return (
            null === shellBoundary
              ? renderDidSuspendDelayIfPossible()
              : null === sourceFiber.alternate &&
                0 === workInProgressRootExitStatus &&
                (workInProgressRootExitStatus = 3),
            (sourceFiber.flags &= -257),
            (sourceFiber.flags |= 65536),
            (sourceFiber.lanes = rootRenderLanes),
            value === noopSuspenseyCommitThenable
              ? (sourceFiber.flags |= 16384)
              : ((returnFiber = sourceFiber.updateQueue),
                null === returnFiber
                  ? (sourceFiber.updateQueue = new Set([value]))
                  : returnFiber.add(value),
                attachPingListener(root, value, rootRenderLanes)),
            false
          );
        case 22:
          return (
            (sourceFiber.flags |= 65536),
            value === noopSuspenseyCommitThenable
              ? (sourceFiber.flags |= 16384)
              : ((returnFiber = sourceFiber.updateQueue),
                null === returnFiber
                  ? ((returnFiber = {
                      transitions: null,
                      markerInstances: null,
                      retryQueue: new Set([value])
                    }),
                    (sourceFiber.updateQueue = returnFiber))
                  : ((sourceFiber = returnFiber.retryQueue),
                    null === sourceFiber
                      ? (returnFiber.retryQueue = new Set([value]))
                      : sourceFiber.add(value)),
                attachPingListener(root, value, rootRenderLanes)),
            false
          );
      }
      throw Error(formatProdErrorMessage(435, sourceFiber.tag));
    }
    attachPingListener(root, value, rootRenderLanes);
    renderDidSuspendDelayIfPossible();
    return false;
  }
  if (isHydrating)
    return (
      (returnFiber = suspenseHandlerStackCursor.current),
      null !== returnFiber
        ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256),
          (returnFiber.flags |= 65536),
          (returnFiber.lanes = rootRenderLanes),
          value !== HydrationMismatchException &&
            ((root = Error(formatProdErrorMessage(422), { cause: value })),
            queueHydrationError(createCapturedValueAtFiber(root, sourceFiber))))
        : (value !== HydrationMismatchException &&
            ((returnFiber = Error(formatProdErrorMessage(423), {
              cause: value
            })),
            queueHydrationError(
              createCapturedValueAtFiber(returnFiber, sourceFiber)
            )),
          (root = root.current.alternate),
          (root.flags |= 65536),
          (rootRenderLanes &= -rootRenderLanes),
          (root.lanes |= rootRenderLanes),
          (value = createCapturedValueAtFiber(value, sourceFiber)),
          (rootRenderLanes = createRootErrorUpdate(
            root.stateNode,
            value,
            rootRenderLanes
          )),
          enqueueCapturedUpdate(root, rootRenderLanes),
          4 !== workInProgressRootExitStatus &&
            (workInProgressRootExitStatus = 2)),
      false
    );
  var wrapperError = Error(formatProdErrorMessage(520), { cause: value });
  wrapperError = createCapturedValueAtFiber(wrapperError, sourceFiber);
  null === workInProgressRootConcurrentErrors
    ? (workInProgressRootConcurrentErrors = [wrapperError])
    : workInProgressRootConcurrentErrors.push(wrapperError);
  4 !== workInProgressRootExitStatus && (workInProgressRootExitStatus = 2);
  if (null === returnFiber) return true;
  value = createCapturedValueAtFiber(value, sourceFiber);
  sourceFiber = returnFiber;
  do {
    switch (sourceFiber.tag) {
      case 3:
        return (
          (sourceFiber.flags |= 65536),
          (root = rootRenderLanes & -rootRenderLanes),
          (sourceFiber.lanes |= root),
          (root = createRootErrorUpdate(sourceFiber.stateNode, value, root)),
          enqueueCapturedUpdate(sourceFiber, root),
          false
        );
      case 1:
        if (
          ((returnFiber = sourceFiber.type),
          (wrapperError = sourceFiber.stateNode),
          0 === (sourceFiber.flags & 128) &&
            ("function" === typeof returnFiber.getDerivedStateFromError ||
              (null !== wrapperError &&
                "function" === typeof wrapperError.componentDidCatch &&
                (null === legacyErrorBoundariesThatAlreadyFailed ||
                  !legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))))
        )
          return (
            (sourceFiber.flags |= 65536),
            (rootRenderLanes &= -rootRenderLanes),
            (sourceFiber.lanes |= rootRenderLanes),
            (rootRenderLanes = createClassErrorUpdate(rootRenderLanes)),
            initializeClassErrorUpdate(
              rootRenderLanes,
              root,
              sourceFiber,
              value
            ),
            enqueueCapturedUpdate(sourceFiber, rootRenderLanes),
            false
          );
    }
    sourceFiber = sourceFiber.return;
  } while (null !== sourceFiber);
  return false;
}
var SelectiveHydrationException = Error(formatProdErrorMessage(461)),
  didReceiveUpdate = false;
function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
  workInProgress.child =
    null === current
      ? mountChildFibers(workInProgress, null, nextChildren, renderLanes)
      : reconcileChildFibers(
          workInProgress,
          current.child,
          nextChildren,
          renderLanes
        );
}
function updateForwardRef(
  current,
  workInProgress,
  Component,
  nextProps,
  renderLanes
) {
  Component = Component.render;
  var ref = workInProgress.ref;
  if ("ref" in nextProps) {
    var propsWithoutRef = {};
    for (var key in nextProps)
      "ref" !== key && (propsWithoutRef[key] = nextProps[key]);
  } else propsWithoutRef = nextProps;
  prepareToReadContext(workInProgress);
  nextProps = renderWithHooks(
    current,
    workInProgress,
    Component,
    propsWithoutRef,
    ref,
    renderLanes
  );
  key = checkDidRenderIdHook();
  if (null !== current && !didReceiveUpdate)
    return (
      bailoutHooks(current, workInProgress, renderLanes),
      bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes)
    );
  isHydrating && key && pushMaterializedTreeId(workInProgress);
  workInProgress.flags |= 1;
  reconcileChildren(current, workInProgress, nextProps, renderLanes);
  return workInProgress.child;
}
function updateMemoComponent(
  current,
  workInProgress,
  Component,
  nextProps,
  renderLanes
) {
  if (null === current) {
    var type = Component.type;
    if (
      "function" === typeof type &&
      !shouldConstruct(type) &&
      void 0 === type.defaultProps &&
      null === Component.compare
    )
      return (
        (workInProgress.tag = 15),
        (workInProgress.type = type),
        updateSimpleMemoComponent(
          current,
          workInProgress,
          type,
          nextProps,
          renderLanes
        )
      );
    current = createFiberFromTypeAndProps(
      Component.type,
      null,
      nextProps,
      workInProgress,
      workInProgress.mode,
      renderLanes
    );
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return (workInProgress.child = current);
  }
  type = current.child;
  if (!checkScheduledUpdateOrContext(current, renderLanes)) {
    var prevProps = type.memoizedProps;
    Component = Component.compare;
    Component = null !== Component ? Component : shallowEqual;
    if (Component(prevProps, nextProps) && current.ref === workInProgress.ref)
      return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
  }
  workInProgress.flags |= 1;
  current = createWorkInProgress(type, nextProps);
  current.ref = workInProgress.ref;
  current.return = workInProgress;
  return (workInProgress.child = current);
}
function updateSimpleMemoComponent(
  current,
  workInProgress,
  Component,
  nextProps,
  renderLanes
) {
  if (null !== current) {
    var prevProps = current.memoizedProps;
    if (
      shallowEqual(prevProps, nextProps) &&
      current.ref === workInProgress.ref
    )
      if (
        ((didReceiveUpdate = false),
        (workInProgress.pendingProps = nextProps = prevProps),
        checkScheduledUpdateOrContext(current, renderLanes))
      )
        0 !== (current.flags & 131072) && (didReceiveUpdate = true);
      else
        return (
          (workInProgress.lanes = current.lanes),
          bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes)
        );
  }
  return updateFunctionComponent(
    current,
    workInProgress,
    Component,
    nextProps,
    renderLanes
  );
}
function updateOffscreenComponent(current, workInProgress, renderLanes) {
  var nextProps = workInProgress.pendingProps,
    nextChildren = nextProps.children,
    prevState = null !== current ? current.memoizedState : null;
  if ("hidden" === nextProps.mode) {
    if (0 !== (workInProgress.flags & 128)) {
      nextProps =
        null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
      if (null !== current) {
        nextChildren = workInProgress.child = current.child;
        for (prevState = 0; null !== nextChildren; )
          (prevState =
            prevState | nextChildren.lanes | nextChildren.childLanes),
            (nextChildren = nextChildren.sibling);
        workInProgress.childLanes = prevState & ~nextProps;
      } else (workInProgress.childLanes = 0), (workInProgress.child = null);
      return deferHiddenOffscreenComponent(
        current,
        workInProgress,
        nextProps,
        renderLanes
      );
    }
    if (0 !== (renderLanes & 536870912))
      (workInProgress.memoizedState = { baseLanes: 0, cachePool: null }),
        null !== current &&
          pushTransition(
            workInProgress,
            null !== prevState ? prevState.cachePool : null
          ),
        null !== prevState
          ? pushHiddenContext(workInProgress, prevState)
          : reuseHiddenContextOnStack(),
        pushOffscreenSuspenseHandler(workInProgress);
    else
      return (
        (workInProgress.lanes = workInProgress.childLanes = 536870912),
        deferHiddenOffscreenComponent(
          current,
          workInProgress,
          null !== prevState ? prevState.baseLanes | renderLanes : renderLanes,
          renderLanes
        )
      );
  } else
    null !== prevState
      ? (pushTransition(workInProgress, prevState.cachePool),
        pushHiddenContext(workInProgress, prevState),
        reuseSuspenseHandlerOnStack(),
        (workInProgress.memoizedState = null))
      : (null !== current && pushTransition(workInProgress, null),
        reuseHiddenContextOnStack(),
        reuseSuspenseHandlerOnStack());
  reconcileChildren(current, workInProgress, nextChildren, renderLanes);
  return workInProgress.child;
}
function deferHiddenOffscreenComponent(
  current,
  workInProgress,
  nextBaseLanes,
  renderLanes
) {
  var JSCompiler_inline_result = peekCacheFromPool();
  JSCompiler_inline_result =
    null === JSCompiler_inline_result
      ? null
      : { parent: CacheContext._currentValue, pool: JSCompiler_inline_result };
  workInProgress.memoizedState = {
    baseLanes: nextBaseLanes,
    cachePool: JSCompiler_inline_result
  };
  null !== current && pushTransition(workInProgress, null);
  reuseHiddenContextOnStack();
  pushOffscreenSuspenseHandler(workInProgress);
  null !== current &&
    propagateParentContextChanges(current, workInProgress, renderLanes, true);
  return null;
}
function markRef(current, workInProgress) {
  var ref = workInProgress.ref;
  if (null === ref)
    null !== current &&
      null !== current.ref &&
      (workInProgress.flags |= 4194816);
  else {
    if ("function" !== typeof ref && "object" !== typeof ref)
      throw Error(formatProdErrorMessage(284));
    if (null === current || current.ref !== ref)
      workInProgress.flags |= 4194816;
  }
}
function updateFunctionComponent(
  current,
  workInProgress,
  Component,
  nextProps,
  renderLanes
) {
  prepareToReadContext(workInProgress);
  Component = renderWithHooks(
    current,
    workInProgress,
    Component,
    nextProps,
    void 0,
    renderLanes
  );
  nextProps = checkDidRenderIdHook();
  if (null !== current && !didReceiveUpdate)
    return (
      bailoutHooks(current, workInProgress, renderLanes),
      bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes)
    );
  isHydrating && nextProps && pushMaterializedTreeId(workInProgress);
  workInProgress.flags |= 1;
  reconcileChildren(current, workInProgress, Component, renderLanes);
  return workInProgress.child;
}
function replayFunctionComponent(
  current,
  workInProgress,
  nextProps,
  Component,
  secondArg,
  renderLanes
) {
  prepareToReadContext(workInProgress);
  workInProgress.updateQueue = null;
  nextProps = renderWithHooksAgain(
    workInProgress,
    Component,
    nextProps,
    secondArg
  );
  finishRenderingHooks(current);
  Component = checkDidRenderIdHook();
  if (null !== current && !didReceiveUpdate)
    return (
      bailoutHooks(current, workInProgress, renderLanes),
      bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes)
    );
  isHydrating && Component && pushMaterializedTreeId(workInProgress);
  workInProgress.flags |= 1;
  reconcileChildren(current, workInProgress, nextProps, renderLanes);
  return workInProgress.child;
}
function updateClassComponent(
  current,
  workInProgress,
  Component,
  nextProps,
  renderLanes
) {
  prepareToReadContext(workInProgress);
  if (null === workInProgress.stateNode) {
    var context = emptyContextObject,
      contextType = Component.contextType;
    "object" === typeof contextType &&
      null !== contextType &&
      (context = readContext(contextType));
    context = new Component(nextProps, context);
    workInProgress.memoizedState =
      null !== context.state && void 0 !== context.state ? context.state : null;
    context.updater = classComponentUpdater;
    workInProgress.stateNode = context;
    context._reactInternals = workInProgress;
    context = workInProgress.stateNode;
    context.props = nextProps;
    context.state = workInProgress.memoizedState;
    context.refs = {};
    initializeUpdateQueue(workInProgress);
    contextType = Component.contextType;
    context.context =
      "object" === typeof contextType && null !== contextType
        ? readContext(contextType)
        : emptyContextObject;
    context.state = workInProgress.memoizedState;
    contextType = Component.getDerivedStateFromProps;
    "function" === typeof contextType &&
      (applyDerivedStateFromProps(
        workInProgress,
        Component,
        contextType,
        nextProps
      ),
      (context.state = workInProgress.memoizedState));
    "function" === typeof Component.getDerivedStateFromProps ||
      "function" === typeof context.getSnapshotBeforeUpdate ||
      ("function" !== typeof context.UNSAFE_componentWillMount &&
        "function" !== typeof context.componentWillMount) ||
      ((contextType = context.state),
      "function" === typeof context.componentWillMount &&
        context.componentWillMount(),
      "function" === typeof context.UNSAFE_componentWillMount &&
        context.UNSAFE_componentWillMount(),
      contextType !== context.state &&
        classComponentUpdater.enqueueReplaceState(context, context.state, null),
      processUpdateQueue(workInProgress, nextProps, context, renderLanes),
      suspendIfUpdateReadFromEntangledAsyncAction(),
      (context.state = workInProgress.memoizedState));
    "function" === typeof context.componentDidMount &&
      (workInProgress.flags |= 4194308);
    nextProps = true;
  } else if (null === current) {
    context = workInProgress.stateNode;
    var unresolvedOldProps = workInProgress.memoizedProps,
      oldProps = resolveClassComponentProps(Component, unresolvedOldProps);
    context.props = oldProps;
    var oldContext = context.context,
      contextType$jscomp$0 = Component.contextType;
    contextType = emptyContextObject;
    "object" === typeof contextType$jscomp$0 &&
      null !== contextType$jscomp$0 &&
      (contextType = readContext(contextType$jscomp$0));
    var getDerivedStateFromProps = Component.getDerivedStateFromProps;
    contextType$jscomp$0 =
      "function" === typeof getDerivedStateFromProps ||
      "function" === typeof context.getSnapshotBeforeUpdate;
    unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
    contextType$jscomp$0 ||
      ("function" !== typeof context.UNSAFE_componentWillReceiveProps &&
        "function" !== typeof context.componentWillReceiveProps) ||
      ((unresolvedOldProps || oldContext !== contextType) &&
        callComponentWillReceiveProps(
          workInProgress,
          context,
          nextProps,
          contextType
        ));
    hasForceUpdate = false;
    var oldState = workInProgress.memoizedState;
    context.state = oldState;
    processUpdateQueue(workInProgress, nextProps, context, renderLanes);
    suspendIfUpdateReadFromEntangledAsyncAction();
    oldContext = workInProgress.memoizedState;
    unresolvedOldProps || oldState !== oldContext || hasForceUpdate
      ? ("function" === typeof getDerivedStateFromProps &&
          (applyDerivedStateFromProps(
            workInProgress,
            Component,
            getDerivedStateFromProps,
            nextProps
          ),
          (oldContext = workInProgress.memoizedState)),
        (oldProps =
          hasForceUpdate ||
          checkShouldComponentUpdate(
            workInProgress,
            Component,
            oldProps,
            nextProps,
            oldState,
            oldContext,
            contextType
          ))
          ? (contextType$jscomp$0 ||
              ("function" !== typeof context.UNSAFE_componentWillMount &&
                "function" !== typeof context.componentWillMount) ||
              ("function" === typeof context.componentWillMount &&
                context.componentWillMount(),
              "function" === typeof context.UNSAFE_componentWillMount &&
                context.UNSAFE_componentWillMount()),
            "function" === typeof context.componentDidMount &&
              (workInProgress.flags |= 4194308))
          : ("function" === typeof context.componentDidMount &&
              (workInProgress.flags |= 4194308),
            (workInProgress.memoizedProps = nextProps),
            (workInProgress.memoizedState = oldContext)),
        (context.props = nextProps),
        (context.state = oldContext),
        (context.context = contextType),
        (nextProps = oldProps))
      : ("function" === typeof context.componentDidMount &&
          (workInProgress.flags |= 4194308),
        (nextProps = false));
  } else {
    context = workInProgress.stateNode;
    cloneUpdateQueue(current, workInProgress);
    contextType = workInProgress.memoizedProps;
    contextType$jscomp$0 = resolveClassComponentProps(Component, contextType);
    context.props = contextType$jscomp$0;
    getDerivedStateFromProps = workInProgress.pendingProps;
    oldState = context.context;
    oldContext = Component.contextType;
    oldProps = emptyContextObject;
    "object" === typeof oldContext &&
      null !== oldContext &&
      (oldProps = readContext(oldContext));
    unresolvedOldProps = Component.getDerivedStateFromProps;
    (oldContext =
      "function" === typeof unresolvedOldProps ||
      "function" === typeof context.getSnapshotBeforeUpdate) ||
      ("function" !== typeof context.UNSAFE_componentWillReceiveProps &&
        "function" !== typeof context.componentWillReceiveProps) ||
      ((contextType !== getDerivedStateFromProps || oldState !== oldProps) &&
        callComponentWillReceiveProps(
          workInProgress,
          context,
          nextProps,
          oldProps
        ));
    hasForceUpdate = false;
    oldState = workInProgress.memoizedState;
    context.state = oldState;
    processUpdateQueue(workInProgress, nextProps, context, renderLanes);
    suspendIfUpdateReadFromEntangledAsyncAction();
    var newState = workInProgress.memoizedState;
    contextType !== getDerivedStateFromProps ||
    oldState !== newState ||
    hasForceUpdate ||
    (null !== current &&
      null !== current.dependencies &&
      checkIfContextChanged(current.dependencies))
      ? ("function" === typeof unresolvedOldProps &&
          (applyDerivedStateFromProps(
            workInProgress,
            Component,
            unresolvedOldProps,
            nextProps
          ),
          (newState = workInProgress.memoizedState)),
        (contextType$jscomp$0 =
          hasForceUpdate ||
          checkShouldComponentUpdate(
            workInProgress,
            Component,
            contextType$jscomp$0,
            nextProps,
            oldState,
            newState,
            oldProps
          ) ||
          (null !== current &&
            null !== current.dependencies &&
            checkIfContextChanged(current.dependencies)))
          ? (oldContext ||
              ("function" !== typeof context.UNSAFE_componentWillUpdate &&
                "function" !== typeof context.componentWillUpdate) ||
              ("function" === typeof context.componentWillUpdate &&
                context.componentWillUpdate(nextProps, newState, oldProps),
              "function" === typeof context.UNSAFE_componentWillUpdate &&
                context.UNSAFE_componentWillUpdate(
                  nextProps,
                  newState,
                  oldProps
                )),
            "function" === typeof context.componentDidUpdate &&
              (workInProgress.flags |= 4),
            "function" === typeof context.getSnapshotBeforeUpdate &&
              (workInProgress.flags |= 1024))
          : ("function" !== typeof context.componentDidUpdate ||
              (contextType === current.memoizedProps &&
                oldState === current.memoizedState) ||
              (workInProgress.flags |= 4),
            "function" !== typeof context.getSnapshotBeforeUpdate ||
              (contextType === current.memoizedProps &&
                oldState === current.memoizedState) ||
              (workInProgress.flags |= 1024),
            (workInProgress.memoizedProps = nextProps),
            (workInProgress.memoizedState = newState)),
        (context.props = nextProps),
        (context.state = newState),
        (context.context = oldProps),
        (nextProps = contextType$jscomp$0))
      : ("function" !== typeof context.componentDidUpdate ||
          (contextType === current.memoizedProps &&
            oldState === current.memoizedState) ||
          (workInProgress.flags |= 4),
        "function" !== typeof context.getSnapshotBeforeUpdate ||
          (contextType === current.memoizedProps &&
            oldState === current.memoizedState) ||
          (workInProgress.flags |= 1024),
        (nextProps = false));
  }
  context = nextProps;
  markRef(current, workInProgress);
  nextProps = 0 !== (workInProgress.flags & 128);
  context || nextProps
    ? ((context = workInProgress.stateNode),
      (Component =
        nextProps && "function" !== typeof Component.getDerivedStateFromError
          ? null
          : context.render()),
      (workInProgress.flags |= 1),
      null !== current && nextProps
        ? ((workInProgress.child = reconcileChildFibers(
            workInProgress,
            current.child,
            null,
            renderLanes
          )),
          (workInProgress.child = reconcileChildFibers(
            workInProgress,
            null,
            Component,
            renderLanes
          )))
        : reconcileChildren(current, workInProgress, Component, renderLanes),
      (workInProgress.memoizedState = context.state),
      (current = workInProgress.child))
    : (current = bailoutOnAlreadyFinishedWork(
        current,
        workInProgress,
        renderLanes
      ));
  return current;
}
function mountHostRootWithoutHydrating(
  current,
  workInProgress,
  nextChildren,
  renderLanes
) {
  resetHydrationState();
  workInProgress.flags |= 256;
  reconcileChildren(current, workInProgress, nextChildren, renderLanes);
  return workInProgress.child;
}
var SUSPENDED_MARKER = {
  dehydrated: null,
  treeContext: null,
  retryLane: 0,
  hydrationErrors: null
};
function mountSuspenseOffscreenState(renderLanes) {
  return { baseLanes: renderLanes, cachePool: getSuspendedCache() };
}
function getRemainingWorkInPrimaryTree(
  current,
  primaryTreeDidDefer,
  renderLanes
) {
  current = null !== current ? current.childLanes & ~renderLanes : 0;
  primaryTreeDidDefer && (current |= workInProgressDeferredLane);
  return current;
}
function updateSuspenseComponent(current, workInProgress, renderLanes) {
  var nextProps = workInProgress.pendingProps,
    showFallback = false,
    didSuspend = 0 !== (workInProgress.flags & 128),
    JSCompiler_temp;
  (JSCompiler_temp = didSuspend) ||
    (JSCompiler_temp =
      null !== current && null === current.memoizedState
        ? false
        : 0 !== (suspenseStackCursor.current & 2));
  JSCompiler_temp && ((showFallback = true), (workInProgress.flags &= -129));
  JSCompiler_temp = 0 !== (workInProgress.flags & 32);
  workInProgress.flags &= -33;
  if (null === current) {
    if (isHydrating) {
      showFallback
        ? pushPrimaryTreeSuspenseHandler(workInProgress)
        : reuseSuspenseHandlerOnStack();
      if (isHydrating) {
        var nextInstance = nextHydratableInstance,
          JSCompiler_temp$jscomp$0;
        if ((JSCompiler_temp$jscomp$0 = nextInstance)) {
          c: {
            JSCompiler_temp$jscomp$0 = nextInstance;
            for (
              nextInstance = rootOrSingletonContext;
              8 !== JSCompiler_temp$jscomp$0.nodeType;

            ) {
              if (!nextInstance) {
                nextInstance = null;
                break c;
              }
              JSCompiler_temp$jscomp$0 = getNextHydratable(
                JSCompiler_temp$jscomp$0.nextSibling
              );
              if (null === JSCompiler_temp$jscomp$0) {
                nextInstance = null;
                break c;
              }
            }
            nextInstance = JSCompiler_temp$jscomp$0;
          }
          null !== nextInstance
            ? ((workInProgress.memoizedState = {
                dehydrated: nextInstance,
                treeContext:
                  null !== treeContextProvider
                    ? { id: treeContextId, overflow: treeContextOverflow }
                    : null,
                retryLane: 536870912,
                hydrationErrors: null
              }),
              (JSCompiler_temp$jscomp$0 = createFiberImplClass(
                18,
                null,
                null,
                0
              )),
              (JSCompiler_temp$jscomp$0.stateNode = nextInstance),
              (JSCompiler_temp$jscomp$0.return = workInProgress),
              (workInProgress.child = JSCompiler_temp$jscomp$0),
              (hydrationParentFiber = workInProgress),
              (nextHydratableInstance = null),
              (JSCompiler_temp$jscomp$0 = true))
            : (JSCompiler_temp$jscomp$0 = false);
        }
        JSCompiler_temp$jscomp$0 || throwOnHydrationMismatch(workInProgress);
      }
      nextInstance = workInProgress.memoizedState;
      if (
        null !== nextInstance &&
        ((nextInstance = nextInstance.dehydrated), null !== nextInstance)
      )
        return (
          isSuspenseInstanceFallback(nextInstance)
            ? (workInProgress.lanes = 32)
            : (workInProgress.lanes = 536870912),
          null
        );
      popSuspenseHandler(workInProgress);
    }
    nextInstance = nextProps.children;
    nextProps = nextProps.fallback;
    if (showFallback)
      return (
        reuseSuspenseHandlerOnStack(),
        (showFallback = workInProgress.mode),
        (nextInstance = mountWorkInProgressOffscreenFiber(
          { mode: "hidden", children: nextInstance },
          showFallback
        )),
        (nextProps = createFiberFromFragment(
          nextProps,
          showFallback,
          renderLanes,
          null
        )),
        (nextInstance.return = workInProgress),
        (nextProps.return = workInProgress),
        (nextInstance.sibling = nextProps),
        (workInProgress.child = nextInstance),
        (showFallback = workInProgress.child),
        (showFallback.memoizedState = mountSuspenseOffscreenState(renderLanes)),
        (showFallback.childLanes = getRemainingWorkInPrimaryTree(
          current,
          JSCompiler_temp,
          renderLanes
        )),
        (workInProgress.memoizedState = SUSPENDED_MARKER),
        nextProps
      );
    pushPrimaryTreeSuspenseHandler(workInProgress);
    return mountSuspensePrimaryChildren(workInProgress, nextInstance);
  }
  JSCompiler_temp$jscomp$0 = current.memoizedState;
  if (
    null !== JSCompiler_temp$jscomp$0 &&
    ((nextInstance = JSCompiler_temp$jscomp$0.dehydrated),
    null !== nextInstance)
  ) {
    if (didSuspend)
      workInProgress.flags & 256
        ? (pushPrimaryTreeSuspenseHandler(workInProgress),
          (workInProgress.flags &= -257),
          (workInProgress = retrySuspenseComponentWithoutHydrating(
            current,
            workInProgress,
            renderLanes
          )))
        : null !== workInProgress.memoizedState
          ? (reuseSuspenseHandlerOnStack(),
            (workInProgress.child = current.child),
            (workInProgress.flags |= 128),
            (workInProgress = null))
          : (reuseSuspenseHandlerOnStack(),
            (showFallback = nextProps.fallback),
            (nextInstance = workInProgress.mode),
            (nextProps = mountWorkInProgressOffscreenFiber(
              { mode: "visible", children: nextProps.children },
              nextInstance
            )),
            (showFallback = createFiberFromFragment(
              showFallback,
              nextInstance,
              renderLanes,
              null
            )),
            (showFallback.flags |= 2),
            (nextProps.return = workInProgress),
            (showFallback.return = workInProgress),
            (nextProps.sibling = showFallback),
            (workInProgress.child = nextProps),
            reconcileChildFibers(
              workInProgress,
              current.child,
              null,
              renderLanes
            ),
            (nextProps = workInProgress.child),
            (nextProps.memoizedState =
              mountSuspenseOffscreenState(renderLanes)),
            (nextProps.childLanes = getRemainingWorkInPrimaryTree(
              current,
              JSCompiler_temp,
              renderLanes
            )),
            (workInProgress.memoizedState = SUSPENDED_MARKER),
            (workInProgress = showFallback));
    else if (
      (pushPrimaryTreeSuspenseHandler(workInProgress),
      isSuspenseInstanceFallback(nextInstance))
    ) {
      JSCompiler_temp =
        nextInstance.nextSibling && nextInstance.nextSibling.dataset;
      if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
      JSCompiler_temp = digest;
      nextProps = Error(formatProdErrorMessage(419));
      nextProps.stack = "";
      nextProps.digest = JSCompiler_temp;
      queueHydrationError({ value: nextProps, source: null, stack: null });
      workInProgress = retrySuspenseComponentWithoutHydrating(
        current,
        workInProgress,
        renderLanes
      );
    } else if (
      (didReceiveUpdate ||
        propagateParentContextChanges(current, workInProgress, renderLanes, false),
      (JSCompiler_temp = 0 !== (renderLanes & current.childLanes)),
      didReceiveUpdate || JSCompiler_temp)
    ) {
      JSCompiler_temp = workInProgressRoot;
      if (
        null !== JSCompiler_temp &&
        ((nextProps = renderLanes & -renderLanes),
        (nextProps =
          0 !== (nextProps & 42)
            ? 1
            : getBumpedLaneForHydrationByLane(nextProps)),
        (nextProps =
          0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes))
            ? 0
            : nextProps),
        0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane)
      )
        throw (
          ((JSCompiler_temp$jscomp$0.retryLane = nextProps),
          enqueueConcurrentRenderForLane(current, nextProps),
          scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps),
          SelectiveHydrationException)
        );
      "$?" === nextInstance.data || renderDidSuspendDelayIfPossible();
      workInProgress = retrySuspenseComponentWithoutHydrating(
        current,
        workInProgress,
        renderLanes
      );
    } else
      "$?" === nextInstance.data
        ? ((workInProgress.flags |= 192),
          (workInProgress.child = current.child),
          (workInProgress = null))
        : ((current = JSCompiler_temp$jscomp$0.treeContext),
          (nextHydratableInstance = getNextHydratable(
            nextInstance.nextSibling
          )),
          (hydrationParentFiber = workInProgress),
          (isHydrating = true),
          (hydrationErrors = null),
          (rootOrSingletonContext = false),
          null !== current &&
            ((idStack[idStackIndex++] = treeContextId),
            (idStack[idStackIndex++] = treeContextOverflow),
            (idStack[idStackIndex++] = treeContextProvider),
            (treeContextId = current.id),
            (treeContextOverflow = current.overflow),
            (treeContextProvider = workInProgress)),
          (workInProgress = mountSuspensePrimaryChildren(
            workInProgress,
            nextProps.children
          )),
          (workInProgress.flags |= 4096));
    return workInProgress;
  }
  if (showFallback)
    return (
      reuseSuspenseHandlerOnStack(),
      (showFallback = nextProps.fallback),
      (nextInstance = workInProgress.mode),
      (JSCompiler_temp$jscomp$0 = current.child),
      (digest = JSCompiler_temp$jscomp$0.sibling),
      (nextProps = createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
      })),
      (nextProps.subtreeFlags =
        JSCompiler_temp$jscomp$0.subtreeFlags & 65011712),
      null !== digest
        ? (showFallback = createWorkInProgress(digest, showFallback))
        : ((showFallback = createFiberFromFragment(
            showFallback,
            nextInstance,
            renderLanes,
            null
          )),
          (showFallback.flags |= 2)),
      (showFallback.return = workInProgress),
      (nextProps.return = workInProgress),
      (nextProps.sibling = showFallback),
      (workInProgress.child = nextProps),
      (nextProps = showFallback),
      (showFallback = workInProgress.child),
      (nextInstance = current.child.memoizedState),
      null === nextInstance
        ? (nextInstance = mountSuspenseOffscreenState(renderLanes))
        : ((JSCompiler_temp$jscomp$0 = nextInstance.cachePool),
          null !== JSCompiler_temp$jscomp$0
            ? ((digest = CacheContext._currentValue),
              (JSCompiler_temp$jscomp$0 =
                JSCompiler_temp$jscomp$0.parent !== digest
                  ? { parent: digest, pool: digest }
                  : JSCompiler_temp$jscomp$0))
            : (JSCompiler_temp$jscomp$0 = getSuspendedCache()),
          (nextInstance = {
            baseLanes: nextInstance.baseLanes | renderLanes,
            cachePool: JSCompiler_temp$jscomp$0
          })),
      (showFallback.memoizedState = nextInstance),
      (showFallback.childLanes = getRemainingWorkInPrimaryTree(
        current,
        JSCompiler_temp,
        renderLanes
      )),
      (workInProgress.memoizedState = SUSPENDED_MARKER),
      nextProps
    );
  pushPrimaryTreeSuspenseHandler(workInProgress);
  renderLanes = current.child;
  current = renderLanes.sibling;
  renderLanes = createWorkInProgress(renderLanes, {
    mode: "visible",
    children: nextProps.children
  });
  renderLanes.return = workInProgress;
  renderLanes.sibling = null;
  null !== current &&
    ((JSCompiler_temp = workInProgress.deletions),
    null === JSCompiler_temp
      ? ((workInProgress.deletions = [current]), (workInProgress.flags |= 16))
      : JSCompiler_temp.push(current));
  workInProgress.child = renderLanes;
  workInProgress.memoizedState = null;
  return renderLanes;
}
function mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
  primaryChildren = mountWorkInProgressOffscreenFiber(
    { mode: "visible", children: primaryChildren },
    workInProgress.mode
  );
  primaryChildren.return = workInProgress;
  return (workInProgress.child = primaryChildren);
}
function mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
  offscreenProps = createFiberImplClass(22, offscreenProps, null, mode);
  offscreenProps.lanes = 0;
  offscreenProps.stateNode = {
    _visibility: 1,
    _pendingMarkers: null,
    _retryCache: null,
    _transitions: null
  };
  return offscreenProps;
}
function retrySuspenseComponentWithoutHydrating(
  current,
  workInProgress,
  renderLanes
) {
  reconcileChildFibers(workInProgress, current.child, null, renderLanes);
  current = mountSuspensePrimaryChildren(
    workInProgress,
    workInProgress.pendingProps.children
  );
  current.flags |= 2;
  workInProgress.memoizedState = null;
  return current;
}
function scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
  fiber.lanes |= renderLanes;
  var alternate = fiber.alternate;
  null !== alternate && (alternate.lanes |= renderLanes);
  scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function initSuspenseListRenderState(
  workInProgress,
  isBackwards,
  tail,
  lastContentRow,
  tailMode
) {
  var renderState = workInProgress.memoizedState;
  null === renderState
    ? (workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
      })
    : ((renderState.isBackwards = isBackwards),
      (renderState.rendering = null),
      (renderState.renderingStartTime = 0),
      (renderState.last = lastContentRow),
      (renderState.tail = tail),
      (renderState.tailMode = tailMode));
}
function updateSuspenseListComponent(current, workInProgress, renderLanes) {
  var nextProps = workInProgress.pendingProps,
    revealOrder = nextProps.revealOrder,
    tailMode = nextProps.tail;
  reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
  nextProps = suspenseStackCursor.current;
  if (0 !== (nextProps & 2))
    (nextProps = (nextProps & 1) | 2), (workInProgress.flags |= 128);
  else {
    if (null !== current && 0 !== (current.flags & 128))
      a: for (current = workInProgress.child; null !== current; ) {
        if (13 === current.tag)
          null !== current.memoizedState &&
            scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag)
          scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
          current.child.return = current;
          current = current.child;
          continue;
        }
        if (current === workInProgress) break a;
        for (; null === current.sibling; ) {
          if (null === current.return || current.return === workInProgress)
            break a;
          current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
      }
    nextProps &= 1;
  }
  push(suspenseStackCursor, nextProps);
  switch (revealOrder) {
    case "forwards":
      renderLanes = workInProgress.child;
      for (revealOrder = null; null !== renderLanes; )
        (current = renderLanes.alternate),
          null !== current &&
            null === findFirstSuspended(current) &&
            (revealOrder = renderLanes),
          (renderLanes = renderLanes.sibling);
      renderLanes = revealOrder;
      null === renderLanes
        ? ((revealOrder = workInProgress.child), (workInProgress.child = null))
        : ((revealOrder = renderLanes.sibling), (renderLanes.sibling = null));
      initSuspenseListRenderState(
        workInProgress,
        false,
        revealOrder,
        renderLanes,
        tailMode
      );
      break;
    case "backwards":
      renderLanes = null;
      revealOrder = workInProgress.child;
      for (workInProgress.child = null; null !== revealOrder; ) {
        current = revealOrder.alternate;
        if (null !== current && null === findFirstSuspended(current)) {
          workInProgress.child = revealOrder;
          break;
        }
        current = revealOrder.sibling;
        revealOrder.sibling = renderLanes;
        renderLanes = revealOrder;
        revealOrder = current;
      }
      initSuspenseListRenderState(
        workInProgress,
        true,
        renderLanes,
        null,
        tailMode
      );
      break;
    case "together":
      initSuspenseListRenderState(workInProgress, false, null, null, void 0);
      break;
    default:
      workInProgress.memoizedState = null;
  }
  return workInProgress.child;
}
function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
  null !== current && (workInProgress.dependencies = current.dependencies);
  workInProgressRootSkippedLanes |= workInProgress.lanes;
  if (0 === (renderLanes & workInProgress.childLanes))
    if (null !== current) {
      if (
        (propagateParentContextChanges(
          current,
          workInProgress,
          renderLanes,
          false
        ),
        0 === (renderLanes & workInProgress.childLanes))
      )
        return null;
    } else return null;
  if (null !== current && workInProgress.child !== current.child)
    throw Error(formatProdErrorMessage(153));
  if (null !== workInProgress.child) {
    current = workInProgress.child;
    renderLanes = createWorkInProgress(current, current.pendingProps);
    workInProgress.child = renderLanes;
    for (renderLanes.return = workInProgress; null !== current.sibling; )
      (current = current.sibling),
        (renderLanes = renderLanes.sibling =
          createWorkInProgress(current, current.pendingProps)),
        (renderLanes.return = workInProgress);
    renderLanes.sibling = null;
  }
  return workInProgress.child;
}
function checkScheduledUpdateOrContext(current, renderLanes) {
  if (0 !== (current.lanes & renderLanes)) return true;
  current = current.dependencies;
  return null !== current && checkIfContextChanged(current) ? true : false;
}
function attemptEarlyBailoutIfNoScheduledUpdate(
  current,
  workInProgress,
  renderLanes
) {
  switch (workInProgress.tag) {
    case 3:
      pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
      pushProvider(workInProgress, CacheContext, current.memoizedState.cache);
      resetHydrationState();
      break;
    case 27:
    case 5:
      pushHostContext(workInProgress);
      break;
    case 4:
      pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
      break;
    case 10:
      pushProvider(
        workInProgress,
        workInProgress.type,
        workInProgress.memoizedProps.value
      );
      break;
    case 13:
      var state = workInProgress.memoizedState;
      if (null !== state) {
        if (null !== state.dehydrated)
          return (
            pushPrimaryTreeSuspenseHandler(workInProgress),
            (workInProgress.flags |= 128),
            null
          );
        if (0 !== (renderLanes & workInProgress.child.childLanes))
          return updateSuspenseComponent(current, workInProgress, renderLanes);
        pushPrimaryTreeSuspenseHandler(workInProgress);
        current = bailoutOnAlreadyFinishedWork(
          current,
          workInProgress,
          renderLanes
        );
        return null !== current ? current.sibling : null;
      }
      pushPrimaryTreeSuspenseHandler(workInProgress);
      break;
    case 19:
      var didSuspendBefore = 0 !== (current.flags & 128);
      state = 0 !== (renderLanes & workInProgress.childLanes);
      state ||
        (propagateParentContextChanges(
          current,
          workInProgress,
          renderLanes,
          false
        ),
        (state = 0 !== (renderLanes & workInProgress.childLanes)));
      if (didSuspendBefore) {
        if (state)
          return updateSuspenseListComponent(
            current,
            workInProgress,
            renderLanes
          );
        workInProgress.flags |= 128;
      }
      didSuspendBefore = workInProgress.memoizedState;
      null !== didSuspendBefore &&
        ((didSuspendBefore.rendering = null),
        (didSuspendBefore.tail = null),
        (didSuspendBefore.lastEffect = null));
      push(suspenseStackCursor, suspenseStackCursor.current);
      if (state) break;
      else return null;
    case 22:
    case 23:
      return (
        (workInProgress.lanes = 0),
        updateOffscreenComponent(current, workInProgress, renderLanes)
      );
    case 24:
      pushProvider(workInProgress, CacheContext, current.memoizedState.cache);
  }
  return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function beginWork(current, workInProgress, renderLanes) {
  if (null !== current)
    if (current.memoizedProps !== workInProgress.pendingProps)
      didReceiveUpdate = true;
    else {
      if (
        !checkScheduledUpdateOrContext(current, renderLanes) &&
        0 === (workInProgress.flags & 128)
      )
        return (
          (didReceiveUpdate = false),
          attemptEarlyBailoutIfNoScheduledUpdate(
            current,
            workInProgress,
            renderLanes
          )
        );
      didReceiveUpdate = 0 !== (current.flags & 131072) ? true : false;
    }
  else
    (didReceiveUpdate = false),
      isHydrating &&
        0 !== (workInProgress.flags & 1048576) &&
        pushTreeId(workInProgress, treeForkCount, workInProgress.index);
  workInProgress.lanes = 0;
  switch (workInProgress.tag) {
    case 16:
      a: {
        current = workInProgress.pendingProps;
        var lazyComponent = workInProgress.elementType,
          init = lazyComponent._init;
        lazyComponent = init(lazyComponent._payload);
        workInProgress.type = lazyComponent;
        if ("function" === typeof lazyComponent)
          shouldConstruct(lazyComponent)
            ? ((current = resolveClassComponentProps(lazyComponent, current)),
              (workInProgress.tag = 1),
              (workInProgress = updateClassComponent(
                null,
                workInProgress,
                lazyComponent,
                current,
                renderLanes
              )))
            : ((workInProgress.tag = 0),
              (workInProgress = updateFunctionComponent(
                null,
                workInProgress,
                lazyComponent,
                current,
                renderLanes
              )));
        else {
          if (void 0 !== lazyComponent && null !== lazyComponent)
            if (
              ((init = lazyComponent.$$typeof), init === REACT_FORWARD_REF_TYPE)
            ) {
              workInProgress.tag = 11;
              workInProgress = updateForwardRef(
                null,
                workInProgress,
                lazyComponent,
                current,
                renderLanes
              );
              break a;
            } else if (init === REACT_MEMO_TYPE) {
              workInProgress.tag = 14;
              workInProgress = updateMemoComponent(
                null,
                workInProgress,
                lazyComponent,
                current,
                renderLanes
              );
              break a;
            }
          workInProgress =
            getComponentNameFromType(lazyComponent) || lazyComponent;
          throw Error(formatProdErrorMessage(306, workInProgress, ""));
        }
      }
      return workInProgress;
    case 0:
      return updateFunctionComponent(
        current,
        workInProgress,
        workInProgress.type,
        workInProgress.pendingProps,
        renderLanes
      );
    case 1:
      return (
        (lazyComponent = workInProgress.type),
        (init = resolveClassComponentProps(
          lazyComponent,
          workInProgress.pendingProps
        )),
        updateClassComponent(
          current,
          workInProgress,
          lazyComponent,
          init,
          renderLanes
        )
      );
    case 3:
      a: {
        pushHostContainer(
          workInProgress,
          workInProgress.stateNode.containerInfo
        );
        if (null === current) throw Error(formatProdErrorMessage(387));
        lazyComponent = workInProgress.pendingProps;
        var prevState = workInProgress.memoizedState;
        init = prevState.element;
        cloneUpdateQueue(current, workInProgress);
        processUpdateQueue(workInProgress, lazyComponent, null, renderLanes);
        var nextState = workInProgress.memoizedState;
        lazyComponent = nextState.cache;
        pushProvider(workInProgress, CacheContext, lazyComponent);
        lazyComponent !== prevState.cache &&
          propagateContextChanges(
            workInProgress,
            [CacheContext],
            renderLanes,
            true
          );
        suspendIfUpdateReadFromEntangledAsyncAction();
        lazyComponent = nextState.element;
        if (prevState.isDehydrated)
          if (
            ((prevState = {
              element: lazyComponent,
              isDehydrated: false,
              cache: nextState.cache
            }),
            (workInProgress.updateQueue.baseState = prevState),
            (workInProgress.memoizedState = prevState),
            workInProgress.flags & 256)
          ) {
            workInProgress = mountHostRootWithoutHydrating(
              current,
              workInProgress,
              lazyComponent,
              renderLanes
            );
            break a;
          } else if (lazyComponent !== init) {
            init = createCapturedValueAtFiber(
              Error(formatProdErrorMessage(424)),
              workInProgress
            );
            queueHydrationError(init);
            workInProgress = mountHostRootWithoutHydrating(
              current,
              workInProgress,
              lazyComponent,
              renderLanes
            );
            break a;
          } else {
            current = workInProgress.stateNode.containerInfo;
            switch (current.nodeType) {
              case 9:
                current = current.body;
                break;
              default:
                current =
                  "HTML" === current.nodeName
                    ? current.ownerDocument.body
                    : current;
            }
            nextHydratableInstance = getNextHydratable(current.firstChild);
            hydrationParentFiber = workInProgress;
            isHydrating = true;
            hydrationErrors = null;
            rootOrSingletonContext = true;
            renderLanes = mountChildFibers(
              workInProgress,
              null,
              lazyComponent,
              renderLanes
            );
            for (workInProgress.child = renderLanes; renderLanes; )
              (renderLanes.flags = (renderLanes.flags & -3) | 4096),
                (renderLanes = renderLanes.sibling);
          }
        else {
          resetHydrationState();
          if (lazyComponent === init) {
            workInProgress = bailoutOnAlreadyFinishedWork(
              current,
              workInProgress,
              renderLanes
            );
            break a;
          }
          reconcileChildren(
            current,
            workInProgress,
            lazyComponent,
            renderLanes
          );
        }
        workInProgress = workInProgress.child;
      }
      return workInProgress;
    case 26:
      return (
        markRef(current, workInProgress),
        null === current
          ? (renderLanes = getResource(
              workInProgress.type,
              null,
              workInProgress.pendingProps,
              null
            ))
            ? (workInProgress.memoizedState = renderLanes)
            : isHydrating ||
              ((renderLanes = workInProgress.type),
              (current = workInProgress.pendingProps),
              (lazyComponent = getOwnerDocumentFromRootContainer(
                rootInstanceStackCursor.current
              ).createElement(renderLanes)),
              (lazyComponent[internalInstanceKey] = workInProgress),
              (lazyComponent[internalPropsKey] = current),
              setInitialProperties(lazyComponent, renderLanes, current),
              markNodeAsHoistable(lazyComponent),
              (workInProgress.stateNode = lazyComponent))
          : (workInProgress.memoizedState = getResource(
              workInProgress.type,
              current.memoizedProps,
              workInProgress.pendingProps,
              current.memoizedState
            )),
        null
      );
    case 27:
      return (
        pushHostContext(workInProgress),
        null === current &&
          isHydrating &&
          ((lazyComponent = workInProgress.stateNode =
            resolveSingletonInstance(
              workInProgress.type,
              workInProgress.pendingProps,
              rootInstanceStackCursor.current
            )),
          (hydrationParentFiber = workInProgress),
          (rootOrSingletonContext = true),
          (init = nextHydratableInstance),
          isSingletonScope(workInProgress.type)
            ? ((previousHydratableOnEnteringScopedSingleton = init),
              (nextHydratableInstance = getNextHydratable(
                lazyComponent.firstChild
              )))
            : (nextHydratableInstance = init)),
        reconcileChildren(
          current,
          workInProgress,
          workInProgress.pendingProps.children,
          renderLanes
        ),
        markRef(current, workInProgress),
        null === current && (workInProgress.flags |= 4194304),
        workInProgress.child
      );
    case 5:
      if (null === current && isHydrating) {
        if ((init = lazyComponent = nextHydratableInstance))
          (lazyComponent = canHydrateInstance(
            lazyComponent,
            workInProgress.type,
            workInProgress.pendingProps,
            rootOrSingletonContext
          )),
            null !== lazyComponent
              ? ((workInProgress.stateNode = lazyComponent),
                (hydrationParentFiber = workInProgress),
                (nextHydratableInstance = getNextHydratable(
                  lazyComponent.firstChild
                )),
                (rootOrSingletonContext = false),
                (init = true))
              : (init = false);
        init || throwOnHydrationMismatch(workInProgress);
      }
      pushHostContext(workInProgress);
      init = workInProgress.type;
      prevState = workInProgress.pendingProps;
      nextState = null !== current ? current.memoizedProps : null;
      lazyComponent = prevState.children;
      shouldSetTextContent(init, prevState)
        ? (lazyComponent = null)
        : null !== nextState &&
          shouldSetTextContent(init, nextState) &&
          (workInProgress.flags |= 32);
      null !== workInProgress.memoizedState &&
        ((init = renderWithHooks(
          current,
          workInProgress,
          TransitionAwareHostComponent,
          null,
          null,
          renderLanes
        )),
        (HostTransitionContext._currentValue = init));
      markRef(current, workInProgress);
      reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
      return workInProgress.child;
    case 6:
      if (null === current && isHydrating) {
        if ((current = renderLanes = nextHydratableInstance))
          (renderLanes = canHydrateTextInstance(
            renderLanes,
            workInProgress.pendingProps,
            rootOrSingletonContext
          )),
            null !== renderLanes
              ? ((workInProgress.stateNode = renderLanes),
                (hydrationParentFiber = workInProgress),
                (nextHydratableInstance = null),
                (current = true))
              : (current = false);
        current || throwOnHydrationMismatch(workInProgress);
      }
      return null;
    case 13:
      return updateSuspenseComponent(current, workInProgress, renderLanes);
    case 4:
      return (
        pushHostContainer(
          workInProgress,
          workInProgress.stateNode.containerInfo
        ),
        (lazyComponent = workInProgress.pendingProps),
        null === current
          ? (workInProgress.child = reconcileChildFibers(
              workInProgress,
              null,
              lazyComponent,
              renderLanes
            ))
          : reconcileChildren(
              current,
              workInProgress,
              lazyComponent,
              renderLanes
            ),
        workInProgress.child
      );
    case 11:
      return updateForwardRef(
        current,
        workInProgress,
        workInProgress.type,
        workInProgress.pendingProps,
        renderLanes
      );
    case 7:
      return (
        reconcileChildren(
          current,
          workInProgress,
          workInProgress.pendingProps,
          renderLanes
        ),
        workInProgress.child
      );
    case 8:
      return (
        reconcileChildren(
          current,
          workInProgress,
          workInProgress.pendingProps.children,
          renderLanes
        ),
        workInProgress.child
      );
    case 12:
      return (
        reconcileChildren(
          current,
          workInProgress,
          workInProgress.pendingProps.children,
          renderLanes
        ),
        workInProgress.child
      );
    case 10:
      return (
        (lazyComponent = workInProgress.pendingProps),
        pushProvider(workInProgress, workInProgress.type, lazyComponent.value),
        reconcileChildren(
          current,
          workInProgress,
          lazyComponent.children,
          renderLanes
        ),
        workInProgress.child
      );
    case 9:
      return (
        (init = workInProgress.type._context),
        (lazyComponent = workInProgress.pendingProps.children),
        prepareToReadContext(workInProgress),
        (init = readContext(init)),
        (lazyComponent = lazyComponent(init)),
        (workInProgress.flags |= 1),
        reconcileChildren(current, workInProgress, lazyComponent, renderLanes),
        workInProgress.child
      );
    case 14:
      return updateMemoComponent(
        current,
        workInProgress,
        workInProgress.type,
        workInProgress.pendingProps,
        renderLanes
      );
    case 15:
      return updateSimpleMemoComponent(
        current,
        workInProgress,
        workInProgress.type,
        workInProgress.pendingProps,
        renderLanes
      );
    case 19:
      return updateSuspenseListComponent(current, workInProgress, renderLanes);
    case 31:
      return (
        (lazyComponent = workInProgress.pendingProps),
        (renderLanes = workInProgress.mode),
        (lazyComponent = {
          mode: lazyComponent.mode,
          children: lazyComponent.children
        }),
        null === current
          ? ((renderLanes = mountWorkInProgressOffscreenFiber(
              lazyComponent,
              renderLanes
            )),
            (renderLanes.ref = workInProgress.ref),
            (workInProgress.child = renderLanes),
            (renderLanes.return = workInProgress),
            (workInProgress = renderLanes))
          : ((renderLanes = createWorkInProgress(current.child, lazyComponent)),
            (renderLanes.ref = workInProgress.ref),
            (workInProgress.child = renderLanes),
            (renderLanes.return = workInProgress),
            (workInProgress = renderLanes)),
        workInProgress
      );
    case 22:
      return updateOffscreenComponent(current, workInProgress, renderLanes);
    case 24:
      return (
        prepareToReadContext(workInProgress),
        (lazyComponent = readContext(CacheContext)),
        null === current
          ? ((init = peekCacheFromPool()),
            null === init &&
              ((init = workInProgressRoot),
              (prevState = createCache()),
              (init.pooledCache = prevState),
              prevState.refCount++,
              null !== prevState && (init.pooledCacheLanes |= renderLanes),
              (init = prevState)),
            (workInProgress.memoizedState = {
              parent: lazyComponent,
              cache: init
            }),
            initializeUpdateQueue(workInProgress),
            pushProvider(workInProgress, CacheContext, init))
          : (0 !== (current.lanes & renderLanes) &&
              (cloneUpdateQueue(current, workInProgress),
              processUpdateQueue(workInProgress, null, null, renderLanes),
              suspendIfUpdateReadFromEntangledAsyncAction()),
            (init = current.memoizedState),
            (prevState = workInProgress.memoizedState),
            init.parent !== lazyComponent
              ? ((init = { parent: lazyComponent, cache: lazyComponent }),
                (workInProgress.memoizedState = init),
                0 === workInProgress.lanes &&
                  (workInProgress.memoizedState =
                    workInProgress.updateQueue.baseState =
                      init),
                pushProvider(workInProgress, CacheContext, lazyComponent))
              : ((lazyComponent = prevState.cache),
                pushProvider(workInProgress, CacheContext, lazyComponent),
                lazyComponent !== init.cache &&
                  propagateContextChanges(
                    workInProgress,
                    [CacheContext],
                    renderLanes,
                    true
                  ))),
        reconcileChildren(
          current,
          workInProgress,
          workInProgress.pendingProps.children,
          renderLanes
        ),
        workInProgress.child
      );
    case 29:
      throw workInProgress.pendingProps;
  }
  throw Error(formatProdErrorMessage(156, workInProgress.tag));
}
function markUpdate(workInProgress) {
  workInProgress.flags |= 4;
}
function preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
  if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4))
    workInProgress.flags &= -16777217;
  else if (((workInProgress.flags |= 16777216), !preloadResource(resource))) {
    resource = suspenseHandlerStackCursor.current;
    if (
      null !== resource &&
      ((workInProgressRootRenderLanes & 4194048) ===
      workInProgressRootRenderLanes
        ? null !== shellBoundary
        : ((workInProgressRootRenderLanes & 62914560) !==
            workInProgressRootRenderLanes &&
            0 === (workInProgressRootRenderLanes & 536870912)) ||
          resource !== shellBoundary)
    )
      throw (
        ((suspendedThenable = noopSuspenseyCommitThenable),
        SuspenseyCommitException)
      );
    workInProgress.flags |= 8192;
  }
}
function scheduleRetryEffect(workInProgress, retryQueue) {
  null !== retryQueue && (workInProgress.flags |= 4);
  workInProgress.flags & 16384 &&
    ((retryQueue =
      22 !== workInProgress.tag ? claimNextRetryLane() : 536870912),
    (workInProgress.lanes |= retryQueue),
    (workInProgressSuspendedRetryLanes |= retryQueue));
}
function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
  if (!isHydrating)
    switch (renderState.tailMode) {
      case "hidden":
        hasRenderedATailFallback = renderState.tail;
        for (var lastTailNode = null; null !== hasRenderedATailFallback; )
          null !== hasRenderedATailFallback.alternate &&
            (lastTailNode = hasRenderedATailFallback),
            (hasRenderedATailFallback = hasRenderedATailFallback.sibling);
        null === lastTailNode
          ? (renderState.tail = null)
          : (lastTailNode.sibling = null);
        break;
      case "collapsed":
        lastTailNode = renderState.tail;
        for (var lastTailNode$113 = null; null !== lastTailNode; )
          null !== lastTailNode.alternate && (lastTailNode$113 = lastTailNode),
            (lastTailNode = lastTailNode.sibling);
        null === lastTailNode$113
          ? hasRenderedATailFallback || null === renderState.tail
            ? (renderState.tail = null)
            : (renderState.tail.sibling = null)
          : (lastTailNode$113.sibling = null);
    }
}
function bubbleProperties(completedWork) {
  var didBailout =
      null !== completedWork.alternate &&
      completedWork.alternate.child === completedWork.child,
    newChildLanes = 0,
    subtreeFlags = 0;
  if (didBailout)
    for (var child$114 = completedWork.child; null !== child$114; )
      (newChildLanes |= child$114.lanes | child$114.childLanes),
        (subtreeFlags |= child$114.subtreeFlags & 65011712),
        (subtreeFlags |= child$114.flags & 65011712),
        (child$114.return = completedWork),
        (child$114 = child$114.sibling);
  else
    for (child$114 = completedWork.child; null !== child$114; )
      (newChildLanes |= child$114.lanes | child$114.childLanes),
        (subtreeFlags |= child$114.subtreeFlags),
        (subtreeFlags |= child$114.flags),
        (child$114.return = completedWork),
        (child$114 = child$114.sibling);
  completedWork.subtreeFlags |= subtreeFlags;
  completedWork.childLanes = newChildLanes;
  return didBailout;
}
function completeWork(current, workInProgress, renderLanes) {
  var newProps = workInProgress.pendingProps;
  popTreeContext(workInProgress);
  switch (workInProgress.tag) {
    case 31:
    case 16:
    case 15:
    case 0:
    case 11:
    case 7:
    case 8:
    case 12:
    case 9:
    case 14:
      return bubbleProperties(workInProgress), null;
    case 1:
      return bubbleProperties(workInProgress), null;
    case 3:
      renderLanes = workInProgress.stateNode;
      newProps = null;
      null !== current && (newProps = current.memoizedState.cache);
      workInProgress.memoizedState.cache !== newProps &&
        (workInProgress.flags |= 2048);
      popProvider(CacheContext);
      popHostContainer();
      renderLanes.pendingContext &&
        ((renderLanes.context = renderLanes.pendingContext),
        (renderLanes.pendingContext = null));
      if (null === current || null === current.child)
        popHydrationState(workInProgress)
          ? markUpdate(workInProgress)
          : null === current ||
            (current.memoizedState.isDehydrated &&
              0 === (workInProgress.flags & 256)) ||
            ((workInProgress.flags |= 1024),
            upgradeHydrationErrorsToRecoverable());
      bubbleProperties(workInProgress);
      return null;
    case 26:
      return (
        (renderLanes = workInProgress.memoizedState),
        null === current
          ? (markUpdate(workInProgress),
            null !== renderLanes
              ? (bubbleProperties(workInProgress),
                preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes))
              : (bubbleProperties(workInProgress),
                (workInProgress.flags &= -16777217)))
          : renderLanes
            ? renderLanes !== current.memoizedState
              ? (markUpdate(workInProgress),
                bubbleProperties(workInProgress),
                preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes))
              : (bubbleProperties(workInProgress),
                (workInProgress.flags &= -16777217))
            : (current.memoizedProps !== newProps && markUpdate(workInProgress),
              bubbleProperties(workInProgress),
              (workInProgress.flags &= -16777217)),
        null
      );
    case 27:
      popHostContext(workInProgress);
      renderLanes = rootInstanceStackCursor.current;
      var type = workInProgress.type;
      if (null !== current && null != workInProgress.stateNode)
        current.memoizedProps !== newProps && markUpdate(workInProgress);
      else {
        if (!newProps) {
          if (null === workInProgress.stateNode)
            throw Error(formatProdErrorMessage(166));
          bubbleProperties(workInProgress);
          return null;
        }
        current = contextStackCursor.current;
        popHydrationState(workInProgress)
          ? prepareToHydrateHostInstance(workInProgress)
          : ((current = resolveSingletonInstance(type, newProps, renderLanes)),
            (workInProgress.stateNode = current),
            markUpdate(workInProgress));
      }
      bubbleProperties(workInProgress);
      return null;
    case 5:
      popHostContext(workInProgress);
      renderLanes = workInProgress.type;
      if (null !== current && null != workInProgress.stateNode)
        current.memoizedProps !== newProps && markUpdate(workInProgress);
      else {
        if (!newProps) {
          if (null === workInProgress.stateNode)
            throw Error(formatProdErrorMessage(166));
          bubbleProperties(workInProgress);
          return null;
        }
        current = contextStackCursor.current;
        if (popHydrationState(workInProgress))
          prepareToHydrateHostInstance(workInProgress);
        else {
          type = getOwnerDocumentFromRootContainer(
            rootInstanceStackCursor.current
          );
          switch (current) {
            case 1:
              current = type.createElementNS(
                "http://www.w3.org/2000/svg",
                renderLanes
              );
              break;
            case 2:
              current = type.createElementNS(
                "http://www.w3.org/1998/Math/MathML",
                renderLanes
              );
              break;
            default:
              switch (renderLanes) {
                case "svg":
                  current = type.createElementNS(
                    "http://www.w3.org/2000/svg",
                    renderLanes
                  );
                  break;
                case "math":
                  current = type.createElementNS(
                    "http://www.w3.org/1998/Math/MathML",
                    renderLanes
                  );
                  break;
                case "script":
                  current = type.createElement("div");
                  current.innerHTML = "<script>\x3c/script>";
                  current = current.removeChild(current.firstChild);
                  break;
                case "select":
                  current =
                    "string" === typeof newProps.is
                      ? type.createElement("select", { is: newProps.is })
                      : type.createElement("select");
                  newProps.multiple
                    ? (current.multiple = true)
                    : newProps.size && (current.size = newProps.size);
                  break;
                default:
                  current =
                    "string" === typeof newProps.is
                      ? type.createElement(renderLanes, { is: newProps.is })
                      : type.createElement(renderLanes);
              }
          }
          current[internalInstanceKey] = workInProgress;
          current[internalPropsKey] = newProps;
          a: for (type = workInProgress.child; null !== type; ) {
            if (5 === type.tag || 6 === type.tag)
              current.appendChild(type.stateNode);
            else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
              type.child.return = type;
              type = type.child;
              continue;
            }
            if (type === workInProgress) break a;
            for (; null === type.sibling; ) {
              if (null === type.return || type.return === workInProgress)
                break a;
              type = type.return;
            }
            type.sibling.return = type.return;
            type = type.sibling;
          }
          workInProgress.stateNode = current;
          a: switch (
            (setInitialProperties(current, renderLanes, newProps), renderLanes)
          ) {
            case "button":
            case "input":
            case "select":
            case "textarea":
              current = !!newProps.autoFocus;
              break a;
            case "img":
              current = true;
              break a;
            default:
              current = false;
          }
          current && markUpdate(workInProgress);
        }
      }
      bubbleProperties(workInProgress);
      workInProgress.flags &= -16777217;
      return null;
    case 6:
      if (current && null != workInProgress.stateNode)
        current.memoizedProps !== newProps && markUpdate(workInProgress);
      else {
        if ("string" !== typeof newProps && null === workInProgress.stateNode)
          throw Error(formatProdErrorMessage(166));
        current = rootInstanceStackCursor.current;
        if (popHydrationState(workInProgress)) {
          current = workInProgress.stateNode;
          renderLanes = workInProgress.memoizedProps;
          newProps = null;
          type = hydrationParentFiber;
          if (null !== type)
            switch (type.tag) {
              case 27:
              case 5:
                newProps = type.memoizedProps;
            }
          current[internalInstanceKey] = workInProgress;
          current =
            current.nodeValue === renderLanes ||
            (null !== newProps && true === newProps.suppressHydrationWarning) ||
            checkForUnmatchedText(current.nodeValue, renderLanes)
              ? true
              : false;
          current || throwOnHydrationMismatch(workInProgress);
        } else
          (current =
            getOwnerDocumentFromRootContainer(current).createTextNode(
              newProps
            )),
            (current[internalInstanceKey] = workInProgress),
            (workInProgress.stateNode = current);
      }
      bubbleProperties(workInProgress);
      return null;
    case 13:
      newProps = workInProgress.memoizedState;
      if (
        null === current ||
        (null !== current.memoizedState &&
          null !== current.memoizedState.dehydrated)
      ) {
        type = popHydrationState(workInProgress);
        if (null !== newProps && null !== newProps.dehydrated) {
          if (null === current) {
            if (!type) throw Error(formatProdErrorMessage(318));
            type = workInProgress.memoizedState;
            type = null !== type ? type.dehydrated : null;
            if (!type) throw Error(formatProdErrorMessage(317));
            type[internalInstanceKey] = workInProgress;
          } else
            resetHydrationState(),
              0 === (workInProgress.flags & 128) &&
                (workInProgress.memoizedState = null),
              (workInProgress.flags |= 4);
          bubbleProperties(workInProgress);
          type = false;
        } else
          (type = upgradeHydrationErrorsToRecoverable()),
            null !== current &&
              null !== current.memoizedState &&
              (current.memoizedState.hydrationErrors = type),
            (type = true);
        if (!type) {
          if (workInProgress.flags & 256)
            return popSuspenseHandler(workInProgress), workInProgress;
          popSuspenseHandler(workInProgress);
          return null;
        }
      }
      popSuspenseHandler(workInProgress);
      if (0 !== (workInProgress.flags & 128))
        return (workInProgress.lanes = renderLanes), workInProgress;
      renderLanes = null !== newProps;
      current = null !== current && null !== current.memoizedState;
      if (renderLanes) {
        newProps = workInProgress.child;
        type = null;
        null !== newProps.alternate &&
          null !== newProps.alternate.memoizedState &&
          null !== newProps.alternate.memoizedState.cachePool &&
          (type = newProps.alternate.memoizedState.cachePool.pool);
        var cache$127 = null;
        null !== newProps.memoizedState &&
          null !== newProps.memoizedState.cachePool &&
          (cache$127 = newProps.memoizedState.cachePool.pool);
        cache$127 !== type && (newProps.flags |= 2048);
      }
      renderLanes !== current &&
        renderLanes &&
        (workInProgress.child.flags |= 8192);
      scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
      bubbleProperties(workInProgress);
      return null;
    case 4:
      return (
        popHostContainer(),
        null === current &&
          listenToAllSupportedEvents(workInProgress.stateNode.containerInfo),
        bubbleProperties(workInProgress),
        null
      );
    case 10:
      return (
        popProvider(workInProgress.type), bubbleProperties(workInProgress), null
      );
    case 19:
      pop(suspenseStackCursor);
      type = workInProgress.memoizedState;
      if (null === type) return bubbleProperties(workInProgress), null;
      newProps = 0 !== (workInProgress.flags & 128);
      cache$127 = type.rendering;
      if (null === cache$127)
        if (newProps) cutOffTailIfNeeded(type, false);
        else {
          if (
            0 !== workInProgressRootExitStatus ||
            (null !== current && 0 !== (current.flags & 128))
          )
            for (current = workInProgress.child; null !== current; ) {
              cache$127 = findFirstSuspended(current);
              if (null !== cache$127) {
                workInProgress.flags |= 128;
                cutOffTailIfNeeded(type, false);
                current = cache$127.updateQueue;
                workInProgress.updateQueue = current;
                scheduleRetryEffect(workInProgress, current);
                workInProgress.subtreeFlags = 0;
                current = renderLanes;
                for (renderLanes = workInProgress.child; null !== renderLanes; )
                  resetWorkInProgress(renderLanes, current),
                    (renderLanes = renderLanes.sibling);
                push(
                  suspenseStackCursor,
                  (suspenseStackCursor.current & 1) | 2
                );
                return workInProgress.child;
              }
              current = current.sibling;
            }
          null !== type.tail &&
            now$1() > workInProgressRootRenderTargetTime &&
            ((workInProgress.flags |= 128),
            (newProps = true),
            cutOffTailIfNeeded(type, false),
            (workInProgress.lanes = 4194304));
        }
      else {
        if (!newProps)
          if (((current = findFirstSuspended(cache$127)), null !== current)) {
            if (
              ((workInProgress.flags |= 128),
              (newProps = true),
              (current = current.updateQueue),
              (workInProgress.updateQueue = current),
              scheduleRetryEffect(workInProgress, current),
              cutOffTailIfNeeded(type, true),
              null === type.tail &&
                "hidden" === type.tailMode &&
                !cache$127.alternate &&
                !isHydrating)
            )
              return bubbleProperties(workInProgress), null;
          } else
            2 * now$1() - type.renderingStartTime >
              workInProgressRootRenderTargetTime &&
              536870912 !== renderLanes &&
              ((workInProgress.flags |= 128),
              (newProps = true),
              cutOffTailIfNeeded(type, false),
              (workInProgress.lanes = 4194304));
        type.isBackwards
          ? ((cache$127.sibling = workInProgress.child),
            (workInProgress.child = cache$127))
          : ((current = type.last),
            null !== current
              ? (current.sibling = cache$127)
              : (workInProgress.child = cache$127),
            (type.last = cache$127));
      }
      if (null !== type.tail)
        return (
          (workInProgress = type.tail),
          (type.rendering = workInProgress),
          (type.tail = workInProgress.sibling),
          (type.renderingStartTime = now$1()),
          (workInProgress.sibling = null),
          (current = suspenseStackCursor.current),
          push(suspenseStackCursor, newProps ? (current & 1) | 2 : current & 1),
          workInProgress
        );
      bubbleProperties(workInProgress);
      return null;
    case 22:
    case 23:
      return (
        popSuspenseHandler(workInProgress),
        popHiddenContext(),
        (newProps = null !== workInProgress.memoizedState),
        null !== current
          ? (null !== current.memoizedState) !== newProps &&
            (workInProgress.flags |= 8192)
          : newProps && (workInProgress.flags |= 8192),
        newProps
          ? 0 !== (renderLanes & 536870912) &&
            0 === (workInProgress.flags & 128) &&
            (bubbleProperties(workInProgress),
            workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192))
          : bubbleProperties(workInProgress),
        (renderLanes = workInProgress.updateQueue),
        null !== renderLanes &&
          scheduleRetryEffect(workInProgress, renderLanes.retryQueue),
        (renderLanes = null),
        null !== current &&
          null !== current.memoizedState &&
          null !== current.memoizedState.cachePool &&
          (renderLanes = current.memoizedState.cachePool.pool),
        (newProps = null),
        null !== workInProgress.memoizedState &&
          null !== workInProgress.memoizedState.cachePool &&
          (newProps = workInProgress.memoizedState.cachePool.pool),
        newProps !== renderLanes && (workInProgress.flags |= 2048),
        null !== current && pop(resumedCache),
        null
      );
    case 24:
      return (
        (renderLanes = null),
        null !== current && (renderLanes = current.memoizedState.cache),
        workInProgress.memoizedState.cache !== renderLanes &&
          (workInProgress.flags |= 2048),
        popProvider(CacheContext),
        bubbleProperties(workInProgress),
        null
      );
    case 25:
      return null;
    case 30:
      return null;
  }
  throw Error(formatProdErrorMessage(156, workInProgress.tag));
}
function unwindWork(current, workInProgress) {
  popTreeContext(workInProgress);
  switch (workInProgress.tag) {
    case 1:
      return (
        (current = workInProgress.flags),
        current & 65536
          ? ((workInProgress.flags = (current & -65537) | 128), workInProgress)
          : null
      );
    case 3:
      return (
        popProvider(CacheContext),
        popHostContainer(),
        (current = workInProgress.flags),
        0 !== (current & 65536) && 0 === (current & 128)
          ? ((workInProgress.flags = (current & -65537) | 128), workInProgress)
          : null
      );
    case 26:
    case 27:
    case 5:
      return popHostContext(workInProgress), null;
    case 13:
      popSuspenseHandler(workInProgress);
      current = workInProgress.memoizedState;
      if (null !== current && null !== current.dehydrated) {
        if (null === workInProgress.alternate)
          throw Error(formatProdErrorMessage(340));
        resetHydrationState();
      }
      current = workInProgress.flags;
      return current & 65536
        ? ((workInProgress.flags = (current & -65537) | 128), workInProgress)
        : null;
    case 19:
      return pop(suspenseStackCursor), null;
    case 4:
      return popHostContainer(), null;
    case 10:
      return popProvider(workInProgress.type), null;
    case 22:
    case 23:
      return (
        popSuspenseHandler(workInProgress),
        popHiddenContext(),
        null !== current && pop(resumedCache),
        (current = workInProgress.flags),
        current & 65536
          ? ((workInProgress.flags = (current & -65537) | 128), workInProgress)
          : null
      );
    case 24:
      return popProvider(CacheContext), null;
    case 25:
      return null;
    default:
      return null;
  }
}
function unwindInterruptedWork(current, interruptedWork) {
  popTreeContext(interruptedWork);
  switch (interruptedWork.tag) {
    case 3:
      popProvider(CacheContext);
      popHostContainer();
      break;
    case 26:
    case 27:
    case 5:
      popHostContext(interruptedWork);
      break;
    case 4:
      popHostContainer();
      break;
    case 13:
      popSuspenseHandler(interruptedWork);
      break;
    case 19:
      pop(suspenseStackCursor);
      break;
    case 10:
      popProvider(interruptedWork.type);
      break;
    case 22:
    case 23:
      popSuspenseHandler(interruptedWork);
      popHiddenContext();
      null !== current && pop(resumedCache);
      break;
    case 24:
      popProvider(CacheContext);
  }
}
function commitHookEffectListMount(flags, finishedWork) {
  try {
    var updateQueue = finishedWork.updateQueue,
      lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
    if (null !== lastEffect) {
      var firstEffect = lastEffect.next;
      updateQueue = firstEffect;
      do {
        if ((updateQueue.tag & flags) === flags) {
          lastEffect = void 0;
          var create = updateQueue.create,
            inst = updateQueue.inst;
          lastEffect = create();
          inst.destroy = lastEffect;
        }
        updateQueue = updateQueue.next;
      } while (updateQueue !== firstEffect);
    }
  } catch (error) {
    captureCommitPhaseError(finishedWork, finishedWork.return, error);
  }
}
function commitHookEffectListUnmount(
  flags,
  finishedWork,
  nearestMountedAncestor$jscomp$0
) {
  try {
    var updateQueue = finishedWork.updateQueue,
      lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
    if (null !== lastEffect) {
      var firstEffect = lastEffect.next;
      updateQueue = firstEffect;
      do {
        if ((updateQueue.tag & flags) === flags) {
          var inst = updateQueue.inst,
            destroy = inst.destroy;
          if (void 0 !== destroy) {
            inst.destroy = void 0;
            lastEffect = finishedWork;
            var nearestMountedAncestor = nearestMountedAncestor$jscomp$0,
              destroy_ = destroy;
            try {
              destroy_();
            } catch (error) {
              captureCommitPhaseError(
                lastEffect,
                nearestMountedAncestor,
                error
              );
            }
          }
        }
        updateQueue = updateQueue.next;
      } while (updateQueue !== firstEffect);
    }
  } catch (error) {
    captureCommitPhaseError(finishedWork, finishedWork.return, error);
  }
}
function commitClassCallbacks(finishedWork) {
  var updateQueue = finishedWork.updateQueue;
  if (null !== updateQueue) {
    var instance = finishedWork.stateNode;
    try {
      commitCallbacks(updateQueue, instance);
    } catch (error) {
      captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
  }
}
function safelyCallComponentWillUnmount(
  current,
  nearestMountedAncestor,
  instance
) {
  instance.props = resolveClassComponentProps(
    current.type,
    current.memoizedProps
  );
  instance.state = current.memoizedState;
  try {
    instance.componentWillUnmount();
  } catch (error) {
    captureCommitPhaseError(current, nearestMountedAncestor, error);
  }
}
function safelyAttachRef(current, nearestMountedAncestor) {
  try {
    var ref = current.ref;
    if (null !== ref) {
      switch (current.tag) {
        case 26:
        case 27:
        case 5:
          var instanceToUse = current.stateNode;
          break;
        case 30:
          instanceToUse = current.stateNode;
          break;
        default:
          instanceToUse = current.stateNode;
      }
      "function" === typeof ref
        ? (current.refCleanup = ref(instanceToUse))
        : (ref.current = instanceToUse);
    }
  } catch (error) {
    captureCommitPhaseError(current, nearestMountedAncestor, error);
  }
}
function safelyDetachRef(current, nearestMountedAncestor) {
  var ref = current.ref,
    refCleanup = current.refCleanup;
  if (null !== ref)
    if ("function" === typeof refCleanup)
      try {
        refCleanup();
      } catch (error) {
        captureCommitPhaseError(current, nearestMountedAncestor, error);
      } finally {
        (current.refCleanup = null),
          (current = current.alternate),
          null != current && (current.refCleanup = null);
      }
    else if ("function" === typeof ref)
      try {
        ref(null);
      } catch (error$143) {
        captureCommitPhaseError(current, nearestMountedAncestor, error$143);
      }
    else ref.current = null;
}
function commitHostMount(finishedWork) {
  var type = finishedWork.type,
    props = finishedWork.memoizedProps,
    instance = finishedWork.stateNode;
  try {
    a: switch (type) {
      case "button":
      case "input":
      case "select":
      case "textarea":
        props.autoFocus && instance.focus();
        break a;
      case "img":
        props.src
          ? (instance.src = props.src)
          : props.srcSet && (instance.srcset = props.srcSet);
    }
  } catch (error) {
    captureCommitPhaseError(finishedWork, finishedWork.return, error);
  }
}
function commitHostUpdate(finishedWork, newProps, oldProps) {
  try {
    var domElement = finishedWork.stateNode;
    updateProperties(domElement, finishedWork.type, oldProps, newProps);
    domElement[internalPropsKey] = newProps;
  } catch (error) {
    captureCommitPhaseError(finishedWork, finishedWork.return, error);
  }
}
function isHostParent(fiber) {
  return (
    5 === fiber.tag ||
    3 === fiber.tag ||
    26 === fiber.tag ||
    (27 === fiber.tag && isSingletonScope(fiber.type)) ||
    4 === fiber.tag
  );
}
function getHostSibling(fiber) {
  a: for (;;) {
    for (; null === fiber.sibling; ) {
      if (null === fiber.return || isHostParent(fiber.return)) return null;
      fiber = fiber.return;
    }
    fiber.sibling.return = fiber.return;
    for (
      fiber = fiber.sibling;
      5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;

    ) {
      if (27 === fiber.tag && isSingletonScope(fiber.type)) continue a;
      if (fiber.flags & 2) continue a;
      if (null === fiber.child || 4 === fiber.tag) continue a;
      else (fiber.child.return = fiber), (fiber = fiber.child);
    }
    if (!(fiber.flags & 2)) return fiber.stateNode;
  }
}
function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
  var tag = node.tag;
  if (5 === tag || 6 === tag)
    (node = node.stateNode),
      before
        ? (9 === parent.nodeType
            ? parent.body
            : "HTML" === parent.nodeName
              ? parent.ownerDocument.body
              : parent
          ).insertBefore(node, before)
        : ((before =
            9 === parent.nodeType
              ? parent.body
              : "HTML" === parent.nodeName
                ? parent.ownerDocument.body
                : parent),
          before.appendChild(node),
          (parent = parent._reactRootContainer),
          (null !== parent && void 0 !== parent) ||
            null !== before.onclick ||
            (before.onclick = noop$1));
  else if (
    4 !== tag &&
    (27 === tag &&
      isSingletonScope(node.type) &&
      ((parent = node.stateNode), (before = null)),
    (node = node.child),
    null !== node)
  )
    for (
      insertOrAppendPlacementNodeIntoContainer(node, before, parent),
        node = node.sibling;
      null !== node;

    )
      insertOrAppendPlacementNodeIntoContainer(node, before, parent),
        (node = node.sibling);
}
function insertOrAppendPlacementNode(node, before, parent) {
  var tag = node.tag;
  if (5 === tag || 6 === tag)
    (node = node.stateNode),
      before ? parent.insertBefore(node, before) : parent.appendChild(node);
  else if (
    4 !== tag &&
    (27 === tag && isSingletonScope(node.type) && (parent = node.stateNode),
    (node = node.child),
    null !== node)
  )
    for (
      insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
      null !== node;

    )
      insertOrAppendPlacementNode(node, before, parent), (node = node.sibling);
}
function commitHostSingletonAcquisition(finishedWork) {
  var singleton = finishedWork.stateNode,
    props = finishedWork.memoizedProps;
  try {
    for (
      var type = finishedWork.type, attributes = singleton.attributes;
      attributes.length;

    )
      singleton.removeAttributeNode(attributes[0]);
    setInitialProperties(singleton, type, props);
    singleton[internalInstanceKey] = finishedWork;
    singleton[internalPropsKey] = props;
  } catch (error) {
    captureCommitPhaseError(finishedWork, finishedWork.return, error);
  }
}
var offscreenSubtreeIsHidden = false,
  offscreenSubtreeWasHidden = false,
  needsFormReset = false,
  PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set,
  nextEffect = null;
function commitBeforeMutationEffects(root, firstChild) {
  root = root.containerInfo;
  eventsEnabled = _enabled;
  root = getActiveElementDeep(root);
  if (hasSelectionCapabilities(root)) {
    if ("selectionStart" in root)
      var JSCompiler_temp = {
        start: root.selectionStart,
        end: root.selectionEnd
      };
    else
      a: {
        JSCompiler_temp =
          ((JSCompiler_temp = root.ownerDocument) &&
            JSCompiler_temp.defaultView) ||
          window;
        var selection =
          JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
        if (selection && 0 !== selection.rangeCount) {
          JSCompiler_temp = selection.anchorNode;
          var anchorOffset = selection.anchorOffset,
            focusNode = selection.focusNode;
          selection = selection.focusOffset;
          try {
            JSCompiler_temp.nodeType, focusNode.nodeType;
          } catch (e$20) {
            JSCompiler_temp = null;
            break a;
          }
          var length = 0,
            start = -1,
            end = -1,
            indexWithinAnchor = 0,
            indexWithinFocus = 0,
            node = root,
            parentNode = null;
          b: for (;;) {
            for (var next; ; ) {
              node !== JSCompiler_temp ||
                (0 !== anchorOffset && 3 !== node.nodeType) ||
                (start = length + anchorOffset);
              node !== focusNode ||
                (0 !== selection && 3 !== node.nodeType) ||
                (end = length + selection);
              3 === node.nodeType && (length += node.nodeValue.length);
              if (null === (next = node.firstChild)) break;
              parentNode = node;
              node = next;
            }
            for (;;) {
              if (node === root) break b;
              parentNode === JSCompiler_temp &&
                ++indexWithinAnchor === anchorOffset &&
                (start = length);
              parentNode === focusNode &&
                ++indexWithinFocus === selection &&
                (end = length);
              if (null !== (next = node.nextSibling)) break;
              node = parentNode;
              parentNode = node.parentNode;
            }
            node = next;
          }
          JSCompiler_temp =
            -1 === start || -1 === end ? null : { start: start, end: end };
        } else JSCompiler_temp = null;
      }
    JSCompiler_temp = JSCompiler_temp || { start: 0, end: 0 };
  } else JSCompiler_temp = null;
  selectionInformation = { focusedElem: root, selectionRange: JSCompiler_temp };
  _enabled = false;
  for (nextEffect = firstChild; null !== nextEffect; )
    if (
      ((firstChild = nextEffect),
      (root = firstChild.child),
      0 !== (firstChild.subtreeFlags & 1024) && null !== root)
    )
      (root.return = firstChild), (nextEffect = root);
    else
      for (; null !== nextEffect; ) {
        firstChild = nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch (firstChild.tag) {
          case 0:
            break;
          case 11:
          case 15:
            break;
          case 1:
            if (0 !== (root & 1024) && null !== focusNode) {
              root = void 0;
              JSCompiler_temp = firstChild;
              anchorOffset = focusNode.memoizedProps;
              focusNode = focusNode.memoizedState;
              selection = JSCompiler_temp.stateNode;
              try {
                var resolvedPrevProps = resolveClassComponentProps(
                  JSCompiler_temp.type,
                  anchorOffset,
                  JSCompiler_temp.elementType === JSCompiler_temp.type
                );
                root = selection.getSnapshotBeforeUpdate(
                  resolvedPrevProps,
                  focusNode
                );
                selection.__reactInternalSnapshotBeforeUpdate = root;
              } catch (error) {
                captureCommitPhaseError(
                  JSCompiler_temp,
                  JSCompiler_temp.return,
                  error
                );
              }
            }
            break;
          case 3:
            if (0 !== (root & 1024))
              if (
                ((root = firstChild.stateNode.containerInfo),
                (JSCompiler_temp = root.nodeType),
                9 === JSCompiler_temp)
              )
                clearContainerSparingly(root);
              else if (1 === JSCompiler_temp)
                switch (root.nodeName) {
                  case "HEAD":
                  case "HTML":
                  case "BODY":
                    clearContainerSparingly(root);
                    break;
                  default:
                    root.textContent = "";
                }
            break;
          case 5:
          case 26:
          case 27:
          case 6:
          case 4:
          case 17:
            break;
          default:
            if (0 !== (root & 1024)) throw Error(formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
          root.return = firstChild.return;
          nextEffect = root;
          break;
        }
        nextEffect = firstChild.return;
      }
}
function commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
  var flags = finishedWork.flags;
  switch (finishedWork.tag) {
    case 0:
    case 11:
    case 15:
      recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
      flags & 4 && commitHookEffectListMount(5, finishedWork);
      break;
    case 1:
      recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
      if (flags & 4)
        if (((finishedRoot = finishedWork.stateNode), null === current))
          try {
            finishedRoot.componentDidMount();
          } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
          }
        else {
          var prevProps = resolveClassComponentProps(
            finishedWork.type,
            current.memoizedProps
          );
          current = current.memoizedState;
          try {
            finishedRoot.componentDidUpdate(
              prevProps,
              current,
              finishedRoot.__reactInternalSnapshotBeforeUpdate
            );
          } catch (error$142) {
            captureCommitPhaseError(
              finishedWork,
              finishedWork.return,
              error$142
            );
          }
        }
      flags & 64 && commitClassCallbacks(finishedWork);
      flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
      break;
    case 3:
      recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
      if (
        flags & 64 &&
        ((finishedRoot = finishedWork.updateQueue), null !== finishedRoot)
      ) {
        current = null;
        if (null !== finishedWork.child)
          switch (finishedWork.child.tag) {
            case 27:
            case 5:
              current = finishedWork.child.stateNode;
              break;
            case 1:
              current = finishedWork.child.stateNode;
          }
        try {
          commitCallbacks(finishedRoot, current);
        } catch (error) {
          captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
      }
      break;
    case 27:
      null === current &&
        flags & 4 &&
        commitHostSingletonAcquisition(finishedWork);
    case 26:
    case 5:
      recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
      null === current && flags & 4 && commitHostMount(finishedWork);
      flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
      break;
    case 12:
      recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
      break;
    case 13:
      recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
      flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
      flags & 64 &&
        ((finishedRoot = finishedWork.memoizedState),
        null !== finishedRoot &&
          ((finishedRoot = finishedRoot.dehydrated),
          null !== finishedRoot &&
            ((finishedWork = retryDehydratedSuspenseBoundary.bind(
              null,
              finishedWork
            )),
            registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
      break;
    case 22:
      flags = null !== finishedWork.memoizedState || offscreenSubtreeIsHidden;
      if (!flags) {
        current =
          (null !== current && null !== current.memoizedState) ||
          offscreenSubtreeWasHidden;
        prevProps = offscreenSubtreeIsHidden;
        var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
        offscreenSubtreeIsHidden = flags;
        (offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden
          ? recursivelyTraverseReappearLayoutEffects(
              finishedRoot,
              finishedWork,
              0 !== (finishedWork.subtreeFlags & 8772)
            )
          : recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
        offscreenSubtreeIsHidden = prevProps;
        offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
      }
      break;
    case 30:
      break;
    default:
      recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
  }
}
function detachFiberAfterEffects(fiber) {
  var alternate = fiber.alternate;
  null !== alternate &&
    ((fiber.alternate = null), detachFiberAfterEffects(alternate));
  fiber.child = null;
  fiber.deletions = null;
  fiber.sibling = null;
  5 === fiber.tag &&
    ((alternate = fiber.stateNode),
    null !== alternate && detachDeletedInstance(alternate));
  fiber.stateNode = null;
  fiber.return = null;
  fiber.dependencies = null;
  fiber.memoizedProps = null;
  fiber.memoizedState = null;
  fiber.pendingProps = null;
  fiber.stateNode = null;
  fiber.updateQueue = null;
}
var hostParent = null,
  hostParentIsContainer = false;
function recursivelyTraverseDeletionEffects(
  finishedRoot,
  nearestMountedAncestor,
  parent
) {
  for (parent = parent.child; null !== parent; )
    commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent),
      (parent = parent.sibling);
}
function commitDeletionEffectsOnFiber(
  finishedRoot,
  nearestMountedAncestor,
  deletedFiber
) {
  if (injectedHook && "function" === typeof injectedHook.onCommitFiberUnmount)
    try {
      injectedHook.onCommitFiberUnmount(rendererID, deletedFiber);
    } catch (err) {}
  switch (deletedFiber.tag) {
    case 26:
      offscreenSubtreeWasHidden ||
        safelyDetachRef(deletedFiber, nearestMountedAncestor);
      recursivelyTraverseDeletionEffects(
        finishedRoot,
        nearestMountedAncestor,
        deletedFiber
      );
      deletedFiber.memoizedState
        ? deletedFiber.memoizedState.count--
        : deletedFiber.stateNode &&
          ((deletedFiber = deletedFiber.stateNode),
          deletedFiber.parentNode.removeChild(deletedFiber));
      break;
    case 27:
      offscreenSubtreeWasHidden ||
        safelyDetachRef(deletedFiber, nearestMountedAncestor);
      var prevHostParent = hostParent,
        prevHostParentIsContainer = hostParentIsContainer;
      isSingletonScope(deletedFiber.type) &&
        ((hostParent = deletedFiber.stateNode), (hostParentIsContainer = false));
      recursivelyTraverseDeletionEffects(
        finishedRoot,
        nearestMountedAncestor,
        deletedFiber
      );
      releaseSingletonInstance(deletedFiber.stateNode);
      hostParent = prevHostParent;
      hostParentIsContainer = prevHostParentIsContainer;
      break;
    case 5:
      offscreenSubtreeWasHidden ||
        safelyDetachRef(deletedFiber, nearestMountedAncestor);
    case 6:
      prevHostParent = hostParent;
      prevHostParentIsContainer = hostParentIsContainer;
      hostParent = null;
      recursivelyTraverseDeletionEffects(
        finishedRoot,
        nearestMountedAncestor,
        deletedFiber
      );
      hostParent = prevHostParent;
      hostParentIsContainer = prevHostParentIsContainer;
      if (null !== hostParent)
        if (hostParentIsContainer)
          try {
            (9 === hostParent.nodeType
              ? hostParent.body
              : "HTML" === hostParent.nodeName
                ? hostParent.ownerDocument.body
                : hostParent
            ).removeChild(deletedFiber.stateNode);
          } catch (error) {
            captureCommitPhaseError(
              deletedFiber,
              nearestMountedAncestor,
              error
            );
          }
        else
          try {
            hostParent.removeChild(deletedFiber.stateNode);
          } catch (error) {
            captureCommitPhaseError(
              deletedFiber,
              nearestMountedAncestor,
              error
            );
          }
      break;
    case 18:
      null !== hostParent &&
        (hostParentIsContainer
          ? ((finishedRoot = hostParent),
            clearSuspenseBoundary(
              9 === finishedRoot.nodeType
                ? finishedRoot.body
                : "HTML" === finishedRoot.nodeName
                  ? finishedRoot.ownerDocument.body
                  : finishedRoot,
              deletedFiber.stateNode
            ),
            retryIfBlockedOn(finishedRoot))
          : clearSuspenseBoundary(hostParent, deletedFiber.stateNode));
      break;
    case 4:
      prevHostParent = hostParent;
      prevHostParentIsContainer = hostParentIsContainer;
      hostParent = deletedFiber.stateNode.containerInfo;
      hostParentIsContainer = true;
      recursivelyTraverseDeletionEffects(
        finishedRoot,
        nearestMountedAncestor,
        deletedFiber
      );
      hostParent = prevHostParent;
      hostParentIsContainer = prevHostParentIsContainer;
      break;
    case 0:
    case 11:
    case 14:
    case 15:
      offscreenSubtreeWasHidden ||
        commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
      offscreenSubtreeWasHidden ||
        commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
      recursivelyTraverseDeletionEffects(
        finishedRoot,
        nearestMountedAncestor,
        deletedFiber
      );
      break;
    case 1:
      offscreenSubtreeWasHidden ||
        (safelyDetachRef(deletedFiber, nearestMountedAncestor),
        (prevHostParent = deletedFiber.stateNode),
        "function" === typeof prevHostParent.componentWillUnmount &&
          safelyCallComponentWillUnmount(
            deletedFiber,
            nearestMountedAncestor,
            prevHostParent
          ));
      recursivelyTraverseDeletionEffects(
        finishedRoot,
        nearestMountedAncestor,
        deletedFiber
      );
      break;
    case 21:
      recursivelyTraverseDeletionEffects(
        finishedRoot,
        nearestMountedAncestor,
        deletedFiber
      );
      break;
    case 22:
      offscreenSubtreeWasHidden =
        (prevHostParent = offscreenSubtreeWasHidden) ||
        null !== deletedFiber.memoizedState;
      recursivelyTraverseDeletionEffects(
        finishedRoot,
        nearestMountedAncestor,
        deletedFiber
      );
      offscreenSubtreeWasHidden = prevHostParent;
      break;
    default:
      recursivelyTraverseDeletionEffects(
        finishedRoot,
        nearestMountedAncestor,
        deletedFiber
      );
  }
}
function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
  if (
    null === finishedWork.memoizedState &&
    ((finishedRoot = finishedWork.alternate),
    null !== finishedRoot &&
      ((finishedRoot = finishedRoot.memoizedState),
      null !== finishedRoot &&
        ((finishedRoot = finishedRoot.dehydrated), null !== finishedRoot)))
  )
    try {
      retryIfBlockedOn(finishedRoot);
    } catch (error) {
      captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function getRetryCache(finishedWork) {
  switch (finishedWork.tag) {
    case 13:
    case 19:
      var retryCache = finishedWork.stateNode;
      null === retryCache &&
        (retryCache = finishedWork.stateNode = new PossiblyWeakSet());
      return retryCache;
    case 22:
      return (
        (finishedWork = finishedWork.stateNode),
        (retryCache = finishedWork._retryCache),
        null === retryCache &&
          (retryCache = finishedWork._retryCache = new PossiblyWeakSet()),
        retryCache
      );
    default:
      throw Error(formatProdErrorMessage(435, finishedWork.tag));
  }
}
function attachSuspenseRetryListeners(finishedWork, wakeables) {
  var retryCache = getRetryCache(finishedWork);
  wakeables.forEach(function (wakeable) {
    var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
    retryCache.has(wakeable) ||
      (retryCache.add(wakeable), wakeable.then(retry, retry));
  });
}
function recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
  var deletions = parentFiber.deletions;
  if (null !== deletions)
    for (var i = 0; i < deletions.length; i++) {
      var childToDelete = deletions[i],
        root = root$jscomp$0,
        returnFiber = parentFiber,
        parent = returnFiber;
      a: for (; null !== parent; ) {
        switch (parent.tag) {
          case 27:
            if (isSingletonScope(parent.type)) {
              hostParent = parent.stateNode;
              hostParentIsContainer = false;
              break a;
            }
            break;
          case 5:
            hostParent = parent.stateNode;
            hostParentIsContainer = false;
            break a;
          case 3:
          case 4:
            hostParent = parent.stateNode.containerInfo;
            hostParentIsContainer = true;
            break a;
        }
        parent = parent.return;
      }
      if (null === hostParent) throw Error(formatProdErrorMessage(160));
      commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
      hostParent = null;
      hostParentIsContainer = false;
      root = childToDelete.alternate;
      null !== root && (root.return = null);
      childToDelete.return = null;
    }
  if (parentFiber.subtreeFlags & 13878)
    for (parentFiber = parentFiber.child; null !== parentFiber; )
      commitMutationEffectsOnFiber(parentFiber, root$jscomp$0),
        (parentFiber = parentFiber.sibling);
}
var currentHoistableRoot = null;
function commitMutationEffectsOnFiber(finishedWork, root) {
  var current = finishedWork.alternate,
    flags = finishedWork.flags;
  switch (finishedWork.tag) {
    case 0:
    case 11:
    case 14:
    case 15:
      recursivelyTraverseMutationEffects(root, finishedWork);
      commitReconciliationEffects(finishedWork);
      flags & 4 &&
        (commitHookEffectListUnmount(3, finishedWork, finishedWork.return),
        commitHookEffectListMount(3, finishedWork),
        commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
      break;
    case 1:
      recursivelyTraverseMutationEffects(root, finishedWork);
      commitReconciliationEffects(finishedWork);
      flags & 512 &&
        (offscreenSubtreeWasHidden ||
          null === current ||
          safelyDetachRef(current, current.return));
      flags & 64 &&
        offscreenSubtreeIsHidden &&
        ((finishedWork = finishedWork.updateQueue),
        null !== finishedWork &&
          ((flags = finishedWork.callbacks),
          null !== flags &&
            ((current = finishedWork.shared.hiddenCallbacks),
            (finishedWork.shared.hiddenCallbacks =
              null === current ? flags : current.concat(flags)))));
      break;
    case 26:
      var hoistableRoot = currentHoistableRoot;
      recursivelyTraverseMutationEffects(root, finishedWork);
      commitReconciliationEffects(finishedWork);
      flags & 512 &&
        (offscreenSubtreeWasHidden ||
          null === current ||
          safelyDetachRef(current, current.return));
      if (flags & 4) {
        var currentResource = null !== current ? current.memoizedState : null;
        flags = finishedWork.memoizedState;
        if (null === current)
          if (null === flags)
            if (null === finishedWork.stateNode) {
              a: {
                flags = finishedWork.type;
                current = finishedWork.memoizedProps;
                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                b: switch (flags) {
                  case "title":
                    currentResource =
                      hoistableRoot.getElementsByTagName("title")[0];
                    if (
                      !currentResource ||
                      currentResource[internalHoistableMarker] ||
                      currentResource[internalInstanceKey] ||
                      "http://www.w3.org/2000/svg" ===
                        currentResource.namespaceURI ||
                      currentResource.hasAttribute("itemprop")
                    )
                      (currentResource = hoistableRoot.createElement(flags)),
                        hoistableRoot.head.insertBefore(
                          currentResource,
                          hoistableRoot.querySelector("head > title")
                        );
                    setInitialProperties(currentResource, flags, current);
                    currentResource[internalInstanceKey] = finishedWork;
                    markNodeAsHoistable(currentResource);
                    flags = currentResource;
                    break a;
                  case "link":
                    var maybeNodes = getHydratableHoistableCache(
                      "link",
                      "href",
                      hoistableRoot
                    ).get(flags + (current.href || ""));
                    if (maybeNodes)
                      for (var i = 0; i < maybeNodes.length; i++)
                        if (
                          ((currentResource = maybeNodes[i]),
                          currentResource.getAttribute("href") ===
                            (null == current.href || "" === current.href
                              ? null
                              : current.href) &&
                            currentResource.getAttribute("rel") ===
                              (null == current.rel ? null : current.rel) &&
                            currentResource.getAttribute("title") ===
                              (null == current.title ? null : current.title) &&
                            currentResource.getAttribute("crossorigin") ===
                              (null == current.crossOrigin
                                ? null
                                : current.crossOrigin))
                        ) {
                          maybeNodes.splice(i, 1);
                          break b;
                        }
                    currentResource = hoistableRoot.createElement(flags);
                    setInitialProperties(currentResource, flags, current);
                    hoistableRoot.head.appendChild(currentResource);
                    break;
                  case "meta":
                    if (
                      (maybeNodes = getHydratableHoistableCache(
                        "meta",
                        "content",
                        hoistableRoot
                      ).get(flags + (current.content || "")))
                    )
                      for (i = 0; i < maybeNodes.length; i++)
                        if (
                          ((currentResource = maybeNodes[i]),
                          currentResource.getAttribute("content") ===
                            (null == current.content
                              ? null
                              : "" + current.content) &&
                            currentResource.getAttribute("name") ===
                              (null == current.name ? null : current.name) &&
                            currentResource.getAttribute("property") ===
                              (null == current.property
                                ? null
                                : current.property) &&
                            currentResource.getAttribute("http-equiv") ===
                              (null == current.httpEquiv
                                ? null
                                : current.httpEquiv) &&
                            currentResource.getAttribute("charset") ===
                              (null == current.charSet
                                ? null
                                : current.charSet))
                        ) {
                          maybeNodes.splice(i, 1);
                          break b;
                        }
                    currentResource = hoistableRoot.createElement(flags);
                    setInitialProperties(currentResource, flags, current);
                    hoistableRoot.head.appendChild(currentResource);
                    break;
                  default:
                    throw Error(formatProdErrorMessage(468, flags));
                }
                currentResource[internalInstanceKey] = finishedWork;
                markNodeAsHoistable(currentResource);
                flags = currentResource;
              }
              finishedWork.stateNode = flags;
            } else
              mountHoistable(
                hoistableRoot,
                finishedWork.type,
                finishedWork.stateNode
              );
          else
            finishedWork.stateNode = acquireResource(
              hoistableRoot,
              flags,
              finishedWork.memoizedProps
            );
        else
          currentResource !== flags
            ? (null === currentResource
                ? null !== current.stateNode &&
                  ((current = current.stateNode),
                  current.parentNode.removeChild(current))
                : currentResource.count--,
              null === flags
                ? mountHoistable(
                    hoistableRoot,
                    finishedWork.type,
                    finishedWork.stateNode
                  )
                : acquireResource(
                    hoistableRoot,
                    flags,
                    finishedWork.memoizedProps
                  ))
            : null === flags &&
              null !== finishedWork.stateNode &&
              commitHostUpdate(
                finishedWork,
                finishedWork.memoizedProps,
                current.memoizedProps
              );
      }
      break;
    case 27:
      recursivelyTraverseMutationEffects(root, finishedWork);
      commitReconciliationEffects(finishedWork);
      flags & 512 &&
        (offscreenSubtreeWasHidden ||
          null === current ||
          safelyDetachRef(current, current.return));
      null !== current &&
        flags & 4 &&
        commitHostUpdate(
          finishedWork,
          finishedWork.memoizedProps,
          current.memoizedProps
        );
      break;
    case 5:
      recursivelyTraverseMutationEffects(root, finishedWork);
      commitReconciliationEffects(finishedWork);
      flags & 512 &&
        (offscreenSubtreeWasHidden ||
          null === current ||
          safelyDetachRef(current, current.return));
      if (finishedWork.flags & 32) {
        hoistableRoot = finishedWork.stateNode;
        try {
          setTextContent(hoistableRoot, "");
        } catch (error) {
          captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
      }
      flags & 4 &&
        null != finishedWork.stateNode &&
        ((hoistableRoot = finishedWork.memoizedProps),
        commitHostUpdate(
          finishedWork,
          hoistableRoot,
          null !== current ? current.memoizedProps : hoistableRoot
        ));
      flags & 1024 && (needsFormReset = true);
      break;
    case 6:
      recursivelyTraverseMutationEffects(root, finishedWork);
      commitReconciliationEffects(finishedWork);
      if (flags & 4) {
        if (null === finishedWork.stateNode)
          throw Error(formatProdErrorMessage(162));
        flags = finishedWork.memoizedProps;
        current = finishedWork.stateNode;
        try {
          current.nodeValue = flags;
        } catch (error) {
          captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
      }
      break;
    case 3:
      tagCaches = null;
      hoistableRoot = currentHoistableRoot;
      currentHoistableRoot = getHoistableRoot(root.containerInfo);
      recursivelyTraverseMutationEffects(root, finishedWork);
      currentHoistableRoot = hoistableRoot;
      commitReconciliationEffects(finishedWork);
      if (flags & 4 && null !== current && current.memoizedState.isDehydrated)
        try {
          retryIfBlockedOn(root.containerInfo);
        } catch (error) {
          captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
      needsFormReset &&
        ((needsFormReset = false), recursivelyResetForms(finishedWork));
      break;
    case 4:
      flags = currentHoistableRoot;
      currentHoistableRoot = getHoistableRoot(
        finishedWork.stateNode.containerInfo
      );
      recursivelyTraverseMutationEffects(root, finishedWork);
      commitReconciliationEffects(finishedWork);
      currentHoistableRoot = flags;
      break;
    case 12:
      recursivelyTraverseMutationEffects(root, finishedWork);
      commitReconciliationEffects(finishedWork);
      break;
    case 13:
      recursivelyTraverseMutationEffects(root, finishedWork);
      commitReconciliationEffects(finishedWork);
      finishedWork.child.flags & 8192 &&
        (null !== finishedWork.memoizedState) !==
          (null !== current && null !== current.memoizedState) &&
        (globalMostRecentFallbackTime = now$1());
      flags & 4 &&
        ((flags = finishedWork.updateQueue),
        null !== flags &&
          ((finishedWork.updateQueue = null),
          attachSuspenseRetryListeners(finishedWork, flags)));
      break;
    case 22:
      hoistableRoot = null !== finishedWork.memoizedState;
      var wasHidden = null !== current && null !== current.memoizedState,
        prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden,
        prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
      offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
      offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
      recursivelyTraverseMutationEffects(root, finishedWork);
      offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
      offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
      commitReconciliationEffects(finishedWork);
      if (flags & 8192)
        a: for (
          root = finishedWork.stateNode,
            root._visibility = hoistableRoot
              ? root._visibility & -2
              : root._visibility | 1,
            hoistableRoot &&
              (null === current ||
                wasHidden ||
                offscreenSubtreeIsHidden ||
                offscreenSubtreeWasHidden ||
                recursivelyTraverseDisappearLayoutEffects(finishedWork)),
            current = null,
            root = finishedWork;
          ;

        ) {
          if (5 === root.tag || 26 === root.tag) {
            if (null === current) {
              wasHidden = current = root;
              try {
                if (((currentResource = wasHidden.stateNode), hoistableRoot))
                  (maybeNodes = currentResource.style),
                    "function" === typeof maybeNodes.setProperty
                      ? maybeNodes.setProperty("display", "none", "important")
                      : (maybeNodes.display = "none");
                else {
                  i = wasHidden.stateNode;
                  var styleProp = wasHidden.memoizedProps.style,
                    display =
                      void 0 !== styleProp &&
                      null !== styleProp &&
                      styleProp.hasOwnProperty("display")
                        ? styleProp.display
                        : null;
                  i.style.display =
                    null == display || "boolean" === typeof display
                      ? ""
                      : ("" + display).trim();
                }
              } catch (error) {
                captureCommitPhaseError(wasHidden, wasHidden.return, error);
              }
            }
          } else if (6 === root.tag) {
            if (null === current) {
              wasHidden = root;
              try {
                wasHidden.stateNode.nodeValue = hoistableRoot
                  ? ""
                  : wasHidden.memoizedProps;
              } catch (error) {
                captureCommitPhaseError(wasHidden, wasHidden.return, error);
              }
            }
          } else if (
            ((22 !== root.tag && 23 !== root.tag) ||
              null === root.memoizedState ||
              root === finishedWork) &&
            null !== root.child
          ) {
            root.child.return = root;
            root = root.child;
            continue;
          }
          if (root === finishedWork) break a;
          for (; null === root.sibling; ) {
            if (null === root.return || root.return === finishedWork) break a;
            current === root && (current = null);
            root = root.return;
          }
          current === root && (current = null);
          root.sibling.return = root.return;
          root = root.sibling;
        }
      flags & 4 &&
        ((flags = finishedWork.updateQueue),
        null !== flags &&
          ((current = flags.retryQueue),
          null !== current &&
            ((flags.retryQueue = null),
            attachSuspenseRetryListeners(finishedWork, current))));
      break;
    case 19:
      recursivelyTraverseMutationEffects(root, finishedWork);
      commitReconciliationEffects(finishedWork);
      flags & 4 &&
        ((flags = finishedWork.updateQueue),
        null !== flags &&
          ((finishedWork.updateQueue = null),
          attachSuspenseRetryListeners(finishedWork, flags)));
      break;
    case 30:
      break;
    case 21:
      break;
    default:
      recursivelyTraverseMutationEffects(root, finishedWork),
        commitReconciliationEffects(finishedWork);
  }
}
function commitReconciliationEffects(finishedWork) {
  var flags = finishedWork.flags;
  if (flags & 2) {
    try {
      for (
        var hostParentFiber, parentFiber = finishedWork.return;
        null !== parentFiber;

      ) {
        if (isHostParent(parentFiber)) {
          hostParentFiber = parentFiber;
          break;
        }
        parentFiber = parentFiber.return;
      }
      if (null == hostParentFiber) throw Error(formatProdErrorMessage(160));
      switch (hostParentFiber.tag) {
        case 27:
          var parent = hostParentFiber.stateNode,
            before = getHostSibling(finishedWork);
          insertOrAppendPlacementNode(finishedWork, before, parent);
          break;
        case 5:
          var parent$144 = hostParentFiber.stateNode;
          hostParentFiber.flags & 32 &&
            (setTextContent(parent$144, ""), (hostParentFiber.flags &= -33));
          var before$145 = getHostSibling(finishedWork);
          insertOrAppendPlacementNode(finishedWork, before$145, parent$144);
          break;
        case 3:
        case 4:
          var parent$146 = hostParentFiber.stateNode.containerInfo,
            before$147 = getHostSibling(finishedWork);
          insertOrAppendPlacementNodeIntoContainer(
            finishedWork,
            before$147,
            parent$146
          );
          break;
        default:
          throw Error(formatProdErrorMessage(161));
      }
    } catch (error) {
      captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
    finishedWork.flags &= -3;
  }
  flags & 4096 && (finishedWork.flags &= -4097);
}
function recursivelyResetForms(parentFiber) {
  if (parentFiber.subtreeFlags & 1024)
    for (parentFiber = parentFiber.child; null !== parentFiber; ) {
      var fiber = parentFiber;
      recursivelyResetForms(fiber);
      5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
      parentFiber = parentFiber.sibling;
    }
}
function recursivelyTraverseLayoutEffects(root, parentFiber) {
  if (parentFiber.subtreeFlags & 8772)
    for (parentFiber = parentFiber.child; null !== parentFiber; )
      commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber),
        (parentFiber = parentFiber.sibling);
}
function recursivelyTraverseDisappearLayoutEffects(parentFiber) {
  for (parentFiber = parentFiber.child; null !== parentFiber; ) {
    var finishedWork = parentFiber;
    switch (finishedWork.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
        recursivelyTraverseDisappearLayoutEffects(finishedWork);
        break;
      case 1:
        safelyDetachRef(finishedWork, finishedWork.return);
        var instance = finishedWork.stateNode;
        "function" === typeof instance.componentWillUnmount &&
          safelyCallComponentWillUnmount(
            finishedWork,
            finishedWork.return,
            instance
          );
        recursivelyTraverseDisappearLayoutEffects(finishedWork);
        break;
      case 27:
        releaseSingletonInstance(finishedWork.stateNode);
      case 26:
      case 5:
        safelyDetachRef(finishedWork, finishedWork.return);
        recursivelyTraverseDisappearLayoutEffects(finishedWork);
        break;
      case 22:
        null === finishedWork.memoizedState &&
          recursivelyTraverseDisappearLayoutEffects(finishedWork);
        break;
      case 30:
        recursivelyTraverseDisappearLayoutEffects(finishedWork);
        break;
      default:
        recursivelyTraverseDisappearLayoutEffects(finishedWork);
    }
    parentFiber = parentFiber.sibling;
  }
}
function recursivelyTraverseReappearLayoutEffects(
  finishedRoot$jscomp$0,
  parentFiber,
  includeWorkInProgressEffects
) {
  includeWorkInProgressEffects =
    includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
  for (parentFiber = parentFiber.child; null !== parentFiber; ) {
    var current = parentFiber.alternate,
      finishedRoot = finishedRoot$jscomp$0,
      finishedWork = parentFiber,
      flags = finishedWork.flags;
    switch (finishedWork.tag) {
      case 0:
      case 11:
      case 15:
        recursivelyTraverseReappearLayoutEffects(
          finishedRoot,
          finishedWork,
          includeWorkInProgressEffects
        );
        commitHookEffectListMount(4, finishedWork);
        break;
      case 1:
        recursivelyTraverseReappearLayoutEffects(
          finishedRoot,
          finishedWork,
          includeWorkInProgressEffects
        );
        current = finishedWork;
        finishedRoot = current.stateNode;
        if ("function" === typeof finishedRoot.componentDidMount)
          try {
            finishedRoot.componentDidMount();
          } catch (error) {
            captureCommitPhaseError(current, current.return, error);
          }
        current = finishedWork;
        finishedRoot = current.updateQueue;
        if (null !== finishedRoot) {
          var instance = current.stateNode;
          try {
            var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
            if (null !== hiddenCallbacks)
              for (
                finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0;
                finishedRoot < hiddenCallbacks.length;
                finishedRoot++
              )
                callCallback(hiddenCallbacks[finishedRoot], instance);
          } catch (error) {
            captureCommitPhaseError(current, current.return, error);
          }
        }
        includeWorkInProgressEffects &&
          flags & 64 &&
          commitClassCallbacks(finishedWork);
        safelyAttachRef(finishedWork, finishedWork.return);
        break;
      case 27:
        commitHostSingletonAcquisition(finishedWork);
      case 26:
      case 5:
        recursivelyTraverseReappearLayoutEffects(
          finishedRoot,
          finishedWork,
          includeWorkInProgressEffects
        );
        includeWorkInProgressEffects &&
          null === current &&
          flags & 4 &&
          commitHostMount(finishedWork);
        safelyAttachRef(finishedWork, finishedWork.return);
        break;
      case 12:
        recursivelyTraverseReappearLayoutEffects(
          finishedRoot,
          finishedWork,
          includeWorkInProgressEffects
        );
        break;
      case 13:
        recursivelyTraverseReappearLayoutEffects(
          finishedRoot,
          finishedWork,
          includeWorkInProgressEffects
        );
        includeWorkInProgressEffects &&
          flags & 4 &&
          commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
        break;
      case 22:
        null === finishedWork.memoizedState &&
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
        safelyAttachRef(finishedWork, finishedWork.return);
        break;
      case 30:
        break;
      default:
        recursivelyTraverseReappearLayoutEffects(
          finishedRoot,
          finishedWork,
          includeWorkInProgressEffects
        );
    }
    parentFiber = parentFiber.sibling;
  }
}
function commitOffscreenPassiveMountEffects(current, finishedWork) {
  var previousCache = null;
  null !== current &&
    null !== current.memoizedState &&
    null !== current.memoizedState.cachePool &&
    (previousCache = current.memoizedState.cachePool.pool);
  current = null;
  null !== finishedWork.memoizedState &&
    null !== finishedWork.memoizedState.cachePool &&
    (current = finishedWork.memoizedState.cachePool.pool);
  current !== previousCache &&
    (null != current && current.refCount++,
    null != previousCache && releaseCache(previousCache));
}
function commitCachePassiveMountEffect(current, finishedWork) {
  current = null;
  null !== finishedWork.alternate &&
    (current = finishedWork.alternate.memoizedState.cache);
  finishedWork = finishedWork.memoizedState.cache;
  finishedWork !== current &&
    (finishedWork.refCount++, null != current && releaseCache(current));
}
function recursivelyTraversePassiveMountEffects(
  root,
  parentFiber,
  committedLanes,
  committedTransitions
) {
  if (parentFiber.subtreeFlags & 10256)
    for (parentFiber = parentFiber.child; null !== parentFiber; )
      commitPassiveMountOnFiber(
        root,
        parentFiber,
        committedLanes,
        committedTransitions
      ),
        (parentFiber = parentFiber.sibling);
}
function commitPassiveMountOnFiber(
  finishedRoot,
  finishedWork,
  committedLanes,
  committedTransitions
) {
  var flags = finishedWork.flags;
  switch (finishedWork.tag) {
    case 0:
    case 11:
    case 15:
      recursivelyTraversePassiveMountEffects(
        finishedRoot,
        finishedWork,
        committedLanes,
        committedTransitions
      );
      flags & 2048 && commitHookEffectListMount(9, finishedWork);
      break;
    case 1:
      recursivelyTraversePassiveMountEffects(
        finishedRoot,
        finishedWork,
        committedLanes,
        committedTransitions
      );
      break;
    case 3:
      recursivelyTraversePassiveMountEffects(
        finishedRoot,
        finishedWork,
        committedLanes,
        committedTransitions
      );
      flags & 2048 &&
        ((finishedRoot = null),
        null !== finishedWork.alternate &&
          (finishedRoot = finishedWork.alternate.memoizedState.cache),
        (finishedWork = finishedWork.memoizedState.cache),
        finishedWork !== finishedRoot &&
          (finishedWork.refCount++,
          null != finishedRoot && releaseCache(finishedRoot)));
      break;
    case 12:
      if (flags & 2048) {
        recursivelyTraversePassiveMountEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions
        );
        finishedRoot = finishedWork.stateNode;
        try {
          var _finishedWork$memoize2 = finishedWork.memoizedProps,
            id = _finishedWork$memoize2.id,
            onPostCommit = _finishedWork$memoize2.onPostCommit;
          "function" === typeof onPostCommit &&
            onPostCommit(
              id,
              null === finishedWork.alternate ? "mount" : "update",
              finishedRoot.passiveEffectDuration,
              -0
            );
        } catch (error) {
          captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
      } else
        recursivelyTraversePassiveMountEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions
        );
      break;
    case 13:
      recursivelyTraversePassiveMountEffects(
        finishedRoot,
        finishedWork,
        committedLanes,
        committedTransitions
      );
      break;
    case 23:
      break;
    case 22:
      _finishedWork$memoize2 = finishedWork.stateNode;
      id = finishedWork.alternate;
      null !== finishedWork.memoizedState
        ? _finishedWork$memoize2._visibility & 2
          ? recursivelyTraversePassiveMountEffects(
              finishedRoot,
              finishedWork,
              committedLanes,
              committedTransitions
            )
          : recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork)
        : _finishedWork$memoize2._visibility & 2
          ? recursivelyTraversePassiveMountEffects(
              finishedRoot,
              finishedWork,
              committedLanes,
              committedTransitions
            )
          : ((_finishedWork$memoize2._visibility |= 2),
            recursivelyTraverseReconnectPassiveEffects(
              finishedRoot,
              finishedWork,
              committedLanes,
              committedTransitions,
              0 !== (finishedWork.subtreeFlags & 10256)
            ));
      flags & 2048 && commitOffscreenPassiveMountEffects(id, finishedWork);
      break;
    case 24:
      recursivelyTraversePassiveMountEffects(
        finishedRoot,
        finishedWork,
        committedLanes,
        committedTransitions
      );
      flags & 2048 &&
        commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
      break;
    default:
      recursivelyTraversePassiveMountEffects(
        finishedRoot,
        finishedWork,
        committedLanes,
        committedTransitions
      );
  }
}
function recursivelyTraverseReconnectPassiveEffects(
  finishedRoot$jscomp$0,
  parentFiber,
  committedLanes$jscomp$0,
  committedTransitions$jscomp$0,
  includeWorkInProgressEffects
) {
  includeWorkInProgressEffects =
    includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
  for (parentFiber = parentFiber.child; null !== parentFiber; ) {
    var finishedRoot = finishedRoot$jscomp$0,
      finishedWork = parentFiber,
      committedLanes = committedLanes$jscomp$0,
      committedTransitions = committedTransitions$jscomp$0,
      flags = finishedWork.flags;
    switch (finishedWork.tag) {
      case 0:
      case 11:
      case 15:
        recursivelyTraverseReconnectPassiveEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions,
          includeWorkInProgressEffects
        );
        commitHookEffectListMount(8, finishedWork);
        break;
      case 23:
        break;
      case 22:
        var instance = finishedWork.stateNode;
        null !== finishedWork.memoizedState
          ? instance._visibility & 2
            ? recursivelyTraverseReconnectPassiveEffects(
                finishedRoot,
                finishedWork,
                committedLanes,
                committedTransitions,
                includeWorkInProgressEffects
              )
            : recursivelyTraverseAtomicPassiveEffects(
                finishedRoot,
                finishedWork
              )
          : ((instance._visibility |= 2),
            recursivelyTraverseReconnectPassiveEffects(
              finishedRoot,
              finishedWork,
              committedLanes,
              committedTransitions,
              includeWorkInProgressEffects
            ));
        includeWorkInProgressEffects &&
          flags & 2048 &&
          commitOffscreenPassiveMountEffects(
            finishedWork.alternate,
            finishedWork
          );
        break;
      case 24:
        recursivelyTraverseReconnectPassiveEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions,
          includeWorkInProgressEffects
        );
        includeWorkInProgressEffects &&
          flags & 2048 &&
          commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
        break;
      default:
        recursivelyTraverseReconnectPassiveEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions,
          includeWorkInProgressEffects
        );
    }
    parentFiber = parentFiber.sibling;
  }
}
function recursivelyTraverseAtomicPassiveEffects(
  finishedRoot$jscomp$0,
  parentFiber
) {
  if (parentFiber.subtreeFlags & 10256)
    for (parentFiber = parentFiber.child; null !== parentFiber; ) {
      var finishedRoot = finishedRoot$jscomp$0,
        finishedWork = parentFiber,
        flags = finishedWork.flags;
      switch (finishedWork.tag) {
        case 22:
          recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
          flags & 2048 &&
            commitOffscreenPassiveMountEffects(
              finishedWork.alternate,
              finishedWork
            );
          break;
        case 24:
          recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
          flags & 2048 &&
            commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
          break;
        default:
          recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
      }
      parentFiber = parentFiber.sibling;
    }
}
var suspenseyCommitFlag = 8192;
function recursivelyAccumulateSuspenseyCommit(parentFiber) {
  if (parentFiber.subtreeFlags & suspenseyCommitFlag)
    for (parentFiber = parentFiber.child; null !== parentFiber; )
      accumulateSuspenseyCommitOnFiber(parentFiber),
        (parentFiber = parentFiber.sibling);
}
function accumulateSuspenseyCommitOnFiber(fiber) {
  switch (fiber.tag) {
    case 26:
      recursivelyAccumulateSuspenseyCommit(fiber);
      fiber.flags & suspenseyCommitFlag &&
        null !== fiber.memoizedState &&
        suspendResource(
          currentHoistableRoot,
          fiber.memoizedState,
          fiber.memoizedProps
        );
      break;
    case 5:
      recursivelyAccumulateSuspenseyCommit(fiber);
      break;
    case 3:
    case 4:
      var previousHoistableRoot = currentHoistableRoot;
      currentHoistableRoot = getHoistableRoot(fiber.stateNode.containerInfo);
      recursivelyAccumulateSuspenseyCommit(fiber);
      currentHoistableRoot = previousHoistableRoot;
      break;
    case 22:
      null === fiber.memoizedState &&
        ((previousHoistableRoot = fiber.alternate),
        null !== previousHoistableRoot &&
        null !== previousHoistableRoot.memoizedState
          ? ((previousHoistableRoot = suspenseyCommitFlag),
            (suspenseyCommitFlag = 16777216),
            recursivelyAccumulateSuspenseyCommit(fiber),
            (suspenseyCommitFlag = previousHoistableRoot))
          : recursivelyAccumulateSuspenseyCommit(fiber));
      break;
    default:
      recursivelyAccumulateSuspenseyCommit(fiber);
  }
}
function detachAlternateSiblings(parentFiber) {
  var previousFiber = parentFiber.alternate;
  if (
    null !== previousFiber &&
    ((parentFiber = previousFiber.child), null !== parentFiber)
  ) {
    previousFiber.child = null;
    do
      (previousFiber = parentFiber.sibling),
        (parentFiber.sibling = null),
        (parentFiber = previousFiber);
    while (null !== parentFiber);
  }
}
function recursivelyTraversePassiveUnmountEffects(parentFiber) {
  var deletions = parentFiber.deletions;
  if (0 !== (parentFiber.flags & 16)) {
    if (null !== deletions)
      for (var i = 0; i < deletions.length; i++) {
        var childToDelete = deletions[i];
        nextEffect = childToDelete;
        commitPassiveUnmountEffectsInsideOfDeletedTree_begin(
          childToDelete,
          parentFiber
        );
      }
    detachAlternateSiblings(parentFiber);
  }
  if (parentFiber.subtreeFlags & 10256)
    for (parentFiber = parentFiber.child; null !== parentFiber; )
      commitPassiveUnmountOnFiber(parentFiber),
        (parentFiber = parentFiber.sibling);
}
function commitPassiveUnmountOnFiber(finishedWork) {
  switch (finishedWork.tag) {
    case 0:
    case 11:
    case 15:
      recursivelyTraversePassiveUnmountEffects(finishedWork);
      finishedWork.flags & 2048 &&
        commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
      break;
    case 3:
      recursivelyTraversePassiveUnmountEffects(finishedWork);
      break;
    case 12:
      recursivelyTraversePassiveUnmountEffects(finishedWork);
      break;
    case 22:
      var instance = finishedWork.stateNode;
      null !== finishedWork.memoizedState &&
      instance._visibility & 2 &&
      (null === finishedWork.return || 13 !== finishedWork.return.tag)
        ? ((instance._visibility &= -3),
          recursivelyTraverseDisconnectPassiveEffects(finishedWork))
        : recursivelyTraversePassiveUnmountEffects(finishedWork);
      break;
    default:
      recursivelyTraversePassiveUnmountEffects(finishedWork);
  }
}
function recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
  var deletions = parentFiber.deletions;
  if (0 !== (parentFiber.flags & 16)) {
    if (null !== deletions)
      for (var i = 0; i < deletions.length; i++) {
        var childToDelete = deletions[i];
        nextEffect = childToDelete;
        commitPassiveUnmountEffectsInsideOfDeletedTree_begin(
          childToDelete,
          parentFiber
        );
      }
    detachAlternateSiblings(parentFiber);
  }
  for (parentFiber = parentFiber.child; null !== parentFiber; ) {
    deletions = parentFiber;
    switch (deletions.tag) {
      case 0:
      case 11:
      case 15:
        commitHookEffectListUnmount(8, deletions, deletions.return);
        recursivelyTraverseDisconnectPassiveEffects(deletions);
        break;
      case 22:
        i = deletions.stateNode;
        i._visibility & 2 &&
          ((i._visibility &= -3),
          recursivelyTraverseDisconnectPassiveEffects(deletions));
        break;
      default:
        recursivelyTraverseDisconnectPassiveEffects(deletions);
    }
    parentFiber = parentFiber.sibling;
  }
}
function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(
  deletedSubtreeRoot,
  nearestMountedAncestor
) {
  for (; null !== nextEffect; ) {
    var fiber = nextEffect;
    switch (fiber.tag) {
      case 0:
      case 11:
      case 15:
        commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
        break;
      case 23:
      case 22:
        if (
          null !== fiber.memoizedState &&
          null !== fiber.memoizedState.cachePool
        ) {
          var cache = fiber.memoizedState.cachePool.pool;
          null != cache && cache.refCount++;
        }
        break;
      case 24:
        releaseCache(fiber.memoizedState.cache);
    }
    cache = fiber.child;
    if (null !== cache) (cache.return = fiber), (nextEffect = cache);
    else
      a: for (fiber = deletedSubtreeRoot; null !== nextEffect; ) {
        cache = nextEffect;
        var sibling = cache.sibling,
          returnFiber = cache.return;
        detachFiberAfterEffects(cache);
        if (cache === fiber) {
          nextEffect = null;
          break a;
        }
        if (null !== sibling) {
          sibling.return = returnFiber;
          nextEffect = sibling;
          break a;
        }
        nextEffect = returnFiber;
      }
  }
}
var DefaultAsyncDispatcher = {
    getCacheForType: function (resourceType) {
      var cache = readContext(CacheContext),
        cacheForType = cache.data.get(resourceType);
      void 0 === cacheForType &&
        ((cacheForType = resourceType()),
        cache.data.set(resourceType, cacheForType));
      return cacheForType;
    }
  },
  PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map,
  executionContext = 0,
  workInProgressRoot = null,
  workInProgress = null,
  workInProgressRootRenderLanes = 0,
  workInProgressSuspendedReason = 0,
  workInProgressThrownValue = null,
  workInProgressRootDidSkipSuspendedSiblings = false,
  workInProgressRootIsPrerendering = false,
  workInProgressRootDidAttachPingListener = false,
  entangledRenderLanes = 0,
  workInProgressRootExitStatus = 0,
  workInProgressRootSkippedLanes = 0,
  workInProgressRootInterleavedUpdatedLanes = 0,
  workInProgressRootPingedLanes = 0,
  workInProgressDeferredLane = 0,
  workInProgressSuspendedRetryLanes = 0,
  workInProgressRootConcurrentErrors = null,
  workInProgressRootRecoverableErrors = null,
  workInProgressRootDidIncludeRecursiveRenderUpdate = false,
  globalMostRecentFallbackTime = 0,
  workInProgressRootRenderTargetTime = Infinity,
  workInProgressTransitions = null,
  legacyErrorBoundariesThatAlreadyFailed = null,
  pendingEffectsStatus = 0,
  pendingEffectsRoot = null,
  pendingFinishedWork = null,
  pendingEffectsLanes = 0,
  pendingEffectsRemainingLanes = 0,
  pendingPassiveTransitions = null,
  pendingRecoverableErrors = null,
  nestedUpdateCount = 0,
  rootWithNestedUpdates = null;
function requestUpdateLane() {
  if (0 !== (executionContext & 2) && 0 !== workInProgressRootRenderLanes)
    return workInProgressRootRenderLanes & -workInProgressRootRenderLanes;
  if (null !== ReactSharedInternals.T) {
    var actionScopeLane = currentEntangledLane;
    return 0 !== actionScopeLane ? actionScopeLane : requestTransitionLane();
  }
  return resolveUpdatePriority();
}
function requestDeferredLane() {
  0 === workInProgressDeferredLane &&
    (workInProgressDeferredLane =
      0 === (workInProgressRootRenderLanes & 536870912) || isHydrating
        ? claimNextTransitionLane()
        : 536870912);
  var suspenseHandler = suspenseHandlerStackCursor.current;
  null !== suspenseHandler && (suspenseHandler.flags |= 32);
  return workInProgressDeferredLane;
}
function scheduleUpdateOnFiber(root, fiber, lane) {
  if (
    (root === workInProgressRoot &&
      (2 === workInProgressSuspendedReason ||
        9 === workInProgressSuspendedReason)) ||
    null !== root.cancelPendingCommit
  )
    prepareFreshStack(root, 0),
      markRootSuspended(
        root,
        workInProgressRootRenderLanes,
        workInProgressDeferredLane,
        false
      );
  markRootUpdated$1(root, lane);
  if (0 === (executionContext & 2) || root !== workInProgressRoot)
    root === workInProgressRoot &&
      (0 === (executionContext & 2) &&
        (workInProgressRootInterleavedUpdatedLanes |= lane),
      4 === workInProgressRootExitStatus &&
        markRootSuspended(
          root,
          workInProgressRootRenderLanes,
          workInProgressDeferredLane,
          false
        )),
      ensureRootIsScheduled(root);
}
function performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
  if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(327));
  var shouldTimeSlice =
      (!forceSync &&
        0 === (lanes & 124) &&
        0 === (lanes & root$jscomp$0.expiredLanes)) ||
      checkIfRootIsPrerendering(root$jscomp$0, lanes),
    exitStatus = shouldTimeSlice
      ? renderRootConcurrent(root$jscomp$0, lanes)
      : renderRootSync(root$jscomp$0, lanes, true),
    renderWasConcurrent = shouldTimeSlice;
  do {
    if (0 === exitStatus) {
      workInProgressRootIsPrerendering &&
        !shouldTimeSlice &&
        markRootSuspended(root$jscomp$0, lanes, 0, false);
      break;
    } else {
      forceSync = root$jscomp$0.current.alternate;
      if (
        renderWasConcurrent &&
        !isRenderConsistentWithExternalStores(forceSync)
      ) {
        exitStatus = renderRootSync(root$jscomp$0, lanes, false);
        renderWasConcurrent = false;
        continue;
      }
      if (2 === exitStatus) {
        renderWasConcurrent = lanes;
        if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent)
          var JSCompiler_inline_result = 0;
        else
          (JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913),
            (JSCompiler_inline_result =
              0 !== JSCompiler_inline_result
                ? JSCompiler_inline_result
                : JSCompiler_inline_result & 536870912
                  ? 536870912
                  : 0);
        if (0 !== JSCompiler_inline_result) {
          lanes = JSCompiler_inline_result;
          a: {
            var root = root$jscomp$0;
            exitStatus = workInProgressRootConcurrentErrors;
            var wasRootDehydrated = root.current.memoizedState.isDehydrated;
            wasRootDehydrated &&
              (prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
            JSCompiler_inline_result = renderRootSync(
              root,
              JSCompiler_inline_result,
              false
            );
            if (2 !== JSCompiler_inline_result) {
              if (
                workInProgressRootDidAttachPingListener &&
                !wasRootDehydrated
              ) {
                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                workInProgressRootInterleavedUpdatedLanes |=
                  renderWasConcurrent;
                exitStatus = 4;
                break a;
              }
              renderWasConcurrent = workInProgressRootRecoverableErrors;
              workInProgressRootRecoverableErrors = exitStatus;
              null !== renderWasConcurrent &&
                (null === workInProgressRootRecoverableErrors
                  ? (workInProgressRootRecoverableErrors = renderWasConcurrent)
                  : workInProgressRootRecoverableErrors.push.apply(
                      workInProgressRootRecoverableErrors,
                      renderWasConcurrent
                    ));
            }
            exitStatus = JSCompiler_inline_result;
          }
          renderWasConcurrent = false;
          if (2 !== exitStatus) continue;
        }
      }
      if (1 === exitStatus) {
        prepareFreshStack(root$jscomp$0, 0);
        markRootSuspended(root$jscomp$0, lanes, 0, true);
        break;
      }
      a: {
        shouldTimeSlice = root$jscomp$0;
        renderWasConcurrent = exitStatus;
        switch (renderWasConcurrent) {
          case 0:
          case 1:
            throw Error(formatProdErrorMessage(345));
          case 4:
            if ((lanes & 4194048) !== lanes) break;
          case 6:
            markRootSuspended(
              shouldTimeSlice,
              lanes,
              workInProgressDeferredLane,
              !workInProgressRootDidSkipSuspendedSiblings
            );
            break a;
          case 2:
            workInProgressRootRecoverableErrors = null;
            break;
          case 3:
          case 5:
            break;
          default:
            throw Error(formatProdErrorMessage(329));
        }
        if (
          (lanes & 62914560) === lanes &&
          ((exitStatus = globalMostRecentFallbackTime + 300 - now$1()),
          10 < exitStatus)
        ) {
          markRootSuspended(
            shouldTimeSlice,
            lanes,
            workInProgressDeferredLane,
            !workInProgressRootDidSkipSuspendedSiblings
          );
          if (0 !== getNextLanes(shouldTimeSlice, 0, true)) break a;
          shouldTimeSlice.timeoutHandle = scheduleTimeout(
            commitRootWhenReady.bind(
              null,
              shouldTimeSlice,
              forceSync,
              workInProgressRootRecoverableErrors,
              workInProgressTransitions,
              workInProgressRootDidIncludeRecursiveRenderUpdate,
              lanes,
              workInProgressDeferredLane,
              workInProgressRootInterleavedUpdatedLanes,
              workInProgressSuspendedRetryLanes,
              workInProgressRootDidSkipSuspendedSiblings,
              renderWasConcurrent,
              2,
              -0,
              0
            ),
            exitStatus
          );
          break a;
        }
        commitRootWhenReady(
          shouldTimeSlice,
          forceSync,
          workInProgressRootRecoverableErrors,
          workInProgressTransitions,
          workInProgressRootDidIncludeRecursiveRenderUpdate,
          lanes,
          workInProgressDeferredLane,
          workInProgressRootInterleavedUpdatedLanes,
          workInProgressSuspendedRetryLanes,
          workInProgressRootDidSkipSuspendedSiblings,
          renderWasConcurrent,
          0,
          -0,
          0
        );
      }
    }
    break;
  } while (1);
  ensureRootIsScheduled(root$jscomp$0);
}
function commitRootWhenReady(
  root,
  finishedWork,
  recoverableErrors,
  transitions,
  didIncludeRenderPhaseUpdate,
  lanes,
  spawnedLane,
  updatedLanes,
  suspendedRetryLanes,
  didSkipSuspendedSiblings,
  exitStatus,
  suspendedCommitReason,
  completedRenderStartTime,
  completedRenderEndTime
) {
  root.timeoutHandle = -1;
  suspendedCommitReason = finishedWork.subtreeFlags;
  if (
    suspendedCommitReason & 8192 ||
    16785408 === (suspendedCommitReason & 16785408)
  )
    if (
      ((suspendedState = { stylesheets: null, count: 0, unsuspend: noop }),
      accumulateSuspenseyCommitOnFiber(finishedWork),
      (suspendedCommitReason = waitForCommitToBeReady()),
      null !== suspendedCommitReason)
    ) {
      root.cancelPendingCommit = suspendedCommitReason(
        commitRoot.bind(
          null,
          root,
          finishedWork,
          lanes,
          recoverableErrors,
          transitions,
          didIncludeRenderPhaseUpdate,
          spawnedLane,
          updatedLanes,
          suspendedRetryLanes,
          exitStatus,
          1,
          completedRenderStartTime,
          completedRenderEndTime
        )
      );
      markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
      return;
    }
  commitRoot(
    root,
    finishedWork,
    lanes,
    recoverableErrors,
    transitions,
    didIncludeRenderPhaseUpdate,
    spawnedLane,
    updatedLanes,
    suspendedRetryLanes
  );
}
function isRenderConsistentWithExternalStores(finishedWork) {
  for (var node = finishedWork; ; ) {
    var tag = node.tag;
    if (
      (0 === tag || 11 === tag || 15 === tag) &&
      node.flags & 16384 &&
      ((tag = node.updateQueue),
      null !== tag && ((tag = tag.stores), null !== tag))
    )
      for (var i = 0; i < tag.length; i++) {
        var check = tag[i],
          getSnapshot = check.getSnapshot;
        check = check.value;
        try {
          if (!objectIs(getSnapshot(), check)) return !1;
        } catch (error) {
          return false;
        }
      }
    tag = node.child;
    if (node.subtreeFlags & 16384 && null !== tag)
      (tag.return = node), (node = tag);
    else {
      if (node === finishedWork) break;
      for (; null === node.sibling; ) {
        if (null === node.return || node.return === finishedWork) return true;
        node = node.return;
      }
      node.sibling.return = node.return;
      node = node.sibling;
    }
  }
  return true;
}
function markRootSuspended(
  root,
  suspendedLanes,
  spawnedLane,
  didAttemptEntireTree
) {
  suspendedLanes &= ~workInProgressRootPingedLanes;
  suspendedLanes &= ~workInProgressRootInterleavedUpdatedLanes;
  root.suspendedLanes |= suspendedLanes;
  root.pingedLanes &= ~suspendedLanes;
  didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
  didAttemptEntireTree = root.expirationTimes;
  for (var lanes = suspendedLanes; 0 < lanes; ) {
    var index$4 = 31 - clz32(lanes),
      lane = 1 << index$4;
    didAttemptEntireTree[index$4] = -1;
    lanes &= ~lane;
  }
  0 !== spawnedLane &&
    markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function flushSyncWork$1() {
  return 0 === (executionContext & 6)
    ? (flushSyncWorkAcrossRoots_impl(0), false)
    : true;
}
function resetWorkInProgressStack() {
  if (null !== workInProgress) {
    if (0 === workInProgressSuspendedReason)
      var interruptedWork = workInProgress.return;
    else
      (interruptedWork = workInProgress),
        (lastContextDependency = currentlyRenderingFiber$1 = null),
        resetHooksOnUnwind(interruptedWork),
        (thenableState = null),
        (thenableIndexCounter = 0),
        (interruptedWork = workInProgress);
    for (; null !== interruptedWork; )
      unwindInterruptedWork(interruptedWork.alternate, interruptedWork),
        (interruptedWork = interruptedWork.return);
    workInProgress = null;
  }
}
function prepareFreshStack(root, lanes) {
  var timeoutHandle = root.timeoutHandle;
  -1 !== timeoutHandle &&
    ((root.timeoutHandle = -1), cancelTimeout(timeoutHandle));
  timeoutHandle = root.cancelPendingCommit;
  null !== timeoutHandle &&
    ((root.cancelPendingCommit = null), timeoutHandle());
  resetWorkInProgressStack();
  workInProgressRoot = root;
  workInProgress = timeoutHandle = createWorkInProgress(root.current, null);
  workInProgressRootRenderLanes = lanes;
  workInProgressSuspendedReason = 0;
  workInProgressThrownValue = null;
  workInProgressRootDidSkipSuspendedSiblings = false;
  workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root, lanes);
  workInProgressRootDidAttachPingListener = false;
  workInProgressSuspendedRetryLanes =
    workInProgressDeferredLane =
    workInProgressRootPingedLanes =
    workInProgressRootInterleavedUpdatedLanes =
    workInProgressRootSkippedLanes =
    workInProgressRootExitStatus =
      0;
  workInProgressRootRecoverableErrors = workInProgressRootConcurrentErrors =
    null;
  workInProgressRootDidIncludeRecursiveRenderUpdate = false;
  0 !== (lanes & 8) && (lanes |= lanes & 32);
  var allEntangledLanes = root.entangledLanes;
  if (0 !== allEntangledLanes)
    for (
      root = root.entanglements, allEntangledLanes &= lanes;
      0 < allEntangledLanes;

    ) {
      var index$2 = 31 - clz32(allEntangledLanes),
        lane = 1 << index$2;
      lanes |= root[index$2];
      allEntangledLanes &= ~lane;
    }
  entangledRenderLanes = lanes;
  finishQueueingConcurrentUpdates();
  return timeoutHandle;
}
function handleThrow(root, thrownValue) {
  currentlyRenderingFiber = null;
  ReactSharedInternals.H = ContextOnlyDispatcher;
  thrownValue === SuspenseException || thrownValue === SuspenseActionException
    ? ((thrownValue = getSuspendedThenable()),
      (workInProgressSuspendedReason = 3))
    : thrownValue === SuspenseyCommitException
      ? ((thrownValue = getSuspendedThenable()),
        (workInProgressSuspendedReason = 4))
      : (workInProgressSuspendedReason =
          thrownValue === SelectiveHydrationException
            ? 8
            : null !== thrownValue &&
                "object" === typeof thrownValue &&
                "function" === typeof thrownValue.then
              ? 6
              : 1);
  workInProgressThrownValue = thrownValue;
  null === workInProgress &&
    ((workInProgressRootExitStatus = 1),
    logUncaughtError(
      root,
      createCapturedValueAtFiber(thrownValue, root.current)
    ));
}
function pushDispatcher() {
  var prevDispatcher = ReactSharedInternals.H;
  ReactSharedInternals.H = ContextOnlyDispatcher;
  return null === prevDispatcher ? ContextOnlyDispatcher : prevDispatcher;
}
function pushAsyncDispatcher() {
  var prevAsyncDispatcher = ReactSharedInternals.A;
  ReactSharedInternals.A = DefaultAsyncDispatcher;
  return prevAsyncDispatcher;
}
function renderDidSuspendDelayIfPossible() {
  workInProgressRootExitStatus = 4;
  workInProgressRootDidSkipSuspendedSiblings ||
    ((workInProgressRootRenderLanes & 4194048) !==
      workInProgressRootRenderLanes &&
      null !== suspenseHandlerStackCursor.current) ||
    (workInProgressRootIsPrerendering = true);
  (0 === (workInProgressRootSkippedLanes & 134217727) &&
    0 === (workInProgressRootInterleavedUpdatedLanes & 134217727)) ||
    null === workInProgressRoot ||
    markRootSuspended(
      workInProgressRoot,
      workInProgressRootRenderLanes,
      workInProgressDeferredLane,
      false
    );
}
function renderRootSync(root, lanes, shouldYieldForPrerendering) {
  var prevExecutionContext = executionContext;
  executionContext |= 2;
  var prevDispatcher = pushDispatcher(),
    prevAsyncDispatcher = pushAsyncDispatcher();
  if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes)
    (workInProgressTransitions = null), prepareFreshStack(root, lanes);
  lanes = false;
  var exitStatus = workInProgressRootExitStatus;
  a: do
    try {
      if (0 !== workInProgressSuspendedReason && null !== workInProgress) {
        var unitOfWork = workInProgress,
          thrownValue = workInProgressThrownValue;
        switch (workInProgressSuspendedReason) {
          case 8:
            resetWorkInProgressStack();
            exitStatus = 6;
            break a;
          case 3:
          case 2:
          case 9:
          case 6:
            null === suspenseHandlerStackCursor.current && (lanes = !0);
            var reason = workInProgressSuspendedReason;
            workInProgressSuspendedReason = 0;
            workInProgressThrownValue = null;
            throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            if (
              shouldYieldForPrerendering &&
              workInProgressRootIsPrerendering
            ) {
              exitStatus = 0;
              break a;
            }
            break;
          default:
            (reason = workInProgressSuspendedReason),
              (workInProgressSuspendedReason = 0),
              (workInProgressThrownValue = null),
              throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
        }
      }
      workLoopSync();
      exitStatus = workInProgressRootExitStatus;
      break;
    } catch (thrownValue$167) {
      handleThrow(root, thrownValue$167);
    }
  while (1);
  lanes && root.shellSuspendCounter++;
  lastContextDependency = currentlyRenderingFiber$1 = null;
  executionContext = prevExecutionContext;
  ReactSharedInternals.H = prevDispatcher;
  ReactSharedInternals.A = prevAsyncDispatcher;
  null === workInProgress &&
    ((workInProgressRoot = null),
    (workInProgressRootRenderLanes = 0),
    finishQueueingConcurrentUpdates());
  return exitStatus;
}
function workLoopSync() {
  for (; null !== workInProgress; ) performUnitOfWork(workInProgress);
}
function renderRootConcurrent(root, lanes) {
  var prevExecutionContext = executionContext;
  executionContext |= 2;
  var prevDispatcher = pushDispatcher(),
    prevAsyncDispatcher = pushAsyncDispatcher();
  workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes
    ? ((workInProgressTransitions = null),
      (workInProgressRootRenderTargetTime = now$1() + 500),
      prepareFreshStack(root, lanes))
    : (workInProgressRootIsPrerendering = checkIfRootIsPrerendering(
        root,
        lanes
      ));
  a: do
    try {
      if (0 !== workInProgressSuspendedReason && null !== workInProgress) {
        lanes = workInProgress;
        var thrownValue = workInProgressThrownValue;
        b: switch (workInProgressSuspendedReason) {
          case 1:
            workInProgressSuspendedReason = 0;
            workInProgressThrownValue = null;
            throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
            break;
          case 2:
          case 9:
            if (isThenableResolved(thrownValue)) {
              workInProgressSuspendedReason = 0;
              workInProgressThrownValue = null;
              replaySuspendedUnitOfWork(lanes);
              break;
            }
            lanes = function () {
              (2 !== workInProgressSuspendedReason &&
                9 !== workInProgressSuspendedReason) ||
                workInProgressRoot !== root ||
                (workInProgressSuspendedReason = 7);
              ensureRootIsScheduled(root);
            };
            thrownValue.then(lanes, lanes);
            break a;
          case 3:
            workInProgressSuspendedReason = 7;
            break a;
          case 4:
            workInProgressSuspendedReason = 5;
            break a;
          case 7:
            isThenableResolved(thrownValue)
              ? ((workInProgressSuspendedReason = 0),
                (workInProgressThrownValue = null),
                replaySuspendedUnitOfWork(lanes))
              : ((workInProgressSuspendedReason = 0),
                (workInProgressThrownValue = null),
                throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
            break;
          case 5:
            var resource = null;
            switch (workInProgress.tag) {
              case 26:
                resource = workInProgress.memoizedState;
              case 5:
              case 27:
                var hostFiber = workInProgress;
                if (resource ? preloadResource(resource) : 1) {
                  workInProgressSuspendedReason = 0;
                  workInProgressThrownValue = null;
                  var sibling = hostFiber.sibling;
                  if (null !== sibling) workInProgress = sibling;
                  else {
                    var returnFiber = hostFiber.return;
                    null !== returnFiber
                      ? ((workInProgress = returnFiber),
                        completeUnitOfWork(returnFiber))
                      : (workInProgress = null);
                  }
                  break b;
                }
            }
            workInProgressSuspendedReason = 0;
            workInProgressThrownValue = null;
            throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
            break;
          case 6:
            workInProgressSuspendedReason = 0;
            workInProgressThrownValue = null;
            throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
            break;
          case 8:
            resetWorkInProgressStack();
            workInProgressRootExitStatus = 6;
            break a;
          default:
            throw Error(formatProdErrorMessage(462));
        }
      }
      workLoopConcurrentByScheduler();
      break;
    } catch (thrownValue$169) {
      handleThrow(root, thrownValue$169);
    }
  while (1);
  lastContextDependency = currentlyRenderingFiber$1 = null;
  ReactSharedInternals.H = prevDispatcher;
  ReactSharedInternals.A = prevAsyncDispatcher;
  executionContext = prevExecutionContext;
  if (null !== workInProgress) return 0;
  workInProgressRoot = null;
  workInProgressRootRenderLanes = 0;
  finishQueueingConcurrentUpdates();
  return workInProgressRootExitStatus;
}
function workLoopConcurrentByScheduler() {
  for (; null !== workInProgress && !shouldYield(); )
    performUnitOfWork(workInProgress);
}
function performUnitOfWork(unitOfWork) {
  var next = beginWork(unitOfWork.alternate, unitOfWork, entangledRenderLanes);
  unitOfWork.memoizedProps = unitOfWork.pendingProps;
  null === next ? completeUnitOfWork(unitOfWork) : (workInProgress = next);
}
function replaySuspendedUnitOfWork(unitOfWork) {
  var next = unitOfWork;
  var current = next.alternate;
  switch (next.tag) {
    case 15:
    case 0:
      next = replayFunctionComponent(
        current,
        next,
        next.pendingProps,
        next.type,
        void 0,
        workInProgressRootRenderLanes
      );
      break;
    case 11:
      next = replayFunctionComponent(
        current,
        next,
        next.pendingProps,
        next.type.render,
        next.ref,
        workInProgressRootRenderLanes
      );
      break;
    case 5:
      resetHooksOnUnwind(next);
    default:
      unwindInterruptedWork(current, next),
        (next = workInProgress =
          resetWorkInProgress(next, entangledRenderLanes)),
        (next = beginWork(current, next, entangledRenderLanes));
  }
  unitOfWork.memoizedProps = unitOfWork.pendingProps;
  null === next ? completeUnitOfWork(unitOfWork) : (workInProgress = next);
}
function throwAndUnwindWorkLoop(
  root,
  unitOfWork,
  thrownValue,
  suspendedReason
) {
  lastContextDependency = currentlyRenderingFiber$1 = null;
  resetHooksOnUnwind(unitOfWork);
  thenableState = null;
  thenableIndexCounter = 0;
  var returnFiber = unitOfWork.return;
  try {
    if (
      throwException(
        root,
        returnFiber,
        unitOfWork,
        thrownValue,
        workInProgressRootRenderLanes
      )
    ) {
      workInProgressRootExitStatus = 1;
      logUncaughtError(
        root,
        createCapturedValueAtFiber(thrownValue, root.current)
      );
      workInProgress = null;
      return;
    }
  } catch (error) {
    if (null !== returnFiber) throw ((workInProgress = returnFiber), error);
    workInProgressRootExitStatus = 1;
    logUncaughtError(
      root,
      createCapturedValueAtFiber(thrownValue, root.current)
    );
    workInProgress = null;
    return;
  }
  if (unitOfWork.flags & 32768) {
    if (isHydrating || 1 === suspendedReason) root = true;
    else if (
      workInProgressRootIsPrerendering ||
      0 !== (workInProgressRootRenderLanes & 536870912)
    )
      root = false;
    else if (
      ((workInProgressRootDidSkipSuspendedSiblings = root = true),
      2 === suspendedReason ||
        9 === suspendedReason ||
        3 === suspendedReason ||
        6 === suspendedReason)
    )
      (suspendedReason = suspenseHandlerStackCursor.current),
        null !== suspendedReason &&
          13 === suspendedReason.tag &&
          (suspendedReason.flags |= 16384);
    unwindUnitOfWork(unitOfWork, root);
  } else completeUnitOfWork(unitOfWork);
}
function completeUnitOfWork(unitOfWork) {
  var completedWork = unitOfWork;
  do {
    if (0 !== (completedWork.flags & 32768)) {
      unwindUnitOfWork(
        completedWork,
        workInProgressRootDidSkipSuspendedSiblings
      );
      return;
    }
    unitOfWork = completedWork.return;
    var next = completeWork(
      completedWork.alternate,
      completedWork,
      entangledRenderLanes
    );
    if (null !== next) {
      workInProgress = next;
      return;
    }
    completedWork = completedWork.sibling;
    if (null !== completedWork) {
      workInProgress = completedWork;
      return;
    }
    workInProgress = completedWork = unitOfWork;
  } while (null !== completedWork);
  0 === workInProgressRootExitStatus && (workInProgressRootExitStatus = 5);
}
function unwindUnitOfWork(unitOfWork, skipSiblings) {
  do {
    var next = unwindWork(unitOfWork.alternate, unitOfWork);
    if (null !== next) {
      next.flags &= 32767;
      workInProgress = next;
      return;
    }
    next = unitOfWork.return;
    null !== next &&
      ((next.flags |= 32768), (next.subtreeFlags = 0), (next.deletions = null));
    if (
      !skipSiblings &&
      ((unitOfWork = unitOfWork.sibling), null !== unitOfWork)
    ) {
      workInProgress = unitOfWork;
      return;
    }
    workInProgress = unitOfWork = next;
  } while (null !== unitOfWork);
  workInProgressRootExitStatus = 6;
  workInProgress = null;
}
function commitRoot(
  root,
  finishedWork,
  lanes,
  recoverableErrors,
  transitions,
  didIncludeRenderPhaseUpdate,
  spawnedLane,
  updatedLanes,
  suspendedRetryLanes
) {
  root.cancelPendingCommit = null;
  do flushPendingEffects();
  while (0 !== pendingEffectsStatus);
  if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(327));
  if (null !== finishedWork) {
    if (finishedWork === root.current) throw Error(formatProdErrorMessage(177));
    didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
    didIncludeRenderPhaseUpdate |= concurrentlyUpdatedLanes;
    markRootFinished(
      root,
      lanes,
      didIncludeRenderPhaseUpdate,
      spawnedLane,
      updatedLanes,
      suspendedRetryLanes
    );
    root === workInProgressRoot &&
      ((workInProgress = workInProgressRoot = null),
      (workInProgressRootRenderLanes = 0));
    pendingFinishedWork = finishedWork;
    pendingEffectsRoot = root;
    pendingEffectsLanes = lanes;
    pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
    pendingPassiveTransitions = transitions;
    pendingRecoverableErrors = recoverableErrors;
    0 !== (finishedWork.subtreeFlags & 10256) ||
    0 !== (finishedWork.flags & 10256)
      ? ((root.callbackNode = null),
        (root.callbackPriority = 0),
        scheduleCallback$1(NormalPriority$1, function () {
          flushPassiveEffects();
          return null;
        }))
      : ((root.callbackNode = null), (root.callbackPriority = 0));
    recoverableErrors = 0 !== (finishedWork.flags & 13878);
    if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
      recoverableErrors = ReactSharedInternals.T;
      ReactSharedInternals.T = null;
      transitions = ReactDOMSharedInternals.p;
      ReactDOMSharedInternals.p = 2;
      spawnedLane = executionContext;
      executionContext |= 4;
      try {
        commitBeforeMutationEffects(root, finishedWork, lanes);
      } finally {
        (executionContext = spawnedLane),
          (ReactDOMSharedInternals.p = transitions),
          (ReactSharedInternals.T = recoverableErrors);
      }
    }
    pendingEffectsStatus = 1;
    flushMutationEffects();
    flushLayoutEffects();
    flushSpawnedWork();
  }
}
function flushMutationEffects() {
  if (1 === pendingEffectsStatus) {
    pendingEffectsStatus = 0;
    var root = pendingEffectsRoot,
      finishedWork = pendingFinishedWork,
      rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
    if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
      rootMutationHasEffect = ReactSharedInternals.T;
      ReactSharedInternals.T = null;
      var previousPriority = ReactDOMSharedInternals.p;
      ReactDOMSharedInternals.p = 2;
      var prevExecutionContext = executionContext;
      executionContext |= 4;
      try {
        commitMutationEffectsOnFiber(finishedWork, root);
        var priorSelectionInformation = selectionInformation,
          curFocusedElem = getActiveElementDeep(root.containerInfo),
          priorFocusedElem = priorSelectionInformation.focusedElem,
          priorSelectionRange = priorSelectionInformation.selectionRange;
        if (
          curFocusedElem !== priorFocusedElem &&
          priorFocusedElem &&
          priorFocusedElem.ownerDocument &&
          containsNode(
            priorFocusedElem.ownerDocument.documentElement,
            priorFocusedElem
          )
        ) {
          if (
            null !== priorSelectionRange &&
            hasSelectionCapabilities(priorFocusedElem)
          ) {
            var start = priorSelectionRange.start,
              end = priorSelectionRange.end;
            void 0 === end && (end = start);
            if ("selectionStart" in priorFocusedElem)
              (priorFocusedElem.selectionStart = start),
                (priorFocusedElem.selectionEnd = Math.min(
                  end,
                  priorFocusedElem.value.length
                ));
            else {
              var doc = priorFocusedElem.ownerDocument || document,
                win = (doc && doc.defaultView) || window;
              if (win.getSelection) {
                var selection = win.getSelection(),
                  length = priorFocusedElem.textContent.length,
                  start$jscomp$0 = Math.min(priorSelectionRange.start, length),
                  end$jscomp$0 =
                    void 0 === priorSelectionRange.end
                      ? start$jscomp$0
                      : Math.min(priorSelectionRange.end, length);
                !selection.extend &&
                  start$jscomp$0 > end$jscomp$0 &&
                  ((curFocusedElem = end$jscomp$0),
                  (end$jscomp$0 = start$jscomp$0),
                  (start$jscomp$0 = curFocusedElem));
                var startMarker = getNodeForCharacterOffset(
                    priorFocusedElem,
                    start$jscomp$0
                  ),
                  endMarker = getNodeForCharacterOffset(
                    priorFocusedElem,
                    end$jscomp$0
                  );
                if (
                  startMarker &&
                  endMarker &&
                  (1 !== selection.rangeCount ||
                    selection.anchorNode !== startMarker.node ||
                    selection.anchorOffset !== startMarker.offset ||
                    selection.focusNode !== endMarker.node ||
                    selection.focusOffset !== endMarker.offset)
                ) {
                  var range = doc.createRange();
                  range.setStart(startMarker.node, startMarker.offset);
                  selection.removeAllRanges();
                  start$jscomp$0 > end$jscomp$0
                    ? (selection.addRange(range),
                      selection.extend(endMarker.node, endMarker.offset))
                    : (range.setEnd(endMarker.node, endMarker.offset),
                      selection.addRange(range));
                }
              }
            }
          }
          doc = [];
          for (
            selection = priorFocusedElem;
            (selection = selection.parentNode);

          )
            1 === selection.nodeType &&
              doc.push({
                element: selection,
                left: selection.scrollLeft,
                top: selection.scrollTop
              });
          "function" === typeof priorFocusedElem.focus &&
            priorFocusedElem.focus();
          for (
            priorFocusedElem = 0;
            priorFocusedElem < doc.length;
            priorFocusedElem++
          ) {
            var info = doc[priorFocusedElem];
            info.element.scrollLeft = info.left;
            info.element.scrollTop = info.top;
          }
        }
        _enabled = !!eventsEnabled;
        selectionInformation = eventsEnabled = null;
      } finally {
        (executionContext = prevExecutionContext),
          (ReactDOMSharedInternals.p = previousPriority),
          (ReactSharedInternals.T = rootMutationHasEffect);
      }
    }
    root.current = finishedWork;
    pendingEffectsStatus = 2;
  }
}
function flushLayoutEffects() {
  if (2 === pendingEffectsStatus) {
    pendingEffectsStatus = 0;
    var root = pendingEffectsRoot,
      finishedWork = pendingFinishedWork,
      rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
    if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
      rootHasLayoutEffect = ReactSharedInternals.T;
      ReactSharedInternals.T = null;
      var previousPriority = ReactDOMSharedInternals.p;
      ReactDOMSharedInternals.p = 2;
      var prevExecutionContext = executionContext;
      executionContext |= 4;
      try {
        commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
      } finally {
        (executionContext = prevExecutionContext),
          (ReactDOMSharedInternals.p = previousPriority),
          (ReactSharedInternals.T = rootHasLayoutEffect);
      }
    }
    pendingEffectsStatus = 3;
  }
}
function flushSpawnedWork() {
  if (4 === pendingEffectsStatus || 3 === pendingEffectsStatus) {
    pendingEffectsStatus = 0;
    requestPaint();
    var root = pendingEffectsRoot,
      finishedWork = pendingFinishedWork,
      lanes = pendingEffectsLanes,
      recoverableErrors = pendingRecoverableErrors;
    0 !== (finishedWork.subtreeFlags & 10256) ||
    0 !== (finishedWork.flags & 10256)
      ? (pendingEffectsStatus = 5)
      : ((pendingEffectsStatus = 0),
        (pendingFinishedWork = pendingEffectsRoot = null),
        releaseRootPooledCache(root, root.pendingLanes));
    var remainingLanes = root.pendingLanes;
    0 === remainingLanes && (legacyErrorBoundariesThatAlreadyFailed = null);
    lanesToEventPriority(lanes);
    finishedWork = finishedWork.stateNode;
    if (injectedHook && "function" === typeof injectedHook.onCommitFiberRoot)
      try {
        injectedHook.onCommitFiberRoot(
          rendererID,
          finishedWork,
          void 0,
          128 === (finishedWork.current.flags & 128)
        );
      } catch (err) {}
    if (null !== recoverableErrors) {
      finishedWork = ReactSharedInternals.T;
      remainingLanes = ReactDOMSharedInternals.p;
      ReactDOMSharedInternals.p = 2;
      ReactSharedInternals.T = null;
      try {
        for (
          var onRecoverableError = root.onRecoverableError, i = 0;
          i < recoverableErrors.length;
          i++
        ) {
          var recoverableError = recoverableErrors[i];
          onRecoverableError(recoverableError.value, {
            componentStack: recoverableError.stack
          });
        }
      } finally {
        (ReactSharedInternals.T = finishedWork),
          (ReactDOMSharedInternals.p = remainingLanes);
      }
    }
    0 !== (pendingEffectsLanes & 3) && flushPendingEffects();
    ensureRootIsScheduled(root);
    remainingLanes = root.pendingLanes;
    0 !== (lanes & 4194090) && 0 !== (remainingLanes & 42)
      ? root === rootWithNestedUpdates
        ? nestedUpdateCount++
        : ((nestedUpdateCount = 0), (rootWithNestedUpdates = root))
      : (nestedUpdateCount = 0);
    flushSyncWorkAcrossRoots_impl(0);
  }
}
function releaseRootPooledCache(root, remainingLanes) {
  0 === (root.pooledCacheLanes &= remainingLanes) &&
    ((remainingLanes = root.pooledCache),
    null != remainingLanes &&
      ((root.pooledCache = null), releaseCache(remainingLanes)));
}
function flushPendingEffects(wasDelayedCommit) {
  flushMutationEffects();
  flushLayoutEffects();
  flushSpawnedWork();
  return flushPassiveEffects();
}
function flushPassiveEffects() {
  if (5 !== pendingEffectsStatus) return false;
  var root = pendingEffectsRoot,
    remainingLanes = pendingEffectsRemainingLanes;
  pendingEffectsRemainingLanes = 0;
  var renderPriority = lanesToEventPriority(pendingEffectsLanes),
    prevTransition = ReactSharedInternals.T,
    previousPriority = ReactDOMSharedInternals.p;
  try {
    ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
    ReactSharedInternals.T = null;
    renderPriority = pendingPassiveTransitions;
    pendingPassiveTransitions = null;
    var root$jscomp$0 = pendingEffectsRoot,
      lanes = pendingEffectsLanes;
    pendingEffectsStatus = 0;
    pendingFinishedWork = pendingEffectsRoot = null;
    pendingEffectsLanes = 0;
    if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(331));
    var prevExecutionContext = executionContext;
    executionContext |= 4;
    commitPassiveUnmountOnFiber(root$jscomp$0.current);
    commitPassiveMountOnFiber(
      root$jscomp$0,
      root$jscomp$0.current,
      lanes,
      renderPriority
    );
    executionContext = prevExecutionContext;
    flushSyncWorkAcrossRoots_impl(0, !1);
    if (
      injectedHook &&
      "function" === typeof injectedHook.onPostCommitFiberRoot
    )
      try {
        injectedHook.onPostCommitFiberRoot(rendererID, root$jscomp$0);
      } catch (err) {}
    return !0;
  } finally {
    (ReactDOMSharedInternals.p = previousPriority),
      (ReactSharedInternals.T = prevTransition),
      releaseRootPooledCache(root, remainingLanes);
  }
}
function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
  sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
  sourceFiber = createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
  rootFiber = enqueueUpdate(rootFiber, sourceFiber, 2);
  null !== rootFiber &&
    (markRootUpdated$1(rootFiber, 2), ensureRootIsScheduled(rootFiber));
}
function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
  if (3 === sourceFiber.tag)
    captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
  else
    for (; null !== nearestMountedAncestor; ) {
      if (3 === nearestMountedAncestor.tag) {
        captureCommitPhaseErrorOnRoot(
          nearestMountedAncestor,
          sourceFiber,
          error
        );
        break;
      } else if (1 === nearestMountedAncestor.tag) {
        var instance = nearestMountedAncestor.stateNode;
        if (
          "function" ===
            typeof nearestMountedAncestor.type.getDerivedStateFromError ||
          ("function" === typeof instance.componentDidCatch &&
            (null === legacyErrorBoundariesThatAlreadyFailed ||
              !legacyErrorBoundariesThatAlreadyFailed.has(instance)))
        ) {
          sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
          error = createClassErrorUpdate(2);
          instance = enqueueUpdate(nearestMountedAncestor, error, 2);
          null !== instance &&
            (initializeClassErrorUpdate(
              error,
              instance,
              nearestMountedAncestor,
              sourceFiber
            ),
            markRootUpdated$1(instance, 2),
            ensureRootIsScheduled(instance));
          break;
        }
      }
      nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function attachPingListener(root, wakeable, lanes) {
  var pingCache = root.pingCache;
  if (null === pingCache) {
    pingCache = root.pingCache = new PossiblyWeakMap();
    var threadIDs = new Set();
    pingCache.set(wakeable, threadIDs);
  } else
    (threadIDs = pingCache.get(wakeable)),
      void 0 === threadIDs &&
        ((threadIDs = new Set()), pingCache.set(wakeable, threadIDs));
  threadIDs.has(lanes) ||
    ((workInProgressRootDidAttachPingListener = true),
    threadIDs.add(lanes),
    (root = pingSuspendedRoot.bind(null, root, wakeable, lanes)),
    wakeable.then(root, root));
}
function pingSuspendedRoot(root, wakeable, pingedLanes) {
  var pingCache = root.pingCache;
  null !== pingCache && pingCache.delete(wakeable);
  root.pingedLanes |= root.suspendedLanes & pingedLanes;
  root.warmLanes &= ~pingedLanes;
  workInProgressRoot === root &&
    (workInProgressRootRenderLanes & pingedLanes) === pingedLanes &&
    (4 === workInProgressRootExitStatus ||
    (3 === workInProgressRootExitStatus &&
      (workInProgressRootRenderLanes & 62914560) ===
        workInProgressRootRenderLanes &&
      300 > now$1() - globalMostRecentFallbackTime)
      ? 0 === (executionContext & 2) && prepareFreshStack(root, 0)
      : (workInProgressRootPingedLanes |= pingedLanes),
    workInProgressSuspendedRetryLanes === workInProgressRootRenderLanes &&
      (workInProgressSuspendedRetryLanes = 0));
  ensureRootIsScheduled(root);
}
function retryTimedOutBoundary(boundaryFiber, retryLane) {
  0 === retryLane && (retryLane = claimNextRetryLane());
  boundaryFiber = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
  null !== boundaryFiber &&
    (markRootUpdated$1(boundaryFiber, retryLane),
    ensureRootIsScheduled(boundaryFiber));
}
function retryDehydratedSuspenseBoundary(boundaryFiber) {
  var suspenseState = boundaryFiber.memoizedState,
    retryLane = 0;
  null !== suspenseState && (retryLane = suspenseState.retryLane);
  retryTimedOutBoundary(boundaryFiber, retryLane);
}
function resolveRetryWakeable(boundaryFiber, wakeable) {
  var retryLane = 0;
  switch (boundaryFiber.tag) {
    case 13:
      var retryCache = boundaryFiber.stateNode;
      var suspenseState = boundaryFiber.memoizedState;
      null !== suspenseState && (retryLane = suspenseState.retryLane);
      break;
    case 19:
      retryCache = boundaryFiber.stateNode;
      break;
    case 22:
      retryCache = boundaryFiber.stateNode._retryCache;
      break;
    default:
      throw Error(formatProdErrorMessage(314));
  }
  null !== retryCache && retryCache.delete(wakeable);
  retryTimedOutBoundary(boundaryFiber, retryLane);
}
function scheduleCallback$1(priorityLevel, callback) {
  return scheduleCallback$3(priorityLevel, callback);
}
var firstScheduledRoot = null,
  lastScheduledRoot = null,
  didScheduleMicrotask = false,
  mightHavePendingSyncWork = false,
  isFlushingWork = false,
  currentEventTransitionLane = 0;
function ensureRootIsScheduled(root) {
  root !== lastScheduledRoot &&
    null === root.next &&
    (null === lastScheduledRoot
      ? (firstScheduledRoot = lastScheduledRoot = root)
      : (lastScheduledRoot = lastScheduledRoot.next = root));
  mightHavePendingSyncWork = true;
  didScheduleMicrotask ||
    ((didScheduleMicrotask = true), scheduleImmediateRootScheduleTask());
}
function flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
  if (!isFlushingWork && mightHavePendingSyncWork) {
    isFlushingWork = true;
    do {
      var didPerformSomeWork = false;
      for (var root$174 = firstScheduledRoot; null !== root$174; ) {
        if (0 !== syncTransitionLanes) {
            var pendingLanes = root$174.pendingLanes;
            if (0 === pendingLanes) var JSCompiler_inline_result = 0;
            else {
              var suspendedLanes = root$174.suspendedLanes,
                pingedLanes = root$174.pingedLanes;
              JSCompiler_inline_result =
                (1 << (31 - clz32(42 | syncTransitionLanes) + 1)) - 1;
              JSCompiler_inline_result &=
                pendingLanes & ~(suspendedLanes & ~pingedLanes);
              JSCompiler_inline_result =
                JSCompiler_inline_result & 201326741
                  ? (JSCompiler_inline_result & 201326741) | 1
                  : JSCompiler_inline_result
                    ? JSCompiler_inline_result | 2
                    : 0;
            }
            0 !== JSCompiler_inline_result &&
              ((didPerformSomeWork = true),
              performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
          } else
            (JSCompiler_inline_result = workInProgressRootRenderLanes),
              (JSCompiler_inline_result = getNextLanes(
                root$174,
                root$174 === workInProgressRoot ? JSCompiler_inline_result : 0,
                null !== root$174.cancelPendingCommit ||
                  -1 !== root$174.timeoutHandle
              )),
              0 === (JSCompiler_inline_result & 3) ||
                checkIfRootIsPrerendering(root$174, JSCompiler_inline_result) ||
                ((didPerformSomeWork = true),
                performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
        root$174 = root$174.next;
      }
    } while (didPerformSomeWork);
    isFlushingWork = false;
  }
}
function processRootScheduleInImmediateTask() {
  processRootScheduleInMicrotask();
}
function processRootScheduleInMicrotask() {
  mightHavePendingSyncWork = didScheduleMicrotask = false;
  var syncTransitionLanes = 0;
  0 !== currentEventTransitionLane &&
    (shouldAttemptEagerTransition() &&
      (syncTransitionLanes = currentEventTransitionLane),
    (currentEventTransitionLane = 0));
  for (
    var currentTime = now$1(), prev = null, root = firstScheduledRoot;
    null !== root;

  ) {
    var next = root.next,
      nextLanes = scheduleTaskForRootDuringMicrotask(root, currentTime);
    if (0 === nextLanes)
      (root.next = null),
        null === prev ? (firstScheduledRoot = next) : (prev.next = next),
        null === next && (lastScheduledRoot = prev);
    else if (
      ((prev = root), 0 !== syncTransitionLanes || 0 !== (nextLanes & 3))
    )
      mightHavePendingSyncWork = true;
    root = next;
  }
  flushSyncWorkAcrossRoots_impl(syncTransitionLanes);
}
function scheduleTaskForRootDuringMicrotask(root, currentTime) {
  for (
    var suspendedLanes = root.suspendedLanes,
      pingedLanes = root.pingedLanes,
      expirationTimes = root.expirationTimes,
      lanes = root.pendingLanes & -62914561;
    0 < lanes;

  ) {
    var index$3 = 31 - clz32(lanes),
      lane = 1 << index$3,
      expirationTime = expirationTimes[index$3];
    if (-1 === expirationTime) {
      if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes))
        expirationTimes[index$3] = computeExpirationTime(lane, currentTime);
    } else expirationTime <= currentTime && (root.expiredLanes |= lane);
    lanes &= ~lane;
  }
  currentTime = workInProgressRoot;
  suspendedLanes = workInProgressRootRenderLanes;
  suspendedLanes = getNextLanes(
    root,
    root === currentTime ? suspendedLanes : 0,
    null !== root.cancelPendingCommit || -1 !== root.timeoutHandle
  );
  pingedLanes = root.callbackNode;
  if (
    0 === suspendedLanes ||
    (root === currentTime &&
      (2 === workInProgressSuspendedReason ||
        9 === workInProgressSuspendedReason)) ||
    null !== root.cancelPendingCommit
  )
    return (
      null !== pingedLanes &&
        null !== pingedLanes &&
        cancelCallback$1(pingedLanes),
      (root.callbackNode = null),
      (root.callbackPriority = 0)
    );
  if (
    0 === (suspendedLanes & 3) ||
    checkIfRootIsPrerendering(root, suspendedLanes)
  ) {
    currentTime = suspendedLanes & -suspendedLanes;
    if (currentTime === root.callbackPriority) return currentTime;
    null !== pingedLanes && cancelCallback$1(pingedLanes);
    switch (lanesToEventPriority(suspendedLanes)) {
      case 2:
      case 8:
        suspendedLanes = UserBlockingPriority;
        break;
      case 32:
        suspendedLanes = NormalPriority$1;
        break;
      case 268435456:
        suspendedLanes = IdlePriority;
        break;
      default:
        suspendedLanes = NormalPriority$1;
    }
    pingedLanes = performWorkOnRootViaSchedulerTask.bind(null, root);
    suspendedLanes = scheduleCallback$3(suspendedLanes, pingedLanes);
    root.callbackPriority = currentTime;
    root.callbackNode = suspendedLanes;
    return currentTime;
  }
  null !== pingedLanes && null !== pingedLanes && cancelCallback$1(pingedLanes);
  root.callbackPriority = 2;
  root.callbackNode = null;
  return 2;
}
function performWorkOnRootViaSchedulerTask(root, didTimeout) {
  if (0 !== pendingEffectsStatus && 5 !== pendingEffectsStatus)
    return (root.callbackNode = null), (root.callbackPriority = 0), null;
  var originalCallbackNode = root.callbackNode;
  if (flushPendingEffects() && root.callbackNode !== originalCallbackNode)
    return null;
  var workInProgressRootRenderLanes$jscomp$0 = workInProgressRootRenderLanes;
  workInProgressRootRenderLanes$jscomp$0 = getNextLanes(
    root,
    root === workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0,
    null !== root.cancelPendingCommit || -1 !== root.timeoutHandle
  );
  if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
  performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
  scheduleTaskForRootDuringMicrotask(root, now$1());
  return null != root.callbackNode && root.callbackNode === originalCallbackNode
    ? performWorkOnRootViaSchedulerTask.bind(null, root)
    : null;
}
function performSyncWorkOnRoot(root, lanes) {
  if (flushPendingEffects()) return null;
  performWorkOnRoot(root, lanes, true);
}
function scheduleImmediateRootScheduleTask() {
  scheduleMicrotask(function () {
    0 !== (executionContext & 6)
      ? scheduleCallback$3(
          ImmediatePriority,
          processRootScheduleInImmediateTask
        )
      : processRootScheduleInMicrotask();
  });
}
function requestTransitionLane() {
  0 === currentEventTransitionLane &&
    (currentEventTransitionLane = claimNextTransitionLane());
  return currentEventTransitionLane;
}
function coerceFormActionProp(actionProp) {
  return null == actionProp ||
    "symbol" === typeof actionProp ||
    "boolean" === typeof actionProp
    ? null
    : "function" === typeof actionProp
      ? actionProp
      : sanitizeURL("" + actionProp);
}
function createFormDataWithSubmitter(form, submitter) {
  var temp = submitter.ownerDocument.createElement("input");
  temp.name = submitter.name;
  temp.value = submitter.value;
  form.id && temp.setAttribute("form", form.id);
  submitter.parentNode.insertBefore(temp, submitter);
  form = new FormData(form);
  temp.parentNode.removeChild(temp);
  return form;
}
function extractEvents$1(
  dispatchQueue,
  domEventName,
  maybeTargetInst,
  nativeEvent,
  nativeEventTarget
) {
  if (
    "submit" === domEventName &&
    maybeTargetInst &&
    maybeTargetInst.stateNode === nativeEventTarget
  ) {
    var action = coerceFormActionProp(
        (nativeEventTarget[internalPropsKey] || null).action
      ),
      submitter = nativeEvent.submitter;
    submitter &&
      ((domEventName = (domEventName = submitter[internalPropsKey] || null)
        ? coerceFormActionProp(domEventName.formAction)
        : submitter.getAttribute("formAction")),
      null !== domEventName && ((action = domEventName), (submitter = null)));
    var event = new SyntheticEvent(
      "action",
      "action",
      null,
      nativeEvent,
      nativeEventTarget
    );
    dispatchQueue.push({
      event: event,
      listeners: [
        {
          instance: null,
          listener: function () {
            if (nativeEvent.defaultPrevented) {
              if (0 !== currentEventTransitionLane) {
                var formData = submitter
                  ? createFormDataWithSubmitter(nativeEventTarget, submitter)
                  : new FormData(nativeEventTarget);
                startHostTransition(
                  maybeTargetInst,
                  {
                    pending: true,
                    data: formData,
                    method: nativeEventTarget.method,
                    action: action
                  },
                  null,
                  formData
                );
              }
            } else
              "function" === typeof action &&
                (event.preventDefault(),
                (formData = submitter
                  ? createFormDataWithSubmitter(nativeEventTarget, submitter)
                  : new FormData(nativeEventTarget)),
                startHostTransition(
                  maybeTargetInst,
                  {
                    pending: true,
                    data: formData,
                    method: nativeEventTarget.method,
                    action: action
                  },
                  action,
                  formData
                ));
          },
          currentTarget: nativeEventTarget
        }
      ]
    });
  }
}
for (
  var i$jscomp$inline_1528 = 0;
  i$jscomp$inline_1528 < simpleEventPluginEvents.length;
  i$jscomp$inline_1528++
) {
  var eventName$jscomp$inline_1529 =
      simpleEventPluginEvents[i$jscomp$inline_1528],
    domEventName$jscomp$inline_1530 =
      eventName$jscomp$inline_1529.toLowerCase(),
    capitalizedEvent$jscomp$inline_1531 =
      eventName$jscomp$inline_1529[0].toUpperCase() +
      eventName$jscomp$inline_1529.slice(1);
  registerSimpleEvent(
    domEventName$jscomp$inline_1530,
    "on" + capitalizedEvent$jscomp$inline_1531
  );
}
registerSimpleEvent(ANIMATION_END, "onAnimationEnd");
registerSimpleEvent(ANIMATION_ITERATION, "onAnimationIteration");
registerSimpleEvent(ANIMATION_START, "onAnimationStart");
registerSimpleEvent("dblclick", "onDoubleClick");
registerSimpleEvent("focusin", "onFocus");
registerSimpleEvent("focusout", "onBlur");
registerSimpleEvent(TRANSITION_RUN, "onTransitionRun");
registerSimpleEvent(TRANSITION_START, "onTransitionStart");
registerSimpleEvent(TRANSITION_CANCEL, "onTransitionCancel");
registerSimpleEvent(TRANSITION_END, "onTransitionEnd");
registerDirectEvent("onMouseEnter", ["mouseout", "mouseover"]);
registerDirectEvent("onMouseLeave", ["mouseout", "mouseover"]);
registerDirectEvent("onPointerEnter", ["pointerout", "pointerover"]);
registerDirectEvent("onPointerLeave", ["pointerout", "pointerover"]);
registerTwoPhaseEvent(
  "onChange",
  "change click focusin focusout input keydown keyup selectionchange".split(" ")
);
registerTwoPhaseEvent(
  "onSelect",
  "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
    " "
  )
);
registerTwoPhaseEvent("onBeforeInput", [
  "compositionend",
  "keypress",
  "textInput",
  "paste"
]);
registerTwoPhaseEvent(
  "onCompositionEnd",
  "compositionend focusout keydown keypress keyup mousedown".split(" ")
);
registerTwoPhaseEvent(
  "onCompositionStart",
  "compositionstart focusout keydown keypress keyup mousedown".split(" ")
);
registerTwoPhaseEvent(
  "onCompositionUpdate",
  "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
);
var mediaEventTypes =
    "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
      " "
    ),
  nonDelegatedEvents = new Set(
    "beforetoggle cancel close invalid load scroll scrollend toggle"
      .split(" ")
      .concat(mediaEventTypes)
  );
function processDispatchQueue(dispatchQueue, eventSystemFlags) {
  eventSystemFlags = 0 !== (eventSystemFlags & 4);
  for (var i = 0; i < dispatchQueue.length; i++) {
    var _dispatchQueue$i = dispatchQueue[i],
      event = _dispatchQueue$i.event;
    _dispatchQueue$i = _dispatchQueue$i.listeners;
    a: {
      var previousInstance = void 0;
      if (eventSystemFlags)
        for (
          var i$jscomp$0 = _dispatchQueue$i.length - 1;
          0 <= i$jscomp$0;
          i$jscomp$0--
        ) {
          var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0],
            instance = _dispatchListeners$i.instance,
            currentTarget = _dispatchListeners$i.currentTarget;
          _dispatchListeners$i = _dispatchListeners$i.listener;
          if (instance !== previousInstance && event.isPropagationStopped())
            break a;
          previousInstance = _dispatchListeners$i;
          event.currentTarget = currentTarget;
          try {
            previousInstance(event);
          } catch (error) {
            reportGlobalError(error);
          }
          event.currentTarget = null;
          previousInstance = instance;
        }
      else
        for (
          i$jscomp$0 = 0;
          i$jscomp$0 < _dispatchQueue$i.length;
          i$jscomp$0++
        ) {
          _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
          instance = _dispatchListeners$i.instance;
          currentTarget = _dispatchListeners$i.currentTarget;
          _dispatchListeners$i = _dispatchListeners$i.listener;
          if (instance !== previousInstance && event.isPropagationStopped())
            break a;
          previousInstance = _dispatchListeners$i;
          event.currentTarget = currentTarget;
          try {
            previousInstance(event);
          } catch (error) {
            reportGlobalError(error);
          }
          event.currentTarget = null;
          previousInstance = instance;
        }
    }
  }
}
function listenToNonDelegatedEvent(domEventName, targetElement) {
  var JSCompiler_inline_result = targetElement[internalEventHandlersKey];
  void 0 === JSCompiler_inline_result &&
    (JSCompiler_inline_result = targetElement[internalEventHandlersKey] =
      new Set());
  var listenerSetKey = domEventName + "__bubble";
  JSCompiler_inline_result.has(listenerSetKey) ||
    (addTrappedEventListener(targetElement, domEventName, 2, false),
    JSCompiler_inline_result.add(listenerSetKey));
}
function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
  var eventSystemFlags = 0;
  isCapturePhaseListener && (eventSystemFlags |= 4);
  addTrappedEventListener(
    target,
    domEventName,
    eventSystemFlags,
    isCapturePhaseListener
  );
}
var listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function listenToAllSupportedEvents(rootContainerElement) {
  if (!rootContainerElement[listeningMarker]) {
    rootContainerElement[listeningMarker] = true;
    allNativeEvents.forEach(function (domEventName) {
      "selectionchange" !== domEventName &&
        (nonDelegatedEvents.has(domEventName) ||
          listenToNativeEvent(domEventName, false, rootContainerElement),
        listenToNativeEvent(domEventName, true, rootContainerElement));
    });
    var ownerDocument =
      9 === rootContainerElement.nodeType
        ? rootContainerElement
        : rootContainerElement.ownerDocument;
    null === ownerDocument ||
      ownerDocument[listeningMarker] ||
      ((ownerDocument[listeningMarker] = true),
      listenToNativeEvent("selectionchange", false, ownerDocument));
  }
}
function addTrappedEventListener(
  targetContainer,
  domEventName,
  eventSystemFlags,
  isCapturePhaseListener
) {
  switch (getEventPriority(domEventName)) {
    case 2:
      var listenerWrapper = dispatchDiscreteEvent;
      break;
    case 8:
      listenerWrapper = dispatchContinuousEvent;
      break;
    default:
      listenerWrapper = dispatchEvent;
  }
  eventSystemFlags = listenerWrapper.bind(
    null,
    domEventName,
    eventSystemFlags,
    targetContainer
  );
  listenerWrapper = void 0;
  !passiveBrowserEventsSupported ||
    ("touchstart" !== domEventName &&
      "touchmove" !== domEventName &&
      "wheel" !== domEventName) ||
    (listenerWrapper = true);
  isCapturePhaseListener
    ? void 0 !== listenerWrapper
      ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
          capture: true,
          passive: listenerWrapper
        })
      : targetContainer.addEventListener(domEventName, eventSystemFlags, true)
    : void 0 !== listenerWrapper
      ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
          passive: listenerWrapper
        })
      : targetContainer.addEventListener(domEventName, eventSystemFlags, false);
}
function dispatchEventForPluginEventSystem(
  domEventName,
  eventSystemFlags,
  nativeEvent,
  targetInst$jscomp$0,
  targetContainer
) {
  var ancestorInst = targetInst$jscomp$0;
  if (
    0 === (eventSystemFlags & 1) &&
    0 === (eventSystemFlags & 2) &&
    null !== targetInst$jscomp$0
  )
    a: for (;;) {
      if (null === targetInst$jscomp$0) return;
      var nodeTag = targetInst$jscomp$0.tag;
      if (3 === nodeTag || 4 === nodeTag) {
        var container = targetInst$jscomp$0.stateNode.containerInfo;
        if (container === targetContainer) break;
        if (4 === nodeTag)
          for (nodeTag = targetInst$jscomp$0.return; null !== nodeTag; ) {
            var grandTag = nodeTag.tag;
            if (
              (3 === grandTag || 4 === grandTag) &&
              nodeTag.stateNode.containerInfo === targetContainer
            )
              return;
            nodeTag = nodeTag.return;
          }
        for (; null !== container; ) {
          nodeTag = getClosestInstanceFromNode(container);
          if (null === nodeTag) return;
          grandTag = nodeTag.tag;
          if (
            5 === grandTag ||
            6 === grandTag ||
            26 === grandTag ||
            27 === grandTag
          ) {
            targetInst$jscomp$0 = ancestorInst = nodeTag;
            continue a;
          }
          container = container.parentNode;
        }
      }
      targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
  batchedUpdates$1(function () {
    var targetInst = ancestorInst,
      nativeEventTarget = getEventTarget(nativeEvent),
      dispatchQueue = [];
    a: {
      var reactName = topLevelEventsToReactNames.get(domEventName);
      if (void 0 !== reactName) {
        var SyntheticEventCtor = SyntheticEvent,
          reactEventType = domEventName;
        switch (domEventName) {
          case "keypress":
            if (0 === getEventCharCode(nativeEvent)) break a;
          case "keydown":
          case "keyup":
            SyntheticEventCtor = SyntheticKeyboardEvent;
            break;
          case "focusin":
            reactEventType = "focus";
            SyntheticEventCtor = SyntheticFocusEvent;
            break;
          case "focusout":
            reactEventType = "blur";
            SyntheticEventCtor = SyntheticFocusEvent;
            break;
          case "beforeblur":
          case "afterblur":
            SyntheticEventCtor = SyntheticFocusEvent;
            break;
          case "click":
            if (2 === nativeEvent.button) break a;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            SyntheticEventCtor = SyntheticMouseEvent;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            SyntheticEventCtor = SyntheticDragEvent;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            SyntheticEventCtor = SyntheticTouchEvent;
            break;
          case ANIMATION_END:
          case ANIMATION_ITERATION:
          case ANIMATION_START:
            SyntheticEventCtor = SyntheticAnimationEvent;
            break;
          case TRANSITION_END:
            SyntheticEventCtor = SyntheticTransitionEvent;
            break;
          case "scroll":
          case "scrollend":
            SyntheticEventCtor = SyntheticUIEvent;
            break;
          case "wheel":
            SyntheticEventCtor = SyntheticWheelEvent;
            break;
          case "copy":
          case "cut":
          case "paste":
            SyntheticEventCtor = SyntheticClipboardEvent;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            SyntheticEventCtor = SyntheticPointerEvent;
            break;
          case "toggle":
          case "beforetoggle":
            SyntheticEventCtor = SyntheticToggleEvent;
        }
        var inCapturePhase = 0 !== (eventSystemFlags & 4),
          accumulateTargetOnly =
            !inCapturePhase &&
            ("scroll" === domEventName || "scrollend" === domEventName),
          reactEventName = inCapturePhase
            ? null !== reactName
              ? reactName + "Capture"
              : null
            : reactName;
        inCapturePhase = [];
        for (
          var instance = targetInst, lastHostComponent;
          null !== instance;

        ) {
          var _instance = instance;
          lastHostComponent = _instance.stateNode;
          _instance = _instance.tag;
          (5 !== _instance && 26 !== _instance && 27 !== _instance) ||
            null === lastHostComponent ||
            null === reactEventName ||
            ((_instance = getListener(instance, reactEventName)),
            null != _instance &&
              inCapturePhase.push(
                createDispatchListener(instance, _instance, lastHostComponent)
              ));
          if (accumulateTargetOnly) break;
          instance = instance.return;
        }
        0 < inCapturePhase.length &&
          ((reactName = new SyntheticEventCtor(
            reactName,
            reactEventType,
            null,
            nativeEvent,
            nativeEventTarget
          )),
          dispatchQueue.push({ event: reactName, listeners: inCapturePhase }));
      }
    }
    if (0 === (eventSystemFlags & 7)) {
      a: {
        reactName =
          "mouseover" === domEventName || "pointerover" === domEventName;
        SyntheticEventCtor =
          "mouseout" === domEventName || "pointerout" === domEventName;
        if (
          reactName &&
          nativeEvent !== currentReplayingEvent &&
          (reactEventType =
            nativeEvent.relatedTarget || nativeEvent.fromElement) &&
          (getClosestInstanceFromNode(reactEventType) ||
            reactEventType[internalContainerInstanceKey])
        )
          break a;
        if (SyntheticEventCtor || reactName) {
          reactName =
            nativeEventTarget.window === nativeEventTarget
              ? nativeEventTarget
              : (reactName = nativeEventTarget.ownerDocument)
                ? reactName.defaultView || reactName.parentWindow
                : window;
          if (SyntheticEventCtor) {
            if (
              ((reactEventType =
                nativeEvent.relatedTarget || nativeEvent.toElement),
              (SyntheticEventCtor = targetInst),
              (reactEventType = reactEventType
                ? getClosestInstanceFromNode(reactEventType)
                : null),
              null !== reactEventType &&
                ((accumulateTargetOnly =
                  getNearestMountedFiber(reactEventType)),
                (inCapturePhase = reactEventType.tag),
                reactEventType !== accumulateTargetOnly ||
                  (5 !== inCapturePhase &&
                    27 !== inCapturePhase &&
                    6 !== inCapturePhase)))
            )
              reactEventType = null;
          } else (SyntheticEventCtor = null), (reactEventType = targetInst);
          if (SyntheticEventCtor !== reactEventType) {
            inCapturePhase = SyntheticMouseEvent;
            _instance = "onMouseLeave";
            reactEventName = "onMouseEnter";
            instance = "mouse";
            if ("pointerout" === domEventName || "pointerover" === domEventName)
              (inCapturePhase = SyntheticPointerEvent),
                (_instance = "onPointerLeave"),
                (reactEventName = "onPointerEnter"),
                (instance = "pointer");
            accumulateTargetOnly =
              null == SyntheticEventCtor
                ? reactName
                : getNodeFromInstance(SyntheticEventCtor);
            lastHostComponent =
              null == reactEventType
                ? reactName
                : getNodeFromInstance(reactEventType);
            reactName = new inCapturePhase(
              _instance,
              instance + "leave",
              SyntheticEventCtor,
              nativeEvent,
              nativeEventTarget
            );
            reactName.target = accumulateTargetOnly;
            reactName.relatedTarget = lastHostComponent;
            _instance = null;
            getClosestInstanceFromNode(nativeEventTarget) === targetInst &&
              ((inCapturePhase = new inCapturePhase(
                reactEventName,
                instance + "enter",
                reactEventType,
                nativeEvent,
                nativeEventTarget
              )),
              (inCapturePhase.target = lastHostComponent),
              (inCapturePhase.relatedTarget = accumulateTargetOnly),
              (_instance = inCapturePhase));
            accumulateTargetOnly = _instance;
            if (SyntheticEventCtor && reactEventType)
              b: {
                inCapturePhase = SyntheticEventCtor;
                reactEventName = reactEventType;
                instance = 0;
                for (
                  lastHostComponent = inCapturePhase;
                  lastHostComponent;
                  lastHostComponent = getParent(lastHostComponent)
                )
                  instance++;
                lastHostComponent = 0;
                for (
                  _instance = reactEventName;
                  _instance;
                  _instance = getParent(_instance)
                )
                  lastHostComponent++;
                for (; 0 < instance - lastHostComponent; )
                  (inCapturePhase = getParent(inCapturePhase)), instance--;
                for (; 0 < lastHostComponent - instance; )
                  (reactEventName = getParent(reactEventName)),
                    lastHostComponent--;
                for (; instance--; ) {
                  if (
                    inCapturePhase === reactEventName ||
                    (null !== reactEventName &&
                      inCapturePhase === reactEventName.alternate)
                  )
                    break b;
                  inCapturePhase = getParent(inCapturePhase);
                  reactEventName = getParent(reactEventName);
                }
                inCapturePhase = null;
              }
            else inCapturePhase = null;
            null !== SyntheticEventCtor &&
              accumulateEnterLeaveListenersForEvent(
                dispatchQueue,
                reactName,
                SyntheticEventCtor,
                inCapturePhase,
                !1
              );
            null !== reactEventType &&
              null !== accumulateTargetOnly &&
              accumulateEnterLeaveListenersForEvent(
                dispatchQueue,
                accumulateTargetOnly,
                reactEventType,
                inCapturePhase,
                !0
              );
          }
        }
      }
      a: {
        reactName = targetInst ? getNodeFromInstance(targetInst) : window;
        SyntheticEventCtor =
          reactName.nodeName && reactName.nodeName.toLowerCase();
        if (
          "select" === SyntheticEventCtor ||
          ("input" === SyntheticEventCtor && "file" === reactName.type)
        )
          var getTargetInstFunc = getTargetInstForChangeEvent;
        else if (isTextInputElement(reactName))
          if (isInputEventSupported)
            getTargetInstFunc = getTargetInstForInputOrChangeEvent;
          else {
            getTargetInstFunc = getTargetInstForInputEventPolyfill;
            var handleEventFunc = handleEventsForInputEventPolyfill;
          }
        else
          (SyntheticEventCtor = reactName.nodeName),
            !SyntheticEventCtor ||
            "input" !== SyntheticEventCtor.toLowerCase() ||
            ("checkbox" !== reactName.type && "radio" !== reactName.type)
              ? targetInst &&
                isCustomElement(targetInst.elementType) &&
                (getTargetInstFunc = getTargetInstForChangeEvent)
              : (getTargetInstFunc = getTargetInstForClickEvent);
        if (
          getTargetInstFunc &&
          (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))
        ) {
          createAndAccumulateChangeEvent(
            dispatchQueue,
            getTargetInstFunc,
            nativeEvent,
            nativeEventTarget
          );
          break a;
        }
        handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
        "focusout" === domEventName &&
          targetInst &&
          "number" === reactName.type &&
          null != targetInst.memoizedProps.value &&
          setDefaultValue(reactName, "number", reactName.value);
      }
      handleEventFunc = targetInst ? getNodeFromInstance(targetInst) : window;
      switch (domEventName) {
        case "focusin":
          if (
            isTextInputElement(handleEventFunc) ||
            "true" === handleEventFunc.contentEditable
          )
            (activeElement = handleEventFunc),
              (activeElementInst = targetInst),
              (lastSelection = null);
          break;
        case "focusout":
          lastSelection = activeElementInst = activeElement = null;
          break;
        case "mousedown":
          mouseDown = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          mouseDown = !1;
          constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
          break;
        case "selectionchange":
          if (skipSelectionChangeEvent) break;
        case "keydown":
        case "keyup":
          constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
      }
      var fallbackData;
      if (canUseCompositionEvent)
        b: {
          switch (domEventName) {
            case "compositionstart":
              var eventType = "onCompositionStart";
              break b;
            case "compositionend":
              eventType = "onCompositionEnd";
              break b;
            case "compositionupdate":
              eventType = "onCompositionUpdate";
              break b;
          }
          eventType = void 0;
        }
      else
        isComposing
          ? isFallbackCompositionEnd(domEventName, nativeEvent) &&
            (eventType = "onCompositionEnd")
          : "keydown" === domEventName &&
            229 === nativeEvent.keyCode &&
            (eventType = "onCompositionStart");
      eventType &&
        (useFallbackCompositionData &&
          "ko" !== nativeEvent.locale &&
          (isComposing || "onCompositionStart" !== eventType
            ? "onCompositionEnd" === eventType &&
              isComposing &&
              (fallbackData = getData())
            : ((root$1 = nativeEventTarget),
              (startText = "value" in root$1 ? root$1.value : root$1.textContent),
              (isComposing = !0))),
        (handleEventFunc = accumulateTwoPhaseListeners(targetInst, eventType)),
        0 < handleEventFunc.length &&
          ((eventType = new SyntheticCompositionEvent(
            eventType,
            domEventName,
            null,
            nativeEvent,
            nativeEventTarget
          )),
          dispatchQueue.push({ event: eventType, listeners: handleEventFunc }),
          fallbackData
            ? (eventType.data = fallbackData)
            : ((fallbackData = getDataFromCustomEvent(nativeEvent)),
              null !== fallbackData && (eventType.data = fallbackData))));
      if (
        (fallbackData = canUseTextInputEvent
          ? getNativeBeforeInputChars(domEventName, nativeEvent)
          : getFallbackBeforeInputChars(domEventName, nativeEvent))
      )
        (eventType = accumulateTwoPhaseListeners(targetInst, "onBeforeInput")),
          0 < eventType.length &&
            ((handleEventFunc = new SyntheticCompositionEvent(
              "onBeforeInput",
              "beforeinput",
              null,
              nativeEvent,
              nativeEventTarget
            )),
            dispatchQueue.push({
              event: handleEventFunc,
              listeners: eventType
            }),
            (handleEventFunc.data = fallbackData));
      extractEvents$1(
        dispatchQueue,
        domEventName,
        targetInst,
        nativeEvent,
        nativeEventTarget
      );
    }
    processDispatchQueue(dispatchQueue, eventSystemFlags);
  });
}
function createDispatchListener(instance, listener, currentTarget) {
  return {
    instance: instance,
    listener: listener,
    currentTarget: currentTarget
  };
}
function accumulateTwoPhaseListeners(targetFiber, reactName) {
  for (
    var captureName = reactName + "Capture", listeners = [];
    null !== targetFiber;

  ) {
    var _instance2 = targetFiber,
      stateNode = _instance2.stateNode;
    _instance2 = _instance2.tag;
    (5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2) ||
      null === stateNode ||
      ((_instance2 = getListener(targetFiber, captureName)),
      null != _instance2 &&
        listeners.unshift(
          createDispatchListener(targetFiber, _instance2, stateNode)
        ),
      (_instance2 = getListener(targetFiber, reactName)),
      null != _instance2 &&
        listeners.push(
          createDispatchListener(targetFiber, _instance2, stateNode)
        ));
    if (3 === targetFiber.tag) return listeners;
    targetFiber = targetFiber.return;
  }
  return [];
}
function getParent(inst) {
  if (null === inst) return null;
  do inst = inst.return;
  while (inst && 5 !== inst.tag && 27 !== inst.tag);
  return inst ? inst : null;
}
function accumulateEnterLeaveListenersForEvent(
  dispatchQueue,
  event,
  target,
  common,
  inCapturePhase
) {
  for (
    var registrationName = event._reactName, listeners = [];
    null !== target && target !== common;

  ) {
    var _instance3 = target,
      alternate = _instance3.alternate,
      stateNode = _instance3.stateNode;
    _instance3 = _instance3.tag;
    if (null !== alternate && alternate === common) break;
    (5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3) ||
      null === stateNode ||
      ((alternate = stateNode),
      inCapturePhase
        ? ((stateNode = getListener(target, registrationName)),
          null != stateNode &&
            listeners.unshift(
              createDispatchListener(target, stateNode, alternate)
            ))
        : inCapturePhase ||
          ((stateNode = getListener(target, registrationName)),
          null != stateNode &&
            listeners.push(
              createDispatchListener(target, stateNode, alternate)
            )));
    target = target.return;
  }
  0 !== listeners.length &&
    dispatchQueue.push({ event: event, listeners: listeners });
}
var NORMALIZE_NEWLINES_REGEX = /\r\n?/g,
  NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function normalizeMarkupForTextOrAttribute(markup) {
  return ("string" === typeof markup ? markup : "" + markup)
    .replace(NORMALIZE_NEWLINES_REGEX, "\n")
    .replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function checkForUnmatchedText(serverText, clientText) {
  clientText = normalizeMarkupForTextOrAttribute(clientText);
  return normalizeMarkupForTextOrAttribute(serverText) === clientText ? true : false;
}
function noop$1() {}
function setProp(domElement, tag, key, value, props, prevValue) {
  switch (key) {
    case "children":
      "string" === typeof value
        ? "body" === tag ||
          ("textarea" === tag && "" === value) ||
          setTextContent(domElement, value)
        : ("number" === typeof value || "bigint" === typeof value) &&
          "body" !== tag &&
          setTextContent(domElement, "" + value);
      break;
    case "className":
      setValueForKnownAttribute(domElement, "class", value);
      break;
    case "tabIndex":
      setValueForKnownAttribute(domElement, "tabindex", value);
      break;
    case "dir":
    case "role":
    case "viewBox":
    case "width":
    case "height":
      setValueForKnownAttribute(domElement, key, value);
      break;
    case "style":
      setValueForStyles(domElement, value, prevValue);
      break;
    case "data":
      if ("object" !== tag) {
        setValueForKnownAttribute(domElement, "data", value);
        break;
      }
    case "src":
    case "href":
      if ("" === value && ("a" !== tag || "href" !== key)) {
        domElement.removeAttribute(key);
        break;
      }
      if (
        null == value ||
        "function" === typeof value ||
        "symbol" === typeof value ||
        "boolean" === typeof value
      ) {
        domElement.removeAttribute(key);
        break;
      }
      value = sanitizeURL("" + value);
      domElement.setAttribute(key, value);
      break;
    case "action":
    case "formAction":
      if ("function" === typeof value) {
        domElement.setAttribute(
          key,
          "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
        );
        break;
      } else
        "function" === typeof prevValue &&
          ("formAction" === key
            ? ("input" !== tag &&
                setProp(domElement, tag, "name", props.name, props, null),
              setProp(
                domElement,
                tag,
                "formEncType",
                props.formEncType,
                props,
                null
              ),
              setProp(
                domElement,
                tag,
                "formMethod",
                props.formMethod,
                props,
                null
              ),
              setProp(
                domElement,
                tag,
                "formTarget",
                props.formTarget,
                props,
                null
              ))
            : (setProp(domElement, tag, "encType", props.encType, props, null),
              setProp(domElement, tag, "method", props.method, props, null),
              setProp(domElement, tag, "target", props.target, props, null)));
      if (
        null == value ||
        "symbol" === typeof value ||
        "boolean" === typeof value
      ) {
        domElement.removeAttribute(key);
        break;
      }
      value = sanitizeURL("" + value);
      domElement.setAttribute(key, value);
      break;
    case "onClick":
      null != value && (domElement.onclick = noop$1);
      break;
    case "onScroll":
      null != value && listenToNonDelegatedEvent("scroll", domElement);
      break;
    case "onScrollEnd":
      null != value && listenToNonDelegatedEvent("scrollend", domElement);
      break;
    case "dangerouslySetInnerHTML":
      if (null != value) {
        if ("object" !== typeof value || !("__html" in value))
          throw Error(formatProdErrorMessage(61));
        key = value.__html;
        if (null != key) {
          if (null != props.children) throw Error(formatProdErrorMessage(60));
          domElement.innerHTML = key;
        }
      }
      break;
    case "multiple":
      domElement.multiple =
        value && "function" !== typeof value && "symbol" !== typeof value;
      break;
    case "muted":
      domElement.muted =
        value && "function" !== typeof value && "symbol" !== typeof value;
      break;
    case "suppressContentEditableWarning":
    case "suppressHydrationWarning":
    case "defaultValue":
    case "defaultChecked":
    case "innerHTML":
    case "ref":
      break;
    case "autoFocus":
      break;
    case "xlinkHref":
      if (
        null == value ||
        "function" === typeof value ||
        "boolean" === typeof value ||
        "symbol" === typeof value
      ) {
        domElement.removeAttribute("xlink:href");
        break;
      }
      key = sanitizeURL("" + value);
      domElement.setAttributeNS(
        "http://www.w3.org/1999/xlink",
        "xlink:href",
        key
      );
      break;
    case "contentEditable":
    case "spellCheck":
    case "draggable":
    case "value":
    case "autoReverse":
    case "externalResourcesRequired":
    case "focusable":
    case "preserveAlpha":
      null != value && "function" !== typeof value && "symbol" !== typeof value
        ? domElement.setAttribute(key, "" + value)
        : domElement.removeAttribute(key);
      break;
    case "inert":
    case "allowFullScreen":
    case "async":
    case "autoPlay":
    case "controls":
    case "default":
    case "defer":
    case "disabled":
    case "disablePictureInPicture":
    case "disableRemotePlayback":
    case "formNoValidate":
    case "hidden":
    case "loop":
    case "noModule":
    case "noValidate":
    case "open":
    case "playsInline":
    case "readOnly":
    case "required":
    case "reversed":
    case "scoped":
    case "seamless":
    case "itemScope":
      value && "function" !== typeof value && "symbol" !== typeof value
        ? domElement.setAttribute(key, "")
        : domElement.removeAttribute(key);
      break;
    case "capture":
    case "download":
      true === value
        ? domElement.setAttribute(key, "")
        : false !== value &&
            null != value &&
            "function" !== typeof value &&
            "symbol" !== typeof value
          ? domElement.setAttribute(key, value)
          : domElement.removeAttribute(key);
      break;
    case "cols":
    case "rows":
    case "size":
    case "span":
      null != value &&
      "function" !== typeof value &&
      "symbol" !== typeof value &&
      !isNaN(value) &&
      1 <= value
        ? domElement.setAttribute(key, value)
        : domElement.removeAttribute(key);
      break;
    case "rowSpan":
    case "start":
      null == value ||
      "function" === typeof value ||
      "symbol" === typeof value ||
      isNaN(value)
        ? domElement.removeAttribute(key)
        : domElement.setAttribute(key, value);
      break;
    case "popover":
      listenToNonDelegatedEvent("beforetoggle", domElement);
      listenToNonDelegatedEvent("toggle", domElement);
      setValueForAttribute(domElement, "popover", value);
      break;
    case "xlinkActuate":
      setValueForNamespacedAttribute(
        domElement,
        "http://www.w3.org/1999/xlink",
        "xlink:actuate",
        value
      );
      break;
    case "xlinkArcrole":
      setValueForNamespacedAttribute(
        domElement,
        "http://www.w3.org/1999/xlink",
        "xlink:arcrole",
        value
      );
      break;
    case "xlinkRole":
      setValueForNamespacedAttribute(
        domElement,
        "http://www.w3.org/1999/xlink",
        "xlink:role",
        value
      );
      break;
    case "xlinkShow":
      setValueForNamespacedAttribute(
        domElement,
        "http://www.w3.org/1999/xlink",
        "xlink:show",
        value
      );
      break;
    case "xlinkTitle":
      setValueForNamespacedAttribute(
        domElement,
        "http://www.w3.org/1999/xlink",
        "xlink:title",
        value
      );
      break;
    case "xlinkType":
      setValueForNamespacedAttribute(
        domElement,
        "http://www.w3.org/1999/xlink",
        "xlink:type",
        value
      );
      break;
    case "xmlBase":
      setValueForNamespacedAttribute(
        domElement,
        "http://www.w3.org/XML/1998/namespace",
        "xml:base",
        value
      );
      break;
    case "xmlLang":
      setValueForNamespacedAttribute(
        domElement,
        "http://www.w3.org/XML/1998/namespace",
        "xml:lang",
        value
      );
      break;
    case "xmlSpace":
      setValueForNamespacedAttribute(
        domElement,
        "http://www.w3.org/XML/1998/namespace",
        "xml:space",
        value
      );
      break;
    case "is":
      setValueForAttribute(domElement, "is", value);
      break;
    case "innerText":
    case "textContent":
      break;
    default:
      if (
        !(2 < key.length) ||
        ("o" !== key[0] && "O" !== key[0]) ||
        ("n" !== key[1] && "N" !== key[1])
      )
        (key = aliases.get(key) || key),
          setValueForAttribute(domElement, key, value);
  }
}
function setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
  switch (key) {
    case "style":
      setValueForStyles(domElement, value, prevValue);
      break;
    case "dangerouslySetInnerHTML":
      if (null != value) {
        if ("object" !== typeof value || !("__html" in value))
          throw Error(formatProdErrorMessage(61));
        key = value.__html;
        if (null != key) {
          if (null != props.children) throw Error(formatProdErrorMessage(60));
          domElement.innerHTML = key;
        }
      }
      break;
    case "children":
      "string" === typeof value
        ? setTextContent(domElement, value)
        : ("number" === typeof value || "bigint" === typeof value) &&
          setTextContent(domElement, "" + value);
      break;
    case "onScroll":
      null != value && listenToNonDelegatedEvent("scroll", domElement);
      break;
    case "onScrollEnd":
      null != value && listenToNonDelegatedEvent("scrollend", domElement);
      break;
    case "onClick":
      null != value && (domElement.onclick = noop$1);
      break;
    case "suppressContentEditableWarning":
    case "suppressHydrationWarning":
    case "innerHTML":
    case "ref":
      break;
    case "innerText":
    case "textContent":
      break;
    default:
      if (!registrationNameDependencies.hasOwnProperty(key))
        a: {
          if (
            "o" === key[0] &&
            "n" === key[1] &&
            ((props = key.endsWith("Capture")),
            (tag = key.slice(2, props ? key.length - 7 : void 0)),
            (prevValue = domElement[internalPropsKey] || null),
            (prevValue = null != prevValue ? prevValue[key] : null),
            "function" === typeof prevValue &&
              domElement.removeEventListener(tag, prevValue, props),
            "function" === typeof value)
          ) {
            "function" !== typeof prevValue &&
              null !== prevValue &&
              (key in domElement
                ? (domElement[key] = null)
                : domElement.hasAttribute(key) &&
                  domElement.removeAttribute(key));
            domElement.addEventListener(tag, value, props);
            break a;
          }
          key in domElement
            ? (domElement[key] = value)
            : true === value
              ? domElement.setAttribute(key, "")
              : setValueForAttribute(domElement, key, value);
        }
  }
}
function setInitialProperties(domElement, tag, props) {
  switch (tag) {
    case "div":
    case "span":
    case "svg":
    case "path":
    case "a":
    case "g":
    case "p":
    case "li":
      break;
    case "img":
      listenToNonDelegatedEvent("error", domElement);
      listenToNonDelegatedEvent("load", domElement);
      var hasSrc = false,
        hasSrcSet = false,
        propKey;
      for (propKey in props)
        if (props.hasOwnProperty(propKey)) {
          var propValue = props[propKey];
          if (null != propValue)
            switch (propKey) {
              case "src":
                hasSrc = true;
                break;
              case "srcSet":
                hasSrcSet = true;
                break;
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(formatProdErrorMessage(137, tag));
              default:
                setProp(domElement, tag, propKey, propValue, props, null);
            }
        }
      hasSrcSet &&
        setProp(domElement, tag, "srcSet", props.srcSet, props, null);
      hasSrc && setProp(domElement, tag, "src", props.src, props, null);
      return;
    case "input":
      listenToNonDelegatedEvent("invalid", domElement);
      var defaultValue = (propKey = propValue = hasSrcSet = null),
        checked = null,
        defaultChecked = null;
      for (hasSrc in props)
        if (props.hasOwnProperty(hasSrc)) {
          var propValue$188 = props[hasSrc];
          if (null != propValue$188)
            switch (hasSrc) {
              case "name":
                hasSrcSet = propValue$188;
                break;
              case "type":
                propValue = propValue$188;
                break;
              case "checked":
                checked = propValue$188;
                break;
              case "defaultChecked":
                defaultChecked = propValue$188;
                break;
              case "value":
                propKey = propValue$188;
                break;
              case "defaultValue":
                defaultValue = propValue$188;
                break;
              case "children":
              case "dangerouslySetInnerHTML":
                if (null != propValue$188)
                  throw Error(formatProdErrorMessage(137, tag));
                break;
              default:
                setProp(domElement, tag, hasSrc, propValue$188, props, null);
            }
        }
      initInput(
        domElement,
        propKey,
        defaultValue,
        checked,
        defaultChecked,
        propValue,
        hasSrcSet,
        false
      );
      track$1(domElement);
      return;
    case "select":
      listenToNonDelegatedEvent("invalid", domElement);
      hasSrc = propValue = propKey = null;
      for (hasSrcSet in props)
        if (
          props.hasOwnProperty(hasSrcSet) &&
          ((defaultValue = props[hasSrcSet]), null != defaultValue)
        )
          switch (hasSrcSet) {
            case "value":
              propKey = defaultValue;
              break;
            case "defaultValue":
              propValue = defaultValue;
              break;
            case "multiple":
              hasSrc = defaultValue;
            default:
              setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
          }
      tag = propKey;
      props = propValue;
      domElement.multiple = !!hasSrc;
      null != tag
        ? updateOptions(domElement, !!hasSrc, tag, false)
        : null != props && updateOptions(domElement, !!hasSrc, props, true);
      return;
    case "textarea":
      listenToNonDelegatedEvent("invalid", domElement);
      propKey = hasSrcSet = hasSrc = null;
      for (propValue in props)
        if (
          props.hasOwnProperty(propValue) &&
          ((defaultValue = props[propValue]), null != defaultValue)
        )
          switch (propValue) {
            case "value":
              hasSrc = defaultValue;
              break;
            case "defaultValue":
              hasSrcSet = defaultValue;
              break;
            case "children":
              propKey = defaultValue;
              break;
            case "dangerouslySetInnerHTML":
              if (null != defaultValue) throw Error(formatProdErrorMessage(91));
              break;
            default:
              setProp(domElement, tag, propValue, defaultValue, props, null);
          }
      initTextarea(domElement, hasSrc, hasSrcSet, propKey);
      track$1(domElement);
      return;
    case "option":
      for (checked in props)
        if (
          props.hasOwnProperty(checked) &&
          ((hasSrc = props[checked]), null != hasSrc)
        )
          switch (checked) {
            case "selected":
              domElement.selected =
                hasSrc &&
                "function" !== typeof hasSrc &&
                "symbol" !== typeof hasSrc;
              break;
            default:
              setProp(domElement, tag, checked, hasSrc, props, null);
          }
      return;
    case "dialog":
      listenToNonDelegatedEvent("beforetoggle", domElement);
      listenToNonDelegatedEvent("toggle", domElement);
      listenToNonDelegatedEvent("cancel", domElement);
      listenToNonDelegatedEvent("close", domElement);
      break;
    case "iframe":
    case "object":
      listenToNonDelegatedEvent("load", domElement);
      break;
    case "video":
    case "audio":
      for (hasSrc = 0; hasSrc < mediaEventTypes.length; hasSrc++)
        listenToNonDelegatedEvent(mediaEventTypes[hasSrc], domElement);
      break;
    case "image":
      listenToNonDelegatedEvent("error", domElement);
      listenToNonDelegatedEvent("load", domElement);
      break;
    case "details":
      listenToNonDelegatedEvent("toggle", domElement);
      break;
    case "embed":
    case "source":
    case "link":
      listenToNonDelegatedEvent("error", domElement),
        listenToNonDelegatedEvent("load", domElement);
    case "area":
    case "base":
    case "br":
    case "col":
    case "hr":
    case "keygen":
    case "meta":
    case "param":
    case "track":
    case "wbr":
    case "menuitem":
      for (defaultChecked in props)
        if (
          props.hasOwnProperty(defaultChecked) &&
          ((hasSrc = props[defaultChecked]), null != hasSrc)
        )
          switch (defaultChecked) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw Error(formatProdErrorMessage(137, tag));
            default:
              setProp(domElement, tag, defaultChecked, hasSrc, props, null);
          }
      return;
    default:
      if (isCustomElement(tag)) {
        for (propValue$188 in props)
          props.hasOwnProperty(propValue$188) &&
            ((hasSrc = props[propValue$188]),
            void 0 !== hasSrc &&
              setPropOnCustomElement(
                domElement,
                tag,
                propValue$188,
                hasSrc,
                props,
                void 0
              ));
        return;
      }
  }
  for (defaultValue in props)
    props.hasOwnProperty(defaultValue) &&
      ((hasSrc = props[defaultValue]),
      null != hasSrc &&
        setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function updateProperties(domElement, tag, lastProps, nextProps) {
  switch (tag) {
    case "div":
    case "span":
    case "svg":
    case "path":
    case "a":
    case "g":
    case "p":
    case "li":
      break;
    case "input":
      var name = null,
        type = null,
        value = null,
        defaultValue = null,
        lastDefaultValue = null,
        checked = null,
        defaultChecked = null;
      for (propKey in lastProps) {
        var lastProp = lastProps[propKey];
        if (lastProps.hasOwnProperty(propKey) && null != lastProp)
          switch (propKey) {
            case "checked":
              break;
            case "value":
              break;
            case "defaultValue":
              lastDefaultValue = lastProp;
            default:
              nextProps.hasOwnProperty(propKey) ||
                setProp(domElement, tag, propKey, null, nextProps, lastProp);
          }
      }
      for (var propKey$205 in nextProps) {
        var propKey = nextProps[propKey$205];
        lastProp = lastProps[propKey$205];
        if (
          nextProps.hasOwnProperty(propKey$205) &&
          (null != propKey || null != lastProp)
        )
          switch (propKey$205) {
            case "type":
              type = propKey;
              break;
            case "name":
              name = propKey;
              break;
            case "checked":
              checked = propKey;
              break;
            case "defaultChecked":
              defaultChecked = propKey;
              break;
            case "value":
              value = propKey;
              break;
            case "defaultValue":
              defaultValue = propKey;
              break;
            case "children":
            case "dangerouslySetInnerHTML":
              if (null != propKey)
                throw Error(formatProdErrorMessage(137, tag));
              break;
            default:
              propKey !== lastProp &&
                setProp(
                  domElement,
                  tag,
                  propKey$205,
                  propKey,
                  nextProps,
                  lastProp
                );
          }
      }
      updateInput(
        domElement,
        value,
        defaultValue,
        lastDefaultValue,
        checked,
        defaultChecked,
        type,
        name
      );
      return;
    case "select":
      propKey = value = defaultValue = propKey$205 = null;
      for (type in lastProps)
        if (
          ((lastDefaultValue = lastProps[type]),
          lastProps.hasOwnProperty(type) && null != lastDefaultValue)
        )
          switch (type) {
            case "value":
              break;
            case "multiple":
              propKey = lastDefaultValue;
            default:
              nextProps.hasOwnProperty(type) ||
                setProp(
                  domElement,
                  tag,
                  type,
                  null,
                  nextProps,
                  lastDefaultValue
                );
          }
      for (name in nextProps)
        if (
          ((type = nextProps[name]),
          (lastDefaultValue = lastProps[name]),
          nextProps.hasOwnProperty(name) &&
            (null != type || null != lastDefaultValue))
        )
          switch (name) {
            case "value":
              propKey$205 = type;
              break;
            case "defaultValue":
              defaultValue = type;
              break;
            case "multiple":
              value = type;
            default:
              type !== lastDefaultValue &&
                setProp(
                  domElement,
                  tag,
                  name,
                  type,
                  nextProps,
                  lastDefaultValue
                );
          }
      tag = defaultValue;
      lastProps = value;
      nextProps = propKey;
      null != propKey$205
        ? updateOptions(domElement, !!lastProps, propKey$205, false)
        : !!nextProps !== !!lastProps &&
          (null != tag
            ? updateOptions(domElement, !!lastProps, tag, true)
            : updateOptions(domElement, !!lastProps, lastProps ? [] : "", false));
      return;
    case "textarea":
      propKey = propKey$205 = null;
      for (defaultValue in lastProps)
        if (
          ((name = lastProps[defaultValue]),
          lastProps.hasOwnProperty(defaultValue) &&
            null != name &&
            !nextProps.hasOwnProperty(defaultValue))
        )
          switch (defaultValue) {
            case "value":
              break;
            case "children":
              break;
            default:
              setProp(domElement, tag, defaultValue, null, nextProps, name);
          }
      for (value in nextProps)
        if (
          ((name = nextProps[value]),
          (type = lastProps[value]),
          nextProps.hasOwnProperty(value) && (null != name || null != type))
        )
          switch (value) {
            case "value":
              propKey$205 = name;
              break;
            case "defaultValue":
              propKey = name;
              break;
            case "children":
              break;
            case "dangerouslySetInnerHTML":
              if (null != name) throw Error(formatProdErrorMessage(91));
              break;
            default:
              name !== type &&
                setProp(domElement, tag, value, name, nextProps, type);
          }
      updateTextarea(domElement, propKey$205, propKey);
      return;
    case "option":
      for (var propKey$221 in lastProps)
        if (
          ((propKey$205 = lastProps[propKey$221]),
          lastProps.hasOwnProperty(propKey$221) &&
            null != propKey$205 &&
            !nextProps.hasOwnProperty(propKey$221))
        )
          switch (propKey$221) {
            case "selected":
              domElement.selected = false;
              break;
            default:
              setProp(
                domElement,
                tag,
                propKey$221,
                null,
                nextProps,
                propKey$205
              );
          }
      for (lastDefaultValue in nextProps)
        if (
          ((propKey$205 = nextProps[lastDefaultValue]),
          (propKey = lastProps[lastDefaultValue]),
          nextProps.hasOwnProperty(lastDefaultValue) &&
            propKey$205 !== propKey &&
            (null != propKey$205 || null != propKey))
        )
          switch (lastDefaultValue) {
            case "selected":
              domElement.selected =
                propKey$205 &&
                "function" !== typeof propKey$205 &&
                "symbol" !== typeof propKey$205;
              break;
            default:
              setProp(
                domElement,
                tag,
                lastDefaultValue,
                propKey$205,
                nextProps,
                propKey
              );
          }
      return;
    case "img":
    case "link":
    case "area":
    case "base":
    case "br":
    case "col":
    case "embed":
    case "hr":
    case "keygen":
    case "meta":
    case "param":
    case "source":
    case "track":
    case "wbr":
    case "menuitem":
      for (var propKey$226 in lastProps)
        (propKey$205 = lastProps[propKey$226]),
          lastProps.hasOwnProperty(propKey$226) &&
            null != propKey$205 &&
            !nextProps.hasOwnProperty(propKey$226) &&
            setProp(domElement, tag, propKey$226, null, nextProps, propKey$205);
      for (checked in nextProps)
        if (
          ((propKey$205 = nextProps[checked]),
          (propKey = lastProps[checked]),
          nextProps.hasOwnProperty(checked) &&
            propKey$205 !== propKey &&
            (null != propKey$205 || null != propKey))
        )
          switch (checked) {
            case "children":
            case "dangerouslySetInnerHTML":
              if (null != propKey$205)
                throw Error(formatProdErrorMessage(137, tag));
              break;
            default:
              setProp(
                domElement,
                tag,
                checked,
                propKey$205,
                nextProps,
                propKey
              );
          }
      return;
    default:
      if (isCustomElement(tag)) {
        for (var propKey$231 in lastProps)
          (propKey$205 = lastProps[propKey$231]),
            lastProps.hasOwnProperty(propKey$231) &&
              void 0 !== propKey$205 &&
              !nextProps.hasOwnProperty(propKey$231) &&
              setPropOnCustomElement(
                domElement,
                tag,
                propKey$231,
                void 0,
                nextProps,
                propKey$205
              );
        for (defaultChecked in nextProps)
          (propKey$205 = nextProps[defaultChecked]),
            (propKey = lastProps[defaultChecked]),
            !nextProps.hasOwnProperty(defaultChecked) ||
              propKey$205 === propKey ||
              (void 0 === propKey$205 && void 0 === propKey) ||
              setPropOnCustomElement(
                domElement,
                tag,
                defaultChecked,
                propKey$205,
                nextProps,
                propKey
              );
        return;
      }
  }
  for (var propKey$236 in lastProps)
    (propKey$205 = lastProps[propKey$236]),
      lastProps.hasOwnProperty(propKey$236) &&
        null != propKey$205 &&
        !nextProps.hasOwnProperty(propKey$236) &&
        setProp(domElement, tag, propKey$236, null, nextProps, propKey$205);
  for (lastProp in nextProps)
    (propKey$205 = nextProps[lastProp]),
      (propKey = lastProps[lastProp]),
      !nextProps.hasOwnProperty(lastProp) ||
        propKey$205 === propKey ||
        (null == propKey$205 && null == propKey) ||
        setProp(domElement, tag, lastProp, propKey$205, nextProps, propKey);
}
var eventsEnabled = null,
  selectionInformation = null;
function getOwnerDocumentFromRootContainer(rootContainerElement) {
  return 9 === rootContainerElement.nodeType
    ? rootContainerElement
    : rootContainerElement.ownerDocument;
}
function getOwnHostContext(namespaceURI) {
  switch (namespaceURI) {
    case "http://www.w3.org/2000/svg":
      return 1;
    case "http://www.w3.org/1998/Math/MathML":
      return 2;
    default:
      return 0;
  }
}
function getChildHostContextProd(parentNamespace, type) {
  if (0 === parentNamespace)
    switch (type) {
      case "svg":
        return 1;
      case "math":
        return 2;
      default:
        return 0;
    }
  return 1 === parentNamespace && "foreignObject" === type
    ? 0
    : parentNamespace;
}
function shouldSetTextContent(type, props) {
  return (
    "textarea" === type ||
    "noscript" === type ||
    "string" === typeof props.children ||
    "number" === typeof props.children ||
    "bigint" === typeof props.children ||
    ("object" === typeof props.dangerouslySetInnerHTML &&
      null !== props.dangerouslySetInnerHTML &&
      null != props.dangerouslySetInnerHTML.__html)
  );
}
var currentPopstateTransitionEvent = null;
function shouldAttemptEagerTransition() {
  var event = window.event;
  if (event && "popstate" === event.type) {
    if (event === currentPopstateTransitionEvent) return false;
    currentPopstateTransitionEvent = event;
    return true;
  }
  currentPopstateTransitionEvent = null;
  return false;
}
var scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0,
  cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0,
  localPromise = "function" === typeof Promise ? Promise : void 0,
  scheduleMicrotask =
    "function" === typeof queueMicrotask
      ? queueMicrotask
      : "undefined" !== typeof localPromise
        ? function (callback) {
            return localPromise
              .resolve(null)
              .then(callback)
              .catch(handleErrorInNextTick);
          }
        : scheduleTimeout;
function handleErrorInNextTick(error) {
  setTimeout(function () {
    throw error;
  });
}
function isSingletonScope(type) {
  return "head" === type;
}
function clearSuspenseBoundary(parentInstance, suspenseInstance) {
  var node = suspenseInstance,
    possiblePreambleContribution = 0,
    depth = 0;
  do {
    var nextNode = node.nextSibling;
    parentInstance.removeChild(node);
    if (nextNode && 8 === nextNode.nodeType)
      if (((node = nextNode.data), "/$" === node)) {
        if (
          0 < possiblePreambleContribution &&
          8 > possiblePreambleContribution
        ) {
          node = possiblePreambleContribution;
          var ownerDocument = parentInstance.ownerDocument;
          node & 1 && releaseSingletonInstance(ownerDocument.documentElement);
          node & 2 && releaseSingletonInstance(ownerDocument.body);
          if (node & 4)
            for (
              node = ownerDocument.head,
                releaseSingletonInstance(node),
                ownerDocument = node.firstChild;
              ownerDocument;

            ) {
              var nextNode$jscomp$0 = ownerDocument.nextSibling,
                nodeName = ownerDocument.nodeName;
              ownerDocument[internalHoistableMarker] ||
                "SCRIPT" === nodeName ||
                "STYLE" === nodeName ||
                ("LINK" === nodeName &&
                  "stylesheet" === ownerDocument.rel.toLowerCase()) ||
                node.removeChild(ownerDocument);
              ownerDocument = nextNode$jscomp$0;
            }
        }
        if (0 === depth) {
          parentInstance.removeChild(nextNode);
          retryIfBlockedOn(suspenseInstance);
          return;
        }
        depth--;
      } else
        "$" === node || "$?" === node || "$!" === node
          ? depth++
          : (possiblePreambleContribution = node.charCodeAt(0) - 48);
    else possiblePreambleContribution = 0;
    node = nextNode;
  } while (node);
  retryIfBlockedOn(suspenseInstance);
}
function clearContainerSparingly(container) {
  var nextNode = container.firstChild;
  nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
  for (; nextNode; ) {
    var node = nextNode;
    nextNode = nextNode.nextSibling;
    switch (node.nodeName) {
      case "HTML":
      case "HEAD":
      case "BODY":
        clearContainerSparingly(node);
        detachDeletedInstance(node);
        continue;
      case "SCRIPT":
      case "STYLE":
        continue;
      case "LINK":
        if ("stylesheet" === node.rel.toLowerCase()) continue;
    }
    container.removeChild(node);
  }
}
function canHydrateInstance(instance, type, props, inRootOrSingleton) {
  for (; 1 === instance.nodeType; ) {
    var anyProps = props;
    if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
      if (
        !inRootOrSingleton &&
        ("INPUT" !== instance.nodeName || "hidden" !== instance.type)
      )
        break;
    } else if (!inRootOrSingleton)
      if ("input" === type && "hidden" === instance.type) {
        var name = null == anyProps.name ? null : "" + anyProps.name;
        if (
          "hidden" === anyProps.type &&
          instance.getAttribute("name") === name
        )
          return instance;
      } else return instance;
    else if (!instance[internalHoistableMarker])
      switch (type) {
        case "meta":
          if (!instance.hasAttribute("itemprop")) break;
          return instance;
        case "link":
          name = instance.getAttribute("rel");
          if ("stylesheet" === name && instance.hasAttribute("data-precedence"))
            break;
          else if (
            name !== anyProps.rel ||
            instance.getAttribute("href") !==
              (null == anyProps.href || "" === anyProps.href
                ? null
                : anyProps.href) ||
            instance.getAttribute("crossorigin") !==
              (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) ||
            instance.getAttribute("title") !==
              (null == anyProps.title ? null : anyProps.title)
          )
            break;
          return instance;
        case "style":
          if (instance.hasAttribute("data-precedence")) break;
          return instance;
        case "script":
          name = instance.getAttribute("src");
          if (
            (name !== (null == anyProps.src ? null : anyProps.src) ||
              instance.getAttribute("type") !==
                (null == anyProps.type ? null : anyProps.type) ||
              instance.getAttribute("crossorigin") !==
                (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) &&
            name &&
            instance.hasAttribute("async") &&
            !instance.hasAttribute("itemprop")
          )
            break;
          return instance;
        default:
          return instance;
      }
    instance = getNextHydratable(instance.nextSibling);
    if (null === instance) break;
  }
  return null;
}
function canHydrateTextInstance(instance, text, inRootOrSingleton) {
  if ("" === text) return null;
  for (; 3 !== instance.nodeType; ) {
    if (
      (1 !== instance.nodeType ||
        "INPUT" !== instance.nodeName ||
        "hidden" !== instance.type) &&
      !inRootOrSingleton
    )
      return null;
    instance = getNextHydratable(instance.nextSibling);
    if (null === instance) return null;
  }
  return instance;
}
function isSuspenseInstanceFallback(instance) {
  return (
    "$!" === instance.data ||
    ("$?" === instance.data && "complete" === instance.ownerDocument.readyState)
  );
}
function registerSuspenseInstanceRetry(instance, callback) {
  var ownerDocument = instance.ownerDocument;
  if ("$?" !== instance.data || "complete" === ownerDocument.readyState)
    callback();
  else {
    var listener = function () {
      callback();
      ownerDocument.removeEventListener("DOMContentLoaded", listener);
    };
    ownerDocument.addEventListener("DOMContentLoaded", listener);
    instance._reactRetry = listener;
  }
}
function getNextHydratable(node) {
  for (; null != node; node = node.nextSibling) {
    var nodeType = node.nodeType;
    if (1 === nodeType || 3 === nodeType) break;
    if (8 === nodeType) {
      nodeType = node.data;
      if (
        "$" === nodeType ||
        "$!" === nodeType ||
        "$?" === nodeType ||
        "F!" === nodeType ||
        "F" === nodeType
      )
        break;
      if ("/$" === nodeType) return null;
    }
  }
  return node;
}
var previousHydratableOnEnteringScopedSingleton = null;
function getParentSuspenseInstance(targetInstance) {
  targetInstance = targetInstance.previousSibling;
  for (var depth = 0; targetInstance; ) {
    if (8 === targetInstance.nodeType) {
      var data = targetInstance.data;
      if ("$" === data || "$!" === data || "$?" === data) {
        if (0 === depth) return targetInstance;
        depth--;
      } else "/$" === data && depth++;
    }
    targetInstance = targetInstance.previousSibling;
  }
  return null;
}
function resolveSingletonInstance(type, props, rootContainerInstance) {
  props = getOwnerDocumentFromRootContainer(rootContainerInstance);
  switch (type) {
    case "html":
      type = props.documentElement;
      if (!type) throw Error(formatProdErrorMessage(452));
      return type;
    case "head":
      type = props.head;
      if (!type) throw Error(formatProdErrorMessage(453));
      return type;
    case "body":
      type = props.body;
      if (!type) throw Error(formatProdErrorMessage(454));
      return type;
    default:
      throw Error(formatProdErrorMessage(451));
  }
}
function releaseSingletonInstance(instance) {
  for (var attributes = instance.attributes; attributes.length; )
    instance.removeAttributeNode(attributes[0]);
  detachDeletedInstance(instance);
}
var preloadPropsMap = new Map(),
  preconnectsSet = new Set();
function getHoistableRoot(container) {
  return "function" === typeof container.getRootNode
    ? container.getRootNode()
    : 9 === container.nodeType
      ? container
      : container.ownerDocument;
}
var previousDispatcher = ReactDOMSharedInternals.d;
ReactDOMSharedInternals.d = {
  f: flushSyncWork,
  r: requestFormReset,
  D: prefetchDNS,
  C: preconnect,
  L: preload,
  m: preloadModule,
  X: preinitScript,
  S: preinitStyle,
  M: preinitModuleScript
};
function flushSyncWork() {
  var previousWasRendering = previousDispatcher.f(),
    wasRendering = flushSyncWork$1();
  return previousWasRendering || wasRendering;
}
function requestFormReset(form) {
  var formInst = getInstanceFromNode(form);
  null !== formInst && 5 === formInst.tag && "form" === formInst.type
    ? requestFormReset$1(formInst)
    : previousDispatcher.r(form);
}
var globalDocument = "undefined" === typeof document ? null : document;
function preconnectAs(rel, href, crossOrigin) {
  var ownerDocument = globalDocument;
  if (ownerDocument && "string" === typeof href && href) {
    var limitedEscapedHref =
      escapeSelectorAttributeValueInsideDoubleQuotes(href);
    limitedEscapedHref =
      'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
    "string" === typeof crossOrigin &&
      (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
    preconnectsSet.has(limitedEscapedHref) ||
      (preconnectsSet.add(limitedEscapedHref),
      (rel = { rel: rel, crossOrigin: crossOrigin, href: href }),
      null === ownerDocument.querySelector(limitedEscapedHref) &&
        ((href = ownerDocument.createElement("link")),
        setInitialProperties(href, "link", rel),
        markNodeAsHoistable(href),
        ownerDocument.head.appendChild(href)));
  }
}
function prefetchDNS(href) {
  previousDispatcher.D(href);
  preconnectAs("dns-prefetch", href, null);
}
function preconnect(href, crossOrigin) {
  previousDispatcher.C(href, crossOrigin);
  preconnectAs("preconnect", href, crossOrigin);
}
function preload(href, as, options) {
  previousDispatcher.L(href, as, options);
  var ownerDocument = globalDocument;
  if (ownerDocument && href && as) {
    var preloadSelector =
      'link[rel="preload"][as="' +
      escapeSelectorAttributeValueInsideDoubleQuotes(as) +
      '"]';
    "image" === as
      ? options && options.imageSrcSet
        ? ((preloadSelector +=
            '[imagesrcset="' +
            escapeSelectorAttributeValueInsideDoubleQuotes(
              options.imageSrcSet
            ) +
            '"]'),
          "string" === typeof options.imageSizes &&
            (preloadSelector +=
              '[imagesizes="' +
              escapeSelectorAttributeValueInsideDoubleQuotes(
                options.imageSizes
              ) +
              '"]'))
        : (preloadSelector +=
            '[href="' +
            escapeSelectorAttributeValueInsideDoubleQuotes(href) +
            '"]')
      : (preloadSelector +=
          '[href="' +
          escapeSelectorAttributeValueInsideDoubleQuotes(href) +
          '"]');
    var key = preloadSelector;
    switch (as) {
      case "style":
        key = getStyleKey(href);
        break;
      case "script":
        key = getScriptKey(href);
    }
    preloadPropsMap.has(key) ||
      ((href = assign(
        {
          rel: "preload",
          href:
            "image" === as && options && options.imageSrcSet ? void 0 : href,
          as: as
        },
        options
      )),
      preloadPropsMap.set(key, href),
      null !== ownerDocument.querySelector(preloadSelector) ||
        ("style" === as &&
          ownerDocument.querySelector(getStylesheetSelectorFromKey(key))) ||
        ("script" === as &&
          ownerDocument.querySelector(getScriptSelectorFromKey(key))) ||
        ((as = ownerDocument.createElement("link")),
        setInitialProperties(as, "link", href),
        markNodeAsHoistable(as),
        ownerDocument.head.appendChild(as)));
  }
}
function preloadModule(href, options) {
  previousDispatcher.m(href, options);
  var ownerDocument = globalDocument;
  if (ownerDocument && href) {
    var as = options && "string" === typeof options.as ? options.as : "script",
      preloadSelector =
        'link[rel="modulepreload"][as="' +
        escapeSelectorAttributeValueInsideDoubleQuotes(as) +
        '"][href="' +
        escapeSelectorAttributeValueInsideDoubleQuotes(href) +
        '"]',
      key = preloadSelector;
    switch (as) {
      case "audioworklet":
      case "paintworklet":
      case "serviceworker":
      case "sharedworker":
      case "worker":
      case "script":
        key = getScriptKey(href);
    }
    if (
      !preloadPropsMap.has(key) &&
      ((href = assign({ rel: "modulepreload", href: href }, options)),
      preloadPropsMap.set(key, href),
      null === ownerDocument.querySelector(preloadSelector))
    ) {
      switch (as) {
        case "audioworklet":
        case "paintworklet":
        case "serviceworker":
        case "sharedworker":
        case "worker":
        case "script":
          if (ownerDocument.querySelector(getScriptSelectorFromKey(key)))
            return;
      }
      as = ownerDocument.createElement("link");
      setInitialProperties(as, "link", href);
      markNodeAsHoistable(as);
      ownerDocument.head.appendChild(as);
    }
  }
}
function preinitStyle(href, precedence, options) {
  previousDispatcher.S(href, precedence, options);
  var ownerDocument = globalDocument;
  if (ownerDocument && href) {
    var styles = getResourcesFromRoot(ownerDocument).hoistableStyles,
      key = getStyleKey(href);
    precedence = precedence || "default";
    var resource = styles.get(key);
    if (!resource) {
      var state = { loading: 0, preload: null };
      if (
        (resource = ownerDocument.querySelector(
          getStylesheetSelectorFromKey(key)
        ))
      )
        state.loading = 5;
      else {
        href = assign(
          { rel: "stylesheet", href: href, "data-precedence": precedence },
          options
        );
        (options = preloadPropsMap.get(key)) &&
          adoptPreloadPropsForStylesheet(href, options);
        var link = (resource = ownerDocument.createElement("link"));
        markNodeAsHoistable(link);
        setInitialProperties(link, "link", href);
        link._p = new Promise(function (resolve, reject) {
          link.onload = resolve;
          link.onerror = reject;
        });
        link.addEventListener("load", function () {
          state.loading |= 1;
        });
        link.addEventListener("error", function () {
          state.loading |= 2;
        });
        state.loading |= 4;
        insertStylesheet(resource, precedence, ownerDocument);
      }
      resource = {
        type: "stylesheet",
        instance: resource,
        count: 1,
        state: state
      };
      styles.set(key, resource);
    }
  }
}
function preinitScript(src, options) {
  previousDispatcher.X(src, options);
  var ownerDocument = globalDocument;
  if (ownerDocument && src) {
    var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts,
      key = getScriptKey(src),
      resource = scripts.get(key);
    resource ||
      ((resource = ownerDocument.querySelector(getScriptSelectorFromKey(key))),
      resource ||
        ((src = assign({ src: src, async: true }, options)),
        (options = preloadPropsMap.get(key)) &&
          adoptPreloadPropsForScript(src, options),
        (resource = ownerDocument.createElement("script")),
        markNodeAsHoistable(resource),
        setInitialProperties(resource, "link", src),
        ownerDocument.head.appendChild(resource)),
      (resource = {
        type: "script",
        instance: resource,
        count: 1,
        state: null
      }),
      scripts.set(key, resource));
  }
}
function preinitModuleScript(src, options) {
  previousDispatcher.M(src, options);
  var ownerDocument = globalDocument;
  if (ownerDocument && src) {
    var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts,
      key = getScriptKey(src),
      resource = scripts.get(key);
    resource ||
      ((resource = ownerDocument.querySelector(getScriptSelectorFromKey(key))),
      resource ||
        ((src = assign({ src: src, async: true, type: "module" }, options)),
        (options = preloadPropsMap.get(key)) &&
          adoptPreloadPropsForScript(src, options),
        (resource = ownerDocument.createElement("script")),
        markNodeAsHoistable(resource),
        setInitialProperties(resource, "link", src),
        ownerDocument.head.appendChild(resource)),
      (resource = {
        type: "script",
        instance: resource,
        count: 1,
        state: null
      }),
      scripts.set(key, resource));
  }
}
function getResource(type, currentProps, pendingProps, currentResource) {
  var JSCompiler_inline_result = (JSCompiler_inline_result =
    rootInstanceStackCursor.current)
    ? getHoistableRoot(JSCompiler_inline_result)
    : null;
  if (!JSCompiler_inline_result) throw Error(formatProdErrorMessage(446));
  switch (type) {
    case "meta":
    case "title":
      return null;
    case "style":
      return "string" === typeof pendingProps.precedence &&
        "string" === typeof pendingProps.href
        ? ((currentProps = getStyleKey(pendingProps.href)),
          (pendingProps = getResourcesFromRoot(
            JSCompiler_inline_result
          ).hoistableStyles),
          (currentResource = pendingProps.get(currentProps)),
          currentResource ||
            ((currentResource = {
              type: "style",
              instance: null,
              count: 0,
              state: null
            }),
            pendingProps.set(currentProps, currentResource)),
          currentResource)
        : { type: "void", instance: null, count: 0, state: null };
    case "link":
      if (
        "stylesheet" === pendingProps.rel &&
        "string" === typeof pendingProps.href &&
        "string" === typeof pendingProps.precedence
      ) {
        type = getStyleKey(pendingProps.href);
        var styles$244 = getResourcesFromRoot(
            JSCompiler_inline_result
          ).hoistableStyles,
          resource$245 = styles$244.get(type);
        resource$245 ||
          ((JSCompiler_inline_result =
            JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result),
          (resource$245 = {
            type: "stylesheet",
            instance: null,
            count: 0,
            state: { loading: 0, preload: null }
          }),
          styles$244.set(type, resource$245),
          (styles$244 = JSCompiler_inline_result.querySelector(
            getStylesheetSelectorFromKey(type)
          )) &&
            !styles$244._p &&
            ((resource$245.instance = styles$244),
            (resource$245.state.loading = 5)),
          preloadPropsMap.has(type) ||
            ((pendingProps = {
              rel: "preload",
              as: "style",
              href: pendingProps.href,
              crossOrigin: pendingProps.crossOrigin,
              integrity: pendingProps.integrity,
              media: pendingProps.media,
              hrefLang: pendingProps.hrefLang,
              referrerPolicy: pendingProps.referrerPolicy
            }),
            preloadPropsMap.set(type, pendingProps),
            styles$244 ||
              preloadStylesheet(
                JSCompiler_inline_result,
                type,
                pendingProps,
                resource$245.state
              )));
        if (currentProps && null === currentResource)
          throw Error(formatProdErrorMessage(528, ""));
        return resource$245;
      }
      if (currentProps && null !== currentResource)
        throw Error(formatProdErrorMessage(529, ""));
      return null;
    case "script":
      return (
        (currentProps = pendingProps.async),
        (pendingProps = pendingProps.src),
        "string" === typeof pendingProps &&
        currentProps &&
        "function" !== typeof currentProps &&
        "symbol" !== typeof currentProps
          ? ((currentProps = getScriptKey(pendingProps)),
            (pendingProps = getResourcesFromRoot(
              JSCompiler_inline_result
            ).hoistableScripts),
            (currentResource = pendingProps.get(currentProps)),
            currentResource ||
              ((currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
              }),
              pendingProps.set(currentProps, currentResource)),
            currentResource)
          : { type: "void", instance: null, count: 0, state: null }
      );
    default:
      throw Error(formatProdErrorMessage(444, type));
  }
}
function getStyleKey(href) {
  return 'href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function getStylesheetSelectorFromKey(key) {
  return 'link[rel="stylesheet"][' + key + "]";
}
function stylesheetPropsFromRawProps(rawProps) {
  return assign({}, rawProps, {
    "data-precedence": rawProps.precedence,
    precedence: null
  });
}
function preloadStylesheet(ownerDocument, key, preloadProps, state) {
  ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]")
    ? (state.loading = 1)
    : ((key = ownerDocument.createElement("link")),
      (state.preload = key),
      key.addEventListener("load", function () {
        return (state.loading |= 1);
      }),
      key.addEventListener("error", function () {
        return (state.loading |= 2);
      }),
      setInitialProperties(key, "link", preloadProps),
      markNodeAsHoistable(key),
      ownerDocument.head.appendChild(key));
}
function getScriptKey(src) {
  return '[src="' + escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function getScriptSelectorFromKey(key) {
  return "script[async]" + key;
}
function acquireResource(hoistableRoot, resource, props) {
  resource.count++;
  if (null === resource.instance)
    switch (resource.type) {
      case "style":
        var instance = hoistableRoot.querySelector(
          'style[data-href~="' +
            escapeSelectorAttributeValueInsideDoubleQuotes(props.href) +
            '"]'
        );
        if (instance)
          return (
            (resource.instance = instance),
            markNodeAsHoistable(instance),
            instance
          );
        var styleProps = assign({}, props, {
          "data-href": props.href,
          "data-precedence": props.precedence,
          href: null,
          precedence: null
        });
        instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement(
          "style"
        );
        markNodeAsHoistable(instance);
        setInitialProperties(instance, "style", styleProps);
        insertStylesheet(instance, props.precedence, hoistableRoot);
        return (resource.instance = instance);
      case "stylesheet":
        styleProps = getStyleKey(props.href);
        var instance$250 = hoistableRoot.querySelector(
          getStylesheetSelectorFromKey(styleProps)
        );
        if (instance$250)
          return (
            (resource.state.loading |= 4),
            (resource.instance = instance$250),
            markNodeAsHoistable(instance$250),
            instance$250
          );
        instance = stylesheetPropsFromRawProps(props);
        (styleProps = preloadPropsMap.get(styleProps)) &&
          adoptPreloadPropsForStylesheet(instance, styleProps);
        instance$250 = (
          hoistableRoot.ownerDocument || hoistableRoot
        ).createElement("link");
        markNodeAsHoistable(instance$250);
        var linkInstance = instance$250;
        linkInstance._p = new Promise(function (resolve, reject) {
          linkInstance.onload = resolve;
          linkInstance.onerror = reject;
        });
        setInitialProperties(instance$250, "link", instance);
        resource.state.loading |= 4;
        insertStylesheet(instance$250, props.precedence, hoistableRoot);
        return (resource.instance = instance$250);
      case "script":
        instance$250 = getScriptKey(props.src);
        if (
          (styleProps = hoistableRoot.querySelector(
            getScriptSelectorFromKey(instance$250)
          ))
        )
          return (
            (resource.instance = styleProps),
            markNodeAsHoistable(styleProps),
            styleProps
          );
        instance = props;
        if ((styleProps = preloadPropsMap.get(instance$250)))
          (instance = assign({}, props)),
            adoptPreloadPropsForScript(instance, styleProps);
        hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
        styleProps = hoistableRoot.createElement("script");
        markNodeAsHoistable(styleProps);
        setInitialProperties(styleProps, "link", instance);
        hoistableRoot.head.appendChild(styleProps);
        return (resource.instance = styleProps);
      case "void":
        return null;
      default:
        throw Error(formatProdErrorMessage(443, resource.type));
    }
  else
    "stylesheet" === resource.type &&
      0 === (resource.state.loading & 4) &&
      ((instance = resource.instance),
      (resource.state.loading |= 4),
      insertStylesheet(instance, props.precedence, hoistableRoot));
  return resource.instance;
}
function insertStylesheet(instance, precedence, root) {
  for (
    var nodes = root.querySelectorAll(
        'link[rel="stylesheet"][data-precedence],style[data-precedence]'
      ),
      last = nodes.length ? nodes[nodes.length - 1] : null,
      prior = last,
      i = 0;
    i < nodes.length;
    i++
  ) {
    var node = nodes[i];
    if (node.dataset.precedence === precedence) prior = node;
    else if (prior !== last) break;
  }
  prior
    ? prior.parentNode.insertBefore(instance, prior.nextSibling)
    : ((precedence = 9 === root.nodeType ? root.head : root),
      precedence.insertBefore(instance, precedence.firstChild));
}
function adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
  null == stylesheetProps.crossOrigin &&
    (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
  null == stylesheetProps.referrerPolicy &&
    (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
  null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function adoptPreloadPropsForScript(scriptProps, preloadProps) {
  null == scriptProps.crossOrigin &&
    (scriptProps.crossOrigin = preloadProps.crossOrigin);
  null == scriptProps.referrerPolicy &&
    (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
  null == scriptProps.integrity &&
    (scriptProps.integrity = preloadProps.integrity);
}
var tagCaches = null;
function getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
  if (null === tagCaches) {
    var cache = new Map();
    var caches = (tagCaches = new Map());
    caches.set(ownerDocument, cache);
  } else
    (caches = tagCaches),
      (cache = caches.get(ownerDocument)),
      cache || ((cache = new Map()), caches.set(ownerDocument, cache));
  if (cache.has(type)) return cache;
  cache.set(type, null);
  ownerDocument = ownerDocument.getElementsByTagName(type);
  for (caches = 0; caches < ownerDocument.length; caches++) {
    var node = ownerDocument[caches];
    if (
      !(
        node[internalHoistableMarker] ||
        node[internalInstanceKey] ||
        ("link" === type && "stylesheet" === node.getAttribute("rel"))
      ) &&
      "http://www.w3.org/2000/svg" !== node.namespaceURI
    ) {
      var nodeKey = node.getAttribute(keyAttribute) || "";
      nodeKey = type + nodeKey;
      var existing = cache.get(nodeKey);
      existing ? existing.push(node) : cache.set(nodeKey, [node]);
    }
  }
  return cache;
}
function mountHoistable(hoistableRoot, type, instance) {
  hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
  hoistableRoot.head.insertBefore(
    instance,
    "title" === type ? hoistableRoot.querySelector("head > title") : null
  );
}
function isHostHoistableType(type, props, hostContext) {
  if (1 === hostContext || null != props.itemProp) return false;
  switch (type) {
    case "meta":
    case "title":
      return true;
    case "style":
      if (
        "string" !== typeof props.precedence ||
        "string" !== typeof props.href ||
        "" === props.href
      )
        break;
      return true;
    case "link":
      if (
        "string" !== typeof props.rel ||
        "string" !== typeof props.href ||
        "" === props.href ||
        props.onLoad ||
        props.onError
      )
        break;
      switch (props.rel) {
        case "stylesheet":
          return (
            (type = props.disabled),
            "string" === typeof props.precedence && null == type
          );
        default:
          return true;
      }
    case "script":
      if (
        props.async &&
        "function" !== typeof props.async &&
        "symbol" !== typeof props.async &&
        !props.onLoad &&
        !props.onError &&
        props.src &&
        "string" === typeof props.src
      )
        return true;
  }
  return false;
}
function preloadResource(resource) {
  return "stylesheet" === resource.type && 0 === (resource.state.loading & 3)
    ? false
    : true;
}
var suspendedState = null;
function noop() {}
function suspendResource(hoistableRoot, resource, props) {
  if (null === suspendedState) throw Error(formatProdErrorMessage(475));
  var state = suspendedState;
  if (
    "stylesheet" === resource.type &&
    ("string" !== typeof props.media ||
      false !== matchMedia(props.media).matches) &&
    0 === (resource.state.loading & 4)
  ) {
    if (null === resource.instance) {
      var key = getStyleKey(props.href),
        instance = hoistableRoot.querySelector(
          getStylesheetSelectorFromKey(key)
        );
      if (instance) {
        hoistableRoot = instance._p;
        null !== hoistableRoot &&
          "object" === typeof hoistableRoot &&
          "function" === typeof hoistableRoot.then &&
          (state.count++,
          (state = onUnsuspend.bind(state)),
          hoistableRoot.then(state, state));
        resource.state.loading |= 4;
        resource.instance = instance;
        markNodeAsHoistable(instance);
        return;
      }
      instance = hoistableRoot.ownerDocument || hoistableRoot;
      props = stylesheetPropsFromRawProps(props);
      (key = preloadPropsMap.get(key)) &&
        adoptPreloadPropsForStylesheet(props, key);
      instance = instance.createElement("link");
      markNodeAsHoistable(instance);
      var linkInstance = instance;
      linkInstance._p = new Promise(function (resolve, reject) {
        linkInstance.onload = resolve;
        linkInstance.onerror = reject;
      });
      setInitialProperties(instance, "link", props);
      resource.instance = instance;
    }
    null === state.stylesheets && (state.stylesheets = new Map());
    state.stylesheets.set(resource, hoistableRoot);
    (hoistableRoot = resource.state.preload) &&
      0 === (resource.state.loading & 3) &&
      (state.count++,
      (resource = onUnsuspend.bind(state)),
      hoistableRoot.addEventListener("load", resource),
      hoistableRoot.addEventListener("error", resource));
  }
}
function waitForCommitToBeReady() {
  if (null === suspendedState) throw Error(formatProdErrorMessage(475));
  var state = suspendedState;
  state.stylesheets &&
    0 === state.count &&
    insertSuspendedStylesheets(state, state.stylesheets);
  return 0 < state.count
    ? function (commit) {
        var stylesheetTimer = setTimeout(function () {
          state.stylesheets &&
            insertSuspendedStylesheets(state, state.stylesheets);
          if (state.unsuspend) {
            var unsuspend = state.unsuspend;
            state.unsuspend = null;
            unsuspend();
          }
        }, 6e4);
        state.unsuspend = commit;
        return function () {
          state.unsuspend = null;
          clearTimeout(stylesheetTimer);
        };
      }
    : null;
}
function onUnsuspend() {
  this.count--;
  if (0 === this.count)
    if (this.stylesheets) insertSuspendedStylesheets(this, this.stylesheets);
    else if (this.unsuspend) {
      var unsuspend = this.unsuspend;
      this.unsuspend = null;
      unsuspend();
    }
}
var precedencesByRoot = null;
function insertSuspendedStylesheets(state, resources) {
  state.stylesheets = null;
  null !== state.unsuspend &&
    (state.count++,
    (precedencesByRoot = new Map()),
    resources.forEach(insertStylesheetIntoRoot, state),
    (precedencesByRoot = null),
    onUnsuspend.call(state));
}
function insertStylesheetIntoRoot(root, resource) {
  if (!(resource.state.loading & 4)) {
    var precedences = precedencesByRoot.get(root);
    if (precedences) var last = precedences.get(null);
    else {
      precedences = new Map();
      precedencesByRoot.set(root, precedences);
      for (
        var nodes = root.querySelectorAll(
            "link[data-precedence],style[data-precedence]"
          ),
          i = 0;
        i < nodes.length;
        i++
      ) {
        var node = nodes[i];
        if (
          "LINK" === node.nodeName ||
          "not all" !== node.getAttribute("media")
        )
          precedences.set(node.dataset.precedence, node), (last = node);
      }
      last && precedences.set(null, last);
    }
    nodes = resource.instance;
    node = nodes.getAttribute("data-precedence");
    i = precedences.get(node) || last;
    i === last && precedences.set(null, nodes);
    precedences.set(node, nodes);
    this.count++;
    last = onUnsuspend.bind(this);
    nodes.addEventListener("load", last);
    nodes.addEventListener("error", last);
    i
      ? i.parentNode.insertBefore(nodes, i.nextSibling)
      : ((root = 9 === root.nodeType ? root.head : root),
        root.insertBefore(nodes, root.firstChild));
    resource.state.loading |= 4;
  }
}
var HostTransitionContext = {
  $$typeof: REACT_CONTEXT_TYPE,
  Provider: null,
  Consumer: null,
  _currentValue: sharedNotPendingObject,
  _currentValue2: sharedNotPendingObject,
  _threadCount: 0
};
function FiberRootNode(
  containerInfo,
  tag,
  hydrate,
  identifierPrefix,
  onUncaughtError,
  onCaughtError,
  onRecoverableError,
  formState
) {
  this.tag = 1;
  this.containerInfo = containerInfo;
  this.pingCache = this.current = this.pendingChildren = null;
  this.timeoutHandle = -1;
  this.callbackNode =
    this.next =
    this.pendingContext =
    this.context =
    this.cancelPendingCommit =
      null;
  this.callbackPriority = 0;
  this.expirationTimes = createLaneMap(-1);
  this.entangledLanes =
    this.shellSuspendCounter =
    this.errorRecoveryDisabledLanes =
    this.expiredLanes =
    this.warmLanes =
    this.pingedLanes =
    this.suspendedLanes =
    this.pendingLanes =
      0;
  this.entanglements = createLaneMap(0);
  this.hiddenUpdates = createLaneMap(null);
  this.identifierPrefix = identifierPrefix;
  this.onUncaughtError = onUncaughtError;
  this.onCaughtError = onCaughtError;
  this.onRecoverableError = onRecoverableError;
  this.pooledCache = null;
  this.pooledCacheLanes = 0;
  this.formState = formState;
  this.incompleteTransitions = new Map();
}
function createFiberRoot(
  containerInfo,
  tag,
  hydrate,
  initialChildren,
  hydrationCallbacks,
  isStrictMode,
  identifierPrefix,
  onUncaughtError,
  onCaughtError,
  onRecoverableError,
  transitionCallbacks,
  formState
) {
  containerInfo = new FiberRootNode(
    containerInfo,
    tag,
    hydrate,
    identifierPrefix,
    onUncaughtError,
    onCaughtError,
    onRecoverableError,
    formState
  );
  tag = 1;
  true === isStrictMode && (tag |= 24);
  isStrictMode = createFiberImplClass(3, null, null, tag);
  containerInfo.current = isStrictMode;
  isStrictMode.stateNode = containerInfo;
  tag = createCache();
  tag.refCount++;
  containerInfo.pooledCache = tag;
  tag.refCount++;
  isStrictMode.memoizedState = {
    element: initialChildren,
    isDehydrated: hydrate,
    cache: tag
  };
  initializeUpdateQueue(isStrictMode);
  return containerInfo;
}
function getContextForSubtree(parentComponent) {
  if (!parentComponent) return emptyContextObject;
  parentComponent = emptyContextObject;
  return parentComponent;
}
function updateContainerImpl(
  rootFiber,
  lane,
  element,
  container,
  parentComponent,
  callback
) {
  parentComponent = getContextForSubtree(parentComponent);
  null === container.context
    ? (container.context = parentComponent)
    : (container.pendingContext = parentComponent);
  container = createUpdate(lane);
  container.payload = { element: element };
  callback = void 0 === callback ? null : callback;
  null !== callback && (container.callback = callback);
  element = enqueueUpdate(rootFiber, container, lane);
  null !== element &&
    (scheduleUpdateOnFiber(element, rootFiber, lane),
    entangleTransitions(element, rootFiber, lane));
}
function markRetryLaneImpl(fiber, retryLane) {
  fiber = fiber.memoizedState;
  if (null !== fiber && null !== fiber.dehydrated) {
    var a = fiber.retryLane;
    fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
  }
}
function markRetryLaneIfNotHydrated(fiber, retryLane) {
  markRetryLaneImpl(fiber, retryLane);
  (fiber = fiber.alternate) && markRetryLaneImpl(fiber, retryLane);
}
function attemptContinuousHydration(fiber) {
  if (13 === fiber.tag) {
    var root = enqueueConcurrentRenderForLane(fiber, 67108864);
    null !== root && scheduleUpdateOnFiber(root, fiber, 67108864);
    markRetryLaneIfNotHydrated(fiber, 67108864);
  }
}
var _enabled = true;
function dispatchDiscreteEvent(
  domEventName,
  eventSystemFlags,
  container,
  nativeEvent
) {
  var prevTransition = ReactSharedInternals.T;
  ReactSharedInternals.T = null;
  var previousPriority = ReactDOMSharedInternals.p;
  try {
    (ReactDOMSharedInternals.p = 2),
      dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
  } finally {
    (ReactDOMSharedInternals.p = previousPriority),
      (ReactSharedInternals.T = prevTransition);
  }
}
function dispatchContinuousEvent(
  domEventName,
  eventSystemFlags,
  container,
  nativeEvent
) {
  var prevTransition = ReactSharedInternals.T;
  ReactSharedInternals.T = null;
  var previousPriority = ReactDOMSharedInternals.p;
  try {
    (ReactDOMSharedInternals.p = 8),
      dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
  } finally {
    (ReactDOMSharedInternals.p = previousPriority),
      (ReactSharedInternals.T = prevTransition);
  }
}
function dispatchEvent(
  domEventName,
  eventSystemFlags,
  targetContainer,
  nativeEvent
) {
  if (_enabled) {
    var blockedOn = findInstanceBlockingEvent(nativeEvent);
    if (null === blockedOn)
      dispatchEventForPluginEventSystem(
        domEventName,
        eventSystemFlags,
        nativeEvent,
        return_targetInst,
        targetContainer
      ),
        clearIfContinuousEvent(domEventName, nativeEvent);
    else if (
      queueIfContinuousEvent(
        blockedOn,
        domEventName,
        eventSystemFlags,
        targetContainer,
        nativeEvent
      )
    )
      nativeEvent.stopPropagation();
    else if (
      (clearIfContinuousEvent(domEventName, nativeEvent),
      eventSystemFlags & 4 &&
        -1 < discreteReplayableEvents.indexOf(domEventName))
    ) {
      for (; null !== blockedOn; ) {
        var fiber = getInstanceFromNode(blockedOn);
        if (null !== fiber)
          switch (fiber.tag) {
            case 3:
              fiber = fiber.stateNode;
              if (fiber.current.memoizedState.isDehydrated) {
                var lanes = getHighestPriorityLanes(fiber.pendingLanes);
                if (0 !== lanes) {
                  var root = fiber;
                  root.pendingLanes |= 2;
                  for (root.entangledLanes |= 2; lanes; ) {
                    var lane = 1 << (31 - clz32(lanes));
                    root.entanglements[1] |= lane;
                    lanes &= ~lane;
                  }
                  ensureRootIsScheduled(fiber);
                  0 === (executionContext & 6) &&
                    ((workInProgressRootRenderTargetTime = now$1() + 500),
                    flushSyncWorkAcrossRoots_impl(0));
                }
              }
              break;
            case 13:
              (root = enqueueConcurrentRenderForLane(fiber, 2)),
                null !== root && scheduleUpdateOnFiber(root, fiber, 2),
                flushSyncWork$1(),
                markRetryLaneIfNotHydrated(fiber, 2);
          }
        fiber = findInstanceBlockingEvent(nativeEvent);
        null === fiber &&
          dispatchEventForPluginEventSystem(
            domEventName,
            eventSystemFlags,
            nativeEvent,
            return_targetInst,
            targetContainer
          );
        if (fiber === blockedOn) break;
        blockedOn = fiber;
      }
      null !== blockedOn && nativeEvent.stopPropagation();
    } else
      dispatchEventForPluginEventSystem(
        domEventName,
        eventSystemFlags,
        nativeEvent,
        null,
        targetContainer
      );
  }
}
function findInstanceBlockingEvent(nativeEvent) {
  nativeEvent = getEventTarget(nativeEvent);
  return findInstanceBlockingTarget(nativeEvent);
}
var return_targetInst = null;
function findInstanceBlockingTarget(targetNode) {
  return_targetInst = null;
  targetNode = getClosestInstanceFromNode(targetNode);
  if (null !== targetNode) {
    var nearestMounted = getNearestMountedFiber(targetNode);
    if (null === nearestMounted) targetNode = null;
    else {
      var tag = nearestMounted.tag;
      if (13 === tag) {
        targetNode = getSuspenseInstanceFromFiber(nearestMounted);
        if (null !== targetNode) return targetNode;
        targetNode = null;
      } else if (3 === tag) {
        if (nearestMounted.stateNode.current.memoizedState.isDehydrated)
          return 3 === nearestMounted.tag
            ? nearestMounted.stateNode.containerInfo
            : null;
        targetNode = null;
      } else nearestMounted !== targetNode && (targetNode = null);
    }
  }
  return_targetInst = targetNode;
  return null;
}
function getEventPriority(domEventName) {
  switch (domEventName) {
    case "beforetoggle":
    case "cancel":
    case "click":
    case "close":
    case "contextmenu":
    case "copy":
    case "cut":
    case "auxclick":
    case "dblclick":
    case "dragend":
    case "dragstart":
    case "drop":
    case "focusin":
    case "focusout":
    case "input":
    case "invalid":
    case "keydown":
    case "keypress":
    case "keyup":
    case "mousedown":
    case "mouseup":
    case "paste":
    case "pause":
    case "play":
    case "pointercancel":
    case "pointerdown":
    case "pointerup":
    case "ratechange":
    case "reset":
    case "resize":
    case "seeked":
    case "submit":
    case "toggle":
    case "touchcancel":
    case "touchend":
    case "touchstart":
    case "volumechange":
    case "change":
    case "selectionchange":
    case "textInput":
    case "compositionstart":
    case "compositionend":
    case "compositionupdate":
    case "beforeblur":
    case "afterblur":
    case "beforeinput":
    case "blur":
    case "fullscreenchange":
    case "focus":
    case "hashchange":
    case "popstate":
    case "select":
    case "selectstart":
      return 2;
    case "drag":
    case "dragenter":
    case "dragexit":
    case "dragleave":
    case "dragover":
    case "mousemove":
    case "mouseout":
    case "mouseover":
    case "pointermove":
    case "pointerout":
    case "pointerover":
    case "scroll":
    case "touchmove":
    case "wheel":
    case "mouseenter":
    case "mouseleave":
    case "pointerenter":
    case "pointerleave":
      return 8;
    case "message":
      switch (getCurrentPriorityLevel()) {
        case ImmediatePriority:
          return 2;
        case UserBlockingPriority:
          return 8;
        case NormalPriority$1:
        case LowPriority:
          return 32;
        case IdlePriority:
          return 268435456;
        default:
          return 32;
      }
    default:
      return 32;
  }
}
var hasScheduledReplayAttempt = false,
  queuedFocus = null,
  queuedDrag = null,
  queuedMouse = null,
  queuedPointers = new Map(),
  queuedPointerCaptures = new Map(),
  queuedExplicitHydrationTargets = [],
  discreteReplayableEvents =
    "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
      " "
    );
function clearIfContinuousEvent(domEventName, nativeEvent) {
  switch (domEventName) {
    case "focusin":
    case "focusout":
      queuedFocus = null;
      break;
    case "dragenter":
    case "dragleave":
      queuedDrag = null;
      break;
    case "mouseover":
    case "mouseout":
      queuedMouse = null;
      break;
    case "pointerover":
    case "pointerout":
      queuedPointers.delete(nativeEvent.pointerId);
      break;
    case "gotpointercapture":
    case "lostpointercapture":
      queuedPointerCaptures.delete(nativeEvent.pointerId);
  }
}
function accumulateOrCreateContinuousQueuedReplayableEvent(
  existingQueuedEvent,
  blockedOn,
  domEventName,
  eventSystemFlags,
  targetContainer,
  nativeEvent
) {
  if (
    null === existingQueuedEvent ||
    existingQueuedEvent.nativeEvent !== nativeEvent
  )
    return (
      (existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [targetContainer]
      }),
      null !== blockedOn &&
        ((blockedOn = getInstanceFromNode(blockedOn)),
        null !== blockedOn && attemptContinuousHydration(blockedOn)),
      existingQueuedEvent
    );
  existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
  blockedOn = existingQueuedEvent.targetContainers;
  null !== targetContainer &&
    -1 === blockedOn.indexOf(targetContainer) &&
    blockedOn.push(targetContainer);
  return existingQueuedEvent;
}
function queueIfContinuousEvent(
  blockedOn,
  domEventName,
  eventSystemFlags,
  targetContainer,
  nativeEvent
) {
  switch (domEventName) {
    case "focusin":
      return (
        (queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(
          queuedFocus,
          blockedOn,
          domEventName,
          eventSystemFlags,
          targetContainer,
          nativeEvent
        )),
        true
      );
    case "dragenter":
      return (
        (queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(
          queuedDrag,
          blockedOn,
          domEventName,
          eventSystemFlags,
          targetContainer,
          nativeEvent
        )),
        true
      );
    case "mouseover":
      return (
        (queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(
          queuedMouse,
          blockedOn,
          domEventName,
          eventSystemFlags,
          targetContainer,
          nativeEvent
        )),
        true
      );
    case "pointerover":
      var pointerId = nativeEvent.pointerId;
      queuedPointers.set(
        pointerId,
        accumulateOrCreateContinuousQueuedReplayableEvent(
          queuedPointers.get(pointerId) || null,
          blockedOn,
          domEventName,
          eventSystemFlags,
          targetContainer,
          nativeEvent
        )
      );
      return true;
    case "gotpointercapture":
      return (
        (pointerId = nativeEvent.pointerId),
        queuedPointerCaptures.set(
          pointerId,
          accumulateOrCreateContinuousQueuedReplayableEvent(
            queuedPointerCaptures.get(pointerId) || null,
            blockedOn,
            domEventName,
            eventSystemFlags,
            targetContainer,
            nativeEvent
          )
        ),
        true
      );
  }
  return false;
}
function attemptExplicitHydrationTarget(queuedTarget) {
  var targetInst = getClosestInstanceFromNode(queuedTarget.target);
  if (null !== targetInst) {
    var nearestMounted = getNearestMountedFiber(targetInst);
    if (null !== nearestMounted)
      if (((targetInst = nearestMounted.tag), 13 === targetInst)) {
        if (
          ((targetInst = getSuspenseInstanceFromFiber(nearestMounted)),
          null !== targetInst)
        ) {
          queuedTarget.blockedOn = targetInst;
          runWithPriority(queuedTarget.priority, function () {
            if (13 === nearestMounted.tag) {
              var lane = requestUpdateLane();
              lane = getBumpedLaneForHydrationByLane(lane);
              var root = enqueueConcurrentRenderForLane(nearestMounted, lane);
              null !== root &&
                scheduleUpdateOnFiber(root, nearestMounted, lane);
              markRetryLaneIfNotHydrated(nearestMounted, lane);
            }
          });
          return;
        }
      } else if (
        3 === targetInst &&
        nearestMounted.stateNode.current.memoizedState.isDehydrated
      ) {
        queuedTarget.blockedOn =
          3 === nearestMounted.tag
            ? nearestMounted.stateNode.containerInfo
            : null;
        return;
      }
  }
  queuedTarget.blockedOn = null;
}
function attemptReplayContinuousQueuedEvent(queuedEvent) {
  if (null !== queuedEvent.blockedOn) return false;
  for (
    var targetContainers = queuedEvent.targetContainers;
    0 < targetContainers.length;

  ) {
    var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.nativeEvent);
    if (null === nextBlockedOn) {
      nextBlockedOn = queuedEvent.nativeEvent;
      var nativeEventClone = new nextBlockedOn.constructor(
        nextBlockedOn.type,
        nextBlockedOn
      );
      currentReplayingEvent = nativeEventClone;
      nextBlockedOn.target.dispatchEvent(nativeEventClone);
      currentReplayingEvent = null;
    } else
      return (
        (targetContainers = getInstanceFromNode(nextBlockedOn)),
        null !== targetContainers &&
          attemptContinuousHydration(targetContainers),
        (queuedEvent.blockedOn = nextBlockedOn),
        false
      );
    targetContainers.shift();
  }
  return true;
}
function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
  attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function replayUnblockedEvents() {
  hasScheduledReplayAttempt = false;
  null !== queuedFocus &&
    attemptReplayContinuousQueuedEvent(queuedFocus) &&
    (queuedFocus = null);
  null !== queuedDrag &&
    attemptReplayContinuousQueuedEvent(queuedDrag) &&
    (queuedDrag = null);
  null !== queuedMouse &&
    attemptReplayContinuousQueuedEvent(queuedMouse) &&
    (queuedMouse = null);
  queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
  queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
}
function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
  queuedEvent.blockedOn === unblocked &&
    ((queuedEvent.blockedOn = null),
    hasScheduledReplayAttempt ||
      ((hasScheduledReplayAttempt = true),
      Scheduler.unstable_scheduleCallback(
        Scheduler.unstable_NormalPriority,
        replayUnblockedEvents
      )));
}
var lastScheduledReplayQueue = null;
function scheduleReplayQueueIfNeeded(formReplayingQueue) {
  lastScheduledReplayQueue !== formReplayingQueue &&
    ((lastScheduledReplayQueue = formReplayingQueue),
    Scheduler.unstable_scheduleCallback(
      Scheduler.unstable_NormalPriority,
      function () {
        lastScheduledReplayQueue === formReplayingQueue &&
          (lastScheduledReplayQueue = null);
        for (var i = 0; i < formReplayingQueue.length; i += 3) {
          var form = formReplayingQueue[i],
            submitterOrAction = formReplayingQueue[i + 1],
            formData = formReplayingQueue[i + 2];
          if ("function" !== typeof submitterOrAction)
            if (null === findInstanceBlockingTarget(submitterOrAction || form))
              continue;
            else break;
          var formInst = getInstanceFromNode(form);
          null !== formInst &&
            (formReplayingQueue.splice(i, 3),
            (i -= 3),
            startHostTransition(
              formInst,
              {
                pending: true,
                data: formData,
                method: form.method,
                action: submitterOrAction
              },
              submitterOrAction,
              formData
            ));
        }
      }
    ));
}
function retryIfBlockedOn(unblocked) {
  function unblock(queuedEvent) {
    return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
  }
  null !== queuedFocus && scheduleCallbackIfUnblocked(queuedFocus, unblocked);
  null !== queuedDrag && scheduleCallbackIfUnblocked(queuedDrag, unblocked);
  null !== queuedMouse && scheduleCallbackIfUnblocked(queuedMouse, unblocked);
  queuedPointers.forEach(unblock);
  queuedPointerCaptures.forEach(unblock);
  for (var i = 0; i < queuedExplicitHydrationTargets.length; i++) {
    var queuedTarget = queuedExplicitHydrationTargets[i];
    queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
  }
  for (
    ;
    0 < queuedExplicitHydrationTargets.length &&
    ((i = queuedExplicitHydrationTargets[0]), null === i.blockedOn);

  )
    attemptExplicitHydrationTarget(i),
      null === i.blockedOn && queuedExplicitHydrationTargets.shift();
  i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
  if (null != i)
    for (queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3) {
      var form = i[queuedTarget],
        submitterOrAction = i[queuedTarget + 1],
        formProps = form[internalPropsKey] || null;
      if ("function" === typeof submitterOrAction)
        formProps || scheduleReplayQueueIfNeeded(i);
      else if (formProps) {
        var action = null;
        if (submitterOrAction && submitterOrAction.hasAttribute("formAction"))
          if (
            ((form = submitterOrAction),
            (formProps = submitterOrAction[internalPropsKey] || null))
          )
            action = formProps.formAction;
          else {
            if (null !== findInstanceBlockingTarget(form)) continue;
          }
        else action = formProps.action;
        "function" === typeof action
          ? (i[queuedTarget + 1] = action)
          : (i.splice(queuedTarget, 3), (queuedTarget -= 3));
        scheduleReplayQueueIfNeeded(i);
      }
    }
}
function ReactDOMRoot(internalRoot) {
  this._internalRoot = internalRoot;
}
ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render =
  function (children) {
    var root = this._internalRoot;
    if (null === root) throw Error(formatProdErrorMessage(409));
    var current = root.current,
      lane = requestUpdateLane();
    updateContainerImpl(current, lane, children, root, null, null);
  };
ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount =
  function () {
    var root = this._internalRoot;
    if (null !== root) {
      this._internalRoot = null;
      var container = root.containerInfo;
      updateContainerImpl(root.current, 2, null, root, null, null);
      flushSyncWork$1();
      container[internalContainerInstanceKey] = null;
    }
  };
function ReactDOMHydrationRoot(internalRoot) {
  this._internalRoot = internalRoot;
}
ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function (target) {
  if (target) {
    var updatePriority = resolveUpdatePriority();
    target = { blockedOn: null, target: target, priority: updatePriority };
    for (
      var i = 0;
      i < queuedExplicitHydrationTargets.length &&
      0 !== updatePriority &&
      updatePriority < queuedExplicitHydrationTargets[i].priority;
      i++
    );
    queuedExplicitHydrationTargets.splice(i, 0, target);
    0 === i && attemptExplicitHydrationTarget(target);
  }
};
var isomorphicReactPackageVersion$jscomp$inline_1785 = React.version;
if (
  "19.1.1" !==
  isomorphicReactPackageVersion$jscomp$inline_1785
)
  throw Error(
    formatProdErrorMessage(
      527,
      isomorphicReactPackageVersion$jscomp$inline_1785,
      "19.1.1"
    )
  );
ReactDOMSharedInternals.findDOMNode = function (componentOrElement) {
  var fiber = componentOrElement._reactInternals;
  if (void 0 === fiber) {
    if ("function" === typeof componentOrElement.render)
      throw Error(formatProdErrorMessage(188));
    componentOrElement = Object.keys(componentOrElement).join(",");
    throw Error(formatProdErrorMessage(268, componentOrElement));
  }
  componentOrElement = findCurrentFiberUsingSlowPath(fiber);
  componentOrElement =
    null !== componentOrElement
      ? findCurrentHostFiberImpl(componentOrElement)
      : null;
  componentOrElement =
    null === componentOrElement ? null : componentOrElement.stateNode;
  return componentOrElement;
};
var internals$jscomp$inline_2256 = {
  bundleType: 0,
  version: "19.1.1",
  rendererPackageName: "react-dom",
  currentDispatcherRef: ReactSharedInternals,
  reconcilerVersion: "19.1.1"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
  var hook$jscomp$inline_2257 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
  if (
    !hook$jscomp$inline_2257.isDisabled &&
    hook$jscomp$inline_2257.supportsFiber
  )
    try {
      (rendererID = hook$jscomp$inline_2257.inject(
        internals$jscomp$inline_2256
      )),
        (injectedHook = hook$jscomp$inline_2257);
    } catch (err) {}
}
reactDomClient_production.createRoot = function (container, options) {
  if (!isValidContainer(container)) throw Error(formatProdErrorMessage(299));
  var isStrictMode = false,
    identifierPrefix = "",
    onUncaughtError = defaultOnUncaughtError,
    onCaughtError = defaultOnCaughtError,
    onRecoverableError = defaultOnRecoverableError,
    transitionCallbacks = null;
  null !== options &&
    void 0 !== options &&
    (true === options.unstable_strictMode && (isStrictMode = true),
    void 0 !== options.identifierPrefix &&
      (identifierPrefix = options.identifierPrefix),
    void 0 !== options.onUncaughtError &&
      (onUncaughtError = options.onUncaughtError),
    void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError),
    void 0 !== options.onRecoverableError &&
      (onRecoverableError = options.onRecoverableError),
    void 0 !== options.unstable_transitionCallbacks &&
      (transitionCallbacks = options.unstable_transitionCallbacks));
  options = createFiberRoot(
    container,
    1,
    false,
    null,
    null,
    isStrictMode,
    identifierPrefix,
    onUncaughtError,
    onCaughtError,
    onRecoverableError,
    transitionCallbacks,
    null
  );
  container[internalContainerInstanceKey] = options.current;
  listenToAllSupportedEvents(container);
  return new ReactDOMRoot(options);
};
reactDomClient_production.hydrateRoot = function (container, initialChildren, options) {
  if (!isValidContainer(container)) throw Error(formatProdErrorMessage(299));
  var isStrictMode = false,
    identifierPrefix = "",
    onUncaughtError = defaultOnUncaughtError,
    onCaughtError = defaultOnCaughtError,
    onRecoverableError = defaultOnRecoverableError,
    transitionCallbacks = null,
    formState = null;
  null !== options &&
    void 0 !== options &&
    (true === options.unstable_strictMode && (isStrictMode = true),
    void 0 !== options.identifierPrefix &&
      (identifierPrefix = options.identifierPrefix),
    void 0 !== options.onUncaughtError &&
      (onUncaughtError = options.onUncaughtError),
    void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError),
    void 0 !== options.onRecoverableError &&
      (onRecoverableError = options.onRecoverableError),
    void 0 !== options.unstable_transitionCallbacks &&
      (transitionCallbacks = options.unstable_transitionCallbacks),
    void 0 !== options.formState && (formState = options.formState));
  initialChildren = createFiberRoot(
    container,
    1,
    true,
    initialChildren,
    null != options ? options : null,
    isStrictMode,
    identifierPrefix,
    onUncaughtError,
    onCaughtError,
    onRecoverableError,
    transitionCallbacks,
    formState
  );
  initialChildren.context = getContextForSubtree(null);
  options = initialChildren.current;
  isStrictMode = requestUpdateLane();
  isStrictMode = getBumpedLaneForHydrationByLane(isStrictMode);
  identifierPrefix = createUpdate(isStrictMode);
  identifierPrefix.callback = null;
  enqueueUpdate(options, identifierPrefix, isStrictMode);
  options = isStrictMode;
  initialChildren.current.lanes = options;
  markRootUpdated$1(initialChildren, options);
  ensureRootIsScheduled(initialChildren);
  container[internalContainerInstanceKey] = initialChildren.current;
  listenToAllSupportedEvents(container);
  return new ReactDOMHydrationRoot(initialChildren);
};
reactDomClient_production.version = "19.1.1";

function checkDCE() {
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") {
    return;
  }
  try {
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    console.error(err);
  }
}
{
  checkDCE();
  client.exports = reactDomClient_production;
}

var clientExports = client.exports;

var velocity = {exports: {}};

/*! VelocityJS.org (1.5.2). (C) 2014 Julian Shapiro. MIT @license: en.wikipedia.org/wiki/MIT_License */

(function (module) {
	/*************************
	 Velocity jQuery Shim
	 *************************/

	/*! VelocityJS.org jQuery Shim (1.0.1). (C) 2014 The jQuery Foundation. MIT @license: en.wikipedia.org/wiki/MIT_License. */

	/* This file contains the jQuery functions that Velocity relies on, thereby removing Velocity's dependency on a full copy of jQuery, and allowing it to work in any environment. */
	/* These shimmed functions are only used if jQuery isn't present. If both this shim and jQuery are loaded, Velocity defaults to jQuery proper. */
	/* Browser support: Using this shim instead of jQuery proper removes support for IE8. */

	(function(window) {
		/***************
		 Setup
		 ***************/

		/* If jQuery is already loaded, there's no point in loading this shim. */
		if (window.jQuery) {
			return;
		}

		/* jQuery base. */
		var $ = function(selector, context) {
			return new $.fn.init(selector, context);
		};

		/********************
		 Private Methods
		 ********************/

		/* jQuery */
		$.isWindow = function(obj) {
			/* jshint eqeqeq: false */
			return obj && obj === obj.window;
		};

		/* jQuery */
		$.type = function(obj) {
			if (!obj) {
				return obj + "";
			}

			return typeof obj === "object" || typeof obj === "function" ?
					class2type[toString.call(obj)] || "object" :
					typeof obj;
		};

		/* jQuery */
		$.isArray = Array.isArray || function(obj) {
			return $.type(obj) === "array";
		};

		/* jQuery */
		function isArraylike(obj) {
			var length = obj.length,
					type = $.type(obj);

			if (type === "function" || $.isWindow(obj)) {
				return false;
			}

			if (obj.nodeType === 1 && length) {
				return true;
			}

			return type === "array" || length === 0 || typeof length === "number" && length > 0 && (length - 1) in obj;
		}

		/***************
		 $ Methods
		 ***************/

		/* jQuery: Support removed for IE<9. */
		$.isPlainObject = function(obj) {
			var key;

			if (!obj || $.type(obj) !== "object" || obj.nodeType || $.isWindow(obj)) {
				return false;
			}

			try {
				if (obj.constructor &&
						!hasOwn.call(obj, "constructor") &&
						!hasOwn.call(obj.constructor.prototype, "isPrototypeOf")) {
					return false;
				}
			} catch (e) {
				return false;
			}

			for (key in obj) {
			}

			return key === undefined || hasOwn.call(obj, key);
		};

		/* jQuery */
		$.each = function(obj, callback, args) {
			var value,
					i = 0,
					length = obj.length,
					isArray = isArraylike(obj);

			if (args) {
				if (isArray) {
					for (; i < length; i++) {
						value = callback.apply(obj[i], args);

						if (value === false) {
							break;
						}
					}
				} else {
					for (i in obj) {
						if (!obj.hasOwnProperty(i)) {
							continue;
						}
						value = callback.apply(obj[i], args);

						if (value === false) {
							break;
						}
					}
				}

			} else {
				if (isArray) {
					for (; i < length; i++) {
						value = callback.call(obj[i], i, obj[i]);

						if (value === false) {
							break;
						}
					}
				} else {
					for (i in obj) {
						if (!obj.hasOwnProperty(i)) {
							continue;
						}
						value = callback.call(obj[i], i, obj[i]);

						if (value === false) {
							break;
						}
					}
				}
			}

			return obj;
		};

		/* Custom */
		$.data = function(node, key, value) {
			/* $.getData() */
			if (value === undefined) {
				var getId = node[$.expando],
						store = getId && cache[getId];

				if (key === undefined) {
					return store;
				} else if (store) {
					if (key in store) {
						return store[key];
					}
				}
				/* $.setData() */
			} else if (key !== undefined) {
				var setId = node[$.expando] || (node[$.expando] = ++$.uuid);

				cache[setId] = cache[setId] || {};
				cache[setId][key] = value;

				return value;
			}
		};

		/* Custom */
		$.removeData = function(node, keys) {
			var id = node[$.expando],
					store = id && cache[id];

			if (store) {
				// Cleanup the entire store if no keys are provided.
				if (!keys) {
					delete cache[id];
				} else {
					$.each(keys, function(_, key) {
						delete store[key];
					});
				}
			}
		};

		/* jQuery */
		$.extend = function() {
			var src, copyIsArray, copy, name, options, clone,
					target = arguments[0] || {},
					i = 1,
					length = arguments.length,
					deep = false;

			if (typeof target === "boolean") {
				deep = target;

				target = arguments[i] || {};
				i++;
			}

			if (typeof target !== "object" && $.type(target) !== "function") {
				target = {};
			}

			if (i === length) {
				target = this;
				i--;
			}

			for (; i < length; i++) {
				if ((options = arguments[i])) {
					for (name in options) {
						if (!options.hasOwnProperty(name)) {
							continue;
						}
						src = target[name];
						copy = options[name];

						if (target === copy) {
							continue;
						}

						if (deep && copy && ($.isPlainObject(copy) || (copyIsArray = $.isArray(copy)))) {
							if (copyIsArray) {
								copyIsArray = false;
								clone = src && $.isArray(src) ? src : [];

							} else {
								clone = src && $.isPlainObject(src) ? src : {};
							}

							target[name] = $.extend(deep, clone, copy);

						} else if (copy !== undefined) {
							target[name] = copy;
						}
					}
				}
			}

			return target;
		};

		/* jQuery 1.4.3 */
		$.queue = function(elem, type, data) {
			function $makeArray(arr, results) {
				var ret = results || [];

				if (arr) {
					if (isArraylike(Object(arr))) {
						/* $.merge */
						(function(first, second) {
							var len = +second.length,
									j = 0,
									i = first.length;

							while (j < len) {
								first[i++] = second[j++];
							}

							if (len !== len) {
								while (second[j] !== undefined) {
									first[i++] = second[j++];
								}
							}

							first.length = i;

							return first;
						})(ret, typeof arr === "string" ? [arr] : arr);
					} else {
						[].push.call(ret, arr);
					}
				}

				return ret;
			}

			if (!elem) {
				return;
			}

			type = (type || "fx") + "queue";

			var q = $.data(elem, type);

			if (!data) {
				return q || [];
			}

			if (!q || $.isArray(data)) {
				q = $.data(elem, type, $makeArray(data));
			} else {
				q.push(data);
			}

			return q;
		};

		/* jQuery 1.4.3 */
		$.dequeue = function(elems, type) {
			/* Custom: Embed element iteration. */
			$.each(elems.nodeType ? [elems] : elems, function(i, elem) {
				type = type || "fx";

				var queue = $.queue(elem, type),
						fn = queue.shift();

				if (fn === "inprogress") {
					fn = queue.shift();
				}

				if (fn) {
					if (type === "fx") {
						queue.unshift("inprogress");
					}

					fn.call(elem, function() {
						$.dequeue(elem, type);
					});
				}
			});
		};

		/******************
		 $.fn Methods
		 ******************/

		/* jQuery */
		$.fn = $.prototype = {
			init: function(selector) {
				/* Just return the element wrapped inside an array; don't proceed with the actual jQuery node wrapping process. */
				if (selector.nodeType) {
					this[0] = selector;

					return this;
				} else {
					throw new Error("Not a DOM node.");
				}
			},
			offset: function() {
				/* jQuery altered code: Dropped disconnected DOM node checking. */
				var box = this[0].getBoundingClientRect ? this[0].getBoundingClientRect() : {top: 0, left: 0};

				return {
					top: box.top + (window.pageYOffset || document.scrollTop || 0) - (document.clientTop || 0),
					left: box.left + (window.pageXOffset || document.scrollLeft || 0) - (document.clientLeft || 0)
				};
			},
			position: function() {
				/* jQuery */
				function offsetParentFn(elem) {
					var offsetParent = elem.offsetParent;

					while (offsetParent && (offsetParent.nodeName.toLowerCase() !== "html" && offsetParent.style && offsetParent.style.position.toLowerCase() === "static")) {
						offsetParent = offsetParent.offsetParent;
					}

					return offsetParent || document;
				}

				/* Zepto */
				var elem = this[0],
						offsetParent = offsetParentFn(elem),
						offset = this.offset(),
						parentOffset = /^(?:body|html)$/i.test(offsetParent.nodeName) ? {top: 0, left: 0} : $(offsetParent).offset();

				offset.top -= parseFloat(elem.style.marginTop) || 0;
				offset.left -= parseFloat(elem.style.marginLeft) || 0;

				if (offsetParent.style) {
					parentOffset.top += parseFloat(offsetParent.style.borderTopWidth) || 0;
					parentOffset.left += parseFloat(offsetParent.style.borderLeftWidth) || 0;
				}

				return {
					top: offset.top - parentOffset.top,
					left: offset.left - parentOffset.left
				};
			}
		};

		/**********************
		 Private Variables
		 **********************/

		/* For $.data() */
		var cache = {};
		$.expando = "velocity" + (new Date().getTime());
		$.uuid = 0;

		/* For $.queue() */
		var class2type = {},
				hasOwn = class2type.hasOwnProperty,
				toString = class2type.toString;

		var types = "Boolean Number String Function Array Date RegExp Object Error".split(" ");
		for (var i = 0; i < types.length; i++) {
			class2type["[object " + types[i] + "]"] = types[i].toLowerCase();
		}

		/* Makes $(node) possible, without having to call init. */
		$.fn.init.prototype = $.fn;

		/* Globalize Velocity onto the window, and assign its Utilities property. */
		window.Velocity = {Utilities: $};
	})(window);

	/******************
	 Velocity.js
	 ******************/

	(function(factory) {
		/* CommonJS module. */
		{
			module.exports = factory();
			/* AMD module. */
		}
	}(function() {
		return function(global, window, document, undefined$1) {

			/***************
			 Summary
			 ***************/

			/*
			 - CSS: CSS stack that works independently from the rest of Velocity.
			 - animate(): Core animation method that iterates over the targeted elements and queues the incoming call onto each element individually.
			 - Pre-Queueing: Prepare the element for animation by instantiating its data cache and processing the call's options.
			 - Queueing: The logic that runs once the call has reached its point of execution in the element's $.queue() stack.
			 Most logic is placed here to avoid risking it becoming stale (if the element's properties have changed).
			 - Pushing: Consolidation of the tween data followed by its push onto the global in-progress calls container.
			 - tick(): The single requestAnimationFrame loop responsible for tweening all in-progress calls.
			 - completeCall(): Handles the cleanup process for each Velocity call.
			 */

			/*********************
			 Helper Functions
			 *********************/

			/* IE detection. Gist: https://gist.github.com/julianshapiro/9098609 */
			var IE = (function() {
				if (document.documentMode) {
					return document.documentMode;
				} else {
					for (var i = 7; i > 4; i--) {
						var div = document.createElement("div");

						div.innerHTML = "<!--[if IE " + i + "]><span></span><![endif]-->";

						if (div.getElementsByTagName("span").length) {
							div = null;

							return i;
						}
					}
				}

				return undefined$1;
			})();

			/* rAF shim. Gist: https://gist.github.com/julianshapiro/9497513 */
			var rAFShim = (function() {
				var timeLast = 0;

				return window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function(callback) {
					var timeCurrent = (new Date()).getTime(),
							timeDelta;

					/* Dynamically set delay on a per-tick basis to match 60fps. */
					/* Technique by Erik Moller. MIT license: https://gist.github.com/paulirish/1579671 */
					timeDelta = Math.max(0, 16 - (timeCurrent - timeLast));
					timeLast = timeCurrent + timeDelta;

					return setTimeout(function() {
						callback(timeCurrent + timeDelta);
					}, timeDelta);
				};
			})();

			var performance = (function() {
				var perf = window.performance || {};

				if (typeof perf.now !== "function") {
					var nowOffset = perf.timing && perf.timing.navigationStart ? perf.timing.navigationStart : (new Date()).getTime();

					perf.now = function() {
						return (new Date()).getTime() - nowOffset;
					};
				}
				return perf;
			})();

			/* Array compacting. Copyright Lo-Dash. MIT License: https://github.com/lodash/lodash/blob/master/LICENSE.txt */
			function compactSparseArray(array) {
				var index = -1,
						length = array ? array.length : 0,
						result = [];

				while (++index < length) {
					var value = array[index];

					if (value) {
						result.push(value);
					}
				}

				return result;
			}

			/**
			 * Shim for "fixing" IE's lack of support (IE < 9) for applying slice
			 * on host objects like NamedNodeMap, NodeList, and HTMLCollection
			 * (technically, since host objects have been implementation-dependent,
			 * at least before ES2015, IE hasn't needed to work this way).
			 * Also works on strings, fixes IE < 9 to allow an explicit undefined
			 * for the 2nd argument (as in Firefox), and prevents errors when
			 * called on other DOM objects.
			 */
			var _slice = (function() {
				var slice = Array.prototype.slice;

				try {
					// Can't be used with DOM elements in IE < 9
					slice.call(document.documentElement);
					return slice;
				} catch (e) { // Fails in IE < 9

					// This will work for genuine arrays, array-like objects, 
					// NamedNodeMap (attributes, entities, notations),
					// NodeList (e.g., getElementsByTagName), HTMLCollection (e.g., childNodes),
					// and will not fail on other DOM objects (as do DOM elements in IE < 9)
					return function(begin, end) {
						var len = this.length;

						if (typeof begin !== "number") {
							begin = 0;
						}
						// IE < 9 gets unhappy with an undefined end argument
						if (typeof end !== "number") {
							end = len;
						}
						// For native Array objects, we use the native slice function
						if (this.slice) {
							return slice.call(this, begin, end);
						}
						// For array like object we handle it ourselves.
						var i,
								cloned = [],
								// Handle negative value for "begin"
								start = (begin >= 0) ? begin : Math.max(0, len + begin),
								// Handle negative value for "end"
								upTo = end < 0 ? len + end : Math.min(end, len),
								// Actual expected size of the slice
								size = upTo - start;

						if (size > 0) {
							cloned = new Array(size);
							if (this.charAt) {
								for (i = 0; i < size; i++) {
									cloned[i] = this.charAt(start + i);
								}
							} else {
								for (i = 0; i < size; i++) {
									cloned[i] = this[start + i];
								}
							}
						}
						return cloned;
					};
				}
			})();

			/* .indexOf doesn't exist in IE<9 */
			var _inArray = (function() {
				if (Array.prototype.includes) {
					return function(arr, val) {
						return arr.includes(val);
					};
				}
				if (Array.prototype.indexOf) {
					return function(arr, val) {
						return arr.indexOf(val) >= 0;
					};
				}
				return function(arr, val) {
					for (var i = 0; i < arr.length; i++) {
						if (arr[i] === val) {
							return true;
						}
					}
					return false;
				};
			});

			function sanitizeElements(elements) {
				/* Unwrap jQuery/Zepto objects. */
				if (Type.isWrapped(elements)) {
					elements = _slice.call(elements);
					/* Wrap a single element in an array so that $.each() can iterate with the element instead of its node's children. */
				} else if (Type.isNode(elements)) {
					elements = [elements];
				}

				return elements;
			}

			var Type = {
				isNumber: function(variable) {
					return (typeof variable === "number");
				},
				isString: function(variable) {
					return (typeof variable === "string");
				},
				isArray: Array.isArray || function(variable) {
					return Object.prototype.toString.call(variable) === "[object Array]";
				},
				isFunction: function(variable) {
					return Object.prototype.toString.call(variable) === "[object Function]";
				},
				isNode: function(variable) {
					return variable && variable.nodeType;
				},
				/* Determine if variable is an array-like wrapped jQuery, Zepto or similar element, or even a NodeList etc. */
				/* NOTE: HTMLFormElements also have a length. */
				isWrapped: function(variable) {
					return variable
							&& variable !== window
							&& Type.isNumber(variable.length)
							&& !Type.isString(variable)
							&& !Type.isFunction(variable)
							&& !Type.isNode(variable)
							&& (variable.length === 0 || Type.isNode(variable[0]));
				},
				isSVG: function(variable) {
					return window.SVGElement && (variable instanceof window.SVGElement);
				},
				isEmptyObject: function(variable) {
					for (var name in variable) {
						if (variable.hasOwnProperty(name)) {
							return false;
						}
					}

					return true;
				}
			};

			/*****************
			 Dependencies
			 *****************/

			var $,
					isJQuery = false;

			if (global.fn && global.fn.jquery) {
				$ = global;
				isJQuery = true;
			} else {
				$ = window.Velocity.Utilities;
			}

			if (IE <= 8 && !isJQuery) {
				throw new Error("Velocity: IE8 and below require jQuery to be loaded before Velocity.");
			} else if (IE <= 7) {
				/* Revert to jQuery's $.animate(), and lose Velocity's extra features. */
				jQuery.fn.velocity = jQuery.fn.animate;

				/* Now that $.fn.velocity is aliased, abort this Velocity declaration. */
				return;
			}

			/*****************
			 Constants
			 *****************/

			var DURATION_DEFAULT = 400,
					EASING_DEFAULT = "swing";

			/*************
			 State
			 *************/

			var Velocity = {
				/* Container for page-wide Velocity state data. */
				State: {
					/* Detect mobile devices to determine if mobileHA should be turned on. */
					isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent),
					/* The mobileHA option's behavior changes on older Android devices (Gingerbread, versions 2.3.3-2.3.7). */
					isAndroid: /Android/i.test(window.navigator.userAgent),
					isGingerbread: /Android 2\.3\.[3-7]/i.test(window.navigator.userAgent),
					isChrome: window.chrome,
					isFirefox: /Firefox/i.test(window.navigator.userAgent),
					/* Create a cached element for re-use when checking for CSS property prefixes. */
					prefixElement: document.createElement("div"),
					/* Cache every prefix match to avoid repeating lookups. */
					prefixMatches: {},
					/* Cache the anchor used for animating window scrolling. */
					scrollAnchor: null,
					/* Cache the browser-specific property names associated with the scroll anchor. */
					scrollPropertyLeft: null,
					scrollPropertyTop: null,
					/* Keep track of whether our RAF tick is running. */
					isTicking: false,
					/* Container for every in-progress call to Velocity. */
					calls: [],
					delayedElements: {
						count: 0
					}
				},
				/* Velocity's custom CSS stack. Made global for unit testing. */
				CSS: {/* Defined below. */},
				/* A shim of the jQuery utility functions used by Velocity -- provided by Velocity's optional jQuery shim. */
				Utilities: $,
				/* Container for the user's custom animation redirects that are referenced by name in place of the properties map argument. */
				Redirects: {/* Manually registered by the user. */},
				Easings: {/* Defined below. */},
				/* Attempt to use ES6 Promises by default. Users can override this with a third-party promises library. */
				Promise: window.Promise,
				/* Velocity option defaults, which can be overriden by the user. */
				defaults: {
					queue: "",
					duration: DURATION_DEFAULT,
					easing: EASING_DEFAULT,
					begin: undefined$1,
					complete: undefined$1,
					progress: undefined$1,
					display: undefined$1,
					visibility: undefined$1,
					loop: false,
					delay: false,
					mobileHA: true,
					/* Advanced: Set to false to prevent property values from being cached between consecutive Velocity-initiated chain calls. */
					_cacheValues: true,
					/* Advanced: Set to false if the promise should always resolve on empty element lists. */
					promiseRejectEmpty: true
				},
				/* A design goal of Velocity is to cache data wherever possible in order to avoid DOM requerying. Accordingly, each element has a data cache. */
				init: function(element) {
					$.data(element, "velocity", {
						/* Store whether this is an SVG element, since its properties are retrieved and updated differently than standard HTML elements. */
						isSVG: Type.isSVG(element),
						/* Keep track of whether the element is currently being animated by Velocity.
						 This is used to ensure that property values are not transferred between non-consecutive (stale) calls. */
						isAnimating: false,
						/* A reference to the element's live computedStyle object. Learn more here: https://developer.mozilla.org/en/docs/Web/API/window.getComputedStyle */
						computedStyle: null,
						/* Tween data is cached for each animation on the element so that data can be passed across calls --
						 in particular, end values are used as subsequent start values in consecutive Velocity calls. */
						tweensContainer: null,
						/* The full root property values of each CSS hook being animated on this element are cached so that:
						 1) Concurrently-animating hooks sharing the same root can have their root values' merged into one while tweening.
						 2) Post-hook-injection root values can be transferred over to consecutively chained Velocity calls as starting root values. */
						rootPropertyValueCache: {},
						/* A cache for transform updates, which must be manually flushed via CSS.flushTransformCache(). */
						transformCache: {}
					});
				},
				/* A parallel to jQuery's $.css(), used for getting/setting Velocity's hooked CSS properties. */
				hook: null, /* Defined below. */
				/* Velocity-wide animation time remapping for testing purposes. */
				mock: false,
				version: {major: 1, minor: 5, patch: 2},
				/* Set to 1 or 2 (most verbose) to output debug info to console. */
				debug: false,
				/* Use rAF high resolution timestamp when available */
				timestamp: true,
				/* Pause all animations */
				pauseAll: function(queueName) {
					var currentTime = (new Date()).getTime();

					$.each(Velocity.State.calls, function(i, activeCall) {

						if (activeCall) {

							/* If we have a queueName and this call is not on that queue, skip */
							if (queueName !== undefined$1 && ((activeCall[2].queue !== queueName) || (activeCall[2].queue === false))) {
								return true;
							}

							/* Set call to paused */
							activeCall[5] = {
								resume: false
							};
						}
					});

					/* Pause timers on any currently delayed calls */
					$.each(Velocity.State.delayedElements, function(k, element) {
						if (!element) {
							return;
						}
						pauseDelayOnElement(element, currentTime);
					});
				},
				/* Resume all animations */
				resumeAll: function(queueName) {
					(new Date()).getTime();

					$.each(Velocity.State.calls, function(i, activeCall) {

						if (activeCall) {

							/* If we have a queueName and this call is not on that queue, skip */
							if (queueName !== undefined$1 && ((activeCall[2].queue !== queueName) || (activeCall[2].queue === false))) {
								return true;
							}

							/* Set call to resumed if it was paused */
							if (activeCall[5]) {
								activeCall[5].resume = true;
							}
						}
					});
					/* Resume timers on any currently delayed calls */
					$.each(Velocity.State.delayedElements, function(k, element) {
						if (!element) {
							return;
						}
						resumeDelayOnElement(element);
					});
				}
			};

			/* Retrieve the appropriate scroll anchor and property name for the browser: https://developer.mozilla.org/en-US/docs/Web/API/Window.scrollY */
			if (window.pageYOffset !== undefined$1) {
				Velocity.State.scrollAnchor = window;
				Velocity.State.scrollPropertyLeft = "pageXOffset";
				Velocity.State.scrollPropertyTop = "pageYOffset";
			} else {
				Velocity.State.scrollAnchor = document.documentElement || document.body.parentNode || document.body;
				Velocity.State.scrollPropertyLeft = "scrollLeft";
				Velocity.State.scrollPropertyTop = "scrollTop";
			}

			/* Shorthand alias for jQuery's $.data() utility. */
			function Data(element) {
				/* Hardcode a reference to the plugin name. */
				var response = $.data(element, "velocity");

				/* jQuery <=1.4.2 returns null instead of undefined when no match is found. We normalize this behavior. */
				return response === null ? undefined$1 : response;
			}

			/**************
			 Delay Timer
			 **************/

			function pauseDelayOnElement(element, currentTime) {
				/* Check for any delay timers, and pause the set timeouts (while preserving time data)
				 to be resumed when the "resume" command is issued */
				var data = Data(element);
				if (data && data.delayTimer && !data.delayPaused) {
					data.delayRemaining = data.delay - currentTime + data.delayBegin;
					data.delayPaused = true;
					clearTimeout(data.delayTimer.setTimeout);
				}
			}

			function resumeDelayOnElement(element, currentTime) {
				/* Check for any paused timers and resume */
				var data = Data(element);
				if (data && data.delayTimer && data.delayPaused) {
					/* If the element was mid-delay, re initiate the timeout with the remaining delay */
					data.delayPaused = false;
					data.delayTimer.setTimeout = setTimeout(data.delayTimer.next, data.delayRemaining);
				}
			}



			/**************
			 Easing
			 **************/

			/* Step easing generator. */
			function generateStep(steps) {
				return function(p) {
					return Math.round(p * steps) * (1 / steps);
				};
			}

			/* Bezier curve function generator. Copyright Gaetan Renaudeau. MIT License: http://en.wikipedia.org/wiki/MIT_License */
			function generateBezier(mX1, mY1, mX2, mY2) {
				var NEWTON_ITERATIONS = 4,
						NEWTON_MIN_SLOPE = 0.001,
						SUBDIVISION_PRECISION = 0.0000001,
						SUBDIVISION_MAX_ITERATIONS = 10,
						kSplineTableSize = 11,
						kSampleStepSize = 1.0 / (kSplineTableSize - 1.0),
						float32ArraySupported = "Float32Array" in window;

				/* Must contain four arguments. */
				if (arguments.length !== 4) {
					return false;
				}

				/* Arguments must be numbers. */
				for (var i = 0; i < 4; ++i) {
					if (typeof arguments[i] !== "number" || isNaN(arguments[i]) || !isFinite(arguments[i])) {
						return false;
					}
				}

				/* X values must be in the [0, 1] range. */
				mX1 = Math.min(mX1, 1);
				mX2 = Math.min(mX2, 1);
				mX1 = Math.max(mX1, 0);
				mX2 = Math.max(mX2, 0);

				var mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);

				function A(aA1, aA2) {
					return 1.0 - 3.0 * aA2 + 3.0 * aA1;
				}
				function B(aA1, aA2) {
					return 3.0 * aA2 - 6.0 * aA1;
				}
				function C(aA1) {
					return 3.0 * aA1;
				}

				function calcBezier(aT, aA1, aA2) {
					return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
				}

				function getSlope(aT, aA1, aA2) {
					return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
				}

				function newtonRaphsonIterate(aX, aGuessT) {
					for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
						var currentSlope = getSlope(aGuessT, mX1, mX2);

						if (currentSlope === 0.0) {
							return aGuessT;
						}

						var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
						aGuessT -= currentX / currentSlope;
					}

					return aGuessT;
				}

				function calcSampleValues() {
					for (var i = 0; i < kSplineTableSize; ++i) {
						mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
					}
				}

				function binarySubdivide(aX, aA, aB) {
					var currentX, currentT, i = 0;

					do {
						currentT = aA + (aB - aA) / 2.0;
						currentX = calcBezier(currentT, mX1, mX2) - aX;
						if (currentX > 0.0) {
							aB = currentT;
						} else {
							aA = currentT;
						}
					} while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);

					return currentT;
				}

				function getTForX(aX) {
					var intervalStart = 0.0,
							currentSample = 1,
							lastSample = kSplineTableSize - 1;

					for (; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample) {
						intervalStart += kSampleStepSize;
					}

					--currentSample;

					var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample + 1] - mSampleValues[currentSample]),
							guessForT = intervalStart + dist * kSampleStepSize,
							initialSlope = getSlope(guessForT, mX1, mX2);

					if (initialSlope >= NEWTON_MIN_SLOPE) {
						return newtonRaphsonIterate(aX, guessForT);
					} else if (initialSlope === 0.0) {
						return guessForT;
					} else {
						return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize);
					}
				}

				var _precomputed = false;

				function precompute() {
					_precomputed = true;
					if (mX1 !== mY1 || mX2 !== mY2) {
						calcSampleValues();
					}
				}

				var f = function(aX) {
					if (!_precomputed) {
						precompute();
					}
					if (mX1 === mY1 && mX2 === mY2) {
						return aX;
					}
					if (aX === 0) {
						return 0;
					}
					if (aX === 1) {
						return 1;
					}

					return calcBezier(getTForX(aX), mY1, mY2);
				};

				f.getControlPoints = function() {
					return [{x: mX1, y: mY1}, {x: mX2, y: mY2}];
				};

				var str = "generateBezier(" + [mX1, mY1, mX2, mY2] + ")";
				f.toString = function() {
					return str;
				};

				return f;
			}

			/* Runge-Kutta spring physics function generator. Adapted from Framer.js, copyright Koen Bok. MIT License: http://en.wikipedia.org/wiki/MIT_License */
			/* Given a tension, friction, and duration, a simulation at 60FPS will first run without a defined duration in order to calculate the full path. A second pass
			 then adjusts the time delta -- using the relation between actual time and duration -- to calculate the path for the duration-constrained animation. */
			var generateSpringRK4 = (function() {
				function springAccelerationForState(state) {
					return (-state.tension * state.x) - (state.friction * state.v);
				}

				function springEvaluateStateWithDerivative(initialState, dt, derivative) {
					var state = {
						x: initialState.x + derivative.dx * dt,
						v: initialState.v + derivative.dv * dt,
						tension: initialState.tension,
						friction: initialState.friction
					};

					return {dx: state.v, dv: springAccelerationForState(state)};
				}

				function springIntegrateState(state, dt) {
					var a = {
						dx: state.v,
						dv: springAccelerationForState(state)
					},
							b = springEvaluateStateWithDerivative(state, dt * 0.5, a),
							c = springEvaluateStateWithDerivative(state, dt * 0.5, b),
							d = springEvaluateStateWithDerivative(state, dt, c),
							dxdt = 1.0 / 6.0 * (a.dx + 2.0 * (b.dx + c.dx) + d.dx),
							dvdt = 1.0 / 6.0 * (a.dv + 2.0 * (b.dv + c.dv) + d.dv);

					state.x = state.x + dxdt * dt;
					state.v = state.v + dvdt * dt;

					return state;
				}

				return function springRK4Factory(tension, friction, duration) {

					var initState = {
						x: -1,
						v: 0,
						tension: null,
						friction: null
					},
							path = [0],
							time_lapsed = 0,
							tolerance = 1 / 10000,
							DT = 16 / 1000,
							have_duration, dt, last_state;

					tension = parseFloat(tension) || 500;
					friction = parseFloat(friction) || 20;
					duration = duration || null;

					initState.tension = tension;
					initState.friction = friction;

					have_duration = duration !== null;

					/* Calculate the actual time it takes for this animation to complete with the provided conditions. */
					if (have_duration) {
						/* Run the simulation without a duration. */
						time_lapsed = springRK4Factory(tension, friction);
						/* Compute the adjusted time delta. */
						dt = time_lapsed / duration * DT;
					} else {
						dt = DT;
					}

					while (true) {
						/* Next/step function .*/
						last_state = springIntegrateState(last_state || initState, dt);
						/* Store the position. */
						path.push(1 + last_state.x);
						time_lapsed += 16;
						/* If the change threshold is reached, break. */
						if (!(Math.abs(last_state.x) > tolerance && Math.abs(last_state.v) > tolerance)) {
							break;
						}
					}

					/* If duration is not defined, return the actual time required for completing this animation. Otherwise, return a closure that holds the
					 computed path and returns a snapshot of the position according to a given percentComplete. */
					return !have_duration ? time_lapsed : function(percentComplete) {
						return path[ (percentComplete * (path.length - 1)) | 0 ];
					};
				};
			}());

			/* jQuery easings. */
			Velocity.Easings = {
				linear: function(p) {
					return p;
				},
				swing: function(p) {
					return 0.5 - Math.cos(p * Math.PI) / 2;
				},
				/* Bonus "spring" easing, which is a less exaggerated version of easeInOutElastic. */
				spring: function(p) {
					return 1 - (Math.cos(p * 4.5 * Math.PI) * Math.exp(-p * 6));
				}
			};

			/* CSS3 and Robert Penner easings. */
			$.each(
					[
						["ease", [0.25, 0.1, 0.25, 1.0]],
						["ease-in", [0.42, 0.0, 1.00, 1.0]],
						["ease-out", [0.00, 0.0, 0.58, 1.0]],
						["ease-in-out", [0.42, 0.0, 0.58, 1.0]],
						["easeInSine", [0.47, 0, 0.745, 0.715]],
						["easeOutSine", [0.39, 0.575, 0.565, 1]],
						["easeInOutSine", [0.445, 0.05, 0.55, 0.95]],
						["easeInQuad", [0.55, 0.085, 0.68, 0.53]],
						["easeOutQuad", [0.25, 0.46, 0.45, 0.94]],
						["easeInOutQuad", [0.455, 0.03, 0.515, 0.955]],
						["easeInCubic", [0.55, 0.055, 0.675, 0.19]],
						["easeOutCubic", [0.215, 0.61, 0.355, 1]],
						["easeInOutCubic", [0.645, 0.045, 0.355, 1]],
						["easeInQuart", [0.895, 0.03, 0.685, 0.22]],
						["easeOutQuart", [0.165, 0.84, 0.44, 1]],
						["easeInOutQuart", [0.77, 0, 0.175, 1]],
						["easeInQuint", [0.755, 0.05, 0.855, 0.06]],
						["easeOutQuint", [0.23, 1, 0.32, 1]],
						["easeInOutQuint", [0.86, 0, 0.07, 1]],
						["easeInExpo", [0.95, 0.05, 0.795, 0.035]],
						["easeOutExpo", [0.19, 1, 0.22, 1]],
						["easeInOutExpo", [1, 0, 0, 1]],
						["easeInCirc", [0.6, 0.04, 0.98, 0.335]],
						["easeOutCirc", [0.075, 0.82, 0.165, 1]],
						["easeInOutCirc", [0.785, 0.135, 0.15, 0.86]]
					], function(i, easingArray) {
				Velocity.Easings[easingArray[0]] = generateBezier.apply(null, easingArray[1]);
			});

			/* Determine the appropriate easing type given an easing input. */
			function getEasing(value, duration) {
				var easing = value;

				/* The easing option can either be a string that references a pre-registered easing,
				 or it can be a two-/four-item array of integers to be converted into a bezier/spring function. */
				if (Type.isString(value)) {
					/* Ensure that the easing has been assigned to jQuery's Velocity.Easings object. */
					if (!Velocity.Easings[value]) {
						easing = false;
					}
				} else if (Type.isArray(value) && value.length === 1) {
					easing = generateStep.apply(null, value);
				} else if (Type.isArray(value) && value.length === 2) {
					/* springRK4 must be passed the animation's duration. */
					/* Note: If the springRK4 array contains non-numbers, generateSpringRK4() returns an easing
					 function generated with default tension and friction values. */
					easing = generateSpringRK4.apply(null, value.concat([duration]));
				} else if (Type.isArray(value) && value.length === 4) {
					/* Note: If the bezier array contains non-numbers, generateBezier() returns false. */
					easing = generateBezier.apply(null, value);
				} else {
					easing = false;
				}

				/* Revert to the Velocity-wide default easing type, or fall back to "swing" (which is also jQuery's default)
				 if the Velocity-wide default has been incorrectly modified. */
				if (easing === false) {
					if (Velocity.Easings[Velocity.defaults.easing]) {
						easing = Velocity.defaults.easing;
					} else {
						easing = EASING_DEFAULT;
					}
				}

				return easing;
			}

			/*****************
			 CSS Stack
			 *****************/

			/* The CSS object is a highly condensed and performant CSS stack that fully replaces jQuery's.
			 It handles the validation, getting, and setting of both standard CSS properties and CSS property hooks. */
			/* Note: A "CSS" shorthand is aliased so that our code is easier to read. */
			var CSS = Velocity.CSS = {
				/*************
				 RegEx
				 *************/

				RegEx: {
					isHex: /^#([A-f\d]{3}){1,2}$/i,
					/* Unwrap a property value's surrounding text, e.g. "rgba(4, 3, 2, 1)" ==> "4, 3, 2, 1" and "rect(4px 3px 2px 1px)" ==> "4px 3px 2px 1px". */
					valueUnwrap: /^[A-z]+\((.*)\)$/i,
					wrappedValueAlreadyExtracted: /[0-9.]+ [0-9.]+ [0-9.]+( [0-9.]+)?/,
					/* Split a multi-value property into an array of subvalues, e.g. "rgba(4, 3, 2, 1) 4px 3px 2px 1px" ==> [ "rgba(4, 3, 2, 1)", "4px", "3px", "2px", "1px" ]. */
					valueSplit: /([A-z]+\(.+\))|(([A-z0-9#-.]+?)(?=\s|$))/ig
				},
				/************
				 Lists
				 ************/

				Lists: {
					colors: ["fill", "stroke", "stopColor", "color", "backgroundColor", "borderColor", "borderTopColor", "borderRightColor", "borderBottomColor", "borderLeftColor", "outlineColor"],
					transformsBase: ["translateX", "translateY", "scale", "scaleX", "scaleY", "skewX", "skewY", "rotateZ"],
					transforms3D: ["transformPerspective", "translateZ", "scaleZ", "rotateX", "rotateY"],
					units: [
						"%", // relative
						"em", "ex", "ch", "rem", // font relative
						"vw", "vh", "vmin", "vmax", // viewport relative
						"cm", "mm", "Q", "in", "pc", "pt", "px", // absolute lengths
						"deg", "grad", "rad", "turn", // angles
						"s", "ms" // time
					],
					colorNames: {
						"aliceblue": "240,248,255",
						"antiquewhite": "250,235,215",
						"aquamarine": "127,255,212",
						"aqua": "0,255,255",
						"azure": "240,255,255",
						"beige": "245,245,220",
						"bisque": "255,228,196",
						"black": "0,0,0",
						"blanchedalmond": "255,235,205",
						"blueviolet": "138,43,226",
						"blue": "0,0,255",
						"brown": "165,42,42",
						"burlywood": "222,184,135",
						"cadetblue": "95,158,160",
						"chartreuse": "127,255,0",
						"chocolate": "210,105,30",
						"coral": "255,127,80",
						"cornflowerblue": "100,149,237",
						"cornsilk": "255,248,220",
						"crimson": "220,20,60",
						"cyan": "0,255,255",
						"darkblue": "0,0,139",
						"darkcyan": "0,139,139",
						"darkgoldenrod": "184,134,11",
						"darkgray": "169,169,169",
						"darkgrey": "169,169,169",
						"darkgreen": "0,100,0",
						"darkkhaki": "189,183,107",
						"darkmagenta": "139,0,139",
						"darkolivegreen": "85,107,47",
						"darkorange": "255,140,0",
						"darkorchid": "153,50,204",
						"darkred": "139,0,0",
						"darksalmon": "233,150,122",
						"darkseagreen": "143,188,143",
						"darkslateblue": "72,61,139",
						"darkslategray": "47,79,79",
						"darkturquoise": "0,206,209",
						"darkviolet": "148,0,211",
						"deeppink": "255,20,147",
						"deepskyblue": "0,191,255",
						"dimgray": "105,105,105",
						"dimgrey": "105,105,105",
						"dodgerblue": "30,144,255",
						"firebrick": "178,34,34",
						"floralwhite": "255,250,240",
						"forestgreen": "34,139,34",
						"fuchsia": "255,0,255",
						"gainsboro": "220,220,220",
						"ghostwhite": "248,248,255",
						"gold": "255,215,0",
						"goldenrod": "218,165,32",
						"gray": "128,128,128",
						"grey": "128,128,128",
						"greenyellow": "173,255,47",
						"green": "0,128,0",
						"honeydew": "240,255,240",
						"hotpink": "255,105,180",
						"indianred": "205,92,92",
						"indigo": "75,0,130",
						"ivory": "255,255,240",
						"khaki": "240,230,140",
						"lavenderblush": "255,240,245",
						"lavender": "230,230,250",
						"lawngreen": "124,252,0",
						"lemonchiffon": "255,250,205",
						"lightblue": "173,216,230",
						"lightcoral": "240,128,128",
						"lightcyan": "224,255,255",
						"lightgoldenrodyellow": "250,250,210",
						"lightgray": "211,211,211",
						"lightgrey": "211,211,211",
						"lightgreen": "144,238,144",
						"lightpink": "255,182,193",
						"lightsalmon": "255,160,122",
						"lightseagreen": "32,178,170",
						"lightskyblue": "135,206,250",
						"lightslategray": "119,136,153",
						"lightsteelblue": "176,196,222",
						"lightyellow": "255,255,224",
						"limegreen": "50,205,50",
						"lime": "0,255,0",
						"linen": "250,240,230",
						"magenta": "255,0,255",
						"maroon": "128,0,0",
						"mediumaquamarine": "102,205,170",
						"mediumblue": "0,0,205",
						"mediumorchid": "186,85,211",
						"mediumpurple": "147,112,219",
						"mediumseagreen": "60,179,113",
						"mediumslateblue": "123,104,238",
						"mediumspringgreen": "0,250,154",
						"mediumturquoise": "72,209,204",
						"mediumvioletred": "199,21,133",
						"midnightblue": "25,25,112",
						"mintcream": "245,255,250",
						"mistyrose": "255,228,225",
						"moccasin": "255,228,181",
						"navajowhite": "255,222,173",
						"navy": "0,0,128",
						"oldlace": "253,245,230",
						"olivedrab": "107,142,35",
						"olive": "128,128,0",
						"orangered": "255,69,0",
						"orange": "255,165,0",
						"orchid": "218,112,214",
						"palegoldenrod": "238,232,170",
						"palegreen": "152,251,152",
						"paleturquoise": "175,238,238",
						"palevioletred": "219,112,147",
						"papayawhip": "255,239,213",
						"peachpuff": "255,218,185",
						"peru": "205,133,63",
						"pink": "255,192,203",
						"plum": "221,160,221",
						"powderblue": "176,224,230",
						"purple": "128,0,128",
						"red": "255,0,0",
						"rosybrown": "188,143,143",
						"royalblue": "65,105,225",
						"saddlebrown": "139,69,19",
						"salmon": "250,128,114",
						"sandybrown": "244,164,96",
						"seagreen": "46,139,87",
						"seashell": "255,245,238",
						"sienna": "160,82,45",
						"silver": "192,192,192",
						"skyblue": "135,206,235",
						"slateblue": "106,90,205",
						"slategray": "112,128,144",
						"snow": "255,250,250",
						"springgreen": "0,255,127",
						"steelblue": "70,130,180",
						"tan": "210,180,140",
						"teal": "0,128,128",
						"thistle": "216,191,216",
						"tomato": "255,99,71",
						"turquoise": "64,224,208",
						"violet": "238,130,238",
						"wheat": "245,222,179",
						"whitesmoke": "245,245,245",
						"white": "255,255,255",
						"yellowgreen": "154,205,50",
						"yellow": "255,255,0"
					}
				},
				/************
				 Hooks
				 ************/

				/* Hooks allow a subproperty (e.g. "boxShadowBlur") of a compound-value CSS property
				 (e.g. "boxShadow: X Y Blur Spread Color") to be animated as if it were a discrete property. */
				/* Note: Beyond enabling fine-grained property animation, hooking is necessary since Velocity only
				 tweens properties with single numeric values; unlike CSS transitions, Velocity does not interpolate compound-values. */
				Hooks: {
					/********************
					 Registration
					 ********************/

					/* Templates are a concise way of indicating which subproperties must be individually registered for each compound-value CSS property. */
					/* Each template consists of the compound-value's base name, its constituent subproperty names, and those subproperties' default values. */
					templates: {
						"textShadow": ["Color X Y Blur", "black 0px 0px 0px"],
						"boxShadow": ["Color X Y Blur Spread", "black 0px 0px 0px 0px"],
						"clip": ["Top Right Bottom Left", "0px 0px 0px 0px"],
						"backgroundPosition": ["X Y", "0% 0%"],
						"transformOrigin": ["X Y Z", "50% 50% 0px"],
						"perspectiveOrigin": ["X Y", "50% 50%"]
					},
					/* A "registered" hook is one that has been converted from its template form into a live,
					 tweenable property. It contains data to associate it with its root property. */
					registered: {
						/* Note: A registered hook looks like this ==> textShadowBlur: [ "textShadow", 3 ],
						 which consists of the subproperty's name, the associated root property's name,
						 and the subproperty's position in the root's value. */
					},
					/* Convert the templates into individual hooks then append them to the registered object above. */
					register: function() {
						/* Color hooks registration: Colors are defaulted to white -- as opposed to black -- since colors that are
						 currently set to "transparent" default to their respective template below when color-animated,
						 and white is typically a closer match to transparent than black is. An exception is made for text ("color"),
						 which is almost always set closer to black than white. */
						for (var i = 0; i < CSS.Lists.colors.length; i++) {
							var rgbComponents = (CSS.Lists.colors[i] === "color") ? "0 0 0 1" : "255 255 255 1";
							CSS.Hooks.templates[CSS.Lists.colors[i]] = ["Red Green Blue Alpha", rgbComponents];
						}

						var rootProperty,
								hookTemplate,
								hookNames;

						/* In IE, color values inside compound-value properties are positioned at the end the value instead of at the beginning.
						 Thus, we re-arrange the templates accordingly. */
						if (IE) {
							for (rootProperty in CSS.Hooks.templates) {
								if (!CSS.Hooks.templates.hasOwnProperty(rootProperty)) {
									continue;
								}
								hookTemplate = CSS.Hooks.templates[rootProperty];
								hookNames = hookTemplate[0].split(" ");

								var defaultValues = hookTemplate[1].match(CSS.RegEx.valueSplit);

								if (hookNames[0] === "Color") {
									/* Reposition both the hook's name and its default value to the end of their respective strings. */
									hookNames.push(hookNames.shift());
									defaultValues.push(defaultValues.shift());

									/* Replace the existing template for the hook's root property. */
									CSS.Hooks.templates[rootProperty] = [hookNames.join(" "), defaultValues.join(" ")];
								}
							}
						}

						/* Hook registration. */
						for (rootProperty in CSS.Hooks.templates) {
							if (!CSS.Hooks.templates.hasOwnProperty(rootProperty)) {
								continue;
							}
							hookTemplate = CSS.Hooks.templates[rootProperty];
							hookNames = hookTemplate[0].split(" ");

							for (var j in hookNames) {
								if (!hookNames.hasOwnProperty(j)) {
									continue;
								}
								var fullHookName = rootProperty + hookNames[j],
										hookPosition = j;

								/* For each hook, register its full name (e.g. textShadowBlur) with its root property (e.g. textShadow)
								 and the hook's position in its template's default value string. */
								CSS.Hooks.registered[fullHookName] = [rootProperty, hookPosition];
							}
						}
					},
					/*****************************
					 Injection and Extraction
					 *****************************/

					/* Look up the root property associated with the hook (e.g. return "textShadow" for "textShadowBlur"). */
					/* Since a hook cannot be set directly (the browser won't recognize it), style updating for hooks is routed through the hook's root property. */
					getRoot: function(property) {
						var hookData = CSS.Hooks.registered[property];

						if (hookData) {
							return hookData[0];
						} else {
							/* If there was no hook match, return the property name untouched. */
							return property;
						}
					},
					getUnit: function(str, start) {
						var unit = (str.substr(start || 0, 5).match(/^[a-z%]+/) || [])[0] || "";

						if (unit && _inArray(CSS.Lists.units)) {
							return unit;
						}
						return "";
					},
					fixColors: function(str) {
						return str.replace(/(rgba?\(\s*)?(\b[a-z]+\b)/g, function($0, $1, $2) {
							if (CSS.Lists.colorNames.hasOwnProperty($2)) {
								return ($1 ? $1 : "rgba(") + CSS.Lists.colorNames[$2] + ($1 ? "" : ",1)");
							}
							return $1 + $2;
						});
					},
					/* Convert any rootPropertyValue, null or otherwise, into a space-delimited list of hook values so that
					 the targeted hook can be injected or extracted at its standard position. */
					cleanRootPropertyValue: function(rootProperty, rootPropertyValue) {
						/* If the rootPropertyValue is wrapped with "rgb()", "clip()", etc., remove the wrapping to normalize the value before manipulation. */
						if (CSS.RegEx.valueUnwrap.test(rootPropertyValue)) {
							rootPropertyValue = rootPropertyValue.match(CSS.RegEx.valueUnwrap)[1];
						}

						/* If rootPropertyValue is a CSS null-value (from which there's inherently no hook value to extract),
						 default to the root's default value as defined in CSS.Hooks.templates. */
						/* Note: CSS null-values include "none", "auto", and "transparent". They must be converted into their
						 zero-values (e.g. textShadow: "none" ==> textShadow: "0px 0px 0px black") for hook manipulation to proceed. */
						if (CSS.Values.isCSSNullValue(rootPropertyValue)) {
							rootPropertyValue = CSS.Hooks.templates[rootProperty][1];
						}

						return rootPropertyValue;
					},
					/* Extracted the hook's value from its root property's value. This is used to get the starting value of an animating hook. */
					extractValue: function(fullHookName, rootPropertyValue) {
						var hookData = CSS.Hooks.registered[fullHookName];

						if (hookData) {
							var hookRoot = hookData[0],
									hookPosition = hookData[1];

							rootPropertyValue = CSS.Hooks.cleanRootPropertyValue(hookRoot, rootPropertyValue);

							/* Split rootPropertyValue into its constituent hook values then grab the desired hook at its standard position. */
							return rootPropertyValue.toString().match(CSS.RegEx.valueSplit)[hookPosition];
						} else {
							/* If the provided fullHookName isn't a registered hook, return the rootPropertyValue that was passed in. */
							return rootPropertyValue;
						}
					},
					/* Inject the hook's value into its root property's value. This is used to piece back together the root property
					 once Velocity has updated one of its individually hooked values through tweening. */
					injectValue: function(fullHookName, hookValue, rootPropertyValue) {
						var hookData = CSS.Hooks.registered[fullHookName];

						if (hookData) {
							var hookRoot = hookData[0],
									hookPosition = hookData[1],
									rootPropertyValueParts,
									rootPropertyValueUpdated;

							rootPropertyValue = CSS.Hooks.cleanRootPropertyValue(hookRoot, rootPropertyValue);

							/* Split rootPropertyValue into its individual hook values, replace the targeted value with hookValue,
							 then reconstruct the rootPropertyValue string. */
							rootPropertyValueParts = rootPropertyValue.toString().match(CSS.RegEx.valueSplit);
							rootPropertyValueParts[hookPosition] = hookValue;
							rootPropertyValueUpdated = rootPropertyValueParts.join(" ");

							return rootPropertyValueUpdated;
						} else {
							/* If the provided fullHookName isn't a registered hook, return the rootPropertyValue that was passed in. */
							return rootPropertyValue;
						}
					}
				},
				/*******************
				 Normalizations
				 *******************/

				/* Normalizations standardize CSS property manipulation by pollyfilling browser-specific implementations (e.g. opacity)
				 and reformatting special properties (e.g. clip, rgba) to look like standard ones. */
				Normalizations: {
					/* Normalizations are passed a normalization target (either the property's name, its extracted value, or its injected value),
					 the targeted element (which may need to be queried), and the targeted property value. */
					registered: {
						clip: function(type, element, propertyValue) {
							switch (type) {
								case "name":
									return "clip";
									/* Clip needs to be unwrapped and stripped of its commas during extraction. */
								case "extract":
									var extracted;

									/* If Velocity also extracted this value, skip extraction. */
									if (CSS.RegEx.wrappedValueAlreadyExtracted.test(propertyValue)) {
										extracted = propertyValue;
									} else {
										/* Remove the "rect()" wrapper. */
										extracted = propertyValue.toString().match(CSS.RegEx.valueUnwrap);

										/* Strip off commas. */
										extracted = extracted ? extracted[1].replace(/,(\s+)?/g, " ") : propertyValue;
									}

									return extracted;
									/* Clip needs to be re-wrapped during injection. */
								case "inject":
									return "rect(" + propertyValue + ")";
							}
						},
						blur: function(type, element, propertyValue) {
							switch (type) {
								case "name":
									return Velocity.State.isFirefox ? "filter" : "-webkit-filter";
								case "extract":
									var extracted = parseFloat(propertyValue);

									/* If extracted is NaN, meaning the value isn't already extracted. */
									if (!(extracted || extracted === 0)) {
										var blurComponent = propertyValue.toString().match(/blur\(([0-9]+[A-z]+)\)/i);

										/* If the filter string had a blur component, return just the blur value and unit type. */
										if (blurComponent) {
											extracted = blurComponent[1];
											/* If the component doesn't exist, default blur to 0. */
										} else {
											extracted = 0;
										}
									}

									return extracted;
									/* Blur needs to be re-wrapped during injection. */
								case "inject":
									/* For the blur effect to be fully de-applied, it needs to be set to "none" instead of 0. */
									if (!parseFloat(propertyValue)) {
										return "none";
									} else {
										return "blur(" + propertyValue + ")";
									}
							}
						},
						/* <=IE8 do not support the standard opacity property. They use filter:alpha(opacity=INT) instead. */
						opacity: function(type, element, propertyValue) {
							if (IE <= 8) {
								switch (type) {
									case "name":
										return "filter";
									case "extract":
										/* <=IE8 return a "filter" value of "alpha(opacity=\d{1,3})".
										 Extract the value and convert it to a decimal value to match the standard CSS opacity property's formatting. */
										var extracted = propertyValue.toString().match(/alpha\(opacity=(.*)\)/i);

										if (extracted) {
											/* Convert to decimal value. */
											propertyValue = extracted[1] / 100;
										} else {
											/* When extracting opacity, default to 1 since a null value means opacity hasn't been set. */
											propertyValue = 1;
										}

										return propertyValue;
									case "inject":
										/* Opacified elements are required to have their zoom property set to a non-zero value. */
										element.style.zoom = 1;

										/* Setting the filter property on elements with certain font property combinations can result in a
										 highly unappealing ultra-bolding effect. There's no way to remedy this throughout a tween, but dropping the
										 value altogether (when opacity hits 1) at leasts ensures that the glitch is gone post-tweening. */
										if (parseFloat(propertyValue) >= 1) {
											return "";
										} else {
											/* As per the filter property's spec, convert the decimal value to a whole number and wrap the value. */
											return "alpha(opacity=" + parseInt(parseFloat(propertyValue) * 100, 10) + ")";
										}
								}
								/* With all other browsers, normalization is not required; return the same values that were passed in. */
							} else {
								switch (type) {
									case "name":
										return "opacity";
									case "extract":
										return propertyValue;
									case "inject":
										return propertyValue;
								}
							}
						}
					},
					/*****************************
					 Batched Registrations
					 *****************************/

					/* Note: Batched normalizations extend the CSS.Normalizations.registered object. */
					register: function() {

						/*****************
						 Transforms
						 *****************/

						/* Transforms are the subproperties contained by the CSS "transform" property. Transforms must undergo normalization
						 so that they can be referenced in a properties map by their individual names. */
						/* Note: When transforms are "set", they are actually assigned to a per-element transformCache. When all transform
						 setting is complete complete, CSS.flushTransformCache() must be manually called to flush the values to the DOM.
						 Transform setting is batched in this way to improve performance: the transform style only needs to be updated
						 once when multiple transform subproperties are being animated simultaneously. */
						/* Note: IE9 and Android Gingerbread have support for 2D -- but not 3D -- transforms. Since animating unsupported
						 transform properties results in the browser ignoring the *entire* transform string, we prevent these 3D values
						 from being normalized for these browsers so that tweening skips these properties altogether
						 (since it will ignore them as being unsupported by the browser.) */
						if ((!IE || IE > 9) && !Velocity.State.isGingerbread) {
							/* Note: Since the standalone CSS "perspective" property and the CSS transform "perspective" subproperty
							 share the same name, the latter is given a unique token within Velocity: "transformPerspective". */
							CSS.Lists.transformsBase = CSS.Lists.transformsBase.concat(CSS.Lists.transforms3D);
						}

						for (var i = 0; i < CSS.Lists.transformsBase.length; i++) {
							/* Wrap the dynamically generated normalization function in a new scope so that transformName's value is
							 paired with its respective function. (Otherwise, all functions would take the final for loop's transformName.) */
							(function() {
								var transformName = CSS.Lists.transformsBase[i];

								CSS.Normalizations.registered[transformName] = function(type, element, propertyValue) {
									switch (type) {
										/* The normalized property name is the parent "transform" property -- the property that is actually set in CSS. */
										case "name":
											return "transform";
											/* Transform values are cached onto a per-element transformCache object. */
										case "extract":
											/* If this transform has yet to be assigned a value, return its null value. */
											if (Data(element) === undefined$1 || Data(element).transformCache[transformName] === undefined$1) {
												/* Scale CSS.Lists.transformsBase default to 1 whereas all other transform properties default to 0. */
												return /^scale/i.test(transformName) ? 1 : 0;
												/* When transform values are set, they are wrapped in parentheses as per the CSS spec.
												 Thus, when extracting their values (for tween calculations), we strip off the parentheses. */
											}
											return Data(element).transformCache[transformName].replace(/[()]/g, "");
										case "inject":
											var invalid = false;

											/* If an individual transform property contains an unsupported unit type, the browser ignores the *entire* transform property.
											 Thus, protect users from themselves by skipping setting for transform values supplied with invalid unit types. */
											/* Switch on the base transform type; ignore the axis by removing the last letter from the transform's name. */
											switch (transformName.substr(0, transformName.length - 1)) {
												/* Whitelist unit types for each transform. */
												case "translate":
													invalid = !/(%|px|em|rem|vw|vh|\d)$/i.test(propertyValue);
													break;
													/* Since an axis-free "scale" property is supported as well, a little hack is used here to detect it by chopping off its last letter. */
												case "scal":
												case "scale":
													/* Chrome on Android has a bug in which scaled elements blur if their initial scale
													 value is below 1 (which can happen with forcefeeding). Thus, we detect a yet-unset scale property
													 and ensure that its first value is always 1. More info: http://stackoverflow.com/questions/10417890/css3-animations-with-transform-causes-blurred-elements-on-webkit/10417962#10417962 */
													if (Velocity.State.isAndroid && Data(element).transformCache[transformName] === undefined$1 && propertyValue < 1) {
														propertyValue = 1;
													}

													invalid = !/(\d)$/i.test(propertyValue);
													break;
												case "skew":
													invalid = !/(deg|\d)$/i.test(propertyValue);
													break;
												case "rotate":
													invalid = !/(deg|\d)$/i.test(propertyValue);
													break;
											}

											if (!invalid) {
												/* As per the CSS spec, wrap the value in parentheses. */
												Data(element).transformCache[transformName] = "(" + propertyValue + ")";
											}

											/* Although the value is set on the transformCache object, return the newly-updated value for the calling code to process as normal. */
											return Data(element).transformCache[transformName];
									}
								};
							})();
						}

						/*************
						 Colors
						 *************/

						/* Since Velocity only animates a single numeric value per property, color animation is achieved by hooking the individual RGBA components of CSS color properties.
						 Accordingly, color values must be normalized (e.g. "#ff0000", "red", and "rgb(255, 0, 0)" ==> "255 0 0 1") so that their components can be injected/extracted by CSS.Hooks logic. */
						for (var j = 0; j < CSS.Lists.colors.length; j++) {
							/* Wrap the dynamically generated normalization function in a new scope so that colorName's value is paired with its respective function.
							 (Otherwise, all functions would take the final for loop's colorName.) */
							(function() {
								var colorName = CSS.Lists.colors[j];

								/* Note: In IE<=8, which support rgb but not rgba, color properties are reverted to rgb by stripping off the alpha component. */
								CSS.Normalizations.registered[colorName] = function(type, element, propertyValue) {
									switch (type) {
										case "name":
											return colorName;
											/* Convert all color values into the rgb format. (Old IE can return hex values and color names instead of rgb/rgba.) */
										case "extract":
											var extracted;

											/* If the color is already in its hookable form (e.g. "255 255 255 1") due to having been previously extracted, skip extraction. */
											if (CSS.RegEx.wrappedValueAlreadyExtracted.test(propertyValue)) {
												extracted = propertyValue;
											} else {
												var converted,
														colorNames = {
															black: "rgb(0, 0, 0)",
															blue: "rgb(0, 0, 255)",
															gray: "rgb(128, 128, 128)",
															green: "rgb(0, 128, 0)",
															red: "rgb(255, 0, 0)",
															white: "rgb(255, 255, 255)"
														};

												/* Convert color names to rgb. */
												if (/^[A-z]+$/i.test(propertyValue)) {
													if (colorNames[propertyValue] !== undefined$1) {
														converted = colorNames[propertyValue];
													} else {
														/* If an unmatched color name is provided, default to black. */
														converted = colorNames.black;
													}
													/* Convert hex values to rgb. */
												} else if (CSS.RegEx.isHex.test(propertyValue)) {
													converted = "rgb(" + CSS.Values.hexToRgb(propertyValue).join(" ") + ")";
													/* If the provided color doesn't match any of the accepted color formats, default to black. */
												} else if (!(/^rgba?\(/i.test(propertyValue))) {
													converted = colorNames.black;
												}

												/* Remove the surrounding "rgb/rgba()" string then replace commas with spaces and strip
												 repeated spaces (in case the value included spaces to begin with). */
												extracted = (converted || propertyValue).toString().match(CSS.RegEx.valueUnwrap)[1].replace(/,(\s+)?/g, " ");
											}

											/* So long as this isn't <=IE8, add a fourth (alpha) component if it's missing and default it to 1 (visible). */
											if ((!IE || IE > 8) && extracted.split(" ").length === 3) {
												extracted += " 1";
											}

											return extracted;
										case "inject":
											/* If we have a pattern then it might already have the right values */
											if (/^rgb/.test(propertyValue)) {
												return propertyValue;
											}

											/* If this is IE<=8 and an alpha component exists, strip it off. */
											if (IE <= 8) {
												if (propertyValue.split(" ").length === 4) {
													propertyValue = propertyValue.split(/\s+/).slice(0, 3).join(" ");
												}
												/* Otherwise, add a fourth (alpha) component if it's missing and default it to 1 (visible). */
											} else if (propertyValue.split(" ").length === 3) {
												propertyValue += " 1";
											}

											/* Re-insert the browser-appropriate wrapper("rgb/rgba()"), insert commas, and strip off decimal units
											 on all values but the fourth (R, G, and B only accept whole numbers). */
											return (IE <= 8 ? "rgb" : "rgba") + "(" + propertyValue.replace(/\s+/g, ",").replace(/\.(\d)+(?=,)/g, "") + ")";
									}
								};
							})();
						}

						/**************
						 Dimensions
						 **************/
						function augmentDimension(name, element, wantInner) {
							var isBorderBox = CSS.getPropertyValue(element, "boxSizing").toString().toLowerCase() === "border-box";

							if (isBorderBox === (wantInner || false)) {
								/* in box-sizing mode, the CSS width / height accessors already give the outerWidth / outerHeight. */
								var i,
										value,
										augment = 0,
										sides = name === "width" ? ["Left", "Right"] : ["Top", "Bottom"],
										fields = ["padding" + sides[0], "padding" + sides[1], "border" + sides[0] + "Width", "border" + sides[1] + "Width"];

								for (i = 0; i < fields.length; i++) {
									value = parseFloat(CSS.getPropertyValue(element, fields[i]));
									if (!isNaN(value)) {
										augment += value;
									}
								}
								return wantInner ? -augment : augment;
							}
							return 0;
						}
						function getDimension(name, wantInner) {
							return function(type, element, propertyValue) {
								switch (type) {
									case "name":
										return name;
									case "extract":
										return parseFloat(propertyValue) + augmentDimension(name, element, wantInner);
									case "inject":
										return (parseFloat(propertyValue) - augmentDimension(name, element, wantInner)) + "px";
								}
							};
						}
						CSS.Normalizations.registered.innerWidth = getDimension("width", true);
						CSS.Normalizations.registered.innerHeight = getDimension("height", true);
						CSS.Normalizations.registered.outerWidth = getDimension("width");
						CSS.Normalizations.registered.outerHeight = getDimension("height");
					}
				},
				/************************
				 CSS Property Names
				 ************************/

				Names: {
					/* Camelcase a property name into its JavaScript notation (e.g. "background-color" ==> "backgroundColor").
					 Camelcasing is used to normalize property names between and across calls. */
					camelCase: function(property) {
						return property.replace(/-(\w)/g, function(match, subMatch) {
							return subMatch.toUpperCase();
						});
					},
					/* For SVG elements, some properties (namely, dimensional ones) are GET/SET via the element's HTML attributes (instead of via CSS styles). */
					SVGAttribute: function(property) {
						var SVGAttributes = "width|height|x|y|cx|cy|r|rx|ry|x1|x2|y1|y2";

						/* Certain browsers require an SVG transform to be applied as an attribute. (Otherwise, application via CSS is preferable due to 3D support.) */
						if (IE || (Velocity.State.isAndroid && !Velocity.State.isChrome)) {
							SVGAttributes += "|transform";
						}

						return new RegExp("^(" + SVGAttributes + ")$", "i").test(property);
					},
					/* Determine whether a property should be set with a vendor prefix. */
					/* If a prefixed version of the property exists, return it. Otherwise, return the original property name.
					 If the property is not at all supported by the browser, return a false flag. */
					prefixCheck: function(property) {
						/* If this property has already been checked, return the cached value. */
						if (Velocity.State.prefixMatches[property]) {
							return [Velocity.State.prefixMatches[property], true];
						} else {
							var vendors = ["", "Webkit", "Moz", "ms", "O"];

							for (var i = 0, vendorsLength = vendors.length; i < vendorsLength; i++) {
								var propertyPrefixed;

								if (i === 0) {
									propertyPrefixed = property;
								} else {
									/* Capitalize the first letter of the property to conform to JavaScript vendor prefix notation (e.g. webkitFilter). */
									propertyPrefixed = vendors[i] + property.replace(/^\w/, function(match) {
										return match.toUpperCase();
									});
								}

								/* Check if the browser supports this property as prefixed. */
								if (Type.isString(Velocity.State.prefixElement.style[propertyPrefixed])) {
									/* Cache the match. */
									Velocity.State.prefixMatches[property] = propertyPrefixed;

									return [propertyPrefixed, true];
								}
							}

							/* If the browser doesn't support this property in any form, include a false flag so that the caller can decide how to proceed. */
							return [property, false];
						}
					}
				},
				/************************
				 CSS Property Values
				 ************************/

				Values: {
					/* Hex to RGB conversion. Copyright Tim Down: http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb */
					hexToRgb: function(hex) {
						var shortformRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
								longformRegex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,
								rgbParts;

						hex = hex.replace(shortformRegex, function(m, r, g, b) {
							return r + r + g + g + b + b;
						});

						rgbParts = longformRegex.exec(hex);

						return rgbParts ? [parseInt(rgbParts[1], 16), parseInt(rgbParts[2], 16), parseInt(rgbParts[3], 16)] : [0, 0, 0];
					},
					isCSSNullValue: function(value) {
						/* The browser defaults CSS values that have not been set to either 0 or one of several possible null-value strings.
						 Thus, we check for both falsiness and these special strings. */
						/* Null-value checking is performed to default the special strings to 0 (for the sake of tweening) or their hook
						 templates as defined as CSS.Hooks (for the sake of hook injection/extraction). */
						/* Note: Chrome returns "rgba(0, 0, 0, 0)" for an undefined color whereas IE returns "transparent". */
						return (!value || /^(none|auto|transparent|(rgba\(0, ?0, ?0, ?0\)))$/i.test(value));
					},
					/* Retrieve a property's default unit type. Used for assigning a unit type when one is not supplied by the user. */
					getUnitType: function(property) {
						if (/^(rotate|skew)/i.test(property)) {
							return "deg";
						} else if (/(^(scale|scaleX|scaleY|scaleZ|alpha|flexGrow|flexHeight|zIndex|fontWeight)$)|((opacity|red|green|blue|alpha)$)/i.test(property)) {
							/* The above properties are unitless. */
							return "";
						} else {
							/* Default to px for all other properties. */
							return "px";
						}
					},
					/* HTML elements default to an associated display type when they're not set to display:none. */
					/* Note: This function is used for correctly setting the non-"none" display value in certain Velocity redirects, such as fadeIn/Out. */
					getDisplayType: function(element) {
						var tagName = element && element.tagName.toString().toLowerCase();

						if (/^(b|big|i|small|tt|abbr|acronym|cite|code|dfn|em|kbd|strong|samp|var|a|bdo|br|img|map|object|q|script|span|sub|sup|button|input|label|select|textarea)$/i.test(tagName)) {
							return "inline";
						} else if (/^(li)$/i.test(tagName)) {
							return "list-item";
						} else if (/^(tr)$/i.test(tagName)) {
							return "table-row";
						} else if (/^(table)$/i.test(tagName)) {
							return "table";
						} else if (/^(tbody)$/i.test(tagName)) {
							return "table-row-group";
							/* Default to "block" when no match is found. */
						} else {
							return "block";
						}
					},
					/* The class add/remove functions are used to temporarily apply a "velocity-animating" class to elements while they're animating. */
					addClass: function(element, className) {
						if (element) {
							if (element.classList) {
								element.classList.add(className);
							} else if (Type.isString(element.className)) {
								// Element.className is around 15% faster then set/getAttribute
								element.className += (element.className.length ? " " : "") + className;
							} else {
								// Work around for IE strict mode animating SVG - and anything else that doesn't behave correctly - the same way jQuery does it
								var currentClass = element.getAttribute(IE <= 7 ? "className" : "class") || "";

								element.setAttribute("class", currentClass + (currentClass ? " " : "") + className);
							}
						}
					},
					removeClass: function(element, className) {
						if (element) {
							if (element.classList) {
								element.classList.remove(className);
							} else if (Type.isString(element.className)) {
								// Element.className is around 15% faster then set/getAttribute
								// TODO: Need some jsperf tests on performance - can we get rid of the regex and maybe use split / array manipulation?
								element.className = element.className.toString().replace(new RegExp("(^|\\s)" + className.split(" ").join("|") + "(\\s|$)", "gi"), " ");
							} else {
								// Work around for IE strict mode animating SVG - and anything else that doesn't behave correctly - the same way jQuery does it
								var currentClass = element.getAttribute(IE <= 7 ? "className" : "class") || "";

								element.setAttribute("class", currentClass.replace(new RegExp("(^|\s)" + className.split(" ").join("|") + "(\s|$)", "gi"), " "));
							}
						}
					}
				},
				/****************************
				 Style Getting & Setting
				 ****************************/

				/* The singular getPropertyValue, which routes the logic for all normalizations, hooks, and standard CSS properties. */
				getPropertyValue: function(element, property, rootPropertyValue, forceStyleLookup) {
					/* Get an element's computed property value. */
					/* Note: Retrieving the value of a CSS property cannot simply be performed by checking an element's
					 style attribute (which only reflects user-defined values). Instead, the browser must be queried for a property's
					 *computed* value. You can read more about getComputedStyle here: https://developer.mozilla.org/en/docs/Web/API/window.getComputedStyle */
					function computePropertyValue(element, property) {
						/* When box-sizing isn't set to border-box, height and width style values are incorrectly computed when an
						 element's scrollbars are visible (which expands the element's dimensions). Thus, we defer to the more accurate
						 offsetHeight/Width property, which includes the total dimensions for interior, border, padding, and scrollbar.
						 We subtract border and padding to get the sum of interior + scrollbar. */
						var computedValue = 0;

						/* IE<=8 doesn't support window.getComputedStyle, thus we defer to jQuery, which has an extensive array
						 of hacks to accurately retrieve IE8 property values. Re-implementing that logic here is not worth bloating the
						 codebase for a dying browser. The performance repercussions of using jQuery here are minimal since
						 Velocity is optimized to rarely (and sometimes never) query the DOM. Further, the $.css() codepath isn't that slow. */
						if (IE <= 8) {
							computedValue = $.css(element, property); /* GET */
							/* All other browsers support getComputedStyle. The returned live object reference is cached onto its
							 associated element so that it does not need to be refetched upon every GET. */
						} else {
							/* Browsers do not return height and width values for elements that are set to display:"none". Thus, we temporarily
							 toggle display to the element type's default value. */
							var toggleDisplay = false;

							if (/^(width|height)$/.test(property) && CSS.getPropertyValue(element, "display") === 0) {
								toggleDisplay = true;
								CSS.setPropertyValue(element, "display", CSS.Values.getDisplayType(element));
							}

							var revertDisplay = function() {
								if (toggleDisplay) {
									CSS.setPropertyValue(element, "display", "none");
								}
							};

							if (!forceStyleLookup) {
								if (property === "height" && CSS.getPropertyValue(element, "boxSizing").toString().toLowerCase() !== "border-box") {
									var contentBoxHeight = element.offsetHeight - (parseFloat(CSS.getPropertyValue(element, "borderTopWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "borderBottomWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingTop")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingBottom")) || 0);
									revertDisplay();

									return contentBoxHeight;
								} else if (property === "width" && CSS.getPropertyValue(element, "boxSizing").toString().toLowerCase() !== "border-box") {
									var contentBoxWidth = element.offsetWidth - (parseFloat(CSS.getPropertyValue(element, "borderLeftWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "borderRightWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingLeft")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingRight")) || 0);
									revertDisplay();

									return contentBoxWidth;
								}
							}

							var computedStyle;

							/* For elements that Velocity hasn't been called on directly (e.g. when Velocity queries the DOM on behalf
							 of a parent of an element its animating), perform a direct getComputedStyle lookup since the object isn't cached. */
							if (Data(element) === undefined$1) {
								computedStyle = window.getComputedStyle(element, null); /* GET */
								/* If the computedStyle object has yet to be cached, do so now. */
							} else if (!Data(element).computedStyle) {
								computedStyle = Data(element).computedStyle = window.getComputedStyle(element, null); /* GET */
								/* If computedStyle is cached, use it. */
							} else {
								computedStyle = Data(element).computedStyle;
							}

							/* IE and Firefox do not return a value for the generic borderColor -- they only return individual values for each border side's color.
							 Also, in all browsers, when border colors aren't all the same, a compound value is returned that Velocity isn't setup to parse.
							 So, as a polyfill for querying individual border side colors, we just return the top border's color and animate all borders from that value. */
							if (property === "borderColor") {
								property = "borderTopColor";
							}

							/* IE9 has a bug in which the "filter" property must be accessed from computedStyle using the getPropertyValue method
							 instead of a direct property lookup. The getPropertyValue method is slower than a direct lookup, which is why we avoid it by default. */
							if (IE === 9 && property === "filter") {
								computedValue = computedStyle.getPropertyValue(property); /* GET */
							} else {
								computedValue = computedStyle[property];
							}

							/* Fall back to the property's style value (if defined) when computedValue returns nothing,
							 which can happen when the element hasn't been painted. */
							if (computedValue === "" || computedValue === null) {
								computedValue = element.style[property];
							}

							revertDisplay();
						}

						/* For top, right, bottom, and left (TRBL) values that are set to "auto" on elements of "fixed" or "absolute" position,
						 defer to jQuery for converting "auto" to a numeric value. (For elements with a "static" or "relative" position, "auto" has the same
						 effect as being set to 0, so no conversion is necessary.) */
						/* An example of why numeric conversion is necessary: When an element with "position:absolute" has an untouched "left"
						 property, which reverts to "auto", left's value is 0 relative to its parent element, but is often non-zero relative
						 to its *containing* (not parent) element, which is the nearest "position:relative" ancestor or the viewport (and always the viewport in the case of "position:fixed"). */
						if (computedValue === "auto" && /^(top|right|bottom|left)$/i.test(property)) {
							var position = computePropertyValue(element, "position"); /* GET */

							/* For absolute positioning, jQuery's $.position() only returns values for top and left;
							 right and bottom will have their "auto" value reverted to 0. */
							/* Note: A jQuery object must be created here since jQuery doesn't have a low-level alias for $.position().
							 Not a big deal since we're currently in a GET batch anyway. */
							if (position === "fixed" || (position === "absolute" && /top|left/i.test(property))) {
								/* Note: jQuery strips the pixel unit from its returned values; we re-add it here to conform with computePropertyValue's behavior. */
								computedValue = $(element).position()[property] + "px"; /* GET */
							}
						}

						return computedValue;
					}

					var propertyValue;

					/* If this is a hooked property (e.g. "clipLeft" instead of the root property of "clip"),
					 extract the hook's value from a normalized rootPropertyValue using CSS.Hooks.extractValue(). */
					if (CSS.Hooks.registered[property]) {
						var hook = property,
								hookRoot = CSS.Hooks.getRoot(hook);

						/* If a cached rootPropertyValue wasn't passed in (which Velocity always attempts to do in order to avoid requerying the DOM),
						 query the DOM for the root property's value. */
						if (rootPropertyValue === undefined$1) {
							/* Since the browser is now being directly queried, use the official post-prefixing property name for this lookup. */
							rootPropertyValue = CSS.getPropertyValue(element, CSS.Names.prefixCheck(hookRoot)[0]); /* GET */
						}

						/* If this root has a normalization registered, peform the associated normalization extraction. */
						if (CSS.Normalizations.registered[hookRoot]) {
							rootPropertyValue = CSS.Normalizations.registered[hookRoot]("extract", element, rootPropertyValue);
						}

						/* Extract the hook's value. */
						propertyValue = CSS.Hooks.extractValue(hook, rootPropertyValue);

						/* If this is a normalized property (e.g. "opacity" becomes "filter" in <=IE8) or "translateX" becomes "transform"),
						 normalize the property's name and value, and handle the special case of transforms. */
						/* Note: Normalizing a property is mutually exclusive from hooking a property since hook-extracted values are strictly
						 numerical and therefore do not require normalization extraction. */
					} else if (CSS.Normalizations.registered[property]) {
						var normalizedPropertyName,
								normalizedPropertyValue;

						normalizedPropertyName = CSS.Normalizations.registered[property]("name", element);

						/* Transform values are calculated via normalization extraction (see below), which checks against the element's transformCache.
						 At no point do transform GETs ever actually query the DOM; initial stylesheet values are never processed.
						 This is because parsing 3D transform matrices is not always accurate and would bloat our codebase;
						 thus, normalization extraction defaults initial transform values to their zero-values (e.g. 1 for scaleX and 0 for translateX). */
						if (normalizedPropertyName !== "transform") {
							normalizedPropertyValue = computePropertyValue(element, CSS.Names.prefixCheck(normalizedPropertyName)[0]); /* GET */

							/* If the value is a CSS null-value and this property has a hook template, use that zero-value template so that hooks can be extracted from it. */
							if (CSS.Values.isCSSNullValue(normalizedPropertyValue) && CSS.Hooks.templates[property]) {
								normalizedPropertyValue = CSS.Hooks.templates[property][1];
							}
						}

						propertyValue = CSS.Normalizations.registered[property]("extract", element, normalizedPropertyValue);
					}

					/* If a (numeric) value wasn't produced via hook extraction or normalization, query the DOM. */
					if (!/^[\d-]/.test(propertyValue)) {
						/* For SVG elements, dimensional properties (which SVGAttribute() detects) are tweened via
						 their HTML attribute values instead of their CSS style values. */
						var data = Data(element);

						if (data && data.isSVG && CSS.Names.SVGAttribute(property)) {
							/* Since the height/width attribute values must be set manually, they don't reflect computed values.
							 Thus, we use use getBBox() to ensure we always get values for elements with undefined height/width attributes. */
							if (/^(height|width)$/i.test(property)) {
								/* Firefox throws an error if .getBBox() is called on an SVG that isn't attached to the DOM. */
								try {
									propertyValue = element.getBBox()[property];
								} catch (error) {
									propertyValue = 0;
								}
								/* Otherwise, access the attribute value directly. */
							} else {
								propertyValue = element.getAttribute(property);
							}
						} else {
							propertyValue = computePropertyValue(element, CSS.Names.prefixCheck(property)[0]); /* GET */
						}
					}

					/* Since property lookups are for animation purposes (which entails computing the numeric delta between start and end values),
					 convert CSS null-values to an integer of value 0. */
					if (CSS.Values.isCSSNullValue(propertyValue)) {
						propertyValue = 0;
					}

					if (Velocity.debug >= 2) {
						console.log("Get " + property + ": " + propertyValue);
					}

					return propertyValue;
				},
				/* The singular setPropertyValue, which routes the logic for all normalizations, hooks, and standard CSS properties. */
				setPropertyValue: function(element, property, propertyValue, rootPropertyValue, scrollData) {
					var propertyName = property;

					/* In order to be subjected to call options and element queueing, scroll animation is routed through Velocity as if it were a standard CSS property. */
					if (property === "scroll") {
						/* If a container option is present, scroll the container instead of the browser window. */
						if (scrollData.container) {
							scrollData.container["scroll" + scrollData.direction] = propertyValue;
							/* Otherwise, Velocity defaults to scrolling the browser window. */
						} else {
							if (scrollData.direction === "Left") {
								window.scrollTo(propertyValue, scrollData.alternateValue);
							} else {
								window.scrollTo(scrollData.alternateValue, propertyValue);
							}
						}
					} else {
						/* Transforms (translateX, rotateZ, etc.) are applied to a per-element transformCache object, which is manually flushed via flushTransformCache().
						 Thus, for now, we merely cache transforms being SET. */
						if (CSS.Normalizations.registered[property] && CSS.Normalizations.registered[property]("name", element) === "transform") {
							/* Perform a normalization injection. */
							/* Note: The normalization logic handles the transformCache updating. */
							CSS.Normalizations.registered[property]("inject", element, propertyValue);

							propertyName = "transform";
							propertyValue = Data(element).transformCache[property];
						} else {
							/* Inject hooks. */
							if (CSS.Hooks.registered[property]) {
								var hookName = property,
										hookRoot = CSS.Hooks.getRoot(property);

								/* If a cached rootPropertyValue was not provided, query the DOM for the hookRoot's current value. */
								rootPropertyValue = rootPropertyValue || CSS.getPropertyValue(element, hookRoot); /* GET */

								propertyValue = CSS.Hooks.injectValue(hookName, propertyValue, rootPropertyValue);
								property = hookRoot;
							}

							/* Normalize names and values. */
							if (CSS.Normalizations.registered[property]) {
								propertyValue = CSS.Normalizations.registered[property]("inject", element, propertyValue);
								property = CSS.Normalizations.registered[property]("name", element);
							}

							/* Assign the appropriate vendor prefix before performing an official style update. */
							propertyName = CSS.Names.prefixCheck(property)[0];

							/* A try/catch is used for IE<=8, which throws an error when "invalid" CSS values are set, e.g. a negative width.
							 Try/catch is avoided for other browsers since it incurs a performance overhead. */
							if (IE <= 8) {
								try {
									element.style[propertyName] = propertyValue;
								} catch (error) {
									if (Velocity.debug) {
										console.log("Browser does not support [" + propertyValue + "] for [" + propertyName + "]");
									}
								}
								/* SVG elements have their dimensional properties (width, height, x, y, cx, etc.) applied directly as attributes instead of as styles. */
								/* Note: IE8 does not support SVG elements, so it's okay that we skip it for SVG animation. */
							} else {
								var data = Data(element);

								if (data && data.isSVG && CSS.Names.SVGAttribute(property)) {
									/* Note: For SVG attributes, vendor-prefixed property names are never used. */
									/* Note: Not all CSS properties can be animated via attributes, but the browser won't throw an error for unsupported properties. */
									element.setAttribute(property, propertyValue);
								} else {
									element.style[propertyName] = propertyValue;
								}
							}

							if (Velocity.debug >= 2) {
								console.log("Set " + property + " (" + propertyName + "): " + propertyValue);
							}
						}
					}

					/* Return the normalized property name and value in case the caller wants to know how these values were modified before being applied to the DOM. */
					return [propertyName, propertyValue];
				},
				/* To increase performance by batching transform updates into a single SET, transforms are not directly applied to an element until flushTransformCache() is called. */
				/* Note: Velocity applies transform properties in the same order that they are chronogically introduced to the element's CSS styles. */
				flushTransformCache: function(element) {
					var transformString = "",
							data = Data(element);

					/* Certain browsers require that SVG transforms be applied as an attribute. However, the SVG transform attribute takes a modified version of CSS's transform string
					 (units are dropped and, except for skewX/Y, subproperties are merged into their master property -- e.g. scaleX and scaleY are merged into scale(X Y). */
					if ((IE || (Velocity.State.isAndroid && !Velocity.State.isChrome)) && data && data.isSVG) {
						/* Since transform values are stored in their parentheses-wrapped form, we use a helper function to strip out their numeric values.
						 Further, SVG transform properties only take unitless (representing pixels) values, so it's okay that parseFloat() strips the unit suffixed to the float value. */
						var getTransformFloat = function(transformProperty) {
							return parseFloat(CSS.getPropertyValue(element, transformProperty));
						};

						/* Create an object to organize all the transforms that we'll apply to the SVG element. To keep the logic simple,
						 we process *all* transform properties -- even those that may not be explicitly applied (since they default to their zero-values anyway). */
						var SVGTransforms = {
							translate: [getTransformFloat("translateX"), getTransformFloat("translateY")],
							skewX: [getTransformFloat("skewX")], skewY: [getTransformFloat("skewY")],
							/* If the scale property is set (non-1), use that value for the scaleX and scaleY values
							 (this behavior mimics the result of animating all these properties at once on HTML elements). */
							scale: getTransformFloat("scale") !== 1 ? [getTransformFloat("scale"), getTransformFloat("scale")] : [getTransformFloat("scaleX"), getTransformFloat("scaleY")],
							/* Note: SVG's rotate transform takes three values: rotation degrees followed by the X and Y values
							 defining the rotation's origin point. We ignore the origin values (default them to 0). */
							rotate: [getTransformFloat("rotateZ"), 0, 0]
						};

						/* Iterate through the transform properties in the user-defined property map order.
						 (This mimics the behavior of non-SVG transform animation.) */
						$.each(Data(element).transformCache, function(transformName) {
							/* Except for with skewX/Y, revert the axis-specific transform subproperties to their axis-free master
							 properties so that they match up with SVG's accepted transform properties. */
							if (/^translate/i.test(transformName)) {
								transformName = "translate";
							} else if (/^scale/i.test(transformName)) {
								transformName = "scale";
							} else if (/^rotate/i.test(transformName)) {
								transformName = "rotate";
							}

							/* Check that we haven't yet deleted the property from the SVGTransforms container. */
							if (SVGTransforms[transformName]) {
								/* Append the transform property in the SVG-supported transform format. As per the spec, surround the space-delimited values in parentheses. */
								transformString += transformName + "(" + SVGTransforms[transformName].join(" ") + ")" + " ";

								/* After processing an SVG transform property, delete it from the SVGTransforms container so we don't
								 re-insert the same master property if we encounter another one of its axis-specific properties. */
								delete SVGTransforms[transformName];
							}
						});
					} else {
						var transformValue,
								perspective;

						/* Transform properties are stored as members of the transformCache object. Concatenate all the members into a string. */
						$.each(Data(element).transformCache, function(transformName) {
							transformValue = Data(element).transformCache[transformName];

							/* Transform's perspective subproperty must be set first in order to take effect. Store it temporarily. */
							if (transformName === "transformPerspective") {
								perspective = transformValue;
								return true;
							}

							/* IE9 only supports one rotation type, rotateZ, which it refers to as "rotate". */
							if (IE === 9 && transformName === "rotateZ") {
								transformName = "rotate";
							}

							transformString += transformName + transformValue + " ";
						});

						/* If present, set the perspective subproperty first. */
						if (perspective) {
							transformString = "perspective" + perspective + " " + transformString;
						}
					}

					CSS.setPropertyValue(element, "transform", transformString);
				}
			};

			/* Register hooks and normalizations. */
			CSS.Hooks.register();
			CSS.Normalizations.register();

			/* Allow hook setting in the same fashion as jQuery's $.css(). */
			Velocity.hook = function(elements, arg2, arg3) {
				var value;

				elements = sanitizeElements(elements);

				$.each(elements, function(i, element) {
					/* Initialize Velocity's per-element data cache if this element hasn't previously been animated. */
					if (Data(element) === undefined$1) {
						Velocity.init(element);
					}

					/* Get property value. If an element set was passed in, only return the value for the first element. */
					if (arg3 === undefined$1) {
						if (value === undefined$1) {
							value = CSS.getPropertyValue(element, arg2);
						}
						/* Set property value. */
					} else {
						/* sPV returns an array of the normalized propertyName/propertyValue pair used to update the DOM. */
						var adjustedSet = CSS.setPropertyValue(element, arg2, arg3);

						/* Transform properties don't automatically set. They have to be flushed to the DOM. */
						if (adjustedSet[0] === "transform") {
							Velocity.CSS.flushTransformCache(element);
						}

						value = adjustedSet;
					}
				});

				return value;
			};

			/*****************
			 Animation
			 *****************/

			var animate = function() {
				var opts;

				/******************
				 Call Chain
				 ******************/

				/* Logic for determining what to return to the call stack when exiting out of Velocity. */
				function getChain() {
					/* If we are using the utility function, attempt to return this call's promise. If no promise library was detected,
					 default to null instead of returning the targeted elements so that utility function's return value is standardized. */
					if (isUtility) {
						return promiseData.promise || null;
						/* Otherwise, if we're using $.fn, return the jQuery-/Zepto-wrapped element set. */
					} else {
						return elementsWrapped;
					}
				}

				/*************************
				 Arguments Assignment
				 *************************/

				/* To allow for expressive CoffeeScript code, Velocity supports an alternative syntax in which "elements" (or "e"), "properties" (or "p"), and "options" (or "o")
				 objects are defined on a container object that's passed in as Velocity's sole argument. */
				/* Note: Some browsers automatically populate arguments with a "properties" object. We detect it by checking for its default "names" property. */
				var syntacticSugar = (arguments[0] && (arguments[0].p || (($.isPlainObject(arguments[0].properties) && !arguments[0].properties.names) || Type.isString(arguments[0].properties)))),
						/* Whether Velocity was called via the utility function (as opposed to on a jQuery/Zepto object). */
						isUtility,
						/* When Velocity is called via the utility function ($.Velocity()/Velocity()), elements are explicitly
						 passed in as the first parameter. Thus, argument positioning varies. We normalize them here. */
						elementsWrapped,
						argumentIndex;

				var elements,
						propertiesMap,
						options;

				/* Detect jQuery/Zepto elements being animated via the $.fn method. */
				if (Type.isWrapped(this)) {
					isUtility = false;

					argumentIndex = 0;
					elements = this;
					elementsWrapped = this;
					/* Otherwise, raw elements are being animated via the utility function. */
				} else {
					isUtility = true;

					argumentIndex = 1;
					elements = syntacticSugar ? (arguments[0].elements || arguments[0].e) : arguments[0];
				}

				/***************
				 Promises
				 ***************/

				var promiseData = {
					promise: null,
					resolver: null,
					rejecter: null
				};

				/* If this call was made via the utility function (which is the default method of invocation when jQuery/Zepto are not being used), and if
				 promise support was detected, create a promise object for this call and store references to its resolver and rejecter methods. The resolve
				 method is used when a call completes naturally or is prematurely stopped by the user. In both cases, completeCall() handles the associated
				 call cleanup and promise resolving logic. The reject method is used when an invalid set of arguments is passed into a Velocity call. */
				/* Note: Velocity employs a call-based queueing architecture, which means that stopping an animating element actually stops the full call that
				 triggered it -- not that one element exclusively. Similarly, there is one promise per call, and all elements targeted by a Velocity call are
				 grouped together for the purposes of resolving and rejecting a promise. */
				if (isUtility && Velocity.Promise) {
					promiseData.promise = new Velocity.Promise(function(resolve, reject) {
						promiseData.resolver = resolve;
						promiseData.rejecter = reject;
					});
				}

				if (syntacticSugar) {
					propertiesMap = arguments[0].properties || arguments[0].p;
					options = arguments[0].options || arguments[0].o;
				} else {
					propertiesMap = arguments[argumentIndex];
					options = arguments[argumentIndex + 1];
				}

				elements = sanitizeElements(elements);

				if (!elements) {
					if (promiseData.promise) {
						if (!propertiesMap || !options || options.promiseRejectEmpty !== false) {
							promiseData.rejecter();
						} else {
							promiseData.resolver();
						}
					}
					return;
				}

				/* The length of the element set (in the form of a nodeList or an array of elements) is defaulted to 1 in case a
				 single raw DOM element is passed in (which doesn't contain a length property). */
				var elementsLength = elements.length,
						elementsIndex = 0;

				/***************************
				 Argument Overloading
				 ***************************/

				/* Support is included for jQuery's argument overloading: $.animate(propertyMap [, duration] [, easing] [, complete]).
				 Overloading is detected by checking for the absence of an object being passed into options. */
				/* Note: The stop/finish/pause/resume actions do not accept animation options, and are therefore excluded from this check. */
				if (!/^(stop|finish|finishAll|pause|resume)$/i.test(propertiesMap) && !$.isPlainObject(options)) {
					/* The utility function shifts all arguments one position to the right, so we adjust for that offset. */
					var startingArgumentPosition = argumentIndex + 1;

					options = {};

					/* Iterate through all options arguments */
					for (var i = startingArgumentPosition; i < arguments.length; i++) {
						/* Treat a number as a duration. Parse it out. */
						/* Note: The following RegEx will return true if passed an array with a number as its first item.
						 Thus, arrays are skipped from this check. */
						if (!Type.isArray(arguments[i]) && (/^(fast|normal|slow)$/i.test(arguments[i]) || /^\d/.test(arguments[i]))) {
							options.duration = arguments[i];
							/* Treat strings and arrays as easings. */
						} else if (Type.isString(arguments[i]) || Type.isArray(arguments[i])) {
							options.easing = arguments[i];
							/* Treat a function as a complete callback. */
						} else if (Type.isFunction(arguments[i])) {
							options.complete = arguments[i];
						}
					}
				}

				/*********************
				 Action Detection
				 *********************/

				/* Velocity's behavior is categorized into "actions": Elements can either be specially scrolled into view,
				 or they can be started, stopped, paused, resumed, or reversed . If a literal or referenced properties map is passed in as Velocity's
				 first argument, the associated action is "start". Alternatively, "scroll", "reverse", "pause", "resume" or "stop" can be passed in 
				 instead of a properties map. */
				var action;

				switch (propertiesMap) {
					case "scroll":
						action = "scroll";
						break;

					case "reverse":
						action = "reverse";
						break;

					case "pause":

						/*******************
						 Action: Pause
						 *******************/

						var currentTime = (new Date()).getTime();

						/* Handle delay timers */
						$.each(elements, function(i, element) {
							pauseDelayOnElement(element, currentTime);
						});

						/* Pause and Resume are call-wide (not on a per element basis). Thus, calling pause or resume on a 
						 single element will cause any calls that containt tweens for that element to be paused/resumed
						 as well. */

						/* Iterate through all calls and pause any that contain any of our elements */
						$.each(Velocity.State.calls, function(i, activeCall) {

							var found = false;
							/* Inactive calls are set to false by the logic inside completeCall(). Skip them. */
							if (activeCall) {
								/* Iterate through the active call's targeted elements. */
								$.each(activeCall[1], function(k, activeElement) {
									var queueName = (options === undefined$1) ? "" : options;

									if (queueName !== true && (activeCall[2].queue !== queueName) && !(options === undefined$1 && activeCall[2].queue === false)) {
										return true;
									}

									/* Iterate through the calls targeted by the stop command. */
									$.each(elements, function(l, element) {
										/* Check that this call was applied to the target element. */
										if (element === activeElement) {

											/* Set call to paused */
											activeCall[5] = {
												resume: false
											};

											/* Once we match an element, we can bounce out to the next call entirely */
											found = true;
											return false;
										}
									});

									/* Proceed to check next call if we have already matched */
									if (found) {
										return false;
									}
								});
							}

						});

						/* Since pause creates no new tweens, exit out of Velocity. */
						return getChain();

					case "resume":

						/*******************
						 Action: Resume
						 *******************/

						/* Handle delay timers */
						$.each(elements, function(i, element) {
							resumeDelayOnElement(element);
						});

						/* Pause and Resume are call-wide (not on a per elemnt basis). Thus, calling pause or resume on a 
						 single element will cause any calls that containt tweens for that element to be paused/resumed
						 as well. */

						/* Iterate through all calls and pause any that contain any of our elements */
						$.each(Velocity.State.calls, function(i, activeCall) {
							var found = false;
							/* Inactive calls are set to false by the logic inside completeCall(). Skip them. */
							if (activeCall) {
								/* Iterate through the active call's targeted elements. */
								$.each(activeCall[1], function(k, activeElement) {
									var queueName = (options === undefined$1) ? "" : options;

									if (queueName !== true && (activeCall[2].queue !== queueName) && !(options === undefined$1 && activeCall[2].queue === false)) {
										return true;
									}

									/* Skip any calls that have never been paused */
									if (!activeCall[5]) {
										return true;
									}

									/* Iterate through the calls targeted by the stop command. */
									$.each(elements, function(l, element) {
										/* Check that this call was applied to the target element. */
										if (element === activeElement) {

											/* Flag a pause object to be resumed, which will occur during the next tick. In
											 addition, the pause object will at that time be deleted */
											activeCall[5].resume = true;

											/* Once we match an element, we can bounce out to the next call entirely */
											found = true;
											return false;
										}
									});

									/* Proceed to check next call if we have already matched */
									if (found) {
										return false;
									}
								});
							}

						});

						/* Since resume creates no new tweens, exit out of Velocity. */
						return getChain();

					case "finish":
					case "finishAll":
					case "stop":
						/*******************
						 Action: Stop
						 *******************/

						/* Clear the currently-active delay on each targeted element. */
						$.each(elements, function(i, element) {
							if (Data(element) && Data(element).delayTimer) {
								/* Stop the timer from triggering its cached next() function. */
								clearTimeout(Data(element).delayTimer.setTimeout);

								/* Manually call the next() function so that the subsequent queue items can progress. */
								if (Data(element).delayTimer.next) {
									Data(element).delayTimer.next();
								}

								delete Data(element).delayTimer;
							}

							/* If we want to finish everything in the queue, we have to iterate through it
							 and call each function. This will make them active calls below, which will
							 cause them to be applied via the duration setting. */
							if (propertiesMap === "finishAll" && (options === true || Type.isString(options))) {
								/* Iterate through the items in the element's queue. */
								$.each($.queue(element, Type.isString(options) ? options : ""), function(_, item) {
									/* The queue array can contain an "inprogress" string, which we skip. */
									if (Type.isFunction(item)) {
										item();
									}
								});

								/* Clearing the $.queue() array is achieved by resetting it to []. */
								$.queue(element, Type.isString(options) ? options : "", []);
							}
						});

						var callsToStop = [];

						/* When the stop action is triggered, the elements' currently active call is immediately stopped. The active call might have
						 been applied to multiple elements, in which case all of the call's elements will be stopped. When an element
						 is stopped, the next item in its animation queue is immediately triggered. */
						/* An additional argument may be passed in to clear an element's remaining queued calls. Either true (which defaults to the "fx" queue)
						 or a custom queue string can be passed in. */
						/* Note: The stop command runs prior to Velocity's Queueing phase since its behavior is intended to take effect *immediately*,
						 regardless of the element's current queue state. */

						/* Iterate through every active call. */
						$.each(Velocity.State.calls, function(i, activeCall) {
							/* Inactive calls are set to false by the logic inside completeCall(). Skip them. */
							if (activeCall) {
								/* Iterate through the active call's targeted elements. */
								$.each(activeCall[1], function(k, activeElement) {
									/* If true was passed in as a secondary argument, clear absolutely all calls on this element. Otherwise, only
									 clear calls associated with the relevant queue. */
									/* Call stopping logic works as follows:
									 - options === true --> stop current default queue calls (and queue:false calls), including remaining queued ones.
									 - options === undefined --> stop current queue:"" call and all queue:false calls.
									 - options === false --> stop only queue:false calls.
									 - options === "custom" --> stop current queue:"custom" call, including remaining queued ones (there is no functionality to only clear the currently-running queue:"custom" call). */
									var queueName = (options === undefined$1) ? "" : options;

									if (queueName !== true && (activeCall[2].queue !== queueName) && !(options === undefined$1 && activeCall[2].queue === false)) {
										return true;
									}

									/* Iterate through the calls targeted by the stop command. */
									$.each(elements, function(l, element) {
										/* Check that this call was applied to the target element. */
										if (element === activeElement) {
											/* Optionally clear the remaining queued calls. If we're doing "finishAll" this won't find anything,
											 due to the queue-clearing above. */
											if (options === true || Type.isString(options)) {
												/* Iterate through the items in the element's queue. */
												$.each($.queue(element, Type.isString(options) ? options : ""), function(_, item) {
													/* The queue array can contain an "inprogress" string, which we skip. */
													if (Type.isFunction(item)) {
														/* Pass the item's callback a flag indicating that we want to abort from the queue call.
														 (Specifically, the queue will resolve the call's associated promise then abort.)  */
														item(null, true);
													}
												});

												/* Clearing the $.queue() array is achieved by resetting it to []. */
												$.queue(element, Type.isString(options) ? options : "", []);
											}

											if (propertiesMap === "stop") {
												/* Since "reverse" uses cached start values (the previous call's endValues), these values must be
												 changed to reflect the final value that the elements were actually tweened to. */
												/* Note: If only queue:false/queue:"custom" animations are currently running on an element, it won't have a tweensContainer
												 object. Also, queue:false/queue:"custom" animations can't be reversed. */
												var data = Data(element);
												if (data && data.tweensContainer && (queueName === true || queueName === "")) {
													$.each(data.tweensContainer, function(m, activeTween) {
														activeTween.endValue = activeTween.currentValue;
													});
												}

												callsToStop.push(i);
											} else if (propertiesMap === "finish" || propertiesMap === "finishAll") {
												/* To get active tweens to finish immediately, we forcefully shorten their durations to 1ms so that
												 they finish upon the next rAf tick then proceed with normal call completion logic. */
												activeCall[2].duration = 1;
											}
										}
									});
								});
							}
						});

						/* Prematurely call completeCall() on each matched active call. Pass an additional flag for "stop" to indicate
						 that the complete callback and display:none setting should be skipped since we're completing prematurely. */
						if (propertiesMap === "stop") {
							$.each(callsToStop, function(i, j) {
								completeCall(j, true);
							});

							if (promiseData.promise) {
								/* Immediately resolve the promise associated with this stop call since stop runs synchronously. */
								promiseData.resolver(elements);
							}
						}

						/* Since we're stopping, and not proceeding with queueing, exit out of Velocity. */
						return getChain();

					default:
						/* Treat a non-empty plain object as a literal properties map. */
						if ($.isPlainObject(propertiesMap) && !Type.isEmptyObject(propertiesMap)) {
							action = "start";

							/****************
							 Redirects
							 ****************/

							/* Check if a string matches a registered redirect (see Redirects above). */
						} else if (Type.isString(propertiesMap) && Velocity.Redirects[propertiesMap]) {
							opts = $.extend({}, options);

							var durationOriginal = opts.duration,
									delayOriginal = opts.delay || 0;

							/* If the backwards option was passed in, reverse the element set so that elements animate from the last to the first. */
							if (opts.backwards === true) {
								elements = $.extend(true, [], elements).reverse();
							}

							/* Individually trigger the redirect for each element in the set to prevent users from having to handle iteration logic in their redirect. */
							$.each(elements, function(elementIndex, element) {
								/* If the stagger option was passed in, successively delay each element by the stagger value (in ms). Retain the original delay value. */
								if (parseFloat(opts.stagger)) {
									opts.delay = delayOriginal + (parseFloat(opts.stagger) * elementIndex);
								} else if (Type.isFunction(opts.stagger)) {
									opts.delay = delayOriginal + opts.stagger.call(element, elementIndex, elementsLength);
								}

								/* If the drag option was passed in, successively increase/decrease (depending on the presense of opts.backwards)
								 the duration of each element's animation, using floors to prevent producing very short durations. */
								if (opts.drag) {
									/* Default the duration of UI pack effects (callouts and transitions) to 1000ms instead of the usual default duration of 400ms. */
									opts.duration = parseFloat(durationOriginal) || (/^(callout|transition)/.test(propertiesMap) ? 1000 : DURATION_DEFAULT);

									/* For each element, take the greater duration of: A) animation completion percentage relative to the original duration,
									 B) 75% of the original duration, or C) a 200ms fallback (in case duration is already set to a low value).
									 The end result is a baseline of 75% of the redirect's duration that increases/decreases as the end of the element set is approached. */
									opts.duration = Math.max(opts.duration * (opts.backwards ? 1 - elementIndex / elementsLength : (elementIndex + 1) / elementsLength), opts.duration * 0.75, 200);
								}

								/* Pass in the call's opts object so that the redirect can optionally extend it. It defaults to an empty object instead of null to
								 reduce the opts checking logic required inside the redirect. */
								Velocity.Redirects[propertiesMap].call(element, element, opts || {}, elementIndex, elementsLength, elements, promiseData.promise ? promiseData : undefined$1);
							});

							/* Since the animation logic resides within the redirect's own code, abort the remainder of this call.
							 (The performance overhead up to this point is virtually non-existant.) */
							/* Note: The jQuery call chain is kept intact by returning the complete element set. */
							return getChain();
						} else {
							var abortError = "Velocity: First argument (" + propertiesMap + ") was not a property map, a known action, or a registered redirect. Aborting.";

							if (promiseData.promise) {
								promiseData.rejecter(new Error(abortError));
							} else if (window.console) {
								console.log(abortError);
							}

							return getChain();
						}
				}

				/**************************
				 Call-Wide Variables
				 **************************/

				/* A container for CSS unit conversion ratios (e.g. %, rem, and em ==> px) that is used to cache ratios across all elements
				 being animated in a single Velocity call. Calculating unit ratios necessitates DOM querying and updating, and is therefore
				 avoided (via caching) wherever possible. This container is call-wide instead of page-wide to avoid the risk of using stale
				 conversion metrics across Velocity animations that are not immediately consecutively chained. */
				var callUnitConversionData = {
					lastParent: null,
					lastPosition: null,
					lastFontSize: null,
					lastPercentToPxWidth: null,
					lastPercentToPxHeight: null,
					lastEmToPx: null,
					remToPx: null,
					vwToPx: null,
					vhToPx: null
				};

				/* A container for all the ensuing tween data and metadata associated with this call. This container gets pushed to the page-wide
				 Velocity.State.calls array that is processed during animation ticking. */
				var call = [];

				/************************
				 Element Processing
				 ************************/

				/* Element processing consists of three parts -- data processing that cannot go stale and data processing that *can* go stale (i.e. third-party style modifications):
				 1) Pre-Queueing: Element-wide variables, including the element's data storage, are instantiated. Call options are prepared. If triggered, the Stop action is executed.
				 2) Queueing: The logic that runs once this call has reached its point of execution in the element's $.queue() stack. Most logic is placed here to avoid risking it becoming stale.
				 3) Pushing: Consolidation of the tween data followed by its push onto the global in-progress calls container.
				 `elementArrayIndex` allows passing index of the element in the original array to value functions.
				 If `elementsIndex` were used instead the index would be determined by the elements' per-element queue.
				 */
				function processElement(element, elementArrayIndex) {

					/*************************
					 Part I: Pre-Queueing
					 *************************/

					/***************************
					 Element-Wide Variables
					 ***************************/

					var /* The runtime opts object is the extension of the current call's options and Velocity's page-wide option defaults. */
							opts = $.extend({}, Velocity.defaults, options),
							/* A container for the processed data associated with each property in the propertyMap.
							 (Each property in the map produces its own "tween".) */
							tweensContainer = {},
							elementUnitConversionData;

					/******************
					 Element Init
					 ******************/

					if (Data(element) === undefined$1) {
						Velocity.init(element);
					}

					/******************
					 Option: Delay
					 ******************/

					/* Since queue:false doesn't respect the item's existing queue, we avoid injecting its delay here (it's set later on). */
					/* Note: Velocity rolls its own delay function since jQuery doesn't have a utility alias for $.fn.delay()
					 (and thus requires jQuery element creation, which we avoid since its overhead includes DOM querying). */
					if (parseFloat(opts.delay) && opts.queue !== false) {
						$.queue(element, opts.queue, function(next, clearQueue) {
							if (clearQueue === true) {
								/* Do not continue with animation queueing. */
								return true;
							}

							/* This is a flag used to indicate to the upcoming completeCall() function that this queue entry was initiated by Velocity. See completeCall() for further details. */
							Velocity.velocityQueueEntryFlag = true;

							/* The ensuing queue item (which is assigned to the "next" argument that $.queue() automatically passes in) will be triggered after a setTimeout delay.
							 The setTimeout is stored so that it can be subjected to clearTimeout() if this animation is prematurely stopped via Velocity's "stop" command, and
							 delayBegin/delayTime is used to ensure we can "pause" and "resume" a tween that is still mid-delay. */

							/* Temporarily store delayed elements to facilite access for global pause/resume */
							var callIndex = Velocity.State.delayedElements.count++;
							Velocity.State.delayedElements[callIndex] = element;

							var delayComplete = (function(index) {
								return function() {
									/* Clear the temporary element */
									Velocity.State.delayedElements[index] = false;

									/* Finally, issue the call */
									next();
								};
							})(callIndex);


							Data(element).delayBegin = (new Date()).getTime();
							Data(element).delay = parseFloat(opts.delay);
							Data(element).delayTimer = {
								setTimeout: setTimeout(next, parseFloat(opts.delay)),
								next: delayComplete
							};
						});
					}

					/*********************
					 Option: Duration
					 *********************/

					/* Support for jQuery's named durations. */
					switch (opts.duration.toString().toLowerCase()) {
						case "fast":
							opts.duration = 200;
							break;

						case "normal":
							opts.duration = DURATION_DEFAULT;
							break;

						case "slow":
							opts.duration = 600;
							break;

						default:
							/* Remove the potential "ms" suffix and default to 1 if the user is attempting to set a duration of 0 (in order to produce an immediate style change). */
							opts.duration = parseFloat(opts.duration) || 1;
					}

					/************************
					 Global Option: Mock
					 ************************/

					if (Velocity.mock !== false) {
						/* In mock mode, all animations are forced to 1ms so that they occur immediately upon the next rAF tick.
						 Alternatively, a multiplier can be passed in to time remap all delays and durations. */
						if (Velocity.mock === true) {
							opts.duration = opts.delay = 1;
						} else {
							opts.duration *= parseFloat(Velocity.mock) || 1;
							opts.delay *= parseFloat(Velocity.mock) || 1;
						}
					}

					/*******************
					 Option: Easing
					 *******************/

					opts.easing = getEasing(opts.easing, opts.duration);

					/**********************
					 Option: Callbacks
					 **********************/

					/* Callbacks must functions. Otherwise, default to null. */
					if (opts.begin && !Type.isFunction(opts.begin)) {
						opts.begin = null;
					}

					if (opts.progress && !Type.isFunction(opts.progress)) {
						opts.progress = null;
					}

					if (opts.complete && !Type.isFunction(opts.complete)) {
						opts.complete = null;
					}

					/*********************************
					 Option: Display & Visibility
					 *********************************/

					/* Refer to Velocity's documentation (VelocityJS.org/#displayAndVisibility) for a description of the display and visibility options' behavior. */
					/* Note: We strictly check for undefined instead of falsiness because display accepts an empty string value. */
					if (opts.display !== undefined$1 && opts.display !== null) {
						opts.display = opts.display.toString().toLowerCase();

						/* Users can pass in a special "auto" value to instruct Velocity to set the element to its default display value. */
						if (opts.display === "auto") {
							opts.display = Velocity.CSS.Values.getDisplayType(element);
						}
					}

					if (opts.visibility !== undefined$1 && opts.visibility !== null) {
						opts.visibility = opts.visibility.toString().toLowerCase();
					}

					/**********************
					 Option: mobileHA
					 **********************/

					/* When set to true, and if this is a mobile device, mobileHA automatically enables hardware acceleration (via a null transform hack)
					 on animating elements. HA is removed from the element at the completion of its animation. */
					/* Note: Android Gingerbread doesn't support HA. If a null transform hack (mobileHA) is in fact set, it will prevent other tranform subproperties from taking effect. */
					/* Note: You can read more about the use of mobileHA in Velocity's documentation: VelocityJS.org/#mobileHA. */
					opts.mobileHA = (opts.mobileHA && Velocity.State.isMobile && !Velocity.State.isGingerbread);

					/***********************
					 Part II: Queueing
					 ***********************/

					/* When a set of elements is targeted by a Velocity call, the set is broken up and each element has the current Velocity call individually queued onto it.
					 In this way, each element's existing queue is respected; some elements may already be animating and accordingly should not have this current Velocity call triggered immediately. */
					/* In each queue, tween data is processed for each animating property then pushed onto the call-wide calls array. When the last element in the set has had its tweens processed,
					 the call array is pushed to Velocity.State.calls for live processing by the requestAnimationFrame tick. */
					function buildQueue(next) {
						var data, lastTweensContainer;

						/*******************
						 Option: Begin
						 *******************/

						/* The begin callback is fired once per call -- not once per elemenet -- and is passed the full raw DOM element set as both its context and its first argument. */
						if (opts.begin && elementsIndex === 0) {
							/* We throw callbacks in a setTimeout so that thrown errors don't halt the execution of Velocity itself. */
							try {
								opts.begin.call(elements, elements);
							} catch (error) {
								setTimeout(function() {
									throw error;
								}, 1);
							}
						}

						/*****************************************
						 Tween Data Construction (for Scroll)
						 *****************************************/

						/* Note: In order to be subjected to chaining and animation options, scroll's tweening is routed through Velocity as if it were a standard CSS property animation. */
						if (action === "scroll") {
							/* The scroll action uniquely takes an optional "offset" option -- specified in pixels -- that offsets the targeted scroll position. */
							var scrollDirection = (/^x$/i.test(opts.axis) ? "Left" : "Top"),
									scrollOffset = parseFloat(opts.offset) || 0,
									scrollPositionCurrent,
									scrollPositionCurrentAlternate,
									scrollPositionEnd;

							/* Scroll also uniquely takes an optional "container" option, which indicates the parent element that should be scrolled --
							 as opposed to the browser window itself. This is useful for scrolling toward an element that's inside an overflowing parent element. */
							if (opts.container) {
								/* Ensure that either a jQuery object or a raw DOM element was passed in. */
								if (Type.isWrapped(opts.container) || Type.isNode(opts.container)) {
									/* Extract the raw DOM element from the jQuery wrapper. */
									opts.container = opts.container[0] || opts.container;
									/* Note: Unlike other properties in Velocity, the browser's scroll position is never cached since it so frequently changes
									 (due to the user's natural interaction with the page). */
									scrollPositionCurrent = opts.container["scroll" + scrollDirection]; /* GET */

									/* $.position() values are relative to the container's currently viewable area (without taking into account the container's true dimensions
									 -- say, for example, if the container was not overflowing). Thus, the scroll end value is the sum of the child element's position *and*
									 the scroll container's current scroll position. */
									scrollPositionEnd = (scrollPositionCurrent + $(element).position()[scrollDirection.toLowerCase()]) + scrollOffset; /* GET */
									/* If a value other than a jQuery object or a raw DOM element was passed in, default to null so that this option is ignored. */
								} else {
									opts.container = null;
								}
							} else {
								/* If the window itself is being scrolled -- not a containing element -- perform a live scroll position lookup using
								 the appropriate cached property names (which differ based on browser type). */
								scrollPositionCurrent = Velocity.State.scrollAnchor[Velocity.State["scrollProperty" + scrollDirection]]; /* GET */
								/* When scrolling the browser window, cache the alternate axis's current value since window.scrollTo() doesn't let us change only one value at a time. */
								scrollPositionCurrentAlternate = Velocity.State.scrollAnchor[Velocity.State["scrollProperty" + (scrollDirection === "Left" ? "Top" : "Left")]]; /* GET */

								/* Unlike $.position(), $.offset() values are relative to the browser window's true dimensions -- not merely its currently viewable area --
								 and therefore end values do not need to be compounded onto current values. */
								scrollPositionEnd = $(element).offset()[scrollDirection.toLowerCase()] + scrollOffset; /* GET */
							}

							/* Since there's only one format that scroll's associated tweensContainer can take, we create it manually. */
							tweensContainer = {
								scroll: {
									rootPropertyValue: false,
									startValue: scrollPositionCurrent,
									currentValue: scrollPositionCurrent,
									endValue: scrollPositionEnd,
									unitType: "",
									easing: opts.easing,
									scrollData: {
										container: opts.container,
										direction: scrollDirection,
										alternateValue: scrollPositionCurrentAlternate
									}
								},
								element: element
							};

							if (Velocity.debug) {
								console.log("tweensContainer (scroll): ", tweensContainer.scroll, element);
							}

							/******************************************
							 Tween Data Construction (for Reverse)
							 ******************************************/

							/* Reverse acts like a "start" action in that a property map is animated toward. The only difference is
							 that the property map used for reverse is the inverse of the map used in the previous call. Thus, we manipulate
							 the previous call to construct our new map: use the previous map's end values as our new map's start values. Copy over all other data. */
							/* Note: Reverse can be directly called via the "reverse" parameter, or it can be indirectly triggered via the loop option. (Loops are composed of multiple reverses.) */
							/* Note: Reverse calls do not need to be consecutively chained onto a currently-animating element in order to operate on cached values;
							 there is no harm to reverse being called on a potentially stale data cache since reverse's behavior is simply defined
							 as reverting to the element's values as they were prior to the previous *Velocity* call. */
						} else if (action === "reverse") {
							data = Data(element);

							/* Abort if there is no prior animation data to reverse to. */
							if (!data) {
								return;
							}

							if (!data.tweensContainer) {
								/* Dequeue the element so that this queue entry releases itself immediately, allowing subsequent queue entries to run. */
								$.dequeue(element, opts.queue);

								return;
							} else {
								/*********************
								 Options Parsing
								 *********************/

								/* If the element was hidden via the display option in the previous call,
								 revert display to "auto" prior to reversal so that the element is visible again. */
								if (data.opts.display === "none") {
									data.opts.display = "auto";
								}

								if (data.opts.visibility === "hidden") {
									data.opts.visibility = "visible";
								}

								/* If the loop option was set in the previous call, disable it so that "reverse" calls aren't recursively generated.
								 Further, remove the previous call's callback options; typically, users do not want these to be refired. */
								data.opts.loop = false;
								data.opts.begin = null;
								data.opts.complete = null;

								/* Since we're extending an opts object that has already been extended with the defaults options object,
								 we remove non-explicitly-defined properties that are auto-assigned values. */
								if (!options.easing) {
									delete opts.easing;
								}

								if (!options.duration) {
									delete opts.duration;
								}

								/* The opts object used for reversal is an extension of the options object optionally passed into this
								 reverse call plus the options used in the previous Velocity call. */
								opts = $.extend({}, data.opts, opts);

								/*************************************
								 Tweens Container Reconstruction
								 *************************************/

								/* Create a deepy copy (indicated via the true flag) of the previous call's tweensContainer. */
								lastTweensContainer = $.extend(true, {}, data ? data.tweensContainer : null);

								/* Manipulate the previous tweensContainer by replacing its end values and currentValues with its start values. */
								for (var lastTween in lastTweensContainer) {
									/* In addition to tween data, tweensContainers contain an element property that we ignore here. */
									if (lastTweensContainer.hasOwnProperty(lastTween) && lastTween !== "element") {
										var lastStartValue = lastTweensContainer[lastTween].startValue;

										lastTweensContainer[lastTween].startValue = lastTweensContainer[lastTween].currentValue = lastTweensContainer[lastTween].endValue;
										lastTweensContainer[lastTween].endValue = lastStartValue;

										/* Easing is the only option that embeds into the individual tween data (since it can be defined on a per-property basis).
										 Accordingly, every property's easing value must be updated when an options object is passed in with a reverse call.
										 The side effect of this extensibility is that all per-property easing values are forcefully reset to the new value. */
										if (!Type.isEmptyObject(options)) {
											lastTweensContainer[lastTween].easing = opts.easing;
										}

										if (Velocity.debug) {
											console.log("reverse tweensContainer (" + lastTween + "): " + JSON.stringify(lastTweensContainer[lastTween]), element);
										}
									}
								}

								tweensContainer = lastTweensContainer;
							}

							/*****************************************
							 Tween Data Construction (for Start)
							 *****************************************/

						} else if (action === "start") {

							/*************************
							 Value Transferring
							 *************************/

							/* If this queue entry follows a previous Velocity-initiated queue entry *and* if this entry was created
							 while the element was in the process of being animated by Velocity, then this current call is safe to use
							 the end values from the prior call as its start values. Velocity attempts to perform this value transfer
							 process whenever possible in order to avoid requerying the DOM. */
							/* If values aren't transferred from a prior call and start values were not forcefed by the user (more on this below),
							 then the DOM is queried for the element's current values as a last resort. */
							/* Note: Conversely, animation reversal (and looping) *always* perform inter-call value transfers; they never requery the DOM. */

							data = Data(element);

							/* The per-element isAnimating flag is used to indicate whether it's safe (i.e. the data isn't stale)
							 to transfer over end values to use as start values. If it's set to true and there is a previous
							 Velocity call to pull values from, do so. */
							if (data && data.tweensContainer && data.isAnimating === true) {
								lastTweensContainer = data.tweensContainer;
							}

							/***************************
							 Tween Data Calculation
							 ***************************/

							/* This function parses property data and defaults endValue, easing, and startValue as appropriate. */
							/* Property map values can either take the form of 1) a single value representing the end value,
							 or 2) an array in the form of [ endValue, [, easing] [, startValue] ].
							 The optional third parameter is a forcefed startValue to be used instead of querying the DOM for
							 the element's current value. Read Velocity's docmentation to learn more about forcefeeding: VelocityJS.org/#forcefeeding */
							var parsePropertyValue = function(valueData, skipResolvingEasing) {
								var endValue, easing, startValue;

								/* If we have a function as the main argument then resolve it first, in case it returns an array that needs to be split */
								if (Type.isFunction(valueData)) {
									valueData = valueData.call(element, elementArrayIndex, elementsLength);
								}

								/* Handle the array format, which can be structured as one of three potential overloads:
								 A) [ endValue, easing, startValue ], B) [ endValue, easing ], or C) [ endValue, startValue ] */
								if (Type.isArray(valueData)) {
									/* endValue is always the first item in the array. Don't bother validating endValue's value now
									 since the ensuing property cycling logic does that. */
									endValue = valueData[0];

									/* Two-item array format: If the second item is a number, function, or hex string, treat it as a
									 start value since easings can only be non-hex strings or arrays. */
									if ((!Type.isArray(valueData[1]) && /^[\d-]/.test(valueData[1])) || Type.isFunction(valueData[1]) || CSS.RegEx.isHex.test(valueData[1])) {
										startValue = valueData[1];
										/* Two or three-item array: If the second item is a non-hex string easing name or an array, treat it as an easing. */
									} else if ((Type.isString(valueData[1]) && !CSS.RegEx.isHex.test(valueData[1]) && Velocity.Easings[valueData[1]]) || Type.isArray(valueData[1])) {
										easing = skipResolvingEasing ? valueData[1] : getEasing(valueData[1], opts.duration);

										/* Don't bother validating startValue's value now since the ensuing property cycling logic inherently does that. */
										startValue = valueData[2];
									} else {
										startValue = valueData[1] || valueData[2];
									}
									/* Handle the single-value format. */
								} else {
									endValue = valueData;
								}

								/* Default to the call's easing if a per-property easing type was not defined. */
								if (!skipResolvingEasing) {
									easing = easing || opts.easing;
								}

								/* If functions were passed in as values, pass the function the current element as its context,
								 plus the element's index and the element set's size as arguments. Then, assign the returned value. */
								if (Type.isFunction(endValue)) {
									endValue = endValue.call(element, elementArrayIndex, elementsLength);
								}

								if (Type.isFunction(startValue)) {
									startValue = startValue.call(element, elementArrayIndex, elementsLength);
								}

								/* Allow startValue to be left as undefined to indicate to the ensuing code that its value was not forcefed. */
								return [endValue || 0, easing, startValue];
							};

							var fixPropertyValue = function(property, valueData) {
								/* In case this property is a hook, there are circumstances where we will intend to work on the hook's root property and not the hooked subproperty. */
								var rootProperty = CSS.Hooks.getRoot(property),
										rootPropertyValue = false,
										/* Parse out endValue, easing, and startValue from the property's data. */
										endValue = valueData[0],
										easing = valueData[1],
										startValue = valueData[2],
										pattern;

								/**************************
								 Start Value Sourcing
								 **************************/

								/* Other than for the dummy tween property, properties that are not supported by the browser (and do not have an associated normalization) will
								 inherently produce no style changes when set, so they are skipped in order to decrease animation tick overhead.
								 Property support is determined via prefixCheck(), which returns a false flag when no supported is detected. */
								/* Note: Since SVG elements have some of their properties directly applied as HTML attributes,
								 there is no way to check for their explicit browser support, and so we skip skip this check for them. */
								if ((!data || !data.isSVG) && rootProperty !== "tween" && CSS.Names.prefixCheck(rootProperty)[1] === false && CSS.Normalizations.registered[rootProperty] === undefined$1) {
									if (Velocity.debug) {
										console.log("Skipping [" + rootProperty + "] due to a lack of browser support.");
									}
									return;
								}

								/* If the display option is being set to a non-"none" (e.g. "block") and opacity (filter on IE<=8) is being
								 animated to an endValue of non-zero, the user's intention is to fade in from invisible, thus we forcefeed opacity
								 a startValue of 0 if its startValue hasn't already been sourced by value transferring or prior forcefeeding. */
								if (((opts.display !== undefined$1 && opts.display !== null && opts.display !== "none") || (opts.visibility !== undefined$1 && opts.visibility !== "hidden")) && /opacity|filter/.test(property) && !startValue && endValue !== 0) {
									startValue = 0;
								}

								/* If values have been transferred from the previous Velocity call, extract the endValue and rootPropertyValue
								 for all of the current call's properties that were *also* animated in the previous call. */
								/* Note: Value transferring can optionally be disabled by the user via the _cacheValues option. */
								if (opts._cacheValues && lastTweensContainer && lastTweensContainer[property]) {
									if (startValue === undefined$1) {
										startValue = lastTweensContainer[property].endValue + lastTweensContainer[property].unitType;
									}

									/* The previous call's rootPropertyValue is extracted from the element's data cache since that's the
									 instance of rootPropertyValue that gets freshly updated by the tweening process, whereas the rootPropertyValue
									 attached to the incoming lastTweensContainer is equal to the root property's value prior to any tweening. */
									rootPropertyValue = data.rootPropertyValueCache[rootProperty];
									/* If values were not transferred from a previous Velocity call, query the DOM as needed. */
								} else {
									/* Handle hooked properties. */
									if (CSS.Hooks.registered[property]) {
										if (startValue === undefined$1) {
											rootPropertyValue = CSS.getPropertyValue(element, rootProperty); /* GET */
											/* Note: The following getPropertyValue() call does not actually trigger a DOM query;
											 getPropertyValue() will extract the hook from rootPropertyValue. */
											startValue = CSS.getPropertyValue(element, property, rootPropertyValue);
											/* If startValue is already defined via forcefeeding, do not query the DOM for the root property's value;
											 just grab rootProperty's zero-value template from CSS.Hooks. This overwrites the element's actual
											 root property value (if one is set), but this is acceptable since the primary reason users forcefeed is
											 to avoid DOM queries, and thus we likewise avoid querying the DOM for the root property's value. */
										} else {
											/* Grab this hook's zero-value template, e.g. "0px 0px 0px black". */
											rootPropertyValue = CSS.Hooks.templates[rootProperty][1];
										}
										/* Handle non-hooked properties that haven't already been defined via forcefeeding. */
									} else if (startValue === undefined$1) {
										startValue = CSS.getPropertyValue(element, property); /* GET */
									}
								}

								/**************************
								 Value Data Extraction
								 **************************/

								var separatedValue,
										endValueUnitType,
										startValueUnitType,
										operator = false;

								/* Separates a property value into its numeric value and its unit type. */
								var separateValue = function(property, value) {
									var unitType,
											numericValue;

									numericValue = (value || "0")
											.toString()
											.toLowerCase()
											/* Match the unit type at the end of the value. */
											.replace(/[%A-z]+$/, function(match) {
												/* Grab the unit type. */
												unitType = match;

												/* Strip the unit type off of value. */
												return "";
											});

									/* If no unit type was supplied, assign one that is appropriate for this property (e.g. "deg" for rotateZ or "px" for width). */
									if (!unitType) {
										unitType = CSS.Values.getUnitType(property);
									}

									return [numericValue, unitType];
								};

								if (startValue !== endValue && Type.isString(startValue) && Type.isString(endValue)) {
									pattern = "";
									var iStart = 0, // index in startValue
											iEnd = 0, // index in endValue
											aStart = [], // array of startValue numbers
											aEnd = [], // array of endValue numbers
											inCalc = 0, // Keep track of being inside a "calc()" so we don't duplicate it
											inRGB = 0, // Keep track of being inside an RGB as we can't use fractional values
											inRGBA = 0; // Keep track of being inside an RGBA as we must pass fractional for the alpha channel

									startValue = CSS.Hooks.fixColors(startValue);
									endValue = CSS.Hooks.fixColors(endValue);
									while (iStart < startValue.length && iEnd < endValue.length) {
										var cStart = startValue[iStart],
												cEnd = endValue[iEnd];

										if (/[\d\.-]/.test(cStart) && /[\d\.-]/.test(cEnd)) {
											var tStart = cStart, // temporary character buffer
													tEnd = cEnd, // temporary character buffer
													dotStart = ".", // Make sure we can only ever match a single dot in a decimal
													dotEnd = "."; // Make sure we can only ever match a single dot in a decimal

											while (++iStart < startValue.length) {
												cStart = startValue[iStart];
												if (cStart === dotStart) {
													dotStart = ".."; // Can never match two characters
												} else if (!/\d/.test(cStart)) {
													break;
												}
												tStart += cStart;
											}
											while (++iEnd < endValue.length) {
												cEnd = endValue[iEnd];
												if (cEnd === dotEnd) {
													dotEnd = ".."; // Can never match two characters
												} else if (!/\d/.test(cEnd)) {
													break;
												}
												tEnd += cEnd;
											}
											var uStart = CSS.Hooks.getUnit(startValue, iStart), // temporary unit type
													uEnd = CSS.Hooks.getUnit(endValue, iEnd); // temporary unit type

											iStart += uStart.length;
											iEnd += uEnd.length;
											if (uStart === uEnd) {
												// Same units
												if (tStart === tEnd) {
													// Same numbers, so just copy over
													pattern += tStart + uStart;
												} else {
													// Different numbers, so store them
													pattern += "{" + aStart.length + (inRGB ? "!" : "") + "}" + uStart;
													aStart.push(parseFloat(tStart));
													aEnd.push(parseFloat(tEnd));
												}
											} else {
												// Different units, so put into a "calc(from + to)" and animate each side to/from zero
												var nStart = parseFloat(tStart),
														nEnd = parseFloat(tEnd);

												pattern += (inCalc < 5 ? "calc" : "") + "("
														+ (nStart ? "{" + aStart.length + (inRGB ? "!" : "") + "}" : "0") + uStart
														+ " + "
														+ (nEnd ? "{" + (aStart.length + (nStart ? 1 : 0)) + (inRGB ? "!" : "") + "}" : "0") + uEnd
														+ ")";
												if (nStart) {
													aStart.push(nStart);
													aEnd.push(0);
												}
												if (nEnd) {
													aStart.push(0);
													aEnd.push(nEnd);
												}
											}
										} else if (cStart === cEnd) {
											pattern += cStart;
											iStart++;
											iEnd++;
											// Keep track of being inside a calc()
											if (inCalc === 0 && cStart === "c"
													|| inCalc === 1 && cStart === "a"
													|| inCalc === 2 && cStart === "l"
													|| inCalc === 3 && cStart === "c"
													|| inCalc >= 4 && cStart === "("
													) {
												inCalc++;
											} else if ((inCalc && inCalc < 5)
													|| inCalc >= 4 && cStart === ")" && --inCalc < 5) {
												inCalc = 0;
											}
											// Keep track of being inside an rgb() / rgba()
											if (inRGB === 0 && cStart === "r"
													|| inRGB === 1 && cStart === "g"
													|| inRGB === 2 && cStart === "b"
													|| inRGB === 3 && cStart === "a"
													|| inRGB >= 3 && cStart === "("
													) {
												if (inRGB === 3 && cStart === "a") {
													inRGBA = 1;
												}
												inRGB++;
											} else if (inRGBA && cStart === ",") {
												if (++inRGBA > 3) {
													inRGB = inRGBA = 0;
												}
											} else if ((inRGBA && inRGB < (inRGBA ? 5 : 4))
													|| inRGB >= (inRGBA ? 4 : 3) && cStart === ")" && --inRGB < (inRGBA ? 5 : 4)) {
												inRGB = inRGBA = 0;
											}
										} else {
											inCalc = 0;
											// TODO: changing units, fixing colours
											break;
										}
									}
									if (iStart !== startValue.length || iEnd !== endValue.length) {
										if (Velocity.debug) {
											console.error("Trying to pattern match mis-matched strings [\"" + endValue + "\", \"" + startValue + "\"]");
										}
										pattern = undefined$1;
									}
									if (pattern) {
										if (aStart.length) {
											if (Velocity.debug) {
												console.log("Pattern found \"" + pattern + "\" -> ", aStart, aEnd, "[" + startValue + "," + endValue + "]");
											}
											startValue = aStart;
											endValue = aEnd;
											endValueUnitType = startValueUnitType = "";
										} else {
											pattern = undefined$1;
										}
									}
								}

								if (!pattern) {
									/* Separate startValue. */
									separatedValue = separateValue(property, startValue);
									startValue = separatedValue[0];
									startValueUnitType = separatedValue[1];

									/* Separate endValue, and extract a value operator (e.g. "+=", "-=") if one exists. */
									separatedValue = separateValue(property, endValue);
									endValue = separatedValue[0].replace(/^([+-\/*])=/, function(match, subMatch) {
										operator = subMatch;

										/* Strip the operator off of the value. */
										return "";
									});
									endValueUnitType = separatedValue[1];

									/* Parse float values from endValue and startValue. Default to 0 if NaN is returned. */
									startValue = parseFloat(startValue) || 0;
									endValue = parseFloat(endValue) || 0;

									/***************************************
									 Property-Specific Value Conversion
									 ***************************************/

									/* Custom support for properties that don't actually accept the % unit type, but where pollyfilling is trivial and relatively foolproof. */
									if (endValueUnitType === "%") {
										/* A %-value fontSize/lineHeight is relative to the parent's fontSize (as opposed to the parent's dimensions),
										 which is identical to the em unit's behavior, so we piggyback off of that. */
										if (/^(fontSize|lineHeight)$/.test(property)) {
											/* Convert % into an em decimal value. */
											endValue = endValue / 100;
											endValueUnitType = "em";
											/* For scaleX and scaleY, convert the value into its decimal format and strip off the unit type. */
										} else if (/^scale/.test(property)) {
											endValue = endValue / 100;
											endValueUnitType = "";
											/* For RGB components, take the defined percentage of 255 and strip off the unit type. */
										} else if (/(Red|Green|Blue)$/i.test(property)) {
											endValue = (endValue / 100) * 255;
											endValueUnitType = "";
										}
									}
								}

								/***************************
								 Unit Ratio Calculation
								 ***************************/

								/* When queried, the browser returns (most) CSS property values in pixels. Therefore, if an endValue with a unit type of
								 %, em, or rem is animated toward, startValue must be converted from pixels into the same unit type as endValue in order
								 for value manipulation logic (increment/decrement) to proceed. Further, if the startValue was forcefed or transferred
								 from a previous call, startValue may also not be in pixels. Unit conversion logic therefore consists of two steps:
								 1) Calculating the ratio of %/em/rem/vh/vw relative to pixels
								 2) Converting startValue into the same unit of measurement as endValue based on these ratios. */
								/* Unit conversion ratios are calculated by inserting a sibling node next to the target node, copying over its position property,
								 setting values with the target unit type then comparing the returned pixel value. */
								/* Note: Even if only one of these unit types is being animated, all unit ratios are calculated at once since the overhead
								 of batching the SETs and GETs together upfront outweights the potential overhead
								 of layout thrashing caused by re-querying for uncalculated ratios for subsequently-processed properties. */
								/* Todo: Shift this logic into the calls' first tick instance so that it's synced with RAF. */
								var calculateUnitRatios = function() {

									/************************
									 Same Ratio Checks
									 ************************/

									/* The properties below are used to determine whether the element differs sufficiently from this call's
									 previously iterated element to also differ in its unit conversion ratios. If the properties match up with those
									 of the prior element, the prior element's conversion ratios are used. Like most optimizations in Velocity,
									 this is done to minimize DOM querying. */
									var sameRatioIndicators = {
										myParent: element.parentNode || document.body, /* GET */
										position: CSS.getPropertyValue(element, "position"), /* GET */
										fontSize: CSS.getPropertyValue(element, "fontSize") /* GET */
									},
											/* Determine if the same % ratio can be used. % is based on the element's position value and its parent's width and height dimensions. */
											samePercentRatio = ((sameRatioIndicators.position === callUnitConversionData.lastPosition) && (sameRatioIndicators.myParent === callUnitConversionData.lastParent)),
											/* Determine if the same em ratio can be used. em is relative to the element's fontSize. */
											sameEmRatio = (sameRatioIndicators.fontSize === callUnitConversionData.lastFontSize);

									/* Store these ratio indicators call-wide for the next element to compare against. */
									callUnitConversionData.lastParent = sameRatioIndicators.myParent;
									callUnitConversionData.lastPosition = sameRatioIndicators.position;
									callUnitConversionData.lastFontSize = sameRatioIndicators.fontSize;

									/***************************
									 Element-Specific Units
									 ***************************/

									/* Note: IE8 rounds to the nearest pixel when returning CSS values, thus we perform conversions using a measurement
									 of 100 (instead of 1) to give our ratios a precision of at least 2 decimal values. */
									var measurement = 100,
											unitRatios = {};

									if (!sameEmRatio || !samePercentRatio) {
										var dummy = data && data.isSVG ? document.createElementNS("http://www.w3.org/2000/svg", "rect") : document.createElement("div");

										Velocity.init(dummy);
										sameRatioIndicators.myParent.appendChild(dummy);

										/* To accurately and consistently calculate conversion ratios, the element's cascaded overflow and box-sizing are stripped.
										 Similarly, since width/height can be artificially constrained by their min-/max- equivalents, these are controlled for as well. */
										/* Note: Overflow must be also be controlled for per-axis since the overflow property overwrites its per-axis values. */
										$.each(["overflow", "overflowX", "overflowY"], function(i, property) {
											Velocity.CSS.setPropertyValue(dummy, property, "hidden");
										});
										Velocity.CSS.setPropertyValue(dummy, "position", sameRatioIndicators.position);
										Velocity.CSS.setPropertyValue(dummy, "fontSize", sameRatioIndicators.fontSize);
										Velocity.CSS.setPropertyValue(dummy, "boxSizing", "content-box");

										/* width and height act as our proxy properties for measuring the horizontal and vertical % ratios. */
										$.each(["minWidth", "maxWidth", "width", "minHeight", "maxHeight", "height"], function(i, property) {
											Velocity.CSS.setPropertyValue(dummy, property, measurement + "%");
										});
										/* paddingLeft arbitrarily acts as our proxy property for the em ratio. */
										Velocity.CSS.setPropertyValue(dummy, "paddingLeft", measurement + "em");

										/* Divide the returned value by the measurement to get the ratio between 1% and 1px. Default to 1 since working with 0 can produce Infinite. */
										unitRatios.percentToPxWidth = callUnitConversionData.lastPercentToPxWidth = (parseFloat(CSS.getPropertyValue(dummy, "width", null, true)) || 1) / measurement; /* GET */
										unitRatios.percentToPxHeight = callUnitConversionData.lastPercentToPxHeight = (parseFloat(CSS.getPropertyValue(dummy, "height", null, true)) || 1) / measurement; /* GET */
										unitRatios.emToPx = callUnitConversionData.lastEmToPx = (parseFloat(CSS.getPropertyValue(dummy, "paddingLeft")) || 1) / measurement; /* GET */

										sameRatioIndicators.myParent.removeChild(dummy);
									} else {
										unitRatios.emToPx = callUnitConversionData.lastEmToPx;
										unitRatios.percentToPxWidth = callUnitConversionData.lastPercentToPxWidth;
										unitRatios.percentToPxHeight = callUnitConversionData.lastPercentToPxHeight;
									}

									/***************************
									 Element-Agnostic Units
									 ***************************/

									/* Whereas % and em ratios are determined on a per-element basis, the rem unit only needs to be checked
									 once per call since it's exclusively dependant upon document.body's fontSize. If this is the first time
									 that calculateUnitRatios() is being run during this call, remToPx will still be set to its default value of null,
									 so we calculate it now. */
									if (callUnitConversionData.remToPx === null) {
										/* Default to browsers' default fontSize of 16px in the case of 0. */
										callUnitConversionData.remToPx = parseFloat(CSS.getPropertyValue(document.body, "fontSize")) || 16; /* GET */
									}

									/* Similarly, viewport units are %-relative to the window's inner dimensions. */
									if (callUnitConversionData.vwToPx === null) {
										callUnitConversionData.vwToPx = parseFloat(window.innerWidth) / 100; /* GET */
										callUnitConversionData.vhToPx = parseFloat(window.innerHeight) / 100; /* GET */
									}

									unitRatios.remToPx = callUnitConversionData.remToPx;
									unitRatios.vwToPx = callUnitConversionData.vwToPx;
									unitRatios.vhToPx = callUnitConversionData.vhToPx;

									if (Velocity.debug >= 1) {
										console.log("Unit ratios: " + JSON.stringify(unitRatios), element);
									}
									return unitRatios;
								};

								/********************
								 Unit Conversion
								 ********************/

								/* The * and / operators, which are not passed in with an associated unit, inherently use startValue's unit. Skip value and unit conversion. */
								if (/[\/*]/.test(operator)) {
									endValueUnitType = startValueUnitType;
									/* If startValue and endValue differ in unit type, convert startValue into the same unit type as endValue so that if endValueUnitType
									 is a relative unit (%, em, rem), the values set during tweening will continue to be accurately relative even if the metrics they depend
									 on are dynamically changing during the course of the animation. Conversely, if we always normalized into px and used px for setting values, the px ratio
									 would become stale if the original unit being animated toward was relative and the underlying metrics change during the animation. */
									/* Since 0 is 0 in any unit type, no conversion is necessary when startValue is 0 -- we just start at 0 with endValueUnitType. */
								} else if ((startValueUnitType !== endValueUnitType) && startValue !== 0) {
									/* Unit conversion is also skipped when endValue is 0, but *startValueUnitType* must be used for tween values to remain accurate. */
									/* Note: Skipping unit conversion here means that if endValueUnitType was originally a relative unit, the animation won't relatively
									 match the underlying metrics if they change, but this is acceptable since we're animating toward invisibility instead of toward visibility,
									 which remains past the point of the animation's completion. */
									if (endValue === 0) {
										endValueUnitType = startValueUnitType;
									} else {
										/* By this point, we cannot avoid unit conversion (it's undesirable since it causes layout thrashing).
										 If we haven't already, we trigger calculateUnitRatios(), which runs once per element per call. */
										elementUnitConversionData = elementUnitConversionData || calculateUnitRatios();

										/* The following RegEx matches CSS properties that have their % values measured relative to the x-axis. */
										/* Note: W3C spec mandates that all of margin and padding's properties (even top and bottom) are %-relative to the *width* of the parent element. */
										var axis = (/margin|padding|left|right|width|text|word|letter/i.test(property) || /X$/.test(property) || property === "x") ? "x" : "y";

										/* In order to avoid generating n^2 bespoke conversion functions, unit conversion is a two-step process:
										 1) Convert startValue into pixels. 2) Convert this new pixel value into endValue's unit type. */
										switch (startValueUnitType) {
											case "%":
												/* Note: translateX and translateY are the only properties that are %-relative to an element's own dimensions -- not its parent's dimensions.
												 Velocity does not include a special conversion process to account for this behavior. Therefore, animating translateX/Y from a % value
												 to a non-% value will produce an incorrect start value. Fortunately, this sort of cross-unit conversion is rarely done by users in practice. */
												startValue *= (axis === "x" ? elementUnitConversionData.percentToPxWidth : elementUnitConversionData.percentToPxHeight);
												break;

											case "px":
												/* px acts as our midpoint in the unit conversion process; do nothing. */
												break;

											default:
												startValue *= elementUnitConversionData[startValueUnitType + "ToPx"];
										}

										/* Invert the px ratios to convert into to the target unit. */
										switch (endValueUnitType) {
											case "%":
												startValue *= 1 / (axis === "x" ? elementUnitConversionData.percentToPxWidth : elementUnitConversionData.percentToPxHeight);
												break;

											case "px":
												/* startValue is already in px, do nothing; we're done. */
												break;

											default:
												startValue *= 1 / elementUnitConversionData[endValueUnitType + "ToPx"];
										}
									}
								}

								/*********************
								 Relative Values
								 *********************/

								/* Operator logic must be performed last since it requires unit-normalized start and end values. */
								/* Note: Relative *percent values* do not behave how most people think; while one would expect "+=50%"
								 to increase the property 1.5x its current value, it in fact increases the percent units in absolute terms:
								 50 points is added on top of the current % value. */
								switch (operator) {
									case "+":
										endValue = startValue + endValue;
										break;

									case "-":
										endValue = startValue - endValue;
										break;

									case "*":
										endValue = startValue * endValue;
										break;

									case "/":
										endValue = startValue / endValue;
										break;
								}

								/**************************
								 tweensContainer Push
								 **************************/

								/* Construct the per-property tween object, and push it to the element's tweensContainer. */
								tweensContainer[property] = {
									rootPropertyValue: rootPropertyValue,
									startValue: startValue,
									currentValue: startValue,
									endValue: endValue,
									unitType: endValueUnitType,
									easing: easing
								};
								if (pattern) {
									tweensContainer[property].pattern = pattern;
								}

								if (Velocity.debug) {
									console.log("tweensContainer (" + property + "): " + JSON.stringify(tweensContainer[property]), element);
								}
							};

							/* Create a tween out of each property, and append its associated data to tweensContainer. */
							for (var property in propertiesMap) {

								if (!propertiesMap.hasOwnProperty(property)) {
									continue;
								}
								/* The original property name's format must be used for the parsePropertyValue() lookup,
								 but we then use its camelCase styling to normalize it for manipulation. */
								var propertyName = CSS.Names.camelCase(property),
										valueData = parsePropertyValue(propertiesMap[property]);

								/* Find shorthand color properties that have been passed a hex string. */
								/* Would be quicker to use CSS.Lists.colors.includes() if possible */
								if (_inArray(CSS.Lists.colors)) {
									/* Parse the value data for each shorthand. */
									var endValue = valueData[0],
											easing = valueData[1],
											startValue = valueData[2];

									if (CSS.RegEx.isHex.test(endValue)) {
										/* Convert the hex strings into their RGB component arrays. */
										var colorComponents = ["Red", "Green", "Blue"],
												endValueRGB = CSS.Values.hexToRgb(endValue),
												startValueRGB = startValue ? CSS.Values.hexToRgb(startValue) : undefined$1;

										/* Inject the RGB component tweens into propertiesMap. */
										for (var i = 0; i < colorComponents.length; i++) {
											var dataArray = [endValueRGB[i]];

											if (easing) {
												dataArray.push(easing);
											}

											if (startValueRGB !== undefined$1) {
												dataArray.push(startValueRGB[i]);
											}

											fixPropertyValue(propertyName + colorComponents[i], dataArray);
										}
										/* If we have replaced a shortcut color value then don't update the standard property name */
										continue;
									}
								}
								fixPropertyValue(propertyName, valueData);
							}

							/* Along with its property data, store a reference to the element itself onto tweensContainer. */
							tweensContainer.element = element;
						}

						/*****************
						 Call Push
						 *****************/

						/* Note: tweensContainer can be empty if all of the properties in this call's property map were skipped due to not
						 being supported by the browser. The element property is used for checking that the tweensContainer has been appended to. */
						if (tweensContainer.element) {
							/* Apply the "velocity-animating" indicator class. */
							CSS.Values.addClass(element, "velocity-animating");

							/* The call array houses the tweensContainers for each element being animated in the current call. */
							call.push(tweensContainer);

							data = Data(element);

							if (data) {
								/* Store the tweensContainer and options if we're working on the default effects queue, so that they can be used by the reverse command. */
								if (opts.queue === "") {

									data.tweensContainer = tweensContainer;
									data.opts = opts;
								}

								/* Switch on the element's animating flag. */
								data.isAnimating = true;
							}

							/* Once the final element in this call's element set has been processed, push the call array onto
							 Velocity.State.calls for the animation tick to immediately begin processing. */
							if (elementsIndex === elementsLength - 1) {
								/* Add the current call plus its associated metadata (the element set and the call's options) onto the global call container.
								 Anything on this call container is subjected to tick() processing. */
								Velocity.State.calls.push([call, elements, opts, null, promiseData.resolver, null, 0]);

								/* If the animation tick isn't running, start it. (Velocity shuts it off when there are no active calls to process.) */
								if (Velocity.State.isTicking === false) {
									Velocity.State.isTicking = true;

									/* Start the tick loop. */
									tick();
								}
							} else {
								elementsIndex++;
							}
						}
					}

					/* When the queue option is set to false, the call skips the element's queue and fires immediately. */
					if (opts.queue === false) {
						/* Since this buildQueue call doesn't respect the element's existing queue (which is where a delay option would have been appended),
						 we manually inject the delay property here with an explicit setTimeout. */
						if (opts.delay) {

							/* Temporarily store delayed elements to facilitate access for global pause/resume */
							var callIndex = Velocity.State.delayedElements.count++;
							Velocity.State.delayedElements[callIndex] = element;

							var delayComplete = (function(index) {
								return function() {
									/* Clear the temporary element */
									Velocity.State.delayedElements[index] = false;

									/* Finally, issue the call */
									buildQueue();
								};
							})(callIndex);

							Data(element).delayBegin = (new Date()).getTime();
							Data(element).delay = parseFloat(opts.delay);
							Data(element).delayTimer = {
								setTimeout: setTimeout(buildQueue, parseFloat(opts.delay)),
								next: delayComplete
							};
						} else {
							buildQueue();
						}
						/* Otherwise, the call undergoes element queueing as normal. */
						/* Note: To interoperate with jQuery, Velocity uses jQuery's own $.queue() stack for queuing logic. */
					} else {
						$.queue(element, opts.queue, function(next, clearQueue) {
							/* If the clearQueue flag was passed in by the stop command, resolve this call's promise. (Promises can only be resolved once,
							 so it's fine if this is repeatedly triggered for each element in the associated call.) */
							if (clearQueue === true) {
								if (promiseData.promise) {
									promiseData.resolver(elements);
								}

								/* Do not continue with animation queueing. */
								return true;
							}

							/* This flag indicates to the upcoming completeCall() function that this queue entry was initiated by Velocity.
							 See completeCall() for further details. */
							Velocity.velocityQueueEntryFlag = true;

							buildQueue();
						});
					}

					/*********************
					 Auto-Dequeuing
					 *********************/

					/* As per jQuery's $.queue() behavior, to fire the first non-custom-queue entry on an element, the element
					 must be dequeued if its queue stack consists *solely* of the current call. (This can be determined by checking
					 for the "inprogress" item that jQuery prepends to active queue stack arrays.) Regardless, whenever the element's
					 queue is further appended with additional items -- including $.delay()'s or even $.animate() calls, the queue's
					 first entry is automatically fired. This behavior contrasts that of custom queues, which never auto-fire. */
					/* Note: When an element set is being subjected to a non-parallel Velocity call, the animation will not begin until
					 each one of the elements in the set has reached the end of its individually pre-existing queue chain. */
					/* Note: Unfortunately, most people don't fully grasp jQuery's powerful, yet quirky, $.queue() function.
					 Lean more here: http://stackoverflow.com/questions/1058158/can-somebody-explain-jquery-queue-to-me */
					if ((opts.queue === "" || opts.queue === "fx") && $.queue(element)[0] !== "inprogress") {
						$.dequeue(element);
					}
				}

				/**************************
				 Element Set Iteration
				 **************************/

				/* If the "nodeType" property exists on the elements variable, we're animating a single element.
				 Place it in an array so that $.each() can iterate over it. */
				$.each(elements, function(i, element) {
					/* Ensure each element in a set has a nodeType (is a real element) to avoid throwing errors. */
					if (Type.isNode(element)) {
						processElement(element, i);
					}
				});

				/******************
				 Option: Loop
				 ******************/

				/* The loop option accepts an integer indicating how many times the element should loop between the values in the
				 current call's properties map and the element's property values prior to this call. */
				/* Note: The loop option's logic is performed here -- after element processing -- because the current call needs
				 to undergo its queue insertion prior to the loop option generating its series of constituent "reverse" calls,
				 which chain after the current call. Two reverse calls (two "alternations") constitute one loop. */
				opts = $.extend({}, Velocity.defaults, options);
				opts.loop = parseInt(opts.loop, 10);
				var reverseCallsCount = (opts.loop * 2) - 1;

				if (opts.loop) {
					/* Double the loop count to convert it into its appropriate number of "reverse" calls.
					 Subtract 1 from the resulting value since the current call is included in the total alternation count. */
					for (var x = 0; x < reverseCallsCount; x++) {
						/* Since the logic for the reverse action occurs inside Queueing and therefore this call's options object
						 isn't parsed until then as well, the current call's delay option must be explicitly passed into the reverse
						 call so that the delay logic that occurs inside *Pre-Queueing* can process it. */
						var reverseOptions = {
							delay: opts.delay,
							progress: opts.progress
						};

						/* If a complete callback was passed into this call, transfer it to the loop redirect's final "reverse" call
						 so that it's triggered when the entire redirect is complete (and not when the very first animation is complete). */
						if (x === reverseCallsCount - 1) {
							reverseOptions.display = opts.display;
							reverseOptions.visibility = opts.visibility;
							reverseOptions.complete = opts.complete;
						}

						animate(elements, "reverse", reverseOptions);
					}
				}

				/***************
				 Chaining
				 ***************/

				/* Return the elements back to the call chain, with wrapped elements taking precedence in case Velocity was called via the $.fn. extension. */
				return getChain();
			};

			/* Turn Velocity into the animation function, extended with the pre-existing Velocity object. */
			Velocity = $.extend(animate, Velocity);
			/* For legacy support, also expose the literal animate method. */
			Velocity.animate = animate;

			/**************
			 Timing
			 **************/

			/* Ticker function. */
			var ticker = window.requestAnimationFrame || rAFShim;

			/* Inactive browser tabs pause rAF, which results in all active animations immediately sprinting to their completion states when the tab refocuses.
			 To get around this, we dynamically switch rAF to setTimeout (which the browser *doesn't* pause) when the tab loses focus. We skip this for mobile
			 devices to avoid wasting battery power on inactive tabs. */
			/* Note: Tab focus detection doesn't work on older versions of IE, but that's okay since they don't support rAF to begin with. */
			if (!Velocity.State.isMobile && document.hidden !== undefined$1) {
				var updateTicker = function() {
					/* Reassign the rAF function (which the global tick() function uses) based on the tab's focus state. */
					if (document.hidden) {
						ticker = function(callback) {
							/* The tick function needs a truthy first argument in order to pass its internal timestamp check. */
							return setTimeout(function() {
								callback(true);
							}, 16);
						};

						/* The rAF loop has been paused by the browser, so we manually restart the tick. */
						tick();
					} else {
						ticker = window.requestAnimationFrame || rAFShim;
					}
				};

				/* Page could be sitting in the background at this time (i.e. opened as new tab) so making sure we use correct ticker from the start */
				updateTicker();

				/* And then run check again every time visibility changes */
				document.addEventListener("visibilitychange", updateTicker);
			}

			/************
			 Tick
			 ************/

			/* Note: All calls to Velocity are pushed to the Velocity.State.calls array, which is fully iterated through upon each tick. */
			function tick(timestamp) {
				/* An empty timestamp argument indicates that this is the first tick occurence since ticking was turned on.
				 We leverage this metadata to fully ignore the first tick pass since RAF's initial pass is fired whenever
				 the browser's next tick sync time occurs, which results in the first elements subjected to Velocity
				 calls being animated out of sync with any elements animated immediately thereafter. In short, we ignore
				 the first RAF tick pass so that elements being immediately consecutively animated -- instead of simultaneously animated
				 by the same Velocity call -- are properly batched into the same initial RAF tick and consequently remain in sync thereafter. */
				if (timestamp) {
					/* We normally use RAF's high resolution timestamp but as it can be significantly offset when the browser is
					 under high stress we give the option for choppiness over allowing the browser to drop huge chunks of frames.
					 We use performance.now() and shim it if it doesn't exist for when the tab is hidden. */
					var timeCurrent = Velocity.timestamp && timestamp !== true ? timestamp : performance.now();

					/********************
					 Call Iteration
					 ********************/

					var callsLength = Velocity.State.calls.length;

					/* To speed up iterating over this array, it is compacted (falsey items -- calls that have completed -- are removed)
					 when its length has ballooned to a point that can impact tick performance. This only becomes necessary when animation
					 has been continuous with many elements over a long period of time; whenever all active calls are completed, completeCall() clears Velocity.State.calls. */
					if (callsLength > 10000) {
						Velocity.State.calls = compactSparseArray(Velocity.State.calls);
						callsLength = Velocity.State.calls.length;
					}

					/* Iterate through each active call. */
					for (var i = 0; i < callsLength; i++) {
						/* When a Velocity call is completed, its Velocity.State.calls entry is set to false. Continue on to the next call. */
						if (!Velocity.State.calls[i]) {
							continue;
						}

						/************************
						 Call-Wide Variables
						 ************************/

						var callContainer = Velocity.State.calls[i],
								call = callContainer[0],
								opts = callContainer[2],
								timeStart = callContainer[3],
								firstTick = !timeStart,
								tweenDummyValue = null,
								pauseObject = callContainer[5],
								millisecondsEllapsed = callContainer[6];



						/* If timeStart is undefined, then this is the first time that this call has been processed by tick().
						 We assign timeStart now so that its value is as close to the real animation start time as possible.
						 (Conversely, had timeStart been defined when this call was added to Velocity.State.calls, the delay
						 between that time and now would cause the first few frames of the tween to be skipped since
						 percentComplete is calculated relative to timeStart.) */
						/* Further, subtract 16ms (the approximate resolution of RAF) from the current time value so that the
						 first tick iteration isn't wasted by animating at 0% tween completion, which would produce the
						 same style value as the element's current value. */
						if (!timeStart) {
							timeStart = Velocity.State.calls[i][3] = timeCurrent - 16;
						}

						/* If a pause object is present, skip processing unless it has been set to resume */
						if (pauseObject) {
							if (pauseObject.resume === true) {
								/* Update the time start to accomodate the paused completion amount */
								timeStart = callContainer[3] = Math.round(timeCurrent - millisecondsEllapsed - 16);

								/* Remove pause object after processing */
								callContainer[5] = null;
							} else {
								continue;
							}
						}

						millisecondsEllapsed = callContainer[6] = timeCurrent - timeStart;

						/* The tween's completion percentage is relative to the tween's start time, not the tween's start value
						 (which would result in unpredictable tween durations since JavaScript's timers are not particularly accurate).
						 Accordingly, we ensure that percentComplete does not exceed 1. */
						var percentComplete = Math.min((millisecondsEllapsed) / opts.duration, 1);

						/**********************
						 Element Iteration
						 **********************/

						/* For every call, iterate through each of the elements in its set. */
						for (var j = 0, callLength = call.length; j < callLength; j++) {
							var tweensContainer = call[j],
									element = tweensContainer.element;

							/* Check to see if this element has been deleted midway through the animation by checking for the
							 continued existence of its data cache. If it's gone, or the element is currently paused, skip animating this element. */
							if (!Data(element)) {
								continue;
							}

							var transformPropertyExists = false;

							/**********************************
							 Display & Visibility Toggling
							 **********************************/

							/* If the display option is set to non-"none", set it upfront so that the element can become visible before tweening begins.
							 (Otherwise, display's "none" value is set in completeCall() once the animation has completed.) */
							if (opts.display !== undefined$1 && opts.display !== null && opts.display !== "none") {
								if (opts.display === "flex") {
									var flexValues = ["-webkit-box", "-moz-box", "-ms-flexbox", "-webkit-flex"];

									$.each(flexValues, function(i, flexValue) {
										CSS.setPropertyValue(element, "display", flexValue);
									});
								}

								CSS.setPropertyValue(element, "display", opts.display);
							}

							/* Same goes with the visibility option, but its "none" equivalent is "hidden". */
							if (opts.visibility !== undefined$1 && opts.visibility !== "hidden") {
								CSS.setPropertyValue(element, "visibility", opts.visibility);
							}

							/************************
							 Property Iteration
							 ************************/

							/* For every element, iterate through each property. */
							for (var property in tweensContainer) {
								/* Note: In addition to property tween data, tweensContainer contains a reference to its associated element. */
								if (tweensContainer.hasOwnProperty(property) && property !== "element") {
									var tween = tweensContainer[property],
											currentValue,
											/* Easing can either be a pre-genereated function or a string that references a pre-registered easing
											 on the Velocity.Easings object. In either case, return the appropriate easing *function*. */
											easing = Type.isString(tween.easing) ? Velocity.Easings[tween.easing] : tween.easing;

									/******************************
									 Current Value Calculation
									 ******************************/

									if (Type.isString(tween.pattern)) {
										var patternReplace = percentComplete === 1 ?
												function($0, index, round) {
													var result = tween.endValue[index];

													return round ? Math.round(result) : result;
												} :
												function($0, index, round) {
													var startValue = tween.startValue[index],
															tweenDelta = tween.endValue[index] - startValue,
															result = startValue + (tweenDelta * easing(percentComplete, opts, tweenDelta));

													return round ? Math.round(result) : result;
												};

										currentValue = tween.pattern.replace(/{(\d+)(!)?}/g, patternReplace);
									} else if (percentComplete === 1) {
										/* If this is the last tick pass (if we've reached 100% completion for this tween),
										 ensure that currentValue is explicitly set to its target endValue so that it's not subjected to any rounding. */
										currentValue = tween.endValue;
									} else {
										/* Otherwise, calculate currentValue based on the current delta from startValue. */
										var tweenDelta = tween.endValue - tween.startValue;

										currentValue = tween.startValue + (tweenDelta * easing(percentComplete, opts, tweenDelta));
										/* If no value change is occurring, don't proceed with DOM updating. */
									}
									if (!firstTick && (currentValue === tween.currentValue)) {
										continue;
									}

									tween.currentValue = currentValue;

									/* If we're tweening a fake 'tween' property in order to log transition values, update the one-per-call variable so that
									 it can be passed into the progress callback. */
									if (property === "tween") {
										tweenDummyValue = currentValue;
									} else {
										/******************
										 Hooks: Part I
										 ******************/
										var hookRoot;

										/* For hooked properties, the newly-updated rootPropertyValueCache is cached onto the element so that it can be used
										 for subsequent hooks in this call that are associated with the same root property. If we didn't cache the updated
										 rootPropertyValue, each subsequent update to the root property in this tick pass would reset the previous hook's
										 updates to rootPropertyValue prior to injection. A nice performance byproduct of rootPropertyValue caching is that
										 subsequently chained animations using the same hookRoot but a different hook can use this cached rootPropertyValue. */
										if (CSS.Hooks.registered[property]) {
											hookRoot = CSS.Hooks.getRoot(property);

											var rootPropertyValueCache = Data(element).rootPropertyValueCache[hookRoot];

											if (rootPropertyValueCache) {
												tween.rootPropertyValue = rootPropertyValueCache;
											}
										}

										/*****************
										 DOM Update
										 *****************/

										/* setPropertyValue() returns an array of the property name and property value post any normalization that may have been performed. */
										/* Note: To solve an IE<=8 positioning bug, the unit type is dropped when setting a property value of 0. */
										var adjustedSetData = CSS.setPropertyValue(element, /* SET */
												property,
												tween.currentValue + (IE < 9 && parseFloat(currentValue) === 0 ? "" : tween.unitType),
												tween.rootPropertyValue,
												tween.scrollData);

										/*******************
										 Hooks: Part II
										 *******************/

										/* Now that we have the hook's updated rootPropertyValue (the post-processed value provided by adjustedSetData), cache it onto the element. */
										if (CSS.Hooks.registered[property]) {
											/* Since adjustedSetData contains normalized data ready for DOM updating, the rootPropertyValue needs to be re-extracted from its normalized form. ?? */
											if (CSS.Normalizations.registered[hookRoot]) {
												Data(element).rootPropertyValueCache[hookRoot] = CSS.Normalizations.registered[hookRoot]("extract", null, adjustedSetData[1]);
											} else {
												Data(element).rootPropertyValueCache[hookRoot] = adjustedSetData[1];
											}
										}

										/***************
										 Transforms
										 ***************/

										/* Flag whether a transform property is being animated so that flushTransformCache() can be triggered once this tick pass is complete. */
										if (adjustedSetData[0] === "transform") {
											transformPropertyExists = true;
										}

									}
								}
							}

							/****************
							 mobileHA
							 ****************/

							/* If mobileHA is enabled, set the translate3d transform to null to force hardware acceleration.
							 It's safe to override this property since Velocity doesn't actually support its animation (hooks are used in its place). */
							if (opts.mobileHA) {
								/* Don't set the null transform hack if we've already done so. */
								if (Data(element).transformCache.translate3d === undefined$1) {
									/* All entries on the transformCache object are later concatenated into a single transform string via flushTransformCache(). */
									Data(element).transformCache.translate3d = "(0px, 0px, 0px)";

									transformPropertyExists = true;
								}
							}

							if (transformPropertyExists) {
								CSS.flushTransformCache(element);
							}
						}

						/* The non-"none" display value is only applied to an element once -- when its associated call is first ticked through.
						 Accordingly, it's set to false so that it isn't re-processed by this call in the next tick. */
						if (opts.display !== undefined$1 && opts.display !== "none") {
							Velocity.State.calls[i][2].display = false;
						}
						if (opts.visibility !== undefined$1 && opts.visibility !== "hidden") {
							Velocity.State.calls[i][2].visibility = false;
						}

						/* Pass the elements and the timing data (percentComplete, msRemaining, timeStart, tweenDummyValue) into the progress callback. */
						if (opts.progress) {
							opts.progress.call(callContainer[1],
									callContainer[1],
									percentComplete,
									Math.max(0, (timeStart + opts.duration) - timeCurrent),
									timeStart,
									tweenDummyValue);
						}

						/* If this call has finished tweening, pass its index to completeCall() to handle call cleanup. */
						if (percentComplete === 1) {
							completeCall(i);
						}
					}
				}

				/* Note: completeCall() sets the isTicking flag to false when the last call on Velocity.State.calls has completed. */
				if (Velocity.State.isTicking) {
					ticker(tick);
				}
			}

			/**********************
			 Call Completion
			 **********************/

			/* Note: Unlike tick(), which processes all active calls at once, call completion is handled on a per-call basis. */
			function completeCall(callIndex, isStopped) {
				/* Ensure the call exists. */
				if (!Velocity.State.calls[callIndex]) {
					return false;
				}

				/* Pull the metadata from the call. */
				var call = Velocity.State.calls[callIndex][0],
						elements = Velocity.State.calls[callIndex][1],
						opts = Velocity.State.calls[callIndex][2],
						resolver = Velocity.State.calls[callIndex][4];

				var remainingCallsExist = false;

				/*************************
				 Element Finalization
				 *************************/

				for (var i = 0, callLength = call.length; i < callLength; i++) {
					var element = call[i].element;

					/* If the user set display to "none" (intending to hide the element), set it now that the animation has completed. */
					/* Note: display:none isn't set when calls are manually stopped (via Velocity("stop"). */
					/* Note: Display gets ignored with "reverse" calls and infinite loops, since this behavior would be undesirable. */
					if (!isStopped && !opts.loop) {
						if (opts.display === "none") {
							CSS.setPropertyValue(element, "display", opts.display);
						}

						if (opts.visibility === "hidden") {
							CSS.setPropertyValue(element, "visibility", opts.visibility);
						}
					}

					/* If the element's queue is empty (if only the "inprogress" item is left at position 0) or if its queue is about to run
					 a non-Velocity-initiated entry, turn off the isAnimating flag. A non-Velocity-initiatied queue entry's logic might alter
					 an element's CSS values and thereby cause Velocity's cached value data to go stale. To detect if a queue entry was initiated by Velocity,
					 we check for the existence of our special Velocity.queueEntryFlag declaration, which minifiers won't rename since the flag
					 is assigned to jQuery's global $ object and thus exists out of Velocity's own scope. */
					var data = Data(element);

					if (opts.loop !== true && ($.queue(element)[1] === undefined$1 || !/\.velocityQueueEntryFlag/i.test($.queue(element)[1]))) {
						/* The element may have been deleted. Ensure that its data cache still exists before acting on it. */
						if (data) {
							data.isAnimating = false;
							/* Clear the element's rootPropertyValueCache, which will become stale. */
							data.rootPropertyValueCache = {};

							var transformHAPropertyExists = false;
							/* If any 3D transform subproperty is at its default value (regardless of unit type), remove it. */
							$.each(CSS.Lists.transforms3D, function(i, transformName) {
								var defaultValue = /^scale/.test(transformName) ? 1 : 0,
										currentValue = data.transformCache[transformName];

								if (data.transformCache[transformName] !== undefined$1 && new RegExp("^\\(" + defaultValue + "[^.]").test(currentValue)) {
									transformHAPropertyExists = true;

									delete data.transformCache[transformName];
								}
							});

							/* Mobile devices have hardware acceleration removed at the end of the animation in order to avoid hogging the GPU's memory. */
							if (opts.mobileHA) {
								transformHAPropertyExists = true;
								delete data.transformCache.translate3d;
							}

							/* Flush the subproperty removals to the DOM. */
							if (transformHAPropertyExists) {
								CSS.flushTransformCache(element);
							}

							/* Remove the "velocity-animating" indicator class. */
							CSS.Values.removeClass(element, "velocity-animating");
						}
					}

					/*********************
					 Option: Complete
					 *********************/

					/* Complete is fired once per call (not once per element) and is passed the full raw DOM element set as both its context and its first argument. */
					/* Note: Callbacks aren't fired when calls are manually stopped (via Velocity("stop"). */
					if (!isStopped && opts.complete && !opts.loop && (i === callLength - 1)) {
						/* We throw callbacks in a setTimeout so that thrown errors don't halt the execution of Velocity itself. */
						try {
							opts.complete.call(elements, elements);
						} catch (error) {
							setTimeout(function() {
								throw error;
							}, 1);
						}
					}

					/**********************
					 Promise Resolving
					 **********************/

					/* Note: Infinite loops don't return promises. */
					if (resolver && opts.loop !== true) {
						resolver(elements);
					}

					/****************************
					 Option: Loop (Infinite)
					 ****************************/

					if (data && opts.loop === true && !isStopped) {
						/* If a rotateX/Y/Z property is being animated by 360 deg with loop:true, swap tween start/end values to enable
						 continuous iterative rotation looping. (Otherise, the element would just rotate back and forth.) */
						$.each(data.tweensContainer, function(propertyName, tweenContainer) {
							if (/^rotate/.test(propertyName) && ((parseFloat(tweenContainer.startValue) - parseFloat(tweenContainer.endValue)) % 360 === 0)) {
								var oldStartValue = tweenContainer.startValue;

								tweenContainer.startValue = tweenContainer.endValue;
								tweenContainer.endValue = oldStartValue;
							}

							if (/^backgroundPosition/.test(propertyName) && parseFloat(tweenContainer.endValue) === 100 && tweenContainer.unitType === "%") {
								tweenContainer.endValue = 0;
								tweenContainer.startValue = 100;
							}
						});

						Velocity(element, "reverse", {loop: true, delay: opts.delay});
					}

					/***************
					 Dequeueing
					 ***************/

					/* Fire the next call in the queue so long as this call's queue wasn't set to false (to trigger a parallel animation),
					 which would have already caused the next call to fire. Note: Even if the end of the animation queue has been reached,
					 $.dequeue() must still be called in order to completely clear jQuery's animation queue. */
					if (opts.queue !== false) {
						$.dequeue(element, opts.queue);
					}
				}

				/************************
				 Calls Array Cleanup
				 ************************/

				/* Since this call is complete, set it to false so that the rAF tick skips it. This array is later compacted via compactSparseArray().
				 (For performance reasons, the call is set to false instead of being deleted from the array: http://www.html5rocks.com/en/tutorials/speed/v8/) */
				Velocity.State.calls[callIndex] = false;

				/* Iterate through the calls array to determine if this was the final in-progress animation.
				 If so, set a flag to end ticking and clear the calls array. */
				for (var j = 0, callsLength = Velocity.State.calls.length; j < callsLength; j++) {
					if (Velocity.State.calls[j] !== false) {
						remainingCallsExist = true;

						break;
					}
				}

				if (remainingCallsExist === false) {
					/* tick() will detect this flag upon its next iteration and subsequently turn itself off. */
					Velocity.State.isTicking = false;

					/* Clear the calls array so that its length is reset. */
					delete Velocity.State.calls;
					Velocity.State.calls = [];
				}
			}

			/******************
			 Frameworks
			 ******************/

			/* Both jQuery and Zepto allow their $.fn object to be extended to allow wrapped elements to be subjected to plugin calls.
			 If either framework is loaded, register a "velocity" extension pointing to Velocity's core animate() method.  Velocity
			 also registers itself onto a global container (window.jQuery || window.Zepto || window) so that certain features are
			 accessible beyond just a per-element scope. This master object contains an .animate() method, which is later assigned to $.fn
			 (if jQuery or Zepto are present). Accordingly, Velocity can both act on wrapped DOM elements and stand alone for targeting raw DOM elements. */
			global.Velocity = Velocity;

			if (global !== window) {
				/* Assign the element function to Velocity's core animate() method. */
				global.fn.velocity = animate;
				/* Assign the object function's defaults to Velocity's global defaults object. */
				global.fn.velocity.defaults = Velocity.defaults;
			}

			/***********************
			 Packaged Redirects
			 ***********************/

			/* slideUp, slideDown */
			$.each(["Down", "Up"], function(i, direction) {
				Velocity.Redirects["slide" + direction] = function(element, options, elementsIndex, elementsSize, elements, promiseData) {
					var opts = $.extend({}, options),
							begin = opts.begin,
							complete = opts.complete,
							inlineValues = {},
							computedValues = {height: "", marginTop: "", marginBottom: "", paddingTop: "", paddingBottom: ""};

					if (opts.display === undefined$1) {
						/* Show the element before slideDown begins and hide the element after slideUp completes. */
						/* Note: Inline elements cannot have dimensions animated, so they're reverted to inline-block. */
						opts.display = (direction === "Down" ? (Velocity.CSS.Values.getDisplayType(element) === "inline" ? "inline-block" : "block") : "none");
					}

					opts.begin = function() {
						/* If the user passed in a begin callback, fire it now. */
						if (elementsIndex === 0 && begin) {
							begin.call(elements, elements);
						}

						/* Cache the elements' original vertical dimensional property values so that we can animate back to them. */
						for (var property in computedValues) {
							if (!computedValues.hasOwnProperty(property)) {
								continue;
							}
							inlineValues[property] = element.style[property];

							/* For slideDown, use forcefeeding to animate all vertical properties from 0. For slideUp,
							 use forcefeeding to start from computed values and animate down to 0. */
							var propertyValue = CSS.getPropertyValue(element, property);
							computedValues[property] = (direction === "Down") ? [propertyValue, 0] : [0, propertyValue];
						}

						/* Force vertical overflow content to clip so that sliding works as expected. */
						inlineValues.overflow = element.style.overflow;
						element.style.overflow = "hidden";
					};

					opts.complete = function() {
						/* Reset element to its pre-slide inline values once its slide animation is complete. */
						for (var property in inlineValues) {
							if (inlineValues.hasOwnProperty(property)) {
								element.style[property] = inlineValues[property];
							}
						}

						/* If the user passed in a complete callback, fire it now. */
						if (elementsIndex === elementsSize - 1) {
							if (complete) {
								complete.call(elements, elements);
							}
							if (promiseData) {
								promiseData.resolver(elements);
							}
						}
					};

					Velocity(element, computedValues, opts);
				};
			});

			/* fadeIn, fadeOut */
			$.each(["In", "Out"], function(i, direction) {
				Velocity.Redirects["fade" + direction] = function(element, options, elementsIndex, elementsSize, elements, promiseData) {
					var opts = $.extend({}, options),
							complete = opts.complete,
							propertiesMap = {opacity: (direction === "In") ? 1 : 0};

					/* Since redirects are triggered individually for each element in the animated set, avoid repeatedly triggering
					 callbacks by firing them only when the final element has been reached. */
					if (elementsIndex !== 0) {
						opts.begin = null;
					}
					if (elementsIndex !== elementsSize - 1) {
						opts.complete = null;
					} else {
						opts.complete = function() {
							if (complete) {
								complete.call(elements, elements);
							}
							if (promiseData) {
								promiseData.resolver(elements);
							}
						};
					}

					/* If a display was passed in, use it. Otherwise, default to "none" for fadeOut or the element-specific default for fadeIn. */
					/* Note: We allow users to pass in "null" to skip display setting altogether. */
					if (opts.display === undefined$1) {
						opts.display = (direction === "In" ? "auto" : "none");
					}

					Velocity(this, propertiesMap, opts);
				};
			});

			return Velocity;
		}((window.jQuery || window.Zepto || window), window, (window ? window.document : undefined));
	}));

	/******************
	 Known Issues
	 ******************/

	/* The CSS spec mandates that the translateX/Y/Z transforms are %-relative to the element itself -- not its parent.
	 Velocity, however, doesn't make this distinction. Thus, converting to or from the % unit with these subproperties
	 will produce an inaccurate conversion value. The same issue exists with the cx/cy attributes of SVG circles and ellipses. */ 
} (velocity));

var velocityExports = velocity.exports;
const s$6 = /*@__PURE__*/getDefaultExportFromCjs(velocityExports);

let t$4=null,a$7=null,e$5=async()=>{let a=0;try{let t=await fetch("/cart.js");for(let e of (await t.json()).items){let t=e.properties?._gift_set;if(t){let e=t.match(/^gift-set-(\d+)$/);e&&(a=Math.max(a,parseInt(e[1],10)));}}}catch{}t$4=a;};const getNextGiftSetId=async()=>(null===t$4&&(a$7||(a$7=(async()=>{try{await e$5();}finally{a$7=null;}})()),await a$7),`gift-set-${String(++t$4).padStart(3,"0")}`);

let d$8=reactExports.createContext();const MinicartProvider=({children:e})=>{let[n,l]=reactExports.useState(false),[u,p]=reactExports.useState({items:[],item_count:0,total_price:0,items_subtotal_price:0,note:""}),[y,m]=reactExports.useState(0),[w,f]=reactExports.useState(0),[_,h]=reactExports.useState(0),[g,v]=reactExports.useState(0),[S,j]=reactExports.useState(false),[k,b]=reactExports.useState(""),[E,q]=reactExports.useState([]),[O,T]=reactExports.useState(null),[L,x]=reactExports.useState(false),[N,P]=reactExports.useState("/cart"===window.location.pathname),[B,C]=reactExports.useState(null),[J,A]=reactExports.useState(false),[U,F]=reactExports.useState(false),[W,D]=reactExports.useState(false),[I,M]=reactExports.useState(false),R=reactExports.useRef(null),X=reactExports.useRef(null),$=reactExports.useRef(null),G=reactExports.useRef(null),H=window.giftWrap?.variants?.[0].id,z=()=>{Q(),R.current&&s$6(R.current,{opacity:1},{duration:200}),X.current&&s$6(X.current,{translateX:[0,"100%"]},{duration:100,easing:"easeOut"}),l(true);},K=()=>{R.current&&s$6(R.current,{opacity:0},{duration:200}),X.current&&s$6(X.current,{translateX:["100%",0]},{duration:300,easing:"easeIn"});let t=document.querySelector(".minicart_wrapper");t&&(t.classList.remove("opacity-100","!block","pointer-events-auto"),t.classList.add("opacity-0","hidden","pointer-events-none")),N&&(window.history.replaceState({},"","/"),window.location.reload(),P(false)),l(false);},Q=async(t=true)=>{let e,r;t&&j(true);let a=false;try{e=await fetch("/cart?view=extra-details"),r=await e.json();}catch{console.error("Failed to load /cart?view=extra-details. Falling back to default /cart.js API."),a=true;}try{if(a){if(!(e=await fetch("/cart.js")).ok)throw Error(`Failed to load cart data. Status code: ${e.status}. ${e.statusText}`);r=await e.json();}r.items=r.items.map(t=>{let e=r.extra_details?.[t.key];return e?{...t,gift_box:e.gift_box,compare_at_price:e.compare_at_price}:t}),p(r),window.dispatchEvent(new CustomEvent("cart:count:update",{detail:{count:r.item_count}}));}catch(t){console.error(t);}j(false);},V=reactExports.useCallback(async(t,e,r)=>{if(!t.properties._gift_box_variant_id&&!L){x(true);try{let a=crypto.randomUUID(),i={id:t.key,quantity:t.quantity,properties:{...t.properties,_uuid:a,_gift_box_variant_id:e,"With Gift Box":r}},o=await fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(i)});if(!o.ok){let t=await o.json();throw Error(t)}let n={_hide_in_minicart:!0};t.properties.Status&&(n.Status=t.properties.Status),t.properties.Backorder&&(n.Backorder=t.properties.Backorder);let s=await fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({id:e,properties:n,quantity:1})});if(!s.ok){let t=await s.json();throw Error(t)}await Q(!1);}catch(e){let t=`Error adding to cart: ${e?.message||e||"Unknown error"}`;console.error(t),alert(t);}x(false);}},[L]),Y=reactExports.useCallback(async t=>{if(!L){x(true);try{let e,r={...t.properties};if(delete r._uuid,delete r._gift_box_variant_id,delete r["With Gift Box"],0===Object.keys(r).length){if(!(e=await fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({id:t.key,quantity:0})})).ok){let t=await e.json();throw Error(t)}e=await fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json","X-Requested-With":"XMLHttpRequest"},body:JSON.stringify({id:t.variant_id,quantity:t.quantity})});}else e=await fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({id:t.key,quantity:t.quantity,properties:r})});if(!e.ok){let t=await e.json();throw Error(t)}let a=ti(t);if(a){let t={id:a.key,quantity:a.quantity-1},e=await fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(t)}),r=await e.json();if(!e.ok)throw Error(r)}await Q(!1);}catch(e){let t=`Error updating cart: ${e?.message||e||"Unknown error"}`;console.error(t),alert(t);}x(false);}},[u,L]),Z=reactExports.useCallback(async(t,e)=>{if(!L){x(true);try{if(t.properties?._gift_set&&e>t.quantity){let r=e-t.quantity,a=[];for(let e=0;e<r;e++)a.push({id:t.variant_id,quantity:1,properties:{...t.properties,_gift_set:await getNextGiftSetId()}});if(!(await fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({items:a})})).ok)throw Error("Failed to add gift set items")}else {let r={[t.key]:e};if(0===e&&t.properties._gift_box_variant_id){let e=ti(t);e&&(r[e.key]=e.quantity-1);}let a=await fetch("/cart/update.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({updates:r})});if(!a.ok)throw Error(a.status);let i=await a.json();1===i.item_count&&O&&await fetch("/cart/clear.js");}await Q();}catch(t){console.error(t);}x(false);}},[u,O,L]),tt=async t=>{try{let e=await fetch("/cart/update.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({note:t})});if(!e.ok)throw Error(e.status);let r=await e.json();b(r.note||"");}catch(t){console.error(t);}},te=async()=>{await ta("add");},tr=async()=>{await ta("remove");},ta=reactExports.useCallback(async t=>{if("add"===t&&O||"remove"===t&&!O||L)return;let e="add"===t?H:O;x(true);try{await fetch("add"===t?"/cart/add.js":"/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({id:e,properties:{_hide_in_minicart:!0},quantity:+("add"===t)})});}catch(t){console.error("Failing updating quantity of Gift Wrap",JSON.stringify(t));}await Q(false),x(false);},[O,L]),ti=reactExports.useCallback(t=>u.items.find(e=>!!t.properties.Status&&!!t.properties.Backorder&&e.properties.Status===t.properties.Status&&e.properties.Backorder===t.properties.Backorder&&e.variant_id===t.properties._gift_box_variant_id||e.variant_id===t.properties._gift_box_variant_id&&!e.properties.Status&&!e.properties.Backorder),[u]);reactExports.useEffect(()=>{if(H){let t=u.items.find(t=>t.variant_id===H);T(t?.key||null);}b(u.note||"");let t=u.items_subtotal_price??u.total_price;f(t),h(u.original_total_price),m(t/100),v(u.items.reduce((t,e)=>true===e.gift_card||e.product_type.toLowerCase().includes("gift card")?t:t+e.original_line_price,0));},[u]),reactExports.useEffect(()=>{!n&&N&&z();},[N]),reactExports.useEffect(()=>{window.__BANNER_DATA__&&q(window.__BANNER_DATA__.headerBanner);},[]),reactExports.useEffect(()=>{let t=document.querySelector("script[data-cart-drawer-blocks]");if(t){let e=JSON.parse(t.textContent);C(e),e?.tieredPromos&&e?.tieredPromos.tiers?.length&&window.customer?.isB2B!==true&&F(true),e?.freeShipping&&D(true),e?.supplementalMessaging&&M(true);}},[]),reactExports.useEffect(()=>(document.body.style.overflow=n?"hidden":"",()=>{document.body.style.overflow="";}),[n]),reactExports.useEffect(()=>{let t=document.querySelector(".minicart_wrapper");return $.current=document.querySelector("#gorgias-chat-container"),G.current=document.querySelector("#polaris-css-lockdown-container"),t&&(n?(t.classList.add("opacity-100","!block","pointer-events-auto"),t.classList.remove("hidden"),t.ariaHidden="false",document.body.style.overflow="hidden",$.current&&($.current.style.display="none"),G.current&&G.current.style.setProperty("display","none","important")):(t.classList.remove("opacity-100","!block","pointer-events-auto"),t.classList.add("hidden"),t.ariaHidden="true",document.body.style.overflow="",$.current&&($.current.style.display=null),G.current&&(G.current.style.display=null))),()=>{t&&(t.classList.remove("opacity-100","pointer-events-auto"),document.body.style.overflow="",$.current&&($.current.style.display=null),G.current&&(G.current.style.display=null));}},[n]);let to=reactExports.useRef(n);reactExports.useEffect(()=>{to.current=n;},[n]);let tn=reactExports.useRef(z),ts=reactExports.useRef(Q);return reactExports.useEffect(()=>{tn.current=z,ts.current=Q;}),reactExports.useEffect(()=>{let t=()=>{tn.current();},e=()=>{ts.current(false);};return window.addEventListener("cartUpdated",t),window.addEventListener("productSuggestionAdded",e),window.addEventListener("regios-dopp:auto-add-to-cart:update",e),()=>{window.removeEventListener("cartUpdated",t),window.removeEventListener("productSuggestionAdded",e),window.removeEventListener("regios-dopp:auto-add-to-cart:update",e);}},[]),reactExports.useEffect(()=>{function t(t){let e=document.querySelector(".minicart_component");to.current&&e&&!e.contains(t.target)&&K();}return document.addEventListener("mousedown",t),()=>document.removeEventListener("mousedown",t)},[]),reactExports.useEffect(()=>{let t=t=>{(t.target.closest(".minicart-toggle")||t.target.closest("#minicart-toggle"))&&(t.preventDefault(),z());};return document.addEventListener("click",t),()=>document.removeEventListener("click",t)},[n]),reactExports.useEffect(()=>{let t=()=>{ts.current(false);};return document.addEventListener("rebuy:cart.change",t),()=>{document.removeEventListener("rebuy:cart.change",t);}},[]),jsxRuntimeExports.jsx(d$8.Provider,{value:{isCartOpen:n,cart:u,isLoading:S,responseGiftMsg:k,scrimRef:R,modalRef:X,subtotalCents:w,origSubtotalCents:_,bannerData:E,itemCount:u.item_count||0,subtotal:y,giftWrapInCart:O,cartUpdatesInProgress:L,cartBlocksData:B,tieredPromosSubtotal:g,showFreeShippingBadge:J,showTieredPromos:U,showFreeShipping:W,showSupplementalMessaging:I,updateCartNote:tt,openCart:z,closeCart:K,fetchCart:Q,updateQty:Z,addGiftboxToItem:V,removeGiftboxFromItem:Y,addGiftWrap:te,removeGiftWrap:tr,setShowFreeShippingBadge:A,setShowSupplementalMessaging:M},children:e})};const useMinicart=()=>reactExports.useContext(d$8);

/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver$1 = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver$1.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver$1;
})();

const ResizeObserver_es = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.defineProperty({
  __proto__: null,
  default: index
}, Symbol.toStringTag, { value: 'Module' }));

const require$$8 = /*@__PURE__*/getAugmentedNamespace(ResizeObserver_es);

var e$4,n$6=reactExports,t$3=(e$4=require$$8)&&"object"==typeof e$4&&"default"in e$4?e$4.default:e$4,r$3={debug:10,info:20,warn:30,error:40,none:100},i$5="undefined"!=typeof window&&window.document&&window.document.createElement?n$6.useLayoutEffect:n$6.useEffect;var dist=function(e){ void 0===e&&(e={});var o=e.logLevel;void 0===o&&(o="info");var c=e.maxFontSize;void 0===c&&(c=100);var f=e.minFontSize;void 0===f&&(f=20);var u=e.onFinish,a=e.onStart,s=e.resolution;void 0===s&&(s=5);var l=r$3[o],S=n$6.useCallback(function(){return {calcKey:0,fontSize:c,fontSizePrev:f,fontSizeMax:c,fontSizeMin:f}},[c,f]),d=n$6.useRef(null),v=n$6.useRef(),z=n$6.useRef(false),m=n$6.useState(S),w=m[0],M=m[1],h=w.calcKey,y=w.fontSize,x=w.fontSizeMax,b=w.fontSizeMin,g=w.fontSizePrev,F=null,K=n$6.useState(function(){return new t$3(function(){F=window.requestAnimationFrame(function(){z.current||(a&&a(),z.current=true,M(Object.assign({},S(),{calcKey:h+1})));});})})[0];n$6.useEffect(function(){return d.current&&K.observe(d.current),function(){F&&window.cancelAnimationFrame(F),K.disconnect();}},[F,K]);var E=d.current&&d.current.innerHTML;return n$6.useEffect(function(){0===h||z.current||(E!==v.current&&(a&&a(),M(Object.assign({},S(),{calcKey:h+1}))),v.current=E);},[h,S,E,a]),i$5(function(){if(0!==h){var e=Math.abs(y-g)<=s,n=!!d.current&&(d.current.scrollHeight>d.current.offsetHeight||d.current.scrollWidth>d.current.offsetWidth),t=y>g;if(e)n&&y===g?(z.current=false,l<=r$3.info&&console.info("[use-fit-text] reached `minFontSize = "+f+"` without fitting text")):n?M({fontSize:t?g:b,fontSizeMax:x,fontSizeMin:b,fontSizePrev:g,calcKey:h}):(z.current=false,u&&u(y));else {var i,o=x,c=b;n?(i=t?g-y:b-y,o=Math.min(x,y)):(i=t?x-y:g-y,c=Math.max(b,y)),M({calcKey:h,fontSize:y+i/2,fontSizeMax:o,fontSizeMin:c,fontSizePrev:y});}}},[h,y,x,b,g,u,d,s]),{fontSize:y+"%",ref:d}};


const s$5 = /*@__PURE__*/getDefaultExportFromCjs(dist);

const Lock=({elClass:C})=>jsxRuntimeExports.jsx("svg",{className:C,viewBox:"0 0 8 12",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:jsxRuntimeExports.jsx("path",{d:"M7.71874 4.6875H7.06249V3.81249C7.06249 2.12382 5.6887 0.75 4 0.75C2.3113 0.75 0.937507 2.12382 0.937507 3.81249V4.6875H0.281257C0.160343 4.6875 0.0625 4.78534 0.0625 4.90626V10.375C0.0625 10.8576 0.454917 11.25 0.937507 11.25H7.06251C7.54508 11.25 7.9375 10.8576 7.9375 10.375V4.90626C7.9375 4.78534 7.83966 4.6875 7.71874 4.6875ZM4.65498 9.25711C4.66181 9.31884 4.64196 9.38079 4.60051 9.42716C4.55906 9.47351 4.49967 9.50001 4.43751 9.50001H3.56251C3.50035 9.50001 3.44096 9.47351 3.39951 9.42716C3.35806 9.38082 3.33819 9.31886 3.34504 9.25711L3.48304 8.01618C3.25895 7.85319 3.12501 7.59534 3.12501 7.3125C3.12501 6.82993 3.51743 6.43749 4.00002 6.43749C4.48261 6.43749 4.87503 6.82991 4.87503 7.3125C4.87503 7.59534 4.74109 7.85319 4.517 8.01618L4.65498 9.25711ZM5.74999 4.6875H2.25001V3.81249C2.25001 2.84756 3.03507 2.0625 4 2.0625C4.96493 2.0625 5.74999 2.84756 5.74999 3.81249V4.6875Z",fill:"currentColor"})});const PrevArrow=({elClass:s})=>jsxRuntimeExports.jsxs("svg",{className:s,viewBox:"0 0 50 48",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[jsxRuntimeExports.jsxs("g",{clipPath:"url(#clip0)",children:[jsxRuntimeExports.jsx("path",{d:"M0 0H46C48.2091 0 50 1.79086 50 4V44C50 46.2091 48.2091 48 46 48H0V0Z",fill:"white",className:"hover:fill-royalBlue"}),jsxRuntimeExports.jsx("line",{y1:"-0.6",x2:"28",y2:"-0.6",transform:"matrix(-1 0 0 1 40 24.5)",stroke:"#14334C",strokeWidth:"1.2"}),jsxRuntimeExports.jsx("path",{d:"M12 23.5C14.6667 23.3333 20 21.2 20 14",stroke:"#14334C",strokeWidth:"1.2"}),jsxRuntimeExports.jsx("path",{d:"M12 24C14.6667 24.1667 20 26.3 20 33.5",stroke:"#14334C",strokeWidth:"1.2"})]}),jsxRuntimeExports.jsx("defs",{children:jsxRuntimeExports.jsx("clipPath",{id:"clip0",children:jsxRuntimeExports.jsx("path",{d:"M0 0H46C48.2091 0 50 1.79086 50 4V44C50 46.2091 48.2091 48 46 48H0V0Z",fill:"white"})})})]});const NextArrow=({elClass:s})=>jsxRuntimeExports.jsxs("svg",{className:s,viewBox:"0 0 50 48",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[jsxRuntimeExports.jsxs("g",{clipPath:"url(#clip0)",children:[jsxRuntimeExports.jsx("path",{d:"M50 0H4C1.79086 0 0 1.79086 0 4V44C0 46.2091 1.79086 48 4 48H50V0Z",fill:"white",className:"hover:fill-royalBlue"}),jsxRuntimeExports.jsx("line",{x1:"10",y1:"23.9",x2:"38",y2:"23.9",stroke:"#14334C",strokeWidth:"1.2"}),jsxRuntimeExports.jsx("path",{d:"M38 23.5C35.3333 23.3333 30 21.2 30 14",stroke:"#14334C",strokeWidth:"1.2"}),jsxRuntimeExports.jsx("path",{d:"M38 24C35.3333 24.1667 30 26.3 30 33.5",stroke:"#14334C",strokeWidth:"1.2"})]}),jsxRuntimeExports.jsx("defs",{children:jsxRuntimeExports.jsx("clipPath",{id:"clip0",children:jsxRuntimeExports.jsx("path",{d:"M50 0H4C1.79086 0 0 1.79086 0 4V44C0 46.2091 1.79086 48 4 48H50V0Z",fill:"white"})})})]});const NextThumnailArrow=({elClass:C})=>jsxRuntimeExports.jsx("svg",{fill:"#fff",className:C,xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 512 512",children:jsxRuntimeExports.jsx("path",{d:"M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"})});const NeedleIcon=({elClass:s,color:a="#3175B3"})=>jsxRuntimeExports.jsxs("svg",{className:s,viewBox:"0 0 15 19",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[jsxRuntimeExports.jsx("path",{d:"M12.0443 7.13232C12.1731 7.19763 12.2698 7.23028 12.4309 7.36089C13.0752 7.7527 13.5585 8.47104 13.6229 9.22203C13.6552 9.67915 13.5585 10.1363 13.3974 10.5607C13.2685 10.8546 13.1397 11.1811 12.8819 11.4097C12.6564 11.6382 12.302 11.7689 11.9798 11.7035C11.6577 11.6382 11.3677 11.3444 11.3999 11.0179C11.3999 10.7567 11.6254 10.5281 11.851 10.3648C12.4309 10.0057 13.2685 10.071 13.784 10.5281C14.2995 11.0179 14.4606 11.8342 14.1384 12.4872",stroke:a,strokeMiterlimit:"10"}),jsxRuntimeExports.jsx("path",{d:"M12.863 4.60598C12.3312 4.1083 11.5157 4.14385 11.0548 4.67707L0.543945 18.168L12.9339 6.41892C13.4303 5.8857 13.3949 5.0681 12.863 4.60598Z",stroke:a,strokeMiterlimit:"10",strokeLinejoin:"round"}),jsxRuntimeExports.jsx("path",{d:"M6.61235 1.10103C5.75573 1.36264 5.21963 2.3737 5.33864 3.27557C5.45766 4.17743 6.09899 4.97137 6.89267 5.39948C7.68635 5.8276 8.60995 5.98517 9.50079 6.00047C10.0947 6.01067 10.7035 5.95736 11.3063 6.07045C11.6271 6.11493 11.4724 6.04371 11.7708 6.18346",stroke:a,strokeMiterlimit:"10"}),jsxRuntimeExports.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M12.1966 5.3536C12.3809 5.54098 12.3809 5.84477 12.1966 6.03214L11.4625 6.77853C11.2782 6.9659 10.9794 6.9659 10.7951 6.77853C10.6109 6.59116 10.6109 6.28737 10.7951 6.09999L11.5292 5.3536C11.7135 5.16623 12.0123 5.16623 12.1966 5.3536Z",fill:a})]});const RegistryBowIcon=({elClass:s})=>jsxRuntimeExports.jsxs("svg",{className:s,width:"13",height:"8",viewBox:"0 0 13 8",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[jsxRuntimeExports.jsx("path",{d:"M6.28909 4.263C5.76234 2.69684 4.23475 -0.200525 2.33842 0.739164C-0.0319759 1.91378 3.91869 4.6545 6.28909 4.263Z",stroke:"currentColor",strokeWidth:"1.11111"}),jsxRuntimeExports.jsx("path",{d:"M6.29016 4.263C6.81692 2.69684 8.34456 -0.200525 10.2408 0.739164C12.6112 1.91378 8.66056 4.6545 6.29016 4.263Z",stroke:"currentColor",strokeWidth:"1.11111"}),jsxRuntimeExports.jsx("path",{d:"M12.2261 6.77605C10.9936 7.26482 8.0635 7.50494 6.20422 4.55566",stroke:"currentColor",strokeWidth:"1.11111"}),jsxRuntimeExports.jsx("path",{d:"M0.204792 6.77605C1.43731 7.26482 4.36741 7.50494 6.22668 4.55566",stroke:"currentColor",strokeWidth:"1.11111"})]});const GiftIcon=({elClass:C})=>jsxRuntimeExports.jsx("svg",{xmlns:"http://www.w3.org/2000/svg",fill:"none",viewBox:"0 0 18 20",className:C,children:jsxRuntimeExports.jsx("path",{fill:"currentColor",d:"M11.7499 6.01294C12.6425 5.0816 12.8599 4.01457 12.2543 3.4315C12.0309 3.21641 11.7278 3.10292 11.3772 3.10292C10.8229 3.10292 10.1701 3.39836 9.59853 3.89702C9.36872 3.18733 8.98994 2.44107 8.36187 1.83612C7.18624 0.703433 5.76425 0 4.64963 0C4.09038 0 3.61487 0.173826 3.27406 0.501782C2.21852 1.51816 2.81412 3.62502 4.65937 5.40205C4.90865 5.64216 5.1826 5.84193 5.4679 6.01263H0V10.6181H1.09838V20H16.9016V10.6187H18V6.01294H11.7499ZM10.3778 4.93153C10.718 4.60358 11.0455 4.44288 11.2591 4.39192C11.2107 4.57231 11.0575 4.8912 10.6966 5.23854C10.5145 5.41393 10.2642 5.51585 10.0289 5.57494C10.0903 5.34703 10.1964 5.10661 10.3778 4.93153ZM4.19717 2.47515C4.02644 1.9818 4.02968 1.56975 4.20625 1.39999C4.31791 1.29275 4.50909 1.27024 4.64996 1.27024C5.27737 1.27024 6.3803 1.72294 7.43 2.73432C8.30637 3.57813 8.54364 4.87682 8.60498 5.63809C7.81398 5.57932 6.46989 5.35078 5.59124 4.5051C4.93169 3.86951 4.4234 3.12981 4.19717 2.47515ZM7.71855 19.0624H2.07245V10.6187H7.71888L7.71855 19.0624ZM7.71855 9.6808H1.09871H0.974069V6.95117H7.71888L7.71855 9.6808ZM15.9282 19.0624H10.2818V10.6187H15.9282V19.0624ZM17.0269 9.6808H16.9023H10.2818V6.95117H17.0269V9.6808Z"})});const WaveBadge=({elClass:s})=>jsxRuntimeExports.jsxs("svg",{className:s,xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 174.7 194.9",children:[jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{d:"M32.5,172.3c0.5-1.4,1-2.8,1.4-4.3c2.7-8.9,5.4-17.7,8-26.6c0.2-0.6,0.2-1.4,0-2c-0.8-3.2-1.6-6.5-2.5-9.7 c-0.2-0.8,0-1.2,0.7-1.4c1.8-0.6,3.7-1.1,5.7-1.7c4.2,15.2,8.2,30.3,12.4,45.3c0.2,0,0.4,0,0.6,0c0.3-1.2,0.7-2.4,1.1-3.6 c1.5-5.7,3-11.5,4.5-17.2c1.1-4.2,2.3-8.5,3.3-12.7c0.3-1.5,0.4-3.1,0.4-4.6c0-0.7-0.4-1.6-0.9-2c-1.1-0.8-2.4-1.4-3.7-2.1 c-0.3-0.2-0.6-0.5-0.6-0.8c-0.2-2-0.2-2,1.9-2c3.4,0,6.7,0,10.1,0c0.1,0,0.2,0,0.4,0c1.9,0,1.9,0,1.8,1.9c0,0.3-0.4,0.8-0.7,0.9 c-2.5,0.8-3.9,2.6-4.6,5.1c-2.5,9.3-5.1,18.5-7.6,27.8c-1.3,4.6-2.6,9.3-3.7,14c-0.3,1.1,0.3,2.4,0.5,3.6c0.2,0.8,0.5,1.6,0.7,2.5 c-0.4,0.1-0.7,0.2-1.1,0.2c-1.7,0-3.4,0-5.2,0c-0.7,0-1.1-0.3-1.2-1c-1.3-5.1-2.7-10.1-4.1-15.2c-1.7-6.1-3.3-12.1-5-18.2 c-0.3-1-0.5-2-0.8-3c-0.1,0-0.3,0-0.4,0c-0.2,0.3-0.5,0.6-0.6,0.9c-2.2,7.1-4.3,14.3-6.5,21.4c-0.8,2.8-1.8,5.6-2.5,8.4 c-0.2,0.8-0.1,1.7,0,2.5c0.3,1.3,0.8,2.6,1.3,4c0,0-0.2,0.1-0.2,0.1c-2.2,0-4.4,0.1-6.6,0.1c-0.3,0-0.7-0.5-0.8-0.8 c-1.4-5.5-2.8-11-4.2-16.4c-1.6-6.3-3.2-12.6-4.9-18.9c-1.3-5.1-2.6-10.1-3.8-15.2c-0.3-1.2-0.9-1.7-2-1.8c-0.2,0-0.5-0.1-0.7-0.1 c-1.3-0.1-2-1.3-1.3-2.4c0.1-0.2,0.6-0.4,0.9-0.4c4.5,0,9,0,13.4,0c0.7,0,1.4,0,1.3,1.1c-0.1,0.8,0.3,1.9-1.2,1.8 c-0.7-0.1-1.4,0.1-2.1,0.2c-1,0.1-1.2,0.5-1,1.5c1.5,6.1,3,12.3,4.5,18.5c1.7,7,3.3,14,5,21.1c0.1,0.4,0.3,0.8,0.5,1.2 C32.2,172.3,32.4,172.3,32.5,172.3z"}),jsxRuntimeExports.jsx("path",{d:"M160.2,182.5c-3.2-0.2-6.2-0.6-9.2-0.6c-8.7-0.1-17.4,0-26.2,0c-0.5,0-1.3-0.2-1.3-0.4c-0.2-0.7-0.1-1.4,0-2.1 c0-0.1,0.5-0.2,0.8-0.3c0.9-0.1,1.8-0.2,2.6-0.3c0.8-0.1,1.2-0.5,1.2-1.4c0-13.1,0-26.2,0-39.3c0-2.3,0-4.6-0.1-6.8 c0-0.4-0.6-0.9-1-1.1c-0.8-0.2-1.7-0.3-2.6-0.3c-1.6,0.1-1-1-1.1-1.8c-0.1-1,0.4-1.1,1.2-1.1c8.1,0,16.2,0,24.4,0 c3.2,0,6.5,0.1,9.6-0.8c0.2-0.1,0.8,0.4,0.8,0.8c0.8,3.3,1.4,6.5,2.1,9.8c0.4,1.7,0.7,3.4,1.1,5.1c-2.1,0.5-1.9,0.4-2.9-1.1 c-1.5-2.3-2.9-4.6-4.7-6.6c-2.5-2.9-5.9-4-9.6-4.3c-2.9-0.2-5.8,0-8.6,0c-1.1,0-1.5,0.4-1.5,1.6c0.1,6.2,0.1,12.3,0,18.5 c0,1,0.2,1.4,1.3,1.3c1.8-0.1,3.5,0,5.3-0.3c2.1-0.3,3.6-1.6,4.3-3.6c0.5-1.2,0.9-2.6,1.2-3.9c0.2-0.9,0.7-1.2,1.6-1.2 c1,0.1,0.9,0.7,0.9,1.4c0,5.8,0,11.6,0,17.4c0,0.6,0.2,1.4-0.8,1.4c-0.9,0-1.5,0-1.8-1.1c-0.4-1.6-1-3.3-1.8-4.8 c-0.9-1.9-2.7-2.7-4.7-2.8c-1.6-0.1-3.2,0-4.8,0c-0.7,0-1.1,0.2-1.1,1c0,7.5,0,15,0,22.4c0,1.6,0.1,1.8,1.7,1.8 c2.8,0,5.6,0.2,8.4-0.1c5.2-0.5,9.6-2.7,12.7-7c1.4-1.9,2.5-4.1,3.6-6.2c0.5-1,1.2-0.6,1.9-0.5c0.9,0.1,0.6,0.8,0.5,1.3 c-0.7,3.1-1.5,6.2-2.2,9.3c-0.5,2.1-1,4.1-1.4,6.2C160.3,182.3,160.2,182.6,160.2,182.5z"}),jsxRuntimeExports.jsx("path",{d:"M114.9,165.8c-1.2,5.7-2.5,11.4-3.7,16.8c-2.9-0.2-5.6-0.6-8.3-0.6c-7.1-0.1-14.2,0-21.4,0c-1.8,0-2.3-1-1.5-2.6 c1.8-3.3,3.6-6.6,5.4-9.9c4.8-8.8,9.6-17.6,14.3-26.4c2-3.7,4-7.3,6.1-11c0.3-0.5,0.5-1.1,0.8-1.8c-0.4-0.1-0.7-0.2-0.9-0.2 c-3.2-0.1-6.4-0.3-9.7,0.4c-4.4,1-7.5,3.5-9.8,7.3c-0.7,1.2-1.3,2.5-1.9,3.7c-0.3,0.6-0.6,0.9-1.2,0.6c-0.5-0.3-1.4-0.2-1.1-1.3 c1.1-4.6,2.1-9.2,3.1-13.9c1,0.1,2.1,0.2,3.1,0.2c8.2,0,16.3,0,24.5,0.1c0.6,0,1.8,0.1,1.8,0.3c0.1,0.9,0.2,1.9-0.2,2.6 c-2,3.9-4.1,7.7-6.2,11.5c-5.7,10.5-11.3,20.9-16.9,31.4c-0.8,1.6-1.7,3.1-2.6,4.7c-0.6,1-0.4,1.4,0.8,1.4 c3.4-0.1,6.8,0.3,10.3-0.5c4.1-1,7.3-3.1,9.6-6.6c1-1.6,1.8-3.3,2.6-5C112.9,165.4,112.8,165.4,114.9,165.8z"})]})}),jsxRuntimeExports.jsx("path",{d:"M158.2,74.8c-0.2,0.3-0.4,0.7-0.7,0.9c-2.5,1.7-5,2.2-7.6,1.2c-2.5-0.9-4.6-4.4-4.8-8c-0.2-4.1,0.8-7.3,3-9.6 c0.1-0.1,0.2-0.2,0.3-0.3c-0.1-0.3-0.3-0.5-0.4-0.7c-2.6-3.7-5.7-5-9.1-4.5c-2.8,0.3-5.3,1.8-7.6,4.2c-3.5,3.7-7,7.5-10.5,11.3 c-2.8,3.1-5.7,5.9-9.1,7.5c-2.8,1.3-5.6,1.1-8-1.8c-3.5-4.1-3.1-12.2,0.6-15.7c0.1-0.1,0.2-0.2,0.4-0.3c-1.2-1.9-2.5-3.3-4-4.1 c-3.5-2-7-1.4-10.4,0.9c-3.3,2.1-6.1,5.4-9,8.6c-2.8,3.3-5.6,6.7-8.6,9.3c-2.1,1.8-4.3,3.4-6.7,3.8c-2.6,0.4-5-0.4-7-3.4 c-2.6-3.8-1.9-10,0-12.9c0.5-0.8,1-1.4,1.6-2.2c-0.9-1.5-1.9-2.6-3-3.5c-3.2-2.3-6.5-2.2-9.7-0.7c-2.7,1.3-5,3.7-7.3,6.3 c-3.1,3.4-6.3,6.9-9.4,10.3c-2.6,2.7-5.3,4.9-8.4,5.9c-2,0.6-4,0.6-5.8-1.2c-0.2-0.2-0.4-0.5-0.4-0.7c-0.2-0.8,0.1-1.3,0.7-1.2 c0.7,0.1,1.3,0.3,2,0.5c2.6,0.6,5-0.3,7.3-1.9c2.9-1.9,5.4-4.9,7.9-7.8c2.7-3,5.3-6.2,8.1-8.9c2.9-2.9,6.2-4.8,9.7-4.8 c3.6,0,6.6,2.3,9.3,5.8c0.1,0.2,0.3,0.5,0.4,0.7c0.7,1.5,0.5,2.8-0.6,3.5c-1.3,0.9-2.1,2.5-2.5,4.8c-0.6,3.9,0.6,7.4,3.1,8.5 c1.9,0.8,3.9,0.5,5.8-0.3c3-1.3,5.7-3.6,8.2-6.4c3.3-3.7,6.6-7.5,9.9-11.1c2.6-2.8,5.4-4.7,8.6-5.3c2.9-0.6,5.7,0.2,8.3,2.6 c1,1,2.1,2.1,3,3.3c1.1,1.4,0.9,3.1-0.3,4.1c-1.9,1.6-2.8,4.2-2.6,7.4c0.2,2.9,1.7,5.4,3.7,6c2.1,0.7,4.1,0.1,6.1-0.9 c2.6-1.3,5-3.5,7.2-6c2.8-3.2,5.6-6.5,8.4-9.6c2.6-2.9,5.3-5.2,8.4-6.3c4.2-1.6,8-0.3,11.6,3.6c0.5,0.5,0.9,1,1.3,1.6 c1.2,1.7,1,3.3-0.4,4.3c-1.1,0.9-1.8,2.2-2.2,4c-0.9,4,0.1,7.5,2.7,9c2.1,1.2,4.3,1,6.4-0.2c0.3-0.2,0.6-0.3,0.9-0.5 c0.8-0.5,1-0.4,1.4,0.9L158.2,74.8L158.2,74.8L158.2,74.8z"})]});const Wave=({elClass:C,fillColor:s})=>jsxRuntimeExports.jsx("svg",{className:C,xmlns:"http://www.w3.org/2000/svg",fill:s,viewBox:"0 0 276.32 32.32",children:jsxRuntimeExports.jsx("path",{className:"",d:"M276.32,28.88c-.45.37-.84.87-1.35,1.09-4.75,2.07-9.68,2.69-14.76,1.51-4.94-1.15-8.94-5.33-9.28-9.78-.38-4.96,1.53-8.9,5.78-11.64.17-.11.34-.21.64-.39-.31-.33-.56-.65-.86-.92-5.07-4.54-11.1-6.04-17.76-5.5-5.41.44-10.4,2.2-14.89,5.16-6.86,4.52-13.61,9.19-20.41,13.8-5.52,3.75-11.2,7.24-17.67,9.15-5.52,1.63-10.88,1.32-15.64-2.22-6.74-5.02-6.09-14.8,1.19-19.09.2-.12.39-.24.67-.41-2.23-2.35-4.81-4.02-7.79-5.06-6.88-2.42-13.61-1.67-20.21,1.04-6.37,2.62-11.96,6.52-17.48,10.53-5.48,3.98-10.86,8.12-16.89,11.29-4.1,2.16-8.28,4.17-12.99,4.65-5.11.52-9.7-.52-13.64-4.11-5.11-4.66-3.65-12.16-.07-15.71.96-.95,2.02-1.79,3.12-2.77-1.67-1.82-3.66-3.18-5.87-4.19-6.19-2.84-12.54-2.69-18.96-.85-5.31,1.52-9.8,4.6-14.29,7.63-6.14,4.15-12.2,8.44-18.37,12.54-5,3.33-10.36,6-16.32,7.21-3.87.78-7.72.78-11.25-1.41-.35-.22-.75-.54-.87-.9-.33-.96.21-1.55,1.37-1.45,1.31.12,2.61.36,3.92.54,4.99.69,9.69-.42,14.25-2.3,5.67-2.34,10.51-6,15.45-9.49,5.21-3.68,10.33-7.5,15.71-10.92C56.57,2.25,62.91.02,69.89.01s12.84,2.83,18.17,7.02c.31.24.55.57.79.89,1.35,1.81.95,3.38-1.13,4.31-2.59,1.15-4.17,3.1-4.87,5.81-1.23,4.75,1.26,9.08,6.08,10.36,3.77,1,7.52.62,11.25-.35,5.84-1.52,11.03-4.39,15.92-7.8,6.44-4.49,12.8-9.1,19.28-13.54,5.06-3.47,10.64-5.75,16.81-6.49,5.7-.68,11.08.29,16.05,3.13,2.03,1.16,3.98,2.52,5.79,4,2.14,1.75,1.81,3.72-.64,4.97-3.71,1.88-5.52,5.12-5.05,9.01.44,3.56,3.3,6.5,7.24,7.31,4.03.82,7.95.08,11.8-1.08,5.15-1.54,9.72-4.21,14.06-7.29,5.46-3.88,10.86-7.84,16.33-11.71,4.98-3.52,10.35-6.3,16.34-7.74,8.17-1.95,15.69-.4,22.56,4.35.88.61,1.77,1.23,2.58,1.94,2.29,2.01,2.06,3.99-.69,5.29-2.17,1.03-3.5,2.69-4.28,4.87-1.75,4.9.27,9.18,5.24,10.93,4.16,1.47,8.33,1.21,12.46-.18.57-.19,1.12-.41,1.68-.63,1.62-.65,1.97-.51,2.66,1.02v.48h0Z"})});const Angler=({elClass:s,fillColor:a})=>jsxRuntimeExports.jsxs("svg",{className:s,xmlns:"http://www.w3.org/2000/svg",fill:a,viewBox:"0 0 269.56 98.87",children:[jsxRuntimeExports.jsx("path",{d:"M128.65,98.87c-3.99-1.63-4.93-3.32-4.11-7.7.69-3.68,1.51-7.33,2.21-11.01.05-.28-.34-.9-.57-.93-8.44-.98-16.88-1.98-25.33-2.83-2.75-.28-5.24.73-7.49,2.37-6.37,4.64-12.91,9-20.36,11.75-2.27.84-4.64,1.47-7.02,1.92-2.5.47-3.94-.53-4.78-2.92-1.73-4.93-2.77-10.1-3.21-15.31-.21-2.54-.37-5.17-.13-7.7.17-1.78-.57-1.72-2.26-1.86-7.36-.61-14.3.97-21.19,3.46-6.66,2.41-13.41,4.66-20.28,6.34-3.77.92-7.86.59-11.81.7-1.95.05-2.73-1.17-2.12-3.17,1.16-3.81,2.27-7.64,3.63-11.38,1.93-5.34,2.07-10.7,1.04-16.24-.97-5.28-1.67-10.61-2.28-15.95-.42-3.69,1.71-5.43,5.42-4.86,10.29,1.57,19.64,5.47,28.1,11.47,5.67,4.03,12.07,4.97,18.79,4.69.18,0,.48-.38.49-.6.02-.47-.12-.94-.18-1.42-.32-2.94,1.09-4.78,4.05-4.56,3.44.26,6.85.92,10.24,1.58,6.25,1.21,12.44.86,18.68-.2,8.97-1.52,17.99-2.75,26.98-4.11.45-.07.88-.27,1.33-.42-.31-.33-.58-.72-.94-.99q-3.86-2.8-.65-6.33c6.44-7.03,12.88-14.07,19.31-21.1,1.82-1.98,2.8-2.08,4.98-.28,6.49,5.37,13.08,10.63,19.37,16.22,4.79,4.25,10.24,5.97,16.51,6.18,24.02.83,47.52,4.9,70.55,11.73,4.58,1.36,8.94,3.34,13.11,5.64,3.71,2.05,8.74,4.08,10.18,8.41.92,2.77,1.02,7.78-1.14,9.99-2.06,2.12-5.23,3.08-7.87,4.21-3.43,1.48-7.3,2.33-10.89,3.37-7.29,2.12-14.66,3.97-22.09,5.55-3.41.73-6.94,1.25-10.08,2.83-2.79,1.4-5.11,3.53-6.98,6-2.13,2.81-4.59,5.41-7.16,7.83-2.19,2.06-4.24,1.4-5.25-1.42-.88-2.47-1.67-4.99-2.35-7.52-.28-1.02-.74-1.18-1.67-1.06-2.22.28-4.44.53-6.67.69-10.43.73-20.86,1.45-31.29,2.09-1.87.12-3.16.97-4.18,2.39-1.09,1.53-2.08,3.12-3.21,4.61-.91,1.2-2.25,1.99-3.66,1.24-2.26-1.21-3.72-.4-5.08,1.36-.41.53-.92,1-1.43,1.44-2.4,2.11-4.31,4.87-7.61,5.79h-1.68ZM54.04,53.24c-7.54-.18-15.09-.34-22.63-.56-1.03-.03-1.45.13-1.16,1.29.48,1.97.76,3.99,1.23,5.96.89,3.7,2.34,4.42,6.1,3.6,3.97-.87,7.96-1.8,11.99-2.15,8.51-.75,16.32,1.76,23.73,5.76,3.77,2.03,7.83,3.78,12.01,4.74,5.12,1.17,10.45,1.2,15.67,1.55,5.77.48,11.79.31,17.46,1.41,6.95,1.35,14.7,1.38,21.74.84,3.77-.29,7.41-.09,10.65,2.25.64.46,1.68.51,2.53.51,2.71.01,5.43-.15,8.14-.12,10.89.09,21.71-.64,32.44-2.48.67-.12,1.49-.87,1.76-1.52.69-1.65.75-3.48,1.68-5.02.86-1.43,2.1-2.61,3.47-3.55,4.61-3.17,10.57-5.54,16.23-4.7.53.08,1.07.04,1.6.06-.29-.46-.57-.94-.89-1.39-2.97-4.11-4.51-8.46-2.11-13.39.52-1.07.23-1.17-.79-1.15-8.22.16-16.45.22-24.67.43-9.66.25-19.32.42-28.96.99-18.69,1.1-37.37,2.41-56.04,3.72-17.04,1.19-34.03,3.31-51.16,2.92ZM34.72,39.7c-.78.59-2.12,1.09-2.56,2.02-.88,1.87-1.26,3.97-1.88,5.97-.5,1.6.22,1.88,1.67,1.88,3.47,0,6.94.13,10.42.26,16.5.58,32.96-.05,49.41-1.49,18.65-1.63,37.33-2.95,56-4.28,10.35-.73,20.71-1.36,31.08-1.75,9.29-.35,18.59-.32,27.89-.48,4.59-.08,9.27.87,13.67-1.3,2.73-1.35,1.71,2.21.87,3.39-.93,1.3-1.95,2.53-2.76,3.9-1.35,2.27-1.43,4.69,0,6.91,1.07,1.66,2.41,3.15,3.73,4.62,1.78,1.98,3.69,3.84,5.5,5.79,1.1,1.18.08,1.6-.78,1.33-1.66-.53-3.26-1.32-4.79-2.17-.71-.39-.94-.42-1.25.37-.78,1.96-1.66,3.88-2.49,5.83-.13.31-.17.66-.25.99.35-.03.71,0,1.03-.1,6.17-2.04,12.52-3.36,18.82-4.91,8.49-2.09,16.75-5.14,25.09-7.83.69-.22,1.27-.8,1.87-1.26.2-.15.31-.41.47-.62-.23-.05-.45-.13-.68-.15-1-.06-2-.07-2.99-.17-.6-.06-1.18-.23-1.78-.36.34-.57.57-1.27,1.05-1.69.86-.75,1.84-1.37,2.82-1.97.68-.41,1.46-.66,2.14-1.05.15-.09.26-.63.16-.73-1.34-1.35-2.57-2.9-4.13-3.93-8.88-5.86-18.76-9.29-29.08-11.53-16.66-3.61-33.46-6.43-50.44-8.12-7.77-.77-15.52-1.09-23.28.11-10.49,1.61-21,3.13-31.5,4.65-13.23,1.91-26.49,3.65-39.7,5.72-7.32,1.14-14.54,2.92-21.85,4.18-8.15,1.41-16.34,1.86-24.49-.11-2.2-.53-4.38-1.19-7.04-1.92ZM145.03,25.78c1.48-.26,2.69-.52,3.91-.67,3.29-.4,6.58-.72,9.87-1.13.47-.06.91-.38,1.36-.58-.28-.38-.5-.82-.85-1.12-6.28-5.35-12.56-10.71-18.9-16-.86-.71-1.99-1.22-3.08-1.48-.69-.17-1.79.02-2.27.49-2.29,2.27-4.43,4.69-6.63,7.04-.57.6-.48.99.19,1.5,4.9,3.7,9.77,7.45,14.67,11.15.55.41,1.27.59,1.72.79ZM65.96,89.03c1.32-.29,2.23-.44,3.11-.69,7.86-2.19,14.5-6.67,21.06-11.29.15-.1.23-.29.34-.44-.3-.16-.58-.38-.9-.48-2.28-.7-4.54-1.45-6.85-2.01-1.13-.27-2.49-.52-3.51-.15-4.45,1.61-8.83,3.41-13.2,5.23-3.99,1.66-4.43,2.85-2.77,6.87.2.48.35,1.03.7,1.37.66.64,1.45,1.15,2.02,1.59ZM5.91,32.73c0,2.36,1.43,2.75,2.85,3.13,5.43,1.43,10.88,2.79,16.29,4.31,3.28.92,4.06.79,6.2-1.96,1.22-1.57,1.08-2.43-.71-3.27-2.49-1.17-4.99-2.33-7.55-3.31-4.39-1.67-8.82-3.22-13.26-4.77-1.04-.36-2.28-.58-2.69.84-.52,1.79-.82,3.64-1.12,5.03ZM9.74,71.63c1.97-.23,4.41-.38,6.79-.81,4.51-.82,9.01-1.78,12.95-4.33.6-.39,1.26-1.12,1.36-1.78.18-1.26-2.86-3.82-4.14-3.63-6.19.9-12.39,1.78-18.56,2.81-.91.15-1.89.98-2.47,1.77-.78,1.07-1.23,2.39-1.78,3.62-.54,1.2-.11,1.93,1.21,2.04,1.39.12,2.78.18,4.64.3ZM120.51,29.17c2.11-.26,3.84-.5,5.59-.69,3.96-.42,7.93-.79,11.89-1.24.52-.06,1-.51,1.5-.78-.28-.41-.47-.93-.85-1.21-4.03-2.99-8.09-5.95-12.17-8.86-.27-.19-1-.14-1.23.09-2.52,2.49-4.98,5.05-7.46,7.58-1.68,1.71-1.56,3.09.5,4.33.75.45,1.68.61,2.24.8ZM199.38,74.2c.1,1.24.42,2.46.74,3.66,2.73-3.13,5.61-6.14,8.63-9.01.35-.33.72-.68,1.18-.83s1.04-.05,1.3.36c.34.54-.03,1.24-.4,1.76-2.56,3.64-5.48,7.04-8.68,10.14-.82.79-1.67,1.57-2.22,2.57-.52.94-.83,2.49-.26,3.49.79,1.39,2.04.64,2.76-.32,4.49-6.06,8.97-12.12,13.46-18.18.6-.81,1.22-1.82.84-2.74-.28-.68-1.05-1.06-1.79-1.09s-1.45.21-2.15.45c-2.65.91-5.29,1.82-7.94,2.73-1.56.54-3.21,1.13-4.26,2.4-.92,1.11-1.27,2.6-1.24,4.04,0,.19.01.39.03.58ZM18.59,48.82c0,.08,0,.15,0,.23,1,.06,1.99.14,2.99.19,1,.04,2,.1,2.99.05,1.8-.09,2.62-1.19,2.83-3.63.13-1.51-.87-2.02-2.07-2.32-1.59-.39-3.2-.68-4.78-1.1-4.31-1.16-8.61-2.37-12.92-3.53-.27-.07-.92.28-.91.31.62,2.42,1.15,4.88,2,7.22.62,1.72,2.2,2.49,4.01,2.55,1.95.07,3.91.02,5.86.02ZM148.9,82.13c-.52-.84-.83-1.64-1.4-2.18-1.85-1.76-5.27-1.69-7.1.1-1.4,1.37-2.75,2.78-4.1,4.2-2.34,2.45-4.76,4.84-6.95,7.41-.63.74-1.13,2.64-.76,2.97,1.15,1.03,2.43.13,3.5-.7.22-.17.41-.38.6-.58,1.41-1.47,2.82-2.93,4.21-4.42,1.73-1.87,3.83-2.78,6.35-2.26,1.41.3,2.51.46,3.31-1.1.6-1.17,1.49-2.2,2.35-3.43ZM18.21,52.42c0-.05,0-.1,0-.16-2.07-.09-4.14-.22-6.21-.27-1.32-.03-2.55.34-2.95,1.75-.54,1.95-.92,3.95-1.31,5.93-.03.14.39.54.55.52,5.51-.81,11.01-1.7,16.53-2.47,1.54-.21,2.32-.76,2.21-2.41-.14-2.17-.65-2.85-2.48-2.88-2.11-.03-4.23,0-6.34,0ZM60.94,69.86c-.23.74-.16,1.58-.02,2.36.28,1.54.37,3.04.49,4.6.07.83.41.73.99.49,3.78-1.6,7.57-3.16,11.35-4.77.31-.13.65-.49.7-.8.04-.22-.31-.62-.58-.77-1.71-.94-3.42-1.9-5.18-2.73-2.1-.99-6.03-1.34-7.47,1.03-.11.19-.2.39-.27.59ZM135.43,79.23c-4.63,0-6.46,1.87-6.54,6.24,0,.33.09.67.14,1,.25-.18.51-.34.74-.55,1.91-1.75,3.82-3.5,5.72-5.25.4-.37.77-.79,1.15-1.18-.56-.12-1.12-.24-1.22-.26ZM65.13,39.14c1.17-.38,2.22-.7,3.25-1.07.2-.07.34-.3.51-.45-.21-.09-.41-.23-.63-.26-2.88-.41-5.75-.81-8.63-1.19-.31-.04-.65.09-.97.15.22.34.38.88.69.99,1.91.66,3.84,1.23,5.79,1.83Z"}),jsxRuntimeExports.jsx("path",{d:"M246.63,43.78c2.01-.02,3.58,1.52,3.59,3.5,0,1.92-1.52,3.46-3.47,3.5-2,.04-3.63-1.48-3.68-3.44-.05-1.93,1.57-3.54,3.56-3.56Z"})]});const AnglerBadge=({elClass:s})=>jsxRuntimeExports.jsxs("svg",{className:s,xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 174.7 194.9",children:[jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{d:"M77.8,166.7c-5.2,4.7-9.7,8.3-13.6,10.8s-7.1,3.8-9.6,3.8c-1.5,0-2.7-0.5-3.7-1.4c-0.5-0.5-0.9-1.1-1.2-1.8 c-0.2-0.7-0.4-1.4-0.5-2.1c-1.2,1-2.6,2-4,3c-1.5,0.9-3,1.6-4.6,2.1c-0.6,0.2-1.2,0.4-1.8,0.4c-0.5,0.1-1.1,0.1-1.6,0.1 c-1.9,0-3.5-0.6-4.5-1.8c-0.9-1-1.4-2.3-1.4-3.6c0-1.4,0.3-2.8,0.9-4.2c0.6-1.4,1.5-2.9,2.5-4.3c1.1-1.4,2.3-2.7,3.6-3.9 c1.4-1.3,2.9-2.4,4.5-3.3c1.6-0.9,3.1-1.6,4.7-2c1.5-0.4,3-0.6,4.3-0.4c1.3,0.2,2.4,0.8,3.3,1.8c0.1,0.2,0.3,0.4,0.4,0.5 c0.1,0.2,0.2,0.4,0.3,0.6c0.4-0.1,0.7-0.1,1,0c0.3,0.1,0.6,0.2,0.8,0.3c0.6,0.5,0.9,1,0.8,1.6c-0.1,0.6-0.2,1-0.5,1.4 c-1.1,1.3-2,2.7-2.7,4.1c-0.7,1.4-1.2,2.7-1.6,3.9c-0.3,1.2-0.5,2.2-0.5,3.1c0,0.9,0.1,1.4,0.4,1.7c0,0,0.2,0.1,0.4,0.2 c0.2,0.1,0.7,0.1,1.3,0c0.6-0.1,1.4-0.4,2.4-0.8c1-0.4,2.3-1.1,3.9-2.1c1.6-1,3.4-2.3,5.6-4c2.2-1.7,4.7-3.8,7.7-6.4 c0.5-0.4,1-0.5,1.5-0.5c0.6,0,1,0.2,1.4,0.6c0.4,0.4,0.5,0.9,0.5,1.5C78.5,165.8,78.2,166.3,77.8,166.7z M50.5,162 c-1,0-2.4,0.4-4,1.1c-1.7,0.7-3.4,1.9-5.3,3.6c-1.2,1.1-2.3,2.2-3.2,3.4s-1.5,2.3-2,3.3c-0.5,1-0.7,1.9-0.6,2.4 c0,0.6,0.1,1,0.3,1.2c0.2,0.2,0.6,0.4,1.2,0.5c0.6,0.1,1.4,0,2.5-0.3c1.1-0.4,2.3-0.9,3.6-1.6c1.3-0.7,2.5-1.6,3.7-2.7 c1.4-1.3,2.5-2.5,3.3-3.6c0.8-1.2,1.4-2.2,1.8-3.1c0.4-0.9,0.6-1.7,0.6-2.3c0-0.6-0.1-1.1-0.3-1.3c-0.1-0.1-0.2-0.2-0.5-0.3 C51.4,162.1,51,162,50.5,162z"}),jsxRuntimeExports.jsx("path",{d:"M114.5,164.1c-2.7,2-5.1,3.8-7.4,5.2c-2.3,1.4-4.5,2.7-6.6,3.7c-0.4,0.2-1.3,0.6-2.7,1.2c-1.4,0.6-3.1,1.1-4.9,1.6 c-2,0.4-3.8,0.6-5.4,0.5c-0.3,0.5-0.7,1-1.2,1.8c-0.5,0.7-1.2,1.4-1.9,2.1c-0.7,0.7-1.6,1.3-2.5,1.8c-0.9,0.5-1.9,0.7-2.9,0.6 c-0.5,0-0.9-0.1-1.4-0.1c-0.5,0-0.9-0.2-1.4-0.4c-1.4-0.6-2.5-1.5-3.1-2.6c-0.6-1.1-0.9-2.3-1-3.5c0-0.6-0.1-1.2,0-1.7 c0-0.6,0.1-1.1,0.2-1.7c0.1-1,0.3-1.9,0.4-2.6c0-0.2,0.1-0.6,0.2-1.1c0.1-0.5,0.2-1,0.4-1.5c0.1-0.5,0.3-1.1,0.4-1.5 c0.1-0.5,0.2-0.8,0.3-1.1c0.1-0.4,0.2-0.7,0.2-1c0.1-0.3,0.1-0.6,0.2-0.9c0.1-0.3,0.2-0.6,0.3-0.9c0.1-0.5,0.3-1,0.4-1.4 c0.2-0.5,0.3-0.9,0.5-1.4c0.9-2.5,1.9-5.4,3.3-8.5c1.3-3.2,2.9-6.4,4.8-9.6c1.2-2,2.5-4.1,3.9-6.1c1.5-2.3,3.4-4.7,5.5-7.4 c2.1-2.6,4.6-5,7.4-7.2c1.6-1.2,3-2,4.3-2.5c1.3-0.5,2.5-0.8,3.5-0.8c1.1,0,2,0.1,2.8,0.5c0.8,0.4,1.5,0.8,2.1,1.4 c1.2,1.3,1.7,2.8,1.5,4.5c-0.1,1.5-0.7,3.2-1.8,5.2c-1,2-2.4,4.1-4.2,6.4c-1.7,2.3-3.8,4.6-6.1,7.1c-2.3,2.5-4.8,5-7.4,7.5 c-2.6,2.5-5.4,5-8.3,7.4c-2.9,2.4-5.8,4.7-8.7,6.9c-0.1,0.3-0.2,0.8-0.4,1.4c-0.2,0.6-0.3,1.3-0.5,2c-0.2,0.7-0.4,1.3-0.5,2 c-0.2,0.6-0.3,1.1-0.3,1.4c-0.4,1.6-0.5,2.9-0.5,3.9c0,1,0.1,1.7,0.3,2.2c0.2,0.5,0.4,0.8,0.6,1c0.2,0.2,0.4,0.3,0.6,0.3 c1.2,0.5,2.3,0.4,3.3-0.3c1-0.7,1.9-1.6,2.5-2.6c-1-0.6-1.9-1.4-2.4-2.3c-0.6-0.9-0.9-2-1.1-3.2c-0.1-1-0.1-2,0.1-2.9 c0.2-0.9,0.6-1.8,1.1-2.5c0.6-0.9,1.4-1.5,2.2-1.9c0.8-0.4,1.7-0.4,2.7-0.2c1,0.3,1.9,0.9,2.5,1.8c0.7,0.9,1.1,1.9,1.2,3.1 c0.1,1.6,0,3.3-0.5,5c1.6-0.1,3.3-0.5,5.1-1.1c1.7-0.6,3.2-1.2,4.4-1.7c2-1,4.1-2.2,6.3-3.6c2.1-1.4,4.5-3,7-4.9 c0.5-0.4,1-0.5,1.6-0.4c0.5,0.1,1,0.3,1.4,0.8c0.4,0.5,0.5,0.9,0.4,1.5C115.3,163.3,115,163.7,114.5,164.1z M110.4,121.9 c-0.4-0.5-1-0.7-1.8-0.7c-0.6,0-1.4,0.2-2.3,0.6c-0.9,0.4-2,1.1-3.2,2c-2.5,1.9-4.8,4.1-6.8,6.5c-2,2.5-3.8,4.8-5.3,7 c-0.7,1-1.3,1.9-1.9,2.9c-0.6,1-1.2,2-1.8,2.9c-1.4,2.4-2.6,4.8-3.7,7.1c-1.1,2.4-2,4.6-2.8,6.8c2.6-2.1,5.1-4.2,7.6-6.4 c2.5-2.2,4.8-4.3,7-6.5c2.2-2.1,4.2-4.2,6.1-6.3c1.9-2,3.5-4,4.9-5.8c1.4-1.8,2.4-3.5,3.3-5c0.8-1.5,1.3-2.8,1.4-3.9 c0-0.4,0-0.6-0.1-0.8C110.6,122.1,110.5,122,110.4,121.9z M81.6,165.5H85h0.1l1.6,0.8c-0.9,0-1.5,0-1.7,0.1 c-0.2,0.1-0.4,0.2-0.5,0.3c-0.2,0.3-0.3,0.6-0.4,1.1c-0.1,0.4-0.1,0.9,0,1.5c0,0.5,0.1,0.9,0.2,1.1c0,0.1,0.1,0.2,0.1,0.3 c0,0,0.1,0.1,0.1,0.2c0,0.2,0.1,0.3,0.2,0.4L85,172c0.2-0.7,0.4-1.4,0.6-2.1c0.2-0.7,0.2-1.5,0.1-2.2c0-0.2-0.1-0.4-0.2-0.6 c-0.1-0.2-0.3-0.3-0.6-0.5c-0.3-0.2-0.7-0.3-1.2-0.5C83.2,166,82.5,165.8,81.6,165.5z"}),jsxRuntimeExports.jsx("path",{d:"M142.6,164.7l-2,1.5c-2.4,1.8-4.7,3.5-6.8,5c-2.1,1.5-4.4,3.1-7,4.6c-0.4,0.3-1.2,0.7-2.2,1.3c-1.1,0.6-2.3,1.2-3.8,1.9 c-1.4,0.6-2.9,1.2-4.5,1.7c-1.6,0.5-3.1,0.7-4.5,0.7c-0.7,0-1.4-0.1-2-0.2c-0.7-0.1-1.3-0.4-2-0.8c-1.2-0.8-1.9-1.9-2.2-3.3 c-0.3-1.4-0.4-2.9-0.1-4.6c0.2-1.1,0.5-2.2,1-3.4c0.5-1.2,1.1-2.4,1.9-3.5c0.6-0.9,1.3-1.9,2.2-3c0.9-1,1.9-2,3-2.8 c1.1-0.9,2.2-1.6,3.4-2.2c1.2-0.6,2.4-0.9,3.6-1c1.3-0.1,2.3,0.2,3.1,0.9c0.7,0.7,1.2,1.5,1.4,2.4c0.1,0.6,0.1,1.2,0,1.8 c-0.1,0.6-0.3,1.2-0.7,1.8c-0.3,0.6-0.8,1.1-1.3,1.5c-0.5,0.4-1.1,0.7-1.8,0.9c-0.5,0.2-1.1,0.1-1.5-0.2c-0.5-0.3-0.8-0.7-0.9-1.3 c-0.2-0.6-0.1-1.1,0.2-1.6c0.3-0.5,0.7-0.7,1.2-0.9c0.2-0.1,0.4-0.3,0.6-0.6c0.2-0.3,0.3-0.6,0.2-0.8c0,0,0,0.1-0.1,0.1 c-0.8,0.1-1.6,0.4-2.4,0.8c-0.8,0.4-1.7,1-2.5,1.6c-0.8,0.7-1.6,1.4-2.3,2.2c-0.7,0.8-1.4,1.6-1.9,2.4c-1.4,2.1-2.1,3.9-2.3,5.4 c-0.2,1.3-0.2,2.2,0,2.7c0.2,0.5,0.4,0.9,0.6,1.1c0.6,0.4,1.5,0.5,2.6,0.4c1.2-0.2,2.4-0.5,3.8-1c1.4-0.5,2.8-1.1,4.2-1.8 c1.4-0.7,2.8-1.4,3.9-2.2c2.5-1.5,4.8-3,6.9-4.5c2.1-1.5,4.3-3.1,6.7-4.9l2-1.6c0.5-0.2,0.9-0.3,1.5-0.3c0.5,0,1,0.2,1.3,0.6 c0.4,0.5,0.5,1,0.5,1.6C143.3,163.9,143.1,164.4,142.6,164.7z"})]}),jsxRuntimeExports.jsx("path",{d:"M84.1,90.3c-2.1-0.9-2.6-1.7-2.2-4c0.4-1.9,0.8-3.9,1.2-5.8c0-0.1-0.2-0.5-0.3-0.5c-4.4-0.5-8.9-1-13.3-1.5 c-1.4-0.1-2.8,0.4-3.9,1.2c-3.4,2.4-6.8,4.7-10.7,6.2c-1.2,0.4-2.4,0.8-3.7,1c-1.3,0.2-2.1-0.3-2.5-1.5c-0.9-2.6-1.5-5.3-1.7-8.1 c-0.1-1.3-0.2-2.7-0.1-4c0.1-0.9-0.3-0.9-1.2-1c-3.9-0.3-7.5,0.5-11.1,1.8c-3.5,1.3-7.1,2.5-10.7,3.3c-2,0.5-4.1,0.3-6.2,0.4 c-1,0-1.4-0.6-1.1-1.7c0.6-2,1.2-4,1.9-6c1-2.8,1.1-5.6,0.5-8.5c-0.5-2.8-0.9-5.6-1.2-8.4c-0.2-1.9,0.9-2.9,2.9-2.6 c5.4,0.8,10.3,2.9,14.8,6c3,2.1,6.3,2.6,9.9,2.5c0.1,0,0.3-0.2,0.3-0.3c0-0.2-0.1-0.5-0.1-0.7c-0.2-1.5,0.6-2.5,2.1-2.4 c1.8,0.1,3.6,0.5,5.4,0.8c3.3,0.6,6.5,0.5,9.8-0.1c4.7-0.8,9.5-1.4,14.2-2.2c0.2,0,0.5-0.1,0.7-0.2c-0.2-0.2-0.3-0.4-0.5-0.5 c-1.4-1-1.5-2.1-0.3-3.3c3.4-3.7,6.8-7.4,10.2-11.1c1-1,1.5-1.1,2.6-0.1c3.4,2.8,6.9,5.6,10.2,8.5c2.5,2.2,5.4,3.1,8.7,3.3 c12.6,0.4,25,2.6,37.1,6.2c2.4,0.7,4.7,1.8,6.9,3c2,1.1,4.6,2.1,5.4,4.4c0.5,1.5,0.5,4.1-0.6,5.3c-1.1,1.1-2.8,1.6-4.1,2.2 c-1.8,0.8-3.8,1.2-5.7,1.8c-3.8,1.1-7.7,2.1-11.6,2.9c-1.8,0.4-3.6,0.7-5.3,1.5c-1.5,0.7-2.7,1.9-3.7,3.2c-1.1,1.5-2.4,2.8-3.8,4.1 c-1.2,1.1-2.2,0.7-2.8-0.7c-0.5-1.3-0.9-2.6-1.2-4c-0.1-0.5-0.4-0.6-0.9-0.6c-1.2,0.1-2.3,0.3-3.5,0.4c-5.5,0.4-11,0.8-16.5,1.1 c-1,0.1-1.7,0.5-2.2,1.3c-0.6,0.8-1.1,1.6-1.7,2.4c-0.5,0.6-1.2,1-1.9,0.7c-1.2-0.6-2-0.2-2.7,0.7c-0.2,0.3-0.5,0.5-0.8,0.8 c-1.3,1.1-2.3,2.6-4,3L84.1,90.3L84.1,90.3z M44.9,66.3c-4-0.1-7.9-0.2-11.9-0.3c-0.5,0-0.8,0.1-0.6,0.7c0.3,1,0.4,2.1,0.6,3.1 c0.5,1.9,1.2,2.3,3.2,1.9c2.1-0.5,4.2-0.9,6.3-1.1c4.5-0.4,8.6,0.9,12.5,3c2,1.1,4.1,2,6.3,2.5c2.7,0.6,5.5,0.6,8.2,0.8 c3,0.3,6.2,0.2,9.2,0.7c3.7,0.7,7.7,0.7,11.4,0.4c2-0.2,3.9,0,5.6,1.2c0.3,0.2,0.9,0.3,1.3,0.3c1.4,0,2.9-0.1,4.3-0.1 c5.7,0,11.4-0.3,17.1-1.3c0.4-0.1,0.8-0.5,0.9-0.8c0.4-0.9,0.4-1.8,0.9-2.6c0.5-0.8,1.1-1.4,1.8-1.9c2.4-1.7,5.6-2.9,8.5-2.5 c0.3,0,0.6,0,0.8,0c-0.2-0.2-0.3-0.5-0.5-0.7c-1.6-2.2-2.4-4.4-1.1-7c0.3-0.6,0.1-0.6-0.4-0.6c-4.3,0.1-8.7,0.1-13,0.2 c-5.1,0.1-10.2,0.2-15.2,0.5c-9.8,0.6-19.7,1.3-29.5,2C62.9,65.4,53.9,66.5,44.9,66.3L44.9,66.3z M34.7,59.2 c-0.4,0.3-1.1,0.6-1.3,1.1c-0.5,1-0.7,2.1-1,3.1c-0.3,0.8,0.1,1,0.9,1c1.8,0,3.6,0.1,5.5,0.1c8.7,0.3,17.3,0,26-0.8 c9.8-0.9,19.6-1.6,29.5-2.3c5.4-0.4,10.9-0.7,16.3-0.9c4.9-0.2,9.8-0.2,14.7-0.3c2.4,0,4.9,0.5,7.2-0.7c1.4-0.7,0.9,1.2,0.5,1.8 c-0.5,0.7-1,1.3-1.5,2.1c-0.7,1.2-0.8,2.5,0,3.6c0.6,0.9,1.3,1.7,2,2.4c0.9,1,1.9,2,2.9,3c0.6,0.6,0,0.8-0.4,0.7 c-0.9-0.3-1.7-0.7-2.5-1.1c-0.4-0.2-0.5-0.2-0.7,0.2c-0.4,1-0.9,2-1.3,3.1c-0.1,0.2-0.1,0.3-0.1,0.5c0.2,0,0.4,0,0.5-0.1 c3.2-1.1,6.6-1.8,9.9-2.6c4.5-1.1,8.8-2.7,13.2-4.1c0.4-0.1,0.7-0.4,1-0.7c0.1-0.1,0.2-0.2,0.2-0.3c-0.1,0-0.2-0.1-0.4-0.1 c-0.5,0-1.1,0-1.6-0.1c-0.3,0-0.6-0.1-0.9-0.2c0.2-0.3,0.3-0.7,0.6-0.9c0.5-0.4,1-0.7,1.5-1c0.4-0.2,0.8-0.3,1.1-0.6 c0.1,0,0.1-0.3,0.1-0.4c-0.7-0.7-1.4-1.5-2.2-2.1c-4.7-3.1-9.9-4.9-15.3-6.1c-8.8-1.9-17.6-3.4-26.5-4.3c-4.1-0.4-8.2-0.6-12.2,0.1 c-5.5,0.8-11,1.6-16.6,2.4c-7,1-13.9,1.9-20.9,3c-3.8,0.6-7.6,1.5-11.5,2.2c-4.3,0.7-8.6,1-12.9-0.1C37.3,59.9,36.1,59.6,34.7,59.2 L34.7,59.2z M92.8,51.9c0.8-0.1,1.4-0.3,2.1-0.4c1.7-0.2,3.5-0.4,5.2-0.6c0.2,0,0.5-0.2,0.7-0.3c-0.1-0.2-0.3-0.4-0.4-0.6 c-3.3-2.8-6.6-5.6-9.9-8.4c-0.5-0.4-1-0.6-1.6-0.8c-0.4-0.1-0.9,0-1.2,0.3c-1.2,1.2-2.3,2.5-3.5,3.7c-0.3,0.3-0.3,0.5,0.1,0.8 c2.6,1.9,5.1,3.9,7.7,5.9C92.1,51.7,92.5,51.8,92.8,51.9L92.8,51.9z M51.2,85.1c0.7-0.2,1.2-0.2,1.6-0.4c4.1-1.2,7.6-3.5,11.1-5.9 c0.1-0.1,0.1-0.2,0.2-0.2c-0.2-0.1-0.3-0.2-0.5-0.3c-1.2-0.4-2.4-0.8-3.6-1.1c-0.6-0.1-1.3-0.3-1.8-0.1c-2.3,0.8-4.6,1.8-6.9,2.8 c-2.1,0.9-2.3,1.5-1.5,3.6c0.1,0.3,0.2,0.5,0.4,0.7C50.5,84.6,50.9,84.9,51.2,85.1z M19.6,55.5c0,1.2,0.8,1.4,1.5,1.6 c2.9,0.8,5.7,1.5,8.6,2.3c1.7,0.5,2.1,0.4,3.3-1c0.6-0.8,0.6-1.3-0.4-1.7c-1.3-0.6-2.6-1.2-4-1.7c-2.3-0.9-4.6-1.7-7-2.5 c-0.5-0.2-1.2-0.3-1.4,0.4C19.9,53.8,19.8,54.8,19.6,55.5L19.6,55.5z M21.6,76c1-0.1,2.3-0.2,3.6-0.4c2.4-0.4,4.7-0.9,6.8-2.3 c0.3-0.2,0.7-0.6,0.7-0.9c0.1-0.7-1.5-2-2.2-1.9c-3.3,0.5-6.5,0.9-9.8,1.5c-0.5,0.1-1,0.5-1.3,0.9c-0.4,0.6-0.6,1.3-0.9,1.9 c-0.3,0.6-0.1,1,0.6,1.1C19.9,75.9,20.6,75.9,21.6,76L21.6,76z M79.9,53.7c1.1-0.1,2-0.3,2.9-0.4c2.1-0.2,4.2-0.4,6.3-0.7 c0.3,0,0.5-0.3,0.8-0.4c-0.1-0.2-0.2-0.5-0.4-0.6c-2.1-1.6-4.3-3.1-6.4-4.7c-0.1-0.1-0.5-0.1-0.6,0c-1.3,1.3-2.6,2.7-3.9,4 c-0.9,0.9-0.8,1.6,0.3,2.3C79.1,53.5,79.6,53.6,79.9,53.7L79.9,53.7z M121.3,77.3c0.1,0.7,0.2,1.3,0.4,1.9c1.4-1.6,3-3.2,4.5-4.7 c0.2-0.2,0.4-0.4,0.6-0.4s0.5,0,0.7,0.2c0.2,0.3,0,0.7-0.2,0.9c-1.3,1.9-2.9,3.7-4.6,5.3c-0.4,0.4-0.9,0.8-1.2,1.4 c-0.3,0.5-0.4,1.3-0.1,1.8c0.4,0.7,1.1,0.3,1.5-0.2c2.4-3.2,4.7-6.4,7.1-9.6c0.3-0.4,0.6-1,0.4-1.4c-0.1-0.4-0.6-0.6-0.9-0.6 c-0.4,0-0.8,0.1-1.1,0.2c-1.4,0.5-2.8,1-4.2,1.4c-0.8,0.3-1.7,0.6-2.2,1.3c-0.5,0.6-0.7,1.4-0.7,2.1 C121.3,77.1,121.3,77.3,121.3,77.3L121.3,77.3z M26.3,64c0,0,0,0.1,0,0.1c0.5,0,1,0.1,1.6,0.1c0.5,0,1.1,0.1,1.6,0 c0.9,0,1.4-0.6,1.5-1.9c0.1-0.8-0.5-1.1-1.1-1.2c-0.8-0.2-1.7-0.4-2.5-0.6c-2.3-0.6-4.5-1.2-6.8-1.9c-0.1,0-0.5,0.1-0.5,0.2 c0.3,1.3,0.6,2.6,1.1,3.8c0.3,0.9,1.2,1.3,2.1,1.3C24.2,64,25.2,64,26.3,64L26.3,64z M94.8,81.5c-0.3-0.4-0.4-0.9-0.7-1.1 c-1-0.9-2.8-0.9-3.7,0.1c-0.7,0.7-1.4,1.5-2.2,2.2c-1.2,1.3-2.5,2.5-3.7,3.9c-0.3,0.4-0.6,1.4-0.4,1.6c0.6,0.5,1.3,0.1,1.8-0.4 c0.1-0.1,0.2-0.2,0.3-0.3c0.7-0.8,1.5-1.5,2.2-2.3c0.9-1,2-1.5,3.3-1.2c0.7,0.2,1.3,0.2,1.7-0.6C93.9,82.7,94.3,82.2,94.8,81.5 L94.8,81.5z M26.1,65.9C26.1,65.9,26.1,65.8,26.1,65.9c-1.1-0.1-2.2-0.2-3.3-0.2c-0.7,0-1.3,0.2-1.6,0.9c-0.3,1-0.5,2.1-0.7,3.1 c0,0.1,0.2,0.3,0.3,0.3c2.9-0.4,5.8-0.9,8.7-1.3c0.8-0.1,1.2-0.4,1.2-1.3c-0.1-1.1-0.3-1.5-1.3-1.5C28.3,65.9,27.2,65.9,26.1,65.9 L26.1,65.9z M48.5,75.1c-0.1,0.4-0.1,0.8,0,1.2c0.1,0.8,0.2,1.6,0.3,2.4c0,0.4,0.2,0.4,0.5,0.3c2-0.8,4-1.7,6-2.5 c0.2-0.1,0.3-0.3,0.4-0.4c0-0.1-0.2-0.3-0.3-0.4c-0.9-0.5-1.8-1-2.7-1.4c-1.1-0.5-3.2-0.7-3.9,0.5C48.6,74.9,48.6,75,48.5,75.1 L48.5,75.1z M87.7,80c-2.4,0-3.4,1-3.4,3.3c0,0.2,0,0.4,0.1,0.5c0.1-0.1,0.3-0.2,0.4-0.3c1-0.9,2-1.8,3-2.8c0.2-0.2,0.4-0.4,0.6-0.6 C88.1,80.1,87.8,80,87.7,80L87.7,80z M50.7,58.9c0.6-0.2,1.2-0.4,1.7-0.6c0.1,0,0.2-0.2,0.3-0.2c-0.1,0-0.2-0.1-0.3-0.1 c-1.5-0.2-3-0.4-4.5-0.6c-0.2,0-0.3,0-0.5,0.1c0.1,0.2,0.2,0.5,0.4,0.5C48.7,58.3,49.7,58.6,50.7,58.9L50.7,58.9z"}),jsxRuntimeExports.jsx("path",{d:"M146.2,61.3c1.1,0,1.9,0.8,1.9,1.8c0,1-0.8,1.8-1.8,1.8c-1.1,0-1.9-0.8-1.9-1.8C144.3,62.2,145.1,61.4,146.2,61.3z"})]});const DinkBadge=({elClass:s,fillColor:a})=>jsxRuntimeExports.jsxs("svg",{className:s,xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 432 432",children:[jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{className:"st0",d:"M65,288.6h31.9v5.6l-9,1.1l20.1,83.7h0.3l19.4-63.6l-6.2-23.5l13.8-4.5l24.9,91.1h0.3l13.8-52.6   c1.2-4.8,4.7-12.8,4.7-23.6c0-3.4-5.8-8.1-10.7-8.1v-5.6h29.1v5.6c-5.6,1.2-9,3.9-11,11.4l-22.7,83.4l3.1,10.9h-15.2l-20.4-74.8   h-0.3l-19.6,63.9l3.6,10.9H99.2L72.5,295.2l-7.5-1.1L65,288.6L65,288.6z"}),jsxRuntimeExports.jsx("path",{className:"st0",d:"M219.3,391c2.6,0.5,6.1,0.8,9.3,0.8c21,0,31.7-7.8,38.7-27.5l5,0.8l-7.6,34.7c-3.1-1.1-5.9-1.5-8.9-1.9   c-3.1-0.5-6.4-0.5-10.6-0.5h-43.5v-4.4l53.6-98.1c-2.5-0.2-5.6-0.8-8.4-0.8c-20.5,0-28.9,7.6-36.2,24.6l-4.8-1.2l6.8-30.2   c2.2,0.6,4.7,0.9,7.1,1.1c2.5,0.2,5,0.2,7.1,0.2H272v5.3L219.3,391L219.3,391z"}),jsxRuntimeExports.jsx("path",{className:"st0",d:"M297.5,295.3l-9.3-1.1v-5.6h52.6c8.4,0,13.2-0.3,19.4-2.3l6.8,32.2l-4.8,0.9c-9.3-19.3-18-25.2-36.9-25.2   c-4.4,0-8.5,0-12.9,0.8v41.5h7.1c10.1,0,14-2.6,17.1-17.3h5.1v40.1h-5.1c-3.1-14.6-7-17.3-17.1-17.3h-7.5v49   c4.4,0.8,8.5,0.8,12.9,0.8c20.1,0,31.4-8.7,39.6-27.8l5.4,0.6l-8.4,35.1c-3.1-1.1-5.9-1.5-8.9-1.9c-3.1-0.5-6.4-0.5-10.6-0.5h-54.1   v-5.6l9.3-1.1L297.5,295.3L297.5,295.3z"})]}),jsxRuntimeExports.jsx("g",{id:"m5YsMK_00000055685305034694302510000009022022761495622051_",children:jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsx("path",{className:"st0",d:"M195.5,247.3c-1-0.7-2.2-1.4-3-2.2c-3.8-3.7-7.5-7.4-11.3-11.2c-1.8-1.8-1.8-4.2-0.1-6.1     c1-1.1,1.9-2.3,2.9-3.3c1.4-1.3,2.9-2.4,4.4-3.6c1.9-1.4,3.9-2.7,5.6-4.3c2.4-2.2,4.6-4.7,7-7.1c-0.3-0.3-0.5-0.6-0.7-0.8     c-1.7-1.7-3.4-3.3-5-5c-0.9-0.9-1.8-1.5-3.2-1.5c-2.1,0-3.7-1.4-5.2-2.8c-3.9-3.6-8.3-5.9-13.6-6.6c-4.9-0.7-9.8-0.5-14.6,0.7     c-4.9,1.2-9.7,2.9-14.6,4.1c-12.6,3.2-24,0.6-33.5-8.5c-9-8.6-17.6-17.5-26.3-26.4c-8.9-9.1-17.7-18.3-26.7-27.3     c-4.4-4.4-7-9.6-8.2-15.5c-0.4-1.8-0.6-3.6-0.9-5.5c0-1.8,0-3.6,0-5.3c0.3-1.5,0.5-3,0.8-4.5c1.5-6.6,4.8-12.1,9.5-16.9     c9.3-9.4,18.7-18.7,28-28c3.7-3.7,7.3-7.3,11.1-10.9c6.9-6.4,15-10,24.6-9.8c9.4,0.2,17.6,3.3,24.4,10.2     c16.9,17.2,33.9,34.2,50.9,51.3c7.3,7.4,11,16.2,10.6,26.7c-0.2,4.8-1.6,9.3-2.8,13.8c-1.3,5-2.8,10.1-3.7,15.2     c-1.2,6.9,0.4,13.4,4.3,19.2c0.3,0.5,0.7,0.9,1.2,1.3c2.3,1.9,3.5,4.4,3.9,7.3c0.1,0.6,0.3,1.3,0.7,1.7c1.9,2.2,3.9,4.3,5.9,6.5     c2-2.2,4-4.4,6-6.6c0.4-0.5,0.5-1.2,0.6-1.8c0.5-2.8,1.7-5.1,3.8-7c2.1-1.9,3.1-4.4,4.1-6.9c2.3-5.8,2.3-11.7,0.8-17.7     c-1.5-6-3.3-11.8-4.8-17.8c-3-12.4-0.2-23.5,8.5-32.7c7.4-7.8,15.1-15.3,22.7-23c9.9-10,19.8-19.9,29.7-29.9     c5.8-5.9,12.9-8.8,21-9.6c11-1.1,20.4,2.6,28.2,10.2c12.5,12.3,24.9,24.7,37.4,37c4.3,4.3,7.7,9.1,9.7,14.8     c1.4,4.1,1.9,8.4,1.6,12.7c-0.4,5.1-1.5,10-3.9,14.5c-1,2-2.3,3.9-3.9,5.5c-17.6,18.1-35.4,36-53,54.1c-7.5,7.7-16.6,11-27,11     c-4.3,0-8.4-1.3-12.4-2.6c-5.4-1.7-10.9-3.4-16.6-3.7c-6.9-0.4-13.6,0.5-19.4,4.9c-1,0.8-2,1.7-3,2.6c-1.6,1.4-3.3,2.4-5.5,2.3     c-0.4,0-1,0.3-1.3,0.6c-2.2,2.2-4.3,4.4-6.6,6.7c2.5,2.5,4.9,5.1,7.6,7.6c1.6,1.5,3.6,2.6,5.4,4c1.3,1,2.6,2.1,3.9,3.3     c1,1,1.8,2.1,2.8,3.1c2,2.2,1.9,4.4-0.2,6.5c-3.7,3.7-7.3,7.3-11.1,10.9c-0.9,0.9-2,1.5-3,2.2c-0.6,0-1.2,0-1.9,0     c-0.5-0.3-1.2-0.5-1.6-0.9c-2.4-2.5-5.1-4.9-7.2-7.7c-1.6-2.1-3.1-4.2-5-6c-1.9-1.9-3.8-3.8-5.7-5.6c-0.3-0.3-0.6-0.6-1-0.9     c-2.8,2.9-5.6,5.6-8.3,8.4c-0.9,1-1.7,2.1-2.5,3.2c-2.5,3.8-5.6,7.1-9.5,9.7C196.7,247.3,196.1,247.3,195.5,247.3z M55.6,111.6     c0.1,1.3,0.2,2.7,0.4,4c0.9,7,3.6,13.2,8.7,18.2c3.9,3.9,7.8,7.9,11.7,11.9c12,12.2,24,24.4,36,36.6c5.7,5.8,12.6,8.6,20.6,9     c4.3,0.2,8.4-0.9,12.5-2.1c7.6-2.3,15.3-4.2,23.3-3.6c2.2,0.2,4.6,0.5,6.6,1.3c2.8,1.1,5.4,2.7,8.1,4.2c0.5,0.3,0.9,0.4,1.4-0.1     c0.9-0.9,2-1.6,2.9-2.4c4.1-3.4,7.8-7.1,11.3-11.1c0.8-0.9,0.7-1.6,0-2.4c-0.5-0.6-1.1-1.1-1.5-1.8c-3.6-6.1-4.9-12.8-3.6-19.7     c1.1-6.2,2.7-12.4,4.2-18.5c1.2-4.7,1.8-9.4,1.2-14.2c-0.9-7.2-4.2-13-9.2-18.1c-16.3-16.5-32.6-33.1-48.9-49.6     c-1.3-1.3-2.8-2.5-4.3-3.4c-4.5-2.8-9.5-3.8-14.7-3.9c-6.7-0.2-12.8,1.5-18.1,5.6c-3.6,2.8-6.8,6.1-10,9.3     c-9.9,9.9-19.8,19.8-29.7,29.8C58.9,96.4,55.6,103.3,55.6,111.6z M313.9,45.8c-0.7,0-1.4,0-2.1,0c-0.7,0-1.4,0.1-2.1,0.2     c-6.3,0.7-11.8,3-16.3,7.6c-11.1,11.4-22.3,22.7-33.5,34c-5.7,5.8-11.5,11.4-16.9,17.4c-6.4,7-8.4,15.4-7,24.6     c0.7,4.6,2.1,9,3.1,13.6c1.1,4.8,2.5,9.6,2.5,14.5c0,6.3-1.3,12.2-5.5,17.2c-0.9,1.1-0.9,1.7,0.1,2.7c4.1,4.5,8.3,8.9,13.2,12.6     c1.6,1.2,1.5,1.2,3.3,0.2c2.1-1.2,4.1-2.5,6.3-3.4c5.2-2.2,10.7-2.1,16.1-1.2c5.1,0.8,10.1,2.1,15.1,3.5     c5.4,1.5,10.7,2.5,16.3,1.5c5.6-1,10.7-3.2,14.9-7.2c4.6-4.5,9.1-9.1,13.7-13.7c12-12.2,24.1-24.3,35.9-36.6     c7.5-7.9,9.8-17.4,7.8-28c-1.2-6.1-4.5-11-8.8-15.3c-9.3-9.3-18.6-18.6-27.8-28c-3.9-4-8-7.7-12.4-11.2c-0.7-0.6-1.5-1.2-2.4-1.6     C323.3,46.9,318.7,45.7,313.9,45.8z"})})})})]});const PerryBadge=({elClass:s})=>jsxRuntimeExports.jsxs("svg",{className:s,viewBox:"0 0 48 39",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[jsxRuntimeExports.jsx("rect",{width:"47",height:"38",transform:"translate(0.5 0.5)",fill:"white"}),jsxRuntimeExports.jsxs("g",{clipPath:"url(#clip0)",children:[jsxRuntimeExports.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M7.7865 22.0632H11.9018L11.6965 20.6697H8.06028L7.7865 22.0632Z",fill:"#14334C"}),jsxRuntimeExports.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M3.50007 28.2156C3.83375 28.2241 4.17598 28.1901 4.5011 28.1136C4.92888 28.0116 5.38234 27.9436 5.70746 27.6632C5.79302 27.5953 5.86146 27.5103 5.92135 27.4168L5.58768 25.7259L5.50212 25.0036C5.34812 25.318 5.05722 26.3292 4.88611 26.6351C4.82622 26.737 4.76632 26.839 4.69788 26.941C4.56099 27.1534 4.40698 27.3658 4.20164 27.5188C3.99631 27.6717 3.74819 27.7737 3.49152 27.8162V28.2156H3.50007Z",fill:"#14334C"}),jsxRuntimeExports.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M8.31707 27.8163C8.05185 27.8333 7.78662 27.7399 7.58983 27.5699C7.47005 27.4679 7.3845 27.3235 7.30749 27.1875C7.22194 27.0346 7.16205 26.8646 7.11927 26.6947C7.04227 26.4313 6.99949 26.1509 6.99093 25.8705C6.96526 25.2417 7.20483 24.6469 7.37594 24.0351C7.81228 22.4716 8.11174 20.8826 8.46252 19.2936C8.88176 17.3987 9.36943 15.5123 9.63466 13.592C9.70311 13.0821 9.72878 12.5553 9.95123 12.1049C10.1309 11.7311 10.4132 11.4167 10.764 11.1872C10.7384 11.0343 10.6785 10.8983 10.5929 10.7709C10.2935 10.329 9.78011 10.1166 9.26677 9.92965C8.60797 9.69172 7.89784 9.59825 7.19627 9.64924L7.07649 10.0656C7.47005 10.1676 7.81228 10.414 8.04329 10.7454C8.1374 10.8813 8.21441 11.0343 8.26574 11.1957C8.29996 11.3147 8.30852 11.4337 8.31707 11.5526C8.32563 11.7141 8.29996 11.8755 8.29141 12.037C8.24007 12.5043 8.16307 12.9632 8.07751 13.422C7.72673 15.3594 7.25616 17.2628 6.83693 19.1831C6.48614 20.7976 6.22947 22.4376 5.78457 24.0266L5.30545 25.7005C5.24555 25.9044 5.237 26.1169 5.26267 26.3293C5.29689 26.6692 5.42523 26.9921 5.6049 27.281C5.7589 27.5189 5.93857 27.7314 6.16958 27.8928C6.46047 28.0967 6.8027 28.2242 7.15349 28.2327H8.20585L8.31707 27.8163Z",fill:"#14334C"}),jsxRuntimeExports.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M16.8556 27.8672C16.4877 27.7397 16.1626 27.5188 15.8974 27.2384C15.5723 26.89 15.4268 26.4227 15.2472 25.9808C15.1274 25.6749 14.9819 24.7742 14.9135 24.4513L14.7338 25.0036C14.691 25.3435 14.6055 25.6664 14.4771 25.9808C14.306 26.4311 14.0494 26.8475 13.7328 27.2129C13.9638 27.3998 14.2205 27.5613 14.4771 27.7057C14.7253 27.8332 14.9734 27.9522 15.2386 28.0371C15.7348 28.1901 16.2567 28.2496 16.7786 28.2156L16.8556 27.8672Z",fill:"#14334C"}),jsxRuntimeExports.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M13.9892 10.1757C13.7667 10.1333 13.5443 10.1502 13.339 10.2352C12.9967 10.3712 12.8085 10.7111 12.6545 11.0425C12.5262 11.3229 12.4492 11.6373 12.4834 11.9432L12.6288 13.1923L14.9902 24.7995C15.0416 25.4623 14.8362 26.1081 14.4683 26.6689C14.1346 27.1787 13.6555 27.5611 13.1165 27.8415C12.4663 28.1729 11.739 28.3088 11.0118 28.2409L10.9006 27.833C11.4054 27.7565 11.8503 27.4761 12.124 27.0427C12.2609 26.8303 12.3465 26.5924 12.3807 26.346C12.4577 25.7682 12.3807 25.1904 12.2695 24.621L10.0193 13.1243C9.91666 12.6144 9.8311 12.0791 9.99366 11.5863C10.199 10.9575 10.7295 10.5071 11.3027 10.1587C11.8674 9.81886 12.5262 9.65741 13.185 9.65741H13.9806V10.1757H13.9892Z",fill:"#14334C"})]}),jsxRuntimeExports.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M36.2698 26.6982C36.473 27.0706 36.7607 27.3922 37.0992 27.6376C37.5139 27.9338 38.0133 28.0777 38.5211 28.1708C39.2574 28.3062 40.0106 28.2808 40.7131 28.0184C41.3055 27.7984 41.8218 27.4091 42.2703 26.9521C42.8458 26.3681 43.2605 25.6402 43.4975 24.8532C43.7853 23.9053 43.6922 22.8981 43.5314 21.9248C43.4129 21.2393 43.2859 20.5538 42.9389 19.9529C42.4904 19.1743 41.8387 18.5311 41.0516 18.0994L39.926 18.6242C40.3915 19.1912 40.7131 19.8513 40.8739 20.5623C40.9839 21.0616 40.9585 21.5863 40.9585 22.0941V24.3961C40.9585 24.9378 40.857 25.471 40.6792 25.9788C40.5692 26.3004 40.4169 26.6051 40.1545 26.8251C39.7567 27.1636 39.2151 27.2906 38.7157 27.1383C38.4534 27.0536 38.2333 26.8928 38.0302 26.6982C37.6747 26.3512 37.5393 25.5556 37.5055 25.0563L36.2698 26.6982Z",fill:"#14334C"}),jsxRuntimeExports.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M37.311 18.8105H39.3337C39.8839 18.8105 40.4255 18.6667 40.9333 18.4381C41.4496 18.2096 41.9151 17.8796 42.3128 17.4733C42.7952 16.9909 43.193 16.4239 43.4046 15.7807C43.6331 15.0613 43.5569 14.2827 43.4554 13.5294C43.3708 12.8947 43.2523 12.2599 42.9476 11.7013C42.626 11.092 42.1859 10.5419 41.6019 10.1949C41.0518 9.8648 40.3917 9.76324 39.7484 9.72938C39.0629 9.68707 38.3774 9.73785 37.7511 10.0171C37.1841 10.271 36.6932 10.6603 36.3208 11.1512L37.3364 13.0639L37.4887 13.0724L37.7342 11.7183C37.8019 11.3967 37.9965 11.1174 38.2589 10.9142C38.6567 10.6096 39.1983 10.5588 39.6638 10.7365C39.9346 10.8381 40.1632 11.0243 40.3409 11.2443C40.5863 11.5405 40.6625 11.9383 40.7556 12.3192C40.8487 12.7339 40.8656 13.1655 40.8656 13.5971V15.5522C40.8656 15.9415 40.9079 16.3477 40.7556 16.6947C40.6456 16.9486 40.4848 17.1771 40.2732 17.3548C40.0023 17.5833 39.6638 17.7188 39.3084 17.7188H37.311V18.8105Z",fill:"#14334C"}),jsxRuntimeExports.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M33.0795 10.3985C33.7566 10.3139 34.4252 10.6608 34.7552 11.2617C34.916 11.541 34.9583 11.8711 34.9583 12.2012V13.1914V24.6253C34.9583 25.1247 35.0261 25.6325 34.8314 26.081C34.6875 26.4026 34.459 26.6819 34.1966 26.9189C33.8666 27.2067 33.4773 27.4182 33.0456 27.5198L33.0372 27.9853C33.6127 28.0361 34.1966 27.9599 34.7383 27.7737C35.2715 27.5875 35.7285 27.249 36.1686 26.8935C36.6679 26.4957 37.125 26.0303 37.5058 25.514V12.8952C37.3535 12.3535 37.0657 11.8626 36.7103 11.431C36.3633 11.0078 35.9401 10.6439 35.4577 10.39C34.9414 10.1107 34.3744 9.92454 33.7904 9.91608H33.0795V10.3985Z",fill:"#14334C"}),jsxRuntimeExports.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M32.5613 13.233C32.0648 13.3464 31.5542 13.3323 31.0578 13.2046C30.5755 13.0769 30.15 12.8358 29.7954 12.5096C29.2564 11.999 29.0295 11.2756 28.8876 10.5522C28.6891 9.57354 29.3273 8.56649 29.2139 7.5878C29.1288 6.86443 28.9444 6.12687 28.4054 5.61625C27.8664 5.10563 27.1147 4.89287 26.3629 4.89287C25.8239 4.89287 25.3133 5.02053 24.8452 5.27584C24.1502 5.64462 23.668 6.26871 23.3559 6.96371C23.1148 7.51688 23.1006 8.14097 23.0439 8.73669C22.8879 10.6515 23.0155 12.5663 23.0013 14.4811C22.9872 17.7292 22.8737 27.1899 23.0723 28.665C23.1999 29.5444 23.2992 30.4521 23.8524 31.1613C24.3204 31.7571 24.9303 32.2535 25.6821 32.4521C26.4055 32.6365 27.1714 32.5088 27.8806 32.2393C28.5472 31.9982 29.1429 31.601 29.5685 31.062C29.8805 30.6933 30.0649 30.2394 30.2351 29.7997C30.8734 28.2253 30.7032 25.2041 30.7032 25.2041L32.0081 25.2183C32.0081 25.2183 32.6038 29.4451 30.8592 32.2393C30.4053 32.9627 29.7245 33.53 28.9444 33.9414C27.8522 34.5087 26.5757 34.5655 25.3417 34.452C23.824 34.3101 22.3489 33.7853 21.2 32.8208C20.2213 32.0124 19.654 30.8493 19.115 29.7146C18.349 28.1118 18.1505 26.3388 17.881 24.5942C17.3704 21.2185 17.4271 17.7718 18.0654 14.4244C18.4767 12.2968 18.9448 10.1693 19.9518 8.24026C20.3348 7.51688 20.7178 6.77932 21.2426 6.15524C21.9801 5.26165 22.817 4.42481 23.8949 3.98511C24.675 3.65888 25.5119 3.47449 26.3629 3.50286C27.4976 3.54541 28.6323 3.8149 29.4408 4.55246C30.2351 5.26165 30.4195 6.38218 30.7174 7.40341C30.9585 8.22608 31.0578 9.07711 31.1712 9.92814C31.2422 10.4813 31.2847 11.0487 31.5116 11.5451C31.6393 11.843 31.8379 12.1124 32.0223 12.3819C32.1925 12.6372 32.391 12.8642 32.5896 13.0911L32.5613 13.233Z",fill:"#14334C"}),jsxRuntimeExports.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M26.0226 10.1414C25.9659 10.6378 26.1644 11.1343 26.5616 11.4605C27.0438 11.8576 27.7388 11.7584 28.3771 11.6165C28.7743 11.5314 29.143 11.347 29.4409 11.0917L29.0863 9.02087C28.7884 9.31873 28.4338 9.55986 28.0509 9.73007C27.7105 9.88609 27.3417 9.98538 26.9587 9.99956C26.6892 10.0137 26.4197 9.97119 26.1644 9.90027L26.0226 10.1414Z",fill:"#14334C"}),jsxRuntimeExports.jsx("defs",{children:jsxRuntimeExports.jsx("clipPath",{id:"clip0",children:jsxRuntimeExports.jsx("rect",{width:"13.3555",height:"18.575",fill:"white",transform:"translate(3.5 9.64062)"})})})]});const ForsythBadge=({elClass:s})=>jsxRuntimeExports.jsxs("svg",{width:"63",height:"47",viewBox:"0 0 203 121",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[jsxRuntimeExports.jsx("path",{d:"M202.08 76.1245C201.036 77.7235 199.969 79.1597 199.116 80.7156C197.648 83.3918 197.281 86.3599 197.18 89.3616C197.123 91.109 197.242 92.8851 197.009 94.6086C196.499 98.3427 194.411 101.143 191.347 103.202C187.934 105.495 184.145 106.649 180.032 106.74C175.747 106.831 171.51 106.52 167.602 104.609C165.442 103.556 163.465 102.134 161.32 100.827C157.121 104.82 151.83 105.873 145.982 105.39V103.551C146.049 103.518 146.173 103.417 146.311 103.379C150.744 102.177 153.136 99.0321 154.142 94.7714C154.638 92.6601 154.928 90.4531 154.938 88.2845C155 69.9728 155.009 51.6563 154.938 33.3446C154.928 30.7451 154.557 28.1072 154.032 25.5556C153.193 21.4863 150.906 18.7288 146.449 18.3937C146.297 18.3841 146.154 18.3219 145.958 18.2692V16.0718C151.635 15.6266 157.054 15.8611 161.015 20.8256C165.042 17.7282 169.56 15.976 174.436 15.143C178.821 14.3962 183.201 14.3579 187.515 15.6361C193.072 17.283 196.108 21.1033 196.871 26.7668C197.223 29.3998 197.223 32.0855 197.633 34.7042C198.115 37.7394 199.373 40.473 201.651 42.6465C201.851 42.838 202.037 43.3119 201.937 43.4986C201.794 43.7715 201.365 44.1018 201.094 44.0731C197.314 43.6758 193.82 42.7183 191.904 39.123C190.312 39.2091 188.744 39.4485 187.2 39.348C185.027 39.2044 183.783 37.8591 183.421 35.7096C183.273 34.8431 183.459 34.4744 184.45 34.5319C186.814 34.6659 189.097 34.3165 190.794 32.4685C193.425 29.6057 192.996 25.0864 189.912 22.2092C188.072 20.4953 185.851 19.5714 183.416 19.2027C179.469 18.6091 175.647 18.9681 172.177 21.1512C169.093 23.0949 167.43 25.8907 167.42 29.5817C167.401 37.6245 167.411 45.6673 167.411 53.7053C167.411 53.9782 167.459 54.2511 167.492 54.6723C169.937 54.4952 172.33 54.3181 174.984 54.1266C174.684 52.9633 174.465 51.8957 174.126 50.8664C173.412 48.6833 172.344 46.5817 172.601 44.188C172.935 41.081 174.427 38.7256 177.258 37.3181C177.553 37.1697 178.025 37.1745 178.321 37.3133C178.468 37.3804 178.373 37.9166 178.449 38.2229C178.788 39.549 178.969 40.9565 179.55 42.1677C180.356 43.8433 181.586 45.3083 182.42 46.9743C182.992 48.1184 183.397 49.4206 183.54 50.6893C183.807 53.0399 182.715 54.8351 180.737 56.0846C180.38 56.3096 180.013 56.5251 179.512 56.8267C181.395 57.9038 182.71 59.3113 183.297 61.322C183.854 63.237 183.32 64.9604 182.291 66.5354C181.357 67.9669 180.284 69.2978 179.298 70.6957C178.264 72.1558 177.525 73.7069 177.811 75.5836C177.858 75.8948 177.701 76.2394 177.634 76.5746C173.502 75.5788 171.472 72.1989 172.477 67.8472C172.921 65.9227 173.764 64.0939 174.355 62.1981C174.679 61.1592 174.856 60.0773 175.123 58.9092C174.36 58.8469 173.85 58.7751 173.34 58.7703C171.405 58.756 169.47 58.7656 167.397 58.7656C167.397 59.0528 167.397 59.4406 167.397 59.8283C167.397 68.1871 167.325 76.5506 167.44 84.9094C167.478 87.6717 167.711 90.4962 168.359 93.1676C169.365 97.3134 171.724 100.511 176.071 101.794C181.199 103.312 188.692 100.803 191.328 96.6672C194.164 92.2149 191.981 87.169 186.781 86.2163C185.932 86.0583 185.036 86.1493 184.188 85.9913C183.854 85.9291 183.354 85.5317 183.325 85.2445C183.101 83.0184 184.469 81.2375 186.704 80.9646C187.991 80.8066 189.316 80.8688 190.617 80.9646C191.413 81.022 191.871 80.8449 192.367 80.1699C194.65 77.0677 197.891 75.9331 201.613 75.9043C201.746 75.9043 201.885 76.0288 202.071 76.1198L202.08 76.1245Z",fill:"#84BDEE"}),jsxRuntimeExports.jsx("path",{d:"M178.683 107.381C175.108 107.381 171.1 107.017 167.32 105.174C165.809 104.437 164.423 103.547 162.955 102.608C162.44 102.278 161.92 101.943 161.391 101.617C157.502 105.117 152.44 106.563 145.925 106.022L145.348 105.974V103.173L145.687 102.996C145.801 102.924 145.954 102.828 146.144 102.776C150.072 101.713 152.483 99.0465 153.527 94.6325C154.037 92.4734 154.299 90.343 154.304 88.2893C154.371 68.2828 154.371 50.3111 154.304 33.3542C154.294 31.0706 154.004 28.562 153.408 25.6896C152.54 21.4959 150.248 19.3176 146.397 19.0304C146.23 19.016 146.082 18.9729 145.954 18.9346C145.906 18.9203 145.853 18.9059 145.796 18.8915L145.32 18.7719V15.4973L145.901 15.4494C151.034 15.0473 156.835 15.0425 161.105 19.9687C164.89 17.1777 169.222 15.3968 174.322 14.5303C179.298 13.6829 183.668 13.8504 187.686 15.0377C193.377 16.7229 196.675 20.6437 197.486 26.6902C197.652 27.9253 197.743 29.1844 197.829 30.4004C197.929 31.7935 198.029 33.2345 198.248 34.6181C198.734 37.6868 200.021 40.2384 202.08 42.2013C202.423 42.5268 202.766 43.288 202.49 43.8098C202.271 44.2311 201.642 44.7769 201.022 44.7146C197.533 44.346 193.706 43.4699 191.542 39.7932C191.185 39.8171 190.832 39.8459 190.479 39.8794C189.393 39.9703 188.268 40.0661 187.152 39.9943C184.769 39.8363 183.22 38.357 182.796 35.8293C182.715 35.3601 182.677 34.7713 183.054 34.3452C183.43 33.9191 184.054 33.8904 184.483 33.9143C187.2 34.0723 189.006 33.493 190.331 32.052C192.71 29.4621 192.338 25.3497 189.483 22.6879C187.853 21.1703 185.785 20.2129 183.325 19.8442C179.059 19.2027 175.523 19.8107 172.515 21.7017C169.56 23.5592 168.064 26.2162 168.054 29.5961C168.04 36.1021 168.04 42.6034 168.045 49.1094V53.7197C168.045 53.8154 168.054 53.9064 168.064 54.0069L174.198 53.5617C174.169 53.442 174.141 53.3223 174.112 53.2074C173.931 52.4606 173.759 51.7568 173.535 51.077C173.388 50.6222 173.221 50.1722 173.059 49.7222C172.42 47.9748 171.762 46.17 171.982 44.1353C172.349 40.7124 174.031 38.2325 176.981 36.7676C177.439 36.5378 178.116 36.533 178.588 36.7532C179.036 36.9591 179.045 37.4522 179.045 37.7777C179.045 37.8783 179.045 38.0267 179.064 38.0793C179.164 38.4623 179.25 38.8549 179.336 39.2474C179.546 40.2049 179.741 41.1097 180.127 41.9044C180.527 42.7326 181.028 43.5034 181.562 44.3173C182.057 45.0785 182.572 45.8636 182.992 46.7014C183.616 47.9461 184.026 49.3057 184.178 50.6318C184.46 53.1021 183.387 55.1798 181.085 56.6352C180.971 56.707 180.852 56.7788 180.728 56.8554C182.358 57.9948 183.406 59.4118 183.911 61.1592C184.464 63.055 184.107 64.9317 182.825 66.8945C182.239 67.7897 181.595 68.6563 180.971 69.494C180.58 70.0159 180.194 70.5425 179.817 71.0739C178.635 72.7495 178.221 74.0708 178.44 75.5022C178.492 75.8517 178.406 76.1628 178.325 76.4405C178.302 76.5315 178.273 76.6224 178.259 76.7086L178.135 77.3549L177.496 77.2017C172.997 76.1198 170.79 72.3952 171.877 67.7131C172.158 66.4971 172.592 65.3195 173.011 64.1801C173.273 63.4715 173.54 62.7439 173.764 62.021C173.974 61.3412 174.122 60.6326 174.279 59.881C174.308 59.7517 174.336 59.6177 174.36 59.4837C173.964 59.4454 173.65 59.4166 173.345 59.4118C171.948 59.4023 170.552 59.4023 169.103 59.4071H168.035V59.8379C168.035 62.1742 168.031 64.5104 168.026 66.8418C168.011 72.7638 167.997 78.8869 168.078 84.9094C168.121 88.0451 168.417 90.7021 168.984 93.024C170.028 97.323 172.477 100.076 176.262 101.196C181.123 102.637 188.33 100.229 190.808 96.3368C192.043 94.3979 192.295 92.234 191.504 90.3957C190.708 88.5573 188.949 87.2648 186.681 86.8435C186.299 86.7717 185.899 86.7573 185.47 86.7429C185.017 86.7238 184.555 86.7094 184.083 86.6233C183.568 86.5275 182.777 85.9722 182.71 85.3163C182.448 82.7455 184.102 80.6534 186.638 80.347C187.987 80.1842 189.373 80.2465 190.67 80.347C191.285 80.3949 191.514 80.2848 191.866 79.806C194.082 76.7948 197.271 75.3155 201.613 75.282H201.618C201.88 75.282 202.08 75.4017 202.223 75.4878C202.261 75.5118 202.304 75.5357 202.347 75.5596L202.99 75.8756L202.6 76.4788C202.271 76.9863 201.937 77.4746 201.608 77.9581C200.898 79.0018 200.231 79.988 199.659 81.0268C198.181 83.7269 197.891 86.7717 197.805 89.3904C197.786 89.9696 197.786 90.5489 197.786 91.1282C197.786 92.3011 197.786 93.5123 197.624 94.6995C197.119 98.3858 195.121 101.421 191.685 103.733C188.225 106.055 184.307 107.281 180.032 107.376C179.589 107.386 179.136 107.391 178.673 107.391L178.683 107.381ZM161.234 100.033L161.644 100.282C162.321 100.693 162.983 101.119 163.636 101.536C165.071 102.455 166.424 103.326 167.873 104.035C171.896 105.998 176.262 106.184 180.013 106.098C184.045 106.012 187.739 104.858 190.994 102.671C194.116 100.574 195.932 97.8305 196.385 94.5176C196.537 93.4117 196.532 92.2963 196.532 91.1186C196.532 90.525 196.532 89.9313 196.551 89.3377C196.642 86.5658 196.956 83.3391 198.563 80.4045C199.163 79.3129 199.85 78.3028 200.574 77.2352C200.727 77.0102 200.879 76.7852 201.036 76.5554C197.419 76.7086 194.75 78.0156 192.881 80.5481C192.267 81.3811 191.623 81.6731 190.579 81.5965C189.345 81.5056 188.034 81.4433 186.79 81.5965C184.927 81.8263 183.792 83.2386 183.959 85.12C184.031 85.211 184.221 85.3498 184.317 85.3737C184.693 85.4456 185.098 85.4599 185.522 85.4743C185.975 85.4934 186.442 85.5078 186.909 85.594C189.597 86.0871 191.695 87.6525 192.662 89.8835C193.625 92.1096 193.339 94.7091 191.876 97.007C189.088 101.383 181.333 104.001 175.914 102.398C171.667 101.139 168.927 98.0842 167.768 93.3112C167.182 90.8936 166.872 88.1456 166.829 84.9142C166.748 78.8869 166.763 72.7542 166.777 66.8275C166.782 64.4912 166.787 62.1598 166.787 59.8236V58.1288H169.112C170.561 58.1288 171.963 58.1288 173.364 58.1336C173.726 58.1336 174.084 58.1719 174.498 58.2102C174.708 58.2294 174.932 58.2533 175.189 58.2724L175.914 58.3299L175.752 59.0432C175.666 59.4118 175.594 59.7709 175.518 60.1204C175.356 60.9007 175.199 61.6428 174.97 62.38C174.737 63.1316 174.46 63.8785 174.193 64.6013C173.788 65.7024 173.364 66.8466 173.102 67.9812C172.225 71.7633 173.788 74.7027 177.191 75.7846C177.201 75.7368 177.201 75.6985 177.201 75.6698C176.857 73.4149 177.873 71.6244 178.797 70.3175C179.179 69.7765 179.574 69.2451 179.97 68.7137C180.58 67.8903 181.214 67.0381 181.776 66.1764C182.858 64.52 183.154 63.0263 182.706 61.4896C182.2 59.7517 181.09 58.44 179.212 57.3676L178.278 56.8315L179.665 55.9937C179.941 55.8309 180.18 55.6873 180.413 55.5389C182.305 54.342 183.149 52.7287 182.925 50.7467C182.791 49.5834 182.42 48.3387 181.867 47.2424C181.481 46.4716 181.009 45.7487 180.508 44.9827C179.979 44.1689 179.426 43.3311 178.993 42.4263C178.545 41.4927 178.321 40.473 178.106 39.4868C178.025 39.1086 177.944 38.7352 177.849 38.3666C177.801 38.1894 177.796 37.9979 177.792 37.8256C177.696 37.8256 177.601 37.84 177.544 37.8687C175.003 39.1325 173.555 41.2725 173.235 44.2359C173.049 45.9785 173.626 47.5679 174.241 49.253C174.412 49.7174 174.579 50.1818 174.732 50.651C174.97 51.3786 175.146 52.1063 175.332 52.8771C175.418 53.2266 175.504 53.5856 175.599 53.9495L175.79 54.6867L166.925 55.333L166.868 54.7106C166.853 54.567 166.839 54.4426 166.829 54.3277C166.806 54.0979 166.782 53.9016 166.782 53.6861V49.0759C166.782 42.5699 166.777 36.0638 166.791 29.5626C166.801 25.7183 168.498 22.7023 171.843 20.6006C175.118 18.5421 178.936 17.8766 183.511 18.5612C186.228 18.9681 188.525 20.0357 190.341 21.7305C193.711 24.871 194.116 29.7685 191.256 32.8802C189.178 35.1447 186.352 35.2548 184.412 35.1495C184.178 35.1351 184.059 35.1495 184.007 35.1686C184.002 35.2261 183.997 35.3457 184.04 35.5899C184.369 37.5384 185.446 38.582 187.238 38.7017C188.258 38.7687 189.288 38.6825 190.374 38.5916C190.87 38.5485 191.366 38.5054 191.866 38.4815L192.267 38.4575L192.457 38.8118C194.283 42.2395 197.69 43.0582 201.108 43.422C201.165 43.3981 201.251 43.3311 201.313 43.2688C201.289 43.2018 201.246 43.1204 201.217 43.0917C198.954 40.9374 197.538 38.1416 197.009 34.7904C196.78 33.3542 196.68 31.8845 196.575 30.4674C196.489 29.2706 196.404 28.0354 196.242 26.8386C195.498 21.3283 192.505 17.7569 187.334 16.2298C183.506 15.0952 179.322 14.942 174.536 15.7558C169.422 16.6271 165.123 18.4463 161.391 21.314L160.9 21.6922L160.514 21.2086C157.087 16.9096 152.621 16.2298 146.578 16.6463V17.7522C150.953 18.1112 153.665 20.6868 154.638 25.4119C155.248 28.3658 155.548 30.9557 155.557 33.3255C155.629 50.2871 155.629 68.2589 155.557 88.2701C155.548 90.4196 155.276 92.6458 154.747 94.9006C153.618 99.688 150.877 102.728 146.602 103.934V104.782C152.655 105.174 157.326 103.719 160.876 100.349L161.224 100.018L161.234 100.033Z",fill:"#042D41"}),jsxRuntimeExports.jsx("path",{d:"M98.4678 108.903C101.809 110.658 105.291 111.394 108.829 111.919C113.554 112.617 118.255 113.019 122.967 111.69C127.693 110.356 130.264 107.575 130.603 103.193C130.929 98.9844 128.702 94.9304 125.379 94.0219C124.198 93.6944 122.857 93.7129 121.626 93.8612C120.137 94.0405 119.516 93.5708 119.805 92.0876C120.433 88.8493 124.05 86.5009 127.563 87.1189C128.708 87.3228 129.822 87.7122 131.07 88.0459C133.741 83.1823 137.795 80.3024 143.911 79.9007C143.702 80.6608 143.733 81.4642 143.357 81.7979C139.235 85.4688 138.054 90.3263 137.826 95.536C137.654 99.4541 137.408 103.341 135.943 107.031C133.15 114.051 127.607 117.549 120.543 119.038C112.957 120.639 105.617 119.224 98.3386 117.123C96.4743 116.585 94.6039 116.047 92.7028 115.689C88.8328 114.96 86.8024 115.436 81.4496 118.031C80.2868 117.475 80.416 116.672 80.8221 115.627C94.1794 81.1861 107.518 46.739 120.851 12.2857C121.072 11.7171 121.269 11.1424 121.62 10.1721C118.55 9.36871 115.597 8.46026 112.588 7.83608C108.656 7.02033 104.688 6.84111 100.763 8.02766C94.0194 10.067 91.1277 17.4336 95.0223 22.8101C97.1265 25.7147 100.111 26.135 103.445 25.4243C104.264 26.2091 104.171 27.0311 103.624 27.989C101.716 31.32 98.4001 32.7537 94.7639 31.6413C93.9702 31.4003 93.5457 31.5054 93.1211 32.179C90.2417 36.7336 85.7995 37.7039 80.619 37.5926C80.7913 37.1106 80.8159 36.678 81.0435 36.4493C85.7195 31.9009 86.7409 26.0855 86.8209 19.9241C86.8393 18.4903 86.9008 17.0504 87.0239 15.6167C87.7253 7.3664 93.601 2.41625 101.747 1.1988C108.577 0.179101 115.16 1.31621 121.755 2.88593C124.573 3.55336 127.471 3.94888 130.351 4.2826C133.193 4.61014 135.919 3.93652 138.595 2.95391C139.229 2.71907 140.016 2.91683 141.038 2.91683C126.733 38.532 112.613 73.696 98.4678 108.909V108.903Z",fill:"#84BDEE"}),jsxRuntimeExports.jsx("path",{d:"M113.794 120.534C108.183 120.534 102.83 119.267 98.1109 117.907C96.2897 117.382 94.4132 116.845 92.5489 116.492C88.9189 115.806 87.11 116.189 81.8003 118.767L81.4496 118.933L81.0989 118.767C79.0993 117.815 79.7761 116.072 80.0591 115.324C92.2659 83.862 104.448 52.3937 116.63 20.9253L120.088 11.989C120.23 11.6244 120.359 11.2536 120.531 10.7777L120.55 10.7283C119.891 10.5491 119.233 10.3699 118.581 10.1906C116.47 9.60973 114.471 9.05971 112.422 8.6333C108.09 7.7372 104.35 7.79282 100.996 8.80634C97.8956 9.74569 95.4714 12.0076 94.5178 14.8565C93.6626 17.4027 94.0871 20.128 95.6806 22.3281C97.3541 24.6394 99.7721 25.3687 103.279 24.6271L103.697 24.5405L104.005 24.8372C105.02 25.8012 105.125 27.0063 104.325 28.403C102.215 32.0925 98.4554 33.6374 94.5239 32.4324C94.0256 32.2779 94.0071 32.3088 93.8041 32.6239C90.4632 37.9016 85.2519 38.5134 80.6006 38.4146L79.4746 38.3898L79.8499 37.3207C79.8992 37.1786 79.9361 37.0488 79.9668 36.919C80.0591 36.5668 80.1576 36.1712 80.4775 35.8622C85.2273 31.2396 85.941 25.208 86.0087 19.9117C86.0272 18.4038 86.101 16.933 86.2179 15.5487C86.9131 7.3973 92.672 1.73027 101.63 0.3954C108.73 -0.667555 115.59 0.586979 121.946 2.09489C124.776 2.76851 127.705 3.15785 130.449 3.47302C132.756 3.73876 135.18 3.34324 138.318 2.18759C138.897 1.97129 139.5 2.01455 140.139 2.06399C140.416 2.08253 140.718 2.10725 141.038 2.10725H142.244L141.794 3.232L99.5075 108.526C102.652 110.04 105.894 110.671 108.952 111.122C114.089 111.882 118.402 112.142 122.752 110.912C127.188 109.663 129.489 107.117 129.797 103.137C130.092 99.2625 128.062 95.6102 125.17 94.813C124.241 94.5596 123.078 94.5101 121.725 94.677C121.029 94.7573 120.039 94.7944 119.405 94.1084C118.95 93.614 118.821 92.9033 119.005 91.9331C119.719 88.2498 123.792 85.6295 127.705 86.3217C128.523 86.4638 129.305 86.6925 130.129 86.9397C130.308 86.9953 130.492 87.0447 130.683 87.1003C133.624 82.1069 137.943 79.4866 143.862 79.0973L145 79.0231L144.699 80.1293C144.637 80.358 144.6 80.5867 144.563 80.8091C144.465 81.4024 144.366 82.0081 143.899 82.4283C140.533 85.4256 138.909 89.4858 138.638 95.5854C138.454 99.8249 138.177 103.632 136.7 107.346C134.03 114.051 128.8 118.142 120.716 119.848C118.384 120.342 116.07 120.546 113.806 120.546L113.794 120.534ZM89.8295 114.57C90.7585 114.57 91.7368 114.675 92.8443 114.885C94.7823 115.25 96.6958 115.8 98.5539 116.338C104.996 118.192 112.625 119.873 120.371 118.241C127.883 116.659 132.732 112.889 135.18 106.728C136.565 103.255 136.823 99.5901 137.008 95.5051C137.205 91.0741 138.041 85.4441 142.81 81.1923C142.834 81.149 142.871 80.9884 142.902 80.8153C137.906 81.4148 134.264 83.9177 131.778 88.4414L131.47 89.0038L130.855 88.8369C130.443 88.7257 130.049 88.6083 129.668 88.497C128.886 88.2684 128.148 88.0521 127.416 87.9223C124.333 87.3784 121.146 89.3993 120.593 92.2421C120.476 92.8415 120.586 92.9899 120.586 92.996C120.586 92.996 120.746 93.1444 121.522 93.0517C123.084 92.8601 124.45 92.9219 125.588 93.2371C129.268 94.2506 131.772 98.558 131.409 103.261C131.046 107.939 128.283 111.042 123.183 112.481C118.285 113.86 113.332 113.421 108.706 112.735C105.297 112.228 101.649 111.505 98.0924 109.639L97.4403 109.299L97.7171 108.613L139.85 3.67078C139.444 3.64606 139.1 3.62752 138.872 3.71404C136.589 4.55452 133.55 5.47533 130.252 5.09218C127.459 4.77082 124.475 4.36912 121.559 3.67696C115.363 2.20613 108.687 0.982497 101.858 2.00219C93.5764 3.23818 88.4636 8.22542 87.8299 15.6785C87.713 17.0257 87.6453 18.4533 87.6268 19.9241C87.553 25.4613 86.8085 31.7711 81.8618 36.7707C87.0793 36.6718 90.2725 35.1268 92.4259 31.734C93.2073 30.498 94.204 30.6154 94.9915 30.8565C98.2093 31.8391 101.169 30.6154 102.91 27.5749C103.267 26.9569 103.298 26.6046 103.125 26.308C99.2122 27.0187 96.3451 26.0237 94.3578 23.2798C92.4505 20.6472 91.946 17.3841 92.9735 14.3312C94.0932 10.9817 96.9173 8.33048 100.523 7.2428C104.14 6.14895 108.14 6.08097 112.748 7.03269C114.852 7.46528 116.969 8.05238 119.011 8.61476C119.94 8.86814 120.876 9.12769 121.823 9.37489L122.691 9.60355L122.063 11.3278C121.885 11.8222 121.749 12.1991 121.608 12.5761L118.15 21.5124C105.968 52.9807 93.7856 84.4553 81.5788 115.918C81.2835 116.678 81.2835 116.937 81.4804 117.104C85.1104 115.361 87.3131 114.564 89.8418 114.564L89.8295 114.57Z",fill:"#042D41"}),jsxRuntimeExports.jsx("path",{d:"M40.2838 42.6765C38.6776 52.2368 37.0618 61.7972 35.4652 71.3624C34.3022 78.3376 33.144 85.3176 32.024 92.3023C31.7523 93.9875 31.5712 95.6966 31.4759 97.4057C31.2995 100.498 32.7675 102.38 35.9275 103.194V104.994C31.1994 105.903 27.763 104.802 24.4648 101.336C21.7433 105.693 17.3966 105.075 13.1499 105.147V103.447C13.9601 103.17 14.7656 102.969 15.5092 102.629C17.1583 101.877 18.2164 100.087 18.0114 98.253C17.5824 94.4614 17.1487 90.6699 16.5863 86.8974C15.3995 78.9169 14.1317 70.9459 12.9021 62.9701C11.5151 53.9747 10.1377 44.9744 8.73641 35.9789C8.09298 31.857 7.44954 27.7303 6.69172 23.6275C6.30566 21.5354 5.42392 19.6444 3.26007 18.8019C2.46888 18.4955 1.57761 18.4428 0.629136 18.2561V15.8481C5.50971 15.2496 10.0662 15.6996 13.636 19.7928C17.2107 16.8917 21.1142 15.0773 25.8136 15.8098C26.0551 17.1215 25.6055 18.0024 24.4648 18.4524C21.2858 19.7019 19.5795 22.9717 20.0847 26.859C21.8148 40.2253 23.5545 53.5965 25.2703 66.9628C25.7136 70.4288 26.0949 73.9045 26.5381 77.653C27.091 74.4933 27.5676 71.597 28.1062 68.715C30.2748 57.1966 32.5006 45.6877 34.6358 34.1645C35.4985 29.5064 36.1563 24.81 35.489 20.0514C35.3174 18.8449 35.0505 17.6529 34.7836 16.2263C38.282 16.8342 40.7985 18.505 42.1569 21.4924C43.134 20.6306 44.0872 19.6157 45.2072 18.8449C46.4989 17.9497 47.9144 17.2268 49.3205 16.5087C50.1164 16.1018 50.593 16.4752 50.4405 17.3561C49.3348 23.7281 51.184 29.8511 52.0324 36.046C53.2192 44.668 54.6729 53.2566 55.9121 61.8738C56.708 67.4128 57.3133 72.9757 58.0092 78.5674C58.3428 76.0109 58.6622 73.464 59.0101 70.922C59.7536 65.5266 60.5067 60.1312 61.2788 54.7406C62.3417 47.3011 63.4617 39.8711 64.4865 32.4267C64.8392 29.8703 65.0918 27.2851 65.168 24.7095C65.2681 21.4588 63.3283 18.754 60.5734 18.1125C59.358 17.83 60.2255 16.7098 59.93 15.8768C64.0146 15.1299 67.4081 16.3555 70.2059 18.6678C72.0456 17.7391 73.6899 16.7241 75.4725 16.0731C76.6212 15.6566 77.9557 15.714 79.214 15.6709C80.272 15.6374 80.9488 16.1018 80.6819 17.3369C80.6247 17.605 80.639 17.8875 80.6152 18.1891C75.2628 19.4912 73.6757 23.7999 72.8654 28.4293C71.507 36.18 70.4251 43.9786 69.2479 51.7629C67.8371 61.0791 66.4072 70.3906 65.0584 79.7164C64.3053 84.9059 63.5713 90.1049 63.09 95.3232C62.9327 97.0323 63.476 98.8467 63.9193 100.556C64.3101 102.059 65.5874 102.811 67.0125 103.256C68.2184 103.634 68.2231 103.624 68.0039 104.946C65.2776 104.946 62.5466 105.094 59.849 104.864C58.9339 104.783 58.0807 103.759 57.2323 103.127C56.8224 102.82 56.4793 102.428 56.0217 101.987C53.243 105.171 49.6303 105.472 45.8173 105.051C45.5123 104.137 45.7649 103.62 46.6276 103.131C49.1775 101.676 50.4596 99.3733 50.0306 96.453C49.1489 90.4784 48.1432 84.5229 47.0851 78.577C44.9975 66.8766 42.8385 55.1859 40.708 43.4903C40.6603 43.227 40.565 42.9685 40.4935 42.71C40.4268 42.7004 40.36 42.6956 40.2933 42.686L40.2838 42.6765Z",fill:"#84BDEE"}),jsxRuntimeExports.jsx("path",{d:"M32.9248 105.937C29.7171 105.937 27.0862 104.783 24.5554 102.327C21.9864 105.798 18.2926 105.784 14.6989 105.779C14.1889 105.779 13.6742 105.779 13.1594 105.784L12.5208 105.793V102.997L12.9497 102.854C13.2071 102.768 13.4692 102.686 13.7266 102.605C14.2652 102.437 14.7799 102.274 15.2518 102.059C16.6816 101.408 17.5586 99.8712 17.387 98.3344C16.9581 94.5045 16.5244 90.756 15.9667 86.9979C15.1469 81.4733 14.27 75.8577 13.4263 70.4288C13.045 67.9777 12.6637 65.5266 12.2825 63.0755L10.9432 54.3768C10.0042 48.2825 9.06528 42.1834 8.11681 36.0891C7.48767 32.0581 6.83471 27.8931 6.07688 23.7568C5.64793 21.4301 4.68516 20.0466 3.03606 19.4099C2.55944 19.2279 2.01133 19.1418 1.42985 19.0508C1.12959 19.0029 0.82455 18.9551 0.509982 18.8976L0 18.7971V15.2879L0.552877 15.2209C4.5946 14.7278 9.69918 14.7182 13.7075 18.9311C17.8255 15.7236 21.7195 14.5315 25.9137 15.1826L26.357 15.2496L26.438 15.6901C26.8527 17.9401 26.6859 18.2513 24.6984 19.0364C21.7719 20.1902 20.242 23.1536 20.7091 26.7728L22.3439 39.3828C23.5306 48.5458 24.7174 57.7136 25.8947 66.8766C26.1663 68.9783 26.4094 71.0608 26.662 73.2438C26.9337 71.664 27.2006 70.132 27.4913 68.5953C28.3064 64.2627 29.1309 59.9301 29.9555 55.5976C31.2995 48.5362 32.6865 41.2355 34.0162 34.0448C34.9743 28.8793 35.4842 24.5371 34.8646 20.1327C34.755 19.338 34.593 18.529 34.4214 17.6673C34.3356 17.2412 34.2498 16.8007 34.164 16.3316L33.9972 15.4363L34.8932 15.5943C38.3725 16.2023 40.8748 17.8348 42.3475 20.4583C42.4381 20.3769 42.5239 20.2907 42.6144 20.2093C43.3103 19.5583 44.03 18.8832 44.8498 18.3135C46.1509 17.4135 47.576 16.6811 48.9535 15.9725L49.0297 15.9342C49.8447 15.5177 50.3643 15.7475 50.6026 15.9246C50.8409 16.1018 51.2174 16.5374 51.0601 17.4566C50.2499 22.1147 51.0792 26.7633 51.8847 31.2538C52.1611 32.7906 52.4423 34.3752 52.6568 35.9454C53.3098 40.6993 54.058 45.525 54.7825 50.1926C55.3687 53.9842 55.9788 57.9051 56.5317 61.7685C57.0798 65.5936 57.5469 69.5001 57.9997 73.2725C58.0092 73.3444 58.0187 73.4162 58.0235 73.488C58.1427 72.5975 58.257 71.7071 58.381 70.8166C58.9958 66.3835 59.8061 60.5429 60.6497 54.6305C61.0357 51.9305 61.4313 49.2304 61.8222 46.5351C62.499 41.877 63.2043 37.0657 63.8526 32.3214C64.2386 29.5256 64.4579 27.0218 64.5293 24.6712C64.6199 21.7413 62.9327 19.2902 60.4257 18.7109C59.0911 18.4045 59.2436 17.2795 59.3151 16.7433C59.3485 16.4896 59.3866 16.231 59.3294 16.0731L59.0816 15.3741L59.8108 15.2401C63.619 14.5411 67.1365 15.4363 70.2726 17.9066C70.6968 17.6864 71.1114 17.4662 71.5213 17.246C72.7748 16.5709 73.9616 15.939 75.2437 15.4698C76.2923 15.0869 77.4266 15.0677 78.5276 15.0438C78.7469 15.0438 78.9613 15.0342 79.1758 15.0294C80.1863 14.9959 80.7105 15.3645 80.9727 15.6757C81.3397 16.1161 81.4445 16.7146 81.2825 17.4614C81.2539 17.5859 81.2491 17.7391 81.2444 17.9114C81.2444 18.0119 81.2396 18.1125 81.23 18.2178L81.1967 18.6822L80.7487 18.7923C75.6346 20.037 74.2285 24.2068 73.4707 28.525C72.4698 34.2316 71.6071 40.0626 70.773 45.7021C70.468 47.7511 70.1677 49.7953 69.8579 51.8395L69.1144 56.7561C67.9658 64.301 66.7838 72.1092 65.6685 79.7882C64.9059 85.0638 64.1767 90.2246 63.7048 95.3663C63.5713 96.8025 63.9908 98.3775 64.3911 99.8999L64.515 100.374C64.7915 101.432 65.6399 102.145 67.1889 102.629C68.695 103.098 68.8809 103.409 68.6187 105.027L68.5329 105.559H67.9991C67.2365 105.559 66.4692 105.568 65.7066 105.583C63.7668 105.611 61.7602 105.645 59.7918 105.472C58.9291 105.396 58.2189 104.778 57.5374 104.18C57.299 103.974 57.075 103.773 56.8558 103.61C56.5603 103.39 56.3029 103.136 56.036 102.868C52.9714 105.975 49.1298 106.028 45.7411 105.654L45.3407 105.611L45.212 105.228C44.6973 103.687 45.5885 102.964 46.3082 102.557C48.7104 101.188 49.778 99.1004 49.4015 96.5248C48.6198 91.2156 47.6857 85.5378 46.4608 78.6679C44.9213 70.0459 43.3198 61.2898 41.7708 52.8209C41.3276 50.3985 40.8843 47.9761 40.4411 45.5537L39.4735 51.3129C38.3439 58.0296 37.2144 64.7415 36.0943 71.4581C34.979 78.1317 33.7922 85.2841 32.6531 92.3933C32.391 94.0306 32.2099 95.7253 32.1098 97.4296C31.9525 100.197 33.2155 101.829 36.0895 102.566L36.5662 102.686V105.501L36.0562 105.602C34.9504 105.812 33.9162 105.922 32.9343 105.922L32.9248 105.937ZM24.3647 100.312L24.9224 100.9C27.9394 104.074 31.066 105.156 35.2983 104.467V103.677C32.1622 102.715 30.6609 100.594 30.8467 97.3722C30.9468 95.6248 31.1327 93.887 31.4044 92.2066C32.5435 85.0926 33.735 77.9354 34.8456 71.2619C35.9656 64.5452 37.0952 57.8285 38.2248 51.1166L39.7595 41.9823L40.9749 42.1259L41.0893 42.5328C41.1131 42.6094 41.1369 42.6908 41.1608 42.7674C41.2179 42.9589 41.2799 43.1552 41.318 43.3706C41.8804 46.4489 42.4429 49.5272 43.0053 52.6055C44.5543 61.0743 46.1605 69.8352 47.6952 78.4573C48.9249 85.3415 49.859 91.0289 50.6455 96.3525C51.103 99.4451 49.7828 102.045 46.9326 103.672C46.4464 103.95 46.2939 104.151 46.3178 104.457C49.4396 104.759 52.9142 104.572 55.5451 101.561L55.9788 101.068L56.4554 101.523C56.6079 101.671 56.7509 101.815 56.8844 101.949C57.1418 102.212 57.3705 102.437 57.6088 102.614C57.8662 102.806 58.1236 103.031 58.3667 103.246C58.9005 103.711 59.4486 104.194 59.9014 104.232C61.8079 104.395 63.7811 104.367 65.6923 104.338C66.2833 104.328 66.8743 104.319 67.4653 104.314C67.4796 104.218 67.4844 104.142 67.4844 104.084C67.3652 104.027 67.1031 103.945 66.8457 103.864C64.8487 103.241 63.6953 102.212 63.3044 100.714L63.1805 100.24C62.7468 98.6121 62.3035 96.9269 62.4561 95.2609C62.9327 90.0954 63.6619 84.9154 64.4293 79.6206C65.5445 71.9369 66.7266 64.1287 67.8752 56.579L68.6187 51.6624C68.9285 49.6182 69.2336 47.5739 69.5338 45.525C70.3679 39.8759 71.2354 34.0353 72.2363 28.3144C73.0084 23.9196 74.5383 19.2471 79.9956 17.6912C80.0051 17.5332 80.0194 17.3704 80.0528 17.2029C80.1243 16.8678 80.11 16.6188 80.0051 16.4943C79.8908 16.3603 79.6096 16.2837 79.2187 16.2981C78.9995 16.3076 78.7755 16.3076 78.5515 16.3124C77.5553 16.3316 76.5211 16.3507 75.6727 16.6619C74.4716 17.1023 73.3277 17.7151 72.1123 18.3662C71.5785 18.6535 71.0352 18.9455 70.4775 19.2279L70.1105 19.4146L69.7912 19.1513C67.0316 16.8678 63.9431 15.9438 60.6115 16.3986C60.6068 16.5853 60.5829 16.7624 60.5591 16.9204C60.5353 17.0832 60.5019 17.3513 60.5305 17.4279C60.5305 17.4279 60.5686 17.4566 60.7021 17.4853C63.8001 18.2034 65.8925 21.1764 65.7829 24.7143C65.7114 27.1127 65.4826 29.6596 65.0918 32.4985C64.4388 37.2428 63.7382 42.0589 63.0566 46.7218C62.661 49.4171 62.2702 52.1172 61.8841 54.8172C61.0405 60.7248 60.2303 66.5654 59.6154 70.9938C59.3723 72.7364 59.1483 74.4838 58.9243 76.2311C58.8195 77.0306 58.7194 77.8349 58.6145 78.6344L57.9758 83.5271L57.3658 78.6296C57.1513 76.8918 56.9416 75.154 56.7319 73.421C56.2791 69.6533 55.812 65.7564 55.2687 61.9456C54.7158 58.087 54.1057 54.1709 53.5195 50.3841C52.795 45.7117 52.0467 40.8812 51.389 36.113C51.1745 34.5667 50.8933 32.9916 50.6216 31.4692C49.8018 26.8686 48.9487 22.1051 49.7971 17.2316C49.8161 17.1071 49.8161 17.021 49.8114 16.9683C49.7589 16.9779 49.6827 17.0066 49.5826 17.0593L49.5063 17.0976C48.167 17.7869 46.7753 18.5003 45.5409 19.3524C44.7974 19.8647 44.111 20.5109 43.4485 21.1285C43.1483 21.411 42.848 21.6886 42.5525 21.9519L41.9138 22.5169L41.5611 21.7413C40.4458 19.2854 38.4774 17.7343 35.5605 17.0257C35.5843 17.1598 35.6129 17.2891 35.6367 17.4183C35.8131 18.2944 35.9751 19.1226 36.0943 19.9508C36.7377 24.5276 36.2182 28.9846 35.2412 34.2698C33.9114 41.4605 32.5197 48.7612 31.1756 55.8274C30.3511 60.1599 29.5265 64.4925 28.7115 68.8251C28.3397 70.7879 28.0061 72.7459 27.6486 74.8141C27.4818 75.7716 27.315 76.7482 27.1386 77.7535L26.3999 81.9856L25.8947 77.7152C25.7517 76.504 25.6135 75.3168 25.48 74.1534C25.194 71.6927 24.9271 69.3708 24.6269 67.0298C23.4496 57.862 22.2628 48.699 21.0761 39.536L19.4413 26.926C18.9027 22.7658 20.7758 19.1992 24.217 17.8444C24.7365 17.6385 25.2798 17.4279 25.337 17.3082C25.3895 17.2029 25.337 16.8199 25.256 16.3555C21.4478 15.8911 17.8637 17.1406 14.0173 20.2668L13.5455 20.6498L13.1451 20.1902C9.67535 16.2119 5.23803 15.9869 1.25827 16.413V17.7295C1.37743 17.7486 1.49658 17.7678 1.61574 17.7869C2.2687 17.8875 2.88354 17.9832 3.48408 18.2178C5.54784 19.0173 6.80134 20.7503 7.30656 23.5174C8.06915 27.6729 8.72211 31.8474 9.35125 35.8832C10.3045 41.9775 11.2434 48.0766 12.1776 54.1709L13.5169 62.8696C13.8934 65.3207 14.2747 67.7719 14.6608 70.2182C15.5092 75.6519 16.3814 81.2675 17.2012 86.7969C17.7636 90.5741 18.1973 94.337 18.631 98.1764C18.8646 100.254 17.6873 102.318 15.7665 103.198C15.2184 103.447 14.6465 103.629 14.0936 103.802C13.9887 103.835 13.8791 103.869 13.7743 103.902V104.505C14.0793 104.505 14.3891 104.505 14.6989 104.505C18.3117 104.52 21.7195 104.524 23.9262 100.996L24.3552 100.307L24.3647 100.312Z",fill:"#042D41"})]});const PonceBadge=({elClass:s})=>jsxRuntimeExports.jsxs("svg",{width:"63",height:"47",viewBox:"0 0 47 47",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[jsxRuntimeExports.jsx("path",{d:"M22.9495 19.8563C22.5586 22.1833 22.165 24.5089 21.7755 26.8359C21.4918 28.5339 21.2095 30.2318 20.9367 31.9311C20.8702 32.3409 20.8268 32.7576 20.8023 33.1729C20.7589 33.9258 21.1159 34.3833 21.8868 34.5808V35.0192C20.7358 35.2398 19.8971 34.9729 19.095 34.1287C18.4313 35.188 17.3726 35.0383 16.3384 35.056V34.642C16.5352 34.5753 16.732 34.5249 16.9139 34.4432C17.3156 34.2594 17.5735 33.8251 17.5233 33.3798C17.4188 32.458 17.3129 31.5348 17.1758 30.6171C16.8868 28.6755 16.5787 26.7365 16.2787 24.7949C15.9408 22.6054 15.6055 20.416 15.2635 18.2278C15.1061 17.2243 14.95 16.2208 14.7654 15.2228C14.6718 14.7135 14.456 14.2533 13.9294 14.0491C13.7366 13.9742 13.5195 13.9619 13.2888 13.917V13.3301C14.4777 13.1845 15.5879 13.2934 16.4579 14.2901C17.3279 13.5834 18.2793 13.1436 19.4234 13.3206C19.4822 13.6401 19.3727 13.8544 19.095 13.9633C18.32 14.2683 17.9047 15.0621 18.0268 16.0098C18.4476 19.2627 18.871 22.5156 19.2904 25.7684C19.399 26.6113 19.4913 27.4568 19.5998 28.3705C19.7342 27.6025 19.8496 26.8972 19.9826 26.196C20.5105 23.3938 21.0534 20.593 21.5732 17.7894C21.7836 16.6552 21.9438 15.5128 21.7809 14.3554C21.7402 14.0613 21.6737 13.7713 21.6085 13.4241C22.4609 13.5725 23.0743 13.9796 23.4041 14.7054C23.6417 14.4957 23.8737 14.2492 24.1465 14.0613C24.4614 13.8435 24.8062 13.6678 25.1482 13.4922C25.3423 13.3928 25.459 13.484 25.421 13.6991C25.1522 15.25 25.6015 16.7396 25.8091 18.2456C26.0982 20.3438 26.4525 22.4325 26.7538 24.5294C26.9479 25.8774 27.0958 27.2308 27.2654 28.5911C27.3469 27.9688 27.4242 27.3493 27.5097 26.7311C27.6916 25.4185 27.8748 24.1059 28.0621 22.7933C28.3214 20.9837 28.5942 19.1755 28.8425 17.3646C28.928 16.7423 28.9891 16.1133 29.0095 15.4869C29.0339 14.6958 28.5616 14.0368 27.8911 13.883C27.5953 13.8149 27.8056 13.5426 27.7337 13.3397C28.7285 13.1572 29.5551 13.4568 30.2364 14.0191C30.6843 13.7931 31.086 13.5453 31.519 13.3873C31.7986 13.2852 32.1243 13.2988 32.431 13.2893C32.6889 13.2811 32.8545 13.3941 32.7893 13.6951C32.7758 13.7604 32.7785 13.8285 32.7731 13.902C31.4688 14.2193 31.0833 15.2664 30.8852 16.3938C30.554 18.2796 30.2907 20.1777 30.0043 22.0703C29.6609 24.3374 29.3121 26.6031 28.9837 28.8715C28.8005 30.1338 28.6213 31.4 28.5032 32.6691C28.4652 33.0844 28.5969 33.5269 28.7055 33.9422C28.8005 34.3084 29.1126 34.4909 29.4601 34.5985C29.7546 34.6897 29.7546 34.6883 29.7017 35.0097C29.0366 35.0097 28.3716 35.0464 27.7147 34.9892C27.4907 34.9702 27.2844 34.7197 27.0768 34.5658C26.9777 34.4923 26.8936 34.3956 26.7809 34.288C26.1037 35.0628 25.2242 35.1363 24.2945 35.0328C24.2198 34.8095 24.2823 34.6842 24.4913 34.5658C25.1115 34.2118 25.4251 33.6521 25.3205 32.9414C25.1061 31.4886 24.8618 30.0384 24.6026 28.5924C24.0936 25.7453 23.5684 22.9009 23.0486 20.0551C23.0363 19.9911 23.0133 19.9285 22.9956 19.8645C22.9793 19.8631 22.963 19.8604 22.9468 19.8591L22.9495 19.8563Z",fill:"#84BDEE"}),jsxRuntimeExports.jsx("path",{d:"M21.1552 35.248C20.3734 35.248 19.7328 34.9675 19.1166 34.3697C18.4896 35.2139 17.5884 35.2112 16.7157 35.2085C16.5909 35.2085 16.466 35.2085 16.3411 35.2098L16.185 35.2126V34.5318L16.2895 34.4964C16.3533 34.4746 16.4158 34.4555 16.4796 34.4351C16.6112 34.3942 16.7361 34.3547 16.8514 34.303C17.2002 34.1437 17.4133 33.7706 17.3713 33.3962C17.2668 32.4635 17.1609 31.5512 17.0252 30.6389C16.8243 29.2909 16.6112 27.9225 16.4049 26.599C16.3126 26.0054 16.2203 25.4117 16.128 24.818L15.7982 22.6803C15.5702 21.2043 15.3436 19.727 15.1128 18.251C14.9595 17.272 14.802 16.2603 14.6161 15.25C14.5116 14.6836 14.2768 14.3473 13.875 14.192C13.7597 14.1471 13.6253 14.1267 13.4842 14.1049C13.4109 14.094 13.3362 14.0818 13.2602 14.0668L13.1367 14.0423V13.1926L13.2711 13.1763C14.2551 13.0565 15.4996 13.0551 16.4755 14.079C17.4785 13.2988 18.4272 13.0088 19.4478 13.1668L19.555 13.1831L19.5754 13.2907C19.6758 13.838 19.6365 13.9143 19.1519 14.1049C18.4394 14.3854 18.0662 15.107 18.1802 15.988L18.5873 19.1252C18.8737 21.3323 19.1601 23.5395 19.4437 25.7467C19.5089 26.2586 19.5686 26.7651 19.631 27.2948C19.6975 26.9095 19.7627 26.5378 19.8333 26.1647C20.0328 25.1081 20.2336 24.0501 20.4345 22.9935C20.7616 21.2779 21.0996 19.5037 21.4226 17.7567C21.656 16.5 21.7795 15.4434 21.6289 14.3718C21.6017 14.1784 21.5624 13.981 21.5216 13.7727C21.5013 13.6692 21.4796 13.5616 21.4579 13.4486L21.4171 13.2308L21.6357 13.2689C22.4839 13.4159 23.0933 13.8149 23.4516 14.4521C23.4733 14.4317 23.4951 14.4113 23.5168 14.3908C23.6864 14.2315 23.8615 14.0681 24.061 13.9306C24.3786 13.7114 24.7261 13.533 25.0613 13.3615L25.0789 13.3519C25.2771 13.2498 25.4033 13.307 25.4617 13.3492C25.52 13.3928 25.6123 13.4976 25.573 13.7223C25.3762 14.8552 25.5784 15.9866 25.7738 17.08C25.8403 17.4531 25.9096 17.8398 25.9625 18.221C26.1213 19.3771 26.3031 20.5508 26.4796 21.685C26.6235 22.6081 26.7714 23.564 26.9071 24.5049C27.0415 25.4376 27.1555 26.3907 27.2654 27.3125C27.2668 27.3275 27.2695 27.3425 27.2708 27.3574C27.2993 27.1409 27.3279 26.9244 27.3577 26.708C27.5776 25.1149 27.7486 23.9003 27.9101 22.7702C28.0037 22.1139 28.1001 21.459 28.1951 20.8027C28.3607 19.6684 28.5317 18.4961 28.6905 17.3414C28.7842 16.6606 28.8384 16.052 28.8561 15.4801C28.8778 14.768 28.4666 14.1716 27.8558 14.03C27.5301 13.9551 27.5681 13.6814 27.5857 13.5507C27.5939 13.4895 27.6034 13.4255 27.5898 13.3873L27.5301 13.2171L27.7079 13.1845C28.6349 13.0143 29.4926 13.2321 30.2567 13.8326C30.3599 13.7795 30.4617 13.725 30.5621 13.6706C30.8675 13.5072 31.1566 13.3519 31.4687 13.2389C31.7239 13.1463 32.0008 13.1409 32.2695 13.1354C32.3224 13.1354 32.3754 13.1327 32.4283 13.1314C32.6726 13.1232 32.8015 13.2131 32.8653 13.2893C32.9549 13.3969 32.9793 13.5426 32.9413 13.7237C32.9345 13.7536 32.9332 13.7904 32.9318 13.8339C32.9318 13.8585 32.9305 13.883 32.9278 13.9088L32.9196 14.0205L32.811 14.0464C31.5651 14.3486 31.2231 15.363 31.0385 16.4142C30.7942 17.803 30.5838 19.2218 30.3816 20.5943C30.3083 21.0927 30.2337 21.5897 30.159 22.088L29.9717 23.3189C29.6948 25.1435 29.4071 27.0307 29.1384 28.8879C28.9524 30.1705 28.776 31.4259 28.6593 32.6772C28.6267 33.0272 28.7285 33.4112 28.8276 33.7815L28.8574 33.8959C28.9253 34.1532 29.1316 34.3275 29.5089 34.4446C29.8767 34.559 29.9215 34.6352 29.8564 35.0287L29.8346 35.1581H29.7044C29.5184 35.1581 29.3325 35.1608 29.1465 35.1635C28.6742 35.1703 28.1843 35.1785 27.7052 35.1363C27.4948 35.1186 27.3224 34.9675 27.1555 34.8218C27.0998 34.7728 27.0442 34.7251 26.9899 34.6843C26.918 34.6312 26.8555 34.5685 26.7904 34.5032C26.0439 35.2589 25.1074 35.2725 24.2822 35.1812L24.1845 35.1703L24.1533 35.0764C24.0284 34.702 24.2456 34.5263 24.4193 34.4269C25.0043 34.0933 25.2649 33.5854 25.1726 32.9591C24.9826 31.6683 24.7546 30.2876 24.456 28.6142C24.0814 26.5132 23.6905 24.3796 23.3118 22.3154L22.9902 20.5562L22.7499 21.9804C22.4758 23.6062 22.2016 25.2333 21.9302 26.8591C21.6574 28.4917 21.3669 30.2386 21.0914 31.9529C21.0276 32.3505 20.9828 32.763 20.9598 33.1783C20.9218 33.8523 21.2298 34.2485 21.9288 34.4283L22.0442 34.4582V35.1431L21.9193 35.1676C21.6506 35.2194 21.3981 35.2452 21.1579 35.2452L21.1552 35.248ZM19.0705 33.8782L19.2062 34.0212C19.9418 34.7932 20.7032 35.056 21.7347 34.8885V34.6965C20.9706 34.4623 20.6055 33.9476 20.6503 33.162C20.6747 32.7358 20.7209 32.3123 20.786 31.9052C21.0615 30.1896 21.352 28.4413 21.6248 26.8087C21.8962 25.1816 22.1704 23.5558 22.4446 21.9301L22.8232 19.6848L23.1191 19.7215L23.1462 19.8196C23.1517 19.8386 23.1571 19.8563 23.1625 19.8754C23.1775 19.9244 23.1924 19.9734 23.2019 20.0238L23.6118 22.2609C23.9904 24.3251 24.3813 26.4601 24.7559 28.5611C25.0559 30.2372 25.2839 31.6206 25.4739 32.9155C25.5852 33.6671 25.2635 34.3003 24.5686 34.6965C24.4505 34.7646 24.4125 34.8122 24.4193 34.8885C25.1807 34.962 26.0263 34.9171 26.6669 34.1832L26.7727 34.0634L26.8881 34.1736C26.9261 34.2091 26.96 34.2445 26.9926 34.2771C27.0564 34.3411 27.1107 34.3956 27.1677 34.4392C27.2315 34.4868 27.2926 34.5399 27.3523 34.5917C27.4826 34.7047 27.6169 34.8231 27.7269 34.8327C28.191 34.8735 28.6729 34.8653 29.137 34.8585C29.2809 34.8558 29.4248 34.8545 29.5686 34.8531C29.5713 34.8299 29.5741 34.8109 29.5741 34.7973C29.5442 34.7837 29.4804 34.7632 29.4193 34.7442C28.9321 34.593 28.6525 34.3425 28.5575 33.9776L28.5276 33.8632C28.4218 33.4656 28.3132 33.0558 28.3512 32.6514C28.4679 31.3932 28.6444 30.1324 28.8317 28.8457C29.1017 26.9871 29.3881 25.0999 29.6663 23.274L29.8536 22.0431C29.9297 21.5461 30.0029 21.0477 30.0762 20.5508C30.2798 19.1755 30.4902 17.754 30.7358 16.3625C30.9231 15.2936 31.2964 14.1566 32.6265 13.7781C32.6278 13.74 32.6319 13.7005 32.6414 13.6583C32.659 13.5766 32.655 13.5167 32.6305 13.4867C32.6034 13.4541 32.5342 13.435 32.4392 13.4391C32.3849 13.4404 32.3306 13.4418 32.2763 13.4432C32.0333 13.4472 31.7823 13.4527 31.5746 13.5276C31.2828 13.6338 31.0032 13.7836 30.7073 13.9415C30.577 14.011 30.444 14.0818 30.3083 14.1512L30.2187 14.1961L30.1414 14.1321C29.4696 13.5766 28.7176 13.3519 27.9047 13.4622C27.9033 13.5072 27.8965 13.5507 27.8925 13.5902C27.887 13.6297 27.8789 13.6951 27.8857 13.7128C27.8857 13.7128 27.8938 13.7196 27.9277 13.7264C28.6837 13.9007 29.1927 14.6237 29.1655 15.4856C29.1479 16.0697 29.0922 16.6892 28.9972 17.3796C28.8384 18.5356 28.6674 19.7093 28.5018 20.8435C28.4055 21.4984 28.3105 22.1534 28.2168 22.8097C28.0553 23.9384 27.8843 25.153 27.6644 26.7461C27.6061 27.1723 27.5504 27.5984 27.4948 28.0273L27.2641 29.7974L27.1161 28.6047C27.0632 28.1839 27.013 27.7646 26.9628 27.3452C26.8528 26.4261 26.7388 25.4743 26.6045 24.5444C26.4701 23.6048 26.3208 22.6504 26.1783 21.7285C26.0018 20.593 25.82 19.4179 25.6598 18.2592C25.6082 17.8834 25.539 17.4994 25.4739 17.1304C25.273 16.0098 25.0667 14.8524 25.273 13.6651C25.2784 13.6351 25.2784 13.6147 25.2771 13.6011C25.2649 13.6038 25.2459 13.6093 25.2214 13.6229L25.2038 13.6324C24.8767 13.7999 24.5388 13.9728 24.2375 14.1812C24.0569 14.3064 23.89 14.4616 23.7285 14.6141C23.6552 14.6822 23.5819 14.7503 23.51 14.8157L23.3553 14.9532L23.2698 14.7653C22.9969 14.1675 22.5178 13.7904 21.808 13.6174C21.8148 13.6501 21.8202 13.6814 21.827 13.7128C21.8691 13.9252 21.9098 14.1267 21.9383 14.3296C22.0944 15.4434 21.9682 16.5272 21.7293 17.8139C21.4049 19.5609 21.067 21.335 20.7412 23.052C20.5404 24.1086 20.3395 25.1652 20.14 26.2219C20.0504 26.6971 19.969 27.1709 19.8835 27.672C19.8428 27.9075 19.802 28.1472 19.7586 28.395L19.5781 29.4244L19.4546 28.3855C19.4193 28.09 19.3867 27.8013 19.3528 27.5181C19.2836 26.9204 19.2184 26.3553 19.1451 25.7848C18.8615 23.5776 18.5751 21.3704 18.2887 19.1633L17.8816 16.0261C17.7499 15.0131 18.2073 14.1458 19.0447 13.8176C19.1723 13.7672 19.3039 13.7155 19.3175 13.6869C19.3311 13.661 19.3175 13.5684 19.2985 13.4554C18.3702 13.3438 17.4975 13.6474 16.5596 14.4072L16.4456 14.4998L16.3479 14.3881C15.4983 13.4159 14.4166 13.3615 13.4475 13.4649V13.7863C13.4774 13.7917 13.5059 13.7958 13.5344 13.7999C13.6932 13.8244 13.8425 13.8476 13.9891 13.9047C14.4926 14.0995 14.7966 14.5216 14.9201 15.1942C15.1061 16.2072 15.2648 17.223 15.4182 18.2033C15.6489 19.6793 15.877 21.1567 16.1036 22.6327L16.4334 24.7704C16.5257 25.364 16.618 25.9577 16.7103 26.55C16.9166 27.8749 17.131 29.2433 17.3305 30.5926C17.4663 31.5103 17.5735 32.4253 17.678 33.3608C17.735 33.8659 17.4473 34.3684 16.9804 34.5821C16.8474 34.6434 16.7076 34.687 16.5732 34.7292C16.5474 34.7374 16.5216 34.7455 16.4945 34.7537V34.9008C16.5691 34.9008 16.6451 34.9008 16.7198 34.9008C17.5993 34.9035 18.4312 34.9062 18.9687 34.047L19.0732 33.8795L19.0705 33.8782Z",fill:"#042D41"}),jsxRuntimeExports.jsx("path",{d:"M27.5897 38.3579C28.4502 38.9692 29.4763 39.3518 30.5268 39.4349C31.9844 39.6187 33.6144 39.085 34.7993 38.2925C35.7263 37.707 36.527 36.8655 37.1717 35.9887C37.5422 35.4849 37.8666 34.9457 38.1408 34.3833C38.7434 33.147 39.2008 31.7432 39.1193 30.3516C39.0433 29.0486 38.3593 27.6052 36.9804 27.2975C36.8311 27.2635 36.6723 27.2417 36.5528 27.1477C36.1443 26.8223 37.1826 26.1252 37.4201 25.925C37.9874 25.4457 38.7637 25.1326 39.5089 25.2347C39.9852 25.3 40.4399 25.522 40.7887 25.8529C41.0765 26.1252 41.2868 26.5582 41.7401 26.5214C42.1935 26.4846 42.5409 25.9985 42.982 25.8692C44.0176 25.5628 45.1685 26.019 45.8105 26.8632C45.9801 27.0865 46.2203 27.3751 46.0846 27.6447C45.976 27.8585 45.6014 27.977 45.4074 28.0968C44.6283 28.5815 44.1031 29.0785 43.7244 29.935C43.4 30.6675 43.2331 31.4559 42.982 32.2129C42.4174 33.9149 41.8311 35.6156 41.0466 37.2305C40.6164 38.1169 40.1793 38.8521 39.4912 39.5493C38.7665 40.2818 37.9589 40.9368 37.0957 41.4977C35.8932 42.2793 34.6826 42.6456 33.3077 42.9274C32.3468 43.1249 31.3927 43.3454 30.4426 43.5892C29.6717 43.7866 29.023 44.3217 28.4963 44.9208C27.9982 45.4845 27.4201 46.0673 27.0604 46.6787C26.9043 46.4812 26.7007 46.375 26.5121 46.213C25.8728 45.6629 25.4548 44.8813 25.4426 44.029C25.4317 43.2814 25.6774 42.3297 26.3533 41.9362C26.3831 41.9185 25.6747 41.0566 25.6217 40.9762C25.3666 40.5895 25.1956 40.147 25.1318 39.6882C25.0422 39.0468 26.0656 36.4353 26.7333 37.5041C26.9695 37.8813 27.2328 38.1032 27.587 38.3551L27.5897 38.3579Z",fill:"#84BDEE"}),jsxRuntimeExports.jsx("path",{d:"M27.0821 46.9973L26.9206 46.7917C26.8338 46.6814 26.7225 46.5997 26.6058 46.5139C26.5379 46.4635 26.4673 46.4118 26.3967 46.3519C25.6896 45.7432 25.277 44.899 25.2648 44.0344C25.254 43.2923 25.4738 42.3692 26.109 41.8885C25.9991 41.7428 25.8118 41.5086 25.6964 41.3629C25.5512 41.1805 25.4942 41.1097 25.4752 41.0797C25.2024 40.6672 25.0232 40.196 24.9567 39.7154C24.878 39.1517 25.52 37.3544 26.1986 37.1052C26.3506 37.0494 26.641 37.0153 26.8881 37.4102C27.1025 37.752 27.3359 37.9548 27.6942 38.2095L27.7092 38.2203C28.5547 38.8181 29.5346 39.1762 30.5444 39.2565C31.8419 39.4199 33.4326 38.9937 34.703 38.1441C35.5295 37.6212 36.3113 36.8615 37.0306 35.8838C37.3916 35.3923 37.7119 34.8626 37.982 34.3057C38.6878 32.8597 39.0108 31.5321 38.9429 30.3639C38.871 29.1316 38.2249 27.7605 36.9451 27.4759L36.8799 27.4623C36.7388 27.4323 36.5786 27.3983 36.4443 27.2921C36.337 27.2063 36.28 27.0933 36.2814 26.9639C36.2841 26.6099 36.7239 26.2423 37.1731 25.8951C37.2287 25.8529 37.2749 25.8161 37.3075 25.7902C37.9698 25.232 38.8031 24.9596 39.536 25.0604C40.045 25.1312 40.5349 25.3668 40.915 25.7262C40.9937 25.8011 41.0656 25.8842 41.1348 25.9645C41.3493 26.2137 41.4918 26.3648 41.7293 26.3458C41.9302 26.3294 42.1229 26.1892 42.3278 26.0421C42.5151 25.906 42.7079 25.7671 42.9359 25.7004C44.0013 25.3858 45.2445 25.8202 45.957 26.757L45.9842 26.7924C46.1606 27.0238 46.4294 27.3724 46.2489 27.7292C46.143 27.9361 45.9028 28.0532 45.6897 28.1567C45.6191 28.1907 45.554 28.2234 45.5065 28.252C44.8143 28.6823 44.2755 29.1466 43.8941 30.0098C43.6878 30.4755 43.5426 30.9793 43.4014 31.4668C43.3254 31.7309 43.2453 32.006 43.1571 32.2728C42.6088 33.9272 42.0075 35.6782 41.2136 37.3122C40.8376 38.0869 40.3843 38.9093 39.6229 39.6786C38.8927 40.4153 38.077 41.0797 37.1975 41.6516C35.8824 42.5067 34.5699 42.8566 33.3484 43.1072C32.4038 43.3005 31.4429 43.5224 30.4928 43.7662C29.8644 43.9282 29.2401 44.3571 28.6375 45.0434C28.533 45.1618 28.4258 45.2789 28.3186 45.3987C27.9155 45.844 27.4975 46.3056 27.2219 46.774L27.0889 47L27.0821 46.9973ZM26.375 37.4306C26.352 37.4306 26.333 37.4374 26.318 37.4429C25.8552 37.6117 25.2445 39.2021 25.3082 39.6636C25.368 40.0898 25.5281 40.5106 25.7711 40.8782C25.786 40.9 25.8864 41.0253 25.9746 41.1369C26.5501 41.8599 26.5501 41.8654 26.5311 41.9689L26.5162 42.0492L26.4456 42.0928C25.8213 42.4563 25.6123 43.3618 25.6218 44.029C25.6326 44.7901 25.9991 45.5376 26.6288 46.0782C26.6885 46.1299 26.751 46.1749 26.8175 46.2239C26.8894 46.2756 26.9613 46.3301 27.0319 46.3914C27.3156 45.9638 27.6875 45.554 28.0485 45.155C28.1557 45.0366 28.2616 44.9195 28.3647 44.8037C29.0162 44.063 29.7002 43.596 30.4006 43.4162C31.356 43.1712 32.3237 42.9478 33.2738 42.7531C34.4614 42.5094 35.7344 42.1704 37.0007 41.348C37.8585 40.7897 38.6552 40.1416 39.3664 39.424C40.0504 38.7337 40.4684 38.0175 40.8878 37.1542C41.6723 35.5393 42.2695 33.8006 42.8137 32.1585C42.9006 31.8984 42.9779 31.6274 43.0539 31.366C43.1978 30.8677 43.3471 30.3516 43.5629 29.8642C43.9823 28.9165 44.5673 28.4113 45.3151 27.9456C45.3789 27.9062 45.4522 27.8708 45.5309 27.8326C45.6775 27.7618 45.877 27.6638 45.9272 27.5644C45.9991 27.4228 45.8715 27.2376 45.6978 27.0102L45.6707 26.9735C45.045 26.1524 43.9619 25.7698 43.0349 26.0435C42.8667 26.0925 42.7065 26.2096 42.5368 26.3321C42.302 26.5023 42.0591 26.678 41.7578 26.7025C41.3289 26.7379 41.0697 26.4383 40.862 26.1973C40.7955 26.1197 40.7331 26.0476 40.668 25.9863C40.3422 25.6786 39.9228 25.4757 39.4872 25.4158C38.8533 25.3286 38.1232 25.571 37.5382 26.0653C37.5029 26.0952 37.4527 26.1333 37.3916 26.181C37.2057 26.324 36.6411 26.7597 36.6397 26.9667C36.6397 26.9762 36.6397 26.9884 36.6669 27.0089C36.7361 27.0633 36.8419 27.0851 36.9532 27.1096L37.0224 27.1246C38.4842 27.45 39.2212 28.9764 39.3012 30.3434C39.3732 31.5757 39.0379 32.9618 38.305 34.465C38.0254 35.0396 37.6929 35.5897 37.3197 36.099C36.5732 37.1134 35.7589 37.9045 34.8984 38.4477C33.5642 39.3409 31.8799 39.7889 30.5078 39.616C29.4356 39.5302 28.3891 39.1462 27.4893 38.5063L27.4744 38.4954C27.0957 38.2244 26.827 37.9902 26.5854 37.6022C26.4985 37.4619 26.428 37.432 26.3791 37.432L26.375 37.4306Z",fill:"#042D41"}),jsxRuntimeExports.jsx("path",{d:"M15.3421 39.5275C16.2135 39.5125 17.0821 39.3205 17.8706 38.9529C18.2588 38.7732 18.6429 38.5744 18.9835 38.3129C19.1437 38.1904 19.2781 38.0447 19.3907 37.8772C19.4952 37.7247 19.5577 37.4442 19.6866 37.3217C20.0205 37.0031 20.4724 37.7697 20.6122 37.9834C20.9719 38.5349 21.1945 39.1599 21.1551 39.8271C21.1293 40.2723 20.9895 40.7094 20.7615 41.092C20.6014 41.3602 20.0639 41.7224 20.03 41.9661C19.9621 42.4427 20.5131 42.9233 20.7113 43.3169C21.0017 43.8955 20.8416 44.7152 20.5851 45.2817C20.3747 45.7487 20.0449 46.1517 19.6377 46.4581C19.4857 46.5738 19.3446 46.7563 19.1573 46.661C19.0039 46.5834 18.9564 46.3206 18.8628 46.1885C18.5859 45.8018 18.2764 45.4396 17.9398 45.106C17.4119 44.5845 16.8147 44.127 16.1659 43.7648C15.5172 43.4026 14.6879 43.4258 13.9428 43.276C12.9941 43.0867 12.04 42.8961 11.1347 42.5544C9.12603 41.7946 7.2612 40.1783 5.99763 38.4573C4.977 37.0684 4.17352 35.3106 3.803 33.6236C3.66456 32.9945 3.48948 32.3763 3.26418 31.7745C2.9588 30.9589 2.61543 30.1174 2.11733 29.3876C1.8676 29.0213 1.57579 28.6823 1.2297 28.4032C1.01526 28.2316 0.172423 27.9334 0.179209 27.6447C0.187353 27.2894 0.557875 26.8713 0.800818 26.6344C1.58394 25.8706 2.71586 25.7916 3.70121 26.1606C3.94686 26.2532 4.15859 26.4411 4.3866 26.5663C4.71641 26.7474 4.86706 26.7665 5.06386 26.4125C5.48867 25.6459 6.55138 25.2755 7.38471 25.3872C7.95474 25.4648 8.47185 25.7467 8.91837 26.1034C8.98488 26.1579 10.0476 27.1246 9.90508 27.1478C8.82744 27.3125 7.91946 28.1431 7.49193 29.148C7.06441 30.1528 7.07119 31.3047 7.33042 32.3668C8.11625 35.5761 10.7588 38.8113 14.1057 39.424C14.5129 39.4989 14.9268 39.5316 15.3421 39.5261V39.5275Z",fill:"#84BDEE"}),jsxRuntimeExports.jsx("path",{d:"M19.2632 46.8693C19.2048 46.8693 19.1424 46.8557 19.0759 46.8216C18.9198 46.7427 18.8465 46.5725 18.7882 46.4363C18.7637 46.3818 18.7393 46.3246 18.7176 46.2933C18.4502 45.9189 18.1462 45.5635 17.815 45.2354C17.2871 44.7139 16.7035 44.2713 16.0805 43.9228C15.6625 43.6899 15.1603 43.6273 14.6296 43.5606C14.3921 43.5306 14.1465 43.5007 13.9103 43.453C12.967 43.2651 11.9925 43.069 11.0737 42.7218C9.19667 42.0124 7.24498 40.4575 5.85518 38.5621C4.81419 37.1447 4.00257 35.3569 3.62933 33.6603C3.48275 32.9972 3.30903 32.4008 3.0973 31.8358C2.81771 31.0896 2.47841 30.2304 1.97081 29.487C1.70886 29.1044 1.42249 28.7858 1.11847 28.542C1.06554 28.4998 0.933888 28.4317 0.806309 28.3664C0.405928 28.1635 -0.00802512 27.9511 0.000118224 27.6406C0.00961879 27.2376 0.373355 26.8005 0.676016 26.5051C1.45099 25.7494 2.60463 25.5574 3.7637 25.9917C3.93335 26.0557 4.08265 26.1551 4.22516 26.2518C4.31066 26.309 4.39074 26.3635 4.47217 26.407C4.75312 26.5609 4.77755 26.5568 4.90648 26.324C5.39237 25.4457 6.55822 25.0931 7.4092 25.2088C7.95209 25.2823 8.49634 25.537 9.02973 25.9631C9.04194 25.9727 10.1657 26.9013 10.0911 27.1845C10.0707 27.2594 10.011 27.3139 9.93364 27.3261C8.97815 27.4718 8.08374 28.2152 7.65622 29.2188C7.17712 30.3421 7.30877 31.528 7.50421 32.3246C8.23168 35.2942 10.7425 38.6261 14.137 39.2484C14.5292 39.3205 14.935 39.3532 15.3381 39.3478C16.1918 39.3341 17.0401 39.1408 17.7933 38.7895C18.1326 38.6316 18.5276 38.4355 18.8737 38.17C19.0148 38.0624 19.1343 37.933 19.2401 37.7765C19.2741 37.7261 19.308 37.6457 19.3406 37.5681C19.3989 37.4306 19.4586 37.2876 19.5604 37.191C19.6609 37.0943 19.783 37.0534 19.9119 37.0671C20.2214 37.1038 20.4874 37.4592 20.729 37.8364L20.7602 37.884C21.1782 38.5253 21.371 39.183 21.3316 39.8379C21.3045 40.3063 21.1592 40.772 20.9136 41.1846C20.8335 41.3194 20.6937 41.4542 20.5444 41.5971C20.4223 41.7156 20.216 41.913 20.2051 41.992C20.1698 42.2439 20.3815 42.5312 20.5878 42.8103C20.6964 42.9574 20.7996 43.0976 20.8701 43.2365C21.1945 43.8819 21.0194 44.7547 20.748 45.3565C20.5295 45.8413 20.182 46.2729 19.745 46.6038C19.7179 46.6242 19.6921 46.6473 19.6649 46.6691C19.5659 46.7535 19.4301 46.8706 19.2605 46.8706L19.2632 46.8693ZM2.55849 26.1238C1.93145 26.1238 1.3587 26.3417 0.927102 26.7638C0.571509 27.1096 0.365211 27.4323 0.359783 27.6488C0.388284 27.7496 0.795451 27.9579 0.969176 28.0478C1.12526 28.1281 1.26098 28.1975 1.34241 28.2629C1.67358 28.5298 1.98438 28.8743 2.26532 29.2855C2.796 30.0616 3.14616 30.9439 3.43254 31.7105C3.64969 32.2905 3.82885 32.9033 3.9795 33.5841C4.34188 35.2343 5.13042 36.9718 6.14291 38.3511C7.49335 40.192 9.38396 41.7006 11.1986 42.3869C12.0903 42.7232 13.0498 42.9152 13.9782 43.1017C14.2021 43.1466 14.441 43.1766 14.6717 43.2052C15.2146 43.2733 15.7751 43.3427 16.2542 43.6096C16.9057 43.9745 17.5151 44.4347 18.0661 44.9807C18.4122 45.3225 18.7298 45.6942 19.0094 46.0864C19.0542 46.149 19.0854 46.2239 19.1166 46.296C19.1492 46.3709 19.198 46.4826 19.2388 46.5044C19.2727 46.5221 19.3053 46.5085 19.4328 46.3982C19.4654 46.3709 19.4966 46.3437 19.5292 46.3192C19.9187 46.0251 20.2268 45.6425 20.4209 45.2108C20.6476 44.7098 20.8172 43.935 20.5498 43.4013C20.4942 43.2896 20.3992 43.163 20.3001 43.0268C20.0626 42.7055 19.7939 42.3406 19.8509 41.943C19.8794 41.7415 20.083 41.5454 20.2974 41.3398C20.4223 41.22 20.5512 41.0947 20.6068 41.0021C20.8226 40.6386 20.9502 40.2301 20.9747 39.8202C21.0086 39.2443 20.8362 38.6601 20.4603 38.0855L20.4277 38.0352C20.1793 37.6471 19.992 37.4442 19.8699 37.4293C19.8549 37.4293 19.8373 37.4292 19.8088 37.4551C19.7613 37.5001 19.7138 37.6131 19.6717 37.7125C19.6324 37.8064 19.5916 37.9031 19.5374 37.9821C19.4125 38.1686 19.2618 38.3293 19.0908 38.4586C18.7176 38.7446 18.3009 38.9529 17.944 39.1176C17.1459 39.4894 16.2461 39.6936 15.3435 39.7086C14.916 39.7168 14.4871 39.68 14.0718 39.6037C10.5267 38.9543 7.90866 35.4944 7.15404 32.4117C6.94639 31.5621 6.80795 30.2931 7.32506 29.0785C7.76208 28.0532 8.64292 27.2717 9.61605 27.0238C9.37446 26.7624 8.88858 26.3131 8.80443 26.245C8.32262 25.861 7.83673 25.6323 7.35899 25.5669C6.61794 25.4662 5.6136 25.7889 5.21864 26.501C4.93227 27.017 4.62011 26.9027 4.29845 26.7256C4.20344 26.6739 4.11251 26.6126 4.02429 26.5527C3.89264 26.4642 3.76777 26.3798 3.63612 26.3308C3.26967 26.1933 2.90458 26.1252 2.55577 26.1252L2.55849 26.1238Z",fill:"#042D41"}),jsxRuntimeExports.jsx("path",{d:"M31.1213 7.54604C30.2351 7.55829 29.2837 7.73666 28.4585 8.10838C28.0228 8.30445 27.6021 8.55907 27.2723 8.91037C27.0375 9.15954 26.7877 9.97787 26.3833 9.66606C25.7685 9.19222 25.3708 8.44606 25.3192 7.6713C25.2636 6.85025 25.6056 6.28791 26.029 5.63434C26.4837 4.93175 26.063 4.60496 25.8309 3.91735C25.5513 3.09222 25.6544 2.23304 26.1091 1.5073C26.3765 1.08112 27.028 0.0612758 27.5817 0.703955C28.6607 1.958 29.8171 3.24199 31.5244 3.62869C33.4924 4.0753 35.4414 4.32039 37.1488 5.50635C38.7951 6.65146 40.2378 8.18191 41.2272 9.95881C42.2574 11.8092 42.5234 14.0082 43.2902 15.9812C43.6716 16.9616 44.1833 17.9052 44.9555 18.6323C45.208 18.8692 46.1309 19.2845 46.2232 19.5636C46.3358 19.904 45.8092 20.3465 45.5975 20.548C45.17 20.9579 44.6135 21.2343 44.0258 21.3119C43.2631 21.414 42.0592 21.1635 41.6439 20.4323C41.4281 20.5181 41.3263 20.7046 41.1811 20.8789C40.9762 21.1226 40.7237 21.3242 40.4468 21.478C39.9148 21.7708 39.2783 21.8865 38.6824 21.7517C38.1667 21.636 37.7025 21.3555 37.3225 20.9933C37.1949 20.8721 36.481 20.2866 36.5041 20.1491C36.5584 19.8305 37.4759 19.5827 37.7256 19.4247C38.1952 19.1238 38.6092 18.6854 38.8887 18.2033C39.4343 17.2679 39.4574 16.1514 39.2308 15.1166C38.7476 12.9094 37.2859 10.7976 35.63 9.30115C35.5188 9.20039 35.4061 9.10235 35.2907 9.00704C34.133 8.06072 32.6387 7.5365 31.1458 7.55012H31.1227L31.1213 7.54604Z",fill:"#84BDEE"}),jsxRuntimeExports.jsx("path",{d:"M39.1859 21.9859C39.0013 21.9859 38.8194 21.9668 38.643 21.926C38.1286 21.8102 37.6292 21.5325 37.1989 21.1226C37.1758 21.1008 37.1297 21.06 37.0727 21.011C36.4443 20.4623 36.2977 20.2866 36.3276 20.1164C36.3819 19.7978 36.8637 19.599 37.2885 19.4247C37.431 19.3662 37.5667 19.3103 37.6292 19.2708C38.0716 18.9863 38.4652 18.5751 38.7339 18.1108C39.3175 17.11 39.2307 15.9499 39.0556 15.1533C38.6199 13.1599 37.3265 11.0753 35.5092 9.43186C35.387 9.32157 35.2784 9.22762 35.1767 9.1432C34.0732 8.24182 32.6291 7.72713 31.2027 7.72713C31.1837 7.72713 31.1647 7.72713 31.1457 7.72713H31.0575C30.1631 7.74755 29.27 7.9409 28.533 8.27313C28.0512 8.48963 27.6821 8.7388 27.4038 9.03427C27.3523 9.08874 27.2871 9.20039 27.2247 9.30796C27.074 9.5653 26.903 9.85804 26.6411 9.90979C26.5542 9.92613 26.4212 9.9234 26.2746 9.81039C25.6204 9.30659 25.197 8.51141 25.14 7.68492C25.0789 6.77128 25.4847 6.14358 25.8783 5.53766C26.1633 5.09786 26.0507 4.85822 25.8634 4.46199C25.7969 4.32038 25.7222 4.16108 25.6598 3.97726C25.3626 3.10174 25.4684 2.19083 25.957 1.41335C26.1715 1.07159 26.6194 0.360827 27.1446 0.32134C27.2898 0.310447 27.5083 0.347211 27.716 0.589577C28.8832 1.94574 29.9771 3.09766 31.5624 3.45576C31.8881 3.52929 32.2125 3.59737 32.5355 3.66545C34.2117 4.01811 35.7956 4.3517 37.2491 5.36065C38.9782 6.56295 40.4074 8.12336 41.3819 9.87302C42.0143 11.01 42.3672 12.2872 42.7079 13.5235C42.9278 14.3214 43.1558 15.1465 43.4557 15.9172C43.8927 17.0405 44.4234 17.8861 45.0762 18.5015C45.159 18.5791 45.3558 18.6962 45.5458 18.8106C46.01 19.0884 46.3195 19.2872 46.3914 19.5064C46.5285 19.9231 46.0657 20.3547 45.7888 20.612L45.7196 20.6774C45.2595 21.1185 44.6664 21.4086 44.0475 21.4903C43.3214 21.5869 42.1284 21.3895 41.5868 20.6733C41.5257 20.725 41.4742 20.7931 41.4131 20.8721C41.3819 20.9129 41.3507 20.9538 41.3167 20.9933C41.1023 21.2493 40.8376 21.4644 40.5323 21.6332C40.1129 21.8633 39.6433 21.9845 39.1859 21.9845V21.9859ZM36.694 20.1477C36.789 20.2866 37.1745 20.6229 37.3075 20.7387C37.3699 20.7931 37.4188 20.8367 37.4446 20.8612C37.8273 21.2261 38.2684 21.4726 38.7204 21.5747C39.2483 21.6945 39.8469 21.6006 40.3585 21.3187C40.6259 21.1703 40.8566 20.9837 41.0426 20.7618C41.0724 20.725 41.1009 20.6883 41.1294 20.6515C41.2394 20.5099 41.3629 20.3479 41.5773 20.2635L41.7225 20.2063L41.7999 20.3411C42.1745 20.9987 43.3214 21.2234 44.0027 21.1308C44.5469 21.0586 45.0681 20.804 45.4739 20.4146C45.4956 20.3942 45.5201 20.371 45.5472 20.3452C45.7182 20.1858 46.1186 19.8128 46.0535 19.6153C46.0141 19.505 45.592 19.2518 45.364 19.1156C45.1387 18.9808 44.9432 18.8637 44.8333 18.7589C44.1398 18.1053 43.5806 17.2175 43.1246 16.0425C42.8178 15.2541 42.5885 14.4194 42.3659 13.6134C42.0306 12.3988 41.6845 11.142 41.0724 10.0432C40.1251 8.34121 38.7339 6.82166 37.0483 5.65068C35.6544 4.68257 34.1058 4.35715 32.4649 4.0113C32.1405 3.94322 31.8135 3.87378 31.4864 3.80025C29.6568 3.38632 28.4313 1.96208 27.4473 0.818327C27.3143 0.663104 27.2084 0.671273 27.1745 0.673997C26.8284 0.699867 26.4185 1.35344 26.2638 1.59989C25.8349 2.28342 25.7412 3.0854 26.0032 3.85608C26.0588 4.02083 26.1267 4.16516 26.1918 4.30404C26.39 4.72478 26.5759 5.12237 26.1823 5.72965C25.7385 6.41454 25.4521 6.91833 25.5024 7.65632C25.5512 8.38206 25.9231 9.0792 26.4972 9.52173C26.5461 9.55985 26.5678 9.55441 26.5759 9.55305C26.6791 9.53262 26.8229 9.28617 26.9179 9.12278C26.994 8.99206 27.0659 8.86952 27.146 8.78374C27.4581 8.45287 27.8639 8.17782 28.3892 7.9409C29.1872 7.58144 30.159 7.37583 31.1226 7.36222H31.1986H31.2H31.2081C32.7133 7.36222 34.2402 7.9055 35.406 8.85999C35.5132 8.94713 35.6259 9.04516 35.7521 9.15954C37.6237 10.852 38.9565 13.0061 39.4085 15.0703C39.6786 16.3039 39.5537 17.4163 39.0461 18.2864C38.7489 18.7984 38.3146 19.2545 37.8246 19.569C37.735 19.6262 37.5925 19.6848 37.4269 19.7529C37.2437 19.8277 36.7823 20.017 36.6967 20.1436L36.694 20.1477Z",fill:"#042D41"}),jsxRuntimeExports.jsx("path",{d:"M7.89777 21.6128C7.62768 21.6782 7.34674 21.7027 7.06715 21.6795C6.5039 21.6319 5.92572 21.3119 5.51448 20.9374C5.40591 20.8394 5.15482 20.3901 5.05303 20.3547C4.81551 20.2716 4.79244 20.4677 4.59429 20.6011C3.31171 21.4589 1.17544 21.3201 0.500898 19.7474C0.333959 19.4438 0.346174 19.3689 0.598618 19.1197C0.851062 18.8719 1.24737 18.8079 1.53239 18.6091C2.00199 18.281 2.28565 17.7064 2.57066 17.2189C3.54244 15.555 3.92925 13.518 4.51964 11.7017C5.21318 9.56257 6.60298 7.69036 8.31308 6.25523C9.15592 5.54719 10.1005 4.88136 11.1198 4.4579C12.3128 3.96228 13.6117 3.84654 14.8739 3.63685C16.1076 3.43261 17.1595 2.82534 18.0104 1.91033C18.267 1.63257 18.5018 1.33846 18.7366 1.04163C18.7366 1.04163 18.7366 1.03891 18.7393 1.03754C18.9809 0.718927 19.1329 0.475199 19.3989 0.217855C19.7056 0.375802 20.0992 0.841472 20.3299 1.1206C20.7683 1.64891 20.9733 2.3515 20.9339 3.03502C20.9135 3.38768 20.8308 3.74714 20.6733 4.06304C20.543 4.3231 20.1698 4.61857 20.1657 4.90996C20.1603 5.31572 20.8579 6.00333 21.0832 6.32739C21.4307 6.83119 21.2488 7.84014 21.0574 8.363C20.9325 8.70204 20.7507 9.01521 20.5172 9.28889C20.429 9.39373 20.2159 9.83353 20.0816 9.84851C19.8006 9.87983 19.4423 9.02474 19.3039 8.84364C18.9605 8.39431 18.4027 8.05527 17.8829 7.8415C16.7401 7.37175 15.429 7.35949 14.2279 7.57599C13.0783 7.78295 12.0373 8.27449 11.1293 9.00431C10.6081 9.42369 10.1277 9.89345 9.69745 10.404C8.67139 11.6227 7.79326 13.2008 7.49467 14.7775C7.33452 15.6204 7.33588 16.4972 7.50282 17.3387C7.57882 17.7159 7.66161 18.2469 7.88013 18.571C8.09864 18.895 8.51531 19.0652 8.8519 19.2736C9.15049 19.456 9.75309 19.5568 9.94989 19.8631C10.1738 20.2117 9.39614 20.6842 9.11656 20.932C8.78132 21.2629 8.3538 21.4971 7.89641 21.6087L7.89913 21.6142L7.89777 21.6128Z",fill:"#84BDEE"}),jsxRuntimeExports.jsx("path",{d:"M7.35415 21.8688C7.27951 21.8688 7.20622 21.8661 7.13157 21.8593C6.58325 21.813 5.96436 21.5189 5.47304 21.0709C5.41197 21.0151 5.33868 20.9089 5.25317 20.7849C5.19481 20.7005 5.09981 20.5616 5.05637 20.5194C5.03602 20.514 5.02787 20.5154 5.02787 20.5154C5.01566 20.5208 4.98173 20.5576 4.96001 20.5821C4.91387 20.6324 4.85686 20.6951 4.77407 20.7509C3.98552 21.2779 2.8916 21.4453 1.98498 21.1757C1.25886 20.9606 0.703757 20.4813 0.41874 19.8277C0.217871 19.4601 0.245015 19.2953 0.551748 18.9917C0.721401 18.8256 0.931771 18.7357 1.13535 18.6486C1.27243 18.59 1.40137 18.5356 1.50859 18.4607C1.88318 18.1993 2.13563 17.7554 2.37993 17.3265C2.41793 17.2597 2.45593 17.193 2.49394 17.1277C3.18476 15.9444 3.58107 14.5501 3.96381 13.2022C4.11039 12.6861 4.2624 12.1537 4.42662 11.6458C5.09709 9.58028 6.42717 7.66858 8.27571 6.11771C9.29227 5.26398 10.226 4.66759 11.1286 4.29179C12.1044 3.88603 13.1536 3.72944 14.1688 3.57694C14.4212 3.53882 14.6723 3.50206 14.9234 3.45985C16.0838 3.26786 17.1045 2.70552 17.9568 1.78779C18.2119 1.51275 18.4508 1.21183 18.6612 0.944956L18.6815 0.917724C18.7372 0.844197 18.7888 0.773393 18.8376 0.706675C18.9991 0.484733 19.1389 0.292746 19.3507 0.0898661L19.4429 0L19.557 0.0585492C19.8678 0.219219 20.2301 0.627701 20.545 1.00623C20.9983 1.55087 21.2331 2.29431 21.1897 3.04592C21.1666 3.44351 21.0703 3.8234 20.9101 4.14474C20.8531 4.25775 20.7635 4.3694 20.6767 4.47833C20.5586 4.62538 20.4242 4.79286 20.4229 4.91404C20.4201 5.14552 20.8083 5.61119 21.0404 5.88896C21.149 6.01967 21.244 6.13268 21.3078 6.22527C21.7217 6.82438 21.4856 7.92592 21.3023 8.42563C21.1721 8.78373 20.9793 9.11324 20.7296 9.40599C20.712 9.42778 20.6712 9.49449 20.6346 9.55304C20.4677 9.82809 20.3441 10.0092 20.1772 10.0269C19.8773 10.0596 19.6452 9.68376 19.3751 9.18813C19.3222 9.0901 19.2665 8.98934 19.238 8.95121C18.8607 8.45559 18.2323 8.1465 17.8916 8.00626C16.6403 7.49021 15.2681 7.5828 14.3371 7.75164C13.235 7.95043 12.2198 8.41882 11.3186 9.1432C10.811 9.55168 10.3373 10.0146 9.91252 10.5198C8.80503 11.8351 8.01648 13.3996 7.74911 14.8102C7.59303 15.6299 7.59574 16.4918 7.75725 17.3033L7.78304 17.4354C7.84954 17.7812 7.93369 18.2129 8.10741 18.4702C8.24992 18.6826 8.51458 18.8297 8.76974 18.9726C8.8566 19.0217 8.94346 19.0693 9.0249 19.1197C9.11583 19.1755 9.25155 19.2259 9.39406 19.2804C9.68858 19.392 10.0211 19.5173 10.1799 19.7651C10.4486 20.1845 9.88945 20.6161 9.51893 20.902C9.44021 20.9633 9.36556 21.0205 9.31399 21.0654C9.01675 21.3609 8.64352 21.5856 8.23228 21.7204L8.23635 21.7285L8.02055 21.7871C7.80068 21.8416 7.5781 21.8674 7.35551 21.8674L7.35415 21.8688ZM5.02923 20.1559C5.07673 20.1559 5.13102 20.1654 5.1921 20.1858C5.2966 20.2226 5.37668 20.3288 5.5504 20.5821C5.60741 20.6651 5.68477 20.7781 5.71463 20.8054C6.14894 21.2016 6.69047 21.4617 7.16279 21.5012C7.36637 21.5175 7.57131 21.508 7.77625 21.4726L7.93233 21.4344C8.36664 21.3282 8.75888 21.1104 9.06833 20.804C9.13619 20.7441 9.21491 20.6828 9.29906 20.6175C9.49857 20.4622 9.96817 20.1014 9.87723 19.9598C9.78223 19.8128 9.50807 19.7093 9.26648 19.6181C9.10769 19.5581 8.95704 19.501 8.83624 19.4274C8.75752 19.3798 8.67609 19.3335 8.5933 19.2872C8.30014 19.1238 7.99884 18.9549 7.80747 18.6717C7.59303 18.3531 7.50209 17.882 7.4288 17.5035L7.40301 17.3741C7.23336 16.5177 7.22929 15.6081 7.39487 14.7435C7.6731 13.273 8.49151 11.6486 9.63701 10.287C10.0767 9.76409 10.5667 9.28481 11.0933 8.86271C12.042 8.10021 13.1115 7.60731 14.2719 7.39762C15.2491 7.22061 16.6946 7.1253 18.0274 7.67402C18.402 7.82789 19.0928 8.17101 19.523 8.73335C19.5678 8.79327 19.6221 8.8913 19.69 9.01521C19.7782 9.17588 20.0021 9.58844 20.127 9.66061C20.1854 9.6007 20.2804 9.44548 20.3292 9.36514C20.3808 9.28208 20.4201 9.21536 20.4568 9.17315C20.678 8.91173 20.849 8.61898 20.9658 8.30173C21.1585 7.77614 21.301 6.84753 21.0133 6.43088C20.9576 6.3519 20.864 6.23889 20.7649 6.11907C20.4337 5.72284 20.0591 5.27215 20.0632 4.9086C20.0659 4.66215 20.2424 4.44429 20.3971 4.25094C20.4758 4.1529 20.5491 4.06168 20.5898 3.9827C20.7282 3.70494 20.811 3.37407 20.8314 3.02549C20.8694 2.36511 20.6644 1.7129 20.2681 1.2377C20.1134 1.05116 19.7768 0.644041 19.5013 0.447969C19.3615 0.597746 19.2502 0.748885 19.1267 0.920447C19.0765 0.989889 19.0236 1.06205 18.9666 1.1383L18.9543 1.15601C18.9543 1.15601 18.9516 1.15873 18.9516 1.16009L18.9489 1.16281C18.7318 1.43786 18.4861 1.7483 18.2201 2.0356C17.3121 3.01324 16.2236 3.61235 14.9818 3.81659C14.7293 3.8588 14.4769 3.89692 14.2231 3.93505C13.2296 4.08346 12.2022 4.23869 11.267 4.62674C10.3971 4.98757 9.4945 5.56625 8.50644 6.39547C6.70947 7.90277 5.4174 9.75728 4.76864 11.7588C4.60578 12.2599 4.45512 12.7896 4.3099 13.3016C3.92038 14.6713 3.51864 16.0888 2.80474 17.3101C2.76809 17.3741 2.73009 17.4395 2.69209 17.5062C2.441 17.9487 2.15463 18.4498 1.71353 18.7575C1.57645 18.8528 1.42309 18.9182 1.27515 18.9808C1.09464 19.0584 0.92227 19.1306 0.802834 19.2491C0.67616 19.3743 0.653992 19.5118 0.73633 19.6616L0.744474 19.678C1.05256 20.3942 1.64431 20.7005 2.08677 20.8326C2.89432 21.0722 3.87152 20.9238 4.57456 20.4527C4.62206 20.4214 4.65735 20.3819 4.69535 20.3397C4.76457 20.2635 4.86229 20.1559 5.02923 20.1559Z",fill:"#042D41"}),jsxRuntimeExports.jsx("path",{d:"M23.1393 2.52715C24.1925 2.48085 25.2634 3.26514 25.091 4.51101C25.1059 5.26534 24.6173 6.00606 23.9184 6.28519C23.218 6.56432 22.3562 6.3628 21.8513 5.80318C21.2175 5.10059 21.1958 3.86833 21.8174 3.15349C22.173 2.745 22.6548 2.54757 23.1393 2.52715Z",fill:"#84BDEE"}),jsxRuntimeExports.jsx("path",{d:"M23.2481 6.59291C22.6767 6.59291 22.108 6.35599 21.7185 5.92436C21.0263 5.15777 21.01 3.80842 21.6832 3.03639C22.0483 2.61701 22.5627 2.37329 23.1327 2.34878C23.776 2.32018 24.4098 2.57344 24.8211 3.02822C25.1862 3.42989 25.345 3.96092 25.2717 4.52327C25.2825 5.35385 24.7559 6.1463 23.985 6.45403C23.7489 6.54798 23.4978 6.59427 23.2481 6.59427V6.59291ZM23.2304 2.70552C23.2019 2.70552 23.1748 2.70552 23.1463 2.70688C22.6767 2.7273 22.2519 2.92746 21.9519 3.27195C21.3914 3.91599 21.4049 5.04204 21.9831 5.68199C22.4364 6.18579 23.2223 6.36824 23.8507 6.11771C24.4791 5.86717 24.9256 5.19182 24.9107 4.51373V4.50012L24.912 4.4865C24.9935 3.89693 24.7627 3.49934 24.5537 3.26922C24.2307 2.91248 23.7407 2.70552 23.2291 2.70552H23.2304Z",fill:"#042D41"}),jsxRuntimeExports.jsx("path",{d:"M23.115 44.5001C22.5409 44.4851 21.9736 44.2073 21.6153 43.7158C21.2312 43.1902 21.1307 42.4672 21.3574 41.8558C21.5759 41.2635 22.1351 40.7393 22.7608 40.6018C23.8778 40.3553 24.8889 41.3643 24.9853 42.4114C25.0423 43.0295 24.7966 43.6736 24.3256 44.0766C23.9741 44.3775 23.5439 44.5123 23.1164 44.5001H23.115Z",fill:"#84BDEE"}),jsxRuntimeExports.jsx("path",{d:"M23.1665 44.6812C23.1475 44.6812 23.1285 44.6812 23.1095 44.6812C22.4621 44.6635 21.8486 44.3421 21.4699 43.8234C21.0533 43.2542 20.9433 42.4577 21.1876 41.7946C21.4347 41.1247 22.0508 40.5746 22.72 40.4275C23.2343 40.3145 23.7677 40.4357 24.2238 40.7706C24.7449 41.1519 25.1032 41.7755 25.1616 42.3964C25.2254 43.0826 24.9485 43.7798 24.4396 44.2155C24.0867 44.5178 23.6361 44.6825 23.1651 44.6825L23.1665 44.6812ZM23.0986 40.7448C22.9982 40.7448 22.8977 40.7557 22.7987 40.7774C22.2531 40.8973 21.7292 41.367 21.5256 41.9185C21.322 42.4713 21.4129 43.1344 21.7604 43.6096C22.0739 44.0399 22.5829 44.3067 23.1203 44.3203C23.5234 44.3312 23.9089 44.1964 24.2075 43.9405C24.6296 43.5796 24.8589 42.9996 24.806 42.4291C24.7571 41.9076 24.4545 41.3834 24.0147 41.0607C23.7324 40.8537 23.4162 40.7461 23.0986 40.7461V40.7448Z",fill:"#042D41"}),jsxRuntimeExports.jsx("path",{d:"M2.47971 23.6484C2.54893 22.3399 4.14503 21.1975 5.55247 22.2255C7.5313 23.6716 5.07744 26.7284 3.17054 25.1162C2.65208 24.6778 2.45393 24.1509 2.48107 23.6484H2.47971Z",fill:"#84BDEE"}),jsxRuntimeExports.jsx("path",{d:"M4.33519 25.7548C3.88595 25.7548 3.44621 25.586 3.05397 25.2538C2.53687 24.8167 2.26814 24.2434 2.30071 23.6389C2.34007 22.89 2.82596 22.186 3.53715 21.847C4.22933 21.5161 5.00295 21.6019 5.65849 22.0798C6.25702 22.5169 6.53797 23.1351 6.44839 23.8213C6.3466 24.6056 5.77521 25.3286 5.02738 25.62C4.79801 25.7099 4.56592 25.7535 4.33655 25.7535L4.33519 25.7548ZM2.65902 23.6579C2.63323 24.1536 2.85039 24.6111 3.28606 24.9787C3.77466 25.3913 4.34605 25.5002 4.89708 25.2864C5.51734 25.0441 6.00865 24.4245 6.0928 23.7764C6.16337 23.2263 5.934 22.728 5.44676 22.3712C4.70029 21.8252 4.02575 22.0118 3.69051 22.1724C3.10555 22.4516 2.6916 23.0493 2.65902 23.6579Z",fill:"#042D41"}),jsxRuntimeExports.jsx("path",{d:"M41.7618 25.4961C41.314 25.5016 40.8579 25.3395 40.4657 24.9487C38.5534 23.0425 41.6044 20.7863 43.3308 22.3957C44.6595 23.6334 43.2548 25.4798 41.7618 25.4961Z",fill:"#84BDEE"}),jsxRuntimeExports.jsx("path",{d:"M41.743 25.6758C41.2177 25.6758 40.7332 25.4689 40.3396 25.0767C39.3258 24.0664 39.6379 23.0071 40.212 22.4066C40.9816 21.6033 42.4406 21.3201 43.4531 22.2637C44.0136 22.7865 44.1833 23.4809 43.9186 24.1685C43.5861 25.0318 42.6795 25.665 41.7633 25.6758C41.7565 25.6758 41.7498 25.6758 41.7416 25.6758H41.743ZM41.9479 22.0281C41.386 22.0281 40.8363 22.2718 40.4713 22.6544C39.9867 23.1596 39.7641 23.9943 40.592 24.8194C40.9164 25.1435 41.3141 25.3137 41.743 25.3137H41.7606C42.5234 25.3055 43.3079 24.7568 43.5847 24.0365C43.7965 23.485 43.6634 22.9485 43.2088 22.5251C42.8342 22.1765 42.3863 22.0267 41.9479 22.0267V22.0281Z",fill:"#042D41"})]});const InmanBadge=({elClass:s})=>jsxRuntimeExports.jsxs("svg",{id:"Layer_1",xmlns:"http://www.w3.org/2000/svg",version:"1.1",viewBox:"0 0 63 47",fill:"#84bdee",stroke:"#000000",strokeMiterlimit:10,strokeWidth:.2,children:[jsxRuntimeExports.jsx("polygon",{points:"233.1 -41.7 233.1 -.6 236.1 -.6 238.7 -17.6 241.7 -.6 244.7 -.6 244.7 -41.7 241.7 -41.7 241.7 -27.3 241.7 -18.8 239.9 -26.9 237.9 -26.9 236.1 -18.7 236.1 -27 236.1 -41.7 233.1 -41.7"}),jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("line",{className:"st0",x1:"260.4",y1:"-13.9",x2:"257",y2:"-13.9"}),jsxRuntimeExports.jsx("polygon",{points:"257 -29.1 257 -41.1 250.2 -41.1 250.2 -27.4 246.8 -27.4 246.8 -44.5 260.4 -44.5 260.4 -27.8 250.2 -13.9 250.2 -1 257 -1 257 -13.9 260.4 -13.9 260.4 2.1 246.8 2.1 246.8 -13.9 257 -29.1"})]}),jsxRuntimeExports.jsx("polygon",{points:"274 -26.8 274 -41.7 262.3 -41.7 262.3 -.5 274 -.5 274 -15 271.1 -15 271.1 -3.4 265.2 -3.4 265.2 -19.3 271.4 -19.3 271.4 -22.2 265.2 -22.2 265.2 -38.8 271.1 -38.8 271.1 -26.8 274 -26.8"}),jsxRuntimeExports.jsx("path",{d:"M23.5,7.8v31.4h-9V7.8h2.3v29.1h4.5V7.8h2.3Z"}),jsxRuntimeExports.jsx("polygon",{points:"35.7 19.2 35.7 7.8 26.7 7.8 26.7 39.2 35.7 39.2 35.7 28.1 33.5 28.1 33.5 37 28.9 37 28.9 24.9 33.6 24.9 33.6 22.7 28.9 22.7 28.9 10 33.5 10 33.5 19.2 35.7 19.2"}),jsxRuntimeExports.jsx("polygon",{points:"11.3 19.2 11.3 7.8 2.3 7.8 2.3 39.2 11.3 39.2 11.3 22.6 9.9 22.6 9.9 22.6 6.8 22.6 6.8 24.8 9.1 24.8 9.1 37 4.5 37 4.5 24.9 4.5 22.7 4.5 10 9.1 10 9.1 19.2 11.3 19.2"}),jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("line",{x1:"38.9",y1:"28.4",x2:"41.1",y2:"28.4"}),jsxRuntimeExports.jsx("polygon",{points:"41.1 18.2 41.1 10.1 45.7 10.1 45.7 19.3 48 19.3 48 7.8 38.9 7.8 38.9 19 45.7 28.4 45.7 37 41.1 37 41.1 28.4 38.9 28.4 38.9 39.2 48 39.2 48 28.4 41.1 18.2"})]}),jsxRuntimeExports.jsx("polygon",{points:"60.7 7.8 51.2 7.8 51.2 9.3 51.2 9.3 51.2 19.1 53.7 19.1 53.7 10 54.8 10 54.8 39.2 57.1 39.2 57.1 10 58.2 10 58.2 19.1 60.7 19.1 60.7 10 60.7 10 60.7 7.8"})]});const WindsorBadge=({elClass:s})=>jsxRuntimeExports.jsxs("svg",{id:"Layer_1",xmlns:"http://www.w3.org/2000/svg",version:"1.1",viewBox:"0 0 63 47",fill:"#84bdee",stroke:"#000000",strokeMiterlimit:10,strokeWidth:.2,children:[jsxRuntimeExports.jsx("path",{d:"M1.2,34.3v-.5c.7-.2,1.3-.5,1.6-1.1.3-.5.5-1.4.5-2.7v-13.3c0-2.2-.7-3.4-2.1-3.4v-.6h.7c.7,0,1.2.1,1.7.4s.9.6,1.3,1c.9-1.1,2.1-1.7,3.6-1.7s1.4.1,2,.4,1.1.6,1.5,1.1c.4.5.7,1.1.9,1.8.2.7.3,1.4.3,2.3s0,.9-.2,1.3c-.1.5-.3.9-.5,1.3-.2.4-.5.8-.8,1.2-.3.4-.7.6-1,.8,1,.7,1.7,1.5,2.1,2.5.4,1,.6,2.1.6,3.2s-.1,1.8-.4,2.5-.6,1.4-1,2c-.4.5-1,1-1.6,1.3s-1.3.5-2.1.5-1.3-.1-1.9-.4-1.1-.7-1.5-1.3c0,0,0,0,0,0,0,0,0,0,0,0-.3.3-.6.5-.9.6-.3.2-.5.3-.8.4-.3,0-.6.2-.8.2-.3,0-.6,0-1,0ZM6.3,16.2v5.8h2.1c.3,0,.5,0,.8-.2s.4-.3.6-.5c.2-.2.3-.5.4-.8,0-.3.1-.6.1-.9v-2.9c0-.3,0-.7,0-1.1,0-.4-.1-.7-.3-1.1-.1-.3-.3-.6-.6-.8-.3-.2-.6-.3-1-.3-.6,0-1.1.2-1.5.7s-.5,1.2-.5,2ZM6.3,23.3v7.6c0,.3,0,.6.1.9,0,.3.2.6.3.8.2.2.3.4.6.6.2.2.5.2.9.2s.8-.1,1-.3c.3-.2.5-.5.6-.8.2-.3.3-.7.3-1,0-.4,0-.7,0-1.1v-3.2c0-.4,0-.8,0-1.1,0-.3,0-.6-.1-.9,0-.3-.2-.6-.3-.8-.1-.3-.3-.6-.6-.8-.2,0-.5,0-.8,0h-2.1Z"}),jsxRuntimeExports.jsx("path",{d:"M14,33.8c.4-.1.7-.4.9-.7.3-.3.5-.6.7-1,.2-.4.4-.8.5-1.3.1-.5.3-.9.3-1.4l2.7-12.3c.1-.5.2-.9.2-1.2,0-.3,0-.7,0-1s-.1-.8-.4-1.1-.6-.5-1-.6v-.5c.4,0,.7,0,1.1,0s.7,0,1.1.2.7.2,1,.4.6.4.8.6c.4-.4.9-.7,1.4-.9.6-.2,1.1-.3,1.6-.3h.9v.6c0,0-.2,0-.2,0-.2,0-.3,0-.5,0-.4.2-.6.4-.8.8-.1.4-.2.8-.2,1.2s0,.9.2,1.4l2.7,13.5c.2,1,.4,1.8.7,2.3.3.6.7,1,1.3,1.1v.5c-.6,0-1.2,0-1.7-.2-.5-.2-1-.4-1.5-.8-.4.4-.9.6-1.5.8-.6.2-1.2.3-1.8.3v-.5c.5-.1.9-.4,1.2-.8.3-.4.4-.9.4-1.5s0-.4,0-.6c0-.2,0-.5-.1-.9l-.6-3h-4.5l-.5,2.3c0,.3-.2.7-.2,1.1s0,.8,0,1.2,0,.5,0,.7c0,.2,0,.5.2.7,0,.2.2.4.4.5.2.1.4.2.7.2v.5h-1.2c-.3,0-.6,0-.9-.2-.3-.2-.5-.3-.7-.6-.2.3-.5.4-.9.6s-1,.2-1.7.2v-.5ZM19.3,25.5h3.8l-1.7-8.8c0-.1,0-.3,0-.4,0-.1,0-.3,0-.4,0,.2-.1.5-.2.7,0,.2,0,.4-.1.6l-1.7,8.2Z"}),jsxRuntimeExports.jsx("path",{d:"M26.8,19.3c.4-.5.7-1,.8-1.5s.2-1.2.2-2,.1-1,.3-1.4c.2-.4.6-.7,1-1,.4-.3.9-.5,1.4-.6.5-.1,1.1-.2,1.8-.2s.6,0,.9,0c.3,0,.7,0,1,.2.4,0,.7.2,1,.4.3.2.6.4.9.7.5-.5,1.1-.8,1.8-1,.7-.2,1.5-.3,2.3-.3s1.2,0,1.7.1c.5,0,.9.3,1.3.5.3.2.6.5.8.9.2.4.3.8.3,1.3s0,.9,0,1.3c0,.4,0,.7.2,1s.2.6.4.8c.2.3.4.5.6.8l-.2.2c-.5,0-1-.1-1.5-.3-.5-.2-.8-.6-1-1.1,0,0-.2,0-.4.1,0,0-.2,0-.3,0,0,0-.2,0-.3,0-.3,0-.5,0-.7-.2-.1-.1-.2-.3-.3-.4,0-.2,0-.3,0-.5h0c0,0,.1,0,.2,0,0,0,.1,0,.2,0,.4,0,.8-.2,1.1-.5.3-.4.5-.7.5-1.2s0-.6-.2-.8c-.1-.2-.3-.4-.6-.5s-.5-.2-.8-.3c-.3,0-.6,0-.9,0s-.7,0-1,0-.7.2-.9.3c-.3.2-.5.4-.7.7-.2.3-.3.7-.3,1.1v14.6c0,.8.2,1.5.5,2.1.3.6.9.9,1.7,1.1v.6h-.5c-.7,0-1.4,0-1.9-.2s-1-.4-1.4-.9c-.5.4-1,.7-1.4.8-.4.2-.9.3-1.6.3h-.8v-.5c.4,0,.7-.2,1-.5s.5-.5.7-.8c.2-.3.3-.7.4-1,0-.4.1-.7.1-1.1v-14.4c0-.8-.2-1.4-.7-1.7-.5-.3-1.1-.5-1.8-.5s-.7,0-1,0c-.4,0-.7.2-1,.3s-.5.3-.7.6-.3.5-.3.9c0,.5.2.9.6,1.1s.8.4,1.3.4h0s0,0,0,0c0,0,0,0,0,0v.2c0,.3-.3.6-.5.8s-.5.3-.8.4c-.1,0-.2,0-.3,0,0,0-.2,0-.3,0-.3.5-.6.8-1,1-.4.2-.9.3-1.4.3l-.2-.2Z"}),jsxRuntimeExports.jsx("path",{d:"M45.3,33.7h.4c.3,0,.6-.2.9-.5s.4-.6.6-1c.2-.4.3-.9.3-1.4,0-.5,0-1.1,0-1.7v-12c0-.5,0-1,0-1.4,0-.4-.2-.8-.3-1.2s-.3-.6-.5-.8-.5-.3-.8-.3h-.4v-.6h1.2c.5,0,.9,0,1.4.2.4.2.8.4,1.1.8.4-.4.8-.6,1.4-.8s1.1-.2,1.6-.2.3,0,.4,0c.1,0,.3,0,.4,0v.5c-.7,0-1.3.2-1.6.7s-.5,1-.5,1.6v6.5h5.8v-6.5c0-.7-.2-1.2-.5-1.6-.4-.4-.9-.6-1.6-.6v-.5c0,0,.2,0,.4,0,.1,0,.3,0,.6,0,.6,0,1.1,0,1.5.2.4.1.8.4,1.2.8.4-.3.8-.6,1.2-.7s.9-.3,1.5-.3h1v.6c-.5,0-.9,0-1.2.3-.3.2-.5.4-.7.8-.2.3-.3.7-.3,1.2,0,.5,0,1,0,1.6v12c0,1.3.2,2.4.4,3.1.3.8.8,1.2,1.5,1.4h.3v.6h-1c-1.2,0-2.2-.3-2.9-1-.3.3-.6.5-1.1.7-.5.2-.9.3-1.3.3h-1.1v-.5c.5-.1.9-.3,1.1-.6.3-.3.5-.6.6-1,.1-.4.2-.8.3-1.3,0-.4,0-.9,0-1.3v-6.2h-5.8v6.2c0,.5,0,1,0,1.5,0,.5.1.9.3,1.2.1.4.3.7.6.9.3.3.7.4,1.2.5v.5h-1.2c-.4,0-.9,0-1.3-.3-.4-.2-.8-.4-1.1-.8-.8.7-1.7,1-2.8,1h-1v-.5Z"})]});const PonceSvgContainer=({stroke:a,fill:l,patternSize:t=700,patternAspect:e})=>{let h=reactExports.useId().replace(/[^a-zA-Z0-9]/g,""),d=`appl-frame-pattern-${h}`,p=l.startsWith("#")?l:`url(#${d})`;return jsxRuntimeExports.jsxs("svg",{id:`appl-frame-${h}`,"data-name":"appl-frame",xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 431.91 476.91",stroke:a,children:[jsxRuntimeExports.jsx("defs",{children:jsxRuntimeExports.jsx("pattern",{id:d,patternUnits:"userSpaceOnUse",width:t,height:t,children:jsxRuntimeExports.jsx("image",{href:l,x:"0",y:"0",width:t,height:t,preserveAspectRatio:e})})}),jsxRuntimeExports.jsx("g",{id:`_7Vt8hd-${h}`,"data-name":"7Vt8hd",children:jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{stroke:a,strokeWidth:"4",fill:p,d:"m424.16,279.1c-.8.5-1.6.9-2.3,1.4-9.2,6.8-16.4,16.1-20.6,26.8-4.8,12.2-4.7,25.8-7.7,38.4-2.4,10-5.7,19.7-9.8,29.1-6.1,13.8-15,26.8-25.8,37.7-10,10.1-20.7,18.5-33.7,24.3-12.7,5.7-27.9,4.8-41,10.4-7.5,3.2-14.5,7.7-20.1,13.6-3.3,3.4-7.9,16.4-13.4,15.4-2.6-.5-7.1-6.4-8.5-8.5-2.4-3.5-4-7.7-4.4-12-.4-4.1.3-8.3,1.8-12.1,1-2.4,7.1-8.7,6.9-10.5-.2-1.7-7.3-7.2-8.5-9.3-2.2-3.7-3.5-7.9-3.8-12.2-.4-5.6,1.1-11.3,4-16.2,2.5-4.2,4.6-7,8.3-3.6,3.6,3.4,6.6,6.5,11.1,9.1,9.2,5.2,19.8,7.9,30.4,7.5,12.3-.5,24.2-5.5,34.1-12.7,17.2-12.6,32.7-34.2,39.5-54.3,4.4-13,5.7-27,3.8-40.6-1-6.6-2.6-13.6-5.4-19.7-1.6-3.4-4.9-5.4-8.1-7.1-4.1-2.3-10.1-1.9-5.6-7.6,9.2-11.8,26.9-15.3,38.2-4.5,4.8,4.5,6.2,5.1,11.7,1.7,5.6-3.5,12.2-5.1,18.7-3.9,5.9,1.1,12,4.5,15.7,9.3,2.4,3,3.2,4.2.8,6.5-1.7,1.3-4.1,2.4-6.3,3.6Z"}),jsxRuntimeExports.jsx("path",{stroke:a,strokeWidth:"4",fill:p,d:"m194.86,79.1c-.9,1.6-1.9,3.1-3,4.6-1.4,2-1.2,3.3-3.6,3.1-.8-.1-.9-.6-1.1-1.1-6.1-12.8-22.3-17.6-35.3-17.4-10.7.1-21.5,2.5-31.2,7-15.4,7.2-28.3,19.7-35.9,34.9-3.6,6.5-7.1,12.7-9.9,19.6-2.6,6.3-4.9,12.7-6.5,19.2-2.6,10.6-3.3,21.9-.3,32.4,2.4,8.4,7.4,16.3,14.5,21.4,2.1,1.6,7.4,2.2,7.3,4.1-.2,2-5.2,4.7-6.6,5.9-3.3,2.8-6.9,5.3-11,6.7-6.9,2.4-15.4,1.5-20.9-3.7-1.6-1.5-4.8-6.6-6.8-7.2-3-1-7,3-9.4,4.4-5.4,3.4-12.1,4.5-18.3,3-7.1-1.7-11.6-7.5-16.5-12.5.2-.3.3-.6.5-.8-.2-.2-.4-.4-.6-.6,9.3-6.9,18.7-12.5,25-22.5,5.1-8,8.3-17.3,9.1-26.8.8-10.2,3-20.1,6-29.9,9.3-30.7,25.6-58.8,53.5-76,11.2-6.9,23.8-11.6,36.8-13.4,5.9-.8,11.6-.6,17.3-2.9,6-2.4,11.3-6.3,16.1-10.6,4.7-4.3,8-10.3,12.4-15,1.2-1.3,4-5,6.1-5,3.1.1,6.3,6,7.9,8.2,3.1,4.3,5,8.8,5.1,14.3.1,7.2-3.6,15.4-9.2,20,5.1,5.5,10.6,10.7,12.4,18.3,1.5,6.8-.6,12.8-3.9,18.3Z"}),jsxRuntimeExports.jsx("path",{stroke:a,strokeWidth:"4",fill:p,d:"m187.06,433.9c-.2,2.2,3,4.4,4,6,3,4.6,4.5,10.2,4.2,15.7-.3,5.6-2.6,11.1-6.2,15.4-2.1,2.4-6.6,8-9.3,5.1-2.4-2.5-4.3-5.8-6.6-8.4-6.3-7.6-12.8-14.9-22-18.9-6.9-3-14.4-4.5-21.8-5.9-5.7-1.1-11.4-2.3-17.2-3.4-4.7-.9-8-2.8-12.1-5.3-7.7-4.6-14.8-10.1-21.3-16.3-13.1-12.4-23.6-27.4-31.1-43.8-1.7-3.6-3.2-7.3-4.5-11-1.1-3.1-3.5-7.5-3.5-10.8-2.4-8.5-4-17.2-4.7-26-.6-7.7-3.3-15.7-6.4-22.7-2.6-5.9-6.2-11.5-10.7-16.1-2.2-2.3-4.7-4.4-7.4-6.1-2.5-1.6-6.4-2.3-8.6-3.9-8.2-5.9,13.1-16,17.6-16.6,10-1.4,16.7,3.4,24.3,8.8,4.3-7.9,13.2-13.2,22.2-13,6.6.1,13.1,3.1,17.7,7.9,1.3,1.4,5.6,4.5,5.1,6.6-.5,2.3-5,3.7-6.8,4.5-3.1,1.5-5.1,2.7-7.3,5.4-5.2,6.4-7.9,14.7-8.5,22.8-1.2,15.9,3.5,32.3,9.6,46.8,3,7.1,6.6,13.8,11,20.1,12.4,18,29,31.6,50.2,37.5,7.6,2.1,15.8,2.4,23.5.6,7.8-1.7,15.1-5.5,21.1-10.7,2.1-1.9,5.9-7.9,8.7-6.8,2,.8,4.9,6.2,5.9,8.1,2.2,4.4,3.2,9.3,2.7,14.2-.5,5.5-2.8,10.7-6.4,14.8-1.2,1.4-5.1,3.5-5.4,5.2,0,.1,0,.2,0,.2Z"}),jsxRuntimeExports.jsx("path",{stroke:a,strokeWidth:"4",fill:p,d:"m333.06,43.8c.2.1.4.2.6.3,15.1,9,28.1,21.2,38.3,35.4,6.7,9.4,11.9,19.5,16,30.3,4.6,12.1,6,24.7,8.4,37.3,2.1,11,4.7,22.1,10.1,31.9,3.8,6.8,9,13,15.6,17.3,2.1,1.3,8.6,3.1,9.4,5.5,1,3-3.9,7.2-5.9,8.9-3.6,3-7.9,5.1-12.5,5.8-8.7,1.3-18.6-2.5-24.5-8.9-5.2,7.6-12.4,13.1-22,13.1-10.1,0-15.9-6-22.6-12.6-2.9-2.8,2.9-4.2,4.9-5.4,2.8-1.8,5.5-3.8,7.8-6.2,4.6-4.9,7.5-11,8.7-17.7,1.8-9.7.4-19.7-1.9-29.2-8.3-34.4-29.6-69.7-65.7-79.7-10.2-2.8-21.2-2.9-31.3.1-8.4,2.5-20.1,7.9-22.6,16.8-.2.6-1.3.4-1.6-.2-4.2-8.1-10.1-13.2-9.1-23.4.6-5.9,3.3-11.6,7.6-15.8,1.9-1.9,4.9-2.7,4.5-5.6-.3-2.2-3.6-3.8-4.7-5.6-2.5-4.2-3.9-9-3.7-13.9.2-4.4,1.6-8.7,3.9-12.5,1.8-2.9,4.2-6.6,7.3-8.3,5.7-3.1,6.7,3,9.4,6.9,6.1,8.7,14.9,15.2,24.5,19.6,16.2,7.5,35.4,6.7,51.1,15.8Z"}),jsxRuntimeExports.jsx("path",{stroke:a,strokeWidth:"4",fill:p,d:"m29.86,226.1c2.9-2.8,6.7-4.6,10.8-4.9,8.5-.5,14.9,4.1,17.3,11.9,1.5,4.8.9,10.4-1.9,14.6-4.3,6.5-13.3,9.4-20.5,6.6-7.3-2.8-12-11-10.8-18.7.5-3.5,2.4-6.9,5.1-9.5Z"}),jsxRuntimeExports.jsx("path",{stroke:a,strokeWidth:"4",fill:p,d:"m397.86,223.7c7.6,4.6,10.6,16.2,5.8,23.8-4.6,7.3-15.4,10-22.9,5.7-7.6-4.3-10.8-14.9-6.8-22.6,3.7-7.3,12.9-10.8,20.8-8.4,1,.5,2.1.9,3.1,1.5Z"}),jsxRuntimeExports.jsx("path",{stroke:a,strokeWidth:"4",fill:p,d:"m232.96,42.5c-.3,2.2-1.1,4.3-2.3,6.2-4.5,7.1-14.8,9.9-22.3,6s-11.1-13.9-7.9-21.7c5.7-13.9,26.6-13.6,31.6.7,1,2.8,1.3,5.8.9,8.8Z"}),jsxRuntimeExports.jsx("path",{stroke:a,strokeWidth:"4",fill:p,d:"m205.66,422.8c11.2-9.5,29.5.6,27.1,16.3-.6,4.1-2.9,7.8-6,10.5-4.1,3.6-9.3,5.4-14.7,3.8-11.3-3.3-16.2-17.7-9.4-27.2.9-1.3,1.9-2.5,3-3.4Z"})]})})]})};const CarterSvgContainer=({stroke:s,fill:a})=>jsxRuntimeExports.jsxs("svg",{id:"appl-frame","data-name":"appl-frame",xmlns:"http://www.w3.org/2000/svg",viewBox:"0 -4059 674.28161 683.9757",stroke:s,children:[jsxRuntimeExports.jsx("defs",{children:jsxRuntimeExports.jsx("pattern",{id:"carterImg1",patternUnits:"userSpaceOnUse",width:900,height:900,children:jsxRuntimeExports.jsx("image",{href:a,x:"0",y:"0",width:900,height:900})})}),jsxRuntimeExports.jsxs("g",{transform:"matrix(0.53856355,0,0,0.53856355,-880.5514,-1872.9706)",children:[jsxRuntimeExports.jsx("polyline",{points:"2422,-3997 2611,-3997 2611,-3912 2573,-3912 2573,-3946 2528,-3946 2528,-3856 2666,-3856 2666,-4059 2422,-4059 2074,-4059 1855,-4059 1855,-3856 1994,-3856 1994,-3946 1952,-3946 1952,-3912 1914,-3912 1914,-3997 2074,-3997 2422,-3997",stroke:s,strokeWidth:"6",fill:a.startsWith("#")?a:"url(#carterImg1)"}),jsxRuntimeExports.jsx("polyline",{points:"2422,-2851 2611,-2851 2611,-2936 2573,-2936 2573,-2902 2528,-2902 2528,-2991 2666,-2991 2666,-2789 2422,-2789 2074,-2789 1855,-2789 1855,-2991 1994,-2991 1994,-2902 1952,-2902 1952,-2936 1914,-2936 1914,-2851 2074,-2851 2422,-2851",stroke:s,strokeWidth:"6",fill:a.startsWith("#")?a:"url(#carterImg1)"}),jsxRuntimeExports.jsx("polyline",{points:"2826,-3264 2825,-3075 2740,-3075 2740,-3113 2774,-3113 2774,-3158 2685,-3158 2685,-3019 2887,-3019 2887,-3264 2887,-3612 2887,-3831 2685,-3831 2685,-3691 2774,-3691 2774,-3733 2740,-3733 2740,-3771 2825,-3771 2825,-3612 2826,-3264",stroke:s,strokeWidth:"6",fill:a.startsWith("#")?a:"url(#carterImg1)"}),jsxRuntimeExports.jsx("polyline",{points:"1696,-3264 1696,-3075 1782,-3075 1782,-3113 1747,-3113 1747,-3158 1837,-3158 1837,-3019 1635,-3019 1635,-3264 1635,-3612 1635,-3831 1837,-3831 1837,-3691 1747,-3691 1747,-3733 1782,-3733 1782,-3771 1696,-3771 1696,-3612 1696,-3264",stroke:s,strokeWidth:"6",fill:a.startsWith("#")?a:"url(#carterImg1)"})]})]});const CarterBadge=({elClass:s})=>jsxRuntimeExports.jsxs("svg",{className:s,viewBox:"-300 -300 600 600",xmlns:"http://www.w3.org/2000/svg",children:[jsxRuntimeExports.jsx("path",{fillRule:"evenodd",strokeLinejoin:"miter",strokeWidth:"6",stroke:"#14334C",fill:"#A7CFE9",d:"M 65.92,-234.61 L 143.31,-234.61 L 143.31,-199.81 L 127.75,-199.81 L 127.75,-213.73 L 109.32,-213.73 L 109.32,-176.88 L 165.83,-176.88 L 165.83,-260.00 L 65.92,-260.00 L -76.57,-260.00 L -166.24,-260.00 L -166.24,-176.88 L -109.32,-176.88 L -109.32,-213.73 L -126.52,-213.73 L -126.52,-199.81 L -142.08,-199.81 L -142.08,-234.61 L -76.57,-234.61 L 65.92,-234.61 Z M 65.92,234.61 L 143.31,234.61 L 143.31,199.81 L 127.75,199.81 L 127.75,213.73 L 109.32,213.73 L 109.32,177.29 L 165.83,177.29 L 165.83,260.00 L 65.92,260.00 L -76.57,260.00 L -166.24,260.00 L -166.24,177.29 L -109.32,177.29 L -109.32,213.73 L -126.52,213.73 L -126.52,199.81 L -142.08,199.81 L -142.08,234.61 L -76.57,234.61 L 65.92,234.61 Z M 231.34,65.51 L 230.93,142.90 L 196.13,142.90 L 196.13,127.34 L 210.05,127.34 L 210.05,108.91 L 173.61,108.91 L 173.61,165.83 L 256.31,165.83 L 256.31,65.51 L 256.31,-76.98 L 256.31,-166.65 L 173.61,-166.65 L 173.61,-109.32 L 210.05,-109.32 L 210.05,-126.52 L 196.13,-126.52 L 196.13,-142.08 L 230.93,-142.08 L 230.93,-76.98 L 231.34,65.51 Z M -231.34,65.51 L -231.34,142.90 L -196.13,142.90 L -196.13,127.34 L -210.46,127.34 L -210.46,108.91 L -173.61,108.91 L -173.61,165.83 L -256.31,165.83 L -256.31,65.51 L -256.31,-76.98 L -256.31,-166.65 L -173.61,-166.65 L -173.61,-109.32 L -210.46,-109.32 L -210.46,-126.52 L -196.13,-126.52 L -196.13,-142.08 L -231.34,-142.08 L -231.34,-76.98 L -231.34,65.51 Z"}),jsxRuntimeExports.jsx("path",{strokeWidth:"9.965217391304348",stroke:"#14334C",fill:"#A7CFE9",transform:"translate(-95,0) scale(0.6020942408376964,-0.6020942408376964) translate(-92.5,-351.0)",d:"M64 360H120V512H64ZM150 542V160H116V332H69V160H35V542Z"}),jsxRuntimeExports.jsx("path",{strokeWidth:"6.670588235294118",stroke:"#14334C",fill:"#A7CFE9",transform:"translate(0,0) scale(0.8994708994708994,-0.8994708994708994) translate(-91.0,-348.0)",d:"M147 537V402H117V508H66V189H117V294H147V159H35V537Z"}),jsxRuntimeExports.jsx("path",{strokeWidth:"9.88695652173913",stroke:"#14334C",fill:"#A7CFE9",transform:"translate(95,0) scale(0.6068601583113457,-0.6068601583113457) translate(-91.0,-348.5)",d:"M64 189 117 188V282L78 331H64ZM65 359 80 358 109 395Q111 398 112.5 401.5Q114 405 116 409Q118 414 118.0 422.5Q118 431 118 432V436L117 507H65ZM146 537 147 435Q147 427 146.0 415.5Q145 404 142 400Q140 395 137.0 390.5Q134 386 132 383L104 346L146 294V160L35 159V538Z"})]});const GradyBadge=({elClass:C})=>jsxRuntimeExports.jsx("img",{className:C,src:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/ACB_Grady_monogram_all_navy.svg?v=1784848709",alt:"Grady"});const WesleyBadge=({elClass:C})=>jsxRuntimeExports.jsx("img",{className:C,src:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Wesley_guest_personlizer_tile.svg?v=1785960158",alt:"Wesley"});const HighlandBadge=({elClass:C})=>jsxRuntimeExports.jsx("img",{className:C,src:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/WEEZIE_Highland.svg?v=1786644601",alt:"Highland"});const AnsleyBadge=({elClass:C})=>jsxRuntimeExports.jsx("img",{className:C,src:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/W_Ansley_no_frame_TTF_navy.svg?v=1785171125",alt:"Ansley"});const AnsleyVineBadge=({elClass:C})=>jsxRuntimeExports.jsx("img",{className:C,src:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/W_Ansley_with_frame_TTF_navy.svg?v=1785171124",alt:"Ansley Vine"});const HudsonBadge=({elClass:s})=>jsxRuntimeExports.jsxs("svg",{className:s,viewBox:"0 0 48 39",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[jsxRuntimeExports.jsxs("g",{clipPath:"url(#clipHudson)",children:[jsxRuntimeExports.jsx("rect",{width:"47",height:"38",transform:"translate(0.5 0.5)",fill:"white"}),jsxRuntimeExports.jsx("path",{d:"M40.8898 16.5278C41.0932 16.2643 41.2458 15.9698 41.3475 15.6521C41.4492 15.3344 41.5 14.9856 41.5 14.6137V9.98725C41.5 9.74701 41.4782 9.51453 41.4274 9.29755C41.3765 9.07281 41.3039 8.86358 41.2022 8.65434C41.1005 8.45286 40.977 8.25137 40.8245 8.06539C40.6719 7.8794 40.4976 7.69341 40.2869 7.52293C40.0835 7.35244 39.8656 7.2052 39.6477 7.07346C39.4225 6.94172 39.1901 6.84098 38.9431 6.75573C38.6961 6.67049 38.4419 6.60849 38.1731 6.562C37.9044 6.5155 37.6283 6.5 37.345 6.5H32.5V7.46093H33.3644V29.5468H32.5V30.5H37.3305C37.6211 30.5 37.8971 30.4768 38.1586 30.438C38.4274 30.3915 38.6816 30.3295 38.9286 30.2443C39.1755 30.159 39.408 30.0505 39.6332 29.9265C39.8584 29.7948 40.069 29.6476 40.2724 29.4771C40.4758 29.3066 40.6574 29.1206 40.8099 28.9346C40.9625 28.7486 41.086 28.5471 41.1877 28.3379C41.2893 28.1287 41.362 27.9194 41.4128 27.6947C41.4637 27.47 41.4855 27.2375 41.4855 26.9973V20.9992C41.4855 20.635 41.4346 20.294 41.3329 19.9763C41.2312 19.6585 41.0787 19.3718 40.8753 19.1006C40.6719 18.8371 40.4177 18.5891 40.1199 18.3721C39.8148 18.1551 39.4661 17.9614 39.0593 17.7987C39.4661 17.6437 39.8148 17.4577 40.1199 17.2485C40.4322 17.0315 40.6864 16.7912 40.8898 16.5278ZM38.7252 28.1674C38.7252 28.2604 38.7179 28.3534 38.6961 28.4387C38.6816 28.5239 38.6525 28.6091 38.6162 28.6944C38.5799 28.7719 38.5363 28.8494 38.4855 28.9269C38.4346 29.0044 38.3765 29.0741 38.3039 29.1361C38.2385 29.2058 38.1659 29.2601 38.0932 29.3143C38.0206 29.3608 37.9407 29.4073 37.8608 29.4383C37.7809 29.4693 37.6937 29.5003 37.6065 29.5158C37.5194 29.5313 37.4249 29.5391 37.3305 29.5391H36.1247V18.1087H37.3305C37.4249 18.1087 37.5194 18.1164 37.6065 18.1319C37.6937 18.1474 37.7809 18.1706 37.8608 18.2094C37.9407 18.2404 38.0206 18.2869 38.0932 18.3334C38.1659 18.3799 38.2385 18.4419 38.3039 18.5116C38.3692 18.5814 38.4346 18.6511 38.4855 18.7209C38.5363 18.7984 38.5799 18.8758 38.6162 18.9533C38.6525 19.0308 38.6743 19.1083 38.6889 19.1936C38.6961 19.2556 38.7034 19.3253 38.7107 19.3873C38.7107 19.4183 38.7179 19.4493 38.7179 19.4803V28.1674H38.7252ZM38.7252 16.1248C38.7252 16.2178 38.7179 16.3108 38.6961 16.396C38.6816 16.4813 38.6525 16.5665 38.6162 16.6518C38.5799 16.7293 38.5363 16.8067 38.4855 16.8842C38.4346 16.9617 38.3765 17.0315 38.3039 17.0935C38.2385 17.1632 38.1659 17.2175 38.0932 17.2717C38.0206 17.3182 37.9407 17.3647 37.8608 17.3957C37.7809 17.4267 37.6937 17.45 37.6065 17.4732C37.5194 17.4887 37.4249 17.4964 37.3305 17.4964H36.1247V7.45318L37.3305 7.46093C37.4249 7.46093 37.5194 7.46868 37.6065 7.48418C37.6937 7.49968 37.7809 7.52293 37.8608 7.56167C37.9407 7.59267 38.0206 7.63917 38.0932 7.68566C38.1659 7.73216 38.2385 7.79416 38.3039 7.8639C38.3692 7.93365 38.4346 8.00339 38.4855 8.07314C38.5363 8.15063 38.5799 8.22812 38.6162 8.30562C38.6525 8.38311 38.6743 8.46836 38.6961 8.56135C38.7107 8.64659 38.7252 8.73184 38.7252 8.83258V16.1248Z",fill:"#14334C"}),jsxRuntimeExports.jsx("path",{d:"M29.7508 12.4841V7.23981C29.7508 6.91401 29.7193 6.59873 29.6459 6.29395C29.5725 5.98917 29.4676 5.70541 29.3207 5.42166C29.1739 5.1379 28.9956 4.87516 28.7753 4.62293C28.555 4.3707 28.3033 4.11847 27.9991 3.88726C27.7054 3.65605 27.4012 3.45637 27.0761 3.27771C26.7509 3.09904 26.4153 2.96242 26.0587 2.84682C25.702 2.73121 25.3349 2.64713 24.9468 2.58408C24.5588 2.52102 24.1602 2.5 23.7511 2.5C23.342 2.5 22.9435 2.53153 22.5659 2.58408C22.1883 2.63662 21.8211 2.73121 21.4645 2.84682C21.1079 2.96242 20.7723 3.10955 20.4471 3.27771C20.1219 3.45637 19.8178 3.65605 19.5136 3.88726C19.2199 4.11847 18.9577 4.36019 18.7374 4.62293C18.5171 4.87516 18.3283 5.14841 18.1815 5.42166C18.0346 5.70541 17.9193 5.98917 17.8458 6.29395C17.7724 6.59873 17.7305 6.91401 17.7305 7.23981V30.7602C17.7305 31.086 17.7724 31.4013 17.8458 31.7061C17.9193 32.0108 18.0346 32.2946 18.1815 32.5783C18.3283 32.8621 18.5171 33.1248 18.7374 33.3771C18.9577 33.6293 19.2199 33.8815 19.5136 34.1127C19.8073 34.3439 20.1219 34.5541 20.4471 34.7223C20.7723 34.901 21.1079 35.0376 21.4645 35.1532C21.8211 35.2688 22.1883 35.3529 22.5659 35.4159C22.9435 35.479 23.342 35.5 23.7511 35.5C24.1707 35.5 24.5692 35.4685 24.9468 35.4159C25.3349 35.3634 25.702 35.2688 26.0587 35.1532C26.4153 35.0376 26.7509 34.8904 27.0761 34.7223C27.4012 34.5436 27.7054 34.3439 27.9991 34.1127C28.2928 33.8815 28.555 33.6293 28.7753 33.3771C28.9956 33.1248 29.1739 32.8516 29.3207 32.5678C29.4676 32.2841 29.5725 32.0003 29.6459 31.6955C29.7193 31.3908 29.7508 31.0755 29.7508 30.7497V25.5054H25.744V32.799C25.744 32.9252 25.7335 33.0513 25.7125 33.1669C25.6916 33.2825 25.6496 33.3981 25.6076 33.5137C25.5552 33.6188 25.5028 33.7239 25.4293 33.829C25.3559 33.9341 25.272 34.0287 25.1776 34.1127C25.0832 34.2073 24.9783 34.2809 24.8734 34.3545C24.7685 34.4175 24.6532 34.4806 24.5378 34.5226C24.4224 34.5646 24.2965 34.6067 24.1707 34.6277C24.0448 34.6487 23.9084 34.6592 23.7721 34.6592C23.6357 34.6592 23.4994 34.6487 23.3735 34.6277C23.2476 34.6067 23.1218 34.5752 23.0064 34.5226C22.891 34.4806 22.7756 34.4175 22.6707 34.3545C22.5659 34.2914 22.461 34.2073 22.3561 34.1127C22.2617 34.0182 22.1778 33.9236 22.1043 33.829C22.0309 33.7239 21.968 33.6188 21.926 33.5137C21.8736 33.4086 21.8421 33.293 21.8211 33.1669C21.8002 33.0513 21.7897 32.9252 21.7897 32.799V5.19045C21.7897 5.06433 21.8002 4.93822 21.8211 4.82261C21.8421 4.70701 21.8841 4.5914 21.926 4.4758C21.9785 4.3707 22.0309 4.26561 22.1043 4.16051C22.1778 4.05541 22.2617 3.96083 22.3561 3.87675C22.4505 3.78217 22.5554 3.7086 22.6707 3.63503C22.7756 3.57197 22.891 3.50892 23.0064 3.46688C23.1218 3.42484 23.2476 3.39331 23.3735 3.36178C23.4994 3.34076 23.6357 3.33025 23.7721 3.33025C23.9084 3.33025 24.0448 3.34076 24.1707 3.36178C24.2965 3.3828 24.4224 3.41433 24.5378 3.46688C24.6532 3.50892 24.7685 3.57197 24.8734 3.63503C24.9783 3.69809 25.0832 3.78217 25.1881 3.87675C25.2825 3.97134 25.3769 4.06592 25.4398 4.16051C25.5132 4.26561 25.5762 4.3707 25.6181 4.4758C25.6706 4.58089 25.702 4.6965 25.723 4.82261C25.744 4.93822 25.7545 5.06433 25.7545 5.19045V12.4841H29.7508V12.4841Z",fill:"#14334C"}),jsxRuntimeExports.jsx("path",{d:"M14.6476 29.5566L14.1077 23.85L13.5608 18.0666L13.0067 12.2833L12.4526 6.5H9.70363L9.11405 12.2833L8.52447 18.0666L7.93489 23.85L7.35241 29.5566H6.5V29.6333V30.2469V30.5H9.05012V30.2469V29.6333V29.5566H8.21192L8.3753 27.9151L8.54578 26.197L8.71626 24.4789L8.84412 23.152H11.3516L11.4724 24.4789L11.6287 26.197L11.7849 27.9151L11.9341 29.5566H11.0817V30.5H15.5V30.2469V29.6333V29.5566H14.6476ZM9.2277 18.9564L9.54025 15.7426L9.8528 12.5288L10.1654 9.31496L10.4495 12.5288L10.7336 15.7426L11.0178 18.9564L11.3019 22.1702H8.91515L9.2277 18.9564Z",fill:"#14334C"})]}),jsxRuntimeExports.jsx("defs",{children:jsxRuntimeExports.jsx("clipPath",{id:"clipHudson",children:jsxRuntimeExports.jsx("rect",{width:"47",height:"38",fill:"white",transform:"translate(0.5 0.5)"})})})]});const ArdsleyBadge=({elClass:s})=>jsxRuntimeExports.jsxs("svg",{className:s,viewBox:"0 0 48 39",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[jsxRuntimeExports.jsx("rect",{width:"47",height:"38",transform:"translate(0.5 0.5)",fill:"white"}),jsxRuntimeExports.jsx("g",{clipPath:"url(#clipArdsley)",children:jsxRuntimeExports.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M14.9822 15.3697C14.9822 15.3697 16.8228 7.7263 13.2931 7.26274C10.6622 6.90698 9.39539 10.2705 8.97313 12.2973C8.57253 14.1946 8.71328 16.1351 8.9623 18.0325C8.9623 18.0325 6.17974 19.9083 6.58034 23.3581C6.67779 24.2098 6.93764 25.2231 7.56561 25.8484C8.07448 26.3551 9.2005 26.5491 9.8393 26.064C10.8137 25.3202 10.7055 23.6707 10.5864 22.625C10.1858 19.2507 10.0125 17.8816 10.0125 17.8816C10.0125 17.8816 12.1455 16.0489 13.553 16.1244C13.4014 16.1136 12.6868 19.3154 12.6327 19.5418C11.9506 22.2693 11.4092 25.0614 11.485 27.8752C11.5175 29.0287 11.6041 30.3008 12.4703 31.1632C12.925 31.616 13.6937 31.9502 14.3434 31.713C15.242 31.3896 15.5668 30.3655 15.6318 29.503C15.7184 28.2525 15.2528 27.1852 14.7223 26.0856C14.679 26.0101 14.6465 25.9239 14.5816 25.87C14.5166 25.8161 14.4192 25.7837 14.3325 25.8268C14.2026 25.8915 14.2243 26.0856 14.2568 26.2257C14.5166 27.2068 14.7873 28.2094 14.744 29.2335C14.7331 29.6324 14.6357 30.0852 14.2892 30.29C14.0186 30.4517 13.6613 30.4194 13.4014 30.2469C13.1416 30.0744 12.9575 29.7941 12.8601 29.503C12.676 28.964 12.6435 28.3495 12.6219 27.7889C12.5677 26.4629 12.7301 25.1477 12.9792 23.8432C13.0225 23.6168 13.4122 21.0942 13.4772 21.0942C14.3759 21.0834 15.4477 20.6522 16.0974 20.0593C17.6132 18.6793 16.8877 15.9411 14.9822 15.3697ZM8.7999 25.277C8.5617 25.277 8.34516 25.1369 8.19358 24.9644C8.042 24.7919 7.95538 24.5547 7.87959 24.3284C7.50065 23.0886 7.46816 21.7841 7.98786 20.5767C8.17193 20.1563 8.39929 19.7574 8.6808 19.3909C8.72411 19.337 9.04892 19.0351 9.03809 18.9812C9.10306 19.5418 9.16802 20.0916 9.23298 20.6522C9.34125 21.644 9.51449 22.6681 9.51449 23.6707C9.50366 24.1666 9.54697 25.277 8.7999 25.277ZM9.81765 17.0623C9.81765 17.0623 9.11388 11.6396 11.6366 9.10621C14.1485 6.57278 14.0727 11.0791 14.0727 11.0791C14.0727 11.0791 13.9861 13.3861 13.7046 15.1433C13.7046 15.1433 11.3876 15.2835 9.81765 17.0623ZM15.8483 18.6793C15.4369 20.2856 13.7912 20.0593 13.7912 20.0593C13.9536 18.895 14.7656 16.3615 14.7656 16.3615C15.3503 16.4046 15.6426 16.8574 15.7942 17.2671C15.9566 17.7091 15.9674 18.205 15.8483 18.6793Z",fill:"#14334C"})}),jsxRuntimeExports.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M28.9132 22.1767C27.2658 20.2548 25.6642 20.2243 24.4744 20.6819C23.1321 21.2005 22.1864 22.4208 21.9424 23.8393C21.4695 26.4629 23.1169 27.7137 23.9863 28.1866C24.2609 28.3239 24.5965 28.2018 24.7033 27.9273C24.81 27.6832 24.7185 27.3934 24.4744 27.2714C23.0711 26.5239 23.0711 24.8918 23.0711 24.8918C23.0101 20.9717 26.4727 21.7649 26.4727 21.7649C26.4727 21.7649 29.7674 22.6801 28.7454 28.5832C27.7234 34.4863 25.1151 34.8829 24.4897 35.1727C23.8643 35.4625 20.6306 35.0659 19.0442 29.4984C17.4578 23.9309 19.273 16.838 19.273 16.838C19.5323 17.1583 22.3085 19.4768 26.5184 16.1973C30.7284 12.9178 30.1335 6.46562 30.1335 6.46562C30.1335 6.46562 29.5691 1.27944 24.9626 3.00308C20.356 4.72672 18.6324 13.467 18.6324 13.467C17.7019 10.9349 19.1662 8.20452 19.7611 7.36558C19.8984 7.16728 19.8679 6.89272 19.6696 6.74018C19.4713 6.58765 19.1967 6.61816 19.029 6.8012C15.9478 10.462 18.1137 15.1754 18.1137 15.1754C17.229 17.921 17.046 23.8088 17.046 23.8088C17.046 23.8088 16.863 31.4508 21.256 35.1117C25.649 38.7725 28.7607 32.9914 28.7607 32.9914C28.7607 32.9914 32.208 26.0206 28.9132 22.1767ZM23.544 5.55041C24.2914 4.65046 25.3744 4.07082 26.5337 3.9793C27.6929 3.90304 28.9895 4.28437 28.9895 6.45037C28.9895 10.3705 27.0065 13.772 27.0065 13.772C27.0065 13.772 23.8185 19.0345 19.6543 15.4499C19.6543 15.4499 20.7526 8.87567 23.544 5.55041Z",fill:"#14334C"}),jsxRuntimeExports.jsx("g",{clipPath:"url(#clip1)",children:jsxRuntimeExports.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M41.3444 21.031C41.0367 20.1626 40.5989 19.3538 40.0427 18.6281C40.0072 18.5806 39.3445 17.8074 39.3209 17.8312C39.593 17.5457 39.7587 17.1412 39.9007 16.7844C40.6344 14.9644 40.9184 12.4426 40.3977 10.5394C40.2557 10.0517 40.0427 9.58776 39.7705 9.17143C38.8949 7.86295 37.4631 6.97081 35.9484 6.79238C35.0964 6.69722 34.2326 6.82806 33.4161 7.2325C31.724 8.07706 30.7063 9.95651 30.6353 11.8122C30.4815 16.4037 35.0018 16.3562 35.0018 16.3562C35.0018 16.3562 32.3275 16.4037 31.9488 18.7828C31.582 21.1618 35.0018 21.2689 35.0018 21.2689C35.2621 24.2308 34.7414 25.7653 34.7414 25.7653C33.5463 25.6582 32.363 26.0984 31.866 27.2522C31.3926 28.3347 31.5465 29.8216 32.3275 30.7137C32.4576 30.8684 32.6115 30.9992 32.7653 31.1182C34.0314 32.046 36.2206 31.9151 37.6051 31.3085C41.1787 29.7264 42.5513 24.4925 41.3444 21.031ZM34.9899 20.3411C34.9899 20.3411 32.3038 20.1507 33.0256 18.3665C33.0256 18.3665 33.6764 17.165 34.9899 17.4029V20.3411ZM36.1851 16.1658C37.9364 15.4759 38.1494 13.9771 38.1612 13.311C38.1612 13.1206 38.0074 12.966 37.8299 12.966C37.6761 12.966 37.5459 13.0612 37.5104 13.2039C37.0962 14.6432 36.2442 15.1666 36.2442 15.1666L36.3507 8.08896C41.9123 9.40933 38.6819 17.3316 38.6819 17.3316C38.0666 16.4394 36.1851 16.4394 36.1851 16.4394V16.1658ZM36.1851 17.4029C37.4512 17.6289 38.0311 18.4021 38.0311 18.4021C37.6051 19.33 36.1496 20.0675 36.1496 20.0675L36.1851 17.4029ZM32.1736 10.1706C32.6115 9.12385 33.5344 7.93432 35.4869 8.01759L35.2739 15.3094C35.2739 15.3094 33.0256 15.7138 32.1263 13.192C31.7713 12.2166 31.7713 11.1341 32.1736 10.1706ZM33.3806 30.1903C33.3806 30.1903 31.9961 28.8818 32.9191 27.5258C32.9191 27.5258 33.6054 26.479 34.6468 26.7169C34.6468 26.7169 34.7178 29.1435 33.3806 30.1903ZM34.1498 30.4639C35.3449 29.655 35.6881 26.9548 35.6881 26.9548C37.2264 27.4187 37.3447 30.0833 37.3447 30.0833C35.4869 31.0468 34.1498 30.4639 34.1498 30.4639ZM39.4865 27.9659C39.238 28.4298 38.9185 28.8818 38.5281 29.2387C38.4689 29.2863 38.0784 29.5123 38.0666 29.5837C38.0784 26.7288 35.7946 25.9556 35.7946 25.9556C36.0194 25.2181 36.1022 21.0548 36.1022 21.0548C37.9127 20.4719 38.6346 18.9255 38.6346 18.9255C39.2854 19.7225 39.877 20.6265 40.1492 21.6376C40.6699 23.5885 40.4569 26.1697 39.4865 27.9659Z",fill:"#14334C"})}),jsxRuntimeExports.jsxs("defs",{children:[jsxRuntimeExports.jsx("clipPath",{id:"clipArdsley",children:jsxRuntimeExports.jsx("rect",{width:"10.3724",height:"24.5581",fill:"white",transform:"translate(6.53613 7.2287)"})}),jsxRuntimeExports.jsx("clipPath",{id:"clip1",children:jsxRuntimeExports.jsx("rect",{width:"11.135",height:"25.0157",fill:"white",transform:"translate(30.6365 6.77026)"})})]})]});const PrinceBadge=({elClass:s})=>jsxRuntimeExports.jsxs("svg",{className:s,width:"48",height:"39",viewBox:"0 0 48 39",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[jsxRuntimeExports.jsx("rect",{width:"47",height:"38",transform:"translate(0.5 0.5)",fill:"white"}),jsxRuntimeExports.jsx("g",{clipPath:"url(#clipPrince0)",children:jsxRuntimeExports.jsx("path",{d:"M15.8703 4.65259H13.1819C12.4792 4.65259 11.9141 5.21776 11.9141 5.92041V34.4998H13.6096V20.8746H15.4273V34.4998H17.1228V5.92041C17.1381 5.21776 16.5729 4.65259 15.8703 4.65259ZM13.6096 18.5528V6.98966H15.4273V18.5528H13.6096Z",fill:"#14334C"})}),jsxRuntimeExports.jsx("g",{clipPath:"url(#clipPrince1)",children:jsxRuntimeExports.jsx("path",{d:"M27.0512 18.0487V6.24118C27.0512 5.35524 26.3485 4.65259 25.4779 4.65259H21.7202L21.8424 34.4387H25.4626C26.3333 34.4387 27.0512 33.7361 27.0512 32.8502V20.9968C27.0512 20.6607 26.9137 20.3247 26.6693 20.0956L26.2874 19.7137L26.8831 18.6903C26.9901 18.507 27.0512 18.2778 27.0512 18.0487ZM25.1876 32.2392H23.6449V20.7677H25.1876V32.2392ZM25.1876 18.4611H23.6449V6.97438H25.1876V18.4611Z",fill:"#14334C"})}),jsxRuntimeExports.jsx("g",{clipPath:"url(#clipPrince2)",children:jsxRuntimeExports.jsx("path",{d:"M35.299 4.5H33.4202C32.4274 4.5 31.6331 5.2943 31.6331 6.28717V32.667C31.6331 33.6446 32.4274 34.4542 33.4202 34.4542H35.1921C36.1697 34.4542 36.9793 33.6599 36.9793 32.667V25.5642H35.2227V32.056H33.6188V6.94399H35.0546V13.6955H37.0709V6.28717C37.0862 5.2943 36.2766 4.5 35.299 4.5Z",fill:"#14334C"})}),jsxRuntimeExports.jsx("rect",{x:"18.5789",y:"19.0792",width:"1.4579",height:"1.87444",rx:"0.728948",fill:"#14334C"}),jsxRuntimeExports.jsx("rect",{x:"28.5757",y:"19.0792",width:"1.4579",height:"1.87444",rx:"0.728948",fill:"#14334C"}),jsxRuntimeExports.jsxs("defs",{children:[jsxRuntimeExports.jsx("clipPath",{id:"clipPrince0",children:jsxRuntimeExports.jsx("rect",{width:"5.22403",height:"29.8473",fill:"white",transform:"translate(11.9141 4.65259)"})}),jsxRuntimeExports.jsx("clipPath",{id:"clipPrince1",children:jsxRuntimeExports.jsx("rect",{width:"5.33096",height:"29.7862",fill:"white",transform:"translate(21.7202 4.65259)"})}),jsxRuntimeExports.jsx("clipPath",{id:"clipPrince2",children:jsxRuntimeExports.jsx("rect",{width:"5.45316",height:"29.9542",fill:"white",transform:"translate(31.6331 4.5)"})})]})]});const CrosbyBadge=({elClass:s})=>jsxRuntimeExports.jsxs("svg",{className:s,viewBox:"0 0 48 39",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[jsxRuntimeExports.jsx("rect",{width:"47",height:"38",transform:"translate(0.5 0.5)",fill:"white"}),jsxRuntimeExports.jsx("g",{clipPath:"url(#clipCrosby0)",children:jsxRuntimeExports.jsx("path",{d:"M17.059 35.03C17.059 33.9995 17.0012 18.1841 17.059 2.88971C10.8533 5.52947 6.5 11.7352 6.5 18.9598C6.5 23.3479 8.10933 27.3538 10.7491 30.4104L13.0994 27.7012C10.4133 25.1077 9.74181 20.7081 9.74181 20.7081H13.9909V33.328C14.9519 33.9995 15.9823 34.5669 17.059 35.03ZM13.933 17.3158L9.7997 17.3737C10.2976 11.4458 13.933 8.57446 13.933 8.57446V17.3158Z",fill:"#14334C"})}),jsxRuntimeExports.jsx("path",{d:"M32.0987 3.12061L32.0872 34.9251C37.5288 32.4822 41.4768 27.33 42.241 21.1821L39.0339 18.7276L42.1368 16.1342C41.1642 10.3105 37.3088 5.47092 32.0987 3.12061ZM39.0455 22.5715C39.0455 22.5715 38.3624 26.9827 34.9122 29.5877V20.198L39.0455 22.5715ZM34.9237 17.5351V8.14542C38.374 10.7504 39.0571 15.1616 39.0571 15.1616L34.9237 17.5351Z",fill:"#14334C"}),jsxRuntimeExports.jsx("g",{clipPath:"url(#clipCrosby1)",children:jsxRuntimeExports.jsx("path",{d:"M29.8527 14.5483V2.19467C28.3013 1.74314 26.6688 1.5 24.9784 1.5C23.1723 1.5 21.4472 1.76629 19.8147 2.27572V35.7243C21.4472 36.2221 23.1723 36.5 24.9784 36.5C26.553 36.5 28.0813 36.2916 29.5286 35.898V22.2823H26.5646V32.8993H22.9407V4.49868H26.8888V14.5367H29.8527V14.5483Z",fill:"#14334C"})}),jsxRuntimeExports.jsxs("defs",{children:[jsxRuntimeExports.jsx("clipPath",{id:"clipCrosby0",children:jsxRuntimeExports.jsx("rect",{width:"10.559",height:"32.1403",fill:"white",transform:"translate(6.5 2.88971)"})}),jsxRuntimeExports.jsx("clipPath",{id:"clipCrosby1",children:jsxRuntimeExports.jsx("rect",{width:"10.038",height:"35",fill:"white",transform:"translate(19.8147 1.5)"})})]})]});const MercerBadge=({elClass:s})=>jsxRuntimeExports.jsxs("svg",{className:s,viewBox:"0 0 48 39",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[jsxRuntimeExports.jsx("rect",{width:"47",height:"38",transform:"translate(0.5 0.5)",fill:"white"}),jsxRuntimeExports.jsx("g",{clipPath:"url(#clipMercer)",children:jsxRuntimeExports.jsx("path",{d:"M38.28 34.3399H29.36C29.12 34.3399 28.8 34.3399 28.52 34.1199C28.48 34.0999 28.46 34.0799 28.44 34.0399C28.14 33.7399 28.14 33.3999 28.14 33.0999V29.9399C28.14 29.6999 28.14 29.3799 28.36 29.0999C28.38 29.0599 28.4 29.0399 28.44 29.0199C28.74 28.7199 29.08 28.7199 29.38 28.7199C29.56 28.7199 29.72 28.6999 29.84 28.6799L29.08 26.8799H19.92L19.14 28.6599C19.26 28.6799 19.42 28.6999 19.62 28.6999C19.86 28.6999 20.18 28.6999 20.48 28.9999C20.78 29.2999 20.78 29.6399 20.78 29.9399V33.0999C20.78 33.3399 20.78 33.6599 20.56 33.9399C20.54 33.9799 20.52 33.9999 20.48 34.0199C20.18 34.3199 19.86 34.3199 19.62 34.3199H10.72C10 34.3199 9.7 34.0599 9.6 33.7599C9.5 33.5199 9.5 33.2799 9.5 33.0799V29.6399C9.5 29.3999 9.5 29.0799 9.72 28.7999C9.74 28.7599 9.76 28.7399 9.8 28.7199C10.1 28.4199 10.44 28.4199 10.74 28.4199C10.98 28.4199 11.14 28.3999 11.26 28.3399L11.3 28.2999C11.44 28.2199 11.6 28.1399 11.66 28.0799C11.66 28.0599 11.68 28.0599 11.68 28.0399C11.84 27.8799 11.92 27.7999 12.02 27.6599C12.04 27.6399 12.04 27.6199 12.06 27.5999C12.06 27.5199 12.08 27.4599 12.12 27.3999L20.78 5.53988C20.88 5.25988 21 5.11988 21.1 4.99988C21.4 4.65988 21.82 4.65988 22.04 4.65988H26.9C27.14 4.65988 27.46 4.65988 27.74 4.87988C27.78 4.89988 27.8 4.91988 27.82 4.95988C27.94 5.07988 28.08 5.23988 28.18 5.53988L36.88 27.4999C36.98 27.6799 37.1 27.8999 37.36 28.1399C37.38 28.1599 37.42 28.1999 37.44 28.2199C37.52 28.3199 37.8 28.4599 38.3 28.4599C38.54 28.4599 38.86 28.4599 39.14 28.6799C39.16 28.6999 39.2 28.7199 39.22 28.7599C39.52 29.0599 39.52 29.3999 39.52 29.6999V33.1399C39.52 33.3799 39.52 33.6999 39.3 33.9799C39.28 33.9999 39.26 34.0399 39.22 34.0599C38.92 34.3399 38.56 34.3399 38.28 34.3399ZM11.16 33.3399C11.16 33.3799 11.16 33.3999 11.16 33.4399C11.16 33.4199 11.16 33.3799 11.16 33.3399ZM29.74 32.7399H37.9V30.0399C37.16 29.9799 36.58 29.6999 36.2 29.2599C35.78 28.8599 35.56 28.4799 35.42 28.1799C35.4 28.1599 35.4 28.1399 35.4 28.1199L26.78 6.25988H22.22L13.64 27.8999C13.6 28.1599 13.48 28.3799 13.34 28.5799C13.16 28.8399 13 28.9999 12.82 29.1799C12.56 29.4599 12.24 29.6199 12 29.7399L11.94 29.7599C11.68 29.8799 11.4 29.9599 11.08 29.9999V32.6999H19.16V30.2799C18.26 30.1999 17.68 29.8799 17.4 29.2999C17.3 29.0999 17.3 28.8399 17.38 28.6399L18.64 25.7799C18.76 25.4799 19.06 25.2999 19.38 25.2999H29.58C29.9 25.2999 30.2 25.4999 30.32 25.7799L31.58 28.7399C31.68 28.9799 31.66 29.2399 31.52 29.4599C31.3 29.8199 30.94 30.0799 30.48 30.1999C30.32 30.2399 30.06 30.2999 29.72 30.3199V32.7399H29.74ZM22.36 6.01988C22.34 6.01988 22.34 6.01988 22.36 6.01988C22.34 6.01988 22.34 6.01988 22.36 6.01988ZM28.42 23.0799H20.62C20.36 23.0799 20.12 22.9599 19.96 22.7399C19.8 22.5199 19.78 22.2599 19.86 22.0199L23.06 12.8999L23.7 10.1999C23.78 9.83988 24.1 9.57988 24.48 9.57988C24.84 9.57988 25.18 9.83988 25.26 10.1999L25.9 12.8599L29.16 22.0199C29.24 22.2599 29.2 22.5399 29.06 22.7399C28.92 22.9399 28.68 23.0799 28.42 23.0799ZM21.76 21.4799H27.3L24.5 13.6399L21.76 21.4799Z",fill:"#14334C"})}),jsxRuntimeExports.jsx("defs",{children:jsxRuntimeExports.jsx("clipPath",{id:"clipMercer",children:jsxRuntimeExports.jsx("rect",{width:"30",height:"30",fill:"white",transform:"translate(9.5 4.5)"})})})]});const RiverWordBadge=({elClass:s})=>jsxRuntimeExports.jsxs("svg",{className:s,viewBox:"0 0 48 39",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[jsxRuntimeExports.jsx("rect",{width:"47",height:"38",transform:"translate(0 0.5)",fill:"white"}),jsxRuntimeExports.jsx("path",{d:"M14.9484 15.184C14.3477 15.7053 13.6394 16.119 12.8234 16.425C12.0074 16.7197 11.1007 16.9123 10.1034 17.003C9.11736 17.0937 8.21636 17.0937 7.40036 17.003C6.5957 16.901 5.84203 16.697 5.13936 16.391C4.72003 17.207 4.40836 18.04 4.20436 18.89C4.00036 19.7287 3.8927 20.5163 3.88136 21.253C3.88136 21.9783 3.9777 22.63 4.17036 23.208C4.36303 23.7747 4.64636 24.194 5.02036 24.466C5.36036 24.704 5.76836 24.806 6.24436 24.772C6.72036 24.7493 7.2587 24.5737 7.85936 24.245C8.47136 23.9163 9.13436 23.4403 9.84836 22.817C10.5624 22.1823 11.3217 21.3833 12.1264 20.42C12.183 20.3407 12.2737 20.2783 12.3984 20.233C12.523 20.1877 12.6534 20.2103 12.7894 20.301C12.8914 20.3577 12.965 20.4483 13.0104 20.573C13.0557 20.6863 13.0557 20.8053 13.0104 20.93C12.8404 21.3493 12.676 21.7743 12.5174 22.205C12.37 22.6243 12.217 23.0437 12.0584 23.463C11.7637 24.2677 11.4577 25.0723 11.1404 25.877C10.8344 26.693 10.5 27.5033 10.1374 28.308C10.33 28.274 10.5114 28.2457 10.6814 28.223C10.8627 28.2003 11.0327 28.189 11.1914 28.189C11.35 28.1663 11.4747 28.2117 11.5654 28.325C11.6674 28.4383 11.7184 28.5573 11.7184 28.682C11.7184 28.818 11.673 28.937 11.5824 29.039C11.4917 29.1523 11.367 29.209 11.2084 29.209C11.0044 29.209 10.7607 29.2317 10.4774 29.277C10.194 29.3223 9.88236 29.3903 9.54236 29.481C9.4857 29.6057 9.42336 29.7247 9.35536 29.838C9.28736 29.9513 9.21936 30.0703 9.15136 30.195C9.1287 30.2517 9.10036 30.3027 9.06636 30.348C9.03236 30.4047 8.99836 30.4613 8.96436 30.518C8.7037 30.994 8.40336 31.4927 8.06336 32.014C7.82536 32.388 7.55336 32.7677 7.24736 33.153C6.9527 33.5497 6.62403 33.9067 6.26136 34.224C5.8987 34.5527 5.50203 34.8247 5.07136 35.04C4.65203 35.2553 4.1987 35.3743 3.71136 35.397H3.62636C3.37703 35.397 3.1447 35.346 2.92936 35.244C2.7027 35.1533 2.51003 35.0117 2.35136 34.819C2.17003 34.6263 2.04536 34.3997 1.97736 34.139C1.89803 33.8783 1.88103 33.612 1.92636 33.34C1.9717 33.034 2.06803 32.7507 2.21536 32.49C2.3627 32.2407 2.53836 32.0083 2.74236 31.793C2.94636 31.5777 3.16736 31.3793 3.40536 31.198C3.63203 31.028 3.8587 30.8693 4.08536 30.722C4.38003 30.5293 4.71436 30.331 5.08836 30.127C5.46236 29.9343 5.85903 29.7417 6.27836 29.549C6.6977 29.3677 7.1227 29.1977 7.55336 29.039C7.99536 28.8803 8.42603 28.7387 8.84536 28.614C9.2987 27.73 9.70103 26.8233 10.0524 25.894C10.415 24.9647 10.7607 24.041 11.0894 23.123L11.1234 23.021C10.0127 24.0977 8.97003 24.8627 7.99536 25.316C7.5647 25.52 7.16803 25.656 6.80536 25.724C6.45403 25.792 6.12536 25.8147 5.81936 25.792C5.5247 25.7693 5.25836 25.707 5.02036 25.605C4.7937 25.5143 4.59536 25.4067 4.42536 25.282C3.8927 24.8967 3.5017 24.3583 3.25236 23.667C2.9917 22.9643 2.86136 22.188 2.86136 21.338C2.85003 20.4767 2.96336 19.5757 3.20136 18.635C3.43936 17.6943 3.78503 16.782 4.23836 15.898C3.88703 15.694 3.5527 15.4447 3.23536 15.15C3.1447 15.0707 3.0937 14.963 3.08236 14.827C3.0597 14.6797 3.1107 14.5493 3.23536 14.436C3.33736 14.3227 3.45636 14.266 3.59236 14.266C3.72836 14.266 3.8417 14.3113 3.93236 14.402C4.1817 14.64 4.4537 14.844 4.74836 15.014C4.7597 14.9913 4.77103 14.9743 4.78236 14.963C4.7937 14.9517 4.80503 14.9347 4.81636 14.912C5.6437 13.5973 6.64103 12.5207 7.80836 11.682C8.98703 10.832 10.2677 10.2597 11.6504 9.965C12.0584 9.88567 12.5004 9.846 12.9764 9.846C13.4524 9.83467 13.9057 9.89133 14.3364 10.016C14.7784 10.1407 15.175 10.3447 15.5264 10.628C15.8777 10.9113 16.1327 11.3023 16.2914 11.801C16.3934 12.141 16.4217 12.4753 16.3764 12.804C16.331 13.1327 16.2404 13.4443 16.1044 13.739C15.9684 14.0223 15.7927 14.2887 15.5774 14.538C15.3734 14.7873 15.1637 15.0027 14.9484 15.184ZM11.8544 10.985C10.6077 11.2457 9.4517 11.7557 8.38636 12.515C7.32103 13.263 6.41436 14.2433 5.66636 15.456L5.64936 15.49C6.22736 15.7393 6.87336 15.9093 7.58736 16C8.30136 16.0793 9.10603 16.0737 10.0014 15.983C10.3187 15.949 10.6587 15.9037 11.0214 15.847C11.3954 15.779 11.7694 15.6883 12.1434 15.575C12.5287 15.4503 12.9027 15.2973 13.2654 15.116C13.6394 14.9233 13.985 14.691 14.3024 14.419C14.4724 14.2717 14.631 14.1073 14.7784 13.926C14.9257 13.7333 15.0447 13.535 15.1354 13.331C15.2374 13.127 15.3054 12.923 15.3394 12.719C15.3734 12.5037 15.362 12.2997 15.3054 12.107C15.2487 11.9257 15.141 11.7443 14.9824 11.563C14.835 11.3817 14.6197 11.2287 14.3364 11.104C14.0644 10.9793 13.7244 10.9 13.3164 10.866C12.9084 10.832 12.421 10.8717 11.8544 10.985ZM4.62936 31.589C4.21003 31.861 3.83603 32.15 3.50736 32.456C3.19003 32.762 3.00303 33.1133 2.94636 33.51C2.9237 33.6347 2.92936 33.7537 2.96336 33.867C2.98603 33.9917 3.03136 34.088 3.09936 34.156C3.2467 34.3147 3.4337 34.3883 3.66036 34.377C4.13636 34.3543 4.58403 34.2013 5.00336 33.918C5.4227 33.6347 5.81936 33.2777 6.19336 32.847C6.38603 32.6203 6.56736 32.388 6.73736 32.15C6.90736 31.912 7.0717 31.6683 7.23036 31.419C7.38903 31.1697 7.53636 30.926 7.67236 30.688C7.8197 30.45 7.9557 30.2233 8.08036 30.008C8.08036 29.9853 8.0917 29.9627 8.11436 29.94C7.50236 30.1553 6.89603 30.399 6.29536 30.671C5.6947 30.9543 5.13936 31.2603 4.62936 31.589ZM25.6519 20.641C25.5045 20.7317 25.3459 20.8393 25.1759 20.964C25.0059 21.0887 24.8189 21.2303 24.6149 21.389C24.0029 21.8537 23.3852 22.3127 22.7619 22.766C22.1499 23.208 21.5605 23.5877 20.9939 23.905C20.4272 24.211 19.9002 24.432 19.4129 24.568C18.9369 24.704 18.5289 24.687 18.1889 24.517C18.0075 24.4263 17.8659 24.3073 17.7639 24.16C17.6732 24.0127 17.6052 23.8483 17.5599 23.667C17.5259 23.4743 17.5202 23.2703 17.5429 23.055C17.5655 22.8397 17.6052 22.6187 17.6619 22.392C16.8685 23.174 16.1545 23.803 15.5199 24.279C14.8965 24.7437 14.3752 24.976 13.9559 24.976C13.7632 24.976 13.5932 24.9193 13.4459 24.806C13.2532 24.67 13.1172 24.5 13.0379 24.296C12.9699 24.092 12.9359 23.8767 12.9359 23.65C12.9359 23.4233 12.9642 23.1967 13.0209 22.97C13.0775 22.732 13.1399 22.5167 13.2079 22.324C13.3665 21.8933 13.5365 21.508 13.7179 21.168C13.9105 20.8167 14.0352 20.5957 14.0919 20.505C14.1599 20.3803 14.2562 20.3067 14.3809 20.284C14.5169 20.25 14.6472 20.2613 14.7719 20.318C14.9192 20.3973 15.0042 20.5107 15.0269 20.658C15.0609 20.794 15.0382 20.9243 14.9589 21.049C14.8002 21.3097 14.6415 21.593 14.4829 21.899C14.3242 22.205 14.1939 22.4997 14.0919 22.783C13.9899 23.055 13.9219 23.3043 13.8879 23.531C13.8652 23.7463 13.9162 23.8993 14.0409 23.99C14.0409 23.99 14.0579 23.99 14.0919 23.99C14.1372 23.9787 14.2165 23.939 14.3299 23.871C14.4545 23.803 14.6189 23.6897 14.8229 23.531C15.0382 23.3723 15.3272 23.14 15.6899 22.834C15.9279 22.63 16.1715 22.409 16.4209 22.171C16.6702 21.933 16.9139 21.7007 17.1519 21.474C17.3899 21.236 17.6165 21.0093 17.8319 20.794C18.0472 20.5787 18.2399 20.3803 18.4099 20.199C18.5345 20.0743 18.6422 19.9667 18.7329 19.876C18.8349 19.7853 18.9255 19.7003 19.0049 19.621C19.0955 19.519 19.2089 19.468 19.3449 19.468C19.4809 19.468 19.5999 19.5133 19.7019 19.604C19.8152 19.6947 19.8719 19.8137 19.8719 19.961C19.8719 20.097 19.8265 20.2217 19.7359 20.335C19.6679 20.4143 19.5602 20.5843 19.4129 20.845C19.2655 21.1057 19.1239 21.3947 18.9879 21.712C18.8519 22.0293 18.7385 22.3467 18.6479 22.664C18.5572 22.9813 18.5289 23.242 18.5629 23.446C18.5742 23.5027 18.5855 23.5423 18.5969 23.565C18.6082 23.5763 18.6195 23.5877 18.6309 23.599C18.8235 23.6897 19.1239 23.6557 19.5319 23.497C19.9399 23.327 20.3932 23.089 20.8919 22.783C21.4019 22.4657 21.9289 22.1143 22.4729 21.729C23.0169 21.3323 23.5269 20.9527 24.0029 20.59C24.2069 20.4313 24.3939 20.2897 24.5639 20.165C24.7452 20.029 24.9095 19.91 25.0569 19.808C25.1929 19.706 25.3232 19.6777 25.4479 19.723C25.5839 19.7683 25.6972 19.8363 25.7879 19.927C25.8559 20.0517 25.8785 20.182 25.8559 20.318C25.8445 20.4427 25.7765 20.5503 25.6519 20.641ZM32.9986 20.947C32.8626 21.0603 32.653 21.236 32.3696 21.474C32.0976 21.712 31.769 21.9783 31.3836 22.273C31.0096 22.5563 30.596 22.851 30.1426 23.157C29.6893 23.4517 29.2246 23.7237 28.7486 23.973C28.284 24.2223 27.8193 24.4263 27.3546 24.585C26.9013 24.7437 26.4706 24.823 26.0626 24.823C25.768 24.823 25.4903 24.7777 25.2296 24.687C24.9803 24.5963 24.7536 24.4433 24.5496 24.228C24.1303 23.786 23.9376 23.2137 23.9716 22.511C23.9943 21.9103 24.1303 21.3493 24.3796 20.828C24.629 20.3067 24.9633 19.8703 25.3826 19.519C25.6206 19.3037 25.921 19.128 26.2836 18.992C26.6463 18.8447 26.9976 18.8277 27.3376 18.941C27.4963 18.9977 27.655 19.1053 27.8136 19.264C27.9836 19.4113 28.1026 19.6437 28.1706 19.961C28.2273 20.2897 28.1933 20.5843 28.0686 20.845C27.9553 21.1057 27.8363 21.3153 27.7116 21.474C27.3943 21.8707 26.992 22.1993 26.5046 22.46C26.0286 22.7207 25.5356 22.8963 25.0256 22.987C25.071 23.2023 25.1616 23.3837 25.2976 23.531C25.3543 23.5877 25.445 23.65 25.5696 23.718C25.6943 23.7747 25.8643 23.803 26.0796 23.803C26.3063 23.7917 26.5896 23.7407 26.9296 23.65C27.2696 23.5593 27.6776 23.3893 28.1536 23.14C28.5616 22.936 28.964 22.7037 29.3606 22.443C29.7686 22.1823 30.154 21.9217 30.5166 21.661C30.8793 21.389 31.208 21.1283 31.5026 20.879C31.8086 20.6297 32.0693 20.4087 32.2846 20.216C32.4093 20.0687 32.5453 20.0177 32.6926 20.063C32.84 20.097 32.9476 20.1537 33.0156 20.233C33.1403 20.3463 33.1913 20.4767 33.1686 20.624C33.146 20.76 33.0893 20.8677 32.9986 20.947ZM26.9806 19.893H26.9126C26.788 19.893 26.6463 19.9327 26.4876 20.012C26.329 20.08 26.1816 20.1707 26.0456 20.284C25.5923 20.692 25.275 21.2417 25.0936 21.933C25.1843 21.9103 25.275 21.8877 25.3656 21.865C25.4563 21.831 25.547 21.7913 25.6376 21.746C25.8983 21.644 26.142 21.5137 26.3686 21.355C26.5953 21.185 26.7766 21.0093 26.9126 20.828C26.992 20.726 27.0543 20.6183 27.0996 20.505C27.1563 20.3803 27.1733 20.267 27.1506 20.165C27.128 20.063 27.1053 20.0007 27.0826 19.978C27.06 19.944 27.026 19.9157 26.9806 19.893ZM40.0076 20.488C39.8149 20.5787 39.5996 20.6863 39.3616 20.811C39.1349 20.9357 38.8856 21.066 38.6136 21.202C38.2736 21.372 37.9166 21.5533 37.5426 21.746C37.1686 21.9387 36.8002 22.137 36.4376 22.341C36.0862 22.5337 35.7462 22.7263 35.4176 22.919C35.1002 23.1003 34.8169 23.2703 34.5676 23.429C34.5222 23.4517 34.4769 23.48 34.4316 23.514C34.3976 23.548 34.3579 23.5763 34.3126 23.599C34.3579 23.9617 34.3522 24.3187 34.2956 24.67C34.2502 25.0213 34.1596 25.35 34.0236 25.656C33.8989 25.962 33.7402 26.234 33.5476 26.472C33.3549 26.7213 33.1452 26.931 32.9186 27.101C32.7486 27.2257 32.5672 27.322 32.3746 27.39C32.1819 27.458 31.9892 27.492 31.7966 27.492C31.6379 27.492 31.4792 27.4637 31.3206 27.407C31.1619 27.3503 31.0202 27.2653 30.8956 27.152C30.7709 27.05 30.6746 26.9197 30.6066 26.761C30.5272 26.6023 30.4932 26.4267 30.5046 26.234C30.5272 25.8033 30.7652 25.3273 31.2186 24.806C31.6832 24.296 32.3236 23.752 33.1396 23.174C33.0829 23.0493 33.0262 22.9247 32.9696 22.8C32.9129 22.6753 32.8506 22.5507 32.7826 22.426C32.7259 22.3127 32.6692 22.205 32.6126 22.103C32.5672 21.9897 32.5162 21.8707 32.4596 21.746C32.3576 21.5307 32.2669 21.2927 32.1876 21.032C32.1309 20.794 32.1139 20.5503 32.1366 20.301C32.1706 20.0403 32.2896 19.808 32.4936 19.604C32.6636 19.434 32.8392 19.315 33.0206 19.247C33.2132 19.1677 33.4002 19.128 33.5816 19.128C33.7742 19.1167 33.9556 19.1393 34.1256 19.196C34.2956 19.2413 34.4486 19.3093 34.5846 19.4C34.7772 19.5247 34.9246 19.7003 35.0266 19.927C35.1399 20.1537 35.1796 20.386 35.1456 20.624C35.1229 20.7827 35.0492 20.9017 34.9246 20.981C34.8112 21.0603 34.6922 21.0943 34.5676 21.083C34.4316 21.0717 34.3126 21.015 34.2106 20.913C34.1086 20.7997 34.0746 20.6523 34.1086 20.471C34.1312 20.3803 34.1029 20.3123 34.0236 20.267C33.9102 20.1877 33.7799 20.148 33.6326 20.148C33.4852 20.1367 33.3492 20.1933 33.2246 20.318C33.1906 20.3633 33.1622 20.4313 33.1396 20.522C33.1282 20.6013 33.1509 20.7203 33.2076 20.879C33.2529 21.0377 33.3209 21.2077 33.4116 21.389C33.4569 21.4797 33.5022 21.576 33.5476 21.678C33.5929 21.7687 33.6439 21.8593 33.7006 21.95C33.7572 22.0747 33.8082 22.188 33.8536 22.29C33.9102 22.392 33.9612 22.494 34.0066 22.596C34.2786 22.4147 34.5902 22.222 34.9416 22.018C35.3042 21.814 35.6726 21.61 36.0466 21.406C36.4319 21.1907 36.8059 20.9923 37.1686 20.811C37.5426 20.6183 37.8656 20.4483 38.1376 20.301C38.4096 20.165 38.6589 20.0347 38.8856 19.91C39.1236 19.7853 39.3332 19.672 39.5146 19.57C39.6619 19.4907 39.7979 19.4793 39.9226 19.536C40.0586 19.5927 40.1549 19.6777 40.2116 19.791C40.2682 19.9043 40.2796 20.029 40.2456 20.165C40.2229 20.301 40.1436 20.4087 40.0076 20.488ZM32.0006 25.486C31.9439 25.5653 31.8816 25.639 31.8136 25.707C31.7569 25.775 31.7002 25.8543 31.6436 25.945C31.5416 26.0923 31.5019 26.2057 31.5246 26.285C31.5472 26.387 31.5926 26.4493 31.6606 26.472C31.7286 26.4947 31.8022 26.4947 31.8816 26.472C31.9609 26.4607 32.0402 26.4323 32.1196 26.387C32.2102 26.3417 32.2839 26.302 32.3406 26.268C32.6012 26.0867 32.8222 25.8203 33.0036 25.469C33.1962 25.129 33.3039 24.7437 33.3266 24.313C33.0886 24.5057 32.8562 24.6927 32.6296 24.874C32.4029 25.0667 32.1932 25.2707 32.0006 25.486ZM47.4748 15.575C47.4408 15.5977 47.2765 15.677 46.9818 15.813C46.6985 15.949 46.3018 16.0963 45.7918 16.255C45.2931 16.4137 44.6981 16.5553 44.0068 16.68C43.3268 16.7933 42.5731 16.8387 41.7458 16.816C41.4171 17.5527 41.1055 18.2723 40.8108 18.975C40.5275 19.6663 40.2668 20.352 40.0288 21.032C39.9381 21.2927 39.8475 21.6043 39.7568 21.967C39.6775 22.3183 39.6378 22.6527 39.6378 22.97C39.6378 23.344 39.7568 23.6217 39.9948 23.803C40.1195 23.905 40.2838 23.973 40.4878 24.007C40.7031 24.041 40.9411 24.0297 41.2018 23.973C41.5078 23.8937 41.7968 23.769 42.0688 23.599C42.3408 23.4177 42.6015 23.2363 42.8508 23.055L42.9868 22.953C43.3495 22.6923 43.6951 22.4147 44.0238 22.12C44.3525 21.814 44.6811 21.4967 45.0098 21.168C45.1005 21.0773 45.1911 20.9867 45.2818 20.896C45.3838 20.8053 45.4801 20.7147 45.5708 20.624C45.6728 20.522 45.7918 20.4767 45.9278 20.488C46.0751 20.488 46.1998 20.539 46.3018 20.641C46.3925 20.743 46.4378 20.8677 46.4378 21.015C46.4378 21.151 46.3868 21.27 46.2848 21.372C46.1941 21.4627 46.0978 21.5533 45.9958 21.644C45.9051 21.7233 45.8145 21.8083 45.7238 21.899C45.3951 22.2277 45.0551 22.5563 44.7038 22.885C44.3638 23.2137 43.9955 23.5197 43.5988 23.803C43.2588 24.041 42.9188 24.2733 42.5788 24.5C42.2388 24.7153 41.8648 24.874 41.4568 24.976C41.1735 25.0327 40.9355 25.061 40.7428 25.061C40.4821 25.061 40.2328 25.0213 39.9948 24.942C39.7568 24.874 39.5415 24.7607 39.3488 24.602C39.0995 24.4093 38.9125 24.177 38.7878 23.905C38.6745 23.6217 38.6178 23.31 38.6178 22.97C38.6178 22.5733 38.6631 22.171 38.7538 21.763C38.8445 21.3437 38.9465 20.9867 39.0598 20.692C39.2865 20.0573 39.5301 19.417 39.7908 18.771C40.0628 18.125 40.3461 17.462 40.6408 16.782C39.9041 16.7707 39.2865 16.799 38.7878 16.867C38.3005 16.9237 37.9038 16.9973 37.5978 17.088C37.2918 17.1673 37.0765 17.241 36.9518 17.309C36.8158 17.377 36.7478 17.411 36.7478 17.411C36.6685 17.4903 36.5608 17.53 36.4248 17.53C36.2661 17.53 36.1358 17.4677 36.0338 17.343C35.9431 17.2297 35.9035 17.105 35.9148 16.969C35.9261 16.8217 35.9885 16.7027 36.1018 16.612C36.1358 16.5893 36.2435 16.527 36.4248 16.425C36.5948 16.3117 36.8781 16.204 37.2748 16.102C37.6601 15.9887 38.1645 15.898 38.7878 15.83C39.4111 15.7507 40.1818 15.728 41.0998 15.762C41.6551 14.572 42.2275 13.3593 42.8168 12.124C42.8735 11.9993 42.9698 11.9143 43.1058 11.869C43.2418 11.8123 43.3721 11.8123 43.4968 11.869C43.6215 11.937 43.7065 12.039 43.7518 12.175C43.8085 12.311 43.8028 12.4413 43.7348 12.566C43.2135 13.6653 42.7091 14.742 42.2218 15.796C42.9245 15.7847 43.5648 15.7223 44.1428 15.609C44.7208 15.4957 45.2195 15.371 45.6388 15.235C46.1261 15.0763 46.5681 14.895 46.9648 14.691C47.0895 14.6117 47.2198 14.5947 47.3558 14.64C47.5031 14.674 47.6108 14.7533 47.6788 14.878C47.7468 15.0027 47.7581 15.133 47.7128 15.269C47.6788 15.405 47.5995 15.507 47.4748 15.575Z",fill:"#14334C"})]});const WaverlyWordBadge=({elClass:s})=>jsxRuntimeExports.jsxs("svg",{className:s,viewBox:"0 0 47 39",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[jsxRuntimeExports.jsxs("g",{clipPath:"",children:[jsxRuntimeExports.jsx("rect",{width:"47",height:"38",transform:"translate(0 0.5)",fill:"white"}),jsxRuntimeExports.jsx("path",{d:"M8.44336 12.8145C9.25716 12.8145 10.0254 13.2181 10.748 14.0254V13.752C10.748 13.2311 10.9564 12.9707 11.373 12.9707H11.5293C11.946 12.9707 12.1543 13.4655 12.1543 14.4551C12.2064 15.0736 12.2324 15.4902 12.2324 15.7051C12.2324 18.2572 12.1283 20.64 11.9199 22.8535H11.959C12.7793 22.248 13.5605 21.5319 14.3027 20.7051C14.5632 20.1322 14.8236 19.8457 15.084 19.8457H15.2793C15.722 19.9368 15.9434 20.1452 15.9434 20.4707V20.5098C15.9434 21.4473 14.5241 22.8926 11.6855 24.8457C11.627 24.8457 11.5618 25.1191 11.4902 25.666C10.5202 29.2077 9.15299 30.9785 7.38867 30.9785C6.41862 30.9785 5.74154 30.4447 5.35742 29.377C5.30534 29.1296 5.2793 28.9342 5.2793 28.791V28.4785C5.2793 27.0462 6.49023 25.7832 8.91211 24.6895C9.80404 24.2467 10.2598 23.9733 10.2793 23.8691C10.5397 22.1243 10.6699 20.4837 10.6699 18.9473V18.9082H10.6309C10.2207 19.9043 9.67383 20.8418 8.99023 21.7207C8.00716 22.7363 7.10872 23.2441 6.29492 23.2441C5.38997 23.2441 4.5957 22.6973 3.91211 21.6035C3.62565 20.9004 3.48242 20.2363 3.48242 19.6113C3.48242 17.8926 4.10742 16.1868 5.35742 14.4941C6.35352 13.3743 7.36914 12.8145 8.4043 12.8145H8.44336ZM4.9668 19.6504C4.9668 20.627 5.31836 21.304 6.02148 21.6816C6.07357 21.6816 6.16471 21.7077 6.29492 21.7598C6.91992 21.6296 7.51888 21.1999 8.0918 20.4707C8.59961 19.7611 9.10742 18.7715 9.61523 17.502C9.82357 16.7663 10.0059 16.1934 10.1621 15.7832C9.9082 15.1517 9.54362 14.722 9.06836 14.4941C8.86003 14.3639 8.63867 14.2988 8.4043 14.2988C7.67513 14.2988 6.91992 14.8457 6.13867 15.9395C5.35742 17.2155 4.9668 18.4525 4.9668 19.6504ZM6.76367 28.6738C6.80273 29.2207 7.01107 29.4941 7.38867 29.4941C8.2806 29.4941 9.11393 28.2832 9.88867 25.8613H9.84961C7.79232 26.8118 6.76367 27.6842 6.76367 28.4785V28.6738ZM15.6699 17.6875C16.0866 17.6875 16.2949 18.0521 16.2949 18.7812V19.1719C16.2949 20.0117 16.2819 20.9883 16.2559 22.1016C16.3145 23.2734 16.4967 23.8594 16.8027 23.8594C16.8027 23.918 17.0111 23.9701 17.4277 24.0156C18.3783 24.0156 18.9772 23.4688 19.2246 22.375C19.5111 21.6784 19.7845 20.4805 20.0449 18.7812C20.2272 18.3646 20.4616 18.1562 20.748 18.1562H20.8262C21.1777 18.1562 21.3861 18.3776 21.4512 18.8203L21.4902 19.0547C21.4121 19.5495 21.36 20.5391 21.334 22.0234C21.334 23.2214 21.4382 23.8203 21.6465 23.8203C21.6465 23.8919 21.8418 23.944 22.2324 23.9766H22.2715C22.9811 23.9766 23.554 23.4688 23.9902 22.4531C24.3027 21.3854 24.5111 20.7995 24.6152 20.6953C24.804 20.5391 24.9863 20.4609 25.1621 20.4609C25.6569 20.5456 25.9043 20.793 25.9043 21.2031C25.5267 22.9154 24.9798 24.0742 24.2637 24.6797C23.5996 25.2005 22.9355 25.4609 22.2715 25.4609H22.1543C21.4707 25.4609 20.8978 25.2135 20.4355 24.7188C20.2598 24.4974 20.1556 24.3151 20.123 24.1719H20.084C19.4395 25.0573 18.541 25.5 17.3887 25.5C16.0996 25.5 15.2793 24.849 14.9277 23.5469C14.8236 23.0456 14.7715 22.4206 14.7715 21.6719L14.9277 18.7422V18.5078C14.9277 17.9609 15.1491 17.6875 15.5918 17.6875H15.6699ZM27.0176 17.375C27.623 17.375 28.1309 17.7266 28.541 18.4297C28.6712 18.7096 28.7363 18.9961 28.7363 19.2891C28.7363 20.4935 27.903 21.6003 26.2363 22.6094C26.2103 22.6094 26.1712 22.6224 26.1191 22.6484C26.4837 23.5599 26.9525 24.0156 27.5254 24.0156H27.6035C28.5736 24.0156 29.5892 23.2734 30.6504 21.7891C31.0736 20.7995 31.373 20.3047 31.5488 20.3047L31.7832 20.2656H31.9004C32.3431 20.3568 32.5645 20.5651 32.5645 20.8906V21.0469C32.4212 21.7826 31.9134 22.668 31.041 23.7031C29.8887 24.901 28.7428 25.5 27.6035 25.5C26.0801 25.5 25.0384 24.4453 24.4785 22.3359C24.4264 22.0755 24.4004 21.8151 24.4004 21.5547V21.125C24.4004 19.3802 25.0124 18.1823 26.2363 17.5312C26.5488 17.4271 26.8092 17.375 27.0176 17.375ZM25.8848 21.1641C26.7962 20.4674 27.252 19.8164 27.252 19.2109C27.2064 19.0352 27.1152 18.918 26.9785 18.8594C26.653 18.8594 26.3405 19.224 26.041 19.9531C25.9368 20.3503 25.8848 20.7279 25.8848 21.0859V21.1641ZM33.5312 17.2969C34.4167 17.2969 35.0286 17.7917 35.3672 18.7812C35.4453 19.0677 35.4844 19.3672 35.4844 19.6797C35.4258 20.1745 35.2044 20.4219 34.8203 20.4219C34.4362 20.4219 34.2148 20.2005 34.1562 19.7578C34.1042 19.1068 33.9219 18.7812 33.6094 18.7812H33.5312C33.1341 18.7812 32.8216 19.0807 32.5938 19.6797C32.5677 19.7773 32.5547 19.8815 32.5547 19.9922C32.5547 20.2917 32.737 20.6302 33.1016 21.0078C34.612 22.5247 35.3672 23.4232 35.3672 23.7031C37.2943 23.2474 38.2578 22.8828 38.2578 22.6094C38.401 22.6094 38.6094 22.0625 38.8828 20.9688C39.0521 20.7083 39.2604 20.5781 39.5078 20.5781H39.5859C39.9701 20.5781 40.2044 20.8255 40.2891 21.3203C40.2891 21.6914 40.0938 22.3164 39.7031 23.1953C39.332 23.8203 38.668 24.2891 37.7109 24.6016C36.7474 24.888 35.9922 25.0964 35.4453 25.2266C35.1914 25.9036 34.7747 26.2422 34.1953 26.2422C33.707 26.2422 33.3945 25.9036 33.2578 25.2266V25.0703C33.2578 24.7122 33.4792 24.4128 33.9219 24.1719H33.9609C33.681 23.7357 32.9779 22.9674 31.8516 21.8672C31.3307 21.1771 31.0703 20.6042 31.0703 20.1484V19.7969C31.0703 18.944 31.5521 18.1888 32.5156 17.5312C32.8867 17.375 33.2122 17.2969 33.4922 17.2969H33.5312ZM39.9277 13.127C40.2598 13.127 40.4681 13.3613 40.5527 13.8301C40.5267 14.2272 40.5137 14.5918 40.5137 14.9238V15.1582H41.7637C42.2585 15.2233 42.5059 15.4577 42.5059 15.8613V15.9395C42.5059 16.3366 42.2585 16.571 41.7637 16.6426H40.5527L40.4746 16.6816C40.4486 17.4759 40.4355 18.0618 40.4355 18.4395V18.791C40.4355 22.2285 40.5527 23.9473 40.7871 23.9473C41.002 24.1296 41.3014 24.2207 41.6855 24.2207C42.5579 24.2207 43.3132 23.4134 43.9512 21.7988C44.1725 20.7051 44.3939 20.1582 44.6152 20.1582C44.6152 20.1126 44.7064 20.0866 44.8887 20.0801H45.084C45.3965 20.0801 45.6048 20.3145 45.709 20.7832C45.709 21.2845 45.4095 22.209 44.8105 23.5566C43.9056 24.9889 42.8379 25.7051 41.6074 25.7051C40.6178 25.7051 39.8757 25.3145 39.3809 24.5332C39.0944 24.3314 38.9512 22.4434 38.9512 18.8691V17.0723C38.9512 17.0462 38.9642 17.0332 38.9902 17.0332C38.9902 17.0072 38.9772 16.9941 38.9512 16.9941L38.9902 16.7988V16.6816C37.8444 16.6816 37.2715 16.6035 37.2715 16.4473C37.1673 16.3757 37.0892 16.2194 37.0371 15.9785C37.0371 15.5944 37.2585 15.373 37.7012 15.3145C37.7012 15.2949 38.1569 15.2689 39.0684 15.2363C39.1204 13.8822 39.2897 13.2051 39.5762 13.2051C39.6738 13.153 39.791 13.127 39.9277 13.127Z",fill:"#14334C"})]}),jsxRuntimeExports.jsx("defs",{children:jsxRuntimeExports.jsx("clipPath",{id:"clip0",children:jsxRuntimeExports.jsx("rect",{width:"47",height:"38",fill:"white",transform:"translate(0 0.5)"})})})]});const TybeeWordBadge=({elClass:s})=>jsxRuntimeExports.jsxs("svg",{className:s,viewBox:"0 0 47 39",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[jsxRuntimeExports.jsxs("g",{clipPath:"url(#clipTybeeWord)",children:[jsxRuntimeExports.jsx("rect",{width:"47",height:"38",transform:"translate(0 0.5)",fill:"white"}),jsxRuntimeExports.jsx("path",{d:"M14.1292 18.56V23.795C13.8692 23.955 13.5742 24.095 13.2442 24.215C12.9142 24.335 12.5692 24.435 12.2092 24.515C11.8592 24.605 11.4992 24.67 11.1292 24.71C10.7692 24.75 10.4292 24.77 10.1092 24.77C9.20924 24.77 8.40424 24.62 7.69424 24.32C6.99424 24.02 6.39924 23.615 5.90924 23.105C5.42924 22.595 5.05924 22.005 4.79924 21.335C4.54924 20.655 4.42424 19.94 4.42424 19.19C4.42424 18.4 4.55924 17.665 4.82924 16.985C5.10924 16.305 5.48924 15.715 5.96924 15.215C6.45924 14.715 7.04424 14.325 7.72424 14.045C8.40424 13.755 9.14924 13.61 9.95924 13.61C10.9392 13.61 11.7392 13.735 12.3592 13.985C12.9792 14.225 13.4992 14.56 13.9192 14.99L12.8992 16.085C12.4592 15.665 11.9942 15.375 11.5042 15.215C11.0142 15.045 10.4992 14.96 9.95924 14.96C9.34924 14.96 8.79924 15.075 8.30924 15.305C7.81924 15.525 7.39924 15.825 7.04924 16.205C6.69924 16.585 6.42924 17.035 6.23924 17.555C6.04924 18.065 5.95424 18.61 5.95424 19.19C5.95424 19.79 6.05924 20.35 6.26924 20.87C6.47924 21.38 6.76924 21.825 7.13924 22.205C7.50924 22.585 7.94424 22.885 8.44424 23.105C8.94424 23.315 9.48924 23.42 10.0792 23.42C10.5892 23.42 11.0692 23.375 11.5192 23.285C11.9792 23.185 12.3692 23.045 12.6892 22.865V19.91H10.3342V18.56H14.1292ZM22.714 24.5H21.364V23.405H21.334C21.164 23.785 20.869 24.095 20.449 24.335C20.029 24.565 19.544 24.68 18.994 24.68C18.644 24.68 18.314 24.625 18.004 24.515C17.694 24.415 17.419 24.255 17.179 24.035C16.949 23.815 16.764 23.535 16.624 23.195C16.484 22.845 16.414 22.435 16.414 21.965V17.39H17.764V21.59C17.764 21.92 17.809 22.205 17.899 22.445C17.989 22.675 18.109 22.865 18.259 23.015C18.409 23.155 18.579 23.26 18.769 23.33C18.969 23.39 19.174 23.42 19.384 23.42C19.664 23.42 19.924 23.375 20.164 23.285C20.404 23.195 20.614 23.055 20.794 22.865C20.974 22.665 21.114 22.415 21.214 22.115C21.314 21.815 21.364 21.46 21.364 21.05V17.39H22.714V24.5ZM25.769 21.44C25.769 21.75 25.834 22.035 25.964 22.295C26.104 22.545 26.284 22.76 26.504 22.94C26.724 23.12 26.979 23.26 27.269 23.36C27.559 23.46 27.859 23.51 28.169 23.51C28.589 23.51 28.954 23.415 29.264 23.225C29.574 23.025 29.859 22.765 30.119 22.445L31.139 23.225C30.389 24.195 29.339 24.68 27.989 24.68C27.429 24.68 26.919 24.585 26.459 24.395C26.009 24.205 25.624 23.945 25.304 23.615C24.994 23.275 24.754 22.88 24.584 22.43C24.414 21.97 24.329 21.475 24.329 20.945C24.329 20.415 24.419 19.925 24.599 19.475C24.789 19.015 25.044 18.62 25.364 18.29C25.694 17.95 26.084 17.685 26.534 17.495C26.984 17.305 27.474 17.21 28.004 17.21C28.634 17.21 29.164 17.32 29.594 17.54C30.034 17.76 30.394 18.05 30.674 18.41C30.954 18.76 31.154 19.16 31.274 19.61C31.404 20.05 31.469 20.5 31.469 20.96V21.44H25.769ZM30.029 20.36C30.019 20.06 29.969 19.785 29.879 19.535C29.799 19.285 29.674 19.07 29.504 18.89C29.334 18.7 29.119 18.555 28.859 18.455C28.609 18.345 28.314 18.29 27.974 18.29C27.644 18.29 27.339 18.355 27.059 18.485C26.789 18.605 26.559 18.765 26.369 18.965C26.179 19.165 26.029 19.39 25.919 19.64C25.819 19.88 25.769 20.12 25.769 20.36H30.029ZM36.864 19.175C36.704 18.975 36.504 18.81 36.264 18.68C36.034 18.54 35.749 18.47 35.409 18.47C35.089 18.47 34.809 18.54 34.569 18.68C34.339 18.81 34.224 19.005 34.224 19.265C34.224 19.475 34.289 19.645 34.419 19.775C34.559 19.905 34.719 20.01 34.899 20.09C35.089 20.17 35.289 20.23 35.499 20.27C35.709 20.31 35.889 20.345 36.039 20.375C36.329 20.445 36.599 20.53 36.849 20.63C37.109 20.73 37.329 20.86 37.509 21.02C37.699 21.18 37.844 21.375 37.944 21.605C38.054 21.835 38.109 22.115 38.109 22.445C38.109 22.845 38.024 23.19 37.854 23.48C37.684 23.76 37.464 23.99 37.194 24.17C36.924 24.35 36.614 24.48 36.264 24.56C35.924 24.64 35.579 24.68 35.229 24.68C34.639 24.68 34.119 24.59 33.669 24.41C33.229 24.23 32.834 23.9 32.484 23.42L33.504 22.58C33.724 22.8 33.969 22.995 34.239 23.165C34.509 23.335 34.839 23.42 35.229 23.42C35.399 23.42 35.569 23.405 35.739 23.375C35.919 23.335 36.074 23.28 36.204 23.21C36.344 23.13 36.454 23.035 36.534 22.925C36.624 22.805 36.669 22.67 36.669 22.52C36.669 22.32 36.604 22.155 36.474 22.025C36.354 21.895 36.204 21.795 36.024 21.725C35.854 21.645 35.669 21.585 35.469 21.545C35.279 21.495 35.109 21.455 34.959 21.425C34.669 21.355 34.394 21.275 34.134 21.185C33.874 21.095 33.644 20.975 33.444 20.825C33.244 20.675 33.084 20.485 32.964 20.255C32.844 20.025 32.784 19.74 32.784 19.4C32.784 19.03 32.859 18.71 33.009 18.44C33.169 18.16 33.374 17.93 33.624 17.75C33.884 17.57 34.174 17.435 34.494 17.345C34.824 17.255 35.154 17.21 35.484 17.21C35.964 17.21 36.424 17.3 36.864 17.48C37.304 17.66 37.654 17.96 37.914 18.38L36.864 19.175ZM43.559 18.56H41.624V21.785C41.624 21.985 41.629 22.185 41.639 22.385C41.649 22.575 41.684 22.75 41.744 22.91C41.814 23.06 41.914 23.185 42.044 23.285C42.184 23.375 42.384 23.42 42.644 23.42C42.804 23.42 42.969 23.405 43.139 23.375C43.309 23.345 43.464 23.29 43.604 23.21V24.44C43.444 24.53 43.234 24.59 42.974 24.62C42.724 24.66 42.529 24.68 42.389 24.68C41.869 24.68 41.464 24.61 41.174 24.47C40.894 24.32 40.684 24.13 40.544 23.9C40.414 23.67 40.334 23.415 40.304 23.135C40.284 22.845 40.274 22.555 40.274 22.265V18.56H38.714V17.39H40.274V15.395H41.624V17.39H43.559V18.56Z",fill:"#14334C"})]}),jsxRuntimeExports.jsx("defs",{children:jsxRuntimeExports.jsx("clipPath",{id:"clipTybeeWord",children:jsxRuntimeExports.jsx("rect",{width:"47",height:"38",fill:"white",transform:"translate(0 0.5)"})})})]});const OnlyRiverBadge=({elClass:C})=>jsxRuntimeExports.jsx("img",{className:C,src:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/only-river.svg?v=1786477958",alt:"Only River"});const OnlySullivanBadge=({elClass:C})=>jsxRuntimeExports.jsx("img",{className:C,src:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/sullivan-sullivan.svg",alt:"Only Sullivan"});const RiverSullivanBadge=({elClass:C})=>jsxRuntimeExports.jsx("img",{className:C,src:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/river-sullivan.svg?v=1786477968",alt:"River + Sullivan"});const SullivanWordBadge=({elClass:s})=>jsxRuntimeExports.jsxs("svg",{className:s,viewBox:"0 0 47 39",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[jsxRuntimeExports.jsx("rect",{width:"47",height:"38",transform:"translate(0 0.5)",fill:"white"}),jsxRuntimeExports.jsx("path",{d:"M11.5573 20.859V21.471L12.4753 21.59V24.14C12.4753 24.752 11.6083 25.075 10.7073 25.075C8.99029 25.075 6.84829 23.205 6.84829 18.972C6.84829 16.014 7.90229 14.025 10.0613 14.025C12.1013 14.025 12.7643 15.674 13.4783 17.119L14.0223 17L13.2233 13.345C12.8663 13.566 12.5603 13.736 12.1353 13.736C11.8463 13.736 11.5913 13.634 11.2683 13.532C10.9453 13.43 10.5543 13.345 9.97629 13.345C7.37529 13.345 5.04629 15.844 5.04629 19.975C5.04629 23.018 7.08629 25.755 10.3163 25.755C11.2683 25.755 13.2573 25.007 13.5973 25.007H14.1923C14.1243 24.531 14.1073 24.055 14.1073 23.562V21.59L14.8553 21.471V20.859H11.5573ZM16.0112 17.918V18.428C16.1812 18.377 16.3172 18.36 16.4362 18.36C16.7932 18.36 16.9462 18.666 16.9462 19.839V23.341C16.9462 25.007 18.0342 25.755 19.2412 25.755C20.4992 25.755 21.3492 25.262 22.1992 24.242C22.3012 24.786 22.4542 25.279 22.7602 25.755L24.4602 25.228V24.718C24.3072 24.769 24.1542 24.786 24.0012 24.786C23.6442 24.786 23.5592 24.446 23.5592 23.885V18.173C23.5592 17.799 23.5762 17.493 23.5932 17.136L21.2472 17.918V18.428C21.4172 18.377 21.5532 18.36 21.6722 18.36C22.0292 18.36 22.1822 18.666 22.1822 19.839V23.256C21.8592 23.834 21.0942 24.769 19.9892 24.769C18.9692 24.769 18.3232 24.14 18.3232 23.12V18.173C18.3232 17.799 18.3402 17.493 18.3572 17.136L16.0112 17.918ZM31.7984 20.4C31.5604 18.717 30.7104 17.136 28.8234 17.136C27.1574 17.136 25.6784 18.955 25.6784 21.777C25.6784 23.766 26.7834 25.755 28.9934 25.755C30.4384 25.755 31.4414 24.752 31.9854 23.545L31.5604 23.256C31.0334 24.072 30.4554 24.616 29.5034 24.616C27.9394 24.616 27.1914 22.95 27.1404 21.777L31.7984 20.4ZM27.0724 20.995C27.0554 20.825 27.0554 20.655 27.0554 20.128C27.0554 19.108 27.4804 17.748 28.9254 17.748C29.9114 17.748 30.2344 18.632 30.2344 19.278C30.2344 20.043 29.8774 20.213 29.3334 20.366L27.0724 20.995ZM38.4682 23.256C38.4682 20.162 34.5582 20.808 34.5582 18.904C34.5582 18.224 35.0342 17.748 35.7312 17.748C36.3432 17.748 36.3092 18.887 37.1252 18.887C37.6352 18.887 37.9582 18.666 37.9582 18.088C37.9582 17.544 37.4652 17.136 36.4792 17.136C34.5412 17.136 33.4192 18.054 33.4192 19.482C33.4192 22.049 37.3292 21.675 37.3292 23.8C37.3292 24.684 36.4792 25.143 35.5612 25.143C34.3032 25.143 35.0512 23.392 33.7592 23.392C33.2832 23.392 32.9602 23.698 32.9602 24.276C32.9602 25.126 34.2012 25.755 35.5272 25.755C37.3632 25.755 38.4682 24.565 38.4682 23.256ZM42.0326 17.391V14.042L40.6556 15.164V17.391H39.5676V18.139H40.6216V23.324C40.6216 24.922 41.2166 25.755 42.3216 25.755C43.3586 25.755 43.9876 25.33 44.7356 24.65L44.4806 24.123C44.0386 24.463 43.5626 24.769 43.1546 24.769C42.3046 24.769 41.9986 24.412 41.9986 23.46V18.139H44.2256V17.391H42.0326Z",fill:"#14334C"})]});const SusanBadge=({elClass:C})=>jsxRuntimeExports.jsx("svg",{className:C,id:"Layer_1","data-name":"Layer 1",xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 200 200",children:jsxRuntimeExports.jsx("path",{className:"cls-1",d:"M148.28,90.4A2.59,2.59,0,0,1,147,93.71a136.23,136.23,0,0,1-12.84,4.77,142,142,0,0,0-7.1,21.31,45.88,45.88,0,0,0-1.29,15.58v.16c.24,2.1.64,6,2.58,7.19a2.88,2.88,0,0,1,1.13,1.86,2.33,2.33,0,0,1-.56,1.85,2.48,2.48,0,0,1-3.32.57c-4-2.66-4.6-8.16-4.92-11.06v-.16A51.47,51.47,0,0,1,122,118.66a148.41,148.41,0,0,1,5.89-18.41,264.76,264.76,0,0,1-26.48,5.49c-.64.65-1.13,1.3-1.69,1.86-3.47,3.88-6.78,7-9.93,10.09-1.29,1.29-2.58,2.5-3.8,3.72l-.56.56A74,74,0,0,1,78,128.35c-3.15,2.42-11.3,8.07-19.3,7.1A9.69,9.69,0,0,1,50.92,130a9.81,9.81,0,0,1,.64-9.44,2.29,2.29,0,0,1,1.62-1,2.39,2.39,0,0,1,1.94.32,2.67,2.67,0,0,1,.72,3.47,4.42,4.42,0,0,0-.32,4.36,4.9,4.9,0,0,0,3.87,2.67c1.54.24,7.27.4,15.59-6a63.78,63.78,0,0,0,6.94-6l.56-.57c1.21-1.21,2.51-2.42,3.8-3.71,2.34-2.34,4.76-4.68,7.26-7.27-8,1-13.24,1.38-13.4,1.38a2.46,2.46,0,0,1-2.58-2.43,2.68,2.68,0,0,1,2.26-2.66c.16,0,7.75-.49,19.05-2.18,10.66-12,18.57-21,25-28.42,1.94-2.18,3.63-4.2,5.08-5.89,1.14-1.29,2.1-2.5,3.07-3.55l.73-.81a58.84,58.84,0,0,1,4.68-4.68c4.84-4.36,7.75-5.66,10-4.77a4.26,4.26,0,0,1,2.18,2.1c1.21,2.83-.81,7.83-5,18.17-.73,1.77-1.46,3.71-2.35,5.81l-1,2.18-.4,1c-.9,1.94-1.7,3.88-2.51,5.89-.64,1.37-1.13,2.75-1.69,4.2,3.07-1.13,5.73-2.18,8.23-3.23A2.69,2.69,0,0,1,148.28,90.4ZM137.62,76.92c.57-1.37,1.13-2.74,1.7-4l1-2.43c1.37-3.39,2.66-6.54,3.55-9,.24-.65.4-1.05.4-1.05l.17-.4.32-.81.16-.4a2.8,2.8,0,0,1,.24-.49l.08-.24.08-.24a52,52,0,0,0-9.44,8.72c-1.94,2.18-4.2,4.84-6.79,7.83L127.69,76l-4.12,4.76c-5.08,5.82-10.82,12.44-16.63,19a208.5,208.5,0,0,0,23.33-5.49c.9-1.86,1.7-3.8,2.51-5.65.32-.81.64-1.62,1-2.43.65-1.45,1.21-2.82,1.78-4.27l.72-1.7c.32-.64.56-1.29.89-2Z"})});const JonesBadge=({elClass:s})=>jsxRuntimeExports.jsx("svg",{className:s,id:"Golf_Clubs__x2B__WZE_xA0_Image_00000145040947359490654840000002378796076169046696_",xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 174.7 194.9",children:jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{fill:"#0E334B",d:"M2.4,83.9c0-1,1.2-1.9,2.8-2.4c0.4-12.4,4.4-25.5,11.2-34.1c7.2-9,17.1-14.6,28.3-14.6 c4.6,0,8.7,0.7,12.8,2.5c0.4-0.7,2.6-4.3,6.8-8.1c0.7,2.1,0.7,4.3,0,6.6c-1.8,2.2-3.4,4.7-4.6,7.4c-0.1-0.6-7.8-3.7-15-3.7 c-9,0-17.5,4.6-24,12.8c-7.2,8.8-9.7,19.7-10.3,31.1c1.8,0.6,2.9,1.5,2.9,2.5c0,1.6-2.4,3.1-5.4,3.1C4.9,87,2.4,85.5,2.4,83.9z M57.5,159.5c-4.1,1.8-8.2,2.6-12.8,2.6c-11.2,0-20.9-5.6-28.3-14.7c-6.8-8.7-10.7-21.8-11.2-34C3.6,113,2.4,112,2.4,111 c0-1.6,2.5-2.9,5.4-2.9c3.1,0,5.4,1.3,5.4,2.9c0,1-1.2,2.1-2.9,2.5c0.7,12.1,3.2,22.2,10.3,31.2c6.5,8.1,15.2,12.7,24,12.7 c7.2,0,14.9-3.1,15-3.7c1.2,2.6,2.8,5.2,4.6,7.5c0.7,2.4,0.7,4.4,0,6.5C60.1,164,57.9,160.3,57.5,159.5z M3.5,97.4 c0-2.5,2.1-4.3,4.3-4.3c2.5,0,4.6,1.8,4.6,4.3s-2.1,4.4-4.6,4.4C5.5,101.9,3.5,99.9,3.5,97.4z M58.8,129.4 c1.5,0.6,2.4,1.5,2.4,2.5c0,1.8-2.4,2.9-5.3,2.9c-2.9,0-5.3-1.2-5.3-2.9c0-1,0.9-1.8,2.2-2.4l-7.9-26.6l-7.9,26.6 c1.3,0.6,2.2,1.3,2.2,2.4c0,1.8-2.4,2.9-5.3,2.9c-2.9,0-5.3-1.2-5.3-2.9c0-1,0.9-1.9,2.4-2.5V65.1c-1.6-0.4-2.8-1.5-2.8-2.6 c0-1.6,2.4-2.9,5.3-2.9s5.3,1.3,5.3,2.9c0,1.2-1.2,2.2-2.8,2.6v53.4L42.2,97c0.4-1.8,1-4.1,2.6-4.1c1.5,0,2.2,2.4,2.6,4.1 l6.3,21.5V65.1c-1.6-0.4-2.8-1.5-2.8-2.6c0-1.6,2.4-2.9,5.3-2.9s5.3,1.3,5.3,2.9c0,1.2-1.2,2.2-2.8,2.6V129.4z"}),jsxRuntimeExports.jsx("path",{fill:"#0E334B",d:"M64.3,27.2c2.4-2.1,5.2-4.1,8.5-5.9c0.4-1.8,1.5-2.9,2.6-2.9c1.6,0,2.9,2.4,2.9,5c0,2.9-1.3,5-2.9,5 c-0.9,0-1.8-0.7-2.2-2.1c-3.5,2.1-6.5,4.6-9,7.5C63.4,31.9,63.4,29.7,64.3,27.2z M72.8,173.5c-3.4-1.8-6.2-3.8-8.5-5.9 c-0.7-2.4-0.7-4.6,0-6.6c2.5,2.9,5.4,5.4,9,7.5c0.4-1.3,1.3-2.1,2.2-2.1c1.6,0,2.9,2.1,2.9,5c0,2.6-1.3,5-2.9,5 C74.3,176.5,73.2,175.3,72.8,173.5z M104.6,139.8c0,2.1-0.7,4.1-1.8,4.9H74.6c-3.5,0-4.4-1.6-3.2-5.2l27.2-84.2H76.3 c0,2.8-1.2,5.2-2.8,5.2c-1.8,0-2.9-2.5-2.9-5.4c0-2.1,0.7-4.1,1.8-4.9h29c3.5,0,3.8,1.6,2.6,5.2l-27.2,84.2h22.1 c0-2.8,1.2-5.2,2.8-5.2C103.4,134.4,104.6,136.9,104.6,139.8z M82.9,22.4c0-2.5,1.9-4.6,4.4-4.6s4.4,2.1,4.4,4.6 s-1.9,4.4-4.4,4.4S82.9,24.9,82.9,22.4z M82.9,172.5c0-2.5,1.9-4.4,4.4-4.4s4.4,1.9,4.4,4.4s-1.9,4.6-4.4,4.6 S82.9,175,82.9,172.5z M101.5,26.4c-0.4,1.3-1.3,2.1-2.2,2.1c-1.6,0-2.9-2.1-2.9-5c0-2.6,1.3-5,2.9-5c1.2,0,2.2,1.2,2.6,2.9 c3.4,1.8,6.2,3.8,8.5,5.9c0.7,2.4,0.7,4.6,0,6.6C108,30.9,105,28.4,101.5,26.4z M96.3,171.5c0-2.9,1.3-5,2.9-5 c0.9,0,1.8,0.7,2.2,2.1c3.5-2.1,6.5-4.6,9-7.5c0.9,2.2,0.9,4.4,0,6.6c-2.4,2.1-5.2,4.1-8.5,5.9c-0.4,1.8-1.5,2.9-2.6,2.9 C97.7,176.5,96.3,174.1,96.3,171.5z"}),jsxRuntimeExports.jsx("path",{fill:"#0E334B",d:"M161.4,83.9c0-1,1.2-1.9,2.9-2.5c-0.6-11.3-3.1-22.2-10.3-31.1c-6.5-8.2-15-12.8-24-12.8 c-7.2,0-14.9,3.1-15,3.7c-1.2-2.6-2.8-5.2-4.6-7.4c-0.7-2.4-0.7-4.6,0-6.6c4.1,3.8,6.3,7.4,6.8,8.1c4.1-1.8,8.2-2.5,12.8-2.5 c11.2,0,21,5.6,28.3,14.6c6.8,8.7,10.7,21.8,11.2,34.1c1.6,0.4,2.8,1.3,2.8,2.4c0,1.6-2.5,3.1-5.4,3.1 C163.7,87,161.4,85.5,161.4,83.9z M110.5,161.2c1.8-2.4,3.4-4.9,4.6-7.5c0.1,0.6,7.8,3.7,15,3.7c8.8,0,17.5-4.6,24-12.7 c7.1-9,9.6-19.1,10.3-31.2c-1.8-0.4-2.9-1.5-2.9-2.5c0-1.6,2.4-2.9,5.4-2.9c2.9,0,5.4,1.3,5.4,2.9c0,1-1.2,2.1-2.8,2.5 c-0.4,12.2-4.4,25.3-11.2,34c-7.4,9.1-17.1,14.7-28.3,14.7c-4.6,0-8.7-0.9-12.8-2.6c-0.4,0.7-2.6,4.4-6.8,8.1 C109.7,165.6,109.7,163.5,110.5,161.2z M143.4,130.6c0,1.6-0.4,3.2-1.2,4.3h-24.9c-3.2,0-4.9-1.3-4.9-2.8c0-1.3,1.3-2.6,3.4-2.8 V65.7c-2.1-0.1-3.4-1.5-3.4-2.6c0-1.8,1.5-2.9,4.7-2.9h25c0.7,1,1.2,2.6,1.2,4.3c0,2.9-1.3,5.2-2.9,5.2c-1.6,0-2.6-1.9-2.5-4.4 h-17.1v28.4h10.6c0.6-1.6,1.5-2.8,2.6-2.8c1.8,0,2.9,2.4,2.9,5.3s-1.2,5.3-2.9,5.3c-1.2,0-2.1-1.2-2.6-2.8h-10.6v31.3H138 c0-2.5,0.9-4.4,2.5-4.4C142.1,125.4,143.4,127.6,143.4,130.6z M162.4,97.4c0-2.5,2.1-4.3,4.6-4.3c2.2,0,4.3,1.8,4.3,4.3 s-2.1,4.4-4.3,4.4C164.5,101.9,162.4,99.9,162.4,97.4z"})]})});const PonceSvg=({elClass:s,embColor:a})=>{let l=[{green:"#93ac96"},{brightpink:"#de5b96"},{rollerrabbitpink:"#ee6890"},{lightpink:"#facad8"},{balletpink:"#facad8"},{coral:"#eeb4ad"},{red:"#ba1f31"},{cranberry:"#aa1e33"},{brightpink:"#de5b96"},{lilac:"#ccbfd9"},{lightblue:"#d2e2f1"},{frenchblue:"#78a0d4"},{rollerrabbitblue:"#597ab2"},{lavender:"#ccbfd9"},{marigold:"#ffce06"},{navy:"#14334c"},{spablue:"#91b6bb"},{parterregreen:"#a5b293"},{mint:"#90cfb7"},{white:"#fff"},{sand:"#dfd4c9"},{taupe:"#af9483"},{grey:"#bfc2c6"},{black:"#000"}].find(c=>c[a.toLowerCase().replace(/\s+/g,"")]),t=l?l[a.toLowerCase().replace(/\s+/g,"")]:"";return jsxRuntimeExports.jsxs("svg",{className:s,width:"42",height:"42",viewBox:"0 0 129 131",fill:"#FAF9FF",xmlns:"http://www.w3.org/2000/svg",children:[jsxRuntimeExports.jsx("path",{d:"M76.6777 106.604C79.0691 108.303 81.9208 109.367 84.8403 109.597C88.8914 110.108 93.4216 108.625 96.7145 106.422C99.2908 104.795 101.516 102.457 103.308 100.02C104.338 98.6195 105.239 97.121 106.001 95.5581C107.676 92.1221 108.947 88.2206 108.721 84.3531C108.51 80.7317 106.608 76.7205 102.776 75.8652C102.361 75.7706 101.92 75.7101 101.588 75.449C100.453 74.5446 103.338 72.607 103.998 72.0508C105.575 70.7187 107.733 69.8484 109.803 70.1322C111.127 70.3138 112.391 70.9307 113.36 71.8502C114.16 72.607 114.745 73.8104 116.005 73.7082C117.264 73.6061 118.23 72.2551 119.456 71.8956C122.334 71.0442 125.533 72.3119 127.317 74.6581C127.788 75.2787 128.456 76.0809 128.079 76.8302C127.777 77.4243 126.736 77.7535 126.196 78.0865C124.031 79.4337 122.572 80.8149 121.519 83.1952C120.618 85.2311 120.154 87.4221 119.456 89.5261C117.887 94.2563 116.257 98.9828 114.077 103.471C112.881 105.934 111.667 107.978 109.754 109.915C107.74 111.951 105.496 113.771 103.097 115.33C99.7548 117.503 96.3901 118.521 92.5691 119.304C89.8985 119.853 87.2468 120.466 84.6064 121.143C82.4639 121.692 80.6609 123.179 79.1974 124.844C77.8131 126.411 76.2062 128.03 75.2066 129.729C74.7728 129.181 74.207 128.885 73.6827 128.435C71.9061 126.906 70.7443 124.734 70.7104 122.365C70.6802 120.288 71.3629 117.643 73.2414 116.549C73.3244 116.5 71.3554 114.104 71.2083 113.881C70.4992 112.806 70.0239 111.577 69.8466 110.301C69.5977 108.519 72.4417 101.261 74.2976 104.231C74.9539 105.28 75.6857 105.896 76.6701 106.597L76.6777 106.604Z",fill:t}),jsxRuntimeExports.jsx("path",{d:"M75.267 130.615L74.8181 130.043C74.5767 129.737 74.2674 129.51 73.943 129.271C73.7544 129.131 73.5583 128.988 73.3621 128.821C71.3969 127.129 70.2502 124.783 70.2163 122.38C70.1861 120.318 70.7972 117.752 72.5625 116.416C72.2569 116.012 71.7364 115.361 71.4158 114.956C71.0122 114.449 70.8537 114.252 70.8009 114.169C70.0428 113.022 69.5449 111.713 69.36 110.377C69.1413 108.81 70.9254 103.815 72.8114 103.123C73.2339 102.967 74.0411 102.873 74.7276 103.97C75.3236 104.92 75.9723 105.484 76.9682 106.192L77.0096 106.222C79.3596 107.883 82.083 108.878 84.8893 109.102C88.4954 109.556 92.9162 108.371 96.4467 106.01C98.7439 104.557 100.917 102.445 102.916 99.7282C103.919 98.3621 104.809 96.8901 105.56 95.3424C107.521 91.3236 108.419 87.634 108.23 84.3872C108.031 80.9625 106.235 77.1518 102.678 76.3609L102.497 76.3231C102.105 76.2398 101.66 76.1452 101.286 75.8501C100.988 75.6117 100.83 75.2976 100.834 74.9381C100.841 73.9542 102.063 72.9325 103.312 71.9675C103.466 71.8502 103.595 71.748 103.685 71.6761C105.526 70.1246 107.842 69.3678 109.879 69.6478C111.293 69.8446 112.655 70.4992 113.711 71.4983C113.93 71.7064 114.13 71.9372 114.322 72.1605C114.918 72.853 115.314 73.273 115.974 73.2201C116.533 73.1746 117.068 72.7849 117.638 72.3762C118.158 71.9978 118.694 71.6118 119.328 71.4263C122.289 70.5522 125.744 71.7594 127.724 74.3629L127.8 74.4613C128.29 75.1046 129.037 76.0733 128.535 77.0648C128.241 77.64 127.573 77.9654 126.981 78.253C126.785 78.3476 126.604 78.4384 126.472 78.5179C124.548 79.7137 123.051 81.0041 121.991 83.4033C121.417 84.6975 121.014 86.0976 120.621 87.4524C120.41 88.1865 120.188 88.9509 119.942 89.6926C118.419 94.2904 116.748 99.1568 114.541 103.698C113.496 105.851 112.236 108.137 110.12 110.275C108.091 112.322 105.824 114.169 103.38 115.758C99.7246 118.134 96.0771 119.107 92.6823 119.803C90.057 120.341 87.3864 120.957 84.746 121.635C82.9996 122.085 81.2645 123.277 79.5897 125.184C79.2992 125.514 79.0013 125.839 78.7033 126.172C77.583 127.41 76.4212 128.692 75.6555 129.994L75.2858 130.622L75.267 130.615ZM73.3018 104.027C73.2377 104.027 73.1848 104.046 73.1434 104.061C71.8571 104.53 70.1597 108.95 70.337 110.233C70.503 111.418 70.9481 112.587 71.6232 113.609C71.6647 113.669 71.9439 114.017 72.189 114.328C73.7884 116.337 73.7884 116.352 73.7356 116.64L73.6941 116.863L73.4979 116.984C71.7628 117.994 71.1819 120.511 71.2083 122.365C71.2385 124.481 72.2569 126.558 74.0071 128.06C74.1731 128.204 74.3466 128.329 74.5314 128.465C74.7314 128.609 74.9313 128.76 75.1274 128.931C75.9158 127.743 76.9493 126.603 77.9526 125.495C78.2506 125.165 78.5448 124.84 78.8315 124.518C80.6421 122.46 82.5432 121.162 84.4895 120.662C87.145 119.981 89.8344 119.361 92.4748 118.819C95.7753 118.142 99.3135 117.2 102.833 114.914C105.217 113.363 107.431 111.561 109.407 109.567C111.308 107.649 112.47 105.658 113.636 103.259C115.816 98.7708 117.476 93.9384 118.988 89.3747C119.23 88.6519 119.445 87.8989 119.656 87.1723C120.056 85.7873 120.471 84.3531 121.07 82.9984C122.236 80.3646 123.862 78.9607 125.94 77.6665C126.117 77.5567 126.321 77.4583 126.54 77.3524C126.947 77.1556 127.502 76.8831 127.641 76.6069C127.841 76.2133 127.486 75.6987 127.004 75.0667L126.928 74.9646C125.189 72.6827 122.179 71.6193 119.603 72.38C119.135 72.5162 118.69 72.8416 118.219 73.1822C117.566 73.6552 116.891 74.1434 116.054 74.2115C114.862 74.3099 114.141 73.4774 113.564 72.8076C113.379 72.5919 113.206 72.3913 113.025 72.221C112.119 71.3658 110.954 70.802 109.743 70.6355C107.981 70.3933 105.952 71.0668 104.326 72.4405C104.228 72.5238 104.089 72.6297 103.919 72.7622C103.402 73.1595 101.833 74.3704 101.829 74.9456C101.829 74.9721 101.829 75.0062 101.905 75.0629C102.097 75.2143 102.391 75.2749 102.701 75.343L102.893 75.3846C106.956 76.289 109.004 80.5311 109.226 84.3304C109.426 87.7551 108.494 91.6074 106.458 95.7851C105.681 97.382 104.756 98.9108 103.719 100.326C101.645 103.145 99.3813 105.344 96.9899 106.854C93.282 109.336 88.601 110.581 84.7875 110.101C81.8076 109.862 78.8994 108.795 76.3986 107.017L76.3571 106.986C75.3047 106.233 74.5579 105.582 73.8864 104.504C73.645 104.114 73.4489 104.031 73.3131 104.031L73.3018 104.027Z",fill:t}),jsxRuntimeExports.jsx("path",{d:"M42.6391 109.855C45.0608 109.813 47.4748 109.28 49.6664 108.258C50.7451 107.758 51.8126 107.206 52.7594 106.479C53.2045 106.139 53.5779 105.734 53.891 105.268C54.1814 104.844 54.3549 104.065 54.7133 103.724C55.6412 102.839 56.8973 104.969 57.2858 105.563C58.2854 107.096 58.904 108.833 58.7946 110.687C58.7229 111.925 58.3344 113.139 57.7007 114.203C57.2556 114.948 55.7619 115.955 55.6676 116.632C55.479 117.957 57.0104 119.292 57.5611 120.386C58.3684 121.994 57.9233 124.272 57.2103 125.847C56.6257 127.145 55.7091 128.265 54.5775 129.116C54.155 129.438 53.7627 129.945 53.2422 129.68C52.816 129.464 52.684 128.734 52.4237 128.367C51.6542 127.292 50.7942 126.286 49.8587 125.358C48.3914 123.909 46.7317 122.638 44.9287 121.631C43.1257 120.624 40.821 120.689 38.7502 120.273C36.1136 119.747 33.4619 119.217 30.9459 118.267C25.3634 116.155 20.1807 111.664 16.6689 106.88C13.8324 103.02 11.5994 98.1351 10.5696 93.4465C10.1849 91.6982 9.6983 89.9802 9.07215 88.3076C8.22345 86.0409 7.26914 83.7022 5.88481 81.6739C5.19077 80.656 4.37979 79.7137 3.41793 78.938C2.82195 78.4611 0.479544 77.6324 0.498404 76.8302C0.521036 75.8425 1.55079 74.6808 2.22598 74.0223C4.40242 71.8994 7.54826 71.6799 10.2867 72.7054C10.9695 72.9627 11.5579 73.485 12.1916 73.8331C13.1082 74.3364 13.5269 74.3894 14.0738 73.4055C15.2544 71.275 18.2079 70.2457 20.5239 70.556C22.1082 70.7717 23.5453 71.555 24.7863 72.5465C24.9711 72.6978 27.9246 75.3846 27.5285 75.4489C24.5336 75.9068 22.0101 78.2152 20.8219 81.0079C19.6337 83.8006 19.6526 87.002 20.373 89.9537C22.557 98.873 29.9011 107.864 39.2028 109.567C40.3344 109.775 41.4849 109.866 42.6391 109.851V109.855Z",fill:t}),jsxRuntimeExports.jsx("path",{d:"M53.5363 130.259C53.3741 130.259 53.2006 130.221 53.0157 130.127C52.5819 129.907 52.3783 129.434 52.2161 129.056C52.1482 128.904 52.0803 128.745 52.0199 128.658C51.2768 127.618 50.4319 126.63 49.5115 125.718C48.0442 124.269 46.4223 123.039 44.6909 122.07C43.5292 121.423 42.1335 121.249 40.6587 121.063C39.9986 120.98 39.3158 120.897 38.6595 120.765C36.038 120.242 33.3297 119.697 30.776 118.732C25.5594 116.761 20.1352 112.439 16.2727 107.172C13.3796 103.232 11.1239 98.2638 10.0866 93.5487C9.67927 91.7058 9.19645 90.0483 8.60802 88.4779C7.83099 86.4042 6.88799 84.0163 5.47727 81.9502C4.74927 80.8868 3.95338 80.0013 3.10845 79.324C2.96134 79.2067 2.59546 79.0174 2.24089 78.8358C1.12816 78.272 -0.0223034 77.6816 0.000328567 76.8188C0.0267325 75.6987 1.03763 74.484 1.87878 73.6628C4.03259 71.5626 7.23879 71.029 10.4601 72.2362C10.9316 72.414 11.3465 72.6903 11.7425 72.959C11.9802 73.1179 12.2027 73.2693 12.4291 73.3904C13.2099 73.818 13.2778 73.8066 13.6361 73.1595C14.9865 70.7187 18.2266 69.7386 20.5917 70.0603C22.1004 70.2646 23.613 70.9723 25.0954 72.1567C25.1294 72.1832 28.2526 74.764 28.0451 75.5511C27.9885 75.7593 27.8226 75.9106 27.6076 75.9447C24.9521 76.3496 22.4663 78.4158 21.2782 81.2047C19.9466 84.3266 20.3125 87.6227 20.8557 89.8364C22.8775 98.0897 29.8557 107.35 39.2894 109.079C40.3795 109.28 41.5074 109.37 42.6276 109.355C45.0002 109.317 47.3577 108.78 49.4512 107.804C50.3942 107.365 51.4918 106.82 52.4537 106.082C52.846 105.783 53.1779 105.423 53.4721 104.988C53.5664 104.848 53.6607 104.625 53.7513 104.409C53.9135 104.027 54.0794 103.63 54.3623 103.361C54.6414 103.092 54.9809 102.979 55.3393 103.017C56.1993 103.119 56.9386 104.107 57.61 105.155L57.6968 105.287C58.8585 107.07 59.3942 108.897 59.2848 110.718C59.2093 112.019 58.8057 113.313 58.123 114.46C57.9005 114.835 57.5119 115.209 57.097 115.607C56.7575 115.936 56.1842 116.485 56.154 116.704C56.056 117.404 56.6444 118.203 57.2177 118.978C57.5195 119.387 57.8062 119.777 58.0023 120.163C58.9038 121.957 58.4172 124.382 57.6628 126.055C57.0555 127.402 56.0899 128.602 54.8753 129.521C54.7999 129.578 54.7282 129.642 54.6528 129.703C54.3774 129.937 54.0002 130.263 53.5287 130.263L53.5363 130.259ZM7.11054 72.6033C5.36788 72.6033 3.7761 73.2087 2.5766 74.3818C1.58834 75.343 1.015 76.2399 0.999907 76.8415C1.07912 77.1216 2.21072 77.7006 2.69353 77.9503C3.12731 78.1736 3.50451 78.3666 3.73083 78.5482C4.6512 79.2899 5.51499 80.2473 6.29579 81.3901C7.77064 83.5471 8.74381 85.9993 9.53971 88.1297C10.1432 89.7418 10.6411 91.4447 11.0598 93.3368C12.0669 97.9232 14.2585 102.752 17.0724 106.585C20.8255 111.701 26.0799 115.894 31.1231 117.802C33.6013 118.736 36.2681 119.27 38.8481 119.788C39.4705 119.913 40.1344 119.996 40.7756 120.076C42.2844 120.265 43.8422 120.458 45.1737 121.2C46.9843 122.214 48.6779 123.493 50.2094 125.01C51.1712 125.96 52.0539 126.993 52.8309 128.083C52.9554 128.257 53.0421 128.465 53.1289 128.666C53.2194 128.874 53.3552 129.184 53.4684 129.245C53.5627 129.294 53.6532 129.256 54.0078 128.95C54.0983 128.874 54.185 128.798 54.2756 128.73C55.3581 127.913 56.2144 126.849 56.7538 125.65C57.3837 124.257 57.8552 122.104 57.1121 120.621C56.9575 120.31 56.6934 119.958 56.4181 119.58C55.758 118.687 55.0111 117.673 55.1695 116.568C55.2487 116.008 55.8145 115.463 56.4105 114.891C56.7575 114.558 57.1159 114.21 57.2705 113.953C57.8703 112.943 58.2248 111.807 58.2927 110.668C58.387 109.068 57.908 107.444 56.8632 105.847L56.7726 105.707C56.0824 104.629 55.5618 104.065 55.2223 104.023C55.1808 104.023 55.1318 104.023 55.0526 104.095C54.9206 104.22 54.7886 104.534 54.6716 104.81C54.5622 105.072 54.4491 105.34 54.2982 105.56C53.9512 106.078 53.5325 106.525 53.0572 106.884C52.0199 107.679 50.8619 108.258 49.8699 108.716C47.6519 109.749 45.1511 110.316 42.6427 110.358C41.4546 110.381 40.2626 110.279 39.1084 110.067C29.2559 108.262 21.9797 98.646 19.8825 90.0786C19.3054 87.7173 18.9207 84.1904 20.3578 80.8149C21.5724 77.9654 24.0204 75.7933 26.7249 75.1046C26.0535 74.378 24.7031 73.1293 24.4693 72.9401C23.1302 71.8729 21.7798 71.2372 20.4521 71.0555C18.3926 70.7755 15.6013 71.6724 14.5037 73.6515C13.7078 75.0857 12.8402 74.7678 11.9462 74.2759C11.6822 74.1321 11.4295 73.9618 11.1843 73.7953C10.8184 73.5493 10.4714 73.3147 10.1055 73.1785C9.08707 72.7963 8.0724 72.607 7.103 72.607L7.11054 72.6033Z",fill:t}),jsxRuntimeExports.jsx("path",{d:"M86.4924 20.972C84.0293 21.006 81.3851 21.5017 79.0918 22.5348C77.8809 23.0797 76.7116 23.7874 75.795 24.7637C75.1425 25.4562 74.4484 27.7305 73.3244 26.8639C71.6157 25.547 70.5105 23.4733 70.3671 21.3201C70.2125 19.0382 71.163 17.4754 72.3399 15.659C73.6035 13.7063 72.4342 12.7981 71.7892 10.8871C71.0121 8.5939 71.2988 6.20608 72.5624 4.18911C73.3055 3.00467 75.1161 0.170315 76.655 1.95645C79.6538 5.44168 82.8675 9.01016 87.6127 10.0849C93.0821 11.3261 98.4987 12.0072 103.244 15.3033C107.819 18.4857 111.829 22.7392 114.579 27.6775C117.442 32.8202 118.181 38.9317 120.312 44.4149C121.372 47.1396 122.794 49.762 124.94 51.7827C125.642 52.4412 128.207 53.5954 128.463 54.3711C128.776 55.3172 127.313 56.547 126.725 57.1071C125.536 58.2461 123.99 59.0143 122.357 59.23C120.237 59.5138 116.891 58.8175 115.737 56.7854C115.137 57.0238 114.854 57.5423 114.45 58.0266C113.881 58.704 113.179 59.2641 112.41 59.6917C110.931 60.5053 109.162 60.8269 107.506 60.4523C106.073 60.1306 104.783 59.3511 103.727 58.3445C103.372 58.0077 101.388 56.3805 101.452 55.9983C101.603 55.1128 104.153 54.4241 104.847 53.9851C106.152 53.1488 107.303 51.9303 108.08 50.5907C109.596 47.991 109.66 44.888 109.03 42.012C107.687 35.8778 103.625 30.0086 99.023 25.8498C98.7137 25.5697 98.4006 25.2973 98.08 25.0324C94.8625 22.4024 90.7095 20.9455 86.5603 20.9833H86.4962L86.4924 20.972Z",fill:t}),jsxRuntimeExports.jsx("path",{d:"M108.905 61.1031C108.392 61.1031 107.887 61.0501 107.397 60.9366C105.967 60.6149 104.579 59.8429 103.383 58.7039C103.319 58.6433 103.191 58.5298 103.032 58.3936C101.286 56.8686 100.879 56.3804 100.962 55.9074C101.113 55.0219 102.452 54.4694 103.632 53.985C104.028 53.8223 104.405 53.6671 104.579 53.5574C105.809 52.7665 106.903 51.6237 107.649 50.3333C109.271 47.5519 109.03 44.3278 108.543 42.114C107.333 36.574 103.738 30.7804 98.6871 26.2129C98.3477 25.9064 98.0459 25.6453 97.763 25.4107C94.6964 22.9056 90.683 21.4751 86.7186 21.4751C86.6658 21.4751 86.613 21.4751 86.5602 21.4751H86.315C83.8293 21.5319 81.3473 22.0692 79.2991 22.9926C77.96 23.5943 76.934 24.2868 76.1608 25.1079C76.0175 25.2593 75.8364 25.5696 75.6629 25.8686C75.2442 26.5838 74.7689 27.3974 74.0409 27.5412C73.7995 27.5866 73.4299 27.579 73.0225 27.2649C71.2044 25.8648 70.0275 23.6548 69.8691 21.3578C69.6994 18.8186 70.8272 17.0741 71.9211 15.3902C72.7132 14.1679 72.4001 13.5019 71.8796 12.4007C71.6947 12.0071 71.4873 11.5644 71.3138 11.0535C70.4877 8.62027 70.7819 6.08866 72.1398 3.92789C72.7358 2.97806 73.9806 1.00272 75.4403 0.892977C75.8439 0.862703 76.4512 0.964876 77.0283 1.63846C80.2723 5.4075 83.3125 8.60892 87.7182 9.60416C88.6235 9.8085 89.525 9.99771 90.4227 10.1869C95.0811 11.167 99.483 12.0941 103.523 14.8982C108.328 18.2397 112.3 22.5763 115.009 27.439C116.766 30.5988 117.747 34.1483 118.694 37.5844C119.305 39.8019 119.939 42.0951 120.772 44.237C121.987 47.3589 123.462 49.7089 125.276 51.4193C125.506 51.635 126.053 51.9605 126.581 52.2784C127.871 53.0503 128.731 53.6028 128.931 54.2121C129.312 55.37 128.026 56.5696 127.256 57.2848L127.064 57.4665C125.785 58.6925 124.137 59.4986 122.417 59.7256C120.399 59.9943 117.083 59.4456 115.578 57.4551C115.408 57.5989 115.265 57.7881 115.095 58.0076C115.009 58.1211 114.922 58.2347 114.828 58.3444C114.232 59.0558 113.496 59.6537 112.647 60.123C111.482 60.7625 110.177 61.0993 108.905 61.0993V61.1031ZM101.98 55.9944C102.244 56.3804 103.315 57.3151 103.685 57.6368C103.859 57.7881 103.994 57.9092 104.066 57.9773C105.13 58.9915 106.356 59.6764 107.612 59.9602C109.079 60.2932 110.742 60.0321 112.164 59.2488C112.908 58.8363 113.549 58.3179 114.066 57.7011C114.149 57.5989 114.228 57.4967 114.307 57.3946C114.613 57.001 114.956 56.5507 115.552 56.3161L115.955 56.1571L116.17 56.5318C117.211 58.3595 120.399 58.9839 122.292 58.7266C123.805 58.526 125.253 57.8184 126.381 56.7361C126.441 56.6794 126.509 56.615 126.585 56.5431C127.06 56.1004 128.173 55.0635 127.992 54.5148C127.882 54.2083 126.709 53.5044 126.076 53.126C125.449 52.7514 124.906 52.4259 124.601 52.1346C122.673 50.3182 121.119 47.8509 119.852 44.5851C118.999 42.3941 118.362 40.0744 117.743 37.8341C116.812 34.4587 115.85 30.9659 114.149 27.912C111.516 23.1818 107.649 18.9587 102.965 15.7043C99.0907 13.0137 94.7869 12.1093 90.2266 11.1481C89.325 10.9589 88.416 10.7659 87.507 10.5616C82.4223 9.41117 79.0162 5.45291 76.2815 2.2742C75.9118 1.84281 75.6176 1.86551 75.5233 1.87308C74.5615 1.94498 73.4223 3.76139 72.9923 4.44632C71.8004 6.34598 71.5401 8.57486 72.2681 10.7167C72.4227 11.1746 72.6113 11.5757 72.7924 11.9617C73.3431 13.131 73.8599 14.236 72.766 15.9237C71.5325 17.8272 70.7367 19.2273 70.8762 21.2784C71.012 23.2953 72.0455 25.2328 73.6411 26.4627C73.7769 26.5686 73.8372 26.5535 73.8599 26.5497C74.1465 26.493 74.5464 25.808 74.8104 25.3539C75.0216 24.9906 75.2216 24.6501 75.4441 24.4117C76.3117 23.4921 77.4395 22.7277 78.8993 22.0692C81.1172 21.0702 83.8179 20.4988 86.4961 20.461H86.7073H86.7111H86.7337C90.9168 20.461 95.1603 21.9709 98.4005 24.6236C98.6985 24.8658 99.0115 25.1382 99.3623 25.4561C104.564 30.1598 108.268 36.1464 109.524 41.8832C110.275 45.3117 109.928 48.4034 108.517 50.8214C107.691 52.2443 106.484 53.512 105.122 54.3861C104.873 54.5451 104.477 54.7078 104.017 54.897C103.508 55.1051 102.225 55.6311 101.988 55.9831L101.98 55.9944Z",fill:t}),jsxRuntimeExports.jsx("path",{d:"M21.9497 60.0663C21.1991 60.2479 20.4183 60.316 19.6413 60.2517C18.0759 60.1193 16.469 59.23 15.3261 58.1893C15.0243 57.9169 14.3265 56.6681 14.0436 56.5697C13.3835 56.3389 13.3194 56.8838 12.7687 57.2546C9.20414 59.6387 3.26702 59.2527 1.39234 54.882C0.928386 54.0381 0.962334 53.83 1.66392 53.1375C2.36552 52.4487 3.46694 52.2709 4.25906 51.7184C5.56417 50.8064 6.35252 49.2095 7.14463 47.8547C9.84538 43.2305 10.9204 37.5693 12.5612 32.5212C14.4887 26.5763 18.3512 21.3731 23.1039 17.3845C25.4464 15.4168 28.0717 13.5663 30.9044 12.3894C34.22 11.012 37.8298 10.6903 41.3378 10.1075C44.7665 9.53992 47.6898 7.85217 50.0549 5.3092C50.7678 4.53723 51.4203 3.71985 52.0729 2.8949C52.0729 2.8949 52.0729 2.88733 52.0804 2.88355C52.7518 1.99805 53.1743 1.32068 53.9136 0.605469C54.7661 1.04443 55.86 2.33862 56.5012 3.11438C57.7195 4.58264 58.2891 6.53528 58.1797 8.43494C58.1232 9.41504 57.8931 10.4141 57.4555 11.292C57.0934 12.0148 56.0561 12.8359 56.0448 13.6458C56.0297 14.7734 57.9685 16.6845 58.5947 17.5851C59.5603 18.9852 59.0548 21.7893 58.523 23.2424C58.176 24.1847 57.6705 25.0551 57.0217 25.8157C56.7766 26.1071 56.1844 27.3294 55.8109 27.371C55.0301 27.458 54.0343 25.0815 53.6496 24.5783C52.6953 23.3295 51.145 22.3872 49.7003 21.7931C46.5243 20.4876 42.8805 20.4535 39.5423 21.0552C36.3474 21.6304 33.4543 22.9965 30.9308 25.0248C29.4824 26.1903 28.1471 27.4959 26.9514 28.9149C24.0998 32.3018 21.6593 36.6876 20.8294 41.0697C20.3843 43.4121 20.3881 45.8491 20.8521 48.1878C21.0633 49.236 21.2934 50.7118 21.9007 51.6124C22.508 52.5131 23.666 52.9861 24.6014 53.5651C25.4313 54.0722 27.106 54.3522 27.653 55.2036C28.2754 56.1724 26.114 57.4855 25.337 58.1742C24.4053 59.0938 23.2171 59.7446 21.9459 60.0549L21.9535 60.0701L21.9497 60.0663Z",fill:t}),jsxRuntimeExports.jsx("path",{d:"M20.218 60.7777C20.0106 60.7777 19.8069 60.7701 19.5994 60.7512C18.0755 60.6226 16.3555 59.8052 14.99 58.5602C14.8203 58.405 14.6166 58.1099 14.379 57.7655C14.2168 57.5309 13.9527 57.1449 13.832 57.0276C13.7755 57.0125 13.7528 57.0162 13.7528 57.0162C13.7189 57.0314 13.6246 57.1336 13.5642 57.2017C13.436 57.3417 13.2775 57.5158 13.0475 57.6709C10.8559 59.1354 7.8157 59.6008 5.29601 58.8516C3.27799 58.2537 1.73524 56.9216 0.943125 55.1052C0.384869 54.0835 0.460309 53.6256 1.31278 52.7817C1.78428 52.3201 2.36894 52.0703 2.93474 51.8281C3.31571 51.6654 3.67405 51.514 3.97204 51.3059C5.01311 50.5793 5.7147 49.3457 6.39366 48.1537C6.49927 47.9683 6.60489 47.7828 6.71051 47.6012C8.63045 44.3127 9.73187 40.4377 10.7956 36.6914C11.203 35.2572 11.6254 33.7776 12.0818 32.3661C13.9452 26.6255 17.6417 21.3125 22.7792 17.0023C25.6044 14.6296 28.1996 12.9722 30.7079 11.9277C33.42 10.8 36.3358 10.3649 39.1572 9.94104C39.8588 9.83508 40.5566 9.73291 41.2544 9.6156C44.4795 9.08203 47.316 7.51917 49.6848 4.96863C50.394 4.20422 51.0579 3.36792 51.6425 2.62622L51.6991 2.55054C51.8537 2.34619 51.9971 2.14941 52.1329 1.96399C52.5817 1.34717 52.9703 0.813599 53.5587 0.249756L53.8152 0L54.132 0.16272C54.9958 0.609253 56.0029 1.74451 56.878 2.79651C58.1379 4.31018 58.7904 6.37634 58.6697 8.46521C58.6056 9.57019 58.3378 10.626 57.8927 11.519C57.7343 11.8331 57.4853 12.1434 57.2439 12.4462C56.9158 12.8549 56.5423 13.3203 56.5386 13.6571C56.531 14.3004 57.6098 15.5946 58.2548 16.3666C58.5566 16.7299 58.8206 17.0439 58.9979 17.3013C60.1484 18.9663 59.492 22.0277 58.9828 23.4165C58.6207 24.4117 58.0851 25.3275 57.391 26.1411C57.342 26.2017 57.2288 26.3871 57.127 26.5498C56.663 27.3142 56.3198 27.8175 55.8558 27.8667C55.0222 27.9575 54.3772 26.9131 53.6266 25.5356C53.4795 25.2632 53.3248 24.9832 53.2456 24.8772C52.197 23.4998 50.4506 22.6407 49.5038 22.251C46.026 20.8168 42.2125 21.0741 39.6249 21.5433C36.5621 22.0958 33.7406 23.3976 31.236 25.4108C29.8253 26.546 28.5089 27.8326 27.3282 29.2366C24.2503 32.8921 22.0588 37.2401 21.3157 41.1605C20.8819 43.4386 20.8894 45.834 21.3383 48.0894L21.41 48.4564C21.5948 49.4176 21.8287 50.6172 22.3115 51.3324C22.7075 51.9227 23.4431 52.3314 24.1522 52.7288C24.3936 52.865 24.635 52.9974 24.8613 53.1375C25.1141 53.2926 25.4913 53.4326 25.8873 53.584C26.7059 53.8943 27.63 54.2424 28.0713 54.9312C28.8182 56.0967 27.2641 57.2963 26.2344 58.0909C26.0156 58.2612 25.8081 58.4202 25.6648 58.5451C24.8387 59.3662 23.8014 59.9906 22.6585 60.3652L22.6698 60.3879L22.0701 60.5507C21.459 60.702 20.8404 60.7739 20.2218 60.7739L20.218 60.7777ZM13.7566 56.0172C13.8886 56.0172 14.0395 56.0437 14.2092 56.1005C14.4997 56.2026 14.7222 56.4978 15.205 57.2017C15.3635 57.4325 15.5785 57.7466 15.6615 57.8223C16.8685 58.9235 18.3735 59.6462 19.6862 59.756C20.252 59.8014 20.8215 59.7749 21.3911 59.6765L21.8249 59.5706C23.0319 59.2754 24.122 58.6699 24.9821 57.8185C25.1707 57.652 25.3894 57.4817 25.6233 57.3001C26.1778 56.8687 27.4829 55.8658 27.2302 55.4723C26.9661 55.0636 26.2042 54.776 25.5328 54.5225C25.0914 54.356 24.6727 54.197 24.337 53.9927C24.1183 53.8602 23.8919 53.7316 23.6619 53.6029C22.8471 53.1488 22.0097 52.6796 21.4779 51.8925C20.8819 51.007 20.6292 49.6976 20.4255 48.6456L20.3538 48.2861C19.8823 45.9059 19.871 43.3781 20.3312 40.9751C21.1044 36.8882 23.379 32.3737 26.5625 28.5895C27.7846 27.1364 29.1463 25.8043 30.6099 24.6312C33.2465 22.5121 36.2188 21.1422 39.4439 20.5595C42.1597 20.0675 46.1769 19.8026 49.881 21.3276C50.9221 21.7553 52.842 22.7089 54.0377 24.2717C54.1622 24.4382 54.3131 24.7107 54.5017 25.0551C54.7469 25.5016 55.3692 26.6482 55.7163 26.8488C55.8785 26.6823 56.1425 26.2509 56.2783 26.0276C56.4216 25.7968 56.531 25.6113 56.6329 25.494C57.2477 24.7675 57.723 23.9539 58.0474 23.0721C58.583 21.6115 58.979 19.0306 58.1794 17.8727C58.0247 17.6532 57.7645 17.3391 57.4891 17.0061C56.5687 15.9049 55.5277 14.6523 55.539 13.642C55.5465 12.957 56.0369 12.3516 56.4669 11.8142C56.6857 11.5417 56.8894 11.2882 57.0025 11.0687C57.3873 10.2968 57.6173 9.3772 57.6739 8.40845C57.7795 6.57312 57.21 4.7605 56.1086 3.43982C55.6785 2.92139 54.7431 1.78992 53.9774 1.245C53.5889 1.66126 53.2796 2.0813 52.9363 2.55811C52.7967 2.7511 52.6496 2.95166 52.4912 3.16357L52.4573 3.21277C52.4573 3.21277 52.4497 3.22034 52.4497 3.22412L52.4422 3.23169C51.8387 3.99609 51.1559 4.85889 50.4166 5.65735C47.8932 8.37439 44.868 10.0394 41.4166 10.6071C40.715 10.7244 40.0135 10.8303 39.3081 10.9363C36.547 11.3488 33.6916 11.7802 31.0927 12.8586C28.6748 13.8615 26.1665 15.4697 23.4204 17.7743C18.4263 21.9634 14.8354 27.1174 13.0324 32.6802C12.5797 34.0728 12.161 35.5448 11.7574 36.9677C10.6749 40.7745 9.55836 44.7139 7.57429 48.1083C7.47245 48.2861 7.36683 48.4678 7.26122 48.6532C6.5634 49.8831 5.76751 51.2756 4.54161 52.1309C4.16064 52.3958 3.7344 52.5774 3.32325 52.7515C2.82158 52.9672 2.34253 53.1677 2.0106 53.497C1.65855 53.8451 1.59694 54.2273 1.82577 54.6436L1.8484 54.689C2.70465 56.6795 4.34924 57.5309 5.57891 57.898C7.82324 58.564 10.5391 58.1515 12.493 56.8422C12.625 56.7551 12.7231 56.6454 12.8287 56.5281C13.0211 56.3162 13.2926 56.0172 13.7566 56.0172Z",fill:t}),jsxRuntimeExports.jsx("path",{d:"M64.3091 7.02335C67.2362 6.89468 70.2123 9.07437 69.7332 12.5369C69.7747 14.6333 68.4168 16.6919 66.4742 17.4677C64.5279 18.2434 62.1327 17.6834 60.7295 16.1281C58.968 14.1754 58.9076 10.7508 60.6352 8.76407C61.6235 7.62881 62.9625 7.08011 64.3091 7.02335Z",fill:t}),jsxRuntimeExports.jsx("path",{d:"M64.6108 18.323C63.0228 18.323 61.4423 17.6645 60.3597 16.4649C58.436 14.3344 58.3908 10.5843 60.2617 8.43869C61.2763 7.27317 62.7059 6.5958 64.2902 6.52768C66.0781 6.44821 67.8396 7.15207 68.9825 8.41599C69.9972 9.53232 70.4385 11.0082 70.2348 12.571C70.265 14.8794 68.8015 17.0818 66.659 17.937C66.0026 18.1981 65.3048 18.3268 64.6108 18.3268V18.323ZM64.5617 7.51914C64.4825 7.51914 64.4071 7.51914 64.3279 7.52292C63.0228 7.57968 61.8421 8.13596 61.0085 9.09336C59.4507 10.8833 59.4884 14.0128 61.0953 15.7914C62.3551 17.1915 64.5391 17.6986 66.2855 17.0023C68.032 16.306 69.273 14.4291 69.2315 12.5445V12.5067L69.2352 12.4688C69.4616 10.8303 68.8203 9.72532 68.2394 9.08579C67.3417 8.09433 65.98 7.51914 64.558 7.51914H64.5617Z",fill:t}),jsxRuntimeExports.jsx("path",{d:"M64.2415 123.675C62.6459 123.633 61.0692 122.861 60.0734 121.495C59.006 120.034 58.7268 118.025 59.3567 116.326C59.964 114.68 61.5181 113.223 63.257 112.841C66.3613 112.156 69.1715 114.96 69.4393 117.87C69.5977 119.588 68.915 121.378 67.6061 122.498C66.6292 123.334 65.4334 123.709 64.2453 123.675H64.2415Z",fill:t}),jsxRuntimeExports.jsx("path",{d:"M64.3844 124.178C64.3316 124.178 64.2788 124.178 64.226 124.178C62.4268 124.129 60.7218 123.236 59.6694 121.794C58.5114 120.212 58.2059 117.998 58.8849 116.156C59.5714 114.294 61.2839 112.765 63.1435 112.356C64.573 112.042 66.0554 112.379 67.3228 113.31C68.7713 114.369 69.7671 116.103 69.9293 117.828C70.1066 119.735 69.3371 121.673 67.9226 122.884C66.9419 123.724 65.6895 124.182 64.3807 124.182L64.3844 124.178ZM64.1958 113.238C63.9167 113.238 63.6376 113.268 63.3622 113.329C61.8459 113.662 60.3899 114.967 59.8241 116.5C59.2583 118.036 59.511 119.879 60.4767 121.2C61.348 122.396 62.7625 123.137 64.2562 123.175C65.3765 123.205 66.4477 122.831 67.2776 122.119C68.4507 121.117 69.0881 119.504 68.941 117.919C68.8052 116.47 67.9641 115.013 66.7419 114.116C65.9574 113.541 65.0785 113.242 64.1958 113.242V113.238Z",fill:t}),jsxRuntimeExports.jsx("path",{d:"M6.89166 65.7236C7.08403 62.087 11.5199 58.912 15.4315 61.7691C20.931 65.7879 14.1113 74.2834 8.81161 69.8029C7.3707 68.5844 6.81999 67.1199 6.89543 65.7236H6.89166Z",fill:t}),jsxRuntimeExports.jsx("path",{d:"M12.0478 71.5778C10.7993 71.5778 9.57716 71.1085 8.48705 70.1852C7.04992 68.9705 6.30307 67.3773 6.39359 65.6972C6.50298 63.6159 7.85336 61.6594 9.82988 60.7172C11.7536 59.7976 13.9036 60.036 15.7255 61.3643C17.389 62.579 18.1698 64.297 17.9208 66.2042C17.6379 68.3839 16.0499 70.3933 13.9715 71.2031C13.3341 71.4529 12.6891 71.574 12.0516 71.574L12.0478 71.5778ZM7.3894 65.7501C7.31773 67.1276 7.92125 68.3991 9.13206 69.4208C10.49 70.5674 12.078 70.8701 13.6094 70.276C15.3332 69.6024 16.6987 67.8806 16.9325 66.0794C17.1287 64.5506 16.4912 63.1655 15.1371 62.1741C13.0625 60.6566 11.1878 61.1751 10.2561 61.6216C8.63039 62.3974 7.47993 64.0586 7.3894 65.7501Z",fill:t}),jsxRuntimeExports.jsx("path",{d:"M116.065 70.8588C114.82 70.8739 113.552 70.4236 112.462 69.3375C107.148 64.0397 115.627 57.7693 120.425 62.2422C124.118 65.682 120.214 70.8134 116.065 70.8588Z",fill:t}),jsxRuntimeExports.jsx("path",{d:"M116.012 71.3584C114.552 71.3584 113.206 70.7832 112.112 69.6933C109.294 66.8855 110.162 63.9414 111.757 62.2726C113.896 60.0399 117.951 59.2528 120.765 61.8752C122.322 63.3283 122.794 65.2583 122.058 67.1693C121.134 69.5685 118.615 71.3281 116.069 71.3584C116.05 71.3584 116.031 71.3584 116.008 71.3584H116.012ZM116.582 61.2206C115.02 61.2206 113.492 61.8979 112.478 62.9613C111.131 64.3652 110.512 66.6849 112.813 68.9781C113.715 69.8788 114.82 70.3518 116.012 70.3518H116.061C118.181 70.3291 120.361 68.8041 121.131 66.8022C121.719 65.2696 121.349 63.7787 120.086 62.6018C119.045 61.633 117.8 61.2168 116.582 61.2168V61.2206Z",fill:t})]})};const BirdieBadge=({elClass:s})=>jsxRuntimeExports.jsx("svg",{className:s,xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 174.72 194.88",children:jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{className:"st0",d:"M130.45,11.77c0.46,0.35,0.91,0.71,1.37,1.05c1.5,1.13,1.19,3.01,0.19,4.2c-3.33,3.96-6.64,7.93-9.98,11.88 c-2.86,3.38-5.76,6.72-8.63,10.09c-2.64,3.1-5.25,6.22-7.87,9.32c-0.2,0.23-0.4,0.48-0.66,0.63c-3.33,1.93-5.53,4.97-7.89,7.87 c-1.89,2.33-3.82,4.62-5.71,6.95c-2.98,3.67-5.93,7.36-8.92,11.03c-2.29,2.82-4.63,5.59-6.92,8.41 c-2.99,3.67-5.94,7.36-8.92,11.03c-1.97,2.42-3.97,4.81-5.96,7.21c-1.16,1.4-2.26,2.85-3.49,4.18c-0.73,0.78-1.57,1.64-2.53,2 c-4.53,1.68-8.98,1.48-13.03-1.32c-2.92-2.02-3.96-5.1-1.97-8.34c0.76-1.23,2.01-1.54,3.35-1.67c3.8-0.38,7.21,1.01,10.67,2.23 c2.68,0.94,2.65,0.89,4.37-1.3c1.81-2.29,3.69-4.52,5.56-6.76c2.45-2.94,4.91-5.88,7.38-8.8c2.35-2.78,4.74-5.52,7.08-8.3 c2.29-2.72,4.52-5.47,6.8-8.19c1.91-2.27,3.86-4.5,5.77-6.77c2.95-3.5,5.92-6.99,8.81-10.55c0.59-0.73,0.71-1.84,1.27-2.61 c1.68-2.28,3.44-4.51,5.23-6.7c2.48-3.02,5.01-6,7.54-8.98c2.38-2.8,4.78-5.59,7.17-8.38c2.31-2.7,4.61-5.42,6.93-8.11 c0.4-0.47,0.89-0.86,1.34-1.28C129.33,11.77,129.89,11.77,130.45,11.77z"}),jsxRuntimeExports.jsx("path",{className:"st0",d:"M46.19,11.77c1.17,1.31,2.38,2.59,3.52,3.93c2.48,2.92,4.91,5.88,7.38,8.8c2.35,2.78,4.74,5.52,7.08,8.3 c3.31,3.92,6.59,7.87,9.88,11.81c0.15,0.18,0.29,0.39,0.35,0.61c0.88,3.24,3.41,5.33,5.42,7.77c2.03,2.47,4.09,4.91,6.13,7.37 c-0.82,0.98-1.63,1.95-2.5,2.99c-0.2-0.15-0.45-0.27-0.61-0.47c-2.07-2.44-4.02-4.99-6.21-7.31c-2.11-2.24-3.61-5.06-6.56-6.55 c-1.16-0.59-1.96-1.94-2.86-2.99c-1.99-2.34-3.95-4.72-5.92-7.09c-2.35-2.82-4.68-5.66-7.04-8.46c-2.34-2.78-4.72-5.53-7.08-8.3 c-1.47-1.71-2.97-3.39-4.39-5.14c-1.56-1.93-0.92-4.12,1.4-5.02c0.13-0.05,0.22-0.17,0.33-0.26 C45.07,11.77,45.63,11.77,46.19,11.77z"}),jsxRuntimeExports.jsx("path",{className:"st0",d:"M32.53,172.31c0.46-1.42,0.95-2.84,1.38-4.27c2.69-8.85,5.38-17.7,8.02-26.56c0.18-0.61,0.18-1.35,0.02-1.97 c-0.79-3.25-1.64-6.49-2.53-9.72c-0.21-0.75-0.03-1.16,0.66-1.38c1.85-0.58,3.7-1.14,5.67-1.74c4.19,15.17,8.18,30.29,12.41,45.35 c0.2,0,0.4-0.01,0.6-0.01c0.35-1.18,0.74-2.35,1.06-3.55c1.52-5.74,3.03-11.48,4.54-17.22c1.11-4.23,2.27-8.46,3.27-12.72 c0.35-1.49,0.39-3.09,0.36-4.63c-0.02-0.68-0.42-1.58-0.94-1.96c-1.12-0.83-2.45-1.37-3.67-2.08c-0.27-0.16-0.61-0.48-0.64-0.75 c-0.17-2.02-0.15-2.02,1.93-2.02c3.36,0,6.72,0,10.08,0c0.12,0,0.24,0,0.36,0c1.92,0,1.95,0.01,1.77,1.94 c-0.03,0.32-0.38,0.77-0.68,0.87c-2.49,0.84-3.95,2.59-4.62,5.07c-2.52,9.27-5.05,18.54-7.58,27.82 c-1.27,4.65-2.63,9.28-3.74,13.97c-0.26,1.09,0.27,2.39,0.5,3.58c0.16,0.81,0.45,1.6,0.71,2.52c-0.4,0.09-0.74,0.23-1.07,0.24 c-1.72,0.02-3.44,0-5.16,0.01c-0.7,0.01-1.06-0.26-1.25-0.98c-1.35-5.08-2.74-10.15-4.13-15.23c-1.66-6.07-3.33-12.14-4.99-18.2 c-0.28-1-0.55-2.01-0.82-3.01c-0.14,0-0.27-0.01-0.41-0.01c-0.2,0.3-0.48,0.58-0.58,0.92c-2.18,7.13-4.35,14.26-6.52,21.39 c-0.85,2.78-1.77,5.55-2.54,8.35c-0.21,0.78-0.14,1.71,0.04,2.52c0.3,1.31,0.81,2.58,1.27,3.98c-0.05,0.03-0.15,0.14-0.25,0.14 c-2.19,0.04-4.38,0.09-6.57,0.06c-0.26,0-0.66-0.47-0.75-0.79c-1.41-5.48-2.77-10.97-4.17-16.45c-1.61-6.29-3.24-12.58-4.86-18.87 c-1.3-5.06-2.63-10.1-3.84-15.18c-0.29-1.2-0.88-1.7-2.01-1.77c-0.24-0.02-0.47-0.07-0.71-0.09c-1.28-0.09-1.98-1.3-1.34-2.41 c0.13-0.23,0.58-0.38,0.89-0.38c4.48-0.02,8.96-0.02,13.44-0.02c0.72,0,1.41,0.01,1.29,1.06c-0.09,0.81,0.32,1.87-1.2,1.75 c-0.71-0.05-1.43,0.14-2.14,0.2c-0.95,0.08-1.19,0.53-0.96,1.46c1.51,6.15,2.98,12.31,4.45,18.47c1.67,7.02,3.31,14.04,4.98,21.06 c0.1,0.43,0.33,0.82,0.5,1.23C32.22,172.31,32.38,172.31,32.53,172.31z"}),jsxRuntimeExports.jsx("path",{className:"st0",d:"M160.22,182.52c-3.16-0.21-6.16-0.56-9.17-0.59c-8.72-0.08-17.44-0.02-26.16-0.04 c-0.47,0-1.28-0.16-1.34-0.39c-0.16-0.67-0.06-1.42,0.04-2.12c0.02-0.13,0.53-0.24,0.82-0.28c0.87-0.11,1.75-0.17,2.62-0.26 c0.85-0.09,1.23-0.48,1.22-1.41c-0.03-13.11-0.02-26.23-0.02-39.34c0-2.27,0.04-4.55-0.05-6.82c-0.02-0.38-0.57-0.95-0.98-1.07 c-0.83-0.24-1.74-0.34-2.61-0.29c-1.57,0.09-1.03-1.01-1.12-1.78c-0.12-0.99,0.42-1.08,1.23-1.08c8.12,0.02,16.24,0.02,24.36,0.01 c3.23,0,6.47,0.13,9.63-0.8c0.19-0.06,0.75,0.44,0.82,0.75c0.75,3.26,1.43,6.54,2.13,9.82c0.36,1.7,0.72,3.4,1.08,5.09 c-2.06,0.49-1.95,0.42-2.91-1.08c-1.46-2.28-2.91-4.59-4.67-6.63c-2.48-2.85-5.92-4.03-9.59-4.28c-2.87-0.2-5.76-0.01-8.64-0.03 c-1.1-0.01-1.51,0.4-1.5,1.57c0.06,6.16,0.05,12.32,0.01,18.48c-0.01,0.97,0.24,1.4,1.27,1.32c1.75-0.13,3.53-0.04,5.26-0.3 c2.07-0.31,3.56-1.59,4.34-3.55c0.5-1.25,0.89-2.56,1.23-3.87c0.24-0.92,0.73-1.21,1.63-1.16c1.02,0.06,0.95,0.72,0.95,1.42 c-0.01,5.8,0,11.6-0.01,17.4c0,0.6,0.21,1.35-0.83,1.38c-0.85,0.03-1.47-0.04-1.76-1.1c-0.45-1.64-0.99-3.29-1.75-4.81 c-0.93-1.87-2.72-2.67-4.73-2.81c-1.59-0.11-3.2-0.01-4.8-0.04c-0.74-0.01-1.06,0.19-1.05,1.02c0.04,7.48,0.03,14.96,0.04,22.44 c0,1.58,0.13,1.75,1.66,1.77c2.8,0.03,5.62,0.23,8.4-0.05c5.17-0.52,9.59-2.72,12.67-7.04c1.38-1.94,2.49-4.07,3.61-6.18 c0.53-1,1.24-0.62,1.95-0.52c0.89,0.12,0.64,0.8,0.52,1.3c-0.72,3.11-1.47,6.21-2.2,9.31c-0.49,2.06-0.96,4.12-1.44,6.17 C160.31,182.34,160.19,182.59,160.22,182.52z"}),jsxRuntimeExports.jsx("path",{className:"st0",d:"M114.88,165.82c-1.25,5.73-2.49,11.38-3.66,16.75c-2.89-0.23-5.61-0.6-8.33-0.64 c-7.12-0.09-14.24-0.03-21.36-0.03c-1.75,0-2.34-1.02-1.48-2.63c1.78-3.3,3.59-6.59,5.38-9.88c4.78-8.8,9.56-17.6,14.35-26.4 c2-3.68,4.04-7.34,6.05-11.02c0.29-0.53,0.5-1.11,0.78-1.76c-0.44-0.11-0.67-0.21-0.89-0.21c-3.23-0.08-6.43-0.34-9.66,0.39 c-4.38,1-7.51,3.53-9.77,7.27c-0.72,1.19-1.32,2.46-1.91,3.73c-0.26,0.57-0.56,0.91-1.17,0.59c-0.53-0.27-1.38-0.19-1.11-1.31 c1.08-4.57,2.08-9.16,3.14-13.88c1.04,0.08,2.09,0.24,3.14,0.24c8.16,0.03,16.32,0.03,24.48,0.06c0.64,0,1.79,0.1,1.83,0.31 c0.14,0.86,0.22,1.91-0.16,2.65c-1.98,3.87-4.1,7.67-6.17,11.5c-5.65,10.46-11.29,20.93-16.94,31.39 c-0.85,1.58-1.72,3.15-2.57,4.73c-0.56,1.04-0.39,1.43,0.77,1.4c3.42-0.08,6.85,0.33,10.26-0.52c4.06-1.02,7.32-3.11,9.61-6.59 c1.02-1.56,1.81-3.28,2.63-4.96C112.89,165.38,112.85,165.36,114.88,165.82z"}),jsxRuntimeExports.jsx("path",{className:"st0",d:"M91.47,66.91c2.16,2.54,4.22,4.94,6.24,7.35c2.28,2.72,4.53,5.47,6.81,8.19c1.9,2.27,3.85,4.51,5.76,6.77 c2.33,2.78,4.69,5.54,6.95,8.37c1.22,1.52,1.62,1.7,3.45,1.12c2.53-0.8,5.05-1.72,7.65-2.24c1.58-0.32,3.35-0.24,4.94,0.1 c2.25,0.48,3.63,3.45,2.93,5.67c-1.09,3.48-3.71,5.16-7.03,5.97c-2.47,0.6-4.93,0.63-7.46-0.09c-2.17-0.62-3.71-1.93-5.06-3.54 c-2.22-2.66-4.33-5.41-6.49-8.11c-2.61-3.26-5.22-6.51-7.86-9.75c-2.27-2.78-4.57-5.54-6.84-8.31c-2.1-2.56-4.19-5.13-6.25-7.72 c-0.15-0.19-0.15-0.7-0.01-0.9C89.9,68.82,90.66,67.91,91.47,66.91z"})]})})});const DeuceBadge=({elClass:s})=>jsxRuntimeExports.jsxs("svg",{className:s,xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 338.72 367.49",children:[jsxRuntimeExports.jsxs("g",{id:"d9ZjTm",children:[jsxRuntimeExports.jsx("g",{id:"d9ZjTm-2","data-name":"d9ZjTm",children:jsxRuntimeExports.jsx("path",{d:"m283.55.18c-12.5,1.54-23.09,5.38-32.56,12.09-4.98,3.53-9.05,8.08-13.33,12.4-13.51,13.61-21.94,30.05-26.75,48.43-2.13,8.14-3.54,16.48-5.78,24.59-3.77,13.62-7.92,27.13-11.95,40.67-.81,2.73-2.45,4.98-4.4,7.06-6.13,6.53-12.14,13.17-18.28,19.69-7.01,7.46-14.11,14.84-21.16,22.26-7.16,7.54-14.27,15.13-21.48,22.61-1.48,1.53-3.31,2.73-5.01,4.05-.53.42-1.16.71-1.71,1.11-2.79,2-3.33,4.86-1.16,7.48,2.11,2.55,4.46,4.93,7.54,6.36,2.56,1.19,4.56.45,5.64-2.15,1.25-2.99,3.38-5.32,5.53-7.63,5.82-6.27,11.67-12.52,17.55-18.74,12.28-12.99,24.58-25.95,36.89-38.92,2.45-2.58,4.98-5.07,7.43-7.64,2.02-2.12,4.58-3.3,7.25-4.3,17.07-6.39,34.26-12.37,51.74-17.55,10.85-3.22,21.64-6.63,31.62-12.19,5.79-3.23,11.06-7.13,16.16-11.32,6.54-5.38,12.49-11.4,17.71-18.02,8.27-10.47,12.72-22.53,13.53-35.87.38-6.34.18-12.65-1.85-18.74-2.44-7.33-6.11-13.91-11.62-19.46-4.4-4.43-9.12-8.35-14.74-11.15-8.79-4.38-18.08-5.83-26.8-5.09Zm-34.58,126.73c-1.5.15-3.01.37-4.51.45-5.83.28-11.21-1.26-16.23-4.17-3.2-1.85-6.21-3.99-8.41-6.99-3.31-4.54-4.97-9.6-5.46-15.32-.74-8.67.23-17.12,2.39-25.38,2.73-10.38,6.84-20.33,12.44-29.5,6.86-11.24,14.77-21.66,26.05-28.98,2.57-1.67,5.15-3.31,7.79-4.87,3.63-2.15,7.67-3.25,11.64-4.58,6.27-2.11,12.56-2.96,19.05-1.64,5.07,1.03,10.22,1.78,14.8,4.53,5.02,3.01,9.77,6.22,13.62,10.79,4.39,5.22,7.19,11.21,9.47,17.49,2.41,6.64,1.89,13.56.68,20.27-1.76,9.72-5.3,18.79-11.5,26.7-7.82,9.96-16.71,18.67-27.76,25-2.97,1.7-5.89,3.5-8.9,5.14-10.99,5.99-22.84,9.28-35.17,11.06Zm-45.01,16.56c-2.74.4-4.2-1.52-3.46-4.17,2.62-9.42,5.27-18.84,7.92-28.25.14-.5.23-1.09.56-1.43.38-.38,1.01-.72,1.51-.69.42.03.97.53,1.18.96.98,2.04,1.76,4.18,2.8,6.18,2.71,5.24,7.25,8.64,12.16,11.59,2.15,1.29,4.33,2.55,6.96,2.71.95.05,1.33,1.49.63,2.3-.34.4-.88.69-1.38.86-8.67,3-17.35,5.97-26.02,8.94-1.05.36-2.1.73-2.85.99Z"})}),jsxRuntimeExports.jsx("g",{id:"d9ZjTm-3","data-name":"d9ZjTm",children:jsxRuntimeExports.jsx("g",{id:"d9ZjTm-4","data-name":"d9ZjTm",children:jsxRuntimeExports.jsx("path",{d:"m53.41,2.16c12.54,1.09,23.27,4.55,32.97,10.92,5.11,3.35,9.34,7.76,13.77,11.91,13.98,13.12,22.99,29.25,28.46,47.45,2.42,8.06,4.12,16.34,6.65,24.37,4.25,13.47,8.88,26.83,13.39,40.22.91,2.7,2.62,4.89,4.65,6.89,6.36,6.31,12.61,12.72,18.97,19.03,7.27,7.2,14.63,14.32,21.94,21.49,7.42,7.28,14.8,14.61,22.28,21.83,1.53,1.48,3.41,2.61,5.15,3.87.55.4,1.18.67,1.75,1.04,2.86,1.9,3.5,4.74,1.42,7.43-2.02,2.62-4.28,5.08-7.31,6.63-2.52,1.28-4.54.61-5.72-1.95-1.35-2.95-3.57-5.2-5.79-7.43-6.04-6.06-12.11-12.1-18.2-18.11-12.73-12.54-25.49-25.06-38.25-37.58-2.54-2.49-5.16-4.89-7.7-7.37-2.1-2.05-4.7-3.14-7.4-4.04-17.28-5.78-34.68-11.14-52.33-15.7-10.96-2.83-21.87-5.86-32.03-11.06-5.9-3.02-11.31-6.73-16.55-10.74-6.72-5.15-12.89-10.94-18.35-17.37C6.54,83.73,1.65,71.84.37,58.53c-.61-6.32-.63-12.63,1.18-18.8,2.18-7.41,5.61-14.12,10.92-19.86,4.24-4.59,8.81-8.67,14.33-11.67,8.63-4.69,17.86-6.47,26.61-6.04Zm39.08,125.42c1.51.1,3.02.27,4.53.29,5.84.08,11.16-1.66,16.07-4.74,3.13-1.97,6.07-4.2,8.15-7.29,3.15-4.66,4.63-9.77,4.91-15.5.43-8.69-.84-17.1-3.3-25.28-3.09-10.28-7.56-20.07-13.48-29.04-7.26-10.99-15.53-21.12-27.07-28.03-2.63-1.57-5.27-3.12-7.96-4.59-3.71-2.02-7.78-2.97-11.8-4.17-6.34-1.88-12.66-2.51-19.1-.96-5.03,1.21-10.15,2.14-14.63,5.06-4.91,3.19-9.55,6.56-13.23,11.27-4.2,5.37-6.79,11.46-8.84,17.82-2.17,6.72-1.41,13.62.04,20.28,2.1,9.65,5.96,18.59,12.45,26.27,8.17,9.67,17.36,18.06,28.64,24,3.03,1.6,6.01,3.29,9.08,4.82,11.2,5.6,23.16,8.46,35.54,9.8Zm45.57,14.94c2.76.3,4.14-1.67,3.31-4.29-2.96-9.32-5.94-18.64-8.92-27.95-.16-.49-.27-1.09-.61-1.41-.39-.37-1.04-.68-1.53-.64-.42.04-.95.56-1.14,1-.91,2.07-1.61,4.24-2.58,6.28-2.53,5.34-6.94,8.89-11.74,12.01-2.1,1.37-4.23,2.71-6.86,2.95-.94.09-1.28,1.53-.55,2.32.35.38.9.66,1.41.81,8.77,2.69,17.55,5.34,26.32,8.01,1.06.32,2.12.66,2.88.89Z"})})})]}),jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{d:"m19.94,256.31h31.88v5.6l-9.02,1.09,20.06,83.66h.31l19.44-63.6-6.22-23.48,13.84-4.51,24.88,91.12h.31l13.84-52.56c1.24-4.82,4.67-12.75,4.67-23.64,0-3.42-5.75-8.09-10.73-8.09v-5.6h29.08v5.6c-5.6,1.24-9.02,3.89-11.04,11.35l-22.7,83.35,3.11,10.88h-15.24l-20.37-74.79h-.31l-19.59,63.91,3.58,10.88h-15.55l-26.75-104.49-7.46-1.09v-5.6Z"}),jsxRuntimeExports.jsx("path",{d:"m174.2,358.78c2.64.47,6.06.78,9.33.78,20.99,0,31.72-7.78,38.72-27.52l4.98.78-7.62,34.68c-3.11-1.09-5.91-1.55-8.86-1.87-3.11-.47-6.37-.47-10.57-.47h-43.54v-4.35l53.64-98.12c-2.49-.16-5.6-.78-8.4-.78-20.53,0-28.92,7.62-36.23,24.57l-4.82-1.24,6.84-30.17c2.18.62,4.66.93,7.15,1.09,2.49.16,4.98.16,7.15.16h44.94v5.29l-52.71,97.19Z"}),jsxRuntimeExports.jsx("path",{d:"m252.41,263l-9.33-1.09v-5.6h52.56c8.4,0,13.22-.31,19.44-2.33l6.84,32.19-4.82.93c-9.33-19.28-18.04-25.19-36.85-25.19-4.35,0-8.55,0-12.91.78v41.52h7.15c10.11,0,13.99-2.64,17.1-17.26h5.13v40.12h-5.13c-3.11-14.62-7-17.26-17.1-17.26h-7.46v48.98c4.35.78,8.55.78,12.91.78,20.06,0,31.41-8.71,39.65-27.83l5.44.62-8.4,35.14c-3.11-1.09-5.91-1.55-8.86-1.87-3.11-.47-6.38-.47-10.57-.47h-54.11v-5.6l9.33-1.09v-95.48Z"})]})]});const EvergreenBadgeSelector=({elClass:s,fillColor:a})=>jsxRuntimeExports.jsxs("svg",{id:"evergreen-icon",className:s,viewBox:"0 0 360 360",fill:a,xmlns:"http://www.w3.org/2000/svg",children:[jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("g",{id:"_x32_CHZWF_00000083798471038251661670000017429216492854860447_",children:jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{className:"st0",d:"M265.1,280.8c-1.3-3.7-3.7-6.5-6.8-8.9c-1.5-1.1-2.6-2.7-4.1-3.8c-1.9-1.5-3.9-2.9-6-4.1      c-1.7-1.1-3.5-2-5.4-2.9c-3.2-1.5-6.6-1.7-10.1-1.8s-6.9-0.4-10.4-0.7c-1.6-0.1-3.3-0.3-4.9-0.7c-2-0.5-3.9-1.3-5.8-2      c-0.2-0.1-0.4-0.3-0.6-0.5c0.2,0,0.4,0,0.7,0c0.8,0,1.5,0,2.3-0.1c1.9-0.4,3.8-0.8,5.7-1.2c1.2-0.2,2.4-0.3,3.6-0.5      c0.6-0.2,1.4-0.3,1.9-0.7c1.5-1.1,2.8-2.3,4.2-3.4c1.4-1.1,2.8-2.3,4.2-3.4c1.4-2.4,2.7-4.8,4.1-7.2c0.3-0.6,0.6-1.1,0.9-1.7      c1.1-2.9,3-5.2,5-7.5c1.8-2.1,3.6-4.3,3.9-7.2c-0.3-3.1-1-6-2.4-8.9c-1.4-2.9-3.6-5.2-5.9-7.3c-2.2-2-4.6-3.8-7.1-5.5      c-1.1-0.7-2.6-0.9-3.9-1c-2.1-0.2-4.2-0.4-6.3-0.3c-3.8,0.1-7.4,1.3-10.8,3.1c-1.2,0.7-2.6,1.1-3.8,1.8      c-2.7,1.7-5.3,3.4-7.8,5.3c-2.4,1.7-4.9,3.5-7.1,5.5c-2.5,2.3-4.7,4.9-7,7.4c-0.5,0.5-0.9,1.2-1.2,1.9c-0.9,2.1-2.6,1.3-4.1,1.3      c-0.3,0-0.6-0.1-0.9-0.1v18.1c1.7,0,1.8,1.7,2.2,2.7c1.3,3.1,3,5.9,5.1,8.7c1.9,2.6,4.2,4.6,6.9,6.2c2.1,1.3,4.1,2.7,6.2,4      c3.1,1.9,6.5,3,10.1,3.6c2.6,0.5,5.2,0.5,7.9,0.6c4,0.2,8,0.2,12,0.6c2.7,0.3,5.3,0.9,7.7,2.5c1.4,1,3.2,1.5,4.4,2.6      c1.7,1.5,3.1,3.5,4.4,5.3c1.1,1.4,2,3,2.9,4.5c0.6,1,2.4,1.3,3.4,0.6c1.4-1.1,3-1.5,4.7-1.4c1.8,0,3.6,0.1,5.4,0.2      C264.8,284.3,265.8,282.7,265.1,280.8z M208.8,240.7h-0.1c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c-0.5,0-1.1,0-1.6-0.1      c-0.5,0-0.9-0.2-1.2-0.4c-0.1,0-0.1-0.1-0.2-0.1c-0.2-0.1-0.4-0.2-0.6-0.3c-1.5-0.6-3.1-0.6-4.7-1c-0.9-0.3-1.8-0.6-2.7-0.8      c-0.2-0.1-0.5-0.1-0.7-0.2h-0.1c0,0,0,0-0.1,0c-0.3-0.1-0.6-0.2-0.9-0.3c-0.1,0-0.2-0.1-0.3-0.1s-0.2-0.1-0.3-0.1      s-0.2-0.1-0.3-0.1s-0.1-0.1-0.1-0.1l0,0c-1-0.6-1.9-1.3-2.8-2c-0.8-0.8,0.2-1,0.5-1.3c1.8-1.7,3.7-3.2,5.6-4.8      c0.6-0.5,1.3-0.9,2-1.4h0.1c0.2-0.2,0.5-0.4,0.7-0.6c0.2-0.2,0.5-0.3,0.7-0.5l0,0l0.1-0.1c0.3-0.2,0.5-0.4,0.8-0.6      c0.7-0.5,1.5-1.1,2.2-1.6c0.4-0.3,0.9-0.7,1.3-1c0.3-0.2,0.7-0.4,1-0.5l0,0c0.3-0.3,0.6-0.5,0.9-0.7c0.3-0.2,0.7-0.5,1-0.7      s0.7-0.4,1-0.6s0.6-0.3,0.8-0.4c0.2-0.2,0.4-0.3,0.7-0.3h0.1c0.1-0.1,0.3-0.1,0.4-0.2c0.3-0.3,0.7-0.5,1.1-0.6c0,0,0,0,0.1,0      s0.2-0.1,0.3-0.1c0.3-0.1,0.7-0.3,1-0.4c0.4-0.2,0.7-0.3,1.1-0.4c0.5-0.2,1-0.3,1.5-0.4c0.2-0.1,0.5-0.1,0.7-0.2      c0.1,0,0.4-0.2,0.5-0.2s0.2-0.1,0.2-0.1c0.2-0.1,0.4-0.2,0.6-0.3c0.7-0.3,1.3-0.6,2-0.8c0.8-0.3,1.6-0.4,2.4-0.5l0,0      c0.3-0.2,0.7-0.3,1.2-0.3l0,0c0.6-0.1,1.2-0.3,1.7-0.4c0.2-0.1,0.5-0.1,0.7-0.2c0.1,0,0.3-0.1,0.4-0.1l0,0      c0.2,0,0.4-0.1,0.6-0.1c0.3-0.1,0.5-0.1,0.9-0.1c0.1,0,0.3,0,0.4,0c0.5,0,1.1,0,1.7,0c1,0.1,1.9,0.1,2.9,0.2c0.2,0,0.4,0,0.5,0      c0.4,0,0.8,0.1,1.1,0.2c0.1,0,0.2,0.1,0.3,0.1c0.2,0.1,0.5,0.1,0.7,0.2c0.5,0,0.8,0.1,1.2,0.3h0.1c0.7,0.4,1.4,0.6,2,1.1      c0.8,0.6,1.9,1.3,1.4,2.6c-1,2.7-3,4.8-5,6.9c-0.1,0.2-0.2,0.4-0.4,0.5c-0.1,0.1-0.2,0.3-0.4,0.4c-0.1,0.1-0.2,0.2-0.3,0.3      c-0.2,0.3-0.4,0.6-0.6,0.9c-0.5,0.6-1,1.2-1.5,1.8c-0.3,0.3-0.5,0.5-0.8,0.7c-0.2,0.2-0.3,0.4-0.5,0.6c-0.1,0.1-0.2,0.3-0.3,0.4      c-0.1,0.1-0.1,0.1-0.2,0.1c-0.1,0.1-0.2,0.2-0.3,0.3c-0.4,0.4-0.8,0.8-1.2,1.2l-0.1,0.1c0,0,0,0-0.1,0.1s-0.2,0.1-0.2,0.2      c-0.3,0.3-0.6,0.6-1,0.9c-1,0.7-2,1.4-3,1.9h-0.1c-1,0.5-2,1-3,1.4c-0.1,0-0.2,0.1-0.3,0.1c-0.4,0.2-0.8,0.3-1.2,0.5      c-0.1,0.1-0.3,0.1-0.4,0.2c-0.2,0.1-0.3,0.1-0.5,0.2c-0.1,0.1-0.2,0.1-0.3,0.1c-0.2,0.1-0.3,0.1-0.5,0.2l0,0      c-0.2,0.1-0.3,0.1-0.5,0.2c-0.1,0.1-0.3,0.1-0.4,0.1c-0.2,0.1-0.3,0.1-0.5,0.2c-0.1,0-0.1,0-0.2,0.1c-0.2,0.1-0.3,0.1-0.5,0.1      c-0.2,0.1-0.5,0.2-0.8,0.3h-0.1c-0.2,0.1-0.3,0.1-0.5,0.1c-0.1,0-0.2,0-0.3,0.1c-0.1,0-0.2,0.1-0.4,0.1c-0.5,0.1-1,0.2-1.6,0.2      c-0.1,0-0.2,0-0.3,0s-0.1,0-0.2,0c-0.1,0-0.3,0-0.4,0l0,0l0,0c-0.1,0-0.2,0-0.3,0C211.1,240.5,209.9,240.7,208.8,240.7z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M247.7,222.6c-0.3,2.9-2,5.1-3.9,7.2c-2,2.3-3.9,4.7-5,7.5c1.1-0.4,2.4-0.6,3.3-1.3c1.6-1.2,3-0.6,4.5,0      c1.6,0.6,3.2,1.3,4.7,2.1c2.4,1.3,4.8,2.8,7.2,4.1c1.4,0.7,2.9,1.2,4.3,1.9c2.5,1.2,5,2.5,7.5,3.7c1.5,0.7,3.3,1,4.7,1.9      c2.3,1.4,4.8,1.7,7.4,2.2c2.3,0.5,4.6,0.5,6.9,1s4.6,0,6.8-0.4c1-0.2,3.4-1.8,3.3-2.7c-0.1-0.8-0.5-1.7-1.1-2.2      c-1.6-1.3-3.3-2.3-5-3.4c-2.5-1.6-4.9-3.3-7.5-4.8c-1.1-0.6-2.5-0.8-3.8-1.1c-2.1-0.5-4.2-0.9-6.3-1.4c-1.6-0.4-3.2-0.8-4.8-1.2      c-2.8-0.6-5.7-1.2-8.6-1.7c-0.6-0.1-0.7-0.2-0.3-0.8c1.1-1.4,1-3.7-0.1-5.1c-0.1-0.1-0.1-0.2-0.2-0.3c0.1,0,0.2-0.1,0.3-0.1      c0.7,0,1.4,0,2.1,0c3-0.2,6.1-0.2,9.1-0.6c2-0.3,4-1.1,6-1.7c1.2-0.4,2.3-0.4,3.5-0.1c1.8,0.4,3.5-0.2,5.2-0.8      c3.5-1.2,6.9-2.5,10.6-3c2.4-0.3,4.6-1.5,7-2.2c1.9-0.6,4-1,5.8-1.7c2.3-1,4.4-2.3,6.7-3.3c1.8-0.8,3.2-2.1,4.1-3.6      c0.5-0.9,0.5-2.5,0.2-3.5c-1-2.8-3.9-3.7-6.6-2.4c-0.6,0.3-1.4,0.2-2.1,0.4c-1.5,0.4-3.1,0.9-4.5,1.5c-1.7,0.7-3.4,1.6-5,2.5      c-0.9,0.5-1.8,1.1-2.8,1.6c-0.7,0.4-1.5,0.6-2.3,0.9c-0.1,0-0.2,0-0.3,0c0.1-0.1,0.1-0.2,0.2-0.3c1.1-1,2.2-2.1,3.4-2.9      c2.3-1.6,4.7-3.1,7.2-4.4c1.5-0.9,3.2-1,5-0.9c1.2,0.1,2.5-0.1,3.7-0.3c2.9-0.5,5.7-1.1,8.6-1.6c2.7-0.4,5.4-0.4,8.1-0.9      c2.9-0.6,5.7-1.7,8.5-2.7c2.3-0.9,4.7-1.8,6.7-3.2c2.5-1.6,5-3.3,6-6.4c0.4-1.2,0.5-2.4-0.3-3.3c-1.1-1.4-2.5-2.3-4.3-2.7      c-2.5-0.5-4.9-0.2-7.3,0.3c-1.1,0.2-2.2,0.7-3.3,1c-1.8,0.6-3.7,1-5.5,1.7c-1.1,0.4-2,1.2-3,1.8c-1.3,0.8-2.7,1.5-4.1,2.2      c-0.2,0.1-0.4,0-0.7,0c0.1-0.2,0.1-0.4,0.2-0.6c0.8-1.5,1.5-3.1,2.3-4.5c1.3-2.3,2.8-4.5,4-6.8c0.8-1.6,1.5-3.4,2-5.1      c0.6-1.9,1.3-3.9,1.3-5.9c0.1-2.3,0.2-5.1-2.4-6.3c-1.1-0.5-2.6-0.2-3.9,0c-3.2,0.5-5.6,2.7-8,4.6c-2.5,2-4.6,4.3-6,7.2      c-1,2.1-1.9,4.4-2.8,6.5c-0.8,1.9-1.5,3.7-2.2,5.6c-0.7,1.9-1.4,3.9-2.1,5.9c-0.2,0.6-0.3,1.3-0.5,1.9c0,0.1-0.1,0.2-0.1,0.3      c0-0.1,0-0.2-0.1-0.2c-0.5-1-0.8-2.1-1.5-2.9c-2-2.3-4.6-2.5-7.2-0.6c-1.9,1.3-3.2,3.9-2.3,5.3c1.2,1.7,2.6,3.3,4.1,4.7      c0.8,0.8,2.1,1.1,3.1,1.6c0.1,0.1,0.3,0.5,0.2,0.6c-0.6,1.1-1.1,2.2-1.8,3.1c-1.1,1.4-2.4,2.6-3.7,3.9c-0.2,0.2-0.5,0.2-0.8,0.3      c0.1-0.2,0.1-0.5,0.3-0.7c0.7-1.4,1.5-2.7,2.2-4.1c1-2,0.1-4.6-2-4.9c-1.2-0.1-2.8,0.4-3.8,1.2c-3.2,2.4-6.3,4.9-9.3,7.5      c-2.1,1.9-3.8,4.2-5.8,6.2c-0.4,0.4-1,0.6-1.6,0.9c0.3-0.5,0.6-1,0.9-1.5c1.7-2.7,3.1-5.6,3.5-8.8c0.3-2.2,0.9-4.3,0.9-6.5      c0-1.3-0.5-2.7-1.2-3.9c-0.2-0.4-1.8-0.7-2.3-0.3c-2.2,1.4-4.7,2.4-6.4,4.6c-1.1,1.5-2.4,3-3.8,4.4c-1.4,1.4-3.1,2.5-4.2,4.1      c-1.3,1.8-2.1,3.9-3.1,6c-0.8,1.8-1.5,3.6-2.3,5.4c-0.5,1.2-0.9,2.5-1.5,3.6c-1,2-2.1,3.9-3.2,5.8c-0.7,1.1-1.4,2.4-2.4,3.2      c-1.3,1.1-2.9,1.7-4.4,2.5c-0.2,0.1-0.5-0.1-0.7-0.1s-0.3,0.1-0.5,0.1c0.1-0.1,0.2-0.2,0.3-0.2c1.4-1.6,2.9-3.2,4.2-5      c0.5-0.7,0.7-2,0.5-2.9c-0.3-1.2-1.6-1.4-2.6-1.4C250.2,222.5,249,222.6,247.7,222.6z M286.8,219.9c-0.1,0-0.2,0.1-0.3,0.1      c0.1-0.1,0.1-0.2,0.2-0.2c0.7-0.4,1.3-0.9,2-1.3c0.1,0,0.2-0.1,0.3-0.1c-0.1,0.1-0.1,0.2-0.2,0.2      C288.1,219,287.5,219.5,286.8,219.9z M273.5,219.5c0,0,0.1,0,0.2,0c0,0.1-0.1,0.2-0.1,0.3c-0.9,1-1.7,2.1-2.6,3.1      c-0.7,0.7-2,1.1-2.4,1.9c-0.6,1.4-1.5,0.8-2.3,0.7c-0.2,0-0.4,0-0.7,0c-0.5,0-1.1,0-1.6,0.1c0.5-0.4,0.9-0.9,1.4-1.3      c0.2-0.2,0.4-0.2,0.6-0.3c1.6-1,3.2-1.9,4.7-2.9C271.7,220.5,272.6,220.1,273.5,219.5z M307.5,201.7c0.6-1.1,1.2-2.2,1.8-3.3      c0.7-1.3,1.4-2.6,2.1-4c0-0.1,0.3-0.1,0.4-0.1c0.4,0.5,0.8,1.4,1.3,1.5c0.8,0.3,0.4,0.4,0.2,0.7c-0.8,1-1.5,2-2.4,2.9      c-0.9,0.9-1.8,1.7-2.8,2.5c-0.1,0.1-0.2,0.1-0.4,0.2C307.7,202.1,307.6,202,307.5,201.7z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M273.9,219.2c0,0.1-0.1,0.2-0.1,0.4h-0.1C273.8,219.4,273.9,219.3,273.9,219.2c0.1-0.1,0.2-0.2,0.3-0.2      c0,0.1,0,0.1,0.1,0.2C274.2,219.1,274.1,219.1,273.9,219.2z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M284.8,220.9c0.2-0.1,0.4-0.2,0.5-0.3c0,0,0.1,0.1,0.2,0.1c-0.2,0.1-0.3,0.2-0.5,0.3      C285,221,284.9,220.9,284.8,220.9z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M284,221.5c0.2-0.1,0.4-0.2,0.6-0.3l0.1,0.1c-0.2,0.1-0.3,0.2-0.5,0.3C284.2,221.6,284.1,221.5,284,221.5z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M307.2,202.6l-0.1-0.1c0.1-0.1,0.2-0.2,0.3-0.2c0,0,0.1,0,0.2,0.1C307.5,202.4,307.4,202.5,307.2,202.6z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M275.2,218.1c0,0.1-0.1,0.1-0.1,0.2c0,0-0.1,0-0.2,0c0.1-0.1,0.1-0.2,0.2-0.2      C275.1,218.1,275.1,218.1,275.2,218.1z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M279.3,213.7c0.1,0,0.1,0,0.2-0.1v0.1l-0.1,0.1C279.3,213.8,279.3,213.7,279.3,213.7z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M233.8,246.2c-1.4,1.1-2.8,2.3-4.2,3.4c-1.4,1.1-2.8,2.3-4.2,3.4c-0.5,0.4-1.3,0.5-1.9,0.7      c0,0.1-0.1,0.3,0,0.3c1.8,1,3.5,2.2,5.4,3c4,1.8,8.1,1.4,12.2,0.5c1.7-0.4,3.4-1.2,4.9-2c1.8-1,1.6-2.9-0.1-4.1      c-3.4-2.2-7.1-3.6-10.9-4.9C234.5,246.4,234.2,246.3,233.8,246.2z"})]})})}),jsxRuntimeExports.jsx("g",{id:"_x32_CHZWF_00000000900902886073594020000005488387142543844015_",children:jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{className:"st0",d:"M178.9,226c-1.5,0-3.2,0.7-4.1-1.3c-0.3-0.7-0.7-1.3-1.2-1.9c-2.3-2.5-4.5-5.1-7-7.4      c-2.2-2-4.7-3.8-7.1-5.5c-2.6-1.8-5.2-3.6-7.8-5.3c-1.2-0.7-2.6-1.2-3.8-1.8c-3.4-1.8-7-3-10.8-3.1c-2.1-0.1-4.2,0.1-6.3,0.3      c-1.3,0.2-2.8,0.3-3.9,1c-2.5,1.6-4.9,3.4-7.1,5.5c-2.3,2.1-4.5,4.3-5.9,7.3c-1.4,2.9-2.2,5.8-2.4,8.9c0.3,2.9,2,5.1,3.9,7.2      c2,2.3,3.9,4.7,5,7.5c0.3,0.6,0.6,1.1,0.9,1.7c1.4,2.4,2.7,4.8,4.1,7.2c1.4,1.1,2.8,2.3,4.2,3.4c1.4,1.1,2.8,2.3,4.2,3.4      c0.5,0.4,1.3,0.5,1.9,0.7c1.2,0.2,2.4,0.3,3.6,0.5c1.9,0.4,3.8,0.8,5.7,1.2c0.7,0.1,1.5,0.1,2.3,0.1c0.2,0,0.4,0,0.7,0      c-0.2,0.2-0.3,0.4-0.6,0.5c-1.9,0.7-3.8,1.4-5.8,2c-1.6,0.4-3.2,0.6-4.9,0.7c-3.5,0.3-6.9,0.6-10.4,0.7      c-3.5,0.1-6.9,0.3-10.1,1.8c-1.8,0.8-3.6,1.8-5.4,2.9c-2,1.3-4.1,2.6-6,4.1c-1.5,1.1-2.6,2.7-4.1,3.8c-3.1,2.4-5.5,5.2-6.8,8.9      c-0.7,1.9,0.4,3.5,2.4,3.5c1.8,0,3.6-0.1,5.4-0.2c1.7,0,3.3,0.3,4.7,1.4c1,0.8,2.8,0.4,3.4-0.6c1-1.5,1.9-3,2.9-4.5      c1.4-1.8,2.8-3.7,4.4-5.3c1.2-1.1,3-1.6,4.4-2.6c2.3-1.6,5-2.2,7.7-2.5c4-0.4,8-0.4,12-0.6c2.6-0.1,5.3-0.1,7.9-0.6      c3.5-0.6,7-1.7,10.1-3.6c2.1-1.3,4.1-2.7,6.2-4c2.7-1.6,5-3.6,6.9-6.2c2-2.7,3.8-5.5,5.1-8.7c0.4-1,0.4-2.6,2.2-2.7v-18      C179.5,225.9,179.2,226,178.9,226z M167.5,234.9c-1,0.7-1.9,1.5-3,2.1c-0.5,0.3-1.1,0.5-1.7,0.6c-0.2,0.1-0.5,0.2-0.8,0.2h-0.1      c-0.9,0.3-1.8,0.6-2.7,0.8s-1.9,0.3-2.8,0.5c-0.2,0.1-0.5,0.1-0.7,0.2c-0.7,0.2-1.3,0.4-2,0.8c-0.2,0.1-0.4,0.2-0.5,0.2      s-0.2,0.1-0.4,0.1c-0.4,0.1-0.7,0.2-1.2,0.2c-0.1,0-0.3,0-0.4,0c-0.3,0-0.5,0-0.7,0c-0.3,0-0.6,0-0.9,0h-0.1c-0.1,0-0.1,0-0.2,0      c-0.8,0-1.6-0.1-2.3-0.1h-0.1c-0.2,0-0.4,0-0.5,0.1c-0.1,0-0.1,0-0.2,0c-0.4,0-0.7-0.1-1.1-0.1c-0.1,0-0.1,0-0.2,0      c-0.7,0-1.3-0.2-1.9-0.5c-0.7-0.2-1.4-0.4-2.1-0.7c-0.4-0.1-0.7-0.3-1.1-0.4c-0.2-0.1-0.3-0.1-0.5-0.2c-0.9-0.4-1.8-0.7-2.7-1.1      c-0.4-0.1-0.8-0.3-1.1-0.5c-0.5-0.2-1-0.5-1.4-0.7c-0.5-0.2-0.9-0.4-1.3-0.7c-0.1-0.1-0.2-0.1-0.3-0.2c-0.6-0.2-1-0.5-1.4-0.9      c-0.1-0.1-0.2-0.1-0.3-0.2l0,0c-0.4-0.3-0.8-0.6-1.1-1c-0.8-0.8-1.6-1.6-2.4-2.5c-0.2-0.2-0.5-0.4-0.7-0.7c-0.5-0.5-1-1-1.4-1.5      c-0.5-0.6-0.9-1.2-1.4-1.8c0,0,0,0,0-0.1c-0.2-0.3-0.4-0.5-0.6-0.8c-2.1-2.1-4.1-4.2-5.2-7c-0.5-1.3,0.6-2,1.4-2.6      c0.6-0.5,1.4-0.7,2-1.1c1.1-0.3,2.2-0.7,3.4-0.8c0.2,0,0.5,0,0.8-0.1c0.3-0.1,0.7-0.1,1-0.1c0.1,0,0.2,0,0.3,0      c0.1,0,0.3,0,0.4,0c0.3,0,0.5-0.1,0.8-0.1c0.1,0,0.2,0,0.3,0c0.3,0,0.6,0,1,0c0.1,0,0.1,0,0.1,0h0.1c0.8,0,1.5,0.1,2.2,0.2h0.1      c0.3,0,0.6,0.1,0.8,0.2c0.6,0,1.2,0.1,1.7,0.4c0.3,0.1,0.5,0.1,0.8,0.2c0.1,0,0.2,0,0.3,0.1c0.1,0,0.2,0.1,0.4,0.1      c0.4,0.1,0.8,0.1,1.2,0.3c0.3,0.1,0.7,0.1,0.9,0.3c0.1,0,0.2,0.1,0.3,0.1c0.3,0.1,0.6,0.2,0.8,0.3c0.2,0.1,0.4,0.2,0.6,0.2      c0.1,0,0.1,0,0.2,0.1c0.2,0.1,0.5,0.2,0.7,0.3c0.3,0.1,0.6,0.2,0.8,0.3c0.5,0.2,1.1,0.4,1.6,0.5c0.3,0.1,0.6,0.2,0.8,0.3      c0.4,0.1,0.7,0.2,1.1,0.4c0.4,0.1,0.7,0.3,1.1,0.4c0.3,0.1,0.5,0.2,0.8,0.4c0.4,0.2,0.9,0.4,1.3,0.6c0.1,0.1,0.2,0.1,0.4,0.2      c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.2,0.1,0.3,0.2c0.4,0.2,0.8,0.5,1.2,0.8c0,0,0,0,0.1,0c0.4,0.3,0.8,0.5,1.2,0.8      c0.3,0.2,0.6,0.4,0.9,0.6c0.1,0.1,0.2,0.1,0.3,0.2c0.5,0.4,1,0.7,1.6,1.1c0.3,0.1,0.5,0.3,0.7,0.5c1,0.7,1.9,1.3,2.9,2      c0.1,0.1,0.2,0.2,0.2,0.3c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0,0.1,0.1,0.2,0.1l0,0c0.1,0.1,0.2,0.2,0.4,0.3      c0.1,0,0.1,0,0.2,0.1c0.7,0.5,1.4,0.9,2,1.4c1.9,1.6,3.8,3.2,5.6,4.8C167.3,233.9,168.3,234.1,167.5,234.9z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M111.5,222.6c0.3,2.9,2,5.1,3.9,7.2c2,2.3,3.9,4.7,5,7.5c-1.1-0.4-2.4-0.6-3.3-1.3c-1.6-1.2-3-0.6-4.5,0      c-1.6,0.6-3.2,1.3-4.7,2.1c-2.4,1.3-4.8,2.8-7.2,4.1c-1.4,0.7-2.9,1.2-4.3,1.9c-2.5,1.2-5,2.5-7.5,3.7c-1.5,0.7-3.3,1-4.7,1.9      c-2.3,1.4-4.8,1.7-7.4,2.2c-2.3,0.5-4.6,0.5-6.9,1s-4.6,0-6.8-0.4c-1-0.2-3.4-1.8-3.3-2.7c0.1-0.8,0.5-1.7,1.1-2.2      c1.6-1.3,3.3-2.3,5-3.4c2.5-1.6,4.9-3.3,7.5-4.8c1.1-0.6,2.5-0.8,3.8-1.1c2.1-0.5,4.2-0.9,6.3-1.4c1.6-0.4,3.2-0.8,4.8-1.2      c2.8-0.6,5.7-1.2,8.6-1.7c0.6-0.1,0.7-0.2,0.3-0.8c-1.1-1.4-1-3.7,0.1-5.1c0.1-0.1,0.1-0.2,0.2-0.3c-0.1,0-0.2-0.1-0.3-0.1      c-0.7,0-1.4,0-2.1,0c-3-0.2-6.1-0.2-9.1-0.6c-2-0.3-4-1.1-6-1.7c-1.2-0.4-2.3-0.4-3.5-0.1c-1.8,0.4-3.5-0.2-5.2-0.8      c-3.5-1.2-6.9-2.5-10.6-3c-2.4-0.3-4.6-1.5-7-2.2c-1.9-0.6-4-1-5.8-1.7c-2.3-1-4.4-2.3-6.7-3.3c-1.8-0.8-3.2-2.1-4.1-3.6      c-0.5-0.9-0.5-2.5-0.2-3.5c1-2.8,3.9-3.7,6.6-2.4c0.6,0.3,1.4,0.2,2.1,0.4c1.5,0.4,3.1,0.9,4.5,1.5c1.7,0.7,3.4,1.6,5,2.5      c0.9,0.5,1.8,1.1,2.8,1.6c0.7,0.4,1.5,0.6,2.3,0.9c0.1,0,0.2,0,0.3,0c-0.1-0.1-0.1-0.2-0.2-0.3c-1.1-1-2.2-2.1-3.4-2.9      c-2.3-1.6-4.7-3.1-7.2-4.4c-1.5-0.9-3.2-1-5-0.9c-1.2,0.1-2.5-0.1-3.7-0.3c-2.9-0.5-5.7-1.1-8.6-1.6c-2.7-0.4-5.4-0.4-8.1-0.9      c-2.9-0.6-5.7-1.7-8.5-2.7c-2.3-0.9-4.7-1.8-6.7-3.2c-2.5-1.6-5-3.3-6-6.4c-0.4-1.2-0.5-2.4,0.3-3.3c1.1-1.4,2.5-2.3,4.3-2.7      c2.5-0.5,4.9-0.2,7.3,0.3c1.1,0.2,2.2,0.7,3.3,1c1.8,0.6,3.7,1,5.5,1.7c1.1,0.4,2,1.2,3,1.8c1.3,0.8,2.7,1.5,4.1,2.2      c0.2,0.1,0.4,0,0.7,0c-0.1-0.2-0.1-0.4-0.2-0.6c-0.8-1.5-1.5-3.1-2.3-4.5c-1.3-2.3-2.8-4.5-4-6.8c-0.8-1.6-1.5-3.4-2-5.1      c-0.6-1.9-1.3-3.9-1.3-5.9c-0.1-2.3-0.2-5.1,2.4-6.3c1.1-0.5,2.6-0.2,3.9,0c3.2,0.5,5.6,2.7,8,4.6c2.5,2,4.6,4.3,6,7.2      c1,2.1,1.9,4.4,2.8,6.5c0.8,1.9,1.5,3.7,2.2,5.6c0.7,1.9,1.4,3.9,2.1,5.9c0.2,0.6,0.3,1.3,0.5,1.9c0,0.1,0.1,0.2,0.1,0.3      c0-0.1,0-0.2,0.1-0.2c0.5-1,0.8-2.1,1.5-2.9c2-2.3,4.6-2.5,7.2-0.6c1.9,1.3,3.2,3.9,2.3,5.3c-1.2,1.7-2.6,3.3-4.1,4.7      c-0.8,0.8-2.1,1.1-3.1,1.6c-0.1,0.1-0.3,0.5-0.2,0.6c0.6,1.1,1.1,2.2,1.8,3.1c1.1,1.4,2.4,2.6,3.7,3.9c0.2,0.2,0.5,0.2,0.8,0.3      c-0.1-0.2-0.1-0.5-0.3-0.7c-0.7-1.4-1.5-2.7-2.2-4.1c-1-2-0.1-4.6,2-4.9c1.2-0.1,2.8,0.4,3.8,1.2c3.2,2.4,6.3,4.9,9.3,7.5      c2.1,1.9,3.8,4.2,5.8,6.2c0.4,0.4,1,0.6,1.6,0.9c-0.3-0.5-0.6-1-0.9-1.5c-1.7-2.7-3.1-5.6-3.5-8.8c-0.3-2.2-0.9-4.3-0.9-6.5      c0-1.3,0.5-2.7,1.2-3.9c0.2-0.4,1.8-0.7,2.3-0.3c2.2,1.4,4.7,2.4,6.4,4.6c1.1,1.5,2.4,3,3.8,4.4c1.4,1.4,3.1,2.5,4.2,4.1      c1.3,1.8,2.1,3.9,3.1,6c0.8,1.8,1.5,3.6,2.3,5.4c0.5,1.2,0.9,2.5,1.5,3.6c1,2,2.1,3.9,3.2,5.8c0.7,1.1,1.4,2.4,2.4,3.2      c1.3,1.1,2.9,1.7,4.4,2.5c0.2,0.1,0.5-0.1,0.7-0.1s0.3,0.1,0.5,0.1c-0.1-0.1-0.2-0.2-0.3-0.2c-1.4-1.6-2.9-3.2-4.2-5      c-0.5-0.7-0.7-2-0.5-2.9c0.3-1.2,1.6-1.4,2.6-1.4C109,222.5,110.2,222.6,111.5,222.6z M85.3,219.2c0,0.1,0.1,0.2,0.1,0.4h0.1      C85.4,219.4,85.3,219.3,85.3,219.2c-0.1-0.1-0.2-0.2-0.3-0.2c0,0.1,0,0.1-0.1,0.2C85,219.1,85.1,219.1,85.3,219.2z M72.4,219.9      c0.1,0,0.2,0.1,0.3,0.1c-0.1-0.1-0.1-0.2-0.2-0.2c-0.7-0.4-1.3-0.9-2-1.3c-0.1,0-0.2-0.1-0.3-0.1c0.1,0.1,0.1,0.2,0.2,0.2      C71.1,219,71.7,219.5,72.4,219.9z M85.7,219.5c0,0-0.1,0-0.2,0c0,0.1,0.1,0.2,0.1,0.3c0.9,1,1.7,2.1,2.6,3.1      c0.7,0.7,2,1.1,2.4,1.9c0.6,1.4,1.5,0.8,2.3,0.7c0.2,0,0.4,0,0.7,0c0.5,0,1.1,0,1.6,0.1c-0.5-0.4-0.9-0.9-1.4-1.3      c-0.2-0.2-0.4-0.2-0.6-0.3c-1.6-1-3.2-1.9-4.7-2.9C87.5,220.5,86.6,220.1,85.7,219.5z M51.7,201.7c-0.6-1.1-1.2-2.2-1.8-3.3      c-0.7-1.3-1.4-2.6-2.1-4c0-0.1-0.3-0.1-0.4-0.1c-0.4,0.5-0.8,1.4-1.3,1.5c-0.8,0.3-0.4,0.4-0.2,0.7c0.8,1,1.5,2,2.4,2.9      c0.9,0.9,1.8,1.7,2.8,2.5c0.1,0.1,0.2,0.1,0.4,0.2C51.5,202.1,51.6,202,51.7,201.7z M74.4,220.9c-0.2-0.1-0.4-0.2-0.5-0.3      c0,0-0.1,0.1-0.2,0.1c0.2,0.1,0.3,0.2,0.5,0.3C74.2,221,74.3,220.9,74.4,220.9z M75.2,221.5c-0.2-0.1-0.4-0.2-0.6-0.3l-0.1,0.1      c0.2,0.1,0.3,0.2,0.5,0.3C75,221.6,75.1,221.5,75.2,221.5z M52,202.6L52,202.6c0-0.2-0.1-0.3-0.2-0.3c0,0-0.1,0-0.2,0.1      C51.7,202.4,51.8,202.5,52,202.6z M84,218.1c0,0.1,0.1,0.1,0.1,0.2c0,0,0.1,0,0.2,0C84.2,218.2,84.2,218.1,84,218.1      C84.1,218.1,84.1,218.1,84,218.1z M79.9,213.7c-0.1,0-0.1,0-0.2-0.1v0.1H79.9C79.9,213.8,79.9,213.7,79.9,213.7z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M125.4,246.2c1.4,1.1,2.8,2.3,4.2,3.4c1.4,1.1,2.8,2.3,4.2,3.4c0.5,0.4,1.3,0.5,1.9,0.7      c0,0.1,0.1,0.3,0,0.3c-1.8,1-3.5,2.2-5.4,3c-4,1.8-8.1,1.4-12.2,0.5c-1.7-0.4-3.4-1.2-4.9-2c-1.8-1-1.6-2.9,0.1-4.1      c3.4-2.2,7.1-3.6,10.9-4.9C124.7,246.4,125,246.3,125.4,246.2z"})]})})})]}),jsxRuntimeExports.jsx("polygon",{className:"st2",points:"163.2,124.7 186.3,124.7 185.2,116.8 164.8,116.8 "}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M139.2,159.4c1.9,0,3.8-0.1,5.6-0.6c2.4-0.6,4.9-1,6.8-2.5c0.5-0.4,0.9-0.9,1.2-1.4l-1.9-9.5l-0.5-4.1  c-0.9,1.8-2.5,7.5-3.5,9.2c-0.3,0.6-0.7,1.2-1.1,1.7c-0.8,1.2-1.6,2.4-2.8,3.3c-1.2,0.9-2.5,1.4-4,1.7L139.2,159.4L139.2,159.4z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M166.2,157.2c-1.5,0.1-3-0.4-4.1-1.4c-0.7-0.6-1.2-1.4-1.6-2.2c-0.5-0.9-0.8-1.8-1.1-2.8  c-0.4-1.5-0.7-3.1-0.7-4.7c-0.1-3.6,1.2-6.9,2.2-10.4c2.4-8.8,4.1-17.8,6.1-26.8c2.4-10.7,5.1-21.3,6.6-32.2  c0.4-2.9,0.5-5.9,1.8-8.4c1-2.1,2.6-3.9,4.6-5.2c-0.1-0.9-0.5-1.6-1-2.4c-1.7-2.5-4.6-3.7-7.4-4.7c-3.7-1.3-7.7-1.9-11.6-1.6  l-0.7,2.4c2.2,0.6,4.1,2,5.4,3.8c0.5,0.8,1,1.6,1.2,2.5c0.2,0.7,0.2,1.3,0.3,2c0,0.9-0.1,1.8-0.1,2.7c-0.3,2.6-0.7,5.2-1.2,7.8  c-2,10.9-4.6,21.7-7,32.5c-2,9.1-3.4,18.4-5.9,27.3l-2.7,9.5c-0.3,1.2-0.4,2.4-0.2,3.6c0.2,1.9,0.9,3.7,1.9,5.4  c0.9,1.3,1.9,2.5,3.2,3.5c1.6,1.2,3.6,1.9,5.5,1.9h5.9L166.2,157.2L166.2,157.2z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M214.1,157.5c-2.1-0.7-3.9-2-5.4-3.6c-1.8-2-2.6-4.6-3.6-7.1c-0.7-1.7-1.5-6.8-1.9-8.6l-1,3.1  c-0.2,1.9-0.7,3.7-1.4,5.5c-1,2.5-2.4,4.9-4.2,7c1.3,1.1,2.7,2,4.2,2.8c1.4,0.7,2.8,1.4,4.3,1.9c2.8,0.9,5.7,1.2,8.6,1L214.1,157.5  L214.1,157.5z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M198,57.6c-1.2-0.2-2.5-0.1-3.6,0.3c-1.9,0.8-3,2.7-3.8,4.6c-0.7,1.6-1.2,3.4-1,5.1l0.8,7.1l13.2,65.5  c0.3,3.7-0.9,7.4-2.9,10.6c-1.9,2.9-4.6,5-7.6,6.6c-3.6,1.9-7.7,2.6-11.8,2.3l-0.6-2.3c2.8-0.4,5.3-2,6.9-4.5  c0.8-1.2,1.2-2.5,1.4-3.9c0.4-3.3,0-6.5-0.6-9.7l-12.6-64.9c-0.6-2.9-1.1-5.9-0.1-8.7c1.2-3.6,4.1-6.1,7.3-8.1  c3.2-1.9,6.9-2.8,10.6-2.8h4.5L198,57.6L198,57.6z"})]});const DuckBadge=({elClass:s,showLabel:a=true})=>jsxRuntimeExports.jsxs("svg",{className:s,xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 360 360",children:[a&&jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{className:"st0",d:"M129.72,251.47v0.23h0.45v-1.13c0.41-2.4,1.46-3.61,3.16-3.61h1.13c2.4,0,3.61,2.7,3.61,8.11v3.38 c-0.15,15.44-0.23,24.83-0.23,28.17c0.15,0,0.23,0.08,0.23,0.23h-0.23c0.15,0.3,0.23,0.53,0.23,0.68c0,9.05,0.9,15.51,2.7,19.38 c1.99,1.8,3.64,2.7,4.96,2.7c3.12,0,6.35-5.56,9.69-16.68c0.45-3,1.88-4.51,4.28-4.51h0.23c2.7,0.41,4.06,1.77,4.06,4.06 c0,4.17-2.4,10.55-7.21,19.16c-3.19,4.36-7.02,6.54-11.49,6.54c-4.21,0-8.26-2.4-12.17-7.21c-1.65-3.87-2.48-6.87-2.48-9.01 c-0.19,0-1.09,2.1-2.7,6.31c-4.47,8.11-10.03,12.17-16.68,12.17c-5.18,0-10.07-1.65-14.65-4.96c-4.96-5.26-7.44-12.55-7.44-21.86 v-2.03c0-13.56,4.06-25.5,12.17-35.83c5.48-6.16,10.52-9.24,15.1-9.24C121.9,246.51,126.34,248.16,129.72,251.47z M97.71,293.39 c0,6.87,1.58,12.13,4.73,15.78c2.97,1.8,5.97,2.7,9.01,2.7c7.44,0,12.85-12.85,16.23-38.54c0.3-2.33,0.45-4.88,0.45-7.66 c0-2.85-1.95-5.93-5.86-9.24c-1.84-0.9-3.87-1.35-6.08-1.35c-5.26,1.84-9.99,7.1-14.2,15.78c-2.85,6.8-4.28,13.94-4.28,21.41 V293.39z"}),jsxRuntimeExports.jsx("path",{className:"st0",d:"M192.2,255.75c0.45,1.5,0.68,3.23,0.68,5.18v1.35c0,6.24-2.4,11.79-7.21,16.68c3.61,1.05,7.06,3.98,10.37,8.79 c1.8,3.49,2.7,6.95,2.7,10.37v0.45c0,1.8-0.3,3.68-0.9,5.63c3.38-1.43,7.29-4.81,11.72-10.14c1.58-2.55,3.16-3.83,4.73-3.83h0.45 c2.22,0,3.57,1.43,4.06,4.28c0,2.44-3.46,6.8-10.37,13.07c-9.5,6.31-15.74,9.47-18.71,9.47c-8.6,2.25-14.76,3.38-18.48,3.38 c-2.93,0-6.91-0.75-11.94-2.25c-1.69,0-2.82-6.76-3.38-20.28c-0.6-6.35-0.9-11.76-0.9-16.23c0.45-20.66,1.35-31.78,2.7-33.35 c1.01-0.9,2.14-1.35,3.38-1.35c2.03,0,3.23,1.58,3.61,4.73c4.88-4.66,9.69-6.99,14.42-6.99 C185.25,244.71,189.61,248.39,192.2,255.75z M163.8,278.74h0.23c4.17,0,8.75-1.5,13.75-4.51c4.36-3.12,6.54-7.25,6.54-12.4v-0.45 c-0.38-5.26-1.95-7.89-4.73-7.89c0-0.15-0.15-0.23-0.45-0.23c-4.36,0-8.41,3.53-12.17,10.59c-2.1,4.62-3.16,7.7-3.16,9.24V278.74z M166.06,311.19c2.67,0.45,4.47,0.68,5.41,0.68c3.72,0,8-0.98,12.85-2.93c3.91-3.04,5.86-6.57,5.86-10.59v-0.23 c0-5.45-2.93-9.35-8.79-11.72c-1.77-0.75-3.72-1.13-5.86-1.13c-7.51,1.58-11.42,2.63-11.72,3.16 C164.67,303.6,165.42,311.19,166.06,311.19z"}),jsxRuntimeExports.jsx("path",{className:"st0",d:"M246.74,254.4c1.2,3.38,1.8,6.84,1.8,10.37v1.8c0,2.03-1.28,3.23-3.83,3.61h-0.23c-2.07,0-3.27-1.58-3.61-4.73 c-0.71-5.26-1.54-7.89-2.48-7.89c0-0.98-1.8-1.88-5.41-2.7c-0.49,0-0.86-0.08-1.13-0.23c-4.47,0-8.08,4.73-10.82,14.2 c-0.45,4.7-0.68,8.83-0.68,12.4c0,15.85,2.7,25.54,8.11,29.07c1.84,1.05,4.24,1.58,7.21,1.58h0.68c7.21,0,13.37-2.85,18.48-8.56 c3.68-4.96,6.24-9.39,7.66-13.3c1.05-1.8,2.4-2.7,4.06-2.7c2.85,0.53,4.28,1.95,4.28,4.28c-0.6,3-3.08,7.89-7.44,14.65 c-3.79,5.93-9.73,10.22-17.8,12.85c-3.27,0.9-6.35,1.35-9.24,1.35h-0.9c-10.97,0-18.1-5.93-21.41-17.8 c-1.5-4.77-2.25-11.83-2.25-21.18c0-11.79,1.43-19.61,4.28-23.44c3.79-7.96,9.05-11.94,15.78-11.94 C238.1,246.06,243.06,248.84,246.74,254.4z"})]}),jsxRuntimeExports.jsx("g",{id:"sM0Qq5_00000001627413448970021540000003602060967867099577_",children:jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{className:"st1",d:"M122.33,39.67c0,0.1,0,0.2,0,0.3c-2.2,0-4.4,0-6.6,0c0-0.1,0-0.2,0-0.4 C117.93,39.67,120.13,39.67,122.33,39.67z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M115.83,39.67c0,0.1,0,0.2,0,0.4c-0.4,0-0.8,0-1.2,0c0-0.1,0-0.2,0-0.3 C114.93,39.67,115.33,39.67,115.83,39.67z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M119.53,205.47c-0.3-0.1-0.6-0.2-0.8-0.4c-0.4-0.1-0.8-0.3-1.2-0.4c-0.8-0.3-1.6-0.5-2.5-0.8 c-1-0.3-1.9-0.6-2.9-0.8c-0.4-0.1-0.8-0.3-1.2-0.4c-0.3-0.1-0.5-0.3-0.8-0.4c-0.4-0.3-0.8-0.5-1.2-0.8c-0.1-0.1-0.3-0.3-0.4-0.4 c-1.2-0.8-2.4-1.6-3.7-2.5c-0.3-0.3-0.6-0.5-0.8-0.8c-0.9-0.8-1.9-1.6-2.8-2.5c-0.4-0.4-0.8-0.8-1.3-1.2l0,0 c-0.8-1.4-1.7-0.9-2.5,0c-0.4,0.4-0.8,0.8-1.2,1.2c-0.8,0.8-1.7,1.6-2.5,2.5c-0.3,0.1-0.5,0.3-0.8,0.4c-1.2,0.9-2.5,1.9-3.7,2.8 c-0.3,0.1-0.5,0.3-0.8,0.4c-1.1,0.5-2.2,1.1-3.3,1.6c-0.3,0.1-0.5,0.3-0.8,0.4c-1.2,0.4-2.5,0.8-3.7,1.2c-1,0.1-1.9,0.3-2.9,0.4 c-0.2-0.1-0.4-0.4-0.7-0.4c-3.7,0-7.4-0.1-11.1,0c-0.3,0-0.7,0.5-1,0.8c-0.7-0.1-1.4-0.3-2-0.4c-1.6-0.6-3.3-1.1-4.9-1.7 c-1.9-1-3.7-2-5.6-3c-1.8-0.9-2.6-2.4-2.2-4.3c0.4-2,1.4-3.5,3.5-4.1c2.6-0.8,4.9,0,7.2,1.1c7,3.2,14.2,3.5,20.9-0.4 c3-1.7,5.4-4.4,8-6.8c1.5-1.3,2.6-3.1,4.2-4.2c1.4-0.9,3.2-1.1,4.9-1.6c0.3,0,0.6,0,0.9,0l0,0c0.4,0.3,0.8,0.6,1.2,0.9l0,0 c0.1,0.1,0.2,0.3,0.4,0.4c2.5,2.6,4.9,5.3,7.6,7.7c1.9,1.7,4.2,2.8,6.4,4.2c0.4,0,0.8,0,1.2,0c0.2-0.1,0.4-0.1,0.6-0.2 c8.7,4.3,20.6,1.6,26.9-6c0.4-0.4,0.8-0.8,1.2-1.2c0.7-0.7,1.4-1.3,2-2c2.6-3.4,6.7-4.4,10.3-2.2c1.9,1.2,3.5,3,4.9,4.7 c6,7.5,13.8,10.1,23,8.6c6.5-1,11.4-4.6,15.1-9.9c0.7-0.7,1.4-1.4,2.1-2.1c5.1-4,10.1-3.1,13.9,2.2c4.6,6.4,10.8,10.1,18.8,10.1 c2.9,0,5.8-0.5,8.7-0.8c0.1,0,0.3,0.1,0.4,0.1c0.4,0,0.8,0,1.2,0c0.9-0.5,1.8-1,2.6-1.6c4.9-3.3,8.8-7.6,12.7-12 c6-1.8,9.3,2.1,12.2,6.2c3.2,4.4,7.9,6.2,12.8,7.7c7.6,2.3,14.1-0.5,20.4-4.4c0.9-0.6,1.9-1.1,2.9-1.3c3.1-0.7,4.2,1.3,5.2,3.6 c0,1.1,0,2.2,0,3.3c-5.3,5.9-12.1,8.6-19.7,9.4c-1.2,0.1-2.5,0-3.7,0c-7.4,0.2-14-2.1-19.9-6.5c-1.6-1.2-2.9-2.7-4.3-4 c-2-1.9-4-2-5.9,0c-5.2,5.7-11.8,9.1-19.3,10.3c-3.9,0.6-8,0-12-0.4c-7.4-0.8-13.2-4.7-18.2-9.9c-2.3-2.3-3.6-2.4-5.8,0 c-5,5.3-11.1,8.6-18.1,10.5c-0.6,0.2-1.2,0.1-1.8,0.1c-6.4,0.2-12.8,0.3-18.8-2.5c-0.3-0.1-0.6-0.3-0.8-0.4 c-1.7-1.1-3.5-2.3-5.2-3.4c-0.7-0.5-1.4-1-2.1-1.4c-0.7-0.7-1.4-1.4-2.1-2c-2.2-2.7-4.2-2.9-6.7-0.5c-0.8,0.8-1.6,1.7-2.4,2.5 c-0.4,0.4-0.8,0.8-1.2,1.2c-2.8,1.5-5.5,3.1-8.4,4.5c-4.6,2.2-9.6,2.3-14.5,2.1c-1.1-1.3-2.2-1.3-3.3,0 C120.03,205.47,119.73,205.47,119.53,205.47z"}),jsxRuntimeExports.jsx("path",{className:"st4",d:"M261.03,180.87c-3.9,4.4-7.8,8.7-12.7,12c-0.8,0.6-1.7,1-2.6,1.6c-0.4,0-0.8,0-1.2,0c-0.1,0-0.3-0.1-0.4-0.1 c1-1.3,2-2.6,3.1-3.7c3.8-4,7-8.4,8.8-13.6c4.3-12.6,8.3-25.3,9.8-38.6c1-9,2.6-17.9,1.6-27c-0.4-4-0.6-8-2.6-11.6 c-1.2-2.1-1.7-2.2-3-0.2c-2.8,4.3-6.6,7-11.6,8c-3.4,0.7-6.8,1.4-10.3,1.5c-9.7,0.4-19.3-0.7-28.7-3c-13-3.2-26-6.6-39.6-5.3 c-4.4,0.4-5.8-1.4-5.6-5.9c0.1-2.7,0.4-5.5,0.2-8.2c-0.2-3.3-0.2-6.8-1.3-9.8c-4.1-11.5-11.7-20.1-22.5-25.9 c-5.7-3.1-12-4.5-18.3-5.1c-8.4-0.8-16.6,0.1-24,4.8c-8.1,5.2-14.5,12.1-19.8,20c-0.6-0.3-1.2-0.6-1.8-1 c-0.9-0.6-1.8-1.3-2.7-1.9c0-0.3,0-0.5,0-0.8c7.9-12.2,17.6-22,32.1-25.9c2.2-0.6,4.5-0.8,6.8-1.1c0.4,0,0.8,0,1.2,0 c2.2,0,4.4,0,6.6,0c14.6,0.5,27,5.9,37,16.5c5.7,6.1,10.3,13,11.8,21.4c0.9,5,0.6,10.3,0.8,15.5c0,1.2,0.1,1.7,1.5,1.6 c12.3-1,24.1,1.6,35.8,4.7c9.3,2.4,18.7,3.8,28.2,3.8c3.5,0,7.1-0.6,10.5-1.2c4.3-0.8,7.1-3.7,9.5-7.2c2.6-3.7,7.2-4,10.4-0.8 c2.2,2.1,3.3,4.8,3.9,7.7c1.8,9,1.8,18.1,1,27.2c-1.4,16.4-5.4,32.2-10.5,47.8C262.03,178.27,261.53,179.57,261.03,180.87z M81.03,66.77c-0.7-0.3-1.2-0.6-1.8-0.9c-0.1,0-0.4,0.3-0.5,0.4c0.6,0.3,1.2,0.7,1.8,1C80.53,67.37,80.73,67.07,81.03,66.77z"}),jsxRuntimeExports.jsx("path",{className:"st4",d:"M115.43,193.27c-2.1-1.4-4.5-2.6-6.4-4.2c-2.7-2.4-5.1-5.1-7.6-7.7c-0.1-0.1-0.2-0.3-0.4-0.4l0,0 c-0.4-0.3-0.8-0.6-1.2-0.9l0,0c-0.1-0.1-0.3-0.2-0.4-0.4c-0.4-1.8-0.7-3.6-1.2-5.3c-1.9-6.8-3.7-13.7-3.3-20.8 c0.4-7.7,1.2-15.4,4.9-22.3c1-1.8,2.3-3.5,3.6-5.2c0.9-1.1,1-1.7-0.4-2.3c-6.7-3-11.9-7.9-16.5-13.5c-1.9-2.3-3.4-4.8-3.5-7.9 c0.5,0,1.1-0.1,1.6-0.1c0.2-0.1,0.3-0.1,0.5-0.2c0.9-0.5,1.9-1,2.8-1.4c1.9,4.3,4.8,7.9,8.2,11.1c4,3.8,8.7,6.5,13.8,8.6 c2.4,1,3.2,2.9,2,4.8c-0.8,1.3-1.7,2.7-2.8,3.8c-4.6,4.2-6,9.8-7.2,15.4c-1.6,7.4-1.2,14.7,0.4,22c1.7,8,4.7,15.1,10.2,21.2 c0.1,0.1,0.2,0.3,0.3,0.4c1.1,1.2,2.3,2.4,3.4,3.6c0.4,0.4,0.7,1,1,1.5c-0.2,0.1-0.4,0.1-0.6,0.2 C116.23,193.27,115.83,193.27,115.43,193.27z"}),jsxRuntimeExports.jsx("path",{className:"st5",d:"M87.93,100.57c-0.9,0.5-1.9,1-2.8,1.4c-0.2,0.1-0.3,0.1-0.5,0.2c-0.5,0-1.1,0.1-1.6,0.1 c-5.2-0.3-10.5,0-15.7-0.9c-10.9-1.9-17.2-9.1-20.7-19.2c-1.1-3.1-1.4-6.1-1-9.4c0.6-4.8,4.1-7.6,8.6-6.2 c6.2,1.8,12.5,1.8,18.8,1.6c0.7,0,1.3-0.5,2-0.8c0.2,0.1,0.3,0.2,0.5,0.3c0.9,0.7,1.8,1.3,2.7,1.9c0.6,0.4,1.2,0.7,1.8,1 c0.6,0.8,1.1,1.7,1.8,2.4c4.7,4.5,7,10,6.8,16.4C88.63,93.27,88.23,96.87,87.93,100.57z M84.43,90.57c0-3.8-0.5-7.4-2.9-10.4 c-1.9-2.3-4-4.4-6.1-6.6c-0.3-0.3-0.8-0.6-1.1-0.6c-7.2,0.6-14.3,0.4-21.3-1.7c-1.7-0.5-3,0.5-3.2,2.2c-1,9.4,4.6,18,12.7,21.6 c6.2,2.8,12.9,3.1,19.6,2.3c0.6-0.1,1.5-0.9,1.6-1.5C84.13,94.07,84.23,92.37,84.43,90.57z"}),jsxRuntimeExports.jsx("path",{className:"st6",d:"M64.93,205.47c0.3-0.3,0.7-0.8,1-0.8c3.7,0,7.4,0,11.1,0c0.2,0,0.5,0.3,0.7,0.4c-1.2,0.1-2.4,0.3-3.6,0.4 C71.13,205.47,68.03,205.47,64.93,205.47z"}),jsxRuntimeExports.jsx("path",{className:"st7",d:"M99.43,179.67c0.1,0.1,0.3,0.2,0.4,0.4c-0.3,0-0.6,0-0.9,0C99.13,179.97,99.23,179.77,99.43,179.67z"}),jsxRuntimeExports.jsx("path",{className:"st8",d:"M75.63,67.87c-0.2-0.1-0.3-0.2-0.5-0.3c0.2-0.2,0.3-0.3,0.5-0.5C75.63,67.27,75.63,67.57,75.63,67.87z"}),jsxRuntimeExports.jsx("path",{className:"st6",d:"M120.33,205.47c1.1-1.3,2.2-1.3,3.3,0C122.53,205.47,121.43,205.47,120.33,205.47z"}),jsxRuntimeExports.jsx("path",{className:"st7",d:"M99.83,180.07c0.4,0.3,0.8,0.6,1.2,0.9C100.63,180.57,100.23,180.37,99.83,180.07z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M115.43,193.27c0.4,0,0.8,0,1.2,0C116.23,193.27,115.83,193.27,115.43,193.27z"}),jsxRuntimeExports.jsx("path",{className:"st7",d:"M244.53,194.57c0.4,0,0.8,0,1.2,0C245.23,194.47,244.83,194.47,244.53,194.57z"}),jsxRuntimeExports.jsx("path",{className:"st7",d:"M101.03,180.87c0.1,0.1,0.2,0.3,0.4,0.4C101.33,181.17,101.13,181.07,101.03,180.87z"}),jsxRuntimeExports.jsx("path",{className:"st8",d:"M81.03,66.77c-0.3,0.3-0.5,0.6-0.5,0.5c-0.6-0.3-1.2-0.7-1.8-1c0.2-0.1,0.4-0.4,0.5-0.4 C79.83,66.17,80.33,66.47,81.03,66.77z"}),jsxRuntimeExports.jsx("path",{className:"st9",d:"M84.63,102.17c0.2-0.1,0.3-0.1,0.5-0.2C84.93,102.07,84.83,102.17,84.63,102.17z"}),jsxRuntimeExports.jsx("path",{className:"st4",d:"M205.53,176.87c-4.5,0.5-9,1.1-13.5,1.6c-0.7,0-1.4,0-2,0c-16.9-0.6-32.2-6.1-46.4-14.9 c-1-0.6-2-1.7-2.2-2.7c-0.2-1.1,0.2-2.9,0.9-3.4c1-0.6,2.8-0.6,3.9-0.1c3.5,1.7,6.7,3.9,10.2,5.6c11.5,5.8,23.7,9.3,36.7,8.8 c11.7-0.4,22.4-3.9,32-10.7c2.6-1.8,2.7-2,1.5-4.8c-6.6-15.5-18.4-24.2-34.8-26.8c-1.1-0.2-2.3,0-3.5-0.2 c-2.2-0.4-3.2-1.9-2.8-4.2c0.3-1.8,1.7-2.6,3.8-2.4c10.2,0.6,19.3,3.9,27.4,10c8,6.1,13.8,13.8,17,23.4c1.4,4.1,0.7,6.5-2.7,9.1 c-6.5,5.1-13.8,8.7-21.8,10.8c-0.9,0.2-1.8,0.6-2.7,0.8C206.03,176.87,205.83,176.87,205.53,176.87z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M115.43,75.67c-3.1,0-6.1-2.9-6.6-6.5c-0.3-2.2-0.9-4.4,1-6.3c2.1-2.1,4.5-1.9,6.3,0.4 c0.6,0.7,1.3,1.4,2.1,1.9c3.2,1.8,4.3,3.5,3.6,6.1S118.53,75.77,115.43,75.67z"})]})})})]});const BoatBadge=({elClass:s,showLabel:a=true})=>jsxRuntimeExports.jsxs("svg",{className:s,xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 360 360",children:[a&&jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{className:"st0",d:"M129.72,251.47v0.23h0.45v-1.13c0.41-2.4,1.46-3.61,3.16-3.61h1.13c2.4,0,3.61,2.7,3.61,8.11v3.38 c-0.15,15.44-0.23,24.83-0.23,28.17c0.15,0,0.23,0.08,0.23,0.23h-0.23c0.15,0.3,0.23,0.53,0.23,0.68c0,9.05,0.9,15.51,2.7,19.38 c1.99,1.8,3.64,2.7,4.96,2.7c3.12,0,6.35-5.56,9.69-16.68c0.45-3,1.88-4.51,4.28-4.51h0.23c2.7,0.41,4.06,1.77,4.06,4.06 c0,4.17-2.4,10.55-7.21,19.16c-3.19,4.36-7.02,6.54-11.49,6.54c-4.21,0-8.26-2.4-12.17-7.21c-1.65-3.87-2.48-6.87-2.48-9.01 c-0.19,0-1.09,2.1-2.7,6.31c-4.47,8.11-10.03,12.17-16.68,12.17c-5.18,0-10.07-1.65-14.65-4.96c-4.96-5.26-7.44-12.55-7.44-21.86 v-2.03c0-13.56,4.06-25.5,12.17-35.83c5.48-6.16,10.52-9.24,15.1-9.24C121.9,246.51,126.34,248.16,129.72,251.47z M97.71,293.39 c0,6.87,1.58,12.13,4.73,15.78c2.97,1.8,5.97,2.7,9.01,2.7c7.44,0,12.85-12.85,16.23-38.54c0.3-2.33,0.45-4.88,0.45-7.66 c0-2.85-1.95-5.93-5.86-9.24c-1.84-0.9-3.87-1.35-6.08-1.35c-5.26,1.84-9.99,7.1-14.2,15.78c-2.85,6.8-4.28,13.94-4.28,21.41 C97.71,292.27,97.71,293.39,97.71,293.39z"}),jsxRuntimeExports.jsx("path",{className:"st0",d:"M192.2,255.75c0.45,1.5,0.68,3.23,0.68,5.18v1.35c0,6.24-2.4,11.79-7.21,16.68c3.61,1.05,7.06,3.98,10.37,8.79 c1.8,3.49,2.7,6.95,2.7,10.37v0.45c0,1.8-0.3,3.68-0.9,5.63c3.38-1.43,7.29-4.81,11.72-10.14c1.58-2.55,3.16-3.83,4.73-3.83h0.45 c2.22,0,3.57,1.43,4.06,4.28c0,2.44-3.46,6.8-10.37,13.07c-9.5,6.31-15.74,9.47-18.71,9.47c-8.6,2.25-14.76,3.38-18.48,3.38 c-2.93,0-6.91-0.75-11.94-2.25c-1.69,0-2.82-6.76-3.38-20.28c-0.6-6.35-0.9-11.76-0.9-16.23c0.45-20.66,1.35-31.78,2.7-33.35 c1.01-0.9,2.14-1.35,3.38-1.35c2.03,0,3.23,1.58,3.61,4.73c4.88-4.66,9.69-6.99,14.42-6.99 C185.25,244.71,189.61,248.39,192.2,255.75z M163.8,278.74h0.23c4.17,0,8.75-1.5,13.75-4.51c4.36-3.12,6.54-7.25,6.54-12.4v-0.45 c-0.38-5.26-1.95-7.89-4.73-7.89c0-0.15-0.15-0.23-0.45-0.23c-4.36,0-8.41,3.53-12.17,10.59c-2.1,4.62-3.16,7.7-3.16,9.24 L163.8,278.74L163.8,278.74z M166.06,311.19c2.67,0.45,4.47,0.68,5.41,0.68c3.72,0,8-0.98,12.85-2.93 c3.91-3.04,5.86-6.57,5.86-10.59v-0.23c0-5.45-2.93-9.35-8.79-11.72c-1.77-0.75-3.72-1.13-5.86-1.13 c-7.51,1.58-11.42,2.63-11.72,3.16C164.67,303.6,165.42,311.19,166.06,311.19z"}),jsxRuntimeExports.jsx("path",{className:"st0",d:"M246.74,254.4c1.2,3.38,1.8,6.84,1.8,10.37v1.8c0,2.03-1.28,3.23-3.83,3.61h-0.23c-2.07,0-3.27-1.58-3.61-4.73 c-0.71-5.26-1.54-7.89-2.48-7.89c0-0.98-1.8-1.88-5.41-2.7c-0.49,0-0.86-0.08-1.13-0.23c-4.47,0-8.08,4.73-10.82,14.2 c-0.45,4.7-0.68,8.83-0.68,12.4c0,15.85,2.7,25.54,8.11,29.07c1.84,1.05,4.24,1.58,7.21,1.58h0.68c7.21,0,13.37-2.85,18.48-8.56 c3.68-4.96,6.24-9.39,7.66-13.3c1.05-1.8,2.4-2.7,4.06-2.7c2.85,0.53,4.28,1.95,4.28,4.28c-0.6,3-3.08,7.89-7.44,14.65 c-3.79,5.93-9.73,10.22-17.8,12.85c-3.27,0.9-6.35,1.35-9.24,1.35h-0.9c-10.97,0-18.1-5.93-21.41-17.8 c-1.5-4.77-2.25-11.83-2.25-21.18c0-11.79,1.43-19.61,4.28-23.44c3.79-7.96,9.05-11.94,15.78-11.94 C238.1,246.06,243.06,248.84,246.74,254.4z"})]}),jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{className:"st1",d:"M186.72,34.06c-3.91,1.4-7.44-2.08-6.93-4.99c0.15-0.87,0.57-1.7,0.86-2.54c0.57-0.48,1.15-0.97,1.72-1.45 c1.64,0,3.28,0,4.92,0c0.19,0.1,0.38,0.2,0.58,0.3c1.78,1.54,2.29,3.52,2.01,5.77c-0.67,0.87-1.34,1.74-2.02,2.61c0,0,0,0,0,0 C187.49,33.85,187.11,33.95,186.72,34.06z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M264.61,170.39c-0.01,0.35,0.13,0.81-0.04,1.04c-2.29,3.02-4.62,6.01-6.94,9 c-3.46,4.48-6.93,8.95-10.39,13.43c-2.43,3.15-4.84,6.32-7.31,9.44c-0.42,0.54-1.11,0.87-1.67,1.3c-28.35,0-56.7-0.01-85.06-0.01 c-10.27,0-20.54-0.01-30.81,0.01c-0.66,0-1.31,0.19-1.97,0.29c-2.21,0.45-2.8-1.56-3.86-2.69c-2.53-2.68-4.87-5.55-7.29-8.33 c-3.28-3.76-6.56-7.52-9.86-11.26c-2.54-2.88-5.15-5.7-7.66-8.6c-1.05-1.22-1.93-2.59-2.89-3.89c2.64,0.1,5.28,0.29,7.92,0.29 c55.27,0.02,110.53,0.01,165.8,0.01C263.26,170.41,263.93,170.4,264.61,170.39z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M233.63,163.17c-1.25,0-2.51,0-3.76,0c-0.55-0.1-1.1-0.28-1.64-0.28c-10.16-0.02-20.33-0.01-30.49-0.01 c-0.61-0.19-1.22-0.52-1.84-0.56c-2.57-0.15-5.14-0.22-7.72-0.31c-0.29-0.48-0.57-0.97-0.86-1.45c1.15,0.05,0.85-0.81,0.85-1.42 c0.01-28.44,0.01-56.87,0-85.31c0-1.11-0.18-2.21-0.28-3.32c0.1-0.19,0.19-0.38,0.29-0.57c0.77-0.68,1.55-1.35,2.32-2.03 c0.29,0,0.58,0,0.87,0c0.48,0.87,0.97,1.74,1.45,2.6l0,0c0.39,0.68,0.77,1.35,1.16,2.03c0.1,0.39,0.19,0.77,0.29,1.16 c0.29,0.77,0.58,1.54,0.87,2.32c0.1,0.29,0.19,0.58,0.29,0.87c0.19,0.48,0.38,0.97,0.58,1.45c0.1,0.29,0.2,0.58,0.29,0.87 c0.29,0.77,0.58,1.54,0.87,2.32c0.1,0.29,0.19,0.58,0.29,0.87c0.19,0.39,0.39,0.77,0.58,1.16c0.1,0.29,0.19,0.58,0.29,0.87 c0.29,0.48,0.58,0.97,0.87,1.45c0.1,0.39,0.19,0.77,0.29,1.16c0.48,1.4,0.89,2.83,1.47,4.19c0.34,0.79,0.94,1.46,1.42,2.18 c0.19,0.48,0.39,0.96,0.58,1.45c0.19,0.39,0.38,0.77,0.58,1.16c0.19,0.48,0.39,0.96,0.58,1.45c0.1,0.19,0.19,0.39,0.29,0.58 c0.1,0.29,0.19,0.58,0.29,0.87c0.32,1.2,0.27,2.61,1.74,3.19l0,0c0,0.29,0,0.58,0,0.87c0.1,0.19,0.19,0.39,0.29,0.58 c0.1,0.19,0.19,0.39,0.29,0.58c0.1,0.19,0.19,0.39,0.29,0.58c0.1,0.19,0.19,0.39,0.29,0.58c0.1,0.19,0.19,0.39,0.29,0.58 c0.1,0.19,0.19,0.39,0.29,0.58c0.1,0.19,0.19,0.38,0.29,0.58l0,0c0.19,0.19,0.39,0.39,0.58,0.58c0,0.09,0,0.19,0,0.28 c0.39,0.68,0.77,1.35,1.16,2.03c0.58,0.96,1.16,1.93,1.74,2.89c0.36,1.1,0.4,2.39,1.74,2.9c0,0.09,0,0.19,0,0.28 c0.29,0.19,0.58,0.39,0.87,0.58c0.29,0.48,0.58,0.96,0.87,1.45c0.1,0.19,0.19,0.39,0.29,0.58c0.19,0.48,0.39,0.96,0.58,1.44 c0.29,0.39,0.58,0.77,0.87,1.16l0,0c0.67,0.97,1.35,1.93,2.02,2.9l0,0c0.48,0.77,0.97,1.54,1.45,2.32l0,0 c0.39,0.48,0.77,0.97,1.16,1.45c0.1,0.1,0.19,0.19,0.29,0.29c0.29,0.29,0.58,0.58,0.86,0.87c0,0.1,0,0.19,0,0.29 c0.39,0.48,0.77,0.97,1.16,1.45l0,0c0.29,0.39,0.58,0.77,0.87,1.16c0,0,0,0,0,0c0.48,0.58,0.97,1.16,1.45,1.74 c0.1,0.1,0.19,0.19,0.29,0.29c0.29,0.29,0.58,0.58,0.86,0.87c0,0.1,0,0.19,0,0.29c0.39,0.48,0.77,0.97,1.16,1.45l0,0 c0.05,1.11,0.63,1.68,1.74,1.74c0.1,0.1,0.19,0.19,0.29,0.29c0.29,0.39,0.58,0.77,0.87,1.16c0.39,0.48,0.77,0.96,1.16,1.45 c1.84,1.92,3.67,3.84,5.52,5.74c0.1,0.1,0.37,0.04,0.56,0.05c0.29,0.29,0.58,0.58,0.87,0.87c0.13,1.25,0.95,1.9,2.03,2.32l0,0 c0.36,1.15,1.04,1.93,2.32,2.03c0.19,0.19,0.39,0.38,0.58,0.58c0.48,0.39,0.97,0.77,1.45,1.16c0,0,0,0,0,0 c0.48,0.39,0.97,0.77,1.45,1.16l0,0c0.08,0.22,0.1,0.54,0.25,0.64c2.51,1.54,5.04,3.05,7.56,4.57c0,0.39,0,0.77,0,1.16 c-0.29,0.29-0.58,0.58-0.87,0.87c-0.39,0.1-0.77,0.19-1.16,0.29c-0.59-0.62-3.06-0.87-3.77-0.34c-0.16,0.12-0.19,0.41-0.28,0.63 c-3.96,0-7.91,0-11.87,0C236.14,162.98,234.88,163.08,233.63,163.17z M217.99,129.3L217.99,129.3c-0.29-0.39-0.58-0.77-0.87-1.16 l0,0c-0.39-0.48-0.77-0.97-1.16-1.45c-0.1-0.19-0.19-0.39-0.29-0.58c-0.29-0.39-0.58-0.77-0.87-1.16 c-0.29-0.58-0.58-1.16-0.87-1.74c-0.5-1.09-0.87-2.27-1.53-3.26c-0.81-1.22-1.87-2.28-2.82-3.41c-0.19-1.69-1.07-2.97-2.32-4.05 c-0.09-0.47-0.08-0.98-0.28-1.39c-2.04-4.27-4.12-8.53-6.19-12.79c-0.62-1.28-1.32-2.53-1.88-3.84c-0.64-1.48-1.14-3.01-1.73-4.51 c-1.58-4.02-3.16-8.03-4.79-12.03c-0.16-0.39-0.64-0.64-0.97-0.96c-0.22,0.26-0.44,0.52-0.66,0.78c0,15.48,0,30.96,0,46.44 c0,10.95-0.01,21.89,0.02,32.84c0,0.6,0.36,1.19,0.56,1.79c0,0.1,0,0.19,0,0.29c0.02,0.18,0.02,0.51,0.06,0.51 c0.94,0.14,1.89,0.34,2.84,0.34c6.83,0.03,13.67,0.02,20.5,0c0.5,0,1-0.18,1.5-0.28c0.87,0,1.74,0,2.61,0c1.83,0,3.67,0,5.5,0 c0.58,0,1.16,0,1.74,0c0.19-0.1,0.39-0.19,0.58-0.29c0.19,0.1,0.39,0.19,0.58,0.29c0.77,0.83,1.85,0.83,2.6-0.01 c0.1-0.1,0.19-0.19,0.29-0.29c0.48,0.1,0.97,0.19,1.45,0.29c0.58,0,1.16,0,1.74,0c0.32,0.19,0.64,0.55,0.97,0.55 c2.92,0.04,5.85,0.04,8.78,0c0.33,0,0.65-0.36,0.97-0.55c0.73,0,1.67,0,1.36-1.03c-0.24-0.78-0.55-1.99-1.94-1.58 c-0.48-0.39-0.96-0.77-1.45-1.16c-0.29-0.29-0.58-0.58-0.87-0.87c-0.19-0.19-0.39-0.39-0.58-0.58c-1.43-2.62-3.46-4.65-6.08-6.08 c-0.29-0.29-0.58-0.58-0.87-0.87c-0.67-1.07-1.12-2.36-2.61-2.61c-0.1-0.1-0.19-0.19-0.29-0.29c-0.79-1.14-1.26-2.6-2.9-2.9 c-0.1-0.19-0.19-0.39-0.29-0.58c0.66-1.43-0.49-1.05-1.16-1.16c-0.1-0.1-0.19-0.19-0.29-0.29c-0.07-0.92-0.23-1.77-1.45-1.74l0,0 c-0.1-1.08-0.4-2-1.73-2.03c-0.19-0.19-0.39-0.39-0.58-0.58l0,0c0-0.1,0-0.19,0-0.29c-0.1-0.19-0.19-0.39-0.29-0.58 c-1.16-1.45-2.32-2.89-3.47-4.34C218.38,129.88,218.18,129.59,217.99,129.3z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M187.88,70.52c0.1,1.11,0.28,2.21,0.28,3.32c0.02,28.44,0.01,56.87,0,85.31c0,0.61,0.29,1.47-0.85,1.42 c0-29.24,0-58.49-0.01-87.73c0-0.58,0-1.16,0-1.74C187.49,70.91,187.68,70.72,187.88,70.52z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M100.16,156.23c0.19-0.1,0.39-0.19,0.58-0.29c0.29,0,0.58,0,0.86,0c1.14-0.08,2-0.55,2.32-1.74l0,0 c0.65-0.01,1.37,0.1,1.45-0.87c0,0,0,0,0,0c0.84,0.06,1.22-0.32,1.16-1.16c0.1-0.1,0.19-0.19,0.29-0.29c1.09-0.1,2-0.4,2.03-1.74 c0.19-0.19,0.39-0.39,0.58-0.58c1.25,0.32,1.63-0.4,1.74-1.45c0.19-0.19,0.39-0.39,0.58-0.58c0.83,0.06,1.22-0.33,1.16-1.16 c0.87-0.87,1.74-1.74,2.6-2.61c1.63-1.45,3.26-2.9,4.87-4.37c0.1-0.09,0.04-0.36,0.05-0.55c0.39-0.39,0.77-0.77,1.16-1.16 c1.34-0.21,2.11-0.98,2.32-2.32c0.1-0.1,0.19-0.19,0.29-0.29c1.42-0.29,2.34-1.31,2.61-2.9c0.19-0.19,0.39-0.39,0.58-0.58 c1.35-0.18,2.06-0.92,2.03-2.32l0,0c1.1,0.09,1.21-0.61,1.16-1.45l0,0c1.1,0.09,1.21-0.61,1.16-1.45c0,0,0,0,0,0 c0.81-0.66,1.67-1.27,2.43-1.99c0.97-0.93,1.86-1.95,2.79-2.93c0,0.29,0,0.58,0,0.87c-0.1,0.1-0.19,0.19-0.29,0.29 c-0.19,0.29-0.39,0.58-0.58,0.87c-0.1,0.1-0.19,0.19-0.29,0.29c-0.19,0.29-0.39,0.58-0.58,0.87c-0.48,0.58-0.97,1.16-1.45,1.74 c-0.19,0.29-0.39,0.58-0.58,0.87c-0.19,0.19-0.39,0.39-0.58,0.58c-0.29,0.39-0.58,0.77-0.87,1.16c-0.19,0.19-0.39,0.39-0.58,0.58 c-0.29,0.39-0.58,0.77-0.87,1.16c-0.19,0.19-0.39,0.39-0.58,0.58c-0.29,0.39-0.58,0.77-0.87,1.16c-0.58,0.58-1.16,1.16-1.74,1.74 c-0.39,0.39-0.77,0.77-1.16,1.16c-0.39,0.48-0.77,0.97-1.16,1.45c-0.58,0.58-1.16,1.16-1.74,1.74c-1.3,0.27-2.92,1.88-3.18,3.18 c-0.39,0.39-0.77,0.77-1.16,1.16c-0.38,0.14-0.86,0.19-1.14,0.45c-1.15,1.07-2.26,2.18-3.33,3.33c-0.26,0.28-0.31,0.75-0.45,1.14 c-0.29,0.19-0.58,0.39-0.87,0.58c-0.48,0.48-0.97,0.97-1.45,1.45c-0.29,0.19-0.58,0.39-0.87,0.58c-0.68,0.68-1.35,1.35-2.03,2.03 c-0.39,0.29-0.77,0.58-1.16,0.87c-0.19,0.19-0.39,0.39-0.58,0.58c-1.25,0.13-1.89,0.95-2.32,2.03c-0.42,0.18-0.89,0.3-1.26,0.55 c-0.8,0.55-1.48,1.3-2.33,1.73c-1.1,0.55-2.35,0.81-3.48,1.31c-0.93,0.41-0.98,1.23-0.1,1.75c0.59,0.35,1.3,0.5,1.96,0.74 c-0.1,0.29-0.19,0.58-0.29,0.87c-0.19,0-0.39,0-0.58,0c-0.13-0.24-0.19-0.62-0.39-0.71c-1.01-0.48-2.05-0.88-3.08-1.31 c0.29-0.68,0.58-1.35,0.87-2.03c1.28,0,2.59,0.05,3.19-1.45C99.38,157,99.77,156.62,100.16,156.23z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M174.86,46.2c0.58-1.35,1.16-2.7,1.74-4.05c0.29-0.68,0.58-1.35,0.87-2.03c0.1-0.19,0.19-0.39,0.29-0.58 c0.19-0.19,0.39-0.39,0.58-0.58c0.29-0.1,0.58-0.19,0.87-0.29c0.19-0.1,0.39-0.19,0.58-0.29c0,0,0,0,0,0c0.29,0,0.58,0,0.87,0 c0.77,0.29,1.54,0.58,2.32,0.87c0.29,0.96,0.58,1.93,0.87,2.89c-0.1,0.39-0.19,0.77-0.29,1.16c-1.15,0.06-0.76-0.81-0.88-1.41 c-0.24-1.13-0.4-2.39-1.88-2.54c-1.3-0.13-1.94,0.87-2.52,1.82c-0.24,0.4-0.33,0.9-0.5,1.35c-1.27,3.47-2.41,6.99-3.84,10.4 c-3.24,7.75-6.62,15.44-9.98,23.14c-0.19,0.43-0.64,0.75-0.97,1.12c0.15-0.5,0.29-1,0.46-1.49c0.42-1.24,0.85-2.48,1.28-3.72 c0.1-0.38,0.19-0.77,0.29-1.15c0.3-0.32,0.67-0.59,0.87-0.96c0.09-0.16-0.18-0.51-0.29-0.77c0.1-0.19,0.19-0.39,0.29-0.58 c1.18-0.35,1.57-1.26,0.87-2.03c0.1-0.19,0.19-0.39,0.29-0.58c1.14-0.35,2.05-2.17,1.73-3.47c0.1-0.19,0.19-0.39,0.29-0.58 c0.19-0.05,0.52-0.06,0.56-0.17c1.91-4.79,3.81-9.58,5.65-14.39C175.38,47.01,175.01,46.57,174.86,46.2z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M99,162.88c0.1-0.29,0.19-0.58,0.29-0.87c8.88,0,17.76,0,26.64,0c0.73,0.15,1.8-0.46,2.03,0.87 c-0.39,0-0.77,0-1.16,0c-2.9,0-5.79,0-8.69,0c-5.98,0-11.97,0-17.95,0C99.77,162.89,99.38,162.89,99,162.88z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M136.92,121.48c-0.93,0.98-1.81,2-2.79,2.93c-0.75,0.72-1.61,1.33-2.43,1.99c0.28-0.42,0.54-0.86,0.84-1.27 c1.35-1.8,2.72-3.6,4.09-5.39c0.19-0.19,0.38-0.39,0.58-0.58c2.03-2.71,4.68-4.96,6.11-8.13c0.24-0.53,0.74-0.95,1.12-1.42l0,0 c-0.14,0.49-0.3,0.98-0.41,1.47c-0.17,0.76-0.31,1.53-0.46,2.29c-0.1,0.19-0.19,0.39-0.29,0.58c-0.3,0.03-0.74-0.05-0.89,0.12 c-1.16,1.34-2.31,2.69-3.37,4.11C138.26,119.23,137.62,120.38,136.92,121.48z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M172.83,163.18c-0.77,0-1.54,0-2.32,0c0-0.1,0-0.19,0-0.29c0.77-0.19,1.54-0.39,2.32-0.58 c0.39,0,0.77,0,1.16,0c2.51,0,5.02,0,7.53,0c0.19,0,0.39,0,0.58,0c0.39-0.1,0.77-0.19,1.16-0.29c0,0.1,0,0.19,0,0.29 c-0.19,0.19-0.39,0.39-0.58,0.58c-0.19,0.1-0.39,0.19-0.58,0.29c-2.7,0-5.4,0-8.11,0C173.6,163.18,173.21,163.18,172.83,163.18z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M197.72,162.89c0,0.1,0,0.19,0,0.29c-2.61,0-5.21,0-7.82,0c-0.58-0.39-1.16-0.77-1.74-1.16 c2.57,0.1,5.15,0.16,7.72,0.31C196.51,162.37,197.11,162.69,197.72,162.89z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M115.5,143.78c0-0.19,0-0.38,0.01-0.58c0.39-0.39,0.77-0.77,1.16-1.16c0.68-0.68,1.35-1.35,2.03-2.03 c0.39-0.39,0.77-0.77,1.16-1.16c0.19,0,0.38,0,0.58-0.01c-0.01,0.19,0.05,0.46-0.05,0.55 C118.76,140.88,117.13,142.32,115.5,143.78z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M255.34,160.28c-2.52-1.52-5.05-3.03-7.56-4.57c-0.16-0.1-0.17-0.42-0.25-0.64c0.19,0,0.38,0,0.58,0 c0,0,0,0,0,0c0.39,0.29,0.77,0.58,1.16,0.87c0.29,0.19,0.58,0.39,0.87,0.58c1.54,0.87,3.09,1.74,4.63,2.61 c0.1,0.1,0.19,0.19,0.29,0.29C255.15,159.7,255.24,159.99,255.34,160.28z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M249.26,162.88c0.09-0.21,0.12-0.51,0.28-0.63c0.71-0.53,3.19-0.28,3.77,0.34c0,0.1,0,0.19,0,0.29 C251.96,162.89,250.61,162.89,249.26,162.88z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M95.81,162.31c-0.29-0.48-0.58-0.96-0.87-1.45c1.03,0.43,2.07,0.84,3.08,1.31c0.2,0.09,0.26,0.47,0.39,0.71 c-0.48,0-0.96,0-1.45,0C96.58,162.69,96.2,162.5,95.81,162.31C95.81,162.31,95.81,162.31,95.81,162.31z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M188.17,69.95c0.13-0.44,0.12-1.04,0.41-1.3c0.43-0.37,1.07-0.5,1.62-0.74c0.1,0,0.19,0,0.29,0 C189.71,68.6,188.94,69.27,188.17,69.95z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M127.37,131.62c0.1-0.29,0.19-0.58,0.29-0.87c0.19-0.19,0.39-0.39,0.58-0.58c0.39-0.29,0.77-0.58,1.16-0.87 C129.43,130.69,128.72,131.43,127.37,131.62z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M96.39,158.25c0.87-0.29,1.74-0.58,2.61-0.87c-0.6,1.5-1.9,1.45-3.19,1.45c0-0.1,0-0.19,0-0.29 C96.01,158.45,96.2,158.35,96.39,158.25z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M182.96,39.26c0.1,0,0.19,0,0.29,0c0.19,0.19,0.39,0.39,0.58,0.58c0.1,0.77,0.19,1.54,0.29,2.31 c-0.1,0-0.19,0-0.29,0C183.54,41.19,183.25,40.22,182.96,39.26z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M108.84,150.15c-0.03,1.33-0.94,1.64-2.03,1.74c0.29-0.39,0.58-0.77,0.87-1.16c0.1-0.1,0.19-0.19,0.29-0.29 C108.26,150.34,108.55,150.24,108.84,150.15z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M241.15,148.99c0.19,0.39,0.39,0.77,0.58,1.16c-1.08-0.42-1.9-1.07-2.03-2.32c0.29,0.19,0.58,0.39,0.87,0.58 C240.77,148.6,240.96,148.8,241.15,148.99z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M191.64,67.92c0.39,0.87,0.77,1.74,1.16,2.6c-0.48-0.87-0.97-1.74-1.45-2.6 C191.45,67.92,191.55,67.92,191.64,67.92z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M228.71,136.54c0.48,0.39,0.96,0.77,1.45,1.16c0.1,0.19,0.19,0.38,0.29,0.58 C229.34,138.22,228.76,137.64,228.71,136.54z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M177.17,40.12c0.1,0,0.19,0,0.29,0c-0.29,0.68-0.58,1.35-0.87,2.03c0.1-0.48,0.19-0.97,0.29-1.45 C176.97,40.51,177.07,40.32,177.17,40.12z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M231.6,139.15c0,0.19,0,0.39,0,0.58c-0.29-0.39-0.58-0.77-0.87-1.16 C231.02,138.76,231.31,138.95,231.6,139.15z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M255.05,162.31c-0.19,0-0.39,0-0.58,0c0.29-0.29,0.58-0.58,0.87-0.87c0,0.19,0,0.39,0,0.58 C255.24,162.11,255.15,162.21,255.05,162.31z"}),jsxRuntimeExports.jsx("path",{className:"st4",d:"M191.64,80.66c0,25.4,0,50.8-0.01,76.2c0,0.66-0.18,1.31-0.28,1.97c-0.19-0.6-0.55-1.19-0.56-1.79 c-0.03-10.95-0.02-21.89-0.02-32.84c0-15.48,0-30.96,0-46.44c0.62-0.02,1.25-0.06,1.16,0.87 C190.95,79.18,191.27,79.92,191.64,80.66z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M191.93,78.63c0.09-0.93-0.54-0.89-1.16-0.87c0.22-0.26,0.44-0.52,0.66-0.78c0.33,0.32,0.81,0.57,0.97,0.96 c1.63,4,3.21,8.01,4.79,12.03c0.59,1.5,1.1,3.03,1.73,4.51c0.56,1.31,1.26,2.56,1.88,3.84c2.07,4.26,4.14,8.52,6.19,12.79 c0.2,0.41,0.19,0.92,0.28,1.39l0,0c-0.48-0.68-0.96-1.35-1.45-2.03c-0.1-0.19-0.19-0.39-0.29-0.58c-0.19-0.29-0.39-0.58-0.58-0.87 c0,0,0,0,0,0c-0.87-1.74-1.74-3.47-2.61-5.21c0-0.29,0-0.58,0-0.87c-1.35-2.8-2.7-5.6-4.05-8.4c-0.1-0.29-0.19-0.58-0.29-0.87 c-0.39-0.77-0.77-1.54-1.16-2.32c0-0.1,0-0.19,0-0.29c-1.64-3.67-3.28-7.33-4.92-11C191.93,79.6,191.93,79.12,191.93,78.63z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M191.36,159.12c8.3,0,16.6,0,24.9,0c0,0.19,0,0.38,0,0.58c-0.5,0.1-1,0.28-1.5,0.28 c-6.83,0.02-13.67,0.03-20.5,0c-0.95,0-1.9-0.2-2.84-0.34C191.37,159.63,191.38,159.3,191.36,159.12z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M231.6,158.84c4.15,0,8.3,0,12.45,0c0.22-0.02,0.44-0.04,0.68-0.06c-0.45-0.6-0.85-1.14-1.25-1.68 c1.39-0.41,1.7,0.79,1.94,1.58c0.31,1.02-0.63,1.03-1.36,1.03c-3.57,0-7.14,0-10.71,0c-0.58,0-1.16,0-1.74,0 C231.6,159.41,231.6,159.12,231.6,158.84z"}),jsxRuntimeExports.jsx("path",{className:"st4",d:"M216.26,159.7c0-0.19,0-0.38,0-0.58c0.58-0.1,1.16-0.19,1.74-0.29c3.15,0,6.31,0,9.46,0 c0.62,0,1.32-0.13,1.26,0.87c-0.48,0-0.97,0-1.45,0c-0.19-0.1-0.39-0.19-0.58-0.29c-0.19,0.1-0.39,0.19-0.58,0.29 c-0.58,0-1.16,0-1.74,0c-1.83,0-3.67,0-5.5,0C217.99,159.7,217.12,159.7,216.26,159.7z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M236.81,151.3c-0.67-0.68-1.35-1.35-2.02-2.03c-0.1-0.29-0.2-0.58-0.29-0.87c2.63,1.43,4.65,3.46,6.08,6.08 c-0.19,0-0.39,0-0.58,0c-0.1-0.1-0.19-0.19-0.29-0.29C238.74,153.23,237.78,152.27,236.81,151.3z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M233.34,159.7c3.57,0,7.14,0,10.71,0c-0.32,0.19-0.64,0.55-0.97,0.55c-2.92,0.04-5.85,0.04-8.78,0 C233.98,160.25,233.66,159.9,233.34,159.7z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M213.94,123.22c-1.04-1.41-2.08-2.83-3.13-4.23c-0.39-0.53-0.81-1.04-1.21-1.56c0,0,0,0,0,0 c0-0.29,0-0.58,0-0.87l0,0c0.95,1.13,2,2.19,2.82,3.41C213.07,120.95,213.44,122.13,213.94,123.22z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M232.76,141.17c0.29,0,0.58,0,0.87,0c0.58,0.73,1.13,1.49,1.76,2.17c1.13,1.23,2.3,2.41,3.45,3.61 c-0.19-0.01-0.46,0.05-0.56-0.05C236.43,145.01,234.59,143.09,232.76,141.17z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M199.46,87.03c0.26,0.33,0.61,0.62,0.77,0.99c0.74,1.78,1.42,3.59,2.13,5.38c-0.48-0.72-1.08-1.4-1.42-2.18 C200.36,89.86,199.95,88.43,199.46,87.03z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M207.28,112.51c1.24,1.08,2.13,2.37,2.32,4.05c0,0,0,0,0,0c-0.29-0.1-0.58-0.2-0.87-0.29c0,0,0,0,0,0 c-0.29-0.48-0.58-0.96-0.87-1.45c0,0,0,0,0,0C207.67,114.05,207.47,113.28,207.28,112.51L207.28,112.51z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M218.86,159.7c1.83,0,3.67,0,5.5,0C222.53,159.7,220.69,159.7,218.86,159.7z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M229,143.49c-0.39-0.58-0.77-1.16-1.16-1.74c1.64,0.29,2.1,1.76,2.9,2.9 C230.15,144.26,229.57,143.87,229,143.49L229,143.49z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M231.31,145.8c-0.1-0.29-0.2-0.58-0.29-0.87c1.49,0.25,1.94,1.54,2.61,2.61c-0.19,0-0.38,0-0.58-0.01 C232.47,146.96,231.89,146.38,231.31,145.8z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M204.67,98.9c0.58,1.06,1.16,2.12,1.74,3.19C204.95,101.51,205,100.1,204.67,98.9z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M211.91,112.8c0.58,0.97,1.16,1.93,1.74,2.9C212.31,115.18,212.27,113.89,211.91,112.8z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M217.13,121.19c0.67,0.97,1.35,1.93,2.02,2.9C218.48,123.12,217.8,122.16,217.13,121.19z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M241.74,150.14c0.77,0.68,1.54,1.35,2.32,2.03C242.77,152.08,242.09,151.29,241.74,150.14z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M206.41,102.08c0.68,1.45,1.35,2.9,2.03,4.34c-0.1,0-0.19,0-0.29,0c-0.1-0.19-0.19-0.39-0.29-0.58 c-0.1-0.19-0.19-0.39-0.29-0.58c-0.1-0.19-0.19-0.39-0.29-0.58c-0.1-0.19-0.19-0.39-0.29-0.58c-0.1-0.19-0.19-0.39-0.29-0.58 c-0.1-0.19-0.19-0.39-0.29-0.58C206.41,102.66,206.41,102.37,206.41,102.08z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M227.26,159.7c0.48,0,0.97,0,1.45,0c0.38,0,0.77,0,1.15,0C229.1,160.53,228.03,160.53,227.26,159.7z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M224.65,137.99c-0.58-0.68-1.16-1.35-1.73-2.03C224.25,135.99,224.55,136.9,224.65,137.99z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M219.15,124.09c0.48,0.77,0.97,1.54,1.45,2.32C220.12,125.63,219.63,124.86,219.15,124.09z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M226.1,139.73c-0.48-0.58-0.96-1.16-1.45-1.74C225.87,137.96,226.02,138.81,226.1,139.73z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M196.28,79.21c0.29,0.77,0.58,1.54,0.87,2.32C196.86,80.76,196.57,79.98,196.28,79.21z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M227.54,141.17c-0.38-0.19-0.77-0.39-1.15-0.58c0-0.19,0-0.39,0-0.58 C227.05,140.12,228.2,139.75,227.54,141.17z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M226.39,132.78c0,0.29,0,0.58,0,0.87c-0.48-0.58-0.97-1.16-1.45-1.74 C225.42,132.2,225.9,132.49,226.39,132.78z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M209.02,107.87c0.39,0.68,0.77,1.35,1.16,2.03C209.79,109.22,209.41,108.55,209.02,107.87z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M194.25,73.71c0.29,0.77,0.58,1.54,0.87,2.32C194.83,75.25,194.54,74.48,194.25,73.71z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M231.6,158.84c0,0.29,0,0.58,0,0.87c-0.48-0.1-0.97-0.19-1.45-0.29C230.63,159.22,231.12,159.03,231.6,158.84 z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M192.8,70.52c0.39,0.68,0.77,1.35,1.16,2.03C193.58,71.88,193.19,71.2,192.8,70.52z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M246.65,153.91c0.29,0.39,0.58,0.77,0.87,1.16c-0.48-0.39-0.97-0.77-1.45-1.16 C246.27,153.91,246.46,153.91,246.65,153.91z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M244.63,152.75c0.48,0.39,0.97,0.77,1.45,1.16C245.59,153.52,245.11,153.14,244.63,152.75z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M227.55,135.09c0.39,0.48,0.77,0.97,1.16,1.45C228.32,136.06,227.93,135.57,227.55,135.09z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M222.91,129.3c0.39,0.48,0.77,0.97,1.16,1.45C223.69,130.27,223.3,129.78,222.91,129.3z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M217.12,128.14c-0.39-0.48-0.77-0.97-1.16-1.45C216.35,127.18,216.74,127.66,217.12,128.14z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M220.6,126.4c0.39,0.48,0.77,0.97,1.16,1.45C221.37,127.37,220.98,126.89,220.6,126.4z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M216.26,120.03c0.29,0.39,0.58,0.77,0.87,1.16C216.84,120.8,216.55,120.42,216.26,120.03z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M198.3,84.42c0.29,0.48,0.58,0.97,0.87,1.45C198.88,85.39,198.59,84.9,198.3,84.42z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M195.41,76.89c0.19,0.48,0.38,0.97,0.58,1.45C195.79,77.86,195.6,77.38,195.41,76.89z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M217.99,129.3c-0.29-0.39-0.58-0.77-0.87-1.16C217.41,128.53,217.7,128.92,217.99,129.3z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M215.68,126.12c-0.29-0.19-0.58-0.39-0.87-0.58c0-0.1,0-0.19,0-0.29c0-0.1,0-0.19,0-0.29 C215.1,125.34,215.39,125.73,215.68,126.12z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M224.07,130.75c0.29,0.39,0.58,0.77,0.87,1.16C224.65,131.52,224.36,131.13,224.07,130.75z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M202.94,94.85c0.19,0.39,0.38,0.77,0.58,1.16C203.32,95.62,203.13,95.23,202.94,94.85z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M197.44,82.4c0.19,0.39,0.39,0.77,0.58,1.16C197.82,83.17,197.63,82.78,197.44,82.4z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M226.68,133.93c0.29,0.19,0.58,0.39,0.87,0.58c0,0.1,0,0.19,0,0.29 C227.26,134.51,226.97,134.22,226.68,133.93z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M242.02,155.94c-0.29-0.29-0.58-0.58-0.87-0.87C241.44,155.36,241.73,155.65,242.02,155.94z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M222.91,128.72c0,0.1,0,0.19,0,0.29c-0.29-0.29-0.58-0.58-0.86-0.87 C222.34,128.34,222.62,128.53,222.91,128.72z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M213.65,115.98c0.29,0.19,0.58,0.39,0.87,0.58C214.23,116.37,213.94,116.17,213.65,115.98z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M217.99,129.88c0-0.19,0-0.39,0-0.58c0.19,0.29,0.39,0.58,0.58,0.87 C218.38,130.07,218.19,129.98,217.99,129.88z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M226.1,159.7c0.19-0.1,0.39-0.19,0.58-0.29C226.48,159.51,226.29,159.61,226.1,159.7z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M222.33,135.09c-0.1-0.19-0.19-0.39-0.29-0.58C222.14,134.71,222.24,134.9,222.33,135.09z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M215.39,118.01c0.1,0.19,0.19,0.39,0.29,0.58C215.58,118.39,215.48,118.2,215.39,118.01z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M204.1,97.45c0.1,0.19,0.19,0.39,0.29,0.58C204.29,97.84,204.19,97.64,204.1,97.45z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M208.44,107c0.19,0.19,0.39,0.39,0.58,0.58C208.83,107.39,208.63,107.2,208.44,107z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M208.15,106.43c0.1,0,0.19,0,0.29,0c0,0.19,0,0.38,0,0.58C208.34,106.81,208.25,106.62,208.15,106.43z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M207.57,105.27c0.1,0.19,0.19,0.39,0.29,0.58C207.76,105.66,207.67,105.46,207.57,105.27z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M207.28,104.69c0.1,0.19,0.19,0.39,0.29,0.58C207.47,105.08,207.38,104.88,207.28,104.69z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M206.99,104.11c0.1,0.19,0.19,0.39,0.29,0.58C207.18,104.5,207.09,104.3,206.99,104.11z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M206.7,103.53c0.1,0.19,0.19,0.39,0.29,0.58C206.89,103.92,206.8,103.73,206.7,103.53z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M206.41,102.95c0.1,0.19,0.19,0.39,0.29,0.58C206.6,103.34,206.51,103.15,206.41,102.95z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M183.83,42.15c0.1,0,0.19,0,0.29,0c0.1,0.88,0.27,1.76,0.27,2.64c0.01,38.5,0.01,76.99,0.01,115.49 c-0.1,0-0.19,0-0.29,0c-0.19,0-0.39,0-0.58,0c0-0.29,0-0.58,0-0.87c0-38.7,0-77.4,0-116.1C183.63,42.92,183.73,42.54,183.83,42.15 z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M183.54,160.28c0.19,0,0.39,0,0.58,0c0,0.29,0,0.58,0,0.87c-0.29,0.29-0.58,0.58-0.87,0.87 c-0.39,0.1-0.77,0.19-1.16,0.29c0-0.1,0-0.19,0-0.29c0.1-0.29,0.19-0.58,0.29-0.87C182.77,160.86,183.15,160.57,183.54,160.28z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M144.45,109.61c0.89-1.62,1.75-3.26,2.68-4.86c2.8-4.75,5.62-9.49,8.47-14.21c0.29-0.48,0.86-0.81,1.29-1.2 c-0.1,0.48-0.19,0.97-0.29,1.45c-0.19,0.29-0.39,0.58-0.58,0.87c-0.83,1.4-1.74,2.76-2.47,4.21c-0.32,0.63-0.29,1.43-0.43,2.16 c-0.29,0.48-0.58,0.97-0.87,1.45c-0.39,0.15-0.95,0.18-1.14,0.46c-1.64,2.53-3.18,5.12-4.82,7.64 C145.82,108.34,145.08,108.94,144.45,109.61C144.45,109.61,144.45,109.61,144.45,109.61z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M174.86,46.2c0.15,0.36,0.52,0.81,0.42,1.07c-1.84,4.81-3.74,9.6-5.65,14.39c-0.05,0.11-0.37,0.12-0.56,0.17 c0.87-2.23,1.78-4.44,2.61-6.69C172.77,52.18,173.8,49.19,174.86,46.2z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M158.64,85.29c1.06-2.51,2.13-5.02,3.19-7.53c0.19,0,0.38,0,0.58,0c0,0.29,0,0.58,0,0.87c0,0.1,0,0.19,0,0.29 c-0.19,0.39-0.39,0.77-0.58,1.16c-0.1,0.19-0.19,0.39-0.29,0.58c-0.1,0.19-0.19,0.39-0.29,0.58c0.1,0.19,0.19,0.39,0.29,0.58 c-0.1,0.1-0.19,0.19-0.29,0.29c-0.29,0.39-0.58,0.77-0.87,1.16c-0.1,0.1-0.19,0.19-0.29,0.29c-0.1,0.1-0.19,0.19-0.29,0.29 c-0.1,0.29-0.19,0.58-0.29,0.87c-0.1,0.29-0.19,0.58-0.29,0.87C159.02,85.48,158.83,85.39,158.64,85.29z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M164.72,71.97c-0.43,1.24-0.86,2.48-1.28,3.72c-0.17,0.49-0.3,0.99-0.46,1.49c-0.1,0-0.19,0-0.29,0 c-0.19,0-0.38,0-0.58,0C162.98,75.45,163.85,73.71,164.72,71.97z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M159.51,84.71c0.1-0.29,0.19-0.58,0.29-0.87c0.1,0,0.19,0,0.29,0c0.1,0,0.19,0,0.29,0c0,0.39,0,0.77,0,1.16 c-0.19,0.29-0.39,0.58-0.58,0.87c-0.39,0.19-0.77,0.39-1.16,0.58c-0.19,0-0.39,0-0.58,0c0.19-0.39,0.39-0.77,0.58-1.16 c0.19,0.1,0.39,0.19,0.58,0.29C159.31,85.29,159.41,85,159.51,84.71z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M156.61,90.79c0.1-0.48,0.19-0.97,0.29-1.45c0.1-0.29,0.19-0.58,0.29-0.86c0.29,0,0.58,0,0.87,0 c0.1,0.1,0.19,0.19,0.29,0.29c-0.39,0.77-0.77,1.54-1.16,2.32C157,90.99,156.81,90.89,156.61,90.79z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M168.77,62.42c0.32,1.31-0.59,3.12-1.73,3.47C167.62,64.73,168.19,63.58,168.77,62.42z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M158.06,88.48c-0.29,0-0.58,0-0.87,0c0.29-0.68,0.58-1.35,0.87-2.03c0.19,0,0.39,0,0.58,0 c-0.1,0.48-0.19,0.97-0.29,1.45C158.25,88.09,158.16,88.28,158.06,88.48z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M166.75,66.47c0.71,0.77,0.31,1.68-0.87,2.03C166.17,67.82,166.46,67.15,166.75,66.47z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M165.59,69.08c0.11,0.26,0.37,0.61,0.29,0.77c-0.2,0.37-0.57,0.65-0.87,0.96 C165.2,70.24,165.4,69.66,165.59,69.08z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M162.12,77.18c0.19,0,0.38,0,0.58,0c0,0.19,0,0.39,0,0.58c-0.1,0-0.19,0-0.29,0c-0.19,0-0.38,0-0.58,0 C161.92,77.57,162.02,77.38,162.12,77.18z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M125.92,162.02c-8.88,0-17.76,0-26.64,0c-0.66-0.24-1.37-0.39-1.96-0.74c-0.87-0.52-0.83-1.34,0.1-1.75 c1.13-0.5,2.38-0.75,3.48-1.31c0.85-0.43,1.54-1.18,2.33-1.73c0.37-0.26,0.84-0.37,1.26-0.55c-0.45,0.51-0.89,1.02-1.34,1.52 c0.58,0.08,1.01-0.08,1.42-0.27c3.23-1.44,5.71-3.91,8.19-6.28c5.52-5.29,10.98-10.67,16.23-16.24c3.41-3.62,6.44-7.61,9.54-11.51 c2.36-2.96,4.74-5.92,6.81-9.09c3.51-5.39,6.84-10.9,10.13-16.44c1.98-3.34,3.82-6.78,5.55-10.25c1.97-3.95,3.78-7.98,5.6-12.01 c1.55-3.44,3.02-6.92,4.51-10.39c1.89-4.44,3.77-8.88,5.63-13.33c0.46-1.1,1-2.2,1.23-3.36c0.19-0.97,0.49-1.53,1.52-1.5 c1.03,0.03,1.61,0.59,1.69,1.59c0.06,0.72,0.01,1.45,0.02,2.17c0.1,0.81,0.28,1.61,0.28,2.42c0.01,32.31,0.02,64.62,0,96.94 c0,3.17-0.18,6.34-0.28,9.51c-0.29,0.19-0.58,0.39-0.87,0.58c-17.63,0.08-35.26-0.1-52.91,0.36c0.28,0.35,0.57,0.49,0.86,0.5 c2.43,0.02,4.87,0.01,7.3,0.01c14.27,0,28.54,0,42.81-0.01c0.55,0,1.1-0.18,1.64-0.28c0.58-0.19,1.16-0.39,1.74-0.58 c0.19,0,0.39,0,0.58,0c0,0.39,0,0.77,0,1.16c-0.81,0.1-1.61,0.28-2.42,0.28c-14.86,0.02-29.72,0.02-44.57,0 c-2.81,0-5.62-0.14-8.44-0.14C126.61,161.29,126.27,161.76,125.92,162.02z M150.82,107.59c-0.19,0.19-0.39,0.39-0.58,0.58 c0,0.1,0,0.19,0,0.29c-0.48,0.77-0.97,1.54-1.45,2.32c-0.29,0.48-0.58,0.97-0.87,1.45c0,0.1,0,0.19,0,0.29 c-0.68,0.97-1.35,1.93-2.03,2.9c-0.19,0.19-0.39,0.39-0.58,0.58c0,0.1,0,0.19,0,0.29c-0.19,0.19-0.39,0.39-0.58,0.58 c0,0.1,0,0.19,0,0.29c-0.29,0.39-0.58,0.77-0.87,1.16s-0.58,0.77-0.87,1.16c-0.1,0.1-0.19,0.19-0.29,0.29 c-0.29,0.39-0.58,0.77-0.87,1.16c-0.29,0.39-0.58,0.77-0.87,1.16c-0.1,0.1-0.19,0.19-0.29,0.29c-0.29,0.39-0.58,0.77-0.87,1.16 c-0.1,0.1-0.19,0.19-0.29,0.29c-0.29,0.39-0.58,0.77-0.87,1.16c-0.1,0.1-0.19,0.19-0.29,0.29c-0.29,0.39-0.58,0.77-0.87,1.16 c-0.39,0.48-0.77,0.97-1.16,1.45c-0.1,0.1-0.19,0.19-0.29,0.29c-0.68,0.87-1.35,1.74-2.03,2.61c-0.29,0.29-0.58,0.58-0.87,0.87 c-0.48,0.58-0.97,1.16-1.45,1.74c-0.1,0.1-0.19,0.19-0.29,0.29c-0.77,0.87-1.54,1.74-2.32,2.61c-0.39,0.39-0.77,0.77-1.16,1.16 c-0.48,0.48-0.97,0.97-1.45,1.45c-1.58,1.45-3.18,2.88-4.74,4.36c-0.42,0.4-0.71,0.95-1.05,1.43c-0.97,0.97-1.93,1.93-2.9,2.9 c-0.97,0.97-1.93,1.93-2.9,2.9c-0.1,0.1-0.19,0.19-0.29,0.29c-0.77,0.68-1.54,1.35-2.32,2.03c-0.29,0.29-0.58,0.58-0.87,0.87 c-0.77,0.68-1.54,1.35-2.32,2.03c-0.39,0.29-0.77,0.58-1.16,0.87c-1.23,0.35-2.24,0.86-1.92,2.5c0.81,0.14,1.55,0.38,2.3,0.38 c5.81,0.03,11.63,0.07,17.44-0.03c1.02-0.02,2.02-0.72,3.03-1.1c1.64,0,3.28,0,4.92,0c2.51,0,5.02,0,7.53,0 c9.46,0,18.92,0,28.37,0c0.18,0.79,0.58,1.23,1.45,0.87c0.19-0.1,0.39-0.19,0.58-0.29c0.48,0,0.97,0,1.45,0 c0.19,0.1,0.39,0.19,0.58,0.29c1.75,0.04,3.51,0.26,5.23,0.07c1.42-0.15,1.8-1.08,1.54-2.53c-0.1-0.52-0.1-1.05-0.1-1.58 c0-30.52,0-61.04,0-91.55c0-0.43,0.03-0.87,0.03-1.3c-0.01-4.22-0.02-8.44-0.07-12.65c0-0.33-0.32-0.91-0.52-0.92 c-0.35-0.02-0.78,0.24-1.07,0.5c-0.27,0.24-0.47,0.61-0.61,0.97c-1.11,2.81-2.14,5.66-3.31,8.45c-1.28,3.05-2.73,6.03-4.01,9.08 c-0.87,2.07-1.56,4.22-2.32,6.33c0,0.1,0,0.19,0,0.29c-0.29,0.58-0.58,1.16-0.87,1.74c0,0.1,0,0.19,0,0.29 c-0.31,0.33-0.72,0.6-0.9,0.99c-2.26,4.65-4.49,9.3-6.69,13.97c-0.17,0.37-0.15,0.83-0.22,1.25c-0.29,0.58-0.58,1.16-0.87,1.74 c-0.34,0.31-0.78,0.55-1,0.93c-1.02,1.73-1.99,3.48-2.94,5.25c-0.22,0.41-0.27,0.9-0.4,1.35c-1.06,1.64-2.12,3.28-3.18,4.92 C151.21,107.01,151.01,107.3,150.82,107.59z"}),jsxRuntimeExports.jsx("path",{className:"st5",d:"M181.22,50.55c0-0.72,0.05-1.45-0.02-2.17c-0.09-1-0.66-1.56-1.69-1.59c-1.03-0.03-1.33,0.54-1.52,1.5 c-0.23,1.16-0.77,2.26-1.23,3.36c-1.86,4.45-3.74,8.9-5.63,13.33c-1.48,3.47-2.95,6.95-4.51,10.39c-1.82,4.03-3.63,8.06-5.6,12.01 c-1.73,3.48-3.57,6.91-5.55,10.25c-3.28,5.53-6.61,11.05-10.13,16.44c-2.06,3.17-4.45,6.13-6.81,9.09 c-3.11,3.9-6.13,7.89-9.54,11.51c-5.24,5.57-10.7,10.95-16.23,16.24c-2.48,2.37-4.96,4.84-8.19,6.28 c-0.41,0.18-0.84,0.34-1.42,0.27c0.45-0.51,0.89-1.02,1.34-1.52c0.77-0.68,1.54-1.35,2.32-2.03c0.19-0.19,0.39-0.39,0.58-0.58 c0.39-0.29,0.77-0.58,1.16-0.87c0.68-0.68,1.35-1.35,2.03-2.03c0.29-0.19,0.58-0.39,0.87-0.58c0.48-0.48,0.97-0.97,1.45-1.45 c0.29-0.19,0.58-0.39,0.87-0.58c1.64-1.64,3.28-3.28,4.92-4.92c0.39-0.39,0.77-0.77,1.16-1.16c1.06-1.06,2.12-2.12,3.18-3.18 c0.58-0.58,1.16-1.16,1.74-1.74c0.39-0.48,0.77-0.97,1.16-1.45c0.39-0.39,0.77-0.77,1.16-1.16c0.58-0.58,1.16-1.16,1.74-1.74 c0.29-0.39,0.58-0.77,0.87-1.16c0.19-0.19,0.39-0.39,0.58-0.58c0.29-0.39,0.58-0.77,0.87-1.16c0.19-0.19,0.39-0.39,0.58-0.58 c0.29-0.39,0.58-0.77,0.87-1.16c0.19-0.19,0.39-0.39,0.58-0.58c0.19-0.29,0.39-0.58,0.58-0.87c0.48-0.58,0.97-1.16,1.45-1.74 c0.19-0.29,0.39-0.58,0.58-0.87c0.1-0.1,0.19-0.19,0.29-0.29c0.19-0.29,0.39-0.58,0.58-0.87c0.1-0.1,0.19-0.19,0.29-0.29 c0.19-0.29,0.39-0.58,0.58-0.87c0.19-0.19,0.39-0.39,0.58-0.58c0.19-0.29,0.39-0.58,0.58-0.87c0.29-0.29,0.58-0.58,0.87-0.87 c0.29-0.39,0.58-0.77,0.87-1.16c0.1-0.1,0.19-0.19,0.29-0.29c0.19-0.29,0.39-0.58,0.58-0.87c0.68-0.97,1.35-1.93,2.03-2.9 c0.1-0.19,0.19-0.39,0.29-0.58c1.97-2.97,3.97-5.92,5.89-8.92c1.02-1.6,1.87-3.31,2.8-4.97c0.29-0.48,0.58-0.97,0.87-1.45 c1.25-2.12,2.51-4.25,3.76-6.37c0.1-0.19,0.19-0.39,0.29-0.58c0.39-0.77,0.77-1.54,1.16-2.32c0-0.1,0-0.19,0-0.29 c0.48-0.87,0.97-1.74,1.45-2.61c0.19-0.29,0.39-0.58,0.58-0.87c0.29-0.87,0.58-1.74,0.87-2.61c0.29-0.39,0.58-0.77,0.87-1.16 c0.19-0.39,0.39-0.77,0.58-1.16c0.1-0.29,0.19-0.58,0.29-0.87c0.16-0.23,0.36-0.45,0.48-0.7c1.69-3.82,3.42-7.63,5.02-11.49 c3.03-7.32,5.97-14.68,8.95-22.02c0.52-1.29,0.93-2.64,1.61-3.84c0.28-0.5,1.14-0.95,1.72-0.92c0.37,0.02,0.88,0.9,1.01,1.47 c0.68,2.92,0.85,5.87,0.32,8.84C181.8,50.55,181.51,50.55,181.22,50.55z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M118.68,142.91c-1.64,1.64-3.28,3.28-4.92,4.92c0.14-0.38,0.19-0.86,0.45-1.14c1.07-1.15,2.18-2.26,3.33-3.33 C117.82,143.1,118.3,143.05,118.68,142.91z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M124.18,135.09c0.87-0.97,1.74-1.93,2.61-2.9C126.52,133.78,125.61,134.8,124.18,135.09z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M123.03,138.57c-1.06,1.06-2.12,2.12-3.18,3.18C120.11,140.45,121.72,138.83,123.03,138.57z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M121.58,137.7c0.77-0.77,1.54-1.54,2.32-2.32C123.69,136.72,122.92,137.49,121.58,137.7z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M106.81,153.91c-0.77,0.68-1.54,1.35-2.32,2.03C104.92,154.86,105.56,154.04,106.81,153.91z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M101.6,155.94c0.77-0.58,1.55-1.16,2.32-1.74C103.6,155.39,102.74,155.85,101.6,155.94z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M109.42,149.57c0.19-0.29,0.39-0.58,0.58-0.87c0.39-0.19,0.77-0.39,1.16-0.58 C111.05,149.17,110.67,149.89,109.42,149.57z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M130.55,127.85c0.39-0.48,0.77-0.97,1.16-1.45C131.77,127.24,131.65,127.94,130.55,127.85z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M129.4,129.3c0.39-0.48,0.77-0.97,1.16-1.45C130.61,128.69,130.49,129.39,129.4,129.3z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M105.95,152.17c0.19,0,0.38,0,0.58,0c0.06,0.83-0.32,1.22-1.16,1.16 C105.56,152.94,105.75,152.56,105.95,152.17z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M125.92,135.38c-0.39,0.48-0.77,0.97-1.16,1.45C125.15,136.35,125.54,135.86,125.92,135.38z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M103.92,154.2c0.48-0.29,0.96-0.58,1.45-0.87C105.29,154.3,104.57,154.19,103.92,154.2z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M127.08,134.22c-0.39,0.39-0.77,0.77-1.16,1.16C126.31,135,126.69,134.61,127.08,134.22z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M111.73,147.54c0.39-0.39,0.77-0.77,1.16-1.16C112.95,147.22,112.57,147.6,111.73,147.54z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M132.58,127.85c-0.29,0.39-0.58,0.77-0.87,1.16C132,128.63,132.29,128.24,132.58,127.85z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M129.69,131.33c-0.29,0.39-0.58,0.77-0.87,1.16C129.11,132.1,129.4,131.71,129.69,131.33z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M131.13,129.59c-0.29,0.39-0.58,0.77-0.87,1.16C130.56,130.36,130.84,129.98,131.13,129.59z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M108.55,152.46c-0.39,0.29-0.77,0.58-1.16,0.87C107.78,153.04,108.16,152.75,108.55,152.46z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M135.77,123.8c-0.19,0.29-0.39,0.58-0.58,0.87C135.38,124.38,135.57,124.09,135.77,123.8z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M111.45,149.86c-0.29,0.19-0.58,0.39-0.87,0.58C110.87,150.24,111.16,150.05,111.45,149.86z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M113.76,147.83c-0.29,0.19-0.58,0.39-0.87,0.58C113.18,148.22,113.47,148.02,113.76,147.83z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M137.5,121.48c-0.19,0.29-0.39,0.58-0.58,0.87c0-0.29,0-0.58,0-0.87 C137.12,121.48,137.31,121.48,137.5,121.48z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M136.64,122.64c-0.19,0.29-0.39,0.58-0.58,0.87C136.25,123.22,136.44,122.93,136.64,122.64z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M133.74,126.41c-0.19,0.29-0.39,0.58-0.58,0.87C133.35,126.98,133.55,126.7,133.74,126.41z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M182.09,50.55c0.53-2.97,0.36-5.92-0.32-8.84c-0.13-0.57-0.64-1.45-1.01-1.47c-0.58-0.02-1.44,0.42-1.72,0.92 c-0.68,1.2-1.09,2.55-1.61,3.84c-2.98,7.34-5.92,14.7-8.95,22.02c-1.6,3.86-3.34,7.66-5.02,11.49c-0.11,0.26-0.32,0.47-0.48,0.7 c-0.1-0.1-0.19-0.19-0.29-0.29c0-0.1,0-0.19,0-0.29c0-0.29,0-0.58,0-0.87c0-0.19,0-0.39,0-0.58c0.1,0,0.19,0,0.29,0 c0.33-0.37,0.78-0.69,0.97-1.12c3.35-7.7,6.73-15.39,9.98-23.14c1.43-3.4,2.57-6.93,3.84-10.4c0.16-0.45,0.25-0.95,0.5-1.35 c0.58-0.95,1.21-1.95,2.52-1.82c1.47,0.15,1.64,1.42,1.88,2.54c0.13,0.59-0.26,1.47,0.88,1.41c0,38.7,0,77.4,0,116.1 c-0.39,0-0.77,0-1.16,0c0-35.58,0-71.17-0.01-106.75C182.37,51.96,182.19,51.25,182.09,50.55z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M177.75,39.54c0.19-0.19,0.39-0.39,0.58-0.58C178.13,39.16,177.94,39.35,177.75,39.54z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M179.19,38.68c0.19-0.1,0.39-0.19,0.58-0.29C179.58,38.48,179.39,38.58,179.19,38.68z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M125.92,162.02c0.34-0.25,0.69-0.73,1.03-0.73c2.81,0,5.62,0.14,8.44,0.14c14.86,0.02,29.72,0.01,44.57,0 c0.81,0,1.61-0.18,2.42-0.28c-0.1,0.29-0.19,0.58-0.29,0.87c-0.19,0.1-0.39,0.19-0.58,0.29c-2.51,0-5.02,0-7.53,0 c-0.39,0-0.77,0-1.16,0c-0.77,0.19-1.54,0.39-2.32,0.58c-9.84,0-19.69,0-29.53,0c-0.77,0-1.54,0-2.32,0c-0.87,0-1.74,0-2.61,0 c-0.48,0-0.96,0-1.45,0c-2.12,0-4.25,0-6.37,0c-0.1,0-0.19,0-0.29,0C127.72,161.56,126.66,162.17,125.92,162.02z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M152.27,99.48c-0.93,1.66-1.78,3.37-2.8,4.97c-1.91,3.01-3.92,5.95-5.89,8.92c0.15-0.76,0.29-1.53,0.46-2.29 c0.11-0.5,0.27-0.98,0.41-1.47c0.63-0.67,1.36-1.28,1.86-2.03c1.64-2.52,3.18-5.11,4.82-7.64 C151.31,99.66,151.88,99.63,152.27,99.48z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M137.5,121.48c-0.19,0-0.39,0-0.58,0c0.7-1.1,1.33-2.26,2.11-3.3c1.06-1.42,2.21-2.77,3.37-4.11 c0.15-0.17,0.58-0.08,0.89-0.12c-0.68,0.97-1.35,1.93-2.03,2.9c-0.19,0.29-0.39,0.58-0.58,0.87c-0.1,0.1-0.19,0.19-0.29,0.29 c-0.29,0.39-0.58,0.77-0.87,1.16c-0.29,0.29-0.58,0.58-0.87,0.87c-0.19,0.29-0.39,0.58-0.58,0.87 C137.89,121.1,137.7,121.29,137.5,121.48z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M172.83,162.31c0.39,0,0.77,0,1.16,0C173.6,162.31,173.21,162.31,172.83,162.31z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M181.51,162.31c0.19-0.1,0.39-0.19,0.58-0.29c0,0.1,0,0.19,0,0.29C181.9,162.31,181.7,162.31,181.51,162.31z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M182.38,159.41c0.39,0,0.77,0,1.16,0c0,0.29,0,0.58,0,0.87c-0.39,0.29-0.77,0.58-1.16,0.87 c0-0.39,0-0.77,0-1.16C182.38,159.8,182.38,159.61,182.38,159.41z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M156.9,91.66c-1.25,2.12-2.51,4.25-3.76,6.37c0.13-0.72,0.11-1.53,0.43-2.16c0.73-1.45,1.64-2.81,2.47-4.21 C156.32,91.66,156.61,91.66,156.9,91.66z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M156.9,91.66c-0.29,0-0.58,0-0.87,0c0.19-0.29,0.39-0.58,0.58-0.87c0.19,0.1,0.39,0.19,0.58,0.29 C157.1,91.28,157,91.47,156.9,91.66z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M161.24,82.4c-0.29,0.87-0.58,1.74-0.87,2.61c0-0.39,0-0.77,0-1.16c0-0.19,0-0.39,0-0.58 c0.29-0.39,0.58-0.77,0.87-1.16C161.24,82.2,161.24,82.3,161.24,82.4z M160.78,82.89c-0.01,0.04-0.04,0.08-0.04,0.12 c0,0.01,0.07,0.03,0.1,0.04c0.01-0.04,0.04-0.08,0.04-0.12C160.88,82.92,160.81,82.91,160.78,82.89z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M162.69,78.92c0.1,0.1,0.19,0.19,0.29,0.29c-0.1,0.29-0.19,0.58-0.29,0.87c-0.19,0-0.39,0-0.58,0 c-0.1,0-0.19,0-0.29,0c0.19-0.39,0.39-0.77,0.58-1.16C162.5,78.92,162.6,78.92,162.69,78.92z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M161.82,80.08c0.1,0,0.19,0,0.29,0c0,0.29,0,0.58,0,0.87c-0.19,0.29-0.39,0.58-0.58,0.87 c-0.1-0.19-0.19-0.39-0.29-0.58c0.1-0.19,0.19-0.39,0.29-0.58C161.63,80.47,161.73,80.27,161.82,80.08z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M161.53,81.82c0.19-0.29,0.39-0.58,0.58-0.87c0,0.1,0,0.19,0,0.29c-0.29,0.39-0.58,0.77-0.87,1.16 c0-0.1,0-0.19,0-0.29C161.34,82.01,161.44,81.91,161.53,81.82z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M162.69,77.76c0,0.29,0,0.58,0,0.87c-0.1,0-0.19,0-0.29,0c0-0.29,0-0.58,0-0.87 C162.5,77.76,162.6,77.76,162.69,77.76z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M159.51,84.71c-0.1,0.29-0.19,0.58-0.29,0.87C159.31,85.29,159.41,85,159.51,84.71z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M161.53,80.66c-0.1,0.19-0.19,0.39-0.29,0.58C161.34,81.05,161.44,80.85,161.53,80.66z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M161.82,80.08c-0.1,0.19-0.19,0.39-0.29,0.58C161.63,80.47,161.73,80.27,161.82,80.08z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M160.38,83.27c0,0.19,0,0.39,0,0.58c-0.1,0-0.19,0-0.29,0c0-0.1,0-0.19,0-0.29 C160.18,83.46,160.28,83.36,160.38,83.27z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M162.4,78.63c0.1,0,0.19,0,0.29,0c0,0.1,0,0.19,0,0.29c-0.1,0-0.19,0-0.29,0 C162.4,78.83,162.4,78.73,162.4,78.63z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M160.09,83.55c0,0.1,0,0.19,0,0.29c-0.1,0-0.19,0-0.29,0C159.89,83.75,159.99,83.65,160.09,83.55z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M159.8,85.87c-0.48,0.87-0.97,1.74-1.45,2.61c0-0.19,0-0.39,0-0.58c0.1-0.48,0.19-0.97,0.29-1.45 C159.03,86.26,159.41,86.06,159.8,85.87z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M158.35,88.48c0,0.1,0,0.19,0,0.29c-0.1-0.1-0.19-0.19-0.29-0.29C158.16,88.48,158.25,88.48,158.35,88.48z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M158.35,88.48c-0.1,0-0.19,0-0.29,0c0.1-0.19,0.19-0.39,0.29-0.58C158.35,88.09,158.35,88.28,158.35,88.48z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M168.48,74c0.77-2.11,1.46-4.26,2.32-6.33c1.28-3.05,2.73-6.03,4.01-9.08c1.17-2.79,2.2-5.64,3.31-8.45 c0.14-0.35,0.33-0.72,0.61-0.97c0.29-0.26,0.72-0.52,1.07-0.5c0.2,0.01,0.51,0.59,0.52,0.92c0.05,4.22,0.06,8.44,0.07,12.65 c0,0.43-0.03,0.87-0.03,1.3c0,30.52,0,61.04,0,91.55c0,0.53,0.01,1.06,0.1,1.58c0.27,1.44-0.12,2.38-1.54,2.53 c-1.72,0.18-3.49-0.03-5.23-0.07c0-0.29,0-0.58,0-0.86c0.39,0,0.77,0,1.16,0c0.39,0.09,0.77,0.19,1.16,0.28 c0.71,0,1.44,0.08,2.12-0.04c0.89-0.16,1.74-0.49,1.06-1.7c0.1-0.45,0.28-0.9,0.28-1.35c0.02-8.21,0.02-16.42,0-24.63 c0-0.51-0.18-1.02-0.28-1.53c0.84-0.78,0.84-2.4,0-3.18c-0.19-0.68-0.38-1.35-0.58-2.03c0.1-0.61,0.28-1.21,0.28-1.82 c0.02-9.33,0.01-18.67,0.01-28c0.19-0.55,0.55-1.09,0.55-1.64c0.03-9.72,0.03-19.43,0.01-29.15c0-0.45-0.18-0.9-0.27-1.35 c0-3.18,0-6.37,0-9.55c0-0.51,0-1.01,0-1.52c-0.11,0-0.22-0.01-0.33-0.01c-0.18,0.41-0.36,0.83-0.54,1.24 c-0.29,0.77-0.58,1.54-0.87,2.32c-0.1,0.29-0.19,0.58-0.29,0.87c-0.19,0.39-0.38,0.77-0.58,1.16c-0.19,0.48-0.39,0.96-0.58,1.45 c-0.1,0.19-0.19,0.39-0.29,0.58c0,0.19,0,0.39,0,0.58c-0.9,0.28-1.35,0.77-0.87,1.74c-0.39,0.87-0.77,1.74-1.16,2.61 c-0.1,0.19-0.19,0.39-0.29,0.58c-0.19,0.77-0.39,1.54-0.58,2.31c-0.29,0.48-0.58,0.97-0.87,1.45c-0.19,0.29-0.39,0.58-0.58,0.87 c-0.1,0.19-0.19,0.39-0.29,0.58c-0.29,0.68-0.58,1.35-0.87,2.03c-0.19,0.39-0.38,0.77-0.58,1.16c-0.19,0.48-0.39,0.96-0.58,1.45 C168.87,74,168.68,74,168.48,74z M179.44,50.31c-0.13-0.12-0.21-0.26-0.3-0.27c-0.11-0.02-0.24,0.07-0.36,0.11 c0.09,0.12,0.15,0.28,0.27,0.34C179.11,50.52,179.26,50.4,179.44,50.31z"}),jsxRuntimeExports.jsx("path",{className:"st5",d:"M182.38,159.41c0,0.19,0,0.39,0,0.58c-0.19,0-0.39,0-0.58,0c-0.19-0.19-0.39-0.39-0.58-0.58 c0.1-3.17,0.27-6.34,0.28-9.51c0.02-32.31,0.01-64.62,0-96.94c0-0.81-0.18-1.61-0.28-2.42c0.29,0,0.58,0,0.87,0 c0.1,0.71,0.28,1.41,0.28,2.12C182.38,88.25,182.38,123.83,182.38,159.41z"}),jsxRuntimeExports.jsx("path",{className:"st5",d:"M180.06,160.57c-0.55,0.1-1.1,0.28-1.64,0.28c-14.27,0.02-28.54,0.01-42.81,0.01c-2.43,0-4.87,0.01-7.3-0.01 c-0.29,0-0.59-0.14-0.86-0.5c17.65-0.46,35.28-0.28,52.91-0.36C180.26,160.18,180.16,160.38,180.06,160.57z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M128.82,158.26c-1.01,0.39-2.01,1.08-3.03,1.1c-5.81,0.11-11.62,0.07-17.44,0.03c-0.75,0-1.49-0.24-2.3-0.38 c-0.32-1.64,0.69-2.15,1.92-2.5c0,0.29,0,0.58,0,0.87c0,0.1,0,0.19,0,0.29c-0.15,0.13-0.29,0.25-0.44,0.38 c0.15-0.03,0.29-0.06,0.44-0.09c0.68,0,1.35,0,2.03,0c5.4,0,10.81,0,16.21,0C127.08,158.06,127.95,158.16,128.82,158.26 L128.82,158.26z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M159.8,92.53c0.07-0.42,0.04-0.88,0.22-1.25c2.21-4.67,4.44-9.33,6.69-13.97c0.19-0.39,0.6-0.66,0.9-0.99 c0.1,0.1,0.19,0.19,0.29,0.29c-0.1,0.29-0.19,0.58-0.29,0.87c-0.1,0.19-0.19,0.39-0.29,0.58c-0.29,0.68-0.58,1.35-0.87,2.03 c-0.1,0.19-0.19,0.39-0.29,0.58c-0.48,1.16-0.97,2.32-1.45,3.47c-0.19,0.39-0.39,0.77-0.58,1.16c-0.19,0.39-0.39,0.77-0.58,1.16 c-0.58,1.16-1.16,2.32-1.74,3.48c-0.48,0.87-0.96,1.74-1.45,2.61C160.18,92.53,159.99,92.53,159.8,92.53z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M120.71,144.65c0.35-0.48,0.63-1.03,1.05-1.43c1.55-1.48,3.15-2.91,4.74-4.36c0,0.29,0,0.58,0,0.87 c-1.64,1.64-3.28,3.28-4.92,4.92C121.29,144.65,121,144.65,120.71,144.65z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M154.59,101.8c0.13-0.45,0.18-0.95,0.4-1.35c0.95-1.77,1.92-3.52,2.94-5.25c0.22-0.38,0.66-0.62,1-0.93 c0,0.29,0,0.58,0,0.87c-0.19,0.39-0.39,0.77-0.58,1.16c-0.19,0.39-0.39,0.77-0.58,1.16c-0.29,0.48-0.58,0.97-0.87,1.45 c-0.75,0.47-1.49,0.94-1.16,2.03c-0.19,0.29-0.39,0.58-0.58,0.87C154.97,101.8,154.78,101.8,154.59,101.8z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M151.4,106.72c1.06-1.64,2.12-3.28,3.18-4.92c-0.1,0.48-0.19,0.97-0.29,1.45c-0.77,1.16-1.54,2.32-2.32,3.47 C151.79,106.72,151.59,106.72,151.4,106.72z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M120.71,144.65c0.29,0,0.58,0,0.87,0c-1.25,1.25-2.51,2.51-3.76,3.76c0-0.29,0-0.58,0-0.87 C118.78,146.58,119.75,145.61,120.71,144.65z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M117.82,147.54c0,0.29,0,0.58,0,0.87c-0.68,0.68-1.35,1.35-2.03,2.03c-0.29,0-0.58,0-0.87,0 C115.89,149.47,116.85,148.51,117.82,147.54z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M145.9,115.4c0.68-0.97,1.35-1.93,2.03-2.9c0.1,0.1,0.19,0.19,0.29,0.29c-0.29,0.48-0.58,0.97-0.87,1.45 c-0.19,0.29-0.39,0.58-0.58,0.87c0,0.1,0,0.19,0,0.29C146.48,115.4,146.19,115.4,145.9,115.4z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M129.11,136.25c0.77-0.87,1.54-1.74,2.32-2.61c0,0.29,0,0.58,0,0.87c-0.48,0.58-0.97,1.16-1.45,1.74 C129.69,136.25,129.4,136.25,129.11,136.25z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M134.03,130.75c0.68-0.87,1.35-1.74,2.03-2.61c0,0.29,0,0.58,0,0.87c-0.39,0.58-0.77,1.16-1.16,1.74 C134.61,130.75,134.32,130.75,134.03,130.75z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M109.13,155.65c0.77-0.68,1.54-1.35,2.32-2.03c0,0.29,0,0.58,0,0.87c-0.48,0.39-0.96,0.77-1.45,1.16 C109.71,155.65,109.42,155.65,109.13,155.65z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M148.8,110.77c0.48-0.77,0.97-1.54,1.45-2.32c0,0.29,0,0.58,0,0.87c-0.29,0.48-0.58,0.96-0.87,1.45 C149.18,110.77,148.99,110.77,148.8,110.77z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M112.31,152.75c0.77-0.68,1.54-1.35,2.32-2.03c0,0.29,0,0.58,0,0.87c-0.48,0.39-0.96,0.77-1.45,1.16 C112.89,152.75,112.6,152.75,112.31,152.75z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M145.9,115.4c0.29,0,0.58,0,0.87,0c-0.67,0.87-1.35,1.74-2.02,2.61c0-0.29,0-0.58,0-0.87c0-0.1,0-0.19,0-0.29 c0.19-0.19,0.39-0.39,0.58-0.58c0-0.1,0-0.19,0-0.29C145.51,115.79,145.71,115.6,145.9,115.4z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M126.5,139.73c0-0.29,0-0.58,0-0.87c0.48-0.48,0.97-0.97,1.45-1.45c0.29,0,0.58,0,0.87,0 C128.04,138.18,127.27,138.95,126.5,139.73z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M150.24,109.33c0-0.29,0-0.58,0-0.87c0-0.1,0-0.19,0-0.29c0.19-0.19,0.39-0.39,0.58-0.58 c0.19-0.29,0.39-0.58,0.58-0.87c0.19,0,0.39,0,0.58,0C151.4,107.59,150.82,108.46,150.24,109.33z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M167.61,76.03c0.29-0.58,0.58-1.16,0.87-1.74c0.1,0.1,0.19,0.19,0.29,0.29c-0.19,0.48-0.39,0.96-0.58,1.45 C168,76.03,167.81,76.03,167.61,76.03z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M131.71,133.35c0.48-0.58,0.97-1.16,1.45-1.74c0,0.29,0,0.58,0,0.87c-0.19,0.29-0.39,0.58-0.58,0.87 C132.29,133.35,132,133.35,131.71,133.35z"}),jsxRuntimeExports.jsx("path",{className:"st5",d:"M180.06,160.57c0.1-0.19,0.19-0.39,0.29-0.58c0.29-0.19,0.58-0.39,0.87-0.58c0.19,0.19,0.39,0.39,0.58,0.58 C181.22,160.18,180.64,160.38,180.06,160.57z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M133.16,132.49c0-0.29,0-0.58,0-0.87c0.29-0.29,0.58-0.58,0.87-0.87c0.29,0,0.58,0,0.87,0 C134.32,131.33,133.74,131.91,133.16,132.49z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M112.31,152.75c0.29,0,0.58,0,0.87,0c-0.58,0.58-1.16,1.16-1.74,1.74c0-0.29,0-0.58,0-0.87 C111.74,153.33,112.03,153.04,112.31,152.75z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M136.35,127.85c0.39-0.48,0.77-0.97,1.16-1.45c0,0.29,0,0.58,0,0.87c-0.1,0.19-0.19,0.39-0.29,0.58 C136.92,127.85,136.63,127.85,136.35,127.85z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M148.8,110.77c0.19,0,0.39,0,0.58,0c-0.39,0.68-0.77,1.35-1.16,2.03c-0.1-0.1-0.19-0.19-0.29-0.29 c0-0.1,0-0.19,0-0.29C148.22,111.74,148.51,111.25,148.8,110.77z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M158.93,94.27c0.29-0.58,0.58-1.16,0.87-1.74c0,0.39,0,0.77,0,1.16c-0.1,0.19-0.19,0.39-0.29,0.58 C159.32,94.27,159.12,94.27,158.93,94.27z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M169.64,158.26c0.29,0,0.58,0,0.87,0c0.19,0.29,0.39,0.58,0.58,0.87 C170.22,159.48,169.82,159.05,169.64,158.26z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M128.81,137.41c-0.29,0-0.58,0-0.87,0c0.39-0.39,0.77-0.77,1.16-1.16c0,0.29,0,0.58,0,0.87 C129.01,137.21,128.91,137.31,128.81,137.41z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M107.97,156.52c0.39-0.29,0.77-0.58,1.16-0.87c0,0.19,0,0.39,0,0.58c-0.1,0.1-0.19,0.19-0.29,0.29 C108.55,156.52,108.26,156.52,107.97,156.52z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M144.74,117.14c0,0.29,0,0.58,0,0.87c-0.1,0.1-0.19,0.19-0.29,0.29c-0.19,0-0.39,0-0.58,0 C144.16,117.91,144.45,117.53,144.74,117.14z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M143,119.46c0.29-0.39,0.58-0.77,0.87-1.16c0,0.29,0,0.58,0,0.87c-0.1,0.1-0.19,0.19-0.29,0.29 C143.39,119.46,143.2,119.46,143,119.46z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M171.67,158.26c0,0.19,0,0.38,0,0.58c-0.19,0.1-0.39,0.19-0.58,0.29c-0.19-0.29-0.39-0.58-0.58-0.87 C170.9,158.26,171.28,158.26,171.67,158.26z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M141.85,120.9c0.29-0.39,0.58-0.77,0.87-1.16c0,0.29,0,0.58,0,0.87c0,0.1,0,0.19,0,0.29 C142.42,120.9,142.14,120.9,141.85,120.9z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M140.98,122.06c0.29-0.39,0.58-0.77,0.87-1.16c0,0.29,0,0.58,0,0.87c-0.1,0.1-0.19,0.19-0.29,0.29 C141.37,122.06,141.17,122.06,140.98,122.06z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M139.82,123.51c0.29-0.39,0.58-0.77,0.87-1.16c0,0.29,0,0.58,0,0.87c0,0.1,0,0.19,0,0.29 C140.4,123.51,140.11,123.51,139.82,123.51z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M138.66,124.96c0.29-0.39,0.58-0.77,0.87-1.16c0,0.29,0,0.58,0,0.87c0,0.1,0,0.19,0,0.29 C139.24,124.96,138.95,124.96,138.66,124.96z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M137.5,126.41c0.29-0.39,0.58-0.77,0.87-1.16c0,0.29,0,0.58,0,0.87c0,0.1,0,0.19,0,0.29 C138.08,126.41,137.79,126.41,137.5,126.41z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M131.71,133.35c0.29,0,0.58,0,0.87,0c-0.39,0.39-0.77,0.77-1.16,1.16c0-0.29,0-0.58,0-0.87 C131.52,133.55,131.62,133.45,131.71,133.35z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M138.37,126.12c0-0.29,0-0.58,0-0.87c0.1-0.1,0.19-0.19,0.29-0.29c0.29,0,0.58,0,0.87,0 C139.14,125.34,138.76,125.73,138.37,126.12z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M139.53,124.67c0-0.29,0-0.58,0-0.87c0.1-0.1,0.19-0.19,0.29-0.29c0.29,0,0.58,0,0.87,0 C140.3,123.9,139.92,124.28,139.53,124.67z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M148.8,110.77c-0.29,0.48-0.58,0.97-0.87,1.45C148.22,111.74,148.51,111.25,148.8,110.77z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M114.63,151.59c0-0.29,0-0.58,0-0.87c0.1-0.1,0.19-0.19,0.29-0.29c0.29,0,0.58,0,0.87,0 C115.4,150.82,115.02,151.21,114.63,151.59z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M136.35,127.85c0.29,0,0.58,0,0.87,0c-0.39,0.39-0.77,0.77-1.16,1.16c0-0.29,0-0.58,0-0.87 C136.15,128.05,136.25,127.95,136.35,127.85z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M142.72,120.62c0-0.29,0-0.58,0-0.87c0.1-0.1,0.19-0.19,0.29-0.29c0.19,0,0.39,0,0.58,0 C143.3,119.84,143.01,120.23,142.72,120.62z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M140.69,123.22c0-0.29,0-0.58,0-0.87c0.1-0.1,0.19-0.19,0.29-0.29c0.19,0,0.39,0,0.58,0 C141.27,122.45,140.98,122.84,140.69,123.22z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M173.12,158.83c0-0.19,0-0.38,0-0.58c0.19,0,0.39,0,0.58,0c0,0.29,0,0.58,0,0.86 C173.5,159.03,173.31,158.93,173.12,158.83z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M151.4,106.72c-0.19,0.29-0.39,0.58-0.58,0.87C151.01,107.3,151.21,107.01,151.4,106.72z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M145.32,116.27c-0.19,0.19-0.39,0.39-0.58,0.58C144.93,116.66,145.13,116.47,145.32,116.27z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M168.77,74.58c-0.1-0.1-0.19-0.19-0.29-0.29c0-0.1,0-0.19,0-0.29c0.19,0,0.39,0,0.58,0 C168.97,74.19,168.87,74.39,168.77,74.58z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M167.61,76.03c0.19,0,0.39,0,0.58,0c-0.1,0.19-0.19,0.39-0.29,0.58c-0.1-0.1-0.19-0.19-0.29-0.29 C167.61,76.22,167.61,76.12,167.61,76.03z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M145.9,115.4c-0.19,0.19-0.39,0.39-0.58,0.58C145.51,115.79,145.71,115.6,145.9,115.4z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M150.82,107.59c-0.19,0.19-0.39,0.39-0.58,0.58C150.44,107.97,150.63,107.78,150.82,107.59z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M139.53,119.17c0.29-0.39,0.58-0.77,0.87-1.16C140.11,118.4,139.82,118.78,139.53,119.17z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M162.11,81.24c0-0.1,0-0.19,0-0.29c0-0.29,0-0.58,0-0.87c0.19,0,0.39,0,0.58,0 C162.5,80.47,162.31,80.85,162.11,81.24z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M140.69,117.72c0.19-0.29,0.39-0.58,0.58-0.87C141.07,117.14,140.88,117.43,140.69,117.72z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M138.08,120.9c0.19-0.29,0.39-0.58,0.58-0.87C138.47,120.33,138.28,120.62,138.08,120.9z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M160.78,82.89c0.04,0.01,0.1,0.02,0.1,0.04c0,0.04-0.02,0.08-0.04,0.12c-0.04-0.01-0.1-0.02-0.1-0.04 C160.74,82.98,160.76,82.94,160.78,82.89z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M178.91,129.3c0-0.29,0-0.58,0-0.87c0-0.77,0-1.54,0-2.32c0.1,0,0.19,0,0.29,0c0.84,0.78,0.84,2.4,0,3.18 C179.1,129.3,179,129.3,178.91,129.3z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M165.01,85c-0.29,0.1-0.58,0.2-0.86,0.29c0.19-0.39,0.39-0.77,0.58-1.16c0.09,0.19,0.19,0.39,0.28,0.58 C165.01,84.81,165.01,84.9,165.01,85z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M129.4,137.12l-0.14,0c0,0-0.14,0-0.14,0c0-0.29,0-0.58,0-0.87c0.29,0,0.58,0,0.87,0c0,0.1,0,0.19,0,0.29 C129.78,136.73,129.59,136.92,129.4,137.12z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M178.33,52.57c-0.29,0.68-0.58,1.35-0.87,2.03c0.29-0.77,0.58-1.54,0.87-2.32 C178.33,52.38,178.33,52.48,178.33,52.57z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M175.72,59.23c-0.29,0.58-0.58,1.16-0.87,1.74C174.37,60.01,174.82,59.51,175.72,59.23z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M177.17,55.47c-0.19,0.39-0.38,0.77-0.58,1.16C176.78,56.24,176.98,55.86,177.17,55.47z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M170.22,71.39c-0.19,0.39-0.38,0.77-0.58,1.16C169.84,72.17,170.03,71.78,170.22,71.39z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M179.44,50.31c-0.18,0.09-0.33,0.21-0.39,0.18c-0.12-0.07-0.18-0.22-0.27-0.34c0.12-0.04,0.25-0.12,0.36-0.11 C179.23,50.06,179.31,50.19,179.44,50.31z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M171.38,68.79c-0.1,0.19-0.19,0.39-0.29,0.58C171.19,69.17,171.28,68.98,171.38,68.79z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M176.01,58.08c-0.1,0.19-0.19,0.39-0.29,0.58C175.82,58.46,175.92,58.27,176.01,58.08z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M173.69,63.58c-0.1,0.19-0.19,0.39-0.29,0.58C173.5,63.96,173.6,63.77,173.69,63.58z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M108.84,156.52c-0.29,0.29-0.58,0.58-0.87,0.87c0-0.29,0-0.58,0-0.87 C108.26,156.52,108.55,156.52,108.84,156.52z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M163.27,87.61c0,0.1,0,0.19,0,0.29c0,0.19,0,0.38,0,0.58c-0.48,0.48-0.96,0.97-1.44,1.45 c0.58-1.16,1.16-2.32,1.74-3.48C163.47,86.84,163.37,87.22,163.27,87.61z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M160.38,92.53c-0.19,0.39-0.39,0.77-0.58,1.16c0-0.39,0-0.77,0-1.16C159.99,92.53,160.18,92.53,160.38,92.53z "}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M166.46,80.08c-0.1,0.19-0.19,0.39-0.29,0.58C166.26,80.47,166.36,80.27,166.46,80.08z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M167.61,77.47c-0.1,0.19-0.19,0.39-0.29,0.58C167.42,77.86,167.52,77.67,167.61,77.47z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M156.9,98.9c0,0.29,0,0.58,0,0.87c-0.39,0.39-0.77,0.77-1.16,1.16C155.41,99.84,156.15,99.37,156.9,98.9z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M155.17,101.8c-0.29,0.48-0.58,0.97-0.87,1.45c0.1-0.48,0.19-0.97,0.29-1.45 C154.78,101.8,154.97,101.8,155.17,101.8z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M158.35,96.29c-0.19,0.39-0.39,0.77-0.58,1.16C157.96,97.07,158.16,96.68,158.35,96.29z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M159.51,94.27c-0.19,0.29-0.39,0.58-0.58,0.87c0-0.29,0-0.58,0-0.87C159.12,94.27,159.32,94.27,159.51,94.27z "}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M147.35,114.25c-0.19,0.29-0.39,0.58-0.58,0.87C146.96,114.83,147.16,114.54,147.35,114.25z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M110,155.65c-0.29,0.19-0.58,0.39-0.87,0.58c0-0.19,0-0.39,0-0.58C109.42,155.65,109.71,155.65,110,155.65z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M138.37,126.41c-0.29,0.29-0.58,0.58-0.87,0.87c0-0.29,0-0.58,0-0.87 C137.79,126.41,138.08,126.41,138.37,126.41z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M144.46,118.3c-0.19,0.29-0.39,0.58-0.58,0.87c0-0.29,0-0.58,0-0.87C144.07,118.3,144.26,118.3,144.46,118.3z "}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M142.71,120.9c-0.29,0.29-0.58,0.58-0.87,0.87c0-0.29,0-0.58,0-0.87C142.14,120.9,142.42,120.9,142.71,120.9z "})]})})]});const BowBadge=({elClass:s,showLabel:a=true})=>jsxRuntimeExports.jsxs("svg",{className:s,xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 360 360",children:[a&&jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{className:"st0",d:"M129.72,251.47v0.23h0.45v-1.13c0.41-2.4,1.46-3.61,3.16-3.61h1.13c2.4,0,3.61,2.7,3.61,8.11v3.38 c-0.15,15.44-0.23,24.83-0.23,28.17c0.15,0,0.23,0.08,0.23,0.23h-0.23c0.15,0.3,0.23,0.53,0.23,0.68c0,9.05,0.9,15.51,2.7,19.38 c1.99,1.8,3.64,2.7,4.96,2.7c3.12,0,6.35-5.56,9.69-16.68c0.45-3,1.88-4.51,4.28-4.51h0.23c2.7,0.41,4.06,1.77,4.06,4.06 c0,4.17-2.4,10.55-7.21,19.16c-3.19,4.36-7.02,6.54-11.49,6.54c-4.21,0-8.26-2.4-12.17-7.21c-1.65-3.87-2.48-6.87-2.48-9.01 c-0.19,0-1.09,2.1-2.7,6.31c-4.47,8.11-10.03,12.17-16.68,12.17c-5.18,0-10.07-1.65-14.65-4.96c-4.96-5.26-7.44-12.55-7.44-21.86 v-2.03c0-13.56,4.06-25.5,12.17-35.83c5.48-6.16,10.52-9.24,15.1-9.24C121.9,246.51,126.34,248.16,129.72,251.47z M97.71,293.39 c0,6.87,1.58,12.13,4.73,15.78c2.97,1.8,5.97,2.7,9.01,2.7c7.44,0,12.85-12.85,16.23-38.54c0.3-2.33,0.45-4.88,0.45-7.66 c0-2.85-1.95-5.93-5.86-9.24c-1.84-0.9-3.87-1.35-6.08-1.35c-5.26,1.84-9.99,7.1-14.2,15.78c-2.85,6.8-4.28,13.94-4.28,21.41 V293.39z"}),jsxRuntimeExports.jsx("path",{className:"st0",d:"M192.2,255.75c0.45,1.5,0.68,3.23,0.68,5.18v1.35c0,6.24-2.4,11.79-7.21,16.68c3.61,1.05,7.06,3.98,10.37,8.79 c1.8,3.49,2.7,6.95,2.7,10.37v0.45c0,1.8-0.3,3.68-0.9,5.63c3.38-1.43,7.29-4.81,11.72-10.14c1.58-2.55,3.16-3.83,4.73-3.83h0.45 c2.22,0,3.57,1.43,4.06,4.28c0,2.44-3.46,6.8-10.37,13.07c-9.5,6.31-15.74,9.47-18.71,9.47c-8.6,2.25-14.76,3.38-18.48,3.38 c-2.93,0-6.91-0.75-11.94-2.25c-1.69,0-2.82-6.76-3.38-20.28c-0.6-6.35-0.9-11.76-0.9-16.23c0.45-20.66,1.35-31.78,2.7-33.35 c1.01-0.9,2.14-1.35,3.38-1.35c2.03,0,3.23,1.58,3.61,4.73c4.88-4.66,9.69-6.99,14.42-6.99 C185.25,244.71,189.61,248.39,192.2,255.75z M163.8,278.74h0.23c4.17,0,8.75-1.5,13.75-4.51c4.36-3.12,6.54-7.25,6.54-12.4v-0.45 c-0.38-5.26-1.95-7.89-4.73-7.89c0-0.15-0.15-0.23-0.45-0.23c-4.36,0-8.41,3.53-12.17,10.59c-2.1,4.62-3.16,7.7-3.16,9.24V278.74z M166.06,311.19c2.67,0.45,4.47,0.68,5.41,0.68c3.72,0,8-0.98,12.85-2.93c3.91-3.04,5.86-6.57,5.86-10.59v-0.23 c0-5.45-2.93-9.35-8.79-11.72c-1.77-0.75-3.72-1.13-5.86-1.13c-7.51,1.58-11.42,2.63-11.72,3.16 C164.67,303.6,165.42,311.19,166.06,311.19z"}),jsxRuntimeExports.jsx("path",{className:"st0",d:"M246.74,254.4c1.2,3.38,1.8,6.84,1.8,10.37v1.8c0,2.03-1.28,3.23-3.83,3.61h-0.23c-2.07,0-3.27-1.58-3.61-4.73 c-0.71-5.26-1.54-7.89-2.48-7.89c0-0.98-1.8-1.88-5.41-2.7c-0.49,0-0.86-0.08-1.13-0.23c-4.47,0-8.08,4.73-10.82,14.2 c-0.45,4.7-0.68,8.83-0.68,12.4c0,15.85,2.7,25.54,8.11,29.07c1.84,1.05,4.24,1.58,7.21,1.58h0.68c7.21,0,13.37-2.85,18.48-8.56 c3.68-4.96,6.24-9.39,7.66-13.3c1.05-1.8,2.4-2.7,4.06-2.7c2.85,0.53,4.28,1.95,4.28,4.28c-0.6,3-3.08,7.89-7.44,14.65 c-3.79,5.93-9.73,10.22-17.8,12.85c-3.27,0.9-6.35,1.35-9.24,1.35h-0.9c-10.97,0-18.1-5.93-21.41-17.8 c-1.5-4.77-2.25-11.83-2.25-21.18c0-11.79,1.43-19.61,4.28-23.44c3.79-7.96,9.05-11.94,15.78-11.94 C238.1,246.06,243.06,248.84,246.74,254.4z"})]}),jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{className:"st1",d:"M11.69,178.44c0-1.19,0-2.38,0-3.57c0.14-0.13,0.28-0.26,0.42-0.4c2.23-0.68,3.68-2.14,4.37-4.36 c2.92-1.6,5.83-3.2,8.75-4.8c0.27-0.12,0.54-0.25,0.81-0.37c1.19-0.39,2.39-0.78,3.58-1.18c0.17,0.23,0.34,0.46,0.51,0.69 c0.23-0.23,0.46-0.47,0.68-0.7c2.26-0.14,4.51-0.28,6.77-0.42c0.8,0.13,1.59,0.27,2.39,0.4c1.46,0.41,2.92,0.81,4.38,1.22 c0.27,0.13,0.53,0.25,0.8,0.38c0.8,0.13,1.59,0.27,2.39,0.4c0.27,0.14,0.53,0.28,0.8,0.41c0.8,0.39,1.59,0.79,2.39,1.18 c0.67,0.39,1.33,0.78,2,1.17c0.27,0.13,0.53,0.27,0.8,0.4c1.06,0.41,2.11,0.82,3.17,1.23c0.8,0.4,1.59,0.8,2.39,1.2 c1.99,1.06,3.98,2.12,5.97,3.18c0.27,0.13,0.53,0.27,0.8,0.4c0.94,0.78,1.87,1.56,2.81,2.34c0.26,0.14,0.53,0.27,0.79,0.41 c1.72,0.93,3.43,1.87,5.15,2.8c0.4,0.27,0.8,0.54,1.21,0.81c3.05,1.98,6.11,3.97,9.16,5.95c0.26,0.14,0.53,0.27,0.79,0.41 c0.4,0.26,0.8,0.52,1.2,0.78c0.53,0.26,1.07,0.52,1.6,0.79c3.18,1.2,6.36,2.39,9.55,3.59c0.53,0.26,1.07,0.51,1.6,0.77 c0.93,0.27,1.85,0.55,2.78,0.82c0.27,0.12,0.54,0.25,0.81,0.37c1.71,0.4,3.43,1.15,5.14,1.11c2.28-0.05,4.54-0.71,6.81-1.11 c0.53-0.13,1.06-0.26,1.6-0.39c2.52-1.05,5.05-2.11,7.57-3.16c0.27-0.13,0.53-0.27,0.8-0.4c1.19-0.67,2.38-1.34,3.57-2.01 c0.13,0,0.26,0,0.38,0c1.14,0.08,1.67-0.44,1.61-1.58c0-0.13,0.01-0.25,0.01-0.38c1.32-1.07,2.64-2.13,3.96-3.2 c1.52-0.07,2.32-0.87,2.4-2.38c1.06-1.06,2.12-2.12,3.19-3.17c0.4-0.4,0.79-0.8,1.19-1.19c0.27-0.39,0.54-0.78,0.81-1.17 c0.52-0.54,1.05-1.07,1.57-1.61c0.41-0.66,0.81-1.32,1.22-1.98c0.79-0.93,1.57-1.86,2.36-2.79c0.54-0.79,1.08-1.58,1.62-2.37 c0.39-0.4,0.78-0.8,1.17-1.2c0.01-0.13,0.02-0.25,0.02-0.38c0.92-1.07,1.84-2.13,2.77-3.2c0.01-0.13,0.02-0.25,0.02-0.38 c0.52-0.54,1.04-1.07,1.57-1.61c0.94-1.59,1.88-3.17,2.82-4.76c0.14-0.26,0.27-0.53,0.41-0.79c0.4-0.66,0.79-1.32,1.19-1.99 c0.14-0.26,0.27-0.53,0.41-0.79c2.75-4.87,5.68-9.65,8.16-14.65c1.15-2.31-0.11-3.82-2.61-4.05c-0.13-0.19-0.27-0.38-0.4-0.57 c-0.13,0.19-0.26,0.39-0.39,0.58c-0.93,0.4-1.86,0.81-2.79,1.21c-0.53,0.13-1.06,0.27-1.59,0.4c-2.66,0.92-5.32,1.83-7.98,2.75 c-0.53,0.27-1.06,0.54-1.59,0.81c-1.86,0.92-3.72,1.85-5.58,2.77c-1.06,0.53-2.12,1.06-3.19,1.59c-0.66,0.14-1.31,0.29-1.97,0.43 c-0.27,0.13-0.53,0.27-0.8,0.4c-1.07,0.65-2.13,1.3-3.2,1.95c-0.27,0.13-0.53,0.26-0.8,0.4c-2.52,0.93-5.03,1.87-7.55,2.8 c-1.07,0.39-2.13,0.78-3.2,1.17c-3.45,0.01-6.89,0.03-10.34,0.04c-0.53-0.14-1.06-0.27-1.59-0.41c-1.59-0.4-3.19-0.8-4.78-1.2 c-0.54-0.39-1.07-0.79-1.61-1.18c-6.41-1.51-12.33-4.17-17.78-7.79c-2.23-1.48-3.57-3.82-4.11-6.51c-0.13-0.4-0.26-0.8-0.39-1.19 c0.4-3.17,0.81-6.35,1.21-9.52c0.13-0.27,0.25-0.54,0.38-0.81c2.26-4.77,4.48-9.55,6.79-14.29c0.81-1.65,1.85-3.18,2.79-4.77 c0.39-0.4,0.78-0.8,1.16-1.21c0.27-0.39,0.54-0.78,0.81-1.17c0.13-0.01,0.26-0.01,0.39-0.02c1.33,0.01,2-0.65,1.99-1.98 c1.33-0.93,2.65-1.87,3.98-2.8c0.53-0.38,1.07-0.77,1.61-1.15c1.06-0.4,2.12-0.8,3.18-1.2c0.66-0.14,1.32-0.28,1.98-0.42 c5.18,0,10.36,0,15.55,0c0.79,0.14,1.59,0.28,2.38,0.42c0.13,0.19,0.26,0.39,0.39,0.58c0.13-0.19,0.27-0.38,0.4-0.57 c0.58,0.08,1.19,0.07,1.75,0.24c3.66,1.08,7.27,2.35,10.97,3.27c5.54,1.37,9.89,4.75,14.36,7.98c0.4,0.27,0.8,0.53,1.19,0.8 c1.19,0.92,2.39,1.85,3.58,2.77c0.4,0.27,0.79,0.54,1.19,0.8c0.66,0.53,1.33,1.06,1.99,1.59c0.4,0.39,0.81,0.79,1.21,1.18 c1.68,1.23,3.32,2.52,5.07,3.64c0.54,0.34,1.37,0.23,2.06,0.33c1.35,0.03,2.01-0.64,2.01-1.98c0.39-0.27,0.79-0.53,1.18-0.8 c0.67-0.39,1.33-0.79,2-1.18c3.45-1.44,6.8-1.23,10.01,0.7c1.07,0.64,2.08,1.38,3.11,2.08c0.66,0.67,1.33,1.33,1.99,2 c0.52-0.08,1.18,0.01,1.54-0.27c3.96-3.06,7.81-6.25,11.8-9.25c5.62-4.22,11.09-8.74,18.18-10.46c1.72-0.42,3.35-1.16,5.06-1.62 c2.52-0.68,5.08-1.25,7.62-1.87c0.73,0,1.46,0.07,2.18,0c2.46-0.23,4.92-0.52,7.37-0.78c2.26,0,4.51,0,6.77,0 c0.4,0.13,0.79,0.27,1.19,0.4c2.53,1.06,5.08,2.07,7.57,3.21c1.12,0.51,2.12,1.29,3.17,1.95c0.4,0.39,0.81,0.79,1.21,1.18 c0.82,0.84,1.78,1.58,2.43,2.53c1.65,2.42,3.16,4.93,4.73,7.41c1.19,2.25,2.38,4.51,3.57,6.76c0.43,1.24,0.81,2.5,1.29,3.72 c2.47,6.18,4.06,12.35-0.08,18.49c-0.13,0.01-0.26,0.01-0.39,0.02c-1.13-0.07-1.66,0.46-1.59,1.59c0,0.13-0.01,0.25-0.01,0.38 c-0.4,0.26-0.79,0.53-1.19,0.79c-0.27,0.13-0.53,0.27-0.8,0.4c-0.25,0.08-0.52,0.12-0.75,0.25c-3.96,2.15-7.9,4.3-12.33,5.44 c-2.07,0.53-4.02,1.51-6.03,2.28c-0.8,0.26-1.6,0.53-2.4,0.79c-5.22,0.69-10.41,0.78-15.52-0.79c-0.4-0.13-0.8-0.26-1.19-0.4 c-0.39-0.14-0.79-0.28-1.18-0.42c-0.27-0.13-0.53-0.26-0.8-0.4c-0.67-0.39-1.33-0.78-2-1.17c-0.27-0.13-0.54-0.25-0.81-0.38 c-0.93-0.4-1.86-0.79-2.79-1.19c-0.39-0.14-0.79-0.28-1.18-0.42c-0.13,0-0.27,0-0.4,0.01c-0.39-0.14-0.79-0.28-1.18-0.42 c-1.2-0.66-2.39-1.33-3.59-1.99c-0.42-1.7-1.6-2.17-3.19-1.95c-0.53-0.14-1.05-0.28-1.58-0.42c-0.26-0.13-0.53-0.27-0.79-0.4 c-1.06-0.53-2.12-1.06-3.18-1.59c-0.27-0.13-0.53-0.26-0.8-0.4c-0.92-0.49-1.8-1.3-2.76-1.42c-4.91-0.6-9.7-2.34-14.76-1.72 c-1.83-0.32-1.68,1.42-2.01,2.28c-0.24,0.62,0.52,1.63,0.83,2.46c0.4,0.66,0.79,1.33,1.19,1.99c0.14,0.26,0.27,0.53,0.41,0.79 c0.4,0.66,0.79,1.32,1.19,1.98c0.4,0.79,0.8,1.59,1.2,2.38c1.06,1.85,2.12,3.71,3.18,5.56c0.14,0.26,0.27,0.53,0.41,0.79 c0.93,1.59,1.86,3.18,2.79,4.76c-0.65,1.39,0.48,1.07,1.15,1.2c0.28,0.53,0.56,1.05,0.84,1.58c-0.64,1.39,0.49,1.07,1.16,1.2 c1.47,2.11,2.94,4.22,4.41,6.33c0.71,1.12,1.34,2.3,2.14,3.34c0.46,0.6,1.2,0.97,1.82,1.45c0.54,0.79,1.08,1.58,1.62,2.38 c-0.65,1.4,0.51,1.06,1.17,1.2c0.67,0.79,1.35,1.58,2.02,2.38c-0.55,1.61,0.67,1.45,1.6,1.59c0.52,0.4,1.05,0.8,1.57,1.2 c0.4,0.4,0.8,0.79,1.19,1.19c0,1.34,0.66,2.01,2.01,1.98c0.78,0.53,1.57,1.07,2.35,1.6c0.01,0.13,0.02,0.26,0.02,0.39 c-0.01,1.34,0.66,2,2,1.98c0.13,0,0.26,0,0.39,0c0.92,0.8,1.84,1.6,2.77,2.39c2.66,1.46,5.32,2.92,7.98,4.37 c1.2,0.39,2.39,0.78,3.59,1.16c0.4,0,0.8,0,1.2,0l-0.01,0.03c0.23,0.23,0.46,0.46,0.69,0.69c0.17-0.23,0.34-0.46,0.5-0.69 c0.27-0.01,0.53-0.02,0.8-0.03c0.4,0,0.79-0.01,1.19-0.01c1.99-0.12,3.98-0.25,5.97-0.37c0.4-0.13,0.8-0.27,1.19-0.4 c1.19-0.4,2.38-0.8,3.57-1.2c1.43,0.59,2.47,0.12,3.19-1.19c0.79-0.27,1.59-0.53,2.38-0.8c0.27-0.13,0.54-0.25,0.81-0.38 c0.82-0.39,1.66-0.74,2.46-1.17c1.71-0.91,3.41-1.86,5.11-2.8c0.27-0.13,0.53-0.26,0.8-0.39c0.66-0.39,1.33-0.79,1.99-1.18 c0,0,0.19,0,0.19,0l0.19,0.01c0.36,0.14,0.94,0.48,1.05,0.37c0.29-0.3,0.37-0.79,0.54-1.2c0.66-0.4,1.32-0.8,1.99-1.2 c1.65,0.18,2.37-0.3,2.39-1.58c0.8-0.65,1.6-1.3,2.4-1.96c0,0,0.19,0,0.19,0l0.19,0.01c0.36,0.14,0.94,0.48,1.05,0.37 c0.29-0.29,0.37-0.79,0.54-1.2c0.92-0.53,1.84-1.07,2.76-1.6c0.54-0.4,1.08-0.79,1.62-1.19c1.33-0.79,2.65-1.59,3.98-2.38 c1.6,0.15,2.55-0.39,2.8-1.57c0.53-0.27,1.05-0.54,1.58-0.81c1.33,0.66,2.02,0.05,2.39-1.2c0.4-0.38,0.81-0.77,1.21-1.15 c0.27-0.13,0.53-0.27,0.8-0.4c0.4-0.13,0.79-0.26,1.19-0.39c0.25,0.23,0.49,0.46,0.74,0.69c0.28-0.38,0.56-0.75,0.85-1.13 c0.4-0.26,0.8-0.52,1.2-0.78c0.26,0,0.53,0.01,0.79,0.01c0.4-0.14,0.81-0.27,1.21-0.41c0.39-0.26,0.79-0.53,1.18-0.79 c0.13-0.01,0.27-0.01,0.4-0.02c0.27-0.26,0.54-0.52,0.81-0.77c0.52,0,1.05-0.01,1.57-0.01c0.4-0.13,0.8-0.26,1.2-0.38 c1.33-0.27,2.65-0.54,3.98-0.81c0.4-0.12,0.8-0.25,1.2-0.37c7.05-1.36,13.41,0.67,19.52,3.94c0.4,0.27,0.8,0.54,1.2,0.81 c1.32,1.32,2.65,2.64,3.97,3.97c-0.08,1.13,0.45,1.67,1.58,1.6c0.36,1.09,0.72,2.18,1.08,3.27c-0.82,0.23-1.63,0.52-2.47,0.68 c-0.57,0.11-1.17,0.03-1.75,0.04c-1.04,0.35-2.61-0.25-2.83,1.57c-1.05,0.64-2.06,1.34-3.15,1.9c-1.21,0.62-2.39,0.63-3.21-0.7 c0.19-0.25,0.37-0.49,0.56-0.74c-1.12-0.54-2.23-1.09-3.35-1.63c-0.4-0.27-0.8-0.53-1.2-0.8c-0.27-0.26-0.54-0.53-0.81-0.79 c-1.91-0.48-3.8-1.01-5.72-1.44c-1.16-0.26-2.33-0.47-3.21,0.77c-0.26,0.37-0.91,0.45-1.38,0.67c-0.27,0.26-0.54,0.53-0.8,0.79 c-0.67,0.53-1.33,1.06-2,1.59c-0.18-0.21-0.36-0.42-0.54-0.63c-0.35,0.61-0.7,1.22-1.05,1.82c-0.13,0.13-0.27,0.26-0.4,0.39 c-1.58-0.26-2.47,0.46-2.79,1.98c-2.12,1.6-4.24,3.19-6.35,4.79c-0.27,0.26-0.54,0.53-0.81,0.79c-0.4,0.27-0.79,0.54-1.19,0.81 c-1.79-0.77-1.38,0.72-1.6,1.55c-2.78,2.31-5.68,4.42-9.19,5.54c-1.59,0.51-3.16,1.1-4.73,1.65c-0.27,0.13-0.54,0.26-0.8,0.39 c-0.53,0-1.06-0.01-1.59-0.01c-0.4,0.4-0.8,0.8-1.2,1.19c-0.53,0.13-1.06,0.26-1.59,0.4c-0.4,0.13-0.8,0.26-1.2,0.38 c-0.26,0-0.53,0.01-0.79,0.01c-0.4,0.13-0.8,0.26-1.2,0.39c-1.33,0.27-2.65,0.54-3.98,0.8c-0.8,0.13-1.59,0.26-2.39,0.39 c-0.39,0-0.79,0.01-1.18,0.01c-0.54,0.26-1.07,0.52-1.61,0.78c-1.46,0.27-2.92,0.55-4.38,0.82c-0.27-0.01-0.53-0.03-0.8-0.04 c-0.17-0.23-0.34-0.46-0.51-0.68c-0.23,0.23-0.46,0.46-0.68,0.69c-0.66,0.01-1.32,0.02-1.98,0.03c-0.27,0.12-0.54,0.24-0.81,0.37 c-0.53,0.14-1.06,0.28-1.59,0.42c-0.13-0.01-0.27-0.02-0.4-0.03c-0.17-0.23-0.34-0.45-0.51-0.68c-0.23,0.23-0.45,0.46-0.68,0.69 c-2.52-0.13-5.04-0.26-7.57-0.4c-0.27-0.12-0.54-0.24-0.81-0.36c-0.53,0-1.05,0-1.58,0c-0.26,0-0.53-0.01-0.79-0.01 c-4.77-1.2-9.55-2.41-14.32-3.61c-1.06-0.53-2.12-1.06-3.19-1.59c-4.25-2.38-8.49-4.77-12.74-7.15c-0.4-0.38-0.8-0.77-1.21-1.15 c-2.38-1.6-4.77-3.2-7.15-4.81c-0.4-0.38-0.8-0.77-1.21-1.15c-0.52-0.27-1.05-0.55-1.57-0.82c-0.67-0.65-1.34-1.31-2.01-1.96 c-0.26-0.14-0.52-0.28-0.78-0.41c-0.4-0.39-0.81-0.78-1.21-1.17l0.01-0.03c-0.1-1.5-0.89-2.29-2.4-2.37 c-0.13,0-0.26-0.01-0.39-0.02c-0.4-0.65-0.81-1.3-1.21-1.95c0.08-1.14-0.44-1.67-1.58-1.61c-0.13-0.01-0.26-0.01-0.39-0.02 c-0.4-0.78-0.81-1.56-1.21-2.35c0.08-1.13-0.43-1.67-1.57-1.61c-0.91-1.28-1.97-2.48-2.72-3.85c-3.52-6.37-6.96-12.79-10.43-19.19 c-0.27-0.4-0.53-0.81-0.8-1.21c-0.14-0.19-0.27-0.38-0.41-0.56c-0.13,0.33-0.25,0.66-0.38,0.99c0,0.39,0,0.79,0,1.18 c-0.51,1.49-0.8,3.1-1.57,4.44c-3.38,5.84-6.91,11.6-10.39,17.39c-0.13,0.01-0.26,0.01-0.39,0.02c-1.14-0.07-1.67,0.47-1.59,1.6 c0,0.13,0,0.26,0,0.39c-0.53,0.53-1.07,1.06-1.6,1.59c-1.14-0.07-1.66,0.47-1.59,1.6c0,0.13,0,0.26,0,0.39 c-0.4,0.52-0.8,1.04-1.21,1.57c-0.13,0.01-0.26,0.01-0.39,0.02c-1.14-0.06-1.67,0.47-1.58,1.61c-2.6,3.63-6.02,6.3-9.95,8.34 c-0.4,0.27-0.8,0.53-1.2,0.8c-4.68,4.31-10.38,7-15.93,9.92c-1.06,0.53-2.12,1.06-3.19,1.59c-1.2,0.65-2.39,1.31-3.59,1.96 c-0.26,0.13-0.53,0.26-0.79,0.38c-2.92,0.67-5.84,1.33-8.76,2c-0.26,0.13-0.53,0.26-0.79,0.39c-0.39,0.01-0.79,0.02-1.18,0.03 c-0.27,0.12-0.54,0.24-0.81,0.36c-0.13,0.01-0.27,0.02-0.4,0.03c-0.26,0-0.53,0.01-0.79,0.01c-0.53,0.12-1.06,0.23-1.59,0.35 c-0.13-0.19-0.27-0.38-0.4-0.57c-0.13,0.19-0.26,0.39-0.39,0.58c-0.93,0.01-1.85,0.02-2.78,0.03c-0.27,0.12-0.54,0.24-0.81,0.36 c-1.33,0.14-2.65,0.27-3.98,0.41c-0.53-0.13-1.06-0.25-1.6-0.38c-8.66-0.69-17.09-2.64-25.47-4.8c-0.27-0.13-0.54-0.25-0.81-0.38 c-1.33-0.66-2.66-1.32-3.98-1.98c-0.4-0.13-0.8-0.26-1.2-0.39c-0.26-0.01-0.52-0.02-0.79-0.03c-2.39-1.19-4.78-2.38-7.16-3.57 c-0.4-0.39-0.8-0.78-1.2-1.17c-0.13-0.01-0.25-0.02-0.38-0.02c-0.54-0.52-1.07-1.04-1.61-1.57c-0.13-0.01-0.25-0.02-0.38-0.02 c-0.01-0.13-0.01-0.26-0.02-0.39c-0.4-0.39-0.81-0.79-1.21-1.18c-0.13,0-0.25,0-0.38,0c-0.79-0.54-1.59-1.08-2.38-1.62 c-0.93-0.79-1.86-1.57-2.8-2.36c-0.13-0.01-0.25-0.02-0.38-0.02c-0.4-0.39-0.81-0.78-1.21-1.18c-0.13-0.01-0.25-0.02-0.38-0.02 c-1.07-0.92-2.14-1.84-3.21-2.76c-0.26-0.14-0.52-0.28-0.78-0.42c-0.4-0.39-0.8-0.78-1.21-1.16c-1.86-1.06-3.72-2.12-5.58-3.18 c-0.4-0.13-0.79-0.26-1.19-0.39c-0.8-0.01-1.59-0.02-2.39-0.03c-0.13-0.19-0.27-0.38-0.4-0.58c-0.13,0.2-0.26,0.39-0.39,0.59 c-0.8,0.4-1.59,0.8-2.39,1.2c-0.53,0.26-1.07,0.52-1.6,0.78c-0.79,0.41-1.59,0.82-2.38,1.22c-0.13-0.01-0.26-0.01-0.38-0.01 c-1.34-0.03-2.01,0.62-2.01,1.96c-0.99,0.22-2.11,0.84-2.93,0.57c-1.89-0.62-3.63-1.67-5.43-2.54c-0.27-0.12-0.54-0.25-0.81-0.38 c-0.26,0-0.52,0-0.78-0.01C13.55,178.71,12.62,178.58,11.69,178.44z M95.3,131.56c0.14,0.92-0.01,2.13,1.59,1.59 c2.52,0.65,5.03,1.41,7.58,1.92c4.98,1,9.83,0.52,14.43-1.74c2.49-1.23,4.96-2.5,7.44-3.75c0.4-0.26,0.8-0.52,1.21-0.78 c5.87-3.01,12.19-4.45,18.7-5.18c0.33-0.12,0.67-0.25,1-0.37c-0.19-0.14-0.37-0.28-0.56-0.42c0.19-1.44-0.44-2.26-1.77-2.89 c-4.23-2.01-8.4-4.16-12.59-6.26c-0.26-0.13-0.53-0.26-0.79-0.39c-2.06-0.66-4.13-1.31-6.19-1.99c-4.7-1.54-9.51-2.3-14.37-1.16 c-3.42,0.8-6.73,2.09-10.09,3.16c-1.7,0.17-2.62,1.1-2.8,2.79c-0.14,0.26-0.28,0.52-0.42,0.78c-1.49-0.09-1.65,0.87-1.57,2 C94.52,123.02,93.85,127.22,95.3,131.56z M268.51,130.77c0.23-0.23,0.46-0.46,0.69-0.68c-0.23-0.17-0.46-0.34-0.68-0.51 c0.25-1.51,0.84-3.05,0.69-4.51c-0.23-2.23-0.98-4.41-1.5-6.62c0.83-1.46-0.2-1.51-1.2-1.58c-1.24-1.09-2.41-2.26-3.72-3.24 c-6.24-4.65-13.34-4.49-20.49-3.3c-7.81,1.3-14.58,5.36-21.65,8.6c-1.07,0.49-2.1,1.15-3,1.91c-0.46,0.39-0.77,1.18-0.78,1.79 c0,0.33,0.73,0.83,1.22,0.98c1.2,0.36,2.43,0.59,3.67,0.8c6.5,1.1,12.76,2.96,18.32,6.52c6.9,4.42,14.18,5.87,22.13,3.81 C264.7,134.1,267.07,133.15,268.51,130.77z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M125.16,91.85c0,0.13,0,0.26,0.01,0.39c-5.18,0-10.36,0-15.55,0c0-0.13,0.01-0.26,0.01-0.39 C114.81,91.85,119.98,91.85,125.16,91.85z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M12.11,174.47c1.46-1.45,2.91-2.9,4.37-4.36C15.78,172.33,14.33,173.78,12.11,174.47z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M211.17,167.3c1.32,1.6,2.64,3.19,3.96,4.79c-0.61-0.48-1.36-0.85-1.82-1.45 C212.51,169.59,211.87,168.41,211.17,167.3z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M194.44,133.97c-0.99,1.43-2.12,2.83-1.18,4.74c-0.31-0.84-1.08-1.85-0.83-2.46 C192.77,135.39,192.61,133.65,194.44,133.97z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M335.37,181.22c-0.93-0.79-1.86-1.58-2.79-2.37c1.12,0.54,2.23,1.09,3.35,1.63 C335.74,180.73,335.56,180.97,335.37,181.22z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M100.89,113.3c-0.93,0.93-1.87,1.86-2.8,2.78C98.27,114.4,99.2,113.47,100.89,113.3z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M282.84,182.42c0.26,0,0.51-0.01,0.77-0.01c-0.02,1.28-0.74,1.75-2.39,1.58c0.14-0.25,0.28-0.5,0.42-0.76 C282.04,182.96,282.44,182.69,282.84,182.42z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M296.35,174.45c0.93-0.52,1.87-1.05,2.8-1.57C298.9,174.07,297.95,174.6,296.35,174.45z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M221.51,141.87c-1.06-0.65-2.13-1.3-3.19-1.95C219.91,139.7,221.09,140.17,221.51,141.87z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M260.51,193.91c1.06-0.4,2.13-0.79,3.19-1.19C262.98,194.03,261.95,194.5,260.51,193.91z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M315.47,181.22c-0.93,0.66-1.86,1.32-2.79,1.98C313,181.67,313.88,180.96,315.47,181.22z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M131.94,197.13c-1.06,0.53-2.12,1.06-3.19,1.59C129.81,198.19,130.88,197.66,131.94,197.13z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M300.73,172.07c0.8-0.4,1.59-0.8,2.39-1.2C302.75,172.13,302.06,172.73,300.73,172.07z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M202.8,180.01c-0.4-0.26-0.8-0.52-1.2-0.78c-0.4-0.53-0.8-1.06-1.2-1.59 C201.91,177.72,202.7,178.52,202.8,180.01z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M134.7,183.6c0.14-0.26,0.27-0.52,0.41-0.79c0.53-0.53,1.07-1.06,1.6-1.59c0.13,0,0.26,0,0.39-0.01 C137.02,182.73,136.23,183.53,134.7,183.6z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M344.57,178.46c-0.94,0.52-1.88,1.04-2.83,1.57C341.96,178.21,343.53,178.8,344.57,178.46z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M95.3,131.56c0.53,0.53,1.06,1.06,1.59,1.59C95.3,133.69,95.45,132.48,95.3,131.56z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M278.46,185.2c0.26,0,0.51-0.01,0.77-0.01c-0.17,0.41-0.25,0.9-0.54,1.2c-0.11,0.11-0.68-0.24-1.05-0.37 C277.92,185.74,278.19,185.47,278.46,185.2z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M317.46,179.64c-0.53,0.4-1.06,0.79-1.59,1.19c0.35-0.61,0.7-1.22,1.05-1.82 C317.1,179.22,317.28,179.43,317.46,179.64z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M26.44,179.24c-0.54,0.65-1.08,1.31-1.61,1.96c0,0-0.2,0-0.2,0s-0.2,0-0.2,0 C24.43,179.86,25.1,179.21,26.44,179.24z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M228.67,185.99c0.67,0.66,1.33,1.32,2,1.98C229.33,187.99,228.67,187.33,228.67,185.99z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M196.05,143.47c0.4,0.79,0.8,1.59,1.2,2.38C196.84,145.06,196.44,144.27,196.05,143.47z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M286.81,180.04c0.39-0.14,0.79-0.27,1.18-0.41c-0.17,0.41-0.25,0.9-0.54,1.2c-0.11,0.11-0.68-0.23-1.05-0.37 C286.54,180.31,286.67,180.18,286.81,180.04z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M98.5,97.81c0.13,0,0.26,0,0.39,0c0.01,1.33-0.66,1.99-1.99,1.98C97.43,99.13,97.96,98.47,98.5,97.81z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M304.33,189.58c-0.53,0.52-1.07,1.04-1.6,1.55C302.95,190.3,302.54,188.8,304.33,189.58z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M226.29,183.6c0,0.13,0.01,0.26,0.02,0.39c-1.35,0.03-2.01-0.64-2.01-1.98c0,0,0.01-0.01,0.01-0.01 C224.96,182.54,225.62,183.07,226.29,183.6z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M171.72,115.27c0.67-0.66,1.34-1.32,2.01-1.98C173.74,114.64,173.07,115.3,171.72,115.27z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M48.72,166.12c0.66,0.4,1.33,0.8,1.99,1.2c-0.8-0.39-1.59-0.79-2.39-1.18 C48.45,166.13,48.59,166.13,48.72,166.12z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M219.93,178.03c0.53,0.53,1.06,1.06,1.6,1.59C220.6,179.48,219.38,179.65,219.93,178.03z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M97.67,116.87c-0.52,0.67-1.05,1.33-1.57,2C96.03,117.74,96.18,116.79,97.67,116.87z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M276.45,201.88c-0.8,0.13-1.59,0.26-2.39,0.39C274.86,202.14,275.65,202.01,276.45,201.88z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M129.12,188.76c0.54-0.53,1.07-1.05,1.61-1.58C130.8,188.31,130.26,188.84,129.12,188.76z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M174.92,112.5c0.67-0.39,1.33-0.79,2-1.18C176.25,111.71,175.58,112.11,174.92,112.5z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M267.7,118.46c-0.4-0.53-0.8-1.06-1.2-1.58C267.49,116.95,268.53,117,267.7,118.46z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M277.25,137.53c-0.53,0.53-1.06,1.06-1.59,1.59C275.58,137.99,276.12,137.46,277.25,137.53z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M160.59,176.45c-0.4,0.53-0.79,1.06-1.19,1.59c-0.13,0.01-0.26,0.01-0.39,0.02 C158.92,176.93,159.45,176.39,160.59,176.45z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M198.41,175.66c-0.4-0.53-0.79-1.06-1.19-1.59c1.14-0.06,1.67,0.47,1.58,1.61 C198.68,175.67,198.54,175.66,198.41,175.66z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M346.13,172.86c0.53,0.53,1.06,1.07,1.58,1.6C346.58,174.53,346.05,174,346.13,172.86z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M306.31,168.93c0.53-0.15,1.06-0.29,1.58-0.44c-0.28,0.38-0.56,0.75-0.85,1.13 C306.8,169.39,306.56,169.16,306.31,168.93z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M163.77,173.27c-0.53,0.4-1.06,0.81-1.58,1.21c-0.08-1.13,0.45-1.66,1.59-1.6 C163.78,173.01,163.78,173.14,163.77,173.27z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M166.96,169.3c-0.53,0.53-1.06,1.07-1.59,1.6C165.3,169.77,165.83,169.24,166.96,169.3z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M195.62,171.7c-0.52-0.54-1.05-1.07-1.57-1.61C195.19,170.03,195.7,170.58,195.62,171.7z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M205.6,159.76c0.39,0.4,0.77,0.8,1.16,1.2C206.09,160.83,204.96,161.15,205.6,159.76z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M107.24,148.25c-0.54-0.39-1.07-0.79-1.61-1.18C106.17,147.46,106.71,147.86,107.24,148.25z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M272.88,202.28c-0.54,0.26-1.07,0.52-1.61,0.78C271.81,202.8,272.35,202.54,272.88,202.28z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M286.41,198.7c-0.4,0.4-0.8,0.8-1.2,1.19C285.61,199.5,286.01,199.1,286.41,198.7z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M216.74,174.46c0.39,0.4,0.78,0.8,1.17,1.2C217.25,175.52,216.1,175.86,216.74,174.46z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M203.61,156.98c0.38,0.4,0.77,0.8,1.15,1.2C204.1,158.05,202.96,158.36,203.61,156.98z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M290.75,178.03c0.54-0.4,1.08-0.79,1.62-1.19C291.83,177.23,291.29,177.63,290.75,178.03z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M149.06,186.4c-0.4,0.27-0.8,0.53-1.2,0.8C148.26,186.94,148.66,186.67,149.06,186.4z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M163.38,110.12c0.4,0.39,0.81,0.79,1.21,1.18C164.19,110.91,163.78,110.51,163.38,110.12z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M260.12,204.63c-0.4,0-0.79,0.01-1.19,0.01c0.23-0.23,0.45-0.46,0.68-0.69 C259.78,204.17,259.95,204.4,260.12,204.63z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M265.7,203.87c-0.27-0.01-0.53-0.02-0.8-0.02c0.23-0.23,0.46-0.46,0.68-0.69c0.17,0.23,0.34,0.46,0.51,0.68 C265.96,203.85,265.83,203.86,265.7,203.87z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M227.87,144.7c-0.39-0.14-0.79-0.28-1.18-0.42C227.08,144.42,227.47,144.56,227.87,144.7z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M281.63,200.69c-0.4,0.13-0.8,0.26-1.2,0.39C280.83,200.94,281.23,200.81,281.63,200.69z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M283.62,200.29c-0.4,0.13-0.8,0.26-1.2,0.38C282.82,200.55,283.22,200.42,283.62,200.29z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M69.82,197.51c-0.4,0-0.79-0.01-1.19-0.01c0-0.13-0.01-0.25-0.01-0.38 C69.02,197.25,69.42,197.38,69.82,197.51z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M246.59,195.93c0.4,0,0.8,0,1.2,0c-0.17,0.23-0.34,0.46-0.5,0.69C247.05,196.39,246.82,196.16,246.59,195.93z "}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M255.75,195.52c0.4-0.13,0.8-0.27,1.19-0.4C256.54,195.25,256.15,195.39,255.75,195.52z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M315.07,165.72c0.4-0.13,0.8-0.26,1.2-0.38C315.86,165.47,315.46,165.6,315.07,165.72z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M29.61,163.76c0.4,0,0.8-0.01,1.19-0.01c-0.23,0.23-0.46,0.47-0.68,0.7 C29.95,164.22,29.78,163.99,29.61,163.76z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M223.1,180.83c0.4,0.26,0.8,0.53,1.2,0.79c0,0.13,0.01,0.26,0.01,0.39c0,0-0.01,0.01-0.01,0.01 C223.89,181.62,223.5,181.22,223.1,180.83z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M57.08,190.35c-0.4-0.39-0.81-0.79-1.21-1.18C56.27,189.56,56.68,189.96,57.08,190.35z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M320.24,164.52c0.4-0.12,0.8-0.25,1.2-0.37C321.04,164.28,320.64,164.4,320.24,164.52z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M268.51,130.77c0-0.4,0-0.79,0.01-1.19c0.23,0.17,0.46,0.34,0.68,0.51 C268.97,130.32,268.74,130.54,268.51,130.77z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M126.34,129.58c0.4-0.26,0.8-0.52,1.21-0.78C127.15,129.05,126.74,129.31,126.34,129.58z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M180.1,145.84c-0.26,0.14-0.53,0.29-0.79,0.43c0.13-0.33,0.25-0.66,0.38-0.99 C179.83,145.47,179.96,145.66,180.1,145.84z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M146.25,123.62c0.15-0.26,0.3-0.52,0.44-0.79c0.19,0.14,0.37,0.28,0.56,0.42 C146.91,123.37,146.58,123.49,146.25,123.62z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M340.96,168.09c0.4,0.27,0.8,0.54,1.2,0.81C341.76,168.63,341.36,168.36,340.96,168.09z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M331.38,178.05c-0.27-0.26-0.54-0.53-0.81-0.79C330.85,177.52,331.11,177.78,331.38,178.05z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M320.26,177.26c-0.27,0.26-0.54,0.53-0.8,0.79C319.73,177.78,319.99,177.52,320.26,177.26z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M155.42,104.15c0.4,0.27,0.8,0.53,1.19,0.8C156.22,104.69,155.82,104.42,155.42,104.15z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M160.2,107.73c0.4,0.27,0.79,0.54,1.19,0.8C160.99,108.26,160.59,107.99,160.2,107.73z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M311.1,167.32c0.39-0.26,0.79-0.53,1.18-0.79C311.89,166.79,311.49,167.05,311.1,167.32z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M306.33,187.98c-0.27,0.26-0.54,0.53-0.81,0.79C305.79,188.51,306.06,188.24,306.33,187.98z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M33.99,176.04c-0.27,0.01-0.53,0.01-0.8,0.02c0.13-0.2,0.26-0.39,0.39-0.59 C33.72,175.65,33.85,175.84,33.99,176.04z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M25.22,165.31c0.27-0.12,0.54-0.25,0.81-0.37C25.76,165.06,25.49,165.19,25.22,165.31z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M44.34,164.95c0.27,0.13,0.53,0.25,0.8,0.38C44.87,165.2,44.6,165.07,44.34,164.95z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M266.09,191.93c0.27-0.13,0.54-0.25,0.81-0.38C266.63,191.67,266.36,191.8,266.09,191.93z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M200.42,151.42c0.13,0.26,0.27,0.53,0.41,0.79C200.69,151.95,200.56,151.69,200.42,151.42z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M132.33,113.69c-0.26-0.13-0.53-0.26-0.79-0.39C131.8,113.42,132.06,113.56,132.33,113.69z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M68.63,177.22c0.26,0.14,0.53,0.27,0.79,0.41C69.16,177.5,68.9,177.36,68.63,177.22z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M194.45,140.7c0.13,0.26,0.27,0.53,0.41,0.79C194.72,141.23,194.58,140.96,194.45,140.7z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M288.8,198.32c-0.27,0.13-0.54,0.26-0.8,0.39C288.27,198.58,288.54,198.45,288.8,198.32z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M139.5,143.11c-0.27,0.13-0.53,0.27-0.8,0.4C138.97,143.37,139.24,143.24,139.5,143.11z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M52.71,168.49c0.27,0.13,0.53,0.27,0.8,0.4C53.24,168.75,52.97,168.62,52.71,168.49z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M231.46,146.26c-0.27-0.13-0.54-0.25-0.81-0.38C230.92,146.01,231.19,146.14,231.46,146.26z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M125.16,200.68c-0.26,0.13-0.53,0.26-0.79,0.38C124.63,200.94,124.89,200.81,125.16,200.68z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M127.55,92.65c0.26,0,0.53,0.01,0.79,0.01c-0.13,0.19-0.27,0.38-0.4,0.57 C127.81,93.04,127.68,92.85,127.55,92.65z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M115.6,203.06c-0.26,0.13-0.53,0.26-0.79,0.39C115.07,203.32,115.34,203.19,115.6,203.06z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M113.62,203.48c-0.27,0.12-0.54,0.24-0.81,0.36C113.09,203.73,113.36,203.6,113.62,203.48z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M15.27,179.24c0-0.13-0.01-0.25-0.01-0.38c0.27,0.13,0.54,0.25,0.81,0.38 C15.81,179.23,15.54,179.23,15.27,179.24z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M110.03,204.23c-0.26,0-0.53,0.01-0.79,0.01c0.13-0.19,0.26-0.39,0.39-0.58 C109.76,203.85,109.9,204.04,110.03,204.23z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M251.37,204.24c-0.27-0.12-0.54-0.24-0.81-0.36C250.83,204,251.1,204.12,251.37,204.24z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M262.92,203.88c-0.27,0.12-0.54,0.24-0.81,0.37C262.39,204.12,262.65,204,262.92,203.88z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M106.46,204.28c-0.27,0.12-0.54,0.24-0.81,0.36C105.92,204.52,106.19,204.4,106.46,204.28z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M164.97,133.13c-0.26,0-0.53,0.01-0.79,0.01c0.13-0.19,0.26-0.39,0.39-0.58 C164.7,132.75,164.84,132.94,164.97,133.13z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M270.05,204.22c-0.11,0.01-0.21,0.02-0.32,0.02C269.84,204.23,269.94,204.22,270.05,204.22z"})]})})]});const OverflowArrow=({elClass:s})=>jsxRuntimeExports.jsxs("svg",{className:s,viewBox:"0 0 49 81",fill:"none",children:[jsxRuntimeExports.jsx("rect",{width:"49",height:"81",fill:"url(#gradient_linear)"}),jsxRuntimeExports.jsx("path",{d:"M26.8076 30.8086L36 40.001L26.8076 49.1934",stroke:"#14334C",strokeWidth:"1.2"}),jsxRuntimeExports.jsx("defs",{children:jsxRuntimeExports.jsxs("linearGradient",{id:"gradient_linear",x1:"36.5",y1:"31.5",x2:"8.5",y2:"31.5",gradientUnits:"userSpaceOnUse",children:[jsxRuntimeExports.jsx("stop",{stopColor:"white"}),jsxRuntimeExports.jsx("stop",{offset:"1",stopColor:"white",stopOpacity:"0"})]})})]});const CloseIcon=({elClass:s,onClick:a})=>jsxRuntimeExports.jsxs("svg",{className:s,viewBox:"0 0 15 14",fill:"none",onClick:a,children:[jsxRuntimeExports.jsx("line",{x1:"7.46377",y1:"2.62269e-08",x2:"7.46377",y2:"14",stroke:"#14334C",strokeWidth:"1"}),jsxRuntimeExports.jsx("line",{x1:"0.5",y1:"7.03623",x2:"14.5",y2:"7.03623",stroke:"#14334C",strokeWidth:"1"})]});const GolfClubs=({elClass:s,fillColor:a})=>jsxRuntimeExports.jsxs("svg",{className:s,viewBox:"0 0 252 252",fill:a,xmlns:"http://www.w3.org/2000/svg",children:[jsxRuntimeExports.jsx("g",{id:"DIxly4_2_",children:jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{className:"st0",d:"M-910-253.4c-1.25-0.24-2.52-0.4-3.75-0.73c-2.62-0.7-4.74-2.13-6.11-4.53c-1.12-1.96-1.01-3.89,0.19-5.8 c0.89-1.42,2.27-1.85,3.81-1.93c3.03-0.15,5.91,0.56,8.72,1.6c1.63,0.61,3.26,1.24,4.91,1.78c1.29,0.42,1.47,0.29,2.23-0.61 c11.47-13.66,22.95-27.3,34.43-40.95c4.66-5.54,9.32-11.08,13.98-16.62c0.06-0.07,0.12-0.14,0.24-0.26 c0.73,0.61,1.45,1.22,2.22,1.87c-1.08,1.34-2.13,2.64-3.19,3.93c-7.6,9.33-15.2,18.67-22.79,28 c-7.67,9.42-15.34,18.85-23.02,28.27c-0.91,1.12-1.77,2.28-2.74,3.34c-1.4,1.53-3.32,1.97-5.25,2.35c-0.5,0.1-1,0.19-1.5,0.28 C-908.42-253.4-909.21-253.4-910-253.4z"}),jsxRuntimeExports.jsx("path",{className:"st0",d:"M-822.09-253.4c-0.68-0.14-1.35-0.29-2.03-0.41c-2.42-0.42-4.34-1.61-5.87-3.56 c-3.63-4.6-7.33-9.16-11.03-13.71c-6.98-8.6-13.99-17.19-20.98-25.78c-0.07-0.09-0.14-0.18-0.23-0.31 c0.71-0.87,1.42-1.73,2.17-2.65c0.84,0.99,1.64,1.94,2.44,2.89c9.37,11.13,18.74,22.26,28.08,33.42c0.66,0.79,1.31,0.84,2.14,0.53 c1.68-0.61,3.36-1.23,5.04-1.84c2.53-0.92,5.1-1.58,7.82-1.58c3.29,0,4.54,0.94,5.5,4.1c0.01,0.04,0.06,0.07,0.09,0.1 c0,0.51,0,1.02,0,1.54c-0.11,0.33-0.2,0.66-0.33,0.98c-1.2,3.01-3.54,4.71-6.55,5.55c-1.22,0.34-2.49,0.5-3.74,0.73 C-820.41-253.4-821.25-253.4-822.09-253.4z"}),jsxRuntimeExports.jsx("path",{className:"st0",d:"M-912.94-363.96c0.61,0.52,1.31,0.96,1.82,1.56c8.34,9.87,16.66,19.76,24.98,29.65 c1.75,2.08,3.57,4.12,5.23,6.28c0.6,0.78,0.86,1.83,1.25,2.78c0.46,1.13,0.45,1.14-0.46,1.91c-0.46,0.39-0.93,0.78-1.39,1.16 c-0.05,0.04-0.12,0.07-0.19,0.1c-0.91-0.57-1.82-1.13-2.71-1.72c-0.34-0.23-0.67-0.51-0.93-0.82 c-9.87-11.71-19.74-23.43-29.6-35.15c-0.28-0.34-0.55-0.7-0.86-1.01c-1.69-1.71-0.59-3.65,0.87-4.38c0.25-0.12,0.5-0.23,0.75-0.35 C-913.78-363.96-913.36-363.96-912.94-363.96z"}),jsxRuntimeExports.jsx("path",{className:"st0",d:"M-815.38-363.96c0.49,0.29,1.03,0.52,1.47,0.89c1.18,0.99,1.27,2.46,0.27,3.64 c-10.24,12.16-20.47,24.33-30.71,36.49c-0.13,0.16-0.27,0.34-0.44,0.45c-1.03,0.67-2.08,1.32-3.15,2 c-0.74-0.62-1.48-1.22-2.19-1.85c-0.12-0.11-0.14-0.42-0.09-0.6c0.62-1.96,1.56-3.7,2.92-5.31c9.64-11.36,19.21-22.77,28.82-34.15 c0.51-0.6,1.22-1.04,1.83-1.55C-816.22-363.96-815.8-363.96-815.38-363.96z"}),jsxRuntimeExports.jsx("path",{className:"st0",d:"M-867.4-308.55c-0.71,0.84-1.38,1.64-2.1,2.48c-3.68-4.52-7.32-8.99-10.99-13.5 c0.76-0.64,1.47-1.23,2.23-1.88C-874.61-317.13-871.01-312.85-867.4-308.55z"})]})}),jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsx("path",{className:"st0",d:"M-963.75-336.56l-5.86-0.64v-3.27h24.22c22.36,0,32.23,15.9,32.23,31.79c0,14.53-10.06,31.79-30.38,31.79 h-26.07v-3.27l5.86-0.64V-336.56z M-954.37-280.43c2.83,0.18,5.66,0.27,8.21,0.27c12.6,0,22.66-5.99,22.66-28.52 c0-22.52-8.79-28.52-22.66-28.52c-3.42,0-5.86,0.09-8.21,0.09V-280.43z"})}),jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsx("path",{className:"st0",d:"M-760.57-272.62c0,2.08-3.8,4.25-8.08,4.25c-6.62,0-10.22-4.07-12.46-10.5c-1.16,0.36-2.33,0.73-3.5,0.91 c-1.16,0.18-2.43,0.27-3.69,0.27c-16.75,0-28.23-17.2-28.23-33.04c0-15.84,11.48-33.04,28.23-33.04c16.74,0,28.22,17.2,28.22,33.04 c0,10.68-5.25,22.09-13.92,28.24c1.85,3.08,4.48,8.24,9.05,8.24c1.75,0,3.02-0.09,4.38-0.45V-272.62z M-789.77-292.62 c4.38,0,7.79,1.18,11,4.61l1.36,1.45c4.18-4.71,7.01-11.41,7.01-24.17s-2.23-29.42-17.9-29.42c-15.68,0-17.91,16.66-17.91,29.42 s2.23,29.42,17.91,29.42c1.94,0,3.89-0.36,5.55-1.27l-0.59-1.09c-2.63-4.98-4.77-5.34-6.91-6.06L-789.77-292.62z"})}),jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("g",{id:"DIxly4_4_",children:jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{className:"st0",d:"M-863.23,34.64c-2.44-0.46-4.93-0.79-7.32-1.42c-5.12-1.36-9.26-4.16-11.94-8.85 c-2.19-3.83-1.97-7.61,0.37-11.34c1.74-2.78,4.43-3.61,7.45-3.77c5.92-0.3,11.54,1.09,17.04,3.13c3.19,1.18,6.37,2.42,9.6,3.48 c2.51,0.83,2.88,0.56,4.35-1.19c22.41-26.68,44.84-53.35,67.27-80.01c9.1-10.82,18.21-21.65,27.32-32.47 c0.12-0.14,0.24-0.27,0.46-0.51c1.42,1.2,2.82,2.38,4.34,3.66c-2.12,2.61-4.17,5.15-6.23,7.68 c-14.84,18.23-29.69,36.47-44.54,54.7c-14.99,18.41-29.98,36.83-44.97,55.24c-1.78,2.18-3.46,4.45-5.36,6.52 c-2.73,2.98-6.49,3.85-10.26,4.59c-0.98,0.19-1.96,0.37-2.93,0.55C-860.13,34.64-861.68,34.64-863.23,34.64z"}),jsxRuntimeExports.jsx("path",{className:"st0",d:"M-691.46,34.64c-1.32-0.27-2.64-0.57-3.97-0.8c-4.73-0.83-8.47-3.15-11.48-6.96 c-7.1-8.99-14.32-17.9-21.54-26.79c-13.65-16.81-27.33-33.58-41-50.37c-0.14-0.17-0.26-0.36-0.45-0.61 c1.39-1.7,2.77-3.38,4.24-5.18c1.64,1.93,3.21,3.79,4.78,5.65c18.3,21.75,36.62,43.5,54.86,65.29c1.29,1.54,2.56,1.64,4.18,1.04 c3.29-1.2,6.57-2.4,9.85-3.6c4.94-1.8,9.97-3.09,15.28-3.09c6.43,0.01,8.88,1.83,10.75,8.01c0.02,0.08,0.12,0.13,0.18,0.19 c0,1,0,2,0,3c-0.21,0.64-0.4,1.29-0.64,1.91c-2.34,5.89-6.92,9.2-12.8,10.85c-2.38,0.67-4.87,0.97-7.31,1.44 C-688.19,34.64-689.82,34.64-691.46,34.64z"}),jsxRuntimeExports.jsx("path",{className:"st0",d:"M-868.96-181.36c1.19,1.01,2.56,1.87,3.55,3.04c16.29,19.28,32.54,38.61,48.8,57.92 c3.43,4.07,6.97,8.05,10.22,12.26c1.18,1.53,1.68,3.58,2.43,5.42c0.9,2.21,0.87,2.22-0.9,3.74c-0.9,0.77-1.81,1.52-2.72,2.27 c-0.1,0.08-0.24,0.13-0.37,0.2c-1.77-1.12-3.56-2.2-5.3-3.36c-0.67-0.45-1.3-1-1.82-1.61c-19.29-22.89-38.56-45.78-57.84-68.68 c-0.56-0.66-1.07-1.36-1.68-1.98c-3.31-3.34-1.14-7.12,1.69-8.56c0.48-0.24,0.98-0.45,1.47-0.68 C-870.6-181.36-869.78-181.36-868.96-181.36z"}),jsxRuntimeExports.jsx("path",{className:"st0",d:"M-678.36-181.36c0.96,0.57,2.02,1.02,2.87,1.73c2.31,1.93,2.47,4.81,0.53,7.11c-20,23.76-40,47.53-60,71.29 c-0.26,0.31-0.52,0.66-0.85,0.87c-2.02,1.31-4.06,2.58-6.16,3.9c-1.45-1.21-2.9-2.38-4.27-3.62c-0.23-0.21-0.28-0.82-0.17-1.16 c1.21-3.84,3.05-7.24,5.71-10.37c18.84-22.19,37.53-44.5,56.3-66.73c0.99-1.18,2.38-2.02,3.58-3.02 C-679.99-181.36-679.18-181.36-678.36-181.36z"}),jsxRuntimeExports.jsx("path",{className:"st0",d:"M-779.98-73.11c-1.39,1.64-2.7,3.2-4.09,4.85c-7.2-8.84-14.3-17.57-21.47-26.38 c1.49-1.25,2.87-2.41,4.36-3.67C-794.08-89.87-787.04-81.51-779.98-73.11z"})]})}),jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsx("path",{className:"st0",d:"M-968.23-127.84l-11.45-1.24v-6.39h47.32c43.69,0,62.97,31.06,62.97,62.11c0,28.39-19.65,62.11-59.35,62.11 h-50.94v-6.39l11.45-1.24V-127.84z M-949.91-18.17c5.53,0.35,11.06,0.53,16.03,0.53c24.61,0,44.26-11.71,44.26-55.72 c0-44.01-17.17-55.72-44.26-55.72c-6.68,0-11.45,0.18-16.03,0.18V-18.17z"})}),jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsx("path",{className:"st0",d:"M-571.27-2.91c0,4.07-7.42,8.31-15.79,8.31c-12.93,0-19.96-7.96-24.34-20.51c-2.28,0.71-4.55,1.42-6.84,1.77 c-2.28,0.35-4.75,0.53-7.22,0.53c-32.72,0-55.15-33.6-55.15-64.55c0-30.95,22.44-64.55,55.15-64.55c32.7,0,55.14,33.6,55.14,64.55 c0,20.87-10.27,43.15-27.19,55.18c3.61,6.01,8.75,16.09,17.68,16.09c3.42,0,5.9-0.18,8.56-0.89V-2.91z M-628.33-42 c8.56,0,15.22,2.3,21.49,9.01l2.66,2.83c8.18-9.19,13.69-22.28,13.69-47.22s-4.37-57.48-34.98-57.48 c-30.63,0-34.99,32.55-34.99,57.48s4.37,57.48,34.99,57.48c3.79,0,7.6-0.71,10.84-2.48l-1.15-2.12 c-5.14-9.73-9.32-10.43-13.5-11.84L-628.33-42z"})})]}),jsxRuntimeExports.jsx("g",{id:"DIxly4_3_",children:jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{className:"st1",d:"M54.43,214.36c-1.98-0.38-3.99-0.64-5.94-1.15c-4.15-1.1-7.51-3.38-9.68-7.17c-1.77-3.11-1.6-6.17,0.3-9.19 c1.41-2.25,3.59-2.93,6.04-3.05c4.8-0.24,9.36,0.88,13.81,2.54c2.59,0.96,5.16,1.96,7.78,2.82c2.04,0.67,2.33,0.46,3.53-0.96 c18.17-21.63,36.36-43.25,54.54-64.87c7.38-8.78,14.76-17.55,22.15-26.33c0.09-0.11,2-2.59,2.18-2.79 c1.15,0.97,2.38,2.85,3.6,3.88c-1.72,2.12-5.27,5.64-6.94,7.69c-12.04,14.78-24.07,29.57-36.11,44.35 c-12.15,14.93-24.31,29.86-36.46,44.79c-1.44,1.77-2.81,3.61-4.35,5.29c-2.21,2.42-5.26,3.12-8.32,3.72 c-0.79,0.16-1.59,0.3-2.38,0.45C56.94,214.36,55.69,214.36,54.43,214.36z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M193.69,214.36c-1.07-0.22-2.14-0.46-3.22-0.65c-3.84-0.67-6.87-2.56-9.3-5.64 c-5.76-7.29-11.61-14.51-17.46-21.72c-11.06-13.63-22.16-27.23-33.24-40.84c-0.11-0.14-0.21-0.29-0.37-0.5 c1.13-1.38,2.24-2.74,3.43-4.2c1.33,1.57,2.6,3.07,3.87,4.58c14.84,17.64,29.69,35.26,44.48,52.94c1.05,1.25,2.07,1.33,3.39,0.85 c2.66-0.97,5.33-1.94,7.99-2.92c4-1.46,8.09-2.51,12.38-2.5c5.21,0.01,7.2,1.49,8.71,6.5c0.02,0.06,0.1,0.1,0.15,0.16 c0,0.81,0,1.62,0,2.44c-0.17,0.52-0.32,1.04-0.52,1.55c-1.9,4.77-5.61,7.46-10.38,8.8c-1.93,0.54-3.95,0.78-5.93,1.16 C196.35,214.36,195.02,214.36,193.69,214.36z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M49.78,39.23c0.97,0.82,2.08,1.51,2.88,2.47C65.88,57.33,79.05,73,92.23,88.66c2.78,3.3,5.65,6.53,8.29,9.94 c0.95,1.24,1.36,2.9,1.97,4.4c0.73,1.79,0.71,1.8-0.73,3.03c-0.73,0.62-1.47,1.23-2.21,1.84c-0.08,0.07-0.19,0.11-0.3,0.17 c-1.44-0.9-2.89-1.78-4.29-2.72c-0.54-0.36-1.06-0.81-1.48-1.31C77.85,85.45,62.22,66.89,46.59,48.32 c-0.45-0.54-0.87-1.11-1.36-1.6c-2.68-2.71-0.93-5.78,1.37-6.94c0.39-0.2,0.79-0.37,1.19-0.55 C48.46,39.23,49.12,39.23,49.78,39.23z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M204.32,39.23c0.78,0.46,1.64,0.83,2.32,1.41c1.87,1.57,2,3.9,0.43,5.77c-16.21,19.27-32.43,38.53-48.65,57.8 c-0.21,0.25-0.42,0.53-0.69,0.71c-1.64,1.06-3.29,2.09-4.99,3.17c-1.18-0.98-2.35-1.93-3.46-2.94c-0.19-0.17-0.23-0.66-0.14-0.94 c0.98-3.11,2.47-5.87,4.63-8.41c15.27-17.99,30.42-36.08,45.65-54.1c0.81-0.95,1.93-1.64,2.9-2.45 C202.99,39.23,203.66,39.23,204.32,39.23z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M121.93,127c-1.13,1.33-2.19,2.59-3.32,3.93c-5.83-7.17-13.54-15.74-19.35-22.89c1.2-1.01,2.48-2.53,3.7-3.55 C108.71,111.33,116.2,120.19,121.93,127z"})]})})]});const TennisRackets=({elClass:s,fillColor:a})=>jsxRuntimeExports.jsx("svg",{className:s,viewBox:"0 0 338.72 229.53",fill:a,xmlns:"http://www.w3.org/2000/svg",children:jsxRuntimeExports.jsxs("g",{id:"d9ZjTm",children:[jsxRuntimeExports.jsx("g",{id:"d9ZjTm-2","data-name":"d9ZjTm",children:jsxRuntimeExports.jsx("path",{d:"m283.55.18c-12.5,1.54-23.09,5.38-32.56,12.09-4.98,3.53-9.05,8.08-13.33,12.4-13.51,13.61-21.94,30.05-26.75,48.43-2.13,8.14-3.54,16.48-5.78,24.59-3.77,13.62-7.92,27.13-11.95,40.67-.81,2.73-2.45,4.98-4.4,7.06-6.13,6.53-12.14,13.17-18.28,19.69-7.01,7.46-14.11,14.84-21.16,22.26-7.16,7.54-14.27,15.13-21.48,22.61-1.48,1.53-3.31,2.73-5.01,4.05-.53.42-1.16.71-1.71,1.11-2.79,2-3.33,4.86-1.16,7.48,2.11,2.55,4.46,4.93,7.54,6.36,2.56,1.19,4.56.45,5.64-2.15,1.25-2.99,3.38-5.32,5.53-7.63,5.82-6.27,11.67-12.52,17.55-18.74,12.28-12.99,24.58-25.95,36.89-38.92,2.45-2.58,4.98-5.07,7.43-7.64,2.02-2.12,4.58-3.3,7.25-4.3,17.07-6.39,34.26-12.37,51.74-17.55,10.85-3.22,21.64-6.63,31.62-12.19,5.79-3.23,11.06-7.13,16.16-11.32,6.54-5.38,12.49-11.4,17.71-18.02,8.27-10.47,12.72-22.53,13.53-35.87.38-6.34.18-12.65-1.85-18.74-2.44-7.33-6.11-13.91-11.62-19.46-4.4-4.43-9.12-8.35-14.74-11.15-8.79-4.38-18.08-5.83-26.8-5.09Zm-34.58,126.73c-1.5.15-3.01.37-4.51.45-5.83.28-11.21-1.26-16.23-4.17-3.2-1.85-6.21-3.99-8.41-6.99-3.31-4.54-4.97-9.6-5.46-15.32-.74-8.67.23-17.12,2.39-25.38,2.73-10.38,6.84-20.33,12.44-29.5,6.86-11.24,14.77-21.66,26.05-28.98,2.57-1.67,5.15-3.31,7.79-4.87,3.63-2.15,7.67-3.25,11.64-4.58,6.27-2.11,12.56-2.96,19.05-1.64,5.07,1.03,10.22,1.78,14.8,4.53,5.02,3.01,9.77,6.22,13.62,10.79,4.39,5.22,7.19,11.21,9.47,17.49,2.41,6.64,1.89,13.56.68,20.27-1.76,9.72-5.3,18.79-11.5,26.7-7.82,9.96-16.71,18.67-27.76,25-2.97,1.7-5.89,3.5-8.9,5.14-10.99,5.99-22.84,9.28-35.17,11.06Zm-45.01,16.56c-2.74.4-4.2-1.52-3.46-4.17,2.62-9.42,5.27-18.84,7.92-28.25.14-.5.23-1.09.56-1.43.38-.38,1.01-.72,1.51-.69.42.03.97.53,1.18.96.98,2.04,1.76,4.18,2.8,6.18,2.71,5.24,7.25,8.64,12.16,11.59,2.15,1.29,4.33,2.55,6.96,2.71.95.05,1.33,1.49.63,2.3-.34.4-.88.69-1.38.86-8.67,3-17.35,5.97-26.02,8.94-1.05.36-2.1.73-2.85.99Z"})}),jsxRuntimeExports.jsx("g",{id:"d9ZjTm-3","data-name":"d9ZjTm",children:jsxRuntimeExports.jsx("g",{id:"d9ZjTm-4","data-name":"d9ZjTm",children:jsxRuntimeExports.jsx("path",{d:"m53.41,2.16c12.54,1.09,23.27,4.55,32.97,10.92,5.11,3.35,9.34,7.76,13.77,11.91,13.98,13.12,22.99,29.25,28.46,47.45,2.42,8.06,4.12,16.34,6.65,24.37,4.25,13.47,8.88,26.83,13.39,40.22.91,2.7,2.62,4.89,4.65,6.89,6.36,6.31,12.61,12.72,18.97,19.03,7.27,7.2,14.63,14.32,21.94,21.49,7.42,7.28,14.8,14.61,22.28,21.83,1.53,1.48,3.41,2.61,5.15,3.87.55.4,1.18.67,1.75,1.04,2.86,1.9,3.5,4.74,1.42,7.43-2.02,2.62-4.28,5.08-7.31,6.63-2.52,1.28-4.54.61-5.72-1.95-1.35-2.95-3.57-5.2-5.79-7.43-6.04-6.06-12.11-12.1-18.2-18.11-12.73-12.54-25.49-25.06-38.25-37.58-2.54-2.49-5.16-4.89-7.7-7.37-2.1-2.05-4.7-3.14-7.4-4.04-17.28-5.78-34.68-11.14-52.33-15.7-10.96-2.83-21.87-5.86-32.03-11.06-5.9-3.02-11.31-6.73-16.55-10.74-6.72-5.15-12.89-10.94-18.35-17.37C6.54,83.73,1.65,71.84.37,58.53c-.61-6.32-.63-12.63,1.18-18.8,2.18-7.41,5.61-14.12,10.92-19.86,4.24-4.59,8.81-8.67,14.33-11.67,8.63-4.69,17.86-6.47,26.61-6.04Zm39.08,125.42c1.51.1,3.02.27,4.53.29,5.84.08,11.16-1.66,16.07-4.74,3.13-1.97,6.07-4.2,8.15-7.29,3.15-4.66,4.63-9.77,4.91-15.5.43-8.69-.84-17.1-3.3-25.28-3.09-10.28-7.56-20.07-13.48-29.04-7.26-10.99-15.53-21.12-27.07-28.03-2.63-1.57-5.27-3.12-7.96-4.59-3.71-2.02-7.78-2.97-11.8-4.17-6.34-1.88-12.66-2.51-19.1-.96-5.03,1.21-10.15,2.14-14.63,5.06-4.91,3.19-9.55,6.56-13.23,11.27-4.2,5.37-6.79,11.46-8.84,17.82-2.17,6.72-1.41,13.62.04,20.28,2.1,9.65,5.96,18.59,12.45,26.27,8.17,9.67,17.36,18.06,28.64,24,3.03,1.6,6.01,3.29,9.08,4.82,11.2,5.6,23.16,8.46,35.54,9.8Zm45.57,14.94c2.76.3,4.14-1.67,3.31-4.29-2.96-9.32-5.94-18.64-8.92-27.95-.16-.49-.27-1.09-.61-1.41-.39-.37-1.04-.68-1.53-.64-.42.04-.95.56-1.14,1-.91,2.07-1.61,4.24-2.58,6.28-2.53,5.34-6.94,8.89-11.74,12.01-2.1,1.37-4.23,2.71-6.86,2.95-.94.09-1.28,1.53-.55,2.32.35.38.9.66,1.41.81,8.77,2.69,17.55,5.34,26.32,8.01,1.06.32,2.12.66,2.88.89Z"})})})]})});const PickleballPaddles=({elClass:C,fillColor:s})=>jsxRuntimeExports.jsx("svg",{className:C,xmlns:"http://www.w3.org/2000/svg",fill:s,viewBox:"0 0 338.7 229.5",children:jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsx("path",{d:"M147.2,216.7c-1-0.7-2.2-1.4-3-2.2c-3.8-3.7-7.4-7.3-11.2-11.1c-1.8-1.8-1.8-4.2-0.1-6c1-1.1,1.9-2.3,2.9-3.3 c1.4-1.3,2.9-2.4,4.4-3.6c1.9-1.4,3.9-2.7,5.5-4.3c2.4-2.2,4.6-4.7,6.9-7c-0.3-0.3-0.5-0.6-0.7-0.8c-1.7-1.7-3.4-3.3-4.9-4.9 c-0.9-0.9-1.8-1.5-3.2-1.5c-2.1,0-3.7-1.4-5.1-2.8c-3.9-3.6-8.2-5.8-13.5-6.5c-4.9-0.7-9.7-0.5-14.5,0.7 c-4.9,1.2-9.6,2.9-14.5,4.1c-12.5,3.2-23.8,0.6-33.2-8.4c-8.9-8.5-17.4-17.3-26-26.1c-8.8-9-17.5-18.1-26.4-27 c-4.4-4.4-6.9-9.5-8.1-15.3C2.2,88.8,2,87,1.7,85.1c0-1.8,0-3.6,0-5.2c0.3-1.5,0.5-3,0.8-4.5c1.5-6.5,4.8-12,9.4-16.7 c9.2-9.3,18.5-18.5,27.7-27.7c3.7-3.7,7.2-7.2,11-10.8c6.8-6.3,14.8-9.9,24.4-9.7c9.3,0.2,17.4,3.3,24.2,10.1 c16.7,17,33.6,33.9,50.4,50.8c7.2,7.3,10.9,16,10.5,26.4c-0.2,4.8-1.6,9.2-2.8,13.7c-1.3,4.9-2.8,10-3.7,15 c-1.2,6.8,0.4,13.3,4.3,19c0.3,0.5,0.7,0.9,1.2,1.3c2.3,1.9,3.5,4.4,3.9,7.2c0.1,0.6,0.3,1.3,0.7,1.7c1.9,2.2,3.9,4.3,5.8,6.4 c2-2.2,4-4.4,5.9-6.5c0.4-0.5,0.5-1.2,0.6-1.8c0.5-2.8,1.7-5,3.8-6.9c2.1-1.9,3.1-4.4,4.1-6.8c2.3-5.7,2.3-11.6,0.8-17.5 c-1.5-5.9-3.3-11.7-4.8-17.6c-3-12.3-0.2-23.3,8.4-32.4c7.3-7.7,14.9-15.1,22.5-22.8c9.8-9.9,19.6-19.7,29.4-29.6 c5.7-5.8,12.8-8.7,20.8-9.5c10.9-1.1,20.2,2.6,27.9,10.1c12.4,12.2,24.7,24.5,37,36.6c4.3,4.3,7.6,9,9.6,14.7 c1.4,4.1,1.9,8.3,1.6,12.6c-0.4,5-1.5,9.9-3.9,14.4c-1,2-2.3,3.9-3.9,5.4c-17.4,17.9-35,35.6-52.5,53.6 c-7.4,7.6-16.4,10.9-26.7,10.9c-4.3,0-8.3-1.3-12.3-2.6c-5.3-1.7-10.8-3.4-16.4-3.7c-6.8-0.4-13.5,0.5-19.2,4.9 c-1,0.8-2,1.7-3,2.6c-1.6,1.4-3.3,2.4-5.4,2.3c-0.4,0-1,0.3-1.3,0.6c-2.2,2.2-4.3,4.4-6.5,6.6c2.5,2.5,4.9,5,7.5,7.5 c1.6,1.5,3.6,2.6,5.3,4c1.3,1,2.6,2.1,3.9,3.3c1,1,1.8,2.1,2.8,3.1c2,2.2,1.9,4.4-0.2,6.4c-3.7,3.7-7.2,7.2-11,10.8 c-0.9,0.9-2,1.5-3,2.2c-0.6,0-1.2,0-1.9,0c-0.5-0.3-1.2-0.5-1.6-0.9c-2.4-2.5-5-4.9-7.1-7.6c-1.6-2.1-3.1-4.2-4.9-5.9 c-1.9-1.9-3.8-3.8-5.6-5.5c-0.3-0.3-0.6-0.6-1-0.9c-2.8,2.9-5.5,5.5-8.2,8.3c-0.9,1-1.7,2.1-2.5,3.2c-2.5,3.8-5.5,7-9.4,9.6 C148.4,216.7,147.8,216.7,147.2,216.7z M8.7,82.4c0.1,1.3,0.2,2.7,0.4,4c0.9,6.9,3.6,13.1,8.6,18c3.9,3.9,7.7,7.8,11.6,11.8 c11.9,12.1,23.8,24.2,35.6,36.2c5.6,5.7,12.5,8.5,20.4,8.9c4.3,0.2,8.3-0.9,12.4-2.1c7.5-2.3,15.1-4.2,23.1-3.6 c2.2,0.2,4.6,0.5,6.5,1.3c2.8,1.1,5.3,2.7,8,4.2c0.5,0.3,0.9,0.4,1.4-0.1c0.9-0.9,2-1.6,2.9-2.4c4.1-3.4,7.7-7,11.2-11 c0.8-0.9,0.7-1.6,0-2.4c-0.5-0.6-1.1-1.1-1.5-1.8c-3.6-6-4.9-12.7-3.6-19.5c1.1-6.1,2.7-12.3,4.2-18.3c1.2-4.7,1.8-9.3,1.2-14.1 c-0.9-7.1-4.2-12.9-9.1-17.9C125.8,57.4,109.7,41,93.5,24.6c-1.3-1.3-2.8-2.5-4.3-3.4c-4.5-2.8-9.4-3.8-14.6-3.9 c-6.6-0.2-12.7,1.5-17.9,5.5c-3.6,2.8-6.7,6-9.9,9.2c-9.8,9.8-19.6,19.6-29.4,29.5C12,67.3,8.7,74.2,8.7,82.4z M264.4,17.3 c-0.7,0-1.4,0-2.1,0c-0.7,0-1.4,0.1-2.1,0.2c-6.2,0.7-11.7,3-16.1,7.5c-11,11.3-22.1,22.5-33.2,33.7 c-5.6,5.7-11.4,11.3-16.7,17.2c-6.3,6.9-8.3,15.2-6.9,24.4c0.7,4.6,2.1,8.9,3.1,13.5c1.1,4.8,2.5,9.5,2.5,14.4 c0,6.2-1.3,12.1-5.4,17c-0.9,1.1-0.9,1.7,0.1,2.7c4.1,4.5,8.2,8.8,13.1,12.5c1.6,1.2,1.5,1.2,3.3,0.2c2.1-1.2,4.1-2.5,6.2-3.4 c5.1-2.2,10.6-2.1,15.9-1.2c5,0.8,10,2.1,14.9,3.5c5.3,1.5,10.6,2.5,16.1,1.5c5.5-1,10.6-3.2,14.8-7.1c4.6-4.5,9-9,13.6-13.6 c11.9-12.1,23.9-24.1,35.5-36.2c7.4-7.8,9.7-17.2,7.7-27.7c-1.2-6-4.5-10.9-8.7-15.1c-9.2-9.2-18.4-18.4-27.5-27.7 c-3.9-4-7.9-7.6-12.3-11.1c-0.7-0.6-1.5-1.2-2.4-1.6C273.7,18.3,269.2,17.2,264.4,17.3z"})})})})});const Duck=({elClass:s,fillColor:a})=>jsxRuntimeExports.jsx("svg",{id:"duck",className:s,viewBox:"0 0 792 612",fill:a,xmlns:"http://www.w3.org/2000/svg",children:jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{className:"st0",d:"M241.54,414.88c0.26-0.03,0.52-0.07,0.78-0.07c0.26,0.23,0.56,0.49,0.82,0.72c0.69,0.46,1.37,0.95,2.06,1.4    c5.78,5.88,11.36,11.98,17.47,17.53c2.94,2.68,6.82,4.34,10.42,6.2c0.69,0.36,2.02-0.52,3.07-0.82c3.33,2.97,7.09,4.47,11.66,3.98    c2.55-0.29,5.16-0.03,7.74-0.03c1.04-0.26,2.09-0.56,3.13-0.82c5.26-1.04,10.87-1.24,15.64-3.36c7.58-3.33,13.09-9.57,18.35-15.93    c7.15-8.65,17.53-10.58,25.66-1.24c3.33,3.82,6.14,8.26,10.06,11.3c6.5,5.03,13.55,9.11,22.14,10.38    c16.65,2.48,30.5-2.22,41.79-14.63c2.61-2.87,5.13-5.88,7.9-8.62c6.5-6.43,17.57-5.91,23.67,0.98c0.49,0.52,0.98,1.08,1.47,1.6    c0.82,1.31,1.6,2.58,2.42,3.89c0.75,0.78,1.53,1.57,2.29,2.38c3.82,3.07,7.48,6.43,11.56,9.14c2.38,1.57,5.81,1.63,8.2,3.2    c5.52,3.62,11.49,2.19,17.34,2.42c1.53,0.07,3.17-0.85,4.57-0.56c3.46,0.78,6.37,0.56,8.52-2.58c2.16,0.72,4.05,0.42,6.01-0.91    c10.09-6.86,18.25-15.71,26.15-24.85c3.33,0.56,6.69,1.08,10.02,1.63c0.52,0.26,1.04,0.52,1.57,0.78    c3.95,4.28,7.87,8.59,11.82,12.83c7.18,7.74,16.13,11.89,26.58,12.96c0.26,0.26,0.52,0.49,0.78,0.75c1.8,0.26,3.56,0.69,5.35,0.72    c3.07,0.07,6.37,0.69,8.72-2.22c0.33,0.46,0.65,0.91,1.01,1.37c0.46-0.46,0.91-0.91,1.34-1.37c7.22-0.42,12.83-4.57,18.71-8.13    c4.24-2.58,8.46-2.94,11.23-0.75c4.77,3.75,5.22,10.74,0.72,15.31c-5.71,5.78-13.16,8.52-20.47,11.62    c-9.66,4.11-19.85,3.92-29.58,2.68c-11.79-1.53-23.18-5.62-32.26-14.17c-2.35-2.22-4.6-4.54-6.92-6.76    c-2.94-2.81-6.17-2.38-9.93,0.91c-4.08,3.59-8.1,7.38-12.6,10.35c-9.8,6.5-20.6,10.25-32.52,9.96    c-5.98-0.16-11.92-0.52-17.86-0.78c-0.26-0.26-0.52-0.49-0.78-0.75c-8.78-2.12-16.59-6.24-23.61-11.82    c-3.72-2.97-7.25-6.2-10.87-9.31c-0.26-0.26-0.52-0.49-0.78-0.75c-2.16,0.98-4.54,1.63-6.43,3c-6.37,4.64-12.15,10.25-18.97,14.11    c-7.74,4.41-16.36,6.86-25.66,6.43c-5.68-0.26-11.36,0.39-17.08,0.65c-0.2-0.39-0.42-0.78-0.62-1.18    c-0.33,0.42-0.62,0.82-0.95,1.24c-5.13-2.71-10.51-5.03-15.31-8.23c-6.04-4.02-11.59-8.72-17.37-13.09    c-3.98-3.04-6.99-3.07-10.29,0.59c-8.55,9.53-19.07,15.51-31.41,18.51c-10.35,2.51-20.64,2.12-30.99-0.13    c-11.17-2.42-20.28-8.42-28.7-15.77c-1.14-1.01-1.99-2.35-3.04-3.49c-3.3-3.53-6.04-3.53-9.08,0.13    c-9.4,11.33-21.84,18.29-35.92,20.21c-11.59,1.6-23.93,2.35-35.33-3.17c-3.43-1.67-7.28-2.45-10.91-3.72    c-3.36-1.14-5.88-5.26-5.78-9.27c0.1-4.18,2.61-8.39,6.27-8.91c3.46-0.49,7.18-0.33,10.61,0.39c5.55,1.21,10.55,3.82,16.52,4.6    c7.44,0.95,14.3,1.24,21.26-1.24c8.82-3.13,15.77-8.78,21.55-16.06c3.56-4.44,7.31-8.85,13.06-10.68c0.52,0,1.04,0,1.57-0.03    c0.52,0,1.01,0.03,1.53,0.03C240.98,415.33,241.24,415.11,241.54,414.88z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M552.48,415.56c-7.9,9.14-16.06,17.99-26.15,24.85c-1.96,1.34-3.85,1.63-6.01,0.91    c2.97-3.62,6.27-7.09,8.88-10.97c3.98-5.88,7.58-12.05,11.17-18.19c0.72-1.24,0.52-3,1.01-4.41c0.62-1.7,1.63-3.23,2.25-4.93    c0.46-1.18,0.42-2.48,0.85-3.66c1.4-3.89,3.92-7.71,4.05-11.59c0.13-4.21,0.88-7.67,3.1-10.84c6.95-22.79,9.4-46.27,10.91-69.88    c0.2-0.52,0.39-1.08,0.59-1.6c0.07-5.32,0.59-10.68,0.1-15.93c-0.65-7.25-2.02-14.4-3.07-21.62c-0.46-0.95-0.88-1.93-1.34-2.87    c-0.16-0.62-0.29-1.21-0.46-1.83c-0.95-1.4-1.89-2.81-3.2-4.73c-1.21,1.73-1.99,2.84-2.74,3.95c-1.14,1.53-2.32,3.07-3.46,4.57    c-2.32,2.02-4.64,4.08-6.92,6.11c-2.32,1.11-4.64,2.22-6.95,3.3c-0.78,0.26-1.57,0.52-2.35,0.78c-8,1.08-15.93,2.55-23.97,3.13    c-6.5,0.49-13.06,0.07-19.62-0.16c-3.33-0.13-6.69-0.56-9.99-1.04c-5.62-0.82-11.23-1.76-16.82-2.64    c-0.78-0.23-1.57-0.49-2.35-0.72c-6.24-1.34-12.51-2.68-18.74-4.02c-0.52-0.2-1.08-0.39-1.6-0.59c-3.92-0.85-7.8-1.7-11.72-2.51    c-0.52-0.2-1.08-0.39-1.6-0.59c-1.8-0.39-3.56-0.78-5.35-1.18c-0.82-0.13-1.63-0.29-2.48-0.42c-1.04-0.07-2.06-0.1-3.1-0.16    c-0.52-0.2-1.08-0.39-1.6-0.62c-2.81-0.29-5.58-0.82-8.39-0.85c-8.33-0.1-16.69-0.29-24.98,0.07c-4.54,0.2-8.1-0.78-10.61-4.67    c-0.2-1.08-0.36-2.16-0.56-3.27c0.07-6.63,0.29-13.26,0.2-19.88c-0.13-9.11-1.08-18.12-5.81-26.25c-0.78-1.57-1.6-3.13-2.38-4.7    c-2.58-3.95-5.16-7.87-7.71-11.82c0-0.26-0.07-0.49-0.2-0.72c-3.33-3.43-6.66-6.82-9.99-10.25c-1.08-1.01-2.16-2.02-3.23-3    c-2.84-2.09-5.68-4.18-8.55-6.3c-0.46-0.29-0.91-0.59-1.37-0.88c-1.11-0.72-2.22-1.4-3.33-2.12c-2.84-1.4-5.68-2.81-8.55-4.21    c-2.61-0.98-5.16-2.16-7.87-2.84c-12.54-3.2-25.14-5.81-38.24-4.08c-1.67,0.23-3.46-0.52-5.19-0.85c0.1,0.16,0.23,0.29,0.33,0.46    c-5.22,1.5-10.45,3-15.67,4.47c-0.49,0.29-0.98,0.59-1.47,0.88c-3.23,1.96-6.47,3.95-9.7,5.91c-0.46,0.29-0.91,0.56-1.37,0.85    c-2.09,1.57-4.15,3.17-6.24,4.73c-1.04,0.75-2.12,1.47-3.17,2.22c-2.61,2.61-5.22,5.22-7.87,7.87c-1.04,1.04-2.06,2.12-3.1,3.17    c-0.98,1.04-1.96,2.12-2.94,3.17c-2.48,3.46-4.96,6.92-7.48,10.38c-0.75,0.95-1.5,1.93-2.22,2.87c-1.47-0.39-3.07-0.52-4.38-1.21    c-1.76-0.98-3.27-2.38-4.87-3.62c-0.03-0.56-0.07-1.08-0.1-1.63c4.47-5.98,8.95-11.95,13.42-17.89c0.26-0.23,0.52-0.42,0.78-0.65    l0,0c0.72-0.52,1.47-1.04,2.19-1.57c2.16-2.35,4.28-4.67,6.43-7.02c0.46-0.52,0.91-1.04,1.34-1.57    c4.83-3.56,9.47-7.41,14.56-10.61c4.34-2.74,9.04-5.06,13.88-6.89c5.06-1.89,10.42-2.97,15.64-4.41c1.67-0.46,3.3-1.04,5.29-1.67    c2.97,0.26,6.5,0.59,10.02,0.88c6.01,0.49,12.02,1.01,18.02,1.44c9.21,0.65,17.73,3.85,26.25,7.02c0.49,0.52,1.01,1.04,1.5,1.57    c2.32,1.11,4.64,2.19,6.99,3.3c0.26,0.2,0.56,0.42,0.82,0.62c1.27,0.56,2.55,1.11,3.82,1.7c0.29,0.2,0.59,0.39,0.88,0.59    c0.49,0.33,0.98,0.65,1.47,0.98c0.29,0.2,0.59,0.39,0.88,0.59c8.88,5.55,16.2,12.7,22.14,21.32c0.46,0.52,0.91,1.08,1.37,1.6    c3.75,5.13,7.77,10.12,9.53,16.39c0.75,1.27,1.5,2.55,2.22,3.82c5.39,14.04,5.03,28.7,4.54,43.82c6.79,0,13.26,0,19.72,0    c1.73,0,3.46-0.13,5.16,0.1c8.39,1.01,16.85,1.63,25.11,3.27s16.26,4.51,24.49,6.4c8.49,1.96,17.01,3.95,25.63,5.03    c8.95,1.11,18.06,1.8,27.07,1.53c8.36-0.26,16.75-1.24,24.62-5.06c4.8-2.35,8.1-5.84,11.04-9.96c5.06-7.05,13.39-9.5,20.24-4.44    c4.02,2.94,6.27,8.26,7.35,13.55c0.85,4.11,2.35,8.2,2.58,12.34c0.56,9.53,0.59,19.1,0.65,28.67c0.03,5.39,0.03,10.78-0.46,16.13    c-0.42,4.64-1.53,9.21-2.45,13.78c-0.46,2.29-1.73,4.57-1.63,6.79c0.29,7.44-0.33,14.73-2.68,21.84c-0.72,2.16-0.52,4.6-1.21,6.79    c-1.5,4.9-3.46,9.7-4.87,14.63c-1.14,3.98-1.73,8.13-2.61,12.18c-0.07,0.36-0.49,0.65-0.59,1.01    C556.07,403.38,554.28,409.46,552.48,415.56z M203.37,196.99c-0.23,0.42-0.46,0.88-0.69,1.31c1.24,0.65,2.51,1.27,3.75,1.93    c0.2-0.33,0.39-0.69,0.59-1.01C205.82,198.49,204.58,197.74,203.37,196.99z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M276.18,439.82c-1.04,0.29-2.38,1.18-3.07,0.82c-3.59-1.86-7.48-3.53-10.42-6.2    c-6.11-5.55-11.69-11.66-17.47-17.53c-0.69-0.46-1.37-0.95-2.06-1.4c-0.26-0.23-0.56-0.49-0.82-0.72    c-1.18-3.43-2.55-6.82-3.43-10.32c-1.14-4.44-1.76-9.01-2.78-13.49c-2.32-10.25-2.94-20.64-2.29-31.05    c0.42-7.02,1.6-13.98,2.45-20.93c0.52-0.95,1.18-1.83,1.53-2.81c2.06-5.35,4.05-10.78,6.07-16.16c0.49-0.49,0.98-1.01,1.47-1.5    c1.93-2.84,3.89-5.71,5.81-8.55c0.29-0.16,0.59-0.33,0.88-0.49c-0.36-0.1-0.69-0.23-1.04-0.33c-5.52-3.36-11.07-6.76-16.59-10.12    c-0.75-0.75-1.5-1.5-2.25-2.25c-1.18-1.08-2.35-2.12-3.53-3.2c-1.18-1.14-2.38-2.32-3.56-3.46c-1.27-1.24-2.55-2.48-3.82-3.72    c-0.59-0.59-1.18-1.18-1.8-1.73c0-0.29-0.16-0.46-0.46-0.52c-0.59-0.75-1.18-1.5-1.73-2.25c-0.78-1.24-1.63-2.42-2.32-3.69    c-1.86-3.56-4.41-6.89-3.95-11.23c3.17-1.14,6.3-2.32,9.47-3.46c2.06,3.75,4.15,7.51,6.2,11.26c0.56,0.59,1.14,1.18,1.7,1.76    c3.4,3.56,6.82,7.12,10.22,10.68c0.98,0.82,1.96,1.63,2.94,2.48c0.59,0.49,1.21,0.95,1.8,1.44c0.72,0.52,1.44,1.08,2.16,1.6l0,0    c1.31,0.78,2.61,1.57,3.89,2.35c2.06,1.04,4.15,2.12,6.2,3.17c0.26,0.13,0.52,0.29,0.78,0.42c3.46,2.19,6.92,4.38,10.38,6.56    c-0.82,2.02-1.6,4.02-2.42,6.04c-0.46,1.14-0.95,2.25-1.4,3.36c-0.56,0.91-1.14,1.83-1.7,2.74c-1.04,1.18-2.06,2.35-3.1,3.53    c-0.33,0.49-0.62,1.01-0.95,1.5c-1.83,2.87-3.66,5.75-5.45,8.62c-0.2,0.26-0.42,0.52-0.62,0.78c-0.85,3.36-1.7,6.76-2.51,10.12    c-0.2,0.29-0.39,0.56-0.59,0.85c-0.29,1.57-0.59,3.13-0.85,4.7c-3.04,11.92-3.04,23.93-0.52,35.92c1.04,5.03,2.84,9.93,4.31,14.89    c1.14,3.92,2.32,7.84,3.46,11.79c0.85,1.6,1.7,3.2,2.55,4.8c0.85,1.34,1.7,2.68,2.51,4.05c0.82,1.24,1.63,2.45,2.48,3.69    c4.15,5,8.33,9.96,12.47,14.95c0.56,0.49,1.11,0.98,1.67,1.44C276.08,439.27,276.15,439.56,276.18,439.82z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M220.45,263.5c-3.17,1.14-6.3,2.32-9.47,3.46c-0.26,0.07-0.52,0.13-0.82,0.2c-0.23-0.13-0.46-0.16-0.69-0.1    c-0.52,0-1.08,0.03-1.6,0.03c-7.51-0.33-15.05-0.42-22.56-1.01c-10.84-0.85-20.11-5.29-28.21-12.6    c-7.51-6.79-13.13-15.25-16.2-24.39c-2.81-8.33-3.98-17.93,1.93-26.32c3.2-4.54,5.71-5.49,11.36-4.15    c2.51,0.59,5.03,1.14,7.54,1.7c0.49,0.26,1.01,0.52,1.5,0.78c9.14,0.29,18.29,0.62,27.46,0.82c1.63,0.03,3.27-0.52,4.9-0.78    c0.42-0.03,0.88-0.07,1.31-0.1c1.6,1.24,3.13,2.64,4.87,3.62c1.27,0.72,2.91,0.85,4.38,1.21c0.85,1.83,1.7,3.66,2.55,5.49    c1.27,1.08,2.55,2.16,3.82,3.23c5.26,7.51,9.66,15.38,9.6,24.95C221.59,247.54,221,255.5,220.45,263.5z M192.95,211.26    c-9.47-0.23-18.97-0.23-28.44-0.75c-4.08-0.23-8.1-1.6-12.18-2.22c-2.64-0.39-4.83,0.56-4.77,3.66c0.1,4.18,0.16,8.42,0.88,12.54    c1.24,7.09,4.8,13.45,9.6,18.48c14.07,14.66,32.16,16.55,51.13,14.4c1.21-0.13,3.1-2.02,3.2-3.23c0.46-5.65,1.08-11.46,0.33-17.01    c-0.56-4.31-2.32-8.91-4.87-12.44c-3.53-4.9-8.29-8.95-12.51-13.35c-0.33-0.46-0.69-0.88-1.01-1.34    C193.9,210.38,193.44,210.8,192.95,211.26z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M376.23,208.97c-0.75-1.27-1.5-2.55-2.22-3.82C374.73,206.4,375.48,207.67,376.23,208.97z"}),jsxRuntimeExports.jsx("path",{className:"st4",d:"M619.68,442.99c-0.46,0.46-0.91,0.91-1.34,1.37c-0.33-0.46-0.65-0.91-1.01-1.37    C618.11,443.02,618.9,442.99,619.68,442.99z"}),jsxRuntimeExports.jsx("path",{className:"st5",d:"M382.46,464.87c0.33-0.42,0.62-0.82,0.95-1.24c0.2,0.39,0.42,0.78,0.62,1.18    C383.51,464.8,382.99,464.84,382.46,464.87z"}),jsxRuntimeExports.jsx("path",{className:"st6",d:"M196.94,201.04c-0.42,0.03-0.88,0.07-1.31,0.1c0.39-0.56,0.82-1.14,1.21-1.7    C196.87,199.96,196.9,200.52,196.94,201.04z"}),jsxRuntimeExports.jsx("path",{className:"st7",d:"M241.54,414.88c-0.26,0.23-0.52,0.46-0.82,0.69C240.98,415.33,241.24,415.11,241.54,414.88z"}),jsxRuntimeExports.jsx("path",{className:"st4",d:"M452.14,440.61c0.26,0.26,0.52,0.49,0.78,0.75C452.67,441.1,452.4,440.84,452.14,440.61z"}),jsxRuntimeExports.jsx("path",{className:"st4",d:"M603.26,444.49c-0.26-0.26-0.52-0.49-0.78-0.75C602.73,444,602.99,444.26,603.26,444.49z"}),jsxRuntimeExports.jsx("path",{className:"st0",d:"M487.37,462.52c0.26,0.26,0.52,0.49,0.78,0.75C487.9,463.01,487.64,462.75,487.37,462.52z"}),jsxRuntimeExports.jsx("path",{className:"st8",d:"M295.58,443.74c1.04-0.26,2.09-0.56,3.13-0.82C297.67,443.19,296.62,443.48,295.58,443.74z"}),jsxRuntimeExports.jsx("path",{className:"st7",d:"M243.14,415.5c0.69,0.46,1.37,0.95,2.06,1.4C244.51,416.45,243.82,415.99,243.14,415.5z"}),jsxRuntimeExports.jsx("path",{className:"st6",d:"M203.37,196.99c1.21,0.75,2.45,1.47,3.66,2.22c-0.2,0.33-0.39,0.69-0.59,1.01c-1.24-0.65-2.51-1.27-3.75-1.93    C202.91,197.87,203.14,197.45,203.37,196.99z"}),jsxRuntimeExports.jsx("path",{className:"st9",d:"M369.79,260.01c-1.76-0.82-3.27-1.67-0.56-3.27C369.4,257.85,369.6,258.93,369.79,260.01z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M266.75,305.27c0.39,1.14,1.47,2.71,1.08,3.36c-1.34,2.19-3.23,4.05-4.9,6.04c0.46-1.11,0.95-2.25,1.4-3.36    C265.15,309.28,265.93,307.26,266.75,305.27z"}),jsxRuntimeExports.jsx("path",{className:"st10",d:"M228.61,293.61c-1.18-1.14-2.38-2.32-3.56-3.46C226.22,291.29,227.4,292.43,228.61,293.61z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M261.23,317.41c-1.04,1.18-2.06,2.35-3.1,3.53C259.14,319.76,260.18,318.59,261.23,317.41z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M245.49,292.73c1.31,0.78,2.61,1.57,3.89,2.35C248.07,294.29,246.8,293.51,245.49,292.73z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M238.6,287.21c0.98,0.82,1.96,1.63,2.94,2.48C240.56,288.84,239.58,288.03,238.6,287.21z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M234.39,299.03c-0.75-0.75-1.5-1.5-2.25-2.25C232.89,297.53,233.64,298.28,234.39,299.03z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M243.3,291.13c0.72,0.52,1.44,1.08,2.16,1.6C244.74,292.17,244.02,291.65,243.3,291.13z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M218.98,284.17c-0.59-0.75-1.18-1.5-1.73-2.25C217.8,282.67,218.39,283.42,218.98,284.17z"}),jsxRuntimeExports.jsx("path",{className:"st11",d:"M251.11,309.97c-0.03-0.26-0.1-0.56-0.13-0.82c0.36,0.1,0.69,0.23,1.04,0.33    C251.73,309.64,251.4,309.8,251.11,309.97z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M255.58,298.25c0.26,0.13,0.52,0.29,0.78,0.42C256.1,298.54,255.84,298.38,255.58,298.25z"}),jsxRuntimeExports.jsx("path",{className:"st12",d:"M195.4,211.29c-0.82,0-1.63,0-2.42-0.03c0.46-0.42,0.95-0.88,1.4-1.31    C194.72,210.38,195.04,210.84,195.4,211.29z"}),jsxRuntimeExports.jsx("path",{className:"st13",d:"M495.11,359.6c1.5,2.84,3.04,5.68,4.47,8.55c1.63,3.23,0.03,12.6-2.61,15.48c-1.4,1.53-2.91,2.94-4.34,4.44    c-0.26,0-0.42,0.1-0.56,0.33c-0.88,0.65-1.73,1.34-2.61,1.99c-1.99,1.34-4.02,2.71-6.01,4.05c-4.47,2.58-8.75,5.49-13.42,7.58    c-4.21,1.89-8.78,2.91-13.22,4.28c-0.29,0.2-0.59,0.39-0.85,0.62c-6.11,1.31-12.28,2.42-18.29,4.02    c-6.66,1.8-13.45,1.18-20.18,1.53c-13.55,0.72-26.64-1.8-39.61-5.16c-9.31-2.42-18.19-5.98-27-9.96    c-6.5-2.94-12.77-6.04-18.64-9.99c-0.2-0.16-0.42-0.36-0.62-0.52c-1.11-0.62-2.19-1.21-3.3-1.83c-0.23-0.23-0.46-0.46-0.65-0.69    c-3.59-1.8-7.15-3.59-6.2-8.62c1.04-1.4,2.06-2.84,3.1-4.24c3.82-1.47,6.92,0.33,10.06,2.12c1.08,0.62,2.12,1.37,3.17,2.09    c0.29,0.16,0.56,0.36,0.85,0.52c1.01,0.62,2.06,1.21,3.07,1.83c0.29,0.16,0.59,0.36,0.91,0.52c8.2,3.98,16.13,8.52,24.62,11.79    c8,3.1,16.49,4.93,24.85,7.12c1.47,0.39,3.23-0.26,4.83-0.42c0.49-0.07,1.14-0.29,1.5-0.1c9.01,5.06,18.64,3,28.11,2.25    c5.49-0.42,10.94-1.4,16.33-2.45c1.83-0.36,3.49-1.53,5.26-2.35c0.46-0.2,0.88-0.52,1.37-0.59c2.42-0.39,5.16-0.1,7.22-1.14    c9.14-4.64,18.09-9.63,27.07-14.6c3-1.63,3.1-3.53,1.18-6.56c-1.99-3.13-2.38-7.25-4.34-10.38c-3.49-5.55-7.09-11.2-11.62-15.84    c-5.58-5.68-12.08-10.55-18.42-15.44c-2.71-2.09-6.07-3.36-9.14-5.03c-0.29-0.2-0.59-0.42-0.88-0.62    c-4.44-1.47-8.82-3.04-13.32-4.31c-1.83-0.52-3.82-0.39-5.75-0.56c-3.07-0.26-6.11-0.49-9.18-0.82c-3.72-0.39-6.27-3.95-6.17-8.55    c0.49-0.52,1.01-1.04,1.5-1.6c2.78-4.11,6.95-2.19,10.55-2.16c3.27,0,6.53,0.75,9.8,1.18c1.04,0.29,2.09,0.56,3.13,0.85    c1.04,0.26,2.09,0.52,3.13,0.78c0.78,0.1,1.57,0.2,2.35,0.29c1.76,0.59,3.56,1.18,5.32,1.76c0.82,0.42,1.63,0.85,2.48,1.24    l-0.03-0.03c0.42,0.03,0.85,0.07,1.27,0.1l0.16,0.23c0.59,0.36,1.18,0.72,1.76,1.04c7.51,4.57,15.05,9.18,22.56,13.75    c1.08,0.95,2.19,1.89,3.27,2.84c2.74,2.45,5.71,4.67,8.16,7.38c1.83,1.99,2.97,4.6,4.47,6.92c2.16,3.36,4.38,6.73,6.56,10.06    C493.35,356.3,494.23,357.97,495.11,359.6z"}),jsxRuntimeExports.jsx("path",{className:"st0",d:"M264.26,212.14c-0.75-1.04-1.53-2.09-2.29-3.13c-0.29-0.78-0.59-1.53-0.85-2.32    c-1.63-4.9-2.48-9.86,0.75-14.37c3.82-5.35,8.33-5.26,12.38-0.13c0.56,0.69,1.18,1.34,1.76,1.99c0.78,0.52,1.6,1.04,2.38,1.53    c3.95,2.55,8.42,5.16,6.86,10.74c-0.82,2.94-3.46,5.39-5.29,8.07c-0.52,0.26-1.04,0.49-1.6,0.75c-3.72,0.75-7.44,1.67-10.94-0.69    c-0.52-0.56-1.08-1.08-1.6-1.63C265.28,212.7,264.75,212.44,264.26,212.14z"})]})})});const Boat=({elClass:s,fillColor:a})=>jsxRuntimeExports.jsx("svg",{id:"boat",className:s,viewBox:"0 0 792 612",fill:a,xmlns:"http://www.w3.org/2000/svg",children:jsxRuntimeExports.jsx("g",{id:"_x31_GtWAG_00000052794896688026488630000002467731542195200141_",children:jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{className:"st0",d:"M490.83,442.55c5.69,0,11.38,0,17.06,0c7.58,0,15.17,0,22.75,0c12.64,0,25.29,0,37.92,0 c4.31,0,8.64,0,12.95,0c10.31,0,20.65,0,31.41,0c-1.99,2.68-3.74,5.12-5.57,7.5c-15,19.42-30.01,38.85-45.03,58.27 c-3.98,5.14-7.97,10.29-11.97,15.41c-1.5,1.91-3.25,2.95-5.9,2.95c-94.74-0.06-189.49-0.06-284.23-0.02 c-1.75,0-3.5,0.49-5.25,0.55c-0.71,0.02-1.63-0.3-2.11-0.79c-3.4-3.7-6.77-7.46-10.04-11.28c-2.48-2.89-4.76-5.98-7.28-8.84 c-2.2-2.52-4.72-4.76-6.93-7.28c-2.52-2.85-4.76-5.94-7.28-8.82c-2.2-2.52-4.72-4.76-6.93-7.28c-2.52-2.87-4.78-5.96-7.3-8.84 c-2.22-2.52-4.72-4.78-6.95-7.3c-2.48-2.83-4.7-5.88-7.2-8.72c-2.18-2.48-4.66-4.68-6.81-7.18c-2.48-2.87-4.74-5.94-7.09-8.92 c1.83,0,3.72-0.08,5.59,0.02c2.81,0.14,5.65,0.55,8.46,0.55c95.59,0.04,191.18,0.02,286.77,0.02c0.79,0,1.57,0,2.36-0.02 C485.14,442.55,488,442.55,490.83,442.55z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M227.92,393.27c0.31-0.22,0.63-0.43,0.94-0.63c0.53-0.53,1.06-1.04,1.57-1.57c0.22-0.1,0.41-0.22,0.63-0.31 c0.63-0.63,1.26-1.26,1.89-1.89c0.31-0.22,0.63-0.43,0.94-0.63c0.63-0.63,1.26-1.26,1.91-1.89c5.04-5.2,10.02-10.45,15.13-15.55 c4.15-4.15,8.54-8.05,12.71-12.2c2.32-2.32,4.41-4.88,6.59-7.34c0.41-0.41,0.85-0.85,1.26-1.26c0.63-0.63,1.26-1.26,1.89-1.89 c0.31-0.31,0.63-0.63,0.94-0.94c4.53-5.47,9.05-10.96,13.6-16.43c0.53-0.53,1.04-1.06,1.57-1.57c3.27-4.11,6.53-8.21,9.8-12.32 c0.53-0.53,1.04-1.06,1.57-1.57c1.57-2.2,3.21-4.35,4.7-6.61c4.64-6.99,9.29-13.95,13.82-21.02c5.59-8.7,11.43-17.26,16.45-26.29 c6.87-12.34,13.3-24.94,19.42-37.67c5.86-12.2,11.12-24.72,16.57-37.12c3.21-7.3,6.44-14.6,9.41-22 c3.5-8.76,6.75-17.61,10.1-26.45c0.12-0.33,0.16-0.71,0.22-1.06c0.31-0.41,0.63-0.85,0.94-1.26c0.87-2.93,1.75-5.86,2.6-8.8 c0.28-0.94,0.39-1.93,0.57-2.89c0.31-0.41,0.63-0.85,0.94-1.26c0.49-2.81,3.44-4.96,6.95-5.06c0.22-0.1,0.43-0.2,0.63-0.31 c0.53,0,1.06,0,1.57,0c0.31,0.1,0.63,0.22,0.94,0.31c3.05,0.69,5.25,2.46,6.24,5.39c0.61,1.81,0.98,3.78,0.98,5.69 c0.04,96.18,0.04,192.36,0.1,288.52c0,2.05-0.61,3.39-2.26,4.39c-0.41,0.41-0.85,0.85-1.26,1.26c-1.22,0.53-2.44,1.5-3.68,1.52 c-8.11,0.14-16.22,0.1-24.33,0.06c-24.99-0.1-50.01-0.18-75-0.35c-2.79-0.02-5.59-0.75-8.38-0.75c-2.68,0-5.33,0.75-8.01,0.75 c-30.05-0.04-60.12-0.18-90.18-0.3c-0.39,0-0.79-0.2-1.18-0.3c-1.06-0.63-2.11-1.26-3.17-1.89c-0.31-0.31-0.63-0.63-0.94-0.94 c-0.22-1.38-0.41-2.74-0.63-4.11c0.1-0.41,0.22-0.85,0.31-1.26c0.41-0.31,0.83-0.63,1.26-0.94l0,0c0.41-0.41,0.85-0.85,1.26-1.26 c0.31-0.1,0.63-0.22,0.94-0.31c1.26-0.41,2.52-0.85,3.8-1.26l0,0c0.85-0.53,1.69-1.06,2.52-1.57l0,0 c0.73-0.41,1.48-0.85,2.2-1.26c0.31-0.22,0.63-0.41,0.94-0.63c0.22-0.1,0.41-0.22,0.63-0.31l0,0c0.53-0.31,1.06-0.63,1.57-0.94 l0,0c2.83-2.01,5.69-4,8.52-6l0,0c0.41-0.41,0.85-0.85,1.26-1.26c0.1,0,0.22,0,0.31,0c0.94-0.85,1.89-1.67,2.85-2.52 c0.22-0.1,0.41-0.22,0.63-0.31c0.53-0.53,1.06-1.04,1.57-1.57c0.22-0.1,0.41-0.22,0.63-0.31 C226.85,394.31,227.38,393.8,227.92,393.27z M401.93,146.24c-0.33,0.79-0.59,1.34-0.83,1.91c-4.11,10.19-8.07,20.45-12.34,30.58 c-5.02,11.87-10.27,23.64-15.47,35.43c-3.37,7.66-6.51,15.43-10.31,22.87c-5.71,11.16-11.59,22.26-17.95,33.06 c-7.42,12.56-15.23,24.9-23.28,37.06c-4.74,7.16-10.12,13.91-15.47,20.63c-7.56,9.45-15.1,18.93-23.12,27.97 c-7.14,8.05-14.86,15.59-22.48,23.2c-6.42,6.44-12.99,12.69-19.58,18.95c-3.27,3.09-6.67,6.04-10.1,8.95 c-2.13,1.81-4.37,3.46-6.99,5.51c1.02,0.1,1.48,0.16,1.91,0.18c17.42,0.12,34.84,0.24,52.25,0.3c5.35,0.02,10.73-0.26,16.08-0.28 c4.57,0,9.13,0.26,13.72,0.28c26.49,0.14,52.98,0.22,79.49,0.33c4.11,0.02,8.23,0.1,12.32-0.08c0.77-0.04,1.91-1.06,2.16-1.85 c0.43-1.36,0.39-2.89,0.39-4.35c0.02-18.01,0.12-36.02-0.08-54.04c-0.04-3.94,0.69-7.85-0.87-11.97 c-1.2-3.19-0.24-7.18-0.24-11.32c0.65,0.73,0.85,0.94,1.06,1.18c-0.28-1.46-0.81-2.87-0.77-4.27 c0.55-24.25-0.06-48.49,0.63-72.78c1-35.56,0.08-71.17-0.04-106.77C402.03,146.79,401.99,146.65,401.93,146.24z M273.26,418.24 c0.12,0.18,0.26,0.35,0.37,0.53c3.46,0.45,6.91,0.91,10.37,1.34c0.3,0.04,0.61-0.14,0.92-0.18c1.71-0.26,3.4-0.69,5.12-0.71 c7.97-0.08,15.96-0.04,23.93-0.04c20.35,0,40.72,0,61.07,0c9.84,0,19.68-0.14,29.52,0.08c3.94,0.08,4.43-1.38,4.43-4.53 c0-92.48,0.02-184.96-0.02-277.44c0-3.88-0.2-7.77-0.73-11.59c-0.18-1.26-1.61-3.15-2.66-3.27c-1.22-0.14-3.21,1-3.84,2.16 c-1.5,2.74-2.38,5.83-3.5,8.76c-3.96,10.27-7.7,20.65-11.93,30.82c-5.18,12.46-10.71,24.78-16.12,37.14 c-5.2,11.83-9.74,24.01-15.84,35.37c-9.11,16.96-19.27,33.36-29.13,49.91c-4.7,7.89-9.41,15.82-14.8,23.22 c-6.79,9.37-14.19,18.3-21.49,27.26c-5.12,6.28-10.45,12.4-15.88,18.42c-3.37,3.74-7.12,7.12-10.65,10.73 c-5.1,5.24-10.02,10.65-15.23,15.76c-4.98,4.88-10.19,9.55-15.43,14.15c-4.17,3.66-8.48,7.16-12.81,10.63 c-2.5,2.01-5.16,3.84-7.73,5.77c0.14,0.28,0.28,0.55,0.41,0.85c1.08-0.49,2.15-1.02,3.25-1.44c1.85-0.71,3.9-1.04,5.53-2.05 c2.58-1.61,5-3.54,7.3-5.55c6.34-5.57,12.65-11.18,18.83-16.95c2.52-2.34,4.49-5.27,6.93-7.71c2.89-2.87,6.16-5.39,9.07-8.27 c5.57-5.51,11.18-11.02,16.45-16.81c5.53-6.08,10.86-12.36,15.98-18.8c10.21-12.81,20.8-25.35,29.09-39.64 c6.63-11.43,14.05-22.4,21.02-33.63c1.91-3.07,3.5-6.36,5.14-9.6c1.16-2.28,2.09-4.66,3.21-6.97c2.56-5.24,5.27-10.41,7.77-15.67 c2.07-4.35,3.84-8.82,5.86-13.17c2.03-4.37,4.41-8.58,6.3-13.01c2.15-5.04,3.78-10.29,5.88-15.33c1.06-2.58,2.85-4.84,4.01-7.38 c1.18-2.58,1.85-5.37,2.99-7.97c1.77-4.03,3.86-7.95,5.61-11.99c1.65-3.86,3.05-7.81,4.55-11.73c0.79-2.07,1.61-4.09,2.22-6.22 c0.26-0.85-0.45-2.32-0.02-2.7c1.18-1.02,2.7-2.13,4.17-2.24c2.09-0.18,3.68,1.2,4,3.44c0.31,2.15,0.63,4.33,0.63,6.49 c0.04,87.86,0.02,175.69,0.02,263.55c0,3.29-2.03,5.06-5.31,5.29c-3.11,0.24-6.42-1.14-9.33,1.02c-0.14,0.1-0.59-0.31-0.92-0.37 c-1.16-0.18-2.32-0.39-3.5-0.39c-1.16,0-2.32,0.39-3.46,0.31c-2.81-0.22-5.61-0.91-8.4-0.91c-26.67,0.14-53.35,0.37-80.02,0.59 c-4.62,0.04-9.27,0.06-13.89-0.02c-2.09-0.04-4.15-0.55-6.24-0.53C275.31,417.06,274.28,417.83,273.26,418.24z M244.84,419.82 c7.68,0,15.37,0.02,23.05-0.02c0.89,0,1.79-0.1,2.62-0.37c0.49-0.16,0.85-0.75,1.26-1.14c-0.47-0.22-0.94-0.63-1.42-0.63 c-2.05,0.02-4.07,0.26-6.12,0.28c-14.21,0.02-28.42,0-42.63,0.06c-0.63,0-1.26,0.55-1.87,0.85c0.63,0.33,1.26,0.96,1.91,0.96 C229.37,419.84,237.11,419.82,244.84,419.82z M219.08,419.78c-1.02-0.96-1.44-1.59-2.01-1.89c-2.36-1.16-4.72-2.36-7.18-3.25 c-1.02-0.37-2.4-0.16-3.5,0.18c-1.85,0.55-3.66,1.36-5.39,2.2c-0.35,0.18-0.67,1.34-0.47,1.55c0.49,0.55,1.3,1.12,1.99,1.12 C207.74,419.84,213,419.78,219.08,419.78z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M430.18,191.01c0.22,0,0.41,0,0.63,0c0.75,0.31,1.48,0.63,2.22,0.94l0,0c1.26,2.2,2.52,4.43,3.8,6.63 c2.52,6.79,4.92,13.64,7.62,20.35c3.6,8.95,7.32,17.89,11.22,26.71c5.16,11.67,10.23,23.4,15.9,34.84 c4.39,8.88,9.47,17.42,14.5,25.96c4.98,8.44,10.12,16.83,15.57,24.99c3.5,5.25,7.64,10.1,11.59,15.08 c4.13,5.22,8.31,10.41,12.6,15.47c2.66,3.13,5.51,6.06,8.38,8.99c4.19,4.29,8.52,8.4,12.67,12.73 c8.09,8.42,16.35,16.67,25.84,23.5c4.09,2.93,8.66,5.22,13.15,7.6c2.3,1.22,4.03,3.39,2.76,5.85c-0.85,1.61-3.64,3.09-5.59,3.13 c-15.11,0.26-30.23,0.1-45.34,0.14c-29.72,0.08-59.46,0.2-89.17,0.31c-6.97,0.04-13.95,0.22-20.92,0.3 c-2.09,0.02-5.61-3.52-5.61-5.57c0-73.15-0.02-146.29,0.06-219.44c0-1.89,0.98-3.78,1.52-5.67c0.53-0.53,1.04-1.04,1.57-1.57 c0.94-0.41,1.89-0.85,2.83-1.26C428.68,191.01,429.43,191.01,430.18,191.01z M487.68,328.17c-0.22-0.31-0.41-0.63-0.63-0.94 c-3.68-5.69-7.38-11.38-11.06-17.06c-0.22-0.31-0.41-0.63-0.63-0.94c-1.69-2.95-3.37-5.9-5.06-8.86 c-0.1-0.22-0.22-0.41-0.31-0.63c-0.41-0.73-0.85-1.48-1.26-2.2c-0.1-0.22-0.22-0.41-0.31-0.63c-0.41-0.73-0.85-1.48-1.26-2.2 c-0.22-0.41-0.41-0.85-0.63-1.26c-1.38-2.52-2.74-5.06-4.11-7.58c-0.1-0.22-0.22-0.41-0.31-0.63c-0.85-1.89-1.69-3.8-2.52-5.69 c-0.41-0.85-0.85-1.69-1.26-2.52c-0.53-1.16-1.06-2.32-1.57-3.48c-0.22-0.41-0.41-0.85-0.63-1.26c-0.63-1.69-1.26-3.37-1.89-5.06 c-0.53-1.06-1.04-2.11-1.57-3.17c-0.85-1.69-1.69-3.37-2.52-5.06c-0.22-0.63-0.41-1.26-0.63-1.89c-0.31-0.85-0.63-1.69-0.94-2.52 c-0.1-0.22-0.22-0.41-0.31-0.63c-0.31-0.73-0.63-1.48-0.94-2.2c-0.1-0.22-0.22-0.41-0.31-0.63c-0.31-0.73-0.63-1.48-0.94-2.2 c-0.1-0.22-0.22-0.41-0.31-0.63c-0.31-0.73-0.63-1.48-0.94-2.2c-0.1-0.22-0.22-0.41-0.31-0.63c-0.31-0.73-0.63-1.48-0.94-2.2 c-0.1-0.22-0.22-0.41-0.31-0.63c-0.31-0.73-0.63-1.48-0.94-2.2c-0.1-0.22-0.22-0.41-0.31-0.63c-0.73-1.69-1.48-3.37-2.2-5.06 c-0.1-0.22-0.22-0.41-0.31-0.63c-0.31-0.73-0.63-1.48-0.94-2.2c-0.22-0.41-0.41-0.85-0.63-1.26c-0.85-1.89-1.69-3.8-2.52-5.69 c-0.22-0.53-0.41-1.06-0.63-1.57c-0.31-1.04-0.63-2.11-0.96-3.15c-0.22-0.41-0.41-0.85-0.63-1.26c-0.22-0.94-0.41-1.89-0.63-2.83 c-0.22-0.63-0.43-1.24-0.65-1.87c-0.31,0.55-0.89,1.12-0.89,1.67c0.06,15.06,0.26,30.09,0.26,45.15 c0.04,46.55,0.02,93.11,0.02,139.66c0,4.47-0.02,8.95,0.02,13.42c0,0.35,0.39,0.69,0.61,1.04c0.63-0.22,1.26-0.41,1.89-0.63 c0.31,0.1,0.63,0.22,0.94,0.31c0.22,0,0.43,0,0.63,0c0.69,0.31,1.38,0.89,2.09,0.91c5.29,0.08,10.59,0.08,15.88,0.02 c4.51-0.04,9.03-0.28,13.54-0.3c9.84-0.04,19.7,0,29.54-0.06c0.61,0,1.22-0.59,1.83-0.91c1.38,0,2.74,0,4.11,0 c0.94,1.46,1.89,1.46,2.85,0c2.85,0,5.69,0,8.54,0c0.77,1.36,2.46,1.36,3.48,0c1.16,0,2.32,0,3.48,0 c0.53,0.35,1.04,0.92,1.63,1.04c0.94,0.2,1.95-0.04,2.89,0.14c1.3,0.24,1.91-0.14,1.79-1.5c1.57,0.1,3.17,0.22,4.74,0.31 c0.41,0.22,0.83,0.59,1.24,0.59c10.25,0.04,20.49,0.04,30.74,0c0.45,0,0.92-0.41,1.38-0.63c-0.49-0.2-0.96-0.39-1.46-0.59 c-0.41-0.41-0.85-0.85-1.26-1.26c-0.73-0.73-1.48-1.48-2.2-2.2c-0.85-0.75-1.69-1.48-2.52-2.22c-0.41-0.41-0.85-0.85-1.26-1.26 c-0.22-0.1-0.41-0.22-0.63-0.31c-0.31-0.31-0.63-0.63-0.94-0.94c-0.22-0.22-0.41-0.41-0.63-0.63c-0.41-0.31-0.85-0.63-1.26-0.94 c-0.41-0.31-0.85-0.63-1.26-0.94c-0.41-0.41-0.85-0.85-1.26-1.26c-0.22-0.1-0.41-0.22-0.63-0.31c-0.39-0.87-0.61-1.95-1.24-2.58 c-3.25-3.29-6.57-6.46-9.92-9.64c-0.37-0.35-0.98-0.49-1.48-0.73c-0.41-0.41-0.85-0.85-1.26-1.26c-0.41-0.41-0.85-0.85-1.26-1.26 c-1.16-1.16-2.32-2.32-3.48-3.48c-0.85-0.94-1.69-1.89-2.54-2.83l0,0c-0.63-0.31-1.26-0.63-1.89-0.94 c-0.85-1.06-1.69-2.11-2.52-3.17c-0.73-0.85-1.48-1.69-2.2-2.52c-0.53-0.73-1.06-1.48-1.57-2.2c-0.85-0.75-1.67-1.48-2.52-2.22 c-0.1-0.22-0.22-0.41-0.31-0.63c-0.31-0.31-0.63-0.63-0.94-0.94c-0.31-0.41-0.63-0.85-0.94-1.26c-0.63-0.75-1.26-1.48-1.89-2.22 c-0.63-0.85-1.26-1.69-1.91-2.52c-0.41-0.53-0.85-1.06-1.26-1.57c0-0.1,0-0.22,0-0.31c-0.31-0.31-0.63-0.63-0.94-0.94 c-0.1-0.22-0.22-0.41-0.31-0.63c-0.22-0.31-0.43-0.63-0.63-0.94c-0.1-0.1-0.22-0.22-0.31-0.31c-0.31-0.31-0.63-0.63-0.94-0.94 c0-0.1,0-0.22,0-0.31c-0.41-0.41-0.85-0.85-1.26-1.26c0-0.1,0-0.22,0-0.31c-0.31-0.31-0.63-0.63-0.94-0.94c0-0.1,0-0.22,0-0.31 c-0.41-0.41-0.85-0.85-1.26-1.26c0-0.1,0-0.22,0-0.31c-0.31-0.31-0.63-0.63-0.94-0.94c0-0.1,0-0.22,0-0.31 c-0.31-0.41-0.63-0.85-0.94-1.26c-0.1-0.1-0.22-0.22-0.31-0.31c-0.31-0.31-0.63-0.63-0.94-0.94c0-0.1,0-0.22,0-0.31 c-0.31-0.41-0.63-0.85-0.94-1.26c-0.1-0.1-0.22-0.22-0.31-0.31c-0.31-0.31-0.63-0.63-0.94-0.94c0-0.1,0-0.22,0-0.31 c-0.31-0.31-0.63-0.63-0.94-0.94c0-0.1,0-0.22,0-0.31c-0.41-0.41-0.85-0.85-1.26-1.26c0-0.1,0-0.22,0-0.31 c-0.31-0.31-0.63-0.63-0.94-0.94c0-0.1,0-0.22,0-0.31c-0.41-0.41-0.85-0.85-1.26-1.26c0-0.1,0-0.22,0-0.31 c-0.31-0.31-0.63-0.63-0.94-0.94c0-0.1,0-0.22,0-0.31"}),jsxRuntimeExports.jsx("path",{className:"st0",d:"M406.79,88.32c4.76-4.41,10.1-4.25,15.67-1.93c4.74,1.97,7.16,10.16,4.76,14.68 c-1.61,3.07-3.72,5.71-6.87,6.63c-4.27,1.26-8.66,1.02-12.5-2.01c-4.64-3.68-6.65-9.76-2.03-16.41 C406.15,88.96,406.48,88.65,406.79,88.32z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M219.06,400.85c-2.83,2.01-5.69,4-8.52,6C213.37,404.86,216.23,402.85,219.06,400.85z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M436.81,198.61c-1.26-2.2-2.52-4.43-3.8-6.63C434.27,194.18,435.53,196.4,436.81,198.61z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M195.05,416.65c0.22,1.38,0.41,2.74,0.63,4.11C195.48,419.39,195.27,418.03,195.05,416.65z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M202.65,411.59c-1.26,0.41-2.52,0.85-3.8,1.26C200.11,412.44,201.37,412.03,202.65,411.59z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M196.62,421.71c1.06,0.63,2.11,1.26,3.17,1.89C198.73,422.97,197.69,422.34,196.62,421.71z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M223.49,397.07c-0.94,0.85-1.89,1.67-2.85,2.52C221.6,398.74,222.54,397.89,223.49,397.07z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M235.83,386.32c-0.63,0.63-1.26,1.26-1.91,1.89C234.55,387.58,235.18,386.95,235.83,386.32z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M433.01,191.97c-0.75-0.31-1.48-0.63-2.22-0.94C431.53,191.32,432.26,191.66,433.01,191.97z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M232.97,388.84c-0.63,0.63-1.26,1.26-1.89,1.89C231.71,390.1,232.34,389.47,232.97,388.84z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M205.16,410.02c-0.85,0.53-1.69,1.06-2.52,1.57C203.47,411.06,204.32,410.55,205.16,410.02z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M430.18,191.01c-0.75,0-1.48,0-2.22,0C428.68,191.01,429.43,191.01,430.18,191.01z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M207.37,408.74c-0.73,0.41-1.48,0.85-2.2,1.26C205.89,409.58,206.64,409.17,207.37,408.74z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M225.71,395.16c-0.53,0.53-1.06,1.04-1.57,1.57C224.65,396.22,225.18,395.69,225.71,395.16z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M227.92,393.27c-0.53,0.53-1.06,1.04-1.57,1.57C226.85,394.31,227.38,393.8,227.92,393.27z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M230.45,391.07c-0.53,0.53-1.06,1.04-1.57,1.57C229.39,392.11,229.92,391.58,230.45,391.07z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M289.54,329.11c-0.53,0.53-1.04,1.06-1.57,1.57C288.49,330.17,289.01,329.64,289.54,329.11z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M300.91,315.22c-0.53,0.53-1.04,1.06-1.57,1.57C299.87,316.26,300.38,315.75,300.91,315.22z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M425.1,192.29c-0.53,0.53-1.04,1.04-1.57,1.57C424.06,193.33,424.59,192.82,425.1,192.29z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M197.9,413.17c-0.41,0.41-0.85,0.85-1.26,1.26C197.06,414.01,197.47,413.6,197.9,413.17z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M210.54,406.85c-0.53,0.31-1.06,0.63-1.57,0.94C209.48,407.48,210.01,407.16,210.54,406.85z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M220.34,399.59c-0.41,0.41-0.85,0.85-1.26,1.26C219.49,400.43,219.91,400.02,220.34,399.59z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M396.66,122.76c-0.31,0.41-0.63,0.85-0.94,1.26C396.03,123.6,396.34,123.19,396.66,122.76z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M271.53,349.97c-0.41,0.41-0.85,0.85-1.26,1.26C270.68,350.82,271.1,350.4,271.53,349.97z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M410.57,422.97c0.41-0.41,0.85-0.85,1.26-1.26C411.42,422.12,410.99,422.55,410.57,422.97z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M392.57,135.71c-0.31,0.41-0.63,0.85-0.94,1.26C391.94,136.55,392.25,136.14,392.57,135.71z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M196.62,414.43c-0.41,0.31-0.83,0.63-1.26,0.94C195.8,415.08,196.21,414.76,196.62,414.43z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M274.36,347.12c-0.31,0.31-0.63,0.63-0.94,0.94C273.73,347.77,274.05,347.45,274.36,347.12z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M406.78,117.7c-0.31-0.1-0.63-0.22-0.94-0.31C406.15,117.5,406.46,117.6,406.78,117.7z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M208.96,407.79c-0.22,0.1-0.41,0.22-0.63,0.31C208.53,408.01,208.75,407.91,208.96,407.79z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M404.26,117.4c-0.22,0.1-0.43,0.2-0.63,0.31C403.82,117.6,404.04,117.5,404.26,117.4z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M273.26,418.24c1.02-0.43,2.03-1.2,3.05-1.2c2.07-0.04,4.15,0.49,6.24,0.53c4.62,0.1,9.27,0.06,13.89,0.02 c26.67-0.2,53.35-0.45,80.02-0.59c2.79-0.02,5.59,0.69,8.4,0.91c1.14,0.1,2.3-0.31,3.46-0.31s2.34,0.22,3.5,0.39 c0.33,0.04,0.79,0.47,0.92,0.37c2.91-2.16,6.22-0.79,9.33-1.02c3.29-0.24,5.31-2.01,5.31-5.29c0-87.86,0-175.69-0.02-263.55 c0-2.16-0.31-4.35-0.63-6.49c-0.33-2.24-1.93-3.62-4-3.44c-1.46,0.12-2.99,1.22-4.17,2.24c-0.43,0.37,0.26,1.85,0.02,2.7 c-0.61,2.11-1.46,4.15-2.22,6.22c-1.5,3.92-2.89,7.89-4.55,11.73c-1.75,4.05-3.84,7.95-5.61,11.99c-1.14,2.6-1.81,5.39-2.99,7.97 c-1.16,2.54-2.95,4.8-4.01,7.38c-2.11,5.06-3.74,10.29-5.88,15.33c-1.89,4.43-4.25,8.64-6.3,13.01 c-2.03,4.35-3.8,8.84-5.86,13.17c-2.5,5.27-5.2,10.43-7.77,15.67c-1.12,2.3-2.05,4.68-3.21,6.97c-1.63,3.25-3.23,6.51-5.14,9.6 c-6.97,11.24-14.39,22.2-21.02,33.63c-8.29,14.29-18.87,26.82-29.09,39.64c-5.12,6.44-10.45,12.71-15.98,18.8 c-5.27,5.79-10.88,11.3-16.45,16.81c-2.91,2.87-6.18,5.37-9.07,8.27c-2.44,2.44-4.41,5.35-6.93,7.71 c-6.16,5.77-12.48,11.38-18.83,16.95c-2.3,2.01-4.72,3.94-7.3,5.55c-1.63,1.02-3.68,1.36-5.53,2.05 c-1.1,0.41-2.16,0.96-3.25,1.44c-0.14-0.28-0.28-0.55-0.41-0.85c2.58-1.91,5.24-3.74,7.73-5.77c4.33-3.48,8.66-6.97,12.81-10.63 c5.24-4.61,10.45-9.27,15.43-14.15c5.22-5.12,10.14-10.53,15.23-15.76c3.52-3.6,7.28-6.99,10.65-10.73 c5.43-6.02,10.77-12.14,15.88-18.42c7.32-8.97,14.7-17.91,21.49-27.26c5.39-7.42,10.1-15.35,14.8-23.22 c9.88-16.55,20.02-32.95,29.13-49.91c6.1-11.34,10.65-23.52,15.84-35.37c5.43-12.36,10.96-24.68,16.12-37.14 c4.21-10.17,7.97-20.55,11.93-30.82c1.12-2.93,2.01-6.02,3.5-8.76c0.63-1.14,2.62-2.3,3.84-2.16c1.04,0.12,2.48,2.01,2.66,3.27 c0.53,3.82,0.73,7.73,0.73,11.59c0.04,92.48,0.02,184.96,0.02,277.44c0,3.13-0.49,4.61-4.43,4.53 c-9.84-0.22-19.68-0.08-29.52-0.08c-20.35,0-40.72,0-61.07,0c-7.97,0-15.96-0.04-23.93,0.04c-1.71,0.02-3.4,0.45-5.12,0.71 c-0.31,0.04-0.63,0.22-0.92,0.18c-3.46-0.43-6.91-0.89-10.37-1.34C273.52,418.6,273.4,418.42,273.26,418.24z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M244.84,419.82c-7.73,0-15.47,0.02-23.2-0.04c-0.63,0-1.28-0.63-1.91-0.96c0.63-0.3,1.26-0.85,1.87-0.85 c14.21-0.04,28.42-0.02,42.63-0.06c2.05,0,4.07-0.24,6.12-0.28c0.47,0,0.94,0.41,1.42,0.63c-0.41,0.39-0.77,0.98-1.26,1.14 c-0.83,0.28-1.75,0.37-2.62,0.37C260.21,419.82,252.54,419.82,244.84,419.82z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M219.08,419.78c-6.1,0-11.34,0.04-16.59-0.06c-0.69-0.02-1.5-0.59-1.99-1.12c-0.2-0.22,0.12-1.38,0.47-1.55 c1.75-0.85,3.54-1.65,5.39-2.2c1.1-0.33,2.48-0.55,3.5-0.18c2.48,0.87,4.82,2.09,7.18,3.25 C217.66,418.19,218.06,418.82,219.08,419.78z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M432.38,215.98c-0.22-0.02-0.41-0.04-0.63-0.04c0,0.37,0,0.73,0,1.1c0,66.01,0,132.02,0,198.03 c-0.22-0.35-0.61-0.69-0.61-1.04c-0.04-4.47-0.02-8.95-0.02-13.42c0-46.55,0.02-93.11-0.02-139.66 c-0.02-15.06-0.2-30.09-0.26-45.15c0-0.55,0.57-1.12,0.89-1.67C431.95,214.74,432.16,215.37,432.38,215.98z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M435.21,414.76c19.6,0,39.22,0,58.83-0.02c1.36,0,2.7-0.2,4.05-0.3c-0.61,0.31-1.22,0.91-1.83,0.91 c-9.84,0.06-19.7,0-29.54,0.06c-4.51,0.02-9.03,0.24-13.54,0.3c-5.29,0.06-10.59,0.04-15.88-0.02 C436.61,415.65,435.92,415.08,435.21,414.76z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M531.61,414.45c10.21,0,20.41,0,30.62-0.04c0.43,0,0.87-0.39,1.3-0.61c0.49,0.2,0.96,0.39,1.46,0.59 c-0.45,0.22-0.92,0.63-1.38,0.63c-10.25,0.04-20.49,0.04-30.74,0C532.44,415.04,532.02,414.66,531.61,414.45z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M549.62,401.48c-4.21-4.31-8.42-8.64-12.64-12.95c0.49,0.24,1.1,0.35,1.48,0.73 c3.35,3.19,6.69,6.36,9.92,9.64C549.01,399.53,549.21,400.61,549.62,401.48z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M520.55,414.45c2.11-0.1,4.21-0.22,6.32-0.31c0.12,1.36-0.49,1.73-1.79,1.5c-0.94-0.18-1.97,0.06-2.89-0.14 C521.57,415.37,521.08,414.8,520.55,414.45z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M513.58,414.45c1.16,0,2.32,0,3.48,0C516.06,415.8,514.37,415.8,513.58,414.45z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M524.01,375.58c-0.73-0.85-1.48-1.69-2.2-2.52C522.54,373.88,523.29,374.73,524.01,375.58z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M562.25,412.54c-0.73-0.73-1.48-1.48-2.2-2.2C560.78,411.06,561.53,411.81,562.25,412.54z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M502.21,414.45c0.94,0,1.89,0,2.85,0C504.12,415.9,503.17,415.9,502.21,414.45z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M530.96,382.52c-0.85-0.94-1.69-1.89-2.54-2.83C529.29,380.63,530.13,381.58,530.96,382.52z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M520.22,370.83c-0.85-0.75-1.67-1.48-2.52-2.22C518.54,369.36,519.39,370.09,520.22,370.83z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M454.17,267.19c-0.53-1.06-1.04-2.11-1.57-3.17C453.12,265.07,453.65,266.13,454.17,267.19z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M515.49,365.78c-0.63-0.75-1.26-1.48-1.89-2.22C514.23,364.3,514.86,365.05,515.49,365.78z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M459.56,279.51c-0.41-0.85-0.85-1.69-1.26-2.52C458.71,277.82,459.13,278.67,459.56,279.51z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M528.44,379.69c-0.63-0.31-1.26-0.63-1.89-0.94C527.18,379.04,527.81,379.37,528.44,379.69z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M450.07,258.97c-0.22-0.63-0.41-1.26-0.63-1.89C449.66,257.71,449.86,258.34,450.07,258.97z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M493.06,336.71c-0.41-0.63-0.85-1.26-1.26-1.89C492.21,335.45,492.62,336.08,493.06,336.71z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M435.21,224.84c-0.22-0.53-0.41-1.06-0.63-1.57C434.8,223.78,435.02,224.31,435.21,224.84z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M511.69,361.03c-0.41-0.53-0.85-1.06-1.26-1.57C510.85,359.99,511.28,360.5,511.69,361.03z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M497.46,342.39c-0.41-0.41-0.85-0.85-1.26-1.26C496.64,341.55,497.05,341.98,497.46,342.39z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M557.51,408.11c-0.41-0.41-0.85-0.85-1.26-1.26C556.66,407.28,557.1,407.7,557.51,408.11z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M551.51,403.05c-0.41-0.41-0.85-0.85-1.26-1.26C550.66,402.22,551.09,402.64,551.51,403.05z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M505.06,352.2c-0.41-0.41-0.85-0.85-1.26-1.26C504.21,351.35,504.63,351.76,505.06,352.2z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M507.27,355.03c-0.41-0.41-0.85-0.85-1.26-1.26C506.44,354.18,506.85,354.62,507.27,355.03z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M535.7,387.27c-0.41-0.41-0.85-0.85-1.26-1.26C534.86,386.42,535.29,386.83,535.7,387.27z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M495.26,339.54c-0.41-0.41-0.85-0.85-1.26-1.26C494.41,338.69,494.85,339.13,495.26,339.54z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M438.38,231.79c-0.22-0.41-0.41-0.85-0.63-1.26C437.95,230.94,438.17,231.37,438.38,231.79z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M433.64,220.1c-0.22-0.41-0.41-0.85-0.63-1.26C433.23,219.25,433.42,219.66,433.64,220.1z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M456.71,273.49c-0.22-0.41-0.41-0.85-0.63-1.26C456.29,272.67,456.49,273.08,456.71,273.49z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M467.14,294.67c-0.22-0.41-0.41-0.85-0.63-1.26C466.72,293.82,466.92,294.26,467.14,294.67z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M554.05,404.96c-0.41-0.31-0.85-0.63-1.26-0.94C553.2,404.33,553.61,404.64,554.05,404.96z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M502.84,349.34c-0.31-0.41-0.63-0.85-0.94-1.26C502.21,348.5,502.52,348.93,502.84,349.34z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M500.63,346.51c-0.31-0.41-0.63-0.85-0.94-1.26C500,345.66,500.32,346.07,500.63,346.51z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M501.58,347.77c-0.31-0.31-0.63-0.63-0.94-0.94C500.95,347.14,501.26,347.45,501.58,347.77z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M503.8,350.6c-0.31-0.31-0.63-0.63-0.94-0.94C503.17,349.97,503.49,350.29,503.8,350.6z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M555.62,406.53c-0.31-0.31-0.63-0.63-0.94-0.94C554.99,405.9,555.31,406.22,555.62,406.53z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M499.37,344.91c-0.31-0.31-0.63-0.63-0.94-0.94C498.74,344.28,499.06,344.6,499.37,344.91z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M498.43,343.65c-0.31-0.31-0.63-0.63-0.94-0.94C497.8,343.02,498.11,343.34,498.43,343.65z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M496.2,340.82c-0.31-0.31-0.63-0.63-0.94-0.94C495.58,340.17,495.89,340.51,496.2,340.82z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M494,337.97c-0.31-0.31-0.63-0.63-0.94-0.94C493.37,337.34,493.69,337.65,494,337.97z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M506.01,353.46c-0.31-0.31-0.63-0.63-0.94-0.94C505.38,352.83,505.69,353.14,506.01,353.46z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M508.21,356.29c-0.31-0.31-0.63-0.63-0.94-0.94C507.58,355.66,507.9,355.97,508.21,356.29z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M510.43,359.14c-0.31-0.31-0.63-0.63-0.94-0.94C509.8,358.51,510.12,358.83,510.43,359.14z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M433.64,414.45c0.31,0.1,0.63,0.22,0.94,0.31C434.27,414.66,433.95,414.54,433.64,414.45z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M517.38,367.98c-0.31-0.31-0.63-0.63-0.94-0.94C516.75,367.35,517.07,367.66,517.38,367.98z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M491.78,334.8c-0.22-0.31-0.41-0.63-0.63-0.94C491.36,334.17,491.58,334.48,491.78,334.8z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M487.68,328.17c-0.22-0.31-0.41-0.63-0.63-0.94C487.25,327.54,487.47,327.85,487.68,328.17z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M509.17,357.57c-0.22-0.31-0.43-0.63-0.63-0.94C508.74,356.92,508.96,357.25,509.17,357.57z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M475.99,310.16c-0.22-0.31-0.41-0.63-0.63-0.94C475.56,309.53,475.78,309.84,475.99,310.16z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M470.29,300.36c-0.1-0.22-0.22-0.41-0.31-0.63C470.09,299.94,470.19,300.16,470.29,300.36z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M468.71,297.52c-0.1-0.22-0.22-0.41-0.31-0.63C468.49,297.09,468.61,297.31,468.71,297.52z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M462.39,285.83c-0.1-0.22-0.22-0.41-0.31-0.63C462.18,285.4,462.29,285.62,462.39,285.83z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M448.5,254.54c-0.1-0.22-0.22-0.41-0.31-0.63C448.28,254.13,448.38,254.32,448.5,254.54z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M447.22,251.71c-0.1-0.22-0.22-0.41-0.31-0.63C447.02,251.27,447.12,251.49,447.22,251.71z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M445.96,248.85c-0.1-0.22-0.22-0.41-0.31-0.63C445.74,248.44,445.86,248.64,445.96,248.85z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M444.7,246.02c-0.1-0.22-0.22-0.41-0.31-0.63C444.48,245.58,444.6,245.8,444.7,246.02z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M443.44,243.16c-0.1-0.22-0.22-0.41-0.31-0.63C443.22,242.75,443.32,242.95,443.44,243.16z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M442.16,240.31c-0.1-0.22-0.22-0.41-0.31-0.63C441.96,239.9,442.06,240.11,442.16,240.31z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M439.64,234.62c-0.1-0.22-0.22-0.41-0.31-0.63C439.43,234.21,439.54,234.43,439.64,234.62z"})]})})})});const Bow=({elClass:C,fillColor:s})=>jsxRuntimeExports.jsx("svg",{id:"bow",className:C,viewBox:"0 0 792 612",fill:s,xmlns:"http://www.w3.org/2000/svg",children:jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsx("path",{className:"st0",d:"M388.94,317.55c-1.94,3.46-3.87,6.92-5.79,10.37c-0.74,1.34-1.47,2.7-2.22,4.04 c-0.17,0.28-0.33,0.56-0.5,0.84c-1.17,1.03-2.33,2.08-2.51,3.94c-0.6,0.61-1.22,1.19-1.79,1.85c-0.45,0.55-0.73,1.27-1.19,1.79 c-1.97,2.25-4,4.45-5.99,6.68c-3.13,3.52-6.25,7.05-9.36,10.57c-0.66,0.74-1.27,1.52-1.92,2.3c-0.08,0.1-0.17,0.18-0.25,0.28 c-0.46,0.45-0.93,0.91-1.39,1.36c-2.12,2-4.24,3.99-6.37,5.99c-2.17,1.51-4.33,3.01-6.5,4.52c-0.17,0.05-0.33,0.07-0.46,0.17 c-2.5,1.75-5.01,3.52-7.49,5.31c-1.77,1.27-3.52,2.56-5.28,3.85c-0.5,0.23-0.99,0.45-1.47,0.73c-4.17,2.4-8.34,4.8-12.51,7.2 c-1.26,0.73-2.51,1.51-3.77,2.25c-2.76,1.39-5.53,2.75-8.27,4.17c-1.39,0.71-2.68,1.75-4.12,2.27c-2.12,0.74-4.33,1.17-6.52,1.69 c-1.89,0.45-3.81,0.78-5.69,1.24c-1.87,0.46-3.72,1.08-5.58,1.59c-1.27,0.35-2.56,0.73-3.87,0.91c-3.24,0.41-6.5,0.71-9.74,1.06 c-2.73,0.28-5.48,0.76-8.21,0.78c-2.53,0.02-5.06-0.41-7.59-0.71c-4.53-0.53-9.07-1.03-13.6-1.7c-3.14-0.46-6.27-1.17-9.4-1.87 c-2.81-0.63-5.61-1.39-8.42-2.03c-2.53-0.58-5.16-0.83-7.61-1.7c-4.25-1.51-8.42-3.37-12.62-5.1c-0.25,0-0.5,0-0.74-0.02 c-0.22-0.2-0.41-0.45-0.66-0.56c-1.77-0.78-3.57-1.46-5.31-2.27c-2.2-1.03-4.52-1.85-6.5-3.28c-4.32-3.13-8.42-6.62-12.64-9.89 c-4.53-3.52-9.12-6.96-13.67-10.47c-2.28-1.77-4.47-3.76-6.85-5.31c-2.91-1.92-5.48-4.45-9.02-5.29 c-3.04-0.73-5.91-1.26-8.85,0.07c-0.25,0.1-0.5,0.2-0.74,0.3c-1.42,0.56-2.83,1.12-4.25,1.69c-1.84,1.08-3.69,2.1-5.49,3.26 c-0.74,0.48-1.34,1.21-2,1.84c-0.33,0.28-0.66,0.56-0.99,0.84c-0.6,0.38-1.17,0.74-1.77,1.12c-0.25,0.1-0.5,0.2-0.73,0.3 c-0.17,0-0.33,0.02-0.5,0.02c-1.64,0.73-3.06-0.08-4.53-0.73c-2.9-1.26-5.77-2.55-8.72-3.62c-1.79-0.65-3.69-0.93-5.54-1.32 c-1.57-0.33-2.32-2.13-1.79-4.05c0.76-2.8,2.48-4.73,4.37-6.5c2.1-1.95,4.19-3.97,6.49-5.59c2.81-1.97,5.76-3.74,8.78-5.24 c2.8-1.39,5.74-2.4,8.67-3.39c1.52-0.51,3.16-0.61,4.75-0.88c2.4-0.41,4.8-0.99,7.21-1.14c2.28-0.13,4.63-0.12,6.87,0.36 c4.12,0.89,8.17,2.18,12.24,3.33c2.15,0.61,4.28,1.27,6.44,1.92c0.66,0.38,1.34,0.76,2,1.12c0.45,0.2,0.91,0.38,1.36,0.61 c3.49,1.82,6.98,3.66,10.47,5.49c4.63,2.42,9.31,4.75,13.88,7.3c3.14,1.75,6.15,3.82,9.21,5.76c3.59,2.28,7.18,4.6,10.77,6.9 c3.01,1.94,6.01,3.9,9.02,5.82c3.28,2.08,6.52,4.24,9.86,6.17c1.89,1.09,3.94,1.77,5.92,2.63c0.08,0,0.17,0,0.25,0 c0.33,0.18,0.66,0.38,0.99,0.56c0.25,0,0.5,0.02,0.74,0.02c0.33,0.18,0.66,0.36,0.99,0.55c0.08,0,0.17,0,0.25,0 c0.41,0.18,0.83,0.38,1.24,0.56c0.17,0,0.33,0.02,0.5,0.02c0.83,0.36,1.67,0.74,2.5,1.11c0.08,0,0.17,0,0.25,0 c1.42,0.56,2.85,1.17,4.3,1.7c3.46,1.27,6.93,2.55,10.41,3.77c1.67,0.58,3.36,1.06,5.05,1.59c0.25,0,0.5,0,0.74,0 c0.25,0,0.5,0,0.74,0c0.33,0,0.66,0.02,0.99,0.02c1.49,0.07,2.96,0.15,4.45,0.17c0.51,0.02,1.03-0.12,1.56-0.18 c0.25,0,0.5,0,0.74,0c2.83-0.61,5.66-1.37,8.5-1.79c4.48-0.66,8.67-2.3,12.69-4.53c2.45-1.34,4.86-2.75,7.3-4.12 c0.33-0.1,0.66-0.2,0.99-0.3c1.72-1.52,3.47-3.01,5.16-4.57c3.19-2.96,6.37-5.97,9.55-8.97c3.39-3.21,6.95-6.22,10.11-9.69 c2.75-3.01,5.05-6.57,7.56-9.84c3.64-4.71,7.33-9.4,10.97-14.11c1.82-2.37,3.76-4.65,5.38-7.16c2.17-3.34,4.09-6.88,6.09-10.36 c2.17-3.76,4.35-7.49,6.47-11.28c1.04-1.85,1.97-3.79,2.94-5.67c0.5-0.84,1.01-1.7,1.51-2.55c0.17-0.28,0.33-0.56,0.5-0.84 c0.66-1.12,1.32-2.27,1.99-3.39c0.74-1.41,1.51-2.83,2.25-4.24c0-0.38,0-0.76,0-1.12c-0.12-0.91-0.17-1.85-0.35-2.75 c-0.43-1.97-1.92-3.08-4.02-3.19c-2.17-0.13-4.15,0.53-6.12,1.44c-0.5,0.28-0.99,0.56-1.51,0.84c-0.45,0.07-0.91,0.07-1.34,0.18 c-3.47,0.98-6.95,1.92-10.41,2.98c-1.62,0.5-3.18,1.26-4.75,1.9c-0.33,0.18-0.66,0.38-0.99,0.56c-2.15,1.16-4.3,2.35-6.49,3.46 c-0.88,0.45-1.85,0.63-2.73,1.06c-2.08,1.04-4.12,2.2-6.2,3.23c-2.3,1.14-4.65,2.17-6.96,3.26c-2.32,1.09-4.62,2.23-6.95,3.29 c-1.27,0.58-2.6,0.99-3.9,1.51c-1.82,0.71-3.64,1.47-5.48,2.17c-2.22,0.83-4.43,1.64-6.67,2.4c-2.02,0.68-4.05,1.27-6.09,1.9 c-0.28,0.08-0.58,0.07-0.86,0.07c-3.08,0-6.15-0.05-9.23,0.02c-2.51,0.05-4.96-0.3-7.38-1.11c-1.82-0.6-3.72-0.84-5.51-1.54 c-2.4-0.93-4.73-2.13-7.1-3.16c-0.74-0.33-1.56-0.46-2.33-0.71c-1.59-0.51-3.19-0.98-4.76-1.56c-1.47-0.55-2.91-1.24-4.37-1.84 c-2.56-1.08-5.18-1.99-7.68-3.23c-2.86-1.42-5.62-3.13-8.44-4.7c-3.85-2.17-6.55-5.61-8.42-9.89c-0.6-1.37-0.93-2.96-1.16-4.48 c-0.3-1.97-0.53-3.99-0.5-5.97c0.05-1.77,0.45-3.56,0.81-5.29c0.35-1.65,0.76-3.29,1.29-4.88c0.68-1.99,1.46-3.92,2.28-5.84 c1.9-4.45,3.74-8.95,5.82-13.28c1.87-3.89,3.89-7.71,6.12-11.35c1.95-3.18,4.09-6.27,6.5-8.98c2.96-3.34,6.17-6.47,10.12-8.39 c0.96-0.46,1.75-1.41,2.71-1.85c2.32-1.06,4.68-1.94,7.05-2.88c1.09-0.43,2.17-0.84,3.28-1.24c0.35-0.12,0.73-0.17,1.09-0.17 c8.42-0.02,16.84-0.08,25.25,0.05c2,0.03,3.99,0.89,5.99,1.21c1.36,0.22,2.75-0.02,4.1,0.18c1.32,0.2,2.6,0.69,3.89,1.09 c0.81,0.25,1.6,0.6,2.42,0.84c1.26,0.38,2.55,0.63,3.79,1.06c1.59,0.55,3.13,1.29,4.71,1.79c1.79,0.56,3.64,0.91,5.44,1.42 c2.45,0.68,4.88,1.34,7.08,2.85c1.42,0.98,3.03,1.59,4.47,2.51c4.28,2.78,8.59,5.54,12.77,8.49c3.52,2.48,6.95,5.15,10.36,7.83 c3.42,2.68,6.77,5.49,10.16,8.21c1.84,1.47,3.71,2.9,5.58,4.28c0.18,0.13,0.63,0.03,0.83-0.13c2.2-1.9,4.25-4.05,6.58-5.72 c1.8-1.27,3.92-1.97,5.92-2.9c1.77-0.83,3.62-0.84,5.51-0.88c3.64-0.07,6.9,1.19,9.98,3.23c3.26,2.15,6.49,4.35,8.93,7.71 c0.17,0.22,0.91,0.2,1.17-0.03c4.24-3.33,8.44-6.73,12.67-10.08c3.36-2.65,6.73-5.23,10.14-7.81c2.7-2.03,5.39-4.09,8.16-6.01 c2.46-1.7,5.01-3.24,7.53-4.86c1.79-1.16,3.51-2.5,5.38-3.44c1.84-0.93,3.82-1.47,5.76-2.17c1.79-0.63,3.57-1.26,5.38-1.84 c0.89-0.28,1.82-0.46,2.73-0.71c1.17-0.31,2.37-0.58,3.52-0.94c0.98-0.31,1.92-0.84,2.9-1.14c1.6-0.5,3.23-0.84,4.83-1.32 c1.17-0.35,2.33-0.83,3.49-1.24c0.15-0.05,0.31-0.13,0.48-0.15c2.42-0.2,4.83-0.48,7.26-0.55c3.06-0.1,6.12,0.05,9.18-0.05 c1.39-0.05,2.76-0.46,4.14-0.71c0.36-0.07,0.74-0.1,1.11-0.1c2.96,0,5.92-0.02,8.87,0c1.19,0,2.32-0.03,3.49,0.65 c0.98,0.58,2.25,0.46,3.37,0.78c1.65,0.46,3.39,0.74,4.88,1.59c3.57,2.05,7.16,4.14,10.46,6.7c3.84,2.98,7.46,6.37,10.12,10.79 c1.89,3.13,3.62,6.4,5.33,9.66c1.92,3.66,3.81,7.35,5.56,11.12c1.12,2.4,1.97,4.95,2.94,7.41c0.84,2.12,1.7,4.24,2.53,6.35 c0.26,0.71,0.5,1.46,0.63,2.22c0.31,1.9,0.61,3.82,0.83,5.74c0.12,1.03,0,2.07,0.02,3.11c0.1,5.29-1.64,9.76-4.76,13.58 c-1.77,2.17-3.74,4-6.19,5.18c-2.13,1.03-4.07,2.51-6.17,3.62c-1.46,0.78-3.04,1.24-4.57,1.89c-1.75,0.74-3.46,1.57-5.21,2.32 c-0.83,0.35-1.72,0.53-2.58,0.84c-2.42,0.89-4.81,1.84-7.23,2.71c-2.5,0.93-5.03,1.77-7.53,2.7c-1.77,0.65-3.49,1.46-5.28,2.03 c-1.24,0.4-2.55,0.69-3.84,0.73c-4.57,0.08-9.15,0.13-13.73-0.02c-1.7-0.05-3.46-0.25-5.08-1.21c-0.76-0.45-1.74-0.46-2.6-0.71 c-1.29-0.38-2.6-0.69-3.85-1.19c-1.62-0.65-3.19-1.47-4.81-2.15c-1.7-0.71-3.44-1.29-5.13-1.99c-1.64-0.68-3.24-1.42-4.85-2.17 c-2.35-1.08-4.7-2.15-7.01-3.29c-1.12-0.55-2.17-1.27-3.28-1.87c-2.17-1.16-4.37-2.25-6.53-3.39c-1.92-1.01-3.81-2.12-5.74-3.06 c-2.71-1.31-5.46-2.51-8.21-3.76c-0.18-0.08-0.41-0.02-0.63-0.02c-0.25,0-0.5-0.02-0.74-0.02c-0.5-0.18-0.99-0.36-1.51-0.55 c-0.17,0-0.33-0.02-0.5-0.02c-1.89-0.38-3.77-0.78-5.67-1.11c-3.29-0.58-6.57-1.31-9.89-1.6c-2.42-0.22-4.86,0.13-7.3,0.3 c-0.36,0.02-0.86,0.3-1.04,0.63c-0.68,1.22-1.24,2.51-1.85,3.79c-0.17,0.18-0.33,0.38-0.5,0.56c-0.02,0.33-0.17,0.74-0.03,0.98 c0.65,1.12,1.34,2.18,2.03,3.28c0.5,0.94,1.01,1.89,1.51,2.83l0,0c0.99,1.7,2,3.39,2.99,5.1c0.25,0.2,0.5,0.4,0.74,0.58 c0,0.18,0,0.35-0.02,0.53c-0.03,0.2-0.15,0.48-0.07,0.6c0.68,1.14,1.39,2.25,2.08,3.37c0.17,0.28,0.33,0.56,0.5,0.84 c0.41,0.76,0.84,1.51,1.26,2.27c0.6,1.11,1.17,2.22,1.77,3.31c1.8,3.24,3.46,6.58,5.44,9.69c2.22,3.49,4.68,6.78,7.11,10.11 c2.76,3.77,5.59,7.49,8.42,11.22c3.64,4.8,7.26,9.6,10.97,14.31c0.86,1.09,2.02,1.89,3.03,2.81l0,0 c0.18,0.35,0.31,0.78,0.58,1.03c1.6,1.51,3.23,2.99,4.88,4.45c0.89,0.78,1.85,1.44,2.8,2.17l0,0c0.17,0.31,0.26,0.71,0.5,0.91 c3.57,3.29,7.16,6.55,10.75,9.81l0,0c1.41,1.34,2.78,2.71,4.2,4c0.98,0.88,2.03,1.65,3.04,2.48c0.08,0,0.17,0.02,0.25,0.02 c0.25,0.18,0.5,0.36,0.76,0.55c0.17,0,0.33,0.02,0.5,0.02c0.81,0.48,1.6,1.03,2.45,1.44c2.51,1.24,5.05,2.42,7.56,3.62 c0.58,0.18,1.17,0.38,1.75,0.56c1.26,0.28,2.5,0.56,3.76,0.84c0.25,0,0.5,0,0.76,0c1.14,0.2,2.27,0.56,3.41,0.53 c2.37-0.07,4.73-0.33,7.1-0.51c0.08,0,0.17,0,0.25,0s0.17,0,0.26,0h0.12h0.12c0.08,0,0.17,0,0.26,0c0.17,0,0.33,0,0.5,0 c0.08,0,0.17,0,0.26,0h0.12h0.12c0.08,0,0.17,0,0.26,0h0.12h0.12c0.08,0,0.17,0,0.26,0h0.12h0.12c0.08,0,0.17,0,0.26,0 c0.5,0,0.99,0,1.49-0.02c0.33,0,0.66,0,0.99,0c0.25-0.1,0.5-0.18,0.74-0.28c0.38-0.02,0.76,0.03,1.11-0.08 c2.88-0.98,5.74-1.99,8.6-2.99c3.46-1.22,6.93-2.45,10.39-3.72c1.32-0.48,2.6-1.11,3.89-1.67c0.08,0,0.17,0,0.25,0 c0.33-0.18,0.66-0.36,1.01-0.55c0.17,0,0.33-0.02,0.5-0.02c0.41-0.18,0.83-0.38,1.24-0.56c0.08,0,0.17,0,0.25,0 c0.91-0.38,1.84-0.76,2.75-1.12c0.08,0,0.17,0,0.25,0c2.33-1.46,4.67-2.91,6.98-4.37c0.02-0.02,0.02-0.08,0.02-0.13l0,0 c0.43-0.15,0.88-0.22,1.26-0.45c2.1-1.31,4.2-2.65,6.29-3.99c5.51-3.51,11.03-6.95,16.51-10.54c5.51-3.61,11.03-7.16,16.91-9.98 c1.22-0.6,2.35-1.46,3.52-2.2c0.08,0,0.17,0,0.25-0.02c0.28-0.08,0.56-0.1,0.81-0.23c1.74-0.96,3.41-2.03,5.18-2.88 c3.89-1.85,7.83-3.57,11.75-5.36c0.33-0.18,0.66-0.38,0.99-0.56c0.56-0.13,1.12-0.26,1.69-0.41c1.95-0.51,3.9-1.08,5.87-1.56 c2.33-0.58,4.68-1.11,7.03-1.6c1.29-0.28,2.6-0.46,3.9-0.68c0.33-0.1,0.66-0.18,0.99-0.28c1.17,0,2.33,0,3.51,0 c0.33,0,0.66,0,0.99,0c1.67,0.1,3.33,0.18,5,0.28c0.5,0,0.99,0.02,1.51,0.02c1.17,0.18,2.33,0.36,3.51,0.55 c0.25,0,0.5,0.02,0.74,0.02c1.34,0.56,2.66,1.12,4,1.7c0.41,0.18,0.83,0.36,1.26,0.55c3.24,1.21,6.55,2.25,9.71,3.71 c1.84,0.84,3.59,2.17,5.1,3.64c2.88,2.86,5.58,5.97,8.29,9.05c0.63,0.71,1.16,1.62,1.51,2.55c0.71,1.9-0.55,3.76-2.37,3.66 c-0.91-0.05-1.82,0-2.71,0c-0.36,0.07-0.74,0.07-1.09,0.2c-1.56,0.58-3.11,1.17-4.67,1.79c-1.8,0.94-3.61,1.85-5.38,2.83 c-1.59,0.88-3.04,2.23-4.95,1.92c-0.71-0.12-1.44-0.58-2.02-1.08c-1.03-0.86-1.94-1.89-2.9-2.83c-0.33-0.1-0.66-0.2-0.99-0.3 c-0.5-0.46-0.99-0.94-1.51-1.41c-0.25-0.18-0.5-0.38-0.74-0.56c-0.17-0.1-0.33-0.18-0.5-0.28c-0.74-0.56-1.51-1.12-2.25-1.7 c0-0.1,0-0.18-0.02-0.28c-1.84-0.74-3.66-1.51-5.49-2.25c-0.17,0-0.33-0.02-0.5-0.02c-1.99-0.58-3.95-1.04-5.97-0.18 c-0.84,0.36-1.74,0.58-2.63,0.74c-2.18,0.38-3.85,1.75-5.41,3.41c-0.33,0.2-0.66,0.38-0.99,0.58c-0.91,0.74-1.84,1.51-2.75,2.25 c-1.17,0.84-2.33,1.69-3.51,2.55c-1.31,0.88-2.66,1.67-3.92,2.63c-2.5,1.92-4.93,3.94-7.41,5.89c-4.3,3.41-8.57,6.85-12.9,10.19 c-2.25,1.74-4.5,3.62-6.96,4.88c-3.92,1.99-8.02,3.51-12.06,5.23c-0.78,0.28-1.56,0.53-2.32,0.86c-2.65,1.11-5.29,2.25-7.92,3.37 c-0.08,0-0.17,0-0.25,0s-0.17,0-0.26,0l0,0c-0.66,0.18-1.34,0.38-2,0.56c-0.08,0-0.17,0-0.25,0s-0.17,0-0.26,0 c-0.41,0.1-0.83,0.2-1.24,0.3c-0.41,0.05-0.83,0.03-1.22,0.13c-2.38,0.6-4.73,1.27-7.13,1.79c-3.89,0.84-7.79,1.67-11.7,2.33 c-2.73,0.46-5.48,0.66-8.22,0.98c-1.6,0.18-3.21,0.28-4.81,0.5c-2.17,0.3-4.32,0.84-6.49,0.99c-2.42,0.18-4.86,0.18-7.3,0.02 c-3.99-0.26-7.96-0.71-11.93-1.12c-1.44-0.15-2.86-0.45-4.27-0.74c-1.24-0.26-2.48-0.61-3.72-0.93 c-1.77-0.45-3.52-0.89-5.29-1.34c-1.95-0.5-3.92-0.96-5.87-1.49c-1.79-0.48-3.62-0.86-5.33-1.6c-2.78-1.21-5.46-2.68-8.19-4.05 c-0.25-0.1-0.5-0.18-0.74-0.28c-1.09-0.66-2.17-1.32-3.26-1.99c-0.25-0.1-0.5-0.18-0.74-0.28c-1.75-0.94-3.51-1.89-5.26-2.83 c-2.58-1.41-5.16-2.83-7.74-4.24c-0.17-0.1-0.33-0.18-0.5-0.28c-0.91-0.66-1.84-1.32-2.75-1.99c-3.51-2.51-7.03-5.03-10.54-7.54 c-2.8-1.99-5.61-3.94-8.37-5.99c-1.75-1.31-3.41-2.76-5.11-4.15c-1.24-0.99-2.48-1.97-3.72-2.96c-0.33-0.18-0.66-0.38-0.99-0.56 c-0.17-0.18-0.33-0.38-0.5-0.56c-1.67-1.89-3.34-3.77-5.01-5.64c-0.91-1.04-1.82-2.07-2.73-3.11c-0.41-0.48-0.83-0.94-1.24-1.42 l0,0c-0.22-0.38-0.41-0.79-0.66-1.14c-2.78-3.74-6.01-7.06-8.39-11.18c-2.18-3.77-4.38-7.53-6.53-11.32 c-2.91-5.1-5.77-10.22-8.67-15.35c-0.17-0.38-0.35-0.74-0.51-1.12c-1.08-3.03-2.15-6.06-3.26-9.07c-0.08-0.23-0.45-0.55-0.58-0.5 c-0.3,0.12-0.69,0.36-0.79,0.68c-1.06,3.23-2.07,6.49-3.09,9.74c0,0.18,0,0.38-0.02,0.56c-0.2,0.38-0.41,0.74-0.61,1.12 c-0.55,1.04-1.09,2.08-1.62,3.13c0,0.18-0.02,0.36-0.02,0.55c-0.17,0.3-0.33,0.58-0.5,0.88 C389.27,316.97,389.1,317.25,388.94,317.55z M516.07,237.84c0-0.08-0.02-0.15-0.02-0.23c-3.13,0.26-6.25,0.51-9.38,0.81 c-0.73,0.07-1.42,0.28-2.13,0.46c-1.22,0.3-2.46,0.61-3.69,0.94c-1.44,0.38-2.91,0.73-4.33,1.17c-2.15,0.69-4.3,1.41-6.42,2.22 c-1.94,0.74-3.85,1.59-5.74,2.5c-1.84,0.88-3.59,1.95-5.43,2.83c-1.39,0.66-2.85,1.17-4.27,1.75c-0.53,0.22-1.11,0.31-1.6,0.58 c-1.94,0.99-3.85,1.99-5.76,3.04c-2.22,1.24-4.42,2.48-6.58,3.82c-0.79,0.5-0.71,3.66,0.03,4.24c0.1,0.08,0.23,0.1,0.35,0.13 c0.74,0.2,1.51,0.41,2.25,0.56c2.53,0.5,5.08,0.93,7.61,1.44c2.63,0.53,5.28,0.79,7.83,1.9c1.69,0.73,3.51,1.14,5.31,1.44 c2.25,0.36,4.27,1.36,6.29,2.38c1.11,0.56,2.22,1.11,3.34,1.62c1.64,0.76,3.33,1.37,4.91,2.25c3.51,1.92,6.93,4.02,10.44,5.91 c1.64,0.88,3.37,1.56,5.13,2.07c2,0.6,4.07,1.24,6.12,1.31c5.08,0.18,10.16,0.07,15.24,0.05c0.41,0,0.81-0.12,1.22-0.2 c0.88-0.2,1.74-0.43,2.6-0.63c0.31-0.07,0.66-0.05,0.98-0.15c1.47-0.46,2.91-1.21,4.42-1.37c1.03-0.12,1.84-0.56,2.65-1.08 c0.93-0.6,1.97-1.11,2.7-1.95c0.91-1.08,2-2.37,2.23-3.74c0.5-2.99,0.93-6.07,0.38-9.18c-0.55-3.11-0.78-6.27-2.05-9.18 c-0.63-1.46-0.84-3.09-2.12-4.2c-2.51-2.15-4.43-5.1-7.25-6.85c-0.94-0.6-1.85-1.26-2.81-1.79c-1.79-0.99-3.54-2.15-5.44-2.81 c-2.13-0.74-4.37-1.11-6.58-1.46c-2.15-0.33-4.33-0.45-6.5-0.6C518.66,237.78,517.37,237.84,516.07,237.84z M269.37,283.06 c4.4,0.08,9.18-0.25,13.88-1.42c1.12-0.28,2.25-0.58,3.31-1.06c1.04-0.46,1.97-1.21,2.99-1.72c1.69-0.86,3.44-1.54,5.11-2.45 c3.34-1.82,6.6-3.87,9.98-5.59c2.27-1.14,4.68-1.9,7.05-2.8c0.65-0.25,1.34-0.35,1.99-0.61c1.69-0.69,3.34-1.51,5.06-2.12 c1.08-0.38,2.23-0.53,3.36-0.69c2.51-0.38,5.06-0.51,7.53-1.11c1.49-0.36,2.93-0.84,4.47-0.84c0.74,0,1.51-0.3,2.25-0.51 c0.26-0.07,0.56-0.22,0.73-0.45c0.84-1.21,0.69-3.51-0.45-4.28c-1.57-1.09-3.26-2-4.95-2.88c-1.74-0.91-3.51-1.69-5.26-2.53 c-2.9-1.42-5.79-2.85-8.69-4.28c-2.5-1.22-4.98-2.5-7.49-3.66c-1.44-0.66-2.94-1.17-4.45-1.67c-0.96-0.33-1.97-0.48-2.94-0.78 c-2.42-0.76-4.78-1.72-7.23-2.3c-2.81-0.66-5.67-1.34-8.52-1.37c-3.9-0.03-7.81-0.46-11.75,0.35c-1.95,0.4-3.99,0.53-5.96,0.99 c-1.14,0.26-2.28,0.53-3.39,0.93c-1.27,0.46-2.53,1.06-3.77,1.62c-1.79,0.81-3.71,1.41-5.33,2.53c-1.56,1.08-2.83,2.68-4.22,4.07 c-4.67,4.68-7.08,10.57-7.26,17.62c-0.03,1.12-0.02,2.27,0,3.39c0.02,1.08-0.23,2.28,0.1,3.23c1.24,3.49,2.88,6.65,6.72,7.06 c0.23,0.02,0.43,0.25,0.66,0.35c1.14,0.53,2.27,1.24,3.46,1.54c1.56,0.38,3.16,0.43,4.75,0.63c0.45,0.07,0.89,0.18,1.32,0.28 c0.84,0.18,1.69,0.48,2.53,0.53C266.3,283.12,267.64,283.06,269.37,283.06z"})})})})});const BackCaretIcon=({elClass:C})=>jsxRuntimeExports.jsx("svg",{className:C,viewBox:"0 0 11 20",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:jsxRuntimeExports.jsx("path",{d:"M10.1924 19.1924L1 10L10.1924 0.807617",stroke:"#14334C",strokeWidth:"1.2"})});const DownCaretIcon=({elClass:C})=>jsxRuntimeExports.jsx("svg",{xmlns:"http://www.w3.org/2000/svg",className:C,width:"16.872",height:"8.898",viewBox:"0 0 16.872 8.898",children:jsxRuntimeExports.jsx("path",{d:"M7.686,8.148-.51.55A.75.75,0,0,1-.55-.51.75.75,0,0,1,.51-.55L7.686,6.1,14.862-.55a.75.75,0,0,1,1.06.04.75.75,0,0,1-.04,1.06Z",transform:"translate(0.75 0.75)",fill:"#14334c"})});const FilterIcon=({elClass:s})=>jsxRuntimeExports.jsx("svg",{xmlns:"http://www.w3.org/2000/svg",className:s,width:"16.942",height:"13.816",viewBox:"0 0 16.942 13.816",children:jsxRuntimeExports.jsxs("g",{transform:"translate(-54.75 -379.5)",children:[jsxRuntimeExports.jsx("path",{d:"M15.442.75H0A.75.75,0,0,1-.75,0,.75.75,0,0,1,0-.75H15.442a.75.75,0,0,1,.75.75A.75.75,0,0,1,15.442.75Z",transform:"translate(55.5 381.125)",fill:"#3175B3"}),jsxRuntimeExports.jsx("path",{d:"M15.442.75H0A.75.75,0,0,1-.75,0,.75.75,0,0,1,0-.75H15.442a.75.75,0,0,1,.75.75A.75.75,0,0,1,15.442.75Z",transform:"translate(55.5 386.408)",fill:"#3175B3"}),jsxRuntimeExports.jsx("path",{d:"M15.442.75H0A.75.75,0,0,1-.75,0,.75.75,0,0,1,0-.75H15.442a.75.75,0,0,1,.75.75A.75.75,0,0,1,15.442.75Z",transform:"translate(55.5 391.691)",fill:"#3175B3"}),jsxRuntimeExports.jsx("circle",{cx:"1.625",cy:"1.625",r:"1.625",transform:"translate(66.472 379.5)",fill:"#3175B3"}),jsxRuntimeExports.jsx("circle",{cx:"1.625",cy:"1.625",r:"1.625",transform:"translate(62.483 390.066)",fill:"#3175B3"}),jsxRuntimeExports.jsx("circle",{cx:"1.625",cy:"1.625",r:"1.625",transform:"translate(57.442 385)",fill:"#3175B3"})]})});const SortIcon=({elClass:s})=>jsxRuntimeExports.jsx("svg",{xmlns:"http://www.w3.org/2000/svg",className:s,width:"20.5",height:"12.5",viewBox:"0 0 20.5 12.5",children:jsxRuntimeExports.jsxs("g",{transform:"translate(-96.75 -381.75)",children:[jsxRuntimeExports.jsx("path",{d:"M19,.75H0A.75.75,0,0,1-.75,0,.75.75,0,0,1,0-.75H19a.75.75,0,0,1,.75.75A.75.75,0,0,1,19,.75Z",transform:"translate(97.5 382.5)",fill:"#3175B3"}),jsxRuntimeExports.jsx("path",{d:"M12.73.75H0A.75.75,0,0,1-.75,0,.75.75,0,0,1,0-.75H12.73a.75.75,0,0,1,.75.75A.75.75,0,0,1,12.73.75Z",transform:"translate(100.5 388)",fill:"#3175B3"}),jsxRuntimeExports.jsx("path",{d:"M6.27.75H0A.75.75,0,0,1-.75,0,.75.75,0,0,1,0-.75H6.27A.75.75,0,0,1,7.02,0,.75.75,0,0,1,6.27.75Z",transform:"translate(103.5 393.5)",fill:"#3175B3"})]})});const FilterCloseIcon=({elClass:s})=>jsxRuntimeExports.jsx("svg",{xmlns:"http://www.w3.org/2000/svg",className:s,width:"20",height:"20",viewBox:"0 0 20 20",children:jsxRuntimeExports.jsxs("g",{transform:"translate(-337.454 -14)",children:[jsxRuntimeExports.jsx("path",{d:"M18,19a1,1,0,0,1-.707-.293l-18-18a1,1,0,0,1,0-1.414,1,1,0,0,1,1.414,0l18,18A1,1,0,0,1,18,19Z",transform:"translate(338.454 15)",fill:"#14334c"}),jsxRuntimeExports.jsx("path",{d:"M0,19a1,1,0,0,1-.707-.293,1,1,0,0,1,0-1.414l18-18a1,1,0,0,1,1.414,0,1,1,0,0,1,0,1.414l-18,18A1,1,0,0,1,0,19Z",transform:"translate(338.454 15)",fill:"#14334c"})]})});const SearchIcon=({elClass:C})=>jsxRuntimeExports.jsx("svg",{xmlns:"http://www.w3.org/2000/svg",className:C,width:"20.718",height:"20.813",viewBox:"0 0 20.718 20.813",children:jsxRuntimeExports.jsx("g",{transform:"translate(0 0)",children:jsxRuntimeExports.jsx("path",{d:"M19.483,20.813a1.161,1.161,0,0,1-.855-.38l-6.082-6.082a8.154,8.154,0,0,1-4.657,1.426A8.068,8.068,0,0,1,2.281,13.5,8.068,8.068,0,0,1,0,7.888,7.828,7.828,0,0,1,2.281,2.281,7.99,7.99,0,0,1,7.888,0a8.048,8.048,0,0,1,5.7,2.281,7.756,7.756,0,0,1,2.376,5.7,7.4,7.4,0,0,1-1.521,4.657l5.892,5.892a1.22,1.22,0,0,1,.38.95,1.161,1.161,0,0,1-.38.855l-.1.1C20.148,20.718,19.768,20.813,19.483,20.813ZM7.983,2.186A6.287,6.287,0,0,0,3.9,3.9,5.442,5.442,0,0,0,2.281,7.983a5.841,5.841,0,0,0,5.8,5.8,5.915,5.915,0,0,0,4.087-1.711h0a5.38,5.38,0,0,0,1.711-4.087A5.915,5.915,0,0,0,12.165,3.9,6.33,6.33,0,0,0,7.983,2.186Z",transform:"translate(0 0)",fill:"#ff8f77"})})});const PalmIcon=({elClass:s})=>jsxRuntimeExports.jsx("svg",{className:s,id:"palm-tree",viewBox:"0 0 792 612",xmlns:"http://www.w3.org/2000/svg",children:jsxRuntimeExports.jsx("g",{id:"_x39_H8RuD_00000065055646828125831840000017369912187890143890_",children:jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{className:"st0",d:"M368.8,145.8c-2.3-2.7-4.7-5.5-7-8.1c-4.5-5.3-7.5-11.1-9-17.9c-0.3-1.7-2-3.5-3.5-4.7     c-5.8-4.2-12.3-7.5-17.8-12.1c-4.2-3.5-8-8-11-12.6c-4.5-7-3.7-9.5,2.3-15.1c-6-3.3-12-6.6-17.6-10.1c-3.8-2.3-7.1-5.3-10.6-8.1     c-3.3-2.7-4.7-6.3-4-10.6c1-7.3,4.5-13.3,10.8-16.8c2.8-1.5,7.5-2,10.1-0.7c18.9,9.1,39.2,15.4,56.8,27.6     c9.3,6.5,15,15.4,20.4,24.6c10.3,17.3,18.8,35.2,21.3,55.5c1.3,11.5,1.8,23.1,2.7,34.7c0,0.7,0,1.3,0,3c0.8-1.7,1.3-2.3,1.5-3.2     c5-16.1,13.8-30.1,25.4-41.9c26.6-27.2,56.8-49.5,90.7-66.8c6-3,12.8-4.5,19.3-6c5.8-1.3,9,1.5,9,7.8c-0.2,7.3-1,14.8-1.7,22.1     c-0.3,3.5-1.2,7.1-1.7,10.6c-1.7,9.1-6,16.3-15.3,19.8c-7,2.5-6.8,3-3.7,9.5c5.6,12,0.2,23.8-13.6,28.1c-5.6,1.8-11.8,2-17.8,3     c-5.1,0.8-5.1,1-3.7,5.8c2.8,8.6,1,14-6.6,19.6c-9.3,6.8-20.1,10.6-31.7,13.6c4.8,2.7,9.1,5.1,13.6,7.6     c23.4,12.5,39,31.9,51.5,54.8c9.5,17.3,16.3,35.4,18.8,54.8c1.2,8.6-0.2,17.6-0.7,26.4c-0.2,2-1.5,4.2-2.7,5.8     c-2.3,3.2-6.1,3.8-9.1,1.2c-3.5-3-6.3-6.6-9.6-9.8c-4-3.7-7.8-7.8-12.5-10.5c-9.3-5.3-14.3-12.8-16.3-23.3     c-1.7-9.3-4.5-18.3-6.6-27.4c-0.3,0-0.8,0-1.2,0c-0.7,1-1.2,2-1.8,3c-4.3,7.6-12.8,9.5-18.9,3.2c-3.3-3.3-5.5-7.8-7.5-12.3     c-2.2-5-3.3-10.5-5.1-15.6c-0.8-2.5-2.3-4.8-3.7-7.1c-1.5-2.5-3.5-4-7-3.2c-3.7,0.8-7-1-9.6-3.8c-5.6-6.3-11.1-12.6-16.8-18.9     c-2.5-3-5.6-5.3-9.6-6c-0.7-0.5-1.5-1-2.2-1.5c-4,1.5-4.5,5.1-5.3,8.5c-2,3.7-4,7.3-6,11c-2,3.8-4.7,6.6-9.5,6.8     c-1,0-2.5,1.5-2.8,2.5c-1,3.8-1.8,7.6-2.3,11.5c-0.7,5.8-0.7,11.8-1.8,17.4c-1.3,6.6-7,10.8-12.8,9.6c-3-0.7-5.5-2.8-8.6-4.7     c0,2.3,0,5,0,7.6c0,7,0,14.1,0.3,21.1c0.2,4.8-1.2,9.5-4.5,12.6c-7,6.6-11.6,14.8-15.6,23.4c-1.3,2.7-3.2,5.3-6.5,5.1     c-3.5-0.2-6.1-2.5-7.1-5.6c-2.5-8.1-5.8-16.3-6.6-24.6c-2.8-25.3,2.8-49.3,12.5-72.6c6.3-15.1,17.6-26.6,29.4-37.4     c2.3-2,4.7-4,7.3-6.1c-1.5-0.3-2.8-0.7-4.3-1c-7.3-2-14-4.8-14.8-13.8c0-0.7-1.8-1.7-2.7-1.7c-3,0.2-6.1,0.5-9.1,1.3     c-9.1,2.5-18.1,5.6-27.2,8c-5.8,1.5-12.1,2.3-18.1,2.2c-7.8-0.2-12.5-5.3-14.6-13.5c-3.5,2.2-6.6,4.2-9.6,6.3     c-5.5,3.8-10.6,7.8-17.6,9c-8.6,1.3-13.6-2.5-14.5-11.3c-1-11.8,2.8-21.8,10.5-30.7C254,143,265,132,280.8,128.6     c22.8-5.1,45.2-3.8,66.6,6.6c7.1,3.5,14,7.3,21.1,11.1c0.3,0,0.5,0.2,0.8,0.2C369.2,146.3,369,146.2,368.8,145.8z M417,186.2     c0.5-0.5,1.2-0.8,1.7-1.5c14.8-18.6,31.4-35.4,49-51.3c21.1-18.9,42.4-37.4,63.6-56.1c4.8-4.3,9.8-8.5,14.6-12.8     c-1.5-0.5-2.8-0.3-3.8,0.2c-6.3,2.8-12.8,5.1-18.8,8.6c-19.8,11.3-38.2,24.8-55.8,39c-15.8,12.8-30.4,26.7-39.9,45.2     C423,166.6,418.7,175.7,417,186.2c-0.3,0.2-0.5,0.5-0.7,0.8c0.2,0,0.3,0.2,0.3,0.2C416.8,186.9,417,186.5,417,186.2z     M393.8,178.7c0.3,0,0.5,0.2,0.8,0.2c-0.2-0.2-0.3-0.3-0.5-0.5c-0.7-1-1.3-2.2-2.2-3.2c-17.1-19.3-38.4-32.2-62.8-39.4     c-16.8-5-33.9-5.3-50.5,1c-16.3,6.3-28.4,17.4-35.7,33.4c-1.5,3.5-2.2,7.5-3.3,11.8c6-5,11-9.3,16.3-13.5     c12.1-9.3,25.6-16.1,41.2-17.3c19.4-1.3,38.5,1.5,57.3,6.6C368.8,162.1,382,168.9,393.8,178.7z M418.3,196.8     c0.2,0.5,0.3,1,0.5,1.5c16.3-3.7,32.7-6.6,48.8-11c8-2.2,15.8-5.8,23.1-9.8c6.1-3.3,7-8.6,3.8-14.8c-2.3-4.5-1.2-8,3.5-10     c2.2-1,4.7-1.5,7-2c3.8-0.7,7.8-1,11.8-1.7c5.3-0.8,10.1-3,13.3-7.6c3.5-5.1,2.5-10-0.8-15c-4.5-6.8-3-11.3,4.3-14.6     c2-1,4-1.8,6-2.7c4.7-1.8,7.5-5.1,8.6-10c0.8-3.8,2.2-7.6,2.7-11.6c0.8-6.1,1.3-12.5,2-18.6C504.4,108.8,456,147.3,418.3,196.8z     M243.6,189.7c0.2,0.5,0.3,1,0.7,1.5c2.3-0.8,5-1.5,7.1-2.7c6.8-3.8,13.3-8.1,20.1-12.1c6.6-3.8,9.8-2.3,11.1,5.1     c0.7,3.8,3.2,6.3,7.1,6.8c1.8,0.2,3.7,0.5,5.3,0c8-1.8,15.8-4,23.8-5.8c8.1-2,16.3-4,24.6-5.5c5.8-1,8.6,1,10.1,6.3     c1.8,6.8,4,8.6,11,9.5c5.8,0.7,11.6,1.5,17.4,2.2c5.6,0.7,11.1,1.2,17.1,1.7c-5.1-10.6-17.4-21.3-30.7-26.9     c-19.6-8.1-40.4-11.3-61.3-12.1C280.3,157,260.4,170.4,243.6,189.7z M530.6,331.4c0-0.3,0-0.8-0.2-1.3     c-3.8-16.9-10.5-32.9-18.3-48.2c-16.3-32.1-40-56.6-74.4-69.3c-6.6-2.5-13.3-3-20.3-2.5c7.3,8.3,14.5,16.6,21.8,24.4     c1.5,1.5,4.3,2.3,6.5,2.2c3.7-0.3,6.6,0.7,8.8,3.5c2,2.7,4.3,5.5,5.6,8.6c2.3,5.8,4,12.1,6.1,18.1c1.3,3.3,3,6.8,5.1,9.6     c3,3.7,6.5,2.8,8.6-1.5c1-2,1.7-4,2.8-5.8c2.7-4.2,6.6-4.3,9.6-0.5c1.3,1.8,3,3.8,3.5,5.8c2,7.3,3.7,14.6,5.3,21.9     c1.7,7.6,3.2,15.4,9.6,20.8C517.3,322.1,524,326.6,530.6,331.4z M398.1,170.4c0.3-0.2,0.5-0.2,0.8-0.3c-2.3-7-4.8-14-7.1-20.9     c-7.6-22.8-16.8-44.7-32.4-63.3c-9.1-11-17.4-22.9-30.6-29.7c-9.5-5-18.9-9.6-28.7-14.6c-3.5,4-3.5,7.8,0.8,12     c2,1.8,4.2,3.5,6.5,4.8c7.3,4.3,14.6,8.5,21.9,12.6c2.2,1.2,4.3,2.7,3.3,5.3c-0.7,1.8-2.5,3.8-4.3,4.5c-3,1.2-3.2,3-2.5,5.5     c0.3,1.3,1.3,2.5,2.2,3.5c5.5,7.1,12.5,12.5,20.3,16.6c6.3,3.3,10.5,7.8,12.5,15.1c1.3,4.5,4,8.8,7,12.6     c4.8,6.3,10.5,12,15.4,17.9C388.3,158,393.1,164.3,398.1,170.4z M334.1,328.9c0.3,0,0.8,0,1.2,0c2.8-3.7,5.5-7.6,8.8-11     c4.8-5,7-10.6,6.8-17.3c-0.2-5-1.2-10-1-15c0.2-5.1,0.7-10.5,2-15.3c1.3-4.8,5.3-5.3,9-1.8c1.2,1.2,2.2,2.5,3.2,3.8     c2.5,3,5.5,2.8,7.3-0.7c0.7-1.2,1-2.7,1.2-4c0.5-6.6,0.7-13.3,1.7-19.8c1-6.6,2.2-13.6,11-15c1.3-0.2,3-1.7,3.7-3     c4-7.8,8-15.6,11.8-23.4c-0.2-0.3-0.3-0.7-0.3-1c-4.7,2.2-9.6,3.8-14,6.5c-18.6,11.6-30.1,29.2-39.2,48.5     c-5.3,11.5-8.1,23.9-9.8,36.5C335.9,307.6,335.1,318.3,334.1,328.9z M304.4,35.2c0,0.3,0,0.7,0,0.8c1.7,0.8,3.3,1.7,5,2.5     c6.5,3.5,12.8,6.8,19.3,10.3c3.7,2,7.6,3.3,10.6,6c17.4,15,31.7,32.7,42.5,53c9.8,18.3,15.6,38,22.4,57.5c0.5,1.3,1,2.7,1.5,4     c0.5-0.2,1-0.2,1.5-0.3c-1.5-12.8-2.3-25.6-4.5-38.2c-3.3-19.1-12.6-35.7-22.6-52.2c-4.3-7.1-9.3-13.5-16.4-17.8     c-16.8-10.5-35.1-17.9-53.2-25.6C308.7,34.5,306.4,35.2,304.4,35.2z M538.9,339.7c0.2-0.7,0.8-1.8,0.8-2.8     c-0.2-9.6,1.2-19.6-1.2-28.6c-10.8-43.5-31.6-79.9-73.4-101.7c-10.1-5.3-19.3-4.3-29.2-1.7c26.9,7.1,49.5,27.1,63.8,44.5     c17.6,21.4,27.9,46.7,36,72.8C537.6,327.7,537.9,333.9,538.9,339.7z M328,334.4c-0.2-50.3,10.5-96.2,54.7-128.6     c-5.3,0.8-10.6-0.7-15.3,3c-13.3,10.8-24.6,23.1-31.7,38.9c-6.5,14.6-10,30.1-12.1,45.7C321.5,307.8,323.3,321.6,328,334.4z     M398.9,171.9l0.2-0.2h-0.2V171.9z M395.1,180.4l0.2-0.2h-0.2V180.4z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M400.9,222.2c1-3.3,1.3-7,5.3-8.5c1.2,9,2.3,17.9,3.7,26.7c6.1-0.7,6.1-1.5,4.8-5.5     c-2-6.5-4.2-13.1-6.1-19.6c4,0.7,7.1,3,9.6,6c3.5,15,7.8,29.7,10.5,44.7c3.3,18.4,6.1,37,7.5,55.8c2.7,34.6,4.7,69.1,5.8,103.8     c0.7,20.8-0.8,41.7-1.5,62.5c-0.2,7.5-0.7,14.8-1,22.3c-0.8,23.1-1.7,46-2.3,69.1c-0.2,2.7-1.2,4.3-3.7,4.3     c-12.6,0-25.3-0.2-37.9-0.3c-3.7,0-4.7-2.2-4.3-5.3c1-10.8,2.2-21.6,3.2-32.4c2-19.4,4.2-38.9,5.8-58.3c2-22.6,3.7-45.4,5.1-68.1     c1-15.4,1.8-30.9,2.5-46.3c0.5-11,1-22.1,0.7-33.1c-0.5-18.3-1.7-36.5-2.7-54.8c-0.8-13.6-1.7-27.2-2.7-41     C402.6,236.9,401.6,229.6,400.9,222.2z M410.5,438.9c-1.2,17.8-2.5,35.5-3.5,53.2c0,1,1.2,2.7,2.2,3.2c7.6,3.7,15.6,3.7,24.3,2     c0.5-19.8,1.2-39.2,1.7-58.1C426.6,438.9,419,438.9,410.5,438.9z M431,545.2c-9.5-0.3-18.3-0.8-27.2-0.8c-1,0-2.5,2-2.7,3.3     c-0.5,3.3-0.5,6.8-0.8,10.3c-0.7,6.6-1.5,13.3-2.2,20.8c10.6,0,20.4,0,30.4,0C429.3,567.4,430.1,556.8,431,545.2z M402.9,538     c9.3,0,18.8,0,28.4,0c0.5-11,1-22.1,1.5-32.2c-9.3-1-17.9-1.8-26.4-2.7C405.4,514.1,404.2,525.7,402.9,538z M413.4,393.8     c-0.5,11.8-1.2,23.4-1.5,35.1c0,1,1.3,2.7,2.5,3c5.8,1.7,11.6,1,17.4-0.5c2.5-0.7,3.3-1.3,3.3-4c-0.2-6.5-0.2-13.1-0.3-19.6     c-0.2-4.8-0.7-9.6-1-14.1C426.8,393.8,420.3,393.8,413.4,393.8z M433.5,386.4c-0.8-15.4-1.5-30.2-2.2-44.9c-5.6,0-10.5,0-15.1,0     c-0.7,14.3-1.3,28.1-2,42c-0.2,2.7,1.2,4.2,4,4C422.8,387.2,427.8,386.9,433.5,386.4z M417.7,246.2c-7,0-8.1,1.5-7.5,8     c1,9,1.8,18.1,2.3,27.1c0.3,5.8,0,11.6,0,17.6c4.5-0.3,7.8-0.3,11.3-0.8c2.2-0.3,3.5-1.5,2.8-4.3c-1-4.2-1.2-8.3-2-12.5     C422.3,269.6,420,257.8,417.7,246.2z M427.8,304c-5.1,0.8-9.8,1.5-14.8,2.2c0.7,9.1,1.2,17.9,1.8,26.9c0,0.8,1.7,2,2.5,2     c4.2,0,8.3-0.3,13-0.7C429.5,323.7,428.6,313.9,427.8,304z"})]})})})});const DuckIcon=({elClass:s,fillColor:a})=>jsxRuntimeExports.jsx("svg",{id:"duck-icon",className:s,viewBox:"0 0 792 612",fill:a,xmlns:"http://www.w3.org/2000/svg",children:jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{className:"st0",d:"M241.54,414.88c0.26-0.03,0.52-0.07,0.78-0.07c0.26,0.23,0.56,0.49,0.82,0.72c0.69,0.46,1.37,0.95,2.06,1.4    c5.78,5.88,11.36,11.98,17.47,17.53c2.94,2.68,6.82,4.34,10.42,6.2c0.69,0.36,2.02-0.52,3.07-0.82c3.33,2.97,7.09,4.47,11.66,3.98    c2.55-0.29,5.16-0.03,7.74-0.03c1.04-0.26,2.09-0.56,3.13-0.82c5.26-1.04,10.87-1.24,15.64-3.36c7.58-3.33,13.09-9.57,18.35-15.93    c7.15-8.65,17.53-10.58,25.66-1.24c3.33,3.82,6.14,8.26,10.06,11.3c6.5,5.03,13.55,9.11,22.14,10.38    c16.65,2.48,30.5-2.22,41.79-14.63c2.61-2.87,5.13-5.88,7.9-8.62c6.5-6.43,17.57-5.91,23.67,0.98c0.49,0.52,0.98,1.08,1.47,1.6    c0.82,1.31,1.6,2.58,2.42,3.89c0.75,0.78,1.53,1.57,2.29,2.38c3.82,3.07,7.48,6.43,11.56,9.14c2.38,1.57,5.81,1.63,8.2,3.2    c5.52,3.62,11.49,2.19,17.34,2.42c1.53,0.07,3.17-0.85,4.57-0.56c3.46,0.78,6.37,0.56,8.52-2.58c2.16,0.72,4.05,0.42,6.01-0.91    c10.09-6.86,18.25-15.71,26.15-24.85c3.33,0.56,6.69,1.08,10.02,1.63c0.52,0.26,1.04,0.52,1.57,0.78    c3.95,4.28,7.87,8.59,11.82,12.83c7.18,7.74,16.13,11.89,26.58,12.96c0.26,0.26,0.52,0.49,0.78,0.75c1.8,0.26,3.56,0.69,5.35,0.72    c3.07,0.07,6.37,0.69,8.72-2.22c0.33,0.46,0.65,0.91,1.01,1.37c0.46-0.46,0.91-0.91,1.34-1.37c7.22-0.42,12.83-4.57,18.71-8.13    c4.24-2.58,8.46-2.94,11.23-0.75c4.77,3.75,5.22,10.74,0.72,15.31c-5.71,5.78-13.16,8.52-20.47,11.62    c-9.66,4.11-19.85,3.92-29.58,2.68c-11.79-1.53-23.18-5.62-32.26-14.17c-2.35-2.22-4.6-4.54-6.92-6.76    c-2.94-2.81-6.17-2.38-9.93,0.91c-4.08,3.59-8.1,7.38-12.6,10.35c-9.8,6.5-20.6,10.25-32.52,9.96    c-5.98-0.16-11.92-0.52-17.86-0.78c-0.26-0.26-0.52-0.49-0.78-0.75c-8.78-2.12-16.59-6.24-23.61-11.82    c-3.72-2.97-7.25-6.2-10.87-9.31c-0.26-0.26-0.52-0.49-0.78-0.75c-2.16,0.98-4.54,1.63-6.43,3c-6.37,4.64-12.15,10.25-18.97,14.11    c-7.74,4.41-16.36,6.86-25.66,6.43c-5.68-0.26-11.36,0.39-17.08,0.65c-0.2-0.39-0.42-0.78-0.62-1.18    c-0.33,0.42-0.62,0.82-0.95,1.24c-5.13-2.71-10.51-5.03-15.31-8.23c-6.04-4.02-11.59-8.72-17.37-13.09    c-3.98-3.04-6.99-3.07-10.29,0.59c-8.55,9.53-19.07,15.51-31.41,18.51c-10.35,2.51-20.64,2.12-30.99-0.13    c-11.17-2.42-20.28-8.42-28.7-15.77c-1.14-1.01-1.99-2.35-3.04-3.49c-3.3-3.53-6.04-3.53-9.08,0.13    c-9.4,11.33-21.84,18.29-35.92,20.21c-11.59,1.6-23.93,2.35-35.33-3.17c-3.43-1.67-7.28-2.45-10.91-3.72    c-3.36-1.14-5.88-5.26-5.78-9.27c0.1-4.18,2.61-8.39,6.27-8.91c3.46-0.49,7.18-0.33,10.61,0.39c5.55,1.21,10.55,3.82,16.52,4.6    c7.44,0.95,14.3,1.24,21.26-1.24c8.82-3.13,15.77-8.78,21.55-16.06c3.56-4.44,7.31-8.85,13.06-10.68c0.52,0,1.04,0,1.57-0.03    c0.52,0,1.01,0.03,1.53,0.03C240.98,415.33,241.24,415.11,241.54,414.88z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M552.48,415.56c-7.9,9.14-16.06,17.99-26.15,24.85c-1.96,1.34-3.85,1.63-6.01,0.91    c2.97-3.62,6.27-7.09,8.88-10.97c3.98-5.88,7.58-12.05,11.17-18.19c0.72-1.24,0.52-3,1.01-4.41c0.62-1.7,1.63-3.23,2.25-4.93    c0.46-1.18,0.42-2.48,0.85-3.66c1.4-3.89,3.92-7.71,4.05-11.59c0.13-4.21,0.88-7.67,3.1-10.84c6.95-22.79,9.4-46.27,10.91-69.88    c0.2-0.52,0.39-1.08,0.59-1.6c0.07-5.32,0.59-10.68,0.1-15.93c-0.65-7.25-2.02-14.4-3.07-21.62c-0.46-0.95-0.88-1.93-1.34-2.87    c-0.16-0.62-0.29-1.21-0.46-1.83c-0.95-1.4-1.89-2.81-3.2-4.73c-1.21,1.73-1.99,2.84-2.74,3.95c-1.14,1.53-2.32,3.07-3.46,4.57    c-2.32,2.02-4.64,4.08-6.92,6.11c-2.32,1.11-4.64,2.22-6.95,3.3c-0.78,0.26-1.57,0.52-2.35,0.78c-8,1.08-15.93,2.55-23.97,3.13    c-6.5,0.49-13.06,0.07-19.62-0.16c-3.33-0.13-6.69-0.56-9.99-1.04c-5.62-0.82-11.23-1.76-16.82-2.64    c-0.78-0.23-1.57-0.49-2.35-0.72c-6.24-1.34-12.51-2.68-18.74-4.02c-0.52-0.2-1.08-0.39-1.6-0.59c-3.92-0.85-7.8-1.7-11.72-2.51    c-0.52-0.2-1.08-0.39-1.6-0.59c-1.8-0.39-3.56-0.78-5.35-1.18c-0.82-0.13-1.63-0.29-2.48-0.42c-1.04-0.07-2.06-0.1-3.1-0.16    c-0.52-0.2-1.08-0.39-1.6-0.62c-2.81-0.29-5.58-0.82-8.39-0.85c-8.33-0.1-16.69-0.29-24.98,0.07c-4.54,0.2-8.1-0.78-10.61-4.67    c-0.2-1.08-0.36-2.16-0.56-3.27c0.07-6.63,0.29-13.26,0.2-19.88c-0.13-9.11-1.08-18.12-5.81-26.25c-0.78-1.57-1.6-3.13-2.38-4.7    c-2.58-3.95-5.16-7.87-7.71-11.82c0-0.26-0.07-0.49-0.2-0.72c-3.33-3.43-6.66-6.82-9.99-10.25c-1.08-1.01-2.16-2.02-3.23-3    c-2.84-2.09-5.68-4.18-8.55-6.3c-0.46-0.29-0.91-0.59-1.37-0.88c-1.11-0.72-2.22-1.4-3.33-2.12c-2.84-1.4-5.68-2.81-8.55-4.21    c-2.61-0.98-5.16-2.16-7.87-2.84c-12.54-3.2-25.14-5.81-38.24-4.08c-1.67,0.23-3.46-0.52-5.19-0.85c0.1,0.16,0.23,0.29,0.33,0.46    c-5.22,1.5-10.45,3-15.67,4.47c-0.49,0.29-0.98,0.59-1.47,0.88c-3.23,1.96-6.47,3.95-9.7,5.91c-0.46,0.29-0.91,0.56-1.37,0.85    c-2.09,1.57-4.15,3.17-6.24,4.73c-1.04,0.75-2.12,1.47-3.17,2.22c-2.61,2.61-5.22,5.22-7.87,7.87c-1.04,1.04-2.06,2.12-3.1,3.17    c-0.98,1.04-1.96,2.12-2.94,3.17c-2.48,3.46-4.96,6.92-7.48,10.38c-0.75,0.95-1.5,1.93-2.22,2.87c-1.47-0.39-3.07-0.52-4.38-1.21    c-1.76-0.98-3.27-2.38-4.87-3.62c-0.03-0.56-0.07-1.08-0.1-1.63c4.47-5.98,8.95-11.95,13.42-17.89c0.26-0.23,0.52-0.42,0.78-0.65    l0,0c0.72-0.52,1.47-1.04,2.19-1.57c2.16-2.35,4.28-4.67,6.43-7.02c0.46-0.52,0.91-1.04,1.34-1.57    c4.83-3.56,9.47-7.41,14.56-10.61c4.34-2.74,9.04-5.06,13.88-6.89c5.06-1.89,10.42-2.97,15.64-4.41c1.67-0.46,3.3-1.04,5.29-1.67    c2.97,0.26,6.5,0.59,10.02,0.88c6.01,0.49,12.02,1.01,18.02,1.44c9.21,0.65,17.73,3.85,26.25,7.02c0.49,0.52,1.01,1.04,1.5,1.57    c2.32,1.11,4.64,2.19,6.99,3.3c0.26,0.2,0.56,0.42,0.82,0.62c1.27,0.56,2.55,1.11,3.82,1.7c0.29,0.2,0.59,0.39,0.88,0.59    c0.49,0.33,0.98,0.65,1.47,0.98c0.29,0.2,0.59,0.39,0.88,0.59c8.88,5.55,16.2,12.7,22.14,21.32c0.46,0.52,0.91,1.08,1.37,1.6    c3.75,5.13,7.77,10.12,9.53,16.39c0.75,1.27,1.5,2.55,2.22,3.82c5.39,14.04,5.03,28.7,4.54,43.82c6.79,0,13.26,0,19.72,0    c1.73,0,3.46-0.13,5.16,0.1c8.39,1.01,16.85,1.63,25.11,3.27s16.26,4.51,24.49,6.4c8.49,1.96,17.01,3.95,25.63,5.03    c8.95,1.11,18.06,1.8,27.07,1.53c8.36-0.26,16.75-1.24,24.62-5.06c4.8-2.35,8.1-5.84,11.04-9.96c5.06-7.05,13.39-9.5,20.24-4.44    c4.02,2.94,6.27,8.26,7.35,13.55c0.85,4.11,2.35,8.2,2.58,12.34c0.56,9.53,0.59,19.1,0.65,28.67c0.03,5.39,0.03,10.78-0.46,16.13    c-0.42,4.64-1.53,9.21-2.45,13.78c-0.46,2.29-1.73,4.57-1.63,6.79c0.29,7.44-0.33,14.73-2.68,21.84c-0.72,2.16-0.52,4.6-1.21,6.79    c-1.5,4.9-3.46,9.7-4.87,14.63c-1.14,3.98-1.73,8.13-2.61,12.18c-0.07,0.36-0.49,0.65-0.59,1.01    C556.07,403.38,554.28,409.46,552.48,415.56z M203.37,196.99c-0.23,0.42-0.46,0.88-0.69,1.31c1.24,0.65,2.51,1.27,3.75,1.93    c0.2-0.33,0.39-0.69,0.59-1.01C205.82,198.49,204.58,197.74,203.37,196.99z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M276.18,439.82c-1.04,0.29-2.38,1.18-3.07,0.82c-3.59-1.86-7.48-3.53-10.42-6.2    c-6.11-5.55-11.69-11.66-17.47-17.53c-0.69-0.46-1.37-0.95-2.06-1.4c-0.26-0.23-0.56-0.49-0.82-0.72    c-1.18-3.43-2.55-6.82-3.43-10.32c-1.14-4.44-1.76-9.01-2.78-13.49c-2.32-10.25-2.94-20.64-2.29-31.05    c0.42-7.02,1.6-13.98,2.45-20.93c0.52-0.95,1.18-1.83,1.53-2.81c2.06-5.35,4.05-10.78,6.07-16.16c0.49-0.49,0.98-1.01,1.47-1.5    c1.93-2.84,3.89-5.71,5.81-8.55c0.29-0.16,0.59-0.33,0.88-0.49c-0.36-0.1-0.69-0.23-1.04-0.33c-5.52-3.36-11.07-6.76-16.59-10.12    c-0.75-0.75-1.5-1.5-2.25-2.25c-1.18-1.08-2.35-2.12-3.53-3.2c-1.18-1.14-2.38-2.32-3.56-3.46c-1.27-1.24-2.55-2.48-3.82-3.72    c-0.59-0.59-1.18-1.18-1.8-1.73c0-0.29-0.16-0.46-0.46-0.52c-0.59-0.75-1.18-1.5-1.73-2.25c-0.78-1.24-1.63-2.42-2.32-3.69    c-1.86-3.56-4.41-6.89-3.95-11.23c3.17-1.14,6.3-2.32,9.47-3.46c2.06,3.75,4.15,7.51,6.2,11.26c0.56,0.59,1.14,1.18,1.7,1.76    c3.4,3.56,6.82,7.12,10.22,10.68c0.98,0.82,1.96,1.63,2.94,2.48c0.59,0.49,1.21,0.95,1.8,1.44c0.72,0.52,1.44,1.08,2.16,1.6l0,0    c1.31,0.78,2.61,1.57,3.89,2.35c2.06,1.04,4.15,2.12,6.2,3.17c0.26,0.13,0.52,0.29,0.78,0.42c3.46,2.19,6.92,4.38,10.38,6.56    c-0.82,2.02-1.6,4.02-2.42,6.04c-0.46,1.14-0.95,2.25-1.4,3.36c-0.56,0.91-1.14,1.83-1.7,2.74c-1.04,1.18-2.06,2.35-3.1,3.53    c-0.33,0.49-0.62,1.01-0.95,1.5c-1.83,2.87-3.66,5.75-5.45,8.62c-0.2,0.26-0.42,0.52-0.62,0.78c-0.85,3.36-1.7,6.76-2.51,10.12    c-0.2,0.29-0.39,0.56-0.59,0.85c-0.29,1.57-0.59,3.13-0.85,4.7c-3.04,11.92-3.04,23.93-0.52,35.92c1.04,5.03,2.84,9.93,4.31,14.89    c1.14,3.92,2.32,7.84,3.46,11.79c0.85,1.6,1.7,3.2,2.55,4.8c0.85,1.34,1.7,2.68,2.51,4.05c0.82,1.24,1.63,2.45,2.48,3.69    c4.15,5,8.33,9.96,12.47,14.95c0.56,0.49,1.11,0.98,1.67,1.44C276.08,439.27,276.15,439.56,276.18,439.82z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M220.45,263.5c-3.17,1.14-6.3,2.32-9.47,3.46c-0.26,0.07-0.52,0.13-0.82,0.2c-0.23-0.13-0.46-0.16-0.69-0.1    c-0.52,0-1.08,0.03-1.6,0.03c-7.51-0.33-15.05-0.42-22.56-1.01c-10.84-0.85-20.11-5.29-28.21-12.6    c-7.51-6.79-13.13-15.25-16.2-24.39c-2.81-8.33-3.98-17.93,1.93-26.32c3.2-4.54,5.71-5.49,11.36-4.15    c2.51,0.59,5.03,1.14,7.54,1.7c0.49,0.26,1.01,0.52,1.5,0.78c9.14,0.29,18.29,0.62,27.46,0.82c1.63,0.03,3.27-0.52,4.9-0.78    c0.42-0.03,0.88-0.07,1.31-0.1c1.6,1.24,3.13,2.64,4.87,3.62c1.27,0.72,2.91,0.85,4.38,1.21c0.85,1.83,1.7,3.66,2.55,5.49    c1.27,1.08,2.55,2.16,3.82,3.23c5.26,7.51,9.66,15.38,9.6,24.95C221.59,247.54,221,255.5,220.45,263.5z M192.95,211.26    c-9.47-0.23-18.97-0.23-28.44-0.75c-4.08-0.23-8.1-1.6-12.18-2.22c-2.64-0.39-4.83,0.56-4.77,3.66c0.1,4.18,0.16,8.42,0.88,12.54    c1.24,7.09,4.8,13.45,9.6,18.48c14.07,14.66,32.16,16.55,51.13,14.4c1.21-0.13,3.1-2.02,3.2-3.23c0.46-5.65,1.08-11.46,0.33-17.01    c-0.56-4.31-2.32-8.91-4.87-12.44c-3.53-4.9-8.29-8.95-12.51-13.35c-0.33-0.46-0.69-0.88-1.01-1.34    C193.9,210.38,193.44,210.8,192.95,211.26z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M376.23,208.97c-0.75-1.27-1.5-2.55-2.22-3.82C374.73,206.4,375.48,207.67,376.23,208.97z"}),jsxRuntimeExports.jsx("path",{className:"st4",d:"M619.68,442.99c-0.46,0.46-0.91,0.91-1.34,1.37c-0.33-0.46-0.65-0.91-1.01-1.37    C618.11,443.02,618.9,442.99,619.68,442.99z"}),jsxRuntimeExports.jsx("path",{className:"st5",d:"M382.46,464.87c0.33-0.42,0.62-0.82,0.95-1.24c0.2,0.39,0.42,0.78,0.62,1.18    C383.51,464.8,382.99,464.84,382.46,464.87z"}),jsxRuntimeExports.jsx("path",{className:"st6",d:"M196.94,201.04c-0.42,0.03-0.88,0.07-1.31,0.1c0.39-0.56,0.82-1.14,1.21-1.7    C196.87,199.96,196.9,200.52,196.94,201.04z"}),jsxRuntimeExports.jsx("path",{className:"st7",d:"M241.54,414.88c-0.26,0.23-0.52,0.46-0.82,0.69C240.98,415.33,241.24,415.11,241.54,414.88z"}),jsxRuntimeExports.jsx("path",{className:"st4",d:"M452.14,440.61c0.26,0.26,0.52,0.49,0.78,0.75C452.67,441.1,452.4,440.84,452.14,440.61z"}),jsxRuntimeExports.jsx("path",{className:"st4",d:"M603.26,444.49c-0.26-0.26-0.52-0.49-0.78-0.75C602.73,444,602.99,444.26,603.26,444.49z"}),jsxRuntimeExports.jsx("path",{className:"st0",d:"M487.37,462.52c0.26,0.26,0.52,0.49,0.78,0.75C487.9,463.01,487.64,462.75,487.37,462.52z"}),jsxRuntimeExports.jsx("path",{className:"st8",d:"M295.58,443.74c1.04-0.26,2.09-0.56,3.13-0.82C297.67,443.19,296.62,443.48,295.58,443.74z"}),jsxRuntimeExports.jsx("path",{className:"st7",d:"M243.14,415.5c0.69,0.46,1.37,0.95,2.06,1.4C244.51,416.45,243.82,415.99,243.14,415.5z"}),jsxRuntimeExports.jsx("path",{className:"st6",d:"M203.37,196.99c1.21,0.75,2.45,1.47,3.66,2.22c-0.2,0.33-0.39,0.69-0.59,1.01c-1.24-0.65-2.51-1.27-3.75-1.93    C202.91,197.87,203.14,197.45,203.37,196.99z"}),jsxRuntimeExports.jsx("path",{className:"st9",d:"M369.79,260.01c-1.76-0.82-3.27-1.67-0.56-3.27C369.4,257.85,369.6,258.93,369.79,260.01z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M266.75,305.27c0.39,1.14,1.47,2.71,1.08,3.36c-1.34,2.19-3.23,4.05-4.9,6.04c0.46-1.11,0.95-2.25,1.4-3.36    C265.15,309.28,265.93,307.26,266.75,305.27z"}),jsxRuntimeExports.jsx("path",{className:"st10",d:"M228.61,293.61c-1.18-1.14-2.38-2.32-3.56-3.46C226.22,291.29,227.4,292.43,228.61,293.61z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M261.23,317.41c-1.04,1.18-2.06,2.35-3.1,3.53C259.14,319.76,260.18,318.59,261.23,317.41z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M245.49,292.73c1.31,0.78,2.61,1.57,3.89,2.35C248.07,294.29,246.8,293.51,245.49,292.73z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M238.6,287.21c0.98,0.82,1.96,1.63,2.94,2.48C240.56,288.84,239.58,288.03,238.6,287.21z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M234.39,299.03c-0.75-0.75-1.5-1.5-2.25-2.25C232.89,297.53,233.64,298.28,234.39,299.03z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M243.3,291.13c0.72,0.52,1.44,1.08,2.16,1.6C244.74,292.17,244.02,291.65,243.3,291.13z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M218.98,284.17c-0.59-0.75-1.18-1.5-1.73-2.25C217.8,282.67,218.39,283.42,218.98,284.17z"}),jsxRuntimeExports.jsx("path",{className:"st11",d:"M251.11,309.97c-0.03-0.26-0.1-0.56-0.13-0.82c0.36,0.1,0.69,0.23,1.04,0.33    C251.73,309.64,251.4,309.8,251.11,309.97z"}),jsxRuntimeExports.jsx("path",{className:"st3",d:"M255.58,298.25c0.26,0.13,0.52,0.29,0.78,0.42C256.1,298.54,255.84,298.38,255.58,298.25z"}),jsxRuntimeExports.jsx("path",{className:"st12",d:"M195.4,211.29c-0.82,0-1.63,0-2.42-0.03c0.46-0.42,0.95-0.88,1.4-1.31    C194.72,210.38,195.04,210.84,195.4,211.29z"}),jsxRuntimeExports.jsx("path",{className:"st13",d:"M495.11,359.6c1.5,2.84,3.04,5.68,4.47,8.55c1.63,3.23,0.03,12.6-2.61,15.48c-1.4,1.53-2.91,2.94-4.34,4.44    c-0.26,0-0.42,0.1-0.56,0.33c-0.88,0.65-1.73,1.34-2.61,1.99c-1.99,1.34-4.02,2.71-6.01,4.05c-4.47,2.58-8.75,5.49-13.42,7.58    c-4.21,1.89-8.78,2.91-13.22,4.28c-0.29,0.2-0.59,0.39-0.85,0.62c-6.11,1.31-12.28,2.42-18.29,4.02    c-6.66,1.8-13.45,1.18-20.18,1.53c-13.55,0.72-26.64-1.8-39.61-5.16c-9.31-2.42-18.19-5.98-27-9.96    c-6.5-2.94-12.77-6.04-18.64-9.99c-0.2-0.16-0.42-0.36-0.62-0.52c-1.11-0.62-2.19-1.21-3.3-1.83c-0.23-0.23-0.46-0.46-0.65-0.69    c-3.59-1.8-7.15-3.59-6.2-8.62c1.04-1.4,2.06-2.84,3.1-4.24c3.82-1.47,6.92,0.33,10.06,2.12c1.08,0.62,2.12,1.37,3.17,2.09    c0.29,0.16,0.56,0.36,0.85,0.52c1.01,0.62,2.06,1.21,3.07,1.83c0.29,0.16,0.59,0.36,0.91,0.52c8.2,3.98,16.13,8.52,24.62,11.79    c8,3.1,16.49,4.93,24.85,7.12c1.47,0.39,3.23-0.26,4.83-0.42c0.49-0.07,1.14-0.29,1.5-0.1c9.01,5.06,18.64,3,28.11,2.25    c5.49-0.42,10.94-1.4,16.33-2.45c1.83-0.36,3.49-1.53,5.26-2.35c0.46-0.2,0.88-0.52,1.37-0.59c2.42-0.39,5.16-0.1,7.22-1.14    c9.14-4.64,18.09-9.63,27.07-14.6c3-1.63,3.1-3.53,1.18-6.56c-1.99-3.13-2.38-7.25-4.34-10.38c-3.49-5.55-7.09-11.2-11.62-15.84    c-5.58-5.68-12.08-10.55-18.42-15.44c-2.71-2.09-6.07-3.36-9.14-5.03c-0.29-0.2-0.59-0.42-0.88-0.62    c-4.44-1.47-8.82-3.04-13.32-4.31c-1.83-0.52-3.82-0.39-5.75-0.56c-3.07-0.26-6.11-0.49-9.18-0.82c-3.72-0.39-6.27-3.95-6.17-8.55    c0.49-0.52,1.01-1.04,1.5-1.6c2.78-4.11,6.95-2.19,10.55-2.16c3.27,0,6.53,0.75,9.8,1.18c1.04,0.29,2.09,0.56,3.13,0.85    c1.04,0.26,2.09,0.52,3.13,0.78c0.78,0.1,1.57,0.2,2.35,0.29c1.76,0.59,3.56,1.18,5.32,1.76c0.82,0.42,1.63,0.85,2.48,1.24    l-0.03-0.03c0.42,0.03,0.85,0.07,1.27,0.1l0.16,0.23c0.59,0.36,1.18,0.72,1.76,1.04c7.51,4.57,15.05,9.18,22.56,13.75    c1.08,0.95,2.19,1.89,3.27,2.84c2.74,2.45,5.71,4.67,8.16,7.38c1.83,1.99,2.97,4.6,4.47,6.92c2.16,3.36,4.38,6.73,6.56,10.06    C493.35,356.3,494.23,357.97,495.11,359.6z"}),jsxRuntimeExports.jsx("path",{className:"st0",d:"M264.26,212.14c-0.75-1.04-1.53-2.09-2.29-3.13c-0.29-0.78-0.59-1.53-0.85-2.32    c-1.63-4.9-2.48-9.86,0.75-14.37c3.82-5.35,8.33-5.26,12.38-0.13c0.56,0.69,1.18,1.34,1.76,1.99c0.78,0.52,1.6,1.04,2.38,1.53    c3.95,2.55,8.42,5.16,6.86,10.74c-0.82,2.94-3.46,5.39-5.29,8.07c-0.52,0.26-1.04,0.49-1.6,0.75c-3.72,0.75-7.44,1.67-10.94-0.69    c-0.52-0.56-1.08-1.08-1.6-1.63C265.28,212.7,264.75,212.44,264.26,212.14z"})]})})});const BoatIcon=({elClass:s,fillColor:a})=>jsxRuntimeExports.jsx("svg",{id:"boat-icon",className:s,viewBox:"0 0 792 612",fill:a,xmlns:"http://www.w3.org/2000/svg",children:jsxRuntimeExports.jsx("g",{id:"_x31_GtWAG_00000052794896688026488630000002467731542195200141_",children:jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{className:"st0",d:"M490.83,442.55c5.69,0,11.38,0,17.06,0c7.58,0,15.17,0,22.75,0c12.64,0,25.29,0,37.92,0 c4.31,0,8.64,0,12.95,0c10.31,0,20.65,0,31.41,0c-1.99,2.68-3.74,5.12-5.57,7.5c-15,19.42-30.01,38.85-45.03,58.27 c-3.98,5.14-7.97,10.29-11.97,15.41c-1.5,1.91-3.25,2.95-5.9,2.95c-94.74-0.06-189.49-0.06-284.23-0.02 c-1.75,0-3.5,0.49-5.25,0.55c-0.71,0.02-1.63-0.3-2.11-0.79c-3.4-3.7-6.77-7.46-10.04-11.28c-2.48-2.89-4.76-5.98-7.28-8.84 c-2.2-2.52-4.72-4.76-6.93-7.28c-2.52-2.85-4.76-5.94-7.28-8.82c-2.2-2.52-4.72-4.76-6.93-7.28c-2.52-2.87-4.78-5.96-7.3-8.84 c-2.22-2.52-4.72-4.78-6.95-7.3c-2.48-2.83-4.7-5.88-7.2-8.72c-2.18-2.48-4.66-4.68-6.81-7.18c-2.48-2.87-4.74-5.94-7.09-8.92 c1.83,0,3.72-0.08,5.59,0.02c2.81,0.14,5.65,0.55,8.46,0.55c95.59,0.04,191.18,0.02,286.77,0.02c0.79,0,1.57,0,2.36-0.02 C485.14,442.55,488,442.55,490.83,442.55z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M227.92,393.27c0.31-0.22,0.63-0.43,0.94-0.63c0.53-0.53,1.06-1.04,1.57-1.57c0.22-0.1,0.41-0.22,0.63-0.31 c0.63-0.63,1.26-1.26,1.89-1.89c0.31-0.22,0.63-0.43,0.94-0.63c0.63-0.63,1.26-1.26,1.91-1.89c5.04-5.2,10.02-10.45,15.13-15.55 c4.15-4.15,8.54-8.05,12.71-12.2c2.32-2.32,4.41-4.88,6.59-7.34c0.41-0.41,0.85-0.85,1.26-1.26c0.63-0.63,1.26-1.26,1.89-1.89 c0.31-0.31,0.63-0.63,0.94-0.94c4.53-5.47,9.05-10.96,13.6-16.43c0.53-0.53,1.04-1.06,1.57-1.57c3.27-4.11,6.53-8.21,9.8-12.32 c0.53-0.53,1.04-1.06,1.57-1.57c1.57-2.2,3.21-4.35,4.7-6.61c4.64-6.99,9.29-13.95,13.82-21.02c5.59-8.7,11.43-17.26,16.45-26.29 c6.87-12.34,13.3-24.94,19.42-37.67c5.86-12.2,11.12-24.72,16.57-37.12c3.21-7.3,6.44-14.6,9.41-22 c3.5-8.76,6.75-17.61,10.1-26.45c0.12-0.33,0.16-0.71,0.22-1.06c0.31-0.41,0.63-0.85,0.94-1.26c0.87-2.93,1.75-5.86,2.6-8.8 c0.28-0.94,0.39-1.93,0.57-2.89c0.31-0.41,0.63-0.85,0.94-1.26c0.49-2.81,3.44-4.96,6.95-5.06c0.22-0.1,0.43-0.2,0.63-0.31 c0.53,0,1.06,0,1.57,0c0.31,0.1,0.63,0.22,0.94,0.31c3.05,0.69,5.25,2.46,6.24,5.39c0.61,1.81,0.98,3.78,0.98,5.69 c0.04,96.18,0.04,192.36,0.1,288.52c0,2.05-0.61,3.39-2.26,4.39c-0.41,0.41-0.85,0.85-1.26,1.26c-1.22,0.53-2.44,1.5-3.68,1.52 c-8.11,0.14-16.22,0.1-24.33,0.06c-24.99-0.1-50.01-0.18-75-0.35c-2.79-0.02-5.59-0.75-8.38-0.75c-2.68,0-5.33,0.75-8.01,0.75 c-30.05-0.04-60.12-0.18-90.18-0.3c-0.39,0-0.79-0.2-1.18-0.3c-1.06-0.63-2.11-1.26-3.17-1.89c-0.31-0.31-0.63-0.63-0.94-0.94 c-0.22-1.38-0.41-2.74-0.63-4.11c0.1-0.41,0.22-0.85,0.31-1.26c0.41-0.31,0.83-0.63,1.26-0.94l0,0c0.41-0.41,0.85-0.85,1.26-1.26 c0.31-0.1,0.63-0.22,0.94-0.31c1.26-0.41,2.52-0.85,3.8-1.26l0,0c0.85-0.53,1.69-1.06,2.52-1.57l0,0 c0.73-0.41,1.48-0.85,2.2-1.26c0.31-0.22,0.63-0.41,0.94-0.63c0.22-0.1,0.41-0.22,0.63-0.31l0,0c0.53-0.31,1.06-0.63,1.57-0.94 l0,0c2.83-2.01,5.69-4,8.52-6l0,0c0.41-0.41,0.85-0.85,1.26-1.26c0.1,0,0.22,0,0.31,0c0.94-0.85,1.89-1.67,2.85-2.52 c0.22-0.1,0.41-0.22,0.63-0.31c0.53-0.53,1.06-1.04,1.57-1.57c0.22-0.1,0.41-0.22,0.63-0.31 C226.85,394.31,227.38,393.8,227.92,393.27z M401.93,146.24c-0.33,0.79-0.59,1.34-0.83,1.91c-4.11,10.19-8.07,20.45-12.34,30.58 c-5.02,11.87-10.27,23.64-15.47,35.43c-3.37,7.66-6.51,15.43-10.31,22.87c-5.71,11.16-11.59,22.26-17.95,33.06 c-7.42,12.56-15.23,24.9-23.28,37.06c-4.74,7.16-10.12,13.91-15.47,20.63c-7.56,9.45-15.1,18.93-23.12,27.97 c-7.14,8.05-14.86,15.59-22.48,23.2c-6.42,6.44-12.99,12.69-19.58,18.95c-3.27,3.09-6.67,6.04-10.1,8.95 c-2.13,1.81-4.37,3.46-6.99,5.51c1.02,0.1,1.48,0.16,1.91,0.18c17.42,0.12,34.84,0.24,52.25,0.3c5.35,0.02,10.73-0.26,16.08-0.28 c4.57,0,9.13,0.26,13.72,0.28c26.49,0.14,52.98,0.22,79.49,0.33c4.11,0.02,8.23,0.1,12.32-0.08c0.77-0.04,1.91-1.06,2.16-1.85 c0.43-1.36,0.39-2.89,0.39-4.35c0.02-18.01,0.12-36.02-0.08-54.04c-0.04-3.94,0.69-7.85-0.87-11.97 c-1.2-3.19-0.24-7.18-0.24-11.32c0.65,0.73,0.85,0.94,1.06,1.18c-0.28-1.46-0.81-2.87-0.77-4.27 c0.55-24.25-0.06-48.49,0.63-72.78c1-35.56,0.08-71.17-0.04-106.77C402.03,146.79,401.99,146.65,401.93,146.24z M273.26,418.24 c0.12,0.18,0.26,0.35,0.37,0.53c3.46,0.45,6.91,0.91,10.37,1.34c0.3,0.04,0.61-0.14,0.92-0.18c1.71-0.26,3.4-0.69,5.12-0.71 c7.97-0.08,15.96-0.04,23.93-0.04c20.35,0,40.72,0,61.07,0c9.84,0,19.68-0.14,29.52,0.08c3.94,0.08,4.43-1.38,4.43-4.53 c0-92.48,0.02-184.96-0.02-277.44c0-3.88-0.2-7.77-0.73-11.59c-0.18-1.26-1.61-3.15-2.66-3.27c-1.22-0.14-3.21,1-3.84,2.16 c-1.5,2.74-2.38,5.83-3.5,8.76c-3.96,10.27-7.7,20.65-11.93,30.82c-5.18,12.46-10.71,24.78-16.12,37.14 c-5.2,11.83-9.74,24.01-15.84,35.37c-9.11,16.96-19.27,33.36-29.13,49.91c-4.7,7.89-9.41,15.82-14.8,23.22 c-6.79,9.37-14.19,18.3-21.49,27.26c-5.12,6.28-10.45,12.4-15.88,18.42c-3.37,3.74-7.12,7.12-10.65,10.73 c-5.1,5.24-10.02,10.65-15.23,15.76c-4.98,4.88-10.19,9.55-15.43,14.15c-4.17,3.66-8.48,7.16-12.81,10.63 c-2.5,2.01-5.16,3.84-7.73,5.77c0.14,0.28,0.28,0.55,0.41,0.85c1.08-0.49,2.15-1.02,3.25-1.44c1.85-0.71,3.9-1.04,5.53-2.05 c2.58-1.61,5-3.54,7.3-5.55c6.34-5.57,12.65-11.18,18.83-16.95c2.52-2.34,4.49-5.27,6.93-7.71c2.89-2.87,6.16-5.39,9.07-8.27 c5.57-5.51,11.18-11.02,16.45-16.81c5.53-6.08,10.86-12.36,15.98-18.8c10.21-12.81,20.8-25.35,29.09-39.64 c6.63-11.43,14.05-22.4,21.02-33.63c1.91-3.07,3.5-6.36,5.14-9.6c1.16-2.28,2.09-4.66,3.21-6.97c2.56-5.24,5.27-10.41,7.77-15.67 c2.07-4.35,3.84-8.82,5.86-13.17c2.03-4.37,4.41-8.58,6.3-13.01c2.15-5.04,3.78-10.29,5.88-15.33c1.06-2.58,2.85-4.84,4.01-7.38 c1.18-2.58,1.85-5.37,2.99-7.97c1.77-4.03,3.86-7.95,5.61-11.99c1.65-3.86,3.05-7.81,4.55-11.73c0.79-2.07,1.61-4.09,2.22-6.22 c0.26-0.85-0.45-2.32-0.02-2.7c1.18-1.02,2.7-2.13,4.17-2.24c2.09-0.18,3.68,1.2,4,3.44c0.31,2.15,0.63,4.33,0.63,6.49 c0.04,87.86,0.02,175.69,0.02,263.55c0,3.29-2.03,5.06-5.31,5.29c-3.11,0.24-6.42-1.14-9.33,1.02c-0.14,0.1-0.59-0.31-0.92-0.37 c-1.16-0.18-2.32-0.39-3.5-0.39c-1.16,0-2.32,0.39-3.46,0.31c-2.81-0.22-5.61-0.91-8.4-0.91c-26.67,0.14-53.35,0.37-80.02,0.59 c-4.62,0.04-9.27,0.06-13.89-0.02c-2.09-0.04-4.15-0.55-6.24-0.53C275.31,417.06,274.28,417.83,273.26,418.24z M244.84,419.82 c7.68,0,15.37,0.02,23.05-0.02c0.89,0,1.79-0.1,2.62-0.37c0.49-0.16,0.85-0.75,1.26-1.14c-0.47-0.22-0.94-0.63-1.42-0.63 c-2.05,0.02-4.07,0.26-6.12,0.28c-14.21,0.02-28.42,0-42.63,0.06c-0.63,0-1.26,0.55-1.87,0.85c0.63,0.33,1.26,0.96,1.91,0.96 C229.37,419.84,237.11,419.82,244.84,419.82z M219.08,419.78c-1.02-0.96-1.44-1.59-2.01-1.89c-2.36-1.16-4.72-2.36-7.18-3.25 c-1.02-0.37-2.4-0.16-3.5,0.18c-1.85,0.55-3.66,1.36-5.39,2.2c-0.35,0.18-0.67,1.34-0.47,1.55c0.49,0.55,1.3,1.12,1.99,1.12 C207.74,419.84,213,419.78,219.08,419.78z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M430.18,191.01c0.22,0,0.41,0,0.63,0c0.75,0.31,1.48,0.63,2.22,0.94l0,0c1.26,2.2,2.52,4.43,3.8,6.63 c2.52,6.79,4.92,13.64,7.62,20.35c3.6,8.95,7.32,17.89,11.22,26.71c5.16,11.67,10.23,23.4,15.9,34.84 c4.39,8.88,9.47,17.42,14.5,25.96c4.98,8.44,10.12,16.83,15.57,24.99c3.5,5.25,7.64,10.1,11.59,15.08 c4.13,5.22,8.31,10.41,12.6,15.47c2.66,3.13,5.51,6.06,8.38,8.99c4.19,4.29,8.52,8.4,12.67,12.73 c8.09,8.42,16.35,16.67,25.84,23.5c4.09,2.93,8.66,5.22,13.15,7.6c2.3,1.22,4.03,3.39,2.76,5.85c-0.85,1.61-3.64,3.09-5.59,3.13 c-15.11,0.26-30.23,0.1-45.34,0.14c-29.72,0.08-59.46,0.2-89.17,0.31c-6.97,0.04-13.95,0.22-20.92,0.3 c-2.09,0.02-5.61-3.52-5.61-5.57c0-73.15-0.02-146.29,0.06-219.44c0-1.89,0.98-3.78,1.52-5.67c0.53-0.53,1.04-1.04,1.57-1.57 c0.94-0.41,1.89-0.85,2.83-1.26C428.68,191.01,429.43,191.01,430.18,191.01z M487.68,328.17c-0.22-0.31-0.41-0.63-0.63-0.94 c-3.68-5.69-7.38-11.38-11.06-17.06c-0.22-0.31-0.41-0.63-0.63-0.94c-1.69-2.95-3.37-5.9-5.06-8.86 c-0.1-0.22-0.22-0.41-0.31-0.63c-0.41-0.73-0.85-1.48-1.26-2.2c-0.1-0.22-0.22-0.41-0.31-0.63c-0.41-0.73-0.85-1.48-1.26-2.2 c-0.22-0.41-0.41-0.85-0.63-1.26c-1.38-2.52-2.74-5.06-4.11-7.58c-0.1-0.22-0.22-0.41-0.31-0.63c-0.85-1.89-1.69-3.8-2.52-5.69 c-0.41-0.85-0.85-1.69-1.26-2.52c-0.53-1.16-1.06-2.32-1.57-3.48c-0.22-0.41-0.41-0.85-0.63-1.26c-0.63-1.69-1.26-3.37-1.89-5.06 c-0.53-1.06-1.04-2.11-1.57-3.17c-0.85-1.69-1.69-3.37-2.52-5.06c-0.22-0.63-0.41-1.26-0.63-1.89c-0.31-0.85-0.63-1.69-0.94-2.52 c-0.1-0.22-0.22-0.41-0.31-0.63c-0.31-0.73-0.63-1.48-0.94-2.2c-0.1-0.22-0.22-0.41-0.31-0.63c-0.31-0.73-0.63-1.48-0.94-2.2 c-0.1-0.22-0.22-0.41-0.31-0.63c-0.31-0.73-0.63-1.48-0.94-2.2c-0.1-0.22-0.22-0.41-0.31-0.63c-0.31-0.73-0.63-1.48-0.94-2.2 c-0.1-0.22-0.22-0.41-0.31-0.63c-0.31-0.73-0.63-1.48-0.94-2.2c-0.1-0.22-0.22-0.41-0.31-0.63c-0.73-1.69-1.48-3.37-2.2-5.06 c-0.1-0.22-0.22-0.41-0.31-0.63c-0.31-0.73-0.63-1.48-0.94-2.2c-0.22-0.41-0.41-0.85-0.63-1.26c-0.85-1.89-1.69-3.8-2.52-5.69 c-0.22-0.53-0.41-1.06-0.63-1.57c-0.31-1.04-0.63-2.11-0.96-3.15c-0.22-0.41-0.41-0.85-0.63-1.26c-0.22-0.94-0.41-1.89-0.63-2.83 c-0.22-0.63-0.43-1.24-0.65-1.87c-0.31,0.55-0.89,1.12-0.89,1.67c0.06,15.06,0.26,30.09,0.26,45.15 c0.04,46.55,0.02,93.11,0.02,139.66c0,4.47-0.02,8.95,0.02,13.42c0,0.35,0.39,0.69,0.61,1.04c0.63-0.22,1.26-0.41,1.89-0.63 c0.31,0.1,0.63,0.22,0.94,0.31c0.22,0,0.43,0,0.63,0c0.69,0.31,1.38,0.89,2.09,0.91c5.29,0.08,10.59,0.08,15.88,0.02 c4.51-0.04,9.03-0.28,13.54-0.3c9.84-0.04,19.7,0,29.54-0.06c0.61,0,1.22-0.59,1.83-0.91c1.38,0,2.74,0,4.11,0 c0.94,1.46,1.89,1.46,2.85,0c2.85,0,5.69,0,8.54,0c0.77,1.36,2.46,1.36,3.48,0c1.16,0,2.32,0,3.48,0 c0.53,0.35,1.04,0.92,1.63,1.04c0.94,0.2,1.95-0.04,2.89,0.14c1.3,0.24,1.91-0.14,1.79-1.5c1.57,0.1,3.17,0.22,4.74,0.31 c0.41,0.22,0.83,0.59,1.24,0.59c10.25,0.04,20.49,0.04,30.74,0c0.45,0,0.92-0.41,1.38-0.63c-0.49-0.2-0.96-0.39-1.46-0.59 c-0.41-0.41-0.85-0.85-1.26-1.26c-0.73-0.73-1.48-1.48-2.2-2.2c-0.85-0.75-1.69-1.48-2.52-2.22c-0.41-0.41-0.85-0.85-1.26-1.26 c-0.22-0.1-0.41-0.22-0.63-0.31c-0.31-0.31-0.63-0.63-0.94-0.94c-0.22-0.22-0.41-0.41-0.63-0.63c-0.41-0.31-0.85-0.63-1.26-0.94 c-0.41-0.31-0.85-0.63-1.26-0.94c-0.41-0.41-0.85-0.85-1.26-1.26c-0.22-0.1-0.41-0.22-0.63-0.31c-0.39-0.87-0.61-1.95-1.24-2.58 c-3.25-3.29-6.57-6.46-9.92-9.64c-0.37-0.35-0.98-0.49-1.48-0.73c-0.41-0.41-0.85-0.85-1.26-1.26c-0.41-0.41-0.85-0.85-1.26-1.26 c-1.16-1.16-2.32-2.32-3.48-3.48c-0.85-0.94-1.69-1.89-2.54-2.83l0,0c-0.63-0.31-1.26-0.63-1.89-0.94 c-0.85-1.06-1.69-2.11-2.52-3.17c-0.73-0.85-1.48-1.69-2.2-2.52c-0.53-0.73-1.06-1.48-1.57-2.2c-0.85-0.75-1.67-1.48-2.52-2.22 c-0.1-0.22-0.22-0.41-0.31-0.63c-0.31-0.31-0.63-0.63-0.94-0.94c-0.31-0.41-0.63-0.85-0.94-1.26c-0.63-0.75-1.26-1.48-1.89-2.22 c-0.63-0.85-1.26-1.69-1.91-2.52c-0.41-0.53-0.85-1.06-1.26-1.57c0-0.1,0-0.22,0-0.31c-0.31-0.31-0.63-0.63-0.94-0.94 c-0.1-0.22-0.22-0.41-0.31-0.63c-0.22-0.31-0.43-0.63-0.63-0.94c-0.1-0.1-0.22-0.22-0.31-0.31c-0.31-0.31-0.63-0.63-0.94-0.94 c0-0.1,0-0.22,0-0.31c-0.41-0.41-0.85-0.85-1.26-1.26c0-0.1,0-0.22,0-0.31c-0.31-0.31-0.63-0.63-0.94-0.94c0-0.1,0-0.22,0-0.31 c-0.41-0.41-0.85-0.85-1.26-1.26c0-0.1,0-0.22,0-0.31c-0.31-0.31-0.63-0.63-0.94-0.94c0-0.1,0-0.22,0-0.31 c-0.31-0.41-0.63-0.85-0.94-1.26c-0.1-0.1-0.22-0.22-0.31-0.31c-0.31-0.31-0.63-0.63-0.94-0.94c0-0.1,0-0.22,0-0.31 c-0.31-0.41-0.63-0.85-0.94-1.26c-0.1-0.1-0.22-0.22-0.31-0.31c-0.31-0.31-0.63-0.63-0.94-0.94c0-0.1,0-0.22,0-0.31 c-0.31-0.31-0.63-0.63-0.94-0.94c0-0.1,0-0.22,0-0.31c-0.41-0.41-0.85-0.85-1.26-1.26c0-0.1,0-0.22,0-0.31 c-0.31-0.31-0.63-0.63-0.94-0.94c0-0.1,0-0.22,0-0.31c-0.41-0.41-0.85-0.85-1.26-1.26c0-0.1,0-0.22,0-0.31 c-0.31-0.31-0.63-0.63-0.94-0.94c0-0.1,0-0.22,0-0.31"}),jsxRuntimeExports.jsx("path",{className:"st0",d:"M406.79,88.32c4.76-4.41,10.1-4.25,15.67-1.93c4.74,1.97,7.16,10.16,4.76,14.68 c-1.61,3.07-3.72,5.71-6.87,6.63c-4.27,1.26-8.66,1.02-12.5-2.01c-4.64-3.68-6.65-9.76-2.03-16.41 C406.15,88.96,406.48,88.65,406.79,88.32z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M219.06,400.85c-2.83,2.01-5.69,4-8.52,6C213.37,404.86,216.23,402.85,219.06,400.85z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M436.81,198.61c-1.26-2.2-2.52-4.43-3.8-6.63C434.27,194.18,435.53,196.4,436.81,198.61z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M195.05,416.65c0.22,1.38,0.41,2.74,0.63,4.11C195.48,419.39,195.27,418.03,195.05,416.65z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M202.65,411.59c-1.26,0.41-2.52,0.85-3.8,1.26C200.11,412.44,201.37,412.03,202.65,411.59z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M196.62,421.71c1.06,0.63,2.11,1.26,3.17,1.89C198.73,422.97,197.69,422.34,196.62,421.71z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M223.49,397.07c-0.94,0.85-1.89,1.67-2.85,2.52C221.6,398.74,222.54,397.89,223.49,397.07z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M235.83,386.32c-0.63,0.63-1.26,1.26-1.91,1.89C234.55,387.58,235.18,386.95,235.83,386.32z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M433.01,191.97c-0.75-0.31-1.48-0.63-2.22-0.94C431.53,191.32,432.26,191.66,433.01,191.97z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M232.97,388.84c-0.63,0.63-1.26,1.26-1.89,1.89C231.71,390.1,232.34,389.47,232.97,388.84z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M205.16,410.02c-0.85,0.53-1.69,1.06-2.52,1.57C203.47,411.06,204.32,410.55,205.16,410.02z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M430.18,191.01c-0.75,0-1.48,0-2.22,0C428.68,191.01,429.43,191.01,430.18,191.01z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M207.37,408.74c-0.73,0.41-1.48,0.85-2.2,1.26C205.89,409.58,206.64,409.17,207.37,408.74z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M225.71,395.16c-0.53,0.53-1.06,1.04-1.57,1.57C224.65,396.22,225.18,395.69,225.71,395.16z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M227.92,393.27c-0.53,0.53-1.06,1.04-1.57,1.57C226.85,394.31,227.38,393.8,227.92,393.27z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M230.45,391.07c-0.53,0.53-1.06,1.04-1.57,1.57C229.39,392.11,229.92,391.58,230.45,391.07z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M289.54,329.11c-0.53,0.53-1.04,1.06-1.57,1.57C288.49,330.17,289.01,329.64,289.54,329.11z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M300.91,315.22c-0.53,0.53-1.04,1.06-1.57,1.57C299.87,316.26,300.38,315.75,300.91,315.22z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M425.1,192.29c-0.53,0.53-1.04,1.04-1.57,1.57C424.06,193.33,424.59,192.82,425.1,192.29z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M197.9,413.17c-0.41,0.41-0.85,0.85-1.26,1.26C197.06,414.01,197.47,413.6,197.9,413.17z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M210.54,406.85c-0.53,0.31-1.06,0.63-1.57,0.94C209.48,407.48,210.01,407.16,210.54,406.85z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M220.34,399.59c-0.41,0.41-0.85,0.85-1.26,1.26C219.49,400.43,219.91,400.02,220.34,399.59z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M396.66,122.76c-0.31,0.41-0.63,0.85-0.94,1.26C396.03,123.6,396.34,123.19,396.66,122.76z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M271.53,349.97c-0.41,0.41-0.85,0.85-1.26,1.26C270.68,350.82,271.1,350.4,271.53,349.97z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M410.57,422.97c0.41-0.41,0.85-0.85,1.26-1.26C411.42,422.12,410.99,422.55,410.57,422.97z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M392.57,135.71c-0.31,0.41-0.63,0.85-0.94,1.26C391.94,136.55,392.25,136.14,392.57,135.71z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M196.62,414.43c-0.41,0.31-0.83,0.63-1.26,0.94C195.8,415.08,196.21,414.76,196.62,414.43z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M274.36,347.12c-0.31,0.31-0.63,0.63-0.94,0.94C273.73,347.77,274.05,347.45,274.36,347.12z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M406.78,117.7c-0.31-0.1-0.63-0.22-0.94-0.31C406.15,117.5,406.46,117.6,406.78,117.7z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M208.96,407.79c-0.22,0.1-0.41,0.22-0.63,0.31C208.53,408.01,208.75,407.91,208.96,407.79z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M404.26,117.4c-0.22,0.1-0.43,0.2-0.63,0.31C403.82,117.6,404.04,117.5,404.26,117.4z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M273.26,418.24c1.02-0.43,2.03-1.2,3.05-1.2c2.07-0.04,4.15,0.49,6.24,0.53c4.62,0.1,9.27,0.06,13.89,0.02 c26.67-0.2,53.35-0.45,80.02-0.59c2.79-0.02,5.59,0.69,8.4,0.91c1.14,0.1,2.3-0.31,3.46-0.31s2.34,0.22,3.5,0.39 c0.33,0.04,0.79,0.47,0.92,0.37c2.91-2.16,6.22-0.79,9.33-1.02c3.29-0.24,5.31-2.01,5.31-5.29c0-87.86,0-175.69-0.02-263.55 c0-2.16-0.31-4.35-0.63-6.49c-0.33-2.24-1.93-3.62-4-3.44c-1.46,0.12-2.99,1.22-4.17,2.24c-0.43,0.37,0.26,1.85,0.02,2.7 c-0.61,2.11-1.46,4.15-2.22,6.22c-1.5,3.92-2.89,7.89-4.55,11.73c-1.75,4.05-3.84,7.95-5.61,11.99c-1.14,2.6-1.81,5.39-2.99,7.97 c-1.16,2.54-2.95,4.8-4.01,7.38c-2.11,5.06-3.74,10.29-5.88,15.33c-1.89,4.43-4.25,8.64-6.3,13.01 c-2.03,4.35-3.8,8.84-5.86,13.17c-2.5,5.27-5.2,10.43-7.77,15.67c-1.12,2.3-2.05,4.68-3.21,6.97c-1.63,3.25-3.23,6.51-5.14,9.6 c-6.97,11.24-14.39,22.2-21.02,33.63c-8.29,14.29-18.87,26.82-29.09,39.64c-5.12,6.44-10.45,12.71-15.98,18.8 c-5.27,5.79-10.88,11.3-16.45,16.81c-2.91,2.87-6.18,5.37-9.07,8.27c-2.44,2.44-4.41,5.35-6.93,7.71 c-6.16,5.77-12.48,11.38-18.83,16.95c-2.3,2.01-4.72,3.94-7.3,5.55c-1.63,1.02-3.68,1.36-5.53,2.05 c-1.1,0.41-2.16,0.96-3.25,1.44c-0.14-0.28-0.28-0.55-0.41-0.85c2.58-1.91,5.24-3.74,7.73-5.77c4.33-3.48,8.66-6.97,12.81-10.63 c5.24-4.61,10.45-9.27,15.43-14.15c5.22-5.12,10.14-10.53,15.23-15.76c3.52-3.6,7.28-6.99,10.65-10.73 c5.43-6.02,10.77-12.14,15.88-18.42c7.32-8.97,14.7-17.91,21.49-27.26c5.39-7.42,10.1-15.35,14.8-23.22 c9.88-16.55,20.02-32.95,29.13-49.91c6.1-11.34,10.65-23.52,15.84-35.37c5.43-12.36,10.96-24.68,16.12-37.14 c4.21-10.17,7.97-20.55,11.93-30.82c1.12-2.93,2.01-6.02,3.5-8.76c0.63-1.14,2.62-2.3,3.84-2.16c1.04,0.12,2.48,2.01,2.66,3.27 c0.53,3.82,0.73,7.73,0.73,11.59c0.04,92.48,0.02,184.96,0.02,277.44c0,3.13-0.49,4.61-4.43,4.53 c-9.84-0.22-19.68-0.08-29.52-0.08c-20.35,0-40.72,0-61.07,0c-7.97,0-15.96-0.04-23.93,0.04c-1.71,0.02-3.4,0.45-5.12,0.71 c-0.31,0.04-0.63,0.22-0.92,0.18c-3.46-0.43-6.91-0.89-10.37-1.34C273.52,418.6,273.4,418.42,273.26,418.24z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M244.84,419.82c-7.73,0-15.47,0.02-23.2-0.04c-0.63,0-1.28-0.63-1.91-0.96c0.63-0.3,1.26-0.85,1.87-0.85 c14.21-0.04,28.42-0.02,42.63-0.06c2.05,0,4.07-0.24,6.12-0.28c0.47,0,0.94,0.41,1.42,0.63c-0.41,0.39-0.77,0.98-1.26,1.14 c-0.83,0.28-1.75,0.37-2.62,0.37C260.21,419.82,252.54,419.82,244.84,419.82z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M219.08,419.78c-6.1,0-11.34,0.04-16.59-0.06c-0.69-0.02-1.5-0.59-1.99-1.12c-0.2-0.22,0.12-1.38,0.47-1.55 c1.75-0.85,3.54-1.65,5.39-2.2c1.1-0.33,2.48-0.55,3.5-0.18c2.48,0.87,4.82,2.09,7.18,3.25 C217.66,418.19,218.06,418.82,219.08,419.78z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M432.38,215.98c-0.22-0.02-0.41-0.04-0.63-0.04c0,0.37,0,0.73,0,1.1c0,66.01,0,132.02,0,198.03 c-0.22-0.35-0.61-0.69-0.61-1.04c-0.04-4.47-0.02-8.95-0.02-13.42c0-46.55,0.02-93.11-0.02-139.66 c-0.02-15.06-0.2-30.09-0.26-45.15c0-0.55,0.57-1.12,0.89-1.67C431.95,214.74,432.16,215.37,432.38,215.98z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M435.21,414.76c19.6,0,39.22,0,58.83-0.02c1.36,0,2.7-0.2,4.05-0.3c-0.61,0.31-1.22,0.91-1.83,0.91 c-9.84,0.06-19.7,0-29.54,0.06c-4.51,0.02-9.03,0.24-13.54,0.3c-5.29,0.06-10.59,0.04-15.88-0.02 C436.61,415.65,435.92,415.08,435.21,414.76z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M531.61,414.45c10.21,0,20.41,0,30.62-0.04c0.43,0,0.87-0.39,1.3-0.61c0.49,0.2,0.96,0.39,1.46,0.59 c-0.45,0.22-0.92,0.63-1.38,0.63c-10.25,0.04-20.49,0.04-30.74,0C532.44,415.04,532.02,414.66,531.61,414.45z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M549.62,401.48c-4.21-4.31-8.42-8.64-12.64-12.95c0.49,0.24,1.1,0.35,1.48,0.73 c3.35,3.19,6.69,6.36,9.92,9.64C549.01,399.53,549.21,400.61,549.62,401.48z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M520.55,414.45c2.11-0.1,4.21-0.22,6.32-0.31c0.12,1.36-0.49,1.73-1.79,1.5c-0.94-0.18-1.97,0.06-2.89-0.14 C521.57,415.37,521.08,414.8,520.55,414.45z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M513.58,414.45c1.16,0,2.32,0,3.48,0C516.06,415.8,514.37,415.8,513.58,414.45z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M524.01,375.58c-0.73-0.85-1.48-1.69-2.2-2.52C522.54,373.88,523.29,374.73,524.01,375.58z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M562.25,412.54c-0.73-0.73-1.48-1.48-2.2-2.2C560.78,411.06,561.53,411.81,562.25,412.54z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M502.21,414.45c0.94,0,1.89,0,2.85,0C504.12,415.9,503.17,415.9,502.21,414.45z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M530.96,382.52c-0.85-0.94-1.69-1.89-2.54-2.83C529.29,380.63,530.13,381.58,530.96,382.52z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M520.22,370.83c-0.85-0.75-1.67-1.48-2.52-2.22C518.54,369.36,519.39,370.09,520.22,370.83z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M454.17,267.19c-0.53-1.06-1.04-2.11-1.57-3.17C453.12,265.07,453.65,266.13,454.17,267.19z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M515.49,365.78c-0.63-0.75-1.26-1.48-1.89-2.22C514.23,364.3,514.86,365.05,515.49,365.78z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M459.56,279.51c-0.41-0.85-0.85-1.69-1.26-2.52C458.71,277.82,459.13,278.67,459.56,279.51z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M528.44,379.69c-0.63-0.31-1.26-0.63-1.89-0.94C527.18,379.04,527.81,379.37,528.44,379.69z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M450.07,258.97c-0.22-0.63-0.41-1.26-0.63-1.89C449.66,257.71,449.86,258.34,450.07,258.97z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M493.06,336.71c-0.41-0.63-0.85-1.26-1.26-1.89C492.21,335.45,492.62,336.08,493.06,336.71z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M435.21,224.84c-0.22-0.53-0.41-1.06-0.63-1.57C434.8,223.78,435.02,224.31,435.21,224.84z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M511.69,361.03c-0.41-0.53-0.85-1.06-1.26-1.57C510.85,359.99,511.28,360.5,511.69,361.03z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M497.46,342.39c-0.41-0.41-0.85-0.85-1.26-1.26C496.64,341.55,497.05,341.98,497.46,342.39z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M557.51,408.11c-0.41-0.41-0.85-0.85-1.26-1.26C556.66,407.28,557.1,407.7,557.51,408.11z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M551.51,403.05c-0.41-0.41-0.85-0.85-1.26-1.26C550.66,402.22,551.09,402.64,551.51,403.05z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M505.06,352.2c-0.41-0.41-0.85-0.85-1.26-1.26C504.21,351.35,504.63,351.76,505.06,352.2z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M507.27,355.03c-0.41-0.41-0.85-0.85-1.26-1.26C506.44,354.18,506.85,354.62,507.27,355.03z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M535.7,387.27c-0.41-0.41-0.85-0.85-1.26-1.26C534.86,386.42,535.29,386.83,535.7,387.27z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M495.26,339.54c-0.41-0.41-0.85-0.85-1.26-1.26C494.41,338.69,494.85,339.13,495.26,339.54z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M438.38,231.79c-0.22-0.41-0.41-0.85-0.63-1.26C437.95,230.94,438.17,231.37,438.38,231.79z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M433.64,220.1c-0.22-0.41-0.41-0.85-0.63-1.26C433.23,219.25,433.42,219.66,433.64,220.1z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M456.71,273.49c-0.22-0.41-0.41-0.85-0.63-1.26C456.29,272.67,456.49,273.08,456.71,273.49z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M467.14,294.67c-0.22-0.41-0.41-0.85-0.63-1.26C466.72,293.82,466.92,294.26,467.14,294.67z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M554.05,404.96c-0.41-0.31-0.85-0.63-1.26-0.94C553.2,404.33,553.61,404.64,554.05,404.96z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M502.84,349.34c-0.31-0.41-0.63-0.85-0.94-1.26C502.21,348.5,502.52,348.93,502.84,349.34z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M500.63,346.51c-0.31-0.41-0.63-0.85-0.94-1.26C500,345.66,500.32,346.07,500.63,346.51z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M501.58,347.77c-0.31-0.31-0.63-0.63-0.94-0.94C500.95,347.14,501.26,347.45,501.58,347.77z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M503.8,350.6c-0.31-0.31-0.63-0.63-0.94-0.94C503.17,349.97,503.49,350.29,503.8,350.6z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M555.62,406.53c-0.31-0.31-0.63-0.63-0.94-0.94C554.99,405.9,555.31,406.22,555.62,406.53z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M499.37,344.91c-0.31-0.31-0.63-0.63-0.94-0.94C498.74,344.28,499.06,344.6,499.37,344.91z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M498.43,343.65c-0.31-0.31-0.63-0.63-0.94-0.94C497.8,343.02,498.11,343.34,498.43,343.65z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M496.2,340.82c-0.31-0.31-0.63-0.63-0.94-0.94C495.58,340.17,495.89,340.51,496.2,340.82z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M494,337.97c-0.31-0.31-0.63-0.63-0.94-0.94C493.37,337.34,493.69,337.65,494,337.97z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M506.01,353.46c-0.31-0.31-0.63-0.63-0.94-0.94C505.38,352.83,505.69,353.14,506.01,353.46z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M508.21,356.29c-0.31-0.31-0.63-0.63-0.94-0.94C507.58,355.66,507.9,355.97,508.21,356.29z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M510.43,359.14c-0.31-0.31-0.63-0.63-0.94-0.94C509.8,358.51,510.12,358.83,510.43,359.14z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M433.64,414.45c0.31,0.1,0.63,0.22,0.94,0.31C434.27,414.66,433.95,414.54,433.64,414.45z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M517.38,367.98c-0.31-0.31-0.63-0.63-0.94-0.94C516.75,367.35,517.07,367.66,517.38,367.98z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M491.78,334.8c-0.22-0.31-0.41-0.63-0.63-0.94C491.36,334.17,491.58,334.48,491.78,334.8z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M487.68,328.17c-0.22-0.31-0.41-0.63-0.63-0.94C487.25,327.54,487.47,327.85,487.68,328.17z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M509.17,357.57c-0.22-0.31-0.43-0.63-0.63-0.94C508.74,356.92,508.96,357.25,509.17,357.57z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M475.99,310.16c-0.22-0.31-0.41-0.63-0.63-0.94C475.56,309.53,475.78,309.84,475.99,310.16z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M470.29,300.36c-0.1-0.22-0.22-0.41-0.31-0.63C470.09,299.94,470.19,300.16,470.29,300.36z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M468.71,297.52c-0.1-0.22-0.22-0.41-0.31-0.63C468.49,297.09,468.61,297.31,468.71,297.52z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M462.39,285.83c-0.1-0.22-0.22-0.41-0.31-0.63C462.18,285.4,462.29,285.62,462.39,285.83z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M448.5,254.54c-0.1-0.22-0.22-0.41-0.31-0.63C448.28,254.13,448.38,254.32,448.5,254.54z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M447.22,251.71c-0.1-0.22-0.22-0.41-0.31-0.63C447.02,251.27,447.12,251.49,447.22,251.71z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M445.96,248.85c-0.1-0.22-0.22-0.41-0.31-0.63C445.74,248.44,445.86,248.64,445.96,248.85z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M444.7,246.02c-0.1-0.22-0.22-0.41-0.31-0.63C444.48,245.58,444.6,245.8,444.7,246.02z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M443.44,243.16c-0.1-0.22-0.22-0.41-0.31-0.63C443.22,242.75,443.32,242.95,443.44,243.16z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M442.16,240.31c-0.1-0.22-0.22-0.41-0.31-0.63C441.96,239.9,442.06,240.11,442.16,240.31z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M439.64,234.62c-0.1-0.22-0.22-0.41-0.31-0.63C439.43,234.21,439.54,234.43,439.64,234.62z"})]})})})});const BowIcon=({elClass:C,fillColor:s})=>jsxRuntimeExports.jsx("svg",{id:"bow-icon",className:C,viewBox:"0 0 792 612",fill:s,xmlns:"http://www.w3.org/2000/svg",children:jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsx("path",{className:"st0",d:"M388.94,317.55c-1.94,3.46-3.87,6.92-5.79,10.37c-0.74,1.34-1.47,2.7-2.22,4.04 c-0.17,0.28-0.33,0.56-0.5,0.84c-1.17,1.03-2.33,2.08-2.51,3.94c-0.6,0.61-1.22,1.19-1.79,1.85c-0.45,0.55-0.73,1.27-1.19,1.79 c-1.97,2.25-4,4.45-5.99,6.68c-3.13,3.52-6.25,7.05-9.36,10.57c-0.66,0.74-1.27,1.52-1.92,2.3c-0.08,0.1-0.17,0.18-0.25,0.28 c-0.46,0.45-0.93,0.91-1.39,1.36c-2.12,2-4.24,3.99-6.37,5.99c-2.17,1.51-4.33,3.01-6.5,4.52c-0.17,0.05-0.33,0.07-0.46,0.17 c-2.5,1.75-5.01,3.52-7.49,5.31c-1.77,1.27-3.52,2.56-5.28,3.85c-0.5,0.23-0.99,0.45-1.47,0.73c-4.17,2.4-8.34,4.8-12.51,7.2 c-1.26,0.73-2.51,1.51-3.77,2.25c-2.76,1.39-5.53,2.75-8.27,4.17c-1.39,0.71-2.68,1.75-4.12,2.27c-2.12,0.74-4.33,1.17-6.52,1.69 c-1.89,0.45-3.81,0.78-5.69,1.24c-1.87,0.46-3.72,1.08-5.58,1.59c-1.27,0.35-2.56,0.73-3.87,0.91c-3.24,0.41-6.5,0.71-9.74,1.06 c-2.73,0.28-5.48,0.76-8.21,0.78c-2.53,0.02-5.06-0.41-7.59-0.71c-4.53-0.53-9.07-1.03-13.6-1.7c-3.14-0.46-6.27-1.17-9.4-1.87 c-2.81-0.63-5.61-1.39-8.42-2.03c-2.53-0.58-5.16-0.83-7.61-1.7c-4.25-1.51-8.42-3.37-12.62-5.1c-0.25,0-0.5,0-0.74-0.02 c-0.22-0.2-0.41-0.45-0.66-0.56c-1.77-0.78-3.57-1.46-5.31-2.27c-2.2-1.03-4.52-1.85-6.5-3.28c-4.32-3.13-8.42-6.62-12.64-9.89 c-4.53-3.52-9.12-6.96-13.67-10.47c-2.28-1.77-4.47-3.76-6.85-5.31c-2.91-1.92-5.48-4.45-9.02-5.29 c-3.04-0.73-5.91-1.26-8.85,0.07c-0.25,0.1-0.5,0.2-0.74,0.3c-1.42,0.56-2.83,1.12-4.25,1.69c-1.84,1.08-3.69,2.1-5.49,3.26 c-0.74,0.48-1.34,1.21-2,1.84c-0.33,0.28-0.66,0.56-0.99,0.84c-0.6,0.38-1.17,0.74-1.77,1.12c-0.25,0.1-0.5,0.2-0.73,0.3 c-0.17,0-0.33,0.02-0.5,0.02c-1.64,0.73-3.06-0.08-4.53-0.73c-2.9-1.26-5.77-2.55-8.72-3.62c-1.79-0.65-3.69-0.93-5.54-1.32 c-1.57-0.33-2.32-2.13-1.79-4.05c0.76-2.8,2.48-4.73,4.37-6.5c2.1-1.95,4.19-3.97,6.49-5.59c2.81-1.97,5.76-3.74,8.78-5.24 c2.8-1.39,5.74-2.4,8.67-3.39c1.52-0.51,3.16-0.61,4.75-0.88c2.4-0.41,4.8-0.99,7.21-1.14c2.28-0.13,4.63-0.12,6.87,0.36 c4.12,0.89,8.17,2.18,12.24,3.33c2.15,0.61,4.28,1.27,6.44,1.92c0.66,0.38,1.34,0.76,2,1.12c0.45,0.2,0.91,0.38,1.36,0.61 c3.49,1.82,6.98,3.66,10.47,5.49c4.63,2.42,9.31,4.75,13.88,7.3c3.14,1.75,6.15,3.82,9.21,5.76c3.59,2.28,7.18,4.6,10.77,6.9 c3.01,1.94,6.01,3.9,9.02,5.82c3.28,2.08,6.52,4.24,9.86,6.17c1.89,1.09,3.94,1.77,5.92,2.63c0.08,0,0.17,0,0.25,0 c0.33,0.18,0.66,0.38,0.99,0.56c0.25,0,0.5,0.02,0.74,0.02c0.33,0.18,0.66,0.36,0.99,0.55c0.08,0,0.17,0,0.25,0 c0.41,0.18,0.83,0.38,1.24,0.56c0.17,0,0.33,0.02,0.5,0.02c0.83,0.36,1.67,0.74,2.5,1.11c0.08,0,0.17,0,0.25,0 c1.42,0.56,2.85,1.17,4.3,1.7c3.46,1.27,6.93,2.55,10.41,3.77c1.67,0.58,3.36,1.06,5.05,1.59c0.25,0,0.5,0,0.74,0 c0.25,0,0.5,0,0.74,0c0.33,0,0.66,0.02,0.99,0.02c1.49,0.07,2.96,0.15,4.45,0.17c0.51,0.02,1.03-0.12,1.56-0.18 c0.25,0,0.5,0,0.74,0c2.83-0.61,5.66-1.37,8.5-1.79c4.48-0.66,8.67-2.3,12.69-4.53c2.45-1.34,4.86-2.75,7.3-4.12 c0.33-0.1,0.66-0.2,0.99-0.3c1.72-1.52,3.47-3.01,5.16-4.57c3.19-2.96,6.37-5.97,9.55-8.97c3.39-3.21,6.95-6.22,10.11-9.69 c2.75-3.01,5.05-6.57,7.56-9.84c3.64-4.71,7.33-9.4,10.97-14.11c1.82-2.37,3.76-4.65,5.38-7.16c2.17-3.34,4.09-6.88,6.09-10.36 c2.17-3.76,4.35-7.49,6.47-11.28c1.04-1.85,1.97-3.79,2.94-5.67c0.5-0.84,1.01-1.7,1.51-2.55c0.17-0.28,0.33-0.56,0.5-0.84 c0.66-1.12,1.32-2.27,1.99-3.39c0.74-1.41,1.51-2.83,2.25-4.24c0-0.38,0-0.76,0-1.12c-0.12-0.91-0.17-1.85-0.35-2.75 c-0.43-1.97-1.92-3.08-4.02-3.19c-2.17-0.13-4.15,0.53-6.12,1.44c-0.5,0.28-0.99,0.56-1.51,0.84c-0.45,0.07-0.91,0.07-1.34,0.18 c-3.47,0.98-6.95,1.92-10.41,2.98c-1.62,0.5-3.18,1.26-4.75,1.9c-0.33,0.18-0.66,0.38-0.99,0.56c-2.15,1.16-4.3,2.35-6.49,3.46 c-0.88,0.45-1.85,0.63-2.73,1.06c-2.08,1.04-4.12,2.2-6.2,3.23c-2.3,1.14-4.65,2.17-6.96,3.26c-2.32,1.09-4.62,2.23-6.95,3.29 c-1.27,0.58-2.6,0.99-3.9,1.51c-1.82,0.71-3.64,1.47-5.48,2.17c-2.22,0.83-4.43,1.64-6.67,2.4c-2.02,0.68-4.05,1.27-6.09,1.9 c-0.28,0.08-0.58,0.07-0.86,0.07c-3.08,0-6.15-0.05-9.23,0.02c-2.51,0.05-4.96-0.3-7.38-1.11c-1.82-0.6-3.72-0.84-5.51-1.54 c-2.4-0.93-4.73-2.13-7.1-3.16c-0.74-0.33-1.56-0.46-2.33-0.71c-1.59-0.51-3.19-0.98-4.76-1.56c-1.47-0.55-2.91-1.24-4.37-1.84 c-2.56-1.08-5.18-1.99-7.68-3.23c-2.86-1.42-5.62-3.13-8.44-4.7c-3.85-2.17-6.55-5.61-8.42-9.89c-0.6-1.37-0.93-2.96-1.16-4.48 c-0.3-1.97-0.53-3.99-0.5-5.97c0.05-1.77,0.45-3.56,0.81-5.29c0.35-1.65,0.76-3.29,1.29-4.88c0.68-1.99,1.46-3.92,2.28-5.84 c1.9-4.45,3.74-8.95,5.82-13.28c1.87-3.89,3.89-7.71,6.12-11.35c1.95-3.18,4.09-6.27,6.5-8.98c2.96-3.34,6.17-6.47,10.12-8.39 c0.96-0.46,1.75-1.41,2.71-1.85c2.32-1.06,4.68-1.94,7.05-2.88c1.09-0.43,2.17-0.84,3.28-1.24c0.35-0.12,0.73-0.17,1.09-0.17 c8.42-0.02,16.84-0.08,25.25,0.05c2,0.03,3.99,0.89,5.99,1.21c1.36,0.22,2.75-0.02,4.1,0.18c1.32,0.2,2.6,0.69,3.89,1.09 c0.81,0.25,1.6,0.6,2.42,0.84c1.26,0.38,2.55,0.63,3.79,1.06c1.59,0.55,3.13,1.29,4.71,1.79c1.79,0.56,3.64,0.91,5.44,1.42 c2.45,0.68,4.88,1.34,7.08,2.85c1.42,0.98,3.03,1.59,4.47,2.51c4.28,2.78,8.59,5.54,12.77,8.49c3.52,2.48,6.95,5.15,10.36,7.83 c3.42,2.68,6.77,5.49,10.16,8.21c1.84,1.47,3.71,2.9,5.58,4.28c0.18,0.13,0.63,0.03,0.83-0.13c2.2-1.9,4.25-4.05,6.58-5.72 c1.8-1.27,3.92-1.97,5.92-2.9c1.77-0.83,3.62-0.84,5.51-0.88c3.64-0.07,6.9,1.19,9.98,3.23c3.26,2.15,6.49,4.35,8.93,7.71 c0.17,0.22,0.91,0.2,1.17-0.03c4.24-3.33,8.44-6.73,12.67-10.08c3.36-2.65,6.73-5.23,10.14-7.81c2.7-2.03,5.39-4.09,8.16-6.01 c2.46-1.7,5.01-3.24,7.53-4.86c1.79-1.16,3.51-2.5,5.38-3.44c1.84-0.93,3.82-1.47,5.76-2.17c1.79-0.63,3.57-1.26,5.38-1.84 c0.89-0.28,1.82-0.46,2.73-0.71c1.17-0.31,2.37-0.58,3.52-0.94c0.98-0.31,1.92-0.84,2.9-1.14c1.6-0.5,3.23-0.84,4.83-1.32 c1.17-0.35,2.33-0.83,3.49-1.24c0.15-0.05,0.31-0.13,0.48-0.15c2.42-0.2,4.83-0.48,7.26-0.55c3.06-0.1,6.12,0.05,9.18-0.05 c1.39-0.05,2.76-0.46,4.14-0.71c0.36-0.07,0.74-0.1,1.11-0.1c2.96,0,5.92-0.02,8.87,0c1.19,0,2.32-0.03,3.49,0.65 c0.98,0.58,2.25,0.46,3.37,0.78c1.65,0.46,3.39,0.74,4.88,1.59c3.57,2.05,7.16,4.14,10.46,6.7c3.84,2.98,7.46,6.37,10.12,10.79 c1.89,3.13,3.62,6.4,5.33,9.66c1.92,3.66,3.81,7.35,5.56,11.12c1.12,2.4,1.97,4.95,2.94,7.41c0.84,2.12,1.7,4.24,2.53,6.35 c0.26,0.71,0.5,1.46,0.63,2.22c0.31,1.9,0.61,3.82,0.83,5.74c0.12,1.03,0,2.07,0.02,3.11c0.1,5.29-1.64,9.76-4.76,13.58 c-1.77,2.17-3.74,4-6.19,5.18c-2.13,1.03-4.07,2.51-6.17,3.62c-1.46,0.78-3.04,1.24-4.57,1.89c-1.75,0.74-3.46,1.57-5.21,2.32 c-0.83,0.35-1.72,0.53-2.58,0.84c-2.42,0.89-4.81,1.84-7.23,2.71c-2.5,0.93-5.03,1.77-7.53,2.7c-1.77,0.65-3.49,1.46-5.28,2.03 c-1.24,0.4-2.55,0.69-3.84,0.73c-4.57,0.08-9.15,0.13-13.73-0.02c-1.7-0.05-3.46-0.25-5.08-1.21c-0.76-0.45-1.74-0.46-2.6-0.71 c-1.29-0.38-2.6-0.69-3.85-1.19c-1.62-0.65-3.19-1.47-4.81-2.15c-1.7-0.71-3.44-1.29-5.13-1.99c-1.64-0.68-3.24-1.42-4.85-2.17 c-2.35-1.08-4.7-2.15-7.01-3.29c-1.12-0.55-2.17-1.27-3.28-1.87c-2.17-1.16-4.37-2.25-6.53-3.39c-1.92-1.01-3.81-2.12-5.74-3.06 c-2.71-1.31-5.46-2.51-8.21-3.76c-0.18-0.08-0.41-0.02-0.63-0.02c-0.25,0-0.5-0.02-0.74-0.02c-0.5-0.18-0.99-0.36-1.51-0.55 c-0.17,0-0.33-0.02-0.5-0.02c-1.89-0.38-3.77-0.78-5.67-1.11c-3.29-0.58-6.57-1.31-9.89-1.6c-2.42-0.22-4.86,0.13-7.3,0.3 c-0.36,0.02-0.86,0.3-1.04,0.63c-0.68,1.22-1.24,2.51-1.85,3.79c-0.17,0.18-0.33,0.38-0.5,0.56c-0.02,0.33-0.17,0.74-0.03,0.98 c0.65,1.12,1.34,2.18,2.03,3.28c0.5,0.94,1.01,1.89,1.51,2.83l0,0c0.99,1.7,2,3.39,2.99,5.1c0.25,0.2,0.5,0.4,0.74,0.58 c0,0.18,0,0.35-0.02,0.53c-0.03,0.2-0.15,0.48-0.07,0.6c0.68,1.14,1.39,2.25,2.08,3.37c0.17,0.28,0.33,0.56,0.5,0.84 c0.41,0.76,0.84,1.51,1.26,2.27c0.6,1.11,1.17,2.22,1.77,3.31c1.8,3.24,3.46,6.58,5.44,9.69c2.22,3.49,4.68,6.78,7.11,10.11 c2.76,3.77,5.59,7.49,8.42,11.22c3.64,4.8,7.26,9.6,10.97,14.31c0.86,1.09,2.02,1.89,3.03,2.81l0,0 c0.18,0.35,0.31,0.78,0.58,1.03c1.6,1.51,3.23,2.99,4.88,4.45c0.89,0.78,1.85,1.44,2.8,2.17l0,0c0.17,0.31,0.26,0.71,0.5,0.91 c3.57,3.29,7.16,6.55,10.75,9.81l0,0c1.41,1.34,2.78,2.71,4.2,4c0.98,0.88,2.03,1.65,3.04,2.48c0.08,0,0.17,0.02,0.25,0.02 c0.25,0.18,0.5,0.36,0.76,0.55c0.17,0,0.33,0.02,0.5,0.02c0.81,0.48,1.6,1.03,2.45,1.44c2.51,1.24,5.05,2.42,7.56,3.62 c0.58,0.18,1.17,0.38,1.75,0.56c1.26,0.28,2.5,0.56,3.76,0.84c0.25,0,0.5,0,0.76,0c1.14,0.2,2.27,0.56,3.41,0.53 c2.37-0.07,4.73-0.33,7.1-0.51c0.08,0,0.17,0,0.25,0s0.17,0,0.26,0h0.12h0.12c0.08,0,0.17,0,0.26,0c0.17,0,0.33,0,0.5,0 c0.08,0,0.17,0,0.26,0h0.12h0.12c0.08,0,0.17,0,0.26,0h0.12h0.12c0.08,0,0.17,0,0.26,0h0.12h0.12c0.08,0,0.17,0,0.26,0 c0.5,0,0.99,0,1.49-0.02c0.33,0,0.66,0,0.99,0c0.25-0.1,0.5-0.18,0.74-0.28c0.38-0.02,0.76,0.03,1.11-0.08 c2.88-0.98,5.74-1.99,8.6-2.99c3.46-1.22,6.93-2.45,10.39-3.72c1.32-0.48,2.6-1.11,3.89-1.67c0.08,0,0.17,0,0.25,0 c0.33-0.18,0.66-0.36,1.01-0.55c0.17,0,0.33-0.02,0.5-0.02c0.41-0.18,0.83-0.38,1.24-0.56c0.08,0,0.17,0,0.25,0 c0.91-0.38,1.84-0.76,2.75-1.12c0.08,0,0.17,0,0.25,0c2.33-1.46,4.67-2.91,6.98-4.37c0.02-0.02,0.02-0.08,0.02-0.13l0,0 c0.43-0.15,0.88-0.22,1.26-0.45c2.1-1.31,4.2-2.65,6.29-3.99c5.51-3.51,11.03-6.95,16.51-10.54c5.51-3.61,11.03-7.16,16.91-9.98 c1.22-0.6,2.35-1.46,3.52-2.2c0.08,0,0.17,0,0.25-0.02c0.28-0.08,0.56-0.1,0.81-0.23c1.74-0.96,3.41-2.03,5.18-2.88 c3.89-1.85,7.83-3.57,11.75-5.36c0.33-0.18,0.66-0.38,0.99-0.56c0.56-0.13,1.12-0.26,1.69-0.41c1.95-0.51,3.9-1.08,5.87-1.56 c2.33-0.58,4.68-1.11,7.03-1.6c1.29-0.28,2.6-0.46,3.9-0.68c0.33-0.1,0.66-0.18,0.99-0.28c1.17,0,2.33,0,3.51,0 c0.33,0,0.66,0,0.99,0c1.67,0.1,3.33,0.18,5,0.28c0.5,0,0.99,0.02,1.51,0.02c1.17,0.18,2.33,0.36,3.51,0.55 c0.25,0,0.5,0.02,0.74,0.02c1.34,0.56,2.66,1.12,4,1.7c0.41,0.18,0.83,0.36,1.26,0.55c3.24,1.21,6.55,2.25,9.71,3.71 c1.84,0.84,3.59,2.17,5.1,3.64c2.88,2.86,5.58,5.97,8.29,9.05c0.63,0.71,1.16,1.62,1.51,2.55c0.71,1.9-0.55,3.76-2.37,3.66 c-0.91-0.05-1.82,0-2.71,0c-0.36,0.07-0.74,0.07-1.09,0.2c-1.56,0.58-3.11,1.17-4.67,1.79c-1.8,0.94-3.61,1.85-5.38,2.83 c-1.59,0.88-3.04,2.23-4.95,1.92c-0.71-0.12-1.44-0.58-2.02-1.08c-1.03-0.86-1.94-1.89-2.9-2.83c-0.33-0.1-0.66-0.2-0.99-0.3 c-0.5-0.46-0.99-0.94-1.51-1.41c-0.25-0.18-0.5-0.38-0.74-0.56c-0.17-0.1-0.33-0.18-0.5-0.28c-0.74-0.56-1.51-1.12-2.25-1.7 c0-0.1,0-0.18-0.02-0.28c-1.84-0.74-3.66-1.51-5.49-2.25c-0.17,0-0.33-0.02-0.5-0.02c-1.99-0.58-3.95-1.04-5.97-0.18 c-0.84,0.36-1.74,0.58-2.63,0.74c-2.18,0.38-3.85,1.75-5.41,3.41c-0.33,0.2-0.66,0.38-0.99,0.58c-0.91,0.74-1.84,1.51-2.75,2.25 c-1.17,0.84-2.33,1.69-3.51,2.55c-1.31,0.88-2.66,1.67-3.92,2.63c-2.5,1.92-4.93,3.94-7.41,5.89c-4.3,3.41-8.57,6.85-12.9,10.19 c-2.25,1.74-4.5,3.62-6.96,4.88c-3.92,1.99-8.02,3.51-12.06,5.23c-0.78,0.28-1.56,0.53-2.32,0.86c-2.65,1.11-5.29,2.25-7.92,3.37 c-0.08,0-0.17,0-0.25,0s-0.17,0-0.26,0l0,0c-0.66,0.18-1.34,0.38-2,0.56c-0.08,0-0.17,0-0.25,0s-0.17,0-0.26,0 c-0.41,0.1-0.83,0.2-1.24,0.3c-0.41,0.05-0.83,0.03-1.22,0.13c-2.38,0.6-4.73,1.27-7.13,1.79c-3.89,0.84-7.79,1.67-11.7,2.33 c-2.73,0.46-5.48,0.66-8.22,0.98c-1.6,0.18-3.21,0.28-4.81,0.5c-2.17,0.3-4.32,0.84-6.49,0.99c-2.42,0.18-4.86,0.18-7.3,0.02 c-3.99-0.26-7.96-0.71-11.93-1.12c-1.44-0.15-2.86-0.45-4.27-0.74c-1.24-0.26-2.48-0.61-3.72-0.93 c-1.77-0.45-3.52-0.89-5.29-1.34c-1.95-0.5-3.92-0.96-5.87-1.49c-1.79-0.48-3.62-0.86-5.33-1.6c-2.78-1.21-5.46-2.68-8.19-4.05 c-0.25-0.1-0.5-0.18-0.74-0.28c-1.09-0.66-2.17-1.32-3.26-1.99c-0.25-0.1-0.5-0.18-0.74-0.28c-1.75-0.94-3.51-1.89-5.26-2.83 c-2.58-1.41-5.16-2.83-7.74-4.24c-0.17-0.1-0.33-0.18-0.5-0.28c-0.91-0.66-1.84-1.32-2.75-1.99c-3.51-2.51-7.03-5.03-10.54-7.54 c-2.8-1.99-5.61-3.94-8.37-5.99c-1.75-1.31-3.41-2.76-5.11-4.15c-1.24-0.99-2.48-1.97-3.72-2.96c-0.33-0.18-0.66-0.38-0.99-0.56 c-0.17-0.18-0.33-0.38-0.5-0.56c-1.67-1.89-3.34-3.77-5.01-5.64c-0.91-1.04-1.82-2.07-2.73-3.11c-0.41-0.48-0.83-0.94-1.24-1.42 l0,0c-0.22-0.38-0.41-0.79-0.66-1.14c-2.78-3.74-6.01-7.06-8.39-11.18c-2.18-3.77-4.38-7.53-6.53-11.32 c-2.91-5.1-5.77-10.22-8.67-15.35c-0.17-0.38-0.35-0.74-0.51-1.12c-1.08-3.03-2.15-6.06-3.26-9.07c-0.08-0.23-0.45-0.55-0.58-0.5 c-0.3,0.12-0.69,0.36-0.79,0.68c-1.06,3.23-2.07,6.49-3.09,9.74c0,0.18,0,0.38-0.02,0.56c-0.2,0.38-0.41,0.74-0.61,1.12 c-0.55,1.04-1.09,2.08-1.62,3.13c0,0.18-0.02,0.36-0.02,0.55c-0.17,0.3-0.33,0.58-0.5,0.88 C389.27,316.97,389.1,317.25,388.94,317.55z M516.07,237.84c0-0.08-0.02-0.15-0.02-0.23c-3.13,0.26-6.25,0.51-9.38,0.81 c-0.73,0.07-1.42,0.28-2.13,0.46c-1.22,0.3-2.46,0.61-3.69,0.94c-1.44,0.38-2.91,0.73-4.33,1.17c-2.15,0.69-4.3,1.41-6.42,2.22 c-1.94,0.74-3.85,1.59-5.74,2.5c-1.84,0.88-3.59,1.95-5.43,2.83c-1.39,0.66-2.85,1.17-4.27,1.75c-0.53,0.22-1.11,0.31-1.6,0.58 c-1.94,0.99-3.85,1.99-5.76,3.04c-2.22,1.24-4.42,2.48-6.58,3.82c-0.79,0.5-0.71,3.66,0.03,4.24c0.1,0.08,0.23,0.1,0.35,0.13 c0.74,0.2,1.51,0.41,2.25,0.56c2.53,0.5,5.08,0.93,7.61,1.44c2.63,0.53,5.28,0.79,7.83,1.9c1.69,0.73,3.51,1.14,5.31,1.44 c2.25,0.36,4.27,1.36,6.29,2.38c1.11,0.56,2.22,1.11,3.34,1.62c1.64,0.76,3.33,1.37,4.91,2.25c3.51,1.92,6.93,4.02,10.44,5.91 c1.64,0.88,3.37,1.56,5.13,2.07c2,0.6,4.07,1.24,6.12,1.31c5.08,0.18,10.16,0.07,15.24,0.05c0.41,0,0.81-0.12,1.22-0.2 c0.88-0.2,1.74-0.43,2.6-0.63c0.31-0.07,0.66-0.05,0.98-0.15c1.47-0.46,2.91-1.21,4.42-1.37c1.03-0.12,1.84-0.56,2.65-1.08 c0.93-0.6,1.97-1.11,2.7-1.95c0.91-1.08,2-2.37,2.23-3.74c0.5-2.99,0.93-6.07,0.38-9.18c-0.55-3.11-0.78-6.27-2.05-9.18 c-0.63-1.46-0.84-3.09-2.12-4.2c-2.51-2.15-4.43-5.1-7.25-6.85c-0.94-0.6-1.85-1.26-2.81-1.79c-1.79-0.99-3.54-2.15-5.44-2.81 c-2.13-0.74-4.37-1.11-6.58-1.46c-2.15-0.33-4.33-0.45-6.5-0.6C518.66,237.78,517.37,237.84,516.07,237.84z M269.37,283.06 c4.4,0.08,9.18-0.25,13.88-1.42c1.12-0.28,2.25-0.58,3.31-1.06c1.04-0.46,1.97-1.21,2.99-1.72c1.69-0.86,3.44-1.54,5.11-2.45 c3.34-1.82,6.6-3.87,9.98-5.59c2.27-1.14,4.68-1.9,7.05-2.8c0.65-0.25,1.34-0.35,1.99-0.61c1.69-0.69,3.34-1.51,5.06-2.12 c1.08-0.38,2.23-0.53,3.36-0.69c2.51-0.38,5.06-0.51,7.53-1.11c1.49-0.36,2.93-0.84,4.47-0.84c0.74,0,1.51-0.3,2.25-0.51 c0.26-0.07,0.56-0.22,0.73-0.45c0.84-1.21,0.69-3.51-0.45-4.28c-1.57-1.09-3.26-2-4.95-2.88c-1.74-0.91-3.51-1.69-5.26-2.53 c-2.9-1.42-5.79-2.85-8.69-4.28c-2.5-1.22-4.98-2.5-7.49-3.66c-1.44-0.66-2.94-1.17-4.45-1.67c-0.96-0.33-1.97-0.48-2.94-0.78 c-2.42-0.76-4.78-1.72-7.23-2.3c-2.81-0.66-5.67-1.34-8.52-1.37c-3.9-0.03-7.81-0.46-11.75,0.35c-1.95,0.4-3.99,0.53-5.96,0.99 c-1.14,0.26-2.28,0.53-3.39,0.93c-1.27,0.46-2.53,1.06-3.77,1.62c-1.79,0.81-3.71,1.41-5.33,2.53c-1.56,1.08-2.83,2.68-4.22,4.07 c-4.67,4.68-7.08,10.57-7.26,17.62c-0.03,1.12-0.02,2.27,0,3.39c0.02,1.08-0.23,2.28,0.1,3.23c1.24,3.49,2.88,6.65,6.72,7.06 c0.23,0.02,0.43,0.25,0.66,0.35c1.14,0.53,2.27,1.24,3.46,1.54c1.56,0.38,3.16,0.43,4.75,0.63c0.45,0.07,0.89,0.18,1.32,0.28 c0.84,0.18,1.69,0.48,2.53,0.53C266.3,283.12,267.64,283.06,269.37,283.06z"})})})})});const HeartEyes=({elClass:s,fillColor:a})=>jsxRuntimeExports.jsx("svg",{id:"heart-eyes",className:s,viewBox:"0 0 100 100",fill:a,xmlns:"http://www.w3.org/2000/svg",children:jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{className:"st0",d:"M91.6,41.6C87,33.4,79.8,39.8,74.5,42l0,0c-3.9-4.3-7.5-12.8-15.3-7.5c-12.5,8.2,9.3,32.8,9.3,32.8l0,0 C69.1,67.3,99.1,54.4,91.6,41.6L91.6,41.6z"}),jsxRuntimeExports.jsx("path",{className:"st0",d:"M8.2,41.6c4.6-8.2,11.8-1.8,17.1,0.4l0,0c3.9-4.3,7.5-12.8,15.3-7.5c12.5,8.2-9.3,32.8-9.3,32.8l0,0 C30.6,67.3,0.7,54.4,8.2,41.6L8.2,41.6z"})]})});const ThreeHearts=({elClass:s,fillColor:a})=>jsxRuntimeExports.jsx("svg",{id:"three-hearts",className:s,viewBox:"0 0 100 100",fill:a,xmlns:"http://www.w3.org/2000/svg",children:jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{className:"st0",d:"M5.8,40.2c4.4-4.9,8.3,0.6,11.6,2.8l0,0c3.3-2.3,7-7.6,11.6-2.8c7.3,7.5-11.3,21-11.3,21l0,0 C17.3,61.1-1.2,47.8,5.8,40.2L5.8,40.2z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M38,40.8c4.4-4.9,8.3,0.6,11.6,2.8l0,0c3.3-2.3,7-7.6,11.6-2.8c7.3,7.5-11.3,21-11.3,21l0,0 C49.4,61.6,30.9,48.4,38,40.8L38,40.8z"}),jsxRuntimeExports.jsx("path",{className:"st2",d:"M70.9,40.8c4.4-4.9,8.3,0.6,11.6,2.8l0,0c3.3-2.3,7-7.6,11.6-2.8c7.3,7.5-11.3,21-11.3,21l0,0 C82.3,61.6,63.8,48.4,70.9,40.8L70.9,40.8z"})]})});const EyeLids=({elClass:s,fillColor:a})=>jsxRuntimeExports.jsx("svg",{id:"eyelids",className:s,viewBox:"0 0 100 100",fill:a,xmlns:"http://www.w3.org/2000/svg",children:jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{className:"st0",d:"M72.3,57.6c-0.7,0-1.3-0.6-1.3-1.3v-3.8c-1.7-0.2-3.4-0.7-5.1-1.5l-2.7,3.8c-0.3,0.3-0.7,0.6-1.1,0.6 c-0.3,0-0.6-0.1-0.8-0.2c-0.3-0.2-0.5-0.5-0.6-0.9s0-0.7,0.2-1l2.5-3.5c-1.3-0.8-2.5-1.7-3.6-2.8l-0.8-0.8l-2,2.1l-1.3,1.3 c-0.3,0.3-0.6,0.4-1,0.4s-0.7-0.2-0.9-0.4c-0.3-0.3-0.4-0.6-0.4-0.9s0.1-0.7,0.4-1l1.3-1.3l2.9-3.1c0.3-0.3,0.6-0.4,1-0.4 s0.7,0.2,1,0.4l1.7,1.8c1.3,1.2,2.7,2.3,4.3,3.1c2.1,1,4.2,1.7,6.3,1.8c0.8,0,1.6-0.1,2.3-0.2c3.8-0.6,7.7-2.8,11.4-6.8 c0.3-0.3,0.6-0.4,1-0.4c0.4,0,0.8,0.2,1,0.5l3.7,4.2c0.2,0.3,0.3,0.6,0.3,1c0,0.3-0.2,0.7-0.5,0.9c-0.2,0.2-0.6,0.3-0.9,0.3 c-0.4,0-0.8-0.2-1-0.5L87,45.7c-1.5,1.4-3,2.6-4.4,3.6l2.2,4.1c0.2,0.3,0.2,0.7,0.1,1c-0.1,0.3-0.3,0.6-0.7,0.8 c-0.2,0.1-0.4,0.2-0.6,0.2c-0.5,0-1-0.3-1.2-0.7l-2.1-4c-1.7,0.8-3.4,1.4-5.2,1.6c-0.5,0.1-0.9,0.1-1.4,0.2v3.7 C73.7,56.9,73.1,57.6,72.3,57.6"}),jsxRuntimeExports.jsx("path",{className:"st0",d:"M26.7,57.6c-0.7,0-1.4-0.6-1.4-1.3v-3.8c-1.7-0.2-3.4-0.7-5.1-1.5l-2.7,3.8c-0.3,0.3-0.7,0.6-1.1,0.6 c-0.3,0-0.6-0.1-0.8-0.2c-0.3-0.2-0.5-0.5-0.6-0.9c-0.1-0.3,0-0.7,0.2-1l2.5-3.5c-1.3-0.8-2.5-1.7-3.6-2.8l-0.8-0.8l-2,2.1 l-1.3,1.3c-0.3,0.3-0.6,0.4-1,0.4s-0.7-0.2-0.9-0.4C8,49.4,7.8,49,7.8,48.7s0.1-0.7,0.4-1l1.3-1.3l2.9-3.1c0.2-0.3,0.6-0.4,1-0.4 c0.4,0,0.7,0.2,1,0.4l1.7,1.8c1.3,1.2,2.8,2.3,4.3,3.1c2.1,1,4.2,1.7,6.3,1.8c0.8,0,1.5-0.1,2.3-0.2c3.8-0.6,7.7-2.8,11.4-6.8 c0.3-0.3,0.6-0.4,1-0.4c0.4,0,0.8,0.2,1,0.5l3.8,4.2c0.2,0.3,0.3,0.6,0.3,1c0,0.3-0.2,0.7-0.5,0.9c-0.2,0.2-0.6,0.3-0.9,0.3 c-0.4,0-0.8-0.2-1-0.5l-2.8-3.1c-1.5,1.4-3,2.6-4.5,3.6l2.2,4.1c0.2,0.3,0.2,0.7,0.1,1c-0.1,0.3-0.3,0.6-0.7,0.8 c-0.2,0.1-0.4,0.2-0.6,0.2c-0.5,0-1-0.3-1.2-0.7l-2.1-4c-1.7,0.8-3.4,1.4-5.1,1.6c-0.5,0.1-0.9,0.1-1.4,0.2v3.7 C28.1,56.9,27.4,57.6,26.7,57.6"})]})});const TennRackets=({elClass:s,fillColor:a})=>jsxRuntimeExports.jsx("svg",{id:"rackets",className:s,viewBox:"0 0 100 100",fill:a,xmlns:"http://www.w3.org/2000/svg",children:jsxRuntimeExports.jsxs("g",{id:"d9ZjTm",children:[jsxRuntimeExports.jsx("g",{id:"d9ZjTm-2",children:jsxRuntimeExports.jsx("path",{className:"st0",d:"M79.4,20.5c-3.2,0.4-5.9,1.4-8.4,3.1c-1.3,0.9-2.3,2.1-3.4,3.2c-3.5,3.5-5.6,7.7-6.9,12.5 c-0.5,2.1-0.9,4.2-1.5,6.3c-1,3.5-2,7-3.1,10.5c-0.2,0.7-0.6,1.3-1.1,1.8c-1.6,1.7-3.1,3.4-4.7,5.1c-1.8,1.9-3.6,3.8-5.4,5.7 c-1.8,1.9-3.7,3.9-5.5,5.8c-0.4,0.4-0.8,0.7-1.3,1c-0.1,0.1-0.3,0.2-0.4,0.3c-0.7,0.5-0.9,1.2-0.3,1.9c0.5,0.7,1.2,1.3,1.9,1.6 c0.7,0.3,1.2,0.1,1.5-0.6c0.3-0.8,0.9-1.4,1.4-2c1.5-1.6,3-3.2,4.5-4.8c3.2-3.3,6.3-6.7,9.5-10c0.6-0.7,1.3-1.3,1.9-2 c0.5-0.5,1.2-0.8,1.9-1.1c4.4-1.6,8.8-3.2,13.3-4.5c2.8-0.8,5.6-1.7,8.1-3.1c1.5-0.8,2.8-1.8,4.2-2.9c1.7-1.4,3.2-2.9,4.6-4.6 c2.1-2.7,3.3-5.8,3.5-9.2c0.1-1.6,0.1-3.2-0.5-4.8c-0.6-1.9-1.6-3.6-3-5c-1.1-1.1-2.3-2.1-3.8-2.9C84,20.7,81.6,20.4,79.4,20.5 L79.4,20.5L79.4,20.5z M70.5,53.1c-0.4,0-0.8,0.1-1.2,0.1c-1.5,0.1-2.9-0.3-4.2-1.1c-0.8-0.5-1.6-1-2.2-1.8 c-0.8-1.2-1.3-2.5-1.4-3.9c-0.2-2.2,0.1-4.4,0.6-6.5c0.7-2.7,1.8-5.2,3.2-7.6c1.8-2.9,3.8-5.6,6.7-7.5c0.7-0.4,1.3-0.9,2-1.2 c0.9-0.5,2-0.8,3-1.2c1.6-0.5,3.2-0.8,4.9-0.4c1.3,0.3,2.6,0.5,3.8,1.2c1.3,0.8,2.5,1.6,3.5,2.8c1.1,1.3,1.8,2.9,2.4,4.5 c0.6,1.7,0.5,3.5,0.2,5.2c-0.4,2.5-1.4,4.8-3,6.9c-2,2.6-4.3,4.8-7.1,6.4c-0.8,0.4-1.5,0.9-2.3,1.3C76.7,51.8,73.6,52.7,70.5,53.1 L70.5,53.1L70.5,53.1z M58.9,57.4c-0.7,0.1-1.1-0.4-0.9-1.1c0.7-2.4,1.4-4.8,2-7.3c0-0.1,0.1-0.3,0.1-0.4c0.1-0.1,0.3-0.2,0.4-0.2 c0.1,0,0.2,0.1,0.3,0.2c0.2,0.5,0.5,1.1,0.7,1.6c0.7,1.3,1.9,2.2,3.1,3c0.6,0.3,1.1,0.7,1.8,0.7c0.2,0,0.3,0.4,0.2,0.6 c-0.1,0.1-0.2,0.2-0.3,0.2c-2.2,0.8-4.5,1.5-6.7,2.3C59.4,57.2,59.1,57.3,58.9,57.4L58.9,57.4L58.9,57.4z"})}),jsxRuntimeExports.jsx("g",{id:"d9ZjTm-3",children:jsxRuntimeExports.jsx("g",{id:"d9ZjTm-4",children:jsxRuntimeExports.jsx("path",{className:"st0",d:"M20.2,21c3.2,0.3,6,1.2,8.5,2.8c1.3,0.9,2.4,2,3.5,3.1c3.6,3.4,5.9,7.5,7.3,12.2c0.6,2.1,1.1,4.2,1.7,6.3 c1.1,3.5,2.3,6.9,3.4,10.3c0.2,0.7,0.7,1.3,1.2,1.8c1.6,1.6,3.2,3.3,4.9,4.9c1.9,1.9,3.8,3.7,5.6,5.5c1.9,1.9,3.8,3.8,5.7,5.6 c0.4,0.4,0.9,0.7,1.3,1c0.1,0.1,0.3,0.2,0.5,0.3c0.7,0.5,0.9,1.2,0.4,1.9c-0.5,0.7-1.1,1.3-1.9,1.7c-0.7,0.3-1.2,0.2-1.5-0.5 c-0.3-0.8-0.9-1.3-1.5-1.9c-1.5-1.6-3.1-3.1-4.7-4.7c-3.3-3.2-6.6-6.4-9.8-9.7c-0.7-0.6-1.3-1.3-2-1.9c-0.5-0.5-1.2-0.8-1.9-1 c-4.4-1.5-8.9-2.9-13.5-4c-2.8-0.7-5.6-1.5-8.2-2.8c-1.5-0.8-2.9-1.7-4.3-2.8c-1.7-1.3-3.3-2.8-4.7-4.5c-2.2-2.6-3.5-5.7-3.8-9.1 c-0.2-1.6-0.2-3.2,0.3-4.8c0.6-1.9,1.4-3.6,2.8-5.1c1.1-1.2,2.3-2.2,3.7-3C15.5,21.4,17.9,20.9,20.2,21L20.2,21z M30.2,53.3 c0.4,0,0.8,0.1,1.2,0.1c1.5,0,2.9-0.4,4.1-1.2c0.8-0.5,1.6-1.1,2.1-1.9c0.8-1.2,1.2-2.5,1.3-4c0.1-2.2-0.2-4.4-0.8-6.5 c-0.8-2.6-1.9-5.2-3.5-7.5c-1.9-2.8-4-5.4-7-7.2c-0.7-0.4-1.4-0.8-2-1.2c-1-0.5-2-0.8-3-1.1c-1.6-0.5-3.3-0.6-4.9-0.2 c-1.3,0.3-2.6,0.5-3.8,1.3c-1.3,0.8-2.5,1.7-3.4,2.9c-1.1,1.4-1.8,3-2.3,4.6c-0.6,1.7-0.4,3.5,0,5.2c0.5,2.5,1.5,4.8,3.2,6.8 c2.1,2.5,4.5,4.6,7.4,6.2c0.8,0.4,1.5,0.8,2.3,1.2C24,52.2,27.1,53,30.2,53.3L30.2,53.3L30.2,53.3z M42,57.1 c0.7,0.1,1.1-0.4,0.8-1.1c-0.8-2.4-1.5-4.8-2.3-7.2c0-0.1-0.1-0.3-0.2-0.4c-0.1-0.1-0.3-0.2-0.4-0.2c-0.1,0-0.2,0.1-0.3,0.3 c-0.2,0.5-0.4,1.1-0.7,1.6c-0.7,1.4-1.8,2.3-3,3.1c-0.5,0.3-1.1,0.7-1.8,0.8c-0.2,0-0.3,0.4-0.1,0.6c0.1,0.1,0.2,0.2,0.4,0.2 c2.3,0.7,4.5,1.4,6.8,2.1C41.5,57,41.8,57.1,42,57.1L42,57.1L42,57.1z"})})})]})});const Clubs=({elClass:s,fillColor:a})=>jsxRuntimeExports.jsx("svg",{id:"clubs",className:s,viewBox:"0 0 100 100",fill:a,xmlns:"http://www.w3.org/2000/svg",children:jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{className:"st1",d:"M80.8,15.7c2,1.6,2.1,2.1,0.3,4.2c-6,7.1-12,14.3-18,21.4c-0.2,0.2-0.4,0.5-0.7,0.6c-2,1-3.3,2.8-4.7,4.4 c-9.7,11.9-19.4,23.8-29,35.7c-1.8,2.2-4.2,2.5-6.7,2.3c-1.6-0.1-3.1-0.5-4.5-1.4c-2-1.4-2.7-3.6-1.8-5.5 c0.7-1.4,2.1-2.1,4.2-1.7c2,0.4,4,1.1,6,1.6c0.1,0,0.3,0.1,0.4,0.2c1.8,0.6,1.3,0.6,2.5-0.7c9.2-11,18.5-22,27.7-33 c1.1-1.3,2.1-2.7,2.9-4.2c0.8-1.5,2-2.8,3.1-4.1c5.1-6.1,10.3-12.3,15.5-18.4c0.4-0.5,0.9-0.9,1.4-1.4 C79.9,15.6,80.4,15.6,80.8,15.7L80.8,15.7z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M20.7,15.7c2,2.3,4.1,4.6,6.1,6.9c4.5,5.3,8.9,10.6,13.4,15.9c0.2,0.2,0.5,0.5,0.5,0.8 c0.7,2.5,2.7,4.2,4.3,6.1c1.2,1.5,2.4,2.9,3.6,4.3c0.3,0.3,0.3,0.6,0,0.9c-0.5,0.5-0.9,1.1-1.4,1.7c-1.6-1.9-3.2-3.8-4.8-5.6 c-0.9-1.1-1.8-2.2-2.8-3.3c-0.1-0.1-0.1-0.2-0.2-0.2c-2.8-1.5-4.4-4.2-6.3-6.5c-4.9-5.7-9.7-11.5-14.5-17.2 c-1.2-1.4-1-2.5,0.5-3.5c0.1-0.1,0.1-0.1,0.2-0.2C19.8,15.7,20.3,15.7,20.7,15.7L20.7,15.7z"}),jsxRuntimeExports.jsx("path",{className:"st1",d:"M53,54.9c2.6,3.1,5.1,6.1,7.7,9.1c3.7,4.4,7.4,8.8,11.1,13.2c0.5,0.6,0.9,0.7,1.6,0.4 c2.2-0.8,4.4-1.8,6.8-1.9c0.8,0,1.5-0.1,2.3,0.1c1.7,0.3,2.9,2.5,2.3,4.2c-0.4,1.3-1.2,2.4-2.4,3.1c-2,1.1-4.1,1.5-6.3,1.2 c-2.2-0.2-3.8-1.4-5.2-3.1C64.5,73.5,58.3,65.9,52,58.2c-0.8-1-0.8-1,0-2.1C52.3,55.7,52.7,55.3,53,54.9L53,54.9z"})]})})});const Paddles=({elClass:C,fillColor:s})=>jsxRuntimeExports.jsx("svg",{id:"paddles",className:C,viewBox:"0 0 100 100",fill:s,xmlns:"http://www.w3.org/2000/svg",children:jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsx("path",{className:"cls-1",d:"m44.09,77.47c-.26-.18-.58-.37-.79-.58-1-.98-1.98-1.95-2.98-2.96-.48-.48-.48-1.11-.03-1.61.26-.29.5-.61.77-.87.37-.34.77-.63,1.16-.95.5-.37,1.03-.71,1.48-1.14.63-.58,1.21-1.24,1.85-1.88-.08-.08-.13-.16-.18-.21-.45-.45-.9-.87-1.32-1.32-.24-.24-.48-.4-.85-.4-.55,0-.98-.37-1.37-.74-1.03-.95-2.19-1.56-3.59-1.74-1.29-.18-2.59-.13-3.86.18-1.29.32-2.56.77-3.86,1.08-3.33.85-6.34.16-8.85-2.24-2.38-2.27-4.65-4.62-6.95-6.97-2.35-2.4-4.67-4.83-7.05-7.21-1.16-1.16-1.85-2.54-2.17-4.09-.11-.48-.16-.95-.24-1.45v-1.4c.08-.4.13-.79.21-1.19.4-1.74,1.27-3.2,2.51-4.46,2.46-2.48,4.94-4.94,7.4-7.4.98-.98,1.93-1.93,2.93-2.88,1.82-1.69,3.96-2.64,6.5-2.59,2.48.05,4.65.87,6.44,2.69,4.46,4.54,8.95,9.03,13.44,13.55,1.93,1.95,2.91,4.28,2.8,7.05-.05,1.27-.42,2.46-.74,3.64-.34,1.32-.74,2.67-.98,4.01-.32,1.82.11,3.54,1.14,5.07.08.13.18.24.32.34.61.5.92,1.16,1.03,1.93.03.16.08.34.18.45.5.58,1.03,1.14,1.56,1.72.53-.58,1.06-1.16,1.58-1.74.11-.13.13-.32.16-.48.13-.74.45-1.35,1-1.85.55-.5.82-1.16,1.08-1.82.61-1.53.61-3.09.21-4.67-.4-1.58-.87-3.12-1.27-4.7-.79-3.28-.05-6.21,2.24-8.64,1.95-2.06,3.99-4.04,6-6.07,2.61-2.64,5.23-5.26,7.84-7.9,1.53-1.56,3.41-2.32,5.55-2.54,2.91-.29,5.39.69,7.45,2.69,3.3,3.25,6.58,6.52,9.88,9.77,1.14,1.14,2.03,2.4,2.56,3.91.37,1.08.5,2.22.42,3.35-.11,1.35-.4,2.64-1.03,3.83-.26.53-.61,1.03-1.03,1.45-4.65,4.78-9.35,9.51-14,14.29-1.98,2.03-4.38,2.91-7.13,2.91-1.14,0-2.22-.34-3.28-.69-1.43-.45-2.88-.9-4.38-.98-1.82-.11-3.59.13-5.12,1.29-.26.21-.53.45-.79.69-.42.37-.87.63-1.45.61-.11,0-.26.08-.34.16-.58.58-1.14,1.16-1.74,1.77.66.66,1.29,1.35,2.01,2.01.42.4.95.69,1.43,1.06.34.26.69.55,1.03.87.26.26.48.55.74.82.53.58.5,1.16-.05,1.72-.98.98-1.93,1.93-2.93,2.88-.24.24-.53.4-.79.58h-.5c-.13-.08-.32-.13-.42-.24-.63-.66-1.35-1.29-1.9-2.03-.42-.55-.82-1.11-1.32-1.58-.5-.5-1-1-1.51-1.48-.08-.08-.16-.16-.26-.24-.74.77-1.48,1.48-2.19,2.22-.24.26-.45.55-.66.85-.66,1-1.48,1.88-2.51,2.56-.16-.08-.32-.08-.48-.08ZM7.14,41.65c.03.34.05.71.11,1.06.24,1.85.95,3.49,2.3,4.81,1.03,1.03,2.06,2.09,3.09,3.14,3.17,3.22,6.34,6.44,9.51,9.67,1.51,1.53,3.33,2.27,5.44,2.38,1.14.05,2.22-.24,3.3-.55,2.01-.61,4.04-1.11,6.15-.95.58.05,1.21.13,1.74.34.74.29,1.43.71,2.14,1.11.13.08.24.11.37-.03.24-.24.53-.42.77-.63,1.08-.9,2.06-1.88,2.98-2.93.21-.24.18-.42,0-.63-.13-.16-.29-.29-.4-.48-.95-1.61-1.29-3.38-.95-5.2.29-1.64.71-3.28,1.11-4.89.32-1.24.48-2.48.32-3.75-.24-1.9-1.11-3.43-2.43-4.78-4.31-4.36-8.61-8.74-12.92-13.1-.34-.34-.74-.66-1.14-.9-1.19-.74-2.51-1-3.88-1.03-1.77-.05-3.38.4-4.78,1.48-.95.74-1.8,1.61-2.64,2.46-2.61,2.61-5.23,5.23-7.84,7.87-1.48,1.51-2.35,3.35-2.35,5.55Zm68.22-17.38h-.55c-.18,0-.37.03-.55.05-1.66.18-3.12.79-4.31,2.01-2.93,3.01-5.89,6-8.85,8.98-1.51,1.53-3.04,3.01-4.46,4.6-1.69,1.85-2.22,4.07-1.85,6.5.18,1.21.55,2.38.82,3.59.29,1.27.66,2.54.66,3.83,0,1.66-.34,3.22-1.45,4.54-.24.29-.24.45.03.71,1.08,1.19,2.19,2.35,3.49,3.33.42.32.4.32.87.05.55-.32,1.08-.66,1.66-.9,1.37-.58,2.83-.55,4.25-.32,1.35.21,2.67.55,3.99.92,1.43.4,2.83.66,4.31.4,1.48-.26,2.83-.85,3.94-1.9,1.21-1.19,2.4-2.4,3.62-3.62,3.17-3.22,6.37-6.42,9.48-9.67,1.98-2.09,2.59-4.6,2.06-7.4-.32-1.61-1.19-2.91-2.32-4.04-2.46-2.46-4.91-4.91-7.34-7.4-1.03-1.06-2.11-2.03-3.28-2.96-.18-.16-.4-.32-.63-.42-1.08-.63-2.3-.92-3.57-.9Z"})})});const FlutesIcon=({elClass:s,fillColor:a})=>jsxRuntimeExports.jsxs("svg",{id:"flutes",className:s,viewBox:"0 0 216 216",fill:a,xmlns:"http://www.w3.org/2000/svg",children:[jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsx("path",{className:"st0",d:"M155.5,106.46c0,5.58-0.55,11.16-2.46,16.46c-1.09,2.93-2.46,5.79-5.05,7.53c-2.12,1.39-1.91,2.93-1.43,4.81     c1.09,4.32,2.12,8.72,3.14,13.04c1.64,6.69,3.21,13.32,4.85,20.01c0.55,2.23,0.61,2.23,2.73,1.67c1.57-0.42,3.21-0.77,4.78-1.19     c1.09-0.28,2.59-1.05,3.75-0.7c0.75,0.21,1.43,0.98,1.43,1.81c0,1.67-2.59,1.88-3.75,2.16c-2.18,0.56-4.44,1.12-6.62,1.67     c-2.59,0.63-5.12,1.32-7.71,1.95c-2.18,0.56-4.71,1.67-6.89,1.74c-0.55,0-1.16-0.14-1.5-0.56c-0.48-0.56-0.48-1.39-0.07-2.02     c0.41-0.63,1.02-1.05,1.71-1.26c2.32-0.7,4.78-0.98,7.17-1.6c2.05-0.56,2.18-0.77,1.64-3c-1.36-5.93-2.8-11.78-4.23-17.71     c-1.3-5.44-2.66-10.81-3.96-16.25c-0.27-1.32-0.68-2.09-2.12-2.3c-3.89-0.56-7.1-2.72-9.83-5.51     c-5.6-5.65-9.08-12.62-11.94-20.01c-2.8-7.25-4.44-14.85-5.87-22.45c-0.89-4.81-1.64-9.62-2.39-14.43     c-0.89-6-0.82-6.07,4.71-7.53c8.33-2.16,16.65-4.25,24.98-6.35c2.25-0.56,3.07-0.21,3.89,1.95c5.25,14.36,9.96,28.94,11.06,44.42     C155.57,104.09,155.5,105.28,155.5,106.46z M152.16,106.39c0-0.42,0-0.77,0-1.19c-0.34-9.9-2.59-19.45-5.39-28.94     c-0.48-1.6-1.3-2.09-2.8-1.6c-0.48,0.14-0.96,0.21-1.43,0.35c-7.78,1.88-15.56,3.83-23.27,5.72c-2.93,0.7-3.07,0.84-2.53,3.77     c1.64,8.99,3.69,17.92,7.58,26.29c2.59,5.51,5.53,10.74,10.03,14.92c6.48,6,12.22,4.6,15.42-3.63     C151.68,116.92,152.02,111.69,152.16,106.39z M114.08,68.25c0.41,2.86,0.68,5.37,1.09,7.81c0.2,1.12,0.75,1.81,2.05,1.39     c0.48-0.14,0.96-0.14,1.43-0.28c8.05-1.95,16.11-3.9,24.16-5.93c1.91-0.49,2.18-0.84,1.57-2.65c-0.68-2.3-1.57-4.46-2.32-6.76     c-0.48-1.39-1.16-1.81-2.66-1.39c-4.16,1.12-8.33,2.09-12.49,3.07c-3.62,0.91-7.17,1.81-10.78,2.72     C115.03,66.65,113.81,66.93,114.08,68.25z"})}),jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsx("path",{className:"st0",d:"M105.75,67.56c-0.96,6-1.84,11.99-2.93,17.99c-1.64,8.86-3.69,17.71-7.44,25.94     c-2.46,5.37-5.32,10.46-9.28,14.78c-3,3.28-6.41,5.86-10.85,6.48c-1.3,0.21-1.71,0.91-1.98,2.09     c-2.66,11.44-5.46,22.8-8.19,34.24c-0.48,2.09-0.34,2.37,1.77,2.93c2.46,0.63,4.91,1.26,7.37,1.81c1.16,0.28,2.05,0.91,1.77,2.23     c-0.27,1.46-1.5,1.39-2.59,1.12c-5.05-1.19-10.03-2.44-15.01-3.77c-2.53-0.63-5.12-1.26-7.64-2.02c-0.68-0.21-1.5-0.7-1.77-1.26     c-0.68-1.32,0.61-2.44,2.46-2.09c2.39,0.49,4.71,1.12,7.1,1.74c2.59,0.7,2.66,0.7,3.34-1.95c1.64-6.76,3.28-13.6,4.91-20.36     c0.82-3.35,1.57-6.69,2.39-10.04c0.75-3.14,1.5-5.3-1.36-7.53c-3.07-2.3-4.44-6-5.39-9.69c-1.64-6.35-1.98-12.76-1.5-19.24     c0.96-11.64,4.3-22.59,7.78-33.61c0.89-2.93,1.98-5.86,3.07-8.72c0.96-2.37,1.64-2.72,4.03-2.09c8.33,2.09,16.65,4.18,24.98,6.35     c0.55,0.14,1.16,0.28,1.71,0.42C105.55,64.07,105.68,64.28,105.75,67.56z M64.06,106.74c0.2,5.37,0.55,11.23,3.07,16.66     c2.93,6.35,7.92,7.67,13.24,3.35c2.39-1.95,4.57-4.39,6.35-6.9c7.51-10.81,10.65-23.36,12.9-36.12c0.41-2.23,0.14-2.37-2.18-2.93     c-7.98-1.95-15.9-3.83-23.89-5.79c-3.41-0.84-3.55-0.77-4.44,2.58c-0.2,0.7-0.41,1.32-0.55,2.02     C66.03,88.27,64.26,97.12,64.06,106.74z M102.07,68.6c0.34-1.32-0.48-1.88-1.64-2.16c-1.3-0.28-2.53-0.63-3.75-0.98     c-6.62-1.67-13.24-3.28-19.86-4.95c-1.43-0.35-2.18-0.14-2.66,1.32c-0.75,2.23-1.64,4.46-2.32,6.76     c-0.61,1.81-0.34,2.16,1.5,2.65c2.87,0.7,5.66,1.39,8.53,2.09c5.6,1.32,11.19,2.65,16.79,4.04c1.5,0.42,2.25-0.14,2.46-1.6     C101.45,73.48,101.73,71.11,102.07,68.6z"})}),jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsx("path",{className:"st0",d:"M96.61,45.66c1.16-0.21,2.12,1.26,2.87,2.02c1.36,1.32,2.66,2.65,3.96,3.97c0.82,0.84,1.3,1.88,0.27,2.86     c-0.89,0.77-1.84,0.42-2.59-0.35c-1.23-1.19-2.46-2.37-3.62-3.56c-0.82-0.84-2.32-1.81-2.32-3.14     C95.17,46.57,95.79,45.8,96.61,45.66z"})}),jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsx("path",{className:"st0",d:"M110.05,44.55c0,1.26,0.07,2.58,0,3.83c-0.07,0.91-0.34,1.81-1.5,1.88c-1.09,0.07-1.71-0.63-1.77-1.6     c-0.07-1.74-1.36-10.46,1.64-10.11C110.6,38.76,109.98,43.08,110.05,44.55L110.05,44.55z"})}),jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsx("path",{className:"st0",d:"M120.08,45.66c0.48,0,0.89,0.14,1.23,0.63c1.3,1.88-2.46,4.6-3.55,5.72c-0.82,0.84-1.64,2.09-2.8,2.51     c-0.82,0.28-1.77,0-2.18-0.7c-1.02-1.6,2.05-4.11,3-4.95C116.47,48.1,118.51,45.73,120.08,45.66z"})}),jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsx("path",{className:"st0",d:"M146.77,103.4c0.27,4.95,0,9.83-1.3,14.43c-0.34,1.19-1.16,1.6-2.25,1.32c-1.02-0.28-1.16-1.19-1.02-2.16     c0.27-1.39,0.61-2.72,0.75-4.11c1.02-8.72-0.2-17.29-1.84-25.8c-0.07-0.42-0.14-0.77-0.27-1.19c-0.27-1.19-0.07-2.23,1.23-2.58     c1.23-0.28,1.84,0.7,1.98,1.67C145.2,90.85,146.43,97.19,146.77,103.4z"})}),jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsx("path",{className:"st0",d:"M69.31,103.33c0-0.21,0-0.35,0-0.56c0.27-5.23,1.5-10.53,2.32-15.69c0.14-0.91,0.27-1.81,0.75-2.58     c0.34-0.56,1.43-1.26,1.71-1.12c0.61,0.35,1.3,1.26,1.3,1.88c0,1.39-0.48,2.72-0.75,4.11c-1.5,7.95-2.39,15.97-1.36,24.06     c0.14,1.19,0.48,2.3,0.68,3.49c0.2,0.98,0,1.88-1.02,2.16c-1.09,0.35-1.98-0.14-2.18-1.32     C69.99,113.16,69.11,108.14,69.31,103.33z"})})]})}),jsxRuntimeExports.jsx("path",{className:"st0",d:"M136.74,95.24c-1.57,0-2.8,1.26-2.8,2.86s1.23,2.86,2.8,2.86s2.8-1.26,2.8-2.86S138.31,95.24,136.74,95.24z"}),jsxRuntimeExports.jsx("path",{className:"st0",d:"M134.28,102.63c-1.57,0-2.8,1.26-2.8,2.86c0,1.6,1.23,2.86,2.8,2.86s2.8-1.26,2.8-2.86  C137.08,103.88,135.85,102.63,134.28,102.63z"}),jsxRuntimeExports.jsx("path",{className:"st0",d:"M130.18,97.75c-1.57,0-2.8,1.26-2.8,2.86s1.23,2.86,2.8,2.86s2.8-1.26,2.8-2.86S131.75,97.75,130.18,97.75z"}),jsxRuntimeExports.jsx("path",{className:"st0",d:"M83.23,106.25c-0.2-0.77-0.68-1.32-1.3-1.74c-0.61-0.35-1.36-0.49-2.12-0.28c-0.75,0.21-1.3,0.7-1.71,1.32  c-0.34,0.63-0.48,1.39-0.27,2.16c0.34,1.32,1.5,2.16,2.73,2.16c0.2,0,0.48-0.07,0.68-0.14c0.75-0.21,1.3-0.7,1.71-1.32  C83.3,107.79,83.44,107.02,83.23,106.25z"}),jsxRuntimeExports.jsx("path",{className:"st0",d:"M83.78,98.45c-0.2-0.77-0.68-1.32-1.3-1.74c-0.61-0.35-1.36-0.49-2.12-0.28s-1.3,0.7-1.71,1.32  c-0.34,0.63-0.48,1.39-0.27,2.16c0.2,0.77,0.68,1.32,1.3,1.74c0.48,0.28,0.96,0.42,1.43,0.42c0.2,0,0.48,0,0.68-0.14  c0.75-0.21,1.3-0.7,1.71-1.32C83.85,99.98,83.98,99.21,83.78,98.45z"}),jsxRuntimeExports.jsx("path",{className:"st0",d:"M88.9,102.07c-0.2-0.77-0.68-1.32-1.3-1.74c-0.61-0.35-1.36-0.49-2.12-0.28s-1.3,0.7-1.71,1.32  c-0.34,0.63-0.48,1.39-0.27,2.16c0.2,0.77,0.68,1.32,1.3,1.74c0.48,0.28,0.96,0.42,1.43,0.42c0.27,0,0.48,0,0.68-0.14  c0.75-0.21,1.3-0.7,1.71-1.32C88.96,103.6,89.1,102.84,88.9,102.07z"})]});const SandShellIcon=({elClass:s})=>jsxRuntimeExports.jsx("svg",{className:s,id:"sand-shell",viewBox:"0 0 792 612",xmlns:"http://www.w3.org/2000/svg",children:jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{className:"st0",d:"M688.2,330.8c-2.3-5.6-4.9-11.7-5.1-17.7c-0.2-8.2,3.5-15.7,5.8-23.3c4.9-15.2-1.4-33.2-10.7-45.7       c-7.4-9.9-19.2-13.8-22.4-27.2c-1.8-7-1-14.2-1.6-21.2c-1.6-15.7-10.7-30.5-23.9-39.5c-14.4-9.5-23.5-9.9-28.6-28.4       c-1.8-6.4-4.9-12.8-8-18.7c-3.3-6.2-8.6-10.7-14.6-15c-8-5.4-15.9-9.1-25.7-9.9c-4.5-0.4-9.1-1.4-13-3.5       c-5.2-2.7-10.1-6.4-14.8-10.3c-8.9-7.2-18.9-11.5-30.5-11.3c-8.6,0.2-20.6,2.3-28.8,0c-6.2-1.7-11.1-7.2-16.7-10.7       c-13.6-8.2-29.4-13-45.1-14.2c-14.6-1.2-29.2,0.6-43.2,5.6C350.6,44,343,51.4,333.1,56.3c-9.3,4.7-22.4,2.9-32.5,3.3       c-14.4,0.4-30.9,4.5-40.8,15.9c-5.4,6.2-12.8,8.4-19.8,8.6c-13.6,0.6-23.5,7.4-33.2,15.4c-3.5,2.9-5.8,7.2-8.9,10.5       c-6.4,7-7.4,16.1-10.1,24.7c-1.6,5.2-2.5,11.1-9.5,13.8c-8.2,3.1-16.7,7-22.9,12.8c-12.1,11.1-20.4,24.5-18.5,42.2       c0.6,5.6,0.2,11.3,0,17.1c0,1.7-1.2,4.1-2.5,4.9c-8,4.7-14.6,10.1-19.8,18.1c-6.6,9.9-12.8,24.5-13,36.6       c-0.2,14.4,9.5,26.2,5.6,41.4c-1.7,6.4-5.2,12.2-7.2,18.5c-10.1,33.6,30.7,59.3,53.3,75.4c17.3,12.4,35.6,23.5,54.1,33.8       c12.2,6.8,40.4,15.4,47.1,28.2c2.1,4.1,2.7,8.7,3.3,13.2c2.7,21.2,2.7,45.3,9.1,65.7c0.8,2.5,2.3,5.8,4.3,6.8       c4.9,2.3,10.3,4.9,15.6,4.9c22.4,0.6,44.7,0.4,67.1,0.2c7.4,0,13.8,2.1,20.2,5.2c4.1,1.9,8.4,4.3,12.8,4.9       c11.3,1.4,22.2,0,32.5-5.4c6-3.1,12.4-4.9,19.4-4.5c10.3,0.4,20.8,0,31.1,0c8.6,0,17.1,0.2,25.5,0c6.4-0.2,13-0.2,18.9-2.3       c14.8-5.4,15.2-30.1,16.1-43.6c0.8-11.5,1.2-22.9,4.5-33.8c5.6-17.7,21.2-24.3,36.6-32.3c21.8-11.1,43-23.3,62.8-37.5       c18.7-13.2,44.3-29.2,54.8-50.2C696.9,353.6,694.4,345.6,688.2,330.8z M623.6,406.6c-6.8,8.9-15.9,18.7-25.9,24.1       c-13,7.2-26.1,14.2-39.1,21.4c-7,3.9-15.2,7-20.6,12.4c-4.1,4.1-9.3,8.4-10.3,15.6c-1.2,10.7-3.7,21.4-5.6,32.1       c0,0.4,0,0.6-0.2,1c-0.8,8.9-0.8,18.1-2.3,27c-0.8,4.9-0.2,10.9-5.1,14.4c-3.1,2.1-7,4.1-10.7,4.3c-11.9,0.6-23.7,0.2-35.6,0.2       c-10.7,0-21.4,0-32.1,0c-9.7,0-17.9,3.9-26.1,8.6c-7,4.1-14.8,7.4-23.5,1.9c-6.8-4.3-14.6-7-22-10.1c-1.4-0.6-3.3-0.4-4.9-0.4       c-23.1,0-46.1-0.2-69.2,0c-12.8,0-16.1-7.4-17.5-17.1c-1.2-8.6-1.2-17.5-2.1-26.1c-1-9.3-1.7-18.7-4.1-27.6       c-3.3-11.7-6.4-24.1-19.2-29.6c-5.4-2.3-11.3-4.3-16.7-7c-12.6-6.8-27.4-12.8-36-24.7l-12.6-17.5c-3.1-4.5-6.4-8.9-8-14.4       c-1.4-5.2-0.6-10.3,2.5-14.8c3.1-4.3,5.8-8.6,5.2-14c-0.8-7.8-1.9-15.6-3.1-23.1c-0.8-5.4-1.4-11.1-0.8-16.5       c0.6-7.4,3.3-14.8,8.9-20.2c4.7-4.3,9.7-8.2,14.4-12.6c10.7-10.1,3.1-19.8,4.9-32.1c1.2-8.6,6.4-15.9,12.2-22.4       c4.9-5.2,9.1-9.5,16.1-12.1c3.9-1.4,8.7-2.5,11.5-6c2.9-3.9,4.5-11.3,5.6-15.7c5.1-20.2,20.4-26.2,38.7-32.1       c10.1-3.1,17.7-7.2,26.2-13.2c4.3-2.9,11.1-9.1,16.5-6c7.8-0.2,15.6,0,23.1-1.2c10.9-1.7,19.8-7,30.1-10.5       c8.6-2.7,17.7-3.7,26.4-3.5c13.4,0.4,26.2,5.4,39.5,7c26.1,3.1,52.5,13.8,75.8,25.5c6.6,3.3,13.2,7,18.3,12.6       c5.4,6,7.6,15.7,10.5,23.3c1.2,3.1,2.3,6,4.3,8.7c7,10.3,22.2,10.3,29.6,20.8c4.9,7,9.9,14.2,8.7,23.7c-0.6,4.1,0.4,8.4-0.2,12.4       c-1,8,2.3,13.8,9.1,17.1c8.2,3.9,11.9,11.3,15.6,18.7c3.3,6.6,5.2,14.2,4.5,21.8c-0.4,4.1-1.2,8.6-2.7,12.2       c-1,2.1-3.1,4.1-5.1,5.6c-0.6,0.4,0,12.2,0.2,13.6c0.6,3.1,2.5,3.3,4.3,5.2c1.6,1.6,2.3,4.1,3.1,6c1.4,3.7,2.7,8.2,2.5,12.1       C631.4,393.6,628.1,400.8,623.6,406.6z M676.3,369.7c-4.3,6.2-9.3,11.9-14.8,17.1c-4.1,4.1-9.5,6.8-14.2,10.3       c-1.9,1.4-3.3,3.3-5.2,4.7c-0.8,0.6-2.1,0.6-3.1,0.8c0-1-0.2-2.1,0-3.1c2.7-7.6,3.7-15.4,1.4-23.1c-1.6-5.2-7.6-9.3-7.8-14.6       c-0.2-3.7,1.2-8.2,1.8-11.9c0.6-4.7,2.5-9.3,4.3-13.8c-0.2-1.4-0.4-2.7-0.4-4.1c1-10.5-1.2-20.4-6.2-29.6       c-4.5-8-9.9-15.6-18.3-20.2c-2.9-1.6-5.1-4.1-4.7-8.2c0.4-3.1-0.4-6.4,0.2-9.5c1.9-11.1-2.1-20.8-7.8-29.7       c-3.3-5.2-8.4-9.5-13.4-13.2c-3.9-2.9-8.9-4.5-13.4-6.4c-3.5-1.6-5.2-7.2-7.4-10.3c-2.5-3.7-3.9-8-4.3-12.6       c-0.6-0.8-1-1.4-1.6-2.1c-2.7-4.9-4.9-10.3-8.6-14.4c-5.8-6.4-13-11.1-21.4-13.6c-7.2-2.1-14.8-3.7-22-6.2       c-3.9-1.4-7.2-4.7-10.5-7.2c-5.1-3.7-10.5-7.2-16.7-8.9c-6.6-1.9-14.2-1.7-21-2.5c-5.8-0.6-13-0.2-18.5-1.9       c-4.5-1.4-8.4-4.7-13-6c-10.7-3.1-22.2-2.3-33.1-0.8c-11.1,1.6-23.3,3.3-32.1,12.6c-5.2,5.4-12.1,3.9-18.7,2.7       c-9.7-1.7-16.9,1.6-26.1,3.1c-5.1,2.1-9.7,5.1-13.8,8.7c-7,6.2-15.2,8.9-24.1,10.7c-6.8,1.4-13.8,3.7-19.4,7.6       c-9.7,6.8-16.7,16.3-19.2,28.4c-1.2,5.1-1.9,9.1-5.8,12.8c-2.9,2.9-6.4,4.9-10.1,7c-3.7,2.1-6.2,5.4-9.9,7.2       c-9.7,4.7-14.2,13.8-17.5,22.7c-2.5,6.8-3.7,11.9-1.7,19.1c0.8,2.9,1.7,6,1.4,8.9c-0.8,7.6-9.3,7.6-13.8,12.4       c-4.7,5.2-9.1,11.1-12.4,17.5c-3.5,7-4.5,15-4.5,22.7c0,7.2-0.8,13.6,0.8,20.8c0.6,3.1,1.4,6,1.7,9.1c0.6,2.9,1,5.8,0.6,8.7       c-0.8,5.4-5.6,8.6-6.8,14c-1.6,6.4,0.2,13,2.7,19.1c1.2,3.1,3.1,5.8,4.5,8.7c0.2,0.6,0.2,1.2,0.2,1.7c-0.6,0-1.4,0.4-1.7,0.2       c-2.1-1.2-4.3-2.5-6.2-3.9c-6.2-4.3-12.6-8.4-18.5-13c-7-5.6-13.4-11.7-20.2-17.5c-5.1-4.3-9.5-9.3-12.6-15.2       c-3.1-5.8-6.2-11.1-5.2-17.9c1.4-10.5,10.3-17.9,11.7-28.2c0.6-4.1-0.8-9.5-1.7-13.4c-2.1-8.4-6-16.5-6.2-25.3       c-0.2-7.4,2.3-14.6,5.1-21.4c2.7-6.6,7.6-10.7,12.4-15.6c4.1-4.1,8.2-8.4,12.2-12.4c1.7-1.9,3.7-3.9,5.1-6.2       c1.4-2.3,0.8-4.7,0.8-7.4c0-6.4,0-12.8,0-19.4c0-8.4,2.9-15.2,8.2-22.2c6-8.2,14.8-13.8,23.5-18.5c7.2-3.9,13.8-9.3,16.9-17.1       c1.7-4.3,2.3-8.9,3.9-13.2c1.6-4.7,3.9-8.9,6.6-13.2c5.6-8.6,13.4-14,22.4-17.9c4.1-1.7,8.7-2.3,13-3.5       c8.4-2.3,16.9-2.3,23.7-9.9c6.6-7.2,15.2-12.2,24.7-14.4c5.4-1.2,11.7-0.6,17.3-0.6c6.4-0.2,12.8-0.4,19.1-0.8       c5.2-0.4,8.6-1.6,12.4-4.7c4.7-3.7,9.9-7.4,15.4-9.7c10.3-4.7,21.2-8,32.3-9.3c5.6-0.6,11.5-0.8,17.1-0.2       c5.4,0.6,10.7,2.5,16.1,3.1c7.2,0.8,13.2,3.7,19.4,6.6c6.4,2.9,10.7,8.6,17.1,11.5c9.7,4.3,21,3.3,31.5,3.3       c8.4-1,18.5,0.2,27.4,6c5.1,3.3,9.9,7.2,14.4,11.1c3.7,3.3,7.6,5.1,12.4,6.2c9.1,2.1,18.9,1.7,27,7.6       c9.7,6.8,19.4,13.4,22.4,26.2c0.6,2.9,2.9,5.6,3.3,8.7c0.2,1.6,0.2,3.5-0.2,5.2c0.6,2.1,1,4.1,1.6,6.2c1.6,3.7,3.9,6.8,6.6,7.2       c3.1,0.4,5.2,1.7,6.6,3.3c3.1,1.6,6.4,2.9,9.3,4.7c10.7,5.6,18.5,14.6,24.9,24.3c1.9,3.1,2.1,7.4,2.5,11.3c0.4,4.3,0,8.7,0,13       c0,3.9,0.4,7.8,0,11.5c-0.8,7.2,4.1,10.3,8.7,14.2c5.8,4.7,11.7,10.1,16.1,16.1c3.9,5.4,6.4,12.1,8.7,18.7       c1.2,3.1,0.2,7,0.6,10.3c1.8,12.1-4.3,23.5-8,34.6c-0.4,1-0.8,2.1-1,3.3c-0.4,2.7,0.4,5.2,1,8c0.4,1.6,1,3.1,1.8,4.5       c1.2,1.8,2.7,1.9,4.1,3.1c1.6,1.4,2.7,3.3,3.5,5.1c1.8,3.3,3.5,7.2,3.9,10.9c0,0.2,0,0.6,0,0.8       C686,356.5,679.8,364.4,676.3,369.7z"}),jsxRuntimeExports.jsx("path",{className:"st0",d:"M394.9,579.5c-2.5,0-5.2-0.2-8-0.6c-4.1-0.4-8-2.3-11.7-4.3l-1.4-0.6c-7.4-3.5-13.4-5.1-19.8-5.1       c-21.2,0.2-43.9,0.4-67.3-0.2c-5.4-0.2-10.9-2.5-16.1-5.1c-2.7-1.2-4.3-5.2-4.9-7.4c-4.5-14.4-5.8-30.5-7.2-46.3       c-0.6-6.8-1.2-13.4-1.9-19.8c-0.6-4.5-1.2-8.9-3.1-13c-4.5-8.9-20.4-15.7-33.2-21.4c-5.1-2.1-9.9-4.3-13.4-6.2       c-20.8-11.7-38.7-22.9-54.2-34c-1.6-1.2-3.3-2.3-4.9-3.5c-23.3-16.3-58.3-41-48.8-73.1c1-3.1,2.1-6,3.5-8.7       c1.4-3.1,2.9-6.4,3.7-9.7c2.3-8.6,0-15.9-2.3-23.7c-1.7-5.6-3.5-11.3-3.3-17.5c0.2-13,7.2-28.2,13.2-37.1       c4.9-7.2,11.3-13,20.2-18.3c1-0.6,1.9-2.5,1.9-4.1c0.4-5.6,0.6-11.3,0-16.9c-1.7-15.7,4.5-29.7,18.9-43       c6.8-6.2,15.9-10.3,23.1-13c5.8-2.1,7.2-6.6,8.4-11.5c0.2-0.6,0.4-1.2,0.4-1.7c0.6-1.7,1-3.7,1.6-5.6c1.7-6.8,3.5-13.8,8.7-19.4       c1.2-1.4,2.3-2.7,3.3-4.3c1.7-2.3,3.3-4.7,5.6-6.4c10.7-8.9,20.6-15.2,33.8-15.6c8.2-0.4,14.6-3.1,19.1-8.2       c11.5-13.4,30.9-15.9,41.4-16.1c2.3,0,5.1,0,7.8,0c8.2,0.2,17.5,0.2,24.3-3.1c4.1-1.9,8-4.5,11.5-7c5.2-3.5,10.5-7,16.9-9.3       c13.6-5.1,28.2-7,43.6-5.6c16.3,1.4,32.1,6.2,45.7,14.4c2.1,1.2,4.1,2.7,6,4.3c3.5,2.7,6.8,5.2,10.5,6.2c5.4,1.6,13.2,1,19.8,0.4       c3.1-0.2,6-0.4,8.6-0.4c11.1-0.2,21.4,3.7,31.3,11.5c4.5,3.7,9.5,7.4,14.8,10.1c3.5,1.7,8,2.9,12.6,3.3       c8.9,0.6,16.9,3.7,26.1,10.1c5.2,3.7,11.1,8.4,15,15.2c2.9,5.4,6.2,12.1,8,18.9c3.7,13.8,9.7,17.1,18.7,22.4       c2.7,1.6,6,3.3,9.3,5.6c13.8,9.1,22.7,24.1,24.3,40.1c0.2,2.7,0.4,5.4,0.4,8c0,4.5,0.2,8.9,1.2,13.2c1.9,8.2,7.2,12.8,12.8,17.5       c3.3,2.7,6.6,5.6,9.3,9.3c8.4,11.1,16.1,29.9,10.9,46.5c-0.6,1.7-1.2,3.5-1.8,5.2c-2.1,5.8-4.3,11.7-4.1,17.9       c0.2,6,2.5,11.9,4.9,17.5l0,0c6.2,14.8,9.1,23.1,1.4,38.5c-9.3,18.7-29.7,32.9-47.6,45.3c-2.5,1.7-5.1,3.5-7.6,5.2       c-18.1,12.8-38.7,25.1-63,37.5l-3.3,1.7c-14.2,7.2-27.6,14-32.7,29.9c-3.1,9.5-3.7,19.8-4.3,29.7l-0.4,6.8       c-0.8,13.4-2.1,36.2-16.5,41.4c-5.2,1.9-11.1,2.1-16.7,2.3h-2.5c-6,0.2-12.1,0.2-17.9,0.2c-5.6,0-11.3,0-16.9,0       c-7.2,0-14.6,0.2-21.8-0.2c-6.4-0.2-12.8,1.2-18.9,4.5C412.3,577.6,403.9,579.5,394.9,579.5z M354.3,567.1       c6.4,0,12.6,1.6,20.2,5.2l1.4,0.6c3.7,1.7,7.4,3.5,11.1,4.1c11.9,1.4,22.4-0.4,32.1-5.2c6.4-3.3,13.2-4.9,19.8-4.7       c7.2,0.2,14.6,0.2,21.8,0.2c5.6,0,11.3,0,16.9,0c5.8,0,11.9,0.2,17.9-0.2h2.5c5.4-0.2,11.1-0.4,16.1-2.1       c13.2-4.9,14.6-26.6,15.4-39.7l0.4-6.8c0.6-10.1,1.2-20.4,4.3-30.1c5.4-16.9,19.1-23.7,33.6-31.1l3.3-1.7       c24.3-12.4,44.7-24.7,62.8-37.5c2.3-1.7,4.9-3.5,7.6-5.2c17.9-12.4,38.1-26.4,47.1-44.5c7.4-14.8,4.7-22.4-1.4-36.9l0,0       c-2.3-5.4-4.9-11.7-5.1-18.1c-0.2-6.4,1.9-12.6,4.1-18.5c0.6-1.7,1.2-3.5,1.8-5.2c5.1-15.9-2.5-34-10.5-44.7       c-2.7-3.5-5.8-6.2-9.1-8.9c-5.6-4.9-11.5-9.7-13.6-18.7c-1.2-4.5-1.2-9.1-1.2-13.6c0-2.5,0-5.2-0.4-7.8       c-1.4-15.4-10.1-29.7-23.5-38.7c-3.3-2.3-6.4-4.1-9.3-5.6c-9.1-5.1-15.7-8.7-19.6-23.5c-1.8-6.6-5.1-13-8-18.5       c-3.5-6.6-9.1-11.1-14.2-14.6c-8.9-6-16.7-9.1-25.1-9.7c-5.1-0.4-9.7-1.6-13.4-3.5c-5.4-2.7-10.5-6.6-15-10.3       c-9.1-7.4-18.9-11.1-29.4-11.1c-0.2,0-0.4,0-0.6,0c-2.5,0-5.4,0.2-8.4,0.4c-6.8,0.6-14.8,1.2-20.6-0.6c-4.1-1.2-7.8-3.9-11.1-6.6       c-1.9-1.6-3.9-2.9-5.8-4.1c-13.2-8-28.8-12.8-44.7-14c-15-1.2-29.4,0.8-42.8,5.6c-6.2,2.3-11.5,5.8-16.5,9.1       c-3.7,2.5-7.6,5.1-11.7,7c-7.2,3.5-16.7,3.5-25.3,3.3c-2.7,0-5.2,0-7.6,0c-10.3,0.4-29,2.7-40.1,15.6c-4.9,5.6-11.7,8.6-20.4,8.9       c-12.6,0.6-22.2,6.4-32.7,15.2c-1.9,1.7-3.5,3.9-5.2,6c-1.2,1.6-2.3,3.1-3.5,4.5c-4.9,5.2-6.6,11.9-8.4,18.7       c-0.6,1.9-1,3.7-1.6,5.6c-0.2,0.6-0.4,1.2-0.4,1.6c-1.4,4.7-2.9,10.1-9.7,12.6c-7,2.7-15.9,6.6-22.6,12.6       c-14,13-19.8,26.1-18.3,41.2c0.6,5.6,0.2,11.5,0,17.1c-0.2,2.1-1.2,4.9-2.9,5.8c-8.7,5.1-15,10.7-19.6,17.7       c-5.8,8.7-12.6,23.3-12.8,36.2c-0.2,5.8,1.6,11.5,3.3,16.9c2.3,7.6,4.7,15.6,2.3,24.7c-1,3.5-2.3,6.8-3.9,9.9       c-1.2,2.7-2.5,5.6-3.3,8.6c-9.1,30.7,25.3,54.8,48,71c1.7,1.2,3.3,2.3,4.9,3.5c15.6,11.1,33.2,22.2,54.1,33.8       c3.5,1.9,8.2,4.1,13.2,6.2c13,5.6,29.4,12.8,34,22.4c2.1,4.3,2.7,9.3,3.3,13.6c0.8,6.4,1.4,13.2,1.9,19.8       c1.4,15.6,2.7,31.5,7,45.7c1,3.3,2.5,5.6,3.9,6.2c5.1,2.3,10.3,4.7,15.2,4.9c23.1,0.6,45.9,0.4,67.1,0.2       C354.1,567.1,354.1,567.1,354.3,567.1z M396.1,573.5c-3.1,0-6.4-0.8-9.9-3.1c-5.1-3.1-10.7-5.4-16.3-7.8       c-1.7-0.8-3.7-1.6-5.4-2.3c-1-0.4-2.1-0.4-3.5-0.4c-0.4,0-0.8,0-1.2,0h-16.5c-17.3,0-35.2,0-52.7,0h-0.2       c-14,0-17.1-8.9-18.3-17.9c-0.6-4.7-1-9.3-1.2-14c-0.2-3.9-0.6-8.2-1-12.1c-0.2-1.8-0.4-3.5-0.6-5.2c-0.8-7.4-1.6-15.2-3.5-22.2       l-0.4-1.2c-3.1-11.1-6.4-22.7-18.5-28c-1.9-0.8-3.9-1.6-6-2.3c-3.5-1.4-7.4-2.9-10.7-4.7c-2.1-1.2-4.3-2.3-6.4-3.3       c-11.1-5.6-22.6-11.5-29.7-21.6l-12.6-17.5c-3.1-4.3-6.6-9.1-8.2-14.6c-1.6-5.6-0.6-10.9,2.7-15.6c3.1-4.3,5.6-8.2,5.1-13.4       c-0.8-6.6-1.7-14-3.1-23.1c-1-6.6-1.4-11.9-0.8-16.7c0.6-6,2.7-14.4,9.3-20.8c2.3-2.1,4.7-4.1,7-6.2c2.5-2.1,5.1-4.3,7.4-6.4       c6.6-6.2,5.8-12.2,4.9-19.2c-0.4-3.9-1-7.8-0.4-12.1c1.2-7.6,5.1-14.8,12.6-22.9c4.9-5.2,9.3-9.7,16.5-12.2       c0.6-0.2,1.4-0.4,1.9-0.8c3.3-1.2,6.8-2.3,8.9-5.1c2.5-3.3,4.1-10.1,5.2-14.4l0.2-1c5.1-20.6,20.8-27,39.5-32.7       c9.1-2.7,16.5-6.6,25.9-13c0.6-0.4,1.2-0.8,1.9-1.4c4.3-3.1,10.3-7.6,15.4-4.9c1.9,0,3.9,0,5.8-0.2c5.6,0,11.5-0.2,16.9-1       c6.8-1.2,12.8-3.5,19.1-6.2c3.5-1.4,7-2.9,10.9-4.3c8-2.5,16.9-3.9,26.8-3.5c7.8,0.2,15.4,1.9,22.7,3.7       c5.4,1.4,11.1,2.5,16.7,3.3c22.4,2.5,47.2,11.1,76.2,25.7c6.6,3.3,13.4,7.2,18.5,12.8c4.1,4.5,6.2,11.1,8.4,17.3       c0.8,2.1,1.6,4.3,2.3,6.2c1.2,2.9,2.3,6,4.1,8.6c3.3,4.9,8.6,7.4,14.2,9.9c5.6,2.5,11.5,5.2,15.4,10.7       c5.1,7.2,10.3,14.6,8.9,24.5c-0.2,1.9-0.2,3.9,0,6c0,2.1,0.2,4.3-0.2,6.4c-1,7.4,1.9,12.8,8.7,15.9c8.6,4.1,12.4,12.1,15.9,19.1       c3.7,7.4,5.2,15.2,4.5,22.4c-0.4,3.7-1,8.4-2.9,12.6c-0.8,1.9-2.5,3.9-5.2,5.8c-0.2,1.7,0.2,11.5,0.4,12.8c0.2,1.7,1,2.3,2.3,3.3       c0.6,0.4,1.2,1,1.8,1.6c1.6,1.7,2.5,4.3,3.3,6.2c1.2,3.3,2.9,8.2,2.7,12.6c-0.2,8.7-4.7,16.1-8.2,21l-0.8-0.6l0.8,0.6       c-6,7.8-15.4,18.5-26.1,24.5c-6.6,3.7-13.2,7.2-19.8,10.9c-6.4,3.5-12.8,7-19.2,10.5c-1.9,1-3.9,2.1-5.8,3.1       c-5.2,2.7-10.7,5.4-14.6,9.3c-0.4,0.4-1,1-1.6,1.4c-3.9,3.7-7.8,7.4-8.4,13.4c-0.8,7.6-2.3,15.2-3.9,22.6       c-0.6,3.1-1.4,6.4-1.9,9.5c0,0.4,0,0.6-0.2,1c-0.2,2.7-0.4,5.2-0.6,8c-0.4,6.2-0.8,12.8-1.7,19.1c-0.2,1-0.2,1.9-0.4,2.9       c-0.4,4.3-1,9.1-5.1,12.1c-2.3,1.6-6.8,4.3-11.1,4.5c-8.6,0.4-17.3,0.4-25.7,0.2c-3.3,0-6.6,0-9.9,0h-9.7c-7.4,0-15,0-22.4,0       c-9.9,0-18.5,4.3-25.7,8.4C406.4,571.1,401.6,573.5,396.1,573.5z M362.1,558.1c1,0,2.1,0,3.1,0.6c1.7,0.8,3.7,1.6,5.4,2.3       c5.6,2.3,11.5,4.7,16.5,8c8.6,5.2,16.1,1.7,22.6-1.9c7.4-4.3,16.1-8.7,26.6-8.7c7.4,0,15,0,22.4,0h9.7c3.3,0,6.6,0,9.9,0       c8.4,0,17.1,0.2,25.7-0.2c3.9-0.2,8-2.7,10.1-4.1c3.5-2.5,3.9-6.6,4.3-10.7c0.2-1,0.2-2.1,0.4-3.1c1-6.2,1.4-12.6,1.8-18.9       c0.2-2.7,0.4-5.4,0.6-8c0-0.4,0-0.8,0.2-1.2c0.6-3.3,1.2-6.4,1.9-9.7c1.6-7.4,2.9-15,3.9-22.4c0.8-6.8,5.2-10.9,8.9-14.8       c0.6-0.4,1-1,1.4-1.4c4.3-4.1,9.7-7,15.2-9.7c1.9-1,3.9-1.9,5.8-2.9c6.4-3.5,12.8-7,19.2-10.5c6.6-3.7,13.2-7.2,19.8-10.9       c10.5-5.8,19.6-16.1,25.5-23.9c3.5-4.5,7.6-11.7,7.8-19.8c0.2-4.1-1.4-8.7-2.5-11.9c-0.8-2.1-1.6-4.3-2.9-5.8       c-0.6-0.6-1-1-1.6-1.4c-1.4-1-2.5-1.9-2.9-4.5c0-0.2-1.2-13.4,0.2-14.6c2.5-1.7,4.1-3.5,4.9-5.2c1.8-3.9,2.3-8.6,2.7-12.1       c0.8-6.8-0.8-14.2-4.3-21.4c-3.5-7-7.2-14.4-15.2-18.1c-7.4-3.5-10.9-9.7-9.7-18.1c0.2-1.9,0.2-3.9,0-6c0-2.1-0.2-4.3,0-6.4       c1.2-9.1-3.9-16.3-8.6-23.1c-3.5-5.1-9.1-7.6-14.6-10.1c-5.6-2.5-11.5-5.2-15-10.7c-1.9-2.7-3.1-5.8-4.3-8.9       c-0.8-1.9-1.6-4.1-2.3-6.4c-2.1-6-4.3-12.4-8-16.5c-4.9-5.4-11.5-9.1-17.9-12.4c-28.8-14.6-53.5-22.7-75.6-25.5       c-5.6-0.6-11.5-1.9-16.9-3.3c-7.4-1.7-15-3.5-22.6-3.7c-9.5-0.4-18.5,0.8-26.2,3.3c-3.7,1.2-7.2,2.7-10.7,4.1       c-6,2.5-12.4,5.2-19.6,6.4c-5.6,1-11.5,1-17.3,1c-2.1,0-4.1,0-6.2,0.2h-0.2l-0.2-0.2c-4.1-2.3-9.5,1.7-13.6,4.7       c-0.8,0.6-1.4,1-1.9,1.4c-9.5,6.6-17.1,10.5-26.4,13.2c-18.7,5.8-33.2,11.7-38.1,31.3l-0.2,1c-1.2,4.9-2.7,11.5-5.6,15.2       c-2.3,3.1-6.4,4.5-9.9,5.6c-0.6,0.2-1.4,0.4-1.9,0.6c-6.8,2.5-10.9,6.6-15.7,11.7c-7.2,7.8-11.1,14.8-12.1,21.8       c-0.6,4.1-0.2,8,0.4,11.7c1,7.2,1.7,14-5.4,21c-2.3,2.3-5.1,4.5-7.4,6.6c-2.3,1.9-4.7,3.9-7,6c-6.2,5.8-8.2,13.8-8.7,19.4       c-0.4,4.7-0.2,9.9,0.8,16.3c1.4,9.1,2.3,16.5,3.1,23.1c0.6,5.8-2.1,10.3-5.4,14.8c-2.9,4.1-3.7,8.9-2.3,14       c1.4,5.2,4.7,9.7,7.8,14l12.6,17.5c7,9.7,18.3,15.6,29.2,21c2.1,1.2,4.5,2.3,6.4,3.3c3.3,1.7,7,3.3,10.5,4.7       c1.9,0.8,4.1,1.6,6,2.3c13,5.6,16.3,17.5,19.6,29.2l0.4,1.2c2.1,7.4,2.9,15,3.7,22.6c0.2,1.7,0.4,3.5,0.6,5.2       c0.4,4.1,0.8,8.2,1,12.2c0.4,4.5,0.6,9.3,1.2,13.8c1.2,9.7,4.7,16.3,16.5,16.1c17.5-0.2,35.4,0,52.7,0h16.5l0,0c0.4,0,0.8,0,1,0       C361.3,558.3,361.7,558.1,362.1,558.1z M170.9,416.6c-0.4,0-0.6,0-1-0.2c-2.5-1.4-4.5-2.7-6.4-3.9c-1.6-1.2-3.3-2.1-4.9-3.3       c-4.5-3.1-9.1-6.2-13.6-9.7s-8.7-7.4-12.8-11.1c-2.5-2.1-4.9-4.5-7.4-6.6c-5.6-4.9-10.1-10.1-12.8-15.6l-0.6-1.2       c-2.9-5.4-5.6-10.5-4.9-17.3c0.6-5.4,3.3-10.1,6-14.8c2.5-4.5,5.1-8.6,5.6-13.6c0.6-3.9-0.6-8.6-1.6-12.4l-0.2-0.6       c-0.6-2.7-1.6-5.4-2.3-8.2c-1.7-5.6-3.7-11.3-3.7-17.3c-0.2-7.6,2.3-15,5.2-21.8c2.3-5.6,6.2-9.5,10.3-13.4       c0.8-0.8,1.6-1.6,2.3-2.3l12.2-12.4c1.9-1.9,3.7-3.7,4.9-6c0.8-1.6,0.8-3.1,0.8-4.9c0-0.6,0-1.4,0-1.9c0-4.9,0-9.7,0-14.6v-4.7       c0-8,2.5-15,8.2-22.7c6.8-9.1,16.9-15,23.9-18.7c8.2-4.3,13.8-9.9,16.5-16.5c1-2.3,1.6-4.7,2.1-7.2c0.6-1.9,1-4.1,1.7-6       c1.6-4.7,3.9-9.1,6.6-13.4c5.2-8,12.4-13.8,22.7-18.3c2.7-1.2,5.6-1.9,8.6-2.5c1.6-0.4,3.1-0.8,4.7-1.2c1.9-0.6,3.9-1,5.8-1.4       c6.4-1.4,12.4-2.5,17.5-8.2c6.8-7.4,15.6-12.4,25.3-14.6c3.9-0.8,8.2-0.8,12.2-0.8c1.7,0,3.5,0,5.2,0c6.4-0.2,12.8-0.4,19.1-0.8       c5.1-0.4,8.2-1.6,11.9-4.5c5.2-4.3,10.7-7.8,15.6-9.9c11.1-5.1,22-8.2,32.7-9.3c5.8-0.6,11.9-0.8,17.3-0.2c2.7,0.2,5.6,1,8.2,1.6       c2.5,0.6,5.2,1.4,8,1.6c6.8,0.8,12.8,3.5,18.7,6.2l1.2,0.6c3.1,1.6,5.8,3.7,8.6,5.6c2.7,2.1,5.4,4.3,8.6,5.6       c8.2,3.5,17.5,3.5,26.4,3.3c1.6,0,3.1,0,4.7,0c7.2-0.8,17.9-0.4,28,6.2c4.7,3.1,9.5,6.8,14.6,11.3c3.3,2.9,7,4.7,12.1,6       c2.5,0.6,5.2,1,8,1.4c6.6,1,13.6,2.1,19.6,6.2l1,0.6c9.3,6.6,19.1,13.4,21.8,26.2c0.2,1.4,1,2.5,1.6,3.9c0.8,1.6,1.6,3.1,1.8,4.9       c0.2,1.6,0.2,3.5-0.2,5.2c0.6,1.9,1,3.9,1.6,6c1.8,3.9,3.9,6.2,5.8,6.6c2.9,0.4,5.4,1.6,7,3.5c2.9,1.4,6.2,2.9,9.3,4.5       c9.3,4.9,17.5,12.6,25.3,24.7c1.9,2.9,2.3,7,2.5,10.5l0.2,1.2c0.4,3.1,0.2,6.2,0.2,9.1c0,1.4,0,2.7,0,3.9s0,2.3,0,3.5       c0,2.7,0.2,5.4-0.2,8c-0.8,6,2.9,8.9,7.2,12.2l1.2,1c7.2,5.8,12.4,11.1,16.3,16.3c4.1,5.6,6.6,12.6,8.9,18.9       c0.8,1.9,0.6,4.3,0.6,6.4c0,1.4-0.2,2.9,0,4.3c1.4,9.7-2.1,19.2-5.4,28.2c-0.8,2.3-1.8,4.5-2.5,6.8c-0.4,1-0.8,2.1-0.8,3.1       c-0.4,2.5,0.4,5.1,1,7.6c0.4,1.6,0.8,3.1,1.6,4.3c0.6,0.8,1.4,1.2,2.1,1.7c0.6,0.4,1.2,0.6,1.8,1.2c1.6,1.4,2.7,3.5,3.7,5.2       c2.3,4.3,3.7,8.2,4.1,11.5c0,0.4,0,0.6,0,0.8c0,5.8-4.9,13-8.4,18.3c-0.6,0.8-1,1.4-1.4,2.1c-3.9,5.8-8.7,11.5-15,17.3       c-2.7,2.7-6,4.9-9.1,6.8c-1.8,1.2-3.5,2.3-5.1,3.5c-1,0.6-1.8,1.4-2.5,2.3c-0.8,0.8-1.8,1.6-2.7,2.3c-0.8,0.6-1.8,0.8-2.5,0.8       c-0.4,0-0.6,0-1,0.2l-1.2,0.2v-1.2c0-0.4,0-0.6,0-1c0-0.8-0.2-1.6,0.2-2.5c2.9-8.4,3.3-15.7,1.4-22.6c-0.6-2.1-2.1-4.1-3.7-6.2       c-1.9-2.7-4.1-5.4-4.3-8.7c-0.2-2.5,0.4-5.4,1-8.2c0.2-1.4,0.6-2.7,0.8-3.9c0.8-4.9,2.5-9.9,4.1-13.8v-0.6       c-0.2-1.2-0.4-2.3-0.2-3.5c1-10.1-1-19.8-6-29c-3.7-6.6-9.1-15-17.9-19.8c-3.9-2.1-5.6-5.2-5.2-9.1c0.2-1.4,0-2.7,0-4.1       c0-1.7-0.2-3.7,0.2-5.4c1.9-11.7-2.9-21.6-7.6-29c-3.3-5.2-8.6-9.5-13.2-13c-2.7-1.9-6.2-3.3-9.5-4.7c-1.4-0.6-2.5-1-3.9-1.6       c-2.7-1.2-4.5-4.5-5.8-7.2c-0.6-1.2-1.2-2.3-1.9-3.3c-2.5-3.7-4.1-8.2-4.3-12.8l0,0c-0.4-0.6-1-1.2-1.4-1.9       c-1-1.6-1.8-3.1-2.5-4.9c-1.8-3.3-3.5-6.8-5.8-9.3c-5.6-6.2-13-10.9-21-13.4c-2.9-1-6-1.7-8.9-2.3c-4.3-1.2-8.7-2.3-13-3.9       c-2.9-1.2-5.6-3.3-8.2-5.2c-0.8-0.8-1.7-1.4-2.5-2.1c-4.3-3.1-9.9-7-16.3-8.7c-4.7-1.4-9.9-1.6-14.8-1.9c-1.9-0.2-4.1-0.2-6-0.4       c-1.7-0.2-3.9-0.2-5.8-0.4c-4.5-0.2-8.9-0.4-12.8-1.6c-2.3-0.8-4.5-1.9-6.4-2.9c-2.1-1.2-4.3-2.3-6.6-3.1       c-11.1-3.3-22.7-2.1-32.7-0.8c-10.7,1.6-22.9,3.3-31.5,12.2c-5.4,5.6-12.1,4.5-18.7,3.1l-0.8-0.2c-6.8-1.2-12.4,0-18.3,1.6       c-2.3,0.6-4.7,1.2-7.4,1.6c-4.7,1.9-9.3,4.9-13.6,8.6c-7.8,6.8-16.7,9.3-24.5,10.9c-5.2,1-12.8,3.1-19.1,7.4       c-10.1,7.2-16.3,16.5-18.9,27.8c-1.2,5.1-2.1,9.5-6.2,13.4c-3.1,2.9-6.6,5.1-10.3,7c-1.6,1-2.9,2.1-4.3,3.3       c-1.7,1.4-3.5,2.9-5.6,3.9c-9.7,4.5-13.8,13.8-17.1,22.2c-2.5,6.8-3.5,11.7-1.6,18.3c0.8,3.1,1.7,6.2,1.4,9.3       c-0.6,5.2-4.5,7.2-8.2,9.1c-2.1,1-4.3,2.1-5.8,3.9c-5.4,6-9.5,11.7-12.2,17.1c-3.7,7.4-4.3,15.7-4.3,22.4c0,1.7,0,3.5-0.2,5.1       c-0.2,5.2-0.4,10.3,0.8,15.6c0.6,3.1,1.4,6,1.7,9.1c0.6,2.9,1,6,0.6,9.1c-0.4,3.1-1.9,5.4-3.5,7.6c-1.4,2.1-2.7,4.1-3.3,6.4       c-1.2,5.2-0.4,11.1,2.5,18.5c0.8,1.9,1.7,3.7,2.7,5.4c0.6,1.2,1.2,2.1,1.7,3.3c0.2,0.6,0.2,1.2,0.2,1.6c0,0.2,0,0.4,0,0.6v1h-1       c-0.2,0-0.4,0-0.6,0C171.7,416.6,171.3,416.6,170.9,416.6z M298.1,69.1c-2.7,0-5.6,0.2-8.2,0.8c-9.3,2.1-17.7,7-24.3,14       c-5.4,6-12.1,7.4-18.5,8.7c-1.9,0.4-3.9,0.8-5.8,1.4c-1.6,0.4-3.1,0.8-4.7,1.2c-2.9,0.6-5.6,1.2-8.2,2.3       c-9.9,4.3-16.9,9.9-21.8,17.5c-2.7,4.1-4.9,8.6-6.4,13c-0.8,1.9-1.2,3.9-1.7,6c-0.6,2.5-1.2,5.1-2.1,7.4       c-2.9,7.2-8.7,13-17.5,17.5c-6.8,3.5-16.7,9.3-23.1,18.1c-5.4,7.4-8,14-8,21.6v4.7c0,4.9,0,9.7,0,14.6c0,0.6,0,1.2,0,1.9       c0,1.9,0.2,3.9-1,6c-1.4,2.3-3.3,4.5-5.1,6.2l-12.2,12.6c-0.8,0.8-1.6,1.6-2.5,2.5c-3.9,3.9-7.6,7.6-9.7,12.8       c-2.7,6.6-5.2,13.8-5.1,21c0.2,5.6,1.9,11.3,3.7,16.7c0.8,2.7,1.7,5.4,2.5,8.4l0.2,0.6c1,4.1,2.3,9.1,1.6,13.2       c-0.8,5.2-3.5,9.9-6,14.2c-2.7,4.5-5.2,8.9-5.8,14c-0.8,6.2,1.7,10.9,4.7,16.1l0.6,1.2c2.7,5.2,7,10.1,12.4,15       c2.5,2.1,5.1,4.3,7.4,6.6c4.1,3.7,8.4,7.4,12.8,10.9c4.3,3.5,8.9,6.6,13.4,9.5c1.6,1.2,3.3,2.1,4.9,3.3c1.7,1.2,3.9,2.5,6.2,3.9       c0,0,0.2,0,0.4,0c0-0.2,0-0.4,0-0.6c-0.6-1-1.2-2.1-1.7-3.1c-1-1.8-1.9-3.7-2.9-5.6c-1.9-4.9-4.3-12.2-2.7-19.6       c0.6-2.7,2.1-5.1,3.5-7.2c1.6-2.1,2.9-4.3,3.3-6.8c0.4-2.7,0-5.8-0.6-8.6c-0.6-3.1-1.2-6-1.7-9.1c-1.2-5.4-1-10.5-0.8-15.9       c0-1.6,0.2-3.3,0.2-5.1c0-6.6,0.6-15.4,4.5-23.1c2.9-5.6,7-11.5,12.4-17.7c1.7-1.9,4.1-3.1,6.4-4.3c3.5-1.7,6.6-3.5,7.2-7.6       c0.4-2.9-0.6-5.8-1.4-8.7c-2.1-7.2-1-12.6,1.7-19.6c3.3-8.7,7.8-18.5,18.1-23.3c1.9-1,3.5-2.3,5.2-3.7c1.4-1.2,2.9-2.5,4.7-3.5       c3.5-1.9,7-4.1,9.9-6.8c3.7-3.5,4.5-7.4,5.6-12.2c2.5-11.7,9.3-21.8,19.6-29c6.4-4.5,14.2-6.8,19.8-7.8       c7.6-1.4,16.1-3.9,23.7-10.3c4.5-3.9,9.1-6.8,14.2-8.9h0.2c2.5-0.4,4.9-1,7.4-1.6c6.2-1.6,12.1-2.9,19.1-1.6l1,0.2       c6.2,1.2,12.2,2.3,16.9-2.5c9.1-9.5,21.6-11.3,32.7-12.8c10.1-1.4,22.2-2.5,33.4,0.8c2.5,0.8,4.9,1.9,7,3.1       c2.1,1.2,4.1,2.1,6,2.9c3.7,1.2,8,1.4,12.2,1.6c2.1,0,4.1,0.2,6,0.4s3.9,0.4,5.8,0.4c5.1,0.4,10.3,0.8,15.2,2.1       c6.8,1.9,12.6,5.8,17.1,9.1c1,0.6,1.7,1.4,2.7,2.1c2.3,1.9,4.9,3.9,7.6,4.9c4.3,1.6,8.6,2.7,12.8,3.7c2.9,0.8,6,1.6,8.9,2.5       c8.4,2.5,15.7,7.4,21.8,14c2.5,2.9,4.5,6.4,6.2,9.7c0.8,1.6,1.6,3.1,2.5,4.7c0.4,0.6,0.8,1.2,1.2,1.7l0.4,0.6v0.4       c0.2,4.5,1.6,8.6,4.1,12.1c0.8,1,1.4,2.3,1.9,3.5c1.4,2.7,2.9,5.4,5.1,6.4c1.2,0.6,2.5,1,3.7,1.6c3.5,1.4,7,2.7,9.9,4.9       c4.9,3.7,10.3,8,13.6,13.4c4.9,7.6,9.9,18.1,7.8,30.3c-0.2,1.6-0.2,3.3-0.2,5.1c0,1.4,0.2,2.9,0,4.5c-0.4,3.1,1.2,5.4,4.3,7.2       c9.3,5.1,15,13.6,18.7,20.6c5.2,9.3,7.4,19.4,6.2,30.1c0,1,0,1.9,0.2,3.1l0.2,1v0.2c-1.6,3.9-3.5,8.7-4.1,13.6       c-0.2,1.2-0.4,2.5-0.8,3.9c-0.6,2.7-1.2,5.2-1,7.6c0.2,2.7,1.9,5.1,3.9,7.6c1.6,2.1,3.1,4.3,3.9,6.8c2.1,7.2,1.8,15-1.4,23.7       c-0.2,0.4-0.2,1,0,1.6l0,0c0.6,0,1.4-0.2,1.6-0.4c0.8-0.6,1.6-1.4,2.5-2.1c0.8-0.8,1.8-1.7,2.7-2.5c1.8-1.2,3.5-2.5,5.2-3.5       c3.1-1.9,6.2-4.1,8.9-6.6c6-5.8,10.9-11.3,14.6-16.9l0,0c0.4-0.6,1-1.4,1.4-2.1c3.5-5.1,8.2-11.7,8.2-17.1c0-0.2,0-0.4,0-0.6       c-0.4-3.1-1.6-6.6-3.7-10.7c-1-1.7-1.9-3.7-3.3-4.9c-0.4-0.4-1-0.6-1.6-1c-1-0.6-1.9-1.2-2.7-2.3c-1-1.6-1.4-3.3-1.9-4.9       c-0.8-2.5-1.6-5.4-1-8.4c0.2-1.2,0.6-2.3,1-3.3c0.8-2.3,1.6-4.7,2.5-6.8c3.3-8.7,6.6-17.9,5.4-27.2c-0.2-1.6-0.2-3.1-0.2-4.5       c0-2.1,0.2-4.1-0.4-5.6c-2.1-6-4.7-12.8-8.6-18.3c-3.7-5.2-8.7-10.3-15.9-15.9l-1.2-1c-4.5-3.5-8.7-6.8-8-14       c0.2-2.5,0.2-5.2,0.2-7.8c0-1.2,0-2.3,0-3.7c0-1.4,0-2.7,0-3.9c0-2.9,0.2-6-0.2-8.9l-0.2-1.2c-0.4-3.5-0.6-7.2-2.3-9.7       c-7.6-11.7-15.4-19.2-24.5-24.1c-3.1-1.6-6.4-3.1-9.3-4.7l-0.4-0.2c-1.4-1.6-3.5-2.7-6-3.1c-3.5-0.6-6-4.5-7.4-7.8       c-0.6-2.1-1.2-4.3-1.6-6.4v-0.2v-0.2c0.4-1.6,0.4-3.3,0.2-4.9c-0.2-1.4-1-2.9-1.6-4.3c-0.6-1.4-1.4-2.7-1.8-4.3       c-2.7-12.1-11.5-18.3-21-25.1l-1-0.6c-5.6-4.1-12.2-5.1-18.7-6c-2.7-0.4-5.4-0.8-8-1.4c-5.4-1.4-9.3-3.1-13-6.4       c-4.9-4.3-9.7-8-14.2-11.1c-9.5-6.2-19.8-6.6-26.8-5.8c-1.6,0-3.1,0-4.7,0c-9.1,0.2-18.7,0.2-27.2-3.5c-3.5-1.6-6.2-3.7-9.1-6       c-2.7-2.1-5.1-4.1-8.2-5.4l-1.2-0.6c-5.6-2.7-11.5-5.4-18.1-6c-2.7-0.2-5.6-1-8.2-1.6c-2.5-0.6-5.2-1.4-8-1.6       c-5.4-0.6-11.3-0.6-16.9,0.2c-10.3,1.2-21.2,4.3-32.1,9.1c-4.7,2.1-9.9,5.4-15.2,9.7c-4.1,3.3-7.6,4.7-13,5.1       c-6.4,0.4-12.8,0.8-19.1,0.8c-1.7,0-3.5,0-5.2,0C300.6,69.1,299.5,69.1,298.1,69.1z"})]}),jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{className:"st0",d:"M400,554.8c-6.2,0-13.2-3.7-17.3-8c-2.9-3.1-5.2-7.6-4.3-11.7c0.4-1.9,7.4,1,8.4,1.6c2.5,1.7,3.5,4.7,6,6.2       c5.2,3.1,11.7,0.6,16.1-2.9c2.1-1.8,4.9-3.3,7.6-3.7c3.5-0.6,5.1,1.9,3.7,5.2c-2.3,5.6-10.3,10.3-15.6,12.4       C403.3,554.6,401.8,554.8,400,554.8z"}),jsxRuntimeExports.jsx("path",{className:"st0",d:"M399.8,555.8c-6.8,0-14-4.3-17.9-8.2c-3.7-3.9-5.4-8.6-4.5-12.6c0.2-0.6,0.6-1,1.2-1.2       c2.3-0.8,8,1.7,8.7,2.1c1.4,1,2.1,2.1,3.1,3.1c1,1.2,1.7,2.3,2.9,2.9c4.9,2.9,10.9,0.4,15-2.9c1.6-1.2,4.5-3.3,8.2-3.9       c1.9-0.4,3.5,0.2,4.5,1.4c1,1.4,1.2,3.1,0.2,5.2c-2.3,5.8-10.3,10.5-16.1,13C403.5,555.4,401.9,555.8,399.8,555.8L399.8,555.8       C400,555.8,400,555.8,399.8,555.8z M379.4,535.6c-0.8,3.3,0.8,7.2,4.1,10.7c3.5,3.7,10.3,7.8,16.5,7.6l0,0c1.6,0,2.9-0.2,4.3-0.8       c4.5-1.7,12.8-6.4,15.2-11.9c0.6-1.4,0.6-2.5,0-3.3c-0.4-0.6-1.4-0.8-2.7-0.6c-2.3,0.4-4.9,1.7-7.2,3.5       c-4.7,3.7-11.5,6.4-17.1,3.1c-1.6-1-2.5-2.1-3.5-3.5c-0.8-1-1.6-1.9-2.7-2.7C385.4,536.9,380.6,535.2,379.4,535.6z"})]})]}),jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsx("path",{className:"st0",d:"M378,402.4c-0.8-2.1-1.4-4.5-1.6-6.6c-0.6-8-1.4-15.7-1.9-23.7c-3.1-36-7-71.9-11.5-107.7        c-2.3-17.9-4.7-35.8-7.2-53.7c-3.1-21.4-6-42.8-9.1-64.4c-2.9-20.6-8.4-41-8.4-62c-0.8-6.2-2.1-12.2-2.9-18.3        c-0.2-1,0.4-2.1,1.2-3.1c-0.8-3.1-1.4-6-1.7-9.3c-0.6,0.4-1.4,0.8-1.9,1c-3.3,1.6-7,2.3-10.7,2.9c0.2,4.1,0.4,8.2,0.2,12.2        c0.6,1.2,1,2.5,1,4.3c0.6,8.4,1.2,16.7,2.1,25.1c1.9,17.7,6,35,4.1,52.9c0-0.4,3.5,0,3.7,1.6c8.9,78.9,19.6,158.3,29.9,237.2        c0.4,2.9-0.2,6,0.2,8.9c0.4,3.1,0.4,7.2,2.3,8.7c2.1,1.7,6.4,1.7,9.3,1C378,408.8,379.2,405.7,378,402.4z"})}),jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsx("path",{className:"st0",d:"M298.5,436.8c-4.7-3.9-9.7-7.2-14.6-10.7c-38.7-27.8-78.4-54.2-117.4-81.5c-9.1-6.2-19.1-10.9-28.2-17.1        c-4.9-3.3-9.7-6.6-14.4-10.3c-4.7-3.5-9.3-4.1-15-5.2c-0.4,0-0.6-0.2-1-0.2c0,2.5-0.2,5.1-1,7.8c-0.2,0.8-0.4,1.6-0.6,2.1        c3.3,2.9,6.4,5.8,9.7,8.7c1,0,1.9,0.6,3.1,1.4c7.8,5.2,15.9,9.7,23.5,15.2c7.8,5.6,15.7,11.1,23.9,16.3        c17.9,11.7,37.1,21.6,54.8,34c18.5,13,37.1,25.7,55,39.5c4.3,3.3,8.4,6.6,12.6,10.1c3.9,3.1,6.2,1.4,8.9-1.4        C300.6,442.4,301.8,439.5,298.5,436.8z"})}),jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsx("path",{className:"st0",d:"M338.2,402.4c-29.9-57.4-56.6-119-92-173.1c-1.9-2.9-1.9-4.9-1.4-6.6c-2.1-3.3-4.1-6.8-5.8-10.3        c-0.2,0.2-0.4,0.4-0.6,0.6c-0.6-1-1.2-1.9-1.7-2.9c-5.8-9.9-11.7-19.6-17.3-29.7c-7-12.4-14-25.1-20.8-37.9        c-0.4-0.8-0.8-1.7-1-2.7c-1-0.8-1.9-1.7-2.9-2.7c-2.1-2.1-4.1-4.7-5.8-7c-0.2,1-0.6,1.7-0.8,2.7c-1,3.5-1.9,7.4-4.5,10.3        c1.2,3.1,2.3,6.4,3.5,9.7c1.7,0.2,3.1,1.6,3.9,3.3c5.1,9.3,9.5,18.9,14.4,28.4c3.5,6.8,6.2,14,10.7,19.8        c3.7,4.9,6.2,9.9,8.6,15.4c0.4,1,0.2,2.9-0.6,3.5c-0.2,0.2-0.4,0.4-0.8,0.6c1.4,1.7,2.5,3.7,3.7,5.4c0.4,0.8,0.8,1.4,1.2,2.1        c6-0.4,8.7,11.1,11.1,15.2c5.8,10.3,12.2,20.6,17.9,30.9c3.7,6.6,6.2,13.8,9.7,20.4c4.7,8.9,9.7,17.5,14.4,26.2        c15.4,29.4,29.9,59.1,44.9,88.7c1.9,3.7,4.5,8,8.6,7.8c3.7,0,6.4-4.1,6.6-7.8C341.7,409.4,339.9,405.7,338.2,402.4z"})}),jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsx("path",{className:"st0",d:"M466.3,57.4c-4.3-1.2-8-4.3-11.7-7c-0.8,23.9-5.6,47.4-9.5,71c-2.5,15.6-2.9,32.1-5.8,47.6        c-2.3,11.7-4.7,22.9-6.2,34.8c-2.7,22.6-4.1,45.1-7,67.5c-5.2,40.4-10.3,80.9-14.2,121.3c-0.6,5.1-0.6,10.1,0,15        c0.6,4.3,4.5,2.1,7,2.5c3.5,0.4,6-1.4,6.6-4.7c8.6-64.4,14.4-129.7,23.5-193.7c3.5-24.3,6.6-48.8,9.5-73.3        c1.6-12.4,2.9-24.9,4.5-37.3c1.4-11.1,1.2-22.6,5.1-32.9c0.2-0.6,1.2-1.2,2.1-1.4c0.2-1.2,0.4-2.5,0.6-3.7        c0.2-1.6,0.2-3.3,0.4-4.9C469.4,58,467.9,57.8,466.3,57.4z"})}),jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsx("path",{className:"st0",d:"M602.4,125.3c-0.6-0.6-1-1.2-1.6-1.6c1,0.8-12.8,25.9-14.2,28.4c-6.8,13.4-15.6,26.1-22.9,39.3        c0,3.9-6.6,11.9-8.6,15.4c-3.1,5.6-6.2,11.1-9.1,16.7c-5.6,10.1-10.1,20.6-15.6,30.9c-11.9,22.4-23.7,44.9-35.6,67.3        c-15.2,29-28.8,60.1-46.3,87.7c-2.7,4.3,0.2,7.6,1.9,10.3c1,1.6,5.1,1.2,7.8,1c0.8,0,1.7-1.7,2.3-2.7        c8.4-16.5,16.7-32.9,24.9-49.4c5.8-11.7,11.5-23.3,17.3-34.8c6.8-13.4,14-26.6,21-40.1c5.1-9.5,9.9-19.1,15.4-28.6        c10.7-18.9,21.4-37.7,31.9-56.6c5.2-9.3,10.5-18.7,15.7-27.8c5.2-9.3,9.7-20.8,16.3-29.2C609.4,144.3,608.8,132.5,602.4,125.3z"})}),jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsx("path",{className:"st0",d:"M682.1,312.7c-1.6-2.3-4.3-6-7.4-6.4c0.6,0-2.5,7.2-2.9,7.8c-1.9,2.5-4.9,4.1-7.6,5.8        c-8.6,5.1-16.9,10.3-25.5,15.4c-0.2-1.4-0.4-2.9-0.8-4.3c-3.1,2.9-10.1,7-11.7,10.9c-1.2,2.5-3.9,4.9-6.2,6.4        c-12.4,8.4-25.1,16.5-37.5,24.9c-11.1,7.6-22,15.4-33.1,22.9c-12.2,8.4-24.9,16.1-37.1,24.5c-7,4.9-13.6,10.5-20.2,15.7        c-3.7,2.9-2.7,5.8,0.4,8.7c2.9,2.7,5.6,4.5,9.3,0.8c1.9-1.9,4.9-3.1,7.4-4.7c8.2-5.6,16.5-11.1,24.5-16.7        c5.6-3.9,10.9-8.4,16.7-12.2c8.6-6,17.3-11.7,25.9-17.7c7.2-5.1,14.4-10.1,21.8-15c7.6-5.1,15.2-9.7,22.7-14.6        c1.2-0.8,2.1,0,3.1-0.4c1.4-0.4,2.3-1.6,3.5-2.3c2.5-2.1,5.2-4.1,8-6.2c5.4-4.1,10.9-8,16.5-11.7c11.1-7.4,22.4-14.2,34-20.4        C685.6,320.1,684.3,316.2,682.1,312.7z"})})]})})]})});const CoralShellIcon=({elClass:s})=>jsxRuntimeExports.jsx("svg",{className:s,id:"coral-shell",viewBox:"0 0 792 612",xmlns:"http://www.w3.org/2000/svg",children:jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{className:"st0",d:"M688.2,330.6c-2.3-5.6-4.9-11.7-5.1-17.7c-0.2-8.2,3.5-15.7,5.8-23.3c4.9-15.2-1.4-33.2-10.7-45.7       c-7.4-9.9-19.2-13.8-22.4-27.2c-1.8-7-1-14.2-1.6-21.2c-1.6-15.7-10.7-30.5-23.9-39.5c-14.4-9.5-23.5-9.9-28.6-28.4       c-1.8-6.4-4.9-12.8-8-18.7c-3.3-6.2-8.6-10.7-14.6-15c-8-5.4-15.9-9.1-25.7-9.9c-4.5-0.4-9.1-1.4-13-3.5       c-5.2-2.7-10.1-6.4-14.8-10.3c-8.9-7.2-18.9-11.5-30.5-11.3c-8.6,0.2-20.6,2.3-28.8,0c-6.2-1.7-11.1-7.2-16.7-10.7       c-13.6-8.2-29.4-13-45.1-14.2c-14.6-1.2-29.2,0.6-43.2,5.6c-10.9,4.1-18.5,11.5-28.4,16.3c-9.3,4.7-22.4,2.9-32.5,3.3       c-14.4,0.4-30.9,4.5-40.8,15.9c-5.4,6.2-12.8,8.4-19.8,8.6c-13.6,0.6-23.5,7.4-33.2,15.4c-3.5,2.9-5.8,7.2-8.9,10.5       c-6.4,7-7.4,16.1-10.1,24.7c-1.6,5.2-2.5,11.1-9.5,13.8c-8.2,3.1-16.7,7-22.9,12.8c-12.1,11.1-20.4,24.5-18.5,42.2       c0.6,5.6,0.2,11.3,0,17.1c0,1.7-1.2,4.1-2.5,4.9c-8,4.7-14.6,10.1-19.8,18.1c-6.6,9.9-12.8,24.5-13,36.6       c-0.2,14.4,9.5,26.2,5.6,41.4c-1.7,6.4-5.2,12.2-7.2,18.5c-10.1,33.6,30.7,59.3,53.3,75.4c17.3,12.4,35.6,23.5,54.1,33.8       c12.2,6.8,40.4,15.4,47.1,28.2c2.1,4.1,2.7,8.7,3.3,13.2c2.7,21.2,2.7,45.3,9.1,65.7c0.8,2.5,2.3,5.8,4.3,6.8       c4.9,2.3,10.3,4.9,15.6,4.9c22.4,0.6,44.7,0.4,67.1,0.2c7.4,0,13.8,2.1,20.2,5.2c4.1,1.9,8.4,4.3,12.8,4.9       c11.3,1.4,22.2,0,32.5-5.4c6-3.1,12.4-4.9,19.4-4.5c10.3,0.4,20.8,0,31.1,0c8.6,0,17.1,0.2,25.5,0c6.4-0.2,13-0.2,18.9-2.3       c14.8-5.4,15.2-30.1,16.1-43.6c0.8-11.5,1.2-22.9,4.5-33.8c5.6-17.7,21.2-24.3,36.6-32.3c21.8-11.1,43-23.3,62.8-37.5       c18.7-13.2,44.3-29.2,54.8-50.2C696.9,353.4,694.4,345.6,688.2,330.6z M623.6,406.6c-6.8,8.9-15.9,18.7-25.9,24.1       c-13,7.2-26.1,14.2-39.1,21.4c-7,3.9-15.2,7-20.6,12.4c-4.1,4.1-9.3,8.4-10.3,15.6c-1.2,10.7-3.7,21.4-5.6,32.1       c0,0.4,0,0.6-0.2,1c-0.8,8.9-0.8,18.1-2.3,27c-0.8,4.9-0.2,10.9-5.1,14.4c-3.1,2.1-7,4.1-10.7,4.3c-11.9,0.6-23.7,0.2-35.6,0.2       c-10.7,0-21.4,0-32.1,0c-9.7,0-17.9,3.9-26.1,8.6c-7,4.1-14.8,7.4-23.5,1.9c-6.8-4.3-14.6-7-22-10.1c-1.4-0.6-3.3-0.4-4.9-0.4       c-23.1,0-46.1-0.2-69.2,0c-12.8,0-16.1-7.4-17.5-17.1c-1.2-8.6-1.2-17.5-2.1-26.1c-1-9.3-1.7-18.7-4.1-27.6       c-3.3-11.7-6.4-24.1-19.2-29.6c-5.4-2.3-11.3-4.3-16.7-7c-12.6-6.8-27.4-12.8-36-24.7l-12.6-17.5c-3.1-4.5-6.4-8.9-8-14.4       c-1.4-5.2-0.6-10.3,2.5-14.8c3.1-4.3,5.8-8.6,5.2-14c-0.8-7.8-1.9-15.6-3.1-23.1c-0.8-5.4-1.4-11.1-0.8-16.5       c0.6-7.4,3.3-14.8,8.9-20.2c4.7-4.3,9.7-8.2,14.4-12.6c10.7-10.1,3.1-19.8,4.9-32.1c1.2-8.6,6.4-15.9,12.2-22.4       c4.9-5.2,9.1-9.5,16.1-12.1c3.9-1.4,8.7-2.5,11.5-6c2.9-3.9,4.5-11.3,5.6-15.7c5.1-20.2,20.4-26.2,38.7-32.1       c10.1-3.1,17.7-7.2,26.2-13.2c4.3-2.9,11.1-9.1,16.5-6c7.8-0.2,15.6,0,23.1-1.2c10.9-1.7,19.8-7,30.1-10.5       c8.6-2.7,17.7-3.7,26.4-3.5c13.4,0.4,26.2,5.4,39.5,7c26.1,3.1,52.5,13.8,75.8,25.5c6.6,3.3,13.2,7,18.3,12.6       c5.4,6,7.6,15.7,10.5,23.3c1.2,3.1,2.3,6,4.3,8.7c7,10.3,22.2,10.3,29.6,20.8c4.9,7,9.9,14.2,8.7,23.7c-0.6,4.1,0.4,8.4-0.2,12.4       c-1,8,2.3,13.8,9.1,17.1c8.2,3.9,11.9,11.3,15.6,18.7c3.3,6.6,5.2,14.2,4.5,21.8c-0.4,4.1-1.2,8.6-2.7,12.2       c-1,2.1-3.1,4.1-5.1,5.6c-0.6,0.4,0,12.2,0.2,13.6c0.6,3.1,2.5,3.3,4.3,5.2c1.6,1.6,2.3,4.1,3.1,6c1.4,3.7,2.7,8.2,2.5,12.1       C631.4,393.6,628.1,400.6,623.6,406.6z M676.3,369.7c-4.3,6.2-9.3,11.9-14.8,17.1c-4.1,4.1-9.5,6.8-14.2,10.3       c-1.9,1.4-3.3,3.3-5.2,4.7c-0.8,0.6-2.1,0.6-3.1,0.8c0-1-0.2-2.1,0-3.1c2.7-7.6,3.7-15.4,1.4-23.1c-1.6-5.2-7.6-9.3-7.8-14.6       c-0.2-3.7,1.2-8.2,1.8-11.9c0.6-4.7,2.5-9.3,4.3-13.8c-0.2-1.4-0.4-2.7-0.4-4.1c1-10.5-1.2-20.4-6.2-29.6       c-4.5-8-9.9-15.6-18.3-20.2c-2.9-1.6-5.1-4.1-4.7-8.2c0.4-3.1-0.4-6.4,0.2-9.5c1.9-11.1-2.1-20.8-7.8-29.7       c-3.3-5.2-8.4-9.5-13.4-13.2c-3.9-2.9-8.9-4.5-13.4-6.4c-3.5-1.6-5.2-7.2-7.4-10.3c-2.5-3.7-3.9-8-4.3-12.6       c-0.6-0.8-1-1.4-1.6-2.1c-2.7-4.9-4.9-10.3-8.6-14.4c-5.8-6.4-13-11.1-21.4-13.6c-7.2-2.1-14.8-3.7-22-6.2       c-3.9-1.4-7.2-4.7-10.5-7.2c-5.1-3.7-10.5-7.2-16.7-8.9c-6.6-1.9-14.2-1.7-21-2.5c-5.8-0.6-13-0.2-18.5-1.9       c-4.5-1.4-8.4-4.7-13-6c-10.7-3.1-22.2-2.3-33.1-0.8c-11.1,1.6-23.3,3.3-32.1,12.6c-5.2,5.4-12.1,3.9-18.7,2.7       c-9.7-1.7-16.9,1.6-26.1,3.1c-5.1,2.1-9.7,5.1-13.8,8.7c-7,6.2-15.2,8.9-24.1,10.7c-6.8,1.4-13.8,3.7-19.4,7.6       c-9.7,6.8-16.7,16.3-19.2,28.4c-1.2,5.1-1.9,9.1-5.8,12.8c-2.9,2.9-6.4,4.9-10.1,7c-3.7,2.1-6.2,5.4-9.9,7.2       c-9.7,4.7-14.2,13.8-17.5,22.7c-2.5,6.8-3.7,11.9-1.7,19.1c0.8,2.9,1.7,6,1.4,8.9c-0.8,7.6-9.3,7.6-13.8,12.4       c-4.7,5.2-9.1,11.1-12.4,17.5c-3.5,7-4.5,15-4.5,22.7c0,7.2-0.8,13.6,0.8,20.8c0.6,3.1,1.4,6,1.7,9.1c0.6,2.9,1,5.8,0.6,8.7       c-0.8,5.4-5.6,8.6-6.8,14c-1.6,6.4,0.2,13,2.7,19.1c1.2,3.1,3.1,5.8,4.5,8.7c0.2,0.6,0.2,1.2,0.2,1.7c-0.6,0-1.4,0.4-1.7,0.2       c-2.1-1.2-4.3-2.5-6.2-3.9c-6.2-4.3-12.6-8.4-18.5-13c-7-5.6-13.4-11.7-20.2-17.5c-5.1-4.3-9.5-9.3-12.6-15.2       c-3.1-5.8-6.2-11.1-5.2-17.9c1.4-10.5,10.3-17.9,11.7-28.2c0.6-4.1-0.8-9.5-1.7-13.4c-2.1-8.4-6-16.5-6.2-25.3       c-0.2-7.4,2.3-14.6,5.1-21.4c2.7-6.6,7.6-10.7,12.4-15.6c4.1-4.1,8.2-8.4,12.2-12.4c1.7-1.9,3.7-3.9,5.1-6.2       c1.4-2.3,0.8-4.7,0.8-7.4c0-6.4,0-12.8,0-19.4c0-8.4,2.9-15.2,8.2-22.2c6-8.2,14.8-13.8,23.5-18.5c7.2-3.9,13.8-9.3,16.9-17.1       c1.7-4.3,2.3-8.9,3.9-13.2c1.6-4.7,3.9-8.9,6.6-13.2c5.6-8.6,13.4-14,22.4-17.9c4.1-1.7,8.7-2.3,13-3.5       c8.4-2.3,16.9-2.3,23.7-9.9c6.6-7.2,15.2-12.2,24.7-14.4c5.4-1.2,11.7-0.6,17.3-0.6c6.4-0.2,12.8-0.4,19.1-0.8       c5.2-0.4,8.6-1.6,12.4-4.7c4.7-3.7,9.9-7.4,15.4-9.7c10.3-4.7,21.2-8,32.3-9.3c5.6-0.6,11.5-0.8,17.1-0.2       c5.4,0.6,10.7,2.5,16.1,3.1c7.2,0.8,13.2,3.7,19.4,6.6c6.4,2.9,10.7,8.6,17.1,11.5c9.7,4.3,21,3.3,31.5,3.3       c8.4-1,18.5,0.2,27.4,6c5.1,3.3,9.9,7.2,14.4,11.1c3.7,3.3,7.6,5.1,12.4,6.2c9.1,2.1,18.9,1.7,27,7.6       c9.7,6.8,19.4,13.4,22.4,26.2c0.6,2.9,2.9,5.6,3.3,8.7c0.2,1.6,0.2,3.5-0.2,5.2c0.6,2.1,1,4.1,1.6,6.2c1.6,3.7,3.9,6.8,6.6,7.2       c3.1,0.4,5.2,1.7,6.6,3.3c3.1,1.6,6.4,2.9,9.3,4.7c10.7,5.6,18.5,14.6,24.9,24.3c1.9,3.1,2.1,7.4,2.5,11.3c0.4,4.3,0,8.7,0,13       c0,3.9,0.4,7.8,0,11.5c-0.8,7.2,4.1,10.3,8.7,14.2c5.8,4.7,11.7,10.1,16.1,16.1c3.9,5.4,6.4,12.1,8.7,18.7       c1.2,3.1,0.2,7,0.6,10.3c1.8,12.1-4.3,23.5-8,34.6c-0.4,1-0.8,2.1-1,3.3c-0.4,2.7,0.4,5.2,1,8c0.4,1.6,1,3.1,1.8,4.5       c1.2,1.8,2.7,1.9,4.1,3.1c1.6,1.4,2.7,3.3,3.5,5.1c1.8,3.3,3.5,7.2,3.9,10.9c0,0.2,0,0.6,0,0.8       C686,356.3,679.8,364.4,676.3,369.7z"}),jsxRuntimeExports.jsx("path",{className:"st0",d:"M394.9,579.5c-2.5,0-5.2-0.2-8-0.6c-4.1-0.4-8-2.3-11.7-4.3l-1.4-0.6c-7.2-3.5-13.2-5.1-19.4-5.1       c-0.2,0-0.4,0-0.4,0c-21.2,0.2-43.9,0.4-67.3-0.2c-5.4-0.2-10.9-2.5-16.1-5.1c-2.7-1.2-4.3-5.2-4.9-7.4       c-4.5-14.4-5.8-30.5-7.2-46.3c-0.6-6.8-1.2-13.4-1.9-19.8c-0.6-4.5-1.2-8.9-3.1-13c-4.5-8.9-20.4-15.7-33.2-21.4       c-5.1-2.1-9.9-4.3-13.4-6.2c-20.8-11.7-38.7-22.9-54.2-34c-1.6-1.2-3.3-2.3-4.9-3.5c-23.3-16.3-58.3-41-48.8-73.1       c1-3.1,2.1-6,3.5-8.7c1.4-3.1,2.9-6.4,3.7-9.7c2.3-8.6,0-15.9-2.3-23.7c-1.7-5.6-3.5-11.3-3.3-17.5c0.2-13,7.2-28.2,13.2-37.1       c4.9-7.2,11.3-13,20.2-18.3c1-0.6,1.9-2.5,1.9-4.1c0.4-5.6,0.6-11.3,0-16.9c-1.7-15.7,4.5-29.7,18.9-43       c6.8-6.2,15.9-10.3,23.1-13c5.8-2.1,7.2-6.6,8.4-11.5c0.2-0.6,0.4-1.2,0.4-1.7c0.6-1.7,1-3.7,1.6-5.6c1.7-6.8,3.5-13.8,8.7-19.4       c1.2-1.4,2.3-2.7,3.3-4.3c1.7-2.3,3.3-4.7,5.6-6.4c10.7-8.9,20.6-15.2,33.8-15.6c8.2-0.4,14.6-3.1,19.1-8.2       c11.5-13.4,30.9-15.9,41.4-16.1c2.3,0,5.1,0,7.8,0c8.2,0.2,17.5,0.2,24.3-3.1c4.1-1.9,8-4.5,11.5-7c5.2-3.5,10.5-7,16.9-9.3       c13.6-5.1,28.2-7,43.6-5.6c16.3,1.4,32.1,6.2,45.7,14.4c2.1,1.2,4.1,2.7,6,4.3c3.5,2.7,6.6,5.2,10.5,6.2c5.4,1.6,13.2,1,19.8,0.4       c3.1-0.2,6-0.4,8.6-0.4c11.3,0,21.4,3.7,31.3,11.5c4.5,3.7,9.5,7.4,14.8,10.1c3.5,1.7,8,2.9,12.6,3.3c8.9,0.6,16.9,3.7,26.1,10.1       c5.2,3.7,11.1,8.4,15,15.2c2.9,5.4,6.2,12.1,8,18.9c3.7,13.8,9.7,17.1,18.7,22.4c2.7,1.6,6,3.3,9.3,5.6       c13.8,9.1,22.7,24.3,24.3,40.1c0.2,2.7,0.4,5.4,0.4,8c0,4.5,0.2,8.9,1.2,13.2c1.9,8.2,7.2,12.8,12.8,17.5       c3.3,2.7,6.6,5.6,9.3,9.3c8.4,11.1,16.1,29.9,10.9,46.5c-0.6,1.7-1.2,3.5-1.8,5.2c-2.1,5.8-4.3,11.7-4.1,17.9       c0.2,6,2.5,11.9,4.9,17.5l0,0c6.2,14.8,9.1,23.1,1.4,38.5c-9.3,18.7-29.7,32.9-47.6,45.3c-2.5,1.7-5.1,3.5-7.6,5.2       c-18.1,12.8-38.7,25.1-63,37.5l-3.3,1.7c-14.2,7.2-27.6,14-32.7,29.9c-3.1,9.5-3.7,19.8-4.3,29.7l-0.4,6.8       c-0.8,13.6-2.1,36.2-16.5,41.4c-5.2,1.9-11.1,2.1-16.7,2.3h-2.5c-6,0.2-12.1,0.2-17.9,0.2c-5.6,0-11.3,0-16.9,0       c-7.2,0-14.6,0.2-21.8-0.2c-6.4-0.2-12.8,1.2-18.9,4.5C412.3,577.4,403.9,579.5,394.9,579.5z M354.3,567.1       c6.4,0,12.6,1.6,20.2,5.2l1.4,0.8c3.7,1.7,7.4,3.5,11.1,4.1c11.9,1.4,22.4-0.4,32.1-5.2c6.4-3.3,13.2-4.9,19.8-4.7       c7.2,0.2,14.6,0.2,21.8,0.2c5.6,0,11.3,0,16.9,0c5.8,0,11.9,0.2,17.9-0.2h2.5c5.4-0.2,11.1-0.4,16.1-2.1       c13.2-4.9,14.6-26.6,15.4-39.7l0.4-6.8c0.6-10.1,1.2-20.4,4.3-30.1c5.4-16.9,19.1-23.7,33.6-31.1l3.3-1.7       c24.3-12.4,44.7-24.7,62.8-37.5c2.3-1.7,4.9-3.5,7.6-5.2c17.9-12.4,38.1-26.4,47.1-44.5c7.4-14.8,4.7-22.4-1.4-36.9l0,0       c-2.3-5.4-4.9-11.7-5.1-18.1c-0.2-6.4,1.9-12.6,4.1-18.5c0.6-1.7,1.2-3.5,1.8-5.2c5.1-15.9-2.5-34-10.5-44.7       c-2.7-3.5-5.8-6.2-9.1-8.9c-5.6-4.9-11.5-9.7-13.6-18.7c-1.2-4.5-1.2-9.1-1.2-13.6c0-2.5,0-5.2-0.4-7.8       c-1.4-15.4-10.1-29.7-23.5-38.7c-3.3-2.3-6.4-4.1-9.3-5.6c-9.1-5.1-15.7-8.7-19.6-23.5c-1.8-6.6-5.1-13-8-18.5       c-3.5-6.6-9.1-11.1-14.2-14.6c-8.9-6-16.7-9.1-25.1-9.7c-4.9-0.4-9.7-1.6-13.4-3.5c-5.4-2.7-10.5-6.6-15-10.3       c-9.3-7.6-19.2-11.3-29.9-11.1c-2.5,0-5.4,0.2-8.4,0.4c-6.8,0.6-14.8,1.2-20.6-0.6c-4.1-1.2-7.8-3.9-11.1-6.6       c-1.9-1.6-3.9-2.9-5.8-4.1c-13.2-8-28.8-12.8-44.7-14c-15-1.2-29.4,0.8-42.8,5.6c-6.2,2.3-11.5,5.8-16.5,9.1       c-3.7,2.5-7.6,5.1-11.7,7c-7.2,3.5-16.7,3.5-25.3,3.3c-2.7,0-5.2,0-7.6,0c-10.3,0.4-29,2.7-40.1,15.6c-4.9,5.6-11.7,8.6-20.4,8.9       c-12.6,0.6-22.2,6.4-32.7,15.2c-1.9,1.7-3.5,3.9-5.2,6c-1.2,1.6-2.1,3.1-3.5,4.5c-4.9,5.2-6.6,11.9-8.4,18.7       c-0.6,1.9-1,3.7-1.6,5.6c-0.2,0.6-0.4,1.2-0.4,1.6c-1.4,4.7-2.9,10.1-9.7,12.6c-7,2.7-15.9,6.6-22.6,12.6       c-14,13-19.8,26.1-18.3,41.2c0.6,5.6,0.2,11.5,0,17.1c-0.2,2.1-1.2,4.9-2.9,5.8c-8.7,5.1-15,10.7-19.6,17.7       c-5.8,8.7-12.6,23.3-12.8,36.2c-0.2,5.8,1.6,11.5,3.3,16.9c2.3,7.6,4.7,15.6,2.3,24.7c-1,3.5-2.3,6.8-3.9,9.9       c-1.2,2.7-2.5,5.6-3.3,8.6c-9.1,30.7,25.3,54.8,48,71c1.7,1.2,3.3,2.3,4.9,3.5c15.6,11.1,33.2,22.2,54.1,33.8       c3.5,1.9,8.2,4.1,13.2,6.2c13,5.6,29.4,12.8,34,22.4c2.1,4.3,2.7,9.3,3.3,13.6c0.8,6.4,1.4,13.2,1.9,19.8       c1.4,15.6,2.7,31.5,7,45.7c1,3.3,2.5,5.6,3.9,6.2c5.1,2.3,10.3,4.7,15.2,4.9c23.1,0.6,45.9,0.4,67.1,0.2       C354.1,567.1,354.3,567.1,354.3,567.1z M396.1,573.5c-3.1,0-6.4-0.8-9.9-3.1c-5.1-3.1-10.7-5.4-16.3-7.8       c-1.7-0.8-3.7-1.6-5.4-2.3c-1-0.4-2.1-0.4-3.5-0.4c-0.4,0-0.6,0-1.2,0h-16.3c-17.3,0-35.2,0-52.9,0h-0.2       c-14,0-17.1-8.9-18.3-17.9c-0.6-4.7-1-9.3-1.2-14c-0.2-3.9-0.6-8.2-1-12.1c-0.2-1.8-0.4-3.5-0.6-5.2c-0.8-7.4-1.6-15.2-3.5-22.2       l-0.4-1.2c-3.1-11.1-6.4-22.7-18.5-28c-1.9-0.8-3.9-1.6-6-2.3c-3.5-1.4-7.4-2.9-10.7-4.7c-2.1-1.2-4.3-2.3-6.4-3.3       c-11.1-5.6-22.6-11.5-29.7-21.6l-12.6-17.5c-3.1-4.3-6.6-9.1-8.2-14.6c-1.6-5.6-0.6-10.9,2.7-15.6c3.1-4.3,5.6-8.2,5.1-13.4       c-0.8-6.6-1.7-14-3.1-23.1c-1-6.6-1.4-11.9-0.8-16.7c0.6-6,2.7-14.4,9.3-20.8c2.3-2.1,4.7-4.1,7-6.2c2.5-2.1,5.1-4.3,7.4-6.4       c6.6-6.2,5.8-12.2,4.9-19.2c-0.4-3.9-1-7.8-0.4-12.1c1.2-7.6,5.1-14.8,12.6-22.9c4.9-5.2,9.3-9.7,16.5-12.2       c0.6-0.2,1.4-0.4,1.9-0.8c3.3-1.2,7-2.3,8.9-5.1c2.5-3.3,4.1-10.1,5.2-14.4l0.2-1c5.1-20.6,20.8-27,39.5-32.7       c9.1-2.7,16.5-6.6,25.9-13c0.6-0.4,1.2-0.8,1.9-1.4c4.3-3.1,10.3-7.6,15.4-4.9c1.9,0,3.9,0,5.8-0.2c5.6,0,11.5-0.2,16.9-1       c6.8-1.2,12.8-3.5,19.1-6.2c3.5-1.4,7-2.9,10.9-4.3c8-2.5,16.9-3.7,26.8-3.5c7.8,0.2,15.4,1.9,22.7,3.7       c5.4,1.4,11.1,2.5,16.7,3.3c22.4,2.5,47.2,11.1,76.2,25.7c6.6,3.3,13.4,7.2,18.5,12.8c4.1,4.5,6.2,11.1,8.4,17.3       c0.8,2.1,1.6,4.3,2.3,6.2c1.2,2.9,2.3,6,4.1,8.6c3.3,4.9,8.6,7.4,14.2,9.9c5.6,2.5,11.5,5.2,15.4,10.7       c5.1,7.2,10.3,14.6,8.9,24.5c-0.2,1.9-0.2,3.9,0,6c0,2.1,0.2,4.3-0.2,6.4c-1,7.4,1.9,12.8,8.7,15.9c8.6,4.1,12.4,12.1,15.9,19.1       c3.7,7.4,5.2,15.2,4.5,22.4c-0.4,3.7-1,8.4-2.9,12.6c-0.8,1.9-2.5,3.9-5.2,5.8c-0.2,1.7,0.2,11.5,0.4,12.8c0.2,1.7,1,2.3,2.3,3.3       c0.6,0.4,1.2,1,1.8,1.6c1.6,1.7,2.5,4.3,3.3,6.2c1.2,3.3,2.7,8.2,2.7,12.6c-0.2,8.7-4.7,16.1-8.2,21l0,0       c-6,7.8-15.4,18.5-26.1,24.5c-6.6,3.7-13.2,7.4-19.8,10.9c-6.4,3.5-12.8,7-19.1,10.5c-1.9,1-3.9,2.1-5.8,3.1       c-5.2,2.7-10.7,5.4-14.6,9.3c-0.4,0.4-1,1-1.6,1.4c-3.9,3.7-7.8,7.4-8.4,13.6c-0.8,7.6-2.3,15.2-3.9,22.6       c-0.6,3.1-1.4,6.4-1.9,9.5c0,0.4,0,0.6-0.2,1c-0.2,2.7-0.4,5.2-0.6,8c-0.4,6.2-0.8,12.8-1.8,19.1c-0.2,1-0.2,1.9-0.4,2.9       c-0.4,4.3-1,9.1-5.1,12.1c-2.3,1.6-6.8,4.3-11.1,4.5c-8.6,0.4-17.3,0.4-25.7,0.2c-3.3,0-6.6,0-9.9,0h-9.7c-7.4,0-15,0-22.4,0       h-0.2c-9.9,0-18.3,4.3-25.3,8.4C406.4,571.1,401.6,573.5,396.1,573.5z M362.1,558.1c1.2,0,2.1,0,3.1,0.6c1.7,0.8,3.7,1.6,5.4,2.3       c5.6,2.3,11.5,4.7,16.5,8c8.6,5.2,16.1,1.7,22.6-1.9c7.4-4.3,15.9-8.7,26.2-8.7c0.2,0,0.2,0,0.4,0c7.4,0,15,0,22.4,0h9.7       c3.3,0,6.6,0,9.9,0c8.4,0,17.1,0.2,25.7-0.2c3.9-0.2,8-2.7,10.1-4.1c3.5-2.5,3.9-6.6,4.3-10.7c0.2-1,0.2-2.1,0.4-3.1       c1-6.2,1.4-12.6,1.8-18.9c0.2-2.7,0.4-5.4,0.6-8c0-0.4,0-0.8,0.2-1.2c0.6-3.3,1.2-6.4,1.9-9.7c1.6-7.4,2.9-15,3.9-22.4       c0.8-6.8,5.2-10.9,9.1-14.8c0.6-0.4,1-1,1.4-1.4c4.3-4.1,9.7-7,15.2-9.7c1.9-1,3.9-1.9,5.8-2.9c6.4-3.5,12.8-7,19.1-10.5       c6.6-3.7,13.2-7.2,19.8-10.9c10.5-5.8,19.6-16.1,25.5-23.9l0,0c3.5-4.5,7.6-11.7,7.8-19.8c0.2-4.1-1.4-8.7-2.5-11.9       c-0.8-2.1-1.6-4.3-2.9-5.8c-0.6-0.6-1-1-1.6-1.4c-1.4-1-2.5-1.9-2.9-4.5c0-0.2-1.2-13.4,0.2-14.6c2.5-1.7,4.1-3.5,4.9-5.2       c1.8-3.9,2.3-8.6,2.7-12.1c0.8-6.8-0.8-14.2-4.3-21.4c-3.5-7-7.2-14.4-15.2-18.1c-7.4-3.5-10.9-9.7-9.7-18.1c0.2-1.9,0.2-3.9,0-6       c0-2.1-0.2-4.3,0-6.4c1.2-9.1-3.9-16.3-8.6-23.1c-3.5-5.1-9.1-7.6-14.6-10.1c-5.6-2.5-11.5-5.2-15-10.7c-1.9-2.7-3.1-5.8-4.3-8.9       c-0.8-1.9-1.6-4.1-2.3-6.4c-2.1-6-4.3-12.4-8-16.5c-4.9-5.4-11.5-9.1-17.9-12.4c-28.8-14.6-53.5-22.7-75.6-25.5       c-5.6-0.6-11.5-1.9-16.9-3.3c-7.4-1.7-15-3.5-22.6-3.7c-9.5-0.4-18.5,0.8-26.2,3.5c-3.7,1.2-7.2,2.7-10.7,4.1       c-6.2,2.5-12.4,5.2-19.6,6.4c-5.6,1-11.5,1-17.3,1c-2.1,0-4.1,0-6.2,0.2h-0.2l-0.2-0.2c-4.1-2.3-9.5,1.7-13.6,4.7       c-0.8,0.6-1.4,1-1.9,1.4c-9.5,6.6-17.1,10.5-26.4,13.2c-18.7,5.8-33.2,11.7-38.1,31.3l-0.2,1c-1.2,4.9-2.7,11.5-5.6,15.2       c-2.3,3.3-6.4,4.5-9.9,5.6c-0.6,0.2-1.4,0.4-1.9,0.6c-6.8,2.5-10.9,6.6-15.7,11.7c-7.2,7.8-11.1,14.8-12.1,21.8       c-0.6,4.1-0.2,8,0.4,11.7c1,7.2,1.7,14-5.4,21c-2.3,2.3-5.1,4.5-7.4,6.6c-2.3,1.9-4.7,3.9-7,6c-6.2,5.8-8.2,13.8-8.7,19.4       c-0.4,4.7-0.2,9.9,0.8,16.3c1.4,9.1,2.3,16.5,3.1,23.1c0.6,5.8-2.1,10.3-5.4,14.8c-2.9,4.1-3.7,8.9-2.3,14       c1.4,5.2,4.7,9.7,7.8,14l12.6,17.5c7,9.7,18.3,15.6,29.2,21c2.1,1.2,4.5,2.3,6.4,3.3c3.3,1.7,7,3.1,10.5,4.7       c1.9,0.8,4.1,1.6,6,2.5c13,5.6,16.3,17.5,19.6,29.2l0.4,1.2c2.1,7.4,2.9,15,3.7,22.6c0.2,1.8,0.4,3.5,0.6,5.2       c0.4,4.1,0.8,8.2,1,12.2c0.4,4.5,0.6,9.3,1.2,13.8c1.2,9.7,4.5,16.1,16.3,16.1h0.2c17.7-0.2,35.6,0,52.9,0h16.3c0.4,0,0.8,0,1,0       C361.3,558.1,361.7,558.1,362.1,558.1z M170.9,416.6c-0.4,0-0.6,0-1-0.2c-2.3-1.4-4.5-2.7-6.4-3.9c-1.6-1.2-3.3-2.1-4.9-3.3       c-4.5-3.1-9.1-6.2-13.6-9.7s-8.7-7.4-12.8-11.1c-2.5-2.1-4.9-4.3-7.4-6.4c-5.6-4.9-10.1-10.1-12.8-15.6l-0.6-1.2       c-2.9-5.4-5.6-10.5-4.9-17.3c0.6-5.4,3.3-10.1,6-14.8c2.5-4.5,5.1-8.6,5.6-13.6c0.6-3.9-0.6-8.7-1.6-12.6l-0.2-0.6       c-0.6-2.7-1.6-5.6-2.5-8.2c-1.7-5.6-3.7-11.3-3.7-17.3c-0.2-7.6,2.3-15,5.2-21.8c2.3-5.6,6.2-9.5,10.3-13.6       c0.8-0.8,1.6-1.6,2.3-2.3l12.2-12.4c1.7-1.9,3.7-3.7,4.9-6c0.8-1.6,0.8-3.1,0.8-4.9c0-0.6,0-1.4,0-1.9c0-4.9,0-9.7,0-14.6v-4.7       c0-8,2.5-15,8.2-22.7c6.8-9.1,16.9-15,23.9-18.7c8.2-4.3,13.8-9.9,16.5-16.5c1-2.3,1.6-4.7,2.1-7.2c0.6-1.9,1-4.1,1.7-6       c1.6-4.7,3.9-9.1,6.6-13.4c5.2-8,12.4-13.8,22.7-18.3c2.7-1.2,5.6-1.9,8.6-2.5c1.6-0.4,3.1-0.8,4.7-1.2c1.9-0.6,3.9-1,5.8-1.4       c6.4-1.4,12.4-2.5,17.5-8.2c6.8-7.4,15.6-12.4,25.3-14.6c3.9-0.8,8.2-0.8,12.2-0.8c1.7,0,3.5,0,5.2,0c6.4-0.2,12.8-0.4,19.1-0.8       c5.1-0.4,8.2-1.6,11.9-4.5c5.2-4.3,10.7-7.6,15.6-9.9c11.1-5.1,22-8.2,32.7-9.3c5.8-0.6,11.9-0.8,17.3-0.2c2.7,0.2,5.6,1,8.2,1.6       c2.5,0.6,5.2,1.4,8,1.6c6.8,0.8,12.8,3.5,18.7,6.2l1.2,0.6c3.1,1.6,5.8,3.7,8.6,5.6c2.7,2.1,5.4,4.3,8.6,5.6       c8.2,3.5,17.3,3.5,26.4,3.3c1.6,0,3.1,0,4.7,0c7.2-0.8,17.9-0.4,28,6.2c4.7,3.1,9.5,6.8,14.6,11.3c3.3,2.9,7,4.7,12.1,6       c2.5,0.6,5.2,1,8,1.4c6.6,1,13.6,2.1,19.6,6.2l1,0.6c9.3,6.6,19.1,13.4,21.8,26.2c0.2,1.4,1,2.5,1.6,3.9c0.8,1.6,1.6,3.1,1.8,4.9       c0.2,1.6,0.2,3.5-0.2,5.2c0.6,1.9,1,3.9,1.6,6c1.8,3.9,3.9,6.2,5.8,6.6c2.9,0.4,5.4,1.6,7,3.5c2.9,1.4,6.2,2.9,9.3,4.5       c9.3,4.9,17.5,12.6,25.3,24.7c1.9,2.9,2.3,7,2.5,10.5l0.2,1.2c0.4,3.1,0.2,6.2,0.2,9.1c0,1.4,0,2.7,0,3.9s0,2.3,0,3.5       c0,2.7,0.2,5.4-0.2,8c-0.8,6,2.9,8.9,7.2,12.2l1.2,1c7.2,5.8,12.4,11.1,16.3,16.3c4.1,5.6,6.6,12.6,8.9,18.9       c0.8,1.9,0.6,4.3,0.6,6.4c0,1.4-0.2,2.9,0,4.3c1.4,9.7-2.1,19.2-5.4,28.2c-0.8,2.3-1.8,4.5-2.5,6.8c-0.4,1.2-0.8,2.1-0.8,3.1       c-0.4,2.5,0.4,5.1,1,7.6c0.4,1.6,0.8,3.1,1.6,4.3c0.6,0.8,1.2,1.2,2.1,1.7c0.6,0.4,1.2,0.6,1.8,1.2c1.6,1.4,2.7,3.5,3.7,5.2       c2.3,4.3,3.7,8.2,4.1,11.5c0,0.4,0,0.6,0,0.8c0,5.8-4.9,13-8.4,18.3c-0.6,0.8-1,1.4-1.4,2.1l0,0c-3.9,5.8-8.7,11.5-15,17.3       c-2.7,2.7-6,4.9-9.1,6.8c-1.8,1.2-3.5,2.3-5.1,3.5c-1,0.6-1.8,1.4-2.5,2.3c-0.8,0.8-1.8,1.6-2.7,2.3c-0.8,0.6-1.8,0.8-2.5,0.8       c-0.4,0-0.6,0-1,0.2l-1.2,0.2v-1.2c0-0.4,0-0.6,0-1c0-0.8-0.2-1.6,0.2-2.5c2.9-8.4,3.3-15.7,1.4-22.6c-0.6-2.1-2.1-4.1-3.7-6.2       c-1.9-2.7-4.1-5.4-4.3-8.7c-0.2-2.5,0.4-5.4,1-8.2c0.2-1.4,0.6-2.7,0.8-3.9c0.8-4.9,2.5-9.9,4.1-13.8v-0.6       c-0.2-1.2-0.4-2.3-0.2-3.5c1-10.1-1-19.8-6-29c-3.7-6.6-9.1-15-17.9-19.8c-3.9-2.1-5.6-5.2-5.2-9.1c0.2-1.4,0-2.7,0-4.1       c0-1.7-0.2-3.7,0.2-5.4c1.9-11.7-2.9-21.6-7.6-29c-3.3-5.2-8.6-9.5-13.2-13c-2.7-1.9-6.2-3.3-9.3-4.7c-1.4-0.6-2.5-1-3.9-1.6       c-2.7-1.2-4.5-4.5-5.8-7.2c-0.6-1.2-1.2-2.3-1.9-3.3c-2.5-3.7-4.1-8.2-4.3-12.8l0,0c-0.4-0.6-1-1.2-1.4-1.9       c-1-1.6-1.8-3.1-2.5-4.9c-1.8-3.3-3.5-6.8-5.8-9.3c-5.6-6.2-13-10.9-21-13.4c-2.9-1-6-1.7-8.9-2.3c-4.3-1.2-8.7-2.3-13-3.9       c-2.9-1.2-5.6-3.3-8.2-5.2c-0.8-0.8-1.8-1.4-2.5-2.1c-4.3-3.1-9.9-7-16.3-8.7c-4.7-1.4-9.9-1.6-14.8-1.9c-1.9-0.2-4.1-0.2-6-0.4       c-1.7-0.2-3.9-0.2-5.8-0.4c-4.5-0.2-8.9-0.4-12.8-1.6c-2.3-0.8-4.5-1.9-6.4-2.9c-2.1-1.2-4.3-2.3-6.6-3.1       c-11.1-3.3-22.7-2.1-32.7-0.8c-10.7,1.6-22.9,3.3-31.5,12.2c-5.4,5.6-12.1,4.5-18.7,3.1l-1-0.2c-6.8-1.2-12.4,0-18.3,1.6       c-2.3,0.6-4.7,1.2-7.4,1.6c-4.7,1.9-9.3,4.9-13.6,8.6c-7.8,6.8-16.7,9.3-24.5,10.9c-5.2,1-12.8,3.1-19.1,7.4       c-10.1,7.2-16.3,16.5-18.9,27.8c-1.2,5.1-2.1,9.5-6.2,13.4c-3.1,2.9-6.6,5.1-10.3,7c-1.6,1-2.9,2.1-4.3,3.3       c-1.7,1.4-3.5,2.9-5.6,3.9c-9.7,4.5-13.8,13.8-17.1,22.2c-2.5,6.8-3.5,11.7-1.6,18.3c0.8,3.1,1.7,6.2,1.4,9.3       c-0.6,5.2-4.5,7.2-8.2,9.1c-2.1,1-4.3,2.1-5.8,3.9c-5.4,6-9.5,11.7-12.2,17.1c-3.7,7.4-4.3,15.7-4.3,22.4c0,1.7,0,3.5-0.2,5.1       c-0.2,5.2-0.4,10.3,0.8,15.6v0.2c0.6,2.9,1.2,6,1.7,8.9c0.6,2.9,1,6,0.6,9.1c-0.4,3.1-1.9,5.4-3.5,7.6c-1.4,2.1-2.7,4.1-3.3,6.4       c-1.2,5.2-0.4,11.1,2.5,18.5c0.8,1.9,1.7,3.7,2.7,5.4c0.6,1.2,1.2,2.1,1.7,3.3c0.2,0.6,0.2,1.2,0.2,1.6c0,0.2,0,0.4,0,0.6v1h-1       c-0.2,0-0.4,0-0.6,0C171.7,416.4,171.3,416.6,170.9,416.6z M298.1,69.1c-2.7,0-5.6,0.2-8.2,0.8c-9.3,2.1-17.7,7-24.3,14       c-5.4,6-12.1,7.4-18.5,8.7c-1.9,0.4-3.9,0.8-5.8,1.4c-1.6,0.4-3.1,0.8-4.7,1.2c-2.9,0.6-5.6,1.2-8.2,2.3       c-9.9,4.3-16.9,9.9-21.8,17.5c-2.7,4.1-4.9,8.6-6.4,13c-0.8,1.9-1.2,3.9-1.7,6c-0.6,2.5-1.2,5.1-2.1,7.4       c-2.9,7.2-8.7,13-17.5,17.5c-6.8,3.5-16.7,9.3-23.1,18.1c-5.4,7.4-8,14-8,21.6v4.7c0,4.9,0,9.7,0,14.6c0,0.6,0,1.2,0,1.9       c0,1.9,0.2,3.9-1,6c-1.4,2.5-3.3,4.5-5.1,6.4l-12.2,12.6c-0.8,0.8-1.6,1.6-2.5,2.5c-3.9,3.9-7.6,7.6-9.7,12.8       c-2.7,6.6-5.2,13.8-5.1,21c0.2,5.6,1.9,11.3,3.7,16.7c0.8,2.7,1.7,5.4,2.5,8.4l0.2,0.6c1,4.1,2.3,9.1,1.7,13.2       c-0.8,5.2-3.5,9.9-6,14.2c-2.7,4.5-5.2,8.9-5.8,14c-0.8,6.2,1.7,10.9,4.7,16.1l0.6,1.2c2.7,5.2,7,10.1,12.4,15       c2.5,2.1,5.1,4.3,7.4,6.6c4.1,3.7,8.4,7.4,12.8,10.9c4.3,3.5,8.9,6.6,13.4,9.7c1.6,1.2,3.3,2.1,4.9,3.3c1.7,1.2,3.9,2.5,6.2,3.9       c0,0,0.2,0,0.4,0c0-0.2,0-0.4,0-0.6c-0.6-1.2-1.2-2.1-1.7-3.1c-1-1.7-1.9-3.7-2.9-5.6c-1.9-4.9-4.3-12.2-2.7-19.6       c0.6-2.7,2.1-5.1,3.5-7.2c1.6-2.1,2.9-4.3,3.3-6.8c0.4-2.7,0-5.6-0.6-8.6c-0.6-2.9-1.2-5.8-1.7-8.9v-0.2       c-1.2-5.4-1-10.5-0.8-15.9c0-1.6,0.2-3.3,0.2-5.1c0-6.6,0.6-15.4,4.5-23.1c2.9-5.6,7-11.5,12.4-17.7c1.7-1.9,4.1-3.1,6.4-4.3       c3.5-1.7,6.6-3.5,7.2-7.6c0.4-2.9-0.6-5.8-1.4-8.7c-2.1-7.2-1-12.6,1.7-19.6c3.3-8.7,7.8-18.5,18.1-23.3c1.9-1,3.5-2.3,5.2-3.7       c1.4-1.2,2.9-2.5,4.7-3.5c3.5-1.9,7-4.1,9.9-6.8c3.7-3.5,4.5-7.4,5.6-12.2c2.5-11.7,9.3-21.8,19.6-29.2       c6.4-4.5,14.2-6.8,19.8-7.8c7.6-1.4,16.1-3.9,23.7-10.3c4.5-3.9,9.1-6.8,14.2-8.9h0.2c2.5-0.4,4.9-1,7.4-1.6       c6.2-1.6,12.1-2.9,19.1-1.6l1,0.2c6.2,1.2,12.2,2.3,16.9-2.5c9.1-9.5,21.6-11.3,32.7-12.8c10.1-1.4,22.2-2.5,33.4,0.8       c2.5,0.8,4.9,1.9,7,3.1c2.1,1.2,4.1,2.1,6,2.9c3.7,1.2,8,1.4,12.2,1.6c2.1,0,4.1,0.2,6,0.4c1.9,0.2,3.9,0.4,5.8,0.4       c5.1,0.4,10.3,0.8,15.2,2.1c6.8,1.9,12.6,5.8,17.1,9.1c1,0.6,1.8,1.4,2.7,2.1c2.3,1.9,4.9,3.9,7.6,4.9c4.3,1.6,8.6,2.7,12.8,3.7       c2.9,0.8,6,1.6,8.9,2.5c8.4,2.5,15.9,7.4,21.8,14c2.5,2.9,4.5,6.4,6.2,9.7c0.8,1.6,1.6,3.1,2.5,4.7c0.4,0.6,0.8,1.2,1.2,1.7       l0.4,0.6v0.4c0.2,4.5,1.6,8.6,4.1,12.1c0.8,1,1.4,2.3,1.9,3.5c1.4,2.7,2.9,5.4,5.1,6.4c1.2,0.6,2.5,1,3.9,1.6       c3.5,1.4,7,2.7,9.9,4.9c4.9,3.7,10.3,8,13.6,13.4c4.9,7.6,9.9,18.1,7.8,30.3c-0.2,1.6-0.2,3.3-0.2,5.1c0,1.4,0.2,2.9,0,4.5       c-0.4,3.1,1.2,5.4,4.3,7.2c9.3,5.1,15,13.6,18.7,20.6c5.2,9.3,7.4,19.4,6.2,30.1c0,1,0,1.9,0.2,3.1l0.2,1v0.2       c-1.6,3.9-3.5,8.7-4.1,13.6c-0.2,1.2-0.4,2.5-0.8,4.1c-0.6,2.5-1.2,5.2-1,7.6c0.2,2.7,1.9,5.1,3.9,7.6c1.6,2.1,3.1,4.3,3.9,6.8       c2.1,7.2,1.8,15-1.4,23.7c-0.2,0.4-0.2,1,0,1.6c0.6,0,1.4-0.2,1.6-0.4c0.8-0.6,1.6-1.4,2.5-2.1c0.8-0.8,1.8-1.7,2.7-2.5       c1.8-1.2,3.5-2.5,5.2-3.5c3.1-1.9,6.2-4.1,8.9-6.6c6-5.8,10.9-11.3,14.6-16.9l0,0c0.4-0.6,1-1.4,1.4-2.1       c3.5-5.1,8.2-11.7,8.2-17.1c0-0.2,0-0.4,0-0.6c-0.4-3.1-1.6-6.6-3.7-10.7c-1-1.7-1.9-3.7-3.3-4.9c-0.4-0.4-1-0.6-1.6-1       c-1-0.6-1.9-1.2-2.7-2.3c-1-1.6-1.4-3.3-1.9-4.9c-0.8-2.5-1.6-5.4-1-8.4c0.2-1.2,0.6-2.3,1-3.3c0.8-2.3,1.6-4.7,2.5-6.8       c3.3-8.7,6.6-17.9,5.4-27.2c-0.2-1.6-0.2-3.1-0.2-4.5c0-2.1,0.2-4.1-0.4-5.6c-2.1-6-4.7-12.8-8.6-18.3       c-3.7-5.2-8.7-10.3-15.9-15.9l-1.2-1c-4.5-3.5-8.7-6.8-8-14c0.2-2.5,0.2-5.2,0.2-7.8c0-1.2,0-2.3,0-3.7c0-1.4,0-2.7,0-3.9       c0-2.9,0.2-6-0.2-8.9l-0.2-1.2c-0.4-3.5-0.6-7.2-2.3-9.7c-7.6-11.7-15.4-19.2-24.5-24.1c-3.1-1.6-6.4-3.1-9.3-4.5l-0.4-0.2       c-1.4-1.6-3.5-2.7-6-3.1c-2.7-0.4-5.2-3.1-7.4-7.8c-0.6-2.1-1.2-4.3-1.6-6.4v-0.2v-0.2c0.4-1.6,0.4-3.3,0.2-4.9       c-0.2-1.4-1-2.9-1.6-4.3c-0.6-1.4-1.4-2.7-1.8-4.3c-2.7-12.1-11.5-18.3-21-25.1l-1-0.6c-5.6-4.1-12.2-5.1-18.7-6       c-2.7-0.4-5.4-0.8-8-1.4c-5.4-1.4-9.3-3.1-13-6.4c-4.9-4.3-9.7-8-14.2-11.1c-9.5-6.2-19.8-6.6-26.8-5.8c-1.6,0-3.1,0-4.7,0       c-9.1,0.2-18.7,0.2-27.2-3.5c-3.5-1.6-6.2-3.7-9.1-6c-2.7-2.1-5.1-4.1-8.2-5.4l-1.2-0.6c-5.6-2.7-11.5-5.4-18.1-6       c-2.7-0.2-5.6-1-8.2-1.6c-2.5-0.6-5.2-1.4-8-1.6c-5.4-0.6-11.3-0.6-16.9,0.2c-10.3,1.2-21.2,4.3-32.1,9.1       c-4.7,2.1-9.9,5.4-15.2,9.7c-4.1,3.3-7.6,4.7-13,5.1c-6.4,0.4-12.8,0.8-19.1,0.8c-1.8,0-3.5,0-5.2,0       C300.6,69.1,299.5,69.1,298.1,69.1z"})]}),jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{className:"st0",d:"M400,554.8c-6.2,0-13.2-3.7-17.3-8c-2.9-3.1-5.2-7.6-4.3-11.7c0.4-1.9,7.4,1,8.4,1.6c2.5,1.7,3.5,4.7,6,6.2       c5.2,3.1,11.7,0.6,16.1-2.9c2.1-1.8,4.9-3.3,7.6-3.7c3.5-0.6,5.1,1.9,3.7,5.2c-2.3,5.6-10.3,10.3-15.6,12.4       C403.3,554.4,401.8,554.8,400,554.8z"}),jsxRuntimeExports.jsx("path",{className:"st0",d:"M399.8,555.8c-6.8,0-14-4.3-17.9-8.2c-3.7-3.9-5.4-8.6-4.5-12.6c0.2-0.6,0.6-1,1.2-1.2       c2.3-0.8,8,1.7,8.7,2.1c1.4,1,2.1,2.1,3.1,3.1c1,1.2,1.7,2.3,2.9,2.9c4.9,2.9,10.9,0.4,15-2.9c1.6-1.2,4.7-3.3,8.2-3.9       c1.9-0.4,3.5,0.2,4.5,1.4c1,1.4,1.2,3.1,0.2,5.2c-2.3,5.8-10.3,10.5-16.1,13C403.5,555.4,401.9,555.8,399.8,555.8L399.8,555.8       C400,555.8,400,555.8,399.8,555.8z M379.4,535.6c-0.8,3.3,0.8,7.4,4.1,10.7c3.5,3.7,10.3,7.6,16.5,7.6l0,0c1.6,0,2.9-0.2,4.3-0.8       c4.5-1.7,12.8-6.4,15.2-11.9c0.6-1.4,0.6-2.5,0-3.3c-0.4-0.6-1.4-0.8-2.7-0.6c-2.3,0.4-4.9,1.7-7.2,3.5       c-4.7,3.7-11.5,6.4-17.1,3.1c-1.6-1-2.5-2.1-3.5-3.5c-0.8-1-1.6-1.9-2.7-2.7C385.4,536.9,380.6,535.2,379.4,535.6z"})]})]}),jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsx("path",{className:"st0",d:"M378,402.4c-0.8-2.1-1.4-4.5-1.6-6.6c-0.6-8-1.4-15.7-1.9-23.7c-3.1-36-7-71.9-11.5-107.7        c-2.3-17.9-4.7-35.8-7.2-53.7c-3.1-21.4-6-42.8-9.1-64.4c-2.9-20.6-8.4-41-8.4-62c-0.8-6.2-2.1-12.2-2.9-18.3        c-0.2-1,0.4-2.1,1.2-3.1c-0.8-3.1-1.4-6-1.7-9.3c-0.6,0.4-1.4,0.8-1.9,1c-3.3,1.6-7,2.3-10.7,2.9c0.2,4.1,0.4,8.2,0.2,12.2        c0.6,1.2,1,2.5,1,4.3c0.6,8.4,1.2,16.7,2.1,25.1c1.9,17.7,6,35,4.1,52.9c0-0.4,3.5,0,3.7,1.6c8.9,78.9,19.6,158.3,29.9,237.2        c0.4,2.9-0.2,6,0.2,8.9c0.4,3.1,0.4,7.2,2.3,8.7c2.1,1.7,6.4,1.7,9.3,1C378,408.6,379.2,405.7,378,402.4z"})}),jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsx("path",{className:"st0",d:"M298.5,436.6c-4.7-3.9-9.7-7.2-14.6-10.7c-38.7-27.8-78.4-54.2-117.4-81.5c-9.1-6.2-19.1-10.9-28.2-17.1        c-4.9-3.3-9.7-6.6-14.4-10.3c-4.7-3.5-9.3-4.1-15-5.2c-0.4,0-0.6-0.2-1-0.2c0,2.5-0.2,5.1-1,7.8c-0.2,0.8-0.4,1.6-0.6,2.1        c3.3,2.9,6.4,5.8,9.7,8.7c1,0,1.9,0.6,3.1,1.4c7.8,5.2,15.9,9.7,23.5,15.2c7.8,5.6,15.7,11.1,23.9,16.3        c17.9,11.7,37.1,21.6,54.8,34c18.5,13,37.1,25.7,55,39.5c4.3,3.3,8.4,6.6,12.6,10.1c3.9,3.1,6.2,1.4,8.9-1.4        C300.6,442.4,301.8,439.5,298.5,436.6z"})}),jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsx("path",{className:"st0",d:"M338.2,402.4c-29.9-57.4-56.6-119-92-173.1c-1.9-2.9-1.9-4.9-1.4-6.6c-2.1-3.3-4.1-6.8-5.8-10.3        c-0.2,0.2-0.4,0.4-0.6,0.6c-0.6-1-1.2-1.9-1.7-2.9c-5.8-9.9-11.7-19.6-17.3-29.7c-7-12.4-14-25.1-20.8-37.9        c-0.4-0.8-0.8-1.7-1-2.7c-1-0.8-1.9-1.7-2.9-2.7c-2.1-2.1-4.1-4.7-5.8-7c-0.2,1-0.6,1.7-0.8,2.7c-1,3.5-1.9,7.4-4.5,10.3        c1.2,3.1,2.3,6.4,3.5,9.7c1.7,0.2,3.1,1.6,3.9,3.3c5.1,9.3,9.5,18.9,14.4,28.4c3.5,6.8,6.2,14,10.7,19.8        c3.7,4.9,6.2,9.9,8.6,15.4c0.4,1,0.2,2.9-0.6,3.5c-0.2,0.2-0.4,0.4-0.8,0.6c1.4,1.7,2.5,3.7,3.7,5.4c0.4,0.8,0.8,1.4,1.2,2.1        c6-0.4,8.7,11.1,11.1,15.2c5.8,10.3,12.2,20.6,17.9,30.9c3.7,6.6,6.2,13.8,9.7,20.4c4.7,8.9,9.7,17.5,14.4,26.2        c15.4,29.4,29.9,59.1,44.9,88.7c1.9,3.7,4.5,8,8.6,7.8c3.7,0,6.4-4.1,6.6-7.8C341.7,409.2,339.9,405.7,338.2,402.4z"})}),jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsx("path",{className:"st0",d:"M466.3,57.4c-4.3-1.2-8-4.3-11.7-7c-0.8,23.9-5.6,47.4-9.5,71c-2.5,15.6-2.9,32.1-5.8,47.6        c-2.3,11.7-4.7,22.9-6.2,34.8c-2.7,22.6-4.1,45.1-7,67.5c-5.2,40.4-10.3,80.9-14.2,121.3c-0.6,5.1-0.6,10.1,0,15        c0.6,4.3,4.5,2.1,7,2.5c3.5,0.4,6-1.4,6.6-4.7c8.6-64.4,14.4-129.7,23.5-193.7c3.5-24.3,6.6-48.8,9.5-73.3        c1.6-12.4,2.9-24.9,4.5-37.3c1.4-11.1,1.2-22.6,5.1-32.9c0.2-0.6,1.2-1.2,2.1-1.4c0.2-1.2,0.4-2.5,0.6-3.7        c0.2-1.6,0.2-3.3,0.4-4.9C469.4,58,467.9,57.8,466.3,57.4z"})}),jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsx("path",{className:"st0",d:"M602.4,125.3c-0.6-0.6-1-1.2-1.6-1.6c1,0.8-12.8,25.9-14.2,28.4c-6.8,13.4-15.6,26.1-22.9,39.3        c0,3.9-6.6,11.9-8.6,15.4c-3.1,5.6-6.2,11.1-9.1,16.7c-5.6,10.1-10.1,20.6-15.6,30.9c-11.9,22.4-23.7,44.9-35.6,67.3        c-15.2,29-28.8,60.1-46.3,87.7c-2.7,4.3,0.2,7.6,1.9,10.3c1,1.6,5.1,1.2,7.8,1c0.8,0,1.7-1.7,2.3-2.7        c8.4-16.5,16.7-32.9,24.9-49.4c5.8-11.7,11.5-23.3,17.3-34.8c6.8-13.4,14-26.6,21-40.1c5.1-9.5,9.9-19.1,15.4-28.6        c10.7-18.9,21.4-37.7,31.9-56.6c5.2-9.3,10.5-18.7,15.7-27.8c5.2-9.3,9.7-20.8,16.3-29.2C609.4,144.1,608.8,132.5,602.4,125.3z"})}),jsxRuntimeExports.jsx("g",{children:jsxRuntimeExports.jsx("path",{className:"st0",d:"M682.1,312.7c-1.6-2.3-4.3-6-7.4-6.4c0.6,0-2.5,7.2-2.9,7.8c-1.9,2.5-4.9,4.1-7.6,5.8        c-8.6,5.1-16.9,10.3-25.5,15.4c-0.2-1.4-0.4-2.9-0.8-4.3c-3.1,2.9-10.1,7-11.7,10.9c-1.2,2.5-3.9,4.9-6.2,6.4        c-12.4,8.4-25.1,16.5-37.5,24.9c-11.1,7.6-22,15.4-33.1,22.9c-12.2,8.4-24.9,16.1-37.1,24.5c-7,4.9-13.6,10.5-20.2,15.7        c-3.7,2.9-2.7,5.8,0.4,8.7c2.9,2.7,5.6,4.5,9.3,0.8c1.9-1.9,4.9-3.1,7.4-4.7c8.2-5.6,16.5-11.1,24.5-16.7        c5.6-3.9,10.9-8.4,16.7-12.2c8.6-6,17.3-11.7,25.9-17.7c7.2-5.1,14.4-10.1,21.8-15c7.6-5.1,15.2-9.7,22.7-14.6        c1.2-0.8,2.1,0,3.1-0.4c1.4-0.4,2.3-1.6,3.5-2.3c2.5-2.1,5.2-4.1,8-6.2c5.4-4.1,10.9-8,16.5-11.7c11.1-7.4,22.4-14.2,34-20.4        C685.6,320.1,684.3,316,682.1,312.7z"})})]})})]})});const EggsIcon=()=>jsxRuntimeExports.jsxs("svg",{xmlns:"http://www.w3.org/2000/svg",fill:"none",viewBox:"0 0 249 102",height:"102",width:"249",children:[jsxRuntimeExports.jsxs("g",{"clip-path":"url(#clip0_333_161)",children:[jsxRuntimeExports.jsx("path",{fill:"#EEB3AB",d:"M0.223002 55.7565C0.508239 51.087 1.42596 46.5294 2.7116 42.0463C5.33247 32.9269 9.40021 24.4828 14.7949 16.6851C18.4203 11.4438 22.6245 6.74533 28.1391 3.41826C31.3346 1.49162 34.7491 -0.0165473 38.5813 0.169902C42.0785 0.343921 45.2203 1.76922 48.1842 3.5467C53.6451 6.81991 57.5558 11.6013 60.9249 16.884C64.0005 21.7068 66.6296 26.799 68.9032 32.0237C71.2802 37.4887 72.942 43.2438 74.1243 49.1107C75.0173 53.5482 75.4348 58.0271 75.2363 62.5433C74.8767 70.7968 73.1901 78.6649 68.184 85.4889C62.9339 92.6444 56.2164 97.7117 47.5559 100.086C44.472 100.931 41.4378 101.847 38.1968 101.88C31.2105 101.942 24.6997 100.268 18.718 96.6427C12.1823 92.6817 6.94469 87.4819 3.57971 80.5294C1.79388 76.8418 1.04978 72.8767 0.454499 68.866C0.322215 67.9752 0.437963 67.0305 0.00390625 66.1894V65.7253C0.194065 65.2613 0.194065 64.7972 0.00390625 64.3332V58.5408C0.247805 58.1348 0.0659144 57.6873 0.123789 57.2647C0.173395 56.7592 0.012174 56.2413 0.227136 55.7483L0.223002 55.7565Z"}),jsxRuntimeExports.jsx("path",{fill:"#F6D9D6",d:"M0.223229 55.7565C0.223229 56.2992 0.223229 56.842 0.223229 57.3806C0.14882 57.4884 0.0744098 57.4967 0 57.3848V55.7606C0.0744098 55.7606 0.14882 55.7606 0.223229 55.7523V55.7565Z"}),jsxRuntimeExports.jsx("path",{fill:"#F5D5D0",d:"M0 64.3414C0.343112 64.8055 0.363781 65.2695 0 65.7336V64.3414Z"}),jsxRuntimeExports.jsx("path",{fill:"#F2C7C1",d:"M0 57.389C0.0744098 57.389 0.14882 57.389 0.223229 57.3849C0.177757 57.7785 0.384451 58.2218 0 58.5492V57.389Z"}),jsxRuntimeExports.jsx("path",{fill:"#90A993",d:"M123.409 102C112.673 101.254 103.43 97.3305 96.2866 89.0191C90.9622 82.829 87.8535 75.6155 86.7125 67.5609C86.08 63.0944 86.419 58.632 87.1466 54.2028C88.7588 44.379 91.8675 35.0607 96.6338 26.3142C100.437 19.341 104.765 12.7324 110.644 7.30056C114.352 3.87818 118.564 1.31348 123.599 0.294221C127.394 -0.472291 130.937 0.352227 134.38 1.88111C140.221 4.47896 144.533 8.83773 147.989 14.0624C154.343 23.6666 158.328 34.2652 160.746 45.4853C161.904 50.8509 162.701 56.2911 162.495 61.7685C162.052 73.4402 158.439 83.8689 149.655 92.0147C144.033 97.2228 137.311 100.202 129.783 101.42C127.688 101.76 125.583 101.992 123.413 102.004L123.409 102Z"}),jsxRuntimeExports.jsx("path",{fill:"#8EA8CD",d:"M249 60.7285C248.83 66.1852 248.425 71.9651 246.209 77.397C241.542 88.845 233.332 96.4769 221.427 100.053C218.355 100.977 215.296 101.814 212.059 101.872C203.064 102.029 195.102 99.1784 188.066 93.6429C182.461 89.2303 178.124 83.8564 175.9 76.9827C174.784 73.5271 174.226 69.9515 173.933 66.3302C172.672 50.8674 176.876 36.7387 184.325 23.3889C187.5 17.7002 191.196 12.3926 195.974 7.92611C199.976 4.18885 204.445 1.25953 209.98 0.285849C213.068 -0.256924 215.863 0.696037 218.599 1.87688C225.147 4.69433 229.918 9.57515 233.684 15.4545C240.112 25.4896 245.101 36.1752 247.693 47.8801C248.603 51.9944 248.921 56.1791 249 60.7285Z"}),jsxRuntimeExports.jsx("path",{fill:"#FEFEFE",d:"M64.1658 29.1108C65.3522 31.2364 66.1046 33.5442 66.9479 35.8064C69.1017 41.5863 70.8337 47.4823 71.7225 53.6019C72.1153 56.3158 72.1235 59.0545 72.0284 61.7933C66.1294 62.6136 60.6479 61.8347 56.0303 57.6707C55.774 57.4386 55.5384 57.1776 55.2614 56.9705C54.3602 56.3034 53.5913 56.3158 52.7604 57.074C51.8758 57.882 51.0201 58.7231 50.2181 59.6056C44.8317 65.5388 36.2001 65.4518 30.4334 61.1925C29.003 60.1359 27.6554 58.9882 26.4111 57.7162C24.7989 56.0714 23.6869 56.0051 21.868 57.4345C20.9916 58.1264 20.1193 58.8308 19.3504 59.6512C16.5725 62.6261 13.0421 63.9934 9.07362 64.3787C7.38699 64.5444 5.77891 64.1301 4.19564 63.5997C3.81946 63.4754 3.50528 63.2559 3.27792 62.9285C2.91414 57.2563 3.76158 51.7167 5.10096 46.2351C6.40313 40.911 8.1683 35.7401 10.3386 30.706C10.413 30.5361 10.5453 30.387 10.6528 30.2295C10.9297 30.358 11.153 30.5941 11.4795 30.6314C15.7374 31.1079 18.4906 33.7472 20.6485 37.1489C21.9672 39.2329 22.1449 39.3034 23.9142 37.5632C27.1015 34.435 30.8798 32.2722 35.2204 31.3358C38.2381 30.6853 41.2931 31.0582 44.195 32.2432C46.0015 32.9807 47.3781 34.261 48.5149 35.8106C49.2673 36.8381 49.9122 37.9402 50.5777 39.0299C51.6195 40.7287 52.4545 40.7411 53.5252 39.0299C54.4057 37.6212 55.3028 36.2332 56.3445 34.9322C57.7211 33.2127 59.4077 31.8827 61.301 30.8179C62.2766 30.271 63.2646 29.753 64.1782 29.1067L64.1658 29.1108Z"}),jsxRuntimeExports.jsx("path",{fill:"#FEFEFE",d:"M71.7933 64.3539C71.6982 67.0636 71.0823 69.6863 70.3919 72.28C69.1683 76.8915 67.4734 81.3125 64.4557 85.0829C61.7769 88.4307 58.4698 91.0782 54.7783 93.2203C51.0288 95.3997 47.0479 96.9949 42.7445 97.749C37.9492 98.5901 33.249 98.1674 28.6026 96.854C22.6456 95.1718 17.5114 92.0561 13.2411 87.6103C8.06545 82.2157 4.82449 75.806 3.68354 68.3729C3.58432 67.7265 3.39003 67.0926 3.47684 66.4297C3.84476 66.2267 4.23748 66.322 4.60953 66.38C10.7855 67.3371 16.2009 65.6093 21.0045 61.7312C21.6948 61.176 22.3852 60.6208 23.0218 59.9993C23.861 59.183 24.1834 59.183 25.0929 59.9496C27.1929 61.7229 29.4583 63.2145 31.8518 64.5818C36.9406 67.4945 41.9674 66.9559 47.0644 64.7765C49.1686 63.8774 50.8097 62.3692 52.3765 60.7492C53.6001 59.4855 53.72 59.4358 55.2371 60.3556C58.97 62.622 63.0171 63.8733 67.337 64.3083C68.4945 64.4243 69.6437 64.2006 70.797 64.2254C71.1319 64.2337 71.4874 64.0597 71.7892 64.3456L71.7933 64.3539Z"}),jsxRuntimeExports.jsx("path",{fill:"#FEFEFE",d:"M11.8023 27.7063C13.4889 24.0105 15.6138 20.5715 18.061 17.3398C20.9382 13.5445 24.1915 10.1014 28.1973 7.46624C31.1075 5.55203 34.2947 4.25932 37.7961 4.13502C41.2645 4.01072 44.493 5.03412 47.4198 6.9069C52.674 10.2713 56.4399 15.0112 59.6313 20.2691C60.8714 22.3117 62.0537 24.3834 63.0252 26.571C63.05 27.0848 62.6077 27.1801 62.2894 27.3458C58.7549 29.1689 55.8736 31.7378 53.5503 34.953C53.323 35.2637 53.0832 35.5662 52.8517 35.8769C52.3515 36.544 51.9009 36.5481 51.4007 35.8603C50.6732 34.8618 49.8257 33.9586 49.0114 33.0305C46.3574 30.0017 42.856 28.941 38.9908 28.709C34.4601 28.4314 30.5164 30.0431 26.8166 32.4463C25.75 33.1382 24.6835 33.8343 23.6624 34.6049C22.5628 35.4336 22.261 35.4212 21.3888 34.2983C20.3346 32.9393 19.0407 31.8496 17.7386 30.7599C16.4075 29.6454 14.8531 28.9907 13.1913 28.5515C12.7118 28.4231 12.1992 28.3651 11.7941 28.0295C11.7072 27.9218 11.7114 27.814 11.8023 27.7105V27.7063Z"}),jsxRuntimeExports.jsx("path",{fill:"#D0E1F0",d:"M71.7926 64.3538C68.6798 64.938 65.6372 64.5776 62.5947 63.8028C59.7217 63.0736 57.0719 61.8761 54.5791 60.3183C53.8764 59.8791 53.5043 60.0034 53.0248 60.5378C50.9827 62.796 48.6842 64.6894 45.745 65.6838C41.5905 67.0926 37.4111 67.6312 33.2897 65.6631C30.3009 64.2337 27.4402 62.5598 25.0136 60.2602C24.315 59.5973 23.9016 59.5186 23.1493 60.252C19.6561 63.666 15.5677 66.0899 10.6897 66.7818C8.31277 67.1174 5.85311 67.1423 3.47613 66.4296C3.39345 66.3509 3.31078 66.268 3.2281 66.1893C2.90566 65.2695 2.65762 64.3538 3.19503 63.4216C3.21983 63.26 3.24877 63.0984 3.27357 62.9368C9.33384 65.3441 14.5301 63.8028 19.1105 59.4647C20.2266 58.4082 21.2931 57.2895 22.6821 56.581C24.2654 55.7772 25.0467 55.8849 26.2786 57.1528C28.081 59.009 30.0156 60.6912 32.2645 61.9963C37.2458 64.8842 44.5338 64.7599 49.1596 60.2147C50.2592 59.1333 51.334 58.027 52.4295 56.9415C53.4878 55.8932 54.6081 55.8228 55.6457 56.8917C58.0061 59.328 60.8543 60.7699 64.1697 61.3748C66.4847 61.7974 68.8079 61.9797 71.1477 61.64C71.4825 61.5902 71.7512 61.6524 72.0241 61.7974C71.9662 62.6509 72.2184 63.5335 71.7843 64.3497L71.7926 64.3538Z"}),jsxRuntimeExports.jsx("path",{fill:"#D0E1F0",d:"M11.8146 27.9549C15.8038 28.4728 18.7058 30.7931 21.2688 33.6727C21.3184 33.7307 21.339 33.8136 21.3845 33.8716C22.3518 35.156 22.4635 35.1394 23.7698 34.1906C26.9859 31.8455 30.2848 29.5708 34.2698 28.8084C38.9328 27.9176 43.4677 28.2532 47.4776 31.1991C49.0154 32.3302 50.1439 33.8633 51.3593 35.301C52.2232 36.3244 52.1902 36.399 52.9343 35.3093C54.9599 32.3385 57.4939 29.9106 60.5282 28.0005C61.3384 27.4909 62.1942 27.0475 63.0292 26.571C63.6369 27.3168 64.2115 28.0751 64.1702 29.1109C64.0544 29.9106 63.3351 30.097 62.7812 30.3497C58.7589 32.1894 55.9809 35.2761 53.8644 39.0548C53.7528 39.2579 53.6453 39.465 53.5006 39.6432C52.3266 41.1265 51.4047 41.0395 50.4209 39.3987C49.4949 37.8491 48.6144 36.2747 47.399 34.9115C45.2163 32.4628 42.3433 31.6632 39.2429 31.4353C33.3108 30.9961 28.6808 33.8136 24.4146 37.4845C24.0922 37.7621 23.8152 38.0853 23.5176 38.3836C22.327 39.5645 21.5168 39.4816 20.7768 37.9776C19.454 35.2761 17.3416 33.3826 14.8075 31.8952C13.803 31.3069 12.7488 30.8387 11.5335 30.9547C11.0168 31.0044 10.591 30.9215 10.6488 30.242C10.7108 30.0929 10.7729 29.9437 10.8349 29.7945C11.2069 29.2062 11.3971 28.5184 11.8146 27.9549Z"}),jsxRuntimeExports.jsx("path",{fill:"#FACE1F",d:"M3.19994 63.4258C3.21234 64.3497 3.22474 65.2696 3.23301 66.1935C2.4021 65.6425 2.59226 64.7599 2.55505 63.9727C2.53852 63.5625 2.67907 63.1482 2.75348 62.7131C3.21234 62.8209 2.9271 63.2849 3.19994 63.4299V63.4258Z"}),jsxRuntimeExports.jsx("path",{fill:"#F1EBED",d:"M11.8147 27.9549C11.608 28.6303 11.3972 29.3098 10.835 29.7945C10.9838 29.0197 11.3269 28.3319 11.8023 27.7063C11.8064 27.7892 11.8106 27.872 11.8147 27.9549Z"}),jsxRuntimeExports.jsx("path",{fill:"#FEFEFE",d:"M95.6995 81.2504C91.5946 74.2523 89.631 66.7239 90.1312 58.5989C90.2428 56.7966 90.3503 54.9859 90.8091 53.225C94.6909 51.3481 97.8863 48.4561 101.4 46.0322C103.43 44.6318 105.402 43.1402 107.394 41.6818C108.738 40.6998 109.246 40.7081 110.631 41.6155C115.894 45.0627 121.04 48.684 126.294 52.1395C126.584 52.3301 126.869 52.5289 127.162 52.7154C128.63 53.6476 129.345 53.5648 130.403 52.1478C131.673 50.449 132.818 48.655 133.942 46.8526C134.74 45.5765 135.571 44.321 136.435 43.0863C137.419 41.6859 138.266 41.4995 139.816 42.1955C145.062 44.5448 150.374 46.7366 155.785 48.684C156.612 48.9823 157.67 49.0403 157.923 50.1921C159.998 59.8419 158.964 69.1851 155.136 78.2506C154.831 78.868 154.301 78.6815 153.822 78.5862C152.569 78.3459 151.358 77.9357 150.151 77.5421C146.12 76.2245 141.929 75.8433 137.758 75.3503C133.194 74.8117 128.601 74.7537 124.021 74.8904C116.266 75.1224 108.684 76.411 101.371 79.071C99.9202 79.5972 98.6015 80.4258 97.2001 81.0763C96.7247 81.2959 96.2452 81.6523 95.6913 81.2504H95.6995Z"}),jsxRuntimeExports.jsx("path",{fill:"#FEFEFE",d:"M144.959 16.6146C150.726 25.2824 154.566 34.7623 156.877 44.8927C157.001 45.4313 157.05 45.9534 157.03 46.492C156.558 46.8318 156.128 46.5417 155.732 46.3594C150.147 43.8237 144.31 41.9054 138.75 39.3117C137.299 38.6322 136.646 38.8559 135.649 40.3226C133.673 43.223 131.755 46.1647 129.8 49.0774C128.77 50.6146 128.506 50.6809 126.923 49.7155C121.557 46.434 116.472 42.734 111.247 39.2412C109.114 37.8159 108.837 37.8366 106.741 39.349C102.458 42.444 98.2583 45.6468 93.8268 48.5305C93.3101 48.8661 92.8016 49.2266 92.227 49.4545C91.8426 49.6078 91.4788 49.6575 91.702 49.0277C93.5209 41.6941 96.2451 34.7126 99.8209 28.0626C101.301 25.3073 102.921 22.639 104.711 20.0743C105.286 19.6517 105.637 20.1157 106.009 20.4182C108.362 22.3531 110.61 24.3999 112.913 26.3928C114.07 27.3955 114.488 27.3665 115.476 26.2395C117.431 24.0104 119.304 21.7026 121.367 19.5729C122.417 18.4915 122.768 18.4377 123.938 19.2995C127.071 21.6114 130.255 23.853 133.359 26.2022C133.545 26.3431 133.723 26.4881 133.913 26.6207C135.12 27.4494 135.798 27.4038 136.658 26.2064C137.828 24.5739 139.122 23.045 140.391 21.4954C141.614 20.008 142.892 18.562 144.115 17.0787C144.33 16.8176 144.529 16.4986 144.959 16.6146Z"}),jsxRuntimeExports.jsx("path",{fill:"#FEFEFE",d:"M149.229 86.8811C143.326 92.9096 136.364 96.8789 127.853 97.7572C119.287 98.6398 111.499 96.5847 104.6 91.3765C103.806 90.7799 103.008 90.1543 102.388 89.3588C102.355 88.6627 102.95 88.4762 103.388 88.2235C105.923 86.7526 108.696 85.9322 111.557 85.4143C115.356 84.7307 119.192 84.4075 123.045 84.1299C131.387 83.5291 139.593 84.4697 147.753 86.0855C148.295 86.1933 149.047 86.0565 149.233 86.8811H149.229Z"}),jsxRuntimeExports.jsx("path",{fill:"#FEFEFE",d:"M106.773 17.5179C109.973 12.9313 113.776 8.98684 118.811 6.41385C125.752 2.86717 131.821 3.67098 137.757 8.73824C139.646 10.35 141.312 12.1565 142.92 14.0293C143.267 14.7999 142.668 15.2722 142.3 15.757C141.064 17.3853 139.692 18.9018 138.377 20.468C137.682 21.2966 136.976 22.1128 136.298 22.9539C135.107 24.4207 134.756 24.487 133.259 23.3766C130.816 21.5535 128.381 19.718 125.913 17.924C125.289 17.4682 124.665 17.0124 123.999 16.623C122.453 15.7197 121.759 15.7653 120.523 17.0497C118.973 18.6615 117.53 20.3768 116.062 22.0631C115.785 22.3822 115.517 22.7136 115.227 23.0244C114.124 24.2052 113.785 24.2549 112.59 23.1197C110.99 21.6074 109.25 20.2566 107.675 18.7278C107.311 18.3756 106.662 18.2223 106.773 17.5179Z"}),jsxRuntimeExports.jsx("path",{fill:"#F6DADF",d:"M149.229 86.881C147.488 86.1228 145.599 86.0316 143.772 85.696C140.002 85.0041 136.191 84.6353 132.35 84.4447C130.118 84.3329 127.881 84.1796 125.666 84.308C119.696 84.6478 113.706 84.9378 107.927 86.6531C105.951 87.2415 103.979 87.9334 102.392 89.3587C101.226 88.8325 100.04 88.327 99.8538 86.8189C100.656 86.0358 101.788 85.9198 102.731 85.4143C104.07 84.6975 104.223 82.9697 102.996 82.0623C102.557 81.735 102.115 81.8593 101.685 82.0623C100.705 82.5181 99.7587 83.0319 98.7831 83.4918C98.378 83.6865 97.9935 84.0097 97.4892 83.8191C96.6831 83.1106 96.1539 82.2074 95.6992 81.2502C96.1994 81.3083 96.5921 81.0348 96.9931 80.8152C102.466 77.7947 108.436 76.4357 114.533 75.4289C120.527 74.4428 126.567 74.2895 132.59 74.6002C139.638 74.9648 146.653 75.7604 153.387 78.1262C153.921 78.3126 154.528 78.7021 155.14 78.2505C155.012 79.4562 154.086 80.2434 153.565 81.2461C152.044 80.8608 150.564 80.3263 149.035 79.9741C147.832 79.6965 147.65 79.7959 147.24 80.9312C147.174 81.1135 147.116 81.2958 147.059 81.4781C146.686 82.659 146.777 82.7998 148.009 83.1562C149.179 83.4918 150.419 83.6119 151.482 84.279C151.097 85.464 150.49 86.4542 149.233 86.8851L149.229 86.881Z"}),jsxRuntimeExports.jsx("path",{fill:"#F6DADF",d:"M91.7023 49.0277C91.8428 49.699 92.1405 49.1935 92.3265 49.0858C95.2574 47.3787 97.9734 45.3609 100.727 43.3846C102.913 41.8184 105.055 40.1901 107.242 38.6197C108.664 37.5964 109.366 37.6088 110.801 38.5825C115.323 41.6444 119.842 44.7187 124.372 47.7723C125.36 48.4394 126.448 48.9656 127.394 49.6824C128.287 50.3577 128.804 50.1133 129.349 49.2805C131.334 46.2559 133.347 43.2478 135.36 40.2398C136.567 38.4374 137.278 38.2427 139.209 39.1957C142.772 40.9524 146.551 42.1789 150.205 43.7077C152.474 44.6566 154.69 45.7297 157.034 46.492C157.439 47.7019 157.774 48.9242 157.927 50.1962C157.514 49.4338 156.703 49.3053 156.005 49.0567C150.42 47.0762 144.942 44.8306 139.552 42.3736C138.213 41.7645 137.526 41.9593 136.642 43.2893C134.748 46.144 132.867 49.007 130.982 51.8659C130.813 52.1228 130.643 52.3797 130.437 52.6076C129.259 53.9044 128.585 54.0039 127.134 53.0468C124.79 51.5013 122.458 49.9351 120.127 48.3648C116.902 46.1979 113.686 44.0143 110.466 41.8474C109.118 40.94 108.817 40.9939 107.498 41.9468C102.587 45.5142 97.6509 49.0485 92.7399 52.6159C92.1446 53.0468 91.541 53.2954 90.8135 53.2249C90.9168 51.783 91.0532 50.3495 91.7064 49.0277H91.7023Z"}),jsxRuntimeExports.jsx("path",{fill:"#F6DADF",d:"M106.774 17.518C108.229 18.8231 109.68 20.1365 111.135 21.4375C111.85 22.0756 112.582 22.7012 113.301 23.3393C113.818 23.7992 114.161 23.8448 114.69 23.215C116.467 21.0936 118.303 19.0178 120.188 16.9918C121.722 15.3427 122.565 15.2433 124.405 16.5401C127.356 18.6201 130.237 20.7995 133.152 22.9333C133.276 23.0244 133.383 23.1363 133.507 23.2274C134.838 24.1846 134.983 24.1514 136.017 22.896C137.922 20.584 139.853 18.2969 141.771 15.9932C142.263 15.4049 142.775 14.8207 142.924 14.0293C144.322 14.2945 144.772 14.8662 144.962 16.6106C143.511 18.2969 142.04 19.9667 140.613 21.6737C139.307 23.2357 138.005 24.7978 136.827 26.4675C135.888 27.7934 135.157 27.8514 133.801 26.8694C130.655 24.5947 127.542 22.2786 124.413 19.9791C124.041 19.7056 123.669 19.4322 123.284 19.1753C122.796 18.8438 122.371 18.8894 121.961 19.3493C120.324 21.1889 118.663 23.0079 117.026 24.8475C116.439 25.5063 115.922 26.2272 115.339 26.8901C114.669 27.6442 113.917 27.6691 113.107 26.9689C110.668 24.8558 108.233 22.7302 105.81 20.5964C105.484 20.3106 105.194 20.0039 104.715 20.0702C105.211 19.0634 105.943 18.2472 106.778 17.518H106.774Z"}),jsxRuntimeExports.jsx("path",{fill:"#FEFEFE",d:"M151.477 84.2749C149.956 84.0926 148.526 83.5374 147.042 83.1977C146.868 83.1562 146.612 83.0319 146.575 82.8952C146.281 81.8097 146.963 80.9313 147.294 79.9907C147.501 79.4065 148.05 79.3817 148.654 79.5723C149.997 79.9949 151.37 80.3429 152.73 80.72C153.061 80.8111 153.416 80.8691 153.565 81.2462C152.978 82.3317 152.312 83.3593 151.477 84.2749Z"}),jsxRuntimeExports.jsx("path",{fill:"#FEFEFE",d:"M97.4893 83.8191C98.87 83.1272 100.255 82.4477 101.627 81.7433C102.574 81.2544 103.26 81.4574 103.669 82.4601C103.86 82.9241 104.079 83.3799 104.199 83.8647C104.364 84.5276 104.199 85.0414 103.488 85.3646C102.297 85.9032 101.127 86.4957 99.8538 86.823C99.0684 85.8245 98.2788 84.8218 97.4893 83.8232V83.8191Z"}),jsxRuntimeExports.jsx("path",{fill:"#FEFEFE",d:"M237.896 29.1233C239.161 31.3855 239.934 33.8508 240.823 36.2622C242.903 41.9054 244.61 47.6563 245.445 53.6268C245.825 56.3407 245.896 59.0794 245.751 61.8181C239.736 62.5847 234.139 61.8099 229.505 57.4387C228.141 56.1501 227.401 56.1708 226.065 57.4635C224.461 59.0173 222.99 60.7036 221.125 61.9839C216.442 65.1908 209.216 64.9878 204.181 61.2174C202.759 60.1525 201.403 59.0214 200.158 57.7494C198.505 56.0589 197.389 56.0009 195.532 57.4842C194.66 58.1803 193.796 58.893 193.023 59.7051C190.22 62.6344 186.703 64.0182 182.738 64.3911C181.097 64.5444 179.522 64.1467 177.976 63.6246C177.579 63.492 177.17 63.3387 176.975 62.9037C176.657 57.6251 177.352 52.446 178.567 47.3248C179.919 41.6195 181.643 36.0385 184.135 30.7143C185.342 30.4284 186.516 30.619 187.6 31.1286C190.452 32.4752 192.817 34.3936 194.392 37.1903C194.544 37.4596 194.673 37.7414 194.846 37.9983C195.516 38.9719 196.115 39.1087 196.897 38.2634C199.464 35.475 202.688 33.7306 206.074 32.1603C209.923 30.3746 217.913 30.619 221.452 34.8493C222.25 35.8023 222.911 36.8381 223.577 37.8781C223.887 38.367 224.16 38.8808 224.482 39.3573C225.329 40.621 226.053 40.6334 226.991 39.407C227.388 38.8849 227.69 38.2966 228.033 37.7372C229.992 34.5469 232.51 31.949 235.941 30.3373C236.644 30.0058 237.218 29.4838 237.901 29.1191L237.896 29.1233Z"}),jsxRuntimeExports.jsx("path",{fill:"#FEFEFE",d:"M245.523 64.3994C245.172 69.0109 243.94 73.407 242.328 77.7202C239.645 84.8964 234.449 89.773 228.004 93.4896C224.511 95.5032 220.786 96.9741 216.801 97.7033C210.675 98.822 204.71 98.0887 199.017 95.7021C188.092 91.1279 181.151 82.9697 178.046 71.5549C177.591 69.8893 177.219 68.1905 177.207 66.4421C177.509 66.1437 177.86 66.2846 178.191 66.3385C182.139 66.9807 185.954 66.5871 189.617 64.9256C192.209 63.7489 194.474 62.0916 196.558 60.1691C197.649 59.1623 197.881 59.1167 198.976 60.0862C201.365 62.2035 204.057 63.8442 206.901 65.2571C210.423 67.0097 214.061 66.873 217.736 65.891C220.819 65.0665 223.527 63.5749 225.681 61.1635C225.859 60.9605 226.057 60.7782 226.255 60.5917C227.293 59.6222 227.591 59.5269 228.785 60.2602C232.088 62.2988 235.685 63.4879 239.488 64.1384C241.146 64.4243 242.791 64.2503 244.445 64.2337C244.808 64.2337 245.213 64.0099 245.528 64.387L245.523 64.3994Z"}),jsxRuntimeExports.jsx("path",{fill:"#FEFEFE",d:"M185.508 27.7021C187.579 23.2812 190.163 19.1752 193.3 15.4421C196.239 11.9451 199.447 8.73404 203.519 6.51323C209.48 3.25659 215.371 3.32288 221.154 6.91927C226.012 9.93975 229.517 14.2736 232.576 19.0053C234.188 21.4996 235.631 24.0974 236.892 26.7864C235.114 27.9259 233.242 28.9078 231.601 30.2751C229.773 31.7999 228.277 33.5898 226.871 35.4791C225.945 36.7221 225.846 36.6724 224.867 35.533C223.139 33.5276 221.576 31.3151 219.025 30.2088C214.16 28.104 209.294 28.1537 204.458 30.2958C201.874 31.4394 199.518 32.9931 197.277 34.7002C196.516 35.2802 195.946 35.3092 195.318 34.5386C192.85 31.5181 189.977 29.0901 186.012 28.2946C185.822 28.2573 185.653 28.1537 185.508 28.0212C185.425 27.9134 185.421 27.8057 185.508 27.698V27.7021Z"}),jsxRuntimeExports.jsx("path",{fill:"#EEB3AB",d:"M245.524 64.3995C239.856 65.195 234.635 63.8277 229.687 61.1263C227.054 59.6844 227.918 59.4275 225.743 61.5779C221.307 65.9656 215.938 67.5981 209.89 66.5913C206.632 66.0485 203.867 64.1136 201.18 62.2325C200.266 61.5944 199.402 60.8777 198.584 60.1194C197.98 59.5642 197.608 59.5476 196.98 60.1526C193.825 63.1938 190.233 65.5057 185.893 66.4877C182.991 67.1423 180.097 67.076 177.203 66.4421C176.823 65.282 176.939 64.0887 176.98 62.9037C182.251 65.5845 189.001 63.2849 192.354 59.962C193.557 58.7687 194.718 57.5174 196.215 56.6846C197.918 55.7399 198.761 55.8435 200.113 57.2398C201.862 59.0505 203.755 60.6581 205.921 61.9591C211.378 65.2406 218.538 64.4492 223.093 60.0034C224.09 59.0339 225.045 58.0271 226.033 57.0492C227.223 55.8684 228.298 55.7731 229.431 56.9457C231.89 59.4979 234.904 60.8652 238.335 61.4494C240.509 61.8223 242.688 61.9425 244.879 61.6483C245.21 61.6027 245.487 61.6442 245.755 61.8182C245.648 62.6758 246.012 63.5749 245.528 64.3953L245.524 64.3995Z"}),jsxRuntimeExports.jsx("path",{fill:"#EEB3AB",d:"M185.533 27.9673C189.679 28.4687 192.61 30.9588 195.219 33.942C196.24 35.1104 196.182 35.1352 197.41 34.2403C200.663 31.8827 203.982 29.5542 208.013 28.8043C212.68 27.9342 217.236 28.2532 221.229 31.2281C222.812 32.4089 224.015 33.9958 225.21 35.5454C225.735 36.2249 225.991 36.2457 226.471 35.5454C228.67 32.3219 231.394 29.6329 234.801 27.6856C235.462 27.3085 236.086 26.8196 236.896 26.774C236.996 26.9274 237.095 27.0765 237.194 27.2298C237.426 27.5116 237.479 27.8845 237.657 28.1911C237.74 28.4977 237.822 28.8084 237.905 29.115C237.851 29.8525 237.186 30.01 236.706 30.2254C232.56 32.1065 229.679 35.2595 227.517 39.1667C227.368 39.4319 227.178 39.6846 226.971 39.9083C225.946 41.0229 225.131 40.9525 224.305 39.6639C223.784 38.8518 223.308 38.019 222.821 37.1862C220.501 33.2045 216.905 31.5927 212.445 31.3897C206.967 31.137 202.722 33.8052 198.658 36.9749C198.117 37.3975 197.682 37.961 197.186 38.4458C196.087 39.5313 195.223 39.4691 194.561 38.1019C193.309 35.504 191.32 33.6768 188.948 32.1189C187.451 31.137 185.802 30.9588 184.136 30.706C184.342 30.0473 184.69 29.4589 185.062 28.883C185.173 28.5515 185.297 28.2283 185.533 27.959V27.9673Z"}),jsxRuntimeExports.jsx("path",{fill:"#E7DEE2",d:"M185.533 27.9673C185.483 28.3278 185.355 28.651 185.062 28.8913C184.888 28.3734 185.268 28.0626 185.508 27.7021C185.516 27.7892 185.525 27.8803 185.533 27.9673Z"}),jsxRuntimeExports.jsx("path",{fill:"#CBCEDC",d:"M237.652 28.1994C237.351 27.9508 237.214 27.6193 237.189 27.2382C237.586 27.4412 237.677 27.7934 237.652 28.1994Z"}),jsxRuntimeExports.jsx("path",{fill:"#90A993",d:"M33.8194 51.0538C33.8276 47.6936 35.8863 45.4521 38.8585 45.5432C39.8879 45.5764 40.7188 45.9907 41.3802 46.7531C42.5956 48.1576 42.6328 50.7431 41.4712 52.3797C40.1731 54.2027 37.9408 55.0148 36.1137 54.327C34.6999 53.7967 33.8152 52.533 33.8194 51.0538Z"}),jsxRuntimeExports.jsx("path",{fill:"#91A994",d:"M14.1668 50.4531C14.018 51.203 13.9188 52.0068 13.6955 52.7775C13.1664 54.6088 12.1247 55.3422 10.2189 55.3049C8.65633 55.2759 7.62286 54.4017 7.13506 52.6988C6.51085 50.5235 7.25908 48.137 9.04078 46.8153C9.86342 46.2062 10.777 46.0819 11.7443 46.5998C13.278 47.4161 13.9725 48.7336 14.1668 50.4572V50.4531Z"}),jsxRuntimeExports.jsx("path",{fill:"#91A994",d:"M66.9732 50.8549C66.936 52.4915 66.2622 53.7925 64.7823 54.5259C63.4801 55.1681 62.1573 55.0314 60.9626 54.1489C60.0077 53.4445 59.5943 52.4915 59.8382 51.3148C60.0325 50.3702 60.2722 49.4462 60.8716 48.6424C61.8968 47.2792 63.447 46.6578 64.7947 47.1218C66.1795 47.6024 66.9898 48.9946 66.965 50.8508L66.9732 50.8549Z"}),jsxRuntimeExports.jsx("path",{fill:"#90A993",d:"M55.4184 66.2018C58.1881 66.1355 59.9077 67.507 59.9656 69.8272C60.0359 72.7856 58.031 75.2011 55.4556 75.2591C52.938 75.3171 50.9455 73.3698 51.053 70.6683C51.1977 67.0761 52.4792 66.1148 55.4184 66.2018Z"}),jsxRuntimeExports.jsx("path",{fill:"#91A993",d:"M28.284 70.8257C28.2634 73.2371 26.4031 75.1844 24.1088 75.201C21.769 75.2176 19.6773 73.1874 19.6856 70.9086C19.6938 68.4391 21.5127 66.4462 23.7492 66.4545C26.3742 66.4669 28.3047 68.3314 28.284 70.8257Z"}),jsxRuntimeExports.jsx("path",{fill:"#FCCE0E",d:"M39.1393 89.309C39.1393 90.0424 39.2013 90.7799 39.1228 91.5009C39.0236 92.3958 38.6805 93.1913 37.585 93.1706C36.5102 93.154 36.2787 92.3502 36.2456 91.4926C36.1175 88.0702 36.0017 84.6478 35.9108 81.2254C35.886 80.3181 36.1423 79.4853 37.2378 79.3941C38.3622 79.2988 38.7631 80.1109 38.7797 81.0059C38.8417 83.7736 38.8004 86.5413 38.8004 89.309H39.1352H39.1393Z"}),jsxRuntimeExports.jsx("path",{fill:"#FCCE0E",d:"M29.1768 91.6957C29.2305 92.313 28.9536 92.6983 28.4038 92.9801C27.7134 93.3323 27.1843 93.0588 26.7585 92.5906C25.9813 91.7371 25.2579 90.8338 24.522 89.943C23.0752 88.1904 21.6325 86.4337 20.1939 84.6727C19.6027 83.9477 19.334 83.1729 20.1319 82.4188C20.7891 81.7973 21.6903 81.9589 22.4303 82.8497C24.4972 85.3398 26.5476 87.8465 28.5939 90.3532C28.9081 90.7386 29.2181 91.1487 29.1685 91.6957H29.1768Z"}),jsxRuntimeExports.jsx("path",{fill:"#FCCE0E",d:"M46.5889 92.0312C46.5889 91.4719 46.8328 90.983 47.0271 90.4816C47.9861 88.0081 49.1395 85.6049 49.6521 82.9739C49.8216 82.0997 50.4251 81.5776 51.2891 81.3705C52.3887 81.1095 53.2568 81.9671 52.8724 83.0319C51.7025 86.2513 50.4871 89.4541 49.2428 92.6486C49.0031 93.2618 48.507 93.8336 47.767 93.6761C46.9733 93.5021 46.5889 92.8599 46.5889 92.0312Z"}),jsxRuntimeExports.jsx("path",{fill:"#FCCE0E",d:"M47.0102 11.709C47.5889 11.6966 48.0602 11.9576 48.4323 12.3678C49.7303 13.7848 50.9911 15.2391 52.1197 16.8053C52.2768 17.0208 52.409 17.2652 52.5124 17.5097C52.839 18.2969 53.0415 19.1504 52.2354 19.7139C51.4128 20.2898 50.6687 19.8092 50.1313 19.138C48.7836 17.4558 47.4732 15.7446 46.1669 14.0293C45.77 13.5072 45.6874 12.8816 45.9561 12.2767C46.1462 11.854 46.5472 11.6925 47.0102 11.709Z"}),jsxRuntimeExports.jsx("path",{fill:"#FCCE0F",d:"M23.886 17.3108C23.9976 16.7141 24.0679 16.1009 24.4234 15.5706C25.3328 14.195 26.234 12.807 27.1435 11.4273C27.2923 11.2035 27.4411 10.9632 27.6437 10.7975C28.3299 10.2381 29.0905 9.56278 29.9793 10.2464C30.7771 10.8596 30.2397 11.6676 29.9256 12.3388C28.9417 14.4477 27.4494 16.2169 26.019 18.0234C25.6429 18.4999 25.0765 18.7112 24.4647 18.4792C23.948 18.2844 23.9397 17.7748 23.8818 17.3108H23.886Z"}),jsxRuntimeExports.jsx("path",{fill:"#FCCE0E",d:"M36.7954 16.5816C36.7954 15.7736 36.7954 14.9657 36.7954 14.1577C36.7954 13.6978 36.7664 13.2296 37.0021 12.8029C37.3452 12.1814 37.709 11.5143 38.544 11.6759C39.2922 11.8209 39.5816 12.4921 39.5857 13.1675C39.5981 15.2433 39.9165 17.3149 39.6188 19.3907C39.4535 20.5343 38.8458 21.2759 38.0231 21.1558C36.9277 20.9942 36.8036 20.1489 36.8202 19.2374C36.8367 18.3508 36.8202 17.4682 36.8202 16.5816C36.8078 16.5816 36.7954 16.5816 36.7871 16.5816H36.7954Z"}),jsxRuntimeExports.jsx("path",{fill:"#EEB4AC",d:"M125.984 66.0485C126.026 67.8012 125.645 68.4682 124.62 68.4807C123.715 68.4889 123.338 67.8302 123.223 66.1024C123.165 65.2613 123.057 64.4244 123 63.5833C122.946 62.8085 123.177 62.1372 124.045 62.071C124.951 62.0047 125.579 62.477 125.761 63.4134C125.856 63.9023 125.935 64.3954 125.98 64.8925C126.013 65.2737 125.988 65.6632 125.988 66.0444L125.984 66.0485Z"}),jsxRuntimeExports.jsx("path",{fill:"#EEB4AC",d:"M138.761 64.3125C138.596 65.5347 138.319 66.7322 137.893 67.8923C137.666 68.5138 137.186 68.8908 136.542 69.04C135.797 69.214 135.268 68.953 135.272 68.1616C135.285 66.525 135.777 64.9671 136.347 63.4589C136.595 62.8043 137.335 62.5806 138.03 62.7794C138.778 62.999 138.786 63.6661 138.761 64.3083V64.3125Z"}),jsxRuntimeExports.jsx("path",{fill:"#EEB4AC",d:"M94.707 68.9157C94.8765 67.7845 94.9964 66.641 95.232 65.5223C95.385 64.8138 95.9348 64.4409 96.6872 64.5072C97.4891 64.5776 97.886 65.1577 97.8488 65.8413C97.7785 67.0553 97.6131 68.2776 97.3362 69.4584C97.1791 70.1338 96.8815 70.9625 95.8893 70.7636C94.9137 70.5688 94.6781 69.8106 94.7029 68.9115L94.707 68.9157Z"}),jsxRuntimeExports.jsx("path",{fill:"#EEB4AC",d:"M148.286 62.0337C148.716 62.0585 148.973 62.3569 149.212 62.6593C149.981 63.6247 150.606 64.6854 151.164 65.7751C151.577 66.583 151.25 67.304 150.568 67.7763C149.837 68.2818 149.332 67.7017 148.931 67.1921C148.22 66.2889 147.518 65.369 147.067 64.2959C146.666 63.3388 147.406 61.984 148.291 62.0337H148.286Z"}),jsxRuntimeExports.jsx("path",{fill:"#EEB4AC",d:"M110.531 67.6934C110.449 68.5055 110.267 69.0151 109.614 69.2306C108.985 69.4377 108.555 69.1601 108.262 68.6629C107.559 67.4697 107.042 66.1894 106.608 64.8801C106.36 64.126 106.732 63.6288 107.427 63.3346C108.142 63.0322 108.609 63.3098 108.903 63.9727C109.473 65.2654 110.035 66.5623 110.531 67.6934Z"}),jsxRuntimeExports.jsx("path",{fill:"#D0E1F0",d:"M127.625 32.8647C127.608 34.319 126.521 35.6283 125.36 35.591C124.103 35.5496 122.78 34.2071 122.768 32.9559C122.755 31.5886 123.954 30.4657 125.397 30.4989C126.79 30.532 127.642 31.4353 127.625 32.8647Z"}),jsxRuntimeExports.jsx("path",{fill:"#D0E1F0",d:"M105.393 31.2156C105.389 32.5249 104.302 33.6643 103.021 33.7099C101.995 33.7431 100.801 32.3468 100.834 31.1535C100.871 29.8069 101.88 28.6634 103.049 28.6509C104.401 28.6344 105.397 29.7282 105.393 31.2156Z"}),jsxRuntimeExports.jsx("path",{fill:"#D0E1F0",d:"M147.555 33.2873C146.174 33.2873 145.215 32.4214 145.228 31.1784C145.236 29.9395 146.422 28.8498 147.729 28.8747C148.878 28.8995 149.589 29.7033 149.622 31.0251C149.655 32.2515 148.713 33.2873 147.555 33.2873Z"}),jsxRuntimeExports.jsx("path",{fill:"#EEB4AC",d:"M112.462 33.9792C111.586 33.8632 110.85 33.8135 110.462 33.0221C110.284 32.6617 110.168 32.268 110.309 31.9076C110.85 30.5237 112.185 31.0126 113.198 30.7599C114.025 30.5527 114.608 30.909 114.868 31.7336C115.149 32.6244 114.802 33.2583 113.988 33.5939C113.467 33.8094 112.88 33.8756 112.458 33.9751L112.462 33.9792Z"}),jsxRuntimeExports.jsx("path",{fill:"#EEB4AC",d:"M137.943 31.2074C138.055 31.2281 138.468 31.3027 138.881 31.3648C139.349 31.4394 139.832 31.4891 139.886 32.1065C139.936 32.6658 139.874 33.1962 139.357 33.5484C138.377 34.2196 137.294 34.348 136.17 34.0621C135.653 33.9295 135.235 33.5857 135.306 32.989C135.388 32.3385 135.57 31.7046 136.269 31.3856C136.711 31.1825 137.17 31.2157 137.943 31.2032V31.2074Z"}),jsxRuntimeExports.jsx("path",{fill:"#D0E1F0",d:"M115.554 94.2396C113.88 94.2313 113.012 93.2535 113.025 91.3973C113.037 89.7276 114.256 88.2277 115.596 88.2318C116.972 88.2318 118.341 89.8726 118.353 91.5423C118.37 93.0961 117.175 94.2479 115.55 94.2396H115.554Z"}),jsxRuntimeExports.jsx("path",{fill:"#D0E1F0",d:"M133.88 91.7909C133.888 93.1955 132.735 94.5296 131.47 94.5794C130.081 94.6291 128.564 93.3529 128.576 92.1348C128.593 90.4319 129.887 88.8864 131.263 88.9196C132.636 88.9569 133.872 90.3076 133.88 91.7909Z"}),jsxRuntimeExports.jsx("path",{fill:"#EEB4AC",d:"M133.888 18.0027C132.429 18.011 131.552 17.1658 131.561 15.7612C131.569 14.2903 132.772 13.039 134.235 12.9769C135.372 12.9313 136.389 14.1992 136.381 15.6576C136.377 16.9213 135.236 17.9903 133.888 17.9986V18.0027Z"}),jsxRuntimeExports.jsx("path",{fill:"#EEB4AC",d:"M114.07 12.8898C115.434 12.8773 116.368 13.7557 116.381 15.0692C116.397 16.5069 115.318 17.7582 114.078 17.7375C112.896 17.7209 111.73 16.627 111.684 15.4959C111.631 14.1162 112.739 12.9064 114.07 12.8898Z"}),jsxRuntimeExports.jsx("path",{fill:"#FEFEFE",d:"M133.88 80.2931C133.777 78.2256 134.603 77.6083 136.501 77.9025C138.865 78.2671 141.284 78.3872 143.677 78.6855C144.504 78.7891 144.661 79.1496 144.339 79.8457C144.322 79.8788 144.322 79.9203 144.31 79.9575C143.413 82.4104 144.012 82.6424 140.854 82.2405C139.002 82.0043 137.125 81.8925 135.257 81.7599C134.144 81.6812 133.694 81.2875 133.884 80.2931H133.88Z"}),jsxRuntimeExports.jsx("path",{fill:"#FEFEFE",d:"M127.071 81.4947C126.302 81.4947 125.529 81.4326 124.769 81.5113C123.83 81.6107 123.545 81.1094 123.471 80.3305C123.454 80.1399 123.462 79.9451 123.462 79.7545C123.442 77.8321 123.45 77.9315 125.372 77.7492C126.943 77.6 128.506 77.6042 130.073 77.5379C131.073 77.4964 131.4 77.9771 131.321 78.8555C131.267 79.4604 131.16 80.0694 131.023 80.6619C130.883 81.2627 130.49 81.5362 129.841 81.5072C128.919 81.4657 127.997 81.4989 127.075 81.4989L127.071 81.4947Z"}),jsxRuntimeExports.jsx("path",{fill:"#FEFEFE",d:"M120.908 79.7794C120.912 81.2835 120.747 81.5072 118.907 81.6771C117.799 81.7807 116.696 81.8138 115.621 82.1328C115.513 82.166 115.373 82.1991 115.282 82.1577C114.099 81.6232 114.6 80.4258 114.31 79.5474C114.145 79.0502 114.472 78.5737 115.083 78.4867C116.787 78.234 118.494 78.06 120.213 77.9647C120.602 77.944 120.635 78.0931 120.714 78.3873C120.842 78.8762 120.958 79.3527 120.912 79.7794H120.908Z"}),jsxRuntimeExports.jsx("path",{fill:"#FEFEFE",d:"M110.379 79.1828C110.627 79.1828 110.71 79.1621 110.78 79.1828C112.161 79.6427 111.636 81.0017 112.012 81.9215C112.268 82.5513 111.681 82.9449 111.057 83.0982C110.127 83.3261 109.193 83.5333 108.275 83.8026C107.597 84.0015 107.167 83.8274 106.923 83.1604C106.675 82.4767 106.386 81.8014 106.158 81.1094C106.005 80.6454 105.976 80.1855 106.634 80.0405C107.94 79.7504 109.242 79.4438 110.383 79.1828H110.379Z"}),jsxRuntimeExports.jsx("path",{fill:"#90A993",d:"M212.345 45.5432C214.292 45.5432 215.603 46.7033 215.962 48.7377C216.57 52.1849 213.222 55.3919 210.055 54.3892C208.385 53.863 207.471 52.5661 207.538 50.8259C207.662 47.6605 209.592 45.5391 212.345 45.5432Z"}),jsxRuntimeExports.jsx("path",{fill:"#91A994",d:"M187.884 50.3992C187.74 51.1533 187.645 51.9571 187.43 52.7277C186.905 54.5881 185.879 55.3256 183.99 55.3049C182.37 55.2842 181.328 54.4058 180.84 52.6366C180.245 50.4986 180.972 48.1908 182.725 46.8525C183.622 46.1689 184.585 46.0819 185.623 46.6827C187.053 47.5113 187.665 48.7875 187.893 50.3992H187.884Z"}),jsxRuntimeExports.jsx("path",{fill:"#91A994",d:"M240.679 51.4309C240.633 52.5496 239.935 53.921 238.318 54.6047C236.942 55.1848 235.598 54.9734 234.449 53.9376C233.978 53.515 233.552 53.0095 233.539 52.3797C233.498 50.5277 233.998 48.8538 235.561 47.6978C236.578 46.9437 237.744 46.6247 238.922 47.2917C240.261 48.0541 240.72 49.3344 240.683 51.4309H240.679Z"}),jsxRuntimeExports.jsx("path",{fill:"#90A993",d:"M233.684 70.0137C233.684 72.9678 231.625 75.2632 228.984 75.2632C226.561 75.2632 224.734 73.2579 224.738 70.602C224.742 67.4241 226.086 66.1894 229.55 66.1977C232.068 66.1977 233.684 67.6934 233.684 70.0137Z"}),jsxRuntimeExports.jsx("path",{fill:"#91A993",d:"M202.002 70.7677C201.99 73.2122 200.047 75.2383 197.761 75.1927C195.384 75.1472 193.375 73.1377 193.404 70.8423C193.437 68.3811 195.289 66.4089 197.529 66.4545C200.105 66.5042 202.014 68.348 202.002 70.7677Z"}),jsxRuntimeExports.jsx("path",{fill:"#D0E1F0",d:"M212.907 89.0563C212.779 90.3242 212.994 91.2481 212.676 92.1597C212.432 92.864 211.998 93.1126 211.291 93.096C210.551 93.0795 210.142 92.7646 210.055 92.0229C210.014 91.6832 209.857 91.3434 209.869 91.012C209.989 87.7802 209.6 84.565 209.625 81.3373C209.625 80.9976 209.658 80.6413 209.766 80.3222C209.935 79.8333 210.237 79.4604 210.828 79.4024C211.436 79.3444 211.891 79.5681 212.205 80.0571C212.478 80.4797 212.622 80.9644 212.622 81.4741C212.622 84.1258 212.602 86.7734 212.912 89.0605L212.907 89.0563Z"}),jsxRuntimeExports.jsx("path",{fill:"#D0E1F0",d:"M193.408 83.4049C193.358 82.8373 193.602 82.4561 194.123 82.2116C194.879 81.8512 195.553 82.1329 196 82.655C198.215 85.2611 200.386 87.9045 202.527 90.5687C203.073 91.2523 203.184 92.1183 202.473 92.7729C201.729 93.4566 200.94 93.1707 200.365 92.4829C198.124 89.798 195.917 87.0883 193.709 84.3744C193.49 84.1051 193.375 83.7654 193.412 83.3966L193.408 83.4049Z"}),jsxRuntimeExports.jsx("path",{fill:"#D0E1F0",d:"M220.262 91.8075C220.659 90.7799 221.093 89.5908 221.576 88.4224C222.283 86.7153 222.953 84.9959 223.313 83.1769C223.461 82.4229 223.825 81.8552 224.582 81.5155C225.218 81.2296 225.776 81.1964 226.293 81.6605C226.785 82.1038 226.752 82.6383 226.537 83.2432C225.413 86.3963 224.243 89.5286 222.936 92.6113C222.672 93.2328 222.242 93.8294 221.477 93.6471C220.688 93.4606 220.32 92.8101 220.262 91.8116V91.8075Z"}),jsxRuntimeExports.jsx("path",{fill:"#D0E1F0",d:"M220.745 11.7256C221.324 11.709 221.799 11.9452 222.171 12.3595C223.54 13.905 224.924 15.4463 226.057 17.1782C226.26 17.4931 226.404 17.866 226.483 18.2347C226.615 18.8396 226.475 19.4238 225.921 19.7512C225.387 20.0661 224.759 20.0288 224.321 19.573C222.597 17.7707 221.088 15.786 219.716 13.7144C219.083 12.7614 219.716 11.7297 220.745 11.7214V11.7256Z"}),jsxRuntimeExports.jsx("path",{fill:"#D0E1F0",d:"M204.061 11.2532C203.995 11.9658 203.511 12.7365 203.044 13.4657C202.138 14.8827 201.13 16.2417 200.134 17.6008C199.869 17.9612 199.555 18.3051 199.084 18.4626C198.228 18.7526 197.595 18.3838 197.604 17.4889C197.608 16.8011 197.765 16.1092 198.145 15.5167C199.017 14.1659 199.935 12.8401 200.816 11.4977C201.254 10.8306 201.816 10.3292 202.564 10.0599C203.383 9.76161 204.057 10.2215 204.061 11.2573V11.2532Z"}),jsxRuntimeExports.jsx("path",{fill:"#D0E1F0",d:"M210.542 16.594C210.542 15.67 210.554 14.746 210.538 13.8221C210.53 13.3456 210.583 12.8857 210.873 12.5045C211.195 12.0778 211.538 11.5598 212.146 11.6551C212.832 11.7629 213.287 12.3471 213.275 12.9603C213.225 15.2142 213.866 17.4682 213.308 19.7222C213.105 20.5467 212.626 21.2138 211.753 21.1599C210.836 21.1019 210.534 20.3519 210.542 19.486C210.55 18.5247 210.542 17.5594 210.542 16.5981C210.542 16.5981 210.542 16.5981 210.538 16.5981L210.542 16.594Z"})]}),jsxRuntimeExports.jsx("defs",{children:jsxRuntimeExports.jsx("clipPath",{id:"clip0_333_161",children:jsxRuntimeExports.jsx("rect",{fill:"white",height:"102",width:"249"})})})]});const FireworksIcon=()=>jsxRuntimeExports.jsxs("svg",{xmlns:"http://www.w3.org/2000/svg",fill:"none",viewBox:"0 0 318 94",height:"94",width:"318",children:[jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M43.9463 50.3836L65.026 15.2547C65.2387 14.8884 65.7231 14.7702 66.0776 14.9947C66.4439 15.2074 66.5621 15.6801 66.3376 16.0464L51.0595 41.5216L68.618 24.8375C68.9253 24.5539 69.4097 24.5539 69.7051 24.8611C70.0005 25.1683 69.9887 25.6528 69.6815 25.9482L43.9581 50.3836H43.9463Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M83.2107 55.431C83.2107 55.431 83.128 55.431 83.0925 55.431L44.1943 49.5466L89.5204 44.0877C89.9222 44.0168 90.3239 44.3358 90.3712 44.7612C90.4184 45.1865 90.123 45.5646 89.6977 45.6119L55.5849 49.7239L83.3288 53.9185C83.7424 53.9776 84.0378 54.3675 83.9669 54.7929C83.9078 55.171 83.5888 55.4428 83.2107 55.4428V55.431Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M68.0865 82.1937C67.862 82.1937 67.6257 82.0873 67.4839 81.8983L50.1972 59.4125L58.7519 80.1731C58.9173 80.5631 58.7283 81.0121 58.3384 81.1775C57.9484 81.3429 57.4994 81.1539 57.334 80.7639L44.3955 49.3689L68.701 80.9766C68.9609 81.3075 68.89 81.7919 68.5592 82.0519C68.4174 82.1582 68.252 82.2055 68.0865 82.2055V82.1937Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M19.8409 80.8479C19.6755 80.8479 19.5101 80.7888 19.3683 80.6825C19.0374 80.4225 18.9784 79.9381 19.2383 79.6072L36.8087 57.3459L18.7657 70.7098C18.423 70.9579 17.9504 70.887 17.6904 70.5562C17.4423 70.2135 17.5132 69.7409 17.844 69.4809L45.1271 49.2638L20.4199 80.5643C20.2663 80.7534 20.0418 80.8597 19.8173 80.8597L19.8409 80.8479Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M4.94284 49.8312C4.51747 49.8312 4.1748 49.4886 4.1748 49.0632C4.1748 48.6378 4.51747 48.2952 4.94284 48.2952L33.3012 48.2243L11.6189 42.399C11.2053 42.2926 10.969 41.8673 11.0753 41.4655C11.1817 41.0638 11.5952 40.8156 12.0088 40.922L44.8099 49.7249L4.94284 49.8194V49.8312Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M45.1501 51.3894L26.28 16.2605C26.0791 15.8824 26.2209 15.4216 26.5872 15.2207C26.9535 15.0198 27.4262 15.1616 27.627 15.5279L41.05 40.5187L35.9691 18.6473C35.8746 18.2338 36.1345 17.8202 36.5481 17.7257C36.9617 17.6312 37.3752 17.8911 37.4697 18.3047L45.1501 51.3776V51.3894Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M12.007 67.2674C11.7352 67.2674 11.4634 67.1138 11.3217 66.8538C11.1326 66.4757 11.2744 66.0149 11.6525 65.8258L77.7393 31.6304C78.1174 31.4413 78.5782 31.5831 78.7673 31.9612C78.9563 32.3393 78.8145 32.8002 78.4364 32.9892L12.3615 67.1846C12.2433 67.2437 12.1251 67.2674 12.007 67.2674Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M87.76 33.0381C87.76 33.0381 87.7246 33.0381 87.7128 33.0381L70.2488 31.8801C69.8234 31.8565 69.5044 31.4902 69.5398 31.0648C69.5752 30.6394 69.9297 30.3204 70.3551 30.3558L87.8191 31.5138C88.2445 31.5374 88.5635 31.9037 88.5281 32.3291C88.5044 32.7309 88.1618 33.0499 87.76 33.0499V33.0381Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M76.8644 40.1527C76.8644 40.1527 76.7462 40.1527 76.699 40.1291C76.2854 40.0345 76.0255 39.621 76.12 39.2074L79.7239 23.3386C79.8184 22.925 80.2201 22.6532 80.6455 22.7596C81.0591 22.8541 81.319 23.2677 81.2245 23.6812L77.6206 39.5501C77.5379 39.9046 77.2189 40.1527 76.8762 40.1527H76.8644Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M83.7543 38.5563C83.5298 38.5563 83.3053 38.4618 83.1517 38.2727L72.7654 25.287C72.5055 24.9561 72.5527 24.4717 72.8836 24.2117C73.2144 23.9518 73.6989 23.999 73.9588 24.3299L84.3451 37.3156C84.605 37.6465 84.5578 38.1309 84.2269 38.3909C84.0851 38.5091 83.9197 38.5563 83.7425 38.5563H83.7543Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M17.9293 72.893C17.7757 72.893 17.6103 72.8458 17.4803 72.7512L3.3248 62.4713C2.98213 62.2232 2.91124 61.7387 3.15937 61.3961C3.40751 61.0534 3.89196 60.9825 4.23463 61.2307L18.3902 71.5106C18.7328 71.7587 18.8037 72.2432 18.5556 72.5858C18.402 72.7867 18.1775 72.9048 17.9412 72.9048L17.9293 72.893Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M4.91743 73.1077C4.71656 73.1077 4.5275 73.0368 4.37389 72.8832C4.07849 72.5878 4.07849 72.1033 4.37389 71.7961L15.8827 60.2873C16.1781 59.9919 16.6625 59.9919 16.9697 60.2873C17.2769 60.5827 17.2651 61.0672 16.9697 61.3744L5.46096 72.8832C5.30736 73.0368 5.1183 73.1077 4.91743 73.1077Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M11.5938 75.4322C11.2038 75.4322 10.873 75.1486 10.8375 74.7469L8.97062 58.2281C8.92336 57.8146 9.23057 57.4247 9.64413 57.3774C10.0341 57.3301 10.4476 57.6255 10.4949 58.0509L12.3618 74.5696C12.4091 74.9832 12.1019 75.3731 11.6883 75.4204C11.6647 75.4204 11.6292 75.4204 11.6056 75.4204L11.5938 75.4322Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M46.6872 84.7217C46.2854 84.7217 45.9428 84.4027 45.9191 83.9891L42.2444 9.67842C42.2207 9.25305 42.5516 8.89857 42.9769 8.87494C43.3905 8.81586 43.7568 9.18215 43.7804 9.60753L47.4552 83.9182C47.4788 84.3436 47.148 84.698 46.7226 84.7217C46.7108 84.7217 46.699 84.7217 46.6872 84.7217Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M42.7049 93.5227C42.5868 93.5227 42.4568 93.4873 42.3386 93.4282C41.9605 93.2273 41.8306 92.7665 42.0314 92.3884L50.3262 76.9804C50.5271 76.6023 50.9998 76.4723 51.366 76.6731C51.7442 76.874 51.8741 77.3348 51.6733 77.713L43.3784 93.121C43.2367 93.3809 42.9767 93.5227 42.7049 93.5227Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M53.7067 90.5371C53.5413 90.5371 53.3759 90.4899 53.2459 90.3835L40.3074 80.5172C39.9765 80.2572 39.9056 79.7846 40.1656 79.4419C40.4255 79.0993 40.8982 79.0402 41.2408 79.3001L54.1793 89.1665C54.5102 89.4264 54.5811 89.8991 54.3211 90.2417C54.1675 90.4426 53.943 90.5371 53.7067 90.5371Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M39.3501 87.594C39.0074 87.594 38.7002 87.3576 38.6057 87.015C38.4993 86.6014 38.7475 86.1879 39.161 86.0815L55.2898 82.0286C55.7034 81.9223 56.1169 82.1704 56.2233 82.584C56.3296 82.9975 56.0815 83.4111 55.6679 83.5175L39.5391 87.5703C39.48 87.5821 39.4091 87.594 39.3501 87.594Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M35.4503 13.4462C35.1786 13.4462 34.9186 13.3044 34.7768 13.0562C34.5642 12.6899 34.6941 12.2173 35.0722 12.0164L50.303 3.40257C50.6693 3.18988 51.142 3.31986 51.3428 3.69797C51.5555 4.06427 51.4256 4.5369 51.0474 4.73778L35.8166 13.3516C35.6985 13.4225 35.5685 13.4462 35.4385 13.4462H35.4503Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M46.3461 16.7801C46.0389 16.7801 45.7435 16.591 45.6253 16.2838L39.9418 1.04121C39.7882 0.639467 40.0009 0.202276 40.3908 0.0604839C40.7926 -0.0813078 41.2298 0.119564 41.3715 0.509491L47.055 15.7639C47.2086 16.1657 46.996 16.6028 46.606 16.7446C46.5233 16.7801 46.4288 16.7919 46.3343 16.7919L46.3461 16.7801Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M51.5812 11.8071C51.4985 11.8071 51.4276 11.7953 51.3449 11.7716L35.5351 6.60804C35.1334 6.47806 34.9089 6.04087 35.0389 5.63913C35.1688 5.23739 35.606 5.0247 36.0078 5.14286L51.8176 10.3064C52.2193 10.4364 52.4438 10.8736 52.3138 11.2754C52.2075 11.5944 51.9121 11.8071 51.5812 11.8071Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M75.4589 65.7233C75.3407 65.7233 75.2108 65.6997 75.1044 65.6406L9.25397 30.9962C8.87586 30.7953 8.73407 30.3345 8.93494 29.9564C9.13581 29.5783 9.59664 29.4365 9.97475 29.6373L75.8252 64.2818C76.2033 64.4827 76.3451 64.9435 76.1442 65.3216C76.0024 65.5815 75.7425 65.7351 75.4707 65.7351L75.4589 65.7233Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M81.0126 73.6381C80.7526 73.6381 80.5045 73.5081 80.3627 73.2718L71.3235 58.2892C71.1108 57.9229 71.2171 57.4502 71.5834 57.2375C71.9497 57.0249 72.4224 57.1312 72.6351 57.4975L81.6743 72.4802C81.887 72.8465 81.7806 73.3191 81.4143 73.5318C81.2844 73.6027 81.1544 73.6381 81.0126 73.6381Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M68.9495 68.758C68.6422 68.758 68.3587 68.5807 68.2405 68.2735C68.0751 67.8836 68.2641 67.4346 68.6659 67.281L83.7431 61.1603C84.133 60.9949 84.582 61.1958 84.7356 61.5857C84.901 61.9756 84.712 62.4246 84.3102 62.5782L69.233 68.6989C69.1385 68.7344 69.044 68.758 68.9495 68.758Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M74.1947 73.506C74.1238 73.506 74.0529 73.506 73.982 73.4705C73.5803 73.3524 73.344 72.927 73.4621 72.5134L78.1767 56.5619C78.2949 56.1601 78.732 55.9238 79.1338 56.042C79.5355 56.1601 79.7719 56.5855 79.6537 56.999L74.9391 72.9506C74.8446 73.2815 74.5374 73.4942 74.2065 73.4942L74.1947 73.506Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M8.38034 39.1455H8.36853C7.94315 39.1455 7.6123 38.791 7.6123 38.3657L7.95497 20.8662C7.95497 20.4408 8.33308 20.11 8.73482 20.11C9.1602 20.11 9.49104 20.4645 9.49104 20.8898L9.14838 38.3893C9.14838 38.8029 8.7939 39.1455 8.38034 39.1455Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M16.7931 31.4658C16.7931 31.4658 16.6985 31.4658 16.6513 31.454L0.628799 28.5827C0.215239 28.5119 -0.068344 28.1101 0.0143678 27.6965C0.0852637 27.283 0.498823 26.9994 0.900566 27.0821L16.923 29.9416C17.3366 30.0125 17.6202 30.4142 17.5375 30.8278C17.4666 31.1941 17.1475 31.454 16.7812 31.454L16.7931 31.4658Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M2.67166 35.4152C2.45897 35.4152 2.24629 35.3324 2.09268 35.1552C1.8091 34.8362 1.84454 34.3517 2.16358 34.08L14.6531 23.0911C14.9721 22.8075 15.4565 22.843 15.7283 23.162C16.0001 23.481 15.9765 23.9655 15.6574 24.2372L3.17975 35.2143C3.03796 35.3443 2.8489 35.4033 2.67166 35.4033V35.4152Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M271.57 50.3829L292.65 15.254C292.863 14.8877 293.347 14.7695 293.702 14.994C294.068 15.2067 294.186 15.6793 293.962 16.0456L278.684 41.5209L296.242 24.8367C296.549 24.5531 297.034 24.5531 297.329 24.8604C297.625 25.1676 297.613 25.652 297.306 25.9474L271.582 50.3829H271.57Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M310.836 55.4255C310.836 55.4255 310.753 55.4255 310.718 55.4255L271.819 49.5411L317.145 44.0822C317.559 44.0113 317.949 44.3303 317.996 44.7557C318.043 45.181 317.748 45.5592 317.323 45.6064L283.21 49.7184L310.954 53.913C311.367 53.9721 311.663 54.3621 311.592 54.7874C311.533 55.1655 311.214 55.4373 310.836 55.4373V55.4255Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M295.711 82.1882C295.486 82.1882 295.25 82.0818 295.108 81.8928L277.821 59.407L286.376 80.1677C286.541 80.5576 286.352 81.0066 285.962 81.172C285.572 81.3374 285.123 81.1484 284.958 80.7585L272.02 49.3634L296.325 80.9711C296.585 81.302 296.514 81.7864 296.183 82.0464C296.041 82.1527 295.876 82.2 295.711 82.2V82.1882Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M247.466 80.8425C247.3 80.8425 247.135 80.7834 246.993 80.6771C246.662 80.4172 246.603 79.9327 246.863 79.6019L264.434 57.3406L246.391 70.7044C246.048 70.9526 245.575 70.8817 245.315 70.5508C245.067 70.2081 245.138 69.7355 245.469 69.4756L272.752 49.2584L248.045 80.5589C247.891 80.748 247.667 80.8543 247.442 80.8543L247.466 80.8425Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M232.554 49.8257C232.129 49.8257 231.786 49.4831 231.786 49.0577C231.786 48.6323 232.129 48.2897 232.554 48.2897L260.913 48.2188L239.23 42.3935C238.817 42.2872 238.58 41.8618 238.687 41.46C238.793 41.0583 239.218 40.8102 239.62 40.9165L272.421 49.7194L232.554 49.8139V49.8257Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M272.775 51.384L253.905 16.2551C253.704 15.877 253.846 15.4162 254.212 15.2153C254.579 15.0144 255.051 15.1562 255.252 15.5225L268.675 40.5133L263.594 18.642C263.5 18.2284 263.76 17.8148 264.173 17.7203C264.587 17.6258 265 17.8857 265.095 18.2993L272.775 51.3722V51.384Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M239.632 67.2667C239.36 67.2667 239.088 67.1131 238.947 66.8532C238.758 66.4751 238.899 66.0143 239.278 65.8252L305.364 31.6298C305.731 31.4407 306.203 31.5825 306.392 31.9606C306.581 32.3387 306.439 32.7995 306.061 32.9886L239.975 67.184C239.856 67.2431 239.738 67.2667 239.62 67.2667H239.632Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M315.385 33.0375C315.385 33.0375 315.35 33.0375 315.338 33.0375L297.874 31.8795C297.448 31.8559 297.129 31.4896 297.165 31.0642C297.188 30.6388 297.578 30.3198 297.98 30.3552L315.444 31.5132C315.869 31.5368 316.189 31.9031 316.153 32.3285C316.129 32.7302 315.787 33.0493 315.385 33.0493V33.0375Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M304.489 40.1472C304.489 40.1472 304.371 40.1472 304.324 40.1236C303.91 40.0291 303.65 39.6155 303.745 39.2019L307.349 23.3331C307.443 22.9195 307.845 22.6477 308.271 22.7541C308.684 22.8486 308.944 23.2622 308.85 23.6757L305.246 39.5446C305.163 39.8991 304.844 40.1472 304.501 40.1472H304.489Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M311.379 38.5556C311.155 38.5556 310.93 38.4611 310.777 38.272L300.39 25.2862C300.13 24.9554 300.178 24.4709 300.509 24.211C300.839 23.951 301.324 23.9983 301.584 24.3292L311.97 37.3149C312.23 37.6458 312.183 38.1302 311.852 38.3902C311.71 38.5083 311.545 38.5556 311.367 38.5556H311.379Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M245.553 72.8923C245.4 72.8923 245.234 72.845 245.104 72.7505L230.949 62.4706C230.606 62.2225 230.535 61.738 230.783 61.3954C231.032 61.0527 231.516 60.9818 231.859 61.2299L246.014 71.5098C246.357 71.758 246.428 72.2424 246.18 72.5851C246.026 72.786 245.802 72.9041 245.565 72.9041L245.553 72.8923Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M232.542 73.1022C232.342 73.1022 232.153 73.0313 231.999 72.8777C231.703 72.5823 231.703 72.0978 231.999 71.7906L243.508 60.2819C243.803 59.9865 244.288 59.9865 244.595 60.2819C244.902 60.5773 244.89 61.0617 244.595 61.3689L233.086 72.8777C232.932 73.0313 232.743 73.1022 232.542 73.1022Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M239.219 75.4316C238.829 75.4316 238.498 75.148 238.463 74.7463L236.596 58.2275C236.548 57.814 236.856 57.4241 237.269 57.3768C237.671 57.3295 238.073 57.6249 238.12 58.0503L239.987 74.569C240.034 74.9826 239.727 75.3725 239.313 75.4198C239.29 75.4198 239.254 75.4198 239.231 75.4198L239.219 75.4316Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M274.312 84.7209C273.91 84.7209 273.568 84.4019 273.544 83.9884L269.869 9.67769C269.846 9.25231 270.177 8.89783 270.602 8.8742C271.015 8.81512 271.382 9.18142 271.405 9.60679L275.08 83.9175C275.104 84.3428 274.773 84.6973 274.348 84.7209C274.336 84.7209 274.324 84.7209 274.312 84.7209Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M270.329 93.522C270.211 93.522 270.081 93.4866 269.963 93.4275C269.585 93.2266 269.455 92.7658 269.655 92.3877L277.95 76.9796C278.151 76.6015 278.624 76.4715 278.99 76.6724C279.368 76.8733 279.498 77.3341 279.297 77.7122L271.002 93.1203C270.861 93.3802 270.601 93.522 270.329 93.522Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M281.332 90.5316C281.166 90.5316 281.001 90.4844 280.871 90.378L267.932 80.5117C267.602 80.2517 267.531 79.7791 267.791 79.4364C268.051 79.0938 268.535 79.0347 268.866 79.2946L281.804 89.161C282.135 89.4209 282.206 89.8936 281.946 90.2362C281.793 90.4371 281.568 90.5316 281.332 90.5316Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M266.974 87.5886C266.631 87.5886 266.324 87.3523 266.23 87.0096C266.123 86.596 266.371 86.1825 266.785 86.0761L282.914 82.0233C283.327 81.9169 283.741 82.1651 283.847 82.5786C283.954 82.9922 283.706 83.4057 283.292 83.5121L267.163 87.565C267.104 87.5768 267.033 87.5886 266.974 87.5886Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M263.063 13.4454C262.791 13.4454 262.531 13.3036 262.389 13.0555C262.176 12.6892 262.306 12.2166 262.685 12.0157L277.915 3.40184C278.282 3.18915 278.754 3.31913 278.955 3.69724C279.168 4.06353 279.038 4.53617 278.66 4.73704L263.429 13.3509C263.311 13.4218 263.181 13.4454 263.051 13.4454H263.063Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M273.971 16.7769C273.664 16.7769 273.368 16.5878 273.25 16.2806L267.567 1.0262C267.413 0.624452 267.626 0.187261 268.016 0.0454692C268.418 -0.0963225 268.855 0.104549 268.997 0.494476L274.68 15.7489C274.834 16.1506 274.621 16.5878 274.231 16.7296C274.148 16.7651 274.054 16.7769 273.959 16.7769H273.971Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M279.202 11.8016C279.12 11.8016 279.049 11.7898 278.966 11.7661L263.156 6.60255C262.755 6.47257 262.53 6.03538 262.66 5.63364C262.79 5.23189 263.227 5.01921 263.629 5.13737L279.439 10.3009C279.84 10.4309 280.065 10.8681 279.935 11.2699C279.829 11.5889 279.533 11.8016 279.202 11.8016Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M303.073 65.7178C302.955 65.7178 302.825 65.6942 302.719 65.6351L236.868 30.9907C236.49 30.7898 236.348 30.329 236.549 29.9509C236.75 29.5728 237.211 29.431 237.589 29.6318L303.439 64.2763C303.818 64.4772 303.959 64.938 303.758 65.3161C303.617 65.576 303.357 65.7296 303.085 65.7296L303.073 65.7178Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M308.638 73.6375C308.378 73.6375 308.129 73.5075 307.988 73.2712L298.948 58.2886C298.736 57.9223 298.842 57.4496 299.208 57.2369C299.575 57.0242 300.047 57.1306 300.26 57.4969L309.299 72.4795C309.512 72.8458 309.406 73.3185 309.039 73.5312C308.909 73.6021 308.779 73.6375 308.638 73.6375Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M296.574 68.7574C296.267 68.7574 295.984 68.5801 295.866 68.2729C295.7 67.883 295.889 67.434 296.291 67.2804L311.368 61.1597C311.758 60.9943 312.207 61.1951 312.361 61.5851C312.526 61.975 312.337 62.424 311.935 62.5776L296.858 68.6983C296.764 68.7337 296.669 68.7574 296.574 68.7574Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M301.82 73.5052C301.749 73.5052 301.678 73.5052 301.607 73.4698C301.205 73.3516 300.969 72.9262 301.087 72.5127L305.802 56.5611C305.92 56.1594 306.357 55.9231 306.759 56.0412C307.161 56.1594 307.397 56.5848 307.279 56.9983L302.564 72.9499C302.47 73.2807 302.162 73.4934 301.832 73.4934L301.82 73.5052Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M236.005 39.1448H235.994C235.568 39.1448 235.237 38.7903 235.237 38.3649L235.58 20.8655C235.58 20.4401 235.934 20.1093 236.36 20.1093C236.785 20.1093 237.116 20.4637 237.116 20.8891L236.773 38.3886C236.773 38.8021 236.419 39.1448 236.005 39.1448Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M244.418 31.4628C244.418 31.4628 244.324 31.4628 244.276 31.451L228.254 28.5915C227.84 28.5206 227.557 28.1189 227.639 27.7053C227.71 27.2918 228.124 27.0082 228.526 27.0909L244.548 29.9504C244.962 30.0213 245.245 30.423 245.162 30.8366C245.092 31.2029 244.773 31.4628 244.406 31.4628H244.418Z"}),jsxRuntimeExports.jsx("path",{fill:"#B92031",d:"M230.297 35.4097C230.084 35.4097 229.871 35.327 229.718 35.1497C229.434 34.8307 229.47 34.3462 229.789 34.0745L242.278 23.0856C242.597 22.802 243.082 22.8375 243.353 23.1565C243.625 23.4755 243.601 23.96 243.282 24.2317L230.793 35.2206C230.651 35.3506 230.462 35.4097 230.285 35.4097H230.297Z"}),jsxRuntimeExports.jsx("path",{fill:"#90A9CD",d:"M156.436 50.3829L177.515 15.254C177.728 14.8877 178.212 14.7695 178.567 14.994C178.933 15.2067 179.051 15.6793 178.827 16.0456L163.537 41.5209L181.095 24.8367C181.403 24.5531 181.887 24.5531 182.183 24.8604C182.478 25.1676 182.466 25.652 182.159 25.9474L156.436 50.3829Z"}),jsxRuntimeExports.jsx("path",{fill:"#90A9CD",d:"M195.688 55.4255C195.688 55.4255 195.606 55.4255 195.57 55.4255L156.672 49.5411L201.986 44.0822C202.4 44.0113 202.79 44.3303 202.837 44.7557C202.884 45.181 202.589 45.5592 202.163 45.6064L168.051 49.7184L195.795 53.913C196.208 53.9721 196.504 54.3621 196.433 54.7874C196.374 55.1655 196.055 55.4373 195.676 55.4373L195.688 55.4255Z"}),jsxRuntimeExports.jsx("path",{fill:"#90A9CD",d:"M180.563 82.1882C180.339 82.1882 180.102 82.0818 179.96 81.8928L162.674 59.407L171.228 80.1677C171.394 80.5576 171.205 81.0066 170.815 81.172C170.425 81.3374 169.976 81.1484 169.811 80.7585L156.872 49.3634L181.178 80.9711C181.437 81.302 181.367 81.7864 181.036 82.0464C180.894 82.1527 180.729 82.2 180.563 82.2V82.1882Z"}),jsxRuntimeExports.jsx("path",{fill:"#90A9CD",d:"M132.33 80.8425C132.165 80.8425 131.999 80.7834 131.858 80.6771C131.527 80.4172 131.468 79.9327 131.728 79.6019L149.298 57.3406L131.255 70.7044C130.912 70.9526 130.44 70.8817 130.18 70.5508C129.932 70.2081 130.002 69.7355 130.333 69.4756L157.616 49.2584L132.909 80.5471C132.756 80.7362 132.531 80.8425 132.307 80.8425H132.33Z"}),jsxRuntimeExports.jsx("path",{fill:"#90A9CD",d:"M117.418 49.8257C116.993 49.8257 116.65 49.4831 116.65 49.0577C116.65 48.6323 116.993 48.2897 117.418 48.2897L145.777 48.2188L124.094 42.3935C123.681 42.2872 123.445 41.8618 123.551 41.46C123.657 41.0583 124.083 40.8102 124.484 40.9165L157.286 49.7194L117.418 49.8139V49.8257Z"}),jsxRuntimeExports.jsx("path",{fill:"#90A9CD",d:"M157.628 51.384L138.758 16.2551C138.557 15.877 138.698 15.4162 139.065 15.2153C139.431 15.0144 139.904 15.1562 140.105 15.5225L153.528 40.5133L148.447 18.642C148.352 18.2284 148.612 17.8148 149.026 17.7203C149.439 17.6258 149.853 17.8857 149.947 18.2993L157.628 51.3722V51.384Z"}),jsxRuntimeExports.jsx("path",{fill:"#90A9CD",d:"M124.485 67.2667C124.213 67.2667 123.941 67.1131 123.799 66.8532C123.61 66.4751 123.752 66.0143 124.13 65.8252L190.217 31.6298C190.583 31.4407 191.056 31.5825 191.245 31.9606C191.434 32.3387 191.292 32.7995 190.914 32.9886L124.827 67.184C124.709 67.2431 124.591 67.2667 124.473 67.2667H124.485Z"}),jsxRuntimeExports.jsx("path",{fill:"#90A9CD",d:"M200.237 33.0375C200.237 33.0375 200.202 33.0375 200.19 33.0375L182.738 31.8795C182.313 31.8559 181.994 31.4896 182.029 31.0642C182.065 30.6388 182.443 30.3198 182.844 30.3552L200.297 31.5132C200.722 31.5368 201.041 31.9031 201.006 32.3285C200.982 32.7302 200.639 33.0493 200.237 33.0493V33.0375Z"}),jsxRuntimeExports.jsx("path",{fill:"#90A9CD",d:"M189.342 40.1472C189.342 40.1472 189.224 40.1472 189.177 40.1236C188.763 40.0291 188.503 39.6155 188.598 39.2019L192.201 23.3331C192.296 22.9195 192.698 22.6477 193.123 22.7541C193.537 22.8486 193.797 23.2622 193.702 23.6757L190.098 39.5446C190.015 39.8991 189.696 40.1472 189.354 40.1472H189.342Z"}),jsxRuntimeExports.jsx("path",{fill:"#90A9CD",d:"M196.232 38.5556C196.007 38.5556 195.783 38.4611 195.629 38.272L185.243 25.2862C184.983 24.9554 185.03 24.4709 185.361 24.211C185.692 23.951 186.176 23.9983 186.436 24.3292L196.823 37.3149C197.083 37.6458 197.035 38.1302 196.704 38.3902C196.563 38.5083 196.397 38.5556 196.22 38.5556H196.232Z"}),jsxRuntimeExports.jsx("path",{fill:"#90A9CD",d:"M130.403 72.8923C130.249 72.8923 130.084 72.845 129.954 72.7505L115.798 62.4706C115.456 62.2225 115.385 61.738 115.633 61.3954C115.881 61.0527 116.366 60.9818 116.708 61.2299L130.864 71.5098C131.206 71.758 131.277 72.2424 131.029 72.5851C130.876 72.786 130.651 72.9041 130.415 72.9041L130.403 72.8923Z"}),jsxRuntimeExports.jsx("path",{fill:"#90A9CD",d:"M117.395 73.1022C117.194 73.1022 117.005 73.0313 116.851 72.8777C116.556 72.5823 116.556 72.0978 116.851 71.7906L128.36 60.2819C128.656 59.9865 129.14 59.9865 129.447 60.2819C129.754 60.5773 129.743 61.0617 129.447 61.3689L117.938 72.8777C117.785 73.0313 117.596 73.1022 117.395 73.1022Z"}),jsxRuntimeExports.jsx("path",{fill:"#90A9CD",d:"M124.07 75.4316C123.68 75.4316 123.35 75.148 123.314 74.7463L121.447 58.2275C121.4 57.814 121.707 57.4241 122.121 57.3768C122.511 57.3295 122.924 57.6249 122.971 58.0503L124.838 74.569C124.886 74.9826 124.578 75.3725 124.165 75.4198C124.141 75.4198 124.106 75.4198 124.082 75.4198L124.07 75.4316Z"}),jsxRuntimeExports.jsx("path",{fill:"#90A9CD",d:"M159.176 84.7209C158.775 84.7209 158.432 84.4019 158.408 83.9884L154.734 9.67769C154.71 9.25231 155.041 8.89783 155.466 8.8742C155.903 8.81512 156.246 9.18142 156.27 9.60679L159.944 83.9175C159.968 84.3428 159.637 84.6973 159.212 84.7209C159.2 84.7209 159.188 84.7209 159.176 84.7209Z"}),jsxRuntimeExports.jsx("path",{fill:"#90A9CD",d:"M155.194 93.522C155.076 93.522 154.946 93.4866 154.828 93.4275C154.45 93.2266 154.32 92.7658 154.521 92.3877L162.815 76.9796C163.016 76.6015 163.489 76.4715 163.855 76.6724C164.233 76.8733 164.363 77.3341 164.163 77.7122L155.868 93.1203C155.726 93.3802 155.466 93.522 155.194 93.522Z"}),jsxRuntimeExports.jsx("path",{fill:"#90A9CD",d:"M166.195 90.5316C166.029 90.5316 165.864 90.4844 165.734 90.378L152.795 80.5117C152.453 80.2517 152.394 79.7791 152.654 79.4364C152.913 79.0938 153.398 79.0347 153.729 79.2946L166.667 89.161C167.01 89.4209 167.069 89.8936 166.809 90.2362C166.655 90.4371 166.431 90.5434 166.195 90.5434V90.5316Z"}),jsxRuntimeExports.jsx("path",{fill:"#90A9CD",d:"M151.839 87.5886C151.497 87.5886 151.189 87.3523 151.095 87.0096C150.989 86.596 151.237 86.1825 151.65 86.0761L167.779 82.0233C168.193 81.9169 168.606 82.1651 168.713 82.5786C168.819 82.9922 168.571 83.4057 168.157 83.5121L152.028 87.565C151.969 87.5768 151.898 87.5886 151.839 87.5886Z"}),jsxRuntimeExports.jsx("path",{fill:"#90A9CD",d:"M147.928 13.4454C147.656 13.4454 147.396 13.3036 147.254 13.0555C147.042 12.6892 147.172 12.2166 147.55 12.0157L162.781 3.40184C163.147 3.18915 163.62 3.31913 163.82 3.69724C164.033 4.06353 163.903 4.53617 163.525 4.73704L148.294 13.3509C148.176 13.4218 148.046 13.4454 147.916 13.4454H147.928Z"}),jsxRuntimeExports.jsx("path",{fill:"#90A9CD",d:"M158.824 16.7769C158.516 16.7769 158.221 16.5878 158.103 16.2806L152.419 1.0262C152.266 0.624452 152.478 0.187261 152.868 0.0454692C153.27 -0.0963225 153.707 0.104549 153.849 0.494476L159.533 15.7489C159.686 16.1506 159.473 16.5878 159.084 16.7296C159.001 16.7651 158.906 16.7769 158.812 16.7769H158.824Z"}),jsxRuntimeExports.jsx("path",{fill:"#90A9CD",d:"M164.058 11.8016C163.975 11.8016 163.904 11.7898 163.821 11.7661L148.012 6.60255C147.61 6.47257 147.385 6.03538 147.515 5.63364C147.645 5.23189 148.083 5.01921 148.484 5.13737L164.294 10.3009C164.696 10.4309 164.92 10.8681 164.79 11.2699C164.684 11.5889 164.389 11.8016 164.058 11.8016Z"}),jsxRuntimeExports.jsx("path",{fill:"#90A9CD",d:"M187.936 65.7178C187.818 65.7178 187.688 65.6942 187.582 65.6351L121.732 30.9907C121.353 30.7898 121.212 30.329 121.412 29.9509C121.613 29.5728 122.074 29.431 122.452 29.6318L188.303 64.2763C188.681 64.4772 188.823 64.938 188.622 65.3161C188.48 65.576 188.22 65.7296 187.948 65.7296L187.936 65.7178Z"}),jsxRuntimeExports.jsx("path",{fill:"#90A9CD",d:"M193.49 73.6375C193.23 73.6375 192.982 73.5075 192.84 73.2712L183.801 58.2886C183.588 57.9223 183.695 57.4614 184.061 57.2369C184.415 57.0242 184.888 57.1306 185.113 57.4969L194.152 72.4795C194.364 72.8458 194.258 73.3067 193.892 73.5312C193.774 73.6021 193.632 73.6375 193.502 73.6375H193.49Z"}),jsxRuntimeExports.jsx("path",{fill:"#90A9CD",d:"M181.437 68.7574C181.13 68.7574 180.846 68.5801 180.728 68.2729C180.562 67.883 180.751 67.434 181.153 67.2804L196.23 61.1597C196.62 60.9943 197.069 61.1951 197.223 61.5851C197.388 61.975 197.199 62.424 196.798 62.5776L181.72 68.6983C181.626 68.7337 181.531 68.7574 181.437 68.7574Z"}),jsxRuntimeExports.jsx("path",{fill:"#90A9CD",d:"M186.684 73.5052C186.613 73.5052 186.542 73.5052 186.471 73.4698C186.07 73.3516 185.833 72.9262 185.951 72.5127L190.666 56.5611C190.784 56.1594 191.221 55.9231 191.623 56.0412C192.025 56.1594 192.261 56.5848 192.143 56.9983L187.428 72.9499C187.334 73.2807 187.027 73.4934 186.696 73.4934L186.684 73.5052Z"}),jsxRuntimeExports.jsx("path",{fill:"#90A9CD",d:"M120.858 39.1448H120.846C120.421 39.1448 120.09 38.7903 120.09 38.3649L120.433 20.8655C120.433 20.4401 120.799 20.1093 121.212 20.1093C121.638 20.1093 121.969 20.4637 121.969 20.8891L121.626 38.3886C121.626 38.8021 121.271 39.1448 120.858 39.1448Z"}),jsxRuntimeExports.jsx("path",{fill:"#90A9CD",d:"M129.271 31.4628C129.271 31.4628 129.176 31.4628 129.129 31.451L113.106 28.5915C112.693 28.5206 112.409 28.1189 112.492 27.7053C112.563 27.2918 112.976 27.0082 113.378 27.0909L129.401 29.9504C129.814 30.0213 130.098 30.423 130.015 30.8366C129.944 31.2029 129.625 31.4628 129.259 31.4628H129.271Z"}),jsxRuntimeExports.jsx("path",{fill:"#90A9CD",d:"M115.164 35.4097C114.951 35.4097 114.738 35.327 114.585 35.1497C114.301 34.8307 114.337 34.3462 114.656 34.0745L127.145 23.0856C127.464 22.802 127.949 22.8375 128.221 23.1565C128.492 23.4755 128.469 23.96 128.15 24.2317L115.66 35.2206C115.518 35.3506 115.329 35.4097 115.152 35.4097H115.164Z"})]});const PumpkinsIcon=()=>jsxRuntimeExports.jsxs("svg",{xmlns:"http://www.w3.org/2000/svg",fill:"none",viewBox:"0 0 362 109",height:"109",width:"362",children:[jsxRuntimeExports.jsxs("g",{"clip-path":"url(#clip0_333_232)",children:[jsxRuntimeExports.jsx("path",{fill:"#C5834D",d:"M312.559 25.6724C313.893 25.3738 315.27 25.4641 316.618 25.2211C319.936 24.631 323.276 24.2561 326.664 24.3117C338.973 24.513 348.391 29.8655 354.923 40.1191C358.933 46.4227 361.05 53.4205 361.685 60.8486C361.769 61.8692 361.804 62.8897 361.86 63.9171C361.965 64.3336 361.888 64.7502 361.909 65.1737C362.112 72.1714 360.239 78.6971 357.34 84.9868C356.069 87.7359 354.65 90.3948 352.771 92.7968C349.341 97.1843 344.828 100.017 339.63 101.863C337.262 102.703 334.831 103.349 332.323 103.599C329.43 103.89 326.741 104.911 323.988 105.709C320.726 106.654 317.407 107.16 313.998 107.063C313.216 107.042 312.447 106.89 311.665 106.841C311.085 106.799 310.547 106.896 310.072 107.223C308.591 108.222 306.97 108.819 305.196 109.007H304.693C304.078 108.868 303.463 108.868 302.848 109.007H302.178C300.578 108.479 298.971 107.979 297.469 107.195C297.252 107.084 296.917 107.139 296.652 107.181C293.787 107.674 291 107.369 288.415 106.091C285.474 104.633 282.372 103.71 279.207 102.891C268.162 100.017 260.757 93.1092 256.6 82.6473C253.959 76.0035 252.534 69.1168 252.96 61.9594C253.589 51.3656 257.11 41.82 264.278 33.8295C269.524 27.9772 276.308 24.9156 284.104 23.9993C287.542 23.5966 290.951 23.9437 294.353 24.4089C295.261 24.5338 296.183 24.6518 297.099 24.638C298.866 24.6171 300.592 24.8532 302.317 25.1586C302.534 24.999 302.785 24.9712 303.037 25.0406C304.218 25.3738 305.468 25.3947 306.649 25.714C308.255 26.1444 309.841 26.0403 311.434 25.6654C311.804 25.5752 312.189 25.4155 312.566 25.6654L312.559 25.6724Z"}),jsxRuntimeExports.jsx("path",{fill:"#C5834D",d:"M49.3083 109C47.7085 108.472 46.0947 107.98 44.5927 107.195C44.3761 107.084 44.0408 107.133 43.7753 107.181C40.9389 107.667 38.1724 107.396 35.6155 106.126C32.5695 104.613 29.3489 103.703 26.0864 102.835C15.4256 99.996 8.13208 93.3383 3.96835 83.2721C1.11103 76.3646 -0.40496 69.1724 0.0910544 61.7026C0.803639 50.9352 4.44341 41.2785 11.9116 33.2741C16.4805 28.3799 22.265 25.603 28.825 24.3326C33.0516 23.5134 37.2642 23.798 41.4769 24.402C42.2453 24.5131 43.0278 24.5755 43.8102 24.5964C45.7035 24.645 47.5897 24.7769 49.448 25.1517C49.7554 24.9296 50.0768 25.0198 50.4051 25.0893C51.9491 25.4155 53.5209 25.6377 55.0649 25.9431C56.2455 26.1792 57.3773 25.8737 58.523 25.6655C58.8723 25.603 59.2216 25.4433 59.5779 25.6377C65.2995 25.0476 70.9862 23.923 76.7707 24.3048C79.4744 24.4853 82.0872 25.2212 84.6441 26.1098C94.7391 29.6225 101.278 36.7175 105.253 46.3603C107.852 52.6638 109.186 59.2103 108.956 66.0345C108.718 72.9698 106.888 79.5094 103.856 85.7366C102.249 89.0411 100.419 92.1998 97.785 94.8309C93.7121 98.906 88.724 101.287 83.184 102.662C81.179 103.162 79.1181 103.349 77.0921 103.717C74.7518 104.14 72.5721 105.112 70.2737 105.689C66.4313 106.647 62.561 107.167 58.5998 106.542C58.2505 106.487 57.8942 106.556 57.6288 106.723C55.98 107.778 54.1916 108.472 52.3123 108.986H51.8093C51.1387 108.847 50.468 108.847 49.7973 108.986H49.2943L49.3083 109Z"}),jsxRuntimeExports.jsx("path",{fill:"#C5834D",d:"M175.659 109C174.974 108.549 174.101 108.632 173.409 108.229C171.81 107.299 170.147 107.091 168.303 107.32C166.102 107.598 163.943 107.063 161.98 106.084C159.088 104.647 156.042 103.738 152.926 102.939C141.364 99.9681 133.84 92.6371 129.76 81.6406C127.553 75.6911 126.26 69.5542 126.477 63.1951C126.847 52.0598 130.452 42.0699 137.955 33.6906C142.531 28.5742 148.462 25.6654 155.204 24.3533C159.486 23.5203 163.755 23.8049 168.023 24.4297C168.764 24.5408 169.518 24.5894 170.273 24.6102C172.138 24.6796 174.003 24.7421 175.827 25.1795C176.064 24.9781 176.344 24.992 176.623 25.0614C177.978 25.3947 179.383 25.471 180.731 25.8181C182.086 26.1653 183.435 26.0472 184.783 25.714C185.202 25.6099 185.635 25.3877 186.075 25.6654C187.445 25.3947 188.842 25.4641 190.225 25.2211C193.516 24.638 196.827 24.2631 200.18 24.3186C212.741 24.513 222.263 30.0321 228.767 40.5843C232.833 47.1863 234.915 54.4757 235.348 62.2163C235.81 70.4567 233.937 78.1973 230.381 85.5908C228.593 89.3118 226.497 92.8176 223.402 95.6501C219.294 99.4197 214.411 101.773 208.983 102.78C204.533 103.599 200.187 104.71 195.835 105.897C192.307 106.855 188.702 107.133 185.055 106.577C184.671 106.522 184.301 106.591 184.007 106.778C182.352 107.82 180.57 108.549 178.677 109.007H178.342C177.615 108.868 176.889 108.868 176.162 109.007H175.659V109Z"}),jsxRuntimeExports.jsx("path",{fill:"#D4A47C",d:"M176.162 109C176.889 108.729 177.615 108.729 178.342 109H176.162Z"}),jsxRuntimeExports.jsx("path",{fill:"#D5A67F",d:"M49.8115 109C50.4822 108.736 51.1529 108.736 51.8235 109H49.8115Z"}),jsxRuntimeExports.jsx("path",{fill:"#D5A67F",d:"M302.842 109C303.457 108.736 304.071 108.736 304.686 109H302.842Z"}),jsxRuntimeExports.jsx("path",{fill:"#F0E0D2",d:"M362.001 65.257C361.952 65.257 361.903 65.2639 361.854 65.2639C361.854 64.8127 361.853 64.3684 361.86 63.9171C361.91 63.9171 361.952 63.9171 362.001 63.9241V65.257Z"}),jsxRuntimeExports.jsx("path",{fill:"#B49687",d:"M59.5781 25.6446C57.3495 26.3805 55.121 26.4152 52.8505 25.7835C51.7467 25.478 50.587 25.36 49.4482 25.1587C49.5111 24.0757 50.1329 23.1871 50.4892 22.2082C51.6209 19.1259 52.4313 16.0019 52.5501 12.6904C52.613 10.8299 52.0471 9.2193 51.2786 7.60871C50.7826 6.56043 50.3145 5.49132 49.9023 4.40834C49.3993 3.06849 49.6229 1.79111 50.4263 0.617877C50.9642 -0.166595 51.3066 -0.173538 51.8375 0.617877C53.4932 3.04766 55.1419 5.4705 56.609 8.02524C58.1669 10.7327 58.9144 13.5513 58.8306 16.6475C58.7538 19.6674 59.3266 22.6525 59.5781 25.6516V25.6446Z"}),jsxRuntimeExports.jsx("path",{fill:"#B49687",d:"M312.559 25.6724C311.42 25.8807 310.289 26.1445 309.143 26.2764C307.976 26.4083 306.865 25.957 305.727 25.7696C304.588 25.5891 303.449 25.3669 302.311 25.1656C302.401 24.0618 303.002 23.1315 303.386 22.1319C304.7 18.6885 305.524 15.1619 305.391 11.4547C305.363 10.6078 305.154 9.82328 304.805 9.05964C304.155 7.65036 303.512 6.24109 302.911 4.81099C302.276 3.29758 302.373 1.83971 303.393 0.499862C303.896 -0.15965 304.176 -0.173535 304.651 0.527631C306.335 2.99907 308.123 5.40802 309.478 8.08772C310.296 9.69138 311.232 11.2326 311.476 13.0653C311.658 14.4399 311.679 15.8214 311.707 17.2029C311.777 20.0492 312.098 22.8677 312.559 25.6793V25.6724Z"}),jsxRuntimeExports.jsx("path",{fill:"#B49687",d:"M186.069 25.6585C185.217 25.7696 184.406 26.0542 183.561 26.193C182.094 26.4429 180.724 26.0056 179.327 25.7557C178.161 25.5474 176.994 25.36 175.827 25.1656C175.904 24.3464 176.372 23.6661 176.652 22.9163C177.406 20.8892 178.216 18.869 178.559 16.7377C178.887 14.6759 179.292 12.5724 178.838 10.4758C178.475 8.81662 177.546 7.36569 176.889 5.81063C176.421 4.70682 175.96 3.61689 176.155 2.37423C176.26 1.70083 176.491 1.08991 176.917 0.555361C177.497 -0.173573 177.727 -0.180516 178.272 0.603957C179.928 2.99903 181.556 5.40798 183.009 7.9419C184.56 10.6424 185.314 13.4471 185.251 16.5711C185.189 19.6118 185.692 22.6317 186.076 25.6515L186.069 25.6585Z"}),jsxRuntimeExports.jsx("path",{fill:"#EBC185",d:"M291.79 69.2418C291.79 64.8821 291.706 61.8553 291.811 58.8424C291.992 53.358 292.055 47.8597 293.613 42.5142C294.989 37.8213 297.26 33.6698 300.927 30.3514C302.22 29.1851 303.673 28.234 305.503 28.1785C307.823 28.1091 309.443 29.4351 310.806 31.0665C313.139 33.8642 314.704 37.0437 315.319 40.6468C315.507 41.7575 315.661 42.8822 315.724 44.0068C315.836 45.8534 315.836 47.707 315.927 49.5606C316.108 53.1775 316.143 56.8013 316.297 60.4182C316.395 62.7439 316.451 65.0626 316.388 67.3882C316.283 71.0885 316.101 74.7817 315.885 78.4819C315.724 81.2866 315.549 84.1051 315.214 86.8959C314.704 91.1376 313.635 95.2474 311.965 99.1976C311.253 100.878 310.617 102.592 309.36 103.995C308.046 105.459 306.405 106.181 304.469 106.355C300.208 106.737 297.637 104.494 295.848 100.961C294.249 97.8091 293.368 94.4768 292.935 90.9918C292.411 86.7987 292.104 82.5987 291.901 78.3778C291.734 74.8859 291.873 71.4009 291.797 69.2557L291.79 69.2418Z"}),jsxRuntimeExports.jsx("path",{fill:"#EBC185",d:"M342.23 66.451C342.258 73.5113 341.755 79.8495 340.036 86.049C338.981 89.8602 337.451 93.4772 335.02 96.6428C333.462 98.6769 331.31 99.9681 328.991 100.982C325.798 102.384 322.487 103.432 319.022 103.925C317.212 104.182 315.389 104.37 313.552 104.224C312.944 104.175 312.979 103.946 313.132 103.509C313.88 101.336 314.613 99.1628 315.333 96.983C316.646 92.9842 317.645 88.923 318.107 84.7299C318.351 82.5362 318.505 80.3355 318.624 78.1279C318.903 72.8934 318.777 67.659 318.7 62.4315C318.658 59.724 318.693 57.0096 318.568 54.3021C318.407 50.713 318.372 47.1169 318.218 43.5278C317.981 38.1406 316.074 33.3435 312.525 29.2407C312.001 28.6367 312.196 28.4978 312.853 28.3243C315.962 27.5259 319.036 27.755 322.082 28.5881C325.03 29.3934 327.796 30.6083 330.283 32.3994C333.804 34.9402 336.291 38.2864 338.024 42.2088C339.966 46.624 341.035 51.2753 341.671 56.0169C341.887 57.5997 341.999 59.1964 342.076 60.8001C342.167 62.9036 342.244 65.0001 342.23 66.4441V66.451Z"}),jsxRuntimeExports.jsx("path",{fill:"#EBC185",d:"M297.267 27.3315C297.825 27.3315 298.384 27.3246 298.943 27.3315C299.153 27.3315 299.446 27.2344 299.565 27.4426C299.698 27.6925 299.453 27.8939 299.306 28.0883C298.133 29.5947 296.945 31.0942 295.771 32.6076C292.649 36.648 290.825 41.216 290.099 46.2422C289.728 48.79 289.68 51.3586 289.568 53.9203C289.449 56.5792 289.554 59.2381 289.414 61.89C289.149 66.9023 289.302 71.9146 289.309 76.9269C289.309 79.8565 289.442 82.7861 289.638 85.7088C290.029 91.6027 291.265 97.2954 293.934 102.62C294.186 103.113 294.367 103.641 294.619 104.133C294.905 104.689 294.765 104.904 294.144 104.821C292.516 104.612 290.909 104.349 289.379 103.689C285.97 102.217 282.826 100.35 280.283 97.6217C277.377 94.5115 275.589 90.8044 274.492 86.7224C273.486 82.9805 272.85 79.19 272.48 75.3302C272.04 70.7136 272.033 66.09 272.228 61.4804C272.522 54.434 273.933 47.5543 276.581 40.9939C278.502 36.2315 281.869 32.6424 286.403 30.1709C289.784 28.3312 293.382 27.2968 297.267 27.3246V27.3315Z"}),jsxRuntimeExports.jsx("path",{fill:"#EBC185",d:"M325.91 27.0608C329.012 26.8318 331.834 27.0608 334.601 27.887C339.924 29.4837 344.668 32.087 348.559 36.0649C352.003 39.5916 354.434 43.7569 356.181 48.3388C357.543 51.8932 358.479 55.5587 358.934 59.3214C359.311 62.4246 359.29 65.5555 359.017 68.6795C358.466 75.0039 356.398 80.8493 353.505 86.4655C350.823 91.6722 346.931 95.6223 341.566 98.0868C339.673 98.9616 337.696 99.6141 335.607 100.142C335.572 99.7321 335.802 99.51 336.026 99.274C339.1 96.0319 340.972 92.1443 342.209 87.9304C343.417 83.8136 344.039 79.5858 344.43 75.3233C344.626 73.1989 344.619 71.0677 344.794 68.9572C344.989 66.5691 344.794 64.2018 344.696 61.8345C344.409 54.8784 343.32 48.0542 340.518 41.5909C339.149 38.4392 337.43 35.5095 334.978 33.0659C333.001 31.0943 330.738 29.4906 328.244 28.2133C327.538 27.8523 326.818 27.5051 325.917 27.0608H325.91Z"}),jsxRuntimeExports.jsx("path",{fill:"#EBC185",d:"M287.479 26.4707C286.005 27.4496 284.566 28.4771 283.057 29.3934C278.502 32.1634 275.665 36.2385 273.821 41.1189C272.221 45.3467 271.047 49.6856 270.377 54.1494C269.986 56.7389 269.706 59.3422 269.643 61.9733C269.601 63.6325 269.427 65.2848 269.51 66.944C269.692 70.304 269.783 73.6641 270.125 77.0241C270.537 81.1061 271.25 85.1118 272.528 89.0064C273.807 92.9079 275.651 96.5109 278.578 99.4892C278.732 99.6419 278.963 99.8224 278.809 100.051C278.669 100.26 278.446 100.065 278.278 100.01C274.121 98.7811 270.482 96.6845 267.268 93.7826C264.173 90.9849 261.756 87.7082 259.932 84.001C258.06 80.2036 256.935 76.1633 256.237 71.9979C255.713 68.8531 255.468 65.6944 255.587 62.5079C255.783 57.1901 256.859 52.0598 258.919 47.1308C260.324 43.7639 262.049 40.5913 264.306 37.7102C268.574 32.2675 274.107 28.7825 280.849 27.165C283.015 26.6443 285.222 26.5471 287.472 26.4638L287.479 26.4707Z"}),jsxRuntimeExports.jsx("path",{fill:"#EBC185",d:"M38.8915 74.4485C39.0382 72.352 38.619 70.1166 38.7727 67.8812C38.9963 64.5906 38.7797 61.293 38.9544 58.0024C39.1081 55.1075 39.0592 52.2056 39.4154 49.3177C40.142 43.507 41.644 37.981 45.3397 33.2603C46.4714 31.8163 47.708 30.4625 49.2519 29.4282C52.0394 27.5607 54.6522 27.7412 57.0205 30.1154C59.8568 32.9617 61.5964 36.412 62.3788 40.3413C62.7421 42.1602 62.826 44.0068 62.9098 45.8535C63.0565 49.0538 63.1543 52.2612 63.2591 55.4685C63.3779 59.1687 63.6363 62.8758 63.5385 66.576C63.4337 70.4984 63.2451 74.4138 63.0285 78.3362C62.8679 81.1756 62.6932 84.0149 62.3509 86.8335C61.8269 91.1515 60.7581 95.3516 59.0255 99.3642C58.257 101.141 57.5864 102.953 56.1263 104.356C54.9456 105.487 53.5624 106.14 51.9835 106.32C48.4345 106.716 45.661 105.446 43.7888 102.363C41.679 98.8921 40.5751 95.1086 40.0721 91.1099C39.5552 87.0001 39.1989 82.8833 39.0382 78.7388C38.9823 77.3573 38.9683 75.9758 38.8915 74.4485Z"}),jsxRuntimeExports.jsx("path",{fill:"#EBC185",d:"M89.3595 67.1661C89.3735 73.5391 88.8914 79.8565 87.1658 86.0212C86.083 89.9089 84.546 93.6091 82.0031 96.8094C80.4801 98.7255 78.4402 99.9682 76.2256 100.94C73.3403 102.211 70.3642 103.203 67.2484 103.738C65.0897 104.113 62.917 104.356 60.7094 104.224C59.9689 104.182 60.1016 103.863 60.2553 103.384C61.2962 100.288 62.428 97.226 63.3292 94.0881C64.2234 90.978 64.8382 87.8193 65.2364 84.605C66.1376 77.4129 65.9001 70.186 65.8232 62.973C65.7953 60.2933 65.8093 57.6067 65.6975 54.927C65.5368 51.2545 65.4739 47.5751 65.3482 43.9027C65.2364 40.6537 64.5657 37.495 63.1336 34.5376C62.1974 32.6077 61.0098 30.8374 59.6196 29.206C59.1375 28.6437 59.3052 28.4909 59.9339 28.3313C63.3012 27.4704 66.5987 27.8175 69.8822 28.7894C74.0319 30.0182 77.6647 32.0801 80.6268 35.2388C82.9951 37.7658 84.6369 40.7301 85.8525 43.9443C87.3545 47.9222 88.2906 52.032 88.8146 56.2321C89.0311 57.9815 89.1499 59.7449 89.2198 61.5151C89.2966 63.3965 89.3455 65.2709 89.3525 67.1522L89.3595 67.1661Z"}),jsxRuntimeExports.jsx("path",{fill:"#EBC185",d:"M19.2952 66.6801C19.3092 64.2712 19.2603 61.8622 19.4769 59.4602C20.0986 52.6291 21.3771 45.9229 24.3532 39.6957C27.3013 33.524 32.4361 29.8377 38.9961 28.0119C41.2736 27.3801 43.5999 27.2413 45.9473 27.3385C46.2058 27.3524 46.576 27.1927 46.7018 27.4912C46.8136 27.755 46.5201 27.9772 46.3455 28.1924C44.6898 30.3098 42.9852 32.3855 41.4901 34.6278C39.1568 38.1337 37.8853 42.0144 37.2356 46.1242C36.8304 48.6997 36.8094 51.2892 36.6907 53.8856C36.5719 56.3223 36.6767 58.759 36.544 61.1888C36.2505 66.6454 36.4392 72.102 36.4322 77.5517C36.4322 80.3424 36.544 83.1332 36.7675 85.9171C37.1238 90.4365 37.8015 94.9142 39.555 99.149C40.2326 100.787 40.9732 102.398 41.6718 104.022C41.7696 104.245 41.9652 104.508 41.8255 104.724C41.6788 104.946 41.3644 104.835 41.1199 104.807C35.9152 104.196 31.6467 101.683 27.958 98.1701C24.7234 95.0878 22.8162 91.2001 21.6426 86.9306C20.5946 83.1124 19.9379 79.2386 19.5886 75.2954C19.3302 72.4214 19.2882 69.5542 19.2812 66.6801H19.2952Z"}),jsxRuntimeExports.jsx("path",{fill:"#EBC185",d:"M82.4645 100.114C83.254 99.1837 83.8967 98.4686 84.4835 97.7119C87.2011 94.2061 88.8359 90.2074 89.8559 85.9379C90.7012 82.3904 91.2042 78.7943 91.5675 75.1635C92.0146 70.7413 91.9727 66.3122 91.819 61.89C91.6303 56.3362 90.8828 50.838 89.1084 45.5271C87.8718 41.8131 86.3418 38.217 83.8618 35.1138C81.5424 32.2119 78.699 29.9279 75.3876 28.2271C74.675 27.8592 73.9554 27.5121 73.2568 27.0886C75.4435 26.9428 77.6162 26.9011 79.7679 27.401C85.2101 28.6714 90.0794 31.0318 94.2711 34.7528C97.8969 37.9671 100.482 41.8894 102.445 46.2491C103.982 49.6717 105.037 53.2469 105.693 56.9332C106.378 60.7654 106.462 64.6183 106.154 68.4921C105.812 72.824 104.75 76.9893 103.13 81.0089C101.264 85.6255 99.1125 90.0963 95.3959 93.5882C91.9168 96.858 87.7461 98.8782 83.1212 100.024C82.9955 100.051 82.8628 100.058 82.4715 100.114H82.4645Z"}),jsxRuntimeExports.jsx("path",{fill:"#EBC185",d:"M34.6021 26.4777C33.2677 27.3663 31.9613 28.3104 30.585 29.1296C25.8764 31.9273 22.8793 36.0371 20.9721 41.0703C19.2326 45.666 18.017 50.3867 17.3463 55.2463C17.025 57.565 16.8573 59.9045 16.7595 62.258C16.6896 63.9449 16.5988 65.6319 16.6617 67.3119C16.9062 74.268 17.2834 81.2102 19.3234 87.9373C20.6158 92.1929 22.4602 96.1569 25.6249 99.3989C25.7925 99.5725 26.093 99.746 25.9602 100.01C25.7925 100.329 25.5061 100.045 25.3035 99.9821C21.3773 98.8088 17.8982 96.8511 14.8104 94.1575C9.06078 89.1452 5.80525 82.7445 4.05871 75.4621C2.95491 70.8594 2.44492 66.1942 2.75231 61.4874C3.33914 52.5874 6.11962 44.4164 11.7155 37.37C16.3543 31.5316 22.4811 28.0397 29.9004 26.8317C30.6689 26.7068 31.4373 26.6026 32.2128 26.5193C32.9813 26.436 33.7637 26.3874 34.5322 26.325L34.5951 26.4777H34.6021Z"}),jsxRuntimeExports.jsx("path",{fill:"#EBC185",d:"M165.278 68.4434C165.278 66.2289 165.18 64.0074 165.299 61.7928C165.481 58.5369 165.362 55.2671 165.613 52.0112C166.012 46.749 166.899 41.5909 169.449 36.8632C171.07 33.8642 173.082 31.1637 175.981 29.2407C178.475 27.5815 181.06 27.8383 183.211 29.9071C186.677 33.2463 188.521 37.3492 189.08 42.063C189.303 43.9304 189.345 45.8048 189.429 47.6862C189.583 51.1087 189.66 54.5382 189.785 57.9607C189.883 60.5848 190.044 63.209 190.023 65.8262C190.002 69.3321 189.771 72.8379 189.555 76.3368C189.185 82.2238 189.066 88.1455 187.382 93.8729C186.474 96.9552 185.44 99.9959 183.805 102.787C182.45 105.105 180.347 106.181 177.671 106.341C173.64 106.584 171.244 104.376 169.519 101.114C167.975 98.1979 167.067 95.0808 166.605 91.8249C166.075 88.0275 165.767 84.2093 165.565 80.3702C165.348 76.3923 165.243 72.4144 165.278 68.4296V68.4434Z"}),jsxRuntimeExports.jsx("path",{fill:"#EBC185",d:"M191.077 27.8244C196.121 28.1646 201.193 30.0182 205.518 33.7601C209.618 37.3145 211.826 41.9727 213.342 47.0267C214.313 50.2617 214.97 53.5593 215.34 56.9055C215.578 59.0437 215.745 61.1958 215.724 63.3548C215.71 64.5419 215.871 65.7499 215.815 66.9092C215.703 69.1724 215.766 71.4356 215.592 73.6987C215.396 76.2049 215.123 78.6902 214.711 81.1686C213.873 86.1809 212.308 90.9502 209.597 95.2821C207.753 98.2395 204.945 100.051 201.745 101.343C198.741 102.551 195.66 103.495 192.454 103.946C190.889 104.168 189.296 104.265 187.717 104.307C186.515 104.342 186.473 104.203 186.837 103.085C188.08 99.2739 189.505 95.5182 190.448 91.6166C191.196 88.5273 191.643 85.3964 191.937 82.2307C192.195 79.4469 192.265 76.6561 192.258 73.8653C192.244 68.5268 192.321 63.1882 192.195 57.8565C192.146 55.6975 192.146 53.5454 192.069 51.3864C191.964 48.4568 191.95 45.5271 191.72 42.6045C191.329 37.7032 189.547 33.3296 186.355 29.5392C186.264 29.435 186.18 29.324 186.089 29.2198C185.67 28.7339 185.691 28.4631 186.404 28.3104C187.745 28.0327 189.079 27.8244 191.084 27.8175L191.077 27.8244Z"}),jsxRuntimeExports.jsx("path",{fill:"#EBC185",d:"M168.331 104.807C165.963 104.807 163.839 104.147 161.778 103.189C156.413 100.697 152.277 96.9552 149.783 91.5542C148.288 88.3121 147.457 84.8827 146.842 81.3907C146.22 77.9057 145.927 74.3999 145.78 70.8594C145.675 68.3671 145.612 65.8748 145.696 63.3895C145.955 55.6698 147.261 48.1305 150.188 40.9314C152.025 36.4189 155.169 32.9825 159.382 30.5111C163.504 28.0952 167.968 27.0469 172.746 27.3316C172.907 27.3385 173.117 27.276 173.207 27.4357C173.333 27.6648 173.089 27.7759 172.984 27.9147C170.951 30.5805 168.743 33.1144 167.074 36.0441C165.362 39.0431 164.335 42.2574 163.769 45.6382C163.175 49.1926 163.196 52.7887 163.071 56.3779C162.798 64.41 162.875 72.4422 162.98 80.4743C163.043 85.5214 163.392 90.5684 164.761 95.4765C165.551 98.3159 166.738 100.996 167.954 103.668C168.115 104.015 168.338 104.349 168.338 104.8L168.331 104.807Z"}),jsxRuntimeExports.jsx("path",{fill:"#EBC185",d:"M209.108 100.093C209.542 99.1559 210.254 98.5658 210.806 97.8647C213.384 94.6088 214.977 90.8947 216.039 86.9306C216.989 83.3762 217.513 79.7524 217.911 76.1077C218.358 72.0048 218.505 67.8881 218.351 63.7713C218.107 57.2179 217.436 50.7199 215.186 44.4928C213.845 40.7787 212.203 37.2104 209.57 34.1974C207.579 31.9204 205.217 30.0807 202.542 28.6436C201.57 28.123 200.578 27.6509 199.475 27.0886C203.324 26.7068 206.88 27.3038 210.324 28.602C215.117 30.407 219.357 33.0381 222.815 36.8285C225.826 40.1261 228.006 43.9304 229.627 48.068C231.164 52.0043 232.17 56.0724 232.596 60.2586C232.91 63.2854 232.833 66.3122 232.512 69.3529C231.876 75.2955 229.948 80.8076 227.251 86.1045C225.232 90.0685 222.564 93.498 218.819 96.0041C215.997 97.8924 212.916 99.2114 209.611 100.031C209.486 100.058 209.353 100.065 209.108 100.1V100.093Z"}),jsxRuntimeExports.jsx("path",{fill:"#EBC185",d:"M152.451 100.169C148.923 99.26 145.779 97.698 142.943 95.5459C138.779 92.3733 135.586 88.4093 133.344 83.6955C131.52 79.8704 130.431 75.8231 129.746 71.6647C129.306 69.0197 129.054 66.34 129.11 63.6741C129.229 57.4817 130.466 51.5183 133.05 45.8465C134.518 42.6253 136.271 39.5915 138.542 36.8702C140.798 34.1627 143.481 31.9343 146.569 30.2056C149.733 28.4354 153.108 27.276 156.691 26.7276C158.089 26.5193 159.507 26.4568 160.981 26.318C160.862 26.7484 160.506 26.8248 160.261 26.9914C158.04 28.5187 155.706 29.8724 153.639 31.6149C151.291 33.5935 149.635 36.0649 148.385 38.8071C146.541 42.8475 145.255 47.0753 144.424 51.435C143.851 54.441 143.474 57.4747 143.285 60.5363C143.18 62.2788 143.166 64.0143 143.152 65.7568C143.11 70.2623 143.404 74.747 143.97 79.2248C144.494 83.4109 145.437 87.4791 146.995 91.4084C148.203 94.456 149.964 97.1565 152.185 99.5655C152.311 99.7043 152.486 99.8224 152.458 100.163L152.451 100.169Z"})]}),jsxRuntimeExports.jsx("defs",{children:jsxRuntimeExports.jsx("clipPath",{id:"clip0_333_232",children:jsxRuntimeExports.jsx("rect",{fill:"white",height:"109",width:"362"})})})]});const GarlandIcon=()=>jsxRuntimeExports.jsxs("svg",{xmlns:"http://www.w3.org/2000/svg",fill:"none",viewBox:"0 0 306 110",height:"110",width:"306",children:[jsxRuntimeExports.jsx("path",{fill:"#BA2031",d:"M226.927 105.054C225.752 101.857 223.704 99.3831 221.022 97.3621C219.757 96.3969 218.763 95.0696 217.528 94.0742C215.901 92.7772 214.154 91.6008 212.377 90.5149C210.9 89.5798 209.334 88.7654 207.737 88.0113C204.996 86.7444 202.014 86.5635 199.031 86.5031C196.049 86.4428 193.066 86.1713 190.084 85.93C188.668 85.8094 187.252 85.6887 185.897 85.3267C184.18 84.8743 182.523 84.2107 180.866 83.6376C180.685 83.5772 180.534 83.3661 180.384 83.2454C180.565 83.2454 180.776 83.2756 180.956 83.2756C181.619 83.2454 182.282 83.2756 182.914 83.1549C184.571 82.8533 186.198 82.431 187.855 82.1294C188.879 81.9484 189.903 81.8579 190.928 81.7071C191.47 81.4959 192.133 81.4356 192.584 81.1038C193.85 80.1687 195.025 79.1432 196.26 78.1478C197.465 77.1524 198.7 76.1871 199.935 75.1917C201.11 73.1104 202.285 71.0291 203.46 68.9478C203.731 68.4652 204.002 67.9826 204.273 67.4999C205.267 65.0265 206.864 62.9754 208.581 61.0147C210.177 59.2049 211.654 57.3347 211.925 54.801C211.684 52.1164 211.021 49.5826 209.816 47.079C208.581 44.5453 206.683 42.6148 204.725 40.7748C202.857 39.0253 200.748 37.4568 198.609 36.0391C197.676 35.4358 196.38 35.285 195.235 35.1643C193.428 34.9532 191.59 34.8325 189.783 34.8627C186.469 34.9532 183.366 36.0089 180.444 37.5473C179.36 38.1204 178.155 38.4522 177.13 39.1158C174.841 40.5637 172.551 42.0719 170.352 43.6705C168.243 45.1787 166.135 46.6869 164.237 48.4364C162.068 50.4272 160.14 52.6895 158.152 54.8613C157.73 55.3138 157.399 55.917 157.158 56.4902C156.435 58.2698 154.928 57.6364 153.633 57.6665C153.362 57.6665 153.121 57.6062 152.85 57.576V73.0802C154.356 73.1104 154.356 74.4979 154.717 75.4029C155.802 78.1176 157.338 80.5307 159.085 82.8835C160.742 85.0854 162.731 86.8349 165.08 88.2526C166.918 89.3687 168.665 90.6054 170.473 91.7215C173.154 93.3805 176.106 94.3457 179.179 94.8887C181.408 95.2808 183.698 95.2808 185.987 95.4015C189.451 95.5824 192.916 95.5523 196.38 95.9142C198.67 96.1555 200.989 96.6985 203.008 98.0559C204.243 98.8703 205.779 99.3227 206.834 100.288C208.28 101.615 209.485 103.274 210.69 104.873C211.623 106.11 212.377 107.437 213.22 108.734C213.762 109.578 215.329 109.88 216.172 109.216C217.377 108.251 218.763 107.95 220.269 107.98C221.836 108.01 223.402 108.1 224.969 108.131C226.686 108.131 227.62 106.743 227.017 105.114L226.927 105.054ZM178.185 70.3957C178.185 70.3957 178.124 70.3957 178.094 70.3957C178.034 70.3957 178.004 70.3957 177.974 70.3957C177.914 70.3957 177.883 70.3957 177.823 70.3957C177.371 70.3957 176.889 70.3957 176.438 70.3353C176.016 70.3052 175.654 70.1845 175.383 69.9734C175.323 69.9432 175.263 69.9131 175.202 69.8829C175.022 69.8226 174.841 69.7321 174.69 69.6416C173.365 69.0986 171.979 69.0986 170.623 68.7668C169.84 68.5255 169.057 68.2842 168.274 68.0429C168.063 67.9826 167.852 67.9222 167.671 67.8619C167.671 67.8619 167.611 67.8619 167.581 67.8619C167.581 67.8619 167.551 67.8619 167.521 67.8619C167.249 67.7714 167.008 67.6809 166.737 67.5904C166.647 67.5603 166.557 67.5301 166.466 67.4999C166.376 67.4698 166.315 67.4396 166.225 67.3793C166.135 67.3491 166.075 67.319 165.984 67.2586C165.954 67.2586 165.894 67.1983 165.864 67.1681C165.02 66.6554 164.237 66.0219 163.424 65.4186C162.761 64.7249 163.634 64.5439 163.875 64.3327C165.472 62.8849 167.099 61.5275 168.756 60.14C169.298 59.6875 169.9 59.3256 170.503 58.9334C170.533 58.9334 170.563 58.9334 170.623 58.9033C170.834 58.7223 171.015 58.5413 171.226 58.3603C171.407 58.2095 171.617 58.0587 171.798 57.9079C171.828 57.9079 171.859 57.8475 171.919 57.8475C172.13 57.6665 172.371 57.4856 172.582 57.3347C173.214 56.8521 173.877 56.4298 174.509 55.9472C174.871 55.6456 175.263 55.3741 175.654 55.1026C175.925 54.9216 176.227 54.801 176.528 54.6803C176.528 54.6803 176.528 54.6803 176.558 54.6502C176.799 54.4088 177.07 54.2279 177.341 54.0167C177.612 53.8056 177.914 53.6246 178.215 53.4436C178.486 53.2626 178.787 53.0816 179.058 52.9007C179.299 52.78 179.54 52.6593 179.781 52.5689C179.962 52.4482 180.173 52.3276 180.384 52.2672C180.384 52.2672 180.444 52.2672 180.474 52.2672C180.595 52.2069 180.715 52.1466 180.806 52.0862C181.077 51.8449 181.378 51.6639 181.77 51.6036C181.77 51.6036 181.8 51.6036 181.83 51.6036C181.92 51.5735 181.98 51.5433 182.071 51.5131C182.372 51.3925 182.643 51.2718 182.945 51.1512C183.276 51.0305 183.577 50.8797 183.908 50.7892C184.33 50.6384 184.752 50.5177 185.174 50.3971C185.385 50.3367 185.596 50.2764 185.776 50.2161C185.837 50.2161 186.108 50.0954 186.168 50.0653C186.228 50.0653 186.288 50.0049 186.379 49.9748C186.559 49.8843 186.74 49.7938 186.951 49.7335C187.523 49.4922 188.096 49.2207 188.698 49.0095C189.361 48.7682 190.054 48.6174 190.747 48.6174C190.747 48.6174 190.747 48.6174 190.777 48.6174C191.078 48.4666 191.41 48.3761 191.831 48.3761C191.831 48.3761 191.831 48.3761 191.861 48.3761C192.374 48.2554 192.856 48.1348 193.368 48.0443C193.548 47.984 193.759 47.9236 194 47.9236C194.121 47.9236 194.241 47.8633 194.362 47.8633C194.543 47.8633 194.693 47.803 194.874 47.7728C195.115 47.7125 195.356 47.6522 195.627 47.6522C195.748 47.6522 195.868 47.6522 195.989 47.6823C196.471 47.6823 196.922 47.6823 197.404 47.6823C198.248 47.7728 199.092 47.7427 199.905 47.8331C200.056 47.8331 200.206 47.8331 200.357 47.8331C200.688 47.8331 201.019 47.9236 201.291 48.0443C201.381 48.0443 201.471 48.0745 201.562 48.1046C201.773 48.1649 201.953 48.1951 202.164 48.2554C202.556 48.2554 202.887 48.3761 203.158 48.5269C203.188 48.5269 203.219 48.5269 203.249 48.5269C203.851 48.8285 204.514 49.0699 205.026 49.4921C205.719 50.0653 206.623 50.6384 206.201 51.7544C205.297 54.1374 203.61 55.9472 201.863 57.6967C201.773 57.8777 201.652 58.0285 201.501 58.1492C201.381 58.2396 201.291 58.3603 201.17 58.481C201.11 58.5715 201.019 58.6619 200.959 58.7524C200.778 59.0239 200.598 59.2652 200.417 59.5367C200.025 60.0797 199.573 60.6226 199.091 61.1052C198.881 61.3164 198.64 61.5577 198.399 61.7387C198.248 61.8895 198.097 62.0705 197.977 62.2213C197.886 62.3419 197.826 62.4626 197.706 62.5832C197.676 62.6134 197.615 62.6737 197.555 62.7039C197.495 62.7944 197.404 62.8849 197.314 62.9754C196.983 63.3373 196.651 63.6691 196.32 63.9708C196.29 64.0009 196.23 64.0311 196.199 64.0914C196.199 64.0914 196.169 64.1216 196.139 64.1518C196.079 64.2121 196.019 64.2724 195.928 64.3327C195.657 64.5741 195.386 64.8455 195.085 65.0868C194.271 65.7203 193.398 66.2632 192.464 66.7458C192.464 66.7458 192.434 66.7458 192.404 66.776C191.56 67.2285 190.687 67.6206 189.783 67.9826C189.692 68.0127 189.602 68.0731 189.512 68.1032C189.18 68.254 188.849 68.3747 188.518 68.4953C188.397 68.5557 188.277 68.5858 188.156 68.6462C188.005 68.7065 187.885 68.7668 187.734 68.797C187.644 68.8573 187.554 68.8875 187.433 68.9176C187.282 68.978 187.132 69.0383 187.011 69.0986C186.861 69.1589 186.71 69.2193 186.59 69.2796C186.499 69.3399 186.379 69.3701 186.258 69.4003C186.108 69.4606 185.987 69.4908 185.836 69.5511C185.806 69.5511 185.746 69.5812 185.686 69.6114C185.565 69.6717 185.415 69.7019 185.294 69.7321C185.083 69.8527 184.842 69.913 184.571 69.9734C184.541 69.9734 184.511 69.9734 184.481 69.9734C184.36 70.0337 184.21 70.0639 184.059 70.094C183.969 70.094 183.878 70.1242 183.788 70.1544C183.698 70.1544 183.577 70.2147 183.457 70.2147C183.005 70.3052 182.553 70.3655 182.101 70.3957C182.011 70.3957 181.92 70.3957 181.8 70.3957C181.739 70.3957 181.709 70.3957 181.679 70.3957C181.559 70.3957 181.438 70.3957 181.348 70.3957C181.288 70.3957 181.197 70.3957 181.137 70.3957C180.113 70.3655 179.089 70.5465 178.064 70.5163L178.185 70.3957Z"}),jsxRuntimeExports.jsx("path",{fill:"#93AB95",d:"M211.864 54.7407C211.592 57.2744 210.086 59.1446 208.52 60.9544C206.773 62.9452 205.176 64.9662 204.212 67.4396C205.176 67.0776 206.291 66.8967 207.104 66.2934C208.49 65.2678 209.725 65.7504 211.02 66.2632C212.406 66.8062 213.792 67.3491 215.117 68.0429C217.226 69.159 219.244 70.4258 221.323 71.5419C222.528 72.1753 223.823 72.5976 225.028 73.2009C227.197 74.2265 229.306 75.3727 231.505 76.3681C232.831 76.9714 234.367 77.2127 235.602 77.9668C237.59 79.1733 239.789 79.4448 241.958 79.8973C243.947 80.2894 245.965 80.3497 247.953 80.772C249.972 81.1943 251.9 80.772 253.858 80.4402C254.731 80.2894 256.78 78.8415 256.69 78.1176C256.629 77.454 256.238 76.6094 255.726 76.2173C254.37 75.1314 252.864 74.2265 251.388 73.2612C249.249 71.8435 247.14 70.3655 244.881 69.0986C243.917 68.5557 242.712 68.435 241.597 68.1635C239.79 67.7412 237.952 67.3793 236.144 66.957C234.759 66.6252 233.373 66.2331 231.987 65.9314C229.517 65.4186 227.047 64.936 224.576 64.4534C224.034 64.3629 223.974 64.2422 224.335 63.7898C225.269 62.5832 225.209 60.5623 224.275 59.3859C224.215 59.2954 224.155 59.1747 224.094 59.0842C224.185 59.0541 224.245 58.9636 224.335 58.9636C224.938 58.9636 225.57 58.9636 226.173 58.9636C228.794 58.8128 231.445 58.8128 234.036 58.481C235.783 58.2396 237.5 57.5459 239.217 57.0331C240.241 56.7013 241.175 56.6711 242.26 56.9426C243.766 57.3347 245.272 56.7616 246.778 56.2187C249.761 55.1629 252.743 54.0469 255.936 53.5944C257.985 53.2928 259.943 52.3275 261.961 51.7243C263.648 51.2115 265.396 50.9099 266.992 50.2161C268.981 49.4017 270.788 48.1951 272.746 47.3505C274.313 46.6567 275.457 45.5407 276.271 44.2135C276.753 43.4292 276.753 42.0719 276.421 41.1669C275.548 38.7538 273.078 37.9997 270.728 39.0856C270.186 39.3269 269.523 39.2666 268.92 39.4476C267.625 39.8397 266.269 40.2017 265.034 40.7145C263.558 41.3479 262.142 42.1322 260.696 42.8561C259.883 43.2784 259.13 43.8214 258.316 44.2738C257.684 44.6056 257.021 44.8168 256.358 45.0882C256.298 45.0882 256.208 45.0882 256.147 45.0882C256.177 44.9977 256.208 44.9072 256.298 44.8469C257.262 44.0023 258.196 43.0673 259.25 42.3735C261.269 41.0161 263.347 39.7191 265.456 38.5125C266.751 37.7584 268.227 37.6076 269.764 37.7283C270.818 37.8188 271.903 37.6076 272.957 37.4266C275.427 37.0043 277.898 36.4312 280.368 36.0693C282.687 35.7374 285.067 35.7676 287.327 35.2548C289.827 34.6817 292.297 33.807 294.707 32.9021C296.695 32.148 298.744 31.3034 300.521 30.1572C302.69 28.7998 304.799 27.2916 305.733 24.6372C306.094 23.5814 306.155 22.586 305.492 21.7716C304.528 20.5952 303.353 19.7808 301.726 19.449C299.557 18.9965 297.479 19.268 295.4 19.6903C294.436 19.9015 293.502 20.2634 292.568 20.5651C290.972 21.0477 289.375 21.47 287.839 22.0732C286.935 22.4352 286.152 23.1591 285.278 23.6418C284.103 24.3054 282.928 24.9087 281.754 25.5421C281.603 25.6326 281.362 25.5421 281.181 25.5421C281.241 25.3913 281.302 25.2103 281.362 25.0595C282.025 23.7323 282.657 22.4051 283.38 21.1382C284.525 19.1474 285.82 17.247 286.845 15.2261C287.568 13.8084 288.11 12.3002 288.562 10.7618C289.074 9.07265 289.646 7.35332 289.676 5.63398C289.707 3.64317 289.857 1.26023 287.568 0.234659C286.634 -0.187634 285.338 0.0536767 284.224 0.234659C281.452 0.687117 279.404 2.52711 277.295 4.18612C275.156 5.87529 273.288 7.89627 272.114 10.3999C271.24 12.27 270.487 14.1703 269.704 16.0707C269.041 17.6995 268.378 19.3283 267.776 20.9572C267.143 22.6464 266.54 24.3355 265.968 26.0247C265.787 26.5375 265.697 27.1106 265.576 27.6536C265.576 27.7441 265.516 27.8044 265.486 27.8949C265.486 27.8345 265.486 27.744 265.426 27.6837C265.004 26.809 264.703 25.8437 264.1 25.1198C262.353 23.129 260.124 22.9782 257.864 24.5769C256.177 25.7532 255.093 27.9552 255.906 29.1618C256.9 30.6398 258.105 32.0273 259.401 33.2339C260.094 33.8975 261.178 34.1388 262.082 34.6214C262.202 34.6817 262.323 35.0437 262.263 35.1643C261.781 36.0693 261.329 37.0647 260.666 37.8489C259.672 39.0555 258.557 40.1414 257.473 41.2273C257.322 41.3781 257.021 41.4083 256.78 41.4987C256.87 41.2876 256.9 41.0764 257.021 40.8653C257.654 39.6889 258.316 38.5125 258.919 37.3361C259.792 35.5866 258.979 33.3545 257.141 33.1132C256.087 32.9925 254.731 33.445 253.828 34.1086C251.056 36.1598 248.375 38.3315 245.814 40.624C244.007 42.2528 242.501 44.2135 240.784 45.9931C240.422 46.3551 239.88 46.5361 239.428 46.8076C239.699 46.3853 239.97 45.963 240.241 45.5407C241.717 43.1879 242.922 40.7446 243.314 37.9394C243.555 36.0693 244.037 34.1991 244.097 32.3289C244.097 31.2129 243.645 29.9762 243.073 28.9808C242.862 28.6188 241.537 28.4077 241.115 28.6791C239.217 29.9158 237.048 30.7303 235.632 32.6608C234.638 33.988 233.524 35.2247 232.379 36.4312C231.204 37.6679 229.728 38.6332 228.764 39.9906C227.649 41.5591 226.926 43.3991 226.113 45.1486C225.39 46.6869 224.787 48.2856 224.155 49.8541C223.733 50.9098 223.341 51.9656 222.829 52.9911C221.955 54.6803 221.022 56.3695 220.058 57.9983C219.455 58.9937 218.853 60.0495 217.979 60.7734C216.864 61.6783 215.479 62.2816 214.183 62.9754C214.033 63.0659 213.761 62.915 213.581 62.8547C213.46 62.8849 213.31 62.915 213.189 62.9452C213.279 62.8849 213.37 62.7944 213.46 62.7341C214.665 61.3164 215.991 59.959 217.075 58.4206C217.527 57.7872 217.648 56.7315 217.467 55.9472C217.226 54.8915 216.111 54.7708 215.177 54.7105C214.123 54.6502 213.039 54.7105 211.954 54.7105L211.864 54.7407ZM245.634 52.3879C245.634 52.3879 245.453 52.4482 245.363 52.4784C245.423 52.418 245.453 52.3577 245.513 52.2672C246.086 51.9053 246.658 51.5433 247.23 51.1512L247.501 51.0607C247.501 51.0607 247.411 51.1813 247.381 51.2718C246.809 51.6338 246.236 51.9957 245.664 52.3879H245.634ZM234.126 52.0862C234.126 52.0862 234.216 52.0862 234.277 52.1164C234.246 52.2069 234.216 52.2974 234.156 52.3577C233.403 53.2626 232.71 54.1977 231.897 55.0121C231.264 55.6456 230.149 55.917 229.848 56.641C229.306 57.8174 228.553 57.3046 227.83 57.2744C227.649 57.2744 227.438 57.2442 227.257 57.2442C226.806 57.2442 226.354 57.2744 225.902 57.3046C226.293 56.9426 226.715 56.5505 227.137 56.1885C227.288 56.0679 227.529 56.0075 227.709 55.917C229.065 55.0725 230.451 54.2279 231.806 53.4134C232.56 52.961 233.343 52.5387 234.156 52.0862H234.126ZM263.528 36.6725C264.01 35.7676 264.552 34.7722 265.064 33.7768C265.667 32.6306 266.239 31.4844 266.842 30.3381C266.872 30.2778 267.113 30.2476 267.143 30.2778C267.535 30.7303 267.806 31.4542 268.288 31.605C268.95 31.8162 268.589 31.9971 268.438 32.2083C267.776 33.0529 267.113 33.9276 266.36 34.7119C265.607 35.4961 264.763 36.1597 263.98 36.8535C263.889 36.944 263.769 36.9742 263.679 37.0345C263.679 36.944 263.618 36.8535 263.558 36.6424L263.528 36.6725Z"}),jsxRuntimeExports.jsx("path",{fill:"#93AB95",d:"M234.519 51.7544C234.519 51.7544 234.459 51.9656 234.428 52.0561H234.368C234.428 51.9656 234.489 51.8751 234.519 51.7846C234.609 51.6941 234.669 51.6338 234.76 51.5433L234.82 51.6941C234.82 51.6941 234.609 51.7243 234.519 51.7544Z"}),jsxRuntimeExports.jsx("path",{fill:"#93AB95",d:"M243.947 53.2325C244.128 53.142 244.279 53.0515 244.399 52.9911C244.399 52.9911 244.489 53.0515 244.52 53.0816C244.369 53.1721 244.248 53.2626 244.098 53.323C244.098 53.323 244.007 53.2928 243.917 53.2626L243.947 53.2325Z"}),jsxRuntimeExports.jsx("path",{fill:"#93AB95",d:"M243.194 53.7452C243.405 53.6547 243.556 53.5643 243.706 53.5341C243.706 53.5341 243.797 53.5944 243.827 53.6246C243.706 53.7151 243.556 53.8056 243.435 53.8659C243.405 53.8659 243.345 53.8357 243.194 53.7754V53.7452Z"}),jsxRuntimeExports.jsx("path",{fill:"#93AB95",d:"M263.288 37.4266C263.288 37.4266 263.227 37.3663 263.197 37.3361C263.288 37.2758 263.348 37.1853 263.438 37.1552C263.468 37.1552 263.559 37.1853 263.619 37.2155C263.529 37.2758 263.438 37.3361 263.288 37.4266Z"}),jsxRuntimeExports.jsx("path",{fill:"#93AB95",d:"M235.602 50.8797C235.602 50.8797 235.542 51.0003 235.482 51.0305C235.482 51.0305 235.391 51.0305 235.361 51.0305C235.422 50.9702 235.452 50.8797 235.512 50.8194C235.512 50.8194 235.572 50.8797 235.632 50.9099L235.602 50.8797Z"}),jsxRuntimeExports.jsx("path",{fill:"#93AB95",d:"M239.127 47.0187C239.127 47.0187 239.217 46.9885 239.278 46.9584C239.278 46.9885 239.308 47.0489 239.308 47.0489C239.308 47.079 239.217 47.1092 239.187 47.1394C239.187 47.1092 239.157 47.0489 239.127 46.9885V47.0187Z"}),jsxRuntimeExports.jsx("path",{fill:"#93AB95",d:"M199.845 75.1314C198.61 76.1268 197.405 77.092 196.169 78.0874C194.964 79.0828 193.759 80.1084 192.494 81.0435C192.042 81.3753 191.41 81.4658 190.837 81.6468C190.837 81.7373 190.777 81.9182 190.837 81.9484C192.374 82.8533 193.88 83.8487 195.507 84.5727C198.941 86.111 202.526 85.749 206.05 84.9949C207.527 84.6631 208.942 83.9995 210.268 83.2454C211.834 82.3405 211.654 80.7418 210.147 79.7464C207.225 77.816 204.002 76.6094 200.718 75.4933C200.417 75.4028 200.116 75.252 199.845 75.1314Z"}),jsxRuntimeExports.jsx("path",{fill:"#BA2031",d:"M152.397 57.6364C151.102 57.6364 149.626 58.2397 148.873 56.46C148.632 55.8869 148.3 55.2836 147.879 54.8312C145.89 52.6594 143.962 50.3971 141.793 48.4063C139.895 46.6568 137.787 45.1486 135.678 43.6404C133.479 42.0417 131.189 40.5335 128.9 39.0857C127.876 38.4522 126.671 38.0902 125.586 37.5171C122.664 35.9788 119.591 34.923 116.247 34.8326C114.44 34.7722 112.602 34.9231 110.795 35.1342C109.65 35.2549 108.355 35.4057 107.421 36.0089C105.282 37.4266 103.173 38.9952 101.305 40.7447C99.3472 42.5847 97.4493 44.485 96.2142 47.0489C95.0092 49.5223 94.3464 52.0561 94.1054 54.7708C94.3766 57.3046 95.8829 59.1747 97.4494 60.9846C99.1966 62.9754 100.793 64.9964 101.757 67.4698C102.028 67.9524 102.299 68.435 102.571 68.9177C103.745 70.999 104.92 73.0803 106.095 75.1616C107.33 76.157 108.535 77.1222 109.77 78.1176C110.975 79.113 112.18 80.1386 113.446 81.0737C113.898 81.4055 114.53 81.496 115.103 81.6769C116.127 81.8278 117.151 81.9183 118.175 82.0992C119.832 82.4009 121.459 82.8232 123.116 83.1248C123.748 83.2455 124.411 83.2153 125.074 83.2455C125.255 83.2455 125.466 83.2455 125.646 83.2153C125.496 83.3661 125.345 83.5471 125.164 83.6074C123.507 84.1805 121.851 84.8441 120.133 85.2966C118.778 85.6586 117.332 85.7792 115.946 85.8999C112.964 86.1412 109.981 86.4127 106.999 86.473C103.986 86.5333 101.034 86.7143 98.2928 87.9812C96.6962 88.7051 95.1598 89.5497 93.6536 90.4848C91.8762 91.6008 90.129 92.7772 88.5022 94.0441C87.237 95.0395 86.273 96.3667 85.0077 97.332C82.3266 99.3831 80.248 101.826 79.1033 105.024C78.5008 106.683 79.4346 108.07 81.1517 108.04C82.7182 108.04 84.2847 107.919 85.8512 107.889C87.3575 107.859 88.7131 108.161 89.9483 109.126C90.7918 109.79 92.3582 109.458 92.9005 108.643C93.744 107.346 94.4971 106.019 95.4309 104.782C96.6359 103.184 97.8108 101.555 99.2869 100.198C100.341 99.2323 101.878 98.7798 103.113 97.9654C105.131 96.608 107.451 96.0952 109.74 95.8238C113.175 95.4618 116.669 95.492 120.133 95.311C122.393 95.1903 124.712 95.1903 126.942 94.7982C129.984 94.2552 132.967 93.29 135.648 91.631C137.455 90.5149 139.203 89.2782 141.04 88.1622C143.39 86.7445 145.378 85.0251 147.035 82.793C148.782 80.4402 150.319 78.0271 151.403 75.3124C151.765 74.4376 151.765 73.0501 153.271 72.9898V57.4856C153 57.5157 152.759 57.5761 152.488 57.5761L152.397 57.6364ZM142.546 65.4186C141.703 66.0521 140.89 66.7459 139.956 67.2586C139.504 67.5301 138.992 67.6809 138.449 67.8318C138.269 67.9223 138.028 67.9826 137.787 68.0429C137.757 68.0429 137.696 68.0429 137.666 68.0731C136.883 68.3144 136.1 68.5557 135.316 68.797C134.533 68.978 133.72 69.0685 132.906 69.2193C132.696 69.2796 132.485 69.3098 132.274 69.34C131.701 69.4908 131.129 69.6717 130.557 70.0035C130.406 70.094 130.255 70.1544 130.075 70.2147C129.984 70.2449 129.864 70.3052 129.773 70.3052C129.472 70.3957 129.111 70.456 128.749 70.456C128.629 70.456 128.508 70.456 128.388 70.4258C128.177 70.4258 127.966 70.4258 127.755 70.4258C127.484 70.4258 127.213 70.4258 126.942 70.3957C126.942 70.3957 126.881 70.3957 126.851 70.3957C126.791 70.3957 126.731 70.3957 126.671 70.3957C126.008 70.3655 125.315 70.3052 124.652 70.3354C124.622 70.3354 124.562 70.3354 124.532 70.3354C124.381 70.3354 124.23 70.3354 124.08 70.3655C124.02 70.3655 123.959 70.3655 123.929 70.3655C123.628 70.3655 123.297 70.3052 122.995 70.2449C122.935 70.2449 122.875 70.2449 122.815 70.2449C122.212 70.2449 121.67 70.094 121.128 69.8226C120.525 69.6416 119.923 69.4606 119.32 69.2193C119.019 69.0986 118.687 68.9478 118.386 68.8272C118.236 68.7668 118.115 68.7367 117.964 68.6462C117.181 68.3445 116.428 68.0429 115.675 67.7111C115.313 67.6206 115.012 67.4698 114.741 67.2888C114.319 67.1078 113.928 66.8967 113.506 66.6855C113.084 66.5347 112.723 66.3537 112.421 66.0823C112.331 66.0219 112.241 65.9918 112.15 65.9314C111.668 65.7505 111.277 65.4488 110.945 65.117C110.855 65.0567 110.795 64.9964 110.704 64.936C110.313 64.6947 109.981 64.3931 109.74 64.0613C109.017 63.3977 108.355 62.6737 107.692 61.9196C107.481 61.7387 107.3 61.5577 107.119 61.3164C106.728 60.8639 106.276 60.4718 105.884 60.0193C105.463 59.5066 105.071 58.9938 104.709 58.4206C104.709 58.4206 104.709 58.3905 104.679 58.3603C104.499 58.1492 104.318 57.9079 104.137 57.6967C102.36 55.8869 100.582 54.0469 99.6786 51.6036C99.2568 50.4876 100.161 49.8843 100.853 49.3413C101.366 48.9191 102.028 48.7079 102.631 48.3761C103.595 48.1348 104.559 47.803 105.523 47.6823C105.734 47.6522 105.945 47.6522 106.186 47.622C106.457 47.5617 106.758 47.5315 107.059 47.5315C107.15 47.5315 107.24 47.5315 107.33 47.5315C107.451 47.5315 107.571 47.5315 107.692 47.5315C107.903 47.5014 108.144 47.4712 108.385 47.4712C108.475 47.4712 108.565 47.4712 108.656 47.4712C108.927 47.4712 109.198 47.4712 109.499 47.4712C109.529 47.4712 109.59 47.4712 109.62 47.4712C109.65 47.4712 109.68 47.4712 109.71 47.4712C110.373 47.4712 111.006 47.5315 111.638 47.6522C111.668 47.6522 111.698 47.6522 111.759 47.6522C112 47.6823 112.241 47.7427 112.482 47.7728C113.024 47.7728 113.506 47.8935 113.928 48.1046C114.169 48.165 114.38 48.2253 114.621 48.2554C114.711 48.2554 114.801 48.2856 114.892 48.3158C114.982 48.3158 115.103 48.3761 115.193 48.3761C115.554 48.4364 115.886 48.4968 116.187 48.6174C116.488 48.6777 116.759 48.7381 117 48.8587C117.091 48.8587 117.181 48.9191 117.272 48.9492C117.513 49.0095 117.754 49.1 117.964 49.2207C118.145 49.281 118.326 49.3413 118.507 49.4318C118.567 49.4318 118.627 49.462 118.657 49.4922C118.868 49.5827 119.049 49.643 119.26 49.7335C119.501 49.7938 119.742 49.8843 119.953 50.005C120.435 50.1859 120.887 50.3368 121.369 50.4574C121.61 50.5177 121.851 50.6082 122.092 50.6686C122.423 50.7289 122.724 50.8495 123.025 50.9702C123.357 51.0909 123.658 51.2115 123.959 51.3623C124.2 51.4528 124.411 51.5433 124.622 51.6941C125.014 51.8751 125.375 52.0259 125.767 52.2371C125.887 52.2974 125.978 52.3577 126.068 52.3879C126.128 52.3879 126.158 52.4482 126.219 52.4784C126.309 52.5387 126.399 52.5689 126.49 52.6594C126.851 52.8705 127.213 53.0817 127.544 53.323C127.544 53.323 127.574 53.323 127.604 53.3531C127.936 53.5944 128.297 53.8056 128.629 54.0469C128.87 54.2279 129.111 54.3787 129.352 54.5597C129.442 54.62 129.563 54.6803 129.653 54.7708C130.105 55.0725 130.557 55.4043 131.009 55.7059C131.25 55.8266 131.43 55.9774 131.611 56.1282C132.455 56.7013 133.268 57.2744 134.111 57.8475C134.202 57.9079 134.262 58.0285 134.322 58.119C134.383 58.1793 134.473 58.2397 134.533 58.3C134.624 58.3603 134.744 58.4207 134.834 58.5111C134.895 58.5111 134.925 58.5715 134.985 58.6016C134.985 58.6016 135.196 58.7525 135.286 58.8429C135.347 58.8429 135.377 58.8731 135.437 58.9033C136.009 59.2954 136.642 59.6875 137.184 60.1098C138.841 61.4672 140.468 62.8547 142.064 64.3026C142.305 64.5439 143.209 64.6947 142.516 65.3885L142.546 65.4186Z"}),jsxRuntimeExports.jsx("path",{fill:"#93AB95",d:"M94.136 54.7407C94.4071 57.2744 95.9134 59.1446 97.4799 60.9544C99.2272 62.9452 100.824 64.9662 101.788 67.4396C100.824 67.0776 99.7091 66.8967 98.8957 66.2934C97.5099 65.2678 96.2749 65.7504 94.9795 66.2632C93.5937 66.8062 92.208 67.3491 90.8825 68.0429C88.7738 69.159 86.7554 70.4258 84.6768 71.5419C83.4718 72.1753 82.1764 72.5976 80.9714 73.2009C78.8024 74.2265 76.6937 75.3727 74.4945 76.3681C73.1691 76.9714 71.6326 77.2127 70.3975 77.9668C68.4093 79.1733 66.2102 79.4448 64.0412 79.8973C62.0529 80.2894 60.0345 80.3497 58.0463 80.772C56.0279 81.1943 54.0999 80.772 52.1418 80.4402C51.2682 80.2894 49.2197 78.8415 49.31 78.1176C49.3703 77.454 49.7619 76.6094 50.2741 76.2173C51.6297 75.1314 53.1359 74.2265 54.6121 73.2612C56.7509 71.8435 58.8597 70.3655 61.1191 69.0986C62.0831 68.5557 63.288 68.435 64.4027 68.1635C66.2102 67.7412 68.0478 67.3793 69.8553 66.957C71.241 66.6252 72.6268 66.2331 74.0125 65.9314C76.4828 65.4186 78.953 64.936 81.4233 64.4534C81.9655 64.3629 82.0258 64.2422 81.6643 63.7898C80.7304 62.5832 80.7906 60.5623 81.7245 59.3859C81.7848 59.2954 81.845 59.1747 81.9053 59.0842C81.8149 59.0541 81.7547 58.9636 81.6643 58.9636C81.0618 58.9636 80.4291 58.9636 79.8266 58.9636C77.2058 58.8128 74.5548 58.8128 71.9641 58.481C70.2168 58.2396 68.4997 57.5459 66.7826 57.0331C65.7583 56.7013 64.8244 56.6711 63.7399 56.9426C62.2337 57.3347 60.7274 56.7616 59.2212 56.2187C56.2388 55.1629 53.2564 54.0469 50.0632 53.5944C48.0147 53.2928 46.0565 52.3275 44.0382 51.7243C42.3512 51.2115 40.604 50.9099 39.0073 50.2161C37.0191 49.4017 35.2116 48.1951 33.2535 47.3505C31.687 46.6567 30.5422 45.5407 29.7288 44.2135C29.2468 43.4292 29.2468 42.0719 29.5782 41.1669C30.4518 38.7538 32.922 37.9997 35.2718 39.0856C35.814 39.3269 36.4768 39.2666 37.0793 39.4476C38.3747 39.8397 39.7303 40.2017 40.9655 40.7145C42.4416 41.3479 43.8575 42.1322 45.3035 42.8561C46.1168 43.2784 46.8699 43.8214 47.6833 44.2738C48.3159 44.6056 48.9787 44.8168 49.6415 45.0882C49.7017 45.0882 49.792 45.0882 49.8523 45.0882C49.8221 44.9977 49.792 44.9072 49.7017 44.8469C48.7377 44.0023 47.8038 43.0673 46.7494 42.3735C44.731 41.0161 42.6524 39.7191 40.5437 38.5125C39.2483 37.7584 37.7722 37.6076 36.2358 37.7283C35.1814 37.8188 34.0969 37.6076 33.0426 37.4266C30.5723 37.0043 28.1021 36.4312 25.6319 36.0693C23.3122 35.7374 20.9324 35.7676 18.673 35.2548C16.1726 34.6817 13.7023 33.807 11.2923 32.9021C9.3041 32.148 7.25562 31.3034 5.47825 30.1572C3.30925 28.7998 1.20047 27.2916 0.266599 24.6372C-0.0949008 23.5814 -0.155099 22.586 0.50765 21.7716C1.47165 20.5952 2.64652 19.7808 4.27327 19.449C6.44227 18.9965 8.52082 19.268 10.5994 19.6903C11.5634 19.9015 12.4973 20.2634 13.4312 20.5651C15.0278 21.0477 16.6245 21.47 18.1608 22.0732C19.0646 22.4352 19.8479 23.1591 20.7215 23.6418C21.8963 24.3054 23.0712 24.9087 24.246 25.5421C24.3967 25.6326 24.6377 25.5421 24.8184 25.5421C24.7582 25.3913 24.6979 25.2103 24.6377 25.0595C23.9749 23.7323 23.3424 22.4051 22.6194 21.1382C21.4746 19.1474 20.1793 17.247 19.155 15.2261C18.432 13.8084 17.8897 12.3002 17.4379 10.7618C16.9257 9.07265 16.3534 7.35332 16.3233 5.63398C16.2931 3.64317 16.1425 1.26023 18.4319 0.234659C19.3658 -0.187634 20.6612 0.0536767 21.7759 0.234659C24.5474 0.687117 26.5958 2.52711 28.7046 4.18612C30.8434 5.87529 32.7112 7.89627 33.8861 10.3999C34.7597 12.27 35.5128 14.1703 36.296 16.0707C36.9588 17.6995 37.6216 19.3283 38.2241 20.9572C38.8567 22.6464 39.4592 24.3355 40.0316 26.0247C40.2123 26.5375 40.3027 27.1106 40.4232 27.6536C40.4232 27.7441 40.4835 27.8044 40.5136 27.8949C40.5136 27.8345 40.5136 27.744 40.5738 27.6837C40.9956 26.809 41.2968 25.8437 41.8993 25.1198C43.6466 23.129 45.8758 22.9782 48.1352 24.5769C49.8222 25.7532 50.9067 27.9552 50.0933 29.1618C49.0992 30.6398 47.8942 32.0273 46.5988 33.2339C45.9059 33.8975 44.8214 34.1388 43.9176 34.6214C43.7971 34.6817 43.6766 35.0437 43.7369 35.1643C44.2189 36.0693 44.6708 37.0647 45.3335 37.8489C46.3276 39.0555 47.4423 40.1414 48.5268 41.2273C48.6775 41.3781 48.9787 41.4083 49.2197 41.4987C49.1293 41.2876 49.0992 41.0764 48.9787 40.8653C48.3461 39.6889 47.6833 38.5125 47.0808 37.3361C46.2072 35.5866 47.0206 33.3545 48.8582 33.1132C49.9126 32.9925 51.2682 33.445 52.1719 34.1086C54.9434 36.1598 57.6246 38.3315 60.1852 40.624C61.9927 42.2528 63.4989 44.2135 65.216 45.9931C65.5775 46.3551 66.1198 46.5361 66.5717 46.8076C66.3005 46.3853 66.0294 45.963 65.7582 45.5407C64.2821 43.1879 63.0771 40.7446 62.6855 37.9394C62.4445 36.0693 61.9625 34.1991 61.9022 32.3289C61.9022 31.2129 62.3542 29.9762 62.9266 28.9808C63.1374 28.6188 64.4629 28.4077 64.8847 28.6791C66.7826 29.9158 68.9516 30.7303 70.3674 32.6608C71.3616 33.988 72.4762 35.2247 73.6209 36.4312C74.7958 37.6679 76.2719 38.6332 77.2359 39.9906C78.3506 41.5591 79.0735 43.3991 79.8868 45.1486C80.6098 46.6869 81.2124 48.2856 81.845 49.8541C82.2668 50.9098 82.6584 51.9656 83.1706 52.9911C84.0442 54.6803 84.978 56.3695 85.942 57.9983C86.5445 58.9937 87.147 60.0495 88.0206 60.7734C89.1353 61.6783 90.521 62.2816 91.8164 62.9754C91.967 63.0659 92.2381 62.915 92.4188 62.8547C92.5393 62.8849 92.69 62.915 92.8105 62.9452C92.7201 62.8849 92.6297 62.7944 92.5394 62.7341C91.3344 61.3164 90.0088 59.959 88.9243 58.4206C88.4725 57.7872 88.352 56.7315 88.5328 55.9472C88.7738 54.8915 89.8884 54.7708 90.8222 54.7105C91.8766 54.6502 92.9611 54.7105 94.0456 54.7105L94.136 54.7407ZM71.4821 51.7544C71.4821 51.7544 71.5423 51.9656 71.5724 52.0561H71.6326C71.5724 51.9656 71.5122 51.8751 71.4821 51.7846C71.3917 51.6941 71.3314 51.6338 71.241 51.5433L71.1808 51.6941C71.1808 51.6941 71.3917 51.7243 71.4821 51.7544ZM60.3659 52.3879C60.3659 52.3879 60.5467 52.4482 60.637 52.4784C60.5768 52.418 60.5466 52.3577 60.4864 52.2672C59.914 51.9053 59.3417 51.5433 58.7693 51.1512L58.4982 51.0607C58.4982 51.0607 58.5885 51.1813 58.6186 51.2718C59.191 51.6338 59.7634 51.9957 60.3358 52.3879H60.3659ZM71.8737 52.0862C71.8737 52.0862 71.7833 52.0862 71.723 52.1164C71.7531 52.2069 71.7833 52.2974 71.8435 52.3577C72.5967 53.2626 73.2895 54.1977 74.1029 55.0121C74.7355 55.6456 75.8501 55.917 76.1514 56.641C76.6936 57.8174 77.4468 57.3046 78.1698 57.2744C78.3505 57.2744 78.5614 57.2442 78.7422 57.2442C79.1941 57.2442 79.6459 57.2744 80.0977 57.3046C79.7061 56.9426 79.2844 56.5505 78.8626 56.1885C78.712 56.0679 78.471 56.0075 78.2902 55.917C76.9346 55.0725 75.5489 54.2279 74.1933 53.4134C73.4402 52.961 72.6569 52.5387 71.8435 52.0862H71.8737ZM42.4717 36.6725C41.9897 35.7676 41.4474 34.7722 40.9353 33.7768C40.3328 32.6306 39.7604 31.4844 39.1579 30.3381C39.1278 30.2778 38.8868 30.2476 38.8567 30.2778C38.465 30.7303 38.1939 31.4542 37.7119 31.605C37.0492 31.8162 37.4107 31.9971 37.5613 32.2083C38.2241 33.0529 38.8868 33.9276 39.6399 34.7119C40.3931 35.4961 41.2366 36.1597 42.0198 36.8535C42.1102 36.944 42.2306 36.9742 42.321 37.0345C42.321 36.944 42.3813 36.8535 42.4415 36.6424L42.4717 36.6725ZM62.0529 53.2325C61.8722 53.142 61.7216 53.0515 61.6011 52.9911C61.6011 52.9911 61.5107 53.0515 61.4805 53.0816C61.6312 53.1721 61.7516 53.2626 61.9022 53.3229C61.9022 53.3229 61.9927 53.2928 62.0831 53.2626L62.0529 53.2325ZM62.806 53.7452C62.5952 53.6548 62.4445 53.5643 62.2939 53.5341C62.2939 53.5341 62.2036 53.5944 62.1735 53.6246C62.2939 53.7151 62.4445 53.8056 62.565 53.8659C62.5951 53.8659 62.6554 53.8357 62.806 53.7754V53.7452ZM42.7127 37.4266C42.7127 37.4266 42.7729 37.3663 42.803 37.3361C42.7127 37.2758 42.6524 37.1853 42.5621 37.1552C42.5319 37.1552 42.4416 37.1853 42.3813 37.2155C42.4717 37.2758 42.562 37.3361 42.7127 37.4266ZM70.3975 50.8797C70.3975 50.8797 70.4578 51.0003 70.518 51.0305C70.518 51.0305 70.6084 51.0305 70.6386 51.0305C70.5783 50.9702 70.5481 50.8797 70.4879 50.8194C70.4879 50.8194 70.4277 50.8797 70.3674 50.9098L70.3975 50.8797ZM66.8729 47.0187C66.8729 47.0187 66.7825 46.9885 66.7223 46.9584C66.7223 46.9885 66.6922 47.0489 66.6922 47.0489C66.6922 47.079 66.7825 47.1092 66.8126 47.1394C66.8126 47.1092 66.8428 47.0489 66.8729 46.9886V47.0187Z"}),jsxRuntimeExports.jsx("path",{fill:"#93AB95",d:"M106.157 75.1314C107.392 76.1268 108.597 77.092 109.832 78.0874C111.037 79.0828 112.242 80.1084 113.507 81.0435C113.959 81.3753 114.592 81.4658 115.164 81.6468C115.164 81.7373 115.224 81.9182 115.164 81.9484C113.628 82.8533 112.121 83.8487 110.495 84.5727C107.06 86.111 103.476 85.749 99.9509 84.9949C98.4748 84.6631 97.059 83.9995 95.7335 83.2454C94.167 82.3405 94.3477 80.7418 95.854 79.7464C98.7761 77.816 101.999 76.6094 105.283 75.4933C105.584 75.4028 105.886 75.252 106.157 75.1314Z"})]});const WreathIcon=()=>jsxRuntimeExports.jsxs("svg",{xmlns:"http://www.w3.org/2000/svg",fill:"none",viewBox:"0 0 202 200",height:"200",width:"202",children:[jsxRuntimeExports.jsxs("g",{"clip-path":"url(#clip0_341_12)",children:[jsxRuntimeExports.jsx("path",{fill:"#749561",d:"M35.851 135.039C36.628 132.004 35.1446 130.699 33.7671 128.123C32.6015 125.935 31.8244 123.606 31.2593 121.207C30.7295 118.878 30.5882 116.549 30.5529 114.15C30.5529 111.397 29.9877 110.092 27.9744 108.327C25.2194 105.963 22.9942 102.999 21.2635 99.8236C20.6983 98.4474 20.1685 97.0713 19.6387 95.6951C19.4974 95.2717 19.2855 94.8483 19.0383 94.4954C17.5901 92.096 13.3163 91.7784 12.4333 95.2364C10.42 103.317 6.28742 110.445 1.02462 116.867C-0.494181 118.737 -0.317577 121.136 1.76635 122.548C8.01815 126.747 8.40668 136.486 8.12411 143.19C8.01815 145.342 10.5612 147.53 12.7158 146.683C18.5438 144.354 23.0648 149.682 25.7492 154.199C27.4446 157.057 32.9193 156.104 32.4955 152.364C32.4249 151.87 32.4602 151.341 32.4249 150.847C32.2836 145.448 34.5441 140.191 35.8863 135.004L35.851 135.039Z"}),jsxRuntimeExports.jsx("path",{fill:"#4E7A38",d:"M69.5112 17.9958C69.1933 17.9252 68.9107 17.8546 68.5928 17.784C68.4516 17.7488 68.3103 17.6782 68.169 17.6429C67.6039 17.3606 67.0387 17.0783 66.4736 16.7607C65.308 16.1256 64.1071 15.4905 62.9768 14.7847C61.9172 14.1496 60.8929 13.4086 59.798 12.7735C58.809 12.1736 57.7493 11.8207 56.6544 11.609C56.5838 11.609 56.5131 11.5384 56.4425 11.5032C56.3365 11.5032 56.2305 11.5032 56.1246 11.5032C55.948 11.5032 55.7714 11.3973 55.5948 11.3973C54.7118 11.2914 53.864 11.8913 53.4049 12.6676C53.1576 12.8793 52.9104 13.1263 52.7338 13.4086C52.1333 14.2555 51.6742 15.2082 51.1797 16.1256C51.0737 16.2315 50.9324 16.3373 50.8265 16.4432C50.7205 16.5137 50.6145 16.5843 50.5086 16.6549C50.2613 16.8313 49.9788 16.9725 49.7315 17.1136C49.6255 17.1842 49.4843 17.2547 49.3783 17.29C49.3077 17.29 49.0957 17.3959 49.0604 17.4312C48.9545 17.4665 48.8132 17.5017 48.7072 17.537C48.3893 17.6429 48.1067 17.7135 47.7889 17.7488C47.7182 17.7488 47.6123 17.7488 47.5769 17.784C47.4003 17.784 47.259 17.784 47.0824 17.8193C46.6586 17.8193 46.2347 17.8193 45.8462 17.8193C45.6696 17.8193 45.493 17.8193 45.2811 17.784C45.2811 17.784 45.0338 17.784 44.9632 17.7488C44.8572 17.7488 44.5393 17.6782 44.504 17.6782C44.3274 17.6782 44.1508 17.6076 43.9742 17.5723C43.1618 17.3959 42.3494 17.1842 41.5371 17.0077C40.866 16.8313 40.1242 16.9372 39.5238 17.29C38.5348 17.6782 37.8284 18.5956 37.7931 19.7248C37.7577 20.748 37.6871 21.7713 37.5811 22.7593C37.5458 23.2533 37.4752 23.7826 37.4045 24.2766C37.4045 24.3472 37.4045 24.3119 37.4045 24.3472C37.4045 24.3472 37.4045 24.3472 37.4045 24.4178C37.3692 24.6648 37.3339 24.9118 37.2986 25.1588C37.1926 25.9351 37.016 26.7466 36.8041 27.5229C36.6628 27.6994 36.5215 27.8758 36.3802 28.0169C36.1683 28.2286 35.9564 28.4404 35.7091 28.6521C35.6032 28.7579 35.4972 28.8285 35.3912 28.9344C34.7555 29.3225 34.155 29.7106 33.4486 30.0635C30.6582 31.4396 28.2211 32.3924 25.1482 33.4157C23.8413 33.8391 22.8523 35.2858 23.2762 36.6972C23.5941 37.65 24.4418 38.4262 25.3954 38.6027C25.6427 38.885 25.8546 39.1672 26.1019 39.4495C26.1019 39.6612 26.1019 39.8377 26.1372 40.0494C26.8083 42.3783 26.667 45.06 26.2078 47.4594C25.9606 48.8356 25.6074 50.1764 25.2188 51.482C24.795 52.964 24.3358 54.4107 24.3005 55.9986C24.3005 56.2809 24.3711 56.5631 24.4418 56.8102V56.8807C24.3005 58.7509 26.8436 60.374 28.433 59.1743C30.8702 57.3041 33.3073 55.2576 36.027 53.8109C36.3449 53.6344 36.6981 53.458 37.0513 53.3169C36.6981 53.458 37.5811 53.1404 37.6871 53.1051C37.9343 53.0346 38.1816 52.964 38.4288 52.8934C38.5348 52.8934 38.5701 52.8934 38.6054 52.8934C38.7114 52.8934 38.8527 52.8934 38.9586 52.8934C39.0646 52.8934 39.5944 52.964 39.6297 52.9287C39.9476 52.9993 40.2655 53.0699 40.5481 53.211C40.2655 53.0699 41.1132 53.4933 41.1839 53.5639C41.5017 53.7403 41.855 53.952 42.1728 54.1637C43.3738 54.8694 45.3164 54.5871 45.9169 53.2463C47.0824 50.5646 48.7425 47.8476 51.3209 46.3303C54.2173 44.6013 58.0672 46.4714 60.8929 44.4954C62.1291 43.6133 62.3411 42.2724 62.6589 40.8962C63.0475 39.2025 63.542 37.5441 64.0718 35.8857C65.1667 32.4982 66.5442 29.2519 68.2043 26.0762C68.275 25.9351 68.275 25.7939 68.3456 25.6528C68.7695 25.0529 69.1933 24.4178 69.5465 23.7473C69.6878 23.5003 69.7938 23.2533 69.935 23.0063C70.6768 22.7241 71.2772 22.1948 71.4538 21.3479C71.7364 20.0423 71.0653 18.3486 69.5818 18.0663L69.5112 17.9958ZM44.1508 33.2039C44.3981 33.2039 44.61 33.2039 44.8219 33.2392C44.7866 33.5215 44.7159 33.8038 44.6806 34.0861C44.6806 33.8038 44.7866 33.5215 44.8219 33.2392C44.61 33.2392 44.3627 33.2039 44.1508 33.2039ZM46.1641 30.8045C46.1994 30.5928 46.2347 30.3811 46.2701 30.1341C46.2347 30.3458 46.1994 30.5928 46.1641 30.8045Z"}),jsxRuntimeExports.jsx("path",{fill:"#D14247",d:"M77.282 24.4531C80.2666 24.4531 82.6861 21.9254 82.6861 18.8074C82.6861 15.6893 80.2666 13.1616 77.282 13.1616C74.2974 13.1616 71.8779 15.6893 71.8779 18.8074C71.8779 21.9254 74.2974 24.4531 77.282 24.4531Z"}),jsxRuntimeExports.jsx("path",{fill:"#D14247",d:"M77.2824 25.3352C73.7856 25.3352 70.96 22.4065 70.96 18.8073C70.96 15.2082 73.7856 12.2794 77.2824 12.2794C80.7792 12.2794 83.6048 15.2082 83.6048 18.8073C83.6048 22.4065 80.7792 25.3352 77.2824 25.3352ZM77.2824 14.079C74.7746 14.079 72.7613 16.1962 72.7613 18.8073C72.7613 21.4185 74.7746 23.5356 77.2824 23.5356C79.7902 23.5356 81.8035 21.4185 81.8035 18.8073C81.8035 16.1962 79.7902 14.079 77.2824 14.079Z"}),jsxRuntimeExports.jsx("path",{fill:"#D14247",d:"M151.137 31.1221C154.122 31.1221 156.542 28.5944 156.542 25.4764C156.542 22.3583 154.122 19.8306 151.137 19.8306C148.153 19.8306 145.733 22.3583 145.733 25.4764C145.733 28.5944 148.153 31.1221 151.137 31.1221Z"}),jsxRuntimeExports.jsx("path",{fill:"#D14247",d:"M151.138 32.0042C147.641 32.0042 144.815 29.0755 144.815 25.4764C144.815 21.8772 147.641 18.9485 151.138 18.9485C154.635 18.9485 157.46 21.8772 157.46 25.4764C157.46 29.0755 154.635 32.0042 151.138 32.0042ZM151.138 20.7128C148.63 20.7128 146.617 22.8299 146.617 25.4411C146.617 28.0522 148.63 30.1694 151.138 30.1694C153.646 30.1694 155.659 28.0522 155.659 25.4411C155.659 22.8299 153.646 20.7128 151.138 20.7128Z"}),jsxRuntimeExports.jsx("path",{fill:"#D14247",d:"M144.215 40.8257C147.199 40.8257 149.619 38.298 149.619 35.18C149.619 32.0619 147.199 29.5342 144.215 29.5342C141.23 29.5342 138.811 32.0619 138.811 35.18C138.811 38.298 141.23 40.8257 144.215 40.8257Z"}),jsxRuntimeExports.jsx("path",{fill:"#D14247",d:"M144.215 41.7078C140.754 41.7078 137.893 38.7791 137.893 35.18C137.893 31.5808 140.718 28.6521 144.215 28.6521C147.712 28.6521 150.537 31.5808 150.537 35.18C150.537 38.7791 147.712 41.7078 144.215 41.7078ZM144.215 30.4517C141.707 30.4517 139.694 32.5688 139.694 35.18C139.694 37.7911 141.707 39.9083 144.215 39.9083C146.723 39.9083 148.736 37.7911 148.736 35.18C148.736 32.5688 146.723 30.4517 144.215 30.4517Z"}),jsxRuntimeExports.jsx("path",{fill:"#4E7A38",d:"M195.219 59.633C194.583 59.1743 193.947 58.7156 193.311 58.2569C193.241 58.2216 193.205 58.1863 193.17 58.151C193.029 58.0452 192.888 57.904 192.711 57.7982C192.393 57.5512 192.075 57.3042 191.793 57.0572C190.556 56.0339 189.355 55.0106 188.19 53.9167C187.66 53.4227 187.201 52.8934 186.706 52.3994C186.706 52.3994 186.706 52.3994 186.671 52.3289C186.6 52.223 186.494 52.0819 186.424 51.976C186.247 51.6937 186.071 51.4114 185.894 51.0939C185.788 50.9174 185.717 50.741 185.647 50.5646C185.647 50.494 185.647 50.5293 185.611 50.494C185.611 50.4234 185.576 50.3529 185.541 50.3176C185.541 50.247 185.541 50.1764 185.541 50.1059C185.541 49.7177 185.576 49.2943 185.647 48.9061C185.647 48.8003 185.647 48.7297 185.647 48.6238C185.647 48.4121 185.717 48.2004 185.753 47.9887C186.071 46.0833 186.459 44.2131 186.954 42.343C187.271 41.2138 186.742 39.9435 185.753 39.3084C185.294 38.885 184.693 38.638 183.987 38.5674C183.21 38.4968 182.397 38.4615 181.62 38.3557C181.514 38.3557 181.479 38.3557 181.408 38.3557C181.267 38.3557 181.126 38.3204 180.984 38.2851C180.561 38.2145 180.172 38.144 179.748 38.0381C179.395 37.9322 179.006 37.8617 178.653 37.7205C178.477 37.65 178.3 37.5794 178.123 37.5441C178.123 37.5441 178.123 37.5441 178.053 37.5441C177.735 37.3677 177.382 37.2265 177.064 37.0148C176.922 36.909 176.781 36.8384 176.64 36.7325C176.569 36.662 176.11 36.4502 176.499 36.6267C176.852 36.8031 176.428 36.5914 176.357 36.5208C176.251 36.415 176.145 36.3091 176.004 36.2032C175.792 35.9915 175.58 35.7798 175.368 35.5328C175.262 35.427 175.156 35.2858 175.05 35.18C175.05 35.18 175.05 35.18 175.05 35.1447C174.909 34.933 174.803 34.7565 174.662 34.5448C174.415 33.5921 174.238 32.6394 174.026 31.6867C173.92 31.2279 173.708 30.8398 173.461 30.4869C173.214 29.6048 172.613 28.7932 171.624 28.5815C171.448 28.5462 171.271 28.5815 171.095 28.5462C170.953 28.5462 170.847 28.4756 170.741 28.4756C170.706 28.4756 170.671 28.4756 170.635 28.4756C168.092 28.2639 165.69 29.0402 163.183 29.5695C161.876 29.8518 160.534 30.0988 159.227 30.3105C158.944 30.3458 158.662 30.4164 158.379 30.4517C158.202 30.4517 157.99 30.5222 157.814 30.5222C158.061 30.4869 158.026 30.4869 157.708 30.5222C157.037 30.5575 156.401 30.5575 155.765 30.4869C154.352 30.3105 152.975 31.8631 153.046 33.2039C153.081 34.0508 153.434 34.7212 153.964 35.18C154.105 36.3091 154.529 37.5088 154.882 38.4615C154.882 38.6027 154.882 38.7085 154.882 38.885C155.589 42.5547 155.942 46.2597 155.977 49.9647C155.977 51.8349 155.871 53.6697 155.801 55.5399C155.73 57.0924 155.801 58.3627 157.037 59.4566C159.403 61.5385 162.935 61.2209 165.161 63.4086C167.28 65.4905 168.34 68.6662 168.657 71.5596C168.728 72.1595 168.975 72.6888 169.328 73.1475C169.399 73.2533 169.47 73.2886 169.54 73.3945C169.682 73.5709 169.858 73.7121 170.035 73.8179C170.106 73.8532 170.141 73.8885 170.212 73.9238C170.812 74.2766 171.483 74.3825 172.154 74.1708C172.154 74.1708 172.154 74.1708 172.189 74.1708C172.578 74.0649 173.002 73.9944 173.39 73.9238C173.496 73.9238 173.708 73.8885 173.744 73.8885C173.885 73.8885 174.026 73.8885 174.167 73.8885C174.379 73.8885 174.627 73.8885 174.839 73.8885C175.121 73.9591 175.439 74.0296 175.722 74.1355C175.757 74.1355 175.722 74.1355 175.757 74.1355C175.863 74.2061 176.004 74.2413 176.11 74.3119C176.393 74.4531 176.675 74.6295 176.958 74.8059C176.958 74.8059 177.134 74.9471 177.24 75.0176C177.346 75.0882 177.488 75.2294 177.488 75.2294C177.77 75.4764 178.017 75.6881 178.265 75.9351C178.794 76.4644 179.289 76.9936 179.748 77.5582C179.995 77.8405 180.207 78.1228 180.419 78.4051C180.419 78.4051 180.419 78.4404 180.49 78.4756C180.631 78.6521 180.737 78.8285 180.878 78.9696C181.903 80.3458 182.892 81.7219 183.916 83.1334C184.587 84.0508 185.47 84.5801 186.636 84.4389C187.66 84.2978 188.614 83.5568 188.896 82.5335C189.073 82.2865 189.249 82.0042 189.355 81.6867C189.815 80.1694 189.779 78.6168 189.815 77.0642C189.815 75.5469 189.921 74.0649 190.097 72.5829C190.38 70.3246 191.086 67.7488 192.464 65.7375C192.534 65.6316 192.57 65.4552 192.605 65.3493C192.923 65.1376 193.241 64.9612 193.559 64.7848C194.654 64.9259 195.89 64.3966 196.384 63.4439C197.126 62.0325 196.667 60.5857 195.395 59.7036L195.219 59.633ZM175.58 53.211C175.545 53.4933 175.51 53.7756 175.474 54.0579C175.545 53.7756 175.545 53.4933 175.58 53.211C175.828 53.2816 176.039 53.3169 176.287 53.3874C176.075 53.3169 175.828 53.2816 175.58 53.211Z"}),jsxRuntimeExports.jsx("path",{fill:"#D14247",d:"M169.823 157.022C172.808 157.022 175.227 154.494 175.227 151.376C175.227 148.258 172.808 145.73 169.823 145.73C166.838 145.73 164.419 148.258 164.419 151.376C164.419 154.494 166.838 157.022 169.823 157.022Z"}),jsxRuntimeExports.jsx("path",{fill:"#D14247",d:"M169.822 157.904C166.326 157.904 163.5 154.975 163.5 151.376C163.5 147.777 166.326 144.848 169.822 144.848C173.319 144.848 176.145 147.777 176.145 151.376C176.145 154.975 173.319 157.904 169.822 157.904ZM169.822 146.648C167.315 146.648 165.301 148.765 165.301 151.376C165.301 153.987 167.315 156.104 169.822 156.104C172.33 156.104 174.344 153.987 174.344 151.376C174.344 148.765 172.33 146.648 169.822 146.648Z"}),jsxRuntimeExports.jsx("path",{fill:"#D14247",d:"M109.283 198.977C112.268 198.977 114.687 196.449 114.687 193.331C114.687 190.213 112.268 187.685 109.283 187.685C106.298 187.685 103.879 190.213 103.879 193.331C103.879 196.449 106.298 198.977 109.283 198.977Z"}),jsxRuntimeExports.jsx("path",{fill:"#D14247",d:"M109.282 199.859C105.786 199.859 102.96 196.93 102.96 193.331C102.96 189.732 105.786 186.803 109.282 186.803C112.779 186.803 115.605 189.732 115.605 193.331C115.605 196.93 112.779 199.859 109.282 199.859ZM109.282 188.603C106.775 188.603 104.761 190.72 104.761 193.331C104.761 195.942 106.775 198.059 109.282 198.059C111.79 198.059 113.803 195.942 113.803 193.331C113.803 190.72 111.79 188.603 109.282 188.603Z"}),jsxRuntimeExports.jsx("path",{fill:"#D14247",d:"M103.879 185.674C106.863 185.674 109.283 183.146 109.283 180.028C109.283 176.91 106.863 174.382 103.879 174.382C100.894 174.382 98.4746 176.91 98.4746 180.028C98.4746 183.146 100.894 185.674 103.879 185.674Z"}),jsxRuntimeExports.jsx("path",{fill:"#D14247",d:"M103.879 186.556C100.418 186.556 97.5566 183.627 97.5566 180.028C97.5566 176.429 100.382 173.5 103.879 173.5C107.376 173.5 110.202 176.429 110.202 180.028C110.202 183.627 107.376 186.556 103.879 186.556ZM103.879 175.3C101.371 175.3 99.358 177.417 99.358 180.028C99.358 182.639 101.371 184.757 103.879 184.757C106.387 184.757 108.4 182.639 108.4 180.028C108.4 177.417 106.387 175.3 103.879 175.3Z"}),jsxRuntimeExports.jsx("path",{fill:"#D14247",d:"M95.0135 196.93C97.9981 196.93 100.418 194.402 100.418 191.284C100.418 188.166 97.9981 185.639 95.0135 185.639C92.0289 185.639 89.6094 188.166 89.6094 191.284C89.6094 194.402 92.0289 196.93 95.0135 196.93Z"}),jsxRuntimeExports.jsx("path",{fill:"#D14247",d:"M95.0129 197.812C91.5161 197.812 88.6904 194.884 88.6904 191.284C88.6904 187.685 91.5161 184.757 95.0129 184.757C98.5096 184.757 101.335 187.685 101.335 191.284C101.335 194.884 98.5096 197.812 95.0129 197.812ZM95.0129 186.556C92.5051 186.556 90.4918 188.673 90.4918 191.284C90.4918 193.896 92.5051 196.013 95.0129 196.013C97.5206 196.013 99.5339 193.896 99.5339 191.284C99.5339 188.673 97.5206 186.556 95.0129 186.556Z"}),jsxRuntimeExports.jsx("path",{fill:"#4E7A38",d:"M86.2884 189.873C86.2884 189.873 86.2178 189.908 86.2178 189.944C86.2178 189.944 86.2531 189.908 86.2884 189.873Z"}),jsxRuntimeExports.jsx("path",{fill:"#4E7A38",d:"M88.6907 185.145C88.1962 184.368 87.4898 183.945 86.7481 183.839C86.3596 183.345 85.9357 182.886 85.5472 182.498C85.1586 182.11 84.7701 181.757 84.3816 181.404C84.3109 181.263 84.2756 181.122 84.1343 180.981C81.7325 178.158 79.5779 175.194 77.6706 172.018C76.717 170.43 75.8339 168.807 74.9862 167.184C74.2798 165.808 73.75 164.15 72.2665 163.444C69.0877 161.891 65.8028 164.573 62.6593 164.185C59.3391 163.761 56.3721 161.009 54.5001 158.433C54.1469 157.975 53.6524 157.622 53.1226 157.375C52.946 157.304 52.8047 157.269 52.6281 157.234C52.4515 157.198 52.3102 157.163 52.1336 157.128C51.9924 157.128 51.8864 157.128 51.7804 157.128C50.9327 157.128 50.1557 157.445 49.6612 158.116C49.202 158.574 48.6369 159.139 48.2837 159.386C48.2837 159.386 47.7185 159.739 47.5419 159.845C47.4713 159.88 47.436 159.88 47.4006 159.915C47.224 159.986 47.0474 160.021 46.8708 160.056C46.8355 160.056 46.447 160.127 46.3763 160.162C46.0231 160.162 45.7052 160.162 45.352 160.162C45.352 160.162 44.8929 160.127 44.7869 160.127C44.3984 160.056 44.0452 159.986 43.6566 159.915C40.4424 159.139 37.7934 157.728 34.7558 156.422C33.6608 155.928 32.5306 155.857 31.5416 156.634C30.6586 157.339 30.1641 158.539 30.5173 159.668C30.5173 159.986 30.5173 160.339 30.5879 160.692C30.9764 162.315 31.8241 163.726 32.6365 165.173C33.3429 166.478 34.0494 167.819 34.6498 169.16C35.7094 171.524 36.4865 174.559 36.3452 177.241C36.3452 177.417 36.4159 177.594 36.4512 177.805C36.3099 178.123 36.1686 178.476 35.992 178.793C35.992 178.793 35.9567 178.864 35.9214 178.899C34.8617 179.358 34.0494 180.487 34.0847 181.616C34.1553 183.275 35.3562 184.368 36.981 184.51C40.3011 184.757 43.0915 185.145 46.4117 185.886C47.1534 186.062 47.8951 186.239 48.6016 186.521C48.7075 186.591 48.9901 186.697 48.9901 186.697C49.308 186.874 49.6259 187.05 49.9437 187.262C50.0144 187.297 50.4382 187.615 50.5442 187.685C50.7914 188.109 51.0034 188.567 51.2153 189.026C51.3213 189.273 51.3919 189.485 51.4979 189.732C52.2749 191.743 52.946 193.79 53.5111 195.872C53.829 197.071 55.0299 197.918 56.2309 197.953C56.8666 198.095 57.573 198.024 58.2088 197.671C58.9506 197.283 59.657 196.895 60.3987 196.507C60.5753 196.436 60.7519 196.33 60.9285 196.26C60.9285 196.26 61.1405 196.154 61.2464 196.119C61.3171 196.119 61.5643 195.977 61.5996 195.977C61.7762 195.907 61.9528 195.836 62.1648 195.766C62.5886 195.625 63.0125 195.483 63.4363 195.413C63.6129 195.378 63.8248 195.342 64.0014 195.272C64.0368 195.272 64.1074 195.272 64.1781 195.272C64.8491 195.201 65.4849 195.272 66.156 195.272C66.2973 195.272 66.4386 195.307 66.5446 195.342C66.8624 195.413 67.145 195.483 67.4276 195.589C67.5689 195.625 67.7101 195.695 67.8867 195.73C67.8867 195.73 68.0634 195.801 68.134 195.836C68.24 195.907 68.3812 195.942 68.4166 195.977C68.4519 195.977 68.5225 196.048 68.5578 196.048C69.3349 196.86 70.0413 197.777 70.8537 198.518C71.1363 198.8 71.4895 199.012 71.8427 199.153C72.5491 199.859 73.5734 200.282 74.5624 199.894C74.739 199.824 74.8803 199.718 75.0569 199.647C75.1628 199.577 75.3041 199.577 75.4101 199.506C75.4454 199.506 75.4807 199.435 75.516 199.4C76.6463 198.836 77.6706 198.165 78.589 197.283C79.5779 196.33 80.461 195.272 81.45 194.319C82.5096 193.26 83.6045 192.272 84.6995 191.284C84.9467 191.037 85.2293 190.79 85.5118 190.579C85.6178 190.473 86.0063 190.226 86.1829 190.014C86.077 190.085 85.971 190.12 86.1829 189.979C86.1829 189.979 86.2183 189.979 86.2536 189.944C86.3596 189.873 86.5008 189.767 86.6068 189.697C86.9247 189.485 87.2426 189.308 87.5958 189.167C88.9733 188.532 89.4325 186.415 88.6201 185.215L88.6907 185.145Z"}),jsxRuntimeExports.jsx("path",{fill:"#D14247",d:"M23.1355 72.5829C26.1201 72.5829 28.5396 70.0552 28.5396 66.9372C28.5396 63.8191 26.1201 61.2915 23.1355 61.2915C20.1509 61.2915 17.7314 63.8191 17.7314 66.9372C17.7314 70.0552 20.1509 72.5829 23.1355 72.5829Z"}),jsxRuntimeExports.jsx("path",{fill:"#D14247",d:"M23.1349 73.4651C19.6382 73.4651 16.8125 70.5363 16.8125 66.9372C16.8125 63.338 19.6382 60.4093 23.1349 60.4093C26.6317 60.4093 29.4574 63.338 29.4574 66.9372C29.4574 70.5363 26.6317 73.4651 23.1349 73.4651ZM23.1349 62.1736C20.6272 62.1736 18.6139 64.2908 18.6139 66.9019C18.6139 69.5131 20.6272 71.6302 23.1349 71.6302C25.6427 71.6302 27.656 69.5131 27.656 66.9019C27.656 64.2908 25.6427 62.1736 23.1349 62.1736Z"}),jsxRuntimeExports.jsx("path",{fill:"#D14247",d:"M10.3494 81.7925C13.334 81.7925 15.7535 79.2648 15.7535 76.1468C15.7535 73.0287 13.334 70.5011 10.3494 70.5011C7.36481 70.5011 4.94531 73.0287 4.94531 76.1468C4.94531 79.2648 7.36481 81.7925 10.3494 81.7925Z"}),jsxRuntimeExports.jsx("path",{fill:"#D14247",d:"M10.3488 82.6747C6.85204 82.6747 4.02637 79.7459 4.02637 76.1468C4.02637 72.5476 6.85204 69.6189 10.3488 69.6189C13.8456 69.6189 16.6712 72.5476 16.6712 76.1468C16.6712 79.7459 13.8456 82.6747 10.3488 82.6747ZM10.3488 71.4185C7.84102 71.4185 5.82773 73.5356 5.82773 76.1468C5.82773 78.7579 7.84102 80.8751 10.3488 80.8751C12.8566 80.8751 14.8699 78.7579 14.8699 76.1468C14.8699 73.5356 12.8566 71.4185 10.3488 71.4185Z"}),jsxRuntimeExports.jsx("path",{fill:"#D14247",d:"M20.2039 89.4495C23.1885 89.4495 25.608 86.9219 25.608 83.8038C25.608 80.6858 23.1885 78.1581 20.2039 78.1581C17.2193 78.1581 14.7998 80.6858 14.7998 83.8038C14.7998 86.9219 17.2193 89.4495 20.2039 89.4495Z"}),jsxRuntimeExports.jsx("path",{fill:"#D14247",d:"M20.2033 90.3317C16.7065 90.3317 13.8809 87.403 13.8809 83.8038C13.8809 80.2047 16.7065 77.2759 20.2033 77.2759C23.7001 77.2759 26.5257 80.2047 26.5257 83.8038C26.5257 87.403 23.7001 90.3317 20.2033 90.3317ZM20.2033 79.0755C17.6955 79.0755 15.6822 81.1927 15.6822 83.8038C15.6822 86.415 17.6955 88.5321 20.2033 88.5321C22.7111 88.5321 24.7244 86.415 24.7244 83.8038C24.7244 81.1927 22.7111 79.0755 20.2033 79.0755Z"}),jsxRuntimeExports.jsx("path",{fill:"#749561",d:"M144.25 23.9238C137.61 18.4192 133.089 11.3267 129.522 3.56386C128.744 1.90543 126.095 1.235 124.612 2.25829C118.501 6.4573 110.272 3.52858 104.373 0.423424C101.901 -0.846865 99.0749 0.740997 98.969 3.52858C98.757 9.66831 91.9401 11.8913 86.8539 12.6676C83.0746 13.2322 83.8163 18.5956 86.8539 19.5836C87.4544 19.7953 88.0195 20.0423 88.62 20.2893C92.5759 22.1595 95.896 25.8998 99.0749 28.7226C99.9933 29.5342 100.912 30.6281 102.113 30.9457C103.419 31.2985 104.726 30.7339 105.998 30.5222C108.364 30.1694 110.837 30.2399 113.203 30.6281C115.534 31.0515 117.83 31.7572 119.985 32.7452C122.457 33.8744 123.976 34.2272 126.413 32.9922C129.804 31.2279 133.336 30.2399 137.01 29.8871C138.422 29.8871 139.871 29.9577 141.283 30.0282C141.884 30.0635 142.484 29.8518 143.014 29.5342C145.275 28.6521 146.687 25.7939 144.321 23.8532L144.25 23.9238Z"}),jsxRuntimeExports.jsx("path",{fill:"#749561",d:"M198.397 99.8941C192.817 99.2943 191.157 91.8843 190.839 87.3677C190.839 87.2618 190.768 87.1912 190.768 87.0854C190.768 86.8737 190.697 86.6972 190.627 86.5208C189.673 83.2392 185.081 82.8511 183.774 86.415C183.563 87.0501 183.245 87.6147 182.962 88.2498C180.984 92.0254 177.346 95.1306 174.485 98.1651C173.567 99.1531 172.26 100.176 171.871 101.517C171.589 102.611 171.977 103.811 172.048 104.905C172.26 107.304 172.119 109.739 171.659 112.068C171.2 114.361 170.529 116.62 169.54 118.737C168.304 121.383 167.244 123.112 168.41 126.041C169.929 129.887 170.67 133.769 170.776 137.756C170.67 139.238 170.529 140.685 170.353 142.131C170.317 142.555 170.423 143.084 170.635 143.543C171.342 145.942 174.414 147.601 176.498 145.201C182.114 138.779 189.179 134.474 196.949 131.193C198.751 130.416 199.068 127.805 198.256 126.288C194.618 119.689 198.15 111.186 201.47 105.222C202.918 102.646 201.046 100.106 198.362 99.8236L198.397 99.8941Z"}),jsxRuntimeExports.jsx("path",{fill:"#749561",d:"M160.922 153.952C160.427 154.199 159.862 154.375 159.367 154.622C154.952 156.246 149.548 155.716 144.992 155.999C143.296 156.104 142.06 156.387 141.036 157.833C140.435 158.68 139.87 159.562 139.199 160.374C137.61 162.174 135.808 163.761 133.83 165.067C131.888 166.337 129.839 167.29 127.649 168.066C125.036 168.984 124.117 170.289 123.27 172.83C122.175 176.041 120.373 178.899 118.219 181.475C116.982 182.675 115.781 183.91 114.475 185.039C114.051 185.427 113.768 185.992 113.627 186.627C112.673 188.85 113.662 191.814 116.7 191.567C125.106 190.861 133.018 192.802 140.789 195.907C142.519 196.613 144.851 195.131 145.204 193.402C146.793 186.062 154.776 182.251 161.31 180.24C164.03 179.393 164.63 176.288 162.9 174.241C158.979 169.584 162.9 162.844 165.937 158.892C168.339 155.787 163.889 152.541 161.028 153.987L160.922 153.952Z"}),jsxRuntimeExports.jsx("path",{fill:"#D14247",d:"M31.2586 161.538C34.2432 161.538 36.6627 159.011 36.6627 155.893C36.6627 152.775 34.2432 150.247 31.2586 150.247C28.274 150.247 25.8545 152.775 25.8545 155.893C25.8545 159.011 28.274 161.538 31.2586 161.538Z"}),jsxRuntimeExports.jsx("path",{fill:"#D14247",d:"M31.259 162.421C27.7622 162.421 24.9365 159.492 24.9365 155.893C24.9365 152.294 27.7622 149.365 31.259 149.365C34.7557 149.365 37.5814 152.294 37.5814 155.893C37.5814 159.492 34.7557 162.421 31.259 162.421ZM31.259 151.129C28.7512 151.129 26.7379 153.246 26.7379 155.857C26.7379 158.469 28.7512 160.586 31.259 160.586C33.7667 160.586 35.78 158.469 35.78 155.857C35.78 153.246 33.7667 151.129 31.259 151.129Z"}),jsxRuntimeExports.jsx("path",{fill:"#D14247",d:"M187.413 90.12C190.397 90.12 192.817 87.5923 192.817 84.4743C192.817 81.3562 190.397 78.8285 187.413 78.8285C184.428 78.8285 182.009 81.3562 182.009 84.4743C182.009 87.5923 184.428 90.12 187.413 90.12Z"}),jsxRuntimeExports.jsx("path",{fill:"#D14247",d:"M187.412 91.0021C183.916 91.0021 181.09 88.0734 181.09 84.4742C181.09 80.8751 183.916 77.9464 187.412 77.9464C190.909 77.9464 193.735 80.8751 193.735 84.4742C193.735 88.0734 190.909 91.0021 187.412 91.0021ZM187.412 79.7459C184.905 79.7459 182.891 81.8631 182.891 84.4742C182.891 87.0854 184.905 89.2025 187.412 89.2025C189.92 89.2025 191.933 87.0854 191.933 84.4742C191.933 81.8631 189.92 79.7459 187.412 79.7459Z"})]}),jsxRuntimeExports.jsx("defs",{children:jsxRuntimeExports.jsx("clipPath",{id:"clip0_341_12",children:jsxRuntimeExports.jsx("rect",{fill:"white",height:"200",width:"202"})})})]});const BalloonIcon=({elClass:s,fillColor:a})=>jsxRuntimeExports.jsxs("svg",{id:"hot-air-balloon",className:s,viewBox:"0 0 158.19 231.28",width:"120",height:"120",fill:a,xmlns:"http://www.w3.org/2000/svg",children:[jsxRuntimeExports.jsx("path",{className:"cls-4",d:"M73.92,200.43h.56c3.01,4.37,8.53,3.78,11.49-.38,6.27,6.83,10.48,2.38,14.51-3.49,2.58-3.75,4.62-8.17,7.11-12.03,13.72-21.28,28.4-39.27,37.81-63.26,12.44-31.71,20.19-60.61,2.08-92.23C132.95,3.68,103.02-1.1,76,.19,43.7,1.74,5.49,27.12.85,60.94c-6.71,48.91,27.96,90.62,54.24,127.5,2.67,3.75,5.45,9.41,8.5,12.56,2.83,2.92,8.4,3.33,10.34-.57ZM92.29,208.09c-2.43.64-4.48,2.03-7.09,2.29-3.03.3-9.21.3-12.24,0-1.75-.17-3.37-.89-4.98-1.53-.61,0,.53,6.78.57,7.47.16,3.26-.49,7.16.49,10.22,1.99,6.19,12.43,5.19,17.22,3.27,2.1-.84,3.85-1.95,4.68-4.13.5-1.33,1.35-5.74,1.35-7.07v-10.53Z"}),jsxRuntimeExports.jsx("path",{className:"cls-1",d:"M73.92,200.43c-1.94,3.9-7.51,3.49-10.34.57-3.05-3.15-5.83-8.81-8.5-12.56C28.8,151.55-5.87,109.85.85,60.94,5.49,27.12,43.7,1.74,76,.19c27.01-1.29,56.95,3.49,71.48,28.85,18.12,31.62,10.36,60.53-2.08,92.23-9.41,23.99-24.09,41.98-37.81,63.26-2.49,3.86-4.53,8.28-7.11,12.03-4.03,5.87-8.25,10.31-14.51,3.49-2.95,4.16-8.48,4.75-11.49.38h-.56ZM95.74,189.71c1.37-.26,2.88.98,4.02,0,7.91-12.96,15.99-25.83,24.15-38.63,6.45-10.12,11.23-16.05,15.48-27.78,3.71-10.24,7.45-20.96,10.82-31.3,2.99-9.2,5.03-29.76,2.2-38.78-1.88-5.99-6-17.98-9.26-22.89-13.48-20.29-39.13-27.4-62.52-25.53-.44.04-1.72.12-1.72.76,14.85,3.05,28.41,7.21,38.27,19.35,20.96,25.78,20.01,60.9,13.67,91.75-3.1,15.06-11.84,31.54-19.34,44.98-5.23,9.37-11.7,18.08-15.76,28.07ZM70.47,5.57c-7.59-.21-15.85,3.05-22.72,6.18C20.51,24.14,2.18,44.25,3.84,75.83c2,38.05,27.58,78.67,50.95,107.54,1.27,1.57,4.02,5.5,5.31,6.55.59.48,2.27,1.07,1.94-.02-7.54-12.41-14.05-25.57-20.23-38.73-15.24-32.42-24.19-56.17-15.49-92.71,5.01-21.05,14.08-37.4,33.55-47.99l10.59-4.91ZM75.64,8.63v.38c.25-.13.25-.26,0-.38ZM88.04,190.43c6.95-20.69,15.84-40.82,20.16-62.34,5.72-28.57,6.33-67.27-8.05-93.43-5.71-10.4-12.71-14.35-20.88-22-.53-.5-2.92-3.81-3.44-3.26,6.45,19.69,11.4,39.68,13.73,60.34,2.83,25.05,3.67,52.51,1.96,77.66-.99,14.54-3.38,29.08-8.04,42.88l4.56.15ZM73.15,10.54v-.76h-.38v.76h.38ZM68.94,190.48h7.27c-3.64-12.23-6.18-24.73-7.98-37.38-5.99-42-6.61-89.5,1.98-131.14.64-3.11,2.23-7.16,2.53-10.11.06-.58.29-1.06-.54-.92-7.01,9.92-14.62,18.27-18.59,30.04-7.97,23.66-8.16,48.98-4.91,73.46,3.45,26.02,8.88,52.32,20.24,76.05Z"}),jsxRuntimeExports.jsx("path",{className:"cls-6",d:"M92.29,208.09v10.53c0,1.33-.85,5.75-1.35,7.07-.83,2.18-2.58,3.29-4.68,4.13-4.79,1.92-15.23,2.92-17.22-3.27-.98-3.06-.33-6.96-.49-10.22-.03-.69-1.17-7.48-.57-7.47,1.61.64,3.22,1.36,4.98,1.53,3.03.3,9.21.3,12.24,0,2.61-.26,4.65-1.66,7.09-2.29Z"}),jsxRuntimeExports.jsx("path",{className:"cls-5",d:"M88.04,190.43l-4.56-.15c4.66-13.79,7.05-28.34,8.04-42.88,1.71-25.15.88-52.61-1.96-77.66-2.34-20.66-7.29-40.65-13.73-60.34.52-.55,2.91,2.76,3.44,3.26,8.16,7.65,15.16,11.6,20.88,22,14.37,26.17,13.77,64.86,8.05,93.43-4.31,21.52-13.21,41.65-20.16,62.34Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M95.74,189.71c4.06-9.99,10.53-18.7,15.76-28.07,7.5-13.44,16.24-29.91,19.34-44.98,6.34-30.85,7.29-65.97-13.67-91.75-9.86-12.13-23.42-16.3-38.27-19.35,0-.65,1.27-.73,1.72-.76,23.39-1.87,49.05,5.24,62.52,25.53,3.26,4.91,7.38,16.91,9.26,22.89,2.84,9.01.8,29.57-2.2,38.78-3.36,10.34-7.11,21.05-10.82,31.3-4.25,11.73-9.03,17.67-15.48,27.78-8.17,12.8-16.25,25.67-24.15,38.63-1.14.98-2.65-.25-4.02,0Z"}),jsxRuntimeExports.jsx("path",{className:"cls-2",d:"M70.47,5.57l-10.59,4.91c-19.48,10.59-28.54,26.94-33.55,47.99-8.7,36.54.25,60.29,15.49,92.71,6.18,13.16,12.69,26.31,20.23,38.73.33,1.09-1.35.5-1.94.02-1.29-1.05-4.04-4.98-5.31-6.55C31.42,154.5,5.84,113.88,3.84,75.83,2.18,44.25,20.51,24.14,47.74,11.75c6.87-3.13,15.14-6.38,22.72-6.18Z"}),jsxRuntimeExports.jsx("path",{className:"cls-2",d:"M68.94,190.48c-11.35-23.73-16.78-50.03-20.24-76.05-3.25-24.49-3.06-49.8,4.91-73.46,3.96-11.77,11.58-20.12,18.59-30.04.82-.14.6.34.54.92-.3,2.95-1.89,7-2.53,10.11-8.58,41.64-7.97,89.14-1.98,131.14,1.81,12.65,4.34,25.15,7.98,37.38h-7.27Z"}),jsxRuntimeExports.jsx("rect",{className:"cls-2",x:"72.77",y:"9.78",width:".38",height:".76"}),jsxRuntimeExports.jsx("path",{className:"cls-5",d:"M75.64,8.63c.25.13.25.26,0,.38v-.38Z"})]});const DinoIcon=({elClass:s,fillColor:a})=>jsxRuntimeExports.jsxs("svg",{id:"dino",className:s,viewBox:"0 0 240 223.45",fill:a,width:"120",height:"120",xmlns:"http://www.w3.org/2000/svg",children:[jsxRuntimeExports.jsx("path",{className:"cls-8",d:"M29.72.05c7.6.75,9.45,6.97,10.74,13.39.74,3.69,1.87,8.7-1.87,11.2-2.31,1.54-5.35.07-7.5-1.11-.71-.39-3.55-2.5-3.93-2.56-.71-.11-1.62,3.04-1.95,3.73-5.15,10.53-8.84,19.91-9.18,31.88-.57,20.09,3,36.01,17.42,50.55,9.32,9.4,22.11,10.92,34.83,11.05,20.59-1.87,52.34-4.11,70.07,8.43,7.69,5.44,14.99,12.46,22.51,18.07,3.37,2.51,9.31,5.5,13.18,7.47,18.76,9.51,48.55,8.25,61.92,25.97,4.44,5.88,5.48,19.64,1.77,25.94-5.93,10.04-20.63,17.79-32.11,18.56-2.35.16-4.85-.12-7.21,0-3.97.19-12.48,1.71-15.96.13-.62-.28-1.11-.56-.33-1.05,15.25-2.61,34.47-8.74,37.25-26.39,1.03-6.52.66-11.88-4.99-16-4.15-3.03-5.4-2.31-10.19-2.54-1.08-.05-2.56-.49-3.6-.5-7.85-.02-13.68,2.1-22.02.66-9.71-1.67-18.46-5.63-26.83-10.63-2.47-1.47-3.48-3.26-6.85-2.73-2.04.32-4.08,4.75-4.42,6.62-1.09,6.06.8,11.81.44,17.97-.04.72-.38,1.48-.45,2.19-.3,3.1-.59,8.18-2.9,10.54-3.61,3.7-9.28,3.51-13.7,1.43-5.96-2.81-1.22-10.01.12-14.28,1.39-4.44,2.45-10.87,1.77-15.46-.17-1.15-.41-3.1-1.41-3.75-.19,2.93-1.75,5.47-2.65,8.28-1.22,3.84-2.08,8.11-2.8,12.09-.65,3.61-.89,9.29-1.92,12.48-1.47,4.53-7.93,4.73-11.8,3.73-1.44-.37-4.82-2.21-5.21-3.67-.72-2.71,2.32-6.81,3.36-9.38,1.6-3.94,2.15-8.34.82-12.45-6.55,1.11-13.17,1.24-19.78,1.9-4.71-.06-9.72-.01-14.39-.52-3.71-.4-7.38-1.43-11.08-1.91l-.38.17c-.33.95-.96,1.79-.96,2.85,0,6.02,2.57,15.32,1.06,20.96-.45,1.66-.85,2.43-2.47,3.05-2.88,1.11-5.76.8-8.74.32-2.66-.43-3.81-.4-4.6-3.33-2.62,3-6.19,5.4-9.88,6.93-2.44,1.01-2.83,1.32-4.64-.81-2.14-2.51-5.52-7.78-6.38-10.91-.9-3.3,3.8-4.74,5.73-6.29,5.65-4.53,9.26-18.33,8.26-25.23-.2-1.36-2.9-6.44-3.77-7.75-11.44-17.26-24.14-29.64-28.47-51.01C-.04,90.15-.89,69.54.9,51.07,2.45,35.1,7.26,12.15,20.99,2.25,22.26,1.33,25.51.22,27.08.05c.7-.07,1.94-.07,2.64,0ZM33.65,4.04c-3.34-2.55-8.13-1.9-11.6.23-7.42,4.56-12.34,18.34-14.92,26.38-4.08,12.72-5.01,29.8-5.52,43.22-.22,5.76.83,11.78,1.77,17.46,3.62,21.9,7.22,36.28,21.2,53.95,7.39,9.33,14.13,14.53,13.31,27.77-.43,6.99-4.15,16.1-9.5,20.75-2.99,2.6-5.26,2.11-3.28,7.13.65,1.65,3.87,6.58,5.4,7.33,1.71.84,3.07.06,4.57-.82,6.29-3.68,17.21-19.47,20.06-26.28.42-1.01.63-3.31.81-3.64.05-.09,1.46-1.17,1.56-1.2,1.29-.39,1.75.43,2.65.62,8.79,1.79,19.33,2.87,28.28,2.21,10.11-.74,21.36-1.15,29.78-7.45,1.44-1.07,2.87-2.25,4.32-3.36.65-.49.74-1.08,1.68-1.21,2.37-.32,2.87,1.73,3.38,3.61,2,7.48-.88,16.3-3.18,23.47-.78,2.43-2.43,3.79.17,5.94,1.53,1.27,4.89,1.54,6.85,1.51,3.34-.07,6.31-5.02,6.59-8.03.09-.92.19-1.71.27-2.59.6-6.48-1.01-12.62.06-18.91.91-5.35,3.02-11.56,9.43-11.73,7.25,2.79,13.89,7.21,21.08,10.14,2.61,1.06,6.83,2.49,9.53,3.2,6.25,1.65,13.02-.11,19.32-.37,5.97-.25,14.85.49,19.46,4.58,6.62,5.87,6.59,13.53,4.27,21.54-2.93,10.12-11.56,15.67-21.12,18.74l-2.95,1.48c3.19-.51,5.96.16,9.21-.27,11.73-1.56,25.54-8.62,29.52-20.43,2.46-7.31,1.81-12.8-2.27-19.23-8.13-12.81-31.26-15.89-44.92-19.68-10.54-2.93-22.16-7.41-31.39-13.28-.97-.62-4.99-3.78-5.47-3.9-.18-.04-.36-.08-.54-.03-.56,3.31-3.3,6.28-6.91,5.09-.5-.16-2.39-1.66-2.71-2.09-.57-.79-.44-1.69-.85-2.27-.25-.35-1.22-.92-1.67-1.45-3-3.56-.36-7.06,3.96-5.77-2.42-1.85-4.19-4.95-7.33-2.16-1.5,1.33-1.8,2.87-2.89,4.31-2.09,2.76-7,3.28-9.47.62-1.49-1.61-1.68-3.88-2.63-5.24-.19-.27-2.07-1.08-2.66-1.73-3.22-3.5,1.22-6.64,4.55-7.1.5-.79-1.25-1.1-1.73-1.25-.98-.31-5.85-1.66-6.44-1.27-.27,1.08.18,1.36-.61,2.52-1.16,1.72-2.95,1.89-4.07,2.89-.49.43-.63,1.27-1.07,1.81-2.06,2.53-3.93,3.19-6.97,1.69-1.09-.54-1.56-1.33-2.41-1.91-2.41-1.66-5.88-.23-7.37-3.65.21-1.1-.07-2.19-.07-3.34,0-.57.52-1.59.02-1.92-.79-.53-5.07.19-6.26.13.17,1.65,1.8,2.38.59,4.31-1.69,2.7-3.66,1.47-5.94,1.98-1.74.39-2.05,1.99-5.3,1.85-5.09-.23-2.89-3.88-2.32-7.18-8.05-.35-15.93.14-23.78-2.04-13.39-3.73-20.24-11.72-27.24-23.19-12.23-20.05-10.73-44.32-2.49-65.59,1.62-4.19,4.01-7.55,6.27-11.38.54-.46,1.19-.74,1.9-.5,2.32,1.72,7.94,5.71,10.52,2.95,1.62-1.73,1.01-4.28.64-6.43-.71-4.11-1.66-8.92-5.13-11.57ZM111.79,124.6c.37-.38.42-1.62.18-2.1-.69-1.41-4.21-.84-5.52-.96-2.32-.22-4.65-.75-6.97-.96-.91-.08-4.55-.42-5.06-.02-.94,1.42-.93,4.45.5,5.55,1.17.9,3.94.74,5.58,1.63,1.85,1,1.91,3.13,4.74,2.68,1.94-.31,1.33-2.34,2.29-3.47.88-1.04,3.42-1.46,4.27-2.34ZM74.68,127.01c.53.47,2.45.23,3.12,0,.98-.34,1.36-1.28,2.09-1.51,1.4-.43,3.85.48,4.83-1.18.7-1.19-.91-1.69-.85-3.02l-.28-.2c-2.58-.25-5.03.65-7.6.69-.75.98-1.87,2.36-1.8,3.66.01.25.34,1.44.48,1.56ZM135.59,130.94c-.14-.25-4.6-2.97-5.01-3.05-.75-.15-1.47.96-2.93.81s-3.14-2.04-4.17-2.1c-1.32-.09-3.87,1.23-3.97,2.76-.14,2.28,2.91,2.64,3.83,3.88,1.4,1.89.41,5.33,4.25,5.37,3.41.04,3.4-2.72,4.91-4.69.49-.64,1.3-1.16,1.94-1.66.39-.3,1.57-.56,1.15-1.31ZM141.08,137.91c-.84.25-1.07,2.16-.84,2.91.3,1.02,2.56,1.91,3.18,2.58.7.75.57,2.71,1.74,3.06,1.99.59,4.1-2.37,4.11-4.15,0-1.49-1.43-2.95-2.78-3.42-.69-.24-4.94-1.12-5.41-.98ZM120.01,173.4c-.25-.27-4.45,2.47-5.04,2.76-2.91,1.48-6.18,2.57-9.37,3.24v.36c.37.31.56.49.7.98,2.08,7.08.64,10.55-2.5,16.67-.7,1.36-2.09,2.63-1.77,4.28,1.04.3,2.01,1.12,3.03,1.41,1.5.43,5.32.75,6.71.12,1.56-.7,2.46-3.5,2.88-5.05,1.21-4.52,1.58-9.6,2.58-14.22.77-3.58,2.04-6.98,2.77-10.55ZM55.89,185.41c-.45-.11-.46.15-.68.4-.68.78-1.12,2.1-1.77,3.04-1.62,2.35-3.75,4.75-5.52,7.2-.69.96-3.73,4.51-3.77,5.31-.09,2.27,1.53,3.1,3.48,3.46,3.03.57,7.83.5,8.68-3.27,1.13-5-.31-11.09-.42-16.15Z"}),jsxRuntimeExports.jsx("path",{className:"cls-2",d:"M33.65,4.04c3.46,2.65,4.42,7.45,5.13,11.57.37,2.15.97,4.69-.64,6.43-2.58,2.76-8.19-1.23-10.52-2.95-.71-.24-1.36.04-1.9.5-2.26,3.83-4.65,7.19-6.27,11.38-8.24,21.27-9.75,45.54,2.49,65.59,7,11.47,13.85,19.46,27.24,23.19,7.84,2.18,15.73,1.69,23.78,2.04-.57,3.3-2.78,6.95,2.32,7.18,3.24.15,3.56-1.46,5.3-1.85,2.29-.51,4.25.72,5.94-1.98,1.21-1.93-.42-2.66-.59-4.31,1.19.06,5.47-.67,6.26-.13.5.34-.02,1.36-.02,1.92,0,1.16.28,2.24.07,3.34,1.49,3.42,4.96,1.98,7.37,3.65.84.58,1.31,1.38,2.41,1.91,3.05,1.5,4.92.84,6.97-1.69.44-.54.59-1.38,1.07-1.81,1.12-.99,2.91-1.16,4.07-2.89.78-1.16.33-1.44.61-2.52.59-.39,5.46.96,6.44,1.27.48.15,2.23.46,1.73,1.25-3.33.45-7.77,3.6-4.55,7.1.59.64,2.47,1.46,2.66,1.73.95,1.36,1.14,3.63,2.63,5.24,2.47,2.66,7.38,2.15,9.47-.62,1.09-1.44,1.39-2.98,2.89-4.31,3.14-2.79,4.91.32,7.33,2.16-4.33-1.29-6.97,2.2-3.96,5.77.45.53,1.42,1.11,1.67,1.45.41.58.28,1.48.85,2.27.31.43,2.21,1.93,2.71,2.09,3.61,1.19,6.35-1.78,6.91-5.09.18-.05.36,0,.54.03.48.12,4.5,3.28,5.47,3.9,9.23,5.87,20.85,10.35,31.39,13.28,13.66,3.79,36.79,6.86,44.92,19.68,4.08,6.43,4.74,11.92,2.27,19.23-3.98,11.81-17.79,18.87-29.52,20.43-3.25.43-6.02-.24-9.21.27l2.95-1.48c9.56-3.07,18.19-8.61,21.12-18.74,2.32-8.02,2.35-15.67-4.27-21.54-4.6-4.08-13.48-4.83-19.46-4.58-6.3.26-13.07,2.02-19.32.37-2.7-.71-6.92-2.14-9.53-3.2-7.19-2.93-13.83-7.35-21.08-10.14-6.4.17-8.52,6.38-9.43,11.73-1.07,6.29.54,12.43-.06,18.91-.08.88-.18,1.67-.27,2.59-.28,3.01-3.24,7.96-6.59,8.03-1.96.04-5.31-.23-6.85-1.51-2.6-2.15-.95-3.51-.17-5.94,2.3-7.17,5.18-16,3.18-23.47-.5-1.88-1.01-3.93-3.38-3.61-.94.13-1.03.71-1.68,1.21-1.45,1.11-2.89,2.29-4.32,3.36-8.41,6.3-19.66,6.7-29.78,7.45-8.95.66-19.49-.43-28.28-2.21-.9-.18-1.35-1.01-2.65-.62-.09.03-1.51,1.12-1.56,1.2-.18.32-.39,2.63-.81,3.64-2.86,6.81-13.77,22.6-20.06,26.28-1.5.88-2.86,1.66-4.57.82-1.52-.75-4.75-5.68-5.4-7.33-1.98-5.03.29-4.54,3.28-7.13,5.35-4.65,9.07-13.76,9.5-20.75.82-13.24-5.93-18.43-13.31-27.77C10.6,127.61,7,113.24,3.38,91.33c-.94-5.68-1.99-11.7-1.77-17.46.52-13.42,1.45-30.5,5.52-43.22,2.58-8.04,7.5-21.82,14.92-26.38,3.47-2.13,8.26-2.79,11.6-.23ZM28.69,9.22c-2.09.44-2,3.72.18,3.58s2.25-4.1-.18-3.58ZM37.83,117.99c-1.68.23-3,1.9-2.93,3.59.12,2.63,2.56,3.61,3.24,5.35.97,2.49-.29,5.77,2.51,7.82,5.14,3.76,11.21-5.48,8.58-10.02-.35-.6-6.61-4.7-7.67-5.3s-2.57-1.6-3.73-1.44ZM64.72,124.71c-.65.13-1.35.72-2.28.85-1.54.22-2.81-.3-4.22.58-1.08.67-2.86,3.38-3.02,4.66-.3,2.31.92,2.8,1.67,4.54,1.49,3.48.68,7.96,5.66,8.5,5.91.64,6.71-4.52,6.03-9.15-.33-2.22-.46-2.52-.41-4.86.04-1.97-.72-5.67-3.43-5.13ZM91.57,132.93c-.79-.54-1.08-1.07-2.1-1.39-3.05-.95-6.38-.32-8.85,1.63s-1.57,3.86-2.33,6.32c-.54,1.76-1.63,2.22-1.1,4.33.57,2.29,3.25,3.5,5.46,3.15,2.09-.33,4.08-3.19,6.13-3.71,1.63-.42,3.08.26,4.67.1,3.72-.36,6.72-3.66,4.72-7.3-1.32-2.39-4.64-1.79-6.6-3.13ZM107.95,136.72c-3.12.5-3.98,3.61-1.97,5.93.65.75,1.86,1.32,2.52,2.04.87.97,1.22,2.54,2.56,3.2,2.15,1.05,5.58-1.32,6.02-3.48.15-.74.18-2.7-.17-3.32-.12-.22-3.54-2.83-3.93-3.04-1.07-.57-3.88-1.52-5.03-1.33Z"}),jsxRuntimeExports.jsx("path",{className:"cls-2",d:"M120.01,173.4c-.73,3.58-2,6.98-2.77,10.55-1,4.62-1.38,9.71-2.58,14.22-.41,1.55-1.32,4.34-2.88,5.05-1.39.63-5.22.3-6.71-.12-1.02-.29-1.99-1.11-3.03-1.41-.33-1.65,1.07-2.92,1.77-4.28,3.14-6.12,4.58-9.6,2.5-16.67-.14-.49-.33-.67-.7-.98v-.36c3.19-.67,6.46-1.76,9.37-3.24.59-.3,4.79-3.03,5.04-2.76Z"}),jsxRuntimeExports.jsx("path",{className:"cls-10",d:"M55.89,185.41c.11,5.06,1.55,11.15.42,16.15-.85,3.77-5.65,3.84-8.68,3.27-1.94-.37-3.57-1.19-3.48-3.46.03-.8,3.07-4.36,3.77-5.31,1.77-2.46,3.9-4.85,5.52-7.2.65-.94,1.09-2.26,1.77-3.04.21-.25.23-.51.68-.4Z"}),jsxRuntimeExports.jsx("path",{className:"cls-12",d:"M111.79,124.6c-.84.87-3.39,1.3-4.27,2.34-.96,1.13-.35,3.16-2.29,3.47-2.83.45-2.89-1.67-4.74-2.68-1.64-.89-4.41-.73-5.58-1.63-1.43-1.1-1.43-4.13-.5-5.55.52-.39,4.15-.06,5.06.02,2.32.21,4.65.74,6.97.96,1.31.12,4.84-.45,5.52.96.23.48.19,1.72-.18,2.1Z"}),jsxRuntimeExports.jsx("path",{className:"cls-12",d:"M135.59,130.94c.43.75-.76,1-1.15,1.31-.64.5-1.45,1.02-1.94,1.66-1.51,1.96-1.51,4.72-4.91,4.69-3.84-.04-2.85-3.49-4.25-5.37-.92-1.23-3.97-1.59-3.83-3.88.1-1.53,2.65-2.84,3.97-2.76,1.03.07,2.77,1.96,4.17,2.1s2.18-.96,2.93-.81c.41.08,4.86,2.8,5.01,3.05Z"}),jsxRuntimeExports.jsx("path",{className:"cls-12",d:"M141.08,137.91c.47-.14,4.73.74,5.41.98,1.35.47,2.78,1.93,2.78,3.42,0,1.79-2.11,4.75-4.11,4.15-1.17-.35-1.05-2.31-1.74-3.06-.62-.67-2.88-1.57-3.18-2.58-.23-.76,0-2.66.84-2.91Z"}),jsxRuntimeExports.jsx("path",{className:"cls-7",d:"M74.68,127.01c-.14-.12-.47-1.32-.48-1.56-.07-1.3,1.05-2.68,1.8-3.66,2.57-.04,5.02-.94,7.6-.69l.28.2c-.06,1.33,1.55,1.83.85,3.02-.98,1.66-3.42.74-4.83,1.18-.73.23-1.11,1.17-2.09,1.51-.67.23-2.59.48-3.12,0Z"}),jsxRuntimeExports.jsx("path",{className:"cls-5",d:"M91.57,132.93c1.95,1.33,5.28.74,6.6,3.13,2.01,3.64-1,6.94-4.72,7.3-1.59.15-3.03-.52-4.67-.1-2.05.53-4.04,3.38-6.13,3.71-2.21.35-4.89-.86-5.46-3.15-.53-2.11.56-2.57,1.1-4.33.76-2.45-.02-4.46,2.33-6.32,2.47-1.96,5.8-2.58,8.85-1.63,1.02.32,1.31.85,2.1,1.39ZM84.65,132.89c-1.56.22-2.4.84-3.01,2.28-.92,2.17-1.53,4.96-2.41,7.21.24,1.34.77,2.48,2.25,2.67,3.46.46,3.76-2.81,6.45-3.59.8-.23,3.01-.49,3.85-.49,1.34,0,1.74.84,3.22.11,1.65-.81,2.58-2.91.83-4.14-.84-.59-2.59-1.01-3.69-1.59-2.74-1.44-3.87-2.98-7.5-2.46Z"}),jsxRuntimeExports.jsx("path",{className:"cls-4",d:"M64.72,124.71c2.71-.54,3.48,3.16,3.43,5.13-.05,2.34.08,2.64.41,4.86.68,4.64-.13,9.8-6.03,9.15-4.99-.54-4.17-5.03-5.66-8.5-.75-1.74-1.96-2.23-1.67-4.54.16-1.28,1.95-3.99,3.02-4.66,1.41-.88,2.68-.36,4.22-.58.93-.13,1.63-.73,2.28-.85ZM63.51,127.12c-.9.19-1.5,1.12-2.08,1.28-1.01.27-2.85-.91-3.82.97-1.22,2.37.93,5.83,1.76,8.02.57,1.51.48,3.51,1.97,4.51,1.94,1.3,3.45.54,4.77-1.16,2.21-2.84.64-5.15.36-8.05-.21-2.14.77-6.36-2.95-5.58Z"}),jsxRuntimeExports.jsx("path",{className:"cls-9",d:"M37.83,117.99c1.16-.16,2.71.86,3.73,1.44s7.32,4.7,7.67,5.3c2.63,4.54-3.44,13.78-8.58,10.02-2.79-2.05-1.53-5.33-2.51-7.82-.68-1.74-3.12-2.72-3.24-5.35-.08-1.69,1.25-3.36,2.93-3.59ZM38.06,119.9c-.87.25-1.49,2.07-1.33,2.9.3,1.58,2.22,2.6,2.78,3.72.96,1.91.27,5.04,2.23,6.41,1.81,1.27,4,.42,5.13-1.32,1.88-2.91.51-6.29-1.91-8.38-1.12-.96-5.59-3.7-6.9-3.33Z"}),jsxRuntimeExports.jsx("path",{className:"cls-6",d:"M107.95,136.72c1.16-.18,3.97.76,5.03,1.33.39.21,3.8,2.82,3.93,3.04.36.62.32,2.58.17,3.32-.44,2.16-3.86,4.53-6.02,3.48-1.34-.66-1.69-2.23-2.56-3.2-.66-.73-1.87-1.3-2.52-2.04-2.01-2.32-1.16-5.43,1.97-5.93ZM107.69,138.64c-.94.28-.69,1.6-.46,2.29.44,1.33,1.87,1.65,2.57,2.72.37.57.39,1.33.86,1.78,2.15,2.04,6.73-1.41,3.36-4.56-1.21-1.13-4.71-2.71-6.32-2.23Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M28.69,9.22c2.43-.51,2.41,3.44.18,3.58s-2.28-3.14-.18-3.58Z"}),jsxRuntimeExports.jsx("path",{className:"cls-11",d:"M84.65,132.89c3.62-.52,4.76,1.02,7.5,2.46,1.1.58,2.85,1,3.69,1.59,1.75,1.23.82,3.33-.83,4.14-1.48.73-1.88-.11-3.22-.11-.84,0-3.06.26-3.85.49-2.69.78-2.99,4.05-6.45,3.59-1.48-.19-2.01-1.34-2.25-2.67.88-2.25,1.49-5.04,2.41-7.21.61-1.43,1.44-2.05,3.01-2.28Z"}),jsxRuntimeExports.jsx("path",{className:"cls-11",d:"M63.51,127.12c3.72-.78,2.74,3.45,2.95,5.58.28,2.9,1.85,5.21-.36,8.05-1.32,1.7-2.83,2.45-4.77,1.16-1.49-1-1.4-3-1.97-4.51-.83-2.19-2.98-5.66-1.76-8.02.97-1.88,2.81-.7,3.82-.97.58-.16,1.19-1.1,2.08-1.28Z"}),jsxRuntimeExports.jsx("path",{className:"cls-12",d:"M38.06,119.9c1.31-.38,5.79,2.36,6.9,3.33,2.41,2.08,3.79,5.47,1.91,8.38-1.13,1.74-3.31,2.59-5.13,1.32-1.96-1.37-1.27-4.51-2.23-6.41-.56-1.12-2.48-2.14-2.78-3.72-.16-.83.46-2.65,1.33-2.9Z"}),jsxRuntimeExports.jsx("path",{className:"cls-1",d:"M107.69,138.64c1.61-.48,5.11,1.1,6.32,2.23,3.37,3.15-1.21,6.6-3.36,4.56-.47-.45-.49-1.21-.86-1.78-.69-1.06-2.12-1.39-2.57-2.72-.23-.69-.48-2.01.46-2.29Z"})]});const FlowerIcon=({elClass:s,fillColor:a})=>jsxRuntimeExports.jsxs("svg",{id:"flower",className:s,viewBox:"0 0 210.34 221.58",fill:a,width:"120",height:"120",xmlns:"http://www.w3.org/2000/svg",children:[jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M109.62,160.2l-4.92-15.88c.16-.67,1.73-.35,2.27-.46,10.77-2.06,7.06-10.27,10.84-16.94,2.14-3.78,6.82-6.91,9.62-10.27,5.57-6.68,5.64-15.96,7.22-24.11l-.13-.41c-1.77-1.73-2.19,2.25-2.74,3.54-4.28,9.93-15.89,12.27-23.29,18.66-7.47,6.45-2.9,14.62-7.02,21.04-1.1,1.72-1.77-.72-2.18-1.76-5.21-13.15-1.84-28.91,3.62-41.47,1.25-2.88,3.67-3.57,6.55-4.34,11.81-3.16,32.08-.13,38.65-13.64,3.43-7.05-.1-8.81-.88-14.64-.65-4.85,3.24-6.89,5.91-10.02,8.91-10.42,7.19-22.43-4.89-29.14-8.97-4.98-14.32-.12-23.02-.95-5.99-.57-8.09-6.3-11.57-10.22-7.78-8.74-23.91-14.19-31.67-2.51-5.22,7.87-2.04,17.62-11.84,23.03-5.41,2.99-18.42,6.11-19.15,13.26-.35,3.45,2.14,11.7,5.08,13.71,2.25,1.53,5.44,1.86,7.17,4.27,3.86,5.36-4.5,13.23,2.72,19.34,8.15,6.89,17.23-.32,24.77,3.83,1.18.65,7.08,5.06,7.34,6.03.35,1.29-1.98,5.71-2.34,7.36-.25,1.13-.18,2.56-.42,3.67-.85,3.97-2.05,7.86-2.38,11.92l-2.31-3.54c-7.71-7.83-22.69-6.04-29.18-15.49-1.46-2.12-3.68-9.56-5.74-10.06-.22-.05-.41-.07-.63-.05.81,3.24,1.07,6.86.81,10.21-.34,4.44-1.63,5.05.32,9.77,3.97,9.66,8.82,13.73,19.24,15.35,5.64.88,11.19-1.2,16.2,1.23,2.14,1.04,1.47,3.27,1.9,5.18,1.37,6.04,4.44,11.26,6.74,16.95,3.68,11.02,5.71,22.85,3.95,34.47l-.96.27c-2.16-9.25-4.81-19.56-9.69-27.76-5.16-8.67-15.32-15.31-25.06-17.71-9.86-2.43-15.38,2.51-22.13-7.83-2.58-3.95-5.91-11.63-6.03-16.33-.04-1.68.57-4,.55-5.67-.06-4.72-4.64-9.77-9.41-9.96-8.97-.35-7.64,9.61-13.09,13.63-2.93,2.16-6.98,1.93-10.21,3.41-5.76,2.65-10.32,10.76-7.31,16.84,1.24,2.5,4.97,5.55,5.38,8.24.85,5.56-4.86,9.5-3.17,15.97,1.44,5.5,9.59,8.74,14.76,8.68,2.95-.03,5.73-2.47,8.03.12,2.68,3.01,2.77,8.51,8.31,8.03,11.65-1,10.07-23.88,16.88-30.79,5.45-5.53,17.61-1.74,23.58,1.5,17.32,9.4,22.54,29.1,24.23,47.4.71,7.6.26,15.42,2.72,22.74l-1.47-1.65c-5.07-8.78-14.15-16-24.82-15.24-5.9.42-11.02,3.76-17.09,1.58-6.57-2.36-9.87-11.23-15.64-15.14-6.4-4.35-14.61-4.84-20.51.63l4.76,2.86c3.82,3.1,3.14,3.91,4.03,8.22,3.63,17.58,9.92,31.15,30.03,32.35,13.23.79,21.71-5.91,33.57-7.55,5.47-.76,9.67,1.72,14.92.21,3.14-.91,5.13-2.23,8.7-2.47,12.55-.84,23.44,6.43,35.83-.66,18.02-10.33,12.97-33.18,26.27-45.36.32-.3,2.79-1.75,2.32-2.17-2.7.18-5.67-.8-8.3-.83-7.63-.11-19.62,5.08-25.35,10.09-6.28,5.5-8.92,14.75-18.05,16.54-3.34.66-6.84.4-10.13,1.31-6.4,1.76-13.72,9.64-14.99,16.2-.67-.46-.77-2.3-.83-3.12-.24-3.68.11-7.38,1.1-10.91.52-1.88,2.1-4.79,2.35-6.39.11-.66-.22-1.13-.12-1.71.17-.97.8-2.12.77-3.21l.54.28c.68-3.46,1.03-7,2.04-10.35.86-2.86,2.32-5.49,2.87-8.44l.54.54c-.53-1.25.22-1.4.26-1.56,3.49-15.39,15.29-24.09,29.06-30.27,3.43-1.54,12.24-5.32,15.7-4.61,1.17.24,3.59,1.87,4.92,2.44,2.79,1.19,5.56,1.67,7.82,3.89,4.78,4.69,8.7,21.6,17.82,14.03,2.44-2.03,2.2-3.84,3.73-6.08,3.01-4.4,10.51-3.87,14.34-10.45,5.27-9.06-3.71-11.6-3.73-18.98-.01-6.23,3.72-11.49-1.12-17.46s-11.64-2.06-16.7-5.64c-4.68-3.3-7.1-12.66-13.4-13.3-9.08-.92-14.32,6.75-14.04,15.13.19,5.52,2.75,12.08,2.46,17.41-.11,2.11-3.07,8.34-4.12,10.59-3.35,7.18-7.06,6.32-12.94,9.66-1.24.7-2.17,1.76-3.27,2.45-3.74,2.36-8.12,3.62-11.99,5.72-9.14,4.95-16,13.88-19.18,23.71h-1.03Z"}),jsxRuntimeExports.jsx("path",{className:"cls-6",d:"M109.62,160.2h1.03c3.18-9.84,10.05-18.76,19.18-23.71,3.87-2.1,8.25-3.35,11.99-5.72,1.09-.69,2.03-1.75,3.27-2.45,5.88-3.34,9.59-2.48,12.94-9.66,1.05-2.25,4.01-8.48,4.12-10.59.29-5.33-2.28-11.89-2.46-17.41-.28-8.38,4.96-16.05,14.04-15.13,6.29.64,8.72,9.99,13.4,13.3,5.06,3.57,11.81-.38,16.7,5.64s1.11,11.22,1.12,17.46c.02,7.38,9,9.92,3.73,18.98-3.83,6.58-11.33,6.05-14.34,10.45-1.53,2.24-1.29,4.05-3.73,6.08-9.12,7.56-13.04-9.35-17.82-14.03-2.26-2.22-5.04-2.7-7.82-3.89-1.33-.57-3.75-2.2-4.92-2.44-3.46-.71-12.27,3.07-15.7,4.61-13.77,6.18-25.57,14.89-29.06,30.27-.04.16-.79.3-.26,1.56l-.54-.54c-.55,2.95-2.01,5.58-2.87,8.44-1.01,3.36-1.36,6.9-2.04,10.35l-.54-.28c.02,1.08-.61,2.23-.77,3.21-.1.57.23,1.04.12,1.71-.26,1.6-1.83,4.51-2.35,6.39-.98,3.54-1.34,7.23-1.1,10.91.05.82.15,2.66.83,3.12,1.27-6.56,8.59-14.44,14.99-16.2,3.29-.91,6.79-.65,10.13-1.31,9.13-1.79,11.77-11.04,18.05-16.54,5.72-5.01,17.71-10.19,25.35-10.09,2.63.04,5.59,1.01,8.3.83.47.42-2,1.87-2.32,2.17-13.3,12.18-8.25,35.04-26.27,45.36-12.39,7.1-23.28-.17-35.83.66-3.57.24-5.55,1.56-8.7,2.47-5.25,1.52-9.44-.97-14.92-.21-11.87,1.64-20.34,8.34-33.57,7.55-20.11-1.2-26.4-14.77-30.03-32.35-.89-4.32-.22-5.13-4.03-8.22l-4.76-2.86c5.9-5.47,14.11-4.98,20.51-.63,5.77,3.91,9.07,12.78,15.64,15.14,6.07,2.18,11.19-1.16,17.09-1.58,10.67-.76,19.75,6.46,24.82,15.24l1.47,1.65c-2.47-7.32-2.02-15.14-2.72-22.74-1.7-18.31-6.92-38-24.23-47.4-5.97-3.24-18.13-7.03-23.58-1.5-6.81,6.91-5.23,29.8-16.88,30.79-5.54.47-5.64-5.02-8.31-8.03-2.3-2.59-5.08-.15-8.03-.12-5.17.06-13.33-3.18-14.76-8.68-1.69-6.48,4.02-10.41,3.17-15.97-.41-2.69-4.14-5.73-5.38-8.24-3.01-6.08,1.55-14.19,7.31-16.84,3.22-1.48,7.28-1.25,10.21-3.41,5.45-4.02,4.11-13.98,13.09-13.63,4.77.19,9.35,5.23,9.41,9.96.02,1.67-.59,4-.55,5.67.11,4.71,3.45,12.38,6.03,16.33,6.74,10.34,12.26,5.4,22.13,7.83,9.73,2.4,19.9,9.04,25.06,17.71,4.88,8.2,7.54,18.52,9.69,27.76l.96-.27c1.76-11.62-.27-23.44-3.95-34.47-2.3-5.69-5.37-10.91-6.74-16.95-.43-1.91.24-4.14-1.9-5.18-5.01-2.43-10.57-.35-16.2-1.23-10.42-1.62-15.27-5.69-19.24-15.35-1.94-4.72-.66-5.33-.32-9.77.26-3.35,0-6.96-.81-10.21.22-.02.41,0,.63.05,2.06.5,4.28,7.94,5.74,10.06,6.49,9.44,21.48,7.66,29.18,15.49l2.31,3.54c.33-4.06,1.53-7.96,2.38-11.92.24-1.11.17-2.54.42-3.67.36-1.66,2.69-6.07,2.34-7.36-.26-.97-6.16-5.38-7.34-6.03-7.54-4.15-16.62,3.06-24.77-3.83-7.23-6.11,1.13-13.98-2.72-19.34-1.73-2.41-4.93-2.74-7.17-4.27-2.94-2-5.43-10.25-5.08-13.71.73-7.15,13.74-10.28,19.15-13.26,9.79-5.4,6.61-15.16,11.84-23.03,7.75-11.68,23.88-6.23,31.67,2.51,3.49,3.91,5.58,9.65,11.57,10.22,8.7.83,14.05-4.03,23.02.95,12.08,6.71,13.8,18.73,4.89,29.14-2.68,3.13-6.56,5.16-5.91,10.02.77,5.82,4.31,7.59.88,14.64-6.57,13.52-26.85,10.48-38.65,13.64-2.88.77-5.3,1.47-6.55,4.34-5.46,12.56-8.83,28.32-3.62,41.47.41,1.03,1.07,3.48,2.18,1.76,4.12-6.42-.45-14.58,7.02-21.04,7.39-6.39,19.01-8.73,23.29-18.66.55-1.28.97-5.27,2.74-3.54l.13.41c-1.58,8.15-1.65,17.44-7.22,24.11-2.8,3.36-7.48,6.49-9.62,10.27-3.78,6.68-.07,14.89-10.84,16.94-.54.1-2.11-.21-2.27.46l4.92,15.88ZM98.69,87.78c.18-1.15,1.03-2.57,1.07-3.7.03-.84-.42-2.06-.51-2.98-.14-1.38.49-2.99-.68-3.95-.73-.6-4.24-1.89-5.25-2.1-6.11-1.27-12.6,1.73-16.81-4.71-2.5-3.83,3.28-10.15.94-13.74-1.61-2.48-4.24-3.03-4.37-7.1-.29-8.97,10.25-8.24,13.75-13.21,2.5-3.55.76-8.06,3.7-11.82,5.21-6.68,14.43-7.26,20.02-.69,2.22,2.61,3.33,6.14,5.35,8.81,4.75,6.25,8.74-.21,13.7-1.73,8-2.46,12.14,2.61,9.68,10.23-1.09,3.39-4.71,6.72-5.16,10.1-.74,5.58,4.72,7.17,2.78,13.4-3.35,10.76-15.24,7.06-23.14,10.36-4.72,1.98-8.96,6.04-10.09,11.16-.09.43-.58,2.48.06,2.51,1.94-1.28,3.87-2.04,6.13-2.58,11.3-2.75,30.91-1.01,36.28-13.84,3.63-8.69-4-11.54-1.34-17.95,2.27-5.47,10.04-9.68,10.79-16.17.83-7.18-6.31-14.42-12.77-16.32-8.01-2.35-15.24,3.24-24.04-.2-9.83-3.84-14.49-20.71-27.28-17.07-10.27,2.91-8.32,18.02-15.17,24.6s-22.76,5.63-21.49,18.28c1.01,10.08,12,6.65,13.27,15.33.87,5.95-5.34,11.27,1.16,16.55,4.35,3.53,8.52,1.32,13.5,1.48,5.42.18,9.65,1.76,13.75,5.32.79.69,1.15,1.9,2.17,1.77ZM102.5,80.97c2.6-5.33,10.25-9.2,15.97-9.77,3.11-.31,6.32.42,9.36-.44,4.6-1.3,8.94-6.45,6.69-11.32-.68-1.46-2.15-2.69-2.81-4.27-3.34-7.96,5.95-12.81,5.12-19.56-.16-1.31-1.04-2.51-2.38-2.79-4.26-.88-8.62,4.04-12.86,4.72-8.8,1.4-9.13-4.65-13.03-10.15-4.02-5.69-10.01-8.02-14.23-1.03-2.91,4.81-1.77,10.82-7.44,14.08-3.84,2.21-10.37,2.54-10,8.82.24,4.06,3.87,4.51,4.36,7.63.13.82.08,2.35-.05,3.19-.49,3.12-3.65,6.2-1.29,9.32,4.68,6.22,18.07-.39,21.37,8.32.13.34.73,3.6,1.23,3.26ZM178.78,137.08c1.38,3.8,3.86,11.18,9.21,9.62,2.68-.78,4.38-5.88,6.09-8.08,3.16-4.07,8.27-3.35,11.81-7.81,4.59-5.79-2.71-8.89-5.16-13.37-4.3-7.85,3.5-14.83-1.4-21.21-4.32-5.61-12.09-.99-17.11-7.4-3.3-4.21-5.92-13.16-13.04-10.54-7.31,2.69-6.05,13.02-4.42,19.01.32.51.58-.06.8-.3,1.41-1.59,2.32-5.56,4.26-6.91,4.3-3.01,10.28,3.32,11.09,7.41.4,2.04-.1,6.94,2.67,7.4,2.14.36,4.65-.94,6.64.18,1.15.64,2.82,3.88,2.99,5.18.64,4.7-3.53,6.14-3.8,10.04-.19,2.74.86,2.87,1.96,4.87,5.42,9.8-4.16,14.19-12.58,11.9ZM172.14,91.68c-.6.04-1.65.71-2.09,1.13-1.22,1.16-4.06,7.18-4.49,8.85s-.11,4.83-.43,6.93c-.79,5.18-3.17,10.89-5.97,15.28.09.39,4.89,1.52,5.79,1.85,3.34,1.21,8.13,3.77,10.83,6.06.97.82,1.88,2.15,2.86,2.86,3.45,2.54,9.64,2.16,11.54-2.08,2.5-5.58-3.78-7.2-3.8-11.4-.02-4.98,7.78-8.22,3.83-13.35-2.52-3.28-5.36-.48-8.44-1.63-4.47-1.68-1.99-10.31-6.72-13.44-.64-.42-2.17-1.1-2.91-1.05ZM93.25,119.37c.47-.47-2.26-3.41-2.67-4-2.69-3.88-3.11-5.42-7.88-7.38-8.89-3.66-13.72-3.03-21.59-10.28-1.39-1.28-2.1-2.53-3.26-3.95-2.52,12.35,8.91,22.84,20.55,23.71,3.74.28,7.6-.91,11.12.32.63.22,3.41,1.89,3.74,1.57ZM36.59,107.93c-.05-1.36.83-2.45,1.02-3.75.33-2.29-.47-6.87-2.4-8.36-.68-.52-3.69-1.72-4.51-1.78-3.96-.29-4.72,6.27-5.77,8.9-3.7,9.25-13.62,6.54-18.14,14-6.28,10.33,6.01,12.57,4.35,21.78-.83,4.6-6.47,10.16-1.37,14.42s9.44,1.32,14.97,1.91c4.81.52,4.43,5.96,7.67,8.13,2,1.34,2.79.9,4.45-.63,2.83-2.61,4.17-7.32,4.62-11.03-2.72,1.96-4.46,5.03-8.32,3.29-3.56-1.61-1.66-6.78-3.87-8.74-3.04-2.7-9.15.43-11.56-4.16-1.13-2.15-1.04-4.18.05-6.33,1.01-2,2.98-2.56,2.75-5.17-.25-2.75-3.72-4.77-3.57-8.18.1-2.28,2.93-6.48,5.18-7.09,2.9-.78,4.93,1.82,7.56,2.26,4.6.77.92-5.08.88-7.17-.06-3,3.94-4.09,6-2.3ZM132.2,99.22c-2.18,1.97-3.55,4.62-5.86,6.53-6.1,5.03-17.88,7.36-19.67,16.29-.69,3.46.02,7.09-1.15,10.56-.75,2.24-2.53,4.02-4.05,5.75l2.13,4.32c3.28.73,7.6-1.6,9.22-4.41,1.76-3.06,1.35-6.65,2.36-9.9,1.78-5.71,7.42-8.01,10.9-12.25,3.41-4.16,6.07-11.53,6.12-16.89ZM50.21,133c-5.68-.45-9.19-7.68-11.22-12.35-1.46-3.37-2.53-6.29-2.17-10.08-.2-.58-2.64-1.58-3.19-1.23-1,1.87.53,3.56.76,5.3.57,4.26-1.59,5.45-5.53,4.99-3.18-.37-5.39-3.77-7.79-.65-3.81,4.95,4.29,8.63,1.24,14.59-1.14,2.23-3.72,3.93-2.4,7,1.41,3.28,10.92,1.13,12.47,6.05.77,2.46.11,8.84,4.74,5.58,6.71-4.73,6.92-14.11,13.09-19.18ZM172.51,166.23c-5.92.2-11.97,2.5-16.71,6.04-8.91,6.65-11.65,17.32-23.87,19.98-5.9,1.29-10.75-.55-15.81,3.8-.93.8-1.92,2.04-2.71,3.01-.6.74-4.64,6.09-4.09,6.66,1.23,0,1.94-1.25,2.74-1.75,3.05-1.9,9.91-2.83,13.44-2.3,1.97.3,4.01,1.42,6.02,1.6,12.37,1.14,5.69-14.52,15.27-15.77,2.79-.36,5.41,1.5,7.27,1,2.71-.73,5.06-8.19,6.52-10.64,2.76-4.62,7.61-8.53,11.93-11.63ZM175.78,167.04c-.77-.65-8.38,5.92-9.25,6.95-3.54,4.2-6.47,14.99-11.18,16.88-3.74,1.5-5.61-1.53-8.57-.95-2.65.52-3.66,6.97-4.49,9.12-4.22,10.94-14.88,4.16-23.27,5.33-3.86.54-9.58,3.84-11.06,7.6,14.27-9.18,31,4.86,45.3-4.41,11.87-7.69,10.86-22.75,17.78-33.7,1.48-2.35,3.45-4.35,4.74-6.83ZM96.79,207.35c.18-.18-1.93-3.21-2.23-3.63-2.69-3.79-6.02-7.61-10.39-9.49-11.5-4.96-21.39,6.63-32.87-3.63-2.45-2.19-3.45-5.2-5.45-7.62-3.68-4.46-12.11-8.39-17.69-5.73,0,.34,2.38.7,2.91.9,4.76,1.82,11.63,6.97,13.56,11.77,1.53,3.79,1.91,12.65,6.26,14.17,2.45.86,7.72-.3,10.14-1.33,3.24-1.37,3.92-3.23,8.12-2.77,4.84.53,7.09,6.46,11.35,7.19,2.26.39,4.98-1.19,7.19-1.44,3.06-.34,6.28.48,9.09,1.61ZM100.33,211.17c-2.92-.16-5.96-2.98-8.58-3.27-4.17-.46-8.18,2.01-12.41,1.24-1.03-.19-4.01-1.58-4.87-2.21-1.63-1.19-2.53-3.83-4.5-4.49-3.82-1.29-6.38,1.95-9.5,3.33-4.31,1.91-10.13,2.28-13.95-.86-4.04-3.32-3.42-8.73-5.02-13.23-1.5-4.22-6.5-9.84-10.91-11.02,5.16,4.97,4.09,12.39,5.63,18.74,2.83,11.67,14.84,19.01,26.42,19.01,12.63,0,23.82-8.05,36.73-6.98.3.02,1.02.2.95-.27Z"}),jsxRuntimeExports.jsx("path",{className:"cls-1",d:"M98.69,87.78c-1.03.12-1.38-1.08-2.17-1.77-4.09-3.56-8.33-5.14-13.75-5.32-4.98-.17-9.15,2.05-13.5-1.48-6.5-5.28-.29-10.6-1.16-16.55-1.27-8.68-12.26-5.24-13.27-15.33-1.27-12.64,14.5-11.55,21.49-18.28s4.9-21.69,15.17-24.6c12.8-3.63,17.45,13.23,27.28,17.07,8.81,3.44,16.04-2.15,24.04.2,6.46,1.89,13.6,9.14,12.77,16.32-.75,6.49-8.52,10.7-10.79,16.17-2.66,6.41,4.97,9.26,1.34,17.95-5.36,12.83-24.98,11.09-36.28,13.84-2.26.55-4.19,1.3-6.13,2.58-.63-.03-.15-2.08-.06-2.51,1.13-5.12,5.36-9.18,10.09-11.16,7.9-3.31,19.79.39,23.14-10.36,1.94-6.23-3.52-7.82-2.78-13.4.45-3.38,4.06-6.71,5.16-10.1,2.46-7.61-1.68-12.69-9.68-10.23-4.96,1.53-8.95,7.99-13.7,1.73-2.03-2.67-3.13-6.2-5.35-8.81-5.59-6.57-14.81-5.99-20.02.69-2.94,3.77-1.2,8.27-3.7,11.82-3.5,4.97-14.03,4.24-13.75,13.21.13,4.06,2.75,4.62,4.37,7.1,2.34,3.59-3.45,9.91-.94,13.74,4.2,6.44,10.69,3.44,16.81,4.71,1.01.21,4.52,1.5,5.25,2.1,1.17.96.54,2.57.68,3.95.09.91.54,2.14.51,2.98-.04,1.13-.89,2.55-1.07,3.7Z"}),jsxRuntimeExports.jsx("path",{className:"cls-2",d:"M102.5,80.97c-.5.34-1.1-2.92-1.23-3.26-3.3-8.7-16.69-2.1-21.37-8.32-2.35-3.12.81-6.21,1.29-9.32.13-.83.18-2.37.05-3.19-.49-3.12-4.12-3.58-4.36-7.63-.37-6.28,6.16-6.61,10-8.82,5.67-3.26,4.53-9.27,7.44-14.08,4.23-6.98,10.21-4.66,14.23,1.03,3.89,5.51,4.23,11.55,13.03,10.15,4.24-.67,8.6-5.59,12.86-4.72,1.34.28,2.22,1.47,2.38,2.79.83,6.75-8.46,11.6-5.12,19.56.66,1.58,2.14,2.81,2.81,4.27,2.26,4.87-2.09,10.02-6.69,11.32-3.05.86-6.26.13-9.36.44-5.72.57-13.37,4.44-15.97,9.77Z"}),jsxRuntimeExports.jsx("path",{className:"cls-4",d:"M36.59,107.93c-2.07-1.79-6.07-.7-6,2.3.05,2.09,3.72,7.94-.88,7.17-2.64-.44-4.66-3.03-7.56-2.26-2.26.6-5.09,4.8-5.18,7.09-.14,3.41,3.33,5.43,3.57,8.18.23,2.61-1.73,3.16-2.75,5.17-1.08,2.14-1.17,4.18-.05,6.33,2.41,4.6,8.52,1.46,11.56,4.16,2.2,1.96.31,7.13,3.87,8.74,3.86,1.74,5.6-1.32,8.32-3.29-.46,3.71-1.8,8.42-4.62,11.03-1.66,1.53-2.45,1.97-4.45.63-3.24-2.17-2.86-7.61-7.67-8.13-5.53-.6-9.81,2.4-14.97-1.91s.54-9.82,1.37-14.42c1.66-9.22-10.63-11.45-4.35-21.78,4.53-7.45,14.45-4.75,18.14-14,1.05-2.63,1.82-9.19,5.77-8.9.82.06,3.83,1.26,4.51,1.78,1.93,1.48,2.73,6.07,2.4,8.36-.19,1.3-1.07,2.39-1.02,3.75Z"}),jsxRuntimeExports.jsx("path",{className:"cls-4",d:"M178.78,137.08c8.41,2.29,17.99-2.09,12.58-11.9-1.1-2-2.15-2.13-1.96-4.87.27-3.9,4.44-5.34,3.8-10.04-.18-1.3-1.85-4.54-2.99-5.18-1.99-1.11-4.5.19-6.64-.18-2.77-.47-2.27-5.36-2.67-7.4-.81-4.1-6.78-10.42-11.09-7.41-1.93,1.35-2.84,5.32-4.26,6.91-.22.25-.48.81-.8.3-1.62-5.99-2.88-16.32,4.42-19.01,7.11-2.62,9.73,6.32,13.04,10.54,5.02,6.41,12.79,1.79,17.11,7.4,4.91,6.37-2.9,13.36,1.4,21.21,2.45,4.47,9.75,7.58,5.16,13.37-3.53,4.45-8.65,3.74-11.81,7.81-1.7,2.19-3.41,7.3-6.09,8.08-5.36,1.56-7.83-5.82-9.21-9.62Z"}),jsxRuntimeExports.jsx("path",{className:"cls-2",d:"M172.14,91.68c.74-.05,2.27.63,2.91,1.05,4.72,3.12,2.25,11.76,6.72,13.44,3.08,1.16,5.92-1.64,8.44,1.63,3.95,5.13-3.85,8.37-3.83,13.35.02,4.2,6.3,5.82,3.8,11.4-1.9,4.24-8.09,4.62-11.54,2.08-.97-.72-1.89-2.05-2.86-2.86-2.71-2.28-7.49-4.85-10.83-6.06-.9-.33-5.7-1.45-5.79-1.85,2.8-4.39,5.17-10.1,5.97-15.28.32-2.09-.02-5.17.43-6.93s3.28-7.69,4.49-8.85c.44-.42,1.49-1.09,2.09-1.13Z"}),jsxRuntimeExports.jsx("path",{className:"cls-2",d:"M50.21,133c-6.17,5.07-6.38,14.45-13.09,19.18-4.63,3.27-3.97-3.12-4.74-5.58-1.55-4.92-11.06-2.78-12.47-6.05-1.33-3.07,1.25-4.77,2.4-7,3.05-5.95-5.05-9.63-1.24-14.59,2.4-3.12,4.61.28,7.79.65,3.94.46,6.1-.73,5.53-4.99-.23-1.74-1.76-3.43-.76-5.3.55-.35,2.99.66,3.19,1.23-.35,3.79.71,6.71,2.17,10.08,2.02,4.66,5.54,11.89,11.22,12.35Z"}),jsxRuntimeExports.jsx("path",{className:"cls-5",d:"M100.33,211.17c.07.47-.65.29-.95.27-12.91-1.06-24.1,6.99-36.73,6.98-11.58,0-23.59-7.35-26.42-19.01-1.54-6.35-.47-13.78-5.63-18.74,4.41,1.17,9.41,6.8,10.91,11.02,1.6,4.5.98,9.91,5.02,13.23,3.81,3.13,9.64,2.77,13.95.86,3.12-1.38,5.68-4.62,9.5-3.33,1.97.66,2.86,3.3,4.5,4.49.86.63,3.84,2.02,4.87,2.21,4.22.77,8.24-1.7,12.41-1.24,2.62.29,5.66,3.11,8.58,3.27Z"}),jsxRuntimeExports.jsx("path",{className:"cls-5",d:"M175.78,167.04c-1.29,2.48-3.26,4.48-4.74,6.83-6.92,10.95-5.91,26.01-17.78,33.7-14.3,9.27-31.03-4.77-45.3,4.41,1.48-3.76,7.2-7.06,11.06-7.6,8.39-1.17,19.05,5.61,23.27-5.33.83-2.16,1.85-8.6,4.49-9.12,2.96-.58,4.84,2.44,8.57.95,4.71-1.89,7.64-12.68,11.18-16.88.87-1.03,8.48-7.61,9.25-6.95Z"}),jsxRuntimeExports.jsx("path",{className:"cls-5",d:"M96.79,207.35c-2.82-1.13-6.03-1.95-9.09-1.61-2.22.25-4.94,1.83-7.19,1.44-4.26-.73-6.52-6.66-11.35-7.19-4.21-.46-4.88,1.4-8.12,2.77-2.42,1.03-7.69,2.18-10.14,1.33-4.35-1.53-4.73-10.38-6.26-14.17-1.93-4.8-8.81-9.95-13.56-11.77-.53-.2-2.91-.56-2.91-.9,5.58-2.67,14.02,1.27,17.69,5.73,2,2.42,3,5.44,5.45,7.62,11.48,10.25,21.37-1.33,32.87,3.63,4.37,1.88,7.7,5.7,10.39,9.49.29.41,2.41,3.44,2.23,3.63Z"}),jsxRuntimeExports.jsx("path",{className:"cls-5",d:"M172.51,166.23c-4.33,3.09-9.17,7-11.93,11.63-1.46,2.44-3.81,9.91-6.52,10.64-1.86.5-4.48-1.36-7.27-1-9.58,1.25-2.9,16.91-15.27,15.77-2.01-.18-4.05-1.3-6.02-1.6-3.53-.53-10.39.4-13.44,2.3-.8.5-1.51,1.76-2.74,1.75-.55-.57,3.49-5.93,4.09-6.66.79-.96,1.78-2.21,2.71-3.01,5.06-4.35,9.91-2.51,15.81-3.8,12.22-2.67,14.96-13.34,23.87-19.98,4.73-3.53,10.78-5.84,16.71-6.04Z"}),jsxRuntimeExports.jsx("path",{className:"cls-5",d:"M132.2,99.22c-.05,5.36-2.71,12.73-6.12,16.89-3.48,4.25-9.12,6.54-10.9,12.25-1.01,3.24-.6,6.83-2.36,9.9-1.62,2.81-5.94,5.14-9.22,4.41l-2.13-4.32c1.52-1.73,3.3-3.51,4.05-5.75,1.17-3.48.46-7.1,1.15-10.56,1.79-8.93,13.56-11.25,19.67-16.29,2.32-1.91,3.69-4.56,5.86-6.53Z"}),jsxRuntimeExports.jsx("path",{className:"cls-5",d:"M93.25,119.37c-.32.32-3.11-1.35-3.74-1.57-3.52-1.24-7.37-.05-11.12-.32-11.64-.86-23.07-11.36-20.55-23.71,1.17,1.42,1.87,2.67,3.26,3.95,7.88,7.24,12.7,6.62,21.59,10.28,4.76,1.96,5.19,3.49,7.88,7.38.41.59,3.14,3.53,2.67,4Z"})]});const GooseIcon=({elClass:s,fillColor:a})=>jsxRuntimeExports.jsx("svg",{id:"goose",className:s,viewBox:"0 0 186 225.8",fill:a,width:"120",height:"120",xmlns:"http://www.w3.org/2000/svg",children:jsxRuntimeExports.jsx("g",{id:"UZgtuK",children:jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M65.86,45.15c.04-.69.08-1.39.12-2.08.05-.02.1-.04.15-.06-.05-.02-.1-.04-.15-.06.04-.5.08-1,.12-1.5.05-.02.1-.04.15-.06-.05-.02-.1-.04-.15-.06,0-.89,0-1.77,0-2.66.05-.02.1-.04.15-.06-.05-.02-.1-.04-.15-.06.05-2.52-2.15-3.9-4.3-3.37-.02-.05-.04-.1-.06-.15-.02.05-.04.1-.06.15-.65.16-1.29.36-1.95.47-.73.12-1.48.16-2.22.23-.02-.05-.04-.1-.06-.15-.02.05-.04.1-.06.15-1.65-.31-3.31-.59-4.96-.93-2.19-.45-4.3-1.14-6.19-2.4-.4-.26-.82-.5-1.25-.72-.81-.42-1.53-.93-2.1-1.67-.36-.47-.85-.84-1.28-1.25,0-.04,0-.08-.01-.13,1.65-.97,1.58-1.97,1.49-3.21-.05-.77-.21-1.53-.2-2.29.01-.96.12-1.91.22-2.87.16-1.55.26-3.11.55-4.63.23-1.24.74-2.42,1.06-3.65.28-1.05.28-2.09-.67-2.85-.31-.25-.71-.38-1.06-.57,0-.04,0-.07,0-.11,2.29-1.55,4.57-3.1,6.86-4.65.41-.28.82-.57,1.2-.89.84-.71,1.8-1.15,2.85-1.44,1.57-.44,3.13-.91,4.69-1.41.91-.29,1.82-.21,2.74-.08.02.05.04.1.06.15.02-.05.04-.1.06-.15.69.12,1.39.23,2.08.35.02.05.04.1.06.15.02-.05.04-.1.06-.15.31.04.61.08.92.12.02.05.04.1.06.15.02-.05.04-.1.06-.15,2.22.2,3.91,1.55,5.69,2.66,1.36.85,2.63,1.86,3.84,2.92.59.51.99,1.27,1.42,1.95,1.37,2.16,2.73,4.32,4.05,6.52.33.55.47,1.21.66,1.84.28.92.53,1.85.8,2.77.27.92.6,1.83.49,2.82-.02.22.07.45.1.68-.05.02-.1.04-.15.06.05.02.1.04.15.06.12,1.35.23,2.7.35,4.05-.31.24-.22.47,0,.71.04.54.08,1.08.12,1.61,0,.2,0,.39,0,.59-.04.62-.08,1.23-.12,1.85-.05.02-.1.04-.15.06.05.02.1.04.15.06,0,.07,0,.15,0,.22-.05.02-.1.04-.15.06.05.02.1.04.15.06,0,.07,0,.15,0,.22-.05.02-.1.04-.15.06.05.02.1.04.15.06,0,.19,0,.38,0,.57-.05.02-.1.04-.15.06.05.02.1.04.15.06.04.73.08,1.46.12,2.19-.05.02-.1.04-.15.06.05.02.1.04.15.06,0,.73,0,1.46,0,2.19-.05.02-.1.04-.15.06.05.02.1.04.15.06-.04.19-.08.38-.12.57-.05.02-.1.04-.15.06.05.02.1.04.15.06-.27,1.59-.53,3.17-.81,4.76-.31,1.77-.64,3.54-.94,5.32-.24,1.4-.47,2.79-.68,4.19-.22,1.42-.42,2.84-.63,4.26-.08.55-.13,1.1-.19,1.65,0,.2,0,.39,0,.59-.08.69-.15,1.39-.23,2.08-.05.02-.1.04-.15.06.05.02.1.04.15.06-.04.58-.08,1.15-.12,1.73-.05.02-.1.04-.15.06.05.02.1.04.15.06,0,.07,0,.15,0,.22-.05.05-.15.11-.15.15.02.08.09.14.15.21-.12.92-.23,1.85-.35,2.77-.05.02-.1.04-.15.06.05.02.1.04.15.06-.04.5-.08,1-.12,1.5-.05.04-.15.08-.15.12,0,.62-.01,1.25,0,1.87,0,.04.1.08.15.12-.04.81-.08,1.62-.12,2.43-.29.31-.25.63,0,.94,0,.19,0,.38,0,.57-.25.2-.25.39,0,.59,0,.19,0,.38,0,.57,0,.2,0,.39,0,.59.04.38.08.77.12,1.15-.05.02-.1.04-.15.06.05.02.1.04.15.06.24,1.08.46,2.17.72,3.25.44,1.82.9,3.64,1.38,5.46.2.78.46,1.54.69,2.31-.05.02-.1.04-.15.06.05.02.1.04.15.06.77,2.12,1.91,4.05,3.34,5.77,1.34,1.62,2.91,3.03,4.79,4.03,2.23,1.18,4.44,2.4,6.71,3.52,2.82,1.39,5.68,2.69,8.51,4.05,1.16.56,2.29,1.2,3.45,1.77,2.35,1.14,4.72,2.2,7.05,3.38,1.06.54,2.02,1.26,3.03,1.9,1.3.82,2.61,1.64,3.9,2.48.32.21.64.43.92.7,1.49,1.43,2.91,2.94,4.46,4.31,2.06,1.82,4.19,3.56,6.31,5.31,1.13.93,2.19,1.91,3.05,3.12,1.2,1.69,2.58,3.26,3.82,4.92.99,1.33,1.9,2.71,2.83,4.08,1.4,2.07,2.86,4.1,4.46,6.03.75.91,1.19,2.07,1.83,3.07.86,1.34,1.85,2.6,2.67,3.97.83,1.38,1.51,2.84,2.26,4.27.06.12.1.27.19.35,1.35,1.22,2.06,2.92,3.23,4.27.59.69,1.36,1.22,2.06,1.82.69.59,1.45,1.1,2.06,1.76,1.09,1.19,2.53,1.56,4.01,1.87.35.08.72.09,1.09.13.02.05.04.1.06.15.02-.05.04-.1.06-.15.92,0,1.85,0,2.77,0,.02.05.04.1.06.15.02-.05.04-.1.06-.15.99-.2,2.02-.29,2.97-.62,1.19-.41,2.39-.68,3.61-.9,1.71-.3,3.26-1,4.74-1.86,1.1-.64,2.2-1.27,3.3-1.89.43-.24,1.24-.07,1.49.26-.06.03-.12.06-.18.09.06.05.12.1.18.15-.11.94-.2,1.89-.35,2.83-.15.92-.38,1.82-.58,2.74-.05.02-.1.04-.15.06.05.02.1.04.15.06-.34,1.42-.67,2.84-1.02,4.25-.48,1.96-1.59,3.63-2.54,5.37-.72,1.32-1.47,2.62-2.29,3.88-.41.64-.96,1.2-1.51,1.73-1.39,1.33-2.79,2.66-4.22,3.94-.93.83-1.87,1.69-2.94,2.32-1.42.84-2.95,1.51-4.47,2.18-1.96.85-3.95,1.63-5.93,2.43-1.98.8-3.96,1.59-5.93,2.39-.18.07-.37.12-.54.21-1.31.78-2.73,1.21-4.25,1.37-.78.09-1.55.3-2.29.57-.42.15-.85.47-1.12.82-1.33,1.74-2.83,3.28-4.74,4.4-1.16.68-2.25,1.47-3.37,2.21-.29-.16-.59-.45-.89-.45-1.15-.01-2.3.03-3.45.12-.64.05-1.34.07-1.55.91-.03,0-.07,0-.1,0-2.05-.39-4.1-.78-6.15-1.17-.02-.05-.04-.1-.06-.15-.02.05-.04.1-.06.15-1.35-.38-2.69-.75-4.04-1.14-.73-.21-1.37-.04-1.93.44-.98.85-2.1,1.28-3.4,1.42-.89.09-1.76.4-2.64.56-1.09.19-2.2.32-3.3.47-.32-.59-.85-.64-1.43-.58-.44.05-.87.09-1.31.1-.92.02-1.84,0-2.77.01-.66,0-1.04.37-1.14,1.04-.03,0-.06,0-.1,0-.49-.4-.93-.88-1.47-1.18-1.7-.95-3.36-1.96-4.8-3.29-1.09-1-2.26-1.92-3.29-2.98-1.11-1.15-2.02-2.47-3.13-3.62-1.31-1.35-1.94-3.16-3.18-4.53-.56-.62-1.19-1.23-1.91-1.64-2.23-1.25-4.54-2.36-6.78-3.61-1.73-.97-3.45-1.97-5.05-3.12-1.76-1.26-3.41-2.69-5.08-4.08-1.96-1.62-3.89-3.26-5.82-4.91-.33-.28-.57-.67-.84-1.02-.65-.86-1.27-1.73-1.94-2.58-.9-1.15-1.71-2.41-2.78-3.38-2.09-1.91-3.81-4.13-5.56-6.32-1.45-1.8-2.93-3.57-4.58-5.2-.73-.72-1.21-1.68-1.86-2.5-.79-.99-1.7-1.89-2.44-2.92-.79-1.11-1.55-2.27-2.15-3.49-1.02-2.07-1.91-4.21-2.84-6.32-.5-1.12-1.05-2.23-1.43-3.39-.29-.86-.38-1.79-.51-2.7-.11-.74-.16-1.49-.24-2.23.05-.05.15-.11.15-.15-.02-.08-.09-.14-.15-.21.04-.27.11-.53.11-.8,0-3.51.63-6.91,1.59-10.27.43-1.5.83-3,1.27-4.49.55-1.9,1.05-3.82,1.68-5.69.89-2.62,1.9-5.2,3.17-7.68.84-1.62,1.41-3.37,2.18-5.04.6-1.31,1.32-2.56,1.97-3.84.4-.79.78-1.58,1.16-2.37.32-.65.58-1.35.97-1.96,1.44-2.25,2.96-4.46,4.37-6.73.84-1.36,1.51-2.82,2.32-4.2.81-1.38,1.76-2.67,2.52-4.06.74-1.35,1.43-2.74,1.96-4.18,1.25-3.41,2.46-6.84,3.21-10.41.42-2.01.75-4.03,1.12-6.05.05-.02.1-.04.15-.06-.05-.02-.1-.04-.15-.06.04-.65.08-1.31.12-1.96.05-.02.1-.04.15-.06-.05-.02-.1-.04-.15-.06.04-.46.08-.92.12-1.38.05-.04.15-.08.15-.12,0-.7,0-1.4,0-2.1,0-.04-.1-.08-.15-.12.04-.62.08-1.23.12-1.85.05-.02.1-.04.15-.06-.05-.02-.1-.04-.15-.06ZM134.92,181.91c.72,0,1.43.03,2.15,0,1.39-.07,2.59-.53,3.45-1.69,1.02-1.37,1.53-2.98,2.05-4.57.45-1.35.36-2.78.37-4.19.03-2.7-.67-5.22-1.8-7.64-.67-1.43-1.35-2.86-2.03-4.29-.25-.52-.49-1.05-.79-1.54-.25-.41-.67-.41-1.08-.27-.4.14-.51.45-.45.83.05.3.09.62.21.89.67,1.46,1.35,2.91,2.05,4.35.76,1.56,1.42,3.16,1.75,4.88.34,1.76.47,3.54.15,5.28-.24,1.31-.73,2.58-1.19,3.85-.59,1.64-1.8,2.36-3.55,2.26-1.58-.09-3.17-.05-4.74-.14-1.17-.07-2.34-.17-3.49-.41-2.3-.47-4.58-1.01-6.86-1.55-4.22-1-8.45-1.92-12.27-4.14-2.48-1.44-4.81-3.06-6.91-5.01-1.57-1.46-2.77-3.21-3.86-5.03-.47-.79-.76-1.72-1.33-2.42-1.6-1.97-3.25-3.92-5.35-5.41-1.35-.96-2.65-2.04-4.25-2.54-1.37-.43-2.8-.67-4.2-1.04-2.37-.63-4.4-1.78-5.98-3.72-1.78-2.17-3.48-4.38-4.63-6.96-.79-1.77-1.37-3.61-1.47-5.55-.16-3.06.12-6.08,1.03-9.03.54-1.76,1.11-3.5,2.28-4.97.85-1.07,1.76-2.1,2.65-3.13.54-.63,1.04-1.31,1.65-1.86,2.43-2.19,5.37-2.5,8.46-2.14.74.09,1.47.31,2.21.37.65.05,1.09-.53.84-1.11-.13-.3-.47-.6-.78-.7-.63-.21-1.3-.34-1.97-.4-2.31-.19-4.63-.35-6.84.61-1.41.61-2.73,1.39-3.76,2.54-1.13,1.26-2.25,2.54-3.29,3.87-.77.98-1.54,2.01-2.05,3.13-1.88,4.17-2.52,8.59-2.28,13.15.02.44.1.88.17,1.31.39,2.22,1.19,4.29,2.25,6.28,1.23,2.29,2.81,4.34,4.51,6.27,2.03,2.3,4.66,3.54,7.66,4.06,1.84.31,3.58.89,5.15,1.96,1.9,1.3,3.68,2.74,5.15,4.53.49.6,1.04,1.15,1.45,1.79.54.84.95,1.76,1.46,2.62,1.45,2.45,3.29,4.54,5.5,6.35,1.77,1.45,3.66,2.71,5.64,3.82,2.04,1.14,4.15,2.15,6.43,2.72,3.38.85,6.78,1.59,10.15,2.48,3.42.9,6.88,1.28,10.4,1.23ZM63.79,12.11c.96-.57,1.17-.53,1.74.29.07.09.12.2.19.29.31.38.75.3,1.08.15.22-.1.46-.51.42-.72-.09-.46-.29-.94-.58-1.32-.69-.91-1.52-1.71-2.58-2.16-1.53-.65-3.12-.47-4.7-.2-.66.11-1.03.63-.9,1.11.16.58.74.84,1.37.73.7-.12,1.41-.17,2.24-.26-.22.35-.34.54-.46.74-.67,1.12.12,2.94,1.41,3.14.32.05.83-.1,1.02-.34.36-.47.22-1.01-.25-1.45Z"}),jsxRuntimeExports.jsx("path",{className:"cls-1",d:"M42.99,8.7c.36.19.76.32,1.06.57.95.76.95,1.8.67,2.85-.33,1.22-.83,2.41-1.06,3.65-.29,1.52-.39,3.09-.55,4.63-.1.95-.21,1.91-.22,2.87,0,.76.14,1.53.2,2.29.09,1.24.16,2.24-1.49,3.21-.04,0-.08.01-.11.02-1.3.15-2.59.32-3.89.46-1.55.17-3.1.34-4.65.5-.92.1-1.83.28-2.75.29-2.46.02-4.87.36-7.28.79-.4.07-.8.14-1.2.14-2.63.01-5.26.03-7.89,0-2.29-.03-4.59-.1-6.88-.23-1.47-.08-2.95-.26-4.41-.47-1.28-.18-2.22-1.13-2.47-2.31-.23-1.06.35-2.24,1.41-2.96,1.2-.82,2.6-1.11,3.98-1.29,2.75-.36,5.48-.8,8.18-1.43,2.57-.6,5.17-1.06,7.78-1.46,1.37-.21,2.63-.64,3.83-1.24,2.31-1.16,4.6-2.38,6.86-3.64.56-.31,1.04-.8,1.46-1.29,1.87-2.17,3.9-4.12,6.55-5.34.82-.38,1.63-.7,2.55-.65.11,0,.23.02.34.03Z"}),jsxRuntimeExports.jsx("path",{className:"cls-1",d:"M103.68,206.17c.1-.67.48-1.03,1.14-1.04.92-.01,1.84,0,2.77-.01.44,0,.88-.05,1.31-.1.59-.07,1.12-.02,1.43.58-.08.43-.1.88-.25,1.29-.68,1.79-.95,3.65-.55,5.51.31,1.45,1.11,2.65,2.34,3.6,1.46,1.12,3.14,1.7,4.8,2.36.45.17.88.4,1.28.67,1.29.88,1.21,2.88-.09,3.77-1.31.89-2.78.94-4.24.74-1.67-.22-3.31-.77-4.99-.91-1.79-.15-3.59-.21-5.39.32-2.04.6-4.17.92-6.26,1.33-1.34.27-2.69.51-4.04.72-1.6.25-3.19.53-4.8.67-1.5.13-3.01.19-4.51.1-1.2-.07-2.24-.72-3.06-1.61-.56-.61-.57-1.37-.23-2.12.4-.89,1.16-1.26,2.08-1.35,2.43-.24,4.86-.42,7.28-.72,2.17-.27,4.36-.55,6.49-1.05,2.7-.62,5.18-1.81,6.82-4.16.8-1.16,1.26-2.54,1.4-4,.15-1.56-.22-3.02-.72-4.47,0-.04,0-.08,0-.12Z"}),jsxRuntimeExports.jsx("path",{className:"cls-1",d:"M132.01,205.01c.2-.83.91-.86,1.55-.91,1.15-.08,2.3-.13,3.45-.12.3,0,.59.29.89.45.02.31.03.61.05.92,0,.12,0,.23,0,.35-.03,1.27-.14,2.55-.09,3.82.06,1.56.21,3.1.99,4.53.92,1.68,2.37,2.45,4.19,2.53,1.4.07,2.81-.07,4.22-.09,1.37-.01,2.01.64,2.08,2,0,.17.05.34.08.51.12.6-.13,1.18-.66,1.48-1.25.71-2.63,1.02-4.04,1.1-1.77.11-3.53-.07-5.3-.3-2.72-.36-5.42-.09-8.06.7-1.24.37-2.47.76-3.73,1.04-1.72.38-3.47.44-5.2,0-1.12-.28-1.77-1.01-1.97-2.11-.2-1.13,0-2.24,1.03-2.87.71-.44,1.59-.69,2.42-.83,1.57-.27,3.17-.34,4.73-.61,1.49-.26,2.77-1.07,3.65-2.27.49-.66.74-1.58.86-2.41.32-2.14-.11-4.21-.93-6.2-.08-.2-.14-.4-.21-.6,0-.04,0-.08,0-.12Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M65.75,47.12c.05.04.15.08.15.12,0,.7,0,1.4,0,2.1,0,.04-.1.08-.15.12,0-.78,0-1.56,0-2.33Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M78.04,70.47c-.05-.04-.15-.08-.15-.12,0-.62,0-1.25,0-1.87,0-.04.1-.08.15-.12,0,.7,0,1.4,0,2.1Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M77.92,73.84c-.25-.31-.29-.63,0-.94,0,.31,0,.63,0,.94Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M82.1,27.63c-.22-.24-.31-.47,0-.71,0,.24,0,.47,0,.71Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M77.92,75c-.25-.2-.25-.39,0-.59,0,.2,0,.39,0,.59Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M82.22,29.84c0-.2,0-.39,0-.59,0,.2,0,.39,0,.59Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M77.92,76.16c0-.2,0-.39,0-.59,0,.2,0,.39,0,.59Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M78.85,59.32c0-.2,0-.39,0-.59,0,.2,0,.39,0,.59Z"}),jsxRuntimeExports.jsx("path",{className:"cls-1",d:"M137.94,205.71c0-.12,0-.23,0-.35v.35Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M35.91,130.82c.05.07.13.13.15.21,0,.04-.09.1-.15.15,0-.12,0-.24,0-.36Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M78.5,63.97c-.05-.07-.13-.13-.15-.21,0-.04.09-.1.15-.15,0,.12,0,.24,0,.36Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M186,160.67c-.06-.05-.12-.1-.18-.15.06-.03.12-.06.18-.09,0,.08,0,.16,0,.24Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M42.99,8.7c-.11,0-.23-.02-.34-.03.11-.03.23-.06.34-.09,0,.04,0,.07,0,.11Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M66.1,38.53s.1.04.15.06c-.05.02-.1.04-.15.06,0-.04,0-.08,0-.13Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M66.1,41.32s.1.04.15.06c-.05.02-.1.04-.15.06,0-.04,0-.08,0-.13Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M65.98,42.94s.1.04.15.06c-.05.02-.1.04-.15.06,0-.04,0-.08,0-.13Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M65.86,45.15s.1.04.15.06c-.05.02-.1.04-.15.06,0-.04,0-.08,0-.13Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M82.1,38.54s-.1-.04-.15-.06c.05-.02.1-.04.15-.06,0,.04,0,.08,0,.13Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M82.22,37.85s-.1-.04-.15-.06c.05-.02.1-.04.15-.06,0,.04,0,.08,0,.13Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M65.52,52.93s.1.04.15.06c-.05.02-.1.04-.15.06,0-.04,0-.08,0-.13Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M57.38,35.86s.04-.1.06-.15c.02.05.04.1.06.15-.04,0-.08,0-.13,0Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M78.62,61.53s-.1-.04-.15-.06c.05-.02.1-.04.15-.06,0,.04,0,.08,0,.13Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M78.5,63.39s-.1-.04-.15-.06c.05-.02.1-.04.15-.06,0,.04,0,.08,0,.13Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M82.22,35.53s-.1-.04-.15-.06c.05-.02.1-.04.15-.06,0,.04,0,.08,0,.13Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M78.15,66.87s-.1-.04-.15-.06c.05-.02.1-.04.15-.06,0,.04,0,.08,0,.13Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M61.67,35.16s.04-.1.06-.15c.02.05.04.1.06.15-.04,0-.08,0-.13,0Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M82.1,33.2s-.1-.04-.15-.06c.05-.02.1-.04.15-.06,0,.04,0,.08,0,.13Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M82.1,32.51s-.1-.04-.15-.06c.05-.02.1-.04.15-.06,0,.04,0,.08,0,.13Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M82.1,32.16s-.1-.04-.15-.06c.05-.02.1-.04.15-.06,0,.04,0,.08,0,.13Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M78.04,77.43s-.1-.04-.15-.06c.05-.02.1-.04.15-.06,0,.04,0,.08,0,.13Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M80.82,88.58s-.1-.04-.15-.06c.05-.02.1-.04.15-.06,0,.04,0,.08,0,.13Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M82.1,31.81s-.1-.04-.15-.06c.05-.02.1-.04.15-.06,0,.04,0,.08,0,.13Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M64.7.59s-.04.1-.06.15c-.02-.05-.04-.1-.06-.15.04,0,.08,0,.13,0Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M63.66.47s-.04.1-.06.15c-.02-.05-.04-.1-.06-.15.04,0,.08,0,.13,0Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M166.98,165.43s-.04.1-.06.15c-.02-.05-.04-.1-.06-.15.04,0,.08,0,.13,0Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M169.88,165.43s-.04.1-.06.15c-.02-.05-.04-.1-.06-.15.04,0,.08,0,.13,0Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M185.07,166.36s-.1-.04-.15-.06c.05-.02.1-.04.15-.06,0,.04,0,.08,0,.13Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M125.64,203.84s.04-.1.06-.15c.02.05.04.1.06.15-.04,0-.08,0-.13,0Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M61.45.12s-.04.1-.06.15c-.02-.05-.04-.1-.06-.15.04,0,.08,0,.13,0Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M81.75,22.87s-.1-.04-.15-.06c.05-.02.1-.04.15-.06,0,.04,0,.08,0,.13Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M65.63,50.84s.1.04.15.06c-.05.02-.1.04-.15.06,0-.04,0-.08,0-.13Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M41.48,28.79s.07-.02.11-.02c0,.04,0,.08.01.13-.04-.03-.08-.07-.12-.1Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M132.01,205.01s0,.08,0,.12c-.03-.04-.07-.08-.1-.12.03,0,.07,0,.1,0Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M103.68,206.17s0,.08,0,.12c-.03-.04-.06-.08-.1-.12.03,0,.06,0,.1,0Z"}),jsxRuntimeExports.jsx("path",{className:"cls-2",d:"M63.79,12.11c.46.44.61.98.25,1.45-.18.24-.69.39-1.02.34-1.29-.2-2.08-2.01-1.41-3.14.12-.2.24-.39.46-.74-.83.09-1.54.13-2.24.26-.64.11-1.21-.16-1.37-.73-.14-.49.24-1,.9-1.11,1.58-.27,3.17-.45,4.7.2,1.06.45,1.89,1.25,2.58,2.16.29.37.48.86.58,1.32.04.21-.2.62-.42.72-.33.15-.77.23-1.08-.15-.07-.09-.13-.19-.19-.29-.57-.82-.78-.86-1.74-.29Z"})]})})});const SwanIcon=({elClass:s,fillColor:a})=>jsxRuntimeExports.jsxs("svg",{id:"swan",className:s,viewBox:"0 0 234.08 159.95",fill:a,width:"120",height:"120",xmlns:"http://www.w3.org/2000/svg",children:[jsxRuntimeExports.jsx("path",{className:"cls-2",d:"M96.52,135.3c-1.67-1.39-3.29-2.84-4.88-4.34-.68-.63-1.22-1.44-1.81-2.18-.12-.15-.19-.37-.28-.56-.22-.48-.08-.86.36-1.1s.85-.12,1.13.28c1.78,2.59,4.14,4.6,6.55,6.55,2.33,1.88,4.83,3.49,7.52,4.82,4.31,2.15,8.85,3.6,13.57,4.48,2.73.51,5.47,1.02,8.23,1.25,2.69.22,5.39.08,8.09.05,2.79-.03,5.53-.59,8.23-1.3,4.26-1.13,8.4-2.59,12.43-4.39,2.52-1.13,5-2.29,7.46-3.52,4.45-2.24,8.68-4.85,12.54-8,3.78-3.06,6.86-6.7,9.26-10.93,3.35-5.84,6.24-11.92,8.85-18.13,1.05-2.5,1.96-5.06,2.93-7.61.06-.15.11-.31.2-.45.28-.42.63-.66,1.14-.4.46.25.6.63.4,1.14-.82,2.18-1.54,4.42-2.47,6.56-1.68,3.89-3.47,7.74-5.27,11.58-1.84,3.95-3.86,7.81-6.35,11.41-1.81,2.64-3.97,4.97-6.38,7.1-4.09,3.61-8.71,6.44-13.51,8.97-5.73,3.04-11.67,5.54-17.85,7.49-3.17.99-6.36,1.79-9.68,2.04-1.79.12-3.58.26-5.37.39-3.26-.09-6.45-.42-9.67-.93-4.06-.65-8.08-1.51-11.97-2.87-4.88-1.73-9.42-4.09-13.42-7.41Z"}),jsxRuntimeExports.jsx("path",{className:"cls-2",d:"M85.03,103.66c0-1.02.6-1.74,1.17-2.46,2.04-2.5,4.14-4.97,6.25-7.41,2.62-3.04,5.62-5.68,8.82-8.11,4.01-3.03,8.54-4.94,13.46-5.93,2.69-.54,5.39-1,8.14-.85,1.44.09,2.83.39,3.97,1.33,1.24,1,1.82,2.36,1.5,3.89-.48,2.29-1.17,4.52-1.73,6.78-.2.82-.32,1.67-.4,2.52-.11,1.3.77,2.29,2.22,2.72,2.38.69,4.72.43,7.07-.09,2.87-.63,5.74-1.36,8.65-1.85,3.86-.65,7.72-.57,11.47.76.69.25,1.41.42,2.12.62.11.05.22.09.34.12.52.2.83.56.71,1.14-.12.51-.65.68-1.3.49-1.41-.42-2.83-.8-4.23-1.22-2.29-.66-4.6-.6-6.95-.43-3.61.28-7.04,1.34-10.55,2.08-2.84.6-5.65.83-8.45-.19-2.08-.76-3.06-2.72-2.78-4.93.36-2.67,1.3-5.16,1.98-7.74.19-.69.14-1.5-.02-2.21-.22-1.08-1.14-1.54-2.12-1.79-.9-.22-1.85-.28-2.5-.37-3.47.23-6.58.73-9.64,1.61-3.74,1.1-7.18,2.81-10.27,5.17-1.47,1.13-2.87,2.33-4.22,3.58-1.53,1.42-3.04,2.87-4.42,4.43-2.05,2.33-4,4.77-5.96,7.2-.32.42-.54.94-.76,1.44-.19.45-.46.74-.94.65s-.66-.45-.66-.96Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M121.89,80.54c.65.09,1.61.15,2.5.37.97.25,1.9.71,2.12,1.79.15.71.2,1.51.02,2.21-.68,2.58-1.62,5.06-1.98,7.74-.28,2.21.69,4.17,2.78,4.93,2.79,1.02,5.61.79,8.45.19,3.51-.74,6.93-1.81,10.55-2.08,2.35-.17,4.66-.23,6.95.43,1.41.42,2.83.8,4.23,1.22.65.19,1.17.02,1.3-.49.12-.59-.19-.94-.71-1.14-.12-.03-.23-.08-.34-.12-.71-.2-1.42-.37-2.12-.62-3.75-1.33-7.61-1.41-11.47-.76-2.9.49-5.77,1.22-8.65,1.85-2.35.52-4.69.79-7.07.09-1.45-.43-2.33-1.42-2.22-2.72.08-.85.2-1.7.4-2.52.56-2.25,1.25-4.49,1.73-6.78.32-1.53-.26-2.89-1.5-3.89-1.14-.94-2.53-1.24-3.97-1.33-2.75-.15-5.45.31-8.14.85-4.93.99-9.45,2.9-13.46,5.93-3.2,2.42-6.19,5.06-8.82,8.11-2.12,2.44-4.22,4.91-6.25,7.41-.57.71-1.17,1.44-1.17,2.46,0,.51.19.86.66.96s.76-.2.94-.65c.22-.49.43-1.02.76-1.44,1.96-2.42,3.91-4.86,5.96-7.2,1.37-1.56,2.89-3.01,4.42-4.43,1.34-1.25,2.75-2.46,4.22-3.58,3.09-2.36,6.53-4.08,10.27-5.17,3.06-.88,6.16-1.37,9.64-1.61ZM91.64,130.96c1.59,1.5,3.21,2.95,4.88,4.34,4,3.32,8.54,5.68,13.42,7.41,3.89,1.36,7.91,2.22,11.97,2.87,3.21.51,6.41.83,9.67.93,1.79-.12,3.58-.26,5.37-.39,3.32-.25,6.52-1.05,9.68-2.04,6.18-1.95,12.12-4.45,17.85-7.49,4.8-2.53,9.42-5.36,13.51-8.97,2.41-2.13,4.57-4.46,6.38-7.1,2.49-3.6,4.51-7.46,6.35-11.41,1.79-3.84,3.58-7.69,5.27-11.58.93-2.15,1.65-4.39,2.47-6.56.2-.51.06-.9-.4-1.14-.51-.26-.86-.02-1.14.4-.09.14-.14.29-.2.45-.97,2.55-1.88,5.11-2.93,7.61-2.61,6.21-5.5,12.29-8.85,18.13-2.41,4.23-5.48,7.87-9.26,10.93-3.86,3.15-8.09,5.76-12.54,8-2.46,1.24-4.94,2.39-7.46,3.52-4.03,1.79-8.17,3.26-12.43,4.39-2.7.71-5.44,1.27-8.23,1.3-2.7.03-5.4.17-8.09-.05-2.76-.23-5.5-.74-8.23-1.25-4.72-.88-9.26-2.33-13.57-4.48-2.69-1.33-5.19-2.93-7.52-4.82-2.41-1.95-4.77-3.95-6.55-6.55-.28-.4-.69-.51-1.13-.28s-.57.62-.36,1.1c.09.19.15.4.28.56.59.74,1.13,1.54,1.81,2.18ZM9.14,25.11c1.25-4.15,2.53-8.29,4.96-11.97,1.27-1.91,2.93-3.44,4.79-4.76,1.45-1.02,3.01-1.88,4.4-3,1.61-1.3,3.27-2.5,5.16-3.35C31.2.81,34.04-.06,37.13,0c2.29.03,4.6-.08,6.84.45,1.79.42,3.46,1.14,5,2.15.23.15.49.28.74.42.05.11.06.23.14.31,1.44,1.36,2.89,2.72,4.32,4.06.46.43.93.88,1.39,1.31,1.16.94,1.95,2.18,2.59,3.51.34.69.69,1.39,1.11,2.05,1.44,2.33,2.39,4.86,2.66,7.57.37,3.67.63,7.38.69,11.07.05,1.87-.42,3.74-.69,5.61-.34,2.3-1.17,4.46-2.04,6.62-.34.82-.43,1.73-.63,2.59-.08.12-.19.22-.23.36-.52,1.54-1.05,3.1-1.56,4.66-.17.56-.32,1.11-.48,1.68-.2.51-.39,1.03-.59,1.54l-.69,1.57c-.26.51-.51,1.02-.76,1.53-1.44,2.96-2.84,5.94-4.32,8.88-1.08,2.18-2.16,4.37-3.44,6.44-1.65,2.64-3.47,5.19-5.28,7.74-.85,1.2-1.96,2.24-2.76,3.49-.99,1.54-1.78,3.21-2.66,4.83-.25.57-.48,1.14-.71,1.71-.45,1.85-.02,4.46,1.84,5.44.31.17.79.29,1.07.17,1.25-.51,2.41-1.11,3.23-2.32,2.69-3.95,5.76-7.64,9.34-10.82,2.56-2.27,5.31-4.32,8.06-6.38,4.08-3.03,8.14-6.1,12.38-8.89,3.43-2.27,7.07-4.22,10.69-6.18,4.76-2.59,9.74-4.63,14.82-6.47,1.16-.42,2.35-.71,3.51-1.08,1.87-.62,3.72-1.28,5.59-1.85,2.24-.66,4.48-1.37,6.76-1.84,2.62-.54,5.3-.85,7.95-1.22,2.56-.36,5.14-.69,7.72-.97,1.47-.17,2.96-.23,4.45-.31,2.52-.11,5.05-.22,7.58-.28,2.92-.08,5.82-.15,8.74-.14,6.1.02,12.18.15,18.28.09,2.69-.03,5.36-.36,8.03-.68,3.37-.4,6.72-.91,10.07-1.45,1-.15,1.98-.49,2.93-.83,1.31-.49,2.7-.66,3.98-.36,1.84.43,3.64,1.25,4.29,3.3.76,2.42-.37,4.88-3.01,5.5-2.95.71-5.91,1.41-8.89,2.07-1.39.31-2.81.52-4.22.79-.05,1,.03,1.1.91,1.1,1.37,0,2.75-.03,4.12.02,2.86.09,5.59-.51,8.31-1.28,2.27-.63,4.54-1.28,6.84-1.79,2.42-.52,4.77-.22,6.84,1.24.96.66,1.61,1.62,2.04,2.7.2.49.46.62.97.42,1.78-.66,3.54-1.36,5.34-1.9,2.1-.63,4.25-1.13,6.36-1.68,1.64-.42,3.3-.48,4.97-.43,3.18.08,6.04,2.72,6.36,5.88.29,2.96-1.07,5.06-3.2,6.93-1.68,1.45-3.23,3.06-4.76,4.66-1.11,1.19-2.22,2.42-3.09,3.78-1.39,2.16-2.72,4.39-3.83,6.7-1.2,2.49-2.13,5.11-3.17,7.67-.11.26-.15.54-.22.82-.11.11-.25.22-.31.34-.45.99-.97,1.96-1.33,2.98-.63,1.91-1.19,3.88-1.76,5.81-.29,1.47-.59,2.92-.86,4.39-.09.48-.11.96-.15,1.45-.14.76-.28,1.53-.42,2.29-.45,2.27-.76,4.57-1.37,6.78-.83,2.93-1.79,5.84-2.93,8.66-2.01,4.86-4.54,9.47-7.84,13.6-1.03,1.28-1.87,2.73-2.84,4.08-1.74,2.42-4.05,4.23-6.61,5.71-4.71,2.7-9.59,5.08-14.76,6.76-2.29.76-4.74,1.07-7.12,1.53-2.39.48-4.8.93-7.23,1.34-1.61.26-3.23.45-4.83.65-1.73.23-3.46.45-5.19.66-.76.08-1.5.19-2.25.19-6.05.02-12.11-.02-18.16.03-3.57.02-7.15.17-10.72.26-1.61.05-3.21.14-4.83.14-10.84.02-21.69.06-32.53-.03-2.84-.03-5.68-.51-8.51-.91-3.89-.56-7.64-1.71-11.38-2.9-.2-.06-.45-.06-.68-.03-2.89.43-5.76.97-8.66,1.3-3.18.36-6.39.52-9.59.73-1.59.11-3.18.2-4.76.12-5.13-.23-10.24-.49-15.15-2.21-4.72-1.67-9.19-3.81-13.11-6.96-1.71-1.36-3.04-3.09-4.17-4.99-2.21-3.74-3.34-7.84-4.46-12-1.05-3.86-1.39-7.77-1.22-11.72.11-2.21.45-4.42.9-6.58.65-3.2,1.39-6.36,2.24-9.5.52-1.9,1.39-3.67,2.02-5.54.83-2.46,1.84-4.8,3.34-6.93.79-1.11,1.2-2.49,1.98-3.61,1.36-2.02,2.84-3.95,4.31-5.88,1.54-2.04,3.1-4.05,4.69-6.04,1.61-2.02,3.3-3.97,4.88-6.01.82-1.05,1.56-2.19,2.24-3.35,1.42-2.44,2.87-4.85,4.12-7.37,1.13-2.29,1.99-4.71,3-7.06,1.08-2.5,2.24-4.97,3.3-7.47,1.51-3.6,2.98-7.21,3.88-11.02.03-.11.09-.22.09-.34.02-3.3.17-6.62-.73-9.87-.32-1.19-1.2-1.82-2.12-2.5-.83.52-.94,1.39-.97,2.22-.06,1.19-.02,2.38-.02,3.57-.02,3.92-1.25,7.43-3.63,10.55-1.17,1.53-2.41,3.03-3.66,4.49-.49.57-1.13,1.02-1.7,1.51-.82-.76-1.78-.43-2.7-.36-1.36.12-2.7.34-4.06.48-.39.03-.8-.08-1.17-.19-2.22-.73-3.91-2.21-5.28-4.03-1.71-2.32-3.38-4.66-4-7.58-.25-1.1-.73-2.16-.97-3.26-.17-.76-.42-1.34-1.19-1.61.11-.65.12-1.33.31-1.95ZM17.47,19.95c-1.99-.25-3.09,1.48-3.04,3.01.06,1.81,1.28,3.09,3.09,3.13,1.39.03,3.12-1.3,3.1-3.06,0-1.41-1.02-3.27-3.15-3.09Z"}),jsxRuntimeExports.jsx("path",{d:"M16.75,21.74c.06-.17.57-.22.86-.31.76.08,1.17.43,1.41,1.2.17.59-.14,1.31-.71,1.68-.83.54-1.78.43-1.9-.34-.11-.73.14-1.51.34-2.24Z"}),jsxRuntimeExports.jsx("path",{className:"cls-2",d:"M16.75,21.74c-.2.73-.45,1.51-.34,2.24.12.77,1.07.88,1.9.34.57-.37.88-1.1.71-1.68-.23-.77-.65-1.13-1.41-1.2-.29.09-.8.14-.86.31ZM17.52,26.1c-1.81-.05-3.03-1.33-3.09-3.13-.05-1.53,1.05-3.26,3.04-3.01,2.13-.19,3.15,1.68,3.15,3.09.02,1.76-1.71,3.09-3.1,3.06Z"}),jsxRuntimeExports.jsx("path",{className:"cls-1",d:"M10.99,31.92c.62,2.92,2.29,5.27,4,7.58,1.37,1.82,3.06,3.3,5.28,4.03.37.11.79.22,1.17.19,1.36-.14,2.7-.36,4.06-.48.93-.08,1.88-.4,2.7.36.26.79,0,1.33-.54,2.01-1.47,1.79-2.78,3.71-4.05,5.65-.85,1.3-1.42,2.79-2.32,4.06-1.08,1.53-2.33,2.92-3.55,4.35-2.25,2.64-4.52,5.28-6.82,7.89-1,1.16-2.04,2.3-3.54,2.9-2.15.83-3.91-.99-3.97-2.76-.06-2.3.25-4.57.79-6.79.46-1.85,1.16-3.66,1.61-5.51.45-1.84.76-3.72,1.02-5.61.22-1.48.31-3,.42-4.51.03-.51-.06-1.03-.09-1.54-.06-.14-.11-.29-.15-.43-.2-2.07-.43-4.12-.56-6.19-.12-2.21-.12-4.43-.15-6.66,0-.31.17-.63.31-.93.28-.57.6-1.13.86-1.7.28-.62.73-.85,1.36-.77.77.26,1.02.85,1.19,1.61.25,1.1.73,2.16.97,3.26Z"})]});const RockingHorseIcon=({elClass:s,fillColor:a})=>jsxRuntimeExports.jsx("svg",{id:"rocking-horse",className:s,viewBox:"0 0 230.43 204",fill:a,width:"120",height:"120",xmlns:"http://www.w3.org/2000/svg",children:jsxRuntimeExports.jsx("g",{id:"_5wiBGu","data-name":"5wiBGu",children:jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M33.91,5.92l5.98,7.7c1.37.43,2.94.29,4.31.49,6.74.98,18.09,7.36,23.3,11.82,11.56,9.9,20.11,23.54,26.42,37.29.39.85,1.49,2.96,1.63,3.7.05.29,0,.53-.15.78l.39.09-2.6,1.17c-8.08,10.44-11.94,32.49,3.51,38.45,5.63,2.17,16.06,4.75,22.01,3.62,10.32-1.96,21.23-8.9,23.17-19.91.79-4.51-.97-7.11-1.86-11.25-.32-1.52-.18-3.74-.55-5-.16-.54-.68-1.14-.75-1.51-.06-.3.18-.63.16-.66,2.74-.97,5.45-2.04,8.33-2.59,4.45-.86,8.1-.36,12.41-.66.41-.03.5-.03.7-.42.38,1.45,2.01,1.37,3.06,1.74,1.58.55,2.14,1.22,4.08.71-.16,1.22,1.29,1.65,2.04,2.35,14.5,13.35,10.72,28.03,12.89,45.51,1.09,8.78,8.59,22.25,13.98,29.31,1.14,1.5,2.5,2.84,3.64,4.33.8,1.06,1.3,2.41,2.37,3.25-.37.38-.02.61-1.25,1.3-2.55,1.44-5.39,2.5-8.01,3.83-6.05,3.08-17.34,9.65-23.61,10.38-.83-4.66-2.05-9.3-3.42-13.84-2.84-9.43-6.89-19.06-13.63-26.39-1-1.09-3.12-3.46-4.64-3.42-1.41.04-4.05,1.33-5.63,1.73-3.98,1.02-9.08,1.51-13.21,1.89-15.68,1.47-33.9.27-48.49-6.03-1.01-.44-4.78-2.53-5.41-2.55-.47-.02-.24.03-.31.31-.37,1.5-.59,3.05-.96,4.56-3.55,14.31-9.59,27.47-18.44,39.24-.17-.01-.43.23-1.02.12-1.98-.36-7.99-2.59-10.06-3.44-5.51-2.26-11.5-6.22-16.12-9.97-1.19-.97-2.84-2.18-3.43-3.46,13.77-14.35,25.09-31.93,29.3-51.66,1.64-7.7,1.58-15.35.91-23.18s-2.47-14.67-5.31-21.54c-.2-.14-2.89,1.14-3.46,1.32-1.37.44-3.03.76-4.45,1.06-1.59.34-4.06.07-4.89,1.64-1.6,2.99-1.84,7.01-3.96,10.33-3.68,5.75-11.85,7.24-17.73,4.12-9.54-5.05-3.45-12.53-.57-19.57,2.98-7.29,5.22-15.04,7.73-22.5l-.21-1.12c1.59-.53,2.6-6.66,3.06-8.25-1.62-2.81-2.87-6.81-4.72-9.39-.28-.39-.41-.4-.79-.13.15-.47.22-.72.12-1.23-.23-1.25-1.74-3.73-2.26-5.1s-1.28-2.81-.48-4.15C17.6.13,18.57-.08,19.69.02c3.45.31,11.76,3.45,14.21,5.9ZM32.95,32.73c-1.22,1.03-.05,3.65,1.57,2.9,2.33-1.08.38-4.54-1.57-2.9Z"}),jsxRuntimeExports.jsx("path",{className:"cls-1",d:"M202.36,156.21s.4.03.59-.11c5.56-4.07,11.36-8.42,18.71-6.01,9.94,3.25,11.92,16.77,3.43,22.84-1.18.84-2.32,1.19-3.44,1.87-3,1.82-5.45,4.05-8.67,5.83-13.11,7.23-27.02,13.42-41.21,18.21-10,3.37-20.34,3.66-30.77,4.55-10.63.91-21.18.69-31.85.21-9.86-.44-20.02-.48-29.76-2.12-5.55-.93-13.24-2.36-18.45-4.22-12.66-4.52-26.8-8.36-38.26-15.23-6.15-3.69-18.76-13.16-21.55-19.69-5.36-12.56,9.27-23.86,20-15.51.52.4,3.47,3.43,3.58,3.67.59,1.28,2.24,2.49,3.43,3.46,4.62,3.75,10.61,7.7,16.12,9.97,2.07.85,8.08,3.08,10.06,3.44.59.11.85-.13,1.02-.12.06,0,.23.35.49.44,3.23,1.01,6.43,2.11,9.62,3.23,5.25,1.85,9.48,3.09,15,4.2,8.1,1.62,16.36,1.93,24.6,2.35,12.78.65,24.81.91,37.58-.21,5.93-.52,13.23-.96,18.89-2.55,2.01-.56,6.46-2.78,7.96-2.96,6.28-.74,17.57-7.3,23.61-10.38,2.62-1.33,5.46-2.39,8.01-3.83,1.23-.7.88-.92,1.25-1.3Z"}),jsxRuntimeExports.jsx("path",{className:"cls-11",d:"M33.91,5.92c3.1-1.31,5.6-2.3,9.06-2.02,4.55.37,13.68,3.35,17.75,5.53,7.89,4.23,15.07,10.52,21.27,16.91,7.64,7.87,13.23,21.05,24.4,24.4,1.37.41,3.16.58,4.41,1.09.34.14.28.42.39.45h.3c.06.06.13.14.2.2.22.16.24.13.41.2.91.34.66,1.26,1.23,1.84l.21,1.92c-.56.18-.24.43-.38.67-1.3,2.29-5.68,6.11-7.94,7.59-1.88,1.23-4.09,1.98-5.78,3.51,1.98.41,3.75,1.42,5.67,1.99,9.41,2.78,18.72,1.41,28.33.88,2.48-.14,3.06-.16,4.9,1.43.2.17.49.17.51.2.02.03-.22.35-.16.66.07.37.59.98.75,1.51.37,1.26.23,3.49.55,5,.88,4.14,2.65,6.74,1.86,11.25-1.94,11.02-12.84,17.96-23.17,19.91-5.95,1.13-16.37-1.45-22.01-3.62-15.45-5.95-11.59-28.01-3.51-38.45l2.6-1.17-.39-.09c.15-.25.21-.49.15-.78-.14-.74-1.24-2.85-1.63-3.7-6.31-13.75-14.86-27.38-26.42-37.29-5.21-4.47-16.56-10.84-23.3-11.82-1.37-.2-2.94-.06-4.31-.49l-5.98-7.7Z"}),jsxRuntimeExports.jsx("path",{className:"cls-9",d:"M202.77,61.87l.2.61c.03.19.16.29.2.41.14.37.26.62.61.82.07.2.16.31.2.41.38.96.73,1.95,1.23,2.86-.01.13,0,.27,0,.41l.2.2v.41l.41.41v.2c.02.13-.01.27,0,.41l.2.2c-.02.11-.01.29,0,.41.05.49.94,1.6,1.02,2.25.2,1.56.43,3.14.61,4.7v.41c.04.33-.03.69,0,1.02.02.19.29.52.2.82-.02.25-.01.56,0,.82,0,.13.17.5.2.82.51,5.43,1.85,10.84,2.45,16.24.46,4.2.62,8.94.82,13.17v.41c.02.61,0,1.23,0,1.84,0,.07,0,.14,0,.2,0,.41,0,.82,0,1.23-.29.84-.49,1.37-1.02,2.04-1.36,1.74-2.6,1.55-4.44,2.19-2.71.95-5.42,1.83-8.18,2.65l-.85.06h-.41c-.27.02-.55-.02-.82,0s-.55.17-.82.2c-.24-.02-.58-.02-.82,0-.15.02-.4.22-.61.2-.25-.03-.55,0-.82,0-.65,0-1.08.05-1.84,0-.13,0-.27,0-.41,0-.74-.43-1.18-.48-1.84-1.02-.07-.06-.15-.14-.2-.2-.45-.51-.67-.8-1.02-1.43-.02-.13.01-.28,0-.41l-.2-.41c.01-.2.01-.41,0-.61-.05-.87-.17-1.72-.2-2.65-.03-.67.06-1.39,0-2.04-.02-.19-.29-.53-.2-.82.09-1.31-.38-1.36-.42-1.72-.5-3.94-.39-8.38-.6-12.37v-7.96l-.2-.2c-.34-4.79-1.26-8.98-2.72-13.52-.35-1.1-.69-2.09-1.04-3.25l-1.81-2.57c-3.4-.43-7.29-.17-10.56.87-.57.18-1.34.78-1.84.91-1.94.51-2.5-.16-4.08-.71-1.05-.37-2.68-.29-3.06-1.74-.04-.16.03-.42,0-.61s0-.41,0-.61,0-.41,0-.61v-.41c.31-.97.62-1.52,1.08-2.3,3.37-5.6,8.38-12.16,14.17-15.43,3.05-1.72,7.4-2.85,10.85-1.95,4.26,1.11,11.82,8.13,14.41,11.72.74,1.03,1.06,2.11,1.95,3.05Z"}),jsxRuntimeExports.jsx("path",{className:"cls-5",d:"M22.07,29.41c-.09.03-.28,0-.41,0-.2,0-.41,0-.61,0-1.32-.81-6.12-4.53-6.94-5.61-.06-.08-.82-1.34-.83-1.42-.07-.56.05-1.77.29-2.29,1.12-2.48,4.05-5.05,5.53-7.43.18-.29.43-.68.53-1,.39-.28.51-.26.79.13,1.85,2.58,3.1,6.58,4.72,9.39-.46,1.59-1.47,7.72-3.06,8.25Z"}),jsxRuntimeExports.jsx("path",{className:"cls-4",d:"M203.99,64.12c.52-.11.42.25.55.56.35.79.73,1.51.67,2.3-.5-.91-.84-1.9-1.23-2.86Z"}),jsxRuntimeExports.jsx("path",{className:"cls-7",d:"M187.05,116.8h-.41c.1-.84-.25-1.96.2-2.65.04.93.15,1.79.2,2.65Z"}),jsxRuntimeExports.jsx("path",{className:"cls-7",d:"M192.56,120.88v.41s-1.71,0-1.71,0l-.13-.41c.76.05,1.19,0,1.84,0Z"}),jsxRuntimeExports.jsx("path",{className:"cls-7",d:"M188.48,119.86c.66.54,1.09.6,1.84,1.02-.02,0-.13.24-.44.17-.38-.08-1.46-.66-1.39-1.19Z"}),jsxRuntimeExports.jsx("path",{className:"cls-8",d:"M210.32,115.57c.53-.67.73-1.2,1.02-2.04,0,.03.19.14.19.31-.01.38-.67,1.82-1.21,1.73Z"}),jsxRuntimeExports.jsx("path",{className:"cls-4",d:"M206.04,69.63c.57-.02,1.06,1.47,1.15,1.84.06.27-.13.38-.13.4-.08-.65-.97-1.76-1.02-2.25Z"}),jsxRuntimeExports.jsx("path",{className:"cls-8",d:"M113.34,54.52c-.57-.58-.31-1.5-1.23-1.84.01,0,.04-.19.3-.03.45.29,1.2,1.33.93,1.86Z"}),jsxRuntimeExports.jsx("path",{className:"cls-10",d:"M185.62,97.2c-.34-.26-.34-1.17,0-1.43v1.43Z"}),jsxRuntimeExports.jsx("path",{className:"cls-7",d:"M188.27,119.66c-.88-.12-.94-.84-1.02-1.43.35.63.57.92,1.02,1.43Z"}),jsxRuntimeExports.jsx("path",{className:"cls-7",d:"M195.62,120.47v.41c-.34.17-.7-.19-.82-.2.27-.04.56-.19.82-.2Z"}),jsxRuntimeExports.jsx("path",{className:"cls-4",d:"M203.79,63.71c-.35-.2-.48-.45-.61-.82.83-.03.58.74.61.82Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M160.3,67.79c0,.2-.03.42,0,.61h-.41s0-.51,0-.51l.41-.1Z"}),jsxRuntimeExports.jsx("path",{className:"cls-4",d:"M202.97,62.48l-.2-.61c.67.7.18.47.2.61Z"}),jsxRuntimeExports.jsx("path",{className:"cls-7",d:"M186.84,112.1h-.41c-.17-.33.2-.72.2-.82-.08.29.19.63.2.82Z"}),jsxRuntimeExports.jsx("path",{className:"cls-6",d:"M207.87,79.64h.41s-.2.82-.2.82c-.03-.32-.2-.69-.2-.82Z"}),jsxRuntimeExports.jsx("path",{className:"cls-6",d:"M207.67,78h.41c.17.34-.19.71-.2.82.08-.29-.18-.63-.2-.82Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M21.66,29.41v.41c-.09.08-.49-.33-.61-.41.2,0,.41,0,.61,0Z"}),jsxRuntimeExports.jsx("path",{className:"cls-7",d:"M193.99,120.68c.1.82-.4.23-.61.2.21.02.46-.19.61-.2Z"}),jsxRuntimeExports.jsx("path",{className:"cls-4",d:"M205.42,68c.56-.09.34.15.41.41l-.41-.41Z"}),jsxRuntimeExports.jsx("path",{className:"cls-7",d:"M187.25,117.82l-.38-.03c-.14-.21.18-.35.18-.38l.2.41Z"}),jsxRuntimeExports.jsx("path",{className:"cls-4",d:"M205.83,69.02h.41c.05.16-.2.17-.2.2l-.2-.2Z"}),jsxRuntimeExports.jsx("polygon",{className:"cls-10",points:"185.62 89.23 185.21 89.23 185.41 89.03 185.62 89.23"}),jsxRuntimeExports.jsx("path",{className:"cls-8",d:"M211.34,110.26v-.41s.15.08.15.16c0,.16-.15.23-.15.25Z"}),jsxRuntimeExports.jsx("path",{className:"cls-8",d:"M211.34,112.1l.41.1-.41.1c0-.07,0-.14,0-.2Z"}),jsxRuntimeExports.jsx("polygon",{className:"cls-4",points:"205.22 67.38 205.63 67.39 205.42 67.59 205.22 67.38"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M160.3,67.18c0-.16-.15.06,0-.41v.41Z"}),jsxRuntimeExports.jsx("path",{className:"cls-7",d:"M196.85,120.47c-.19.3-.38,0-.41,0h.41Z"}),jsxRuntimeExports.jsx("path",{className:"cls-8",d:"M111.7,52.48c-.08-.06-.14-.13-.2-.2l.2-.2v.41Z"}),jsxRuntimeExports.jsx("path",{className:"cls-6",d:"M207.67,76.98v-.41s.14.08.15.16c.02.15-.15.23-.15.25Z"}),jsxRuntimeExports.jsx("path",{className:"cls-4",d:"M205.83,68.61v-.2c.06.22,0,.19,0,.2Z"}),jsxRuntimeExports.jsx("path",{className:"cls-2",d:"M32.95,32.73c1.95-1.64,3.9,1.82,1.57,2.9-1.63.75-2.8-1.87-1.57-2.9Z"})]})})});const SheepIcon=({elClass:s,fillColor:a})=>jsxRuntimeExports.jsx("svg",{id:"sheep",className:s,viewBox:"0 0 239.18 195.6",fill:a,width:"120",height:"120",xmlns:"http://www.w3.org/2000/svg",children:jsxRuntimeExports.jsx("g",{id:"E1TuAS",children:jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{className:"cls-4",d:"M166.27,141.46q-1.94-1.35-3.63.35c-1.74,1.73-3.3,3.69-5.73,4.54-.93.33-1.88.61-2.83.91-.06,0-.13,0-.19,0-3.25-.2-6.5-.35-9.74-.63-.97-.08-1.9-.5-2.85-.77-.06,0-.13,0-.19,0-2.5-.97-4.81-2.24-6.65-4.23-1.28-1.39-2.43-2.89-2.96-4.76-.09-.17-.18-.34-.34-.64-.11.29-.18.46-.25.63-.98,1.83-1.71,3.86-3,5.43-1.47,1.78-3.37,3.24-5.23,4.63-1.2.9-2.63,1.54-4.03,2.14-3.15,1.34-6.27,2.84-9.68,3.45-1.32.24-2.69.23-4.04.33-.06,0-.12,0-.18,0,0,.06,0,.13-.01.19-.7-.36-1.39-.75-2.1-1.07-3.5-1.55-7-3.11-10.52-4.63-3.32-1.43-6.66-2.82-9.97-4.22-.22.19-.42.36-.61.53-.31-.11-.64-.34-.93-.3-6.37,1.03-12.08-.3-17.02-4.58-4.2-3.63-6.95-8.12-7.9-13.61-.39-2.26-.06-4.55.81-6.71.16-.4.33-.79.49-1.19,0-.06,0-.12,0-.18-1.79-.43-3.62-.73-5.34-1.33-1.45-.51-2.9-1.21-4.14-2.12-3.29-2.4-5.45-5.57-6.46-9.6-.81-3.26-.98-6.53-.15-9.72.71-2.73,1.7-5.47,3.99-7.42.2-.17.34-.4.51-.6.22-.16.44-.32.7-.51-.28-.11-.49-.19-.7-.28-4.78-2.41-7.94-6.32-9.91-11.16-1.15-2.84-1.3-5.85-.28-8.83.07-.14.14-.27.21-.41,1.24-.52,2.51-.98,3.71-1.57,2.75-1.33,5.48-2.67,8.19-4.08,3.92-2.05,6.8-5.28,9.37-8.76,1.25-1.7,2.08-3.7,3.2-5.5,2.98-4.79,4.96-9.88,4.91-15.62,0-.34.13-.73.32-1.01.78-1.11,1.59-2.2,2.42-3.27,2.69-3.47,4.26-7.35,4-11.79-.12-1.99-.62-3.97-.95-5.95,1.54-.57,3.04-1.32,4.62-1.66,3.26-.72,6.46-.23,9.47,1.16,1.67.78,3.33,1.68,4.81,2.78,2.84,2.11,4.67,5,5.21,8.5.28,1.85.02,3.8-.09,5.7-.03.6.04.98.56,1.34,2.44,1.65,4.32,3.82,5.51,6.5,1.1,2.48,1.44,5.15,1.28,7.87.13.07.26.13.39.2,1.51-.07,3.03-.19,4.54-.19,2.65,0,4.81,1.19,6.71,2.94.28.26.63.43.95.64.15.17.3.34.58.67v-.67c.13-4.08,1.91-7.26,5.12-9.76,3.06-2.38,6.58-3.64,10.27-4.5.92-.22,1.9-.22,2.85-.32,3.01-.32,6.01-.27,8.97.4.29.07.6.12.86.25,2.3,1.19,4.61,2.35,6.88,3.61,2.67,1.47,4.64,3.71,6.43,6.12.14.17.28.35.47.59.13-.25.22-.42.31-.59.48-.91.83-1.92,1.47-2.71,2.48-3.06,5.79-4.63,9.66-5.08,1.34-.16,2.69-.32,4.04-.39,3.03-.16,5.9.7,8.77,1.49,2.48.68,4.75,1.82,6.75,3.48,1.4,1.16,3.05,2.07,4.26,3.39,1.23,1.34,2.3,2.95,2.99,4.62.81,1.96,1.1,4.13,1.68,6.19.07.25.47.55.74.57,1.72.12,3.44.13,5.16.23,3.69.23,7.23,1.09,10.67,2.47,1.95.78,3.69,1.87,5.16,3.29,1.44,1.39,2.7,3,3.88,4.62,1.09,1.49,1.97,3.13,2.99,4.8.91-.37,1.9-.73,2.85-1.17,4.35-2.02,9.77.87,10.72,5.56.61,3.01-.87,6.88-3.85,8.45-1.21.64-2.27,1.56-3.39,2.36,0,.06,0,.13,0,.19,2.5,2,4.14,4.61,5.29,7.56,1.31,3.35,1.91,6.82,1.69,10.4-.26,4.17-.74,8.34-2.67,12.11-1.53,3-3.61,5.53-7.04,6.63-.57.18-1.23.96-1.34,1.55-.36,2.04-1.59,3.53-2.78,5.07-2.93,3.8-6.8,5.71-11.6,5.62-1.65-.03-3.29-.25-4.93-.38-.13.06-.27.13-.4.19-.06,0-.12,0-.18,0-.77-.47-1.54-.95-2.38-1.46-.33.64-.57,1.1-.8,1.57-1.19,2.37-2.76,4.5-4.84,6.12-3.68,2.87-7.85,4.81-12.38,5.92-2.08.51-4.22.8-6.35,1.01-1.97.19-4.01.41-5.95.13-2.86-.41-5.66-1.26-8.49-1.92-.13-.06-.27-.13-.4-.19Z"}),jsxRuntimeExports.jsx("path",{className:"cls-1",d:"M70.58,7.58c.33,1.98.83,3.95.95,5.95.26,4.43-1.3,8.32-4,11.79-.83,1.07-1.64,2.16-2.42,3.27-.2.28-.33.67-.32,1.01.04,5.74-1.93,10.83-4.91,15.62-1.12,1.8-1.95,3.8-3.2,5.5-2.57,3.48-5.44,6.71-9.37,8.76-2.7,1.41-5.44,2.76-8.19,4.08-1.21.58-2.47,1.05-3.71,1.57-.13.07-.27.13-.4.2-1.49.65-2.94,1.39-4.47,1.93-2.72.95-5.44,1.85-8.41,1.71-1.95-.09-3.91.23-5.86.13-3.31-.16-6.49-.83-9.21-2.94-1.88-1.45-2.88-3.42-3.63-5.58.18-.07.36-.18.55-.22,3.39-.56,6.56-1.73,9.54-3.42.42-.24.81-.82.88-1.29.19-1.25-1.05-1.84-2.51-1.13-3.19,1.56-6.54,2.58-10.01,3.25-.46-1.35-1.01-2.67-1.38-4.04-1.07-4-.39-7.68,2.1-11.02,1.01-1.36,1.94-2.77,2.94-4.14,1.48-2.03,3.59-3.31,5.63-4.68,4.62-3.1,9.77-5.07,14.89-7.12.12-.05.22-.13.33-.2,3.84-1.37,7.84-2.12,11.78-3.11,3.41-.86,6.81-1.27,10.29-1.29,1.9-.01,1.89,0,1.94-1.95.01-.46.14-.91.18-1.37.46-4.92,2.01-9.42,5.2-13.27,1.78-1.42,3.53-2.89,5.35-4.26,1.03-.77,2.19-1.47,3.56-1.31.58.07,1.23.33,1.67.71,1.99,1.75,3.2,4.01,4.04,6.49.04.12.11.24.17.36ZM67.86,13.77c-.19-.71-.38-1.94-.86-3.04-.63-1.44-2.21-1.82-3.61-1.16-2.9,1.36-4.31,3.88-5.17,6.73-.81,2.7-.63,5.42.45,8.07.78,1.9,2.8,2.38,4.25.92.53-.54.93-1.2,1.42-1.79,2.24-2.67,3.22-5.8,3.51-9.74ZM42.6,32.52c0-1.87-1.03-2.95-2.82-2.96-1.99,0-3.18,1.04-3.2,2.82-.02,1.89,1.2,3.22,3.01,3.19,1.71-.03,3.06-1.11,3.01-3.05Z"}),jsxRuntimeExports.jsx("path",{className:"cls-1",d:"M166.67,141.64c2.83.66,5.62,1.51,8.49,1.92,1.94.28,3.98.06,5.95-.13,2.13-.21,4.27-.5,6.35-1.01,4.52-1.1,8.7-3.05,12.38-5.92,2.09-1.63,3.65-3.75,4.84-6.12.24-.47.48-.94.8-1.57.84.52,1.61.99,2.38,1.46-.22,1.93-.45,3.86-.67,5.8-.2,1.8-.4,3.6-.56,5.4-.11,1.18-.15,2.37-.22,3.56-.08.04-.16.08-.25.12.08.04.16.08.25.12-.2,1.65-.4,3.31-.6,4.96-.08.04-.16.08-.25.12.08.04.16.08.25.12-.27,2.32-.53,4.64-.8,6.96-.08.04-.16.08-.25.12.08.04.16.08.25.12-.06,1.44-.17,2.89-.17,4.33,0,1.48.11,2.95.17,4.43-.08.04-.16.08-.25.12.08.04.16.08.25.12-.06,2.22-.29,4.45-.13,6.66.23,3.05.85,6.07,1.12,9.12.31,3.39.41,6.8.63,10.2.06.95-.37,1.34-1.24,1.59-2.64.73-5.34.86-8.04.98-1.85.09-3.69.25-5.54.39-2.53.19-3.19-1.55-3.33-3.2-.27-3.05.27-5.97,1.37-8.84.48-1.24.75-2.63.78-3.96.1-4.24.14-8.48,0-12.72-.08-2.39-.6-4.77-.9-7.16-.18-1.51-.29-3.02-.47-4.53-.1-.85-.26-1.69-.39-2.54.01-.1.03-.2.04-.3-.09.1-.18.2-.27.3-1.48,2.47-1.86,5.2-1.8,8.01,0,.32.12.65.18.97-.08.04-.16.08-.25.12.08.04.16.08.25.12-.27,3.16-1.54,6.12-1.67,9.35-.09,2.27-1.02,4.5-1.37,6.78-.45,2.93-.97,5.85-.6,8.86.24,1.93.09,3.92.03,5.88-.03,1.11-1.08,2.18-2.19,2.25-4,.23-8,.46-12,.6-2.46.09-3.51-1.06-3.56-3.47-.04-2.05.56-3.93,1.44-5.72.92-1.88,2-3.68,2.88-5.58,1.15-2.51,2.49-4.96,3.01-7.7.23-1.19.2-2.44.29-3.66.08-.04.16-.08.25-.12-.08-.04-.16-.08-.25-.12-.03-1.51.05-3.02-.11-4.52-.29-2.71-.66-5.42-1.12-8.11-.32-1.88-.89-3.71-1.29-5.58-.5-2.37-1.68-4.42-2.91-6.46-.47-.78-.79-1.66-1.17-2.49,0-.13,0-.27-.01-.4Z"}),jsxRuntimeExports.jsx("path",{className:"cls-1",d:"M81.53,143.66c.2-.17.39-.34.61-.53,3.31,1.4,6.65,2.79,9.97,4.22,3.52,1.52,7.02,3.07,10.52,4.63.72.32,1.4.71,2.1,1.07,1.14,4.32,3.46,8.1,5.49,12.01.82,1.59,1.83,3.08,2.69,4.64.29.53.36,1.19.61,1.76.38.87.79,1.74,1.26,2.57,1.4,2.44,2.86,4.85,4.25,7.3,1,1.75,1.94,3.54,2.87,5.33.97,1.88.28,3.35-1.7,4.01-1.16.38-2.21,1.09-3.37,1.47-1.75.58-3.56.98-5.33,1.49-1.2.34-2.37.76-3.57,1.08-.66.18-1.36.23-2.05.31-3.23.39-4.25-1.77-4.69-3.92-.51-2.48-.5-5.07-.91-7.58-.29-1.79-.98-3.51-1.32-5.29-.53-2.82-2.03-5.18-3.37-7.64-.39-.73-.75-1.48-1.19-2.17-.61-.96-1.27-1.06-1.81-.08-1.1,1.98-2.62,3.81-2.83,6.18-.22,2.51-.35,5.02-.41,7.54-.04,1.85,0,3.72.2,5.57.3,2.79-2.1,4.8-4.34,5.21-3.46.63-6.94.49-10.41.19-.84-.07-1.7-.23-2.48-.53-.95-.37-1.38-1.21-1.38-2.23-.01-2.16-.15-4.34.05-6.49.17-1.82.59-3.66,1.18-5.39.84-2.47,1.88-4.89,2.95-7.28,2.08-4.66,4.95-8.82,8.18-12.76.63-.77,1.25-1.55,1.76-2.39.21-.34.25-.91.13-1.29-.59-1.85-1.27-3.68-1.89-5.52-.61-1.82-1.2-3.64-1.79-5.47Z"}),jsxRuntimeExports.jsx("path",{className:"cls-4",d:"M55.78,5.59c-3.19,3.85-4.74,8.35-5.2,13.27-.04.46-.17.91-.18,1.37-.05,1.95-.04,1.94-1.94,1.95-3.48.02-6.88.44-10.29,1.29-3.94.99-7.94,1.73-11.78,3.11-1.16-1.04-1.62-2.46-1.73-3.9-.23-2.89-.24-5.82,1.34-8.4.74-1.21,1.71-2.34,2.75-3.31,3.21-2.97,7.16-3.8,11.35-3.33,1.8.2,3.53,1.01,5.29,1.54.2-.07.39-.13.59-.2,1.93-3.48,6.02-4.89,9.8-3.39Z"}),jsxRuntimeExports.jsx("path",{className:"cls-3",d:"M1.87,57.78c3.47-.67,6.82-1.69,10.01-3.25,1.46-.71,2.7-.12,2.51,1.13-.07.47-.47,1.05-.88,1.29-2.97,1.69-6.15,2.86-9.54,3.42-.19.03-.37.14-.55.22-.52-.93-1.03-1.87-1.55-2.8Z"}),jsxRuntimeExports.jsx("path",{className:"cls-4",d:"M45.38,85.53c.21.08.42.17.7.28-.26.19-.48.35-.7.51,0-.26,0-.52,0-.78Z"}),jsxRuntimeExports.jsx("path",{className:"cls-4",d:"M157.27,39.15c-.09.17-.18.34-.31.59-.19-.24-.33-.42-.47-.59.26,0,.52,0,.78,0Z"}),jsxRuntimeExports.jsx("path",{className:"cls-4",d:"M115.11,43.35v.67c-.28-.33-.43-.5-.58-.67.19,0,.39,0,.58,0Z"}),jsxRuntimeExports.jsx("path",{className:"cls-4",d:"M130.91,136.87c.07-.17.13-.34.25-.63.16.3.25.47.34.64-.19,0-.39,0-.58,0Z"}),jsxRuntimeExports.jsx("path",{className:"cls-4",d:"M45.98,8.98c-.2.07-.39.13-.59.2.2-.07.39-.13.59-.2Z"}),jsxRuntimeExports.jsx("path",{className:"cls-6",d:"M166.67,141.64c0,.13,0,.27.01.4-.14-.2-.27-.4-.41-.59.13.06.27.13.4.19Z"}),jsxRuntimeExports.jsx("path",{className:"cls-4",d:"M102.34,39.95c-.13-.07-.26-.13-.39-.2.13.07.26.13.39.2Z"}),jsxRuntimeExports.jsx("path",{className:"cls-4",d:"M35,65.33c.13-.07.27-.13.4-.2-.07.14-.14.27-.21.41-.06-.07-.13-.14-.19-.21Z"}),jsxRuntimeExports.jsx("path",{className:"cls-4",d:"M208.03,130.27c.13-.06.27-.13.4-.19-.13.06-.27.13-.4.19Z"}),jsxRuntimeExports.jsx("path",{className:"cls-6",d:"M188.64,152.64c.09-.1.18-.2.27-.3-.01.1-.03.2-.04.3-.07,0-.15,0-.23,0Z"}),jsxRuntimeExports.jsx("path",{className:"cls-6",d:"M206.4,145.27c-.08-.04-.16-.08-.25-.12.08-.04.16-.08.25-.12,0,.08,0,.16,0,.23Z"}),jsxRuntimeExports.jsx("path",{className:"cls-6",d:"M205.81,150.47c-.08-.04-.16-.08-.25-.12.08-.04.16-.08.25-.12,0,.08,0,.16,0,.23Z"}),jsxRuntimeExports.jsx("path",{className:"cls-6",d:"M205.01,157.66c-.08-.04-.16-.08-.25-.12.08-.04.16-.08.25-.12,0,.08,0,.16,0,.23Z"}),jsxRuntimeExports.jsx("path",{className:"cls-6",d:"M187.02,161.85c-.08-.04-.16-.08-.25-.12.08-.04.16-.08.25-.12,0,.08,0,.16,0,.23Z"}),jsxRuntimeExports.jsx("path",{className:"cls-6",d:"M205.01,166.65c-.08-.04-.16-.08-.25-.12.08-.04.16-.08.25-.12,0,.08,0,.16,0,.23Z"}),jsxRuntimeExports.jsx("path",{className:"cls-6",d:"M173.29,169.21c.08.04.16.08.25.12-.08.04-.16.08-.25.12,0-.08,0-.16,0-.23Z"}),jsxRuntimeExports.jsx("path",{className:"cls-4",d:"M231.81,81.51c0-.06,0-.13,0-.19,0,.06,0,.13,0,.19Z"}),jsxRuntimeExports.jsx("path",{className:"cls-4",d:"M56.97,117.09c0,.06,0,.12,0,.18,0-.06,0-.12,0-.18Z"}),jsxRuntimeExports.jsx("path",{className:"cls-4",d:"M141.1,145.86c.06,0,.13,0,.19,0,0,0-.1,0-.1,0h-.1Z"}),jsxRuntimeExports.jsx("path",{className:"cls-4",d:"M153.89,147.26c.06,0,.13,0,.19,0,0,0-.1,0-.1,0h-.1Z"}),jsxRuntimeExports.jsx("path",{className:"cls-4",d:"M104.75,152.86c.06,0,.12,0,.18,0-.06,0-.12,0-.18,0Z"}),jsxRuntimeExports.jsx("path",{className:"cls-2",d:"M67.86,13.77c-.29,3.94-1.28,7.07-3.51,9.74-.49.58-.88,1.25-1.42,1.79-1.45,1.46-3.48.97-4.25-.92-1.09-2.65-1.27-5.37-.45-8.07.86-2.85,2.27-5.37,5.17-6.73,1.4-.66,2.99-.28,3.61,1.16.48,1.1.66,2.32.86,3.04Z"}),jsxRuntimeExports.jsx("path",{className:"cls-5",d:"M42.6,32.52c.05,1.94-1.3,3.02-3.01,3.05-1.81.04-3.03-1.29-3.01-3.19.02-1.78,1.2-2.83,3.2-2.82,1.79,0,2.83,1.09,2.82,2.96Z"})]})})});const DinoBadge=({elClass:s})=>jsxRuntimeExports.jsxs("svg",{className:s,xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 195.01 282.36",children:[jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{d:"M24.15.04c6.18.61,7.68,5.66,8.72,10.88.6,3,1.52,7.07-1.52,9.1-1.88,1.25-4.35.06-6.1-.9-.57-.32-2.89-2.03-3.2-2.08-.58-.09-1.31,2.47-1.59,3.03-4.18,8.56-7.18,16.18-7.46,25.9-.46,16.32,2.44,29.26,14.15,41.08,7.58,7.64,17.96,8.87,28.3,8.98,16.73-1.52,42.53-3.34,56.94,6.85,6.25,4.42,12.18,10.12,18.29,14.68,2.73,2.04,7.56,4.47,10.71,6.07,15.24,7.72,39.45,6.71,50.31,21.1,3.61,4.78,4.46,15.96,1.44,21.07-4.82,8.16-16.76,14.45-26.09,15.08-1.91.13-3.94-.1-5.86,0-3.23.15-10.14,1.39-12.97.1-.5-.23-.9-.45-.27-.85,12.39-2.12,28.01-7.1,30.26-21.44.83-5.3.53-9.66-4.05-13-3.37-2.46-4.39-1.88-8.28-2.06-.88-.04-2.08-.4-2.93-.4-6.38-.02-11.12,1.71-17.89.54-7.89-1.36-15-4.58-21.8-8.64-2.01-1.2-2.83-2.65-5.57-2.22-1.66.26-3.32,3.86-3.59,5.38-.89,4.92.65,9.6.36,14.6-.03.59-.31,1.2-.36,1.78-.25,2.52-.48,6.65-2.36,8.57-2.93,3-7.54,2.85-11.13,1.16-4.84-2.28-.99-8.13.1-11.6,1.13-3.61,1.99-8.83,1.44-12.56-.14-.93-.33-2.52-1.15-3.05-.15,2.38-1.42,4.44-2.15,6.73-.99,3.12-1.69,6.59-2.28,9.82-.53,2.93-.72,7.55-1.56,10.14-1.2,3.68-6.45,3.84-9.59,3.03-1.17-.3-3.92-1.8-4.23-2.98-.59-2.2,1.89-5.54,2.73-7.62,1.3-3.2,1.74-6.78.67-10.12-5.32.9-10.7,1.01-16.07,1.55-3.83-.05-7.9,0-11.69-.42-3.01-.33-6-1.16-9-1.55l-.31.14c-.26.77-.78,1.45-.78,2.32,0,4.9,2.09,12.45.86,17.03-.36,1.35-.69,1.98-2.01,2.48-2.34.9-4.68.65-7.1.26-2.16-.35-3.09-.32-3.73-2.7-2.13,2.43-5.03,4.39-8.03,5.63-1.98.82-2.3,1.08-3.77-.66-1.74-2.04-4.49-6.32-5.18-8.87-.73-2.68,3.09-3.85,4.66-5.11,4.59-3.68,7.53-14.89,6.71-20.5-.16-1.11-2.36-5.23-3.07-6.3-9.3-14.02-19.61-24.08-23.14-41.44C-.03,73.25-.72,56.5.73,41.5,1.99,28.52,5.9,9.87,17.05,1.83c1.03-.75,3.68-1.65,4.95-1.78.57-.06,1.58-.06,2.15,0ZM27.34,3.28c-2.71-2.07-6.61-1.54-9.42.19-6.03,3.71-10.03,14.9-12.12,21.44C2.48,35.25,1.73,49.12,1.31,60.02c-.18,4.68.67,9.57,1.44,14.19,2.94,17.8,5.87,29.48,17.23,43.84,6,7.58,11.48,11.81,10.82,22.56-.35,5.68-3.37,13.09-7.72,16.86-2.43,2.11-4.27,1.71-2.66,5.8.53,1.34,3.15,5.35,4.38,5.96,1.39.68,2.49.05,3.71-.67,5.11-2.99,13.98-15.82,16.3-21.35.34-.82.51-2.69.66-2.95.04-.07,1.19-.95,1.27-.98,1.05-.32,1.42.35,2.15.5,7.14,1.45,15.71,2.33,22.98,1.8,8.22-.6,17.36-.93,24.19-6.05,1.17-.87,2.33-1.83,3.51-2.73.53-.4.6-.88,1.36-.98,1.92-.26,2.34,1.41,2.74,2.93,1.62,6.08-.72,13.25-2.58,19.07-.63,1.98-1.97,3.08.14,4.83,1.25,1.03,3.97,1.26,5.56,1.22,2.72-.05,5.12-4.08,5.35-6.53.07-.75.15-1.39.22-2.1.49-5.27-.82-10.25.04-15.37.74-4.35,2.46-9.39,7.66-9.53,5.89,2.27,11.29,5.86,17.13,8.24,2.12.86,5.55,2.02,7.74,2.6,5.08,1.34,10.58-.09,15.7-.3,4.85-.2,12.07.4,15.81,3.72,5.38,4.77,5.36,10.99,3.47,17.51-2.38,8.23-9.39,12.73-17.16,15.22l-2.4,1.21c2.59-.41,4.84.13,7.48-.22,9.53-1.27,20.75-7,23.99-16.6,2-5.94,1.47-10.4-1.85-15.63-6.61-10.41-25.4-12.91-36.5-15.99-8.56-2.38-18.01-6.02-25.5-10.79-.79-.5-4.06-3.08-4.45-3.17-.15-.04-.29-.07-.44-.03-.45,2.69-2.68,5.1-5.61,4.14-.4-.13-1.95-1.35-2.2-1.7-.46-.64-.36-1.37-.69-1.84-.2-.28-.99-.75-1.35-1.18-2.44-2.9-.3-5.73,3.22-4.69-1.96-1.5-3.41-4.02-5.96-1.76-1.22,1.08-1.46,2.33-2.35,3.5-1.7,2.25-5.69,2.66-7.69.5-1.21-1.31-1.36-3.15-2.13-4.26-.15-.22-1.68-.88-2.16-1.4-2.62-2.84.99-5.4,3.7-5.77.41-.65-1.01-.89-1.4-1.02-.8-.25-4.75-1.35-5.23-1.03-.22.87.14,1.11-.49,2.04-.95,1.4-2.4,1.54-3.31,2.35-.39.35-.52,1.03-.87,1.47-1.67,2.06-3.19,2.59-5.67,1.37-.89-.44-1.27-1.08-1.96-1.56-1.96-1.35-4.77-.18-5.99-2.96.17-.89-.06-1.78-.06-2.72,0-.46.43-1.29.02-1.56-.64-.43-4.12.16-5.08.11.14,1.34,1.47,1.93.48,3.5-1.38,2.19-2.97,1.2-4.83,1.61-1.41.32-1.67,1.62-4.3,1.5-4.14-.19-2.35-3.15-1.88-5.83-6.54-.29-12.95.11-19.32-1.66-10.88-3.03-16.45-9.52-22.13-18.84-9.94-16.29-8.72-36.01-2.02-53.29,1.32-3.4,3.26-6.13,5.09-9.25.44-.37.96-.6,1.54-.41,1.89,1.4,6.45,4.64,8.55,2.4,1.31-1.41.82-3.48.52-5.22-.58-3.34-1.35-7.25-4.16-9.4ZM90.83,101.24c.3-.31.34-1.32.15-1.71-.56-1.14-3.42-.68-4.49-.78-1.88-.18-3.78-.61-5.66-.78-.74-.07-3.69-.34-4.11-.02-.76,1.15-.76,3.62.4,4.51.95.73,3.2.6,4.53,1.32,1.5.82,1.55,2.54,3.85,2.17,1.57-.25,1.08-1.9,1.86-2.82.71-.84,2.78-1.19,3.47-1.9ZM60.68,103.2c.43.38,1.99.18,2.54,0,.8-.28,1.11-1.04,1.7-1.23,1.14-.35,3.13.39,3.92-.95.57-.97-.74-1.37-.69-2.45l-.23-.17c-2.09-.2-4.08.53-6.17.56-.61.8-1.52,1.92-1.46,2.97.01.2.28,1.17.39,1.27ZM110.17,106.39c-.12-.21-3.74-2.41-4.07-2.48-.61-.12-1.2.78-2.38.66s-2.55-1.65-3.39-1.71c-1.07-.07-3.15,1-3.23,2.24-.12,1.86,2.37,2.15,3.11,3.15,1.14,1.53.33,4.33,3.45,4.37,2.77.03,2.77-2.21,3.99-3.81.4-.52,1.06-.95,1.58-1.35.32-.25,1.28-.45.93-1.06ZM114.63,112.06c-.68.21-.87,1.75-.68,2.37.25.83,2.08,1.56,2.58,2.1.57.61.47,2.21,1.42,2.49,1.62.48,3.33-1.92,3.34-3.38,0-1.21-1.16-2.4-2.26-2.78-.56-.19-4.02-.91-4.4-.8ZM97.51,140.9c-.2-.22-3.62,2.01-4.09,2.25-2.36,1.2-5.02,2.09-7.61,2.63v.29c.3.25.45.4.57.8,1.69,5.75.52,8.57-2.03,13.55-.57,1.1-1.7,2.14-1.44,3.48.85.24,1.63.91,2.46,1.15,1.22.35,4.33.61,5.45.1,1.27-.57,2-2.85,2.34-4.1.98-3.67,1.29-7.8,2.1-11.56.63-2.91,1.66-5.67,2.25-8.58ZM45.41,150.65c-.36-.09-.38.12-.55.32-.55.63-.91,1.71-1.43,2.47-1.32,1.91-3.05,3.86-4.49,5.85-.56.78-3.03,3.67-3.06,4.32-.08,1.85,1.25,2.52,2.83,2.82,2.46.46,6.36.41,7.05-2.66.91-4.06-.25-9.01-.34-13.12Z"}),jsxRuntimeExports.jsx("path",{d:"M27.34,3.28c2.81,2.15,3.59,6.05,4.16,9.4.3,1.75.79,3.81-.52,5.22-2.09,2.24-6.66-1-8.55-2.4-.58-.2-1.1.04-1.54.41-1.84,3.11-3.77,5.84-5.09,9.25-6.7,17.28-7.92,37,2.02,53.29,5.68,9.32,11.25,15.81,22.13,18.84,6.37,1.77,12.78,1.37,19.32,1.66-.47,2.68-2.26,5.64,1.88,5.83,2.63.12,2.89-1.19,4.3-1.5,1.86-.41,3.45.58,4.83-1.61.99-1.57-.34-2.16-.48-3.5.96.05,4.44-.54,5.08-.11.41.27-.02,1.1-.02,1.56,0,.94.23,1.82.06,2.72,1.21,2.78,4.03,1.61,5.99,2.96.69.47,1.07,1.12,1.96,1.56,2.47,1.22,4,.68,5.67-1.37.36-.44.48-1.12.87-1.47.91-.81,2.36-.95,3.31-2.35.63-.94.27-1.17.49-2.04.48-.32,4.44.78,5.23,1.03.39.12,1.81.37,1.4,1.02-2.71.37-6.32,2.92-3.7,5.77.48.52,2.01,1.19,2.16,1.4.77,1.1.92,2.95,2.13,4.26,2,2.16,5.99,1.75,7.69-.5.89-1.17,1.13-2.42,2.35-3.5,2.55-2.27,3.99.26,5.96,1.76-3.52-1.05-5.66,1.79-3.22,4.69.36.43,1.15.9,1.35,1.18.33.47.23,1.2.69,1.84.26.35,1.8,1.57,2.2,1.7,2.93.97,5.16-1.44,5.61-4.14.15-.04.29,0,.44.03.39.09,3.66,2.67,4.45,3.17,7.5,4.77,16.94,8.41,25.5,10.79,11.1,3.08,29.89,5.58,36.5,15.99,3.32,5.23,3.85,9.69,1.85,15.63-3.23,9.59-14.45,15.33-23.99,16.6-2.64.35-4.89-.19-7.48.22l2.4-1.21c7.77-2.49,14.78-7,17.16-15.22,1.89-6.52,1.91-12.73-3.47-17.51-3.74-3.32-10.96-3.92-15.81-3.72-5.12.21-10.62,1.64-15.7.3-2.19-.58-5.62-1.74-7.74-2.6-5.84-2.38-11.24-5.97-17.13-8.24-5.2.14-6.92,5.18-7.66,9.53-.87,5.11.44,10.1-.04,15.37-.07.71-.15,1.35-.22,2.1-.23,2.45-2.64,6.47-5.35,6.53-1.6.03-4.32-.19-5.56-1.22-2.11-1.75-.77-2.85-.14-4.83,1.87-5.83,4.21-13,2.58-19.07-.41-1.53-.82-3.2-2.74-2.93-.76.1-.84.58-1.36.98-1.18.9-2.35,1.86-3.51,2.73-6.84,5.12-15.98,5.45-24.19,6.05-7.27.53-15.83-.35-22.98-1.8-.73-.15-1.1-.82-2.15-.5-.08.02-1.23.91-1.27.98-.15.26-.31,2.13-.66,2.95-2.32,5.53-11.19,18.36-16.3,21.35-1.22.71-2.32,1.35-3.71.67-1.24-.61-3.86-4.62-4.38-5.96-1.61-4.09.23-3.69,2.66-5.8,4.35-3.78,7.37-11.18,7.72-16.86.67-10.76-4.82-14.98-10.82-22.56-11.36-14.36-14.28-26.04-17.23-43.84-.76-4.62-1.62-9.5-1.44-14.19.42-10.9,1.18-24.78,4.49-35.11,2.09-6.54,6.1-17.73,12.12-21.44,2.82-1.73,6.71-2.26,9.42-.19ZM23.31,7.49c-1.7.36-1.62,3.02.15,2.91s1.83-3.33-.15-2.91ZM30.74,95.87c-1.37.19-2.44,1.54-2.38,2.92.1,2.13,2.08,2.94,2.63,4.35.79,2.02-.23,4.69,2.04,6.35,4.18,3.06,9.11-4.45,6.97-8.14-.28-.49-5.37-3.82-6.23-4.31s-2.09-1.3-3.03-1.17ZM52.59,101.33c-.53.1-1.1.59-1.86.69-1.25.18-2.28-.24-3.43.47-.87.55-2.32,2.75-2.45,3.79-.24,1.87.75,2.27,1.35,3.68,1.21,2.83.55,6.47,4.6,6.91,4.8.52,5.46-3.67,4.9-7.44-.26-1.8-.37-2.05-.33-3.95.04-1.6-.58-4.61-2.79-4.17ZM74.4,108.01c-.64-.44-.88-.87-1.71-1.13-2.48-.77-5.18-.26-7.19,1.33s-1.28,3.14-1.89,5.13c-.44,1.43-1.32,1.81-.9,3.52.47,1.86,2.64,2.84,4.44,2.56,1.7-.27,3.31-2.59,4.98-3.02,1.33-.34,2.5.21,3.79.08,3.02-.29,5.46-2.98,3.83-5.94-1.07-1.94-3.77-1.46-5.36-2.54ZM87.71,111.09c-2.54.41-3.23,2.93-1.6,4.82.53.61,1.51,1.07,2.05,1.66.71.79.99,2.06,2.08,2.6,1.75.86,4.53-1.07,4.89-2.83.12-.6.15-2.19-.14-2.7-.1-.17-2.87-2.3-3.19-2.47-.87-.47-3.15-1.23-4.09-1.08Z"}),jsxRuntimeExports.jsx("path",{d:"M97.51,140.9c-.59,2.91-1.62,5.67-2.25,8.58-.81,3.75-1.12,7.89-2.1,11.56-.34,1.26-1.07,3.53-2.34,4.1-1.13.51-4.24.25-5.45-.1-.83-.24-1.61-.9-2.46-1.15-.27-1.34.87-2.37,1.44-3.48,2.55-4.97,3.72-7.8,2.03-13.55-.12-.4-.27-.54-.57-.8v-.29c2.59-.54,5.25-1.43,7.61-2.63.48-.24,3.89-2.46,4.09-2.25Z"}),jsxRuntimeExports.jsx("path",{d:"M45.41,150.65c.09,4.11,1.26,9.06.34,13.12-.69,3.07-4.59,3.12-7.05,2.66-1.58-.3-2.9-.97-2.83-2.82.03-.65,2.5-3.54,3.06-4.32,1.44-1.99,3.17-3.94,4.49-5.85.53-.76.89-1.83,1.43-2.47.17-.2.19-.41.55-.32Z"}),jsxRuntimeExports.jsx("path",{d:"M90.83,101.24c-.69.71-2.75,1.05-3.47,1.9-.78.92-.29,2.57-1.86,2.82-2.3.37-2.35-1.36-3.85-2.17-1.33-.72-3.58-.59-4.53-1.32-1.16-.89-1.17-3.36-.4-4.51.42-.32,3.37-.05,4.11.02,1.88.17,3.78.6,5.66.78,1.06.1,3.93-.36,4.49.78.19.39.15,1.4-.15,1.71Z"}),jsxRuntimeExports.jsx("path",{d:"M110.17,106.39c.35.61-.61.82-.93,1.06-.52.41-1.18.83-1.58,1.35-1.23,1.59-1.22,3.84-3.99,3.81-3.12-.03-2.31-2.83-3.45-4.37-.74-1-3.23-1.29-3.11-3.15.08-1.24,2.15-2.31,3.23-2.24.83.06,2.25,1.59,3.39,1.71s1.77-.78,2.38-.66c.33.07,3.95,2.27,4.07,2.48Z"}),jsxRuntimeExports.jsx("path",{d:"M114.63,112.06c.38-.12,3.84.6,4.4.8,1.1.38,2.26,1.57,2.26,2.78,0,1.45-1.72,3.86-3.34,3.38-.95-.28-.85-1.88-1.42-2.49-.5-.54-2.34-1.27-2.58-2.1-.18-.61,0-2.16.68-2.37Z"}),jsxRuntimeExports.jsx("path",{d:"M60.68,103.2c-.11-.1-.38-1.07-.39-1.27-.06-1.06.85-2.18,1.46-2.97,2.09-.03,4.08-.76,6.17-.56l.23.17c-.05,1.08,1.26,1.48.69,2.45-.79,1.35-2.78.6-3.92.95-.59.18-.9.95-1.7,1.23-.55.19-2.1.39-2.54,0Z"}),jsxRuntimeExports.jsx("path",{d:"M74.4,108.01c1.59,1.08,4.29.6,5.36,2.54,1.63,2.96-.81,5.64-3.83,5.94-1.29.13-2.46-.42-3.79-.08-1.67.43-3.28,2.75-4.98,3.02-1.8.29-3.97-.7-4.44-2.56-.43-1.71.45-2.09.9-3.52.62-1.99-.01-3.62,1.89-5.13,2.01-1.59,4.71-2.1,7.19-1.33.82.26,1.07.69,1.71,1.13ZM68.78,107.98c-1.27.18-1.95.68-2.44,1.85-.75,1.77-1.25,4.03-1.96,5.86.2,1.09.63,2.01,1.83,2.17,2.81.37,3.06-2.28,5.24-2.92.65-.19,2.44-.39,3.13-.4,1.09,0,1.41.68,2.61.09,1.34-.66,2.1-2.36.67-3.36-.68-.48-2.1-.82-3-1.29-2.22-1.17-3.15-2.42-6.09-2Z"}),jsxRuntimeExports.jsx("path",{d:"M52.59,101.33c2.2-.44,2.83,2.57,2.79,4.17-.04,1.9.07,2.14.33,3.95.55,3.77-.1,7.96-4.9,7.44-4.05-.44-3.39-4.08-4.6-6.91-.61-1.41-1.59-1.81-1.35-3.68.13-1.04,1.58-3.24,2.45-3.79,1.15-.72,2.18-.3,3.43-.47.76-.11,1.33-.59,1.86-.69ZM51.61,103.29c-.73.15-1.22.91-1.69,1.04-.82.22-2.32-.74-3.11.79-.99,1.92.76,4.74,1.43,6.52.46,1.23.39,2.86,1.6,3.67,1.58,1.06,2.81.44,3.88-.94,1.79-2.31.52-4.18.29-6.54-.17-1.74.62-5.17-2.4-4.54Z"}),jsxRuntimeExports.jsx("path",{d:"M30.74,95.87c.94-.13,2.2.7,3.03,1.17s5.95,3.82,6.23,4.31c2.14,3.69-2.79,11.2-6.97,8.14-2.27-1.66-1.24-4.33-2.04-6.35-.55-1.41-2.54-2.21-2.63-4.35-.06-1.37,1.01-2.73,2.38-2.92ZM30.92,97.42c-.71.2-1.21,1.68-1.08,2.36.24,1.28,1.8,2.11,2.26,3.02.78,1.55.22,4.1,1.81,5.21,1.47,1.03,3.25.34,4.16-1.08,1.53-2.36.41-5.11-1.55-6.81-.91-.78-4.54-3.01-5.61-2.7Z"}),jsxRuntimeExports.jsx("path",{d:"M87.71,111.09c.94-.15,3.22.62,4.09,1.08.32.17,3.09,2.29,3.19,2.47.29.5.26,2.09.14,2.7-.36,1.75-3.14,3.68-4.89,2.83-1.09-.53-1.37-1.81-2.08-2.6-.53-.59-1.52-1.05-2.05-1.66-1.63-1.89-.94-4.42,1.6-4.82ZM87.51,112.65c-.76.23-.56,1.3-.38,1.86.36,1.08,1.52,1.34,2.08,2.21.3.46.32,1.08.7,1.45,1.74,1.66,5.47-1.14,2.73-3.7-.99-.92-3.83-2.2-5.14-1.81Z"}),jsxRuntimeExports.jsx("path",{d:"M23.31,7.49c1.98-.42,1.96,2.8.15,2.91s-1.85-2.55-.15-2.91Z"}),jsxRuntimeExports.jsx("path",{d:"M68.78,107.98c2.94-.42,3.87.83,6.09,2,.9.47,2.32.81,3,1.29,1.42,1,.67,2.7-.67,3.36-1.2.59-1.53-.09-2.61-.09-.69,0-2.48.21-3.13.4-2.18.63-2.43,3.29-5.24,2.92-1.2-.16-1.63-1.09-1.83-2.17.71-1.83,1.21-4.09,1.96-5.86.49-1.17,1.17-1.67,2.44-1.85Z"}),jsxRuntimeExports.jsx("path",{d:"M51.61,103.29c3.02-.63,2.23,2.8,2.4,4.54.23,2.36,1.5,4.23-.29,6.54-1.07,1.38-2.3,1.99-3.88.94-1.21-.81-1.14-2.44-1.6-3.67-.67-1.78-2.42-4.6-1.43-6.52.79-1.53,2.29-.57,3.11-.79.47-.13.97-.89,1.69-1.04Z"}),jsxRuntimeExports.jsx("path",{d:"M30.92,97.42c1.07-.3,4.7,1.92,5.61,2.7,1.96,1.69,3.08,4.44,1.55,6.81-.92,1.42-2.69,2.1-4.16,1.08-1.6-1.11-1.03-3.66-1.81-5.21-.46-.91-2.02-1.74-2.26-3.02-.13-.67.37-2.15,1.08-2.36Z"}),jsxRuntimeExports.jsx("path",{d:"M87.51,112.65c1.31-.39,4.15.89,5.14,1.81,2.74,2.56-.98,5.36-2.73,3.7-.38-.36-.4-.98-.7-1.45-.56-.86-1.72-1.13-2.08-2.21-.19-.56-.39-1.63.38-1.86Z"})]}),jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{d:"M62.04,271.6c0,2.13.32,3.94,2.56,3.94,1.17,0,2.45-.64,3.62-1.49l1.81,2.24c-1.17,2.13-5.22,6.07-10.02,6.07-5.43,0-7.35-3.51-8.2-7.14-4.05,4.26-8.1,7.14-14.17,7.14-6.82,0-11.93-5.75-11.93-12.57,0-13.96,14.38-17.9,25.67-22.58v-5.22c0-5.65-4.26-9.91-7.88-9.91-1.92,0-2.77,7.14-8.42,7.14-4.15,0-6.07-1.6-6.07-5.01,0-4.47,5.01-5.86,9.06-5.86,7.88,0,23.97,4.69,23.97,16.94v26.31ZM51.39,251.15c-9.06,2.45-14.6,7.25-14.6,15.23,0,4.37,3.84,8.52,7.03,8.52,2.98,0,6.18-1.6,7.56-3.41v-20.35Z"}),jsxRuntimeExports.jsx("path",{d:"M77.66,282.36l-2.02-.85c2.13-5.01,3.73-11.19,3.73-18.22v-51.25c0-2.34-1.81-3.09-4.15-3.09v-2.88l14.81-6.61v35.9c4.15-4.47,7.46-7.03,13.21-7.03,13,0,17.58,12.36,17.58,23.97,0,12.25-7.03,30.04-21.31,30.04-6.5,0-10.97-3.84-14.17-7.88l-7.67,7.88ZM90.02,268.09c0,5.54,2.56,10.55,9.06,10.55,6.93,0,11.08-7.03,11.08-20.88,0-7.46-2.34-21.1-12.25-21.1-3.62,0-7.88,3.09-7.88,4.69v26.74Z"}),jsxRuntimeExports.jsx("path",{d:"M169.29,272.56c-5.75,6.61-11.51,9.8-17.37,9.8-13.85,0-22.48-10.44-22.48-24.61,0-16.83,10.12-29.4,24.93-29.4,4.79,0,12.04,1.92,12.04,8.74,0,3.09-2.88,5.22-5.86,5.22-7.88,0-5.65-10.23-8.95-10.23-5.86,0-11.51,6.18-11.51,20.24,0,9.59,5.75,22.05,16.62,22.05,3.94,0,6.71-1.49,9.59-4.15l2.98,2.34Z"})]})]});const GooseBadge=({elClass:s})=>jsxRuntimeExports.jsxs("svg",{className:s,xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 181.66 295.37",children:[jsxRuntimeExports.jsx("g",{id:"UZgtuK",children:jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{d:"M54.61,36.27c.03-.56.06-1.11.09-1.67.04-.02.08-.03.12-.05-.04-.02-.08-.03-.12-.05.03-.4.06-.8.09-1.2.04-.02.08-.03.12-.05-.04-.02-.08-.03-.12-.05,0-.71,0-1.42,0-2.14.04-.02.08-.03.12-.05-.04-.02-.08-.03-.12-.05.04-2.03-1.73-3.13-3.45-2.71-.02-.04-.03-.08-.05-.12-.02.04-.03.08-.05.12-.52.13-1.04.29-1.57.37-.59.1-1.19.13-1.78.18-.02-.04-.03-.08-.05-.12-.02.04-.03.08-.05.12-1.33-.25-2.66-.47-3.99-.74-1.76-.36-3.46-.92-4.97-1.93-.32-.21-.66-.4-1-.58-.65-.34-1.23-.75-1.69-1.34-.29-.38-.68-.67-1.03-1,0-.03,0-.07,0-.1,1.32-.78,1.27-1.59,1.2-2.58-.04-.61-.16-1.23-.16-1.84,0-.77.1-1.54.18-2.3.13-1.24.21-2.5.44-3.72.19-.99.59-1.95.85-2.93.23-.84.22-1.68-.54-2.29-.25-.2-.57-.31-.85-.45,0-.03,0-.06,0-.09,1.84-1.24,3.67-2.49,5.51-3.73.33-.23.66-.46.97-.72.67-.57,1.44-.92,2.29-1.16,1.26-.35,2.52-.73,3.77-1.13.73-.23,1.46-.17,2.2-.06.02.04.03.08.05.12.02-.04.03-.08.05-.12.56.09,1.11.19,1.67.28.02.04.03.08.05.12.02-.04.03-.08.05-.12.25.03.49.06.74.09.02.04.03.08.05.12.02-.04.03-.08.05-.12,1.78.16,3.14,1.25,4.57,2.14,1.09.68,2.11,1.5,3.08,2.34.47.41.79,1.02,1.14,1.56,1.1,1.74,2.2,3.47,3.25,5.24.26.44.38.97.53,1.47.23.74.43,1.48.64,2.23.21.74.48,1.47.4,2.27-.02.18.05.36.08.55-.04.02-.08.03-.12.05.04.02.08.03.12.05.09,1.09.19,2.17.28,3.26-.25.19-.18.38,0,.57.03.43.06.86.09,1.3,0,.16,0,.32,0,.48-.03.49-.06.99-.09,1.48-.04.02-.08.03-.12.05.04.02.08.03.12.05,0,.06,0,.12,0,.18-.04.02-.08.03-.12.05.04.02.08.03.12.05,0,.06,0,.12,0,.18-.04.02-.08.03-.12.05.04.02.08.03.12.05,0,.15,0,.3,0,.46-.04.02-.08.03-.12.05.04.02.08.03.12.05.03.59.06,1.18.09,1.76-.04.02-.08.03-.12.05.04.02.08.03.12.05,0,.59,0,1.18,0,1.76-.04.02-.08.03-.12.05.04.02.08.03.12.05-.03.15-.06.3-.09.46-.04.02-.08.03-.12.05.04.02.08.03.12.05-.22,1.27-.43,2.55-.65,3.82-.25,1.43-.51,2.85-.76,4.27-.19,1.12-.37,2.25-.55,3.37-.18,1.14-.34,2.28-.5,3.42-.06.44-.1.89-.16,1.33,0,.16,0,.32,0,.48-.06.56-.12,1.11-.19,1.67-.04.02-.08.03-.12.05.04.02.08.03.12.05-.03.46-.06.93-.09,1.39-.04.02-.08.03-.12.05.04.02.08.03.12.05,0,.06,0,.12,0,.18-.04.04-.12.09-.12.12.01.06.08.11.12.17-.09.74-.19,1.49-.28,2.23-.04.02-.08.03-.12.05.04.02.08.03.12.05-.03.4-.06.8-.09,1.2-.04.03-.12.06-.12.09,0,.5,0,1,0,1.5,0,.03.08.06.12.09-.03.65-.06,1.3-.09,1.95-.23.25-.2.5,0,.76,0,.15,0,.3,0,.46-.2.16-.2.32,0,.48,0,.15,0,.3,0,.46,0,.16,0,.32,0,.48.03.31.06.62.09.92-.04.02-.08.03-.12.05.04.02.08.03.12.05.19.87.37,1.74.58,2.61.36,1.46.73,2.92,1.11,4.38.16.63.37,1.24.55,1.86-.04.02-.08.03-.12.05.04.02.08.03.12.05.62,1.71,1.53,3.25,2.68,4.64,1.08,1.3,2.34,2.43,3.85,3.24,1.79.95,3.57,1.93,5.39,2.83,2.26,1.12,4.56,2.16,6.84,3.25.93.45,1.84.97,2.77,1.42,1.88.91,3.8,1.77,5.66,2.71.85.43,1.62,1.01,2.43,1.53,1.04.66,2.09,1.32,3.13,1.99.26.17.51.35.74.56,1.2,1.15,2.34,2.36,3.58,3.46,1.65,1.46,3.37,2.86,5.07,4.26.91.75,1.76,1.53,2.45,2.51.96,1.36,2.07,2.62,3.07,3.95.8,1.06,1.53,2.18,2.27,3.28,1.13,1.66,2.3,3.29,3.58,4.84.6.73.95,1.66,1.47,2.47.69,1.08,1.49,2.09,2.15,3.19.66,1.11,1.22,2.28,1.82,3.43.05.1.08.21.16.28,1.08.98,1.66,2.35,2.59,3.43.48.55,1.1.98,1.65,1.46.55.47,1.16.89,1.65,1.42.88.96,2.03,1.25,3.22,1.5.28.06.58.07.87.1.02.04.03.08.05.12.02-.04.03-.08.05-.12.74,0,1.49,0,2.23,0,.02.04.03.08.05.12.02-.04.03-.08.05-.12.8-.16,1.62-.23,2.39-.49.95-.33,1.92-.55,2.9-.72,1.37-.24,2.62-.8,3.81-1.5.88-.51,1.76-1.02,2.65-1.52.34-.19,1-.06,1.2.21-.05.03-.09.05-.14.08.05.04.09.08.14.12-.09.76-.16,1.52-.28,2.27-.12.74-.31,1.47-.46,2.2-.04.02-.08.03-.12.05.04.02.08.03.12.05-.27,1.14-.54,2.28-.82,3.42-.39,1.58-1.28,2.92-2.04,4.32-.58,1.06-1.18,2.11-1.84,3.12-.33.51-.77.96-1.22,1.39-1.11,1.07-2.24,2.14-3.39,3.16-.75.67-1.51,1.36-2.36,1.86-1.14.67-2.37,1.22-3.59,1.75-1.57.69-3.18,1.31-4.77,1.96-1.59.64-3.18,1.28-4.77,1.92-.14.06-.3.09-.43.17-1.06.62-2.19.97-3.41,1.1-.62.07-1.25.24-1.84.46-.34.12-.68.37-.9.66-1.07,1.4-2.27,2.64-3.81,3.54-.93.54-1.81,1.18-2.71,1.78-.24-.13-.47-.36-.71-.36-.92-.01-1.85.03-2.77.09-.51.04-1.08.06-1.24.73-.03,0-.05,0-.08,0-1.65-.31-3.29-.62-4.94-.94-.02-.04-.03-.08-.05-.12-.02.04-.03.08-.05.12-1.08-.3-2.16-.61-3.24-.91-.58-.17-1.1-.03-1.55.36-.79.69-1.69,1.03-2.73,1.14-.72.07-1.41.32-2.12.45-.88.15-1.77.26-2.65.38-.25-.48-.68-.52-1.15-.46-.35.04-.7.07-1.05.08-.74.01-1.48,0-2.22,0-.53,0-.84.3-.92.84-.03,0-.05,0-.08,0-.39-.32-.74-.7-1.18-.95-1.37-.77-2.7-1.57-3.86-2.64-.87-.8-1.82-1.54-2.64-2.39-.89-.92-1.63-1.99-2.52-2.9-1.05-1.08-1.56-2.53-2.56-3.64-.45-.5-.96-.99-1.53-1.31-1.79-1.01-3.65-1.9-5.45-2.9-1.39-.78-2.77-1.58-4.06-2.51-1.42-1.01-2.74-2.16-4.08-3.27-1.57-1.3-3.13-2.62-4.67-3.94-.26-.23-.46-.54-.67-.82-.52-.69-1.02-1.39-1.56-2.07-.72-.92-1.37-1.94-2.23-2.72-1.68-1.53-3.06-3.32-4.47-5.07-1.16-1.45-2.35-2.87-3.68-4.18-.59-.58-.97-1.35-1.49-2-.63-.8-1.37-1.52-1.96-2.35-.64-.89-1.24-1.82-1.72-2.8-.82-1.66-1.53-3.38-2.28-5.08-.4-.9-.84-1.79-1.15-2.73-.23-.69-.3-1.44-.41-2.17-.09-.59-.13-1.19-.19-1.79.04-.04.12-.09.12-.12-.01-.06-.08-.11-.12-.17.03-.21.09-.43.09-.64,0-2.82.51-5.55,1.28-8.25.34-1.2.67-2.41,1.02-3.61.44-1.53.84-3.07,1.35-4.57.71-2.11,1.52-4.18,2.55-6.17.67-1.3,1.14-2.71,1.75-4.04.48-1.05,1.06-2.06,1.58-3.09.32-.63.62-1.27.94-1.91.26-.53.47-1.08.78-1.57,1.16-1.81,2.38-3.58,3.51-5.41.68-1.09,1.21-2.27,1.86-3.38.65-1.1,1.41-2.14,2.03-3.26.59-1.08,1.15-2.2,1.57-3.36,1.01-2.74,1.98-5.5,2.58-8.36.34-1.61.6-3.24.9-4.86.04-.02.08-.03.12-.05-.04-.02-.08-.03-.12-.05.03-.53.06-1.05.09-1.58.04-.02.08-.03.12-.05-.04-.02-.08-.03-.12-.05.03-.37.06-.74.09-1.11.04-.03.12-.06.12-.09,0-.56,0-1.12,0-1.69,0-.03-.08-.06-.12-.09.03-.49.06-.99.09-1.48.04-.02.08-.03.12-.05-.04-.02-.08-.03-.12-.05ZM110.08,146.13c.58,0,1.15.02,1.72,0,1.11-.05,2.08-.43,2.77-1.36.82-1.1,1.23-2.4,1.65-3.67.36-1.09.29-2.23.3-3.36.02-2.17-.54-4.19-1.45-6.14-.54-1.15-1.08-2.3-1.63-3.45-.2-.42-.39-.84-.63-1.24-.2-.33-.54-.33-.87-.21-.32.11-.41.36-.36.67.04.24.07.5.17.71.54,1.17,1.08,2.34,1.65,3.49.61,1.26,1.14,2.54,1.41,3.92.27,1.41.38,2.84.12,4.25-.2,1.05-.59,2.08-.95,3.09-.48,1.31-1.45,1.89-2.85,1.81-1.27-.07-2.54-.04-3.81-.11-.94-.05-1.88-.14-2.8-.33-1.85-.37-3.68-.82-5.51-1.25-3.39-.8-6.79-1.54-9.86-3.32-1.99-1.16-3.86-2.46-5.55-4.02-1.26-1.17-2.22-2.58-3.1-4.04-.38-.63-.61-1.38-1.07-1.94-1.29-1.59-2.61-3.15-4.3-4.35-1.09-.77-2.13-1.64-3.41-2.04-1.1-.35-2.25-.54-3.37-.83-1.9-.5-3.53-1.43-4.81-2.99-1.43-1.74-2.79-3.52-3.72-5.59-.64-1.42-1.1-2.9-1.18-4.46-.13-2.46.09-4.89.83-7.25.44-1.41.9-2.82,1.83-3.99.68-.86,1.41-1.68,2.13-2.52.43-.51.83-1.05,1.32-1.49,1.96-1.76,4.32-2.01,6.8-1.72.59.07,1.18.25,1.77.3.52.04.88-.43.67-.89-.11-.24-.38-.48-.63-.56-.51-.17-1.05-.28-1.58-.32-1.86-.16-3.72-.28-5.49.49-1.13.49-2.19,1.12-3.02,2.04-.91,1.01-1.81,2.04-2.64,3.11-.61.79-1.24,1.61-1.65,2.52-1.51,3.35-2.02,6.9-1.83,10.56.02.35.08.71.14,1.05.31,1.79.95,3.45,1.81,5.05.99,1.84,2.25,3.48,3.63,5.04,1.63,1.85,3.74,2.85,6.16,3.26,1.48.25,2.88.72,4.13,1.58,1.53,1.05,2.96,2.2,4.14,3.64.39.48.84.92,1.17,1.44.43.67.76,1.42,1.17,2.11,1.16,1.97,2.65,3.65,4.42,5.1,1.42,1.17,2.94,2.18,4.53,3.07,1.64.92,3.34,1.72,5.17,2.18,2.71.68,5.45,1.27,8.15,1.99,2.75.73,5.53,1.03,8.36.99ZM52.94,9.73c.77-.46.94-.43,1.39.24.05.08.1.16.15.23.25.31.6.24.87.12.17-.08.37-.41.33-.58-.08-.37-.24-.76-.47-1.06-.56-.73-1.22-1.37-2.08-1.73-1.23-.52-2.51-.38-3.78-.16-.53.09-.83.5-.72.89.13.46.59.68,1.1.59.56-.1,1.13-.13,1.8-.21-.17.28-.27.44-.37.59-.54.9.1,2.36,1.13,2.52.26.04.67-.08.82-.27.29-.38.17-.81-.2-1.17Z"}),jsxRuntimeExports.jsx("path",{d:"M36.23,6.99c.29.15.61.26.85.45.76.61.76,1.45.54,2.29-.26.98-.67,1.94-.85,2.93-.23,1.22-.31,2.48-.44,3.72-.08.77-.17,1.54-.18,2.3,0,.61.11,1.23.16,1.84.07.99.13,1.8-1.2,2.58-.03,0-.06,0-.09.02-1.04.12-2.08.25-3.13.37-1.24.14-2.49.27-3.73.41-.74.08-1.47.23-2.21.23-1.97.01-3.91.29-5.85.64-.32.06-.64.11-.97.11-2.11,0-4.23.03-6.34,0-1.84-.03-3.69-.08-5.53-.19-1.18-.07-2.37-.21-3.54-.38-1.02-.15-1.78-.91-1.99-1.86-.18-.85.28-1.8,1.13-2.38.97-.66,2.09-.89,3.2-1.04,2.21-.29,4.4-.64,6.57-1.15,2.06-.48,4.15-.86,6.25-1.17,1.1-.17,2.11-.51,3.08-1,1.86-.93,3.69-1.92,5.51-2.93.45-.25.84-.64,1.18-1.04,1.5-1.74,3.13-3.31,5.26-4.29.66-.3,1.31-.56,2.05-.52.09,0,.18.01.28.02Z"}),jsxRuntimeExports.jsx("path",{d:"M84.99,165.62c.08-.54.38-.83.92-.84.74-.01,1.48,0,2.22,0,.35,0,.7-.04,1.05-.08.47-.05.9-.01,1.15.46-.06.35-.08.71-.2,1.03-.54,1.44-.76,2.93-.44,4.43.25,1.17.89,2.13,1.88,2.89,1.17.9,2.52,1.37,3.86,1.89.36.14.71.32,1.03.54,1.04.71.97,2.32-.07,3.03-1.06.72-2.23.75-3.4.6-1.35-.18-2.66-.62-4.01-.73-1.44-.12-2.88-.17-4.33.26-1.64.48-3.35.74-5.03,1.07-1.08.21-2.16.41-3.24.58-1.28.2-2.56.42-3.85.54-1.2.1-2.42.16-3.62.08-.96-.06-1.8-.58-2.46-1.29-.45-.49-.46-1.1-.19-1.7.32-.71.93-1.01,1.67-1.08,1.95-.19,3.91-.34,5.85-.58,1.75-.22,3.5-.44,5.21-.84,2.17-.5,4.16-1.45,5.48-3.35.65-.93,1.01-2.04,1.12-3.21.12-1.25-.18-2.43-.58-3.59,0-.03,0-.06,0-.09Z"}),jsxRuntimeExports.jsx("path",{d:"M107.75,164.69c.16-.67.73-.69,1.24-.73.92-.07,1.85-.1,2.77-.09.24,0,.47.23.71.36.01.25.03.49.04.74,0,.09,0,.19,0,.28-.03,1.02-.11,2.05-.07,3.07.05,1.25.17,2.49.79,3.64.74,1.35,1.91,1.97,3.36,2.04,1.13.05,2.26-.06,3.39-.07,1.1,0,1.62.51,1.67,1.61,0,.14.04.27.06.41.1.48-.1.95-.53,1.19-1.01.57-2.11.82-3.24.89-1.42.09-2.84-.06-4.26-.24-2.19-.29-4.35-.07-6.47.56-.99.3-1.99.61-3,.83-1.38.3-2.78.35-4.18,0-.9-.23-1.42-.81-1.58-1.69-.16-.91,0-1.8.83-2.31.57-.35,1.28-.55,1.95-.67,1.26-.22,2.54-.27,3.8-.49,1.2-.21,2.22-.86,2.93-1.83.39-.53.59-1.27.69-1.94.26-1.72-.09-3.38-.75-4.98-.06-.16-.11-.32-.17-.48,0-.03,0-.06,0-.09Z"}),jsxRuntimeExports.jsx("path",{d:"M54.51,37.86s.12.06.12.09c0,.56,0,1.12,0,1.69,0,.03-.08.06-.12.09,0-.62,0-1.25,0-1.87Z"}),jsxRuntimeExports.jsx("path",{d:"M64.38,56.61s-.12-.06-.12-.09c0-.5,0-1,0-1.5,0-.03.08-.06.12-.09,0,.56,0,1.13,0,1.69Z"}),jsxRuntimeExports.jsx("path",{d:"M64.29,59.32c-.2-.25-.23-.5,0-.76,0,.25,0,.5,0,.76Z"}),jsxRuntimeExports.jsx("path",{d:"M67.65,22.2c-.18-.19-.25-.38,0-.57,0,.19,0,.38,0,.57Z"}),jsxRuntimeExports.jsx("path",{d:"M64.29,60.25c-.2-.16-.2-.32,0-.48,0,.16,0,.32,0,.48Z"}),jsxRuntimeExports.jsx("path",{d:"M67.74,23.97c0-.16,0-.32,0-.48,0,.16,0,.32,0,.48Z"}),jsxRuntimeExports.jsx("path",{d:"M64.29,61.18c0-.16,0-.32,0-.48,0,.16,0,.32,0,.48Z"}),jsxRuntimeExports.jsx("path",{d:"M65.04,47.66c0-.16,0-.32,0-.48,0,.16,0,.32,0,.48Z"}),jsxRuntimeExports.jsx("path",{d:"M112.51,165.25c0-.09,0-.19,0-.28v.28Z"}),jsxRuntimeExports.jsx("path",{d:"M30.54,105.1c.04.06.1.11.12.17,0,.03-.08.08-.12.12,0-.1,0-.19,0-.29Z"}),jsxRuntimeExports.jsx("path",{d:"M64.76,51.39c-.04-.06-.1-.11-.12-.17,0-.03.08-.08.12-.12,0,.1,0,.19,0,.29Z"}),jsxRuntimeExports.jsx("path",{d:"M151.12,129.07s-.09-.08-.14-.12c.05-.03.09-.05.14-.08,0,.07,0,.13,0,.2Z"}),jsxRuntimeExports.jsx("path",{d:"M36.23,6.99c-.09,0-.18-.01-.28-.02.09-.02.18-.05.28-.07,0,.03,0,.06,0,.09Z"}),jsxRuntimeExports.jsx("path",{d:"M54.79,30.96s.08.03.12.05c-.04.02-.08.03-.12.05,0-.03,0-.07,0-.1Z"}),jsxRuntimeExports.jsx("path",{d:"M54.79,33.19s.08.03.12.05c-.04.02-.08.03-.12.05,0-.03,0-.07,0-.1Z"}),jsxRuntimeExports.jsx("path",{d:"M54.7,34.5s.08.03.12.05c-.04.02-.08.03-.12.05,0-.03,0-.07,0-.1Z"}),jsxRuntimeExports.jsx("path",{d:"M54.61,36.27s.08.03.12.05c-.04.02-.08.03-.12.05,0-.03,0-.07,0-.1Z"}),jsxRuntimeExports.jsx("path",{d:"M67.65,30.96s-.08-.03-.12-.05c.04-.02.08-.03.12-.05,0,.03,0,.07,0,.1Z"}),jsxRuntimeExports.jsx("path",{d:"M67.74,30.41s-.08-.03-.12-.05c.04-.02.08-.03.12-.05,0,.03,0,.07,0,.1Z"}),jsxRuntimeExports.jsx("path",{d:"M54.33,42.52s.08.03.12.05c-.04.02-.08.03-.12.05,0-.03,0-.07,0-.1Z"}),jsxRuntimeExports.jsx("path",{d:"M47.79,28.81s.03-.08.05-.12c.02.04.03.08.05.12-.03,0-.07,0-.1,0Z"}),jsxRuntimeExports.jsx("path",{d:"M64.85,49.43s-.08-.03-.12-.05c.04-.02.08-.03.12-.05,0,.03,0,.07,0,.1Z"}),jsxRuntimeExports.jsx("path",{d:"M64.76,50.92s-.08-.03-.12-.05c.04-.02.08-.03.12-.05,0,.03,0,.07,0,.1Z"}),jsxRuntimeExports.jsx("path",{d:"M67.74,28.54s-.08-.03-.12-.05c.04-.02.08-.03.12-.05,0,.03,0,.07,0,.1Z"}),jsxRuntimeExports.jsx("path",{d:"M64.48,53.72s-.08-.03-.12-.05c.04-.02.08-.03.12-.05,0,.03,0,.07,0,.1Z"}),jsxRuntimeExports.jsx("path",{d:"M51.24,28.25s.03-.08.05-.12c.02.04.03.08.05.12-.03,0-.07,0-.1,0Z"}),jsxRuntimeExports.jsx("path",{d:"M67.65,26.67s-.08-.03-.12-.05c.04-.02.08-.03.12-.05,0,.03,0,.07,0,.1Z"}),jsxRuntimeExports.jsx("path",{d:"M67.65,26.12s-.08-.03-.12-.05c.04-.02.08-.03.12-.05,0,.03,0,.07,0,.1Z"}),jsxRuntimeExports.jsx("path",{d:"M67.65,25.84s-.08-.03-.12-.05c.04-.02.08-.03.12-.05,0,.03,0,.07,0,.1Z"}),jsxRuntimeExports.jsx("path",{d:"M64.38,62.21s-.08-.03-.12-.05c.04-.02.08-.03.12-.05,0,.03,0,.07,0,.1Z"}),jsxRuntimeExports.jsx("path",{d:"M66.62,71.16s-.08-.03-.12-.05c.04-.02.08-.03.12-.05,0,.03,0,.07,0,.1Z"}),jsxRuntimeExports.jsx("path",{d:"M67.65,25.56s-.08-.03-.12-.05c.04-.02.08-.03.12-.05,0,.03,0,.07,0,.1Z"}),jsxRuntimeExports.jsx("path",{d:"M53.67.47s-.03.08-.05.12c-.02-.04-.03-.08-.05-.12.03,0,.07,0,.1,0Z"}),jsxRuntimeExports.jsx("path",{d:"M52.83.38s-.03.08-.05.12c-.02-.04-.03-.08-.05-.12.03,0,.07,0,.1,0Z"}),jsxRuntimeExports.jsx("path",{d:"M135.83,132.9s-.03.08-.05.12c-.02-.04-.03-.08-.05-.12.03,0,.07,0,.1,0Z"}),jsxRuntimeExports.jsx("path",{d:"M138.16,132.9s-.03.08-.05.12c-.02-.04-.03-.08-.05-.12.03,0,.07,0,.1,0Z"}),jsxRuntimeExports.jsx("path",{d:"M150.37,133.64s-.08-.03-.12-.05c.04-.02.08-.03.12-.05,0,.03,0,.07,0,.1Z"}),jsxRuntimeExports.jsx("path",{d:"M102.62,163.75s.03-.08.05-.12c.02.04.03.08.05.12-.03,0-.07,0-.1,0Z"}),jsxRuntimeExports.jsx("path",{d:"M51.06.1s-.03.08-.05.12c-.02-.04-.03-.08-.05-.12.03,0,.07,0,.1,0Z"}),jsxRuntimeExports.jsx("path",{d:"M67.37,18.37s-.08-.03-.12-.05c.04-.02.08-.03.12-.05,0,.03,0,.07,0,.1Z"}),jsxRuntimeExports.jsx("path",{d:"M54.42,40.84s.08.03.12.05c-.04.02-.08.03-.12.05,0-.03,0-.07,0-.1Z"}),jsxRuntimeExports.jsx("path",{d:"M35.01,23.13s.06-.02.09-.02c0,.03,0,.07,0,.1-.03-.03-.07-.06-.1-.08Z"}),jsxRuntimeExports.jsx("path",{d:"M107.75,164.69s0,.06,0,.09c-.03-.03-.05-.06-.08-.09.03,0,.05,0,.08,0Z"}),jsxRuntimeExports.jsx("path",{d:"M84.99,165.62s0,.06,0,.09c-.03-.03-.05-.06-.08-.09.03,0,.05,0,.08,0Z"}),jsxRuntimeExports.jsx("path",{d:"M52.94,9.73c.37.35.49.79.2,1.17-.15.19-.56.32-.82.27-1.04-.16-1.67-1.62-1.13-2.52.09-.16.19-.31.37-.59-.67.07-1.24.11-1.8.21-.51.09-.97-.13-1.1-.59-.11-.39.19-.8.72-.89,1.27-.22,2.55-.36,3.78.16.85.36,1.52,1.01,2.08,1.73.23.3.39.69.47,1.06.04.17-.16.5-.33.58-.27.12-.62.19-.87-.12-.06-.07-.1-.15-.15-.23-.46-.66-.63-.69-1.39-.24Z"})]})}),jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{d:"M40.55,226.39v.23h.45v-1.13c.41-2.4,1.46-3.61,3.16-3.61h1.13c2.4,0,3.61,2.7,3.61,8.11v3.38c-.15,15.44-.23,24.83-.23,28.17.15,0,.23.08.23.23h-.23c.15.3.23.53.23.68,0,9.05.9,15.51,2.7,19.38,1.99,1.8,3.64,2.7,4.96,2.7,3.12,0,6.35-5.56,9.69-16.68.45-3,1.88-4.51,4.28-4.51h.23c2.7.41,4.06,1.77,4.06,4.06,0,4.17-2.4,10.55-7.21,19.16-3.19,4.36-7.02,6.54-11.49,6.54-4.21,0-8.26-2.4-12.17-7.21-1.65-3.87-2.48-6.87-2.48-9.01-.19,0-1.09,2.1-2.7,6.31-4.47,8.11-10.03,12.17-16.68,12.17-5.18,0-10.07-1.65-14.65-4.96-4.96-5.26-7.44-12.55-7.44-21.86v-2.03c0-13.56,4.06-25.5,12.17-35.83,5.48-6.16,10.52-9.24,15.1-9.24,5.46-.01,9.9,1.64,13.28,4.95ZM8.54,268.31c0,6.87,1.58,12.13,4.73,15.78,2.97,1.8,5.97,2.7,9.01,2.7,7.44,0,12.85-12.85,16.23-38.54.3-2.33.45-4.88.45-7.66s-1.95-5.93-5.86-9.24c-1.84-.9-3.87-1.35-6.08-1.35-5.26,1.84-9.99,7.1-14.2,15.78-2.85,6.8-4.28,13.94-4.28,21.41,0,0,0,1.12,0,1.12Z"}),jsxRuntimeExports.jsx("path",{d:"M103.03,230.67c.45,1.5.68,3.23.68,5.18v1.35c0,6.24-2.4,11.79-7.21,16.68,3.61,1.05,7.06,3.98,10.37,8.79,1.8,3.49,2.7,6.95,2.7,10.37v.45c0,1.8-.3,3.68-.9,5.63,3.38-1.43,7.29-4.81,11.72-10.14,1.58-2.55,3.16-3.83,4.73-3.83h.45c2.22,0,3.57,1.43,4.06,4.28,0,2.44-3.46,6.8-10.37,13.07-9.5,6.31-15.74,9.47-18.71,9.47-8.6,2.25-14.76,3.38-18.48,3.38-2.93,0-6.91-.75-11.94-2.25-1.69,0-2.82-6.76-3.38-20.28-.6-6.35-.9-11.76-.9-16.23.45-20.66,1.35-31.78,2.7-33.35,1.01-.9,2.14-1.35,3.38-1.35,2.03,0,3.23,1.58,3.61,4.73,4.88-4.66,9.69-6.99,14.42-6.99,6.12,0,10.48,3.68,13.07,11.04ZM74.63,253.66h.23c4.17,0,8.75-1.5,13.75-4.51,4.36-3.12,6.54-7.25,6.54-12.4v-.45c-.38-5.26-1.95-7.89-4.73-7.89,0-.15-.15-.23-.45-.23-4.36,0-8.41,3.53-12.17,10.59-2.1,4.62-3.16,7.7-3.16,9.24v5.65h0ZM76.89,286.11c2.67.45,4.47.68,5.41.68,3.72,0,8-.98,12.85-2.93,3.91-3.04,5.86-6.57,5.86-10.59v-.23c0-5.45-2.93-9.35-8.79-11.72-1.77-.75-3.72-1.13-5.86-1.13-7.51,1.58-11.42,2.63-11.72,3.16.86,15.17,1.61,22.76,2.25,22.76Z"}),jsxRuntimeExports.jsx("path",{d:"M157.57,229.32c1.2,3.38,1.8,6.84,1.8,10.37v1.8c0,2.03-1.28,3.23-3.83,3.61h-.23c-2.07,0-3.27-1.58-3.61-4.73-.71-5.26-1.54-7.89-2.48-7.89,0-.98-1.8-1.88-5.41-2.7-.49,0-.86-.08-1.13-.23-4.47,0-8.08,4.73-10.82,14.2-.45,4.7-.68,8.83-.68,12.4,0,15.85,2.7,25.54,8.11,29.07,1.84,1.05,4.24,1.58,7.21,1.58h.68c7.21,0,13.37-2.85,18.48-8.56,3.68-4.96,6.24-9.39,7.66-13.3,1.05-1.8,2.4-2.7,4.06-2.7,2.85.53,4.28,1.95,4.28,4.28-.6,3-3.08,7.89-7.44,14.65-3.79,5.93-9.73,10.22-17.8,12.85-3.27.9-6.35,1.35-9.24,1.35h-.9c-10.97,0-18.1-5.93-21.41-17.8-1.5-4.77-2.25-11.83-2.25-21.18,0-11.79,1.43-19.61,4.28-23.44,3.79-7.96,9.05-11.94,15.78-11.94,6.25-.03,11.21,2.75,14.89,8.31Z"})]})]});const SwanBadge=({elClass:s})=>jsxRuntimeExports.jsxs("svg",{className:s,xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 194.67 252.45",children:[jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{d:"M47.05,183.47v.23h.45v-1.13c.41-2.4,1.46-3.61,3.16-3.61h1.13c2.4,0,3.61,2.7,3.61,8.11v3.38c-.15,15.44-.23,24.83-.23,28.17.15,0,.23.08.23.23h-.23c.15.3.23.53.23.68,0,9.05.9,15.51,2.7,19.38,1.99,1.8,3.64,2.7,4.96,2.7,3.12,0,6.35-5.56,9.69-16.68.45-3,1.88-4.51,4.28-4.51h.23c2.7.41,4.06,1.77,4.06,4.06,0,4.17-2.4,10.55-7.21,19.16-3.19,4.36-7.02,6.54-11.49,6.54-4.21,0-8.26-2.4-12.17-7.21-1.65-3.87-2.48-6.87-2.48-9.01-.19,0-1.09,2.1-2.7,6.31-4.47,8.11-10.03,12.17-16.68,12.17-5.18,0-10.07-1.65-14.65-4.96-4.96-5.26-7.44-12.55-7.44-21.86v-2.03c0-13.56,4.06-25.5,12.17-35.83,5.48-6.16,10.52-9.24,15.1-9.24,5.46-.01,9.9,1.64,13.28,4.95ZM15.04,225.39c0,6.87,1.58,12.13,4.73,15.78,2.97,1.8,5.97,2.7,9.01,2.7,7.44,0,12.85-12.85,16.23-38.54.3-2.33.45-4.88.45-7.66s-1.95-5.93-5.86-9.24c-1.84-.9-3.87-1.35-6.08-1.35-5.26,1.84-9.99,7.1-14.2,15.78-2.85,6.8-4.28,13.94-4.28,21.41,0,0,0,1.12,0,1.12Z"}),jsxRuntimeExports.jsx("path",{d:"M109.53,187.75c.45,1.5.68,3.23.68,5.18v1.35c0,6.24-2.4,11.79-7.21,16.68,3.61,1.05,7.06,3.98,10.37,8.79,1.8,3.49,2.7,6.95,2.7,10.37v.45c0,1.8-.3,3.68-.9,5.63,3.38-1.43,7.29-4.81,11.72-10.14,1.58-2.55,3.16-3.83,4.73-3.83h.45c2.22,0,3.57,1.43,4.06,4.28,0,2.44-3.46,6.8-10.37,13.07-9.5,6.31-15.74,9.47-18.71,9.47-8.6,2.25-14.76,3.38-18.48,3.38-2.93,0-6.91-.75-11.94-2.25-1.69,0-2.82-6.76-3.38-20.28-.6-6.35-.9-11.76-.9-16.23.45-20.66,1.35-31.78,2.7-33.35,1.01-.9,2.14-1.35,3.38-1.35,2.03,0,3.23,1.58,3.61,4.73,4.88-4.66,9.69-6.99,14.42-6.99,6.12,0,10.48,3.68,13.07,11.04ZM81.13,210.74h.23c4.17,0,8.75-1.5,13.75-4.51,4.36-3.12,6.54-7.25,6.54-12.4v-.45c-.38-5.26-1.95-7.89-4.73-7.89,0-.15-.15-.23-.45-.23-4.36,0-8.41,3.53-12.17,10.59-2.1,4.62-3.16,7.7-3.16,9.24v5.65h0ZM83.39,243.19c2.67.45,4.47.68,5.41.68,3.72,0,8-.98,12.85-2.93,3.91-3.04,5.86-6.57,5.86-10.59v-.23c0-5.45-2.93-9.35-8.79-11.72-1.77-.75-3.72-1.13-5.86-1.13-7.51,1.58-11.42,2.63-11.72,3.16.86,15.17,1.61,22.76,2.25,22.76Z"}),jsxRuntimeExports.jsx("path",{d:"M164.07,186.4c1.2,3.38,1.8,6.84,1.8,10.37v1.8c0,2.03-1.28,3.23-3.83,3.61h-.23c-2.07,0-3.27-1.58-3.61-4.73-.71-5.26-1.54-7.89-2.48-7.89,0-.98-1.8-1.88-5.41-2.7-.49,0-.86-.08-1.13-.23-4.47,0-8.08,4.73-10.82,14.2-.45,4.7-.68,8.83-.68,12.4,0,15.85,2.7,25.54,8.11,29.07,1.84,1.05,4.24,1.58,7.21,1.58h.68c7.21,0,13.37-2.85,18.48-8.56,3.68-4.96,6.24-9.39,7.66-13.3,1.05-1.8,2.4-2.7,4.06-2.7,2.85.53,4.28,1.95,4.28,4.28-.6,3-3.08,7.89-7.44,14.65-3.79,5.93-9.73,10.22-17.8,12.85-3.27.9-6.35,1.35-9.24,1.35h-.9c-10.97,0-18.1-5.93-21.41-17.8-1.5-4.77-2.25-11.83-2.25-21.18,0-11.79,1.43-19.61,4.28-23.44,3.79-7.96,9.05-11.94,15.78-11.94,6.25-.03,11.21,2.75,14.89,8.31Z"})]}),jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{d:"M80.27,112.52c-1.39-1.16-2.74-2.36-4.06-3.61-.57-.53-1.01-1.19-1.5-1.81-.1-.13-.15-.31-.23-.46-.18-.4-.06-.72.3-.91s.71-.1.94.23c1.48,2.16,3.44,3.83,5.44,5.44,1.94,1.57,4.02,2.9,6.25,4.01,3.58,1.78,7.36,2.99,11.29,3.72,2.27.42,4.55.85,6.84,1.04,2.23.18,4.48.06,6.73.04,2.32-.03,4.6-.49,6.84-1.08,3.54-.94,6.99-2.16,10.34-3.65,2.09-.94,4.16-1.9,6.2-2.93,3.7-1.86,7.22-4.03,10.43-6.65,3.15-2.54,5.7-5.57,7.7-9.09,2.79-4.85,5.19-9.91,7.36-15.08.87-2.08,1.63-4.21,2.44-6.33.05-.13.09-.26.17-.37.23-.35.53-.55.95-.33.39.21.5.53.33.95-.68,1.81-1.28,3.67-2.05,5.46-1.4,3.24-2.89,6.43-4.38,9.63-1.53,3.29-3.21,6.5-5.28,9.49-1.5,2.2-3.3,4.13-5.3,5.91-3.4,3-7.24,5.35-11.24,7.46-4.76,2.53-9.71,4.61-14.84,6.23-2.63.82-5.29,1.49-8.05,1.7-1.49.1-2.98.22-4.47.32-2.71-.08-5.37-.35-8.04-.77-3.38-.54-6.72-1.26-9.95-2.39-4.06-1.44-7.83-3.4-11.16-6.16Z"}),jsxRuntimeExports.jsx("path",{d:"M70.71,86.21c0-.85.5-1.45.98-2.04,1.7-2.08,3.44-4.13,5.2-6.16,2.18-2.53,4.67-4.73,7.33-6.74,3.34-2.52,7.1-4.11,11.2-4.93,2.23-.45,4.48-.83,6.77-.71,1.19.08,2.35.32,3.3,1.1,1.03.83,1.52,1.96,1.25,3.24-.4,1.9-.98,3.76-1.44,5.64-.17.68-.27,1.39-.33,2.09-.09,1.08.64,1.9,1.85,2.26,1.98.58,3.93.36,5.88-.08,2.39-.53,4.78-1.13,7.19-1.54,3.21-.54,6.42-.48,9.54.63.58.21,1.17.35,1.76.51.09.04.18.08.28.1.44.17.69.46.59.95-.1.42-.54.57-1.08.41-1.17-.35-2.35-.67-3.52-1.01-1.9-.55-3.83-.5-5.78-.36-3,.23-5.86,1.12-8.77,1.73-2.36.5-4.7.69-7.02-.15-1.73-.63-2.54-2.26-2.31-4.1.3-2.22,1.08-4.29,1.64-6.43.15-.58.12-1.25-.01-1.84-.18-.9-.95-1.28-1.76-1.49-.74-.18-1.54-.23-2.08-.31-2.89.19-5.47.6-8.01,1.34-3.11.91-5.97,2.34-8.54,4.3-1.22.94-2.39,1.94-3.51,2.98-1.27,1.18-2.53,2.39-3.67,3.69-1.71,1.94-3.33,3.97-4.96,5.98-.27.35-.45.78-.63,1.19-.15.37-.39.62-.78.54s-.55-.37-.55-.8Z"}),jsxRuntimeExports.jsx("path",{d:"M101.37,66.98c.54.08,1.34.13,2.08.31.81.21,1.58.59,1.76,1.49.13.59.17,1.26.01,1.84-.57,2.14-1.35,4.21-1.64,6.43-.23,1.84.58,3.47,2.31,4.1,2.32.85,4.66.65,7.02.15,2.92-.62,5.77-1.5,8.77-1.73,1.95-.14,3.88-.19,5.78.36,1.17.35,2.35.67,3.52,1.01.54.15.98.01,1.08-.41.1-.49-.15-.78-.59-.95-.1-.03-.19-.06-.28-.1-.59-.17-1.18-.31-1.76-.51-3.12-1.1-6.33-1.17-9.54-.63-2.41.41-4.8,1.01-7.19,1.54-1.95.44-3.9.65-5.88.08-1.21-.36-1.94-1.18-1.85-2.26.06-.71.17-1.41.33-2.09.46-1.87,1.04-3.74,1.44-5.64.27-1.27-.22-2.4-1.25-3.24-.95-.78-2.11-1.03-3.3-1.1-2.29-.13-4.53.26-6.77.71-4.1.82-7.86,2.41-11.2,4.93-2.66,2.02-5.15,4.21-7.33,6.74-1.76,2.03-3.51,4.08-5.2,6.16-.48.59-.98,1.19-.98,2.04,0,.42.15.72.55.8s.63-.17.78-.54c.18-.41.36-.85.63-1.19,1.63-2.02,3.25-4.05,4.96-5.98,1.14-1.3,2.4-2.5,3.67-3.69,1.12-1.04,2.29-2.04,3.51-2.98,2.57-1.96,5.43-3.39,8.54-4.3,2.54-.73,5.12-1.14,8.01-1.34ZM76.21,108.91c1.32,1.25,2.67,2.45,4.06,3.61,3.33,2.76,7.1,4.73,11.16,6.16,3.24,1.13,6.57,1.85,9.95,2.39,2.67.42,5.33.69,8.04.77,1.49-.1,2.98-.22,4.47-.32,2.76-.21,5.42-.87,8.05-1.7,5.14-1.62,10.08-3.7,14.84-6.23,3.99-2.11,7.83-4.46,11.24-7.46,2-1.77,3.8-3.71,5.3-5.91,2.07-2.99,3.75-6.2,5.28-9.49,1.49-3.2,2.98-6.4,4.38-9.63.77-1.78,1.37-3.65,2.05-5.46.17-.42.05-.74-.33-.95-.42-.22-.72-.01-.95.33-.08.12-.12.24-.17.37-.81,2.12-1.57,4.25-2.44,6.33-2.17,5.16-4.57,10.22-7.36,15.08-2,3.52-4.56,6.55-7.7,9.09-3.21,2.62-6.73,4.79-10.43,6.65-2.04,1.03-4.11,1.99-6.2,2.93-3.35,1.49-6.79,2.71-10.34,3.65-2.25.59-4.52,1.05-6.84,1.08-2.25.03-4.49.14-6.73-.04-2.3-.19-4.57-.62-6.84-1.04-3.93-.73-7.7-1.94-11.29-3.72-2.23-1.1-4.31-2.44-6.25-4.01-2-1.62-3.97-3.29-5.44-5.44-.23-.33-.58-.42-.94-.23s-.48.51-.3.91c.08.15.13.33.23.46.49.62.94,1.28,1.5,1.81ZM7.6,20.88c1.04-3.45,2.11-6.9,4.12-9.95,1.05-1.59,2.44-2.86,3.98-3.96,1.21-.85,2.5-1.57,3.66-2.49,1.34-1.08,2.72-2.08,4.29-2.79C25.95.67,28.31-.05,30.88,0c1.9.03,3.83-.06,5.69.37,1.49.35,2.88.95,4.16,1.78.19.13.41.23.62.35.04.09.05.19.12.26,1.19,1.13,2.4,2.26,3.6,3.38.39.36.77.73,1.16,1.09.96.78,1.62,1.81,2.16,2.92.28.58.58,1.16.92,1.71,1.19,1.94,1.99,4.05,2.21,6.29.31,3.06.53,6.14.58,9.21.04,1.55-.35,3.11-.58,4.66-.28,1.91-.98,3.71-1.7,5.51-.28.68-.36,1.44-.53,2.16-.06.1-.15.18-.19.3-.44,1.28-.87,2.58-1.3,3.88-.14.46-.27.92-.4,1.4-.17.42-.32.86-.49,1.28l-.58,1.31c-.22.42-.42.85-.63,1.27-1.19,2.47-2.36,4.94-3.6,7.38-.9,1.81-1.8,3.63-2.86,5.35-1.37,2.2-2.89,4.31-4.39,6.43-.71,1-1.63,1.86-2.3,2.9-.82,1.28-1.48,2.67-2.21,4.02-.21.48-.4.95-.59,1.43-.37,1.54-.01,3.71,1.53,4.52.26.14.65.24.89.14,1.04-.42,2-.92,2.68-1.93,2.23-3.29,4.79-6.36,7.77-9,2.13-1.89,4.42-3.6,6.7-5.3,3.39-2.52,6.77-5.07,10.3-7.4,2.85-1.89,5.88-3.51,8.89-5.14,3.96-2.16,8.1-3.85,12.33-5.38.96-.35,1.95-.59,2.92-.9,1.55-.51,3.09-1.07,4.65-1.54,1.86-.55,3.72-1.14,5.62-1.53,2.18-.45,4.4-.71,6.61-1.01,2.13-.3,4.28-.58,6.42-.81,1.22-.14,2.47-.19,3.7-.26,2.09-.09,4.2-.18,6.31-.23,2.43-.06,4.84-.13,7.27-.12,5.07.01,10.13.13,15.2.08,2.23-.03,4.46-.3,6.68-.57,2.8-.33,5.59-.76,8.37-1.21.83-.13,1.64-.41,2.44-.69,1.09-.41,2.25-.55,3.31-.3,1.53.36,3.03,1.04,3.57,2.75.63,2.02-.31,4.06-2.5,4.57-2.45.59-4.92,1.17-7.4,1.72-1.16.26-2.34.44-3.51.65-.04.83.03.91.76.91,1.14,0,2.29-.03,3.43.01,2.38.08,4.65-.42,6.91-1.07,1.89-.53,3.78-1.07,5.69-1.49,2.02-.44,3.97-.18,5.69,1.03.8.55,1.34,1.35,1.7,2.25.17.41.39.51.81.35,1.48-.55,2.94-1.13,4.44-1.58,1.75-.53,3.53-.94,5.29-1.4,1.36-.35,2.75-.4,4.13-.36,2.65.06,5.02,2.26,5.29,4.89.24,2.47-.89,4.21-2.66,5.77-1.4,1.21-2.68,2.54-3.96,3.88-.92.99-1.85,2.02-2.57,3.15-1.16,1.8-2.26,3.65-3.18,5.57-1,2.07-1.77,4.25-2.63,6.38-.09.22-.13.45-.18.68-.09.09-.21.18-.26.28-.37.82-.81,1.63-1.1,2.48-.53,1.59-.99,3.22-1.46,4.83-.24,1.22-.49,2.43-.72,3.65-.08.4-.09.8-.13,1.21-.12.63-.23,1.27-.35,1.9-.37,1.89-.63,3.8-1.14,5.64-.69,2.44-1.49,4.85-2.44,7.2-1.67,4.05-3.78,7.87-6.52,11.31-.86,1.07-1.55,2.27-2.36,3.39-1.45,2.02-3.36,3.52-5.5,4.75-3.92,2.25-7.97,4.22-12.28,5.62-1.9.63-3.94.89-5.92,1.27-1.99.4-3.99.77-6.01,1.12-1.34.22-2.68.37-4.02.54-1.44.19-2.88.37-4.31.55-.63.06-1.25.15-1.87.15-5.03.01-10.07-.01-15.1.03-2.97.01-5.95.14-8.91.22-1.34.04-2.67.12-4.02.12-9.01.01-18.04.05-27.06-.03-2.36-.03-4.73-.42-7.08-.76-3.24-.46-6.36-1.43-9.46-2.41-.17-.05-.37-.05-.57-.03-2.4.36-4.79.81-7.2,1.08-2.65.3-5.32.44-7.97.6-1.32.09-2.65.17-3.96.1-4.26-.19-8.51-.41-12.6-1.84-3.93-1.39-7.64-3.17-10.9-5.79-1.43-1.13-2.53-2.57-3.47-4.15-1.84-3.11-2.77-6.52-3.71-9.98-.87-3.21-1.16-6.46-1.01-9.75.09-1.84.37-3.67.74-5.47.54-2.66,1.16-5.29,1.86-7.9.44-1.58,1.16-3.06,1.68-4.61.69-2.04,1.53-3.99,2.77-5.77.65-.92,1-2.07,1.64-3,1.13-1.68,2.36-3.29,3.58-4.89,1.28-1.7,2.58-3.36,3.9-5.02,1.34-1.68,2.75-3.3,4.06-5,.68-.87,1.3-1.82,1.86-2.79,1.18-2.03,2.39-4.03,3.43-6.13.94-1.9,1.66-3.92,2.49-5.87.9-2.08,1.86-4.13,2.75-6.22,1.26-2.99,2.48-6,3.22-9.17.03-.09.08-.18.08-.28.01-2.75.14-5.51-.6-8.21-.27-.99-1-1.52-1.76-2.08-.69.44-.78,1.16-.81,1.85-.05.99-.01,1.98-.01,2.97-.01,3.26-1.04,6.18-3.02,8.77-.98,1.27-2,2.52-3.04,3.74-.41.48-.94.85-1.41,1.26-.68-.63-1.48-.36-2.25-.3-1.13.1-2.25.28-3.38.4-.32.03-.67-.06-.98-.15-1.85-.6-3.25-1.84-4.39-3.35-1.43-1.93-2.81-3.88-3.33-6.31-.21-.91-.6-1.8-.81-2.71-.14-.63-.35-1.12-.99-1.34.09-.54.1-1.1.26-1.62ZM14.53,16.59c-1.66-.21-2.57,1.23-2.53,2.5.05,1.5,1.07,2.57,2.57,2.61,1.16.03,2.59-1.08,2.58-2.54,0-1.17-.85-2.72-2.62-2.57Z"}),jsxRuntimeExports.jsx("path",{d:"M13.93,18.08c.05-.14.48-.18.72-.26.63.06.98.36,1.17,1,.14.49-.12,1.09-.59,1.4-.69.45-1.48.36-1.58-.28-.09-.6.12-1.26.28-1.86Z"}),jsxRuntimeExports.jsx("path",{d:"M13.93,18.08c-.17.6-.37,1.26-.28,1.86.1.64.89.73,1.58.28.48-.31.73-.91.59-1.4-.19-.64-.54-.94-1.17-1-.24.08-.67.12-.72.26ZM14.57,21.7c-1.5-.04-2.52-1.1-2.57-2.61-.04-1.27.87-2.71,2.53-2.5,1.77-.15,2.62,1.4,2.62,2.57.01,1.46-1.43,2.57-2.58,2.54Z"}),jsxRuntimeExports.jsx("path",{d:"M9.14,26.55c.51,2.43,1.9,4.38,3.33,6.31,1.14,1.52,2.54,2.75,4.39,3.35.31.09.65.18.98.15,1.13-.12,2.25-.3,3.38-.4.77-.06,1.57-.33,2.25.3.22.65,0,1.1-.45,1.67-1.22,1.49-2.31,3.08-3.36,4.7-.71,1.08-1.18,2.32-1.93,3.38-.9,1.27-1.94,2.43-2.95,3.62-1.87,2.2-3.76,4.39-5.68,6.56-.83.96-1.7,1.91-2.94,2.41-1.78.69-3.25-.82-3.3-2.3-.05-1.91.21-3.8.65-5.65.39-1.54.96-3.04,1.34-4.58.37-1.53.63-3.09.85-4.66.18-1.23.26-2.49.35-3.75.03-.42-.05-.86-.08-1.28-.05-.12-.09-.24-.13-.36-.17-1.72-.36-3.43-.46-5.15-.1-1.84-.1-3.69-.13-5.53,0-.26.14-.53.26-.77.23-.48.5-.94.72-1.41.23-.51.6-.71,1.13-.64.64.22.85.71.99,1.34.21.91.6,1.8.81,2.71Z"})]})]});const BalloonBadge=({elClass:s})=>jsxRuntimeExports.jsxs("svg",{className:s,xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 181.66 292.66",children:[jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{d:"M40.55,223.68v.23h.45v-1.13c.41-2.4,1.46-3.61,3.16-3.61h1.13c2.4,0,3.61,2.7,3.61,8.11v3.38c-.15,15.44-.23,24.83-.23,28.17.15,0,.23.08.23.23h-.23c.15.3.23.53.23.68,0,9.05.9,15.51,2.7,19.38,1.99,1.8,3.64,2.7,4.96,2.7,3.12,0,6.35-5.56,9.69-16.68.45-3,1.88-4.51,4.28-4.51h.23c2.7.41,4.06,1.77,4.06,4.06,0,4.17-2.4,10.55-7.21,19.16-3.19,4.36-7.02,6.54-11.49,6.54-4.21,0-8.26-2.4-12.17-7.21-1.65-3.87-2.48-6.87-2.48-9.01-.19,0-1.09,2.1-2.7,6.31-4.47,8.11-10.03,12.17-16.68,12.17-5.18,0-10.07-1.65-14.65-4.96-4.96-5.26-7.44-12.55-7.44-21.86v-2.03c0-13.56,4.06-25.5,12.17-35.83,5.48-6.16,10.52-9.24,15.1-9.24,5.46-.01,9.9,1.64,13.28,4.95ZM8.54,265.6c0,6.87,1.58,12.13,4.73,15.78,2.97,1.8,5.97,2.7,9.01,2.7,7.44,0,12.85-12.85,16.23-38.54.3-2.33.45-4.88.45-7.66s-1.95-5.93-5.86-9.24c-1.84-.9-3.87-1.35-6.08-1.35-5.26,1.84-9.99,7.1-14.2,15.78-2.85,6.8-4.28,13.94-4.28,21.41,0,0,0,1.12,0,1.12Z"}),jsxRuntimeExports.jsx("path",{d:"M103.03,227.96c.45,1.5.68,3.23.68,5.18v1.35c0,6.24-2.4,11.79-7.21,16.68,3.61,1.05,7.06,3.98,10.37,8.79,1.8,3.49,2.7,6.95,2.7,10.37v.45c0,1.8-.3,3.68-.9,5.63,3.38-1.43,7.29-4.81,11.72-10.14,1.58-2.55,3.16-3.83,4.73-3.83h.45c2.22,0,3.57,1.43,4.06,4.28,0,2.44-3.46,6.8-10.37,13.07-9.5,6.31-15.74,9.47-18.71,9.47-8.6,2.25-14.76,3.38-18.48,3.38-2.93,0-6.91-.75-11.94-2.25-1.69,0-2.82-6.76-3.38-20.28-.6-6.35-.9-11.76-.9-16.23.45-20.66,1.35-31.78,2.7-33.35,1.01-.9,2.14-1.35,3.38-1.35,2.03,0,3.23,1.58,3.61,4.73,4.88-4.66,9.69-6.99,14.42-6.99,6.12,0,10.48,3.68,13.07,11.04ZM74.63,250.95h.23c4.17,0,8.75-1.5,13.75-4.51,4.36-3.12,6.54-7.25,6.54-12.4v-.45c-.38-5.26-1.95-7.89-4.73-7.89,0-.15-.15-.23-.45-.23-4.36,0-8.41,3.53-12.17,10.59-2.1,4.62-3.16,7.7-3.16,9.24v5.65h0ZM76.89,283.4c2.67.45,4.47.68,5.41.68,3.72,0,8-.98,12.85-2.93,3.91-3.04,5.86-6.57,5.86-10.59v-.23c0-5.45-2.93-9.35-8.79-11.72-1.77-.75-3.72-1.13-5.86-1.13-7.51,1.58-11.42,2.63-11.72,3.16.86,15.17,1.61,22.76,2.25,22.76Z"}),jsxRuntimeExports.jsx("path",{d:"M157.57,226.61c1.2,3.38,1.8,6.84,1.8,10.37v1.8c0,2.03-1.28,3.23-3.83,3.61h-.23c-2.07,0-3.27-1.58-3.61-4.73-.71-5.26-1.54-7.89-2.48-7.89,0-.98-1.8-1.88-5.41-2.7-.49,0-.86-.08-1.13-.23-4.47,0-8.08,4.73-10.82,14.2-.45,4.7-.68,8.83-.68,12.4,0,15.85,2.7,25.54,8.11,29.07,1.84,1.05,4.24,1.58,7.21,1.58h.68c7.21,0,13.37-2.85,18.48-8.56,3.68-4.96,6.24-9.39,7.66-13.3,1.05-1.8,2.4-2.7,4.06-2.7,2.85.53,4.28,1.95,4.28,4.28-.6,3-3.08,7.89-7.44,14.65-3.79,5.93-9.73,10.22-17.8,12.85-3.27.9-6.35,1.35-9.24,1.35h-.9c-10.97,0-18.1-5.93-21.41-17.8-1.5-4.77-2.25-11.83-2.25-21.18,0-11.79,1.43-19.61,4.28-23.44,3.79-7.96,9.05-11.94,15.78-11.94,6.25-.03,11.21,2.75,14.89,8.31Z"})]}),jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{d:"M86.8,156.16h.44c2.35,3.41,6.65,2.95,8.95-.3,4.88,5.32,8.17,1.86,11.31-2.72,2.01-2.92,3.6-6.37,5.54-9.38,10.69-16.58,22.13-30.59,29.46-49.28,9.69-24.7,15.73-47.22,1.62-71.86C132.79,2.87,109.47-.86,88.42.15c-25.17,1.21-54.94,20.98-58.56,47.33-5.23,38.11,21.78,70.6,42.26,99.34,2.08,2.92,4.24,7.33,6.62,9.78,2.2,2.28,6.54,2.6,8.06-.44ZM101.11,162.13c-1.9.5-3.49,1.58-5.52,1.79-2.36.23-7.18.23-9.54,0-1.37-.14-2.62-.69-3.88-1.19-.47,0,.41,5.28.44,5.82.13,2.54-.38,5.58.39,7.97,1.55,4.83,9.69,4.04,13.42,2.55,1.64-.66,3-1.52,3.64-3.22.39-1.03,1.05-4.48,1.05-5.51v-8.2Z"}),jsxRuntimeExports.jsx("path",{d:"M86.8,156.16c-1.51,3.04-5.85,2.72-8.06.44-2.38-2.46-4.54-6.87-6.62-9.78-20.48-28.74-47.49-61.23-42.26-99.34C33.48,21.13,63.25,1.35,88.42.15c21.04-1.01,44.37,2.72,55.69,22.48,14.12,24.64,8.07,47.16-1.62,71.86-7.33,18.69-18.77,32.71-29.46,49.28-1.94,3.01-3.53,6.45-5.54,9.38-3.14,4.57-6.43,8.03-11.31,2.72-2.3,3.24-6.6,3.7-8.95.29h-.44ZM103.8,147.81c1.06-.2,2.24.76,3.13,0,6.16-10.1,12.46-20.13,18.82-30.1,5.03-7.88,8.75-12.5,12.06-21.64,2.89-7.98,5.81-16.33,8.43-24.38,2.33-7.17,3.92-23.19,1.71-30.21-1.47-4.66-4.68-14.01-7.22-17.84-10.5-15.81-30.49-21.35-48.71-19.89-.35.03-1.34.09-1.34.6,11.57,2.37,22.14,5.62,29.82,15.07,16.33,20.09,15.59,47.45,10.65,71.48-2.41,11.74-9.23,24.58-15.07,35.04-4.07,7.3-9.11,14.09-12.28,21.87ZM84.11,4.34c-5.91-.16-12.35,2.38-17.7,4.81-21.22,9.66-35.5,25.32-34.21,49.93,1.56,29.64,21.49,61.29,39.7,83.79.99,1.22,3.13,4.29,4.14,5.11.46.37,1.77.83,1.51-.02-5.87-9.67-10.94-19.92-15.76-30.17-11.87-25.26-18.85-43.76-12.07-72.24,3.91-16.4,10.97-29.14,26.14-37.39l8.25-3.82ZM88.14,6.72v.3c.19-.1.19-.2,0-.3ZM97.8,148.37c5.42-16.12,12.34-31.81,15.7-48.57,4.46-22.26,4.93-52.41-6.27-72.8-4.45-8.1-9.91-11.18-16.27-17.14-.41-.39-2.27-2.97-2.68-2.54,5.02,15.34,8.88,30.92,10.7,47.01,2.21,19.52,2.86,40.91,1.53,60.51-.77,11.33-2.64,22.66-6.27,33.41l3.55.12ZM86.19,8.21v-.59h-.29v.59h.29ZM82.92,148.4h5.67c-2.84-9.53-4.81-19.27-6.22-29.12-4.67-32.72-5.15-69.73,1.54-102.17.5-2.42,1.74-5.58,1.97-7.88.05-.45.22-.83-.42-.72-5.46,7.73-11.39,14.24-14.48,23.41-6.21,18.43-6.36,38.16-3.82,57.24,2.69,20.27,6.92,40.76,15.77,59.25Z"}),jsxRuntimeExports.jsx("path",{d:"M101.11,162.13v8.2c0,1.04-.66,4.48-1.05,5.51-.64,1.7-2.01,2.56-3.64,3.22-3.73,1.49-11.86,2.28-13.42-2.55-.77-2.39-.26-5.43-.39-7.97-.03-.54-.92-5.83-.44-5.82,1.25.5,2.51,1.06,3.88,1.19,2.36.23,7.18.23,9.54,0,2.03-.2,3.63-1.29,5.52-1.79Z"}),jsxRuntimeExports.jsx("path",{d:"M97.8,148.37l-3.55-.12c3.63-10.75,5.49-22.08,6.27-33.41,1.34-19.6.68-40.99-1.53-60.51-1.82-16.1-5.68-31.67-10.7-47.01.41-.43,2.27,2.15,2.68,2.54,6.36,5.96,11.81,9.04,16.27,17.14,11.2,20.39,10.73,50.54,6.27,72.8-3.36,16.77-10.29,32.45-15.7,48.57Z"}),jsxRuntimeExports.jsx("path",{d:"M103.8,147.81c3.17-7.78,8.21-14.57,12.28-21.87,5.84-10.47,12.65-23.31,15.07-35.04,4.94-24.03,5.68-51.4-10.65-71.48-7.68-9.45-18.25-12.7-29.82-15.07,0-.5.99-.57,1.34-.6,18.22-1.45,38.21,4.08,48.71,19.89,2.54,3.83,5.75,13.17,7.22,17.84,2.21,7.02.62,23.04-1.71,30.21-2.62,8.05-5.54,16.4-8.43,24.38-3.31,9.14-7.03,13.76-12.06,21.64-6.36,9.97-12.66,20-18.82,30.1-.89.76-2.06-.2-3.13,0Z"}),jsxRuntimeExports.jsx("path",{d:"M84.11,4.34l-8.25,3.82c-15.18,8.25-22.24,20.99-26.14,37.39-6.78,28.47.2,46.98,12.07,72.24,4.82,10.25,9.89,20.5,15.76,30.17.26.85-1.05.39-1.51.02-1.01-.82-3.15-3.88-4.14-5.11-18.21-22.5-38.14-54.15-39.7-83.79-1.29-24.61,12.99-40.28,34.21-49.93,5.35-2.44,11.79-4.97,17.7-4.81Z"}),jsxRuntimeExports.jsx("path",{d:"M82.92,148.4c-8.84-18.49-13.08-38.98-15.77-59.25-2.53-19.08-2.39-38.8,3.82-57.24,3.09-9.17,9.02-15.68,14.48-23.41.64-.11.46.27.42.72-.23,2.3-1.47,5.45-1.97,7.88-6.69,32.44-6.21,69.45-1.54,102.17,1.41,9.86,3.38,19.6,6.22,29.12h-5.67Z"}),jsxRuntimeExports.jsx("rect",{x:"85.9",y:"7.62",width:".29",height:".59"}),jsxRuntimeExports.jsx("path",{d:"M88.14,6.72c.19.1.19.2,0,.3v-.3Z"})]})]});const SheepBadge=({elClass:s})=>jsxRuntimeExports.jsxs("svg",{className:s,xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 187.81 271.16",children:[jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{d:"M43.62,202.18v.23h.45v-1.13c.41-2.4,1.46-3.61,3.16-3.61h1.13c2.4,0,3.61,2.7,3.61,8.11v3.38c-.15,15.44-.23,24.83-.23,28.17.15,0,.23.08.23.23h-.23c.15.3.23.53.23.68,0,9.05.9,15.51,2.7,19.38,1.99,1.8,3.64,2.7,4.96,2.7,3.12,0,6.35-5.56,9.69-16.68.45-3,1.88-4.51,4.28-4.51h.23c2.7.41,4.06,1.77,4.06,4.06,0,4.17-2.4,10.55-7.21,19.16-3.19,4.36-7.02,6.54-11.49,6.54-4.21,0-8.26-2.4-12.17-7.21-1.65-3.87-2.48-6.87-2.48-9.01-.19,0-1.09,2.1-2.7,6.31-4.47,8.11-10.03,12.17-16.68,12.17-5.18,0-10.07-1.65-14.65-4.96-4.96-5.26-7.44-12.55-7.44-21.86v-2.03c0-13.56,4.06-25.5,12.17-35.83,5.48-6.16,10.52-9.24,15.1-9.24,5.46-.01,9.9,1.64,13.28,4.95ZM11.61,244.1c0,6.87,1.58,12.13,4.73,15.78,2.97,1.8,5.97,2.7,9.01,2.7,7.44,0,12.85-12.85,16.23-38.54.3-2.33.45-4.88.45-7.66s-1.95-5.93-5.86-9.24c-1.84-.9-3.87-1.35-6.08-1.35-5.26,1.84-9.99,7.1-14.2,15.78-2.85,6.8-4.28,13.94-4.28,21.41,0,0,0,1.12,0,1.12Z"}),jsxRuntimeExports.jsx("path",{d:"M106.1,206.46c.45,1.5.68,3.23.68,5.18v1.35c0,6.24-2.4,11.79-7.21,16.68,3.61,1.05,7.06,3.98,10.37,8.79,1.8,3.49,2.7,6.95,2.7,10.37v.45c0,1.8-.3,3.68-.9,5.63,3.38-1.43,7.29-4.81,11.72-10.14,1.58-2.55,3.16-3.83,4.73-3.83h.45c2.22,0,3.57,1.43,4.06,4.28,0,2.44-3.46,6.8-10.37,13.07-9.5,6.31-15.74,9.47-18.71,9.47-8.6,2.25-14.76,3.38-18.48,3.38-2.93,0-6.91-.75-11.94-2.25-1.69,0-2.82-6.76-3.38-20.28-.6-6.35-.9-11.76-.9-16.23.45-20.66,1.35-31.78,2.7-33.35,1.01-.9,2.14-1.35,3.38-1.35,2.03,0,3.23,1.58,3.61,4.73,4.88-4.66,9.69-6.99,14.42-6.99,6.12,0,10.48,3.68,13.07,11.04ZM77.7,229.45h.23c4.17,0,8.75-1.5,13.75-4.51,4.36-3.12,6.54-7.25,6.54-12.4v-.45c-.38-5.26-1.95-7.89-4.73-7.89,0-.15-.15-.23-.45-.23-4.36,0-8.41,3.53-12.17,10.59-2.1,4.62-3.16,7.7-3.16,9.24v5.65h0ZM79.96,261.9c2.67.45,4.47.68,5.41.68,3.72,0,8-.98,12.85-2.93,3.91-3.04,5.86-6.57,5.86-10.59v-.23c0-5.45-2.93-9.35-8.79-11.72-1.77-.75-3.72-1.13-5.86-1.13-7.51,1.58-11.42,2.63-11.72,3.16.86,15.17,1.61,22.76,2.25,22.76Z"}),jsxRuntimeExports.jsx("path",{d:"M160.64,205.11c1.2,3.38,1.8,6.84,1.8,10.37v1.8c0,2.03-1.28,3.23-3.83,3.61h-.23c-2.07,0-3.27-1.58-3.61-4.73-.71-5.26-1.54-7.89-2.48-7.89,0-.98-1.8-1.88-5.41-2.7-.49,0-.86-.08-1.13-.23-4.47,0-8.08,4.73-10.82,14.2-.45,4.7-.68,8.83-.68,12.4,0,15.85,2.7,25.54,8.11,29.07,1.84,1.05,4.24,1.58,7.21,1.58h.68c7.21,0,13.37-2.85,18.48-8.56,3.68-4.96,6.24-9.39,7.66-13.3,1.05-1.8,2.4-2.7,4.06-2.7,2.85.53,4.28,1.95,4.28,4.28-.6,3-3.08,7.89-7.44,14.65-3.79,5.93-9.73,10.22-17.8,12.85-3.27.9-6.35,1.35-9.24,1.35h-.9c-10.97,0-18.1-5.93-21.41-17.8-1.5-4.77-2.25-11.83-2.25-21.18,0-11.79,1.43-19.61,4.28-23.44,3.79-7.96,9.05-11.94,15.78-11.94,6.25-.03,11.21,2.75,14.89,8.31Z"})]}),jsxRuntimeExports.jsx("g",{id:"E1TuAS",children:jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{d:"M130.55,111.07q-1.52-1.06-2.85.27c-1.37,1.36-2.59,2.9-4.5,3.56-.73.26-1.48.48-2.22.72-.05,0-.1,0-.15,0-2.55-.16-5.11-.28-7.65-.49-.76-.06-1.49-.4-2.24-.6-.05,0-.1,0-.15,0-1.96-.76-3.78-1.76-5.22-3.32-1.01-1.09-1.9-2.27-2.32-3.74-.07-.13-.14-.27-.26-.5-.09.23-.14.36-.19.5-.77,1.44-1.34,3.03-2.36,4.26-1.15,1.4-2.65,2.54-4.11,3.64-.94.71-2.07,1.21-3.17,1.68-2.48,1.05-4.92,2.23-7.6,2.71-1.04.19-2.11.18-3.17.26-.05,0-.1,0-.14,0,0,.05,0,.1-.01.15-.55-.28-1.09-.59-1.65-.84-2.75-1.22-5.5-2.44-8.26-3.63-2.61-1.13-5.23-2.22-7.83-3.32-.17.15-.33.28-.48.42-.24-.08-.5-.27-.73-.23-5,.81-9.48-.24-13.36-3.6-3.3-2.85-5.46-6.38-6.2-10.68-.31-1.78-.05-3.57.63-5.27.13-.31.26-.62.39-.93,0-.05,0-.1,0-.14-1.4-.34-2.84-.57-4.2-1.04-1.14-.4-2.28-.95-3.25-1.66-2.58-1.88-4.28-4.37-5.07-7.53-.64-2.56-.77-5.13-.12-7.63.56-2.14,1.33-4.29,3.14-5.83.16-.13.27-.31.4-.47.17-.13.35-.25.55-.4-.22-.09-.39-.15-.55-.22-3.75-1.89-6.23-4.96-7.78-8.76-.9-2.23-1.02-4.59-.22-6.93.05-.11.11-.22.16-.32.97-.41,1.97-.77,2.92-1.23,2.16-1.04,4.31-2.1,6.43-3.2,3.08-1.61,5.34-4.14,7.35-6.88.98-1.33,1.63-2.9,2.51-4.32,2.34-3.76,3.89-7.76,3.86-12.26,0-.27.1-.58.25-.8.61-.87,1.25-1.73,1.9-2.57,2.12-2.73,3.34-5.77,3.14-9.25-.09-1.57-.49-3.11-.75-4.67,1.21-.45,2.38-1.03,3.63-1.31,2.56-.56,5.07-.18,7.44.91,1.31.61,2.61,1.32,3.77,2.18,2.23,1.66,3.67,3.93,4.09,6.67.22,1.46.01,2.98-.07,4.48-.03.47.03.77.44,1.05,1.91,1.29,3.39,3,4.33,5.1.86,1.95,1.13,4.04,1,6.18.1.05.2.1.3.16,1.19-.05,2.38-.15,3.56-.15,2.08,0,3.77.93,5.27,2.31.22.2.49.34.74.51.12.14.23.27.46.53v-.53c.1-3.2,1.5-5.7,4.02-7.66,2.4-1.87,5.16-2.86,8.07-3.54.73-.17,1.49-.17,2.24-.25,2.36-.25,4.72-.22,7.05.32.23.05.47.09.67.2,1.81.93,3.62,1.85,5.4,2.83,2.09,1.16,3.64,2.92,5.05,4.81.11.14.22.27.37.46.1-.2.17-.33.24-.46.38-.71.65-1.51,1.15-2.13,1.95-2.4,4.55-3.64,7.59-3.99,1.06-.12,2.11-.25,3.17-.31,2.38-.12,4.63.55,6.88,1.17,1.95.53,3.73,1.43,5.3,2.73,1.1.91,2.39,1.63,3.34,2.66.96,1.05,1.81,2.31,2.35,3.63.63,1.54.87,3.24,1.32,4.86.05.19.37.44.58.45,1.35.09,2.7.1,4.05.18,2.9.18,5.68.86,8.38,1.94,1.53.61,2.9,1.47,4.05,2.58,1.13,1.09,2.12,2.35,3.04,3.63.85,1.17,1.54,2.46,2.35,3.77.71-.29,1.49-.57,2.24-.92,3.41-1.59,7.67.68,8.42,4.36.48,2.36-.68,5.41-3.02,6.63-.95.5-1.78,1.23-2.66,1.85,0,.05,0,.1,0,.15,1.96,1.57,3.25,3.62,4.15,5.94,1.03,2.63,1.5,5.36,1.33,8.17-.21,3.27-.58,6.55-2.1,9.51-1.2,2.35-2.84,4.34-5.53,5.2-.45.14-.97.75-1.05,1.22-.28,1.6-1.25,2.77-2.19,3.98-2.3,2.99-5.34,4.49-9.11,4.42-1.29-.02-2.58-.2-3.87-.3-.1.05-.21.1-.31.15-.05,0-.09,0-.14,0-.6-.37-1.21-.74-1.87-1.15-.26.5-.45.87-.63,1.24-.94,1.86-2.16,3.53-3.8,4.81-2.89,2.25-6.17,3.78-9.72,4.64-1.63.4-3.31.63-4.98.79-1.55.15-3.15.33-4.67.11-2.25-.32-4.44-.99-6.66-1.51-.1-.05-.21-.1-.31-.15Z"}),jsxRuntimeExports.jsx("path",{d:"M55.42,5.95c.26,1.56.65,3.11.75,4.67.21,3.48-1.02,6.53-3.14,9.25-.65.84-1.29,1.7-1.9,2.57-.15.22-.26.53-.25.8.04,4.51-1.52,8.5-3.86,12.26-.88,1.41-1.53,2.99-2.51,4.32-2.02,2.73-4.27,5.27-7.35,6.88-2.12,1.11-4.27,2.16-6.43,3.2-.95.46-1.94.82-2.92,1.23-.1.05-.21.11-.31.16-1.17.51-2.31,1.09-3.51,1.51-2.13.74-4.27,1.45-6.6,1.35-1.53-.07-3.07.18-4.6.1-2.6-.13-5.09-.65-7.23-2.31-1.48-1.14-2.26-2.69-2.85-4.38.14-.06.28-.14.43-.17,2.66-.44,5.15-1.36,7.49-2.69.33-.19.64-.64.69-1.01.15-.98-.82-1.44-1.97-.88-2.5,1.22-5.13,2.03-7.86,2.55-.37-1.06-.79-2.1-1.08-3.17-.84-3.14-.31-6.03,1.65-8.66.8-1.06,1.52-2.18,2.31-3.25,1.16-1.59,2.82-2.6,4.42-3.68,3.63-2.43,7.67-3.98,11.69-5.59.09-.04.17-.1.26-.16,3.01-1.08,6.16-1.66,9.25-2.44,2.68-.67,5.35-1,8.08-1.02,1.49-.01,1.48,0,1.52-1.53,0-.36.11-.72.14-1.08.36-3.87,1.58-7.4,4.08-10.42,1.4-1.12,2.77-2.27,4.2-3.34.81-.61,1.72-1.16,2.79-1.03.46.06.97.26,1.31.56,1.56,1.37,2.51,3.15,3.18,5.09.03.1.09.19.13.28ZM53.28,10.81c-.15-.56-.3-1.52-.67-2.38-.49-1.13-1.73-1.43-2.84-.91-2.28,1.07-3.38,3.05-4.06,5.29-.64,2.12-.5,4.26.36,6.34.61,1.49,2.2,1.87,3.34.73.42-.42.73-.94,1.11-1.4,1.76-2.1,2.53-4.56,2.76-7.65ZM33.45,25.54c0-1.47-.81-2.32-2.21-2.32-1.56,0-2.49.81-2.51,2.21-.02,1.49.94,2.53,2.36,2.5,1.34-.03,2.4-.87,2.36-2.4Z"}),jsxRuntimeExports.jsx("path",{d:"M130.87,111.22c2.22.52,4.42,1.18,6.66,1.51,1.52.22,3.12.05,4.67-.11,1.67-.16,3.35-.39,4.98-.79,3.55-.86,6.83-2.39,9.72-4.64,1.64-1.28,2.86-2.94,3.8-4.81.19-.37.38-.74.63-1.24.66.41,1.26.78,1.87,1.15-.18,1.52-.36,3.03-.52,4.55-.16,1.41-.31,2.83-.44,4.24-.08.93-.12,1.86-.17,2.8-.06.03-.13.06-.19.09.06.03.13.06.19.09-.16,1.3-.31,2.6-.47,3.9-.06.03-.13.06-.19.09.06.03.13.06.19.09-.21,1.82-.42,3.64-.63,5.46-.06.03-.13.06-.19.09.06.03.13.06.19.09-.05,1.13-.13,2.27-.13,3.4,0,1.16.09,2.32.13,3.48-.06.03-.13.06-.19.09.06.03.13.06.19.09-.05,1.74-.23,3.5-.1,5.23.18,2.4.66,4.77.88,7.16.24,2.66.32,5.34.49,8.01.05.75-.29,1.05-.98,1.25-2.07.58-4.19.67-6.31.77-1.45.07-2.9.2-4.35.31-1.99.15-2.5-1.22-2.62-2.51-.21-2.4.21-4.69,1.08-6.94.37-.97.59-2.07.61-3.11.08-3.33.11-6.66,0-9.99-.07-1.88-.47-3.75-.7-5.62-.14-1.18-.23-2.37-.37-3.56-.08-.67-.2-1.33-.31-1.99.01-.08.02-.16.03-.24-.07.08-.14.16-.21.23-1.16,1.94-1.46,4.08-1.41,6.29,0,.26.09.51.14.76-.06.03-.13.06-.19.09.06.03.13.06.19.09-.21,2.48-1.21,4.81-1.31,7.34-.07,1.78-.8,3.53-1.08,5.32-.35,2.3-.76,4.59-.47,6.96.19,1.52.07,3.08.03,4.62-.02.87-.85,1.72-1.72,1.77-3.14.18-6.28.36-9.42.47-1.93.07-2.75-.83-2.79-2.72-.03-1.61.44-3.08,1.13-4.49.72-1.48,1.57-2.89,2.26-4.38.9-1.97,1.95-3.89,2.36-6.05.18-.94.16-1.91.23-2.87.06-.03.13-.06.19-.09-.06-.03-.13-.06-.19-.09-.02-1.18.04-2.37-.09-3.55-.23-2.13-.52-4.26-.88-6.37-.25-1.47-.7-2.92-1.01-4.38-.4-1.86-1.32-3.47-2.29-5.07-.37-.61-.62-1.3-.92-1.96,0-.11,0-.21,0-.32Z"}),jsxRuntimeExports.jsx("path",{d:"M64.02,112.8c.15-.13.31-.27.48-.42,2.6,1.1,5.22,2.19,7.83,3.32,2.76,1.19,5.51,2.41,8.26,3.63.56.25,1.1.56,1.65.84.89,3.39,2.72,6.36,4.31,9.43.65,1.25,1.44,2.42,2.12,3.65.23.42.28.93.48,1.38.3.68.62,1.37.99,2.01,1.1,1.92,2.25,3.81,3.34,5.73.78,1.38,1.53,2.78,2.26,4.18.77,1.47.22,2.63-1.33,3.15-.91.3-1.74.85-2.65,1.15-1.38.45-2.79.77-4.19,1.17-.94.27-1.86.6-2.81.85-.52.14-1.07.18-1.61.25-2.53.3-3.34-1.39-3.68-3.08-.4-1.95-.4-3.98-.71-5.95-.23-1.4-.77-2.75-1.03-4.15-.41-2.22-1.6-4.07-2.64-6-.31-.57-.59-1.16-.94-1.7-.48-.76-1-.83-1.42-.07-.86,1.56-2.06,3-2.22,4.85-.17,1.97-.28,3.95-.32,5.92-.03,1.46,0,2.92.16,4.37.24,2.19-1.65,3.77-3.41,4.09-2.72.5-5.45.38-8.17.15-.66-.06-1.33-.18-1.95-.41-.75-.29-1.08-.95-1.08-1.75,0-1.7-.12-3.41.04-5.09.13-1.43.46-2.87.93-4.23.66-1.94,1.48-3.84,2.32-5.72,1.63-3.66,3.89-6.93,6.42-10.02.49-.6.98-1.22,1.38-1.88.16-.27.2-.71.1-1.02-.46-1.46-1-2.89-1.49-4.33-.48-1.43-.94-2.86-1.41-4.29Z"}),jsxRuntimeExports.jsx("path",{d:"M43.8,4.39c-2.51,3.03-3.72,6.56-4.08,10.42-.03.36-.13.72-.14,1.08-.04,1.53-.03,1.52-1.52,1.53-2.73.02-5.4.34-8.08,1.02-3.09.78-6.23,1.36-9.25,2.44-.91-.82-1.27-1.93-1.36-3.06-.18-2.27-.19-4.57,1.05-6.59.58-.95,1.34-1.84,2.16-2.6,2.52-2.33,5.62-2.98,8.91-2.61,1.41.16,2.77.79,4.15,1.21.15-.05.31-.1.46-.16,1.51-2.73,4.73-3.84,7.7-2.67Z"}),jsxRuntimeExports.jsx("path",{d:"M1.47,45.37c2.73-.52,5.36-1.33,7.86-2.55,1.15-.56,2.12-.1,1.97.88-.06.37-.37.83-.69,1.01-2.33,1.33-4.83,2.24-7.49,2.69-.15.02-.29.11-.43.17-.41-.73-.81-1.47-1.22-2.2Z"}),jsxRuntimeExports.jsx("path",{d:"M35.64,67.16c.16.06.33.13.55.22-.2.15-.37.27-.55.4,0-.21,0-.41,0-.62Z"}),jsxRuntimeExports.jsx("path",{d:"M123.49,30.74c-.07.13-.14.27-.24.46-.15-.19-.26-.33-.37-.46.2,0,.41,0,.61,0Z"}),jsxRuntimeExports.jsx("path",{d:"M90.38,34.04v.53c-.22-.26-.34-.39-.46-.53.15,0,.3,0,.46,0Z"}),jsxRuntimeExports.jsx("path",{d:"M102.79,107.47c.05-.13.1-.27.19-.5.12.23.19.37.26.5-.15,0-.31,0-.46,0Z"}),jsxRuntimeExports.jsx("path",{d:"M36.1,7.05c-.15.05-.31.1-.46.16.15-.05.31-.1.46-.16Z"}),jsxRuntimeExports.jsx("path",{d:"M130.87,111.22c0,.11,0,.21,0,.32-.11-.16-.21-.31-.32-.47.1.05.21.1.31.15Z"}),jsxRuntimeExports.jsx("path",{d:"M80.35,31.37c-.1-.05-.2-.1-.3-.16.1.05.2.1.3.16Z"}),jsxRuntimeExports.jsx("path",{d:"M27.48,51.29c.1-.05.21-.11.31-.16-.05.11-.11.22-.16.32-.05-.05-.1-.11-.15-.16Z"}),jsxRuntimeExports.jsx("path",{d:"M163.34,102.29c.1-.05.21-.1.31-.15-.1.05-.21.1-.31.15Z"}),jsxRuntimeExports.jsx("path",{d:"M148.12,119.85c.07-.08.14-.16.21-.23-.01.08-.02.16-.03.24-.06,0-.12,0-.18,0Z"}),jsxRuntimeExports.jsx("path",{d:"M162.07,114.07c-.06-.03-.13-.06-.19-.09.06-.03.13-.06.19-.09,0,.06,0,.12,0,.18Z"}),jsxRuntimeExports.jsx("path",{d:"M161.6,118.15c-.06-.03-.13-.06-.19-.09.06-.03.13-.06.19-.09,0,.06,0,.12,0,.18Z"}),jsxRuntimeExports.jsx("path",{d:"M160.97,123.79c-.06-.03-.13-.06-.19-.09.06-.03.13-.06.19-.09,0,.06,0,.12,0,.18Z"}),jsxRuntimeExports.jsx("path",{d:"M146.85,127.09c-.06-.03-.13-.06-.19-.09.06-.03.13-.06.19-.09,0,.06,0,.12,0,.18Z"}),jsxRuntimeExports.jsx("path",{d:"M160.97,130.85c-.06-.03-.13-.06-.19-.09.06-.03.13-.06.19-.09,0,.06,0,.12,0,.18Z"}),jsxRuntimeExports.jsx("path",{d:"M136.06,132.87c.06.03.13.06.19.09-.06.03-.13.06-.19.09,0-.06,0-.12,0-.18Z"}),jsxRuntimeExports.jsx("path",{d:"M182.02,64.01c0-.05,0-.1,0-.15,0,.05,0,.1,0,.15Z"}),jsxRuntimeExports.jsx("path",{d:"M44.73,91.94s0,.1,0,.14c0-.05,0-.1,0-.14Z"}),jsxRuntimeExports.jsx("path",{d:"M110.79,114.53c.05,0,.1,0,.15,0,0,0-.08,0-.08,0h-.08Z"}),jsxRuntimeExports.jsx("path",{d:"M120.83,115.63c.05,0,.1,0,.15,0,0,0-.08,0-.08,0h-.08Z"}),jsxRuntimeExports.jsx("path",{d:"M82.25,120.02s.1,0,.14,0c-.05,0-.1,0-.14,0Z"}),jsxRuntimeExports.jsx("path",{d:"M53.28,10.81c-.23,3.09-1,5.55-2.76,7.65-.38.46-.69.98-1.11,1.4-1.14,1.15-2.73.77-3.34-.73-.85-2.08-.99-4.22-.36-6.34.67-2.24,1.78-4.22,4.06-5.29,1.1-.52,2.34-.22,2.84.91.37.86.52,1.82.67,2.38Z"}),jsxRuntimeExports.jsx("path",{d:"M33.45,25.54c.04,1.52-1.02,2.37-2.36,2.4-1.42.03-2.38-1.02-2.36-2.5.02-1.4.95-2.22,2.51-2.21,1.41,0,2.22.86,2.21,2.32Z"})]})})]});const RockinghorseBadge=({elClass:s})=>jsxRuntimeExports.jsxs("svg",{className:s,xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 181.66 279.55",children:[jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{d:"M40.55,210.57v.23h.45v-1.13c.41-2.4,1.46-3.61,3.16-3.61h1.13c2.4,0,3.61,2.7,3.61,8.11v3.38c-.15,15.44-.23,24.83-.23,28.17.15,0,.23.08.23.23h-.23c.15.3.23.53.23.68,0,9.05.9,15.51,2.7,19.38,1.99,1.8,3.64,2.7,4.96,2.7,3.12,0,6.35-5.56,9.69-16.68.45-3,1.88-4.51,4.28-4.51h.23c2.7.41,4.06,1.77,4.06,4.06,0,4.17-2.4,10.55-7.21,19.16-3.19,4.36-7.02,6.54-11.49,6.54-4.21,0-8.26-2.4-12.17-7.21-1.65-3.87-2.48-6.87-2.48-9.01-.19,0-1.09,2.1-2.7,6.31-4.47,8.11-10.03,12.17-16.68,12.17-5.18,0-10.07-1.65-14.65-4.96C2.48,269.32,0,262.03,0,252.72v-2.03C0,237.13,4.06,225.19,12.17,214.86c5.48-6.16,10.52-9.24,15.1-9.24,5.46-.01,9.9,1.64,13.28,4.95ZM8.54,252.49c0,6.87,1.58,12.13,4.73,15.78,2.97,1.8,5.97,2.7,9.01,2.7,7.44,0,12.85-12.85,16.23-38.54.3-2.33.45-4.88.45-7.66s-1.95-5.93-5.86-9.24c-1.84-.9-3.87-1.35-6.08-1.35-5.26,1.84-9.99,7.1-14.2,15.78-2.85,6.8-4.28,13.94-4.28,21.41,0,0,0,1.12,0,1.12Z"}),jsxRuntimeExports.jsx("path",{d:"M103.03,214.85c.45,1.5.68,3.23.68,5.18v1.35c0,6.24-2.4,11.79-7.21,16.68,3.61,1.05,7.06,3.98,10.37,8.79,1.8,3.49,2.7,6.95,2.7,10.37v.45c0,1.8-.3,3.68-.9,5.63,3.38-1.43,7.29-4.81,11.72-10.14,1.58-2.55,3.16-3.83,4.73-3.83h.45c2.22,0,3.57,1.43,4.06,4.28,0,2.44-3.46,6.8-10.37,13.07-9.5,6.31-15.74,9.47-18.71,9.47-8.6,2.25-14.76,3.38-18.48,3.38-2.93,0-6.91-.75-11.94-2.25-1.69,0-2.82-6.76-3.38-20.28-.6-6.35-.9-11.76-.9-16.23.45-20.66,1.35-31.78,2.7-33.35,1.01-.9,2.14-1.35,3.38-1.35,2.03,0,3.23,1.58,3.61,4.73,4.88-4.66,9.69-6.99,14.42-6.99,6.12,0,10.48,3.68,13.07,11.04ZM74.63,237.84h.23c4.17,0,8.75-1.5,13.75-4.51,4.36-3.12,6.54-7.25,6.54-12.4v-.45c-.38-5.26-1.95-7.89-4.73-7.89,0-.15-.15-.23-.45-.23-4.36,0-8.41,3.53-12.17,10.59-2.1,4.62-3.16,7.7-3.16,9.24v5.65h0ZM76.89,270.29c2.67.45,4.47.68,5.41.68,3.72,0,8-.98,12.85-2.93,3.91-3.04,5.86-6.57,5.86-10.59v-.23c0-5.45-2.93-9.35-8.79-11.72-1.77-.75-3.72-1.13-5.86-1.13-7.51,1.58-11.42,2.63-11.72,3.16.86,15.17,1.61,22.76,2.25,22.76Z"}),jsxRuntimeExports.jsx("path",{d:"M157.57,213.5c1.2,3.38,1.8,6.84,1.8,10.37v1.8c0,2.03-1.28,3.23-3.83,3.61h-.23c-2.07,0-3.27-1.58-3.61-4.73-.71-5.26-1.54-7.89-2.48-7.89,0-.98-1.8-1.88-5.41-2.7-.49,0-.86-.08-1.13-.23-4.47,0-8.08,4.73-10.82,14.2-.45,4.7-.68,8.83-.68,12.4,0,15.85,2.7,25.54,8.11,29.07,1.84,1.05,4.24,1.58,7.21,1.58h.68c7.21,0,13.37-2.85,18.48-8.56,3.68-4.96,6.24-9.39,7.66-13.3,1.05-1.8,2.4-2.7,4.06-2.7,2.85.53,4.28,1.95,4.28,4.28-.6,3-3.08,7.89-7.44,14.65-3.79,5.93-9.73,10.22-17.8,12.85-3.27.9-6.35,1.35-9.24,1.35h-.9c-10.97,0-18.1-5.93-21.41-17.8-1.5-4.77-2.25-11.83-2.25-21.18,0-11.79,1.43-19.61,4.28-23.44,3.79-7.96,9.05-11.94,15.78-11.94,6.25-.03,11.21,2.75,14.89,8.31Z"})]}),jsxRuntimeExports.jsx("g",{id:"_5wiBGu","data-name":"5wiBGu",children:jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{d:"M26.73,4.67l4.71,6.07c1.08.34,2.32.23,3.4.39,5.31.78,14.26,5.8,18.37,9.32,9.11,7.81,15.86,18.56,20.83,29.4.31.67,1.18,2.33,1.29,2.92.04.23,0,.42-.12.61l.3.07-2.05.92c-6.37,8.23-9.41,25.62,2.77,30.31,4.44,1.71,12.66,3.74,17.35,2.85,8.14-1.54,16.73-7.01,18.26-15.7.63-3.56-.77-5.61-1.46-8.87-.26-1.2-.14-2.95-.44-3.94-.13-.42-.54-.9-.59-1.19-.05-.24.14-.5.13-.52,2.16-.77,4.3-1.61,6.57-2.05,3.51-.67,6.38-.28,9.79-.52.33-.02.4-.03.55-.33.3,1.14,1.59,1.08,2.41,1.37,1.25.44,1.69.96,3.22.56-.13.96,1.02,1.3,1.61,1.85,11.43,10.52,8.45,22.09,10.16,35.88.86,6.92,6.77,17.54,11.02,23.1.9,1.18,1.97,2.24,2.87,3.41.63.83,1.03,1.9,1.86,2.56-.29.3-.01.48-.99,1.03-2.01,1.13-4.25,1.97-6.31,3.02-4.77,2.43-13.67,7.6-18.61,8.19-.65-3.67-1.62-7.33-2.69-10.91-2.24-7.44-5.43-15.03-10.75-20.8-.79-.86-2.46-2.73-3.66-2.69-1.11.03-3.19,1.05-4.44,1.36-3.14.8-7.16,1.19-10.42,1.49-12.36,1.16-26.73.22-38.22-4.75-.8-.34-3.77-1.99-4.27-2.01-.37-.01-.19.03-.24.25-.29,1.18-.46,2.41-.76,3.59-2.8,11.28-7.56,21.66-14.54,30.93-.13,0-.34.18-.81.1-1.56-.28-6.3-2.04-7.93-2.71-4.34-1.79-9.07-4.9-12.71-7.86-.94-.76-2.24-1.72-2.7-2.73,10.85-11.32,19.78-25.17,23.1-40.72,1.3-6.07,1.25-12.1.72-18.27s-1.95-11.56-4.19-16.98c-.16-.11-2.27.9-2.73,1.04-1.08.34-2.39.6-3.51.84-1.26.27-3.2.06-3.86,1.29-1.26,2.36-1.45,5.53-3.12,8.14-2.9,4.53-9.34,5.7-13.98,3.25-7.52-3.98-2.72-9.88-.45-15.43s4.11-11.85,6.1-17.74l-.17-.88c1.25-.42,2.05-5.25,2.41-6.5-1.28-2.21-2.26-5.37-3.72-7.4-.22-.31-.32-.32-.62-.1.12-.37.17-.57.1-.97-.18-.98-1.37-2.94-1.78-4.02s-1.01-2.21-.38-3.27C13.88.1,14.64-.06,15.53.02c2.72.25,9.27,2.72,11.21,4.65ZM25.97,25.81c-.97.81-.04,2.88,1.24,2.28,1.83-.85.3-3.58-1.24-2.28Z"}),jsxRuntimeExports.jsx("path",{d:"M159.53,123.14s.32.02.47-.09c4.38-3.21,8.96-6.64,14.75-4.74,7.84,2.57,9.39,13.22,2.71,18-.93.66-1.83.94-2.71,1.47-2.36,1.43-4.3,3.2-6.83,4.6-10.33,5.7-21.3,10.58-32.49,14.36-7.88,2.66-16.04,2.89-24.26,3.59-8.38.72-16.7.54-25.11.17-7.77-.35-15.78-.38-23.46-1.67-4.38-.74-10.44-1.86-14.54-3.33-9.98-3.56-21.13-6.59-30.16-12.01-4.85-2.91-14.79-10.38-16.99-15.53-4.23-9.9,7.31-18.81,15.77-12.22.41.32,2.73,2.71,2.82,2.89.47,1.01,1.77,1.96,2.7,2.73,3.64,2.96,8.36,6.07,12.71,7.86,1.63.67,6.37,2.43,7.93,2.71.47.08.67-.11.81-.1.05,0,.18.28.39.35,2.54.8,5.07,1.66,7.58,2.55,4.14,1.46,7.48,2.44,11.82,3.31,6.39,1.28,12.9,1.52,19.4,1.85,10.08.51,19.56.72,29.62-.17,4.68-.41,10.43-.76,14.89-2.01,1.58-.45,5.09-2.19,6.28-2.33,4.95-.58,13.85-5.76,18.61-8.19,2.06-1.05,4.3-1.89,6.31-3.02.97-.55.69-.73.99-1.03Z"}),jsxRuntimeExports.jsx("path",{d:"M26.73,4.67c2.44-1.03,4.41-1.81,7.14-1.59,3.59.29,10.78,2.64,13.99,4.36,6.22,3.34,11.88,8.29,16.77,13.33,6.02,6.2,10.43,16.6,19.24,19.23,1.08.32,2.49.46,3.48.86.26.11.22.33.31.35h.23c.05.05.1.11.16.15.17.12.19.1.32.16.72.27.52.99.97,1.45l.17,1.51c-.44.14-.19.34-.3.53-1.02,1.81-4.48,4.82-6.26,5.98-1.48.97-3.23,1.56-4.56,2.76,1.56.32,2.95,1.12,4.47,1.57,7.42,2.19,14.76,1.11,22.33.69,1.96-.11,2.41-.13,3.86,1.13.16.13.39.14.4.16.01.02-.17.28-.13.52.06.29.47.77.59,1.19.3.99.18,2.75.44,3.94.7,3.26,2.09,5.31,1.46,8.87-1.53,8.69-10.12,14.16-18.26,15.7-4.69.89-12.91-1.14-17.35-2.85-12.18-4.69-9.14-22.08-2.77-30.31l2.05-.92-.3-.07c.12-.2.16-.39.12-.61-.11-.59-.98-2.24-1.29-2.92-4.97-10.84-11.71-21.59-20.83-29.4-4.11-3.52-13.05-8.54-18.37-9.32-1.08-.16-2.32-.05-3.4-.39l-4.71-6.07Z"}),jsxRuntimeExports.jsx("path",{d:"M159.85,48.78l.16.48c.03.15.13.23.16.32.11.29.2.49.48.64.06.16.13.24.16.32.3.76.57,1.53.97,2.25,0,.11,0,.22,0,.32l.16.16v.32l.32.32v.16c.01.1,0,.22,0,.32l.16.16c-.02.08,0,.23,0,.32.04.39.74,1.26.8,1.77.16,1.23.34,2.48.48,3.7v.32c.03.26-.03.54,0,.8.02.15.23.41.16.64-.02.2,0,.44,0,.64,0,.1.14.39.16.64.41,4.28,1.46,8.55,1.93,12.8.37,3.31.49,7.05.65,10.38v.32c.02.48,0,.97,0,1.45,0,.05,0,.11,0,.16,0,.32,0,.64,0,.97-.23.67-.39,1.08-.8,1.61-1.07,1.37-2.05,1.22-3.5,1.73-2.14.75-4.27,1.44-6.45,2.09l-.67.04h-.32c-.21.01-.43-.01-.64,0s-.43.13-.64.16c-.19-.02-.46-.02-.64,0-.12.01-.32.17-.48.16-.2-.02-.44,0-.64,0-.51,0-.85.04-1.45,0-.11,0-.22,0-.32,0-.59-.34-.93-.38-1.45-.8-.05-.04-.11-.11-.16-.16-.36-.4-.53-.63-.8-1.13-.01-.1,0-.22,0-.32l-.16-.32c0-.16,0-.33,0-.48-.04-.68-.13-1.36-.16-2.09-.02-.53.05-1.1,0-1.61-.01-.15-.23-.41-.16-.64.07-1.04-.3-1.07-.33-1.36-.39-3.11-.31-6.61-.47-9.75v-6.28l-.16-.16c-.26-3.78-.99-7.08-2.14-10.66-.28-.86-.54-1.65-.82-2.56l-1.42-2.03c-2.68-.34-5.75-.13-8.33.68-.45.14-1.06.62-1.45.72-1.53.4-1.97-.13-3.22-.56-.83-.29-2.12-.23-2.41-1.37-.03-.13.02-.33,0-.48s0-.33,0-.48,0-.32,0-.48v-.32c.24-.76.49-1.2.85-1.81,2.66-4.42,6.6-9.59,11.17-12.16,2.41-1.36,5.83-2.25,8.56-1.54,3.36.88,9.32,6.41,11.36,9.24.58.81.83,1.66,1.54,2.4Z"}),jsxRuntimeExports.jsx("path",{d:"M17.4,23.18c-.07.02-.22,0-.32,0-.16,0-.32,0-.48,0-1.04-.64-4.82-3.57-5.47-4.42-.05-.06-.64-1.06-.65-1.12-.06-.44.04-1.4.23-1.81.88-1.95,3.19-3.98,4.36-5.86.14-.23.34-.54.42-.79.3-.22.4-.21.62.1,1.46,2.03,2.44,5.19,3.72,7.4-.36,1.26-1.16,6.09-2.41,6.5Z"}),jsxRuntimeExports.jsx("path",{d:"M89.35,42.98c-.45-.46-.25-1.18-.97-1.45.01,0,.03-.15.23-.02.35.23.94,1.05.73,1.47Z"}),jsxRuntimeExports.jsx("path",{d:"M17.07,23.18v.32c-.07.06-.38-.26-.48-.32.16,0,.32,0,.48,0Z"}),jsxRuntimeExports.jsx("path",{d:"M126.37,52.96c0-.13-.12.05,0-.32v.32Z"}),jsxRuntimeExports.jsx("path",{d:"M88.06,41.37c-.06-.04-.11-.11-.16-.16l.16-.16v.32Z"}),jsxRuntimeExports.jsx("path",{d:"M25.97,25.81c1.54-1.3,3.07,1.44,1.24,2.28-1.28.59-2.2-1.47-1.24-2.28Z"})]})})]});const FlowerBadge=({elClass:s})=>jsxRuntimeExports.jsxs("svg",{className:s,xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 181.66 283.82",children:[jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{d:"M40.55,214.84v.23h.45v-1.13c.41-2.4,1.46-3.61,3.16-3.61h1.13c2.4,0,3.61,2.7,3.61,8.11v3.38c-.15,15.44-.23,24.83-.23,28.17.15,0,.23.08.23.23h-.23c.15.3.23.53.23.68,0,9.05.9,15.51,2.7,19.38,1.99,1.8,3.64,2.7,4.96,2.7,3.12,0,6.35-5.56,9.69-16.68.45-3,1.88-4.51,4.28-4.51h.23c2.7.41,4.06,1.77,4.06,4.06,0,4.17-2.4,10.55-7.21,19.16-3.19,4.36-7.02,6.54-11.49,6.54-4.21,0-8.26-2.4-12.17-7.21-1.65-3.87-2.48-6.87-2.48-9.01-.19,0-1.09,2.1-2.7,6.31-4.47,8.11-10.03,12.17-16.68,12.17-5.18,0-10.07-1.65-14.65-4.96-4.96-5.26-7.44-12.55-7.44-21.86v-2.03c0-13.56,4.06-25.5,12.17-35.83,5.48-6.16,10.52-9.24,15.1-9.24,5.46-.01,9.9,1.64,13.28,4.95ZM8.54,256.76c0,6.87,1.58,12.13,4.73,15.78,2.97,1.8,5.97,2.7,9.01,2.7,7.44,0,12.85-12.85,16.23-38.54.3-2.33.45-4.88.45-7.66s-1.95-5.93-5.86-9.24c-1.84-.9-3.87-1.35-6.08-1.35-5.26,1.84-9.99,7.1-14.2,15.78-2.85,6.8-4.28,13.94-4.28,21.41,0,0,0,1.12,0,1.12Z"}),jsxRuntimeExports.jsx("path",{d:"M103.03,219.12c.45,1.5.68,3.23.68,5.18v1.35c0,6.24-2.4,11.79-7.21,16.68,3.61,1.05,7.06,3.98,10.37,8.79,1.8,3.49,2.7,6.95,2.7,10.37v.45c0,1.8-.3,3.68-.9,5.63,3.38-1.43,7.29-4.81,11.72-10.14,1.58-2.55,3.16-3.83,4.73-3.83h.45c2.22,0,3.57,1.43,4.06,4.28,0,2.44-3.46,6.8-10.37,13.07-9.5,6.31-15.74,9.47-18.71,9.47-8.6,2.25-14.76,3.38-18.48,3.38-2.93,0-6.91-.75-11.94-2.25-1.69,0-2.82-6.76-3.38-20.28-.6-6.35-.9-11.76-.9-16.23.45-20.66,1.35-31.78,2.7-33.35,1.01-.9,2.14-1.35,3.38-1.35,2.03,0,3.23,1.58,3.61,4.73,4.88-4.66,9.69-6.99,14.42-6.99,6.12,0,10.48,3.68,13.07,11.04ZM74.63,242.11h.23c4.17,0,8.75-1.5,13.75-4.51,4.36-3.12,6.54-7.25,6.54-12.4v-.45c-.38-5.26-1.95-7.89-4.73-7.89,0-.15-.15-.23-.45-.23-4.36,0-8.41,3.53-12.17,10.59-2.1,4.62-3.16,7.7-3.16,9.24v5.65h0ZM76.89,274.56c2.67.45,4.47.68,5.41.68,3.72,0,8-.98,12.85-2.93,3.91-3.04,5.86-6.57,5.86-10.59v-.23c0-5.45-2.93-9.35-8.79-11.72-1.77-.75-3.72-1.13-5.86-1.13-7.51,1.58-11.42,2.63-11.72,3.16.86,15.17,1.61,22.76,2.25,22.76Z"}),jsxRuntimeExports.jsx("path",{d:"M157.57,217.77c1.2,3.38,1.8,6.84,1.8,10.37v1.8c0,2.03-1.28,3.23-3.83,3.61h-.23c-2.07,0-3.27-1.58-3.61-4.73-.71-5.26-1.54-7.89-2.48-7.89,0-.98-1.8-1.88-5.41-2.7-.49,0-.86-.08-1.13-.23-4.47,0-8.08,4.73-10.82,14.2-.45,4.7-.68,8.83-.68,12.4,0,15.85,2.7,25.54,8.11,29.07,1.84,1.05,4.24,1.58,7.21,1.58h.68c7.21,0,13.37-2.85,18.48-8.56,3.68-4.96,6.24-9.39,7.66-13.3,1.05-1.8,2.4-2.7,4.06-2.7,2.85.53,4.28,1.95,4.28,4.28-.6,3-3.08,7.89-7.44,14.65-3.79,5.93-9.73,10.22-17.8,12.85-3.27.9-6.35,1.35-9.24,1.35h-.9c-10.97,0-18.1-5.93-21.41-17.8-1.5-4.77-2.25-11.83-2.25-21.18,0-11.79,1.43-19.61,4.28-23.44,3.79-7.96,9.05-11.94,15.78-11.94,6.25-.03,11.21,2.75,14.89,8.31Z"})]}),jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("path",{d:"M94.28,124.16l-3.81-12.31c.12-.52,1.34-.27,1.76-.35,8.35-1.59,5.48-7.96,8.4-13.13,1.66-2.93,5.28-5.35,7.45-7.96,4.31-5.17,4.37-12.37,5.6-18.69l-.1-.31c-1.37-1.34-1.7,1.75-2.12,2.74-3.32,7.7-12.32,9.51-18.05,14.46-5.79,5-2.25,11.33-5.44,16.3-.86,1.33-1.37-.56-1.69-1.36-4.04-10.19-1.43-22.4,2.8-32.14.97-2.23,2.84-2.77,5.08-3.37,9.15-2.45,24.86-.1,29.96-10.57,2.66-5.46-.08-6.83-.68-11.34-.5-3.76,2.51-5.34,4.58-7.76,6.9-8.07,5.58-17.39-3.79-22.59-6.95-3.86-11.1-.1-17.84-.74-4.64-.44-6.27-4.89-8.97-7.92-6.03-6.77-18.53-10.99-24.54-1.94-4.05,6.1-1.58,13.66-9.17,17.85-4.2,2.31-14.28,4.73-14.84,10.28-.27,2.68,1.66,9.07,3.94,10.62,1.74,1.19,4.22,1.44,5.56,3.31,2.99,4.16-3.49,10.25,2.11,14.99,6.32,5.34,13.36-.25,19.2,2.97.91.5,5.49,3.93,5.69,4.67.27,1-1.53,4.42-1.82,5.71-.19.88-.14,1.99-.32,2.84-.66,3.07-1.59,6.09-1.84,9.24l-1.79-2.75c-5.97-6.07-17.59-4.68-22.62-12-1.13-1.65-2.85-7.41-4.45-7.8-.17-.04-.32-.06-.49-.04.63,2.51.83,5.32.63,7.91-.27,3.44-1.26,3.91.24,7.57,3.08,7.49,6.84,10.64,14.91,11.9,4.37.68,8.67-.93,12.56.95,1.66.8,1.14,2.53,1.47,4.02,1.06,4.68,3.44,8.73,5.23,13.14,2.86,8.54,4.42,17.71,3.06,26.71l-.74.21c-1.67-7.17-3.73-15.16-7.51-21.52-4-6.72-11.88-11.86-19.42-13.72-7.64-1.89-11.92,1.94-17.15-6.07-2-3.06-4.58-9.01-4.67-12.66-.03-1.3.44-3.1.42-4.4-.04-3.66-3.6-7.57-7.29-7.72-6.95-.27-5.92,7.45-10.14,10.56-2.27,1.68-5.41,1.5-7.91,2.64-4.47,2.05-8,8.34-5.67,13.05.96,1.94,3.85,4.3,4.17,6.38.66,4.31-3.77,7.36-2.46,12.38,1.11,4.27,7.44,6.77,11.44,6.73,2.29-.03,4.44-1.91,6.22.09,2.07,2.33,2.15,6.59,6.44,6.23,9.03-.77,7.8-18.51,13.08-23.87,4.22-4.28,13.65-1.35,18.27,1.16,13.42,7.28,17.47,22.55,18.78,36.74.55,5.89.2,11.95,2.11,17.62l-1.14-1.28c-3.93-6.8-10.97-12.4-19.24-11.81-4.57.33-8.54,2.92-13.24,1.23-5.09-1.83-7.65-8.7-12.12-11.73-4.96-3.37-11.33-3.75-15.9.49l3.69,2.22c2.96,2.4,2.43,3.03,3.13,6.37,2.81,13.62,7.69,24.14,23.27,25.07,10.26.61,16.82-4.58,26.02-5.85,4.24-.59,7.49,1.34,11.56.16,2.44-.7,3.97-1.73,6.74-1.92,9.73-.65,18.17,4.99,27.77-.52,13.97-8,10.05-25.72,20.36-35.16.25-.23,2.16-1.36,1.8-1.68-2.1.14-4.39-.62-6.43-.65-5.92-.08-15.21,3.93-19.64,7.82-4.87,4.26-6.91,11.43-13.99,12.82-2.59.51-5.3.31-7.85,1.01-4.96,1.36-10.63,7.47-11.62,12.56-.52-.36-.6-1.79-.64-2.42-.19-2.85.09-5.72.85-8.46.41-1.46,1.62-3.72,1.82-4.95.08-.52-.17-.88-.09-1.32.13-.75.62-1.64.6-2.48l.42.21c.52-2.68.8-5.42,1.58-8.02.67-2.22,1.8-4.26,2.22-6.54l.42.42c-.41-.97.17-1.08.2-1.21,2.7-11.93,11.85-18.67,22.52-23.46,2.66-1.19,9.48-4.12,12.17-3.57.91.19,2.78,1.45,3.81,1.89,2.16.92,4.31,1.3,6.06,3.02,3.71,3.63,6.75,16.74,13.81,10.88,1.89-1.57,1.7-2.98,2.89-4.71,2.33-3.41,8.15-3,11.11-8.1,4.09-7.02-2.88-8.99-2.89-14.71-.01-4.83,2.89-8.91-.87-13.53-3.79-4.66-9.02-1.6-12.94-4.37-3.63-2.56-5.51-9.81-10.38-10.3-7.03-.72-11.1,5.23-10.88,11.72.14,4.28,2.13,9.36,1.91,13.5-.09,1.63-2.38,6.46-3.2,8.21-2.6,5.57-5.47,4.9-10.03,7.49-.96.54-1.68,1.37-2.53,1.9-2.9,1.83-6.29,2.8-9.29,4.43-7.08,3.84-12.4,10.76-14.87,18.38h-.8Z"}),jsxRuntimeExports.jsx("path",{d:"M94.28,124.16h.8c2.47-7.62,7.79-14.54,14.87-18.38,3-1.63,6.4-2.6,9.29-4.43.85-.54,1.57-1.36,2.53-1.9,4.56-2.59,7.43-1.92,10.03-7.49.81-1.74,3.11-6.57,3.2-8.21.22-4.13-1.76-9.22-1.91-13.5-.22-6.49,3.84-12.44,10.88-11.72,4.88.5,6.76,7.74,10.38,10.3,3.92,2.77,9.15-.3,12.94,4.37,3.76,4.62.86,8.7.87,13.53.01,5.72,6.98,7.69,2.89,14.71-2.97,5.1-8.78,4.69-11.11,8.1-1.19,1.73-1,3.14-2.89,4.71-7.07,5.86-10.11-7.24-13.81-10.88-1.75-1.72-3.9-2.09-6.06-3.02-1.03-.44-2.9-1.7-3.81-1.89-2.68-.55-9.51,2.38-12.17,3.57-10.68,4.79-19.82,11.54-22.52,23.46-.03.12-.62.24-.2,1.21l-.42-.42c-.42,2.29-1.56,4.33-2.22,6.54-.78,2.6-1.05,5.34-1.58,8.02l-.42-.21c.02.84-.47,1.73-.6,2.48-.08.44.18.81.09,1.32-.2,1.24-1.42,3.49-1.82,4.95-.76,2.74-1.04,5.6-.85,8.46.04.63.12,2.06.64,2.42.99-5.09,6.66-11.19,11.62-12.56,2.55-.7,5.26-.51,7.85-1.01,7.08-1.39,9.12-8.56,13.99-12.82,4.44-3.88,13.73-7.9,19.64-7.82,2.04.03,4.34.79,6.43.65.36.32-1.55,1.45-1.8,1.68-10.31,9.44-6.39,27.15-20.36,35.16-9.6,5.5-18.04-.13-27.77.52-2.77.18-4.3,1.21-6.74,1.92-4.07,1.17-7.32-.75-11.56-.16-9.2,1.27-15.77,6.46-26.02,5.85-15.59-.93-20.46-11.45-23.27-25.07-.69-3.35-.17-3.97-3.13-6.37l-3.69-2.22c4.57-4.24,10.93-3.86,15.9-.49,4.47,3.03,7.03,9.91,12.12,11.73,4.71,1.69,8.67-.9,13.24-1.23,8.27-.59,15.31,5.01,19.24,11.81l1.14,1.28c-1.91-5.67-1.56-11.73-2.11-17.62-1.32-14.19-5.36-29.45-18.78-36.74-4.62-2.51-14.05-5.45-18.27-1.16-5.28,5.36-4.05,23.09-13.08,23.87-4.29.37-4.37-3.89-6.44-6.23-1.78-2.01-3.94-.12-6.22-.09-4.01.04-10.33-2.46-11.44-6.73-1.31-5.02,3.12-8.07,2.46-12.38-.32-2.08-3.21-4.44-4.17-6.38-2.34-4.71,1.2-11,5.67-13.05,2.5-1.15,5.64-.97,7.91-2.64,4.22-3.12,3.19-10.84,10.14-10.56,3.69.14,7.25,4.06,7.29,7.72.02,1.3-.46,3.1-.42,4.4.09,3.65,2.67,9.6,4.67,12.66,5.23,8.01,9.51,4.19,17.15,6.07,7.54,1.86,15.42,7.01,19.42,13.72,3.78,6.36,5.84,14.35,7.51,21.52l.74-.21c1.36-9.01-.21-18.17-3.06-26.71-1.78-4.41-4.17-8.45-5.23-13.14-.34-1.48.19-3.21-1.47-4.02-3.89-1.88-8.19-.27-12.56-.95-8.08-1.26-11.83-4.41-14.91-11.9-1.5-3.66-.51-4.13-.24-7.57.2-2.59,0-5.4-.63-7.91.17-.02.32,0,.49.04,1.6.39,3.31,6.15,4.45,7.8,5.03,7.32,16.64,5.94,22.62,12l1.79,2.75c.25-3.15,1.19-6.17,1.84-9.24.18-.86.13-1.97.32-2.84.28-1.28,2.08-4.7,1.82-5.71-.2-.75-4.77-4.17-5.69-4.67-5.84-3.22-12.88,2.37-19.2-2.97-5.6-4.74.88-10.83-2.11-14.99-1.34-1.87-3.82-2.12-5.56-3.31-2.28-1.55-4.21-7.95-3.94-10.62.57-5.55,10.65-7.96,14.84-10.28,7.59-4.19,5.13-11.75,9.17-17.85,6.01-9.05,18.51-4.83,24.54,1.94,2.7,3.03,4.33,7.48,8.97,7.92,6.74.64,10.89-3.12,17.84.74,9.37,5.2,10.69,14.51,3.79,22.59-2.07,2.43-5.08,4-4.58,7.76.6,4.51,3.34,5.88.68,11.34-5.09,10.48-20.81,8.12-29.96,10.57-2.24.6-4.11,1.14-5.08,3.37-4.23,9.74-6.84,21.95-2.8,32.14.32.8.83,2.7,1.69,1.36,3.19-4.97-.35-11.3,5.44-16.3,5.73-4.95,14.73-6.77,18.05-14.46.43-.99.75-4.08,2.12-2.74l.1.31c-1.22,6.31-1.28,13.51-5.6,18.69-2.17,2.6-5.8,5.03-7.45,7.96-2.93,5.17-.06,11.54-8.4,13.13-.42.08-1.64-.17-1.76.35l3.81,12.31ZM85.81,68.03c.14-.89.8-1.99.83-2.87.02-.65-.33-1.6-.4-2.31-.11-1.07.38-2.32-.53-3.06-.57-.47-3.28-1.47-4.07-1.63-4.74-.98-9.77,1.34-13.03-3.65-1.94-2.97,2.54-7.87.73-10.65-1.25-1.92-3.28-2.35-3.38-5.5-.22-6.95,7.94-6.39,10.65-10.24,1.94-2.75.59-6.24,2.87-9.16,4.04-5.18,11.18-5.62,15.51-.54,1.72,2.02,2.58,4.76,4.15,6.83,3.68,4.85,6.77-.16,10.62-1.34,6.2-1.91,9.41,2.03,7.5,7.93-.85,2.63-3.65,5.21-4,7.83-.58,4.33,3.66,5.56,2.15,10.39-2.6,8.34-11.81,5.47-17.94,8.03-3.66,1.53-6.94,4.68-7.82,8.65-.07.33-.45,1.92.05,1.94,1.5-.99,3-1.58,4.75-2,8.76-2.13,23.96-.78,28.12-10.73,2.82-6.74-3.1-8.94-1.04-13.91,1.76-4.24,7.78-7.51,8.36-12.54.64-5.56-4.89-11.18-9.9-12.65-6.21-1.82-11.81,2.51-18.63-.15-7.62-2.98-11.23-16.05-21.14-13.23-7.96,2.26-6.45,13.97-11.75,19.07s-17.64,4.37-16.65,14.16c.79,7.81,9.3,5.15,10.29,11.88.68,4.61-4.14,8.73.9,12.82,3.37,2.74,6.6,1.02,10.46,1.15,4.2.14,7.48,1.36,10.65,4.12.61.53.89,1.47,1.68,1.37ZM88.76,62.75c2.02-4.13,7.95-7.13,12.38-7.57,2.41-.24,4.89.33,7.26-.34,3.56-1.01,6.93-5,5.18-8.77-.52-1.13-1.66-2.09-2.18-3.31-2.59-6.17,4.61-9.93,3.97-15.16-.12-1.02-.81-1.95-1.85-2.16-3.3-.68-6.68,3.13-9.97,3.66-6.82,1.08-7.08-3.6-10.1-7.87-3.12-4.41-7.76-6.21-11.03-.8-2.25,3.73-1.37,8.39-5.76,10.91-2.98,1.71-8.04,1.97-7.75,6.83.19,3.14,3,3.5,3.38,5.92.1.63.06,1.83-.04,2.47-.38,2.41-2.83,4.81-1,7.23,3.63,4.82,14.01-.3,16.57,6.45.1.27.56,2.79.95,2.53ZM147.88,106.24c1.07,2.95,2.99,8.67,7.14,7.46,2.08-.61,3.4-4.56,4.72-6.26,2.45-3.15,6.41-2.6,9.15-6.05,3.56-4.48-2.1-6.89-4-10.36-3.33-6.08,2.72-11.5-1.09-16.44-3.35-4.35-9.37-.77-13.26-5.74-2.56-3.27-4.59-10.2-10.1-8.17s-4.69,10.09-3.43,14.73c.25.4.45-.04.62-.23,1.1-1.23,1.8-4.31,3.3-5.36,3.34-2.33,7.96,2.57,8.59,5.75.31,1.58-.08,5.38,2.07,5.74,1.66.28,3.6-.73,5.14.14.89.5,2.18,3,2.32,4.01.5,3.64-2.73,4.76-2.94,7.78-.15,2.12.67,2.22,1.52,3.77,4.2,7.6-3.23,11-9.75,9.22ZM142.73,71.05c-.47.03-1.28.55-1.62.88-.94.9-3.15,5.56-3.48,6.86s-.08,3.75-.33,5.37c-.61,4.01-2.46,8.44-4.62,11.84.07.3,3.79,1.18,4.49,1.43,2.59.93,6.3,2.92,8.39,4.69.75.63,1.46,1.66,2.21,2.22,2.68,1.97,7.47,1.68,8.94-1.61,1.94-4.33-2.93-5.58-2.94-8.84-.02-3.86,6.03-6.37,2.97-10.34-1.96-2.54-4.15-.37-6.55-1.27-3.47-1.3-1.54-7.99-5.21-10.42-.5-.33-1.68-.85-2.26-.81ZM81.59,92.52c.37-.36-1.75-2.64-2.07-3.1-2.08-3.01-2.41-4.2-6.11-5.72-6.89-2.83-10.63-2.35-16.74-7.96-1.08-.99-1.62-1.96-2.53-3.06-1.95,9.57,6.91,17.7,15.93,18.37,2.9.22,5.89-.71,8.62.25.49.17,2.65,1.47,2.9,1.22ZM37.68,83.65c-.04-1.05.65-1.9.79-2.9.26-1.78-.36-5.33-1.86-6.48-.52-.4-2.86-1.33-3.5-1.38-3.07-.23-3.66,4.86-4.47,6.89-2.87,7.17-10.55,5.07-14.06,10.85-4.86,8.01,4.66,9.74,3.37,16.88-.64,3.56-5.01,7.87-1.06,11.17s7.32,1.02,11.61,1.48c3.73.4,3.44,4.62,5.95,6.3,1.55,1.04,2.17.7,3.45-.49,2.19-2.02,3.23-5.67,3.58-8.55-2.11,1.52-3.46,3.9-6.45,2.55-2.76-1.25-1.29-5.26-3-6.77-2.36-2.09-7.09.34-8.96-3.23-.87-1.66-.8-3.24.04-4.9.78-1.55,2.31-1.98,2.13-4-.19-2.13-2.88-3.69-2.77-6.34.08-1.77,2.27-5.02,4.02-5.49,2.25-.6,3.82,1.41,5.86,1.75,3.56.6.71-3.94.68-5.56-.05-2.33,3.05-3.17,4.65-1.78ZM111.78,76.9c-1.69,1.53-2.75,3.58-4.54,5.06-4.73,3.9-13.86,5.7-15.24,12.62-.54,2.68.01,5.49-.89,8.19-.58,1.74-1.96,3.11-3.14,4.46l1.65,3.35c2.54.57,5.89-1.24,7.14-3.42,1.37-2.37,1.05-5.16,1.83-7.67,1.38-4.43,5.75-6.21,8.45-9.5s4.71-8.94,4.75-13.09ZM48.23,103.08c-4.4-.35-7.13-5.96-8.69-9.57-1.13-2.62-1.96-4.87-1.69-7.81-.15-.45-2.05-1.23-2.47-.96-.78,1.45.41,2.76.59,4.11.44,3.3-1.23,4.22-4.29,3.87-2.47-.29-4.18-2.92-6.04-.5-2.96,3.84,3.33,6.69.96,11.3-.89,1.73-2.89,3.04-1.86,5.42,1.1,2.54,8.46.88,9.66,4.69.6,1.9.09,6.85,3.67,4.32,5.2-3.67,5.36-10.94,10.15-14.87ZM143.02,128.83c-4.59.15-9.28,1.94-12.95,4.68-6.91,5.15-9.03,13.42-18.5,15.49-4.57,1-8.33-.42-12.25,2.95-.72.62-1.49,1.58-2.1,2.33-.47.57-3.6,4.72-3.17,5.17.95,0,1.5-.97,2.12-1.36,2.36-1.47,7.68-2.19,10.41-1.78,1.53.23,3.11,1.1,4.67,1.24,9.59.88,4.41-11.26,11.84-12.22,2.16-.28,4.19,1.16,5.63.77,2.1-.56,3.92-6.35,5.05-8.24,2.14-3.58,5.89-6.61,9.25-9.01ZM145.55,129.46c-.6-.51-6.5,4.59-7.17,5.39-2.74,3.26-5.01,11.62-8.66,13.08-2.9,1.16-4.35-1.18-6.64-.73-2.05.4-2.84,5.4-3.48,7.07-3.27,8.48-11.53,3.22-18.03,4.13-2.99.42-7.42,2.98-8.57,5.89,11.06-7.12,24.02,3.77,35.11-3.42,9.2-5.96,8.42-17.63,13.78-26.12,1.15-1.82,2.68-3.37,3.68-5.29ZM84.33,160.71c.14-.14-1.5-2.49-1.73-2.81-2.09-2.94-4.67-5.9-8.05-7.36-8.91-3.84-16.58,5.14-25.48-2.81-1.9-1.7-2.68-4.03-4.22-5.91-2.85-3.45-9.39-6.51-13.71-4.44,0,.26,1.84.54,2.25.7,3.69,1.41,9.01,5.4,10.51,9.12,1.18,2.94,1.48,9.8,4.85,10.98,1.9.67,5.98-.23,7.86-1.03,2.51-1.07,3.04-2.51,6.3-2.15,3.75.41,5.49,5.01,8.8,5.57,1.75.3,3.86-.92,5.58-1.12,2.38-.27,4.86.37,7.05,1.24ZM87.08,163.66c-2.26-.13-4.62-2.31-6.65-2.54-3.23-.36-6.34,1.56-9.62.96-.8-.15-3.11-1.23-3.78-1.71-1.27-.92-1.96-2.96-3.49-3.48-2.96-1-4.95,1.51-7.36,2.58-3.34,1.48-7.85,1.76-10.81-.66-3.13-2.57-2.65-6.76-3.89-10.25-1.16-3.27-5.04-7.63-8.45-8.54,4,3.85,3.17,9.6,4.36,14.53,2.19,9.04,11.5,14.73,20.48,14.73,9.79,0,18.46-6.24,28.47-5.41.23.02.79.15.73-.21Z"}),jsxRuntimeExports.jsx("path",{d:"M85.81,68.03c-.79.1-1.07-.84-1.68-1.37-3.17-2.76-6.46-3.98-10.65-4.12-3.86-.13-7.09,1.59-10.46-1.15-5.03-4.09-.22-8.21-.9-12.82-.99-6.73-9.5-4.06-10.29-11.88-.99-9.8,11.24-8.96,16.65-14.16s3.8-16.81,11.75-19.07c9.92-2.81,13.53,10.25,21.14,13.23,6.83,2.67,12.43-1.66,18.63.15,5.01,1.47,10.54,7.08,9.9,12.65-.58,5.03-6.6,8.29-8.36,12.54-2.06,4.97,3.85,7.18,1.04,13.91-4.16,9.94-19.36,8.6-28.12,10.73-1.75.43-3.25,1.01-4.75,2-.49-.02-.12-1.61-.05-1.94.88-3.97,4.16-7.11,7.82-8.65,6.12-2.56,15.34.31,17.94-8.03,1.5-4.83-2.73-6.06-2.15-10.39.35-2.62,3.15-5.2,4-7.83,1.9-5.9-1.3-9.83-7.5-7.93-3.84,1.18-6.94,6.19-10.62,1.34-1.57-2.07-2.43-4.81-4.15-6.83-4.33-5.09-11.48-4.64-15.51.54-2.28,2.92-.93,6.41-2.87,9.16-2.71,3.85-10.87,3.29-10.65,10.24.1,3.15,2.14,3.58,3.38,5.5,1.81,2.78-2.67,7.68-.73,10.65,3.26,4.99,8.29,2.67,13.03,3.65.79.16,3.5,1.17,4.07,1.63.91.74.42,1.99.53,3.06.07.71.42,1.65.4,2.31-.03.88-.69,1.98-.83,2.87Z"}),jsxRuntimeExports.jsx("path",{d:"M88.76,62.75c-.39.26-.85-2.26-.95-2.53-2.56-6.74-12.94-1.63-16.57-6.45-1.82-2.42.62-4.81,1-7.23.1-.64.14-1.84.04-2.47-.38-2.42-3.19-2.77-3.38-5.92-.29-4.86,4.77-5.12,7.75-6.83,4.39-2.53,3.51-7.19,5.76-10.91,3.28-5.41,7.91-3.61,11.03.8,3.02,4.27,3.28,8.95,10.1,7.87,3.28-.52,6.67-4.34,9.97-3.66,1.04.21,1.72,1.14,1.85,2.16.64,5.23-6.56,8.99-3.97,15.16.51,1.22,1.66,2.18,2.18,3.31,1.75,3.77-1.62,7.76-5.18,8.77-2.36.67-4.85.1-7.26.34-4.43.45-10.36,3.44-12.38,7.57Z"}),jsxRuntimeExports.jsx("path",{d:"M37.68,83.65c-1.6-1.38-4.7-.54-4.65,1.78.03,1.62,2.88,6.15-.68,5.56-2.05-.34-3.61-2.35-5.86-1.75-1.75.47-3.94,3.72-4.02,5.49-.11,2.64,2.58,4.21,2.77,6.34.18,2.02-1.34,2.45-2.13,4-.84,1.66-.91,3.24-.04,4.9,1.87,3.56,6.6,1.13,8.96,3.23,1.71,1.52.24,5.53,3,6.77,2.99,1.35,4.34-1.03,6.45-2.55-.36,2.88-1.39,6.53-3.58,8.55-1.28,1.19-1.9,1.53-3.45.49-2.51-1.68-2.22-5.9-5.95-6.3-4.29-.46-7.6,1.86-11.61-1.48s.42-7.61,1.06-11.17c1.29-7.14-8.24-8.87-3.37-16.88,3.51-5.78,11.2-3.68,14.06-10.85.81-2.04,1.41-7.12,4.47-6.89.63.05,2.97.97,3.5,1.38,1.5,1.15,2.11,4.7,1.86,6.48-.14,1.01-.83,1.85-.79,2.9Z"}),jsxRuntimeExports.jsx("path",{d:"M147.88,106.24c6.52,1.77,13.94-1.62,9.75-9.22-.86-1.55-1.67-1.65-1.52-3.77.21-3.03,3.44-4.14,2.94-7.78-.14-1.01-1.43-3.51-2.32-4.01-1.54-.86-3.49.14-5.14-.14-2.15-.36-1.76-4.16-2.07-5.74-.63-3.18-5.26-8.08-8.59-5.75-1.5,1.05-2.2,4.12-3.3,5.36-.17.19-.37.63-.62.23-1.26-4.64-2.24-12.65,3.43-14.73s7.54,4.9,10.1,8.17c3.89,4.97,9.91,1.38,13.26,5.74,3.8,4.94-2.25,10.36,1.09,16.44,1.9,3.47,7.56,5.87,4,10.36-2.74,3.45-6.7,2.9-9.15,6.05-1.32,1.7-2.64,5.65-4.72,6.26-4.15,1.21-6.07-4.51-7.14-7.46Z"}),jsxRuntimeExports.jsx("path",{d:"M142.73,71.05c.58-.04,1.76.49,2.26.81,3.66,2.42,1.74,9.12,5.21,10.42,2.39.9,4.59-1.27,6.55,1.27,3.06,3.98-2.99,6.49-2.97,10.34.01,3.26,4.88,4.51,2.94,8.84-1.47,3.29-6.27,3.58-8.94,1.61-.75-.55-1.47-1.59-2.21-2.22-2.1-1.77-5.8-3.76-8.39-4.69-.7-.25-4.42-1.13-4.49-1.43,2.17-3.4,4.01-7.83,4.62-11.84.25-1.62-.02-4.01.33-5.37s2.54-5.96,3.48-6.86c.34-.33,1.15-.85,1.62-.88Z"}),jsxRuntimeExports.jsx("path",{d:"M48.23,103.08c-4.78,3.93-4.95,11.2-10.15,14.87-3.59,2.53-3.07-2.42-3.67-4.32-1.2-3.81-8.57-2.15-9.66-4.69-1.03-2.38.97-3.7,1.86-5.42,2.37-4.61-3.92-7.47-.96-11.3,1.86-2.42,3.57.22,6.04.5,3.05.36,4.73-.57,4.29-3.87-.18-1.35-1.36-2.66-.59-4.11.43-.27,2.32.51,2.47.96-.27,2.94.55,5.2,1.69,7.81,1.57,3.61,4.29,9.22,8.69,9.57Z"}),jsxRuntimeExports.jsx("path",{d:"M87.08,163.66c.05.36-.5.23-.73.21-10.01-.82-18.68,5.41-28.47,5.41-8.97,0-18.28-5.69-20.48-14.73-1.19-4.92-.37-10.68-4.36-14.53,3.42.91,7.29,5.27,8.45,8.54,1.24,3.49.76,7.68,3.89,10.25,2.96,2.43,7.47,2.15,10.81.66,2.42-1.07,4.4-3.58,7.36-2.58,1.52.52,2.22,2.56,3.49,3.48.67.49,2.98,1.57,3.78,1.71,3.27.6,6.39-1.32,9.62-.96,2.03.22,4.39,2.41,6.65,2.54Z"}),jsxRuntimeExports.jsx("path",{d:"M145.55,129.46c-1,1.92-2.53,3.47-3.68,5.29-5.36,8.49-4.58,20.16-13.78,26.12-11.08,7.19-24.05-3.7-35.11,3.42,1.15-2.91,5.58-5.47,8.57-5.89,6.5-.91,14.76,4.35,18.03-4.13.64-1.67,1.43-6.67,3.48-7.07,2.3-.45,3.75,1.89,6.64.73,3.65-1.46,5.92-9.82,8.66-13.08.67-.8,6.57-5.89,7.17-5.39Z"}),jsxRuntimeExports.jsx("path",{d:"M84.33,160.71c-2.18-.87-4.67-1.51-7.05-1.24-1.72.19-3.83,1.42-5.58,1.12-3.31-.56-5.05-5.16-8.8-5.57-3.26-.36-3.78,1.08-6.3,2.15-1.88.8-5.96,1.69-7.86,1.03-3.37-1.18-3.67-8.04-4.85-10.98-1.5-3.72-6.83-7.71-10.51-9.12-.41-.16-2.26-.44-2.25-.7,4.32-2.07,10.86.98,13.71,4.44,1.55,1.88,2.33,4.21,4.22,5.91,8.9,7.95,16.57-1.03,25.48,2.81,3.38,1.46,5.96,4.42,8.05,7.36.23.32,1.87,2.67,1.73,2.81Z"}),jsxRuntimeExports.jsx("path",{d:"M143.02,128.83c-3.35,2.4-7.1,5.43-9.25,9.01-1.13,1.89-2.95,7.68-5.05,8.24-1.44.39-3.47-1.06-5.63-.77-7.43.97-2.25,13.1-11.84,12.22-1.56-.14-3.14-1.01-4.67-1.24-2.73-.41-8.05.31-10.41,1.78-.62.39-1.17,1.36-2.12,1.36-.42-.44,2.7-4.59,3.17-5.17.61-.75,1.38-1.71,2.1-2.33,3.92-3.37,7.68-1.95,12.25-2.95,9.47-2.07,11.59-10.34,18.5-15.49,3.67-2.74,8.36-4.52,12.95-4.68Z"}),jsxRuntimeExports.jsx("path",{d:"M111.78,76.9c-.04,4.15-2.1,9.87-4.75,13.09s-7.07,5.07-8.45,9.5c-.78,2.51-.46,5.3-1.83,7.67-1.25,2.18-4.6,3.98-7.14,3.42l-1.65-3.35c1.18-1.34,2.56-2.72,3.14-4.46.91-2.69.35-5.5.89-8.19,1.39-6.92,10.51-8.72,15.24-12.62,1.79-1.48,2.86-3.54,4.54-5.06Z"}),jsxRuntimeExports.jsx("path",{d:"M81.59,92.52c-.25.25-2.41-1.05-2.9-1.22-2.73-.96-5.71-.03-8.62-.25-9.02-.67-17.88-8.8-15.93-18.37.9,1.1,1.45,2.07,2.53,3.06,6.11,5.61,9.85,5.13,16.74,7.96,3.69,1.52,4.02,2.71,6.11,5.72.32.46,2.44,2.74,2.07,3.1Z"})]})]});const GrantBadge=({elClass:s})=>jsxRuntimeExports.jsxs("svg",{className:"grant",xmlns:"http://www.w3.org/2000/svg",width:"63",height:"47",viewBox:"0 0 32.7 37.2",children:[jsxRuntimeExports.jsx("polygon",{className:"st0",points:"0.1,2.3 0.1,34.8 2.5,34.8 4.5,21.4 6.9,34.8 9.3,34.8 9.3,2.3 6.9,2.3 6.9,13.7 6.9,20.4 5.5,14 3.9,14 2.5,20.5 2.5,13.9 2.5,2.3 0.1,2.3"}),jsxRuntimeExports.jsxs("g",{children:[jsxRuntimeExports.jsx("line",{className:"st0",x1:"21.7",y1:"24.3",x2:"19",y2:"24.3"}),jsxRuntimeExports.jsx("polygon",{className:"st0",points:"19,12.3 19,2.8 13.6,2.8 13.6,13.6 10.9,13.6 10.9,0.1 21.7,0.1 21.7,13.3 13.6,24.3 13.6,34.5 19,34.5 19,24.3 21.7,24.3 21.7,37 10.9,37 10.9,24.3 19,12.3"})]}),jsxRuntimeExports.jsx("polygon",{className:"st0",points:"32.5,14.1 32.5,2.3 23.2,2.3 23.2,34.9 32.5,34.9 32.5,23.4 30.2,23.4 30.2,32.6 25.5,32.6 25.5,20 30.4,20 30.4,17.7 25.5,17.7 25.5,4.6 30.2,4.6 30.2,14.1 32.5,14.1"})]});const ShippingIcon=({elClass:C})=>jsxRuntimeExports.jsx("svg",{className:C,xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 16 14",fill:"none",children:jsxRuntimeExports.jsx("path",{d:"M14.8843 7.26505L13.6726 6.65945L12.9944 4.62441C12.7979 4.03545 12.2491 3.63977 11.6285 3.63977H9.92031V2.19977C9.92031 1.40569 9.27439 0.759766 8.48031 0.759766H1.76031C0.966233 0.759766 0.320312 1.40569 0.320312 2.19977V10.8398C0.320312 11.3692 0.751032 11.7998 1.28031 11.7998H2.78847C3.00303 12.6255 3.74815 13.2398 4.64031 13.2398C5.53247 13.2398 6.27743 12.6255 6.49215 11.7998H10.4685C10.683 12.6255 11.4282 13.2398 12.3203 13.2398C13.2125 13.2398 13.9574 12.6255 14.1722 11.7998H14.7203C15.2496 11.7998 15.6803 11.3692 15.6803 10.8398V8.55305C15.6803 8.00409 15.3752 7.51065 14.8843 7.26505ZM11.6285 4.59977C11.8352 4.59977 12.0186 4.73177 12.0842 4.92809L12.6146 6.51977H9.92031V4.59977H11.6285ZM4.64031 12.2798C4.11103 12.2798 3.68031 11.8492 3.68031 11.3198C3.68031 10.7903 4.11103 10.3598 4.64031 10.3598C5.16959 10.3598 5.60031 10.7903 5.60031 11.3198C5.60031 11.8492 5.16959 12.2798 4.64031 12.2798ZM8.96031 10.8398H6.49215C6.27759 10.014 5.53247 9.39977 4.64031 9.39977C3.74815 9.39977 3.00319 10.014 2.78847 10.8398H1.28031V2.19977C1.28031 1.93513 1.49551 1.71977 1.76031 1.71977H8.48031C8.74511 1.71977 8.96031 1.93513 8.96031 2.19977V10.8398ZM12.3203 12.2798C11.791 12.2798 11.3603 11.8492 11.3603 11.3198C11.3603 10.7903 11.791 10.3598 12.3203 10.3598C12.8496 10.3598 13.2803 10.7903 13.2803 11.3198C13.2803 11.8492 12.8496 12.2798 12.3203 12.2798ZM14.7203 10.8398H14.1722C13.9576 10.014 13.2125 9.39977 12.3203 9.39977C11.4282 9.39977 10.6832 10.014 10.4685 10.8398H9.92031V7.47977H13.1669L14.455 8.12377C14.6186 8.20569 14.7203 8.37017 14.7203 8.55305V10.8398Z",fill:"currentColor"})});const ReturnsIcon=({elClass:C})=>jsxRuntimeExports.jsx("svg",{className:C,xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 16 16",fill:"none",children:jsxRuntimeExports.jsx("path",{d:"M15.6803 7.99982C15.6803 12.2345 12.235 15.6798 8.00031 15.6798C3.76559 15.6798 0.320312 12.2345 0.320312 7.99982C0.320312 7.73454 0.535032 7.51982 0.800312 7.51982C1.06559 7.51982 1.28031 7.73454 1.28031 7.99982C1.28031 11.7053 4.29487 14.7198 8.00031 14.7198C11.7058 14.7198 14.7203 11.7053 14.7203 7.99982C14.7203 4.29438 11.7058 1.27982 8.00031 1.27982C6.21423 1.27982 4.55615 1.97406 3.30879 3.19982H5.12031C5.38559 3.19982 5.60031 3.41454 5.60031 3.67982C5.60031 3.9451 5.38559 4.15982 5.12031 4.15982H2.24031C1.97503 4.15982 1.76031 3.9451 1.76031 3.67982V0.799824C1.76031 0.534544 1.97503 0.319824 2.24031 0.319824C2.50559 0.319824 2.72031 0.534544 2.72031 0.799824V2.43726C4.13647 1.08558 5.99727 0.319824 8.00031 0.319824C12.235 0.319824 15.6803 3.7651 15.6803 7.99982ZM12.3203 6.07982V10.3998C12.3203 10.6 12.1962 10.779 12.0091 10.8494L8.16911 12.2894C8.11471 12.3096 8.05743 12.3198 8.00031 12.3198C7.94319 12.3198 7.88591 12.3096 7.83151 12.2894L3.99151 10.8494C3.80447 10.779 3.68031 10.6 3.68031 10.3998V6.07982C3.68031 5.87966 3.80447 5.70062 3.99151 5.63022L7.83151 4.19022C7.94031 4.1499 8.06031 4.1499 8.16895 4.19022L12.009 5.63022C12.1962 5.70062 12.3203 5.87966 12.3203 6.07982ZM5.52719 6.07982L8.00031 7.00702L10.4734 6.07982L8.00031 5.15262L5.52719 6.07982ZM4.64031 10.067L7.52031 11.147V7.85262L4.64031 6.77262V10.067ZM11.3603 10.067V6.77262L8.48031 7.85262V11.147L11.3603 10.067Z",fill:"currentColor"})});const DownArrow=({elClass:C})=>jsxRuntimeExports.jsx("svg",{className:C,xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 16 16",fill:"none",children:jsxRuntimeExports.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M13.8042 4.70558C13.7423 4.64041 13.6687 4.58871 13.5877 4.55343C13.5067 4.51816 13.4199 4.5 13.3323 4.5C13.2446 4.5 13.1578 4.51816 13.0768 4.55343C12.9958 4.58871 12.9223 4.64041 12.8603 4.70558L7.99983 9.80955L3.13932 4.70558C3.01415 4.57418 2.8444 4.50037 2.6674 4.50037C2.49039 4.50037 2.32064 4.57418 2.19548 4.70558C2.07031 4.83697 2 5.01518 2 5.201C2 5.38682 2.07031 5.56503 2.19548 5.69642L7.52791 11.2944C7.58982 11.3596 7.66338 11.4113 7.74436 11.4466C7.82534 11.4818 7.91215 11.5 7.99983 11.5C8.0875 11.5 8.17431 11.4818 8.25529 11.4466C8.33627 11.4113 8.40983 11.3596 8.47175 11.2944L13.8042 5.69642C13.8662 5.63142 13.9155 5.5542 13.9491 5.46919C13.9827 5.38418 14 5.29304 14 5.201C14 5.10896 13.9827 5.01782 13.9491 4.93281C13.9155 4.8478 13.8662 4.77058 13.8042 4.70558Z",fill:"currentColor"})});const CheckmarkIcon=({elClass:C})=>jsxRuntimeExports.jsx("svg",{className:C,xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 12 10",fill:"none",children:jsxRuntimeExports.jsx("path",{d:"M11.7429 0.631893C11.4 0.278952 10.8857 0.278952 10.5429 0.631893L4.11429 7.24954L1.45714 4.51425C1.11429 4.16131 0.6 4.16131 0.257143 4.51425C-0.0857143 4.86719 -0.0857143 5.3966 0.257143 5.74954L3.51429 9.10248C3.68571 9.27895 3.85714 9.36719 4.11429 9.36719C4.37143 9.36719 4.54286 9.27895 4.71429 9.10248L11.7429 1.86719C12.0857 1.51425 12.0857 0.984835 11.7429 0.631893Z",fill:"currentColor"})});const DiscountIcon=({elClass:C})=>jsxRuntimeExports.jsx("svg",{className:C,xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 8 8",fill:"none",children:jsxRuntimeExports.jsx("path",{d:"M7.3333 0H4.56242C4.37912 0 4.12293 0.106191 3.99342 0.235604L0.194544 4.03446C-0.0648482 4.29356 -0.0648482 4.71836 0.194544 4.97715L3.02312 7.80563C3.28192 8.06473 3.70632 8.06473 3.96551 7.80533L7.76439 4.00706C7.89379 3.87767 8 3.62107 8 3.43816V0.666694C8 0.300095 7.69988 0 7.3333 0ZM5.99989 2.66668C5.63169 2.66668 5.3332 2.36787 5.3332 1.99999C5.3332 1.63149 5.63169 1.33329 5.99989 1.33329C6.36809 1.33329 6.66669 1.63149 6.66669 1.99999C6.6667 2.36787 6.36809 2.66668 5.99989 2.66668Z",fill:"currentColor"})});const icons=[{name:"Duck",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Group_480x480.svg?v=1722249909",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/BurpCloth_Ducky_1_430x.png?v=1722253648",description:"A playful rubber duck for bath time fun"},{name:"Boat",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Group_1791_430x.svg?v=1722249905#",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Weezie_Studio_-_914232471_1_430x.png?v=1722250841",description:"A nod to nautical."},{name:"Bow",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Vector_480x480.svg?v=1722249914",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Weezie_Studio_-_914232475_1_430x.png?v=1722250841",description:"Inspired by towels Liz had as a little girl."},{name:"2 Hearts",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Group_1_430x.svg?v=1722249918#",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Heart-MUT-PDP-Coral_1_430x.png?v=1722250842",description:"Heart eyes over Weezie? Us too!"},{name:"3 Hearts",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Group_2_430x.svg?v=1722249922#",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Weezie_Studio_-_914232483_1_1_430x.png?v=1722250842",description:"Show your love with 3 sweet hearts."},{name:"Eyelids",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Group_4_430x.svg?v=1722250556",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Weezie_Studio_-_914232484_1_1_430x.png?v=1722250842",description:"Our iconic eyelids, perfect for makeup towels."},{name:"Rackets",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/rackets_430x.svg?v=1722249930#",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/image_1466_430x.png?v=1722250841",description:"Serve up a perfect gift for tennis lovers."},{name:"Clubs",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/clubs.svg?v=1723057834",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/image_1456_430x.png?v=1722250841",description:"Towel time takes to the links!"},{name:"Paddles",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/m5YsMK_430x.svg?v=1722249947#",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Weezie_Studio_-_914232474_1_430x.png?v=1722250841",description:"Pickle paddle perfection!"},{name:"Eggs",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/eggs-icon.svg?v=1726260151",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/eggs-iconimg.jpg?v=1726589439",description:"Celebrate spring with colorful, decorated eggs."},{name:"Fireworks",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/fireworks-icon.svg?v=1726260525",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/fireworks-iconimg.jpg?v=1726589439",description:"Spark joy with fireworks – perfect for summer’s celebratory moments."},{name:"Shell",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/shells-icon.png?v=1726260525",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/shell-iconimg.jpg?v=1726589439",description:"A coastal classic."},{name:"Palm",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/palmtree-icon.svg?v=1726260525",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/palm-iconimg.jpg?v=1726589439",description:"Add a tropical twist with a breezy palm tree."},{name:"Pumpkins",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/pumpkins-icon.svg?v=1726260525",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/pumpkins-iconimg.jpg?v=1726589439",description:"A festive addition to your fall lineup."},{name:"Flutes",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/flutes-icon.svg?v=1726260525",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/flutes-iconimg.jpg?v=1726589439",description:"Cheers to good times with clinking champagne flutes."},{name:"Garland",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/garland-icon.svg?v=1726260525",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/garland-iconimg.jpg?v=1726589439",description:"Deck the halls with festive garlands."},{name:"Wreath",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/wreath-icon.svg?v=1726260525",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/wreath-iconimg.jpg?v=1726589439",description:"A classic holiday wreath for a touch of winter festivity."},{name:"Martinis",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/2Martini2_75.svg?v=1759353202",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/PU-Martini.jpg?v=1762283045",description:"It’s ’tini time!"},{name:"Lemons",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Lemon_9.2.25.svg?v=1759353313",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/PU-Lemons.jpg?v=1762283044",description:"By Catherine Owen Design. Bright, bold, and the perfect addition to your kitchen."},{name:"Strawberries",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Strawberries_9.2.25.svg?v=1759353311",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/PU-Strawberry.jpg?v=1762283044",description:"By Catherine Owen Design. Freshly picked and forever a favorite."},{name:"Snail",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Weezie_Snail.svg?v=1759353360",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/PU-Snail.jpg?v=1762283044",description:"By Catherine Owen Design. Our darling snail brings garden charm."},{name:"Beetle",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Beetle_Weezie.svg?v=1759353351",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/PU-Beetle.jpg?v=1762283044",description:"By Catherine Owen Design. A tiny treasure from the garden."},{name:"Dragonfly",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Dragonfly_9.2.25.svg?v=1759353358",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/PU-Dragonfly.jpg?v=1762283044",description:"By Catherine Owen Design. A delicate detail to add a touch of whimsy."},{name:"Red Snake",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/3Snake5_0r.svg?v=1759353454",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/PU-Red_Snake.jpg?v=1762283044",description:"A bold choice with unexpected style."},{name:"Green Snake",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/3Snake5_0g.svg?v=1759353449",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/PU-Green_Snake.jpg?v=1762283044",description:"A subtle showstopper with a playful twist."},{name:"Hot Air Balloon",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Icon-Balloon.svg?v=1759353707",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/PU-Hot_Air_Balloon.jpg?v=1762283044",description:"By Catherine Owen Design. Up, up, and away! Add your little’s name when you select the font version."},{name:"Swan",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Icon-Swan.svg?v=1759353693",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/PU-Swan.jpg?v=1762283044",description:"Graceful, classic, and oh-so-cute. Add your little’s name when you select the font version."},{name:"Rocking Horse",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Icon-Rocking-Horse.svg?v=1759354061",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/PU-Rocking_Horse.jpg?v=1762283045",description:"Our rocking horse is timeless and oh-so-darling. Add your little’s name when you select the font version."},{name:"Flower",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Icon-Florals.svg?v=1759353710",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/PU-Flower.jpg?v=1762283044",description:"By Catherine Owen Design. Blooming with charm! Add your little’s name when you select the font version."},{name:"Dino",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Icon-Dino.svg?v=1759353700",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/PU-Dino.jpg?v=1762283044",description:"By Catherine Owen Design. Meet our friendly dino! Add your little’s name when you select the font version."},{name:"Lamb",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Icon-Sheep.svg?v=1759353696",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/PU-Lamb.jpg?v=1762283044",description:"Soft, snuggly, and oh-so-sweet. Add your little’s name when you select the font version."},{name:"Goose",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Icon-Duck.svg?v=1759353704",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/PU-Goose.jpg?v=1762283044",description:"Complete with storybook charm. Add your little’s name when you select the font version."}];

const o$9 = [{font:"Duck",iconBadge:DuckIcon,iconPreview:DuckIcon},{font:"Boat",iconBadge:BoatIcon,iconPreview:BoatIcon},{font:"Bow",iconBadge:BowIcon,iconPreview:BowIcon},{font:"2 Hearts",iconBadge:HeartEyes,iconPreview:HeartEyes},{font:"3 Hearts",iconBadge:ThreeHearts,iconPreview:ThreeHearts},{font:"Eyelids",iconBadge:EyeLids,iconPreview:EyeLids},{font:"Rackets",iconBadge:TennRackets,iconPreview:TennRackets},{font:"Clubs",iconBadge:Clubs,iconPreview:Clubs},{font:"Paddles",iconBadge:Paddles,iconPreview:Paddles},{font:"Flutes",iconBadge:FlutesIcon,iconPreview:FlutesIcon},{font:"Palm",iconBadge:PalmIcon,iconPreview:PalmIcon},{font:"Sand Shell",iconBadge:SandShellIcon,iconPreview:SandShellIcon},{font:"Coral Shell",iconBadge:CoralShellIcon,iconPreview:CoralShellIcon},{font:"Eggs",iconBadge:EggsIcon,iconPreview:EggsIcon},{font:"Fireworks",iconBadge:FireworksIcon,iconPreview:FireworksIcon},{font:"Pumpkins",iconBadge:PumpkinsIcon,iconPreview:PumpkinsIcon},{font:"Garland",iconBadge:GarlandIcon,iconPreview:GarlandIcon},{font:"Wreath",iconBadge:WreathIcon,iconPreview:WreathIcon}];

const ANSLEY_VINE_HEX="#6FA287";const ANSLEY_COLORWAYS=[{name:"French Blue/Light Blue",fontColor:"French Blue",fontHex:"#78A0D4",borderColor:"Light Blue",borderHex:"#D2E2F1",vineHex:ANSLEY_VINE_HEX,twoTone:true},{name:"Coral/Marigold",fontColor:"Coral",fontHex:"#F4A095",borderColor:"Marigold",borderHex:"#FFCE06",vineHex:ANSLEY_VINE_HEX,twoTone:true},{name:"Begonia/Ballet Pink",fontColor:"Begonia",fontHex:"#F07695",borderColor:"Ballet Pink",borderHex:"#FACAD8",vineHex:ANSLEY_VINE_HEX,twoTone:true},{name:"Spa Blue/Sand",fontColor:"Spa Blue",fontHex:"#91B6BB",borderColor:"Sand",borderHex:"#DFD4C9",vineHex:ANSLEY_VINE_HEX,twoTone:true},{name:"Taupe/Sand",fontColor:"Taupe",fontHex:"#AF9483",borderColor:"Sand",borderHex:"#DFD4C9",vineHex:ANSLEY_VINE_HEX,twoTone:true}];const ANSLEY_COLORWAYS_SINGLE=ANSLEY_COLORWAYS.map(o=>({...o,name:o.fontColor}));const ANSLEY_VINE_COLORWAYS=ANSLEY_COLORWAYS.map(o=>({...o,name:`${o.fontColor} ${o.borderColor}`}));const ANSLEY_FONTS=["Ansley","Ansley Vine"];const isAnsleyFont=o=>ANSLEY_FONTS.includes(o);const TWO_TONE_FONTS={Ansley:ANSLEY_COLORWAYS_SINGLE,"Ansley Vine":ANSLEY_VINE_COLORWAYS,Jones:[{name:"Light Blue with French Blue",fontColor:"Light Blue",fontHex:"#D2E2F1",borderColor:"French Blue",borderHex:"#78A0D4",twoTone:true},{name:"Green with Light Blue",fontColor:"Green",fontHex:"#6FA287",borderColor:"Light Blue",borderHex:"#D2E2F1",twoTone:true},{name:"Coral with Ballet Pink",fontColor:"Coral",fontHex:"#F4A095",borderColor:"Ballet Pink",borderHex:"#FACAD8",twoTone:true},{name:"Coral with Green",fontColor:"Coral",fontHex:"#F4A095",borderColor:"Green",borderHex:"#6FA287",twoTone:true},{name:"Taupe with Sand",fontColor:"Taupe",fontHex:"#AF9483",borderColor:"Sand",borderHex:"#DFD4C9",twoTone:true}],Grady:[{name:"Light Blue with French Blue",fontColor:"Light Blue",fontHex:"#D2E2F1",borderColor:"French Blue",borderHex:"#78A0D4",twoTone:true},{name:"French Blue with Navy",fontColor:"French Blue",fontHex:"#78A0D4",borderColor:"Navy",borderHex:"#14334C",twoTone:true},{name:"Light Blue with Green",fontColor:"Light Blue",fontHex:"#D2E2F1",borderColor:"Green",borderHex:"#6FA287",twoTone:true},{name:"Green with Navy",fontColor:"Green",fontHex:"#6FA287",borderColor:"Navy",borderHex:"#14334C",twoTone:true},{name:"Sand with Taupe",fontColor:"Sand",fontHex:"#DFD4C9",borderColor:"Taupe",borderHex:"#AF9483",twoTone:true},{name:"Ballet Pink with Coral",fontColor:"Ballet Pink",fontHex:"#FACAD8",borderColor:"Coral",borderHex:"#F4A095",twoTone:true}],Wesley:[{name:"Light Blue with French Blue",fontColor:"Light Blue",fontHex:"#D2E2F1",borderColor:"French Blue",borderHex:"#78A0D4",twoTone:true},{name:"French Blue with Navy",fontColor:"French Blue",fontHex:"#78A0D4",borderColor:"Navy",borderHex:"#14334C",twoTone:true},{name:"Light Blue with Green",fontColor:"Light Blue",fontHex:"#D2E2F1",borderColor:"Green",borderHex:"#6FA287",twoTone:true},{name:"Green with Navy",fontColor:"Green",fontHex:"#6FA287",borderColor:"Navy",borderHex:"#14334C",twoTone:true},{name:"Sand with Taupe",fontColor:"Sand",fontHex:"#DFD4C9",borderColor:"Taupe",borderHex:"#AF9483",twoTone:true},{name:"Ballet Pink with Coral",fontColor:"Ballet Pink",fontHex:"#FACAD8",borderColor:"Coral",borderHex:"#F4A095",twoTone:true}]};const TWO_TONE_FONT_PREFIXES=Object.keys(TWO_TONE_FONTS).map(o=>`${o} `).sort((o,e)=>e.length-o.length);const isTwoToneFont=o=>!!TWO_TONE_FONTS[o];const TWO_TONE_ONLY_FONTS=["Grady","Ansley","Ansley Vine","Wesley"];const isTwoToneOnlyFont=o=>TWO_TONE_ONLY_FONTS.includes(o);

const MULTI_ROW_FONTS={"Only River":{mode:"equal",fonts:["River"],opsStyle:"River Multi Row"},"Only Sullivan":{mode:"equal",fonts:["Sullivan"],opsStyle:"Sullivan Multi Row"},"River + Sullivan":{mode:"cascade",fonts:["River","Sullivan","Sullivan"],opsStyle:"River Sullivan Cascading"}};const MULTI_ROW_TEXT_KEYS=["Embroidery Text","Embroidery Text2","Embroidery Text3"];const MULTI_ROW_MIN_ROWS=2;const MULTI_ROW_MAX_ROWS=3;const MULTI_ROW_MAX_CHARS=13;const MULTI_ROW_PLACEHOLDERS={equal:["Weezie","Atlanta","Est 2018"],cascade:["Eloise","Oct 8, 2018","7 lbs. 7 oz."]};const isMultiRowFont=t=>!!MULTI_ROW_FONTS[t];const getMultiRowMode=t=>MULTI_ROW_FONTS[t]?.mode||null;const getMultiRowOpsStyle=t=>MULTI_ROW_FONTS[t]?.opsStyle||null;const getMultiRowPlaceholders=t=>MULTI_ROW_PLACEHOLDERS[t]||[];let t$2=/[^A-Za-z0-9\s,.\/]/g;const sanitizeMultiRowText=e=>(e||"").replace(t$2,"");const getRowFont=(t,e)=>{let o=MULTI_ROW_FONTS[t];return o?o.fonts[e]||o.fonts[o.fonts.length-1]:null};const getRowFontsForOpsStyle=t=>Object.values(MULTI_ROW_FONTS).find(e=>e.opsStyle===t)?.fonts||null;const getMultiRowLines=(t={})=>MULTI_ROW_TEXT_KEYS.map(e=>(t?.[e]||"").trim()).filter(t=>""!==t);

const l$5 = (({properties:v,size:y=41,customClass:f=""})=>{let[w,g]=reactExports.useState(true),[u,h]=reactExports.useState(null),[$,b]=reactExports.useState(false),{fontSize:N,ref:x}=s$5({maxFontSize:500,minFontSize:1,onFinish:()=>g(false)}),C=v?.["Embroidery Color"]||"",H=v?.["Embroidery Style"]||"",S=TWO_TONE_FONT_PREFIXES.find(e=>H.startsWith(e)),F=S?S.trim():H;var L=(v?.["Embroidery Text"]||"").trim();"Icon"===L&&(L="");let j="Ansley Vine"===F,k="Ansley"===F||j,q=k?ANSLEY_COLORWAYS.find(e=>e.fontColor===C||`${e.fontColor} ${e.borderColor}`===C):null,P="Grady"===F,A=((S?H.slice(S.length):"")||C).replace(/\s/g,""),z=P?(TWO_TONE_FONTS.Grady||[]).find(e=>`${e.fontColor}${e.borderColor}`.replace(/\s/g,"")===A):null,E=v?._applique_fill||"",R=v?._applique_stroke||"",T=!!(E&&R),G="Ponce"===F||"Ponce Large"===F||"Ponce Small"===F,M=getRowFontsForOpsStyle(H),W=Array.isArray(M),B=W&&M.includes("River")&&M.includes("Sullivan"),I=W&&M.every(e=>"River"===e),V=W&&M.every(e=>"Sullivan"===e),Y=W?getMultiRowLines(v):[];return reactExports.useEffect(()=>{g(false);},[L,F]),reactExports.useEffect(()=>{if(""===L){let e=o$9.find(e=>e.font===F);h(e||null),b(!!e);}else b(""!==L);},[F,L]),jsxRuntimeExports.jsx("div",{className:`absolute inset-0 flex items-end justify-end p-2 pointer-events-none z-10 ${$?"":"hidden"}`,children:jsxRuntimeExports.jsx("div",{className:"w-16 h-16 bg-white relative rounded py-1 shadow-lg flex items-baseline justify-center",children:jsxRuntimeExports.jsx("div",{className:`litem__img-embpreview-wrap litem__img-embpreview-wrap--${f} litem__img-embpreview-wrap--loading-${w} ${C.toLowerCase().replace(/\s/g,"")}`,children:jsxRuntimeExports.jsx("div",{className:`litem__img-embpreview embroidery__preview-text--${F.toLowerCase()} embroidery__preview-text--${C.toLowerCase().replace(/\s/g,"")} ${T?"embroidery__preview-text--applique litem__img-embpreview--applique":""} ${k?"litem__img-embpreview--ansley":""} ${j?"litem__img-embpreview--ansley-vine":""} ${P?"litem__img-embpreview--grady":""} ${I||V?"litem__img-embpreview--equal-scale":""}`,style:{fontSize:N,height:y,width:y,...T&&{color:R,"--fill-backgrund":E.startsWith("#")?E:`url(${E})`}},ref:x,children:W?jsxRuntimeExports.jsx("div",{className:`litem__img-embpreview--multirow ${B?"litem__img-embpreview--multirow-cascade":""} ${I?"litem__img-embpreview--multirow-river":""} ${V?"litem__img-embpreview--multirow-sullivan":""} flex flex-col items-center justify-center w-full leading-none`,children:Y.map((l,r)=>jsxRuntimeExports.jsx("div",{className:`leading-none multirow-row--${(M[r]||M[M.length-1]).toLowerCase()}`,children:l},`row-${r}`))}):T?jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment,{children:[G?jsxRuntimeExports.jsx("div",{className:"ponce-applique-scale",children:[...L].map((l,r)=>jsxRuntimeExports.jsx("span",{className:" "===l?"spacer":void 0,children:l},`${r}-${l}`))}):[...L].map((l,r)=>jsxRuntimeExports.jsx("span",{className:" "===l?"spacer":void 0,children:l},`${r}-${l}`)),G&&jsxRuntimeExports.jsx(PonceSvgContainer,{stroke:R,fill:E,patternSize:195,patternAspect:"xMidYMid slice"})]}):jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment,{children:[""===L&&u&&jsxRuntimeExports.jsx("div",{className:"embroidery__preview-icon",children:jsxRuntimeExports.jsx(({icon:l,iconClass:r})=>l&&jsxRuntimeExports.jsx(l,{elClass:r,showLabel:false}),{icon:u.iconBadge,iconClass:"embroidery__font-btn__icon"},u.font)}),""!==L&&(()=>{let r=[...L].map((r,i)=>"Ponce"===F||"Ponce Large"===F||"Ponce Small"===F?jsxRuntimeExports.jsxs("div",{children:[jsxRuntimeExports.jsx("span",{className:`ponce_letter ${" "===r?"spacer":void 0}`,children:r},`${i}-${r}`),jsxRuntimeExports.jsx(PonceSvg,{elClass:"ponce_svg",embColor:C},`${i}-${r}-svg`)]},`${i}-${r}-wrapper`):k&&q?jsxRuntimeExports.jsxs("span",{className:"ansley-tt-cell",children:[jsxRuntimeExports.jsx("span",{className:"ansley-tt-flower",style:{color:q.borderHex},children:r}),jsxRuntimeExports.jsx("span",{className:"ansley-tt-stem",style:{color:q.vineHex},children:r}),jsxRuntimeExports.jsx("span",{className:"ansley-tt-letter",style:{color:q.fontHex},children:r})]},`ansley-${i}-${r}`):P&&z?jsxRuntimeExports.jsxs("span",{className:"grady-tt-cell",children:[jsxRuntimeExports.jsx("span",{className:"grady-tt-letter",style:{color:z.fontHex},children:r}),jsxRuntimeExports.jsx("span",{className:"grady-tt-swash",style:{color:z.borderHex},children:r})]},`grady-${i}-${r}`):jsxRuntimeExports.jsx("span",{className:" "===r?"spacer":void 0,children:r},`${i}-${r}`));return j?jsxRuntimeExports.jsx("div",{className:"ansley-vine-scale",children:r}):k?jsxRuntimeExports.jsx("div",{className:"ansley-scale",children:r}):P?jsxRuntimeExports.jsx("div",{className:"grady-scale",children:r}):r})(),j&&q&&jsxRuntimeExports.jsxs("div",{className:"ansley-frame",children:[jsxRuntimeExports.jsx("div",{className:"ansley-frame__layer ansley-frame__vine",style:{backgroundColor:q.vineHex}}),jsxRuntimeExports.jsx("div",{className:"ansley-frame__layer ansley-frame__petals",style:{backgroundColor:q.borderHex}}),jsxRuntimeExports.jsx("div",{className:"ansley-frame__layer ansley-frame__outline",style:{backgroundColor:q.fontHex}})]})]})})})})})});

var __assign$1 = (undefined && undefined.__assign) || function () {
    __assign$1 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};
// This file is autogenerated by tools/process-named-references.ts
var pairDivider = "~";
var blockDivider = "~~";
function generateNamedReferences(input, prev) {
    var entities = {};
    var characters = {};
    var blocks = input.split(blockDivider);
    var isOptionalBlock = false;
    for (var i = 0; blocks.length > i; i++) {
        var entries = blocks[i].split(pairDivider);
        for (var j = 0; j < entries.length; j += 2) {
            var entity = entries[j];
            var character = entries[j + 1];
            var fullEntity = '&' + entity + ';';
            entities[fullEntity] = character;
            if (isOptionalBlock) {
                entities['&' + entity] = character;
            }
            characters[character] = fullEntity;
        }
        isOptionalBlock = true;
    }
    return prev ?
        { entities: __assign$1(__assign$1({}, entities), prev.entities), characters: __assign$1(__assign$1({}, characters), prev.characters) } :
        { entities: entities, characters: characters };
}
var bodyRegExps = {
    xml: /&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g,
    html4: /&notin;|&(?:nbsp|iexcl|cent|pound|curren|yen|brvbar|sect|uml|copy|ordf|laquo|not|shy|reg|macr|deg|plusmn|sup2|sup3|acute|micro|para|middot|cedil|sup1|ordm|raquo|frac14|frac12|frac34|iquest|Agrave|Aacute|Acirc|Atilde|Auml|Aring|AElig|Ccedil|Egrave|Eacute|Ecirc|Euml|Igrave|Iacute|Icirc|Iuml|ETH|Ntilde|Ograve|Oacute|Ocirc|Otilde|Ouml|times|Oslash|Ugrave|Uacute|Ucirc|Uuml|Yacute|THORN|szlig|agrave|aacute|acirc|atilde|auml|aring|aelig|ccedil|egrave|eacute|ecirc|euml|igrave|iacute|icirc|iuml|eth|ntilde|ograve|oacute|ocirc|otilde|ouml|divide|oslash|ugrave|uacute|ucirc|uuml|yacute|thorn|yuml|quot|amp|lt|gt|#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g,
    html5: /&centerdot;|&copysr;|&divideontimes;|&gtcc;|&gtcir;|&gtdot;|&gtlPar;|&gtquest;|&gtrapprox;|&gtrarr;|&gtrdot;|&gtreqless;|&gtreqqless;|&gtrless;|&gtrsim;|&ltcc;|&ltcir;|&ltdot;|&lthree;|&ltimes;|&ltlarr;|&ltquest;|&ltrPar;|&ltri;|&ltrie;|&ltrif;|&notin;|&notinE;|&notindot;|&notinva;|&notinvb;|&notinvc;|&notni;|&notniva;|&notnivb;|&notnivc;|&parallel;|&timesb;|&timesbar;|&timesd;|&(?:AElig|AMP|Aacute|Acirc|Agrave|Aring|Atilde|Auml|COPY|Ccedil|ETH|Eacute|Ecirc|Egrave|Euml|GT|Iacute|Icirc|Igrave|Iuml|LT|Ntilde|Oacute|Ocirc|Ograve|Oslash|Otilde|Ouml|QUOT|REG|THORN|Uacute|Ucirc|Ugrave|Uuml|Yacute|aacute|acirc|acute|aelig|agrave|amp|aring|atilde|auml|brvbar|ccedil|cedil|cent|copy|curren|deg|divide|eacute|ecirc|egrave|eth|euml|frac12|frac14|frac34|gt|iacute|icirc|iexcl|igrave|iquest|iuml|laquo|lt|macr|micro|middot|nbsp|not|ntilde|oacute|ocirc|ograve|ordf|ordm|oslash|otilde|ouml|para|plusmn|pound|quot|raquo|reg|sect|shy|sup1|sup2|sup3|szlig|thorn|times|uacute|ucirc|ugrave|uml|uuml|yacute|yen|yuml|#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g
};
var namedReferences = {};
namedReferences['xml'] = generateNamedReferences("lt~<~gt~>~quot~\"~apos~'~amp~&");
namedReferences['html4'] = generateNamedReferences("apos~'~OElig~Œ~oelig~œ~Scaron~Š~scaron~š~Yuml~Ÿ~circ~ˆ~tilde~˜~ensp~ ~emsp~ ~thinsp~ ~zwnj~‌~zwj~‍~lrm~‎~rlm~‏~ndash~–~mdash~—~lsquo~‘~rsquo~’~sbquo~‚~ldquo~“~rdquo~”~bdquo~„~dagger~†~Dagger~‡~permil~‰~lsaquo~‹~rsaquo~›~euro~€~fnof~ƒ~Alpha~Α~Beta~Β~Gamma~Γ~Delta~Δ~Epsilon~Ε~Zeta~Ζ~Eta~Η~Theta~Θ~Iota~Ι~Kappa~Κ~Lambda~Λ~Mu~Μ~Nu~Ν~Xi~Ξ~Omicron~Ο~Pi~Π~Rho~Ρ~Sigma~Σ~Tau~Τ~Upsilon~Υ~Phi~Φ~Chi~Χ~Psi~Ψ~Omega~Ω~alpha~α~beta~β~gamma~γ~delta~δ~epsilon~ε~zeta~ζ~eta~η~theta~θ~iota~ι~kappa~κ~lambda~λ~mu~μ~nu~ν~xi~ξ~omicron~ο~pi~π~rho~ρ~sigmaf~ς~sigma~σ~tau~τ~upsilon~υ~phi~φ~chi~χ~psi~ψ~omega~ω~thetasym~ϑ~upsih~ϒ~piv~ϖ~bull~•~hellip~…~prime~′~Prime~″~oline~‾~frasl~⁄~weierp~℘~image~ℑ~real~ℜ~trade~™~alefsym~ℵ~larr~←~uarr~↑~rarr~→~darr~↓~harr~↔~crarr~↵~lArr~⇐~uArr~⇑~rArr~⇒~dArr~⇓~hArr~⇔~forall~∀~part~∂~exist~∃~empty~∅~nabla~∇~isin~∈~notin~∉~ni~∋~prod~∏~sum~∑~minus~−~lowast~∗~radic~√~prop~∝~infin~∞~ang~∠~and~∧~or~∨~cap~∩~cup~∪~int~∫~there4~∴~sim~∼~cong~≅~asymp~≈~ne~≠~equiv~≡~le~≤~ge~≥~sub~⊂~sup~⊃~nsub~⊄~sube~⊆~supe~⊇~oplus~⊕~otimes~⊗~perp~⊥~sdot~⋅~lceil~⌈~rceil~⌉~lfloor~⌊~rfloor~⌋~lang~〈~rang~〉~loz~◊~spades~♠~clubs~♣~hearts~♥~diams~♦~~nbsp~ ~iexcl~¡~cent~¢~pound~£~curren~¤~yen~¥~brvbar~¦~sect~§~uml~¨~copy~©~ordf~ª~laquo~«~not~¬~shy~­~reg~®~macr~¯~deg~°~plusmn~±~sup2~²~sup3~³~acute~´~micro~µ~para~¶~middot~·~cedil~¸~sup1~¹~ordm~º~raquo~»~frac14~¼~frac12~½~frac34~¾~iquest~¿~Agrave~À~Aacute~Á~Acirc~Â~Atilde~Ã~Auml~Ä~Aring~Å~AElig~Æ~Ccedil~Ç~Egrave~È~Eacute~É~Ecirc~Ê~Euml~Ë~Igrave~Ì~Iacute~Í~Icirc~Î~Iuml~Ï~ETH~Ð~Ntilde~Ñ~Ograve~Ò~Oacute~Ó~Ocirc~Ô~Otilde~Õ~Ouml~Ö~times~×~Oslash~Ø~Ugrave~Ù~Uacute~Ú~Ucirc~Û~Uuml~Ü~Yacute~Ý~THORN~Þ~szlig~ß~agrave~à~aacute~á~acirc~â~atilde~ã~auml~ä~aring~å~aelig~æ~ccedil~ç~egrave~è~eacute~é~ecirc~ê~euml~ë~igrave~ì~iacute~í~icirc~î~iuml~ï~eth~ð~ntilde~ñ~ograve~ò~oacute~ó~ocirc~ô~otilde~õ~ouml~ö~divide~÷~oslash~ø~ugrave~ù~uacute~ú~ucirc~û~uuml~ü~yacute~ý~thorn~þ~yuml~ÿ~quot~\"~amp~&~lt~<~gt~>");
namedReferences['html5'] = generateNamedReferences("Abreve~Ă~Acy~А~Afr~𝔄~Amacr~Ā~And~⩓~Aogon~Ą~Aopf~𝔸~ApplyFunction~⁡~Ascr~𝒜~Assign~≔~Backslash~∖~Barv~⫧~Barwed~⌆~Bcy~Б~Because~∵~Bernoullis~ℬ~Bfr~𝔅~Bopf~𝔹~Breve~˘~Bscr~ℬ~Bumpeq~≎~CHcy~Ч~Cacute~Ć~Cap~⋒~CapitalDifferentialD~ⅅ~Cayleys~ℭ~Ccaron~Č~Ccirc~Ĉ~Cconint~∰~Cdot~Ċ~Cedilla~¸~CenterDot~·~Cfr~ℭ~CircleDot~⊙~CircleMinus~⊖~CirclePlus~⊕~CircleTimes~⊗~ClockwiseContourIntegral~∲~CloseCurlyDoubleQuote~”~CloseCurlyQuote~’~Colon~∷~Colone~⩴~Congruent~≡~Conint~∯~ContourIntegral~∮~Copf~ℂ~Coproduct~∐~CounterClockwiseContourIntegral~∳~Cross~⨯~Cscr~𝒞~Cup~⋓~CupCap~≍~DD~ⅅ~DDotrahd~⤑~DJcy~Ђ~DScy~Ѕ~DZcy~Џ~Darr~↡~Dashv~⫤~Dcaron~Ď~Dcy~Д~Del~∇~Dfr~𝔇~DiacriticalAcute~´~DiacriticalDot~˙~DiacriticalDoubleAcute~˝~DiacriticalGrave~`~DiacriticalTilde~˜~Diamond~⋄~DifferentialD~ⅆ~Dopf~𝔻~Dot~¨~DotDot~⃜~DotEqual~≐~DoubleContourIntegral~∯~DoubleDot~¨~DoubleDownArrow~⇓~DoubleLeftArrow~⇐~DoubleLeftRightArrow~⇔~DoubleLeftTee~⫤~DoubleLongLeftArrow~⟸~DoubleLongLeftRightArrow~⟺~DoubleLongRightArrow~⟹~DoubleRightArrow~⇒~DoubleRightTee~⊨~DoubleUpArrow~⇑~DoubleUpDownArrow~⇕~DoubleVerticalBar~∥~DownArrow~↓~DownArrowBar~⤓~DownArrowUpArrow~⇵~DownBreve~̑~DownLeftRightVector~⥐~DownLeftTeeVector~⥞~DownLeftVector~↽~DownLeftVectorBar~⥖~DownRightTeeVector~⥟~DownRightVector~⇁~DownRightVectorBar~⥗~DownTee~⊤~DownTeeArrow~↧~Downarrow~⇓~Dscr~𝒟~Dstrok~Đ~ENG~Ŋ~Ecaron~Ě~Ecy~Э~Edot~Ė~Efr~𝔈~Element~∈~Emacr~Ē~EmptySmallSquare~◻~EmptyVerySmallSquare~▫~Eogon~Ę~Eopf~𝔼~Equal~⩵~EqualTilde~≂~Equilibrium~⇌~Escr~ℰ~Esim~⩳~Exists~∃~ExponentialE~ⅇ~Fcy~Ф~Ffr~𝔉~FilledSmallSquare~◼~FilledVerySmallSquare~▪~Fopf~𝔽~ForAll~∀~Fouriertrf~ℱ~Fscr~ℱ~GJcy~Ѓ~Gammad~Ϝ~Gbreve~Ğ~Gcedil~Ģ~Gcirc~Ĝ~Gcy~Г~Gdot~Ġ~Gfr~𝔊~Gg~⋙~Gopf~𝔾~GreaterEqual~≥~GreaterEqualLess~⋛~GreaterFullEqual~≧~GreaterGreater~⪢~GreaterLess~≷~GreaterSlantEqual~⩾~GreaterTilde~≳~Gscr~𝒢~Gt~≫~HARDcy~Ъ~Hacek~ˇ~Hat~^~Hcirc~Ĥ~Hfr~ℌ~HilbertSpace~ℋ~Hopf~ℍ~HorizontalLine~─~Hscr~ℋ~Hstrok~Ħ~HumpDownHump~≎~HumpEqual~≏~IEcy~Е~IJlig~Ĳ~IOcy~Ё~Icy~И~Idot~İ~Ifr~ℑ~Im~ℑ~Imacr~Ī~ImaginaryI~ⅈ~Implies~⇒~Int~∬~Integral~∫~Intersection~⋂~InvisibleComma~⁣~InvisibleTimes~⁢~Iogon~Į~Iopf~𝕀~Iscr~ℐ~Itilde~Ĩ~Iukcy~І~Jcirc~Ĵ~Jcy~Й~Jfr~𝔍~Jopf~𝕁~Jscr~𝒥~Jsercy~Ј~Jukcy~Є~KHcy~Х~KJcy~Ќ~Kcedil~Ķ~Kcy~К~Kfr~𝔎~Kopf~𝕂~Kscr~𝒦~LJcy~Љ~Lacute~Ĺ~Lang~⟪~Laplacetrf~ℒ~Larr~↞~Lcaron~Ľ~Lcedil~Ļ~Lcy~Л~LeftAngleBracket~⟨~LeftArrow~←~LeftArrowBar~⇤~LeftArrowRightArrow~⇆~LeftCeiling~⌈~LeftDoubleBracket~⟦~LeftDownTeeVector~⥡~LeftDownVector~⇃~LeftDownVectorBar~⥙~LeftFloor~⌊~LeftRightArrow~↔~LeftRightVector~⥎~LeftTee~⊣~LeftTeeArrow~↤~LeftTeeVector~⥚~LeftTriangle~⊲~LeftTriangleBar~⧏~LeftTriangleEqual~⊴~LeftUpDownVector~⥑~LeftUpTeeVector~⥠~LeftUpVector~↿~LeftUpVectorBar~⥘~LeftVector~↼~LeftVectorBar~⥒~Leftarrow~⇐~Leftrightarrow~⇔~LessEqualGreater~⋚~LessFullEqual~≦~LessGreater~≶~LessLess~⪡~LessSlantEqual~⩽~LessTilde~≲~Lfr~𝔏~Ll~⋘~Lleftarrow~⇚~Lmidot~Ŀ~LongLeftArrow~⟵~LongLeftRightArrow~⟷~LongRightArrow~⟶~Longleftarrow~⟸~Longleftrightarrow~⟺~Longrightarrow~⟹~Lopf~𝕃~LowerLeftArrow~↙~LowerRightArrow~↘~Lscr~ℒ~Lsh~↰~Lstrok~Ł~Lt~≪~Map~⤅~Mcy~М~MediumSpace~ ~Mellintrf~ℳ~Mfr~𝔐~MinusPlus~∓~Mopf~𝕄~Mscr~ℳ~NJcy~Њ~Nacute~Ń~Ncaron~Ň~Ncedil~Ņ~Ncy~Н~NegativeMediumSpace~​~NegativeThickSpace~​~NegativeThinSpace~​~NegativeVeryThinSpace~​~NestedGreaterGreater~≫~NestedLessLess~≪~NewLine~\n~Nfr~𝔑~NoBreak~⁠~NonBreakingSpace~ ~Nopf~ℕ~Not~⫬~NotCongruent~≢~NotCupCap~≭~NotDoubleVerticalBar~∦~NotElement~∉~NotEqual~≠~NotEqualTilde~≂̸~NotExists~∄~NotGreater~≯~NotGreaterEqual~≱~NotGreaterFullEqual~≧̸~NotGreaterGreater~≫̸~NotGreaterLess~≹~NotGreaterSlantEqual~⩾̸~NotGreaterTilde~≵~NotHumpDownHump~≎̸~NotHumpEqual~≏̸~NotLeftTriangle~⋪~NotLeftTriangleBar~⧏̸~NotLeftTriangleEqual~⋬~NotLess~≮~NotLessEqual~≰~NotLessGreater~≸~NotLessLess~≪̸~NotLessSlantEqual~⩽̸~NotLessTilde~≴~NotNestedGreaterGreater~⪢̸~NotNestedLessLess~⪡̸~NotPrecedes~⊀~NotPrecedesEqual~⪯̸~NotPrecedesSlantEqual~⋠~NotReverseElement~∌~NotRightTriangle~⋫~NotRightTriangleBar~⧐̸~NotRightTriangleEqual~⋭~NotSquareSubset~⊏̸~NotSquareSubsetEqual~⋢~NotSquareSuperset~⊐̸~NotSquareSupersetEqual~⋣~NotSubset~⊂⃒~NotSubsetEqual~⊈~NotSucceeds~⊁~NotSucceedsEqual~⪰̸~NotSucceedsSlantEqual~⋡~NotSucceedsTilde~≿̸~NotSuperset~⊃⃒~NotSupersetEqual~⊉~NotTilde~≁~NotTildeEqual~≄~NotTildeFullEqual~≇~NotTildeTilde~≉~NotVerticalBar~∤~Nscr~𝒩~Ocy~О~Odblac~Ő~Ofr~𝔒~Omacr~Ō~Oopf~𝕆~OpenCurlyDoubleQuote~“~OpenCurlyQuote~‘~Or~⩔~Oscr~𝒪~Otimes~⨷~OverBar~‾~OverBrace~⏞~OverBracket~⎴~OverParenthesis~⏜~PartialD~∂~Pcy~П~Pfr~𝔓~PlusMinus~±~Poincareplane~ℌ~Popf~ℙ~Pr~⪻~Precedes~≺~PrecedesEqual~⪯~PrecedesSlantEqual~≼~PrecedesTilde~≾~Product~∏~Proportion~∷~Proportional~∝~Pscr~𝒫~Qfr~𝔔~Qopf~ℚ~Qscr~𝒬~RBarr~⤐~Racute~Ŕ~Rang~⟫~Rarr~↠~Rarrtl~⤖~Rcaron~Ř~Rcedil~Ŗ~Rcy~Р~Re~ℜ~ReverseElement~∋~ReverseEquilibrium~⇋~ReverseUpEquilibrium~⥯~Rfr~ℜ~RightAngleBracket~⟩~RightArrow~→~RightArrowBar~⇥~RightArrowLeftArrow~⇄~RightCeiling~⌉~RightDoubleBracket~⟧~RightDownTeeVector~⥝~RightDownVector~⇂~RightDownVectorBar~⥕~RightFloor~⌋~RightTee~⊢~RightTeeArrow~↦~RightTeeVector~⥛~RightTriangle~⊳~RightTriangleBar~⧐~RightTriangleEqual~⊵~RightUpDownVector~⥏~RightUpTeeVector~⥜~RightUpVector~↾~RightUpVectorBar~⥔~RightVector~⇀~RightVectorBar~⥓~Rightarrow~⇒~Ropf~ℝ~RoundImplies~⥰~Rrightarrow~⇛~Rscr~ℛ~Rsh~↱~RuleDelayed~⧴~SHCHcy~Щ~SHcy~Ш~SOFTcy~Ь~Sacute~Ś~Sc~⪼~Scedil~Ş~Scirc~Ŝ~Scy~С~Sfr~𝔖~ShortDownArrow~↓~ShortLeftArrow~←~ShortRightArrow~→~ShortUpArrow~↑~SmallCircle~∘~Sopf~𝕊~Sqrt~√~Square~□~SquareIntersection~⊓~SquareSubset~⊏~SquareSubsetEqual~⊑~SquareSuperset~⊐~SquareSupersetEqual~⊒~SquareUnion~⊔~Sscr~𝒮~Star~⋆~Sub~⋐~Subset~⋐~SubsetEqual~⊆~Succeeds~≻~SucceedsEqual~⪰~SucceedsSlantEqual~≽~SucceedsTilde~≿~SuchThat~∋~Sum~∑~Sup~⋑~Superset~⊃~SupersetEqual~⊇~Supset~⋑~TRADE~™~TSHcy~Ћ~TScy~Ц~Tab~\t~Tcaron~Ť~Tcedil~Ţ~Tcy~Т~Tfr~𝔗~Therefore~∴~ThickSpace~  ~ThinSpace~ ~Tilde~∼~TildeEqual~≃~TildeFullEqual~≅~TildeTilde~≈~Topf~𝕋~TripleDot~⃛~Tscr~𝒯~Tstrok~Ŧ~Uarr~↟~Uarrocir~⥉~Ubrcy~Ў~Ubreve~Ŭ~Ucy~У~Udblac~Ű~Ufr~𝔘~Umacr~Ū~UnderBar~_~UnderBrace~⏟~UnderBracket~⎵~UnderParenthesis~⏝~Union~⋃~UnionPlus~⊎~Uogon~Ų~Uopf~𝕌~UpArrow~↑~UpArrowBar~⤒~UpArrowDownArrow~⇅~UpDownArrow~↕~UpEquilibrium~⥮~UpTee~⊥~UpTeeArrow~↥~Uparrow~⇑~Updownarrow~⇕~UpperLeftArrow~↖~UpperRightArrow~↗~Upsi~ϒ~Uring~Ů~Uscr~𝒰~Utilde~Ũ~VDash~⊫~Vbar~⫫~Vcy~В~Vdash~⊩~Vdashl~⫦~Vee~⋁~Verbar~‖~Vert~‖~VerticalBar~∣~VerticalLine~|~VerticalSeparator~❘~VerticalTilde~≀~VeryThinSpace~ ~Vfr~𝔙~Vopf~𝕍~Vscr~𝒱~Vvdash~⊪~Wcirc~Ŵ~Wedge~⋀~Wfr~𝔚~Wopf~𝕎~Wscr~𝒲~Xfr~𝔛~Xopf~𝕏~Xscr~𝒳~YAcy~Я~YIcy~Ї~YUcy~Ю~Ycirc~Ŷ~Ycy~Ы~Yfr~𝔜~Yopf~𝕐~Yscr~𝒴~ZHcy~Ж~Zacute~Ź~Zcaron~Ž~Zcy~З~Zdot~Ż~ZeroWidthSpace~​~Zfr~ℨ~Zopf~ℤ~Zscr~𝒵~abreve~ă~ac~∾~acE~∾̳~acd~∿~acy~а~af~⁡~afr~𝔞~aleph~ℵ~amacr~ā~amalg~⨿~andand~⩕~andd~⩜~andslope~⩘~andv~⩚~ange~⦤~angle~∠~angmsd~∡~angmsdaa~⦨~angmsdab~⦩~angmsdac~⦪~angmsdad~⦫~angmsdae~⦬~angmsdaf~⦭~angmsdag~⦮~angmsdah~⦯~angrt~∟~angrtvb~⊾~angrtvbd~⦝~angsph~∢~angst~Å~angzarr~⍼~aogon~ą~aopf~𝕒~ap~≈~apE~⩰~apacir~⩯~ape~≊~apid~≋~approx~≈~approxeq~≊~ascr~𝒶~ast~*~asympeq~≍~awconint~∳~awint~⨑~bNot~⫭~backcong~≌~backepsilon~϶~backprime~‵~backsim~∽~backsimeq~⋍~barvee~⊽~barwed~⌅~barwedge~⌅~bbrk~⎵~bbrktbrk~⎶~bcong~≌~bcy~б~becaus~∵~because~∵~bemptyv~⦰~bepsi~϶~bernou~ℬ~beth~ℶ~between~≬~bfr~𝔟~bigcap~⋂~bigcirc~◯~bigcup~⋃~bigodot~⨀~bigoplus~⨁~bigotimes~⨂~bigsqcup~⨆~bigstar~★~bigtriangledown~▽~bigtriangleup~△~biguplus~⨄~bigvee~⋁~bigwedge~⋀~bkarow~⤍~blacklozenge~⧫~blacksquare~▪~blacktriangle~▴~blacktriangledown~▾~blacktriangleleft~◂~blacktriangleright~▸~blank~␣~blk12~▒~blk14~░~blk34~▓~block~█~bne~=⃥~bnequiv~≡⃥~bnot~⌐~bopf~𝕓~bot~⊥~bottom~⊥~bowtie~⋈~boxDL~╗~boxDR~╔~boxDl~╖~boxDr~╓~boxH~═~boxHD~╦~boxHU~╩~boxHd~╤~boxHu~╧~boxUL~╝~boxUR~╚~boxUl~╜~boxUr~╙~boxV~║~boxVH~╬~boxVL~╣~boxVR~╠~boxVh~╫~boxVl~╢~boxVr~╟~boxbox~⧉~boxdL~╕~boxdR~╒~boxdl~┐~boxdr~┌~boxh~─~boxhD~╥~boxhU~╨~boxhd~┬~boxhu~┴~boxminus~⊟~boxplus~⊞~boxtimes~⊠~boxuL~╛~boxuR~╘~boxul~┘~boxur~└~boxv~│~boxvH~╪~boxvL~╡~boxvR~╞~boxvh~┼~boxvl~┤~boxvr~├~bprime~‵~breve~˘~bscr~𝒷~bsemi~⁏~bsim~∽~bsime~⋍~bsol~\\~bsolb~⧅~bsolhsub~⟈~bullet~•~bump~≎~bumpE~⪮~bumpe~≏~bumpeq~≏~cacute~ć~capand~⩄~capbrcup~⩉~capcap~⩋~capcup~⩇~capdot~⩀~caps~∩︀~caret~⁁~caron~ˇ~ccaps~⩍~ccaron~č~ccirc~ĉ~ccups~⩌~ccupssm~⩐~cdot~ċ~cemptyv~⦲~centerdot~·~cfr~𝔠~chcy~ч~check~✓~checkmark~✓~cir~○~cirE~⧃~circeq~≗~circlearrowleft~↺~circlearrowright~↻~circledR~®~circledS~Ⓢ~circledast~⊛~circledcirc~⊚~circleddash~⊝~cire~≗~cirfnint~⨐~cirmid~⫯~cirscir~⧂~clubsuit~♣~colon~:~colone~≔~coloneq~≔~comma~,~commat~@~comp~∁~compfn~∘~complement~∁~complexes~ℂ~congdot~⩭~conint~∮~copf~𝕔~coprod~∐~copysr~℗~cross~✗~cscr~𝒸~csub~⫏~csube~⫑~csup~⫐~csupe~⫒~ctdot~⋯~cudarrl~⤸~cudarrr~⤵~cuepr~⋞~cuesc~⋟~cularr~↶~cularrp~⤽~cupbrcap~⩈~cupcap~⩆~cupcup~⩊~cupdot~⊍~cupor~⩅~cups~∪︀~curarr~↷~curarrm~⤼~curlyeqprec~⋞~curlyeqsucc~⋟~curlyvee~⋎~curlywedge~⋏~curvearrowleft~↶~curvearrowright~↷~cuvee~⋎~cuwed~⋏~cwconint~∲~cwint~∱~cylcty~⌭~dHar~⥥~daleth~ℸ~dash~‐~dashv~⊣~dbkarow~⤏~dblac~˝~dcaron~ď~dcy~д~dd~ⅆ~ddagger~‡~ddarr~⇊~ddotseq~⩷~demptyv~⦱~dfisht~⥿~dfr~𝔡~dharl~⇃~dharr~⇂~diam~⋄~diamond~⋄~diamondsuit~♦~die~¨~digamma~ϝ~disin~⋲~div~÷~divideontimes~⋇~divonx~⋇~djcy~ђ~dlcorn~⌞~dlcrop~⌍~dollar~$~dopf~𝕕~dot~˙~doteq~≐~doteqdot~≑~dotminus~∸~dotplus~∔~dotsquare~⊡~doublebarwedge~⌆~downarrow~↓~downdownarrows~⇊~downharpoonleft~⇃~downharpoonright~⇂~drbkarow~⤐~drcorn~⌟~drcrop~⌌~dscr~𝒹~dscy~ѕ~dsol~⧶~dstrok~đ~dtdot~⋱~dtri~▿~dtrif~▾~duarr~⇵~duhar~⥯~dwangle~⦦~dzcy~џ~dzigrarr~⟿~eDDot~⩷~eDot~≑~easter~⩮~ecaron~ě~ecir~≖~ecolon~≕~ecy~э~edot~ė~ee~ⅇ~efDot~≒~efr~𝔢~eg~⪚~egs~⪖~egsdot~⪘~el~⪙~elinters~⏧~ell~ℓ~els~⪕~elsdot~⪗~emacr~ē~emptyset~∅~emptyv~∅~emsp13~ ~emsp14~ ~eng~ŋ~eogon~ę~eopf~𝕖~epar~⋕~eparsl~⧣~eplus~⩱~epsi~ε~epsiv~ϵ~eqcirc~≖~eqcolon~≕~eqsim~≂~eqslantgtr~⪖~eqslantless~⪕~equals~=~equest~≟~equivDD~⩸~eqvparsl~⧥~erDot~≓~erarr~⥱~escr~ℯ~esdot~≐~esim~≂~excl~!~expectation~ℰ~exponentiale~ⅇ~fallingdotseq~≒~fcy~ф~female~♀~ffilig~ﬃ~fflig~ﬀ~ffllig~ﬄ~ffr~𝔣~filig~ﬁ~fjlig~fj~flat~♭~fllig~ﬂ~fltns~▱~fopf~𝕗~fork~⋔~forkv~⫙~fpartint~⨍~frac13~⅓~frac15~⅕~frac16~⅙~frac18~⅛~frac23~⅔~frac25~⅖~frac35~⅗~frac38~⅜~frac45~⅘~frac56~⅚~frac58~⅝~frac78~⅞~frown~⌢~fscr~𝒻~gE~≧~gEl~⪌~gacute~ǵ~gammad~ϝ~gap~⪆~gbreve~ğ~gcirc~ĝ~gcy~г~gdot~ġ~gel~⋛~geq~≥~geqq~≧~geqslant~⩾~ges~⩾~gescc~⪩~gesdot~⪀~gesdoto~⪂~gesdotol~⪄~gesl~⋛︀~gesles~⪔~gfr~𝔤~gg~≫~ggg~⋙~gimel~ℷ~gjcy~ѓ~gl~≷~glE~⪒~gla~⪥~glj~⪤~gnE~≩~gnap~⪊~gnapprox~⪊~gne~⪈~gneq~⪈~gneqq~≩~gnsim~⋧~gopf~𝕘~grave~`~gscr~ℊ~gsim~≳~gsime~⪎~gsiml~⪐~gtcc~⪧~gtcir~⩺~gtdot~⋗~gtlPar~⦕~gtquest~⩼~gtrapprox~⪆~gtrarr~⥸~gtrdot~⋗~gtreqless~⋛~gtreqqless~⪌~gtrless~≷~gtrsim~≳~gvertneqq~≩︀~gvnE~≩︀~hairsp~ ~half~½~hamilt~ℋ~hardcy~ъ~harrcir~⥈~harrw~↭~hbar~ℏ~hcirc~ĥ~heartsuit~♥~hercon~⊹~hfr~𝔥~hksearow~⤥~hkswarow~⤦~hoarr~⇿~homtht~∻~hookleftarrow~↩~hookrightarrow~↪~hopf~𝕙~horbar~―~hscr~𝒽~hslash~ℏ~hstrok~ħ~hybull~⁃~hyphen~‐~ic~⁣~icy~и~iecy~е~iff~⇔~ifr~𝔦~ii~ⅈ~iiiint~⨌~iiint~∭~iinfin~⧜~iiota~℩~ijlig~ĳ~imacr~ī~imagline~ℐ~imagpart~ℑ~imath~ı~imof~⊷~imped~Ƶ~in~∈~incare~℅~infintie~⧝~inodot~ı~intcal~⊺~integers~ℤ~intercal~⊺~intlarhk~⨗~intprod~⨼~iocy~ё~iogon~į~iopf~𝕚~iprod~⨼~iscr~𝒾~isinE~⋹~isindot~⋵~isins~⋴~isinsv~⋳~isinv~∈~it~⁢~itilde~ĩ~iukcy~і~jcirc~ĵ~jcy~й~jfr~𝔧~jmath~ȷ~jopf~𝕛~jscr~𝒿~jsercy~ј~jukcy~є~kappav~ϰ~kcedil~ķ~kcy~к~kfr~𝔨~kgreen~ĸ~khcy~х~kjcy~ќ~kopf~𝕜~kscr~𝓀~lAarr~⇚~lAtail~⤛~lBarr~⤎~lE~≦~lEg~⪋~lHar~⥢~lacute~ĺ~laemptyv~⦴~lagran~ℒ~langd~⦑~langle~⟨~lap~⪅~larrb~⇤~larrbfs~⤟~larrfs~⤝~larrhk~↩~larrlp~↫~larrpl~⤹~larrsim~⥳~larrtl~↢~lat~⪫~latail~⤙~late~⪭~lates~⪭︀~lbarr~⤌~lbbrk~❲~lbrace~{~lbrack~[~lbrke~⦋~lbrksld~⦏~lbrkslu~⦍~lcaron~ľ~lcedil~ļ~lcub~{~lcy~л~ldca~⤶~ldquor~„~ldrdhar~⥧~ldrushar~⥋~ldsh~↲~leftarrow~←~leftarrowtail~↢~leftharpoondown~↽~leftharpoonup~↼~leftleftarrows~⇇~leftrightarrow~↔~leftrightarrows~⇆~leftrightharpoons~⇋~leftrightsquigarrow~↭~leftthreetimes~⋋~leg~⋚~leq~≤~leqq~≦~leqslant~⩽~les~⩽~lescc~⪨~lesdot~⩿~lesdoto~⪁~lesdotor~⪃~lesg~⋚︀~lesges~⪓~lessapprox~⪅~lessdot~⋖~lesseqgtr~⋚~lesseqqgtr~⪋~lessgtr~≶~lesssim~≲~lfisht~⥼~lfr~𝔩~lg~≶~lgE~⪑~lhard~↽~lharu~↼~lharul~⥪~lhblk~▄~ljcy~љ~ll~≪~llarr~⇇~llcorner~⌞~llhard~⥫~lltri~◺~lmidot~ŀ~lmoust~⎰~lmoustache~⎰~lnE~≨~lnap~⪉~lnapprox~⪉~lne~⪇~lneq~⪇~lneqq~≨~lnsim~⋦~loang~⟬~loarr~⇽~lobrk~⟦~longleftarrow~⟵~longleftrightarrow~⟷~longmapsto~⟼~longrightarrow~⟶~looparrowleft~↫~looparrowright~↬~lopar~⦅~lopf~𝕝~loplus~⨭~lotimes~⨴~lowbar~_~lozenge~◊~lozf~⧫~lpar~(~lparlt~⦓~lrarr~⇆~lrcorner~⌟~lrhar~⇋~lrhard~⥭~lrtri~⊿~lscr~𝓁~lsh~↰~lsim~≲~lsime~⪍~lsimg~⪏~lsqb~[~lsquor~‚~lstrok~ł~ltcc~⪦~ltcir~⩹~ltdot~⋖~lthree~⋋~ltimes~⋉~ltlarr~⥶~ltquest~⩻~ltrPar~⦖~ltri~◃~ltrie~⊴~ltrif~◂~lurdshar~⥊~luruhar~⥦~lvertneqq~≨︀~lvnE~≨︀~mDDot~∺~male~♂~malt~✠~maltese~✠~map~↦~mapsto~↦~mapstodown~↧~mapstoleft~↤~mapstoup~↥~marker~▮~mcomma~⨩~mcy~м~measuredangle~∡~mfr~𝔪~mho~℧~mid~∣~midast~*~midcir~⫰~minusb~⊟~minusd~∸~minusdu~⨪~mlcp~⫛~mldr~…~mnplus~∓~models~⊧~mopf~𝕞~mp~∓~mscr~𝓂~mstpos~∾~multimap~⊸~mumap~⊸~nGg~⋙̸~nGt~≫⃒~nGtv~≫̸~nLeftarrow~⇍~nLeftrightarrow~⇎~nLl~⋘̸~nLt~≪⃒~nLtv~≪̸~nRightarrow~⇏~nVDash~⊯~nVdash~⊮~nacute~ń~nang~∠⃒~nap~≉~napE~⩰̸~napid~≋̸~napos~ŉ~napprox~≉~natur~♮~natural~♮~naturals~ℕ~nbump~≎̸~nbumpe~≏̸~ncap~⩃~ncaron~ň~ncedil~ņ~ncong~≇~ncongdot~⩭̸~ncup~⩂~ncy~н~neArr~⇗~nearhk~⤤~nearr~↗~nearrow~↗~nedot~≐̸~nequiv~≢~nesear~⤨~nesim~≂̸~nexist~∄~nexists~∄~nfr~𝔫~ngE~≧̸~nge~≱~ngeq~≱~ngeqq~≧̸~ngeqslant~⩾̸~nges~⩾̸~ngsim~≵~ngt~≯~ngtr~≯~nhArr~⇎~nharr~↮~nhpar~⫲~nis~⋼~nisd~⋺~niv~∋~njcy~њ~nlArr~⇍~nlE~≦̸~nlarr~↚~nldr~‥~nle~≰~nleftarrow~↚~nleftrightarrow~↮~nleq~≰~nleqq~≦̸~nleqslant~⩽̸~nles~⩽̸~nless~≮~nlsim~≴~nlt~≮~nltri~⋪~nltrie~⋬~nmid~∤~nopf~𝕟~notinE~⋹̸~notindot~⋵̸~notinva~∉~notinvb~⋷~notinvc~⋶~notni~∌~notniva~∌~notnivb~⋾~notnivc~⋽~npar~∦~nparallel~∦~nparsl~⫽⃥~npart~∂̸~npolint~⨔~npr~⊀~nprcue~⋠~npre~⪯̸~nprec~⊀~npreceq~⪯̸~nrArr~⇏~nrarr~↛~nrarrc~⤳̸~nrarrw~↝̸~nrightarrow~↛~nrtri~⋫~nrtrie~⋭~nsc~⊁~nsccue~⋡~nsce~⪰̸~nscr~𝓃~nshortmid~∤~nshortparallel~∦~nsim~≁~nsime~≄~nsimeq~≄~nsmid~∤~nspar~∦~nsqsube~⋢~nsqsupe~⋣~nsubE~⫅̸~nsube~⊈~nsubset~⊂⃒~nsubseteq~⊈~nsubseteqq~⫅̸~nsucc~⊁~nsucceq~⪰̸~nsup~⊅~nsupE~⫆̸~nsupe~⊉~nsupset~⊃⃒~nsupseteq~⊉~nsupseteqq~⫆̸~ntgl~≹~ntlg~≸~ntriangleleft~⋪~ntrianglelefteq~⋬~ntriangleright~⋫~ntrianglerighteq~⋭~num~#~numero~№~numsp~ ~nvDash~⊭~nvHarr~⤄~nvap~≍⃒~nvdash~⊬~nvge~≥⃒~nvgt~>⃒~nvinfin~⧞~nvlArr~⤂~nvle~≤⃒~nvlt~<⃒~nvltrie~⊴⃒~nvrArr~⤃~nvrtrie~⊵⃒~nvsim~∼⃒~nwArr~⇖~nwarhk~⤣~nwarr~↖~nwarrow~↖~nwnear~⤧~oS~Ⓢ~oast~⊛~ocir~⊚~ocy~о~odash~⊝~odblac~ő~odiv~⨸~odot~⊙~odsold~⦼~ofcir~⦿~ofr~𝔬~ogon~˛~ogt~⧁~ohbar~⦵~ohm~Ω~oint~∮~olarr~↺~olcir~⦾~olcross~⦻~olt~⧀~omacr~ō~omid~⦶~ominus~⊖~oopf~𝕠~opar~⦷~operp~⦹~orarr~↻~ord~⩝~order~ℴ~orderof~ℴ~origof~⊶~oror~⩖~orslope~⩗~orv~⩛~oscr~ℴ~osol~⊘~otimesas~⨶~ovbar~⌽~par~∥~parallel~∥~parsim~⫳~parsl~⫽~pcy~п~percnt~%~period~.~pertenk~‱~pfr~𝔭~phiv~ϕ~phmmat~ℳ~phone~☎~pitchfork~⋔~planck~ℏ~planckh~ℎ~plankv~ℏ~plus~+~plusacir~⨣~plusb~⊞~pluscir~⨢~plusdo~∔~plusdu~⨥~pluse~⩲~plussim~⨦~plustwo~⨧~pm~±~pointint~⨕~popf~𝕡~pr~≺~prE~⪳~prap~⪷~prcue~≼~pre~⪯~prec~≺~precapprox~⪷~preccurlyeq~≼~preceq~⪯~precnapprox~⪹~precneqq~⪵~precnsim~⋨~precsim~≾~primes~ℙ~prnE~⪵~prnap~⪹~prnsim~⋨~profalar~⌮~profline~⌒~profsurf~⌓~propto~∝~prsim~≾~prurel~⊰~pscr~𝓅~puncsp~ ~qfr~𝔮~qint~⨌~qopf~𝕢~qprime~⁗~qscr~𝓆~quaternions~ℍ~quatint~⨖~quest~?~questeq~≟~rAarr~⇛~rAtail~⤜~rBarr~⤏~rHar~⥤~race~∽̱~racute~ŕ~raemptyv~⦳~rangd~⦒~range~⦥~rangle~⟩~rarrap~⥵~rarrb~⇥~rarrbfs~⤠~rarrc~⤳~rarrfs~⤞~rarrhk~↪~rarrlp~↬~rarrpl~⥅~rarrsim~⥴~rarrtl~↣~rarrw~↝~ratail~⤚~ratio~∶~rationals~ℚ~rbarr~⤍~rbbrk~❳~rbrace~}~rbrack~]~rbrke~⦌~rbrksld~⦎~rbrkslu~⦐~rcaron~ř~rcedil~ŗ~rcub~}~rcy~р~rdca~⤷~rdldhar~⥩~rdquor~”~rdsh~↳~realine~ℛ~realpart~ℜ~reals~ℝ~rect~▭~rfisht~⥽~rfr~𝔯~rhard~⇁~rharu~⇀~rharul~⥬~rhov~ϱ~rightarrow~→~rightarrowtail~↣~rightharpoondown~⇁~rightharpoonup~⇀~rightleftarrows~⇄~rightleftharpoons~⇌~rightrightarrows~⇉~rightsquigarrow~↝~rightthreetimes~⋌~ring~˚~risingdotseq~≓~rlarr~⇄~rlhar~⇌~rmoust~⎱~rmoustache~⎱~rnmid~⫮~roang~⟭~roarr~⇾~robrk~⟧~ropar~⦆~ropf~𝕣~roplus~⨮~rotimes~⨵~rpar~)~rpargt~⦔~rppolint~⨒~rrarr~⇉~rscr~𝓇~rsh~↱~rsqb~]~rsquor~’~rthree~⋌~rtimes~⋊~rtri~▹~rtrie~⊵~rtrif~▸~rtriltri~⧎~ruluhar~⥨~rx~℞~sacute~ś~sc~≻~scE~⪴~scap~⪸~sccue~≽~sce~⪰~scedil~ş~scirc~ŝ~scnE~⪶~scnap~⪺~scnsim~⋩~scpolint~⨓~scsim~≿~scy~с~sdotb~⊡~sdote~⩦~seArr~⇘~searhk~⤥~searr~↘~searrow~↘~semi~;~seswar~⤩~setminus~∖~setmn~∖~sext~✶~sfr~𝔰~sfrown~⌢~sharp~♯~shchcy~щ~shcy~ш~shortmid~∣~shortparallel~∥~sigmav~ς~simdot~⩪~sime~≃~simeq~≃~simg~⪞~simgE~⪠~siml~⪝~simlE~⪟~simne~≆~simplus~⨤~simrarr~⥲~slarr~←~smallsetminus~∖~smashp~⨳~smeparsl~⧤~smid~∣~smile~⌣~smt~⪪~smte~⪬~smtes~⪬︀~softcy~ь~sol~/~solb~⧄~solbar~⌿~sopf~𝕤~spadesuit~♠~spar~∥~sqcap~⊓~sqcaps~⊓︀~sqcup~⊔~sqcups~⊔︀~sqsub~⊏~sqsube~⊑~sqsubset~⊏~sqsubseteq~⊑~sqsup~⊐~sqsupe~⊒~sqsupset~⊐~sqsupseteq~⊒~squ~□~square~□~squarf~▪~squf~▪~srarr~→~sscr~𝓈~ssetmn~∖~ssmile~⌣~sstarf~⋆~star~☆~starf~★~straightepsilon~ϵ~straightphi~ϕ~strns~¯~subE~⫅~subdot~⪽~subedot~⫃~submult~⫁~subnE~⫋~subne~⊊~subplus~⪿~subrarr~⥹~subset~⊂~subseteq~⊆~subseteqq~⫅~subsetneq~⊊~subsetneqq~⫋~subsim~⫇~subsub~⫕~subsup~⫓~succ~≻~succapprox~⪸~succcurlyeq~≽~succeq~⪰~succnapprox~⪺~succneqq~⪶~succnsim~⋩~succsim~≿~sung~♪~supE~⫆~supdot~⪾~supdsub~⫘~supedot~⫄~suphsol~⟉~suphsub~⫗~suplarr~⥻~supmult~⫂~supnE~⫌~supne~⊋~supplus~⫀~supset~⊃~supseteq~⊇~supseteqq~⫆~supsetneq~⊋~supsetneqq~⫌~supsim~⫈~supsub~⫔~supsup~⫖~swArr~⇙~swarhk~⤦~swarr~↙~swarrow~↙~swnwar~⤪~target~⌖~tbrk~⎴~tcaron~ť~tcedil~ţ~tcy~т~tdot~⃛~telrec~⌕~tfr~𝔱~therefore~∴~thetav~ϑ~thickapprox~≈~thicksim~∼~thkap~≈~thksim~∼~timesb~⊠~timesbar~⨱~timesd~⨰~tint~∭~toea~⤨~top~⊤~topbot~⌶~topcir~⫱~topf~𝕥~topfork~⫚~tosa~⤩~tprime~‴~triangle~▵~triangledown~▿~triangleleft~◃~trianglelefteq~⊴~triangleq~≜~triangleright~▹~trianglerighteq~⊵~tridot~◬~trie~≜~triminus~⨺~triplus~⨹~trisb~⧍~tritime~⨻~trpezium~⏢~tscr~𝓉~tscy~ц~tshcy~ћ~tstrok~ŧ~twixt~≬~twoheadleftarrow~↞~twoheadrightarrow~↠~uHar~⥣~ubrcy~ў~ubreve~ŭ~ucy~у~udarr~⇅~udblac~ű~udhar~⥮~ufisht~⥾~ufr~𝔲~uharl~↿~uharr~↾~uhblk~▀~ulcorn~⌜~ulcorner~⌜~ulcrop~⌏~ultri~◸~umacr~ū~uogon~ų~uopf~𝕦~uparrow~↑~updownarrow~↕~upharpoonleft~↿~upharpoonright~↾~uplus~⊎~upsi~υ~upuparrows~⇈~urcorn~⌝~urcorner~⌝~urcrop~⌎~uring~ů~urtri~◹~uscr~𝓊~utdot~⋰~utilde~ũ~utri~▵~utrif~▴~uuarr~⇈~uwangle~⦧~vArr~⇕~vBar~⫨~vBarv~⫩~vDash~⊨~vangrt~⦜~varepsilon~ϵ~varkappa~ϰ~varnothing~∅~varphi~ϕ~varpi~ϖ~varpropto~∝~varr~↕~varrho~ϱ~varsigma~ς~varsubsetneq~⊊︀~varsubsetneqq~⫋︀~varsupsetneq~⊋︀~varsupsetneqq~⫌︀~vartheta~ϑ~vartriangleleft~⊲~vartriangleright~⊳~vcy~в~vdash~⊢~vee~∨~veebar~⊻~veeeq~≚~vellip~⋮~verbar~|~vert~|~vfr~𝔳~vltri~⊲~vnsub~⊂⃒~vnsup~⊃⃒~vopf~𝕧~vprop~∝~vrtri~⊳~vscr~𝓋~vsubnE~⫋︀~vsubne~⊊︀~vsupnE~⫌︀~vsupne~⊋︀~vzigzag~⦚~wcirc~ŵ~wedbar~⩟~wedge~∧~wedgeq~≙~wfr~𝔴~wopf~𝕨~wp~℘~wr~≀~wreath~≀~wscr~𝓌~xcap~⋂~xcirc~◯~xcup~⋃~xdtri~▽~xfr~𝔵~xhArr~⟺~xharr~⟷~xlArr~⟸~xlarr~⟵~xmap~⟼~xnis~⋻~xodot~⨀~xopf~𝕩~xoplus~⨁~xotime~⨂~xrArr~⟹~xrarr~⟶~xscr~𝓍~xsqcup~⨆~xuplus~⨄~xutri~△~xvee~⋁~xwedge~⋀~yacy~я~ycirc~ŷ~ycy~ы~yfr~𝔶~yicy~ї~yopf~𝕪~yscr~𝓎~yucy~ю~zacute~ź~zcaron~ž~zcy~з~zdot~ż~zeetrf~ℨ~zfr~𝔷~zhcy~ж~zigrarr~⇝~zopf~𝕫~zscr~𝓏~~AMP~&~COPY~©~GT~>~LT~<~QUOT~\"~REG~®", namedReferences['html4']);

var numericUnicodeMap = {
    0: 65533,
    128: 8364,
    130: 8218,
    131: 402,
    132: 8222,
    133: 8230,
    134: 8224,
    135: 8225,
    136: 710,
    137: 8240,
    138: 352,
    139: 8249,
    140: 338,
    142: 381,
    145: 8216,
    146: 8217,
    147: 8220,
    148: 8221,
    149: 8226,
    150: 8211,
    151: 8212,
    152: 732,
    153: 8482,
    154: 353,
    155: 8250,
    156: 339,
    158: 382,
    159: 376
};

var fromCodePoint = String.fromCodePoint ||
    function (astralCodePoint) {
        return String.fromCharCode(Math.floor((astralCodePoint - 0x10000) / 0x400) + 0xd800, ((astralCodePoint - 0x10000) % 0x400) + 0xdc00);
    };

var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var allNamedReferences = __assign(__assign({}, namedReferences), { all: namedReferences.html5 });
var defaultDecodeOptions = {
    scope: 'body',
    level: 'all'
};
var strict = /&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);/g;
var attribute = /&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+)[;=]?/g;
var baseDecodeRegExps = {
    xml: {
        strict: strict,
        attribute: attribute,
        body: bodyRegExps.xml
    },
    html4: {
        strict: strict,
        attribute: attribute,
        body: bodyRegExps.html4
    },
    html5: {
        strict: strict,
        attribute: attribute,
        body: bodyRegExps.html5
    }
};
var decodeRegExps = __assign(__assign({}, baseDecodeRegExps), { all: baseDecodeRegExps.html5 });
var fromCharCode = String.fromCharCode;
var outOfBoundsChar = fromCharCode(65533);
function getDecodedEntity(entity, references, isAttribute, isStrict) {
    var decodeResult = entity;
    var decodeEntityLastChar = entity[entity.length - 1];
    if (isAttribute && decodeEntityLastChar === '=') {
        decodeResult = entity;
    }
    else if (isStrict && decodeEntityLastChar !== ';') {
        decodeResult = entity;
    }
    else {
        var decodeResultByReference = references[entity];
        if (decodeResultByReference) {
            decodeResult = decodeResultByReference;
        }
        else if (entity[0] === '&' && entity[1] === '#') {
            var decodeSecondChar = entity[2];
            var decodeCode = decodeSecondChar == 'x' || decodeSecondChar == 'X'
                ? parseInt(entity.substr(3), 16)
                : parseInt(entity.substr(2));
            decodeResult =
                decodeCode >= 0x10ffff
                    ? outOfBoundsChar
                    : decodeCode > 65535
                        ? fromCodePoint(decodeCode)
                        : fromCharCode(numericUnicodeMap[decodeCode] || decodeCode);
        }
    }
    return decodeResult;
}
/** Decodes all entities in the text */
function decode(text, _a) {
    var _b = defaultDecodeOptions , _c = _b.level, level = _c === void 0 ? 'all' : _c, _d = _b.scope, scope = _d === void 0 ? level === 'xml' ? 'strict' : 'body' : _d;
    if (!text) {
        return '';
    }
    var decodeRegExp = decodeRegExps[level][scope];
    var references = allNamedReferences[level].entities;
    var isAttribute = scope === 'attribute';
    var isStrict = scope === 'strict';
    return text.replace(decodeRegExp, function (entity) { return getDecodedEntity(entity, references, isAttribute, isStrict); });
}

const getOptimizedImageUrl=(t,r={})=>{if(!t)return "";let e=new URL(t.startsWith("//")?`https:${t}`:t);return r.width&&e.searchParams.set("width",r.width),r.height&&e.searchParams.set("height",r.height),r.crop&&e.searchParams.set("crop",r.crop),r.format&&e.searchParams.set("format",r.format),r.pad_color&&e.searchParams.set("pad_color",r.pad_color),"region"===r.crop&&(r.crop_left&&e.searchParams.set("crop_left",r.crop_left),r.crop_top&&e.searchParams.set("crop_top",r.crop_top),r.crop_width&&e.searchParams.set("crop_width",r.crop_width),r.crop_height&&e.searchParams.set("crop_height",r.crop_height)),e.toString()};const getOptimizedImageSrcset=(t,r)=>{let e=t.startsWith("//")?`https:${t}`:t,a=new URL(e),s=a.searchParams.get("v");a.search="",s&&a.searchParams.set("v",s);let c=(e=a.toString().replace(/_\d+x\d+(?=\.\w+)/,"")).includes("?")?"&":"?";return r.map(t=>`${e}${c}width=${t} ${t}w`).join(", ")};

function d$7({item:d,fmt:l}){let s,[c,g]=reactExports.useState(false),{addGiftboxToItem:p,removeGiftboxFromItem:f}=useMinicart();if(!window.giftBoxesEnabled||d.properties?._gift_set||d.gift_card||["gift-bag","gift-box","digital-gift-card","physical-gift-card"].includes(d.handle))return null;let x=d.gift_box&&d.gift_box?.available,m=d.properties._gift_box_variant_id,b=d.gift_box?.name.split(" - ")[0]||"";async function u(){g(true),m?await f(d,d.properties._gift_box_variant_id):await p(d,d.gift_box.id,d.gift_box.title),g(false);}return x?(s="p-[6px] pr-space8 flex items-center gap-space12 rounded-[5px] w-full text-primary !mt-space8 border",s=m?`${s} bg-softBlue border-softBlue`:`${s} border-geyser`):s="px-space16 py-[7px] border border-[#008CD3] rounded-[5px] w-full text-center text-14 leading-22 text-primary !mt-space8",jsxRuntimeExports.jsx("div",{className:s,children:x?jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment,{children:[jsxRuntimeExports.jsx("div",{className:"rounded w-[32px] h-[32px]",children:d.gift_box.featured_image?.src&&jsxRuntimeExports.jsx("img",{src:getOptimizedImageUrl(d.gift_box.featured_image.src,{width:32,height:32}),srcSet:getOptimizedImageSrcset(d.gift_box.featured_image.src,[32,64]),sizes:"32px",alt:d.gift_box.name,className:"block w-full h-full object-cover rounded-[5px]"})}),jsxRuntimeExports.jsx("span",{className:"grow text-14 leading-22",children:b}),jsxRuntimeExports.jsx("button",{className:`${!c&&"underline"} hover:no-underline text-14 leading-22 px-space8 py-[5px]`,inert:c,onClick:u,children:m?c?"Removing":"Remove":c?"Adding":"Add"}),jsxRuntimeExports.jsx("span",{className:"font-bold leading-6 text-right",children:l(d.gift_box.price)})]}):"Add gift bags below to wrap your entire order"})}

const s$4 = (({item:m})=>{let{updateQty:x,closeCart:f,showTieredPromos:u}=useMinicart(),h=!!(m?.properties&&m?.properties?._faux_embroidery),y=!!(m?.properties?.["Embroidery Text"]&&m?.properties?.["Embroidery Style"]&&m?.properties?.["Embroidery Color"]);m.price;let w=m.compare_at_price,b=m.line_price,N=null!=w?w*m.quantity:null,g=N>b,v=window.Shopify?.country||"US",C=!m?.properties?._regios_auto_add_to_cart_node_id,k=e=>{let r="GB"===v?"£":"$",t=(e=>{switch(e){case "GB":return "GBP";case "CA":return "CAD";default:return ""}})(v),i=(e/100).toFixed(2).replace(".00","");return `${r}${i}${t?` ${t}`:""}`},E=decode(m.title),S=E.includes(" - ")?E.split(" - ")[0]:E,_=m.options_with_values||[],$=_.find(e=>e?.name&&"string"==typeof e.name&&"color"===e.name.toLowerCase()),j=_.find(e=>e?.name&&"string"==typeof e.name&&"size"===e.name.toLowerCase()),R=_.find(e=>e?.name&&"string"==typeof e.name&&"style"===e.name.toLowerCase());m.properties&&m.properties["Embroidery Text"];let B=getMultiRowLines(m.properties).join(" / "),q="string"==typeof m.properties?.["Embroidery Style"]?m.properties["Embroidery Style"]:"",L="string"==typeof q&&q.toLowerCase().includes("ponce")?"Ponce":q,T=y?`/products/${m.handle}?embvariant=${m.id}&personalized=${encodeURIComponent(m.properties["Embroidery Text"]||"")}&font=${encodeURIComponent(L)}&color=${encodeURIComponent(m.properties["Embroidery Color"]||"")}&type=all`:`/products/${m.handle}?variant=${m.id}`;return jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment,{children:[jsxRuntimeExports.jsxs("div",{className:"&:not(:first-child)]:border-t pt-6 flex items-start space-x-4",children:[jsxRuntimeExports.jsx("div",{className:"flex-shrink-0 flex flex-col",children:jsxRuntimeExports.jsx("div",{className:"relative litem__img w-[120px] h-[120px] md:w-[150px] md:h-[150px] md:basis-[150px] rounded-md overflow-hidden flex-none",children:jsxRuntimeExports.jsxs("a",{href:T,onClick:f,className:"isolate block",children:[jsxRuntimeExports.jsx("img",{src:getOptimizedImageUrl(m.image,{width:150}),srcSet:getOptimizedImageSrcset(m.image,[150,300]),sizes:"150px",alt:m.title,className:"block w-full h-full object-cover rounded"}),y&&!h&&jsxRuntimeExports.jsx(l$5,{properties:m.properties})]})})}),jsxRuntimeExports.jsxs("div",{className:"flex flex-1 flex-col pr-space12",children:[jsxRuntimeExports.jsxs("div",{className:"flex-1 flex flex-row justify-between min-w-0 items-center",children:[jsxRuntimeExports.jsx("p",{className:"box-border antialiased pt-0 px-2 leading-none",children:jsxRuntimeExports.jsx("a",{href:T,onClick:f,className:"inline cursor-pointer box-border text-[16px] font-normal tracking-normal text-primary no-underline transition-colors duration-200 ease-in-out antialiased hover:text-royalBlue [font-feature-settings:'liga'] font-apercu",children:S})}),g?jsxRuntimeExports.jsxs("div",{className:`inline-flex items-center text-right ${"US"!==v?"flex-col min-w-[70px]":""}`,children:[jsxRuntimeExports.jsx("span",{className:"text-primary line-through",children:k(N)}),jsxRuntimeExports.jsx("span",{className:"font-apercuBold text-primary ml-[4px]",children:k(b)})]}):jsxRuntimeExports.jsx("span",{className:`font-apercuBold text-primary text-right ${"US"!==v?"min-w-[70px]":""}`,children:k(b)})]}),jsxRuntimeExports.jsxs("div",{className:"flex-1 flex min-w-0 flex-col",children:[jsxRuntimeExports.jsxs("div",{className:"flex w-full gap-space16 items-start justify-between",children:[($||j||R)&&jsxRuntimeExports.jsxs("div",{className:"p-2 flex flex-wrap rounded-[5px]",children:[$&&jsxRuntimeExports.jsxs("p",{className:"text-fiord font-apercu flex flex-row items-center gap-[4px] mr-[10px]",children:[jsxRuntimeExports.jsx("span",{className:"text-fiord font-apercu text-lg",children:"Color"}),jsxRuntimeExports.jsx("span",{className:"font-apercu text-lg text-primary",children:$.value})]}),j&&jsxRuntimeExports.jsxs("p",{className:"text-fiord font-apercu flex flex-row items-center gap-[4px] mr-[10px]",children:[jsxRuntimeExports.jsx("span",{className:"text-fiord font-apercu text-lg",children:"Size"}),jsxRuntimeExports.jsx("span",{className:"font-apercu text-lg text-primary",children:j.value})]}),R&&jsxRuntimeExports.jsxs("p",{className:"text-fiord font-apercu flex flex-row items-center gap-[4px]",children:[jsxRuntimeExports.jsx("span",{className:"text-fiord font-apercu text-lg",children:"Style"}),jsxRuntimeExports.jsx("span",{className:"font-apercu text-lg text-primary",children:R.value})]})]}),jsxRuntimeExports.jsx("div",{className:"shrink-0",children:m.discounts.map(t=>jsxRuntimeExports.jsxs("div",{className:"flex justify-end items-center gap-[4px] text-[12px] leading-none py-2",children:[jsxRuntimeExports.jsx(DiscountIcon,{elClass:"w-[8px]"}),t.title]}))})]}),(m.properties?.["Embroidery Text"]!=="Icon"||m.properties?.["Embroidery Color"]||m.properties?.["Embroidery Style"]||m.properties?.["Recipient email"]||m.properties?.["Recipient name"]||m.properties?.Message||m.properties?.["Send on"])&&jsxRuntimeExports.jsx("div",{className:"p-2 pt-0 pr-0 min-w-0 flex-1",children:jsxRuntimeExports.jsxs("div",{className:"w-full flex flex-row flex-wrap whitespace-normal break-words m-0 p-2.5 rounded-[5px] text-12 font-normal not-italic text-primary bg-sand",children:[m.properties["Embroidery Text"]&&"Icon"!==m.properties["Embroidery Text"]&&jsxRuntimeExports.jsxs("p",{className:"mr-[10px]",children:[jsxRuntimeExports.jsx("span",{style:{color:"#435c70"},children:"Personalized"})," “",B,"”;"]}),m.properties["Embroidery Color"]&&jsxRuntimeExports.jsxs("p",{className:"mr-[10px]",children:[jsxRuntimeExports.jsx("span",{style:{color:"#435c70"},children:"Color"})," ",m.properties["Embroidery Color"],";"]}),m.properties["Embroidery Applique Background"]&&jsxRuntimeExports.jsxs("p",{className:"mr-[10px]",children:[jsxRuntimeExports.jsx("span",{style:{color:"#435c70"},children:"Applique"})," ",m.properties["Embroidery Applique Background"],";"]}),m.properties["Embroidery Style"]&&jsxRuntimeExports.jsxs("p",{children:[jsxRuntimeExports.jsx("span",{style:{color:"#435c70"},children:"Font"})," ",TWO_TONE_FONT_PREFIXES.find(e=>m.properties["Embroidery Style"]?.startsWith(e))?.trim()||m.properties["Embroidery Style"],";"]}),m.properties["Recipient email"]&&jsxRuntimeExports.jsxs("p",{className:"w-full break-all",children:[jsxRuntimeExports.jsx("span",{style:{color:"#435c70"},children:"Email:"})," ",m.properties["Recipient email"]]}),m.properties["Recipient name"]&&jsxRuntimeExports.jsxs("p",{className:"w-full",children:[jsxRuntimeExports.jsx("span",{style:{color:"#435c70"},children:"Name:"})," ",m.properties["Recipient name"]]}),m.properties.Message&&jsxRuntimeExports.jsxs("p",{className:"w-full",children:[jsxRuntimeExports.jsx("span",{style:{color:"#435c70"},children:"Message:"})," ",m.properties.Message]}),m.properties["Send on"]&&jsxRuntimeExports.jsxs("p",{className:"w-full",children:[jsxRuntimeExports.jsx("span",{style:{color:"#435c70"},children:"Send on:"})," ",m.properties["Send on"]]})]})})]}),C?jsxRuntimeExports.jsxs("div",{className:"flex-1 min-w-0 flex items-center justify-between",children:[jsxRuntimeExports.jsxs("div",{className:"mt-2 px-2 mx-2 inline-flex items-center border border-geyser gap-2 text-2xl rounded-md font-medium",children:[jsxRuntimeExports.jsx("button",{onClick:()=>x(m,m.quantity-1),className:"w-6 h-6 flex items-center justify-center focus:outline-none",children:"−"}),jsxRuntimeExports.jsx("span",{children:m.quantity}),jsxRuntimeExports.jsx("button",{onClick:()=>x(m,m.quantity+1),className:"w-6 h-6 flex items-center justify-center focus:outline-none",children:"+"})]}),jsxRuntimeExports.jsx("button",{onClick:()=>x(m,0),"aria-label":"Remove item",className:"w-[25px] h-[25px] flex items-center justify-center rounded-full border border-black text-primary hover:bg-primary hover:text-white transition-colors duration-150",children:jsxRuntimeExports.jsx("svg",{xmlns:"http://www.w3.org/2000/svg",className:"p-1 w-full h-full",fill:"none",viewBox:"0 0 24 24",stroke:"currentColor",strokeWidth:2,children:jsxRuntimeExports.jsx("path",{strokeLinecap:"round",strokeLinejoin:"round",d:"M6 18L18 6M6 6l12 12"})})})]}):jsxRuntimeExports.jsx("div",{className:"!block"})]})]}),!m.gift_card&&m.properties.Backorder&&jsxRuntimeExports.jsx("div",{className:"flex text-left p-4 !mt-[10px]",children:jsxRuntimeExports.jsx("p",{className:"text-12 text-customRed",children:m.properties.Backorder})}),jsxRuntimeExports.jsx(d$7,{item:m,fmt:k})]})});

const a$6 = (()=>{let{bannerData:i,cart:n}=useMinicart(),r=n.items_subtotal_price??n.total_price,m=reactExports.useMemo(()=>i?.countdown_1?new Date(i.countdown_1):null,[i?.countdown_1]),[o,p]=reactExports.useState({days:0,hours:0,minutes:0,seconds:0}),[x,h]=reactExports.useState(-1),[u,v]=reactExports.useState(false);reactExports.useEffect(()=>{if(!m)return;let e=setInterval(()=>{let l=m-new Date;if(l>0){let e=Math.floor(l/864e5),t=Math.floor(l%864e5/36e5);p({days:e,hours:t,minutes:Math.floor(l%36e5/6e4),seconds:Math.floor(l%6e4/1e3)});}else p({days:0,hours:0,minutes:0,seconds:0}),v(true),clearInterval(e);},1e3);return ()=>clearInterval(e)},[m]);let f=[{label:i?.percent_off_1,value:100*Number(i?.spend_amt_1)},{label:i?.percent_off_2,value:100*Number(i?.spend_amt_2)},{label:i?.percent_off_3,value:100*Number(i?.spend_amt_3)}],N=0;r>=f[2].value?N=100:r>=f[1].value?N=50+(r-f[1].value)/(f[2].value-f[1].value)*50:r>=f[0].value&&(N=(r-f[0].value)/(f[1].value-f[0].value)*50),reactExports.useEffect(()=>{r>=f[2].value?h(2):r>=f[1].value?h(1):r>=f[0].value?h(0):h(-1);},[r]);let _=i?.discount_description?.split("*");return i?.display_banner_in_minicart!==true?null:jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment,{children:[i?.buy_more_banner&&window.Shopify?.country!="CA"&&jsxRuntimeExports.jsx("div",{className:"bg-regen px-[10px] font-apercu",children:jsxRuntimeExports.jsxs("div",{className:"py-[20px] px-[10px] md:px-[60px]",children:[jsxRuntimeExports.jsx("p",{className:"text-center font-apercuBold m-0 text-16 md:text-18 mb-[10px]",children:i?.headline_1}),jsxRuntimeExports.jsx("div",{className:"text-center text-14 md:text-16 mb-[10px] md:mb-[5px]",children:jsxRuntimeExports.jsxs("div",{children:[jsxRuntimeExports.jsx("div",{className:"flex justify-between",children:f.map(l=>jsxRuntimeExports.jsx("span",{className:"font-apercuBold m-0",children:l.label}))}),jsxRuntimeExports.jsx("div",{className:"text-center w-full rounded-[8px]",children:jsxRuntimeExports.jsxs("div",{className:"relative flex justify-between items-center",children:[jsxRuntimeExports.jsx("span",{className:"absolute top-[47%] left-0 right-0 h-[2px] bg-royalBlue z-[1] w-full"}),jsxRuntimeExports.jsx("span",{className:"absolute top-[44%] left-0 right-0 h-[4px] bg-royalBlue z-[1]",style:{width:`${N}%`}}),f.map((l,t)=>jsxRuntimeExports.jsx("div",{className:`flex-1 flex flex-col text-center relative first:items-start first:left-[-1px] last:items-end last:left-[1px]${0==t?"items-start":""} ${1==t?"items-center":""} ${2==t?"items-end":""}`,children:jsxRuntimeExports.jsx("div",{className:`w-[30px] h-[30px] border-[2px] border-royalBlue rounded-full !flex items-center justify-center text-white z-[3] ${t<=x?"bg-royalBlue":"bg-regen"}`,children:t<=x&&jsxRuntimeExports.jsx("span",{className:"text-14",children:jsxRuntimeExports.jsx("svg",{xmlns:"http://www.w3.org/2000/svg",width:"10.713",height:"8.036",viewBox:"0 0 10.713 8.036",children:jsxRuntimeExports.jsx("g",{id:"check",transform:"translate(-9.514 -11.635)",children:jsxRuntimeExports.jsx("path",{id:"Path_16",d:"M13.532,16.992l-2.679-2.678L9.514,15.653l4.018,4.018,6.695-6.7-1.338-1.34-5.357,5.357Z",fill:"#fff"})})})})})},t))]})}),jsxRuntimeExports.jsx("div",{className:"flex justify-between mt-5",children:f.map(e=>jsxRuntimeExports.jsxs("span",{className:"font-apercu text-18",children:["$",e.value/100,"+"]}))})]})})]})}),i?.birthday_sale_banner&&window.Shopify?.country!="CA"&&jsxRuntimeExports.jsx("div",{className:"bg-regen px-[10px] font-apercu",children:jsxRuntimeExports.jsxs("div",{className:"py-[20px] px-[10px] md:px-[60px]",children:[jsxRuntimeExports.jsx("p",{className:"text-center font-apercuBold m-0 text-16 md:text-18 mb-[10px]",children:i?.headline_1}),i?.discount_code&&i?.discount_code.trim()!==""&&jsxRuntimeExports.jsx("div",{className:"text-center text-14 md:text-16 mb-[10px] md:mb-[5px]",children:jsxRuntimeExports.jsxs("div",{class:"block font-apercuBold text-16 text-black",children:["Use code ",jsxRuntimeExports.jsx("span",{children:i?.discount_code})," at checkout"]})}),m&&(u?jsxRuntimeExports.jsx("div",{className:"flex justify-center gap-[5px] text-12",children:jsxRuntimeExports.jsxs("div",{className:"ml-[5px]",children:[" ",i?.post_countdown_message]})}):jsxRuntimeExports.jsxs("div",{className:"flex justify-center gap-[5px] text-12",children:[jsxRuntimeExports.jsxs("div",{className:"flex",children:[jsxRuntimeExports.jsx("div",{className:"font-apercuBold",children:o.days}),jsxRuntimeExports.jsx("div",{className:"ml-[5px]",children:"days"})]}),jsxRuntimeExports.jsxs("div",{className:"flex",children:[jsxRuntimeExports.jsx("div",{className:"font-apercuBold",children:o.hours}),jsxRuntimeExports.jsx("div",{className:"ml-[5px]",children:"hours"})]}),jsxRuntimeExports.jsxs("div",{className:"flex",children:[jsxRuntimeExports.jsx("div",{className:"font-apercuBold",children:o.minutes}),jsxRuntimeExports.jsx("div",{className:"ml-[5px]",children:"mins"})]}),jsxRuntimeExports.jsxs("div",{className:"flex",children:[jsxRuntimeExports.jsx("div",{className:"font-apercuBold",children:o.seconds}),jsxRuntimeExports.jsx("div",{className:"ml-[5px]",children:"secs"})]})]}))]})}),i?.embroidery_sale_banner&&window.Shopify?.country!="CA"&&jsxRuntimeExports.jsx("div",{className:"bg-regen px-[10px] font-apercu",children:jsxRuntimeExports.jsxs("div",{className:"py-[20px] px-[10px] md:px-[60px]",children:[jsxRuntimeExports.jsx("p",{className:"text-center font-apercuBold m-0 text-16 md:text-18 mb-[10px]",children:i?.headline_1}),jsxRuntimeExports.jsxs("div",{className:"text-center text-14 md:text-16 mb-[10px] md:mb-[5px]",children:[_?.map((l,t)=>jsxRuntimeExports.jsx("p",{children:l.trim()},t)),jsxRuntimeExports.jsx("div",{class:"block font-apercuBold text-16 text-black",children:i?.text_block})]}),m&&(u?jsxRuntimeExports.jsx("div",{className:"flex justify-center gap-[5px] text-12",children:jsxRuntimeExports.jsxs("div",{className:"ml-[5px]",children:[" ",i?.post_countdown_message]})}):jsxRuntimeExports.jsxs("div",{className:"flex justify-center gap-[5px] text-12",children:[jsxRuntimeExports.jsxs("div",{className:"flex",children:[jsxRuntimeExports.jsx("div",{className:"font-apercuBold",children:o.days}),jsxRuntimeExports.jsx("div",{className:"ml-[5px]",children:"days"})]}),jsxRuntimeExports.jsxs("div",{className:"flex",children:[jsxRuntimeExports.jsx("div",{className:"font-apercuBold",children:o.hours}),jsxRuntimeExports.jsx("div",{className:"ml-[5px]",children:"hours"})]}),jsxRuntimeExports.jsxs("div",{className:"flex",children:[jsxRuntimeExports.jsx("div",{className:"font-apercuBold",children:o.minutes}),jsxRuntimeExports.jsx("div",{className:"ml-[5px]",children:"mins"})]}),jsxRuntimeExports.jsxs("div",{className:"flex",children:[jsxRuntimeExports.jsx("div",{className:"font-apercuBold",children:o.seconds}),jsxRuntimeExports.jsx("div",{className:"ml-[5px]",children:"secs"})]})]}))]})}),i?.mothers_day_banner&&window.Shopify?.country!="CA"&&jsxRuntimeExports.jsx("div",{className:"bg-regen px-[10px] font-apercu",children:jsxRuntimeExports.jsxs("div",{className:"py-[20px] px-[10px] md:px-[60px] text-center",children:[jsxRuntimeExports.jsx("p",{className:"text-center font-apercuBold m-0 text-16 md:text-18 mb-[10px]",children:i?.headline_1}),jsxRuntimeExports.jsx("div",{className:"text-center text-14 md:text-16 mb-[10px] md:mb-[5px]",children:jsxRuntimeExports.jsxs("div",{className:"banner__wrapper",children:[jsxRuntimeExports.jsxs("div",{class:"discount-block",children:[jsxRuntimeExports.jsx("div",{class:"discount-value",children:i?.delivery_date_1}),jsxRuntimeExports.jsx("div",{class:"block font-apercuBold text-16 text-black",children:i?.delivery_type_1})]}),jsxRuntimeExports.jsxs("div",{class:"discount-block",children:[jsxRuntimeExports.jsx("div",{class:"discount-value",children:i?.delivery_date_2}),jsxRuntimeExports.jsx("div",{class:"block font-apercuBold text-16 text-black",children:i?.delivery_type_2})]}),jsxRuntimeExports.jsxs("div",{class:"discount-block",children:[jsxRuntimeExports.jsx("div",{class:"discount-value",children:i?.delivery_date_3}),jsxRuntimeExports.jsx("div",{class:"block font-apercuBold text-16 text-black",children:i?.delivery_type_3})]})]})}),jsxRuntimeExports.jsx("div",{className:" minicart__banner__wrapper",children:i?.fineprint_1})]})})]})});

const o$8 = (()=>{let{subtotalCents:a,origSubtotalCents:n,itemCount:r,isLoading:s,cartUpdatesInProgress:c,showFreeShippingBadge:o}=useMinicart(),d=window.Shopify?.country||"US";return r>0&&!s&&jsxRuntimeExports.jsxs("div",{className:"py-5 flex flex-col items-center mx-auto w-full",children:[jsxRuntimeExports.jsxs("div",{className:"flex justify-between w-full mb-4",children:[jsxRuntimeExports.jsx("span",{className:"font-bold",children:"Subtotal"}),jsxRuntimeExports.jsxs("div",{className:"text-right",children:[n>a&&jsxRuntimeExports.jsxs("span",{className:"pr-space8 line-through",children:["GB"===d?"£":"$",(n/100).toFixed(2).replace(".00","")]}),jsxRuntimeExports.jsxs("span",{className:"font-semibold",children:["GB"===d?"£":"$",(a/100).toFixed(2).replace(".00",""),"CA"===d&&" CAD","GB"===d&&" GBP"]})]})]}),o&&jsxRuntimeExports.jsxs("div",{className:"flex w-full justify-end items-center gap-[4px] text-[12px] leading-none mb-space16",children:[jsxRuntimeExports.jsx(DiscountIcon,{elClass:"w-[8px]"}),"Free Shipping"]}),jsxRuntimeExports.jsx("a",{href:"/checkout",className:`w-full inline-flex items-center justify-center h-[52px] md:h-[52px] rounded-lg text-16 font-normal hover:bg-royalBlue ${r>0?"bg-primary text-white":"bg-geyser text-fiord pointer-events-none"}`,id:"checkoutBtn","aria-disabled":`${c}`,inert:c,children:"Checkout"}),jsxRuntimeExports.jsx("p",{className:"mt-4 text-12 text-[#04344E] text-center px-4 md:px-0",children:"Final Tax and Shipping calculated at checkout"})]})});

let e$3 = class e{debounce(e,t,o=this){let a=null,i=null,n=()=>e.apply(o,i);return function(...e){i=e,clearTimeout(a),a=setTimeout(n,t);}}checkSafariMobile(){Modernizr.addTest("mobilesafari",()=>/iP(ad|hone|od).+Version\/[\d\.]+.*Safari/i.test(navigator.userAgent)),this.isSafariMobile=Modernizr.mobilesafari;}checkTouch(){Modernizr.touchevents?this.hasTouch=true:this.hasTouch=false;}checkBrowser(){Modernizr.addTest("ie",()=>/MSIE 10/i.test(navigator.userAgent)||/MSIE 9/i.test(navigator.userAgent)||/rv:11.0/i.test(navigator.userAgent)),this.isIe=Modernizr.ie,this.isIe&&document.documentElement.classList.add("ie");}formatMoney(e,t="${{amount_no_trailing_decimals}}"){"string"==typeof e&&(e=e.replace(".","")),e=parseInt(e,10);let o="",a=/\{\{\s*(\w+)\s*\}\}/;function i(e,t=2,o,a){if(o=o||",",a=a||".",Number.isNaN(e)||null==e)return 0;let n=(e=(e/100).toFixed(t)).split(".");return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+o)+(n[1]?a+n[1]:"")}switch(t.match(a)[1]){case "amount":default:o=i(e,2);break;case "amount_full":o=i(e,3);break;case "amount_no_currency":o=i(e,2).replace("$","");break;case "amount_no_trailing_decimals":o=i(e,2).replace(/^([\d,]+)$|^([\d,]+)\.0*$|^([\d,]+\.[0-9]*?)0*$/,"$1$2$3");break;case "amount_no_decimals":o=i(e,0);break;case "amount_with_comma_separator":o=i(e,2,".",",");break;case "amount_no_decimals_with_comma_separator":o=i(e,0,".",",");break;case "amount_no_decimals_with_space_separator":o=i(e,0," ");}return t.replace(a,o)}isScrolledIntoView(e,{offsetTop:t=0}){let o=window.pageYOffset+window.innerHeight;return e.offsetTop+t<=o}static getSiblings(e){return Array.prototype.filter.call(e.parentNode.children,t=>t!==e)}getParents(e,t){let o=[];for(;e=e.parentElement;)e.matches(t)&&o.push(e);return o}getCookie(e){if(document.cookie.length>0){let t=document.cookie.indexOf(e+"=");if(-1!=t){t=t+e.length+1;let o=document.cookie.indexOf(";",t);return -1==o&&(o=document.cookie.length),unescape(document.cookie.substring(t,o))}}return ""}setShortCookie(e,t,o){document.cookie=encodeURI(e)+"="+encodeURI(t)+"; max-age="+o;}createCookie(e,t,o){var a;if(o){var i=new Date;i.setTime(i.getTime()+24*o*36e5),a="; expires="+i.toGMTString();}else a="";document.cookie=e+"="+t+a+"; path=/";}deleteCookie(e){document.cookie=e+"=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";}constructor(){(/Win/i.test(navigator.platform||"")||/Windows/i.test(navigator.userAgent||""))&&document.documentElement.classList.add("windows");}};new e$3;

let r$2=e=>{e.preventDefault();};function o$7({checked:o,onChange:i=r$2,onClick:s=null,size:n=20,className:c="",name:a=""}){return jsxRuntimeExports.jsxs("div",{className:`border border-[#003550] rounded-[2px] shrink-0 p-[1px] flex items-center justify-center relative ${c}`,style:{width:`${n-4}px`,height:`${n-4}px`,backgroundColor:o?"#003550":"white"},children:[o&&jsxRuntimeExports.jsx(CheckmarkIcon,{elClass:"text-white w-full h-full"}),jsxRuntimeExports.jsx("input",{name:a,type:"checkbox",checked:o,onChange:i,onClick:s,className:"cursor-pointer absolute t-0 l-0 !w-full !h-full !m-0 block opacity-0"})]})}

function f$1(){let[r,a]=reactExports.useState(false);return jsxRuntimeExports.jsxs("div",{className:"border-t border-t-geyser bg-white !mt-space24",children:[jsxRuntimeExports.jsxs("button",{"aria-expanded":`${r}`,"aria-controls":"giftOptionsPanel",id:"giftOptionsToggle",className:"flex items-center justify-start text-left text-[#04344E] w-full gap-space8 font-clearface py-[16px]",onClick:()=>{a(!r);},children:[jsxRuntimeExports.jsx(GiftIcon,{elClass:"w-[18px] h-[18px] text-royalBlue relative top-[-2px]"}),jsxRuntimeExports.jsx("span",{className:"grow text-[18px] leading-[26px] tracking-[0.4px]",children:"Additional Gifting Options"}),jsxRuntimeExports.jsx(DownArrow,{elClass:`w-[16px] h-[16px] ${r&&"rotate-180"}`})]}),jsxRuntimeExports.jsx("section",{id:"giftOptionsPanel",className:"grid transition-[grid-template-rows] duration-200 ease-out",style:{gridTemplateRows:r?"1fr":"0fr"},"aria-labelledby":"giftOptionsToggle","aria-hidden":`${!r}`,role:"region",inert:!r,hidden:!r,children:jsxRuntimeExports.jsxs("div",{className:"overflow-hidden",children:[window.giftWrap?.available&&jsxRuntimeExports.jsx(g$2,{giftWrap:window.giftWrap}),jsxRuntimeExports.jsx(h$3,{})]})})]})}function g$2({giftWrap:r}){let{giftWrapInCart:i,addGiftWrap:s,removeGiftWrap:o}=useMinicart(),[f,g]=reactExports.useState(false),[h,u]=reactExports.useState(false),x=new e$3,b=window.Shopify?.country||"US";async function w(){if(h)return;let e=!f;g(e),u(true),e?await s():await o(),u(false);}return reactExports.useEffect(()=>{g(!!i);},[i]),jsxRuntimeExports.jsxs("label",{className:`px-space12 py-space16 flex items-center gap-space12 rounded-[5px] w-full text-primary border mt-space8 cursor-pointer ${f?"border-softBlue bg-softBlue":"border-[#D3DCE4] bg-white"}`,children:[jsxRuntimeExports.jsx(o$7,{checked:f,onChange:w}),jsxRuntimeExports.jsx("div",{className:"rounded w-[48px] h-[48px] shrink-0",children:jsxRuntimeExports.jsx("img",{src:getOptimizedImageUrl(r.featured_image,{width:48,height:48}),srcSet:getOptimizedImageSrcset(r.featured_image,[48,96]),sizes:"48px",alt:r.title,className:"block w-full h-full object-cover rounded-[5px]"})}),jsxRuntimeExports.jsxs("div",{className:"grow flex flex-col gap-[2px] items-start",children:[jsxRuntimeExports.jsx("span",{className:"font-bold leading-normal",children:"Add Gift Bags to My Order"}),jsxRuntimeExports.jsx("span",{className:"text-12 leading-normal",children:"We‘ll wrap your entire order in gift bags."})]}),jsxRuntimeExports.jsxs("span",{className:"font-bold leading-normal self-start",children:[x.formatMoney(r.price,`${"GB"===b?"£":"$"}{{amount}}`).replace(".00",""),"CA"===b&&" CAD","GB"===b&&" GBP"]})]})}function h$3(){let{responseGiftMsg:s,updateCartNote:o}=useMinicart(),[p,f]=reactExports.useState(false),[g,h]=reactExports.useState(true),[u,x]=reactExports.useState(false),[b,w]=reactExports.useState(0),[v,N]=reactExports.useState(""),y=reactExports.useRef(null),k=reactExports.useRef(null),C=s.trim().length>0||u;reactExports.useEffect(()=>{p||f(true);},[s]),reactExports.useEffect(()=>{let e=()=>{y.current?.focus(),k.current?.removeEventListener("transitionend",e);};return u&&k.current&&k.current.addEventListener("transitionend",e),()=>{k.current?.removeEventListener("transitionend",e);}},[u,k,y]),reactExports.useEffect(()=>{N(s),h(false),p&&w(-80);},[s]);let B="//cdn.shopify.com/s/files/1/0019/0352/5941/files/2026-0626-GiftNote_1.jpg?v=1785181779";return jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment,{children:[jsxRuntimeExports.jsxs("div",{className:`px-space12 py-space16 rounded-[5px] text-primary mt-space8 border ${s.trim().length>0?"border-softBlue bg-softBlue":"border-[#D3DCE4] bg-white"}`,children:[jsxRuntimeExports.jsxs("label",{className:"flex items-center gap-space12 w-full cursor-pointer",children:[jsxRuntimeExports.jsx(o$7,{checked:C,onClick:function(){x(!u);}}),jsxRuntimeExports.jsx("div",{className:"rounded w-[48px] h-[48px] shrink-0",children:jsxRuntimeExports.jsx("img",{src:getOptimizedImageUrl(B,{width:48,height:48}),srcSet:getOptimizedImageSrcset(B,[48,96]),sizes:"48px",alt:"Hand holding gift message",className:"block w-full h-full object-cover rounded-[5px]"})}),jsxRuntimeExports.jsxs("div",{className:"grow flex flex-col gap-[2px] items-start",children:[jsxRuntimeExports.jsx("span",{className:"font-bold leading-normal",children:"Gift Message"}),jsxRuntimeExports.jsx("span",{className:"text-12 leading-normal",children:"We'll print your message on designed stationery."})]}),jsxRuntimeExports.jsx("span",{className:"font-bold leading-normal self-start",children:"Free"})]}),jsxRuntimeExports.jsx("div",{ref:k,className:"grid transition-[grid-template-rows] duration-200 ease-out",style:{gridTemplateRows:u?"1fr":"0fr"},inert:!u,hidden:!u,children:jsxRuntimeExports.jsxs("div",{className:"overflow-hidden",children:[jsxRuntimeExports.jsx("textarea",{ref:y,className:"w-full block p-[12px] bg-white border border-[#D3DCE4] text-16 text-[#003550] placeholder:text-[#3C5D72] mt-space16 focus:border-[#003550] rounded-5 resize-none",rows:4,maxLength:200,value:v,placeholder:"Enter gift message here. Gift note is optional.",onChange:e=>{e.target.value!==v&&0!==b&&w(0),N(e.target.value);}}),jsxRuntimeExports.jsxs("div",{className:"text-[12px] leading-[18px] font-apercu mt-[4px] mb-space8",children:[v.length,"/",200]}),jsxRuntimeExports.jsx("button",{"aria-label":"Save Note",onClick:function(){h(true),w(-40),o(v);},disabled:v===s||g,className:"minicart__giftmsg-btn overflow-hidden btn btn--navy mt-space8 text-16 h-[40px] px-[48px] rounded-[4px] bg-primary text-white hover:bg-royalBlue disabled:bg-[#D5DCE3] disabled:text-[#04344E]",children:jsxRuntimeExports.jsxs("div",{className:"flex flex-col w-full items-center relative transition-[top] duration-150 ease-out",style:{top:`${b}px`},children:[jsxRuntimeExports.jsx("span",{className:"flex items-center h-[40px]",children:"Save Note"}),jsxRuntimeExports.jsx("span",{className:"flex items-center h-[40px]",children:"Saving..."}),jsxRuntimeExports.jsx("span",{className:"flex items-center h-[40px]",children:"Note Saved"})]})})]})})]}),jsxRuntimeExports.jsx("span",{className:"block text-12 leading-normal py-space12",children:"Item prices are never shown on packing slips. Gifts are subject to our standard return policy, and recipients can easily start a return with the order number on their packing slip."})]})}

function t$1({threshold:t,title:a,prompt:r,congrats:o,subtotal:n}){let s=Math.min(1,n/t),i=t-n,c=window.Shopify?.country==="GB"?"£":"$",d=window.Shopify?.country==="GB"?" GBP":window.Shopify?.country==="CA"?" CAD":"",p=a.replace("XX",`${c}${Math.round(t/100)}${d}`),u=r.replace("XX",`${c}${Math.round(i/100)}${d}`).replaceAll("<strong>",'<span class="text-cantaloupe font-semibold">').replaceAll("</strong>","</span>"),m=o.replaceAll("<strong>",'<span class="text-cantaloupe font-semibold">').replaceAll("</strong>","</span>");return jsxRuntimeExports.jsxs("div",{className:"pb-2 pt-space8 border-t",children:[jsxRuntimeExports.jsxs("div",{className:"flex flex-col items-center w-full max-w-[70%] mx-auto",children:[jsxRuntimeExports.jsx("div",{className:"text-lg text-royalBlue mb-1",children:p}),jsxRuntimeExports.jsx("div",{className:"relative w-full max-w-[100%] h-[18px] bg-white border border-royalBlue rounded-md overflow-hidden box-border",children:jsxRuntimeExports.jsx("div",{className:"absolute top-0 left-0 box-border block h-full bg-spindle text-royalBlue w-full origin-left transition-[scale] ease-in-out duration-[400ms]",style:{scale:`${s} 1`},children:jsxRuntimeExports.jsx("span",{className:"invisible",children:"•"})})})]}),jsxRuntimeExports.jsx("div",{className:"mt-2 text-16 text-royalBlue text-center px-10 font-bold",dangerouslySetInnerHTML:{__html:i<=0?m:u}})]})}

/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */


/**
 * @constant
 * @name millisecondsInWeek
 * @summary Milliseconds in 1 week.
 */
const millisecondsInWeek = 604800000;

/**
 * @constant
 * @name millisecondsInDay
 * @summary Milliseconds in 1 day.
 */
const millisecondsInDay = 86400000;

/**
 * @constant
 * @name constructFromSymbol
 * @summary Symbol enabling Date extensions to inherit properties from the reference date.
 *
 * The symbol is used to enable the `constructFrom` function to construct a date
 * using a reference date and a value. It allows to transfer extra properties
 * from the reference date to the new date. It's useful for extensions like
 * [`TZDate`](https://github.com/date-fns/tz) that accept a time zone as
 * a constructor argument.
 */
const constructFromSymbol = Symbol.for("constructDateFrom");

/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * Starting from v3.7.0, it allows to construct a date using `[Symbol.for("constructDateFrom")]`
 * enabling to transfer extra properties from the reference date to the new date.
 * It's useful for extensions like [`TZDate`](https://github.com/date-fns/tz)
 * that accept a time zone as a constructor argument.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from "./constructFrom/date-fns";
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date>(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use constructor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   );
 * }
 */
function constructFrom(date, value) {
  if (typeof date === "function") return date(value);

  if (date && typeof date === "object" && constructFromSymbol in date)
    return date[constructFromSymbol](value);

  if (date instanceof Date) return new date.constructor(value);

  return new Date(value);
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * Starting from v3.7.0, it clones a date using `[Symbol.for("constructDateFrom")]`
 * enabling to transfer extra properties from the reference date to the new date.
 * It's useful for extensions like [`TZDate`](https://github.com/date-fns/tz)
 * that accept a time zone as a constructor argument.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument, context) {
  // [TODO] Get rid of `toDate` or `constructFrom`?
  return constructFrom(context || argument, argument);
}

/**
 * The {@link addDays} function options.
 */

/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be added.
 * @param options - An object with options
 *
 * @returns The new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays(date, amount, options) {
  const _date = toDate(date, options?.in);
  if (isNaN(amount)) return constructFrom(date, NaN);

  // If 0 days, no-op to avoid changing times in the hour before end of DST
  if (!amount) return _date;

  _date.setDate(_date.getDate() + amount);
  return _date;
}

let defaultOptions = {};

function getDefaultOptions() {
  return defaultOptions;
}

/**
 * The {@link startOfWeek} function options.
 */

/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek(date, options) {
  const defaultOptions = getDefaultOptions();
  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const _date = toDate(date, options?.in);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;

  _date.setDate(_date.getDate() - diff);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

/**
 * The {@link startOfISOWeek} function options.
 */

/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek(date, options) {
  return startOfWeek(date, { ...options, weekStartsOn: 1 });
}

/**
 * The {@link getISOWeekYear} function options.
 */

/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param date - The given date
 *
 * @returns The ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOWeekYear(date, options) {
  const _date = toDate(date, options?.in);
  const year = _date.getFullYear();

  const fourthOfJanuaryOfNextYear = constructFrom(_date, 0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);

  const fourthOfJanuaryOfThisYear = constructFrom(_date, 0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);

  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  const _date = toDate(date);
  const utcDate = new Date(
    Date.UTC(
      _date.getFullYear(),
      _date.getMonth(),
      _date.getDate(),
      _date.getHours(),
      _date.getMinutes(),
      _date.getSeconds(),
      _date.getMilliseconds(),
    ),
  );
  utcDate.setUTCFullYear(_date.getFullYear());
  return +date - +utcDate;
}

function normalizeDates(context, ...dates) {
  const normalize = constructFrom.bind(
    null,
    dates.find((date) => typeof date === "object"),
  );
  return dates.map(normalize);
}

/**
 * The {@link startOfDay} function options.
 */

/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - The options
 *
 * @returns The start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay(date, options) {
  const _date = toDate(date, options?.in);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

/**
 * The {@link differenceInCalendarDays} function options.
 */

/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @param laterDate - The later date
 * @param earlierDate - The earlier date
 * @param options - The options object
 *
 * @returns The number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */
function differenceInCalendarDays(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(
    options?.in,
    laterDate,
    earlierDate,
  );

  const laterStartOfDay = startOfDay(laterDate_);
  const earlierStartOfDay = startOfDay(earlierDate_);

  const laterTimestamp =
    +laterStartOfDay - getTimezoneOffsetInMilliseconds(laterStartOfDay);
  const earlierTimestamp =
    +earlierStartOfDay - getTimezoneOffsetInMilliseconds(earlierStartOfDay);

  // Round the number of days to the nearest integer because the number of
  // milliseconds in a day is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round((laterTimestamp - earlierTimestamp) / millisecondsInDay);
}

/**
 * The {@link startOfISOWeekYear} function options.
 */

/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of an ISO week-numbering year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOWeekYear(date, options) {
  const year = getISOWeekYear(date, options);
  const fourthOfJanuary = constructFrom(date, 0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  return startOfISOWeek(fourthOfJanuary);
}

/**
 * The {@link addWeeks} function options.
 */

/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of weeks to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be added.
 * @param options - An object with options
 *
 * @returns The new date with the weeks added
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */
function addWeeks(date, amount, options) {
  return addDays(date, amount * 7, options);
}

/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate(value) {
  return (
    value instanceof Date ||
    (typeof value === "object" &&
      Object.prototype.toString.call(value) === "[object Date]")
  );
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate](https://date-fns.org/docs/toDate)
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param date - The date to check
 *
 * @returns The date is valid
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertible into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid(date) {
  return !((!isDate(date) && typeof date !== "number") || isNaN(+toDate(date)));
}

/**
 * The {@link startOfYear} function options.
 */

/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - The options
 *
 * @returns The start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear(date, options) {
  const date_ = toDate(date, options?.in);
  date_.setFullYear(date_.getFullYear(), 0, 1);
  date_.setHours(0, 0, 0, 0);
  return date_;
}

const formatDistanceLocale = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds",
  },

  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds",
  },

  halfAMinute: "half a minute",

  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes",
  },

  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes",
  },

  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours",
  },

  xHours: {
    one: "1 hour",
    other: "{{count}} hours",
  },

  xDays: {
    one: "1 day",
    other: "{{count}} days",
  },

  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks",
  },

  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks",
  },

  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months",
  },

  xMonths: {
    one: "1 month",
    other: "{{count}} months",
  },

  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years",
  },

  xYears: {
    one: "1 year",
    other: "{{count}} years",
  },

  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years",
  },

  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years",
  },
};

const formatDistance = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      return result + " ago";
    }
  }

  return result;
};

function buildFormatLongFn(args) {
  return (options = {}) => {
    // TODO: Remove String()
    const width = options.width ? String(options.width) : args.defaultWidth;
    const format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

const dateFormats = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy",
};

const timeFormats = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a",
};

const dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

const formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full",
  }),

  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full",
  }),

  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full",
  }),
};

const formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P",
};

const formatRelative = (token, _date, _baseDate, _options) =>
  formatRelativeLocale[token];

/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */

/**
 * The map of localized values for each width.
 */

/**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */

/**
 * Converts the unit value to the tuple of values.
 */

/**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */

/**
 * The tuple of localized quarter values. The first element represents Q1.
 */

/**
 * The tuple of localized day values. The first element represents Sunday.
 */

/**
 * The tuple of localized month values. The first element represents January.
 */

function buildLocalizeFn(args) {
  return (value, options) => {
    const context = options?.context ? String(options.context) : "standalone";

    let valuesArray;
    if (context === "formatting" && args.formattingValues) {
      const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      const width = options?.width ? String(options.width) : defaultWidth;

      valuesArray =
        args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      const defaultWidth = args.defaultWidth;
      const width = options?.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[width] || args.values[defaultWidth];
    }
    const index = args.argumentCallback ? args.argumentCallback(value) : value;

    // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}

const eraValues = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"],
};

const quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"],
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],

  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
};

const dayValues = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ],
};

const dayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night",
  },
};

const formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night",
  },
};

const ordinalNumber = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  const rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + "st";
      case 2:
        return number + "nd";
      case 3:
        return number + "rd";
    }
  }
  return number + "th";
};

const localize = {
  ordinalNumber,

  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide",
  }),

  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide",
  }),

  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide",
  }),

  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide",
  }),
};

function buildMatchFn(args) {
  return (string, options = {}) => {
    const width = options.width;

    const matchPattern =
      (width && args.matchPatterns[width]) ||
      args.matchPatterns[args.defaultMatchWidth];
    const matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }
    const matchedString = matchResult[0];

    const parsePatterns =
      (width && args.parsePatterns[width]) ||
      args.parsePatterns[args.defaultParseWidth];

    const key = Array.isArray(parsePatterns)
      ? findIndex(parsePatterns, (pattern) => pattern.test(matchedString))
      : // [TODO] -- I challenge you to fix the type
        findKey(parsePatterns, (pattern) => pattern.test(matchedString));

    let value;

    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback
      ? // [TODO] -- I challenge you to fix the type
        options.valueCallback(value)
      : value;

    const rest = string.slice(matchedString.length);

    return { value, rest };
  };
}

function findKey(object, predicate) {
  for (const key in object) {
    if (
      Object.prototype.hasOwnProperty.call(object, key) &&
      predicate(object[key])
    ) {
      return key;
    }
  }
  return undefined;
}

function findIndex(array, predicate) {
  for (let key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}

function buildMatchPatternFn(args) {
  return (string, options = {}) => {
    const matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    const matchedString = matchResult[0];

    const parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    let value = args.valueCallback
      ? args.valueCallback(parseResult[0])
      : parseResult[0];

    // [TODO] I challenge you to fix the type
    value = options.valueCallback ? options.valueCallback(value) : value;

    const rest = string.slice(matchedString.length);

    return { value, rest };
  };
}

const matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern = /\d+/i;

const matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i,
};
const parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i],
};

const matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i,
};
const parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i,
};
const parseMonthPatterns = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i,
};
const parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i],
};

const matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i,
};
const parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i,
  },
};

const match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any",
  }),

  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any",
  }),

  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any",
  }),

  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any",
  }),
};

/**
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp](https://github.com/kossnocorp)
 * @author Lesha Koss [@leshakoss](https://github.com/leshakoss)
 */
const enUS = {
  code: "en-US",
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1,
  },
};

/**
 * The {@link getDayOfYear} function options.
 */

/**
 * @name getDayOfYear
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @param date - The given date
 * @param options - The options
 *
 * @returns The day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * const result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */
function getDayOfYear(date, options) {
  const _date = toDate(date, options?.in);
  const diff = differenceInCalendarDays(_date, startOfYear(_date));
  const dayOfYear = diff + 1;
  return dayOfYear;
}

/**
 * The {@link getISOWeek} function options.
 */

/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param date - The given date
 * @param options - The options
 *
 * @returns The ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek(date, options) {
  const _date = toDate(date, options?.in);
  const diff = +startOfISOWeek(_date) - +startOfISOWeekYear(_date);

  // Round the number of weeks to the nearest integer because the number of
  // milliseconds in a week is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round(diff / millisecondsInWeek) + 1;
}

/**
 * The {@link getWeekYear} function options.
 */

/**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The local week-numbering year
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */
function getWeekYear(date, options) {
  const _date = toDate(date, options?.in);
  const year = _date.getFullYear();

  const defaultOptions = getDefaultOptions();
  const firstWeekContainsDate =
    options?.firstWeekContainsDate ??
    options?.locale?.options?.firstWeekContainsDate ??
    defaultOptions.firstWeekContainsDate ??
    defaultOptions.locale?.options?.firstWeekContainsDate ??
    1;

  const firstWeekOfNextYear = constructFrom(options?.in || date, 0);
  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfWeek(firstWeekOfNextYear, options);

  const firstWeekOfThisYear = constructFrom(options?.in || date, 0);
  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfWeek(firstWeekOfThisYear, options);

  if (+_date >= +startOfNextYear) {
    return year + 1;
  } else if (+_date >= +startOfThisYear) {
    return year;
  } else {
    return year - 1;
  }
}

/**
 * The {@link startOfWeekYear} function options.
 */

/**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week-numbering year
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfWeekYear(date, options) {
  const defaultOptions = getDefaultOptions();
  const firstWeekContainsDate =
    options?.firstWeekContainsDate ??
    options?.locale?.options?.firstWeekContainsDate ??
    defaultOptions.firstWeekContainsDate ??
    defaultOptions.locale?.options?.firstWeekContainsDate ??
    1;

  const year = getWeekYear(date, options);
  const firstWeek = constructFrom(options?.in || date, 0);
  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  const _date = startOfWeek(firstWeek, options);
  return _date;
}

/**
 * The {@link getWeek} function options.
 */

/**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The week
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */
function getWeek(date, options) {
  const _date = toDate(date, options?.in);
  const diff = +startOfWeek(_date, options) - +startOfWeekYear(_date, options);

  // Round the number of weeks to the nearest integer because the number of
  // milliseconds in a week is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round(diff / millisecondsInWeek) + 1;
}

function addLeadingZeros(number, targetLength) {
  const sign = number < 0 ? "-" : "";
  const output = Math.abs(number).toString().padStart(targetLength, "0");
  return sign + output;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

const lightFormatters = {
  // Year
  y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    const signedYear = date.getFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    const year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === "yy" ? year % 100 : year, token.length);
  },

  // Month
  M(date, token) {
    const month = date.getMonth();
    return token === "M" ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },

  // Day of the month
  d(date, token) {
    return addLeadingZeros(date.getDate(), token.length);
  },

  // AM or PM
  a(date, token) {
    const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";

    switch (token) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },

  // Hour [1-12]
  h(date, token) {
    return addLeadingZeros(date.getHours() % 12 || 12, token.length);
  },

  // Hour [0-23]
  H(date, token) {
    return addLeadingZeros(date.getHours(), token.length);
  },

  // Minute
  m(date, token) {
    return addLeadingZeros(date.getMinutes(), token.length);
  },

  // Second
  s(date, token) {
    return addLeadingZeros(date.getSeconds(), token.length);
  },

  // Fraction of second
  S(date, token) {
    const numberOfDigits = token.length;
    const milliseconds = date.getMilliseconds();
    const fractionalSeconds = Math.trunc(
      milliseconds * Math.pow(10, numberOfDigits - 3),
    );
    return addLeadingZeros(fractionalSeconds, token.length);
  },
};

const dayPeriodEnum = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night",
};

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

const formatters = {
  // Era
  G: function (date, token, localize) {
    const era = date.getFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return localize.era(era, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return localize.era(era, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return localize.era(era, { width: "wide" });
    }
  },

  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === "yo") {
      const signedYear = date.getFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      const year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, { unit: "year" });
    }

    return lightFormatters.y(date, token);
  },

  // Local week-numbering year
  Y: function (date, token, localize, options) {
    const signedWeekYear = getWeekYear(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === "YY") {
      const twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === "Yo") {
      return localize.ordinalNumber(weekYear, { unit: "year" });
    }

    // Padding
    return addLeadingZeros(weekYear, token.length);
  },

  // ISO week-numbering year
  R: function (date, token) {
    const isoWeekYear = getISOWeekYear(date);

    // Padding
    return addLeadingZeros(isoWeekYear, token.length);
  },

  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    const year = date.getFullYear();
    return addLeadingZeros(year, token.length);
  },

  // Quarter
  Q: function (date, token, localize) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case "Q":
        return String(quarter);
      // 01, 02, 03, 04
      case "QQ":
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return localize.ordinalNumber(quarter, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return localize.quarter(quarter, {
          width: "abbreviated",
          context: "formatting",
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return localize.quarter(quarter, {
          width: "narrow",
          context: "formatting",
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return localize.quarter(quarter, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Stand-alone quarter
  q: function (date, token, localize) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case "q":
        return String(quarter);
      // 01, 02, 03, 04
      case "qq":
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return localize.ordinalNumber(quarter, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return localize.quarter(quarter, {
          width: "abbreviated",
          context: "standalone",
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return localize.quarter(quarter, {
          width: "narrow",
          context: "standalone",
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return localize.quarter(quarter, {
          width: "wide",
          context: "standalone",
        });
    }
  },

  // Month
  M: function (date, token, localize) {
    const month = date.getMonth();
    switch (token) {
      case "M":
      case "MM":
        return lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return localize.ordinalNumber(month + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return localize.month(month, {
          width: "abbreviated",
          context: "formatting",
        });
      // J, F, ..., D
      case "MMMMM":
        return localize.month(month, {
          width: "narrow",
          context: "formatting",
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return localize.month(month, { width: "wide", context: "formatting" });
    }
  },

  // Stand-alone month
  L: function (date, token, localize) {
    const month = date.getMonth();
    switch (token) {
      // 1, 2, ..., 12
      case "L":
        return String(month + 1);
      // 01, 02, ..., 12
      case "LL":
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return localize.ordinalNumber(month + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return localize.month(month, {
          width: "abbreviated",
          context: "standalone",
        });
      // J, F, ..., D
      case "LLLLL":
        return localize.month(month, {
          width: "narrow",
          context: "standalone",
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return localize.month(month, { width: "wide", context: "standalone" });
    }
  },

  // Local week of year
  w: function (date, token, localize, options) {
    const week = getWeek(date, options);

    if (token === "wo") {
      return localize.ordinalNumber(week, { unit: "week" });
    }

    return addLeadingZeros(week, token.length);
  },

  // ISO week of year
  I: function (date, token, localize) {
    const isoWeek = getISOWeek(date);

    if (token === "Io") {
      return localize.ordinalNumber(isoWeek, { unit: "week" });
    }

    return addLeadingZeros(isoWeek, token.length);
  },

  // Day of the month
  d: function (date, token, localize) {
    if (token === "do") {
      return localize.ordinalNumber(date.getDate(), { unit: "date" });
    }

    return lightFormatters.d(date, token);
  },

  // Day of year
  D: function (date, token, localize) {
    const dayOfYear = getDayOfYear(date);

    if (token === "Do") {
      return localize.ordinalNumber(dayOfYear, { unit: "dayOfYear" });
    }

    return addLeadingZeros(dayOfYear, token.length);
  },

  // Day of week
  E: function (date, token, localize) {
    const dayOfWeek = date.getDay();
    switch (token) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting",
        });
      // T
      case "EEEEE":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "EEEEEE":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "formatting",
        });
      // Tuesday
      case "EEEE":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Local day of week
  e: function (date, token, localize, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(localDayOfWeek);
      // Padded numerical value
      case "ee":
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return localize.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "eee":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting",
        });
      // T
      case "eeeee":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "eeeeee":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "formatting",
        });
      // Tuesday
      case "eeee":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case "c":
        return String(localDayOfWeek);
      // Padded numerical value
      case "cc":
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return localize.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "ccc":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone",
        });
      // T
      case "ccccc":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "standalone",
        });
      // Tu
      case "cccccc":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "standalone",
        });
      // Tuesday
      case "cccc":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "standalone",
        });
    }
  },

  // ISO day of week
  i: function (date, token, localize) {
    const dayOfWeek = date.getDay();
    const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case "i":
        return String(isoDayOfWeek);
      // 02
      case "ii":
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd
      case "io":
        return localize.ordinalNumber(isoDayOfWeek, { unit: "day" });
      // Tue
      case "iii":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting",
        });
      // T
      case "iiiii":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "iiiiii":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "formatting",
        });
      // Tuesday
      case "iiii":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // AM or PM
  a: function (date, token, localize) {
    const hours = date.getHours();
    const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";

    switch (token) {
      case "a":
      case "aa":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting",
        });
      case "aaa":
        return localize
          .dayPeriod(dayPeriodEnumValue, {
            width: "abbreviated",
            context: "formatting",
          })
          .toLowerCase();
      case "aaaaa":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting",
        });
      case "aaaa":
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    }

    switch (token) {
      case "b":
      case "bb":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting",
        });
      case "bbb":
        return localize
          .dayPeriod(dayPeriodEnumValue, {
            width: "abbreviated",
            context: "formatting",
          })
          .toLowerCase();
      case "bbbbb":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting",
        });
      case "bbbb":
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting",
        });
      case "BBBBB":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting",
        });
      case "BBBB":
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === "ho") {
      let hours = date.getHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, { unit: "hour" });
    }

    return lightFormatters.h(date, token);
  },

  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === "Ho") {
      return localize.ordinalNumber(date.getHours(), { unit: "hour" });
    }

    return lightFormatters.H(date, token);
  },

  // Hour [0-11]
  K: function (date, token, localize) {
    const hours = date.getHours() % 12;

    if (token === "Ko") {
      return localize.ordinalNumber(hours, { unit: "hour" });
    }

    return addLeadingZeros(hours, token.length);
  },

  // Hour [1-24]
  k: function (date, token, localize) {
    let hours = date.getHours();
    if (hours === 0) hours = 24;

    if (token === "ko") {
      return localize.ordinalNumber(hours, { unit: "hour" });
    }

    return addLeadingZeros(hours, token.length);
  },

  // Minute
  m: function (date, token, localize) {
    if (token === "mo") {
      return localize.ordinalNumber(date.getMinutes(), { unit: "minute" });
    }

    return lightFormatters.m(date, token);
  },

  // Second
  s: function (date, token, localize) {
    if (token === "so") {
      return localize.ordinalNumber(date.getSeconds(), { unit: "second" });
    }

    return lightFormatters.s(date, token);
  },

  // Fraction of second
  S: function (date, token) {
    return lightFormatters.S(date, token);
  },

  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return "Z";
    }

    switch (token) {
      // Hours and optional minutes
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX": // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX": // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },

  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx": // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx": // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },

  // Timezone (GMT)
  O: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    switch (token) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },

  // Timezone (specific non-location)
  z: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    switch (token) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },

  // Seconds timestamp
  t: function (date, token, _localize) {
    const timestamp = Math.trunc(+date / 1000);
    return addLeadingZeros(timestamp, token.length);
  },

  // Milliseconds timestamp
  T: function (date, token, _localize) {
    return addLeadingZeros(+date, token.length);
  },
};

function formatTimezoneShort(offset, delimiter = "") {
  const sign = offset > 0 ? "-" : "+";
  const absOffset = Math.abs(offset);
  const hours = Math.trunc(absOffset / 60);
  const minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, delimiter) {
  if (offset % 60 === 0) {
    const sign = offset > 0 ? "-" : "+";
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, delimiter);
}

function formatTimezone(offset, delimiter = "") {
  const sign = offset > 0 ? "-" : "+";
  const absOffset = Math.abs(offset);
  const hours = addLeadingZeros(Math.trunc(absOffset / 60), 2);
  const minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

const dateLongFormatter = (pattern, formatLong) => {
  switch (pattern) {
    case "P":
      return formatLong.date({ width: "short" });
    case "PP":
      return formatLong.date({ width: "medium" });
    case "PPP":
      return formatLong.date({ width: "long" });
    case "PPPP":
    default:
      return formatLong.date({ width: "full" });
  }
};

const timeLongFormatter = (pattern, formatLong) => {
  switch (pattern) {
    case "p":
      return formatLong.time({ width: "short" });
    case "pp":
      return formatLong.time({ width: "medium" });
    case "ppp":
      return formatLong.time({ width: "long" });
    case "pppp":
    default:
      return formatLong.time({ width: "full" });
  }
};

const dateTimeLongFormatter = (pattern, formatLong) => {
  const matchResult = pattern.match(/(P+)(p+)?/) || [];
  const datePattern = matchResult[1];
  const timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  let dateTimeFormat;

  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong.dateTime({ width: "short" });
      break;
    case "PP":
      dateTimeFormat = formatLong.dateTime({ width: "medium" });
      break;
    case "PPP":
      dateTimeFormat = formatLong.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong.dateTime({ width: "full" });
      break;
  }

  return dateTimeFormat
    .replace("{{date}}", dateLongFormatter(datePattern, formatLong))
    .replace("{{time}}", timeLongFormatter(timePattern, formatLong));
};

const longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter,
};

const dayOfYearTokenRE = /^D+$/;
const weekYearTokenRE = /^Y+$/;

const throwTokens = ["D", "DD", "YY", "YYYY"];

function isProtectedDayOfYearToken(token) {
  return dayOfYearTokenRE.test(token);
}

function isProtectedWeekYearToken(token) {
  return weekYearTokenRE.test(token);
}

function warnOrThrowProtectedError(token, format, input) {
  const _message = message(token, format, input);
  console.warn(_message);
  if (throwTokens.includes(token)) throw new RangeError(_message);
}

function message(token, format, input) {
  const subject = token[0] === "Y" ? "years" : "days of the month";
  return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}

// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const formattingTokensRegExp =
  /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;

const escapedStringRegExp = /^'([^]*?)'?$/;
const doubleQuoteRegExp = /''/g;
const unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * The {@link format} function options.
 */

/**
 * @name format
 * @alias formatDate
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear](https://date-fns.org/docs/getISOWeekYear)
 *    and [getWeekYear](https://date-fns.org/docs/getWeekYear)).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param date - The original date
 * @param format - The string of tokens
 * @param options - An object with options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */
function format(date, formatStr, options) {
  const defaultOptions = getDefaultOptions();
  const locale = defaultOptions.locale ?? enUS;

  const firstWeekContainsDate =
    defaultOptions.firstWeekContainsDate ??
    defaultOptions.locale?.options?.firstWeekContainsDate ??
    1;

  const weekStartsOn =
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const originalDate = toDate(date, options?.in);

  if (!isValid(originalDate)) {
    throw new RangeError("Invalid time value");
  }

  let parts = formatStr
    .match(longFormattingTokensRegExp)
    .map((substring) => {
      const firstCharacter = substring[0];
      if (firstCharacter === "p" || firstCharacter === "P") {
        const longFormatter = longFormatters[firstCharacter];
        return longFormatter(substring, locale.formatLong);
      }
      return substring;
    })
    .join("")
    .match(formattingTokensRegExp)
    .map((substring) => {
      // Replace two single quote characters with one single quote character
      if (substring === "''") {
        return { isToken: false, value: "'" };
      }

      const firstCharacter = substring[0];
      if (firstCharacter === "'") {
        return { isToken: false, value: cleanEscapedString(substring) };
      }

      if (formatters[firstCharacter]) {
        return { isToken: true, value: substring };
      }

      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" +
            firstCharacter +
            "`",
        );
      }

      return { isToken: false, value: substring };
    });

  // invoke localize preprocessor (only for french locales at the moment)
  if (locale.localize.preprocessor) {
    parts = locale.localize.preprocessor(originalDate, parts);
  }

  const formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale,
  };

  return parts
    .map((part) => {
      if (!part.isToken) return part.value;

      const token = part.value;

      if (
        (isProtectedWeekYearToken(token)) ||
        (isProtectedDayOfYearToken(token))
      ) {
        warnOrThrowProtectedError(token, formatStr, String(date));
      }

      const formatter = formatters[token[0]];
      return formatter(originalDate, token, locale.localize, formatterOptions);
    })
    .join("");
}

function cleanEscapedString(input) {
  const matched = input.match(escapedStringRegExp);

  if (!matched) {
    return input;
  }

  return matched[1].replace(doubleQuoteRegExp, "'");
}

/**
 * The {@link getMonth} function options.
 */

/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The month index (0-11)
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */
function getMonth(date, options) {
  return toDate(date, options?.in).getMonth();
}

function i$4({displayEdd:i,cart:m,shippingRules:d,singleDateMsg:c,dateRangeMsg:o,eddExtraMsg:u,backorderMsg:p}){if(!i||!m||0===m.items.length)return null;try{var x,y,f;let i,g,h,D,b,k,v,M=(x=m,h=!1,D=!0,b=!1,k=!1,v=!1,x.items.forEach(e=>{let t=e.sku,a=e.properties?.Status==="Backordered",r=!a&&t?.includes("-A"),n=!a&&t?.includes("-E");x.extra_details?.[e.key]?.is_collective_partner_item&&(v=!0),a?h=!0:D=!1,r&&(b=!0),n&&(k=!0);}),{hasBackorderedItems:h,hasOnlyBackorderedItems:D,areAnyApplique:b,areAnyEmbroidery:k,areAnyCollectivePartnerItems:v});if(M.hasOnlyBackorderedItems)i=p,g=null;else {let e=(y=M,f=d,y.areAnyCollectivePartnerItems&&f.collectivePartnerRates?.length>0?f.collectivePartnerRates:y.hasOnlyBackorderedItems?f.backorderRates:y.areAnyApplique?f.appliqueRates:y.areAnyEmbroidery?f.embroideryRates:f.nonEmbroideryRates),t=function(e,t){let i=new Date,m=e.map(e=>{let n,s;switch(e.unit.toLowerCase()){case "week":case "weeks":n=addWeeks(i,e.min),s=addWeeks(i,e.max);break;case "businessdays":case "businessday":case "business_days":case "business_day":n=l$4(i,e.min,t),s=l$4(i,e.max,t);break;default:n=addDays(i,e.min),s=addDays(i,e.max);}return {minDate:n,maxDate:s}}),d=0;for(let e=1;e<m.length;e++){let t=m[e],a=m[d];(t.minDate>a.minDate||t.minDate.getTime()===a.minDate.getTime()&&t.maxDate>a.maxDate)&&(d=e);}let c=d,o=e.findIndex(e=>!0===e.minicartEDD);-1!==o&&(c=o);let{minDate:u,maxDate:p}=m[c],x=m.length>1&&m.some((e,t)=>t!==c&&(e.minDate<u||e.maxDate<p)),y=format(u,"MMM do"),f=getMonth(u)===getMonth(p),g=u.getTime()===p.getTime()?y:f?format(p,"do"):format(p,"MMM do");return {date1:y,date2:g,fasterOptionAvail:x}}(e,d.weezieHolidays);i=t.date1===t.date2?c.replace("{date}",t.date1):o.replace("{date1}",t.date1).replace("{date2}",t.date2),g=M.hasBackorderedItems?u?`${u}<br />${p}`:p:u;}return jsxRuntimeExports.jsxs("div",{className:"text-navy text-center text-[10px] md:text-12 leading-[1.2] pt-[7px] md:pt-[13px]",children:[jsxRuntimeExports.jsx("p",{className:"font-bold",children:i}),g&&jsxRuntimeExports.jsx("p",{className:"pt-[4px] md:pt-[6px] max-md:text-[8px]",dangerouslySetInnerHTML:{__html:g}})]})}catch(e){return console.error("EstimatedDelivery messaging failed",e),null}}function l$4(e,t,r){let n=e,s=0;for(;s<t;)!function(e){let t=e.getDay();return 0===t||6===t}(n=addDays(n,1))&&!function(e,t){return 0!==t.length&&t.some(t=>{try{let[a,r]=t.split("-").map(Number);return a===e.getMonth()+1&&r===e.getDate()}catch{return  false}})}(n,r)&&s++;return n}

function h$2({tiers:h,prompt:f,success:p,disclaimer:u,subtotal:m,cart:x,displayEdd:g,shippingRules:b,singleDateMsg:y,dateRangeMsg:w,eddExtraMsg:v,backorderMsg:N}){let $=reactExports.useRef(null),M=reactExports.useRef(null),j=reactExports.useRef(null),[S,k]=reactExports.useState(null),[C,E]=reactExports.useState(0),[L,W]=reactExports.useState(0),[z,A]=reactExports.useState(""),[B,D]=reactExports.useState(new Set),{setShowFreeShippingBadge:F}=useMinicart(),G=window.Shopify?.country==="GB"?"£":"$",I=window.Shopify?.country==="GB"?" GBP":window.Shopify?.country==="CA"?" CAD":"",T=reactExports.useMemo(()=>[...h].sort((e,t)=>e.threshold-t.threshold),[h]),R=reactExports.useMemo(()=>[...h].some(e=>e.extraMsg&&""!==e.extraMsg),[h]),_=T.length>1?"pb-[35px]":"pb-[12px]";R&&(_=T.length>1?"pb-[55px]":"pb-[32px]"),reactExports.useEffect(()=>{if(j.current){let e=j.current.querySelectorAll(".tierIcon");e.length>0&&k(Array.from(e));}},[T]),reactExports.useEffect(()=>{if(0===m)return void W(0);if(T&&m>T[T.length-1].threshold)return void W(1);if(1===T.length)return void W(Math.min(m/T[0].threshold,1));if($.current&&S&&T){let e=$.current.offsetWidth,t=S[0].offsetWidth,r=[...S].map(e=>e.offsetLeft),n=0;for(let e=0;e<T.length;e++){let l=T[e].threshold;if(m<=l){if(0===e)n=r[e]*m/l;else {let i=T[e-1].threshold,s=(m-i)/(l-i),a=r[e-1];n=(r[e]-a-t)*s+a+t;}m<l?n=Math.min(n,r[e]-3):n+=t/2;break}}W(n/e);return}},[T,m,S,C]),reactExports.useEffect(()=>{let e=debounce(()=>{E(Math.random());},200);return window.addEventListener("resize",e),()=>{window.removeEventListener("resize",e);}},[]),reactExports.useEffect(()=>{if(!M.current||!$.current)return;let e=$.current.offsetWidth;s$6(M.current,{width:e*L},{duration:400,easing:"ease-in-out",progress:function(){let e=M.current.offsetWidth;S&&T.forEach((t,r)=>{let n=S[r];if(n){let r=e>=n.offsetLeft+n.offsetWidth/2;D(e=>{let n=new Set(e);return r&&!e.has(t.id)?n.add(t.id):!r&&e.has(t.id)&&n.delete(t.id),n});}});},complete:function(){D(()=>{let e=new Set;return T.forEach(t=>{m>=t.threshold&&e.add(t.id);}),e});}});},[L,T,S,m,C]),reactExports.useEffect(()=>{if(F(false),m>=T[T.length-1].threshold)A(p.replace("{reward}",`<span class="font-bold">${T[T.length-1].title}</span>`));else for(let e=0;e<T.length;e++){let t=T[e].threshold;if(m>=t&&T[e].title.toLowerCase().includes("free shipping")&&F(true),m<t){let r=(t-m)/100;A(f.replace("{reward}",`<span class="font-bold">${T[e].title}</span>`).replace("{remaining}",`<span class="font-bold">${G}${r.toFixed(2)}${I}</span>`));break}}},[m,T]);let q=T.map((r,n)=>{let l=B.has(r.id);return jsxRuntimeExports.jsxs("div",{className:"flex flex-col items-center text-center relative tierIcon",children:[jsxRuntimeExports.jsxs("div",{className:`w-[24px] h-[24px] rounded-full border-2 flex items-center justify-center relative overflow-hidden transition-colors duration-300 ${l?"border-primary bg-white":"border-geyser bg-geyser"}`,children:[jsxRuntimeExports.jsx("div",{className:`absolute inset-0 flex items-center justify-center transition-all duration-300 ${l?"scale-100 opacity-100":"scale-0 opacity-0"}`,style:{transitionTimingFunction:"cubic-bezier(0.34, 1.56, 0.64, 1)"},children:jsxRuntimeExports.jsx(CheckmarkIcon,{elClass:"w-[9px]"})}),jsxRuntimeExports.jsx("div",{className:`absolute inset-0 flex items-center justify-center transition-all duration-300 ${l?"scale-0 opacity-0":"scale-100 opacity-100"}`,style:{transitionTimingFunction:"cubic-bezier(0.34, 1.56, 0.64, 1)"},children:jsxRuntimeExports.jsx(Lock,{elClass:"w-[8px] -mt-px"})})]}),jsxRuntimeExports.jsxs("div",{className:"absolute whitespace-nowrap top-[28px] flex flex-col items-center text-center",children:[jsxRuntimeExports.jsx("span",{className:"text-14 font-bold leading-none",children:r.title}),r.extraMsg&&jsxRuntimeExports.jsx("span",{className:"text-12 mt-[4px] leading-none",children:r.extraMsg}),jsxRuntimeExports.jsx("span",{className:"text-12 mt-[4px] leading-none",children:`${G}${Math.round(r.threshold/100)}${n===h.length-1?"+":""}${I}`})]})]},r.id)});return jsxRuntimeExports.jsx("div",{className:"text-primary",children:jsxRuntimeExports.jsxs("div",{className:"pt-space8 border-t",children:[jsxRuntimeExports.jsx("span",{className:"block text-center text-14",dangerouslySetInnerHTML:{__html:z}}),jsxRuntimeExports.jsxs("div",{ref:j,className:`relative flex px-[34px] lg:px-[43px] mt-space8 ${_} ${T.length>1?"justify-between":"justify-end"}`,children:[jsxRuntimeExports.jsx("div",{ref:$,className:"absolute w-full h-[6px] rounded-[3px] bg-geyser top-[7px] left-0 overflow-hidden",children:jsxRuntimeExports.jsx("div",{ref:M,className:"!block absolute inset-0 bg-royalBlue origin-left",style:{width:0}})}),T.length>1?q:null]}),jsxRuntimeExports.jsx(i$4,{displayEdd:g,cart:x,shippingRules:b,singleDateMsg:y,dateRangeMsg:w,eddExtraMsg:v,backorderMsg:N}),u&&jsxRuntimeExports.jsx("span",{className:"block text-[10px] text-center pt-space8",children:u})]})})}

function t({message:t}){return jsxRuntimeExports.jsx("div",{className:"text-primary block text-center text-14 py-space12 space-y-[4px] rte",dangerouslySetInnerHTML:{__html:t}})}

let p$3=()=>{let{isLoading:i,scrimRef:p,modalRef:g,closeCart:h,subtotalCents:x,cart:f,cartBlocksData:u,showFreeShipping:b,showTieredPromos:v,showSupplementalMessaging:w,tieredPromosSubtotal:y}=useMinicart();return jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment,{children:jsxRuntimeExports.jsxs("div",{className:"h-full w-full",children:[jsxRuntimeExports.jsx("div",{ref:p,onClick:h,className:"h-full"}),jsxRuntimeExports.jsx("div",{ref:g,className:"h-full max-lg:!transform-none",children:jsxRuntimeExports.jsxs("div",{className:"lg:relative flex flex-col h-full",children:[jsxRuntimeExports.jsxs("div",{className:"grow lg:overflow-y-auto lg:overflow-x-hidden lg:overscroll-contain",children:[jsxRuntimeExports.jsx("div",{className:"bg-white sticky top-0 z-10 px-10 lg:px-[60px]",children:jsxRuntimeExports.jsxs("div",{className:"border-b pb-4",children:[jsxRuntimeExports.jsxs("div",{className:"flex w-full items-center justify-between py-space12 lg:py-space16",children:[jsxRuntimeExports.jsx("h2",{className:"text-[20px] lg:text-[26px] grow font-clearface text-royalBlue w-full tracking-normal leading-none",children:"Your Cart"}),jsxRuntimeExports.jsx("div",{className:"w-[32px] h-full relative",children:jsxRuntimeExports.jsx("button",{onClick:h,"aria-label":"Close cart",className:"absolute top-1/2 -right-[14px] -translate-y-1/2 p-2 px-[10px]",children:jsxRuntimeExports.jsx("svg",{xmlns:"http://www.w3.org/2000/svg",className:"w-11 h-11 text-geyser",fill:"none",viewBox:"0 0 24 24",stroke:"black",strokeWidth:2,children:jsxRuntimeExports.jsx("path",{strokeLinecap:"round",strokeLinejoin:"round",d:"M6 18L18 6M6 6l12 12"})})})})]}),b&&jsxRuntimeExports.jsx(t$1,{threshold:u.freeShipping.threshold,title:u.freeShipping.title,prompt:u.freeShipping.prompt,congrats:u.freeShipping.congrats,subtotal:x}),v&&jsxRuntimeExports.jsx(h$2,{tiers:u.tieredPromos.tiers,prompt:u.tieredPromos.prompt,success:u.tieredPromos.success,disclaimer:u.tieredPromos.disclaimer,subtotal:y,displayEdd:u.tieredPromos.displayEdd,shippingRules:u.tieredPromos.shippingRules,singleDateMsg:u.tieredPromos.singleDateMsg,dateRangeMsg:u.tieredPromos.dateRangeMsg,eddExtraMsg:u.tieredPromos.eddExtraMsg,backorderMsg:u.tieredPromos.backorderMsg,cart:f}),w&&jsxRuntimeExports.jsx(t,{message:u.supplementalMessaging.text}),jsxRuntimeExports.jsx(a$6,{})]})}),jsxRuntimeExports.jsxs("div",{className:"flex-1 space-y-6 px-10 lg:px-[60px] bg-white",children:[i?jsxRuntimeExports.jsx("p",{className:"text-center pt-6",children:"Loading…"}):0===f.items.length?jsxRuntimeExports.jsx("p",{className:"text-center pt-6 ",children:"Your cart is empty"}):f.items.map((r,t)=>r.properties._hide_in_minicart?null:jsxRuntimeExports.jsx(s$4,{item:r},r.key)),f.item_count>0&&!i&&jsxRuntimeExports.jsx("div",{className:"bg-sand p-3 px-10 lg:px-28 max-lg:!mb-6 text-base text-center text-royalBlue rounded",children:"Please review your selections, as orders cannot be changed once they are placed. Personalized items may not be returned or exchanged."}),jsxRuntimeExports.jsx("div",{className:"lg:sticky lg:bottom-0 bg-white",children:f.item_count>0&&!i&&jsxRuntimeExports.jsx(f$1,{})})]})]}),jsxRuntimeExports.jsx("div",{className:"w-full bg-grey z-10 px-10 lg:px-[60px] max-lg:absolute max-lg:bottom-0 max-lg:left-0",children:jsxRuntimeExports.jsx(o$8,{})})]})})]})})};const o$6 = (()=>jsxRuntimeExports.jsx(MinicartProvider,{children:jsxRuntimeExports.jsx(p$3,{})}));

let d$6=reactExports.createContext(null);const ProductProvider=({children:t})=>{let[r,l]=reactExports.useState(null),[s,c]=reactExports.useState(null),[u,p]=reactExports.useState(null),[f,m]=reactExports.useState(null),[y,_]=reactExports.useState(null),[w,b]=reactExports.useState(false),[h,g]=reactExports.useState({}),[k,v]=reactExports.useState(0),[S,x]=reactExports.useState(1),[E,j]=reactExports.useState(null),[$,T]=reactExports.useState(null),[C,q]=reactExports.useState(null),[U,B]=reactExports.useState(null),[O,A]=reactExports.useState(false),[D,P]=reactExports.useState(false),[N,G]=reactExports.useState(false),[I,R]=reactExports.useState([]),[W,L]=reactExports.useState(null),[M,J]=reactExports.useState(null),[z,V]=reactExports.useState(null),[X,F]=reactExports.useState(false),[H,K]=reactExports.useState(new Date),[Q,Y]=reactExports.useState(false);reactExports.useEffect(()=>{let e=document.querySelector("#gorgias-chat-container"),t=document.querySelector("#polaris-css-lockdown-container");return O?(t&&(e.style.display="none"),t&&t.style.setProperty("display","none","important")):(t&&(e.style.display=null),t&&(t.style.display=null)),()=>{t&&(e.style.display=null),t&&(t.style.display=null);}},[O]);let Z=new e$3,ee=window.Shopify?.country||"US",et=()=>{let e=window.Shopify?.country||"US";return "CA"===e?"CAD":"GB"===e||"UK"===e?"GBP":"USD"},er=async()=>{try{let e,t=y.id,r=f.product_variant_info.findIndex(e=>e.id===t),i={},o=s?.tags?.includes("faux emb"),a=s?.tags?.includes("gift_set"),d=t===window.giftWrap?.variants?.[0].id,l=f?.product_variant_info[r];l?.metafields?.embroidery_color&&(i["Embroidery Color"]=l?.metafields?.embroidery_color),l?.metafields?.embroidery_style&&(i["Embroidery Style"]=l?.metafields?.embroidery_style),l?.metafields?.embroidery_text&&(i["Embroidery Text"]=l?.metafields?.embroidery_text),l?.metafields?.embroidery_applique_background&&(i["Embroidery Applique Background"]=l?.metafields?.embroidery_applique_background),l?.metafields?.embroidery_text!="Icon"||l?.metafields?.embroidery_color||(i["Embroidery Color"]="");let c=E?.find(e=>e.id===y.id),u=y.available&&c&&c.inventory_quantity<=0;o&&l?.metafields?.embroidery_text=="Icon"&&(i._faux_embroidery=!0),u&&(i.Status="Backordered",i.Backorder=c?.metafields?.backorder_messaging||"Backordered - Ships when back in stock");let p=s?.title?.includes("Gift Card");p&&(delete i.Backorder,delete i.Status);let m={...i,...p&&h&&Object.keys(h).length>0?h:{}};if(a&&S>1){let t=[];for(let e=0;e<S;e++)t.push({id:y.id,quantity:1,properties:{...m,_gift_set:await getNextGiftSetId()}});e={items:t};}else a&&(m._gift_set=await getNextGiftSetId()),e={id:y.id,quantity:d&&S>1?1:S,properties:m};let _=!1;if(d)try{let e=await fetch("/cart.js");if(!e.ok)throw Error(`Failed to load cart data. Status code: ${e.status}. ${e.statusText}`);_=!(await e.json()).items.find(e=>e.id===window.giftWrap?.variants[0].id);}catch(e){console.error(e);}if(d&&!_)return window.dispatchEvent(new Event("cartUpdated")),console.log("Gift wrap already in cart");let w=await fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json","X-Requested-With":"XMLHttpRequest"},body:JSON.stringify(e)}).catch(e=>{console.error("Error adding to cart:",e)||e.message;});if(!w.ok){let e=await w.json();throw Error(e.message||"Unknown error")}if(X&&l.gift_box){let e=await w.json();await ei(l.gift_box.id,l.gift_box.title,e);}window.dispatchEvent(new Event("cartUpdated")),window.dataLayer=window.dataLayer||[],window.dataLayer.push({event:"add_to_cart_track",ecommerce:{currency:et(),value:Number(Z.formatMoney(y.price,"${{amount}}").replace("$","").replace(",","")),items:[{item_list_id:`${s.id}`,item_list_name:`${s.title}`,item_id:`${y.id}`,item_name:`${s.title}`,affiliation:"Weezie Towels",currency:et(),coupon:null,discount:y.compare_at_price?Number(Z.formatMoney(y.compare_at_price,"${{amount}}").replace("$","").replace(",",""))-Number(Z.formatMoney(y.price,"${{amount}}").replace("$","").replace(",","")):0,index:0,item_brand:"Weezie Towels",item_category:`${s.type}`,item_category2:`${y.option1}`,price:Number(Z.formatMoney(y.price,"${{amount}}").replace("$","").replace(",","")),quantity:k}]}});}catch(e){console.error("addToCart error",e),alert(e.message);}},ei=async(e,t,r,i=false)=>{if(r.properties._gift_box_variant_id)return;let o=crypto.randomUUID();try{let i=await fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({id:r.key,quantity:r.quantity,properties:{...r.properties,_uuid:o,_gift_box_variant_id:e,"With Gift Box":t}})});if(!i.ok){let e=await i.json();throw Error(e)}let a={_hide_in_minicart:!0};r.properties.Status&&(a.Status=r.properties.Status),r.properties.Backorder&&(a.Backorder=r.properties.Backorder);let n=await fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({id:e,quantity:1,properties:a})});if(!n.ok){let e=await n.json();throw Error(e)}}catch(a){if(!i){let i=await fetch("/cart.js"),o=await i.json(),a=new Set(["_attribution","_source","_widget_id"]),n=o.items.find(e=>e.variant_id===r.variant_id&&((e,t)=>{for(let r of new Set([...Object.keys(e),...Object.keys(t)]))if(!a.has(r)&&e[r]!==t[r])return  false;return  true})(e.properties,r.properties));if(n)return void await ei(e,t,{...r,key:n.key},true)}let o=`Error adding Gift Box to cart: ${a?.message||"Unknown error"}`;console.error(o),alert(o);}};reactExports.useEffect(()=>{if(!window.__PRODUCT_DATA__)return;let{product:e,productOptionVals:t,productVariantInfo:r,productSliderAssets:i,embroideryFonts:o,headerBanner:a,date:n}=window.__PRODUCT_DATA__,d=t?.find(t=>t.id===e?.id),s=r?.find(t=>t.id===e?.id),u=i?.find(t=>t.id===e?.id);l(window.__PRODUCT_DATA__),c(e),_(e?.variants?.[0]),p(d),m(s),q(u),B(o),R(a),K(n?new Date(n+"T00:00:00"):new Date),g({}),Y(false);},[]),reactExports.useEffect(()=>{if(!s||!r)return;let e=r?.productOptionVals?.find(e=>e.id===s.id),t=r?.productVariantInfo?.find(e=>e.id===s.id),i=r?.productSliderAssets?.find(e=>e.id===s.id);eo(t),p(e||null),m(t||null),q(i||null);},[s]),reactExports.useEffect(()=>{let e=y,t=null,r=null;if(s&&y){let i=y.sku.split("-")[0];e=s.variants.find(e=>e.sku===i),t=s.variants.find(e=>e.sku===`${i}-E`),r=s.variants.find(e=>e.sku===`${i}-A`);}L(e),J(t),V(r);},[s,y]);let eo=e=>{if(e){let t=e?.product_variant_info.filter(e=>!e.title.includes("No Embroidery")&&!e.title.includes("No Custom Embroidery")),r=e?.product_variant_info.filter(e=>e.title.includes("No Embroidery")||e.title.includes("No Custom Embroidery"));j(0===r.length?e.product_variant_info:r),T(t);}};return O||document.body.classList.remove("disable-scroll"),jsxRuntimeExports.jsx(d$6.Provider,{value:{data:r,selectedProduct:s,currentVariant:y,embModalOpen:w,selectedProductOptionVals:u,selectedProductVariantInfo:f,swatchData:E,embroiderySwatchData:$,productSliderAssets:C,currentCount:k,visitorCountry:ee,conversionRate:{US:1,GB:.78,CA:1.38}[ee],activeQty:S,productSliderAssets:C,selectedFont:U,embVisibility:O,guideActive:D,sizeGuideVisible:N,bannerData:I,extraProperties:h,baseVariant:W,embroideryVariant:M,appliqueVariant:z,addGiftBoxIntent:X,date:H,giftCardHasErrors:Q,addToCart:er,setSelectedProduct:c,setCurrentVariant:_,setEmbModalOpen:b,setSelectedProductOptionVals:p,setSelectedProductVariantInfo:m,setSwatchData:j,setEmbroiderySwatchData:T,setProductSliderAssets:q,setCurrentCount:v,setActiveQty:x,setProductSliderAssets:q,setEmbVisibility:A,setGuideActive:P,setSizeGuideVisible:G,getCurrency:et,setExtraProperties:g,setAddGiftBoxIntent:F,setGiftCardHasErrors:Y},children:t})};const useProductContext=()=>reactExports.useContext(d$6);

var lib = {};

var slider = {};

var innerSlider = {};

var initialState = {};

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var initialState = {
	  animating: false,
	  autoplaying: null,
	  currentDirection: 0,
	  currentLeft: null,
	  currentSlide: 0,
	  direction: 1,
	  dragging: false,
	  edgeDragged: false,
	  initialized: false,
	  lazyLoadedList: [],
	  listHeight: null,
	  listWidth: null,
	  scrolling: false,
	  slideCount: null,
	  slideHeight: null,
	  slideWidth: null,
	  swipeLeft: null,
	  swiped: false,
	  // used by swipeEvent. differentites between touch and swipe.
	  swiping: false,
	  touchObject: {
	    startX: 0,
	    startY: 0,
	    curX: 0,
	    curY: 0
	  },
	  trackStyle: {},
	  trackWidth: 0,
	  targetSlide: 0
	};
	exports["default"] = initialState; 
} (initialState));

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce$1(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var lodash_debounce = debounce$1;

var classnames = {exports: {}};

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/

(function (module) {
	/* global define */

	(function () {

		var hasOwn = {}.hasOwnProperty;

		function classNames () {
			var classes = '';

			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (arg) {
					classes = appendClass(classes, parseValue(arg));
				}
			}

			return classes;
		}

		function parseValue (arg) {
			if (typeof arg === 'string' || typeof arg === 'number') {
				return arg;
			}

			if (typeof arg !== 'object') {
				return '';
			}

			if (Array.isArray(arg)) {
				return classNames.apply(null, arg);
			}

			if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
				return arg.toString();
			}

			var classes = '';

			for (var key in arg) {
				if (hasOwn.call(arg, key) && arg[key]) {
					classes = appendClass(classes, key);
				}
			}

			return classes;
		}

		function appendClass (value, newClass) {
			if (!newClass) {
				return value;
			}
		
			if (value) {
				return value + ' ' + newClass;
			}
		
			return value + newClass;
		}

		if (module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else {
			window.classNames = classNames;
		}
	}()); 
} (classnames));

var classnamesExports = classnames.exports;

var innerSliderUtils = {};

var defaultProps = {};

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireDefault(reactExports);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	var defaultProps = {
	  accessibility: true,
	  adaptiveHeight: false,
	  afterChange: null,
	  appendDots: function appendDots(dots) {
	    return /*#__PURE__*/_react["default"].createElement("ul", {
	      style: {
	        display: "block"
	      }
	    }, dots);
	  },
	  arrows: true,
	  autoplay: false,
	  autoplaySpeed: 3000,
	  beforeChange: null,
	  centerMode: false,
	  centerPadding: "50px",
	  className: "",
	  cssEase: "ease",
	  customPaging: function customPaging(i) {
	    return /*#__PURE__*/_react["default"].createElement("button", null, i + 1);
	  },
	  dots: false,
	  dotsClass: "slick-dots",
	  draggable: true,
	  easing: "linear",
	  edgeFriction: 0.35,
	  fade: false,
	  focusOnSelect: false,
	  infinite: true,
	  initialSlide: 0,
	  lazyLoad: null,
	  nextArrow: null,
	  onEdge: null,
	  onInit: null,
	  onLazyLoadError: null,
	  onReInit: null,
	  pauseOnDotsHover: false,
	  pauseOnFocus: false,
	  pauseOnHover: true,
	  prevArrow: null,
	  responsive: null,
	  rows: 1,
	  rtl: false,
	  slide: "div",
	  slidesPerRow: 1,
	  slidesToScroll: 1,
	  slidesToShow: 1,
	  speed: 500,
	  swipe: true,
	  swipeEvent: null,
	  swipeToSlide: false,
	  touchMove: true,
	  touchThreshold: 5,
	  useCSS: true,
	  useTransform: true,
	  variableWidth: false,
	  vertical: false,
	  waitForAnimate: true,
	  asNavFor: null,
	  unslick: false
	};
	exports["default"] = defaultProps; 
} (defaultProps));

Object.defineProperty(innerSliderUtils, "__esModule", {
  value: true
});
innerSliderUtils.checkSpecKeys = innerSliderUtils.checkNavigable = innerSliderUtils.changeSlide = innerSliderUtils.canUseDOM = innerSliderUtils.canGoNext = void 0;
innerSliderUtils.clamp = clamp;
innerSliderUtils.extractObject = void 0;
innerSliderUtils.filterSettings = filterSettings;
innerSliderUtils.validSettings = innerSliderUtils.swipeStart = innerSliderUtils.swipeMove = innerSliderUtils.swipeEnd = innerSliderUtils.slidesOnRight = innerSliderUtils.slidesOnLeft = innerSliderUtils.slideHandler = innerSliderUtils.siblingDirection = innerSliderUtils.safePreventDefault = innerSliderUtils.lazyStartIndex = innerSliderUtils.lazySlidesOnRight = innerSliderUtils.lazySlidesOnLeft = innerSliderUtils.lazyEndIndex = innerSliderUtils.keyHandler = innerSliderUtils.initializedState = innerSliderUtils.getWidth = innerSliderUtils.getTrackLeft = innerSliderUtils.getTrackCSS = innerSliderUtils.getTrackAnimateCSS = innerSliderUtils.getTotalSlides = innerSliderUtils.getSwipeDirection = innerSliderUtils.getSlideCount = innerSliderUtils.getRequiredLazySlides = innerSliderUtils.getPreClones = innerSliderUtils.getPostClones = innerSliderUtils.getOnDemandLazySlides = innerSliderUtils.getNavigableIndexes = innerSliderUtils.getHeight = void 0;
var _react$4 = _interopRequireDefault$4(reactExports);
var _defaultProps = _interopRequireDefault$4(defaultProps);
function _interopRequireDefault$4(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof$4(o) { "@babel/helpers - typeof"; return _typeof$4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$4(o); }
function ownKeys$4(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$4(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$4(Object(t), true).forEach(function (r) { _defineProperty$4(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$4(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty$4(obj, key, value) { key = _toPropertyKey$4(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$4(t) { var i = _toPrimitive$4(t, "string"); return "symbol" == _typeof$4(i) ? i : String(i); }
function _toPrimitive$4(t, r) { if ("object" != _typeof$4(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r); if ("object" != _typeof$4(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function clamp(number, lowerBound, upperBound) {
  return Math.max(lowerBound, Math.min(number, upperBound));
}
var safePreventDefault = innerSliderUtils.safePreventDefault = function safePreventDefault(event) {
  var passiveEvents = ["onTouchStart", "onTouchMove", "onWheel"];
  if (!passiveEvents.includes(event._reactName)) {
    event.preventDefault();
  }
};
var getOnDemandLazySlides = innerSliderUtils.getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }
  return onDemandSlides;
};

// return list of slides that need to be present
innerSliderUtils.getRequiredLazySlides = function getRequiredLazySlides(spec) {
  var requiredSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    requiredSlides.push(slideIndex);
  }
  return requiredSlides;
};

// startIndex that needs to be present
var lazyStartIndex = innerSliderUtils.lazyStartIndex = function lazyStartIndex(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};
var lazyEndIndex = innerSliderUtils.lazyEndIndex = function lazyEndIndex(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};
var lazySlidesOnLeft = innerSliderUtils.lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};
var lazySlidesOnRight = innerSliderUtils.lazySlidesOnRight = function lazySlidesOnRight(spec) {
  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
};

// get width of an element
var getWidth = innerSliderUtils.getWidth = function getWidth(elem) {
  return elem && elem.offsetWidth || 0;
};
var getHeight = innerSliderUtils.getHeight = function getHeight(elem) {
  return elem && elem.offsetHeight || 0;
};
var getSwipeDirection = innerSliderUtils.getSwipeDirection = function getSwipeDirection(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var xDist, yDist, r, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r * 180 / Math.PI);
  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }
  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return "left";
  }
  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return "right";
  }
  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return "up";
    } else {
      return "down";
    }
  }
  return "vertical";
};

// whether or not we can go next
var canGoNext = innerSliderUtils.canGoNext = function canGoNext(spec) {
  var canGo = true;
  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
      canGo = false;
    }
  }
  return canGo;
};

// given an object and a list of keys, return new object with given keys
innerSliderUtils.extractObject = function extractObject(spec, keys) {
  var newObject = {};
  keys.forEach(function (key) {
    return newObject[key] = spec[key];
  });
  return newObject;
};

// get initialized state
innerSliderUtils.initializedState = function initializedState(spec) {
  // spec also contains listRef, trackRef
  var slideCount = _react$4["default"].Children.count(spec.children);
  var listNode = spec.listRef;
  var listWidth = Math.ceil(getWidth(listNode));
  var trackNode = spec.trackRef && spec.trackRef.node;
  var trackWidth = Math.ceil(getWidth(trackNode));
  var slideWidth;
  if (!spec.vertical) {
    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
      centerPaddingAdj *= listWidth / 100;
    }
    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }
  var slideHeight = listNode && getHeight(listNode.querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
  if (spec.rtl && spec.currentSlide === undefined) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }
  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides(_objectSpread$4(_objectSpread$4({}, spec), {}, {
    currentSlide: currentSlide,
    lazyLoadedList: lazyLoadedList
  }));
  lazyLoadedList = lazyLoadedList.concat(slidesToLoad);
  var state = {
    slideCount: slideCount,
    slideWidth: slideWidth,
    listWidth: listWidth,
    trackWidth: trackWidth,
    currentSlide: currentSlide,
    slideHeight: slideHeight,
    listHeight: listHeight,
    lazyLoadedList: lazyLoadedList
  };
  if (spec.autoplaying === null && spec.autoplay) {
    state["autoplaying"] = "playing";
  }
  return state;
};
innerSliderUtils.slideHandler = function slideHandler(spec) {
  var waitForAnimate = spec.waitForAnimate,
    animating = spec.animating,
    fade = spec.fade,
    infinite = spec.infinite,
    index = spec.index,
    slideCount = spec.slideCount,
    lazyLoad = spec.lazyLoad,
    currentSlide = spec.currentSlide,
    centerMode = spec.centerMode,
    slidesToScroll = spec.slidesToScroll,
    slidesToShow = spec.slidesToShow,
    useCSS = spec.useCSS;
  var lazyLoadedList = spec.lazyLoadedList;
  if (waitForAnimate && animating) return {};
  var animationSlide = index,
    finalSlide,
    animationLeft,
    finalLeft;
  var state = {},
    nextState = {};
  var targetSlide = infinite ? index : clamp(index, 0, slideCount - 1);
  if (fade) {
    if (!infinite && (index < 0 || index >= slideCount)) return {};
    if (index < 0) {
      animationSlide = index + slideCount;
    } else if (index >= slideCount) {
      animationSlide = index - slideCount;
    }
    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList = lazyLoadedList.concat(animationSlide);
    }
    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList: lazyLoadedList,
      targetSlide: animationSlide
    };
    nextState = {
      animating: false,
      targetSlide: animationSlide
    };
  } else {
    finalSlide = animationSlide;
    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
    }
    if (!infinite && animationSlide + slidesToShow >= slideCount) {
      finalSlide = slideCount - slidesToShow;
    }
    animationLeft = getTrackLeft(_objectSpread$4(_objectSpread$4({}, spec), {}, {
      slideIndex: animationSlide
    }));
    finalLeft = getTrackLeft(_objectSpread$4(_objectSpread$4({}, spec), {}, {
      slideIndex: finalSlide
    }));
    if (!infinite) {
      if (animationLeft === finalLeft) animationSlide = finalSlide;
      animationLeft = finalLeft;
    }
    if (lazyLoad) {
      lazyLoadedList = lazyLoadedList.concat(getOnDemandLazySlides(_objectSpread$4(_objectSpread$4({}, spec), {}, {
        currentSlide: animationSlide
      })));
    }
    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread$4(_objectSpread$4({}, spec), {}, {
          left: finalLeft
        })),
        lazyLoadedList: lazyLoadedList,
        targetSlide: targetSlide
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS(_objectSpread$4(_objectSpread$4({}, spec), {}, {
          left: animationLeft
        })),
        lazyLoadedList: lazyLoadedList,
        targetSlide: targetSlide
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread$4(_objectSpread$4({}, spec), {}, {
          left: finalLeft
        })),
        swipeLeft: null,
        targetSlide: targetSlide
      };
    }
  }
  return {
    state: state,
    nextState: nextState
  };
};
innerSliderUtils.changeSlide = function changeSlide(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll,
    slidesToShow = spec.slidesToShow,
    slideCount = spec.slideCount,
    currentSlide = spec.currentSlide,
    previousTargetSlide = spec.targetSlide,
    lazyLoad = spec.lazyLoad,
    infinite = spec.infinite;
  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
  if (options.message === "previous") {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;
    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }
    if (!infinite) {
      targetSlide = previousTargetSlide - slidesToScroll;
    }
  } else if (options.message === "next") {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;
    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }
    if (!infinite) {
      targetSlide = previousTargetSlide + slidesToScroll;
    }
  } else if (options.message === "dots") {
    // Click on dots
    targetSlide = options.index * options.slidesToScroll;
  } else if (options.message === "children") {
    // Click on the slides
    targetSlide = options.index;
    if (infinite) {
      var direction = siblingDirection(_objectSpread$4(_objectSpread$4({}, spec), {}, {
        targetSlide: targetSlide
      }));
      if (targetSlide > options.currentSlide && direction === "left") {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === "right") {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === "index") {
    targetSlide = Number(options.index);
  }
  return targetSlide;
};
innerSliderUtils.keyHandler = function keyHandler(e, accessibility, rtl) {
  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
  if (e.keyCode === 37) return rtl ? "next" : "previous";
  if (e.keyCode === 39) return rtl ? "previous" : "next";
  return "";
};
innerSliderUtils.swipeStart = function swipeStart(e, swipe, draggable) {
  e.target.tagName === "IMG" && safePreventDefault(e);
  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
  return {
    dragging: true,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};
innerSliderUtils.swipeMove = function swipeMove(e, spec) {
  // spec also contains, trackRef and slideIndex
  var scrolling = spec.scrolling,
    animating = spec.animating,
    vertical = spec.vertical,
    swipeToSlide = spec.swipeToSlide,
    verticalSwiping = spec.verticalSwiping,
    rtl = spec.rtl,
    currentSlide = spec.currentSlide,
    edgeFriction = spec.edgeFriction,
    edgeDragged = spec.edgeDragged,
    onEdge = spec.onEdge,
    swiped = spec.swiped,
    swiping = spec.swiping,
    slideCount = spec.slideCount,
    slidesToScroll = spec.slidesToScroll,
    infinite = spec.infinite,
    touchObject = spec.touchObject,
    swipeEvent = spec.swipeEvent,
    listHeight = spec.listHeight,
    listWidth = spec.listWidth;
  if (scrolling) return;
  if (animating) return safePreventDefault(e);
  if (vertical && swipeToSlide && verticalSwiping) safePreventDefault(e);
  var swipeLeft,
    state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return {
      scrolling: true
    };
  }
  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;
  if (!infinite) {
    if (currentSlide === 0 && (swipeDirection === "right" || swipeDirection === "down") || currentSlide + 1 >= dotCount && (swipeDirection === "left" || swipeDirection === "up") || !canGoNext(spec) && (swipeDirection === "left" || swipeDirection === "up")) {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;
      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state["edgeDragged"] = true;
      }
    }
  }
  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state["swiped"] = true;
  }
  if (!vertical) {
    if (!rtl) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }
  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }
  state = _objectSpread$4(_objectSpread$4({}, state), {}, {
    touchObject: touchObject,
    swipeLeft: swipeLeft,
    trackStyle: getTrackCSS(_objectSpread$4(_objectSpread$4({}, spec), {}, {
      left: swipeLeft
    }))
  });
  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }
  if (touchObject.swipeLength > 10) {
    state["swiping"] = true;
    safePreventDefault(e);
  }
  return state;
};
innerSliderUtils.swipeEnd = function swipeEnd(e, spec) {
  var dragging = spec.dragging,
    swipe = spec.swipe,
    touchObject = spec.touchObject,
    listWidth = spec.listWidth,
    touchThreshold = spec.touchThreshold,
    verticalSwiping = spec.verticalSwiping,
    listHeight = spec.listHeight,
    swipeToSlide = spec.swipeToSlide,
    scrolling = spec.scrolling,
    onSwipe = spec.onSwipe,
    targetSlide = spec.targetSlide,
    currentSlide = spec.currentSlide,
    infinite = spec.infinite;
  if (!dragging) {
    if (swipe) safePreventDefault(e);
    return {};
  }
  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping);
  // reset the state of touch related state variables.
  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };
  if (scrolling) {
    return state;
  }
  if (!touchObject.swipeLength) {
    return state;
  }
  if (touchObject.swipeLength > minSwipe) {
    safePreventDefault(e);
    if (onSwipe) {
      onSwipe(swipeDirection);
    }
    var slideCount, newSlide;
    var activeSlide = infinite ? currentSlide : targetSlide;
    switch (swipeDirection) {
      case "left":
      case "up":
        newSlide = activeSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 0;
        break;
      case "right":
      case "down":
        newSlide = activeSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 1;
        break;
      default:
        slideCount = activeSlide;
    }
    state["triggerSlideHandler"] = slideCount;
  } else {
    // Adjust the track back to it's original position.
    var currentLeft = getTrackLeft(spec);
    state["trackStyle"] = getTrackAnimateCSS(_objectSpread$4(_objectSpread$4({}, spec), {}, {
      left: currentLeft
    }));
  }
  return state;
};
var getNavigableIndexes = innerSliderUtils.getNavigableIndexes = function getNavigableIndexes(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];
  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }
  return indexes;
};
var checkNavigable = innerSliderUtils.checkNavigable = function checkNavigable(spec, index) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;
  if (index > navigables[navigables.length - 1]) {
    index = navigables[navigables.length - 1];
  } else {
    for (var n in navigables) {
      if (index < navigables[n]) {
        index = prevNavigable;
        break;
      }
      prevNavigable = navigables[n];
    }
  }
  return index;
};
var getSlideCount = innerSliderUtils.getSlideCount = function getSlideCount(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
  if (spec.swipeToSlide) {
    var swipedSlide;
    var slickList = spec.listRef;
    var slides = slickList.querySelectorAll && slickList.querySelectorAll(".slick-slide") || [];
    Array.from(slides).every(function (slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }
      return true;
    });
    if (!swipedSlide) {
      return 0;
    }
    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
};
var checkSpecKeys = innerSliderUtils.checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error("Keys Missing:", spec);
};
var getTrackCSS = innerSliderUtils.getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var trackWidth, trackHeight;
  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }
  var style = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };
  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
    style = _objectSpread$4(_objectSpread$4({}, style), {}, {
      WebkitTransform: WebkitTransform,
      transform: transform,
      msTransform: msTransform
    });
  } else {
    if (spec.vertical) {
      style["top"] = spec.left;
    } else {
      style["left"] = spec.left;
    }
  }
  if (spec.fade) style = {
    opacity: 1
  };
  if (trackWidth) style.width = trackWidth;
  if (trackHeight) style.height = trackHeight;

  // Fallback for IE8
  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + "px";
    } else {
      style.marginTop = spec.left + "px";
    }
  }
  return style;
};
var getTrackAnimateCSS = innerSliderUtils.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var style = getTrackCSS(spec);
  // useCSS is true by default so it can be undefined
  if (spec.useTransform) {
    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
  } else {
    if (spec.vertical) {
      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    } else {
      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    }
  }
  return style;
};
var getTrackLeft = innerSliderUtils.getTrackLeft = function getTrackLeft(spec) {
  if (spec.unslick) {
    return 0;
  }
  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
  var slideIndex = spec.slideIndex,
    trackRef = spec.trackRef,
    infinite = spec.infinite,
    centerMode = spec.centerMode,
    slideCount = spec.slideCount,
    slidesToShow = spec.slidesToShow,
    slidesToScroll = spec.slidesToScroll,
    slideWidth = spec.slideWidth,
    listWidth = spec.listWidth,
    variableWidth = spec.variableWidth,
    slideHeight = spec.slideHeight,
    fade = spec.fade,
    vertical = spec.vertical;
  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;
  if (fade || spec.slideCount === 1) {
    return 0;
  }
  var slidesToOffset = 0;
  if (infinite) {
    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    }
    // shift current slide to center of the frame
    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }
    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }
  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;
  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }
  if (variableWidth === true) {
    var targetSlideIndex;
    var trackElem = trackRef && trackRef.node;
    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;
      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }
      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }
  return targetLeft;
};
var getPreClones = innerSliderUtils.getPreClones = function getPreClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  if (spec.variableWidth) {
    return spec.slideCount;
  }
  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};
var getPostClones = innerSliderUtils.getPostClones = function getPostClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  return spec.slideCount;
};
var getTotalSlides = innerSliderUtils.getTotalSlides = function getTotalSlides(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};
var siblingDirection = innerSliderUtils.siblingDirection = function siblingDirection(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return "left";
    }
    return "right";
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return "right";
    }
    return "left";
  }
};
var slidesOnRight = innerSliderUtils.slidesOnRight = function slidesOnRight(_ref) {
  var slidesToShow = _ref.slidesToShow,
    centerMode = _ref.centerMode,
    rtl = _ref.rtl,
    centerPadding = _ref.centerPadding;
  // returns no of slides on the right of active slide
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) right += 1;
    if (rtl && slidesToShow % 2 === 0) right += 1;
    return right;
  }
  if (rtl) {
    return 0;
  }
  return slidesToShow - 1;
};
var slidesOnLeft = innerSliderUtils.slidesOnLeft = function slidesOnLeft(_ref2) {
  var slidesToShow = _ref2.slidesToShow,
    centerMode = _ref2.centerMode,
    rtl = _ref2.rtl,
    centerPadding = _ref2.centerPadding;
  // returns no of slides on the left of active slide
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) left += 1;
    if (!rtl && slidesToShow % 2 === 0) left += 1;
    return left;
  }
  if (rtl) {
    return slidesToShow - 1;
  }
  return 0;
};
innerSliderUtils.canUseDOM = function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};
var validSettings = innerSliderUtils.validSettings = Object.keys(_defaultProps["default"]);
function filterSettings(settings) {
  return validSettings.reduce(function (acc, settingName) {
    if (settings.hasOwnProperty(settingName)) {
      acc[settingName] = settings[settingName];
    }
    return acc;
  }, {});
}

var track = {};

Object.defineProperty(track, "__esModule", {
  value: true
});
track.Track = void 0;
var _react$3 = _interopRequireDefault$3(reactExports);
var _classnames$3 = _interopRequireDefault$3(classnamesExports);
var _innerSliderUtils$3 = innerSliderUtils;
function _interopRequireDefault$3(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof$3(o) { "@babel/helpers - typeof"; return _typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$3(o); }
function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
function _classCallCheck$3(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$3(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey$3(descriptor.key), descriptor); } }
function _createClass$3(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$3(Constructor.prototype, protoProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits$3(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$3(subClass, superClass); }
function _setPrototypeOf$3(o, p) { _setPrototypeOf$3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$3(o, p); }
function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf$3(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$3(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$3(this, result); }; }
function _possibleConstructorReturn$3(self, call) { if (call && (_typeof$3(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$3(self); }
function _assertThisInitialized$3(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$3() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$3 = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf$3(o) { _getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$3(o); }
function ownKeys$3(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$3(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$3(Object(t), true).forEach(function (r) { _defineProperty$3(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$3(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty$3(obj, key, value) { key = _toPropertyKey$3(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$3(t) { var i = _toPrimitive$3(t, "string"); return "symbol" == _typeof$3(i) ? i : String(i); }
function _toPrimitive$3(t, r) { if ("object" != _typeof$3(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r); if ("object" != _typeof$3(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;
  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }
  slickCloned = index < 0 || index >= spec.slideCount;
  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }
  var focusedSlide;
  if (spec.targetSlide < 0) {
    focusedSlide = spec.targetSlide + spec.slideCount;
  } else if (spec.targetSlide >= spec.slideCount) {
    focusedSlide = spec.targetSlide - spec.slideCount;
  } else {
    focusedSlide = spec.targetSlide;
  }
  var slickCurrent = index === focusedSlide;
  return {
    "slick-slide": true,
    "slick-active": slickActive,
    "slick-center": slickCenter,
    "slick-cloned": slickCloned,
    "slick-current": slickCurrent // dubious in case of RTL
  };
};
var getSlideStyle = function getSlideStyle(spec) {
  var style = {};
  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }
  if (spec.fade) {
    style.position = "relative";
    if (spec.vertical) {
      style.top = -spec.index * parseInt(spec.slideHeight);
    } else {
      style.left = -spec.index * parseInt(spec.slideWidth);
    }
    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
    style.zIndex = spec.currentSlide === spec.index ? 999 : 998;
    if (spec.useCSS) {
      style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    }
  }
  return style;
};
var getKey = function getKey(child, fallbackKey) {
  return child.key || fallbackKey;
};
var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];
  var childrenCount = _react$3["default"].Children.count(spec.children);
  var startIndex = (0, _innerSliderUtils$3.lazyStartIndex)(spec);
  var endIndex = (0, _innerSliderUtils$3.lazyEndIndex)(spec);
  _react$3["default"].Children.forEach(spec.children, function (elem, index) {
    var child;
    var childOnClickOptions = {
      message: "children",
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    };

    // in case of lazyLoad, whether or not we want to fetch the slide
    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
      child = elem;
    } else {
      child = /*#__PURE__*/_react$3["default"].createElement("div", null);
    }
    var childStyle = getSlideStyle(_objectSpread$3(_objectSpread$3({}, spec), {}, {
      index: index
    }));
    var slideClass = child.props.className || "";
    var slideClasses = getSlideClasses(_objectSpread$3(_objectSpread$3({}, spec), {}, {
      index: index
    }));
    // push a cloned element of the desired slide
    slides.push( /*#__PURE__*/_react$3["default"].cloneElement(child, {
      key: "original" + getKey(child, index),
      "data-index": index,
      className: (0, _classnames$3["default"])(slideClasses, slideClass),
      tabIndex: "-1",
      "aria-hidden": !slideClasses["slick-active"],
      style: _objectSpread$3(_objectSpread$3({
        outline: "none"
      }, child.props.style || {}), childStyle),
      onClick: function onClick(e) {
        child.props && child.props.onClick && child.props.onClick(e);
        if (spec.focusOnSelect) {
          spec.focusOnSelect(childOnClickOptions);
        }
      }
    }));

    // if slide needs to be precloned or postcloned
    if (spec.infinite && spec.fade === false) {
      var preCloneNo = childrenCount - index;
      if (preCloneNo <= (0, _innerSliderUtils$3.getPreClones)(spec)) {
        key = -preCloneNo;
        if (key >= startIndex) {
          child = elem;
        }
        slideClasses = getSlideClasses(_objectSpread$3(_objectSpread$3({}, spec), {}, {
          index: key
        }));
        preCloneSlides.push( /*#__PURE__*/_react$3["default"].cloneElement(child, {
          key: "precloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames$3["default"])(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _objectSpread$3(_objectSpread$3({}, child.props.style || {}), childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);
            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }
      key = childrenCount + index;
      if (key < endIndex) {
        child = elem;
      }
      slideClasses = getSlideClasses(_objectSpread$3(_objectSpread$3({}, spec), {}, {
        index: key
      }));
      postCloneSlides.push( /*#__PURE__*/_react$3["default"].cloneElement(child, {
        key: "postcloned" + getKey(child, key),
        "data-index": key,
        tabIndex: "-1",
        className: (0, _classnames$3["default"])(slideClasses, slideClass),
        "aria-hidden": !slideClasses["slick-active"],
        style: _objectSpread$3(_objectSpread$3({}, child.props.style || {}), childStyle),
        onClick: function onClick(e) {
          child.props && child.props.onClick && child.props.onClick(e);
          if (spec.focusOnSelect) {
            spec.focusOnSelect(childOnClickOptions);
          }
        }
      }));
    }
  });
  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};
track.Track = /*#__PURE__*/function (_React$PureComponent) {
  _inherits$3(Track, _React$PureComponent);
  var _super = _createSuper$3(Track);
  function Track() {
    var _this;
    _classCallCheck$3(this, Track);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$3(_assertThisInitialized$3(_this), "node", null);
    _defineProperty$3(_assertThisInitialized$3(_this), "handleRef", function (ref) {
      _this.node = ref;
    });
    return _this;
  }
  _createClass$3(Track, [{
    key: "render",
    value: function render() {
      var slides = renderSlides(this.props);
      var _this$props = this.props,
        onMouseEnter = _this$props.onMouseEnter,
        onMouseOver = _this$props.onMouseOver,
        onMouseLeave = _this$props.onMouseLeave;
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      return /*#__PURE__*/_react$3["default"].createElement("div", _extends$2({
        ref: this.handleRef,
        className: "slick-track",
        style: this.props.trackStyle
      }, mouseEvents), slides);
    }
  }]);
  return Track;
}(_react$3["default"].PureComponent);

var dots = {};

function _typeof$2(o) { "@babel/helpers - typeof"; return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$2(o); }
Object.defineProperty(dots, "__esModule", {
  value: true
});
dots.Dots = void 0;
var _react$2 = _interopRequireDefault$2(reactExports);
var _classnames$2 = _interopRequireDefault$2(classnamesExports);
var _innerSliderUtils$2 = innerSliderUtils;
function _interopRequireDefault$2(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys$2(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$2(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2(Object(t), true).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty$2(obj, key, value) { key = _toPropertyKey$2(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$2(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey$2(descriptor.key), descriptor); } }
function _createClass$2(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$2(Constructor.prototype, protoProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey$2(t) { var i = _toPrimitive$2(t, "string"); return "symbol" == _typeof$2(i) ? i : String(i); }
function _toPrimitive$2(t, r) { if ("object" != _typeof$2(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r); if ("object" != _typeof$2(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return (String )(t); }
function _inherits$2(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$2(subClass, superClass); }
function _setPrototypeOf$2(o, p) { _setPrototypeOf$2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$2(o, p); }
function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf$2(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$2(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$2(this, result); }; }
function _possibleConstructorReturn$2(self, call) { if (call && (_typeof$2(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$2(self); }
function _assertThisInitialized$2(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$2() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$2 = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf$2(o) { _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$2(o); }
var getDotCount = function getDotCount(spec) {
  var dots;
  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  }
  return dots;
};
dots.Dots = /*#__PURE__*/function (_React$PureComponent) {
  _inherits$2(Dots, _React$PureComponent);
  var _super = _createSuper$2(Dots);
  function Dots() {
    _classCallCheck$2(this, Dots);
    return _super.apply(this, arguments);
  }
  _createClass$2(Dots, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      // In Autoplay the focus stays on clicked button even after transition
      // to next slide. That only goes away by click somewhere outside
      e.preventDefault();
      this.props.clickHandler(options);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        onMouseEnter = _this$props.onMouseEnter,
        onMouseOver = _this$props.onMouseOver,
        onMouseLeave = _this$props.onMouseLeave,
        infinite = _this$props.infinite,
        slidesToScroll = _this$props.slidesToScroll,
        slidesToShow = _this$props.slidesToShow,
        slideCount = _this$props.slideCount,
        currentSlide = _this$props.currentSlide;
      var dotCount = getDotCount({
        slideCount: slideCount,
        slidesToScroll: slidesToScroll,
        slidesToShow: slidesToShow,
        infinite: infinite
      });
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      var dots = [];
      for (var i = 0; i < dotCount; i++) {
        var _rightBound = (i + 1) * slidesToScroll - 1;
        var rightBound = infinite ? _rightBound : (0, _innerSliderUtils$2.clamp)(_rightBound, 0, slideCount - 1);
        var _leftBound = rightBound - (slidesToScroll - 1);
        var leftBound = infinite ? _leftBound : (0, _innerSliderUtils$2.clamp)(_leftBound, 0, slideCount - 1);
        var className = (0, _classnames$2["default"])({
          "slick-active": infinite ? currentSlide >= leftBound && currentSlide <= rightBound : currentSlide === leftBound
        });
        var dotOptions = {
          message: "dots",
          index: i,
          slidesToScroll: slidesToScroll,
          currentSlide: currentSlide
        };
        var onClick = this.clickHandler.bind(this, dotOptions);
        dots = dots.concat( /*#__PURE__*/_react$2["default"].createElement("li", {
          key: i,
          className: className
        }, /*#__PURE__*/_react$2["default"].cloneElement(this.props.customPaging(i), {
          onClick: onClick
        })));
      }
      return /*#__PURE__*/_react$2["default"].cloneElement(this.props.appendDots(dots), _objectSpread$2({
        className: this.props.dotsClass
      }, mouseEvents));
    }
  }]);
  return Dots;
}(_react$2["default"].PureComponent);

var arrows = {};

function _typeof$1(o) { "@babel/helpers - typeof"; return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$1(o); }
Object.defineProperty(arrows, "__esModule", {
  value: true
});
arrows.PrevArrow = arrows.NextArrow = void 0;
var _react$1 = _interopRequireDefault$1(reactExports);
var _classnames$1 = _interopRequireDefault$1(classnamesExports);
var _innerSliderUtils$1 = innerSliderUtils;
function _interopRequireDefault$1(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), true).forEach(function (r) { _defineProperty$1(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty$1(obj, key, value) { key = _toPropertyKey$1(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$1(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey$1(descriptor.key), descriptor); } }
function _createClass$1(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$1(Constructor.prototype, protoProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey$1(t) { var i = _toPrimitive$1(t, "string"); return "symbol" == _typeof$1(i) ? i : String(i); }
function _toPrimitive$1(t, r) { if ("object" != _typeof$1(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r); if ("object" != _typeof$1(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return (String )(t); }
function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$1(subClass, superClass); }
function _setPrototypeOf$1(o, p) { _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$1(o, p); }
function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }
function _possibleConstructorReturn$1(self, call) { if (call && (_typeof$1(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$1(self); }
function _assertThisInitialized$1(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$1() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1 = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf$1(o) { _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$1(o); }
arrows.PrevArrow = /*#__PURE__*/function (_React$PureComponent) {
  _inherits$1(PrevArrow, _React$PureComponent);
  var _super = _createSuper$1(PrevArrow);
  function PrevArrow() {
    _classCallCheck$1(this, PrevArrow);
    return _super.apply(this, arguments);
  }
  _createClass$1(PrevArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }
      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var prevClasses = {
        "slick-arrow": true,
        "slick-prev": true
      };
      var prevHandler = this.clickHandler.bind(this, {
        message: "previous"
      });
      if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
        prevClasses["slick-disabled"] = true;
        prevHandler = null;
      }
      var prevArrowProps = {
        key: "0",
        "data-role": "none",
        className: (0, _classnames$1["default"])(prevClasses),
        style: {
          display: "block"
        },
        onClick: prevHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var prevArrow;
      if (this.props.prevArrow) {
        prevArrow = /*#__PURE__*/_react$1["default"].cloneElement(this.props.prevArrow, _objectSpread$1(_objectSpread$1({}, prevArrowProps), customProps));
      } else {
        prevArrow = /*#__PURE__*/_react$1["default"].createElement("button", _extends$1({
          key: "0",
          type: "button"
        }, prevArrowProps), " ", "Previous");
      }
      return prevArrow;
    }
  }]);
  return PrevArrow;
}(_react$1["default"].PureComponent);
arrows.NextArrow = /*#__PURE__*/function (_React$PureComponent2) {
  _inherits$1(NextArrow, _React$PureComponent2);
  var _super2 = _createSuper$1(NextArrow);
  function NextArrow() {
    _classCallCheck$1(this, NextArrow);
    return _super2.apply(this, arguments);
  }
  _createClass$1(NextArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }
      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var nextClasses = {
        "slick-arrow": true,
        "slick-next": true
      };
      var nextHandler = this.clickHandler.bind(this, {
        message: "next"
      });
      if (!(0, _innerSliderUtils$1.canGoNext)(this.props)) {
        nextClasses["slick-disabled"] = true;
        nextHandler = null;
      }
      var nextArrowProps = {
        key: "1",
        "data-role": "none",
        className: (0, _classnames$1["default"])(nextClasses),
        style: {
          display: "block"
        },
        onClick: nextHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var nextArrow;
      if (this.props.nextArrow) {
        nextArrow = /*#__PURE__*/_react$1["default"].cloneElement(this.props.nextArrow, _objectSpread$1(_objectSpread$1({}, nextArrowProps), customProps));
      } else {
        nextArrow = /*#__PURE__*/_react$1["default"].createElement("button", _extends$1({
          key: "1",
          type: "button"
        }, nextArrowProps), " ", "Next");
      }
      return nextArrow;
    }
  }]);
  return NextArrow;
}(_react$1["default"].PureComponent);

Object.defineProperty(innerSlider, "__esModule", {
  value: true
});
innerSlider.InnerSlider = void 0;
var _react = _interopRequireDefault(reactExports);
var _initialState = _interopRequireDefault(initialState);
var _lodash = _interopRequireDefault(lodash_debounce);
var _classnames = _interopRequireDefault(classnamesExports);
var _innerSliderUtils = innerSliderUtils;
var _track = track;
var _dots = dots;
var _arrows = arrows;
var _resizeObserverPolyfill = _interopRequireDefault(require$$8);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
innerSlider.InnerSlider = /*#__PURE__*/function (_React$Component) {
  _inherits(InnerSlider, _React$Component);
  var _super = _createSuper(InnerSlider);
  function InnerSlider(props) {
    var _this;
    _classCallCheck(this, InnerSlider);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "listRefHandler", function (ref) {
      return _this.list = ref;
    });
    _defineProperty(_assertThisInitialized(_this), "trackRefHandler", function (ref) {
      return _this.track = ref;
    });
    _defineProperty(_assertThisInitialized(_this), "adaptHeight", function () {
      if (_this.props.adaptiveHeight && _this.list) {
        var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));
        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
      }
    });
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.props.onInit && _this.props.onInit();
      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, _this.props), _this.state));
        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
      var spec = _objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props);
      _this.updateState(spec, true, function () {
        _this.adaptHeight();
        _this.props.autoplay && _this.autoPlay("update");
      });
      if (_this.props.lazyLoad === "progressive") {
        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
      }
      _this.ro = new _resizeObserverPolyfill["default"](function () {
        if (_this.state.animating) {
          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
          _this.callbackTimers.push(setTimeout(function () {
            return _this.onWindowResized();
          }, _this.props.speed));
        } else {
          _this.onWindowResized();
        }
      });
      _this.ro.observe(_this.list);
      document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
      });
      if (window.addEventListener) {
        window.addEventListener("resize", _this.onWindowResized);
      } else {
        window.attachEvent("onresize", _this.onWindowResized);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      if (_this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
      }
      if (_this.lazyLoadTimer) {
        clearInterval(_this.lazyLoadTimer);
      }
      if (_this.callbackTimers.length) {
        _this.callbackTimers.forEach(function (timer) {
          return clearTimeout(timer);
        });
        _this.callbackTimers = [];
      }
      if (window.addEventListener) {
        window.removeEventListener("resize", _this.onWindowResized);
      } else {
        window.detachEvent("onresize", _this.onWindowResized);
      }
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
      _this.ro.disconnect();
    });
    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      _this.checkImagesLoad();
      _this.props.onReInit && _this.props.onReInit();
      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, _this.props), _this.state));
        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
      // if (this.props.onLazyLoad) {
      //   this.props.onLazyLoad([leftMostSlide])
      // }
      _this.adaptHeight();
      var spec = _objectSpread(_objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props), _this.state);
      var setTrackStyle = _this.didPropsChange(prevProps);
      setTrackStyle && _this.updateState(spec, setTrackStyle, function () {
        if (_this.state.currentSlide >= _react["default"].Children.count(_this.props.children)) {
          _this.changeSlide({
            message: "index",
            index: _react["default"].Children.count(_this.props.children) - _this.props.slidesToShow,
            currentSlide: _this.state.currentSlide
          });
        }
        if (_this.props.autoplay) {
          _this.autoPlay("update");
        } else {
          _this.pause("paused");
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onWindowResized", function (setTrackStyle) {
      if (_this.debouncedResize) _this.debouncedResize.cancel();
      _this.debouncedResize = (0, _lodash["default"])(function () {
        return _this.resizeWindow(setTrackStyle);
      }, 50);
      _this.debouncedResize();
    });
    _defineProperty(_assertThisInitialized(_this), "resizeWindow", function () {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var isTrackMounted = Boolean(_this.track && _this.track.node);
      // prevent warning: setting state on unmounted component (server side rendering)
      if (!isTrackMounted) return;
      var spec = _objectSpread(_objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props), _this.state);
      _this.updateState(spec, setTrackStyle, function () {
        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
      });
      // animating state should be cleared while resizing, otherwise autoplay stops working
      _this.setState({
        animating: false
      });
      clearTimeout(_this.animationEndCallback);
      delete _this.animationEndCallback;
    });
    _defineProperty(_assertThisInitialized(_this), "updateState", function (spec, setTrackStyle, callback) {
      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
      spec = _objectSpread(_objectSpread(_objectSpread({}, spec), updatedState), {}, {
        slideIndex: updatedState.currentSlide
      });
      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
      spec = _objectSpread(_objectSpread({}, spec), {}, {
        left: targetLeft
      });
      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
      if (setTrackStyle || _react["default"].Children.count(_this.props.children) !== _react["default"].Children.count(spec.children)) {
        updatedState["trackStyle"] = trackStyle;
      }
      _this.setState(updatedState, callback);
    });
    _defineProperty(_assertThisInitialized(_this), "ssrInit", function () {
      if (_this.props.variableWidth) {
        var _trackWidth = 0,
          _trackLeft = 0;
        var childrenWidths = [];
        var preClones = (0, _innerSliderUtils.getPreClones)(_objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
          slideCount: _this.props.children.length
        }));
        var postClones = (0, _innerSliderUtils.getPostClones)(_objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
          slideCount: _this.props.children.length
        }));
        _this.props.children.forEach(function (child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });
        for (var i = 0; i < preClones; i++) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
        }
        for (var _i = 0; _i < postClones; _i++) {
          _trackWidth += childrenWidths[_i];
        }
        for (var _i2 = 0; _i2 < _this.state.currentSlide; _i2++) {
          _trackLeft += childrenWidths[_i2];
        }
        var _trackStyle = {
          width: _trackWidth + "px",
          left: -_trackLeft + "px"
        };
        if (_this.props.centerMode) {
          var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
          _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
        }
        return {
          trackStyle: _trackStyle
        };
      }
      var childrenCount = _react["default"].Children.count(_this.props.children);
      var spec = _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        slideCount: childrenCount
      });
      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
      if (_this.props.centerMode) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }
      var trackStyle = {
        width: trackWidth + "%",
        left: trackLeft + "%"
      };
      return {
        slideWidth: slideWidth + "%",
        trackStyle: trackStyle
      };
    });
    _defineProperty(_assertThisInitialized(_this), "checkImagesLoad", function () {
      var images = _this.list && _this.list.querySelectorAll && _this.list.querySelectorAll(".slick-slide img") || [];
      var imagesCount = images.length,
        loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
        };
        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;
          image.onclick = function (e) {
            prevClickHandler(e);
            image.parentNode.focus();
          };
        }
        if (!image.onload) {
          if (_this.props.lazyLoad) {
            image.onload = function () {
              _this.adaptHeight();
              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
            };
          } else {
            image.onload = handler;
            image.onerror = function () {
              handler();
              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
            };
          }
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "progressiveLazyLoad", function () {
      var slidesToLoad = [];
      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);
      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }
      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }
      if (slidesToLoad.length > 0) {
        _this.setState(function (state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });
        if (_this.props.onLazyLoad) {
          _this.props.onLazyLoad(slidesToLoad);
        }
      } else {
        if (_this.lazyLoadTimer) {
          clearInterval(_this.lazyLoadTimer);
          delete _this.lazyLoadTimer;
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "slideHandler", function (index) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
        asNavFor = _this$props.asNavFor,
        beforeChange = _this$props.beforeChange,
        onLazyLoad = _this$props.onLazyLoad,
        speed = _this$props.speed,
        afterChange = _this$props.afterChange; // capture currentslide before state is updated
      var currentSlide = _this.state.currentSlide;
      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_objectSpread(_objectSpread(_objectSpread({
          index: index
        }, _this.props), _this.state), {}, {
          trackRef: _this.track,
          useCSS: _this.props.useCSS && !dontAnimate
        })),
        state = _slideHandler.state,
        nextState = _slideHandler.nextState;
      if (!state) return;
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
      if (!_this.props.waitForAnimate && _this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
        afterChange && afterChange(currentSlide);
        delete _this.animationEndCallback;
      }
      _this.setState(state, function () {
        // asNavForIndex check is to avoid recursive calls of slideHandler in waitForAnimate=false mode
        if (asNavFor && _this.asNavForIndex !== index) {
          _this.asNavForIndex = index;
          asNavFor.innerSlider.slideHandler(index);
        }
        if (!nextState) return;
        _this.animationEndCallback = setTimeout(function () {
          var animating = nextState.animating,
            firstBatch = _objectWithoutProperties(nextState, ["animating"]);
          _this.setState(firstBatch, function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.setState({
                animating: animating
              });
            }, 10));
            afterChange && afterChange(state.currentSlide);
            delete _this.animationEndCallback;
          });
        }, speed);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "changeSlide", function (options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);
      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
      if (targetSlide !== 0 && !targetSlide) return;
      if (dontAnimate === true) {
        _this.slideHandler(targetSlide, dontAnimate);
      } else {
        _this.slideHandler(targetSlide);
      }
      _this.props.autoplay && _this.autoPlay("update");
      if (_this.props.focusOnSelect) {
        var nodes = _this.list.querySelectorAll(".slick-current");
        nodes[0] && nodes[0].focus();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "clickHandler", function (e) {
      if (_this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }
      _this.clickable = true;
    });
    _defineProperty(_assertThisInitialized(_this), "keyHandler", function (e) {
      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
      dir !== "" && _this.changeSlide({
        message: dir
      });
    });
    _defineProperty(_assertThisInitialized(_this), "selectHandler", function (options) {
      _this.changeSlide(options);
    });
    _defineProperty(_assertThisInitialized(_this), "disableBodyScroll", function () {
      var preventDefault = function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      };
      window.ontouchmove = preventDefault;
    });
    _defineProperty(_assertThisInitialized(_this), "enableBodyScroll", function () {
      window.ontouchmove = null;
    });
    _defineProperty(_assertThisInitialized(_this), "swipeStart", function (e) {
      if (_this.props.verticalSwiping) {
        _this.disableBodyScroll();
      }
      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
      state !== "" && _this.setState(state);
    });
    _defineProperty(_assertThisInitialized(_this), "swipeMove", function (e) {
      var state = (0, _innerSliderUtils.swipeMove)(e, _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      if (state["swiping"]) {
        _this.clickable = false;
      }
      _this.setState(state);
    });
    _defineProperty(_assertThisInitialized(_this), "swipeEnd", function (e) {
      var state = (0, _innerSliderUtils.swipeEnd)(e, _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      var triggerSlideHandler = state["triggerSlideHandler"];
      delete state["triggerSlideHandler"];
      _this.setState(state);
      if (triggerSlideHandler === undefined) return;
      _this.slideHandler(triggerSlideHandler);
      if (_this.props.verticalSwiping) {
        _this.enableBodyScroll();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "touchEnd", function (e) {
      _this.swipeEnd(e);
      _this.clickable = true;
    });
    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "previous"
        });
      }, 0));
    });
    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "next"
        });
      }, 0));
    });
    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      slide = Number(slide);
      if (isNaN(slide)) return "";
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "index",
          index: slide,
          currentSlide: _this.state.currentSlide
        }, dontAnimate);
      }, 0));
    });
    _defineProperty(_assertThisInitialized(_this), "play", function () {
      var nextIndex;
      if (_this.props.rtl) {
        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
      } else {
        if ((0, _innerSliderUtils.canGoNext)(_objectSpread(_objectSpread({}, _this.props), _this.state))) {
          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
        } else {
          return false;
        }
      }
      _this.slideHandler(nextIndex);
    });
    _defineProperty(_assertThisInitialized(_this), "autoPlay", function (playType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
      var autoplaying = _this.state.autoplaying;
      if (playType === "update") {
        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
          return;
        }
      } else if (playType === "leave") {
        if (autoplaying === "paused" || autoplaying === "focused") {
          return;
        }
      } else if (playType === "blur") {
        if (autoplaying === "paused" || autoplaying === "hovered") {
          return;
        }
      }
      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
      _this.setState({
        autoplaying: "playing"
      });
    });
    _defineProperty(_assertThisInitialized(_this), "pause", function (pauseType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
        _this.autoplayTimer = null;
      }
      var autoplaying = _this.state.autoplaying;
      if (pauseType === "paused") {
        _this.setState({
          autoplaying: "paused"
        });
      } else if (pauseType === "focused") {
        if (autoplaying === "hovered" || autoplaying === "playing") {
          _this.setState({
            autoplaying: "focused"
          });
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === "playing") {
          _this.setState({
            autoplaying: "hovered"
          });
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onDotsOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });
    _defineProperty(_assertThisInitialized(_this), "onDotsLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });
    _defineProperty(_assertThisInitialized(_this), "onTrackOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });
    _defineProperty(_assertThisInitialized(_this), "onTrackLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });
    _defineProperty(_assertThisInitialized(_this), "onSlideFocus", function () {
      return _this.props.autoplay && _this.pause("focused");
    });
    _defineProperty(_assertThisInitialized(_this), "onSlideBlur", function () {
      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
    });
    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var className = (0, _classnames["default"])("slick-slider", _this.props.className, {
        "slick-vertical": _this.props.vertical,
        "slick-initialized": true
      });
      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);
      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding", "targetSlide", "useCSS"]);
      var pauseOnHover = _this.props.pauseOnHover;
      trackProps = _objectSpread(_objectSpread({}, trackProps), {}, {
        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
        focusOnSelect: _this.props.focusOnSelect && _this.clickable ? _this.selectHandler : null
      });
      var dots;
      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
        dotProps = _objectSpread(_objectSpread({}, dotProps), {}, {
          clickHandler: _this.changeSlide,
          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
        });
        dots = /*#__PURE__*/_react["default"].createElement(_dots.Dots, dotProps);
      }
      var prevArrow, nextArrow;
      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      arrowProps.clickHandler = _this.changeSlide;
      if (_this.props.arrows) {
        prevArrow = /*#__PURE__*/_react["default"].createElement(_arrows.PrevArrow, arrowProps);
        nextArrow = /*#__PURE__*/_react["default"].createElement(_arrows.NextArrow, arrowProps);
      }
      var verticalHeightStyle = null;
      if (_this.props.vertical) {
        verticalHeightStyle = {
          height: _this.state.listHeight
        };
      }
      var centerPaddingStyle = null;
      if (_this.props.vertical === false) {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: "0px " + _this.props.centerPadding
          };
        }
      } else {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: _this.props.centerPadding + " 0px"
          };
        }
      }
      var listStyle = _objectSpread(_objectSpread({}, verticalHeightStyle), centerPaddingStyle);
      var touchMove = _this.props.touchMove;
      var listProps = {
        className: "slick-list",
        style: listStyle,
        onClick: _this.clickHandler,
        onMouseDown: touchMove ? _this.swipeStart : null,
        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onMouseUp: touchMove ? _this.swipeEnd : null,
        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onTouchStart: touchMove ? _this.swipeStart : null,
        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onTouchEnd: touchMove ? _this.touchEnd : null,
        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
      };
      var innerSliderProps = {
        className: className,
        dir: "ltr",
        style: _this.props.style
      };
      if (_this.props.unslick) {
        listProps = {
          className: "slick-list"
        };
        innerSliderProps = {
          className: className
        };
      }
      return /*#__PURE__*/_react["default"].createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", /*#__PURE__*/_react["default"].createElement("div", _extends({
        ref: _this.listRefHandler
      }, listProps), /*#__PURE__*/_react["default"].createElement(_track.Track, _extends({
        ref: _this.trackRefHandler
      }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
    });
    _this.list = null;
    _this.track = null;
    _this.state = _objectSpread(_objectSpread({}, _initialState["default"]), {}, {
      currentSlide: _this.props.initialSlide,
      targetSlide: _this.props.initialSlide ? _this.props.initialSlide : 0,
      slideCount: _react["default"].Children.count(_this.props.children)
    });
    _this.callbackTimers = [];
    _this.clickable = true;
    _this.debouncedResize = null;
    var ssrState = _this.ssrInit();
    _this.state = _objectSpread(_objectSpread({}, _this.state), ssrState);
    return _this;
  }
  _createClass(InnerSlider, [{
    key: "didPropsChange",
    value: function didPropsChange(prevProps) {
      var setTrackStyle = false;
      for (var _i3 = 0, _Object$keys = Object.keys(this.props); _i3 < _Object$keys.length; _i3++) {
        var key = _Object$keys[_i3];
        if (!prevProps.hasOwnProperty(key)) {
          setTrackStyle = true;
          break;
        }
        if (_typeof(prevProps[key]) === "object" || typeof prevProps[key] === "function" || isNaN(prevProps[key])) {
          continue;
        }
        if (prevProps[key] !== this.props[key]) {
          setTrackStyle = true;
          break;
        }
      }
      return setTrackStyle || _react["default"].Children.count(this.props.children) !== _react["default"].Children.count(prevProps.children);
    }
  }]);
  return InnerSlider;
}(_react["default"].Component);

var camel2hyphen$1 = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

var camel2hyphen_1 = camel2hyphen$1;

var camel2hyphen = camel2hyphen_1;

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and ';
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', ';
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

var json2mq_1 = json2mq;

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */

var QueryHandler_1;
var hasRequiredQueryHandler;

function requireQueryHandler () {
	if (hasRequiredQueryHandler) return QueryHandler_1;
	hasRequiredQueryHandler = 1;
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}

	QueryHandler.prototype = {

	    constructor : QueryHandler,

	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },

	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },

	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },

	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },

	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }

	};

	QueryHandler_1 = QueryHandler;
	return QueryHandler_1;
}

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */

var Util;
var hasRequiredUtil;

function requireUtil () {
	if (hasRequiredUtil) return Util;
	hasRequiredUtil = 1;
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;

	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}

	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}

	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}

	Util = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};
	return Util;
}

var MediaQuery_1;
var hasRequiredMediaQuery;

function requireMediaQuery () {
	if (hasRequiredMediaQuery) return MediaQuery_1;
	hasRequiredMediaQuery = 1;
	var QueryHandler = requireQueryHandler();
	var each = requireUtil().each;

	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);

	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}

	MediaQuery.prototype = {

	    constuctor : MediaQuery,

	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);

	        this.matches() && qh.on();
	    },

	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },

	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },

	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },

	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';

	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};

	MediaQuery_1 = MediaQuery;
	return MediaQuery_1;
}

var MediaQueryDispatch_1;
var hasRequiredMediaQueryDispatch;

function requireMediaQueryDispatch () {
	if (hasRequiredMediaQueryDispatch) return MediaQueryDispatch_1;
	hasRequiredMediaQueryDispatch = 1;
	var MediaQuery = requireMediaQuery();
	var Util = requireUtil();
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;

	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }

	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}

	MediaQueryDispatch.prototype = {

	    constructor : MediaQueryDispatch,

	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;

	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }

	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });

	        return this;
	    },

	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];

	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }

	        return this;
	    }
	};

	MediaQueryDispatch_1 = MediaQueryDispatch;
	return MediaQueryDispatch_1;
}

var src;
var hasRequiredSrc;

function requireSrc () {
	if (hasRequiredSrc) return src;
	hasRequiredSrc = 1;
	var MediaQueryDispatch = requireMediaQueryDispatch();
	src = new MediaQueryDispatch();
	return src;
}

(function (exports) {
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireDefault(reactExports);
	var _innerSlider = innerSlider;
	var _json2mq = _interopRequireDefault(json2mq_1);
	var _defaultProps = _interopRequireDefault(defaultProps);
	var _innerSliderUtils = innerSliderUtils;
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	function _typeof(o) {
	  "@babel/helpers - typeof";
	  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
	    return typeof o2;
	  } : function(o2) {
	    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
	  }, _typeof(o);
	}
	function _extends() {
	  _extends = Object.assign ? Object.assign.bind() : function(target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	    return target;
	  };
	  return _extends.apply(this, arguments);
	}
	function ownKeys(e, r) {
	  var t = Object.keys(e);
	  if (Object.getOwnPropertySymbols) {
	    var o = Object.getOwnPropertySymbols(e);
	    r && (o = o.filter(function(r2) {
	      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
	    })), t.push.apply(t, o);
	  }
	  return t;
	}
	function _objectSpread(e) {
	  for (var r = 1; r < arguments.length; r++) {
	    var t = null != arguments[r] ? arguments[r] : {};
	    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
	      _defineProperty(e, r2, t[r2]);
	    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
	      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
	    });
	  }
	  return e;
	}
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
	  }
	}
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  Object.defineProperty(Constructor, "prototype", { writable: false });
	  return Constructor;
	}
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
	  Object.defineProperty(subClass, "prototype", { writable: false });
	  if (superClass) _setPrototypeOf(subClass, superClass);
	}
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
	    o2.__proto__ = p2;
	    return o2;
	  };
	  return _setPrototypeOf(o, p);
	}
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();
	  return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived), result;
	    if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;
	      result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }
	    return _possibleConstructorReturn(this, result);
	  };
	}
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  } else if (call !== void 0) {
	    throw new TypeError("Derived constructors may only return object or undefined");
	  }
	  return _assertThisInitialized(self);
	}
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	  return self;
	}
	function _isNativeReflectConstruct() {
	  try {
	    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
	    }));
	  } catch (t2) {
	  }
	  return (_isNativeReflectConstruct = function _isNativeReflectConstruct2() {
	    return !!t;
	  })();
	}
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
	    return o2.__proto__ || Object.getPrototypeOf(o2);
	  };
	  return _getPrototypeOf(o);
	}
	function _defineProperty(obj, key, value) {
	  key = _toPropertyKey(key);
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }
	  return obj;
	}
	function _toPropertyKey(t) {
	  var i = _toPrimitive(t, "string");
	  return "symbol" == _typeof(i) ? i : String(i);
	}
	function _toPrimitive(t, r) {
	  if ("object" != _typeof(t) || !t) return t;
	  var e = t[Symbol.toPrimitive];
	  if (void 0 !== e) {
	    var i = e.call(t, r);
	    if ("object" != _typeof(i)) return i;
	    throw new TypeError("@@toPrimitive must return a primitive value.");
	  }
	  return ("string" === r ? String : Number)(t);
	}
	var enquire = (0, _innerSliderUtils.canUseDOM)() && requireSrc();
	exports["default"] = /* @__PURE__ */ function(_React$Component) {
	  _inherits(Slider2, _React$Component);
	  var _super = _createSuper(Slider2);
	  function Slider2(props) {
	    var _this;
	    _classCallCheck(this, Slider2);
	    _this = _super.call(this, props);
	    _defineProperty(_assertThisInitialized(_this), "innerSliderRefHandler", function(ref) {
	      return _this.innerSlider = ref;
	    });
	    _defineProperty(_assertThisInitialized(_this), "slickPrev", function() {
	      return _this.innerSlider.slickPrev();
	    });
	    _defineProperty(_assertThisInitialized(_this), "slickNext", function() {
	      return _this.innerSlider.slickNext();
	    });
	    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function(slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
	      return _this.innerSlider.slickGoTo(slide, dontAnimate);
	    });
	    _defineProperty(_assertThisInitialized(_this), "slickPause", function() {
	      return _this.innerSlider.pause("paused");
	    });
	    _defineProperty(_assertThisInitialized(_this), "slickPlay", function() {
	      return _this.innerSlider.autoPlay("play");
	    });
	    _this.state = {
	      breakpoint: null
	    };
	    _this._responsiveMediaHandlers = [];
	    return _this;
	  }
	  _createClass(Slider2, [{
	    key: "media",
	    value: function media(query, handler) {
	      enquire.register(query, handler);
	      this._responsiveMediaHandlers.push({
	        query,
	        handler
	      });
	    }
	    // handles responsive breakpoints
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	      if (this.props.responsive) {
	        var breakpoints = this.props.responsive.map(function(breakpt) {
	          return breakpt.breakpoint;
	        });
	        breakpoints.sort(function(x, y) {
	          return x - y;
	        });
	        breakpoints.forEach(function(breakpoint, index) {
	          var bQuery;
	          if (index === 0) {
	            bQuery = (0, _json2mq["default"])({
	              minWidth: 0,
	              maxWidth: breakpoint
	            });
	          } else {
	            bQuery = (0, _json2mq["default"])({
	              minWidth: breakpoints[index - 1] + 1,
	              maxWidth: breakpoint
	            });
	          }
	          (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function() {
	            _this2.setState({
	              breakpoint
	            });
	          });
	        });
	        var query = (0, _json2mq["default"])({
	          minWidth: breakpoints.slice(-1)[0]
	        });
	        (0, _innerSliderUtils.canUseDOM)() && this.media(query, function() {
	          _this2.setState({
	            breakpoint: null
	          });
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this._responsiveMediaHandlers.forEach(function(obj) {
	        enquire.unregister(obj.query, obj.handler);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	      var settings;
	      var newProps;
	      if (this.state.breakpoint) {
	        newProps = this.props.responsive.filter(function(resp) {
	          return resp.breakpoint === _this3.state.breakpoint;
	        });
	        settings = newProps[0].settings === "unslick" ? "unslick" : _objectSpread(_objectSpread(_objectSpread({}, _defaultProps["default"]), this.props), newProps[0].settings);
	      } else {
	        settings = _objectSpread(_objectSpread({}, _defaultProps["default"]), this.props);
	      }
	      if (settings.centerMode) {
	        if (settings.slidesToScroll > 1 && false) ;
	        settings.slidesToScroll = 1;
	      }
	      if (settings.fade) {
	        if (settings.slidesToShow > 1 && false) ;
	        if (settings.slidesToScroll > 1 && false) ;
	        settings.slidesToShow = 1;
	        settings.slidesToScroll = 1;
	      }
	      var children = _react["default"].Children.toArray(this.props.children);
	      children = children.filter(function(child) {
	        if (typeof child === "string") {
	          return !!child.trim();
	        }
	        return !!child;
	      });
	      if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
	        console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
	        settings.variableWidth = false;
	      }
	      var newChildren = [];
	      var currentWidth = null;
	      for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
	        var newSlide = [];
	        for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
	          var row = [];
	          for (var k = j; k < j + settings.slidesPerRow; k += 1) {
	            if (settings.variableWidth && children[k].props.style) {
	              currentWidth = children[k].props.style.width;
	            }
	            if (k >= children.length) break;
	            row.push(/* @__PURE__ */ _react["default"].cloneElement(children[k], {
	              key: 100 * i + 10 * j + k,
	              tabIndex: -1,
	              style: {
	                width: "".concat(100 / settings.slidesPerRow, "%"),
	                display: "inline-block"
	              }
	            }));
	          }
	          newSlide.push(/* @__PURE__ */ _react["default"].createElement("div", {
	            key: 10 * i + j
	          }, row));
	        }
	        if (settings.variableWidth) {
	          newChildren.push(/* @__PURE__ */ _react["default"].createElement("div", {
	            key: i,
	            style: {
	              width: currentWidth
	            }
	          }, newSlide));
	        } else {
	          newChildren.push(/* @__PURE__ */ _react["default"].createElement("div", {
	            key: i
	          }, newSlide));
	        }
	      }
	      if (settings === "unslick") {
	        var className = "regular slider " + (this.props.className || "");
	        return /* @__PURE__ */ _react["default"].createElement("div", {
	          className
	        }, children);
	      } else if (newChildren.length <= settings.slidesToShow && !settings.infinite) {
	        settings.unslick = true;
	      }
	      return /* @__PURE__ */ _react["default"].createElement(_innerSlider.InnerSlider, _extends({
	        style: this.props.style,
	        ref: this.innerSliderRefHandler
	      }, (0, _innerSliderUtils.filterSettings)(settings)), newChildren);
	    }
	  }]);
	  return Slider2;
	}(_react["default"].Component); 
} (slider));

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _slider = _interopRequireDefault(slider);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	exports["default"] = _slider["default"]; 
} (lib));

const a$5 = /*@__PURE__*/getDefaultExportFromCjs(lib);

const l$3 = (()=>{let{productSliderAssets:m,currentVariant:p,selectedProduct:u}=useProductContext(),[f,h]=reactExports.useState(null),[w,g]=reactExports.useState(null),x=reactExports.useRef(null),v=reactExports.useRef(null),[b,y]=reactExports.useState(window.innerWidth<768),[N,z]=reactExports.useState(m?.assets),S=u.type.toLowerCase().includes("gift card"),C=u.tags.filter(e=>e.includes("single-slider")).length>0,_=N?.length>5;return reactExports.useEffect(()=>{N.length>1?setTimeout(()=>{h(x.current),g(v.current);},0):(h(null),g(null));},[N]),reactExports.useEffect(()=>{if(!C&&!S)if(p?.featured_image?.src){let e=p.featured_image.src.split("?")[0].toLowerCase();e=(e=(e=(e=p.featured_image.src.includes("files/")?e.split("files/")[1].split(".")[0]:e.split("products/")[1].split(".")[0]).replace(/-?[0-9]?[0-9]/g,"")).split("_emb")[0].split("_")[0]).replace(".jpg",""),z(m?.assets.filter(s=>!s.imageBase.toLowerCase().includes("_emb")&&s.imageBase.toLowerCase().includes(e)));}else S?z([m.assets[0]]):z([]);},[p]),reactExports.useEffect(()=>{let e=()=>y(window.innerWidth<768);return window.addEventListener("resize",e),()=>window.removeEventListener("resize",e)},[]),jsxRuntimeExports.jsx("div",{className:"h-fit md:sticky top-[114px] custom-lg:top-[160px] col-span-full md:col-span-6 xl:col-span-7 wz-grid grid-cols-subgrid",children:N?.length==1?jsxRuntimeExports.jsx("div",{className:"col-span-full",children:jsxRuntimeExports.jsx("img",{src:N[0]?.src,srcSet:N[0]?.srcset,sizes:N[0]?.sizes,className:"rounded-[10px] w-full object-cover"})}):jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment,{children:[jsxRuntimeExports.jsx("div",{className:"relative py-2 col-span-full md:col-[2_/_-1]",children:jsxRuntimeExports.jsx(a$5,{asNavFor:N.length>1?w:void 0,ref:x,arrows:true,nextArrow:jsxRuntimeExports.jsx(({onClick:s})=>jsxRuntimeExports.jsx("button",{onClick:s,className:"absolute top-1/2 right-0 -translate-y-1/2 rounded-tl-[5px] rounded-bl-[5px] bg-white",children:jsxRuntimeExports.jsx(NextArrow,{elClass:"min-w-[35px] md:min-w-[50px]"})}),{}),prevArrow:jsxRuntimeExports.jsx(({onClick:s})=>jsxRuntimeExports.jsx("button",{onClick:s,className:"absolute top-1/2 left-0 -translate-y-1/2 z-[1] rounded-tr-[5px] rounded-br-[5px] bg-white",children:jsxRuntimeExports.jsx(PrevArrow,{elClass:"min-w-[35px] md:min-w-[50px]"})}),{}),fade:false,slidesToShow:1,slidesToScroll:1,autoplay:false,speed:500,children:N?.map((s,l)=>jsxRuntimeExports.jsx("div",{className:"flex justify-center",children:jsxRuntimeExports.jsx("img",{src:s.src,srcSet:s.srcset,sizes:s.sizes,alt:s.alt,className:"w-full rounded-lg",loading:"lazy"})},l))})}),jsxRuntimeExports.jsx("div",{className:"py-2 max-h-[600px] relative col-span-full md:col-[1_/_span_1] md:row-start-1",children:jsxRuntimeExports.jsx(a$5,{asNavFor:N.length>1?f:void 0,ref:v,slidesToShow:b?5:6,swipeToSlide:_,focusOnSelect:true,vertical:!b,verticalSwiping:!b&&_,arrows:_,nextArrow:_?jsxRuntimeExports.jsx(({onClick:s})=>jsxRuntimeExports.jsx("button",{onClick:s,className:"absolute right-0 top-[45%] h-[90%] md:h-[15px] -translate-y-1/2 bg-primary transition p-1 flex justify-center items-center z-[1] md:static md:translate-y-0 md:top-[10px] md:w-full",children:jsxRuntimeExports.jsx(NextThumnailArrow,{elClass:"w-[18px] md:w-[20px] md:h-[30px] transform -rotate-90 md:rotate-0 ",size:18})}),{}):null,autoplay:false,infinite:_,className:"thumb-slider pointer-events-auto",children:N.map((s,l)=>jsxRuntimeExports.jsx("div",{className:`${_?"cursor-pointer":"cursor-default"} p-1`,children:jsxRuntimeExports.jsx("img",{src:s.thumbSrc,srcSet:s.thumbSrcset,sizes:s.thumbSizes,alt:s.alt,className:`w-full rounded-md transition ${_?"hover:scale-105":""}`,loading:"lazy"})},l))})})]})})});

const i$3 = (({baseLink:a,basePath:m,currentPath:i,subLink:r,subPath:n})=>jsxRuntimeExports.jsx("div",{className:"w-full mt-0 md:mt-[15px] text-14",children:jsxRuntimeExports.jsxs("ul",{className:"flex flex-wrap items-end justify-center mb-0 pl-4",role:"navigation","aria-label":"breadcrumbs",itemScope:true,itemType:"https://schema.org/BreadcrumbList",children:[jsxRuntimeExports.jsxs("li",{className:"text-slateBlue after:content-['|'] after:text-slateBlue after:mx-2",itemProp:"itemListElement",itemScope:true,itemType:"https://schema.org/ListItem",children:[jsxRuntimeExports.jsx("a",{href:a,className:"text-14 text-fiord font-apercu font-normal tracking-normal m-0 antialiased leading-[1.357] md:text-14",itemProp:"item",children:jsxRuntimeExports.jsx("span",{className:"text-14 text-fiord font-apercu font-normal tracking-normal m-0 antialiased leading-[1.357] md:text-14",itemProp:"name",children:m})}),jsxRuntimeExports.jsx("meta",{itemProp:"position",content:"1"})]}),n&&jsxRuntimeExports.jsxs("li",{className:"text-slateBlue after:content-['|'] after:text-slateBlue after:mx-2",itemProp:"itemListElement",itemScope:true,itemType:"https://schema.org/ListItem",children:[jsxRuntimeExports.jsx("a",{href:r,className:" text-fiord font-apercu font-normal tracking-normal m-0 antialiased text-14 leading-[1.357] md:text-14",itemProp:"item",children:jsxRuntimeExports.jsx("span",{itemProp:"name",children:n})}),jsxRuntimeExports.jsx("meta",{itemProp:"position",content:"2"})]}),jsxRuntimeExports.jsxs("li",{className:"text-slateBlue type type--medium text-14",itemProp:"itemListElement",itemScope:true,itemType:"https://schema.org/ListItem",children:[jsxRuntimeExports.jsx("span",{itemProp:"name",className:"font-apercu",children:i}),jsxRuntimeExports.jsx("meta",{itemProp:"position",content:n?"3":"2"})]})]})}));

const filterVariants=(t,e,r=false,i=1,n=null,o=false)=>{if(!t?.variants)return [];let l=o?"applique":r?"embroidery":"no embroidery";return t.variants.filter(t=>{if("Default Title"===t.title)return  true;let r=!n||t[`option${i}`]===n,o=!e||t[`option${e}`]?.toLowerCase()===l;return r&&o})};

function c$3({name:l,extraVariantData:i,activeVariant:r,activateVariant:n,styleOptionKey:s,visibleVariants:c}){let{swatchData:m,selectedProduct:p}=useProductContext(),{avail:u,soldOut:f}=c.reduce((e,t)=>((p.variants.filter(e=>e[s]===t[s]&&!["/ Embroidery","/ Custom Embroidery"].some(t=>e.title.includes(t))).every(e=>!e.available)?e.soldOut:e.avail).push(t),e),{avail:[],soldOut:[]}),x=[...u,...f];return jsxRuntimeExports.jsxs("div",{className:"w-full border-t border-link mt-2 py-5 md:py-[16px]",children:[jsxRuntimeExports.jsx("div",{className:"flex items-center flex-[1_0_100%] overflow-x-scroll lg:overflow-hidden relative",style:{scrollbarWidth:"none"},children:jsxRuntimeExports.jsxs("p",{className:"w-full flex-[1_0_100%] text-center p-0 pb-2.5 m-0",children:[jsxRuntimeExports.jsxs("span",{className:"font-apercu leading-[1.35714] text-[14px] md:text-[14px] lg:text-[14px] xl:text-[14px]",children:[l,":"]})," ",jsxRuntimeExports.jsxs("span",{className:"font-apercu leading-[1.35714] text-[14px] md:text-[14px] lg:text-[14px] xl:text-[14px]",children:[null!==r&&r[s],null!==r&&jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment,{children:[r.available&&i?.inventory_quantity<=0&&jsxRuntimeExports.jsxs("span",{className:"mr-[5px] text-customRed",children:[" ","•"," ",null!==i.metafields.backorder_messaging&&""!==i.metafields.backorder_messaging.trim()?i.metafields.backorder_messaging:"Backordered"]}),!r.available&&jsxRuntimeExports.jsx("span",{className:"text-customRed",children:" • Sold Out"})]})]})]})}),jsxRuntimeExports.jsx("div",{className:"flex items-center flex-[1_0_100%] lg:overflow-hidden relative",children:jsxRuntimeExports.jsx("div",{className:"flex flex-wrap items-center justify-center w-full m-0 p-0 relative",children:x.map(a=>jsxRuntimeExports.jsxs("div",{className:`relative min-w-[37px] md:min-w-[42px] p-[5px]${a.available?"":" sold-out"}`,children:[jsxRuntimeExports.jsx("button",{type:"button","aria-label":`${l} ${a[s]}`,"aria-pressed":r?.id===a.id,"data-variant-id":a.id,className:`relative cursor-pointer bg-white border border-geyser rounded-full h-[28px] w-[28px] md:h-[32px] md:w-[32px] m-0 overflow-hidden transition-all duration-300 ease-in-out flex items-center justify-center p-0${r?.id===a.id?" border border-primary":""}`,onClick:()=>n(a),children:m?.find(e=>e.id===a.id).swatch&&jsxRuntimeExports.jsx("img",{className:"h-full object-cover w-full",alt:"","aria-hidden":"true",src:m?.find(e=>e.id===a.id).swatch,srcSet:getOptimizedImageSrcset(m?.find(e=>e.id===a.id).swatch,[30,60]),sizes:"30px"})}),!a.available&&m?.find(e=>e.id===a.id)?.inventory_quantity<=0&&jsxRuntimeExports.jsx("div",{className:"absolute inset-0 pointer-events-none",children:jsxRuntimeExports.jsx("span",{className:"absolute top-1/2 left-0 w-full h-[1px] bg-slateBlue -rotate-45 block origin-center"})})]},a.id))})})]})}function m$2({name:a,sizeOptions:l,activeSize:i,sizeGuide:r,setActiveSize:n}){let{setSizeGuideVisible:s}=useProductContext();return jsxRuntimeExports.jsxs("div",{className:"flex flex-col items-center justify-stretch flex-wrap w-full py-5 mt-2.5 border-t border-link md:justify-center md:flex-nowrap md:py-[11px]",children:[jsxRuntimeExports.jsxs("div",{className:"flex w-full justify-center mb-5 text-sm text-fiord",children:[jsxRuntimeExports.jsxs("span",{className:"font-apercu text-[14px] mr-[5px]",children:[a,":"]}),jsxRuntimeExports.jsx("span",{className:"font-apercu text-[14px] mr-[5px]",children:i}),r?.name&&jsxRuntimeExports.jsx("button",{className:"relative text-[14px] after:content-[''] after:absolute after:left-0 after:bottom-[-5px] after:right-0 after:h-px after:bg-primary after:transition-colors after:duration-200 after:ease-in-out m1-5",onClick:()=>{s(true);},children:"Size Guide"})]}),jsxRuntimeExports.jsx("div",{className:"flex items-center flex-[1_0_100%] overflow-x-auto relative md:overflow-hidden md:justify-center md:flex-[0_1_auto]",children:jsxRuntimeExports.jsx("div",{className:"flex items-center flex-wrap justify-center w-full m-0 relative md:p-0",children:l.map(({value:l,available:r})=>jsxRuntimeExports.jsx("div",{className:"flex-[0_0_auto] min-w-[42px] p-[5px] relative",children:jsxRuntimeExports.jsxs("button",{type:"button","aria-label":`${a} ${l}`,"aria-pressed":l===i,className:`appearance-none min-h-[32px] min-w-[32px] w-auto flex items-center justify-center h-[32px] px-[10px] text-[14px] cursor-pointer overflow-hidden bg-white border border-geyser text-primary font-apercu font-normal leading-none rounded-full transition-colors duration-300 ease-in-out last:m-0 ${l===i?"border-primary":""}`,onClick:()=>n(l),children:[l,!r&&jsxRuntimeExports.jsx("div",{className:"absolute inset-0 pointer-events-none",children:jsxRuntimeExports.jsx("span",{className:"absolute top-1/2 left-0 w-full h-[1px] bg-slateBlue -rotate-45 block origin-center"})})]})},l))})})]})}function p$2(){let{selectedProduct:a}=useProductContext();return jsxRuntimeExports.jsxs("p",{className:"flex justify-evenly border-b border-link pb-[11px] m-0 w-full flex-[1_0_100%] text-center md:pb-[4px]",children:[jsxRuntimeExports.jsxs("a",{href:"/products/digital-gift-card",className:`inline-block relative mt-[10px] md:mt-[10px] underline ${a.title.includes("E-Gift")?"current":""}`,children:[jsxRuntimeExports.jsx("span",{children:"E-Gift Card"}),a.title.includes("E-Gift")&&jsxRuntimeExports.jsx("span",{className:"w-full h-[3px] border bg-primary block relative top-[13px] md:top-[7px]"})]}),jsxRuntimeExports.jsxs("a",{href:"/products/physical-gift-card",className:`inline-block relative mt-[10px] md:mt-[10px] underline ${a.title.includes("Physical")?"current":""}`,children:[jsxRuntimeExports.jsx("span",{children:"Physical Gift Card"}),a.title.includes("Physical")&&jsxRuntimeExports.jsx("span",{className:"w-full h-[3px] border bg-primary block relative top-[13px] md:top-[7px]"})]})]})}function u$3({visibleVariants:a,activeVariant:l,activateVariant:i}){let{selectedProductOptionVals:r}=useProductContext();return jsxRuntimeExports.jsxs("div",{className:"flex flex-col items-center justify-stretch flex-wrap w-full py-5 mt-2.5 md:justify-center md:flex-nowrap md:py-[11px]",children:[jsxRuntimeExports.jsx("div",{className:"flex w-full justify-center mb-5 text-sm text-fiord",children:jsxRuntimeExports.jsx("p",{className:"",children:jsxRuntimeExports.jsx("span",{className:"font-apercu text-[14px] mr-[5px]",children:r?.options_with_values[0]?.name})})}),jsxRuntimeExports.jsx("div",{className:"flex items-center flex-[1_0_100%] overflow-x-auto relative md:overflow-hidden md:justify-center md:flex-[0_1_auto]",children:jsxRuntimeExports.jsx("div",{className:"flex items-center flex-wrap justify-center w-full m-0 relative md:p-0",children:a.map(t=>jsxRuntimeExports.jsx("div",{className:"flex-[0_0_auto] min-w-[42px] p-[5px] relative",children:jsxRuntimeExports.jsx("button",{className:`flex items-center justify-center h-[32px] p-[5px] text-[14px] cursor-pointer overflow-hidden relative bg-white border border-geyser text-primary font-apercu font-normal leading-none rounded-[2px] transition-colors duration-300 ease-in-out last:m-0 ${l?.id===t.id?"border-primary":""}`,onClick:()=>i(t),children:t.title})},t.id))})})]})}function f(e){return `${e.getFullYear()}-${(e.getMonth()+1).toString().padStart(2,"0")}-${e.getDate().toString().padStart(2,"0")}`}function x$2(){let{date:l,extraProperties:n,setExtraProperties:s,setGiftCardHasErrors:d}=useProductContext(),[c,m]=reactExports.useState(""),[p,u]=reactExports.useState(""),[x,h]=reactExports.useState(""),[v,w]=reactExports.useState(false),[b,g]=reactExports.useState(false),[y,_]=reactExports.useState(""),[N,j]=reactExports.useState(""),k=new Date(l);k.setDate(k.getDate()+89);let C=new Intl.DateTimeFormat("en-US",{month:"short",day:"numeric",year:"numeric"}).format(k),$="Please enter a valid email address",S=`Please enter a valid date before ${C} or clear field to send email today.`;function z(e){let t=e.target.value.trim(),a=e.target.validity.valid;_(t),a?h(""):!a&&b&&h(S),s({...n,"Send on":a?t:null});}return reactExports.useEffect(()=>{s({});},[]),reactExports.useEffect(()=>{let e=e=>{(p||!v)&&(u($),w(true));};return window.addEventListener("click-add-to-cart",e),()=>window.removeEventListener("click-add-to-cart",e)},[p,v,$]),reactExports.useEffect(()=>{d(!!p||!v||!!x);},[p,x,v]),jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment,{children:[jsxRuntimeExports.jsx("div",{className:"flex flex-row flex-wrap items-center justify-center w-full mt-[11px] mb-0 pt-5 border-t border-link",children:jsxRuntimeExports.jsx("p",{className:"text-28 text-royalBlue",children:"The Particulars"})}),jsxRuntimeExports.jsxs("form",{className:"flex flex-row flex-wrap justify-center w-full mb-0 mt-0 md:mt-[10px]",children:[jsxRuntimeExports.jsxs("div",{className:"flex flex-row flex-wrap w-full mt-[10px] mb-0 justify-start md:justify-between items-start",children:[jsxRuntimeExports.jsxs("div",{className:"flex flex-row flex-wrap w-full mb-0 mt-[10px] static md:mt-0 md:[flex:0_0_calc(50%-10px)]",children:[jsxRuntimeExports.jsx("label",{className:"text-14 text-left leading-[1.375] font-normal tracking-[0] m-0 font-apercu antialiased type-custom",htmlFor:"recipientEmail",children:jsxRuntimeExports.jsxs("strong",{children:["Recipient’s email",jsxRuntimeExports.jsx("span",{className:"text-red-600",children:"*"})]})}),jsxRuntimeExports.jsx("input",{maxLength:"255",onChange:function(e){let t=e.target.value.trim(),a=t&&e.target.validity.valid;j(t),a?u(""):!a&&v&&u($),s({...n,"Recipient email":t&&a?t:null,__shopify_send_gift_card_to_recipient:t&&a});},onBlur:e=>{let t=e.target.value.trim()&&e.target.validity.valid;v||w(true),t||u($);},value:N,className:"w-full mt-[5px] bg-grey border-none rounded-[2px] shadow-[0_1px_0_white] text-primary outline-none overflow-auto p-[14px_20px] resize-none",type:"email",pattern:"[^\\s@]+@[^\\s@]+\\.[^\\s@]+",id:"recipientEmail",name:"recipientEmail",required:true}),p&&v&&jsxRuntimeExports.jsx("p",{className:"text-12 text-red-600 mt-1",children:p})]}),jsxRuntimeExports.jsxs("div",{className:"flex flex-row flex-wrap w-full mb-0 mt-[10px] static md:mt-0 md:[flex:0_0_calc(50%-10px)]",children:[jsxRuntimeExports.jsx("label",{className:"text-14 text-left leading-[1.375] font-normal tracking-[0] m-0 font-apercu antialiased type-custom",htmlFor:"recipientName",children:jsxRuntimeExports.jsx("strong",{children:"Recipient’s name"})}),jsxRuntimeExports.jsx("input",{maxLength:"255",onChange:e=>s({...n,"Recipient name":e.target.value.trim()}),className:"w-full mt-[5px] bg-grey border-none rounded-[2px] shadow-[0_1px_0_white] text-primary outline-none overflow-auto p-[14px_20px] resize-none",type:"text",id:"recipientName",name:"recipientName"})]})]}),jsxRuntimeExports.jsxs("div",{className:"flex flex-row flex-wrap w-full mt-[10px] mb-0 justify-start md:justify-between",children:[jsxRuntimeExports.jsxs("div",{className:"mt-[10px] static md:mt-0  w-full text-left",children:[jsxRuntimeExports.jsx("label",{className:"text-14 text-left leading-[1.375] font-normal tracking-[0] m-0 font-apercu antialiased type-custom",htmlFor:"message",children:jsxRuntimeExports.jsx("strong",{children:"Your message"})}),jsxRuntimeExports.jsx("textarea",{onChange:e=>{m(e.target.value),s({...n,Message:e.target.value});},className:"w-full mt-[5px] bg-grey border-none rounded-[2px] shadow-[0_1px_0_white] text-primary outline-none overflow-auto p-[14px_20px] resize-none",id:"message",name:"message",rows:"4",maxLength:"200"}),jsxRuntimeExports.jsxs("div",{className:"text-[10px] mt-[5px] text-right w-full",children:[jsxRuntimeExports.jsx("span",{className:"text-12 mt-[10px] static md:mt-0 md:[flex:0_0_calc(50%-10px)]",children:c.length}),"/200"]})]}),jsxRuntimeExports.jsx("div",{className:"flex flex-row flex-wrap w-full mt-[10px] mb-0 justify-start md:justify-between",children:jsxRuntimeExports.jsxs("div",{className:"mt-[10px] static md:mt-0  w-full text-left",children:[jsxRuntimeExports.jsxs("label",{className:"text-14 text-left leading-[1.375] font-normal tracking-[0] m-0 font-apercu antialiased type-custom",htmlFor:"sendOn",children:[jsxRuntimeExports.jsx("strong",{children:"Send on"})," ",jsxRuntimeExports.jsx("em",{children:"(If left blank, email will send immediately.)"})]}),jsxRuntimeExports.jsx("input",{type:"date",id:"sendOn",name:"sendOn",pattern:"\\d{4}-\\d{2}-\\d{2}",className:"w-full mt-[5px] bg-grey border-none rounded-[2px] shadow-[0_1px_0_white] text-primary outline-none overflow-auto p-[14px_20px] resize-none",onKeyUp:z,onChange:z,onBlur:e=>{let t=e.target.value,a=e.target.validity.valid;t&&!b&&g(true),a||h(S);},value:y,min:f(l),max:f(k)}),x&&jsxRuntimeExports.jsx("p",{className:"text-12 text-red-600 mt-1",children:x})]})})]})]})]})}const n$5 = (()=>{let{swatchData:a,setCurrentVariant:d,selectedProduct:f,selectedProductOptionVals:h,activeQty:v,setCurrentCount:w,setEmbVisibility:b}=useProductContext(),g=reactExports.useRef(true),y=new URLSearchParams(window.location.search),_=f.type.toLowerCase().includes("gift card"),N="Digital Gift Card"===f.type,j=f.tags.some(e=>e.includes("bundle")),k=_?h?.options_with_values:h?.options_with_values.filter(e=>["size","towel type","robe style"].some(t=>e.name.toLowerCase().includes(t))&&!["rug size","robe size"].some(t=>e.name.toLowerCase().includes(t))),C=k.length>0,$=C?`option${k[0].position}`:null,S=h?.options_with_values.filter(e=>e.name.toLowerCase().includes("embroidery")),z=S.length>0?`option${S[0].position}`:null,E=h?.options_with_values.filter(e=>["color","pattern","piping","stitching","style","rug size","robe size"].some(t=>e.name.toLowerCase().includes(t))),L=E.length>0,P=L?`option${E[0].position}`:null,[R,G]=reactExports.useState(null),[O,D]=reactExports.useState(null),[F,V]=reactExports.useState(null),[B,q]=reactExports.useState(null),[T,U]=reactExports.useState(C?k[0].values[0]:null),[I,M]=reactExports.useState(null),K=reactExports.useCallback(()=>{let e=f.variants;_||(e=filterVariants(f,S[0]?.position,false,k[0]?.position,C?T:null),D(f.variants.filter(e=>["/ Embroidery","/ Custom Embroidery"].some(t=>e.title.includes(t))))),G(e);},[T,f]),Y=reactExports.useCallback(e=>{V(e),d(e);let t=a?.find(t=>String(t.id)===String(e.id));q(t);let l=document.querySelector(".product__meta__badge");l&&(!_&&t.length>0?(l.innerHTML=t.metafields.badge_callout,l.classList.remove("visually-hidden")):l.classList.add("visually-hidden"));},[a,_]),A=reactExports.useCallback(()=>{if(!y.has("embvariant")&&F){let e=new URL(window.location.href);e.searchParams.set("variant",F.id);let t=`/products/${f.handle}?${e.searchParams.toString()}`;window.location.pathname+window.location.search!==t&&window.history.replaceState({},"",t),!_&&O?.some(e=>e.id===F.id)&&(b(true),setTimeout(()=>Y(f.variants[0]),1e3));}},[F,f.handle]);return (reactExports.useEffect(()=>{if(g.current){g.current=false;return}if(y.has("embvariant")&&b(true),F&&!_){let e=R.filter(e=>e[P]===F[P]);Y(e.length>0?e[0]:R[0]),C&&!T&&U(k[0].values[0]);}else {let e,t=y.get("variant");t?e=f.variants.find(e=>e.id===parseInt(t,10)):(e=f.variants.find(e=>e.available&&(!z||"no embroidery"===e[z].toLowerCase())))||(e=f.variants[0]),e&&(Y(e),C&&U(e[`option${k[0]?.position}`]));}},[R,T]),reactExports.useEffect(()=>{K();},[T,f]),reactExports.useEffect(()=>{A(),window.dispatchEvent(new Event("reload-product-related-components"));},[F]),reactExports.useEffect(()=>{f.activeQty=v,w(v);},[v]),reactExports.useEffect(()=>{if(!C||!f||!F)return;let e=k[0].values.map(e=>({value:e,available:true}));if(P){let t=F[P];e.forEach(e=>{let a=f.variants.find(a=>a[P]===t&&a[$]===e.value);e.available=a?.available??false;}),M(e);}else e.forEach(e=>{let t=f.variants.find(t=>t[$]===e.value);e.available=t?.available??false;}),M(e);},[F,f]),R)?jsxRuntimeExports.jsxs("div",{className:"flex justify-center items-start flex-wrap w-full",children:[L&&F&&jsxRuntimeExports.jsx(c$3,{name:E[0].name,extraVariantData:B,visibleVariants:R,activeVariant:F,activateVariant:Y,styleOptionKey:P}),C&&I&&!_&&!j&&jsxRuntimeExports.jsx(m$2,{name:k[0].name,sizeOptions:I,activeSize:T,setActiveSize:U,sizeGuide:h?.sizeGuide}),_&&jsxRuntimeExports.jsx(p$2,{}),C&&_&&F&&jsxRuntimeExports.jsx(u$3,{visibleVariants:R,activeVariant:F,activateVariant:Y}),N&&jsxRuntimeExports.jsx(x$2,{})]}):null});

let u$2=new Set;const NotifyMeButton=({mini:n})=>{let{currentVariant:a}=useProductContext(),[o,s]=reactExports.useState(false),[d,c]=reactExports.useState(""),[p,x]=reactExports.useState("idle"),f=u$2.has(a?.id);async function m(e){if(e.preventDefault(),"loading"!==p&&a?.id){x("loading");try{let e=await fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=K3Cby9",{method:"POST",headers:{"Content-Type":"application/json",revision:"2024-06-15"},body:JSON.stringify({data:{type:"back-in-stock-subscription",attributes:{profile:{data:{type:"profile",attributes:{email:d}}},channels:["EMAIL"]},relationships:{variant:{data:{type:"catalog-variant",id:`$shopify:::$default:::${a.id}`}}}}})});if(!e.ok)throw Error(`Klaviyo back-in-stock subscription failed: ${e.status}`);u$2.add(a.id),x("success");}catch(e){console.error("Back in stock subscription error",e),x("error");}}}if(reactExports.useEffect(()=>{s(false),c(""),x("idle");},[a?.id]),"success"===p||f)return jsxRuntimeExports.jsx("div",{className:"w-full",children:jsxRuntimeExports.jsx("p",{role:"status",className:"font-normal font-apercu text-16 leading-[1.375] tracking-normal antialiased text-royalBlue",children:"You’re in! We’ll let you know when it’s back."})});let h=`flex items-center justify-center w-full border border-navy rounded-md text-white bg-navy leading-[22px] text-center no-underline transition-all duration-200 ease-in-out cursor-pointer hover:bg-royalBlue hover:text-white md:px-4 ${n?"py-[6px] text-[12px]":"h-[52px] md:py-[15px]"}`;return jsxRuntimeExports.jsxs("div",{className:"w-full",children:[true!==n&&jsxRuntimeExports.jsx("p",{className:"font-normal font-apercu text-16 leading-[1.375] tracking-normal antialiased text-royalBlue",children:"We’ll let you know when it’s back!"}),o?jsxRuntimeExports.jsxs("form",{"aria-label":"Back in stock notification sign up",onSubmit:m,className:`w-full ${n?"flex items-center gap-2":"flex flex-col gap-2 mt-[15px]"}`,children:[jsxRuntimeExports.jsx("input",{type:"email",required:true,autoFocus:true,value:d,onChange:e=>{c(e.target.value),"error"===p&&x("idle");},placeholder:"Email","aria-label":"Email",className:`border border-navy rounded-md px-4 text-navy font-apercu text-16 ${n?"flex-1 min-w-0 h-[34px] text-[12px] px-3":"w-full h-[52px]"}`}),jsxRuntimeExports.jsx("button",{type:"submit",disabled:"loading"===p,className:`${h} ${n?"w-auto whitespace-nowrap px-3":""}`,children:"loading"===p?"Submitting…":"Notify Me"})]}):jsxRuntimeExports.jsx("button",{type:"button",onClick:()=>s(true),className:`${h} ${n?"":"mt-[15px]"}`,children:"Notify Me When Available"}),"error"===p&&jsxRuntimeExports.jsx("p",{role:"alert",className:"mt-2 font-normal font-apercu text-[14px] leading-[1.375] text-red-600",children:"Something went wrong. Please try again."})]})};const AddGiftBox=({giftBox:r,visitorCountry:i,checked:n,onChange:a})=>{let o=new e$3,l=r.name.split(" - ")[0]||"";return jsxRuntimeExports.jsxs("label",{className:`px-space16 py-space12 flex items-center gap-space12 rounded-[5px] w-full text-primary border text-left mt-space16 cursor-pointer text-16 leading-6 ${n?"border-softBlue bg-softBlue":"border-geyser bg-white"}`,children:[jsxRuntimeExports.jsx(o$7,{checked:n,onChange:()=>{a(!n);}}),jsxRuntimeExports.jsx("div",{className:"rounded w-[40px] h-[40px] shrink-0",children:r.featured_image?.src&&jsxRuntimeExports.jsx("img",{src:getOptimizedImageUrl(r.featured_image.src,{width:40,height:40}),srcSet:getOptimizedImageSrcset(r.featured_image.src,[40,80]),sizes:"40px",alt:r.name,className:"block w-full h-full object-cover rounded-[5px]"})}),jsxRuntimeExports.jsxs("span",{className:"grow",children:["Add ",l]}),jsxRuntimeExports.jsxs("span",{className:"font-bold",children:[o.formatMoney(r.price,`${"GB"===i?"£":"$"}{{amount}}`).replace(".00",""),"CA"===i&&" CAD","GB"===i&&" GBP"]})]})};const PersonalizationButton=({mini:i,visitorCountry:o,setEmbVisibility:s})=>{let{baseVariant:d,embroideryVariant:c,appliqueVariant:p,selectedProductVariantInfo:u}=useProductContext(),[x,f]=reactExports.useState(15),m=reactExports.useRef(null);if(d&&u&&m.current!==d.id){let e=u.product_variant_info?.find(e=>e.id===d.id)?.metafields?.units_per_sku||1,t=c?Math.round((c.price-d.price)/100/e):15,r=p?Math.round((p.price-d.price)/100/e):30;m.current=d.id,f(Math.min(t,r));}return jsxRuntimeExports.jsxs("button",{onClick:()=>s(true),id:"personalizeBtn",className:`flex items-center justify-center w-full border border-navy bg-navy rounded-md text-white leading-[22px] text-center no-underline transition-all duration-200 ease-in-out cursor-pointer hover:text-white hover:bg-royalBlue hover:border-royalBlue md:px-4  
        ${i?"py-[6px] text-[12px]":"h-[52px] md:py-[15px]"}`,children:[jsxRuntimeExports.jsx(NeedleIcon,{elClass:`mr-2 ${i?"w-[11px]":"w-[16px]"}`,color:"#ffffff"}),i?`Personalize +${"GB"===o?"£":"$"}${x}`:`Personalize it • From +${"GB"===o?"£":"$"}${x} ${"CA"===o?"CAD":"per item"}`]})};const AddToCartButton=({id:e,mini:r,isSoldOut:i,isPreorder:n,addToCart:a,disabled:o,price:l,quantity:s,giftCardHasErrors:d})=>jsxRuntimeExports.jsxs("button",{id:e,onClick:()=>{window.dispatchEvent(new Event("click-add-to-cart")),i||o||d||a();},className:`flex items-center justify-center w-full  border rounded-md text-white leading-[22px] text-center no-underline transition-all duration-200 ease-in-out cursor-pointer hover:text-white md:px-4 ${i||o||d?"bg-slateBlue hover:bg-slateBlue":"bg-navy hover:bg-royalBlue border-navy hover:border-royalBlue"} ${i||o?"pointer-events-none":""} ${r?"py-[6px] text-[12px]":"h-[52px] md:py-[15px]"}`,disabled:o,children:[i?"Sold Out":n?"Preorder":"Add to Bag"," ",l&&"•"," ",l&&l," ",s>1?"Each":""]});const QuantitySelector=({activeQty:r=1,setActiveQty:i})=>jsxRuntimeExports.jsx("div",{className:"flex flex-row flex-wrap items-center justify-center w-[40%] border border-navy rounded-md text-navy mb-0 p-0 md:w-[50%] xl:w-[45%]",children:jsxRuntimeExports.jsxs("div",{className:"flex flex-row flex-wrap items-center justify-center flex-auto mb-0",children:[jsxRuntimeExports.jsx("button",{onClick:()=>i(Math.max(1,r-1)),className:"w-1/3 flex flex justify-center flex-row flex-wrap items-center flex-auto cursor-pointer border-0 bg-transparent p-2.5","aria-label":"Product quantity decrease",children:jsxRuntimeExports.jsx("svg",{viewBox:"0 0 15 2",fill:"none",className:"w-[14px]",children:jsxRuntimeExports.jsx("line",{x1:"0.5",y1:"1.03623",x2:"14.5",y2:"1.03623",stroke:"#14334C",strokeWidth:"1.2"})})}),jsxRuntimeExports.jsx("span",{className:"w-1/3 font-sans font-normal text-16 leading-[1.375] tracking-normal antialiased",children:r}),jsxRuntimeExports.jsx("button",{onClick:()=>i(r+1),className:"w-1/3 flex flex-row flex-wrap items-center justify-center flex-auto cursor-pointer border-0 bg-transparent p-2.5","aria-label":"Product quantity increase",children:jsxRuntimeExports.jsxs("svg",{viewBox:"0 0 15 14",fill:"none",className:"w-[14px]",children:[jsxRuntimeExports.jsx("line",{x1:"7.5",y1:"0",x2:"7.5",y2:"14",stroke:"#14334C",strokeWidth:"1.2"}),jsxRuntimeExports.jsx("line",{x1:"0.5",y1:"7",x2:"14.5",y2:"7",stroke:"#14334C",strokeWidth:"1.2"})]})})]})});function AddToRegistryButton({productId:n,variantId:a,quantity:l,customer:s,cart:d,redirect:c,properties:p=null,onCartUpdate:u=null}){let[x,f]=reactExports.useState(false),[m,h]=reactExports.useState(null),[y,g]=reactExports.useState(localStorage.getItem("hasGiftRegistry"));return reactExports.useEffect(()=>{s&&null==y?d?.attributes?.registry_id&&d?.attributes?.registry_admin?g("1"):fetch("/apps/giftregistry/api/registry").then(e=>e.json()).then(e=>{let t=Array.isArray(e?.registries)?e.registries:[];t.length>0&&fetch("/cart/update.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({attributes:{registry_admin:"true",registry_id:t[0].id}})}).then(e=>{u&&u(e);}),localStorage.setItem("hasGiftRegistry","1"),g("1");},e=>{localStorage.setItem("hasGiftRegistry","0"),g("0");}):!s&&y&&g(null);},[s,y]),reactExports.useEffect(()=>{!s&&d&&(d?.attributes?.registry_admin||d?.attributes?.registry_id)&&fetch("/cart/update.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({attributes:{registry_admin:"",registry_id:""}})}).then(e=>{u&&u(e);});},[s,d,u]),"1"==y&&jsxRuntimeExports.jsxs("button",{disabled:x,onClick:e=>{e.preventDefault(),s&&d?.attributes?.registry_id?(f(true),fetch(`/apps/giftregistry/api/registry/${d?.attributes?.registry_id}/product`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({products:[{id:n,variants:[{id:a,quantity:l,...p?{properties:p}:{}}]}]})}).then(e=>{h("Added to Registry!"),f(false),setTimeout(()=>{h(null);},1e3);})):c("/apps/giftregistry/create");},type:"button",className:"gift-reggie-link inline-flex items-center gap-1 bg-transparent border-none p-0 mt-[15px] cursor-pointer text-navy font-apercu text-[14px] underline underline-offset-[3px] hover:no-underline transition-all duration-200 ease-in-out",children:[jsxRuntimeExports.jsx(RegistryBowIcon,{elClass:"w-[14px] h-[10px]"}),x?"Adding...":m??"Add To Registry"]})}

const r$1 = (({selectedProductOptionVals:l})=>{let[o,s]=reactExports.useState([]),c=reactExports.useRef(null),d=reactExports.useMemo(()=>{let t=[];return l?.detailsAndCareContent&&""!==l.detailsAndCareContent.trim()&&t.push({title:l.detailsAndCareTitle.replace("&amp;","&"),content:l.detailsAndCareContent}),l?.extraAccordions&&l.extraAccordions.length>0&&(t=[...t,...l.extraAccordions]),l?.hideShippingAccordion!==true&&t.push({title:l.shippingAndReturnsTitle.replace("&amp;","&"),content:`<p>${l.shippingAndReturnsContent}</p>`}),t},[l]);return 0===d.length?null:(reactExports.useEffect(()=>{let t=t=>{c.current&&!c.current.contains(t.target)&&s([]);};return document.addEventListener("mousedown",t),()=>{document.removeEventListener("mousedown",t);}},[]),jsxRuntimeExports.jsx("div",{ref:c,className:"",children:d.map((n,r)=>jsxRuntimeExports.jsxs("div",{className:"border-b border-link",children:[jsxRuntimeExports.jsxs("button",{className:"w-full flex justify-between items-center py-4 px-3 transition duration-200 font-apercuBold text-[#13334C]",onClick:()=>{s(t=>t.includes(r)?t.filter(t=>t!==r):[...t,r]);},children:[n.title,jsxRuntimeExports.jsxs("span",{className:"relative w-5 h-5 block",children:[jsxRuntimeExports.jsx("span",{className:`absolute top-1/2 left-0 w-full h-[1px] bg-primary transition-transform duration-300 ease-in-out transform font-light font-apercuLight ${(o.includes(r),"scale-x-100")} -translate-y-1/2`}),jsxRuntimeExports.jsx("span",{className:`absolute top-0 left-1/2 h-full w-[1px] bg-primary transition-all duration-300 ease-in-out transform font-light font-apercuLight text-[0px]  ${o.includes(r)?"rotate-90 opacity-0":"rotate-0 opacity-100"} -translate-x-1/2`,style:{transformOrigin:"center"},children:"null"})]})]}),jsxRuntimeExports.jsx("div",{className:`transition-all duration-300 ease-in-out overflow-hidden text-primary ${o.includes(r)?"max-h-[500px] opacity-100 py-2":"max-h-0 opacity-0 py-0"}`,children:jsxRuntimeExports.jsx("div",{className:"text-primary text-[14px] custom-accordion-content pl-4",dangerouslySetInnerHTML:{__html:n.content||""}})})]},r))}))});

const l$2 = (({sourceId:i="rebuy-pair-it-with-source",rebuyId:n="234251"})=>{let u=reactExports.useRef(null);return reactExports.useEffect(()=>{let e=u.current,t=document.getElementById(i);if(!e||!t)return;let r=false,c=()=>{if(r)return;let i=t.querySelector(`[data-rebuy-id="${n}"]`);i&&(e.appendChild(i),r=true,l.disconnect());},l=new MutationObserver(c);return l.observe(t,{childList:true,subtree:true}),c(),()=>l.disconnect()},[i,n]),jsxRuntimeExports.jsx("div",{ref:u,className:"mt-4"})});

const u$1 = (({selectedProductOptionVals:o,currentProduct:n})=>jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment,{children:[jsxRuntimeExports.jsx("p",{className:"mt-7 text-left md:mt-10 font-apercu font-normal text-[16px] leading-[1.375] tracking-normal antialiased",dangerouslySetInnerHTML:{__html:o?.description}}),jsxRuntimeExports.jsx("div",{className:" w-[98%] mx-auto block",children:jsxRuntimeExports.jsxs("div",{className:"relative mx-auto my-4 block w-full border border-primary rounded-md pl-[100px] pr-[10px] bg-white min-h-[120px] pb-[10px]",children:[jsxRuntimeExports.jsx("span",{className:"absolute top-[-1px] left-6",children:jsxRuntimeExports.jsx("img",{src:"/cdn/shop/files/guarantee-badge-small.svg?v=1711568843",alt:"Guarantee Badge"})}),jsxRuntimeExports.jsx("h3",{className:"font-clearface font-bold mt-[0.85rem] mb-0 text-[24px] text-left",children:"Our Promise"}),jsxRuntimeExports.jsxs("p",{className:"font-apercu mt-0 text-left",children:[jsxRuntimeExports.jsx("span",{className:"font-apercu mt-0 text-left font-bold text-16",children:"Wowed, or we'll make it right."}),jsxRuntimeExports.jsxs("span",{className:"block text-16",children:["If for any reason you’re not 100% wowed by Weezie, ",jsxRuntimeExports.jsx("a",{href:"mailto:holler@weezietowels.com",className:"underline hover:text-royalBlue",children:"holler"})," and we’ll make it right. "]})]})]})}),jsxRuntimeExports.jsx(r$1,{selectedProductOptionVals:o}),jsxRuntimeExports.jsx(l$2,{})]}));

const getEmbRules=(a=[])=>{let i=a.includes("ForsythSmall"),e={Perry:{charLimitRules:"1-3",charMax:3,charMin:1,hint:"e.g. First Initial, Last Initial, Middle Initial.",limitHint:"1-3 letters",spaces:false,defaultText:"wze",allCaps:true,specialChars:false},Ardsley:{charLimitRules:"1,3",charMax:3,charMin:1,hint:"e.g. First Initial, Last Initial, Middle Initial.",limitHint:"1 or 3 letters",spaces:false,defaultText:"wze",allCaps:true,specialChars:false},Hudson:{charLimitRules:"1-3",charMax:3,charMin:1,hint:"e.g. First Initial, Last Initial, Middle Initial.",limitHint:"1-3 letters",spaces:false,defaultText:"wze",allCaps:true,specialChars:false},Prince:{charLimitRules:"1-4",charMax:a.includes("embmaxchar:3")||a.includes("emb:slipper")?3:4,charMin:1,hint:"e.g. First Initial, Middle Initial, Last Initial.",limitHint:`1-${a.includes("embmaxchar:3")?3:4} letters`,spaces:false,defaultText:"wze",allCaps:true,specialChars:false},Crosby:{charLimitRules:"3",charMax:3,charMin:3,hint:"e.g. First Initial, Last Initial, Middle Initial.",limitHint:"3 letters",spaces:false,defaultText:"wze",allCaps:true,specialChars:false},Mercer:{charLimitRules:"1",charMax:1,charMin:1,hint:"e.g. First Initial or Last Initial.",limitHint:"1 letter",spaces:false,defaultText:"w",allCaps:true,specialChars:false},Ansley:{charLimitRules:"1",charMax:1,charMin:1,hint:"e.g. First Initial or Last Initial.",limitHint:"1 letter",spaces:false,defaultText:"w",allCaps:true,specialChars:false},"Ansley Vine":{charLimitRules:"1",charMax:1,charMin:1,hint:"e.g. First Initial or Last Initial.",limitHint:"1 letter",spaces:false,defaultText:"w",allCaps:true,specialChars:false},River:{charLimitRules:"1-13",charMax:a.includes("embmaxchar:20")?20:a.includes("embmaxchar:10")?10:a.includes("embmaxchar:3")?3:13,charMin:1,hint:"e.g. Anything you want. Have fun!",limitHint:`1-${a.includes("embmaxchar:20")?20:a.includes("embmaxchar:10")?10:a.includes("embmaxchar:3")||a.includes("emb:slipper")?3:13} characters`,spaces:true,defaultText:"Weezie",allCaps:false,specialChars:true},Waverly:{charLimitRules:"1-13",charMax:a.includes("embmaxchar:10")?10:a.includes("embmaxchar:3")||a.includes("emb:slipper")?3:13,charMin:1,hint:"e.g. Anything you want. Have fun!",limitHint:`1-${a.includes("embmaxchar:10")?10:a.includes("embmaxchar:3")||a.includes("emb:slipper")?3:13} characters`,spaces:true,defaultText:"Weezie",allCaps:false,specialChars:true},Mallard:{charLimitRules:"1-11",charMax:a.includes("embmaxchar:10")?10:a.includes("embmaxchar:3")||a.includes("emb:slipper")?3:11,charMin:1,hint:"e.g. First Initial, Middle Initial, Last Initial.",limitHint:`1-${a.includes("embmaxchar:10")?10:a.includes("embmaxchar:3")||a.includes("emb:slipper")?3:11} characters`,spaces:true,defaultText:"Weezie",allCaps:false,specialChars:true},Leeward:{charLimitRules:"1-11",charMax:a.includes("embmaxchar:10")?10:a.includes("embmaxchar:3")||a.includes("emb:slipper")?3:11,charMin:1,hint:"e.g. First Initial, Middle Initial, Last Initial.",limitHint:`1-${a.includes("embmaxchar:10")?10:a.includes("embmaxchar:3")||a.includes("emb:slipper")?3:11} characters`,spaces:true,defaultText:"Weezie",allCaps:false,specialChars:true},Lucy:{charLimitRules:"1-11",charMax:a.includes("embmaxchar:10")?10:a.includes("embmaxchar:3")||a.includes("emb:slipper")?3:11,charMin:1,hint:"e.g. First Initial, Middle Initial, Last Initial.",limitHint:`1-${a.includes("embmaxchar:10")?10:a.includes("embmaxchar:3")||a.includes("emb:slipper")?3:11} characters`,spaces:true,defaultText:"Weezie",allCaps:false,specialChars:true},Tybee:{charLimitRules:"1-13",charMax:a.includes("embmaxchar:10")?10:a.includes("embmaxchar:3")?3:13,charMin:1,hint:"e.g. Anything you want. Have fun!",limitHint:`1-${a.includes("embmaxchar:10")?10:a.includes("embmaxchar:3")||a.includes("emb:slipper")?3:13} characters`,spaces:true,defaultText:"Weezie",allCaps:false,specialChars:true},Sullivan:{charLimitRules:"1-13",charMax:a.includes("embmaxchar:10")?10:a.includes("embmaxchar:3")?3:13,charMin:1,hint:"e.g. Anything you want. Have fun!",limitHint:`1-${a.includes("embmaxchar:10")?10:a.includes("embmaxchar:3")||a.includes("emb:slipper")?3:13} characters`,spaces:true,defaultText:"Weezie",allCaps:false,specialChars:true},"Only River":{charLimitRules:"1-13",charMax:13,charMin:1,hint:"e.g. Anything you want. Have fun!",limitHint:"1-13 characters",spaces:true,defaultText:"Weezie",allCaps:false,specialChars:true},"Only Sullivan":{charLimitRules:"1-13",charMax:13,charMin:1,hint:"e.g. Anything you want. Have fun!",limitHint:"1-13 characters",spaces:true,defaultText:"Weezie",allCaps:false,specialChars:true},"River + Sullivan":{charLimitRules:"1-13",charMax:13,charMin:1,hint:"e.g. Anything you want. Have fun!",limitHint:"1-13 characters",spaces:true,defaultText:"Weezie",allCaps:false,specialChars:true},Wave:{charLimitRules:"1-3",charMax:3,charMin:1,hint:"e.g. First Initial, Middle Initial, Last Initial.",limitHint:"1-3 letters",spaces:false,defaultText:"WZE",allCaps:true,specialChars:false},Angler:{charLimitRules:"1-11",charMax:a.includes("embmaxchar:20")?20:a.includes("embmaxchar:10")?10:a.includes("embmaxchar:3")?3:11,charMin:1,hint:"e.g. First Initial, Middle Initial, Last Initial.",limitHint:`1-${a.includes("embmaxchar:20")?20:a.includes("embmaxchar:10")?10:a.includes("embmaxchar:3")||a.includes("emb:slipper")?3:11} characters`,spaces:true,defaultText:"W",allCaps:false,specialChars:true},Deuce:{charLimitRules:"1-3",charMax:3,charMin:1,hint:"e.g. First Initial, Middle Initial, Last Initial.",limitHint:"1-3 letters",spaces:false,defaultText:"WZE",allCaps:true,specialChars:false},Dink:{charLimitRules:"1-3",charMax:3,charMin:1,hint:"e.g. First Initial, Middle Initial, Last Initial.",limitHint:"1-3 letters",spaces:false,defaultText:"WZE",allCaps:true,specialChars:false},Birdie:{charLimitRules:"1-3",charMax:3,charMin:1,hint:"e.g. First Initial, Middle Initial, Last Initial.",limitHint:"1-3 letters",spaces:false,defaultText:"WZE",allCaps:true,specialChars:false},Evergreen:{charLimitRules:"1",charMax:1,charMin:1,hint:"e.g. First Initial or Last Initial.",limitHint:"1 letter",spaces:false,defaultText:"w",allCaps:true,specialChars:false},Susan:{charLimitRules:"1",charMax:1,charMin:1,hint:"e.g. First Initial or Last Initial.",limitHint:"1 letter",spaces:false,defaultText:"w",allCaps:true,specialChars:false},Jones:{charLimitRules:"3",charMax:3,charMin:3,hint:"e.g. First Initial, Last Initial, Middle Initial.",limitHint:"3 letters",spaces:false,defaultText:"wze",allCaps:true,specialChars:false},Grady:{charLimitRules:"1-3",charMax:3,charMin:1,hint:"e.g. First Initial, Last Initial, Middle Initial.",limitHint:"1-3 letters",spaces:false,defaultText:"wze",allCaps:true,specialChars:false},Wesley:{charLimitRules:"1-13",charMax:13,charMin:1,hint:"e.g. Anything you want. Have fun!",limitHint:"1-13 letters",spaces:true,defaultText:"WEEZIE",allCaps:true,specialChars:false},Forsyth:{charLimitRules:"1-3",charMax:3,charMin:1,hint:"e.g. First Initial, Last Initial, Middle Initial.",limitHint:"1-3 letters",spaces:false,defaultText:"wze",allCaps:true,specialChars:false},Ponce:{charLimitRules:"1",charMax:1,charMin:1,hint:"e.g. First Initial or Last Initial.",limitHint:"1 letter",spaces:false,defaultText:"w",allCaps:true,specialChars:false},Carter:{charLimitRules:"3",charMax:3,charMin:3,hint:"e.g. First Initial, Last Initial, Middle Initial.",limitHint:"3 letters",spaces:false,defaultText:"wze",allCaps:true,specialChars:false},Gander:{charLimitRules:"1-11",charMax:a.includes("embmaxchar:10")?10:a.includes("embmaxchar:3")||a.includes("emb:slipper")?3:11,charMin:1,hint:"e.g. First Initial, Middle Initial, Last Initial.",limitHint:`1-${a.includes("embmaxchar:10")?10:a.includes("embmaxchar:3")||a.includes("emb:slipper")?3:11} characters`,spaces:true,defaultText:"Weezie",allCaps:false,specialChars:true},Mary:{charLimitRules:"1-11",charMax:a.includes("embmaxchar:10")?10:a.includes("embmaxchar:3")||a.includes("emb:slipper")?3:11,charMin:1,hint:"e.g. First Initial, Middle Initial, Last Initial.",limitHint:`1-${a.includes("embmaxchar:10")?10:a.includes("embmaxchar:3")||a.includes("emb:slipper")?3:11} characters`,spaces:true,defaultText:"Weezie",allCaps:false,specialChars:true},Rex:{charLimitRules:"1-11",charMax:a.includes("embmaxchar:10")?10:a.includes("embmaxchar:3")||a.includes("emb:slipper")?3:11,charMin:1,hint:"e.g. First Initial, Middle Initial, Last Initial.",limitHint:`1-${a.includes("embmaxchar:10")?10:a.includes("embmaxchar:3")||a.includes("emb:slipper")?3:11} characters`,spaces:true,defaultText:"Weezie",allCaps:false,specialChars:true},Atlas:{charLimitRules:"1-11",charMax:a.includes("embmaxchar:10")?10:a.includes("embmaxchar:3")||a.includes("emb:slipper")?3:11,charMin:1,hint:"e.g. First Initial, Middle Initial, Last Initial.",limitHint:`1-${a.includes("embmaxchar:10")?10:a.includes("embmaxchar:3")||a.includes("emb:slipper")?3:11} characters`,spaces:true,defaultText:"Weezie",allCaps:false,specialChars:true},Petal:{charLimitRules:"1-11",charMax:a.includes("embmaxchar:10")?10:a.includes("embmaxchar:3")||a.includes("emb:slipper")?3:11,charMin:1,hint:"e.g. First Initial, Middle Initial, Last Initial.",limitHint:`1-${a.includes("embmaxchar:10")?10:a.includes("embmaxchar:3")||a.includes("emb:slipper")?3:11} characters`,spaces:true,defaultText:"Weezie",allCaps:false,specialChars:true},Grace:{charLimitRules:"1-11",charMax:a.includes("embmaxchar:10")?10:a.includes("embmaxchar:3")||a.includes("emb:slipper")?3:11,charMin:1,hint:"e.g. First Initial, Middle Initial, Last Initial.",limitHint:`1-${a.includes("embmaxchar:10")?10:a.includes("embmaxchar:3")||a.includes("emb:slipper")?3:11} characters`,spaces:true,defaultText:"Weezie",allCaps:false,specialChars:true},Derby:{charLimitRules:"1-11",charMax:a.includes("embmaxchar:10")?10:a.includes("embmaxchar:3")||a.includes("emb:slipper")?3:11,charMin:1,hint:"e.g. First Initial, Middle Initial, Last Initial.",limitHint:`1-${a.includes("embmaxchar:10")?10:a.includes("embmaxchar:3")||a.includes("emb:slipper")?3:11} characters`,spaces:true,defaultText:"Weezie",allCaps:false,specialChars:true},Grant:{charLimitRules:"1-3",charMax:3,charMin:1,hint:"e.g. First Initial, Last Initial, Middle Initial.",limitHint:"1-3 letters",spaces:false,defaultText:"wze",allCaps:true,specialChars:false},Highland:{charLimitRules:"1-5",charMax:a.includes("highland:embmaxchar:10")?10:a.includes("highland:embmaxchar:8")?8:a.includes("highland:embmaxchar:6")?6:5,charMin:1,hint:"e.g. Anything you want. Have fun!",limitHint:`1-${a.includes("highland:embmaxchar:10")?10:a.includes("highland:embmaxchar:8")?8:a.includes("highland:embmaxchar:6")?6:5} letters`,spaces:false,defaultText:"wze",allCaps:true,specialChars:false},Inman:{charLimitRules:"1-6",charMax:6,charMin:1,hint:"e.g. Anything you want. Have fun!",limitHint:"1-6 letters",spaces:false,defaultText:"WEEZIE",allCaps:true,specialChars:false},Windsor:{charLimitRules:"1-4",charMax:4,charMin:1,hint:"e.g. Anything you want. Have fun!",limitHint:"1-4 letters",spaces:false,defaultText:"WEEZ",allCaps:true,specialChars:false}};return i?{...e,Forsyth:{charLimitRules:"1",charMax:1,charMin:1,hint:"e.g. First Initial or Last Initial.",limitHint:"1 letter",spaces:false,defaultText:"w",allCaps:true,specialChars:false}}:e};

let u=reactExports.createContext();const useEmbroidery=()=>reactExports.useContext(u);let B=(e,i,t=[],n=[])=>"embroidery"===i?t.includes(e)?e:t[0]||P$1[0]:"applique"===i?n.includes(e)?e:n[0]||L$1[0]:t.includes(e)||n.includes(e)?e:t[0]||P$1[0],F=(e,i,t,n=[],l=[])=>{let r=C(i,t,n,l);return r&&0!==r.length?r.find(i=>i.appliqueName&&i.appliqueName===e?.appliqueName)||r.find(i=>i.name===e?.name)||r[0]:t?q[0]:S$1[0]},A=(e,i=[])=>i.includes(e)||L$1.includes(e),C=(e,i,t=[],n=[])=>{if(i)return n.length>0?n:q;if("Evergreen"===e){let e=t.find(e=>"Cranberry"===e.name);return e?[e]:[S$1.find(e=>"Cranberry"===e.name)]}let l=t.length>0?t:S$1;return isTwoToneOnlyFont(e)?TWO_TONE_FONTS[e]||[]:TWO_TONE_FONTS[e]?[...l,...TWO_TONE_FONTS[e]]:l},q=[{appliqueName:"Spa Blue Poppy & Daisy Liberty",name:"Spa Blue",stroke:"#91B6BB",fill:"https://cdn.shopify.com/s/files/1/0739/6242/2568/files/Blue_Poppy_Daisy_Liberty-updated.png?v=1777071729",background:"Blue Poppy and Daisy Liberty"},{appliqueName:"Taupe Katie and Millie Liberty",name:"Taupe",stroke:"#AF9483",fill:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/katie___millie_720.jpg?v=1776797249",background:"Liberty"},{appliqueName:"Spa Blue Katie and Millie Liberty",name:"Spa Blue",stroke:"#91B6BB",fill:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/katie___millie_720.jpg?v=1776797249",background:"Liberty"},{appliqueName:"Green Betsy Ann Liberty",name:"Green",stroke:"#6FA287",fill:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/betsy_ann_720.jpg?v=1776797250",background:"Betsy Ann Liberty"},{appliqueName:"Light Blue Betsy Ann Liberty",name:"Light Blue",stroke:"#D2E2F1",fill:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/betsy_ann_720.jpg?v=1776797250",background:"Betsy Ann Liberty"},{appliqueName:"Light Pink Michelle",name:"Ballet Pink",stroke:"#FACAD8",fill:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/libertybow_720.jpg?v=1776797249",background:"Michelle"},{appliqueName:"Light Blue Adelajda",name:"Light Blue",stroke:"#D2E2F1",fill:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/adelajda_720.jpg?v=1776797249",background:"Adelajda"},{appliqueName:"White with Soft White",name:"White",stroke:"#FFFFFF",fill:"#F4F5F2",background:"Soft White"},{appliqueName:"Sand with Soft White",name:"Sand",stroke:"#DFD4C9",fill:"#FFFFFF",background:"Soft White"},{appliqueName:"Green",name:"Green",stroke:"#6FA287",fill:"#99B089",background:"Green"},{appliqueName:"Ballet Pink with Pink",name:"Ballet Pink",stroke:"#FACAD8",fill:"#FCE8DF",background:"Pink"},{appliqueName:"French Blue with Blue",name:"French Blue",stroke:"#78A0D4",fill:"#A3BDCA",background:"Blue"},{appliqueName:"Coral with Pink",name:"Coral",stroke:"#F4A095",fill:"#FCE8DF",background:"Pink"},{appliqueName:"Red with Blue",name:"Red",stroke:"#ba0c2f",fill:"#A3BDCA",background:"Blue"},{appliqueName:"French Blue with Green",name:"French Blue",stroke:"#78A0D4",fill:"#99B089",background:"Green"},{appliqueName:"Navy with Blue",name:"Navy",stroke:"#14334C",fill:"#A3BDCA",background:"Blue"}],S$1=[{name:"Light Blue",hex:"#D2E2F1"},{name:"Ballet Pink",hex:"#FACAD8"},{name:"Coral",hex:"#F4A095"},{name:"Bright Pink",hex:"#DE5B96"},{name:"Marigold",hex:"#ffce06"},{name:"Cranberry",hex:"#831D35"},{name:"Red",hex:"#ba0c2f"},{name:"French Blue",hex:"#78A0D4"},{name:"Navy",hex:"#14334C"},{name:"Spa Blue",hex:"#91B6BB"},{name:"Green",hex:"#6FA287"},{name:"White",hex:"#FFFFFF"},{name:"Sand",hex:"#DFD4C9"},{name:"Taupe",hex:"#AF9483"},{name:"Brown",hex:"#453126"},{name:"Grey",hex:"#BFC2C6"},{name:"Black",hex:"#000000"},{name:"Begonia",hex:"#F07695"}],x$1=[{name:"Parterre Green",hex:"#A5B293"},...S$1],P$1=["Perry","Ardsley","Hudson","Prince","Crosby","Jones","Grady","Ansley","Mercer","Wesley","River","Tybee","Sullivan","Waverly","Evergreen"],L$1=["Forsyth","Ponce","Grant"];const EmbroideryProvider=({children:i})=>{let t=new URLSearchParams(window.location.search),[v,$]=reactExports.useState(""),[D,N]=reactExports.useState(""),[M,R]=reactExports.useState(["","",""]),[E,G]=reactExports.useState(false),[T,W]=reactExports.useState("wze"),[j,z]=reactExports.useState(null),[H,I]=reactExports.useState(null),[O,U]=reactExports.useState(0),[J,K]=reactExports.useState(0),[V,Q]=reactExports.useState(false),{selectedProductOptionVals:X,selectedProduct:Y,currentVariant:Z,setCurentVariant:ee,selectedProductVariantInfo:ei,selectedFont:et,embVisibility:en,setEmbVisibility:el,activeQty:er,getCurrency:ea}=useProductContext(),es=new e$3,[eo,eu]=reactExports.useState(null),ed=window.Shopify?.country||"US",ec=Y?.tags.includes("embmaxchar:3"),ep=Y?.images.filter(e=>"string"==typeof e&&e.toLowerCase().includes("_emb")),em=(Y?.tags.filter(e=>e.includes("bundle"))).length>0,ef=reactExports.useMemo(()=>X?.options_with_values?.filter(e=>{if(!e?.name||"string"!=typeof e.name)return  false;let i=e.name.toLowerCase();return i.includes("color")||i.includes("pattern")||i.includes("piping")||i.includes("stitching")||i.includes("style")&&!i.includes("robe style")||i.includes("robe size")}),[X]),eh=reactExports.useMemo(()=>X?.options_with_values?.filter(e=>{if(!e?.name||"string"!=typeof e.name)return  false;let i=e.name.toLowerCase();return i.includes("size")&&!i.includes("rug size")&&!i.includes("robe size")||i.includes("towel type")||i.includes("robe style")}),[X]),ey=eh.length>0,eg=reactExports.useMemo(()=>X?.options_with_values?.filter(e=>!!e?.name&&"string"==typeof e.name&&e.name.toLowerCase().includes("embroidery")),[X]),eb=reactExports.useMemo(()=>{let e=Y?.tags.find(e=>e.includes("embroidery"));return e?e.split(":"):[]},[Y])[1]||"none",ew=reactExports.useMemo(()=>{let e=Y?.handle||"",i=Y?.tags||[];return {isPaterre:["parterre-x-weezie-lil-robe","parterre-x-weezie-floral-robe","parterre-x-weezie-clover-robe"].some(i=>e.includes(i)),isSlipper:i.includes("emb:slipper"),isSash:i.includes("emb:sash"),isGolf:e.includes("golf-towel"),isAngler:e.includes("fishing-towel"),isTennis:e.includes("tennis-towel"),isWave:e.includes("shammy-towel-bundle")||e.includes("shammy-towels"),isPickleball:e.includes("pickleball-towel"),isGoose:i.some(e=>e.includes("icon:goose")),isSwan:i.some(e=>e.includes("icon:swan")),isFlower:i.some(e=>e.includes("icon:flower")),isSheep:i.some(e=>e.includes("icon:sheep")),isDino:i.some(e=>e.includes("icon:dino")),isRockingHorse:i.some(e=>e.includes("icon:rocking-horse")),isBalloon:i.some(e=>e.includes("icon:balloon")),isDuck:i.some(e=>e.includes("icon:duck")),isBoat:i.some(e=>e.includes("icon:boat")),isBow:i.some(e=>e.includes("icon:bow")),isInman:i.includes("emb-applique:font-inman"),isWindsor:i.includes("emb-applique:font-windsor"),isCarter:i.includes("emb-applique:font-carter"),isHighland:i.includes("emb-applique:font-highland"),isMultiRowEqual:i.includes("emb:multi-row-equal"),isMultiRowCascade:i.includes("emb:multi-row-cascade")}},[Y?.handle,Y?.tags]),e_=eo||Z,ek=ei?.product_variant_info?.findIndex(e=>e.id===e_?.id),{embfonts:ev,embAppliqueFonts:eB}=reactExports.useMemo(()=>{let e=[...P$1],i=[...L$1];if(et?.length>0)return {embfonts:[et],embAppliqueFonts:i};if(ew.isSlipper){let i=new Set(["Jones","Perry","Ardsley","Hudson"]);e=e.filter(e=>!i.has(e));}ew.isGolf&&e.unshift("Birdie"),ew.isTennis&&e.unshift("Deuce"),ew.isPickleball&&e.unshift("Dink"),ew.isWave&&e.unshift("Wave"),ew.isAngler&&e.unshift("Angler"),ew.isBow&&e.unshift("Lucy"),ew.isBoat&&e.unshift("Leeward"),ew.isDuck&&e.unshift("Mallard"),ew.isGoose&&e.unshift("Gander"),ew.isSheep&&e.unshift("Mary"),ew.isDino&&e.unshift("Rex"),ew.isFlower&&e.unshift("Petal"),ew.isRockingHorse&&e.unshift("Derby"),ew.isSwan&&e.unshift("Grace"),ew.isBalloon&&e.unshift("Atlas"),ew.isMultiRowEqual&&e.push("Only River","Only Sullivan"),ew.isMultiRowCascade&&e.push("River + Sullivan");let t=ei?.product_variant_info?.[ek]?.metafields?.included_seasonal_fonts;t&&Array.isArray(t)&&t.includes("Evergreen")||(e=e.filter(e=>"Evergreen"!==e));let n=ei?.product_variant_info?.[ek]?.metafields?.invalid_embroidery_fonts;n&&Array.isArray(n)&&n.length>0&&(e=e.filter(e=>!n.includes(e)),n.includes("Ansley")&&!e.includes("Ansley Vine")&&e.push("Ansley Vine")),e=Array.from(new Set(e)),ew.isInman&&i.push("Inman"),ew.isWindsor&&i.push("Windsor"),ew.isCarter&&i.push("Carter"),ew.isHighland&&i.push("Highland");let l=ei?.product_variant_info?.[ek]?.metafields?.invalid_applique_fonts;return l&&Array.isArray(l)&&l.length>0&&(i=i.filter(e=>!l.includes(e))),{embfonts:e,embAppliqueFonts:i}},[et,ew,ei,ek]),eF=X?.options_with_values.some(e=>!!e?.name&&"string"==typeof e.name&&e.name.toLowerCase().includes("embroidery")&&e.values.some(e=>"string"==typeof e&&"applique"===e.toLowerCase())),eA=getEmbRules(Y?.tags),eC=reactExports.useMemo(()=>{let e=ei?.product_variant_info?.[ek]?.metafields?.invalid_embroidery_colors,i=ei?.product_variant_info?.[ek]?.metafields?.valid_embroidery_colors;return (ew.isPaterre?x$1:S$1).filter(t=>"Brown"===t.name?i&&Array.isArray(i)&&i.includes("Brown"):!(e&&Array.isArray(e))||!e.includes(t.name))},[ei,ek,ew.isPaterre]),[eq,eS]=reactExports.useState(()=>t.get("font")||ev?.[0]||P$1[0]),[ex,eP]=reactExports.useState(()=>eC?.[0]||S$1[0]),[eL,e$]=reactExports.useState(()=>{let e=t.get("font");return !!e&&L$1.includes(e)}),[eD,eN]=reactExports.useState(()=>t.get("type")||"all"),eM=reactExports.useRef(false);reactExports.useLayoutEffect(()=>{if(eM.current)return;eM.current=true;let e=B(eq,eD,ev,eB),i=A(e,eB),n=C(e,i,eC,q),l=t.get("color"),r=l?n.find(e=>e.appliqueName===l)||n.find(e=>e.name===l)||n[0]:F(ex,e,i,eC,q);e!==eq&&eS(e),i!==eL&&e$(i),r?.name!==ex?.name&&eP(r);},[]);let[eR,eE]=reactExports.useState(ey?Z[`option${eh[0]?.position}`]:null),eG=async e=>{let i=eq;Y.tags.includes("Ponce Large")&&"Ponce"===eq?i="Ponce Large":Y.tags.includes("Ponce Small")&&"Ponce"===eq&&(i="Ponce Small");let t=ei.product_variant_info?.find(e=>e.id===eo?.id),n=Y?.title?.includes("Gift Card"),l=Y?.tags?.includes("gift_set"),r=ex?.twoTone===true?"Ansley"===i?ex.fontColor:`${ex.fontColor} ${ex.borderColor}`:ex?.name||"",a=i,s=isMultiRowFont(eq),o=(M||[]).filter(e=>""!==(e||"").trim()),u={};return s&&o.forEach((e,i)=>{MULTI_ROW_TEXT_KEYS[i]&&(u[MULTI_ROW_TEXT_KEYS[i]]=String(e));}),{...s?u:{"Embroidery Text":String(V?D.toUpperCase():D)},"Embroidery Color":String(r),"Embroidery Style":s?String(getMultiRowOpsStyle(eq)):String(a||""),...eL&&{"Embroidery Applique Background":String(ex?.background||""),...ex?.fill&&{_applique_fill:String(ex.fill)},...ex?.stroke&&{_applique_stroke:String(ex.stroke)}},...t?.available&&t?.inventory_quantity<=0&&!n&&{Status:"Backordered"},...t?.available&&t?.inventory_quantity<=0&&!n&&{Backorder:t?.metafields?.backorder_messaging||"Backordered - Ships when back in stock"},...l&&{_gift_set:await getNextGiftSetId()}}},eT=async()=>{let e,i=await eG();if(i.hasOwnProperty("_gift_set")&&er>1){let t=[];for(let e=0;e<er;e++)t.push({id:eo?.id,quantity:1,properties:{...i,_gift_set:await getNextGiftSetId()}});e={items:t};}else e={id:eo?.id,quantity:er,properties:i};fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(e)}).then(e=>{if(!e.ok)throw e.json(),Error("The maximum quantity of this item is already in your cart")}).then(()=>{window.dispatchEvent(new Event("cartUpdated")),setTimeout(()=>ej(),500);}).catch(e=>{console.error("Cart add error:",e),alert(e.message);}),(window.dataLayer||[]).push({event:"add_to_cart_track",ecommerce:{currency:ea(),value:Number(es.formatMoney(eo.price,"${{amount}}").replace("$","").replace(",","")),items:[{item_list_id:`${Y.id}`,item_list_name:`${Y.title}`,item_id:`${eo.id}`,item_name:`${Y.title}`,affiliation:"Weezie Towels",currency:ea(),coupon:null,discount:eo?.compare_at_price?es.formatMoney(eo?.compare_at_price,"${{amount}}").replace("$","").replace(",","")-es.formatMoney(eo?.price,"${{amount}}").replace("$","").replace(",",""):0,index:0,item_brand:"Weezie Towels",item_category:`${Y.type}`,item_category2:`${eo.option1}`,item_category3:null,item_category4:null,item_variant:null,price:Number(es.formatMoney(eo.price,"${{amount}}").replace("$","").replace(",","")),quantity:er}]}});},eW=e=>{let i="",t="",n="";e.length>0&&(/[\s]/g.test(e)&&!eA[eq].spaces&&(t="No spaces allowed."),"1,3"===eA[eq].charLimitRules&&2===e.length&&(n=`${eA[eq].limitHint} required.`),(e.length>eA[eq].charMax||e.length<eA[eq].charMin)&&(n=`${eA[eq].limitHint} required.`),i=/[^\w\s]|[\d]/gi.test(e)&&!eA[eq].specialChars?`No special characters or numbers allowed. ${n}${""!==t?` ${t}`:""}`:`${n}${""!==t?` ${t}`:""}`),$(i);};reactExports.useEffect(()=>{isMultiRowFont(eq)&&$("");},[M,eq]);let ej=()=>{let e=Y?.variants[0];t.delete("embvariant"),t.delete("personalized"),t.delete("font"),t.delete("color"),t.delete("type"),eo?.id===Z?(ee(e),t.set("variant",e.id)):t.set("variant",Z.id),window.history.replaceState({},"",`${location.pathname}?${t}`),el(false);},ez=e=>{let i=B(eq,e,ev,eB),t=A(i,eB);eP(F(ex,i,t,eC,q)),eN(e);},eH=()=>{null!==eo&&(t.delete("variant"),t.set("embvariant",eo?.id),t.set("personalized",D),t.set("font",eq),t.set("color",ex.appliqueName||ex.name),t.set("type",eD),window.history.replaceState({},"",`${location.pathname}?${t}`));};return reactExports.useEffect(()=>{let e=filterVariants(Y,eg[0]?.position,true,eh[0]?.position,eR,"applique"===eD||eB.includes(eq));I(e);let i=null===eo?Z:eo;en&&eu(e.filter(e=>e[`option${ef[0]?.position}`]===i?.[`option${ef[0]?.position}`])[0]);},[eR,eD,eL]),reactExports.useEffect(()=>{if("icons"!==eD){if(eA.hasOwnProperty(eq)){let e=eA[eq].defaultText;W(ec?"wze":e),U(eA[eq].charMax),K(eA[eq].limitHint),Q(eA[eq].allCaps),eW(D),N(D);}}else W("Icon");},[eq]),reactExports.useEffect(()=>{let e=B(eq,eD,ev,eB),i=A(e,eB),t=F(ex,e,i,eC,q);e!==eq&&eS(e),i!==eL&&e$(i),t!==ex&&eP(t);},[eD]),reactExports.useEffect(()=>{if(!eL){let e=F(ex,eq,false,eC,q);e!==ex&&eP(e);}},[eC]),reactExports.useEffect(()=>{null!==eo&&ef?.length>0&&z(ep.filter(e=>{if(!e||"string"!=typeof e)return  false;let i=eo?.[`option${ef[0].position}`];if("string"!=typeof i)return  false;let t=e=>e.replace(/\s/g,"-").replace(/[&\/\\#,+()$~%.'":*?<>{}]/g,"-").toLowerCase(),n=t(i);if(em){let e=eo?.option2;if("string"!=typeof e)return  false;n+="-"+t(e);}return e.toLowerCase().includes(n)})),eH();},[eo]),reactExports.useEffect(()=>{let e=t.has("embvariant")?{variantId:parseInt(t.get("embvariant"),10),font:t.get("font"),color:t.get("color"),tab:t.get("type")||"all",text:t.get("personalized")||""}:null;if(!e)return;let i=Y.variants.find(i=>i.id===e.variantId);ey&&i&&eE(i[`option${eh[0]?.position}`]),eu(i),N(e.text);let n=B(e.font,e.tab,ev,eB),l=A(n,eB);eS(n),eN(e.tab),e$(l);let r=C(n,l,eC,q);eP(r.find(i=>i.appliqueName===e.color)||r.find(i=>i.name===e.color)||r[0]);},[en]),reactExports.useEffect(()=>(en?document.body.classList.add("disable-scroll"):document.body.classList.remove("disable-scroll"),()=>document.body.classList.remove("disable-scroll")),[en]),jsxRuntimeExports.jsx(u.Provider,{value:{hasErrorText:v,setHasErrorText:$,inputText:D,setInputText:N,multiRowTexts:M,setMultiRowTexts:R,isMultiRow:isMultiRowFont(eq),multiRowComplete:""!==(M?.[0]||"").trim()&&""!==(M?.[1]||"").trim(),multiRowMode:getMultiRowMode(eq),multiRowMinRows:MULTI_ROW_MIN_ROWS,multiRowMaxRows:MULTI_ROW_MAX_ROWS,multiRowMaxChars:MULTI_ROW_MAX_CHARS,activeFont:eq,setActiveFont:eS,defaultTab:eD,setDefaultTab:eN,hasOverflowText:E,setHasOverflowText:G,defaultText:T,setDefaultText:W,appliqueFontSelected:eL,setAppliqueFontSelected:e$,activeEmbColor:ex,setActiveEmbColor:eP,embImgSrc:j,setEmbImgSrc:z,activeVariant:eo,setActiveVariant:eu,visibleVariants:H,setVisibleVariants:I,activeSize:eR,setActiveSize:eE,visitorCountry:ed,styleOption:ef,sizeOption:eh,embPosClass:eb,embroideryOption:eg,appliqueOptionAvailable:eF,embfonts:ev,embAppliqueFonts:eB,embColors:eC,twoToneColors:TWO_TONE_FONTS[eq]||[],appliqueEmbColors:q,smallMaxChar:ec,embFontToggles:ez,keyPressFontToggle:(e,i)=>{("Enter"===e.key||13===e.charCode)&&ez(i);},keyPressFont:(e,i)=>{let t=A(i,eB);e$(t),eP(F(ex,i,t,eC,q));},closeEmbModal:ej,handleChange:({target:e})=>{let i=e.value,t=getEmbRules(Y?.tags)[eq],n=t?.charMax;t.spaces||(i=i.replace(/\s/g,"")),eW(i=(i=t.specialChars?i.replace(/[^!@#$%&‘’'-+\w\s]/gi,""):i.replace(/[^\w\s]|[\d]/gi,"")).substring(0,n)),i.length<=n?N(i):""!==v&&N(i);},addToCart:eT,embRules:eA,getProperties:eG,setUrl:eH,inputAllCaps:V,maxChars:O,productFlags:ew},children:i})};

/**
 * fitty v2.4.2 - Snugly resizes text to fit its parent container
 * Copyright (c) 2023 Rik Schennink <rik@pqina.nl> (https://pqina.nl/)
 */

var e$2=function(e){if(e){var t=function(e){return [].slice.call(e)},n=0,i=1,r=2,o=3,a=[],l=null,u="requestAnimationFrame"in e?function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{sync:false};e.cancelAnimationFrame(l);var n=function(){return s(a.filter((function(e){return e.dirty&&e.active})))};if(t.sync)return n();l=e.requestAnimationFrame(n);}:function(){},c=function(e){return function(t){a.forEach((function(t){return t.dirty=e})),u(t);}},s=function(e){e.filter((function(e){return !e.styleComputed})).forEach((function(e){e.styleComputed=m(e);})),e.filter(y).forEach(v);var t=e.filter(p);t.forEach(d),t.forEach((function(e){v(e),f(e);})),t.forEach(S);},f=function(e){return e.dirty=n},d=function(e){e.availableWidth=e.element.parentNode.clientWidth,e.currentWidth=e.element.scrollWidth,e.previousFontSize=e.currentFontSize,e.currentFontSize=Math.min(Math.max(e.minSize,e.availableWidth/e.currentWidth*e.previousFontSize),e.maxSize),e.whiteSpace=e.multiLine&&e.currentFontSize===e.minSize?"normal":"nowrap";},p=function(e){return e.dirty!==r||e.dirty===r&&e.element.parentNode.clientWidth!==e.availableWidth},m=function(t){var n=e.getComputedStyle(t.element,null);return t.currentFontSize=parseFloat(n.getPropertyValue("font-size")),t.display=n.getPropertyValue("display"),t.whiteSpace=n.getPropertyValue("white-space"),true},y=function(e){var t=false;return !e.preStyleTestCompleted&&(/inline-/.test(e.display)||(t=true,e.display="inline-block"),"nowrap"!==e.whiteSpace&&(t=true,e.whiteSpace="nowrap"),e.preStyleTestCompleted=true,t)},v=function(e){e.element.style.whiteSpace=e.whiteSpace,e.element.style.display=e.display,e.element.style.fontSize=e.currentFontSize+"px";},S=function(e){e.element.dispatchEvent(new CustomEvent("fit",{detail:{oldValue:e.previousFontSize,newValue:e.currentFontSize,scaleFactor:e.currentFontSize/e.previousFontSize}}));},h=function(e,t){return function(n){e.dirty=t,e.active&&u(n);}},w=function(e){return function(){a=a.filter((function(t){return t.element!==e.element})),e.observeMutations&&e.observer.disconnect(),e.element.style.whiteSpace=e.originalStyle.whiteSpace,e.element.style.display=e.originalStyle.display,e.element.style.fontSize=e.originalStyle.fontSize;}},b=function(e){return function(){e.active||(e.active=true,u());}},z=function(e){return function(){return e.active=false}},F=function(e){e.observeMutations&&(e.observer=new MutationObserver(h(e,i)),e.observer.observe(e.element,e.observeMutations));},g={minSize:16,maxSize:512,multiLine:true,observeMutations:"MutationObserver"in e&&{subtree:true,childList:true,characterData:true}},W=null,E=function(){e.clearTimeout(W),W=e.setTimeout(c(r),x.observeWindowDelay);},M=["resize","orientationchange"];return Object.defineProperty(x,"observeWindow",{set:function(t){var n="".concat(t?"add":"remove","EventListener");M.forEach((function(t){e[n](t,E);}));}}),x.observeWindow=true,x.observeWindowDelay=100,x.fitAll=c(o),x}function C(e,t){var n=Object.assign({},g,t),i=e.map((function(e){var t=Object.assign({},n,{element:e,active:true});return function(e){e.originalStyle={whiteSpace:e.element.style.whiteSpace,display:e.element.style.display,fontSize:e.element.style.fontSize},F(e),e.newbie=true,e.dirty=true,a.push(e);}(t),{element:e,fit:h(t,o),unfreeze:b(t),freeze:z(t),unsubscribe:w(t)}}));return u(),i}function x(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return "string"==typeof e?C(t(document.querySelectorAll(e)),n):C([e],n)[0]}}("undefined"==typeof window?null:window);

const $ = (({inputText:a,defaultText:c,calcText:s=false,setHasOverflowText:m,hasOverflowText:u,embRefPreviewText:o,embRefPreviewContainer:f,activeFont:l})=>{let d=reactExports.useRef(),p=a.replace(/\s/g," ");return s?jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment,{children:""!==p?[...p].map((r,t)=>jsxRuntimeExports.jsx("span",{children:r},`${r}-${t}`)):[...c].map((r,t)=>jsxRuntimeExports.jsx("span",{children:r},`${r}-${t}`))}):(reactExports.useEffect(()=>{let e,r,t=()=>{d.current&&(e=e$2(d.current,{minSize:10,maxSize:160,observeMutations:false}),r=setTimeout(()=>{if(o?.current&&f?.current){let e=o.current.offsetWidth;m(e>f.current.offsetWidth);}},300));};return document.fonts?.ready?document.fonts.ready.then(t):t(),()=>{clearTimeout(r),e&&e.unsubscribe();}},[p,m]),jsxRuntimeExports.jsx("div",{ref:d,className:"w-full",children:(""!==p?[...p]:[...c]).map((r,t)=>jsxRuntimeExports.jsx("span",{children:r},`${r}-${t}`))}))});

const N = (({activeFontLower:n,text:s,swashColor:a})=>{let i=reactExports.useRef(null);return reactExports.useEffect(()=>{let e,t=i.current;if(!t)return;let r=null,l=()=>t.parentElement?.clientWidth??t.clientWidth,n=()=>{t.style.setProperty("--tt-fit-scale","1"),r=l();let e=1;for(let r=0;r<2;r+=1){let r=l(),n=t.scrollWidth;if(!r||!n||n<=r)break;e*=r/n,t.style.setProperty("--tt-fit-scale",String(e));}},s=()=>{cancelAnimationFrame(e),e=requestAnimationFrame(n);};document.fonts?.ready?document.fonts.ready.then(s):s();let a=new ResizeObserver(()=>{l()!==r&&s();});return a.observe(t.parentElement??t),()=>{cancelAnimationFrame(e),a.disconnect();}},[s,n]),jsxRuntimeExports.jsx("div",{ref:i,className:`embroidery__preview-text--${n}-twotone w-full`,children:[...s].map((r,l)=>{let s=" "===r?" ":r;return jsxRuntimeExports.jsxs("span",{className:`${n}-tt-cell`,children:[jsxRuntimeExports.jsx("span",{className:`${n}-tt-letter`,children:s}),jsxRuntimeExports.jsx("span",{className:`${n}-tt-swash`,style:{color:a},children:s})]},`tt-${r}-${l}`)})})});

let P={Birdie:GolfClubs,Deuce:TennisRackets,Dink:PickleballPaddles,Wave:Wave,Angler:Angler,Mallard:Duck,Leeward:Boat,Lucy:Bow,Gander:GooseIcon,Rex:DinoIcon,Grace:SwanIcon,Mary:SheepIcon,Derby:RockingHorseIcon,Petal:FlowerIcon,Atlas:BalloonIcon,Gander:GooseIcon},j=["River","Waverly","Tybee","Sullivan","Wesley"];const r = (({})=>{let{hasErrorText:i,embPosClass:o,inputText:s,activeFont:n,defaultTab:m,hasOverflowText:c,setHasOverflowText:d,defaultText:p,appliqueFontSelected:f,activeEmbColor:w,embImgSrc:u,activeVariant:x,styleOption:y,setUrl:h,productFlags:v,isMultiRow:z,multiRowTexts:L,multiRowMode:A}=useEmbroidery(),F=v?.isSash&&j.includes(n),{selectedProduct:W}=useProductContext(),O=reactExports.useRef(null),B=reactExports.useRef(null),D=Array.isArray(u)?u[0]:u,G="string"==typeof n?n.toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/^-|-$/g,""):"",S="string"==typeof W?.type?W.type.toLowerCase().replace(/\s+/g,"-"):"",M=w?.fill&&w?.stroke,E=w?.twoTone===true&&isTwoToneFont(n);return reactExports.useEffect(()=>{setTimeout(()=>{d(B?.current?.getBoundingClientRect().width>O?.current?.getBoundingClientRect().width);},0),h();},[s,n,w]),jsxRuntimeExports.jsx("div",{className:"w-full bg-white fixed z-[5] top-0 left-0 right-0 flex items-start justify-center flex-nowrap overflow-hidden px-0 md:sticky md:h-screen md:w-1/2",children:jsxRuntimeExports.jsxs("div",{className:"embroidery-preview-wrapper bg-white relative aspect-square xl:min-w-[auto] flex-shrink-0 flex-grow md:flex-grow md:flex-shrink md:min-w-[auto] md:h-auto overflow-hidden w-full",children:[i&&jsxRuntimeExports.jsx("div",{className:"absolute inset-0 z-[500] flex items-center justify-center",children:jsxRuntimeExports.jsxs("span",{className:"bg-white font-normal text-[0.75rem] text-primary p-5 text-center rounded-lg border border-geyser block flex-shrink-0 flex-grow-0",children:["Please review ","applique"===m?"applique":"embroidery"," text and font selection.",jsxRuntimeExports.jsx("br",{}),"Current selections are not supported."]})}),jsxRuntimeExports.jsxs("div",{className:`embroidery__preview embroidery__preview--${o} embroidery__preview--${s.length}-${G}`,ref:O,children:["icons"!==m&&jsxRuntimeExports.jsx("div",{className:`embroidery__preview-text embroidery__preview-text--overflow-calc embroidery__preview-text--type-${S} embroidery__preview-text--${G} embroidery__preview-text--${G}--${o} embroidery__preview-text--${G}--${s.length}`,ref:B,children:""===i&&jsxRuntimeExports.jsx($,{embRefPreviewContainer:O,embRefPreviewText:B,hasOverflowText:c,calcText:true,setHasOverflowText:e=>d(e),inputText:s,defaultText:p,activeFont:n})}),jsxRuntimeExports.jsxs("div",{className:`
                  embroidery__preview-text embroidery__preview-text--${W.handle}
                  embroidery__preview-text--type-${S}
                  embroidery__preview-text--${G}
                  embroidery__preview-text--${G}--${o}
                  embroidery__preview-text--${G}--${s.length}
                  embroidery__preview-text--${"applique"===m||f?"applique":m}
                  ${F?`embroidery__preview-text--sash-rotated ${(()=>{if(!F)return "";let e=s.length;return e<=4?"sash-xs-short":e<=7?"sash-short":e<=10?"sash-medium":"sash-long"})()} ${c?"sash-overflow":""}`:""}
                `,style:("applique"===m||"all"===m&&f||"applique"===m||"all"===m&&f)&&M?{color:w.stroke,"--fill-backgrund":w.fill.startsWith("#")?w.fill:`url(${w.fill})`}:{color:w?.twoTone?w.fontHex:w?.hex},children:[P[n]?jsxRuntimeExports.jsx(P[n],{fillColor:w?.hex}):"Ponce"===n&&""===i&&M?jsxRuntimeExports.jsx(PonceSvgContainer,{stroke:w.stroke,fill:w.fill}):null,""===i&&"icons"!==m&&O.current?.offsetWidth>0&&(z?jsxRuntimeExports.jsx("div",{className:`embroidery__preview-text--multirow embroidery__preview-text--multirow--${A} w-full`,children:(()=>{let r=(L||[]).map((e,r)=>({t:e,i:r})).filter(e=>""!==(e.t||"").trim());return (r.length?r:getMultiRowPlaceholders(A).map((e,r)=>({t:e,i:r}))).map(({t:r,i:t})=>jsxRuntimeExports.jsx("div",{className:`multirow-row multirow-row-${t} multirow-row--${(getRowFont(n,t)||"").toLowerCase()} ${(r||"").length>=11?"multirow-row--long":""} ${0===t&&/[fgjpqyz]/.test(r||"")?"multirow-row--descender":""}`,children:r},t))})()}):isAnsleyFont(n)?jsxRuntimeExports.jsx("div",{className:"embroidery__preview-text--ansley-threetone w-full",children:(""!==(s||"").trim()?[...s||""]:[...p||""]).map((t,l)=>jsxRuntimeExports.jsxs("span",{className:"ansley-tt-cell",children:[jsxRuntimeExports.jsx("span",{className:"ansley-tt-flower",style:{color:w.borderHex},children:t}),jsxRuntimeExports.jsx("span",{className:"ansley-tt-stem",style:{color:w.vineHex},children:t}),jsxRuntimeExports.jsx("span",{className:"ansley-tt-letter",style:{color:w.fontHex},children:t})]},`ansley-${t}-${l}`))}):E?jsxRuntimeExports.jsx(N,{activeFontLower:G,text:""!==(s||"").trim()?s||"":p||"",swashColor:w.borderHex}):"Carter"===n?jsxRuntimeExports.jsx("div",{className:"embroidery__preview-text--carter-letters w-full",children:(""!==(s||"").trim()?[...s||""]:[...p||""]).map((t,l)=>jsxRuntimeExports.jsxs("span",{className:"carter-cell",children:[jsxRuntimeExports.jsx("span",{className:"carter-letter",children:t}),jsxRuntimeExports.jsx("span",{className:"carter-outline",style:{color:w.stroke},children:t})]},`carter-${t}-${l}`))}):"Highland"===n?jsxRuntimeExports.jsx("div",{className:"embroidery__preview-text--highland-letters",children:(""!==(s||"").trim()?[...s||""]:[...p||""]).map((r,t)=>jsxRuntimeExports.jsx("span",{children:r},`highland-${r}-${t}`))}):jsxRuntimeExports.jsx($,{embRefPreviewContainer:O,embRefPreviewText:B,hasOverflowText:c,setHasOverflowText:e=>d(e),inputText:s,defaultText:p,activeFont:n})),"Ponce"===n&&""===i&&M&&jsxRuntimeExports.jsx(PonceSvgContainer,{stroke:w.stroke,fill:w.fill}),"Carter"===n&&""===i&&M&&jsxRuntimeExports.jsx(CarterSvgContainer,{stroke:w.stroke,fill:w.fill}),"Ansley Vine"===n&&""===i&&jsxRuntimeExports.jsxs("div",{className:"ansley-frame",children:[jsxRuntimeExports.jsx("div",{className:"ansley-frame__layer ansley-frame__vine",style:{backgroundColor:w.vineHex}}),jsxRuntimeExports.jsx("div",{className:"ansley-frame__layer ansley-frame__petals",style:{backgroundColor:w.borderHex}}),jsxRuntimeExports.jsx("div",{className:"ansley-frame__layer ansley-frame__outline",style:{backgroundColor:w.fontHex}})]}),"Evergreen"===n&&""===i&&jsxRuntimeExports.jsx(GarlandIcon,{})]})]}),D&&jsxRuntimeExports.jsx("img",{className:"block w-full h-full m-0 w-auto relative z-[15] md:h-auto md:w-full object-contain",src:D,srcSet:getOptimizedImageSrcset(D,[360,480,600,720,900,1200,1800]),sizes:"(min-width: 768px) calc((100vw - 40px) / 2), 100vw",alt:x?x?.[`option${y[0].position}`]:""})]})})});

let X=({defaultTab:r,tabType:t,embFontToggles:l,children:i})=>jsxRuntimeExports.jsx("button",{className:`flex flex-col items-center justify-center text-center text-12 leading-[22px] cursor-pointer relative bg-sand border border-lightBlue border-b-black rounded-[2px_2px_0_0] p-[9px_16px] flex-1
        ${r===t?' current bg-white border-royalBlue border-b-black before:content-[""] before:absolute before:left-0 before:top-0 before:w-full before:block before:h-[5px] before:bg-royalBlue before:rounded-t-[2px]':""}
        `,type:"button",onClick:()=>l(t),children:i});const s$3 = (()=>{let{defaultTab:Y,appliqueOptionAvailable:Z,embfonts:ee=[],embAppliqueFonts:er=[],activeFont:et,setActiveFont:el,keyPressFont:ei,smallMaxChar:eo,embFontToggles:en}=useEmbroidery(),{baseVariant:es,embroideryVariant:ea,appliqueVariant:ep,selectedProductVariantInfo:em}=useProductContext(),ec=reactExports.useRef(null),[ed,ef]=reactExports.useState(15),[eu,ex]=reactExports.useState(30);if(es&&em&&ec.current!==es.id){let e=em.product_variant_info?.find(e=>e.id===es.id)?.metafields?.units_per_sku||1;ec.current=es.id,ef(ea?Math.round((ea.price-es.price)/100/e):15),ex(ep?Math.round((ep.price-es.price)/100/e):30);}let eb=(t,l=false)=>{let i=isMultiRowFont(t);return jsxRuntimeExports.jsx("div",{className:"w-[72px] basis-[84px] p-0 flex-none [contain:layout]",children:jsxRuntimeExports.jsxs("div",{className:`${l?"embroidery__font-btn--applique":""} relative flex w-full h-full flex-col items-center justify-between text-center font-apercu font-normal text-[11rem] capitalize cursor-pointer p-[5px_5px_7px] ${i?"pt-[16px] px-[2px]":""} rounded-[2px] border border-lightBlue transition-colors duration-200 ease-in-out mb-0${l?"flex justify-center content-between gap-[5px]":""} ${et===t?"border-primary":""}`,tabIndex:"0",onKeyPress:e=>ei(e,t),onClick:e=>{el(t),ei(e,t);},children:[i&&jsxRuntimeExports.jsx("span",{className:"absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10 px-[8px] py-[3px] rounded-full bg-lightBlue text-primary text-[10px] leading-none normal-case whitespace-nowrap",children:"Multi-Line"}),((r,t=false)=>{let l={elClass:`${isMultiRowFont(r)?"h-[36px]":"h-[47px]"} my-0 mx-auto fill-navy ${t?"embroidery__font-btn__icon embroidery__font-btn__icon--applique":""}`},i={perry:jsxRuntimeExports.jsx(PerryBadge,{...l}),ardsley:jsxRuntimeExports.jsx(ArdsleyBadge,{...l}),prince:jsxRuntimeExports.jsx(PrinceBadge,{...l}),hudson:jsxRuntimeExports.jsx(HudsonBadge,{...l}),crosby:jsxRuntimeExports.jsx(CrosbyBadge,{...l}),jones:jsxRuntimeExports.jsx(JonesBadge,{...l}),grady:jsxRuntimeExports.jsx(GradyBadge,{...l}),wesley:jsxRuntimeExports.jsx(WesleyBadge,{...l}),mercer:jsxRuntimeExports.jsx(MercerBadge,{...l}),ansley:jsxRuntimeExports.jsx(AnsleyBadge,{elClass:`h-[47px] scale-[1.45] my-0 mx-auto fill-navy ${t?"embroidery__font-btn__icon embroidery__font-btn__icon--applique":""}`}),"ansley-vine":jsxRuntimeExports.jsx(AnsleyVineBadge,{...l}),river:jsxRuntimeExports.jsx(RiverWordBadge,{...l}),waverly:jsxRuntimeExports.jsx(WaverlyWordBadge,{...l}),tybee:jsxRuntimeExports.jsx(TybeeWordBadge,{...l}),sullivan:jsxRuntimeExports.jsx(SullivanWordBadge,{...l}),susan:jsxRuntimeExports.jsx(SusanBadge,{...l}),birdie:jsxRuntimeExports.jsx(BirdieBadge,{...l}),deuce:jsxRuntimeExports.jsx(DeuceBadge,{...l}),wave:jsxRuntimeExports.jsx(WaveBadge,{...l}),angler:jsxRuntimeExports.jsx(AnglerBadge,{...l}),dink:jsxRuntimeExports.jsx(DinkBadge,{...l}),mallard:jsxRuntimeExports.jsx(DuckBadge,{...l}),leeward:jsxRuntimeExports.jsx(BoatBadge,{...l}),lucy:jsxRuntimeExports.jsx(BowBadge,{...l}),evergreen:jsxRuntimeExports.jsx(EvergreenBadgeSelector,{...l}),forsyth:jsxRuntimeExports.jsx(ForsythBadge,{...l}),ponce:jsxRuntimeExports.jsx(PonceBadge,{...l}),windsor:jsxRuntimeExports.jsx(WindsorBadge,{...l}),inman:jsxRuntimeExports.jsx(InmanBadge,{...l}),grant:jsxRuntimeExports.jsx(GrantBadge,{...l}),carter:jsxRuntimeExports.jsx(CarterBadge,{...l}),highland:jsxRuntimeExports.jsx(HighlandBadge,{...l}),gander:jsxRuntimeExports.jsx(GooseBadge,{...l}),rex:jsxRuntimeExports.jsx(DinoBadge,{...l}),grace:jsxRuntimeExports.jsx(SwanBadge,{...l}),mary:jsxRuntimeExports.jsx(SheepBadge,{...l}),derby:jsxRuntimeExports.jsx(RockinghorseBadge,{...l}),petal:jsxRuntimeExports.jsx(FlowerBadge,{...l}),atlas:jsxRuntimeExports.jsx(BalloonBadge,{...l}),"only-river":jsxRuntimeExports.jsx(OnlyRiverBadge,{...l}),"only-sullivan":jsxRuntimeExports.jsx(OnlySullivanBadge,{...l}),"river-sullivan":jsxRuntimeExports.jsx(RiverSullivanBadge,{...l})};if("string"!=typeof r)return console.warn(`Invalid font type: "${r}" (${typeof r})`),null;let o=r.trim().toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/^-|-$/g,"");return i[o]||console.warn(`No badge found for font: "${r}"`),i[o]||null})(t,l),jsxRuntimeExports.jsx("p",{className:`${i?"text-[10px] whitespace-nowrap":"text-[11px]"}`,children:t})]})},t)},eh=()=>{let t="applique"===Y,l=t?eu:ed;return jsxRuntimeExports.jsxs("div",{className:"mt-[24px]",children:[jsxRuntimeExports.jsx("p",{children:jsxRuntimeExports.jsxs("strong",{children:[t?"Applique":"Embroidery"," +$",l,jsxRuntimeExports.jsx("span",{className:"ml-[5px]",children:"per item"})]})}),t&&jsxRuntimeExports.jsx("p",{children:"Fabric inside + embroidered edges"})]})};return jsxRuntimeExports.jsxs("div",{className:"mt-[24px] md:mt-[10px]",children:[false===eo&&Z&&jsxRuntimeExports.jsxs("div",{className:"flex flex-nowrap gap-[8px] min-h-[52px] items-stretch md:mt-5",children:[jsxRuntimeExports.jsx(X,{defaultTab:Y,tabType:"all",embFontToggles:en,children:"All Styles"}),jsxRuntimeExports.jsx(X,{defaultTab:Y,tabType:"embroidery",embFontToggles:en,children:jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment,{children:[jsxRuntimeExports.jsx("strong",{children:"Embroidery"}),jsxRuntimeExports.jsxs("span",{className:"subtext",children:["+$",ed,jsxRuntimeExports.jsx("span",{className:"ml-[5px]",children:"per item"})]})]})}),jsxRuntimeExports.jsx(X,{defaultTab:Y,tabType:"applique",embFontToggles:en,children:jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment,{children:[jsxRuntimeExports.jsx("strong",{children:"Applique"}),jsxRuntimeExports.jsxs("span",{className:"subtext",children:["+$",eu,jsxRuntimeExports.jsx("span",{className:"ml-[5px]",children:"per item"})]})]})})]}),jsxRuntimeExports.jsxs("div",{className:"flex flex-col relative w-full justify-center items-center",children:[("all"===Y||"embroidery"===Y)&&Z&&jsxRuntimeExports.jsx(eh,{}),"applique"===Y&&Z&&jsxRuntimeExports.jsx(eh,{}),jsxRuntimeExports.jsxs("div",{className:" w-full max-w-full md:max-w-[445px]",children:[jsxRuntimeExports.jsxs("div",{className:`flex items-stretch justify-start md:justify-center overflow-x-scroll md:overflow-hidden pt-[18px] gap-[5px] w-full md:flex-wrap ${ee?.length<4||"applique"===Y&&er.length<4?"justify-center":"md:flex-wrap"}`,style:{scrollbarWidth:"none"},children:[("applique"===Y&&er.length>=4||"applique"!==Y&&ee.length>=4)&&jsxRuntimeExports.jsx(OverflowArrow,{elClass:"md:hidden h-[81px] w-[49px] absolute right-0 z-[2] fill-transparent bg-transparent"}),"all"===Y&&ee.filter(e=>"string"==typeof e).map((e,r)=>eb(e,false)),"embroidery"===Y&&ee.filter(e=>"string"==typeof e).map((e,r)=>eb(e,false)),"applique"===Y&&er.filter(e=>"string"==typeof e).map((e,r)=>eb(e,true)),("applique"===Y&&er.length>=5||"applique"!==Y&&ee.length>=5)&&jsxRuntimeExports.jsx("span",{className:"mr-[30px]"})]}),"all"===Y&&Z&&jsxRuntimeExports.jsx("div",{className:"flex flex-wrap items-stretch overflow-x-scroll md:overflow-hidden mt-[10px] gap-[5px] w-full justify-center",style:{scrollbarWidth:"none"},children:jsxRuntimeExports.jsxs("div",{className:"w-full",children:[jsxRuntimeExports.jsxs("div",{className:"mt-[24px] font-apercu",children:[jsxRuntimeExports.jsx("p",{children:jsxRuntimeExports.jsxs("strong",{children:["Applique +$",eu,jsxRuntimeExports.jsx("span",{className:"ml-[5px]",children:"per item"})]})}),jsxRuntimeExports.jsx("p",{children:"fabric inside + embroidered edges"})]}),jsxRuntimeExports.jsxs("div",{className:`w-full flex flex-nowrap md:flex-wrap items-stretch overflow-x-scroll md:overflow-hidden mt-[18px] gap-[5px] md:justify-center ${er.length<4?"justify-center":"justify-start"}`,style:{scrollbarWidth:"none"},children:[er.length>=4&&jsxRuntimeExports.jsx(OverflowArrow,{elClass:"md:hidden h-[81px] w-[49px] absolute right-0 z-[2] fill-transparent bg-transparent"}),er.filter(e=>"string"==typeof e).map((e,r)=>eb(e,true)),er.length>=5&&jsxRuntimeExports.jsx("span",{className:"mr-[30px]"})]})]})})]})]})]})});

const n$4 = (()=>{let{defaultTab:a,appliqueFontSelected:i,activeEmbColor:s,appliqueEmbColors:p,embColors:m,twoToneColors:d,keyPressColor:c,setActiveEmbColor:x,activeFont:f}=useEmbroidery(),u=isTwoToneOnlyFont(f),b=(u?0:m.length)+d.length>=8;return jsxRuntimeExports.jsxs("div",{className:"flex flex-col justify-stretch items-center flex-[0_0_100%] my-[24px] pt-[12px] border-t border-lightBlue md:justify-center",children:[jsxRuntimeExports.jsx("div",{className:"flex w-full items-center overflow-x-scroll md:overflow-hidden relative md:flex-[0_1_auto] md:justify-center",style:{scrollbarWidth:"none"},children:jsxRuntimeExports.jsxs("p",{className:"m-0 p-0 pb-[10px] w-full text-center md:pb-[4px]",children:[jsxRuntimeExports.jsx("span",{className:"mr-[5px] font-apercu whitespace-nowrap text-[14px] text-fiord",children:"applique"===a||i?"Applique Color:":"Embroidery Color:"})," ",jsxRuntimeExports.jsx("span",{className:"mr-[5px] font-apercu whitespace-nowrap text-[14px] text-fiord",children:i?s.appliqueName:s.name})]})}),jsxRuntimeExports.jsxs("div",{className:"w-full flex  md:flex-wrap items-center flex-[1_0_100%] overflow-x-scroll overflow-y-hidden md:overflow-hidden relative md:flex-[0_1_auto] md:justify-center",style:{scrollbarWidth:"none"},children:[!i&&b&&jsxRuntimeExports.jsx(OverflowArrow,{elClass:"h-[81px] w-[49px] absolute md:hidden right-0 z-[100] fill-transparent bg-transparent z-[2]"}),jsxRuntimeExports.jsxs("div",{className:`flex md:flex-wrap md:justify-center overflow-x-scroll md:overflow-hidden items-center m-0 relative w-full md:p-0 ${i?"flex-[0_0_100%] flex-wrap justify-center":b?"justify-start pl-[10px]":"justify-center"}`,style:{scrollbarWidth:"none"},children:["applique"===a||i?p.map(t=>jsxRuntimeExports.jsx("div",{className:"flex-none min-w-[42px] p-[5px] relative",children:jsxRuntimeExports.jsxs("div",{tabIndex:"0",title:t.appliqueName,className:`cursor-pointer bg-white border border-link rounded-full h-[32px] m-0 overflow-hidden relative transition-all duration-300 ease-in-out text-primary font-sans text-sm leading-none font-normal p-[5px] flex items-center justify-center flex-col ${t.appliqueName===s.appliqueName?"border border-primary":""} `,onKeyPress:e=>c(e,t),onClick:()=>x(t),children:[jsxRuntimeExports.jsx("span",{className:"absolute left-[5px] -top-[7px] w-[120%] h-full bg-center bg-no-repeat bg-[length:400%] transform rotate-45 origin-center",style:{backgroundColor:t.stroke}}),jsxRuntimeExports.jsx("span",{className:"absolute right-[6px] -bottom-[13px] w-[120%] h-full bg-center bg-no-repeat bg-[length:400%] transform rotate-45 origin-center",style:t.fill.startsWith("#")?{backgroundColor:t.fill}:{backgroundImage:`url(${t.fill})`}})]})},t.appliqueName)):jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment,{children:[!u&&m.map((r,t)=>jsxRuntimeExports.jsx("div",{className:`flex-none ${t==m.length-1&&0===d.length?"pr-[35px] md:pr-0":""} min-w-[42px] p-[5px] relative`,children:jsxRuntimeExports.jsx("span",{tabIndex:"0",title:r.name,style:{backgroundColor:r.hex},className:`flex items-center justify-center cursor-pointer bg-white border border-geyser rounded-[30px] h-[32px] w-[32px] m-0 overflow-hidden relative transition-all duration-300 ease-in-out text-primary font-sans text-[0.875rem] leading-[1] font-normal p-[5px] last-of-type:m-0${r.name===s.name?"border border-primary":""}`,onKeyPress:e=>c(e,r),onClick:()=>x(r)})},r.hex)),d.map((t,l)=>jsxRuntimeExports.jsx("div",{className:`flex-none ${l==d.length-1?"pr-[35px] md:pr-0":""} min-w-[42px] p-[5px] relative`,children:jsxRuntimeExports.jsxs("div",{tabIndex:"0",title:t.name,className:`cursor-pointer bg-white border border-geyser rounded-full h-[32px] w-[32px] m-0 overflow-hidden relative transition-all duration-300 ease-in-out text-primary font-sans text-sm leading-none font-normal p-[5px] flex items-center justify-center flex-col ${t.name===s.name?"border border-primary":""}`,onKeyPress:e=>c(e,t),onClick:()=>x(t),children:[jsxRuntimeExports.jsx("span",{className:"absolute left-[5px] -top-[7px] w-[120%] h-full bg-center bg-no-repeat bg-[length:400%] transform rotate-45 origin-center",style:{backgroundColor:t.borderHex}}),jsxRuntimeExports.jsx("span",{className:"absolute right-[6px] -bottom-[13px] w-[120%] h-full bg-center bg-no-repeat bg-[length:400%] transform rotate-45 origin-center",style:{backgroundColor:t.fontHex}})]})},t.name))]}),!i&&jsxRuntimeExports.jsx("span",{className:"spacer"})]})]})]})});

const d$5 = (()=>{let{defaultText:n,maxChars:l,inputText:p,handleChange:i,inputAllCaps:s,hasErrorText:d,isMultiRow:x,multiRowMode:c,multiRowTexts:m,setMultiRowTexts:u,multiRowMinRows:f,multiRowMaxRows:h,multiRowMaxChars:b}=useEmbroidery();if(x){let r=getMultiRowPlaceholders(c);return jsxRuntimeExports.jsxs("div",{className:"pt-[24px] mt-[24px] border-t border-lightBlue",children:[jsxRuntimeExports.jsxs("p",{className:"font-apercuBold text-16 text-primary text-center",children:["Enter text (Up to ",h," lines)"]}),jsxRuntimeExports.jsxs("p",{className:"text-14 text-fiord text-center mb-[16px]",children:["Each line allows 1-",b," characters. Case sensitive."]}),Array.from({length:h}).map((t,a)=>jsxRuntimeExports.jsx("input",{className:`w-full px-[19px] mb-[12px] bg-sand font-apercu font-normal text-16 leading-none text-fiord h-[48px] border border-sand rounded appearance-none transition duration-200 ease-in-out placeholder-fiord focus:border-primary embroidery__input--haserror-${""!==d}`,type:"text",placeholder:a+1>f?`${r[a]} (optional)`:r[a],maxLength:b,value:m[a]||"",onChange:e=>((e,t)=>{let r=[...m];r[e]=sanitizeMultiRowText(t),u(r);})(a,e.target.value)},a)),""!==d&&jsxRuntimeExports.jsx("span",{className:"font-normal text-[11px] text-coral block pt-[7px] text-left",children:d})]})}return jsxRuntimeExports.jsxs("div",{className:"pt-[24px]",children:[jsxRuntimeExports.jsx("input",{className:`w-full px-[19px] bg-sand font-apercu font-normal text-16 leading-none text-fiord h-[48px] border border-sand  rounded appearance-none transition duration-200 ease-in-out placeholder-fiord focus:border-primary ${s?"uppercase":""} embroidery__input--haserror-${""!==d}`,type:"text",placeholder:n,maxLength:l,value:p,onChange:e=>i(e)}),""!==d&&jsxRuntimeExports.jsx("span",{className:"font-normal text-[11px] text-coral block pt-[7px] text-left",children:d})]})});

const h$1 = (()=>jsxRuntimeExports.jsxs("div",{className:"flex  flex-col items-center justify-center",children:[jsxRuntimeExports.jsx("div",{className:"max-w-[415px] bg-sand mt-5 mx-[30px] pt-5 pb-5 text-center md:mt-[15px] md:px-[30px] md:pt-[10px] md:pb-[10px]",children:jsxRuntimeExports.jsx("p",{className:"font-apercu text-12 lg:text-16 text-royalBlue",children:"Please note the preview is approximate. Customized items cannot be exchanged or returned and may require additional time to process."})}),jsxRuntimeExports.jsxs("div",{className:"mt-5 mx-[30px] text-center md:mt-[15px]",children:[jsxRuntimeExports.jsx("p",{className:"font-apercu text-12 lg:text-16 text-royalBlue",children:"Still have questions?"}),jsxRuntimeExports.jsxs("p",{className:"font-apercu text-12 lg:text-16 text-black",children:["Email ",jsxRuntimeExports.jsx("a",{href:"mailto:holler@weezietowels.com",children:"holler@weezietowels.com"})]})]})]}));

function d$4({name:r,embroiderySwatchData:a,activeVariant:i,setActiveVariant:n,styleOptionKey:d,visibleVariants:c,selectedProductVariantInfo:m}){return jsxRuntimeExports.jsxs("div",{className:"relative flex flex-col flex-wrap items-center justify-stretch w-full border-t border-lightBlue my-[24px] pt-[12px] md:justify-center md:flex-nowrap product__variants__row product__variants__row--full",children:[jsxRuntimeExports.jsx("div",{className:"flex items-center flex-[1_0_100%] overflow-x-scroll md:overflow-hidden relative md:flex-[0_1_auto] md:justify-center",style:{scrollbarWidth:"none"},children:jsxRuntimeExports.jsxs("p",{className:"m-0 p-0 pb-[10px] w-full flex-[1_0_100%] text-center md:pb-[4px]",children:[jsxRuntimeExports.jsxs("span",{className:"font-apercu text-[14px] mr-[5px] text-primary",children:[r,":"]})," ",jsxRuntimeExports.jsxs("span",{className:"font-apercu text-[14px] mr-[5px] text-primary",children:[null!==i&&i[d],null!==i&&jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment,{children:[i?.available&&a?.find(e=>e.id===i?.id).inventory_quantity<=0&&jsxRuntimeExports.jsxs("span",{className:"font-apercu text-[14px] mr-[5px] text-primary",children:[" ","•"," ",a?.find(e=>e.id===i?.id).metafields.backorder_messaging??"Backordered - Ships when back in stock"]}),!i?.available&&jsxRuntimeExports.jsx("span",{className:"font-apercu text-[14px] mr-[5px] text-primary",children:" • Sold Out"})]})]})]})}),jsxRuntimeExports.jsxs("div",{className:"flex items-center flex-[1_0_100%] overflow-x-scroll md:overflow-hidden w-full md:flex-[0_1_auto] md:justify-center",style:{scrollbarWidth:"none"},children:[null!==c&&c.length>=8&&jsxRuntimeExports.jsx(OverflowArrow,{elClass:" md:hidden h-[81px] w-[49px] absolute right-0 z-[100] fill-transparent bg-transparent z-[2]"}),jsxRuntimeExports.jsxs("div",{className:`flex items-center md:flex-wrap justify-start md:justify-center m-0 relative w-full md:p-0 ${null!==c&&c?.length<=8&&"justify-center md:no-wrap"}`,children:[null!==c&&c.map((l,r)=>jsxRuntimeExports.jsx("div",{className:`${r===c.length-1?"pr-[30px] md:pr-0":""}`,children:jsxRuntimeExports.jsxs("div",{className:"flex-[0_0_auto] min-w-[42px] p-[5px] relative ",children:[jsxRuntimeExports.jsx("div",{tabIndex:"0",title:l.title,variantid:l.id,className:`cursor-pointer bg-white border border-geyser rounded-full h-[32px] w-[32px] m-0 overflow-hidden relative transition-colors duration-300 ease-in-out text-primary font-normal text-sm leading-none font-[Apercu,sans-serif] p-[5px] flex items-center justify-center ${i?.id===l.id?"border-primary":""}`,onClick:()=>n(l),children:a?.find(e=>e.id===l.id)?.swatch&&jsxRuntimeExports.jsx("img",{alt:`${a?.find(e=>e.id===l.id).title} color swatch`,src:a?.find(e=>e.id===l.id).swatch,srcSet:getOptimizedImageSrcset(a?.find(e=>e.id===l.id).swatch,[30,60]),sizes:"30px",className:"h-full w-full object-cover absolute left-0"})}),!l.available&&m?.product_variant_info.find(e=>e.id===l.id)?.inventory_quantity<=0&&jsxRuntimeExports.jsx("div",{className:"absolute inset-0 pointer-events-none",children:jsxRuntimeExports.jsx("span",{className:"absolute top-1/2 left-0 w-full h-[1px] bg-slateBlue -rotate-45 block origin-center"})})]})},l.id)),null!==c&&c.length>=8&&jsxRuntimeExports.jsx("span",{className:"spacer"})]})]})]})}function c$2({name:l,sizeOptions:r,activeSize:a,setActiveSize:i}){return jsxRuntimeExports.jsxs("div",{className:"flex flex-col items-center justify-stretch flex-wrap w-full my-[24px] pt-[12px] border-t border-lightBlue md:justify-center md:flex-nowrap",children:[jsxRuntimeExports.jsx("div",{className:"flex w-full justify-center mb-2.5 text-14 text-fiord",children:jsxRuntimeExports.jsxs("p",{className:"font-apercu mr-[5px]",children:[jsxRuntimeExports.jsxs("span",{className:"font-apercu mr-[5px]",children:[l,":"]})," ",jsxRuntimeExports.jsx("span",{className:"font-apercu mr-[5px]",children:a})]})}),jsxRuntimeExports.jsx("div",{className:"flex items-center flex-[1_0_100%] overflow-x-scroll relative md:overflow-hidden md:justify-center md:flex-[0_1_auto]",children:jsxRuntimeExports.jsx("div",{className:"flex items-center flex-wrap justify-center w-full m-0 relative md:p-0",children:r.map(({value:l,available:r})=>jsxRuntimeExports.jsx("div",{className:"flex-[0_0_auto] min-w-[42px] p-[5px] relative",children:jsxRuntimeExports.jsxs("div",{tabIndex:"0",className:`flex items-center justify-center max-md:min-w-[47px] md:h-8 p-[2px_14px] md:p-[15px] cursor-pointer overflow-hidden bg-white border border-geyser text-primary font-apercu text-[10px] leading-[19px] md:text-14 font-normal md:leading-none rounded-full transition-colors duration-300 ease-in-out last:m-0 ${l===a?"border-primary":""}`,onKeyDown:e=>{("Enter"===e.key||"Spacebar"===e.key||" "===e.key)&&i(l);},onClick:()=>i(l),children:[l,!r&&jsxRuntimeExports.jsx("div",{className:"absolute inset-0 pointer-events-none",children:jsxRuntimeExports.jsx("span",{className:"absolute top-1/2 left-0 w-full h-[1px] bg-slateBlue -rotate-45 block origin-center"})})]})},l))})})]})}const y$2 = (()=>{let{sizeOption:s,activeSize:o,setActiveSize:m,styleOption:p,activeVariant:f,visibleVariants:x,setActiveVariant:u}=useEmbroidery(),{embroiderySwatchData:h,selectedProductVariantInfo:v,selectedProduct:b}=useProductContext(),[w,y]=reactExports.useState(null),_=s?.length>0,N=_?`option${s[0].position}`:null,g=p.length>0,j=g?`option${p[0].position}`:null;return reactExports.useEffect(()=>{if(!_||!b||!f)return;let e=s[0].values.map(e=>({value:e,available:true}));if(j){let t=f[j];e.forEach(e=>{let l=b.variants.find(l=>l[j]===t&&l[N]===e.value);e.available=l?.available??false;}),y(e);}else e.forEach(e=>{let t=b.variants.find(t=>t[N]===e.value);e.available=t?.available??false;}),y(e);},[f,b]),jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment,{children:[_&&w&&jsxRuntimeExports.jsx(c$2,{name:s[0].name,sizeOptions:w,activeSize:o,setActiveSize:m}),g&&f&&jsxRuntimeExports.jsx(d$4,{name:p[0].name,embroiderySwatchData:h,visibleVariants:x,activeVariant:f,setActiveVariant:u,styleOptionKey:j,selectedProductVariantInfo:v})]})});

const fonts=[{name:"Perry",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Perry_480x480.svg?v=1721643849",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Perry_480x480.png?v=1721651155",description:"The perfect traditional monogram! Available for 1-3 letters. Enter First Initial, Last Initial, Middle Initial."},{name:"Ardsley",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Adrsley_480x480.svg?v=1721643849",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Adrsley_480x480.png?v=1721651154",description:"Available for 1 or 3 letters.  Enter First Initial, Last Initial, Middle Initial."},{name:"Hudson",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Hudson_480x480.svg?v=1721643849",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Hudson_480x480.png?v=1721651155",description:"Simple but charming! Available for 1-3 letters. Enter First Initial, Last Initial, Middle Initial."},{name:"Prince",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/princeton_480x480.svg?v=1721643849",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Prince_480x480.png?v=1721651155",description:"Our most modern embroidery style with same-size lettering. Available for 1-4 letters.  Enter First Initial, Middle Initial, Last Initial."},{name:"Crosby",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Crosby_480x480.svg?v=1721643849",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Crosby_480x480.png?v=1721651155",description:"Available for 3 letters. Enter First Initial, Last Initial, Middle Initial."},{name:"Jones",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/ACBjones.svg?v=1723732712",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Jones_480x480.png?v=1721651155",description:"Available for 3 letters.  Enter First Initial, Last Initial, Middle Initial."},{name:"Grady",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/ACB_Grady_monogram_all_navy.svg?v=1784848709",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/ACB_Grady_monogram_all_navy.svg?v=1784848709",description:"Available for 1-3 letters.  Enter First Initial, Last Initial, Middle Initial."},{name:"Wesley",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Wesley_guest_personlizer_tile.svg?v=1785960158",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Wesley_guest_personlizer_tile.svg?v=1785960158",description:"Available for 3 letters.  Enter First Initial, Last Initial, Middle Initial."},{name:"Mercer",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Mercer_480x480.svg?v=1721643849",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Mercer_480x480.png?v=1721651154",description:"Available for 1 letter.  Enter First Initial or Last Initial."},{name:"Ansley",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Mercer_480x480.svg?v=1721643849",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Mercer_480x480.png?v=1721651154",description:"A floral monogram. Available for 1 letter. Enter First Initial or Last Initial."},{name:"Ansley Vine",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Mercer_480x480.svg?v=1721643849",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Mercer_480x480.png?v=1721651154",description:"A floral monogram with a decorative vine border. Available for 1 letter. Enter First Initial or Last Initial."},{name:"River",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/River_480x480.svg?v=1721643849",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/River_480x480.png?v=1721651155",description:"A Weezie classic and the easiest way to say it all. Available for 1-11 characters."},{name:"Waverly",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Waverly_480x480.svg?v=1721643849",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/waverly_480x480.png?v=1721651155",description:"The perfect script with a playful twist.  A favorite for babies, beach and beyond! Available for 1-11 characters."},{name:"Tybee",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Tybee_480x480.svg?v=1721643849",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Tybee_480x480.png?v=1721651155",description:"Available for 1-11 characters. Enter First Initial, Middle Initial, Last Initial."},{name:"Sullivan",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Sullivan_480x480.svg?v=1721643849",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Sullivan_480x480.png?v=1721651154",description:"Available for 1-11 characters. Enter First Initial, Middle Initial, Last Initial."}];

const o$5 = (({title:r,children:o,isOpen:s,toggleAccordion:t,subtitle:c})=>jsxRuntimeExports.jsxs("div",{className:"accordion-custom",children:[jsxRuntimeExports.jsx("div",{className:"accordion-header",onClick:t,children:jsxRuntimeExports.jsx("h2",{children:r})}),jsxRuntimeExports.jsxs("div",{className:`accordion-content ${s?"open":""}`,children:[c&&jsxRuntimeExports.jsx("p",{className:"accordion-subtitle",children:c}),o]}),jsxRuntimeExports.jsx("div",{className:"line",onClick:t,children:jsxRuntimeExports.jsxs("svg",{width:"50",height:"50",viewBox:"0 0 82 82",fill:"none",xmlns:"http://www.w3.org/2000/svg",style:{transform:s?"rotate(-180deg)":"rotate(0deg)",transition:"transform 0.3s ease"},children:[jsxRuntimeExports.jsx("circle",{cx:"41",cy:"41",r:"39.5",fill:"white",stroke:"#FAF9FF",strokeWidth:"3"}),jsxRuntimeExports.jsx("path",{d:"M23 30L41.5 57L60 30",stroke:"#FAF9FF",strokeWidth:"3",strokeLinecap:"round",strokeLinejoin:"round"})]})})]}));

const applique=[{name:"Forsyth",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/forsyth-ex_430x.png?v=1722886338#",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Weezie_Lifestyle-_62720241580_1_430x.png?v=1722340691",description:"Our beloved Perry font, now in applique! Available for 1-3 letters. Enter First Initial, Last Initial, Middle Initial."},{name:"Ponce",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Layer_1_1_430x.svg?v=1722249970#",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Applique_ScallopBathTowel_1_1_430x.png?v=1722340675",description:"A charming and timeless choice for your initial. Available for 1 letter. Enter First Initial or Last Initial."},{name:"Grant",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/grant.svg?v=1762284039",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/PU-Grant1.jpg?v=1762283045",description:"A font with bold lines and streamlined style. Available for 1–3 letters."},{name:"Carter",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/ACB_monogram_Carter.svg?v=1784052510",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/ACB_monogram_Carter.svg?v=1784052510",description:"A classic framed monogram. Available for 3 letters. Enter First Initial, Last Initial, Middle Initial."},{name:"Highland",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/WEEZIE_Highland.svg?v=1786644601",hoverUrl:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/WEEZIE_Highland.svg?v=1786644601",description:"A bold applique for larger coverage. Enter your monogram or name."}];

const accordionData1=[{title:"What are my options?",content:"Piping, embroidery styles, and thread - oh my! We have multiple piping colors, embroidery styles, Applique fabrics, and thread colors for you to choose from. We provide the canvas, you make it custom!"},{title:"What is your most popular style?",content:"Our most popular fonts are Perry for monograms and River for script words."},{title:"What's the difference between embroidery and Applique?",content:"Embroidery uses thread to stitch directly onto the fabric (in this case, terry!), while Applique involves cutting an additional piece of fabric with laser-cut precision and placing it directly on top of the terry. It's then secured with stitches around the perimeter, adding an extra level of design and dimension to your Weezie."}];const accordionData2=[{title:"Where do I put my initials if I’m monogramming?",content:"Up to you. But in general, if each letter is the same size, put your initials in the order of first, middle, last name. If the middle letter is bigger, do first, last, middle. Our embroidery guide gives you the 411 on each embroidery option. It’s our secret weapon and now it’s yours too."},{title:"What is the most traditional monogram option?",content:"If we're following our grandmother's guidance, she'd suggest a three-letter monogram with a large center initial. We say you do you! Weezie offers multiple three-letter options in this style including Perry, Crosby, and Ardsley."},{title:"What is the most modern monogram option?",content:"Prince is one of our most modern monogram styles with all letters being the same size, and River is a fun way to write more than just initials!"},{title:"I have a four-initial name, what should I do?",content:"Embroider all four! Our Prince, River, Waverly, Tybee, and Sullivan fonts allow for 4-letter embroidery."},{title:"Which embroidery fonts are good for boys and men?",content:"It’s up to personal preference, but we recommend Hudson for monograms and Sullivan for names or words."}];const accordionData3=[{title:"Can I split embroidery between pairs and bundles?",content:`
          Unfortunately, we aren't able to split embroidery within a bundle. 
          The discounted price reflects the efficiencies offered to us by having identical embroidery across each towel. 
          If you'd like to order different embroidery styles or only certain towels embroidered within the set, your best bet is to order a la carte!
        `},{title:"What embroidery colors are exact matches to the pipings?",content:`
          Most of our embroidery colors are a perfect match to the corresponding piping, except Pink, Green, Navy, and Sand. 
          While the thread colors for these aren't an exact match, they're as close as we're able to source from our manufacturer, 
          and most people don't notice the difference! If having an exact match is super important to you, 
          we recommend going with one of the following colors: White, French Blue, Light Blue, Grey, Coral, or Black.
        `},{title:"Help! How do I decide?",content:`
          This is a great problem to have! We know one of the hardest parts is deciding on a piping color and thread color, 
          which is why we designed our embroidery preview! Our embroidery preview will help you visualize your towels- making the decision that much easier.
        `},{title:"Need some one-on-one help?",content:`
          Need some one on one help?  Email us at holler@weezietowels.com
        `}];

const d$3 = (({toggle:u,guideActive:v})=>{let[_,x]=reactExports.useState(null),[g,N]=reactExports.useState(false),[y,w]=reactExports.useState(false),[b,k]=reactExports.useState(false),[S,z]=reactExports.useState(null),[q,C]=reactExports.useState(null),[P,I]=reactExports.useState(null),[L,$]=reactExports.useState(false),F=e=>{H(e),x(i=>i===e?null:e);},A=e=>{e.stopPropagation(),x(null);},[E,H]=reactExports.useState(null),U=reactExports.useRef(null);return reactExports.useEffect(()=>{function e(e){U.current&&e.target.closest(".pop")?.querySelector("h3.text")?.textContent!==E&&x(null);}return document.addEventListener("mousedown",e),()=>{document.removeEventListener("mousedown",e);}},[U,E]),reactExports.useEffect(()=>{let e=new URLSearchParams(window.location.search);e.has("embvariant")&&""!==e.get("embvariant")&&$(true);},[]),jsxRuntimeExports.jsxs("div",{className:L?"embroidery__guide":"embroidery__guide--applique",children:[v&&jsxRuntimeExports.jsxs("button",{onClick:()=>u(false),className:"embroidery__guide__close type type--medium",children:[jsxRuntimeExports.jsx(BackCaretIcon,{}),"Back to Personalize"]}),jsxRuntimeExports.jsxs("div",{className:"emb-guide-container",children:[jsxRuntimeExports.jsx("div",{className:"emb-guide-hero",children:jsxRuntimeExports.jsxs("div",{className:"emb-guide-hero__title",children:[jsxRuntimeExports.jsx("img",{src:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/camel-new.svg?v=1726145120",alt:"Weezie Camel",className:""}),jsxRuntimeExports.jsx("h1",{children:"The Weezie Embroidery Guide"})]})}),jsxRuntimeExports.jsx("div",{className:"emb-how-to",children:jsxRuntimeExports.jsxs("div",{className:"emb-how-to__container",children:[jsxRuntimeExports.jsx("p",{className:"sect-header",children:"Design a towel you love"}),jsxRuntimeExports.jsx("h2",{children:"How to customize"}),jsxRuntimeExports.jsxs("div",{className:"steps-container",children:[jsxRuntimeExports.jsxs("div",{className:"step-block",children:[jsxRuntimeExports.jsx("img",{src:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/step1-new.png?v=1723658755",srcSet:getOptimizedImageSrcset("https://cdn.shopify.com/s/files/1/0019/0352/5941/files/step1-new.png?v=1723658755",[240,360,480,600,720,900,1200]),sizes:"(min-width: 1024px) calc((100vw - 100px - 60px) / 4 - 30px), (min-width: 768px) calc((100vw - 100px - 20px) / 2 - 30px), calc((100vw - 20px - 20px))",alt:"Step 1"}),jsxRuntimeExports.jsx("p",{children:"Select type of customization"})]}),jsxRuntimeExports.jsxs("div",{className:"step-block",children:[jsxRuntimeExports.jsx("img",{src:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/step2-new_9216135e-75f5-4ba3-afbf-4314a0d8ea7e.png?v=1726086311",srcSet:getOptimizedImageSrcset("https://cdn.shopify.com/s/files/1/0019/0352/5941/files/step2-new_9216135e-75f5-4ba3-afbf-4314a0d8ea7e.png?v=1726086311",[240,360,480,600,720,900,1200]),sizes:"(min-width: 1024px) calc((100vw - 100px - 60px) / 4 - 30px), (min-width: 768px) calc((100vw - 100px - 20px) / 2 - 30px), calc((100vw - 20px - 20px))",alt:"Step 2"}),jsxRuntimeExports.jsx("p",{children:"Choose style & enter text"})]}),jsxRuntimeExports.jsxs("div",{className:"step-block",children:[jsxRuntimeExports.jsx("img",{src:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/step3-new2.png?v=1723741988",srcSet:getOptimizedImageSrcset("https://cdn.shopify.com/s/files/1/0019/0352/5941/files/step3-new2.png?v=1723741988",[240,360,480,600,720,900,1200]),sizes:"(min-width: 1024px) calc((100vw - 100px - 60px) / 4 - 30px), (min-width: 768px) calc((100vw - 100px - 20px) / 2 - 30px), calc((100vw - 20px - 20px))",alt:"Step 3"}),jsxRuntimeExports.jsx("p",{children:"Pick a thread color"})]}),jsxRuntimeExports.jsxs("div",{className:"step-block",children:[jsxRuntimeExports.jsx("img",{src:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/step4-new_3c3f3f33-04de-4f42-b150-36be9f485e63.png?v=1726086310",srcSet:getOptimizedImageSrcset("https://cdn.shopify.com/s/files/1/0019/0352/5941/files/step4-new_3c3f3f33-04de-4f42-b150-36be9f485e63.png?v=1726086310",[240,360,480,600,720,900,1200]),sizes:"(min-width: 1024px) calc((100vw - 100px - 60px) / 4 - 30px), (min-width: 768px) calc((100vw - 100px - 20px) / 2 - 30px), calc((100vw - 20px - 20px))",alt:"Step 4"}),jsxRuntimeExports.jsx("p",{children:"Add to cart!"})]})]})]})}),jsxRuntimeExports.jsxs("div",{className:"font-options",children:[jsxRuntimeExports.jsx("p",{className:"sect-header",children:"Endless options made Weezie"}),jsxRuntimeExports.jsxs("div",{className:"emb-fonts",children:[jsxRuntimeExports.jsx(o$5,{title:"Meet Our Embroidery Styles",isOpen:g,toggleAccordion:()=>{g&&x(null),N(!g);},subtitle:"We stitch your design directly onto our plush terry, using high-quality thread to create a beautifully detailed and lasting finish. It's a timeless way to make your essentials uniquely yours.",children:jsxRuntimeExports.jsx("div",{className:`emb-fonts__container ${g?"emb-fonts__container--open":""} `,ref:U,children:fonts.map(s=>jsxRuntimeExports.jsxs("div",{className:"emb-fonts__container__item",onClick:()=>F(s.name),children:[jsxRuntimeExports.jsxs("div",{className:"emb-fonts__container__wrap",children:[jsxRuntimeExports.jsx("img",{src:s.url,srcSet:getOptimizedImageSrcset(s.url,[100,200]),sizes:"100px",alt:s.name}),jsxRuntimeExports.jsx("p",{children:s.name})]}),jsxRuntimeExports.jsx("div",{className:`pop-wrap ${_===s.name?"pop-wrap--open":"pop-wrap--hidden"}`,onClick:()=>F(s.name),children:jsxRuntimeExports.jsxs("div",{className:"pop",children:[jsxRuntimeExports.jsx("div",{className:"close-icon",children:jsxRuntimeExports.jsx(CloseIcon,{onClick:A})}),jsxRuntimeExports.jsx("img",{className:"inner-image",src:s.hoverUrl,srcSet:getOptimizedImageSrcset(s.hoverUrl,[220,280,440,560]),sizes:"(min-width: 1024px) calc(400px - 60px), calc(280px - 60px)",alt:`${s.name} Hover`}),jsxRuntimeExports.jsx("h3",{className:"text",children:s.name}),jsxRuntimeExports.jsx("p",{children:s.description})]})})]},s.name))})}),jsxRuntimeExports.jsx(o$5,{title:"Meet our Applique Styles",isOpen:b,toggleAccordion:()=>{b&&k(null),k(!b);},subtitle:"We use a precision-laser to cut a piece of fabric, place it on top of the terry, and stitch around the edges. The result is elevated, design-forward, and functional.",children:jsxRuntimeExports.jsx("div",{className:`emb-fonts__container ${b?"emb-fonts__container--open":""} `,ref:U,children:applique.map(s=>jsxRuntimeExports.jsxs("div",{className:"emb-fonts__container__item",onClick:()=>F(s.name),children:[jsxRuntimeExports.jsxs("div",{className:"emb-fonts__container__wrap",children:[jsxRuntimeExports.jsx("img",{src:s.url,srcSet:getOptimizedImageSrcset(s.url,[100,200]),sizes:"100px",alt:s.name}),jsxRuntimeExports.jsx("p",{children:s.name})]}),jsxRuntimeExports.jsx("div",{className:`pop-wrap ${_===s.name?"pop-wrap--open":"pop-wrap--hidden"}`,onClick:()=>F(s.name),children:jsxRuntimeExports.jsxs("div",{className:"pop",children:[jsxRuntimeExports.jsx("div",{className:"close-icon",children:jsxRuntimeExports.jsx(CloseIcon,{onClick:A})}),jsxRuntimeExports.jsx("img",{className:"inner-image",src:s.hoverUrl,srcSet:getOptimizedImageSrcset(s.hoverUrl,[220,280,440,560]),sizes:"(min-width: 1024px) calc(400px - 60px), calc(280px - 60px)",alt:`${s.name} Hover`}),jsxRuntimeExports.jsx("h3",{className:"text",children:s.name}),jsxRuntimeExports.jsx("p",{children:s.description})]})})]},s.name))})}),jsxRuntimeExports.jsx(o$5,{title:"Meet our Icons",isOpen:y,toggleAccordion:()=>{y&&x(null),w(!y);},subtitle:"Add a special touch with our embroidered icons. Crafted with high-quality thread and stitched onto plush terry, icons are perfect for a festive or personal detail.  Icons subject to seasonal availability.",children:jsxRuntimeExports.jsx("div",{className:`emb-fonts__container ${y?"emb-fonts__container--open":""} `,ref:U,children:icons.map(s=>jsxRuntimeExports.jsxs("div",{className:"emb-fonts__container__item",onClick:s.hoverUrl?()=>F(s.name):void 0,style:{cursor:s.hoverUrl?"pointer":"default"},children:[jsxRuntimeExports.jsxs("div",{className:"emb-fonts__container__wrap",children:[jsxRuntimeExports.jsx("img",{src:s.url,srcSet:getOptimizedImageSrcset(s.url,[100,200]),sizes:"100px",alt:s.name}),jsxRuntimeExports.jsx("p",{className:"text-center",children:s.name})]}),s.hoverUrl&&jsxRuntimeExports.jsx("div",{className:`pop-wrap ${_===s.name?"pop-wrap--open":"pop-wrap--hidden"}`,onClick:()=>F(s.name),children:jsxRuntimeExports.jsxs("div",{className:"pop",children:[jsxRuntimeExports.jsx("div",{className:"close-icon",children:jsxRuntimeExports.jsx(CloseIcon,{onClick:A})}),jsxRuntimeExports.jsx("img",{className:"inner-image",src:s.hoverUrl,srcSet:getOptimizedImageSrcset(s.hoverUrl,[220,280,440,560]),sizes:"(min-width: 1024px) calc(400px - 60px), calc(280px - 60px)",alt:`${s.name} Hover`}),jsxRuntimeExports.jsx("h3",{className:"text",children:s.name}),jsxRuntimeExports.jsxs("p",{children:[s.description,jsxRuntimeExports.jsx("br",{}),"e.g. Only available on eligible products."]})]})})]},s.name))})})]})]}),jsxRuntimeExports.jsxs("div",{className:"personalise",children:[jsxRuntimeExports.jsx("p",{className:"sect-header",children:"Monogram Guide"}),jsxRuntimeExports.jsx("h2",{children:"Personalizing for one?"}),jsxRuntimeExports.jsxs("div",{className:"personalise__content",children:[jsxRuntimeExports.jsx("p",{className:"underline",children:"Example"}),jsxRuntimeExports.jsx("h2",{children:"Carter Grace Bates"}),jsxRuntimeExports.jsx("div",{className:"personalise__wrap",children:[{title:"Single Initial",description:"First or Last",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Layer_1_28a95c68-b7f7-481c-8da6-d9230b450d39_480x480.svg?v=1721991748"},{title:"Three Initials",description:"First, Middle, Last",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Group_1849_1d814983-07d7-4284-9f3a-13ce0a98e0d6_480x480.png?v=1721991749"},{title:"Three Initials",description:"First, Last, Middle",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/carter-grace-bates.png?v=1722882774"}].map(s=>jsxRuntimeExports.jsxs("div",{className:"personalise__item",children:[jsxRuntimeExports.jsx("img",{src:s.url,srcSet:getOptimizedImageSrcset(s.url,[100,200]),sizes:"100px",alt:s.title}),jsxRuntimeExports.jsxs("div",{children:[jsxRuntimeExports.jsx("p",{className:"underline",children:s.title}),jsxRuntimeExports.jsx("p",{children:s.description})]})]}))})]}),jsxRuntimeExports.jsx("h2",{children:"Personalizing for two?"}),jsxRuntimeExports.jsxs("div",{className:"personalise__content",children:[jsxRuntimeExports.jsx("p",{className:"underline",children:"Example"}),jsxRuntimeExports.jsx("h2",{children:"Lila & Oliver Bennett"}),jsxRuntimeExports.jsx("p",{children:"a couple with the same last names"}),jsxRuntimeExports.jsxs("div",{className:"personalise__wrap",children:[jsxRuntimeExports.jsxs("div",{className:"personalise__item",children:[jsxRuntimeExports.jsx("img",{src:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Layer_1_28a95c68-b7f7-481c-8da6-d9230b450d39_430x.svg?v=1721991748#",srcSet:getOptimizedImageSrcset("https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Layer_1_28a95c68-b7f7-481c-8da6-d9230b450d39_430x.svg?v=1721991748#",[100,200]),sizes:"100px",alt:"font"}),jsxRuntimeExports.jsxs("div",{children:[jsxRuntimeExports.jsx("p",{className:"underline",children:"Single Initial"}),jsxRuntimeExports.jsx("p",{children:"First or Last"})]})]}),jsxRuntimeExports.jsxs("div",{className:"personalise__item",children:[jsxRuntimeExports.jsx("img",{src:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/image_1504_430x.png?v=1722338621",srcSet:getOptimizedImageSrcset("https://cdn.shopify.com/s/files/1/0019/0352/5941/files/image_1504_430x.png?v=1722338621",[100,200]),sizes:"100px",alt:"font"}),jsxRuntimeExports.jsxs("div",{children:[jsxRuntimeExports.jsx("p",{className:"underline",children:"Three Initials"}),jsxRuntimeExports.jsx("p",{children:"First, Last, First"})]})]})]}),jsxRuntimeExports.jsx("div",{className:"content-line"}),jsxRuntimeExports.jsx("p",{className:"underline",children:"Example"}),jsxRuntimeExports.jsxs("h2",{children:["Carter Lee Smith &",jsxRuntimeExports.jsx("span",{children:"Alex Fitzgerald"})]}),jsxRuntimeExports.jsx("p",{children:"a couple with different last names"}),jsxRuntimeExports.jsxs("div",{className:"personalise__wrap",children:[jsxRuntimeExports.jsxs("div",{className:"personalise__item",children:[jsxRuntimeExports.jsx("img",{src:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/image_1470_430x.png?v=1722322051",srcSet:getOptimizedImageSrcset("https://cdn.shopify.com/s/files/1/0019/0352/5941/files/image_1470_430x.png?v=1722322051",[100,200]),sizes:"100px",alt:"font"}),jsxRuntimeExports.jsxs("div",{children:[jsxRuntimeExports.jsx("p",{className:"underline",children:"Three Initials"}),jsxRuntimeExports.jsx("p",{children:"First, Last, Middle of one partner"})]})]}),jsxRuntimeExports.jsxs("div",{className:"personalise__item",children:[jsxRuntimeExports.jsx("img",{src:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/csaf2.svg?v=1726238571",srcSet:getOptimizedImageSrcset("https://cdn.shopify.com/s/files/1/0019/0352/5941/files/csaf2.svg?v=1726238571",[100,200]),sizes:"100px",alt:"font"}),jsxRuntimeExports.jsxs("div",{children:[jsxRuntimeExports.jsx("p",{className:"underline",children:"Four initials"}),jsxRuntimeExports.jsx("p",{children:"First and Last in any order"})]})]})]})]}),jsxRuntimeExports.jsx("h2",{children:"Words & Numbers"}),jsxRuntimeExports.jsxs("div",{className:"personalise__number",children:[jsxRuntimeExports.jsx("p",{children:"You do you. Embroider something cheeky or cheerful. The options are endless and up to you - we just make it Weezie."}),jsxRuntimeExports.jsx("p",{className:"example",children:"Example"}),jsxRuntimeExports.jsx("div",{className:"number__wrap",children:jsxRuntimeExports.jsx("div",{className:"number__item",children:jsxRuntimeExports.jsx("img",{src:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/wordcloudv5.svg?v=1728068176"})})})]}),jsxRuntimeExports.jsx("div",{className:"email-box row center-xs center-md center-lg",children:jsxRuntimeExports.jsx("div",{className:"col-xs-12 col-md-10 col-lg-10",children:jsxRuntimeExports.jsx("div",{className:"box",children:jsxRuntimeExports.jsxs("p",{children:[jsxRuntimeExports.jsx("strong",{children:"Need some one on one help?"}),jsxRuntimeExports.jsx("br",{}),"Email us at ",jsxRuntimeExports.jsx("a",{href:"mailto:holler@weezietowels.com",children:"holler@weezietowels.com"})]})})})})]}),jsxRuntimeExports.jsxs("div",{className:"HqPicks pt-[30px] pb-[30px] lg:pt-[50px] lg:pb-[50px]",children:[jsxRuntimeExports.jsx("h2",{children:"HQ Advice"}),jsxRuntimeExports.jsx("div",{className:"HQPicks__wrap max-w-[1000px] mx-auto my-0 lg:border-[4px] lg:border-link",children:[{title:"Perry or Ardsley",description:"If you prefer a more traditional look:",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/hq-perry2.jpg?v=1723734003"},{title:"Prince, Hudson or Crosby",description:"If you like something that is more modern:",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Group_1853_480x480.png?v=1722240707"},{title:"Waverly, Sullivan or River",description:"If you want to spell it out:",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Group_1854_480x480.png?v=1722240707"},{title:"Perry or Prince",description:"If you prefer two initials to three:",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/hq-perry.jpg?v=1723733343"},{title:"Forsyth or Ponce",description:"If you prefer designer approved applique:",url:"https://cdn.shopify.com/s/files/1/0019/0352/5941/files/applique-ponce.jpg?v=1722886069"}].map((s,l)=>jsxRuntimeExports.jsxs("div",{className:`HQPicks__container flex ${l%2==0?"normal flex-row w-full text-center items-center":"reverse flex-row-reverse items-center"}`,children:[jsxRuntimeExports.jsx("div",{className:"HQPicks__image w-[50%] h-auto",children:jsxRuntimeExports.jsx("img",{className:"w-full",src:s.url,srcSet:getOptimizedImageSrcset(s.url,[360,480,600,720,900,1e3,1200]),sizes:"(min-width: 1024px) calc((1000px - 8px) / 2), 50vw",alt:s.title})}),jsxRuntimeExports.jsxs("div",{className:"HQPicks__description w-2/4 p-[30px]",children:[jsxRuntimeExports.jsx("p",{className:"font-apercutext-[14px] mt-[14px] mb-[14px] text-navy lg:text-[16px]",children:s.description}),jsxRuntimeExports.jsx("h3",{className:"font-apercu text-[14px] text-navy lg:text-[28px]",children:s.title})]})]},l))})]}),jsxRuntimeExports.jsx("div",{className:"faq-custom__wrapper",children:jsxRuntimeExports.jsxs("div",{className:"faq-custom",children:[jsxRuntimeExports.jsx("div",{children:jsxRuntimeExports.jsx("p",{className:"sect-header",children:"FAQs"})}),jsxRuntimeExports.jsx("h3",{children:" Customization Options"}),jsxRuntimeExports.jsx("ul",{class:"faq-custom__content",children:accordionData1.map((s,l)=>jsxRuntimeExports.jsxs("li",{className:`accordion ${S===l?"open":""}`,children:[jsxRuntimeExports.jsx("button",{className:"accordion__title type faq-custom__container",onClick:()=>{z(S===l?null:l);},children:s.title}),jsxRuntimeExports.jsx("div",{className:"accordion__content type type--medium",children:jsxRuntimeExports.jsx("div",{className:"faq-custom__container",children:jsxRuntimeExports.jsx("p",{children:s.content})})})]},l))}),jsxRuntimeExports.jsx("h3",{children:"Monogram Style"}),jsxRuntimeExports.jsx("ul",{class:"faq-custom__content",children:accordionData2.map((s,l)=>jsxRuntimeExports.jsxs("li",{className:`accordion ${q===l?"open":""}`,children:[jsxRuntimeExports.jsx("button",{className:"accordion__title type faq-custom__container",onClick:()=>{C(q===l?null:l);},children:s.title}),jsxRuntimeExports.jsx("div",{className:"accordion__content type type--medium",children:jsxRuntimeExports.jsx("div",{className:"faq-custom__container",children:jsxRuntimeExports.jsx("p",{children:s.content})})})]},l))}),jsxRuntimeExports.jsx("h3",{children:"Product Information"}),jsxRuntimeExports.jsx("ul",{class:"faq-custom__content",children:accordionData3.map((s,l)=>jsxRuntimeExports.jsxs("li",{className:`accordion ${P===l?"open":""}`,children:[jsxRuntimeExports.jsx("button",{className:"accordion__title type faq-custom__container",onClick:()=>{I(P===l?null:l);},children:s.title}),jsxRuntimeExports.jsx("div",{className:"accordion__content type type--medium",children:jsxRuntimeExports.jsx("div",{className:"faq-custom__container",children:jsxRuntimeExports.jsx("p",{children:s.content})})})]},l))})]})})]})]})});

const i$2 = (()=>{let w=new e$3,{selectedProduct:N,selectedProductOptionVals:C,selectedProductVariantInfo:g,activeQty:_,setActiveQty:A,setGuideActive:q,extraProperties:k,guideActive:M,baseVariant:j}=useProductContext(),{getProperties:P}=useEmbroidery(),[S,z]=reactExports.useState(null),{activeVariant:I,defaultTab:$,closeEmbModal:B,visitorCountry:D,addToCart:F,appliqueFontSelected:G,inputText:O,hasErrorText:Q,embRules:T,activeFont:E,isMultiRow:H,multiRowComplete:L}=useEmbroidery(),R=H?!L:""===O||""!==Q,Y=j?.price===I?.price?I:j,J=g?.product_variant_info.filter(e=>e.id===I?.id)[0]?.inventory_quantity<=0&&!I?.name.includes("Gift Card"),K=e=>w.formatMoney(e,"${{amount}}").replace(".00","");return reactExports.useEffect(()=>{P(false).then(e=>{z(e);});},[P,z]),jsxRuntimeExports.jsxs("div",{className:"w-full md:w-1/2 pt-[100vw] md:pt-[25px] overflow-y-scroll scroll-smooth",children:[jsxRuntimeExports.jsxs("div",{className:"max-w-full md:max-w-[330px] lg:max-w-[450px] mx-auto max-md:pt-[12px] max-md:pb-[22px]",children:[jsxRuntimeExports.jsxs("button",{onClick:()=>B(),className:" absolute left-0 top-[20px] z-[400] flex flex-row flex-wrap items-center mb-0 cursor-pointer bg-transparent border-0 text-black p-0 md:left-[30px] md:top-[30px]",children:[jsxRuntimeExports.jsx(BackCaretIcon,{elClass:"h-5 mr-2"}),"Back to Product"]}),jsxRuntimeExports.jsx("div",{className:"absolute top-[10px] w-11 h-11 p-2.5 cursor-pointer z-[500] md:top-3 right-0 lg:top-4 block rotate-45",onClick:()=>B(),children:jsxRuntimeExports.jsx(CloseIcon,{elClass:"w-[23px] h-[23px]"})}),jsxRuntimeExports.jsxs("div",{className:"embroidery__header ",children:[jsxRuntimeExports.jsxs("div",{className:"font-apercu text-16 flex items-center justify-center",children:[jsxRuntimeExports.jsx(NeedleIcon,{elClass:"w-[16px] h-[16px] mr-[5px]"})," ","Personalize Your"]}),jsxRuntimeExports.jsx("h2",{className:"text-[28px] pt-[12px] font-normal leading-[1.2] tracking-normal font-clearface antialiased ",children:N?.title}),jsxRuntimeExports.jsxs("div",{className:"flex justify-center items-center text-[15px]",children:[Y?.compare_at_price&&Y?.compare_at_price>Y?.price?jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment,{children:[jsxRuntimeExports.jsx("s",{children:K(Y?.compare_at_price)}),jsxRuntimeExports.jsxs("span",{className:"md:font-bold ml-[4px]",children:[K(Y?.price),"CA"===D&&" CAD"]}),jsxRuntimeExports.jsxs("p",{className:"text-coral text-12px leading-[1.41667] ml-[4px]",children:[Math.floor(100-100*Math.abs(Y?.price/Y?.compare_at_price)),"% off"]})]}):jsxRuntimeExports.jsxs("span",{className:"md:font-bold ml-[4px]",children:[K(Y?.price),"CA"===D&&" CAD"]}),C?.discountMessage&&jsxRuntimeExports.jsx("p",{className:"product__discount-message type type--small",children:C?.discountMessage})]})]}),jsxRuntimeExports.jsx(s$3,{}),T&&!H&&jsxRuntimeExports.jsxs("div",{className:"mt-[24px] p-0 text-center",children:[jsxRuntimeExports.jsxs("p",{className:"text-14 text-primary font-apercuBold",children:[T[E]&&T[E].limitHint,".",!T[E]?.allCaps&&" Case sensitive."]}),("embroidery"===$||"applique"===$||"all"===$)&&T[E]?.hint&&jsxRuntimeExports.jsx("p",{className:"type type--medium",children:T[E].hint})]}),jsxRuntimeExports.jsx(d$5,{}),jsxRuntimeExports.jsx(y$2,{}),jsxRuntimeExports.jsx(n$4,{}),R?jsxRuntimeExports.jsx("p",{className:"text-customRed text-14 text-center w-full",children:H?"Lines 1 & 2 are required":`Please enter your ${G||"applique"==$?"applique":"embroidery"} text to add to bag`}):null,jsxRuntimeExports.jsx("div",{className:"flex flex-col items-center",children:jsxRuntimeExports.jsxs("div",{className:"w-full flex gap-2 mt-[24px]",children:[I?.available&&jsxRuntimeExports.jsx(QuantitySelector,{activeQty:_,setActiveQty:A}),jsxRuntimeExports.jsx("div",{className:"w-full ml-[10px]",children:jsxRuntimeExports.jsx(AddToCartButton,{id:"personaliseAndAddToCart",isSoldOut:!I?.available,isPreorder:J,addToCart:F,disabled:R,price:w.formatMoney(I?.price,"${{amount}}").replace(".00",""),quantity:_})})]})}),jsxRuntimeExports.jsx(AddToRegistryButton,{productId:N?.id,properties:S,variantId:I?.id,quantity:_,customer:window?.customer,cart:cart,redirect:e=>{window.location=e;}})]}),jsxRuntimeExports.jsx(h$1,{}),M&&jsxRuntimeExports.jsx(d$3,{toggle:q,guideActive:M})]})});

const x = (()=>jsxRuntimeExports.jsx("div",{className:"fixed top-0 right-0 bottom-0 z-[25] bg-white p-0 m-0 w-full overflow-hidden",children:jsxRuntimeExports.jsx("div",{className:"container h-full",children:jsxRuntimeExports.jsxs("div",{className:"flex flex-col md:flex-row w-full h-full py-[10px] md:p-[20px] relative",children:[jsxRuntimeExports.jsx(r,{}),jsxRuntimeExports.jsx(i$2,{})]})})}));

let m$1=e=>e.replace(/<br\s*\/?>/gi,"\n"),o$4=(e,t=",",l=true)=>{if(!e||"string"!=typeof e)return [];let r=("\n"===t?m$1(e):e).split(t).map(e=>e.trim());return l?r.filter(Boolean):r},p$1=e=>e&&"string"==typeof e?m$1(e).split("\n").map(e=>e.split(",").map(e=>e.trim())).filter(e=>e.length>0&&e[0]):[];const h = (()=>{let{selectedProduct:m,setSizeGuideVisible:c,selectedProductOptionVals:d}=useProductContext(),u=d?.sizeGuide,f=o$4(u?.sizeGuideHeaders,",",false),x=o$4(u?.sizeGuideRows,"\n"),h=p$1(u?.sizeGuideValues),w=o$4(u?.measurementsHeaders,",",false),g=o$4(u?.measurementsRows,"\n"),b=p$1(u?.measurementsValues),y=f.some(e=>e)&&h.length>0,N=w.some(e=>e)&&b.length>0,v=y&&N,z=()=>y?"size-guide":N?"measurements":"size-guide",[k,B]=reactExports.useState(z);reactExports.useEffect(()=>{B(z());},[m,y,N]);let j=reactExports.useRef(null);reactExports.useEffect(()=>{let e=e=>{"Escape"===e.key&&(e.preventDefault(),c(false));};return window.addEventListener("keydown",e),()=>window.removeEventListener("keydown",e)},[c]),reactExports.useEffect(()=>{let e=e=>{j.current&&!j.current.contains(e.target)&&c(false);};return document.addEventListener("mousedown",e),()=>document.removeEventListener("mousedown",e)},[c]);let E=(l,r,a)=>jsxRuntimeExports.jsxs("div",{className:"flex flex-wrap flex-col flex-[0_1_auto] w-full mt-3 pt-5 mb-0 border-t border-b border-t-spindle border-b-white",children:[jsxRuntimeExports.jsx("ul",{className:"flex flex-row flex-wrap items-center justify-between text-center w-full m-0 p-0",children:l.map((t,r)=>jsxRuntimeExports.jsx("li",{className:"font-apercuBold text-royalBlue flex-1 text-12",style:{flexBasis:`${100/l.length}%`},children:t},r))}),jsxRuntimeExports.jsx("ul",{className:"flex flex-col w-full mt-[10px] m-0 p-0",children:a.map((l,a)=>jsxRuntimeExports.jsxs("li",{className:`flex flex-row flex-wrap items-center justify-between text-center w-full mb-0 p-[10px] md:px-[10px] md:py-[15px] ${a%2==0?"bg-spindleLight":"bg-transparent"}`,children:[jsxRuntimeExports.jsx("span",{className:"font-apercuBold text-royalBlue flex-1 text-12",style:{flexBasis:`${100/(l.length+1)}%`},children:r[a]||""}),l.map((t,r)=>jsxRuntimeExports.jsx("span",{className:"font-apercu text-black flex-1 text-14",style:{flexBasis:`${100/(l.length+1)}%`},children:t},r))]},a))})]}),G=({id:t,label:l})=>jsxRuntimeExports.jsx("li",{className:`cursor-pointer relative ml-[30px] mr-[40px] md:ml-0 after:content-[''] after:absolute after:left-0 after:right-0 after:-bottom-[8px] after:h-px after:bg-primary after:transition-opacity after:duration-200 after:ease-in-out after:z-[100]
        ${k===t?"after:opacity-100":"after:opacity-0"}`,onClick:()=>B(t),children:l});return u?.name?jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment,{children:[jsxRuntimeExports.jsx("div",{className:"fixed top-0 left-0 w-full h-full bg-bgTransparent z-[900]"}),jsxRuntimeExports.jsxs("div",{ref:j,className:"fixed top-0 right-0 h-full w-full md:w-5/8 lg:w-7/12 overflow-y-auto bg-link z-[1000]",children:[jsxRuntimeExports.jsx("div",{className:"fixed top-0 right-0 w-11 h-11 cursor-pointer z-[400] md:top-3 md:right-3 lg:top-4 lg:right-4 block rotate-45",onClick:()=>c(false),children:jsxRuntimeExports.jsx(CloseIcon,{})}),jsxRuntimeExports.jsxs("div",{className:"w-full min-h-full flex flex-col justify-center px-[30px] pt-[52px] pb-14 md:px-[40px] md:pt-[77px] md:pb-[20px] lg:px-[60px] lg:pt-[77px] lg:pb-[20px] lg:max-w-[71.4%] mx-auto",children:[jsxRuntimeExports.jsxs("h2",{className:"text-center leading-[1.29] text-[26px] font-clearface font-normal",children:[m?.title," Size Guide"]}),v&&jsxRuntimeExports.jsxs("ul",{className:"flex flex-row flex-wrap justify-center w-full mt-5 md:mt-10 mb-0",children:[y&&jsxRuntimeExports.jsx(G,{id:"size-guide",label:"Size Guide"}),N&&jsxRuntimeExports.jsx(G,{id:"measurements",label:"Measurements"})]}),y&&("size-guide"===k||!v)&&E(f,x,h),N&&("measurements"===k||!v&&!y)&&E(w,g,b),jsxRuntimeExports.jsx("p",{className:"w-full text-center text-12 mt-[10px]",children:m?.tags?.includes("Summersalt")?"Measured in inches":"Please note products are not pre-shrunk and may shrink up to 5% upon washing"}),jsxRuntimeExports.jsxs("div",{className:"w-full text-center mt-[20px]",children:[jsxRuntimeExports.jsx("h4",{className:"text-royalBlue text-14",children:"Still have questions?"}),jsxRuntimeExports.jsxs("p",{className:"mt-[4px] text-14",children:["Email"," ",jsxRuntimeExports.jsx("a",{href:"mailto:holler@weezietowels.com",className:"underline",children:"holler@weezietowels.com"})," ","or text"," ",jsxRuntimeExports.jsx("a",{href:"sms:+4709996551",className:"underline",children:"470-999-6551"})]})]})]})]})]}):null});

const y$1 = (()=>{let{bannerData:i}=useProductContext(),n=i?.countdown_1?new Date(i?.countdown_1):null,[t,r]=reactExports.useState({days:0,hours:0,minutes:0,seconds:0}),[m,p]=reactExports.useState(false);reactExports.useEffect(()=>{let e=setInterval(()=>{if(!n)return;let l=n-new Date;if(l>0){let e=Math.floor(l/864e5),d=Math.floor(l%864e5/36e5);r({days:e,hours:d,minutes:Math.floor(l%36e5/6e4),seconds:Math.floor(l%6e4/1e3)});}else r({days:0,hours:0,minutes:0,seconds:0}),p(true),clearInterval(e);},1e3);return ()=>{e&&clearInterval(e);}},[n]);let x=i?.discount_description?.split("*");return jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment,{children:[i?.buy_more_banner&&window.Shopify?.country!="CA"&&jsxRuntimeExports.jsx("div",{className:"bg-regen font-apercu mt-[10px]",children:jsxRuntimeExports.jsxs("div",{className:"px-[10px] py-[20px] md:px-[40px] md:py-[10px]",children:[jsxRuntimeExports.jsx("p",{className:"text-16 md:text-18 font-apercuBold",children:i.headline_1}),jsxRuntimeExports.jsx("div",{className:"my-[10px] text-14 md:text-12 lg:text-16",children:jsxRuntimeExports.jsxs("div",{className:"flex justify-center w-full gap-[10px]",children:[jsxRuntimeExports.jsxs("div",{className:"flex",children:[jsxRuntimeExports.jsx("div",{className:"font-apercuBold",children:i.percent_off_1}),jsxRuntimeExports.jsxs("div",{className:"ml-[5px]",children:["$",i.spend_amt_1,"+"]})]}),jsxRuntimeExports.jsxs("div",{className:"flex",children:[jsxRuntimeExports.jsx("div",{className:"font-apercuBold",children:i.percent_off_2}),jsxRuntimeExports.jsxs("div",{className:"ml-[5px]",children:["$",i.spend_amt_2,"+"]})]}),jsxRuntimeExports.jsxs("div",{className:"flex",children:[jsxRuntimeExports.jsx("div",{className:"font-apercuBold",children:i.percent_off_3}),jsxRuntimeExports.jsxs("div",{className:"ml-[5px]",children:["$",i.spend_amt_3,"+"]})]})]})}),n&&(m?jsxRuntimeExports.jsx("div",{className:"flex justify-center gap-[5px] text-12 lg:text-14",children:jsxRuntimeExports.jsxs("div",{className:"ml-[5px]",children:[" ",i.post_countdown_message]})}):jsxRuntimeExports.jsxs("div",{className:"flex justify-center gap-[5px] text-12 lg:text-14",children:[jsxRuntimeExports.jsxs("div",{className:"flex",children:[jsxRuntimeExports.jsx("div",{className:"font-apercuBold",children:t.days}),jsxRuntimeExports.jsx("div",{className:"ml-[5px]",children:"days"})]}),jsxRuntimeExports.jsxs("div",{className:"flex",children:[jsxRuntimeExports.jsx("div",{className:"font-apercuBold",children:t.hours}),jsxRuntimeExports.jsx("div",{className:"ml-[5px]",children:"hours"})]}),jsxRuntimeExports.jsxs("div",{className:"flex",children:[jsxRuntimeExports.jsx("div",{className:"font-apercuBold",children:t.minutes}),jsxRuntimeExports.jsx("div",{className:"ml-[5px]",children:"mins"})]}),jsxRuntimeExports.jsxs("div",{className:"flex",children:[jsxRuntimeExports.jsx("div",{className:"font-apercuBold",children:t.seconds}),jsxRuntimeExports.jsx("div",{className:"ml-[5px]",children:"secs"})]})]}))]})}),i?.birthday_sale_banner&&window.Shopify?.country!="CA"&&jsxRuntimeExports.jsx("div",{className:"bg-regen font-apercu mt-[10px]",children:jsxRuntimeExports.jsxs("div",{className:"px-[10px] py-[20px] md:px-[40px] md:py-[10px]",children:[jsxRuntimeExports.jsx("p",{className:"text-16 md:text-18 font-apercuBold m-0",children:i.headline_1}),i?.discount_code&&i?.discount_code.trim()!==""&&jsxRuntimeExports.jsx("div",{className:"my-[10px] text-14 md:text-12 lg:text-16",children:jsxRuntimeExports.jsxs("div",{class:"ml-[5px]",children:["Use code ",jsxRuntimeExports.jsx("span",{children:i.discount_code})," at checkout"]})}),n&&(m?jsxRuntimeExports.jsx("div",{className:"flex justify-center gap-[5px] text-12 lg:text-14",children:jsxRuntimeExports.jsxs("div",{className:"ml-[5px]",children:[" ",i.post_countdown_message]})}):jsxRuntimeExports.jsxs("div",{className:"flex justify-center gap-[5px] text-12 lg:text-14",children:[jsxRuntimeExports.jsxs("div",{className:"flex",children:[jsxRuntimeExports.jsx("div",{className:"font-apercuBold",children:t.days}),jsxRuntimeExports.jsx("div",{className:"ml-[5px]",children:"days"})]}),jsxRuntimeExports.jsxs("div",{className:"flex",children:[jsxRuntimeExports.jsx("div",{className:"font-apercuBold",children:t.hours}),jsxRuntimeExports.jsx("div",{className:"ml-[5px]",children:"hours"})]}),jsxRuntimeExports.jsxs("div",{className:"flex",children:[jsxRuntimeExports.jsx("div",{className:"font-apercuBold",children:t.minutes}),jsxRuntimeExports.jsx("div",{className:"ml-[5px]",children:"mins"})]}),jsxRuntimeExports.jsxs("div",{className:"flex",children:[jsxRuntimeExports.jsx("div",{className:"font-apercuBold",children:t.seconds}),jsxRuntimeExports.jsx("div",{className:"ml-[5px]",children:"secs"})]})]}))]})}),i?.embroidery_sale_banner&&window.Shopify?.country!="CA"&&jsxRuntimeExports.jsx("div",{className:"bg-regen font-apercu mt-[10px]",children:jsxRuntimeExports.jsxs("div",{className:"px-[10px] py-[20px] md:px-[40px] md:py-[10px]",children:[jsxRuntimeExports.jsx("p",{className:"text-16 md:text-18 font-apercuBold m-0",children:i.headline_1}),(x?.length||i.text_block)&&jsxRuntimeExports.jsxs("div",{className:"my-[10px] text-14 md:text-12 lg:text-16",children:[jsxRuntimeExports.jsx("div",{class:"ml-[5px]",children:x?.map((l,d)=>jsxRuntimeExports.jsx("p",{children:l.trim()},d))}),jsxRuntimeExports.jsx("div",{class:"ml-[5px]",children:i.text_block})]}),n&&(m?jsxRuntimeExports.jsx("div",{className:"flex justify-center gap-[5px] text-12 lg:text-14",children:jsxRuntimeExports.jsxs("div",{className:"ml-[5px]",children:[" ",i.post_countdown_message]})}):jsxRuntimeExports.jsxs("div",{className:"flex justify-center gap-[5px] text-12 lg:text-14",children:[jsxRuntimeExports.jsxs("div",{className:"flex",children:[jsxRuntimeExports.jsx("div",{className:"font-apercuBold",children:t.days}),jsxRuntimeExports.jsx("div",{className:"ml-[5px]",children:"days"})]}),jsxRuntimeExports.jsxs("div",{className:"flex",children:[jsxRuntimeExports.jsx("div",{className:"font-apercuBold",children:t.hours}),jsxRuntimeExports.jsx("div",{className:"ml-[5px]",children:"hours"})]}),jsxRuntimeExports.jsxs("div",{className:"flex",children:[jsxRuntimeExports.jsx("div",{className:"font-apercuBold",children:t.minutes}),jsxRuntimeExports.jsx("div",{className:"ml-[5px]",children:"mins"})]}),jsxRuntimeExports.jsxs("div",{className:"flex",children:[jsxRuntimeExports.jsx("div",{className:"font-apercuBold",children:t.seconds}),jsxRuntimeExports.jsx("div",{className:"ml-[5px]",children:"secs"})]})]}))]})}),i?.mothers_day_banner&&window.Shopify?.country!="CA"&&jsxRuntimeExports.jsx("div",{className:"bg-regen font-apercu mt-[10px]",children:jsxRuntimeExports.jsxs("div",{className:"px-[10px] py-[20px] md:px-[40px] md:py-[10px]",children:[jsxRuntimeExports.jsx("p",{className:"text-16 md:text-18 font-apercuBold m-0",children:i.headline_1}),jsxRuntimeExports.jsx("div",{className:"my-[10px] text-14 md:text-12 lg:text-16",children:jsxRuntimeExports.jsxs("div",{className:"flex justify-center w-full gap-[10px]",children:[jsxRuntimeExports.jsxs("div",{class:"flex",children:[jsxRuntimeExports.jsx("div",{class:"font-apercuBold",children:i.delivery_date_1}),jsxRuntimeExports.jsx("div",{class:"ml-[5px]",children:i.delivery_type_1})]}),jsxRuntimeExports.jsxs("div",{class:"flex",children:[jsxRuntimeExports.jsx("div",{class:"font-apercuBold",children:i.delivery_date_2}),jsxRuntimeExports.jsx("div",{class:"ml-[5px]",children:i.delivery_type_2})]}),jsxRuntimeExports.jsxs("div",{class:"flex",children:[jsxRuntimeExports.jsx("div",{class:"font-apercuBold",children:i.delivery_date_3}),jsxRuntimeExports.jsx("div",{class:"ml-[5px]",children:i.delivery_type_3})]})]})}),jsxRuntimeExports.jsx("div",{className:"flex justify-center gap-[5px] text-12 lg:text-14",children:i.fineprint_1})]})})]})});

const b = (()=>{let s=reactExports.useRef(null),{selectedProduct:i}=useProductContext();return reactExports.useEffect(()=>{s.current&&(s.current.innerHTML="");let t=document.createElement("tolstoy-stories");t.setAttribute("id","79awcscgvnsez"),t.setAttribute("class","tolstoy-stories"),t.setAttribute("data-product-id",i.id),s.current.appendChild(t);},[i.id]),jsxRuntimeExports.jsx("div",{className:"mt-[24px]",ref:s})});

function e$1(){let{selectedProduct:e}=useProductContext(),d=()=>{window.yotpoWidgetsContainer?.initWidgets?window.yotpoWidgetsContainer.initWidgets():setTimeout(d,1e3);};return reactExports.useEffect(()=>{if(e){let t=document.querySelector("#yotpoMainReviews .yotpo-widget-instance");t&&t.setAttribute("data-yotpo-product-id",e.id),d();}},[e]),jsxRuntimeExports.jsx("div",{id:"yotpoStarRating",children:jsxRuntimeExports.jsx("div",{className:"yotpo-widget-instance","data-yotpo-instance-id":"1014586","data-yotpo-product-id":e?.id})})}

let n$3=new e$3;const L = (({currentVariant:a,selectedProduct:c,ctasVisible:d,isNotifyMe:m,isSoldOut:p,isPreorder:u,addToCart:x,showPersonalizationBtn:f,visitorCountry:h,setEmbVisibility:b})=>{let y=c.options.findIndex(e=>e.toLowerCase().includes("embroidery")),v=(a.options?.filter((e,t)=>t!==y)||[]).join(", "),g=a?.featured_image?.src?`${a.featured_image.src}&width=90`:null,[w,$]=reactExports.useState(false);return reactExports.useEffect(()=>(document.body.classList.toggle("sticky-atc-visible",!d),()=>{document.body.classList.remove("sticky-atc-visible");}),[d]),reactExports.useEffect(()=>{let e=()=>{$(document.body.classList.contains("menu-open"));};e();let t=new MutationObserver(e);return t.observe(document.body,{attributes:true,attributeFilter:["class"]}),()=>t.disconnect()},[]),jsxRuntimeExports.jsxs("div",{className:`fixed bottom-0 left-0 w-full h-[var(--sticky-atc-height)] bg-white border-t border-navy p-4 z-10 transition-transform duration-300 ease-in-out md:hidden ${d?"translate-y-full":""} ${w?"hidden":""}`,role:"region","aria-label":"Sticky add to cart","aria-hidden":d,children:[jsxRuntimeExports.jsxs("div",{className:"flex w-full gap-[8px] items-center",children:[g&&jsxRuntimeExports.jsx("img",{src:g,alt:`${c?.title} ${v}`,className:"w-[45px] h-[42px] shrink-0 rounded-[2px] overflow-hidden object-cover"}),jsxRuntimeExports.jsxs("div",{className:"flex flex-col items-start text-navy text-[12px] leading-[19px] grow",children:[jsxRuntimeExports.jsx("span",{className:"font-bold",children:c?.title}),v&&jsxRuntimeExports.jsx("span",{children:v})]}),jsxRuntimeExports.jsxs("div",{className:"flex gap-[8px] shrink-0 text-black text-[12px] leading-[22px]",children:[a?.compare_at_price&&a?.compare_at_price>a?.price&&jsxRuntimeExports.jsx("span",{className:"line-through opacity-50",children:n$3.formatMoney(a.compare_at_price,`${"GB"===h?"£":"$"}{{amount}}`).replace(".00","")}),jsxRuntimeExports.jsxs("span",{children:[n$3.formatMoney(a.price,`${"GB"===h?"£":"$"}{{amount}}`).replace(".00",""),"CA"===h&&" CAD","GB"===h&&" GBP"]})]})]}),jsxRuntimeExports.jsxs("div",{className:"flex gap-[12px] mt-[8px]",children:[f&&jsxRuntimeExports.jsx(PersonalizationButton,{mini:true,visitorCountry:h,setEmbVisibility:b}),m?jsxRuntimeExports.jsx(NotifyMeButton,{mini:true}):jsxRuntimeExports.jsx(AddToCartButton,{mini:true,id:"addToCartSticky",isSoldOut:p,isPreorder:u,addToCart:x})]})]})});

const o$3 = (()=>{let{data:P,selectedProduct:V,setSelectedProduct:k,setCurrentVariant:A,selectedProductOptionVals:G,setSelectedProductOptionVals:M,setSelectedProductVariantInfo:O,swatchData:S,selectedProductVariantInfo:E,setCurrentCount:$,currentVariant:J,visitorCountry:R,conversionRate:T,addToCart:j,activeQty:D,setActiveQty:I,setProductSliderAssets:H,embModalOpen:W,embVisibility:z,setEmbVisibility:q,sizeGuideVisible:F,addGiftBoxIntent:Q,setAddGiftBoxIntent:U,giftCardHasErrors:K}=useProductContext(),X=reactExports.useRef(null),[Y,Z]=reactExports.useState(true),ee=new e$3,et=V.variants.find(e=>e.id===J.id),er=E?.product_variant_info.find(e=>e.id===J.id),ei=!et?.available&&er?.metafields.enable_notify_me===true,eo=V.tags.filter(e=>e.includes("embroidery"))?.length>0,ea=V.type.toLowerCase().includes("gift card"),en=E?.product_variant_info.filter(e=>e.id===J.id)[0]?.inventory_quantity<=0&&!J.name.includes("Gift Card"),el=er?.gift_box,ed=eo&&!ea&&J.available&&!E?.product_variant_info.filter(e=>e.id===J.id)[0]?.metafields?.noEmbroidery;return reactExports.useEffect(()=>{["Ardsley Center","Ardsley Left","Ardsley Right","Birdie","Blue Vinyl","Clearface","Crosby Center","Crosby Left","Crosby Right","Deuce","Dink","Evergreen","Grant","Hudson","Jones Center","Jones Center Border","Jones Center Letters","Jones Left","Jones Left Border","Jones Left Letters","Jones Right","Jones Right Border","Jones Right Letters","Leeward","Lucy","Mallard","Mercer","Perry","Prince","River","Sullivan","Susan","Tybee","Wave","Waverly"].forEach(e=>{let t=`1em ${e}`;document.fonts.check(t)||document.fonts.load(t);});},[]),reactExports.useEffect(()=>{let e=getComputedStyle(document.documentElement).getPropertyValue("--full-header-height").trim(),t=new IntersectionObserver(function(e){e.forEach(e=>{Z(e.isIntersecting||e.boundingClientRect.top>window.innerHeight);});},{threshold:0,rootMargin:`-${e} 0px 0px 0px`});return X.current&&t.observe(X.current),()=>t.disconnect()},[]),jsxRuntimeExports.jsxs("div",{className:"mt-4 md:mt-0 px-0 pt-0 text-center col-span-full md:col-[7_/_-1] xl:col-[8_/_-1] custom-xxl:col-[9_/_-1]",children:[jsxRuntimeExports.jsxs("div",{className:"!hidden md:!block",children:[jsxRuntimeExports.jsx(i$3,{baseLink:"/",basePath:"Home",currentPath:V?.title,subLink:P.productOptionVals[0].subLink,subPath:P.productOptionVals[0].subPath}),jsxRuntimeExports.jsx("h2",{className:"mt-4 md:mt-9 text-[28px] xl:text-[32px] font-clearface font-normal leading-[1.21] md:leading-[1.2] lg:leading-[1.17647] antialiased",children:V?.title})]}),jsxRuntimeExports.jsx(e$1,{}),jsxRuntimeExports.jsx("div",{className:"",children:J?.compare_at_price&&J?.compare_at_price>J?.price?jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment,{children:[jsxRuntimeExports.jsx("s",{children:ee.formatMoney(J.compare_at_price,`${"GB"===R?"£":"$"}{{amount}}`).replace(".00","")}),jsxRuntimeExports.jsxs("span",{className:"pl-[5px] font-apercuBold",children:[ee.formatMoney(J.price,`${"GB"===R?"£":"$"}{{amount}}`).replace(".00",""),"CA"===R&&" CAD","GB"===R&&" GBP"]}),jsxRuntimeExports.jsxs("p",{className:"text-12 text-coral inline-block ml-[5px]",children:[Math.floor(100-100*Math.abs(J.price/J.compare_at_price)),"% off"]})]}):jsxRuntimeExports.jsxs("span",{children:[ee.formatMoney(J.price,`${"GB"===R?"£":"$"}{{amount}}`).replace(".00",""),"CA"===R&&" CAD","GB"===R&&" GBP"]})}),P?.productConnections?.length>0&&jsxRuntimeExports.jsxs("div",{className:"border-t border-link py-[15px] mt-[15px]",children:[jsxRuntimeExports.jsxs("p",{className:"font-apercu mt-0 text-[14px]",children:[P?.cgOptionTitle?cgOptionTitle:"Type"," :"," ",P?.productOptionVals.find(e=>e.id==V.id)?.product_short_name]}),jsxRuntimeExports.jsx("div",{className:"flex flex-wrap justify-center gap-x-[5px] gap-y-[15px] mt-[15px]",children:P?.productConnections.map(r=>jsxRuntimeExports.jsxs("div",{className:"relative",children:[jsxRuntimeExports.jsx("button",{onClick:()=>(e=>{if(!e)return;k(e),A(e.variants[0]);let t=P?.productOptionVals?.find(t=>t.id===e.id),r=P?.productVariantInfo?.find(t=>t.id===e.id),i=P?.productSliderAssets?.find(t=>t.id===e.id);M(t),O(r),H(i);})(r),className:`cursor-pointer bg-white border border-[#d6dce2] rounded-[5px] h-[32px] overflow-hidden relative transition-all duration-300 ease-in-out text-primary font-apercu text-16 leading-[1] font-normal p-[5px] flex items-center justify-center ${V.id===r.id?"border border-primary":""}`,children:P?.productOptionVals.find(e=>e.id==r.id)?.product_short_name},r.id),r.tags.some(e=>e.toLowerCase().startsWith("save badge"))&&jsxRuntimeExports.jsx("span",{className:"text-[11px] font-normal font-apercu text-white bg-royalBlue rounded-[4px] mt-[4px] absolute w-[70%] z-[2] left-1/2 -translate-x-1/2 top-[20px] p-[2px]",children:r.tags?.find(e=>e.toLowerCase().startsWith("save badge")).split(":")[1].trim()})]},r.id))})]}),jsxRuntimeExports.jsx(y$1,{}),V&&G&&E&&jsxRuntimeExports.jsx(n$5,{setCurrentCount:e=>$(e)}),jsxRuntimeExports.jsx("div",{id:"pdp-ctas",ref:X,children:ei?jsxRuntimeExports.jsx(NotifyMeButton,{}):jsxRuntimeExports.jsxs("div",{className:"flex flex-col items-center",children:[ed&&jsxRuntimeExports.jsx(PersonalizationButton,{visitorCountry:R,setEmbVisibility:q}),J.available&&el?.available&&window.giftBoxesEnabled&&jsxRuntimeExports.jsx(AddGiftBox,{giftBox:el,visitorCountry:R,checked:Q,onChange:U}),jsxRuntimeExports.jsxs("div",{className:"w-full flex gap-2 mt-[15px]",children:[jsxRuntimeExports.jsx(QuantitySelector,{activeQty:D,setActiveQty:I}),jsxRuntimeExports.jsx("div",{className:"w-full ml-[10px]",children:jsxRuntimeExports.jsx(AddToCartButton,{id:"addToCart",isSoldOut:!J.available,isPreorder:en,giftCardHasErrors:ea&&K,addToCart:j})})]})]})}),jsxRuntimeExports.jsx(AddToRegistryButton,{productId:V.id,variantId:J.id,quantity:D,customer:window.customer,cart:cart,redirect:e=>{window.location=e;}}),jsxRuntimeExports.jsxs("div",{className:"text-16 font-apercu py-[16px]",children:[window.Shopify?.country==="US"&&jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment,{children:[jsxRuntimeExports.jsxs("div",{className:"inline-flex items-center gap-2",children:[jsxRuntimeExports.jsx(ShippingIcon,{elClass:"w-[16px] h-[16px]"}),"Free Shipping $200+"]}),jsxRuntimeExports.jsx("span",{className:"inline-block mx-[16px]",children:"|"}),jsxRuntimeExports.jsxs("div",{className:"inline-flex items-center gap-2",children:[jsxRuntimeExports.jsx(ReturnsIcon,{elClass:"w-[16px] h-[16px]"}),"Easy 30-Day Returns"]})]}),V?.handle!=="gift-wrap"&&jsxRuntimeExports.jsxs("div",{className:"flex justify-center items-center gap-2",children:[jsxRuntimeExports.jsx(GiftIcon,{elClass:"w-[16px] h-[16px] text-royalBlue"}),"Add Gift Bags & a Message in your Cart"]})]}),jsxRuntimeExports.jsx(b,{}),jsxRuntimeExports.jsx(u$1,{selectedProductOptionVals:G,currentProduct:V}),z&&jsxRuntimeExports.jsx(EmbroideryProvider,{children:jsxRuntimeExports.jsx(x,{})}),F&&jsxRuntimeExports.jsx(h,{}),jsxRuntimeExports.jsx(L,{currentVariant:J,selectedProduct:V,ctasVisible:Y,isNotifyMe:ei,isSoldOut:!J.available,isPreorder:en,addToCart:j,showPersonalizationBtn:ed,visitorCountry:R,setEmbVisibility:q})]})});

const o$2 = (()=>{let[d,s]=reactExports.useState(false),{data:c,selectedProduct:p,productSliderAssets:u,selectedProductOptionVals:x}=useProductContext();return (reactExports.useEffect(()=>{if(c&&!d){let t=document.getElementById("product-skeleton");t&&t.remove(),s(true);}},[c,d]),c)?jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment,{children:jsxRuntimeExports.jsxs("div",{className:"container wz-grid grid-cols-12 gap-space24 mb-[60px] pt-[25px] md:pt-10",children:[jsxRuntimeExports.jsxs("div",{className:"col-span-full flex flex-col justify-center md:hidden",children:[jsxRuntimeExports.jsx(i$3,{baseLink:"/",basePath:"Home",currentPath:p?.title,subLink:c.productOptionVals[0].subLink,subPath:c.productOptionVals[0].subPath}),jsxRuntimeExports.jsx("h2",{className:"mt-4 md:mt-9 text-center text-[28px] xl:text-[32px] font-clearface font-normal leading-[1.21] md:leading-[1.2] lg:leading-[1.17647] antialiased",children:p?.title})]}),u&&jsxRuntimeExports.jsx(l$3,{}),jsxRuntimeExports.jsx(o$3,{})]})}):null});

function n$2(){return jsxRuntimeExports.jsx(ProductProvider,{children:jsxRuntimeExports.jsx(o$2,{})})}

function a$4({label:a,type:s="default",options:n=[],selectedOptions:d=[],setSelectedOptions:p=()=>{},searchTerm:c="",isFilterOpen:u=true,onApply:f=()=>{},onClear:m=()=>{}}){let[b,h]=reactExports.useState(false),[k,x]=reactExports.useState(false),[g,y]=reactExports.useState(false),w=Array.isArray(d)?d:[],v=w.length,N=k&&v>0,C=w.map(e=>e.label).join(", "),j=e=>{p(w.some(r=>r.label===e.label)?w.filter(r=>r.label!==e.label):[...w,e]),y(true);},$=n.filter(e=>e.label.toLowerCase().includes(c.toLowerCase())),z=k&&!b?$.slice(0,7):$;return (reactExports.useEffect(()=>{let e=()=>{x(window.innerWidth<1300);};return e(),window.addEventListener("resize",e),()=>window.removeEventListener("resize",e)},[]),reactExports.useEffect(()=>{k&&(""!==c.trim()?y(true):y(false));},[c,k]),reactExports.useEffect(()=>{!u&&k&&(y(false),h(false));},[u,k]),0===n.length)?null:jsxRuntimeExports.jsxs("div",{className:"group inline-block filter-options text-primary p-sectionX-sm max-filter-desktop:bg-secondary w-full filter-desktop:w-auto border-b border-geyser filter-desktop:border-0 filter-desktop:p-0 filter-desktop:pr-3",children:[jsxRuntimeExports.jsxs("button",{onClick:()=>{k&&(g&&h(false),y(!g));},className:"filter-desktop:border border-geyser relative z-filter-button filter-desktop:font-apercu font-apercuBold filter-desktop:px-4 filter-desktop:py-2 rounded-lg bg-white group-hover:rounded-b-none group-hover:border-b-0 filter-desktop:group-hover:pb-5 filter-desktop:block flex items-center justify-between w-full filter-desktop:w-auto ",children:[a," ",k&&v>0?`(${v})`:"",jsxRuntimeExports.jsx(DownCaretIcon,{elClass:`w-[12px] h-[7px] ml-[0.8rem] transition-transform duration-300 inline-block ${k&&g?"rotate-180":""}`})]}),N&&jsxRuntimeExports.jsx("div",{className:"mt-1 text-14 text-fiord font-apercu truncate",children:C}),jsxRuntimeExports.jsxs("div",{className:`filter-desktop:absolute filter-desktop:invisible filter-desktop:group-hover:visible filter-desktop:top-[41px] filter-desktop:rounded-tl-none filter-desktop:!p-sectionX-sm bg-white filter-desktop:shadow-lg -z-10
        ${k?g?"z-filter-tray max-h-[2000px] mt-3 max-w-full":"max-h-0 overflow-hidden":"group-hover:z-filter-tray"}
        filter-desktop:border border-geyser rounded-lg filter-desktop:opacity-0
        filter-desktop:group-hover:opacity-100 filter-desktop:transition-opacity duration-500 transition-max-height
        wz-grid justify-items-start filter-desktop:justify-items-stretch filter-desktop:grid-cols-2 grid-cols-1 gap-3 w-[600px] filter-desktop:mt-0`,children:["default"===s&&jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment,{children:z.map(t=>{let l=0===t.count&&!w.some(e=>e.label===t.label);return jsxRuntimeExports.jsxs("label",{className:`flex items-start gap-2 ${l?"opacity-40 cursor-not-allowed":"cursor-pointer"}`,children:[jsxRuntimeExports.jsx("input",{id:t.label,type:"checkbox",disabled:l,checked:w.some(e=>e.label===t.label),onChange:()=>j(t),className:`filter-checkmark relative !flex justify-center items-center mt-1 appearance-none !w-7 h-7 border border-primary rounded checked:bg-primary ${l?"cursor-not-allowed":"cursor-pointer"}`}),jsxRuntimeExports.jsxs("span",{children:[t.label," (",t.count,")"]})]},t.label)})}),"color"===s&&jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment,{children:z.map(t=>{let l=0===t.count&&!w.some(e=>e.label===t.label);return jsxRuntimeExports.jsxs("label",{className:`flex items-start gap-2 filter-color ${l?"opacity-40 cursor-not-allowed":"cursor-pointer"}`,children:[jsxRuntimeExports.jsx("input",{id:t.label,type:"checkbox",disabled:l,checked:w.some(e=>e.label===t.label),onChange:()=>j(t),className:`filter-checkmark relative !flex justify-center items-center mt-1 appearance-none !w-7 h-7 border border-primary rounded checked:bg-primary ${l?"cursor-not-allowed":"cursor-pointer"}`}),jsxRuntimeExports.jsx("span",{className:`w-10 h-10 rounded-full border border-geyser text-[0px] ${t.label.toLowerCase()}`,children:t.label}),jsxRuntimeExports.jsxs("span",{children:[t.label," (",t.count,")"]})]},t.label)})}),!k&&jsxRuntimeExports.jsxs("div",{className:"col-span-2 justify-end gap-6 mt-4 flex",children:[jsxRuntimeExports.jsx("button",{onClick:m,className:"text-primary underline text-16",children:"Clear Selections"}),jsxRuntimeExports.jsx("button",{onClick:f,className:" text-white px-4 py-2 rounded w-[126px] h-[44px] bg-primary text-16",children:"Apply"})]}),k&&$.length>7&&jsxRuntimeExports.jsx("button",{onClick:()=>h(!b),className:"mt-4 text-primary text-14 font-apercu underline",children:b?"Show Less":"See All"})]})]})}

let o$1={relevance:"Relevance",manual:"Featured","best-selling":"Best Sellers","price-ascending":"Price, Low to High","price-descending":"Price, High to Low","created-descending":"Newest First","created-ascending":"Oldest First","title-ascending":"Alphabetical, A to Z","title-descending":"Alphabetical, Z to A"},s$2=(window.__PRODUCT_DATA__?.collection?.sort_options||[]).map(e=>({value:e.value,label:o$1[e.value]||e.name||e.value})),c$1=o$1[window.__PRODUCT_DATA__?.collection?.default_sort_by||"best-selling"]||"Best Sellers";function d$2({isSortOpen:o,onSortClick:d}){let u=reactExports.useRef(null),[p,m]=reactExports.useState(false),[w,h]=reactExports.useState(c$1),[f,b]=reactExports.useState(function(){let e=new URLSearchParams(window.location.search).get("sort_by")||"best-selling",t=s$2.find(t=>t.value===e);return t?.label||"Best Sellers"}()),[x,g]=reactExports.useState(false),[y,v]=reactExports.useState(true),_=async e=>{h(e.label),m(false);let t=e.value;b(t);let r=new URLSearchParams(window.location.search);r.set("sort_by",t);let n=`${window.location.pathname}?${r.toString()}`;window.history.pushState({},"",n);try{let e=await fetch(n),t=await e.text(),r=new DOMParser().parseFromString(t,"text/html").querySelector(".product-grid"),a=document.querySelector(".product-grid");r&&a&&(a.innerHTML=r.innerHTML,attachSwatchListeners());}catch(e){console.error("Failed to update product grid:",e);}};return reactExports.useEffect(()=>{let e=()=>{v(true),g(window.innerWidth<1300),v(false);};return e(),window.addEventListener("resize",e),()=>window.removeEventListener("resize",e)},[]),reactExports.useEffect(()=>{function e(e){u.current&&!u.current.contains(e.target)&&m(false);}return document.addEventListener("mousedown",e),()=>document.removeEventListener("mousedown",e)},[]),jsxRuntimeExports.jsxs("div",{ref:u,className:`inline-block text-left ${y?"opacity-0 hidden pointer-events-none":""} ${x?"w-full fixed top-0 z-10 -translate-x-full":"relative ml-auto min-w-[230px]"}
            ${x?o?"translate-x-0 transition-transform duration-300":"-translate-x-full  transition-transform duration-300":""}
        `,children:[jsxRuntimeExports.jsxs("button",{onClick:x?void 0:()=>m(!p),className:`
               text-primary  font-apercuBold
                ${x?"bg-softBlue w-full px-sectionX-sm py-5 flex justify-between items-center text-20":"inline-flex items-center w-full bg-white border border-gray-300 gap-1 text-16 px-4 py-2 rounded-lg shadow-sm transition-all delay-200 duration-700 ease-in-out"}
                ${p?"rounded-b-none pb-8":""}`,children:["Sort by ",x?"":jsxRuntimeExports.jsx("span",{className:"font-apercu inline-block pr-8",children:w}),x?jsxRuntimeExports.jsx("span",{className:"text-primary","aria-label":"Close",onClick:d,children:jsxRuntimeExports.jsx(FilterCloseIcon,{elClass:"w-6 h-6"})}):jsxRuntimeExports.jsx(DownCaretIcon,{elClass:`w-[12px] h-[7px] ml-auto transition-transform duration-300 transform ${p?"rotate-180":""}`})]}),jsxRuntimeExports.jsx("div",{className:`w-full bg-white z-10 ${x?"opacity-100 px-[10px] py-sectionX-sm h-screen":"absolute right-0 border top-[35px] border-gray-200 shadow-lg rounded-b-lg max-h-max overflow-hidden transition-all duration-700 ease-in-out transform origin-top "}
                ${x?"opacity-100":p?"opacity-100 translate-y-0 h-[400px]":"opacity-0 h-0 pointer-events-none"}
                 `,children:jsxRuntimeExports.jsx("ul",{className:"py-2",children:s$2.map(r=>jsxRuntimeExports.jsx("li",{children:jsxRuntimeExports.jsxs("button",{onClick:()=>_(r),className:`flex items-center w-full px-4 py-2 text-left hover:bg-gray-100 text-primary text-16 ${w===r.label?"font-apercuBold":"font-apercu"}`,children:[jsxRuntimeExports.jsx("span",{className:`w-[22px] h-[22px] rounded-full border mr-3 flex items-center justify-center ${w===r.label?"border-primary":"border-gray-300"}`,children:w===r.label&&jsxRuntimeExports.jsx("span",{className:"w-[14px] h-[14px] bg-primary rounded-full"})}),r.label]})},r.value))})})]})}

function l$1({filters:l,clearSelections:s,removeFilter:i}){let a=Object.entries(l).flatMap(([e,t])=>t.map(t=>({key:`${e}-${t.label}`,label:t.label,param:t.param})));return a.length>0?jsxRuntimeExports.jsxs("div",{className:"mt-1 flex filter-desktop:items-center p-sectionX-sm pb-0 flex-col filter-desktop:flex-row filter-desktop:p-0",children:[jsxRuntimeExports.jsx("button",{onClick:s,className:"text-primary underline text-14 flex pt-4 filter-desktop:pt-0 filter-desktop:justify-end pr-11 order-2 filter-desktop:order-1 filter-desktop:basis-48",children:"Clear Filters"}),jsxRuntimeExports.jsx("div",{className:"flex filter-desktop:flex-wrap items-center gap-2 overflow-auto whitespace-nowrap text-16 order-1 filter-desktop:order-2 filter-desktop:basis-11/12",children:a.map(({key:l,label:s,param:a})=>jsxRuntimeExports.jsxs("div",{className:"bg-link text-primary px-3 py-2 rounded-md flex items-center gap-2",children:[jsxRuntimeExports.jsx("span",{children:s}),jsxRuntimeExports.jsx("button",{onClick:()=>i(s),className:"text-primary","aria-label":`Remove ${s}`,children:jsxRuntimeExports.jsx(FilterCloseIcon,{elClass:"w-4 h-4"})})]},l))})]}):null}

const a$3 = (({onFilterClick:o,onSortClick:a,filterCount:c=0})=>{let[d,p]=reactExports.useState(false);return reactExports.useEffect(()=>{let e=()=>{let e=document.getElementById("react-mount-plp");e&&p(e.getBoundingClientRect().top<=100);};return window.addEventListener("scroll",e),e(),()=>window.removeEventListener("scroll",e)},[]),jsxRuntimeExports.jsxs("div",{className:`border border-geyser divide-x divide-geyser w-full flex filter-desktop:wz-hidden ${d?"filter-sort-buttons--sticky":"filter-sort-buttons"}`,children:[jsxRuntimeExports.jsxs("div",{className:"flex justify-center items-center gap-3 px-4 py-4 cursor-pointer basis-1/2",onClick:o,children:[jsxRuntimeExports.jsx("span",{children:jsxRuntimeExports.jsx(FilterIcon,{elClass:"w-7 h-7"})}),jsxRuntimeExports.jsxs("span",{className:"text-14 text-primary font-apercuBold",children:["Filter ",c>0&&jsxRuntimeExports.jsxs("span",{children:["(",c,")"]})]}),jsxRuntimeExports.jsx("span",{children:jsxRuntimeExports.jsx(DownCaretIcon,{elClass:"w-[12px] h-[7px] transition-transform duration-300 inline-block"})})]}),jsxRuntimeExports.jsxs("div",{className:"flex justify-center items-center gap-2 px-4 py-4 cursor-pointer basis-1/2",onClick:a,children:[jsxRuntimeExports.jsx("span",{children:jsxRuntimeExports.jsx(SortIcon,{elClass:"w-7 h-7"})}),jsxRuntimeExports.jsx("span",{className:"text-14 text-primary font-apercuBold",children:"Sort by"}),jsxRuntimeExports.jsx("span",{children:jsxRuntimeExports.jsx(DownCaretIcon,{elClass:"w-[12px] h-[7px] transition-transform duration-300 inline-block"})})]})]})});

const c = (({elClass:r,onFilterClick:s,searchTerm:i,setSearchTerm:o})=>jsxRuntimeExports.jsxs("div",{className:r,children:[jsxRuntimeExports.jsxs("div",{className:"flex items-center justify-between mb-3",children:[jsxRuntimeExports.jsx("h2",{className:"text-20 font-apercuBold text-primary",children:"Filters"}),jsxRuntimeExports.jsx("button",{className:"text-slate-900 text-xl font-light","aria-label":"Close",onClick:s,children:jsxRuntimeExports.jsx(FilterCloseIcon,{elClass:"w-6 h-6"})})]}),jsxRuntimeExports.jsxs("div",{className:"relative",children:[jsxRuntimeExports.jsx("input",{type:"text",placeholder:"Search for a filter",value:i,onChange:e=>o(e.target.value),className:"w-full pl-3 pr-8 py-5 text-16 border border-geyser rounded-md placeholder-bayoux"}),jsxRuntimeExports.jsx("div",{className:"absolute right-6 top-1/2 transform -translate-y-1/2 text-red-400",children:jsxRuntimeExports.jsx(SearchIcon,{})})]})]}));

const d$1 = (({count:e=null})=>{let r=e;return null===r&&"undefined"!=typeof window&&window.__PRODUCT_DATA__&&(r=window.__PRODUCT_DATA__.collection?.products_count||0),jsxRuntimeExports.jsxs("div",{className:"font-apercuBold text-16 leading-7 tracking-normal text-primary pr-11 h-[36px] flex basis-48 justify-center pt-6 items-center filter-desktop:pt-0 filter-desktop:justify-start",children:[r," items"]})});

let e="undefined"!=typeof window&&window.__PRODUCT_DATA__?.filters?window.__PRODUCT_DATA__.filters:{};const SELLING_GROUP_OPTIONS=(e.selling_group||[]).map(({value:e,count:_,param:o})=>({label:e,count:_,param:o}));const SIZE_OPTIONS=(e.size||[]).map(({value:e,count:_,param:o})=>({label:e,count:_,param:o}));const STYLE_OPTIONS=(e.product_style||[]).map(({value:e,count:_,param:o})=>({label:e,count:_,param:o}));const COLOR_OPTIONS=(e.color_family||[]).map(({value:e,count:_,param:o})=>({label:e,count:_,param:o}));const TOWEL_SIZE_CATEGORY_OPTIONS=(e.towel_size_category||[]).map(({value:e,count:_,param:o})=>({label:e,count:_,param:o}));const BUDGET_OPTIONS=(e.budget||[]).map(({value:e,count:_,param:o})=>({label:e,count:_,param:o}));

const y = (({onClearFilters:s,onApplyFilters:a})=>jsxRuntimeExports.jsxs("div",{className:"p-sectionX-sm pb-[max(var(--sectionX-sm),env(safe-area-inset-bottom))] col-span-2 gap-9 flex bg-secondary shadow-custom2 justify-between sm:justify-center mt-auto sticky bottom-0 z-[2]",children:[jsxRuntimeExports.jsx("button",{onClick:s,className:"text-primary underline text-16",children:"Clear Filters"}),jsxRuntimeExports.jsx("button",{onClick:a,className:" text-white px-4 py-2 rounded w-3/5 h-[44px] small-device:w-[224px] bg-primary text-16",children:"Apply Filters"})]}));

const S = (({elClass:r=""})=>jsxRuntimeExports.jsx("div",{className:`w-full h-px bg-gray-300 text-[0px] wz-hidden filter-desktop:block ${r}`,children:"separator"}));

const setGlobalProductCount=t=>{window.__PRODUCT_DATA__=window.__PRODUCT_DATA__||{},window.__PRODUCT_DATA__.productCount=t;let o=new CustomEvent("productCountUpdated",{detail:{productCount:t}});window.dispatchEvent(o);};

function g$1(){let[g,T]=reactExports.useState({"Product Type":[],"Towel Size":[],"Towel Size Category":[],Style:[],Color:[],Price:[]}),[b,x]=reactExports.useState(""),[O,L]=reactExports.useState(null),[P,_]=reactExports.useState(false),[k,z]=reactExports.useState(true),[A,v]=reactExports.useState(false),[F,E]=reactExports.useState(false),[R,q]=reactExports.useState(null),D=reactExports.useCallback(async()=>{T({"Product Type":[],"Towel Size":[],"Towel Size Category":[],Style:[],Color:[],Price:[]});let e=new URLSearchParams(window.location.search);Array.from(e.keys()).forEach(t=>{t.startsWith("filter.")&&e.delete(t);}),document.body.classList.remove("filters-applied"),q(null);let t=`${window.location.pathname}?${e.toString()}`;window.history.pushState({},"",t);try{let e=await fetch(t),r=await e.text(),o=new DOMParser().parseFromString(r,"text/html"),l=o.querySelector(".product-grid"),i=document.querySelector(".product-grid");l&&i&&(i.innerHTML=l.innerHTML,attachSwatchListeners());let n=document.getElementById("no-products-message");n&&n.classList.add("hidden");let s=o.querySelector(".product-count");if(s){let e=s.textContent.match(/\d+/);if(e){let t=parseInt(e[0],10);L(t),setGlobalProductCount(t);}}v(!1);}catch(e){console.error("Failed to refresh product grid:",e);}},[]),M=(e,t)=>R&&t?e.map(e=>{let r=t.find(t=>t.value===e.label);return {...e,count:r?r.count:0}}):e,$=e=>{for(let t of e.querySelectorAll("script"))if(t.textContent.includes("window.__PRODUCT_DATA__")){let e=document.createElement("script");e.textContent=t.textContent,document.head.appendChild(e),document.head.removeChild(e);break}return window.__PRODUCT_DATA__?.filters||null},U=async e=>{let t=new URLSearchParams(window.location.search);t.delete("page"),Array.from(t.keys()).forEach(e=>{e.startsWith("filter.")&&t.delete(e);}),Object.entries(g).forEach(([e,r])=>{r.forEach(({param:e,label:r})=>{e&&t.append(e,r);});}),document.body.classList.toggle("filters-applied",N>0);let r=`${window.location.pathname}?${t.toString()}`;window.history.pushState({},"",r);try{let t=await fetch(r),o=await t.text(),l=new DOMParser().parseFromString(o,"text/html"),i=l.querySelector(".product-grid"),n=document.querySelector(".product-grid");i&&n&&(n.innerHTML=i.innerHTML,attachSwatchListeners());let s=l.querySelector(".product-count");if(s){let e=s.textContent.match(/\d+/);if(e){let t=parseInt(e[0],10);L(t),setGlobalProductCount(t);}}let a=$(l);a&&q(a),"function"==typeof e&&e();}catch(e){console.error("Error applying all filters:",e);}},H=async e=>{let t={...g};for(let r in t)t[r]=t[r].filter(t=>t.label!==e);T(t);let r=Array.from(new URLSearchParams(window.location.search).entries()).filter(([t,r])=>r!==e),o=new URLSearchParams;r.forEach(([e,t])=>{o.append(e,t);});let l=`${window.location.pathname}?${o.toString()}`;window.history.pushState({},"",l);try{let e=await fetch(l),t=await e.text(),r=new DOMParser().parseFromString(t,"text/html"),o=r.querySelector(".product-grid"),i=document.querySelector(".product-grid");o&&i&&(i.innerHTML=o.innerHTML,attachSwatchListeners());let n=r.querySelector(".product-count");if(n){let e=n.textContent.match(/\d+/);if(e){let t=parseInt(e[0],10);L(t),setGlobalProductCount(t);}}let s=$(r);q(s);}catch(e){console.error("Error refreshing product grid:",e);}};reactExports.useEffect(()=>{let e=()=>{z(true),_(window.innerWidth<1300),z(false);};return e(),window.addEventListener("resize",e),()=>window.removeEventListener("resize",e)},[]);let j=()=>{v(!A);},I=()=>{E(!F);},N=Object.values(g).reduce((e,t)=>e+t.length,0);reactExports.useEffect(()=>{let e=new URLSearchParams(window.location.search),t={"Product Type":[],"Towel Size":[],"Towel Size Category":[],Style:[],Color:[],Price:[]};for(let[r,o]of Object.entries({"Product Type":SELLING_GROUP_OPTIONS,"Towel Size":SIZE_OPTIONS,"Towel Size Category":TOWEL_SIZE_CATEGORY_OPTIONS,Style:STYLE_OPTIONS,Color:COLOR_OPTIONS,Price:BUDGET_OPTIONS})){let l=o[0]?.param;if(l){let i=e.getAll(l),n=o.filter(e=>i.includes(e.label));t[r]=n;}}T(t);},[]),reactExports.useEffect(()=>{window.__CLEAR_ALL_FILTERS__=D;},[D]),reactExports.useEffect(()=>(document.body.classList.toggle("plp-filters-open",A),document.body.classList.toggle("plp-sort-open",F),()=>{document.body.classList.remove("plp-filters-open"),document.body.classList.remove("plp-sort-open");}),[A,F]);let B=window.__PRODUCT_DATA__?.collection?.handle,W=["all-towels","bath-towels","hand-towels","kids-towels-washcloths","weezie-basics"].includes(B),G=["all-towels","hand-towels","kids-towels-washcloths"].includes(B);return jsxRuntimeExports.jsx("div",{className:"container max-[1299px]:px-0",children:jsxRuntimeExports.jsxs("div",{className:"flex flex-col filter-desktop:block",children:[jsxRuntimeExports.jsx(S,{elClass:"separator--top mb-16"}),jsxRuntimeExports.jsx(a$3,{onFilterClick:j,onSortClick:I,filterCount:N}),jsxRuntimeExports.jsxs("div",{className:"block w-full relative order-3 filter-desktop:order-none filter-desktop:h-[50px] filter-desktop:flex",children:[jsxRuntimeExports.jsx(d$1,{count:O}),jsxRuntimeExports.jsxs("div",{className:`flex flex-col w-full filter-desktop:w-auto filter-desktop:flex-row  fixed top-0 z-10 filter-desktop:static
          max-filter-desktop:bg-secondary border-b border-geyser filter-desktop:border-0 ${k?"opacity-0 hidden pointer-events-none":""} filter-desktop:translate-x-0
            ${A?"translate-x-0 transition-transform duration-300":" -translate-x-full  transition-transform duration-300 "}
            ${P?"h-[100dvh] overflow-auto":""}
          `,children:[jsxRuntimeExports.jsx(c,{elClass:"filter-desktop:wz-hidden p-sectionX-sm bg-softBlue",onFilterClick:j,searchTerm:b,setSearchTerm:x}),!W&&jsxRuntimeExports.jsx(a$4,{label:"Product Type",searchTerm:b,options:M(SELLING_GROUP_OPTIONS,R?.selling_group),selectedOptions:g["Product Type"],setSelectedOptions:e=>{T(t=>({...t,"Product Type":e}));},isFilterOpen:A,onApply:U,onClear:D}),!G&&jsxRuntimeExports.jsx(a$4,{label:"Size",searchTerm:b,options:M(SIZE_OPTIONS,R?.size),selectedOptions:g["Towel Size"],setSelectedOptions:e=>{T(t=>({...t,"Towel Size":e}));},isFilterOpen:A,onApply:U,onClear:D}),jsxRuntimeExports.jsx(a$4,{label:"Towel Size",searchTerm:b,options:M(TOWEL_SIZE_CATEGORY_OPTIONS,R?.towel_size_category),selectedOptions:g["Towel Size Category"],setSelectedOptions:e=>{T(t=>({...t,"Towel Size Category":e}));},isFilterOpen:A,onApply:U,onClear:D}),jsxRuntimeExports.jsx(a$4,{label:"Style",searchTerm:b,options:M(STYLE_OPTIONS,R?.product_style),selectedOptions:g.Style,setSelectedOptions:e=>{T(t=>({...t,Style:e}));},isFilterOpen:A,onApply:U,onClear:D}),jsxRuntimeExports.jsx(a$4,{label:"Color",type:"color",searchTerm:b,options:M(COLOR_OPTIONS,R?.color_family),selectedOptions:g.Color,setSelectedOptions:e=>{T(t=>({...t,Color:e}));},isFilterOpen:A,onApply:U,onClear:D}),jsxRuntimeExports.jsx(a$4,{label:"Price",searchTerm:b,options:M(BUDGET_OPTIONS,R?.budget),selectedOptions:g.Price,setSelectedOptions:e=>{T(t=>({...t,Price:e}));},isFilterOpen:A,onApply:U,onClear:D}),jsxRuntimeExports.jsx("div",{className:"h-4 text-[0] bg-secondary",children:"spacer"}),P&&jsxRuntimeExports.jsx(y,{onApplyFilters:()=>U(()=>v(!1)),onClearFilters:D})]}),jsxRuntimeExports.jsx(d$2,{isSortOpen:F,onSortClick:I})]}),jsxRuntimeExports.jsx(l$1,{filters:g,clearSelections:D,removeFilter:H}),jsxRuntimeExports.jsx(S,{elClass:"separator--bottom mt-10"})]})})}

const m = (()=>{let[r,s]=reactExports.useState("");return reactExports.useEffect(()=>{let e=window.__PRODUCT_DATA__?.collection?.title||window.__PRODUCT_DATA__?.search?.terms;e&&s(e);},[]),jsxRuntimeExports.jsx("nav",{"aria-label":"Breadcrumb",className:"my-[30px] container font-apercu",children:jsxRuntimeExports.jsxs("ol",{className:"flex items-center text-14",children:[jsxRuntimeExports.jsx("li",{children:jsxRuntimeExports.jsx("a",{href:"/",className:"hover:text-slateBlue text-fiord transition-colors duration-300",children:"Home"})}),jsxRuntimeExports.jsx("span",{className:"mx-4 text-slateBlue",children:"|"}),jsxRuntimeExports.jsx("li",{children:jsxRuntimeExports.jsx("span",{className:"text-slateBlue",children:r})})]})})});

const a$2 = (()=>{let[i,l]=reactExports.useState([]);return (reactExports.useEffect(()=>{let e=window.__PRODUCT_DATA__?.collection||{};e&&l(e.callout||"");},[]),i?.length)?jsxRuntimeExports.jsx("div",{className:"bg-royalBlue py-space80 my-[50px]",children:jsxRuntimeExports.jsx("div",{class:"container wz-grid grid-cols-1 md:grid-cols-3 gap-8 text-white text-center",children:i?.map((a,c)=>jsxRuntimeExports.jsxs("div",{className:"text-center text-white font-apercu",children:[jsxRuntimeExports.jsx("img",{src:a.icon_image,alt:"",className:"mx-auto w-16 h-16 object-contain"}),jsxRuntimeExports.jsx("p",{className:"text-16 max-w-[300px] mx-auto mt-[30px]",children:a.description})]},c))})}):null});

const i$1 = (()=>{let[a,i]=reactExports.useState(()=>window.__PRODUCT_DATA__?.collection?.products_count??null),[l,s]=reactExports.useState(24),[c,d]=reactExports.useState(1);if(reactExports.useEffect(()=>{d(parseInt(new URLSearchParams(window.location.search).get("page")||"1",10));let e=window.__PRODUCT_DATA__?.settings?.products_per_page;"number"==typeof e&&s(e);},[]),reactExports.useEffect(()=>{let e=e=>{i(e.detail.productCount);};return window.addEventListener("productCountUpdated",e),()=>window.removeEventListener("productCountUpdated",e)},[]),reactExports.useEffect(()=>{let e=()=>{d(parseInt(new URLSearchParams(window.location.search).get("page")||"1",10));};return window.addEventListener("popstate",e),()=>window.removeEventListener("popstate",e)},[]),!a||0===a)return null;let u=Math.ceil(a/l);if(u<=1)return null;let p=async e=>{let t=new URLSearchParams(window.location.search);1===e?t.delete("page"):t.set("page",e);let r=`${window.location.pathname}?${t.toString()}`;window.history.pushState({},"",r),d(e);try{let e=await fetch(r),t=await e.text(),o=new DOMParser().parseFromString(t,"text/html").querySelector(".product-grid"),n=document.querySelector(".product-grid");o&&n&&(n.innerHTML=o.innerHTML,attachSwatchListeners(),window.scrollTo({top:n.offsetTop-100,behavior:"smooth"}));}catch(e){console.error("Error fetching new product grid:",e);}};return jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment,{children:jsxRuntimeExports.jsxs("div",{className:"flex justify-center font-apercu items-center gap-10 mt-6 text-20 text-primary",children:[c>1&&jsxRuntimeExports.jsx("button",{onClick:()=>p(c-1),className:"transition-colors duration-300 underline hover:text-royalBlue",children:"Previous"}),(()=>{let t=1;c>3&&(t=c-2),t+5-1>u&&(t=Math.max(1,u-5+1));let r=[];for(let o=0;o<5;o++){let n=t+o;if(n>u)break;let a=n===c;r.push(jsxRuntimeExports.jsx("button",{onClick:()=>p(n),disabled:a,className:`py-1 transition-colors duration-300 ${a?"text-primary cursor-default":"underline hover:text-royalBlue"}`,children:n},n));}return r})(),c<u&&jsxRuntimeExports.jsx("button",{onClick:()=>p(c+1),className:"transition-colors duration-300 underline hover:text-royalBlue",children:"Next"})]})})});

function n$1(){return jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment,{children:[jsxRuntimeExports.jsx(i$1,{}),jsxRuntimeExports.jsx(a$2,{})]})}

function n(){let[n,r]=reactExports.useState("");return (reactExports.useEffect(()=>{let e=window.__PRODUCT_DATA__?.collection||{};e&&r(e.seo_description||"");},[]),n)?jsxRuntimeExports.jsx("div",{className:"collection-seo-content mt-sectionX px-[50px] pb-6",children:jsxRuntimeExports.jsx("div",{dangerouslySetInnerHTML:{__html:n}})}):null}

const p = (({startImage:a="right"})=>{let i=window.__PRODUCT_DATA__?.productOptionVals?.find(e=>e.id===window.__PRODUCT_DATA__?.product?.id),c=i?.productFeatures,n=e=>"string"==typeof e?e:e&&e.value||"",r=n(c?.sectionTitle),s=n(c?.sectionSubtitle),m=n(c?.sectionDescription),o=Array.isArray(c?.features)?c.features:[];if(!o.length&&!r&&!s&&!m)return null;let x="left"===a;return jsxRuntimeExports.jsx("section",{className:"signature-collection-section container",children:jsxRuntimeExports.jsxs("div",{children:[(r||s||m)&&jsxRuntimeExports.jsxs("div",{className:"text-center mb-10",children:[r&&jsxRuntimeExports.jsx("h3",{className:"text-royalBlue font-clearface text-[28px] md:text-[42px] mb-2",children:r}),s&&jsxRuntimeExports.jsx("h4",{className:"text-royalBlue font-clearface text-18 md:text-20 mb-3",children:s}),m&&jsxRuntimeExports.jsx("p",{className:"text-royalBlue font-apercu text-[16px] md:text-[20px] leading-relaxed max-w-2xl mx-auto",children:m})]}),o.map((a,i)=>{let c,r=x?i%2==1:i%2==0,s="string"==typeof(c=a.image)?c:c&&c.value||"",m=n(a.heading),o=n(a.subheading),d=n(a.body);return jsxRuntimeExports.jsx("div",{className:"information-block py-0 px-0 mt-0 ml-0 mr-0",children:jsxRuntimeExports.jsxs("div",{className:["image-text-icons w-full flex flex-col custom-lg:flex-row items-center custom-lg:justify-between gap-10",r?"image-left custom-lg:flex-row-reverse":"image-right"].join(" "),children:[jsxRuntimeExports.jsx("div",{className:"image w-full mt-[20px] md:mt-page-md custom-lg:mt-0",children:s&&jsxRuntimeExports.jsx("img",{src:s,srcSet:getOptimizedImageSrcset(s,[480,640,720,896,1080,1440,1800]),sizes:"(min-width: 990px) calc(min((100vw - 80px - 25px) / 2), 896px), (min-width: 768px) calc(100vw - 80px), 100vw",alt:m||"Section Image",className:"w-full h-auto max-w-full rounded-[5px] object-cover",loading:"lazy"})}),jsxRuntimeExports.jsx("div",{className:"content content-wrapper flex flex-row flex-wrap justify-center mb-0 text-center w-full flex-[0_1_auto]",children:jsxRuntimeExports.jsxs("div",{className:"info-text-block flex flex-1 flex-col gap-5 max-w-[400px] md:max-w-[420px] mx-auto px-sectionX-sm md:px-0",children:[m&&jsxRuntimeExports.jsx("h3",{className:"text-center font-clearface text-[28px] md:text-[42px] !block",children:m}),(o||d)&&jsxRuntimeExports.jsxs("p",{className:"info-content text-center text-[16px] md:text-[20px]",children:[o&&jsxRuntimeExports.jsx("span",{className:"block mb-2",children:o}),d]})]})})]})},i)})]})})});

const a$1 = (()=>{let l=window.__PRODUCT_DATA__?.productOptionVals?.find(e=>e.id===window.__PRODUCT_DATA__?.product?.id),a=l?.allDetails||{};if(![a.feature_1_title,a.feature_2_title,a.feature_3_title].some(e=>e&&""!==e.trim()))return null;let s=e=>e?"string"==typeof e?e:"object"==typeof e&&e.value?e.value:("object"==typeof e&&e.error,""):"",n=e=>e?"string"==typeof e?e:"object"==typeof e&&e.value?e.value:("object"==typeof e&&e.error,""):"",d=[{image:n(a.feature_1_image),title:s(a.feature_1_title),description:s(a.feature_1_description)},{image:n(a.feature_2_image),title:s(a.feature_2_title),description:s(a.feature_2_description)},{image:n(a.feature_3_image),title:s(a.feature_3_title),description:s(a.feature_3_description)}].filter(e=>e.title&&""!==e.title.trim());reactExports.useEffect(()=>{if("undefined"!=typeof window&&window.Swiper){let e=new window.Swiper(".feature-slider-container",{slidesPerView:1,spaceBetween:16,loop:false,centeredSlides:false,navigation:{nextEl:".feature-slider-next",prevEl:".feature-slider-prev"},breakpoints:{0:{slidesPerView:1,spaceBetween:24,centeredSlides:false},390:{slidesPerView:1,spaceBetween:24,centeredSlides:false},640:{slidesPerView:2.4,spaceBetween:16,centeredSlides:false},1024:{slidesPerView:3,spaceBetween:20,centeredSlides:false}}});return ()=>{e&&e.destroy();}}},[]);let c=s(a.headline).toLowerCase().includes("removing makeup");return jsxRuntimeExports.jsx("section",{className:"signature-collection-section container !px-0 md:!px-10",children:jsxRuntimeExports.jsxs("div",{className:"text-center",children:[s(a.subtitle)&&!c&&jsxRuntimeExports.jsx("p",{className:"subheading font-blueVinyl text-royalBlue text-[42px]",children:s(a.subtitle)}),s(a.headline)&&jsxRuntimeExports.jsx("h2",{className:"main-title font-clearface text-[34px] md:text-[42px] mb-[20px] md:mb-[40px] px-2",children:s(a.headline)}),jsxRuntimeExports.jsx("div",{className:"signature-blocks !hidden md:!block flex gap-[20px]",children:jsxRuntimeExports.jsx("div",{className:"swiper-wrapper flex",children:d.map((i,l)=>jsxRuntimeExports.jsxs("div",{className:"signature-block flex shrink flex-col mx-2",children:[i.image&&jsxRuntimeExports.jsx("div",{className:"image-wrap rounded-[50%] overflow-hidden  w-100 h-100 max-w-[240px] max-h-[240px] md:max-w-[300px] md:max-h-[300px] mx-auto mt-0 mb-space15",children:jsxRuntimeExports.jsx("img",{src:i.image,srcSet:getOptimizedImageSrcset(i.image,[240,300,480,600]),sizes:"(min-width: 768px) min(calc((100vw - 80px) / 3), 300px), 240px",alt:i.title,className:"w-full h-full object-cover"})}),jsxRuntimeExports.jsxs("div",{className:"max-w-[260px] px-[10px]",children:[i.title&&jsxRuntimeExports.jsx("h3",{className:"font-apercu text-[16px] mb-2 uppercase",children:i.title}),i.description&&jsxRuntimeExports.jsx("p",{className:"font-apercu text-[16px]",children:i.description})]})]},l))})}),jsxRuntimeExports.jsx("div",{className:"feature-slider-section block md:hidden",children:jsxRuntimeExports.jsxs("div",{className:"relative flex items-center",children:[jsxRuntimeExports.jsx("button",{type:"button",className:"feature-slider-prev flex-shrink-0 w-[50px] h-[48px] rounded-[10px] overflow-hidden cursor-pointer",children:jsxRuntimeExports.jsxs("svg",{viewBox:"0 0 50 48",fill:"none",xmlns:"http://www.w3.org/2000/svg",className:"w-full h-full",children:[jsxRuntimeExports.jsx("path",{d:"M0 0H46C48.2091 0 50 1.79086 50 4V44C50 46.2091 48.2091 48 46 48H0V0Z",fill:"white"}),jsxRuntimeExports.jsx("line",{y1:"-0.6",x2:"28",y2:"-0.6",transform:"matrix(-1 0 0 1 40 24.5)",stroke:"#14334C",strokeWidth:"1.2"}),jsxRuntimeExports.jsx("path",{d:"M12 23.5C14.6667 23.3333 20 21.2 20 14",stroke:"#14334C",strokeWidth:"1.2"}),jsxRuntimeExports.jsx("path",{d:"M12 24C14.6667 24.1667 20 26.3 20 33.5",stroke:"#14334C",strokeWidth:"1.2"})]})}),jsxRuntimeExports.jsx("div",{className:"feature-slider-container swiper-container overflow-hidden flex-1",children:jsxRuntimeExports.jsx("div",{className:"swiper-wrapper",children:d.map((i,l)=>jsxRuntimeExports.jsxs("div",{className:"swiper-slide feature-item p-4 text-center",children:[i.image&&jsxRuntimeExports.jsx("img",{src:i.image,srcSet:getOptimizedImageSrcset(i.image,[240,300,480,600]),sizes:"(min-width: 768px) min(calc((100vw - 80px) / 3), 300px), 240px",alt:i.title,className:"rounded-full w-[240px] h-[240px] max-w-[240px] max-h-[240px] object-cover mx-auto"}),jsxRuntimeExports.jsxs("div",{className:"max-w-[260px] px-[10px] mt-[20px] mx-auto",children:[i.title&&jsxRuntimeExports.jsx("h3",{className:"font-apercu text-[16px] mb-2 uppercase",children:i.title}),i.description&&jsxRuntimeExports.jsx("p",{className:"font-apercu text-[16px]",children:i.description})]})]},l))})}),jsxRuntimeExports.jsx("button",{type:"button",className:"feature-slider-next flex-shrink-0 w-[50px] h-[48px] rounded-[10px] overflow-hidden cursor-pointer",children:jsxRuntimeExports.jsxs("svg",{viewBox:"0 0 50 48",fill:"none",xmlns:"http://www.w3.org/2000/svg",className:"w-full h-full",children:[jsxRuntimeExports.jsx("path",{d:"M50 0H4C1.79086 0 0 1.79086 0 4V44C0 46.2091 1.79086 48 4 48H50V0Z",fill:"white"}),jsxRuntimeExports.jsx("line",{x1:"10",y1:"23.9",x2:"38",y2:"23.9",stroke:"#14334C",strokeWidth:"1.2"}),jsxRuntimeExports.jsx("path",{d:"M38 23.5C35.3333 23.3333 30 21.2 30 14",stroke:"#14334C",strokeWidth:"1.2"}),jsxRuntimeExports.jsx("path",{d:"M38 24C35.3333 24.1667 30 26.3 30 33.5",stroke:"#14334C",strokeWidth:"1.2"})]})})]})})]})})});

const l = (()=>{let i=window.__PRODUCT_DATA__?.signatureBasics;if(!i||!i.show)return null;let r=(i.productLine||"").toLowerCase(),m=r.includes("signature"),n=r.includes("basics"),p={title:i?.signature?.title||"Weezie Signature",image:i?.signature?.image||null,features:i?.signature?.features||["Elevated and design-forward looks","Piped, rounded edges","Slightly thicker bath towels","Customization","Hanging loop"],url:i?.signatureUrl},d={title:i?.basics?.title||"Weezie Basics",image:i?.basics?.image||null,features:i?.basics?.features||["Sleek and streamlined design","Hemmed, square edges","Slightly thinner (still super fluffy!)","Customization","Hanging loop"],url:i?.basicsUrl},o=i?.eyebrow||"thread to thread",c=i?.heading||"Meet Our Towels",x=i?.blurb||"Made of the same plush, soft, 100% organic cotton Weezie terry, our two essential towel lines cater to every style.";return jsxRuntimeExports.jsx("section",{className:"feature-section page-width !px-page-sm lg:!px-page-md custom-xl:!px-page !pt-[45px] !pb-[100px]",children:jsxRuntimeExports.jsxs("div",{className:"flex flex-col lg:flex-row",children:[jsxRuntimeExports.jsxs("div",{className:"text-center w-full lg:w-[30%] flex flex-col align-middle justify-center",children:[jsxRuntimeExports.jsx("p",{className:"font-blueVinyl text-royalBlue text-[42px]",children:o}),jsxRuntimeExports.jsx("h2",{className:"font-clearface text-[34px] mb-section-sm",children:c}),jsxRuntimeExports.jsx("p",{className:"content max-w-[340px] mx-auto mt-section-sm px-section-sm",children:x})]}),jsxRuntimeExports.jsxs("div",{className:"feature-blocks w-full lg:w-[70%] flex justify-between sm:justify-evenly lg:justify-end gap-space15 sm:gap-page-sm mt-page-sm lg:mt-0",children:[jsxRuntimeExports.jsxs("div",{className:"feature-block text-center px-0 sm:px-sectionX-sm pb-page-sm pt-[70px] sm:pt-[100px] bg-softBlue rounded-lg w-[48%] sm:w-[45%] relative mt-[50px] sm:mt-[70px]",children:[jsxRuntimeExports.jsx("div",{className:"absolute w-full left-0 top-[-50px] sm:top-[-70px]",children:jsxRuntimeExports.jsx("div",{className:"image-wrapper flex justify-center mb-4 mx-auto",children:p.image?jsxRuntimeExports.jsx("img",{src:p.image,srcSet:getOptimizedImageSrcset(p.image,[100,150,200,300]),sizes:"(min-width: 640px) 150px, 100px",alt:p.title,className:"rounded-full border-4 md:border-2 border-royalBlue w-[100px] sm:w-[150px]",loading:"lazy"}):jsxRuntimeExports.jsx("div",{className:"rounded-full border-4 md:border-2 border-royalBlue w-[100px] sm:w-[150px] h-[100px] sm:h-[150px] bg-white"})})}),jsxRuntimeExports.jsx("h3",{className:"mt-section-sm mb-0 font-clearface text-26 px-2",children:p.title}),jsxRuntimeExports.jsx("ul",{className:"mb-0 px-0 lg:px-sectionX-sm custom-xl:px-[12%]",children:p.features.map((a,i)=>jsxRuntimeExports.jsx("li",{className:"border-b border-white py-space15 last:border-b-0",children:jsxRuntimeExports.jsxs("p",{className:"m-0 lg:px-0",children:["  ","string"==typeof a?a.split(",").map((a,i,r)=>jsxRuntimeExports.jsxs(reactExports.Fragment,{children:[a.trim(),i<r.length-1&&jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment,{children:[", ",jsxRuntimeExports.jsx("br",{className:"inline md:hidden"})]})]},i)):a]})},i))}),jsxRuntimeExports.jsx("div",{className:"absolute left-0 w-full bottom-[-20px]",children:m?jsxRuntimeExports.jsx("a",{href:p.url,className:"bg-primary text-white max-w-100 px-[20px] py-[12px] rounded text-16 inline-block leading-[16px]",children:"Now Viewing"}):jsxRuntimeExports.jsx("a",{href:p.url,className:"bg-primary text-white max-w-100 px-[20px] py-[12px] rounded text-16 inline-block leading-[16px]",children:"Shop Now"})})]}),jsxRuntimeExports.jsxs("div",{className:"feature-block text-center px-0 sm:px-sectionX-sm pb-page-sm pt-[70px] sm:pt-[100px] bg-softBlue rounded-lg w-[48%] sm:w-[45%] relative mt-[50px] sm:mt-[70px]",children:[jsxRuntimeExports.jsx("div",{className:"absolute w-full left-0 top-[-50px] sm:top-[-70px]",children:jsxRuntimeExports.jsx("div",{className:"image-wrapper flex justify-center mb-4 mx-auto",children:d.image?jsxRuntimeExports.jsx("img",{src:d.image,srcSet:getOptimizedImageSrcset(d.image,[100,150,200,300]),sizes:"(min-width: 640px) 150px, 100px",alt:d.title,className:"rounded-full border-4 md:border-2 border-royalBlue w-[100px] sm:w-[150px]",loading:"lazy"}):jsxRuntimeExports.jsx("div",{className:"rounded-full border-4 md:border-2 border-royalBlue w-[100px] sm:w-[150px] h-[100px] sm:h-[150px] bg-white"})})}),jsxRuntimeExports.jsx("h3",{className:"mt-section-sm mb-0 font-clearface text-26 px-5",children:d.title}),jsxRuntimeExports.jsx("ul",{className:"mb-0 px-0 lg:px-sectionX-sm custom-xl:px-[12%]",children:d.features.map((a,i)=>jsxRuntimeExports.jsx("li",{className:"border-b border-white py-space15 last:border-b-0",children:jsxRuntimeExports.jsxs("p",{className:"m-0 px-1 lg:px-0",children:["  ","string"==typeof a?a.split(",").map((a,i,r)=>jsxRuntimeExports.jsxs(reactExports.Fragment,{children:[a.trim(),i<r.length-1&&jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment,{children:[", ",jsxRuntimeExports.jsx("br",{className:"inline md:hidden"})]})]},i)):a]})},i))}),jsxRuntimeExports.jsx("div",{className:"absolute left-0 w-full bottom-[-20px]",children:n?jsxRuntimeExports.jsx("a",{href:d.url,className:"bg-primary text-white max-w-100 px-[20px] py-[12px] rounded text-16 inline-block leading-[16px]",children:"Now Viewing"}):jsxRuntimeExports.jsx("a",{href:d.url,className:"bg-primary text-white max-w-100 px-[20px] py-[12px] rounded text-16 inline-block leading-[16px]",children:"Shop Now"})})]})]})]})})});

const s$1 = (()=>{let a=window.__PRODUCT_DATA__?.designer;if(!a||!a.name)return null;let d=e=>e?"string"==typeof e?e:"object"==typeof e&&e.value?e.value:"":"",s=d(a.shortBio);return jsxRuntimeExports.jsx("section",{className:"designer-section",style:{backgroundColor:a?.bgColor||"#FAF9FF"},children:jsxRuntimeExports.jsx("div",{className:"page-width !p-page-sm md:!p-page-md custom-xl:!p-page",children:jsxRuntimeExports.jsxs("div",{className:"flex flex-col lg:flex-row items-center gap-10 lg:gap-16",children:[jsxRuntimeExports.jsxs("div",{className:"w-full lg:w-1/2 text-center lg:order-0 order-1",children:[jsxRuntimeExports.jsx("p",{className:"font-blueVinyl text-royalBlue text-[42px] mb-2",children:"meet the designer"}),jsxRuntimeExports.jsx("h2",{className:"font-clearface text-[34px] md:text-[42px] text-primary mb-4",children:d(a.name)}),s&&jsxRuntimeExports.jsx("p",{className:"text-primary text-[16px] md:text-[20px] leading-[22px] mb-8 max-w-[500px] mx-auto md:leading-[27px]",children:s}),a.detailImages&&a.detailImages.length>0&&jsxRuntimeExports.jsx("div",{className:"flex justify-center gap-4 align-items-center mt-[40px] md:mt-[80px]",children:a.detailImages.map((l,s)=>jsxRuntimeExports.jsx("div",{className:"w-[100px] h-auto max-w-[calc((100%/3)-10px)] md:w-[175px] md:h-[175px] rounded-full overflow-hidden border-2 border-white shadow-md",children:jsxRuntimeExports.jsx("img",{src:l,alt:`${d(a.name)} design detail ${s+1}`,className:"w-full h-full object-cover",loading:"lazy"})},s))})]}),jsxRuntimeExports.jsx("div",{className:"w-full lg:w-1/2 relative lg:order-1 order-0",children:jsxRuntimeExports.jsxs("div",{className:"relative",children:[a.mainImage?jsxRuntimeExports.jsx("img",{src:a.mainImage,alt:`${d(a.name)} designer portrait`,className:"w-full h-auto rounded-lg shadow-lg",loading:"lazy"}):jsxRuntimeExports.jsx("div",{className:"w-full h-[500px] bg-gray-200 rounded-lg flex items-center justify-center",children:jsxRuntimeExports.jsx("span",{className:"text-gray-500",children:"Designer Image"})}),a.detailImages&&a.detailImages.length>0&&jsxRuntimeExports.jsx("div",{className:"absolute top-4 right-4 flex flex-col gap-2",children:a.detailImages.slice(0,4).map((l,s)=>jsxRuntimeExports.jsx("div",{className:"w-12 h-16 md:w-16 md:h-20 rounded overflow-hidden border border-white shadow-sm",children:jsxRuntimeExports.jsx("img",{src:l,alt:`${d(a.name)} design ${s+1}`,className:"w-full h-full object-cover",loading:"lazy"})},s))}),jsxRuntimeExports.jsxs("div",{className:"absolute bottom-4 left-4 flex gap-2",children:[jsxRuntimeExports.jsx("div",{className:"w-8 h-8 bg-green-400 rounded shadow-sm"}),jsxRuntimeExports.jsx("div",{className:"w-10 h-8 bg-pink-300 rounded shadow-sm"}),jsxRuntimeExports.jsx("div",{className:"w-12 h-6 bg-yellow-200 rounded-full shadow-sm"})]})]})})]})})})});

let a=(e,t)=>"undefined"!=typeof window&&window.__ICONS__&&window.__ICONS__[e]?window.__ICONS__[e]:t,d=({src:t,alt:r,bgClass:l})=>jsxRuntimeExports.jsx("div",{className:`inline-flex h-[24px] w-[24px] items-center justify-center ${l}`,children:jsxRuntimeExports.jsx("img",{src:t,alt:r,className:"h-[24px] w-[24px] min-h-[24px] min-w-[24px]",width:"24",height:"24"})}),i=()=>jsxRuntimeExports.jsx(d,{src:a("check",'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7 12.5l3 3 7-7" fill="none" stroke="%23005BBB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'),alt:"Yes",bgClass:""}),s=()=>jsxRuntimeExports.jsx(d,{src:a("cross",'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="%238A94A6" stroke-width="2" stroke-linecap="round"/></svg>'),alt:"No",bgClass:""});function o(){let a="undefined"!=typeof window?window.__PRODUCT_DATA__?.competitorComparison:null;if(!a?.show)return null;let d=Array.isArray(a?.rows)&&a.rows.length?a.rows:[{label:"100% organic cotton",weezie:true,otherLuxury:true,standard:false},{label:"Stylish looks",weezie:true,otherLuxury:true,standard:false},{label:"Embroidery & applique personalization",weezie:true,otherLuxury:false,standard:false},{label:"Air Spun: extra fluffy & soft",weezie:true,otherLuxury:false,standard:false},{label:"Ultra absorbent & still quick to dry",weezie:true,otherLuxury:false,standard:false}],o=a?.leftImage,m=reactExports.useRef(null),x=reactExports.useRef(null),[p,h]=reactExports.useState(null);return reactExports.useEffect(()=>{let e=()=>{let e=m.current,t=x.current;if(!e||!t)return;let r=e.getBoundingClientRect(),l=t.getBoundingClientRect();h({left:`${l.left-r.left}px`,width:`${l.width}px`});},t=new ResizeObserver(e);return m.current&&t.observe(m.current),x.current&&t.observe(x.current),e(),window.addEventListener("resize",e),()=>{t.disconnect(),window.removeEventListener("resize",e);}},[]),jsxRuntimeExports.jsx("section",{className:"py-[25px] md:py-sectionY container",children:jsxRuntimeExports.jsx("div",{className:"py-[25px] md:py-sectionY",children:jsxRuntimeExports.jsxs("div",{className:"flex-1 lg:flex flex-row gap-6 items-center",children:[jsxRuntimeExports.jsx("div",{className:"w-full lg:flex-1 lg:max-w-[40%] max-h-[758px] xl:max-w-[50%] min-w-0 rounded-[5px] overflow-hidden",children:o?jsxRuntimeExports.jsx("img",{src:o,srcSet:getOptimizedImageSrcset(o,[480,640,768,960,1200,1440,1800]),sizes:"(min-width: 1280px) calc((100vw - 28px - 15px) / 2), (min-width: 1024px) calc((100vw - 28px - 15px) * 0.4), calc(100vw - 28px)",alt:"Stack of towels",className:"h-full w-full object-cover ",loading:"lazy"}):jsxRuntimeExports.jsx("div",{className:"flex h-full w-full items-center justify-center text-slate-600",children:"image: stack of towels"})}),jsxRuntimeExports.jsxs("div",{className:"w-full lg:flex-1 xl:w-1/2 min-w-0 overflow-hidden",children:[jsxRuntimeExports.jsx("h2",{className:"text-center font-clearface text-[28px] md:text-32 mb-3 md:mb-[46px] pt-6 ",children:"How We Stack Up"}),jsxRuntimeExports.jsxs("div",{ref:m,className:"relative overflow-visible rounded-[16px] pb-16 md:pb-20",children:[jsxRuntimeExports.jsx("div",{className:"absolute inset-y-0 rounded-t-[16px] bg-link pointer-events-none",style:p||{left:"50%",width:"16.6667%"}}),jsxRuntimeExports.jsxs("table",{className:"w-full max-w-full border-separate border-spacing-0 table-fixed",children:[jsxRuntimeExports.jsxs("colgroup",{children:[jsxRuntimeExports.jsx("col",{className:"w-auto"}),jsxRuntimeExports.jsx("col",{className:"cc-col cc-col--weezie"}),jsxRuntimeExports.jsx("col",{className:"cc-col cc-col--other"}),jsxRuntimeExports.jsx("col",{className:"cc-col cc-col--standard"})]}),jsxRuntimeExports.jsx("thead",{children:jsxRuntimeExports.jsxs("tr",{className:"align-middle",children:[jsxRuntimeExports.jsx("th",{className:"cc-first-col p-2 md:p-4 text-center md:text-left border-b border-[#D9D9D9]"}),jsxRuntimeExports.jsx("th",{ref:x,className:"p-2 md:p-4 text-center relative bg-link rounded-t-[15px] md:rounded-t-[16px] cc-col cc-col--weezie border-b border-[#D9D9D9]",children:jsxRuntimeExports.jsx("span",{className:"font-apercuLight text-[12px] md:text-[16px] tracking-normal",children:"Weezie"})}),jsxRuntimeExports.jsxs("th",{className:"p-2 md:p-4 text-center font-apercuLight text-[12px] md:text-[16px] tracking-normal cc-col-header cc-col cc-col--other border-r border-b border-[#D9D9D9]",children:["Other Luxury",jsxRuntimeExports.jsx("br",{})," Towels"]}),jsxRuntimeExports.jsxs("th",{className:"p-2 md:p-4 text-center font-apercuLight text-[12px] md:text-[16px] tracking-normal cc-col-header cc-col cc-col--standard border-r border-b border-[#D9D9D9]",children:["Standard",jsxRuntimeExports.jsx("br",{}),"Towels"]})]})}),jsxRuntimeExports.jsx("tbody",{children:d.map((r,l)=>jsxRuntimeExports.jsxs("tr",{className:"align-middle",children:[jsxRuntimeExports.jsx("td",{className:"cc-first-col p-1 md:p-3 border-b border-[#D9D9D9]",children:jsxRuntimeExports.jsx("div",{className:"px-2 py-1 md:px-4 md:py-3 text-[12px] md:text-[16px] text-primary font-apercu font-normal tracking-normal text-center md:text-left",children:r.label})}),jsxRuntimeExports.jsx("td",{className:"bg-link mix-blend-multiply p-1 md:p-3 text-center relative border-b border-[#D9D9D9]",children:jsxRuntimeExports.jsx("div",{className:"flex items-center justify-center",children:r.weezie?jsxRuntimeExports.jsx(i,{}):jsxRuntimeExports.jsx(s,{})})}),jsxRuntimeExports.jsx("td",{className:"p-1 md:p-3 text-center border-r border-b border-[#D9D9D9]",children:jsxRuntimeExports.jsx("div",{className:"flex items-center justify-center",children:r.otherLuxury?jsxRuntimeExports.jsx(i,{}):jsxRuntimeExports.jsx(s,{})})}),jsxRuntimeExports.jsx("td",{className:"p-1 md:p-3 text-center border-r border-b border-[#D9D9D9]",children:jsxRuntimeExports.jsx("div",{className:"flex items-center justify-center",children:r.standard?jsxRuntimeExports.jsx(i,{}):jsxRuntimeExports.jsx(s,{})})})]},l))})]})]}),jsxRuntimeExports.jsx("div",{className:"pointer-events-none mt-2 h-2 rounded-b-[16px] shadow-[0_8px_20px_rgba(0,0,0,0.06)]"})]})]})})})}

function g(){document.removeEventListener("DOMContentLoaded",g),"undefined"!=typeof window&&(window.ProductFeaturesSection=p,window.AllDetailsSection=a$1,window.SignatureBasicsCompare=l,window.DesignerSection=s$1,window.CompetitorComparison=o);let f=document.getElementById("react-mount");f&&clientExports.createRoot(f).render(jsxRuntimeExports.jsx(n$2,{}));let B=document.getElementById("react-mount-plp");B&&clientExports.createRoot(B).render(jsxRuntimeExports.jsx(g$1,{}));let y=document.getElementById("react-mount-minicart");y&&clientExports.createRoot(y).render(jsxRuntimeExports.jsx(o$6,{}));let w=document.getElementById("react-mount-pagination");w&&clientExports.createRoot(w).render(jsxRuntimeExports.jsx(n$1,{}));let E=document.getElementById("react-mount-breadcrumbs");E&&clientExports.createRoot(E).render(jsxRuntimeExports.jsx(m,{}));let I=document.getElementById("react-emb-guide");I&&clientExports.createRoot(I).render(jsxRuntimeExports.jsx(d$3,{}));let S=document.getElementById("react-plp-seo-section");S&&clientExports.createRoot(S).render(jsxRuntimeExports.jsx(n,{}));let C=document.getElementById("react-product-features");C&&clientExports.createRoot(C).render(jsxRuntimeExports.jsx(p,{}));let b=document.getElementById("react-all-details");b&&clientExports.createRoot(b).render(jsxRuntimeExports.jsx(a$1,{}));let D=document.getElementById("react-signature-basics-compare");D&&clientExports.createRoot(D).render(jsxRuntimeExports.jsx(l,{}));let L=document.getElementById("react-designer-section");L&&clientExports.createRoot(L).render(jsxRuntimeExports.jsx(s$1,{}));let v=document.getElementById("react-competitor-comparison");v&&clientExports.createRoot(v).render(jsxRuntimeExports.jsx(o,{}));}"interactive"===document.readyState||"complete"===document.readyState?g():window.addEventListener("DOMContentLoaded",g);

console.log(`
Built with ❤️ by

                              $$\\
                              $$ |
$$$$$$\\   $$$$$$\\   $$$$$$$\\ $$$$$$\\
$$  __$$\\  \\____$$\\ $$  _____|\\_$$  _|
$$ /  $$ | $$$$$$$ |$$ /        $$ |
$$ |  $$ |$$  __$$ |$$ |        $$ |$$\\
$$$$$$$  |\\$$$$$$$ |\\$$$$$$$\\   \\$$$$  |$$\\
$$  ____/  \\_______| \\_______|   \\____/ \\__|
$$ |
$$ |
\\__|


careers@workwithpact.com
`);
